
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a38"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a38"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6THZ6", function(module, exports) {

$parcel$export(module.exports, "Application", () => yF);

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $5059ff85b35ef8d7$require$Buffer = $6ZWSX.Buffer;
var xF = Object.create;
var Cg = Object.defineProperty;
var bF = Object.getOwnPropertyDescriptor;
var SF = Object.getOwnPropertyNames;
var wF = Object.getPrototypeOf, AF = Object.prototype.hasOwnProperty;
var EF = (n1, t, e)=>t in n1 ? Cg(n1, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : n1[t] = e;
var cc = (n1, t)=>()=>(t || n1((t = {
            exports: {}
        }).exports, t), t.exports), TF = (n1, t)=>{
    for(var e in t)Cg(n1, e, {
        get: t[e],
        enumerable: !0
    });
}, MF = (n1, t, e, r)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let i of SF(t))!AF.call(n1, i) && i !== e && Cg(n1, i, {
        get: ()=>t[i],
        enumerable: !(r = bF(t, i)) || r.enumerable
    });
    return n1;
};
var Wa = (n1, t, e)=>(e = n1 != null ? xF(wF(n1)) : {}, MF(t || !n1 || !n1.__esModule ? Cg(e, "default", {
        value: n1,
        enumerable: !0
    }) : e, n1));
var uo = (n1, t, e)=>(EF(n1, typeof t != "symbol" ? t + "" : t, e), e);
var $D = cc((f1, JD)=>{
    (function(n1, t) {
        typeof f1 == "object" ? JD.exports = t() : typeof define == "function" && define.amd ? define(t) : n1.Alea = t();
    })(f1, function() {
        "use strict";
        return n1.importState = function(e) {
            var r = new n1;
            return r.importState(e), r;
        }, n1;
        function n1() {
            return function(e) {
                var r = 0, i = 0, s = 0, o = 1;
                e.length == 0 && (e = [
                    +new Date
                ]);
                var a = t();
                r = a(" "), i = a(" "), s = a(" ");
                for(var l = 0; l < e.length; l++)r -= a(e[l]), r < 0 && (r += 1), i -= a(e[l]), i < 0 && (i += 1), s -= a(e[l]), s < 0 && (s += 1);
                a = null;
                var c = function() {
                    var u = 2091639 * r + o * 23283064365386963e-26;
                    return r = i, i = s, s = u - (o = u | 0);
                };
                return c.next = c, c.uint32 = function() {
                    return c() * 4294967296;
                }, c.fract53 = function() {
                    return c() + (c() * 2097152 | 0) * 11102230246251565e-32;
                }, c.version = "Alea 0.9", c.args = e, c.exportState = function() {
                    return [
                        r,
                        i,
                        s,
                        o
                    ];
                }, c.importState = function(u) {
                    r = +u[0] || 0, i = +u[1] || 0, s = +u[2] || 0, o = +u[3] || 0;
                }, c;
            }(Array.prototype.slice.call(arguments));
        }
        function t() {
            var e = 4022871197, r = function(i) {
                i = i.toString();
                for(var s = 0; s < i.length; s++){
                    e += i.charCodeAt(s);
                    var o = .02519603282416938 * e;
                    e = o >>> 0, o -= e, o *= e, e = o >>> 0, o -= e, e += o * 4294967296;
                }
                return (e >>> 0) * 23283064365386963e-26;
            };
            return r.version = "Mash 0.9", r;
        }
    });
});
var m1 = cc((w0, nO)=>{
    (function(n1, t) {
        typeof w0 == "object" && typeof nO < "u" ? t(w0) : typeof define == "function" && define.amd ? define([
            "exports"
        ], t) : t((n1 = typeof globalThis < "u" ? globalThis : n1 || self).SVDJS = {});
    })(w0, function(n1) {
        "use strict";
        n1.SVD = function(t, e, r, i, s) {
            if (e = e === void 0 || e, r = r === void 0 || r, s = 1e-64 / (i = i || Math.pow(2, -52)), !t) throw new TypeError("Matrix a is not defined");
            var o, a, l, c, u, h, d, f, p, m, g, y, x = t[0].length, v = t.length;
            if (v < x) throw new TypeError("Invalid matrix: m < n");
            for(var S = [], w = [], A = [], T = e === "f" ? v : x, b = m = d = 0; b < v; b++)w[b] = new Array(T).fill(0);
            for(b = 0; b < x; b++)A[b] = new Array(x).fill(0);
            var M, C = new Array(x).fill(0);
            for(b = 0; b < v; b++)for(o = 0; o < x; o++)w[b][o] = t[b][o];
            for(b = 0; b < x; b++){
                for(S[b] = d, p = 0, l = b + 1, o = b; o < v; o++)p += Math.pow(w[o][b], 2);
                if (p < s) d = 0;
                else for(f = (h = w[b][b]) * (d = h < 0 ? Math.sqrt(p) : -Math.sqrt(p)) - p, w[b][b] = h - d, o = l; o < x; o++){
                    for(p = 0, a = b; a < v; a++)p += w[a][b] * w[a][o];
                    for(h = p / f, a = b; a < v; a++)w[a][o] = w[a][o] + h * w[a][b];
                }
                for(C[b] = d, p = 0, o = l; o < x; o++)p += Math.pow(w[b][o], 2);
                if (p < s) d = 0;
                else {
                    for(f = (h = w[b][b + 1]) * (d = h < 0 ? Math.sqrt(p) : -Math.sqrt(p)) - p, w[b][b + 1] = h - d, o = l; o < x; o++)S[o] = w[b][o] / f;
                    for(o = l; o < v; o++){
                        for(p = 0, a = l; a < x; a++)p += w[o][a] * w[b][a];
                        for(a = l; a < x; a++)w[o][a] = w[o][a] + p * S[a];
                    }
                }
                m < (g = Math.abs(C[b]) + Math.abs(S[b])) && (m = g);
            }
            if (r) for(b = x - 1; 0 <= b; b--){
                if (d !== 0) {
                    for(f = w[b][b + 1] * d, o = l; o < x; o++)A[o][b] = w[b][o] / f;
                    for(o = l; o < x; o++){
                        for(p = 0, a = l; a < x; a++)p += w[b][a] * A[a][o];
                        for(a = l; a < x; a++)A[a][o] = A[a][o] + p * A[a][b];
                    }
                }
                for(o = l; o < x; o++)A[b][o] = 0, A[o][b] = 0;
                A[b][b] = 1, d = S[b], l = b;
            }
            if (e) {
                if (e === "f") for(b = x; b < v; b++){
                    for(o = x; o < v; o++)w[b][o] = 0;
                    w[b][b] = 1;
                }
                for(b = x - 1; 0 <= b; b--){
                    for(l = b + 1, d = C[b], o = l; o < T; o++)w[b][o] = 0;
                    if (d !== 0) {
                        for(f = w[b][b] * d, o = l; o < T; o++){
                            for(p = 0, a = l; a < v; a++)p += w[a][b] * w[a][o];
                            for(h = p / f, a = b; a < v; a++)w[a][o] = w[a][o] + h * w[a][b];
                        }
                        for(o = b; o < v; o++)w[o][b] = w[o][b] / d;
                    } else for(o = b; o < v; o++)w[o][b] = 0;
                    w[b][b] = w[b][b] + 1;
                }
            }
            for(i *= m, a = x - 1; 0 <= a; a--)for(var P = 0; P < 50; P++){
                for(M = !1, l = a; 0 <= l; l--){
                    if (Math.abs(S[l]) <= i) {
                        M = !0;
                        break;
                    }
                    if (Math.abs(C[l - 1]) <= i) break;
                }
                if (!M) {
                    for(u = 0, c = l - (p = 1), b = l; b < a + 1 && (h = p * S[b], S[b] = u * S[b], !(Math.abs(h) <= i)); b++)if (d = C[b], C[b] = Math.sqrt(h * h + d * d), u = d / (f = C[b]), p = -h / f, e) for(o = 0; o < v; o++)g = w[o][c], y = w[o][b], w[o][c] = g * u + y * p, w[o][b] = -g * p + y * u;
                }
                if (y = C[a], l === a) {
                    if (y < 0 && (C[a] = -y, r)) for(o = 0; o < x; o++)A[o][a] = -A[o][a];
                    break;
                }
                for(m = C[l], h = (((g = C[a - 1]) - y) * (g + y) + ((d = S[a - 1]) - (f = S[a])) * (d + f)) / (2 * f * g), d = Math.sqrt(h * h + 1), h = ((m - y) * (m + y) + f * (g / (h < 0 ? h - d : h + d) - f)) / m, b = l + (p = u = 1); b < a + 1; b++){
                    if (d = S[b], g = C[b], f = p * d, d *= u, y = Math.sqrt(h * h + f * f), h = m * (u = h / (S[b - 1] = y)) + d * (p = f / y), d = -m * p + d * u, f = g * p, g *= u, r) for(o = 0; o < x; o++)m = A[o][b - 1], y = A[o][b], A[o][b - 1] = m * u + y * p, A[o][b] = -m * p + y * u;
                    if (y = Math.sqrt(h * h + f * f), h = (u = h / (C[b - 1] = y)) * d + (p = f / y) * g, m = -p * d + u * g, e) for(o = 0; o < v; o++)g = w[o][b - 1], y = w[o][b], w[o][b - 1] = g * u + y * p, w[o][b] = -g * p + y * u;
                }
                S[l] = 0, S[a] = h, C[a] = m;
            }
            for(b = 0; b < x; b++)C[b] < i && (C[b] = 0);
            return {
                u: w,
                q: C,
                v: A
            };
        }, n1.VERSION = "1.1.1", Object.defineProperty(n1, "__esModule", {
            value: !0
        });
    });
});
var IR = cc(($0, _R)=>{
    "use strict";
    Object.defineProperty($0, "__esModule", {
        value: !0
    });
    $0.default = oX;
    function oX(n1) {
        if (n1 === null || n1 === !0 || n1 === !1) return NaN;
        var t = Number(n1);
        return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
    }
    _R.exports = $0.default;
});
var OR = cc((ex, DR)=>{
    "use strict";
    Object.defineProperty(ex, "__esModule", {
        value: !0
    });
    ex.default = aX;
    function aX(n1) {
        var t = new Date(Date.UTC(n1.getFullYear(), n1.getMonth(), n1.getDate(), n1.getHours(), n1.getMinutes(), n1.getSeconds(), n1.getMilliseconds()));
        return t.setUTCFullYear(n1.getFullYear()), n1.getTime() - t.getTime();
    }
    DR.exports = ex.default;
});
var OL = cc((OFe, DL)=>{
    "use strict";
    function aZ(n1, t) {
        function e() {
            this.constructor = n1;
        }
        e.prototype = t.prototype, n1.prototype = new e;
    }
    function ru(n1, t, e, r) {
        this.message = n1, this.expected = t, this.found = e, this.location = r, this.name = "SyntaxError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ru);
    }
    aZ(ru, Error);
    ru.buildMessage = function(n1, t) {
        var e = {
            literal: function(c) {
                return '"' + i(c.text) + '"';
            },
            class: function(c) {
                var u = "", h;
                for(h = 0; h < c.parts.length; h++)u += c.parts[h] instanceof Array ? s(c.parts[h][0]) + "-" + s(c.parts[h][1]) : s(c.parts[h]);
                return "[" + (c.inverted ? "^" : "") + u + "]";
            },
            any: function(c) {
                return "any character";
            },
            end: function(c) {
                return "end of input";
            },
            other: function(c) {
                return c.description;
            }
        };
        function r(c) {
            return c.charCodeAt(0).toString(16).toUpperCase();
        }
        function i(c) {
            return c.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(u) {
                return "\\x0" + r(u);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(u) {
                return "\\x" + r(u);
            });
        }
        function s(c) {
            return c.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(u) {
                return "\\x0" + r(u);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(u) {
                return "\\x" + r(u);
            });
        }
        function o(c) {
            return e[c.type](c);
        }
        function a(c) {
            var u = new Array(c.length), h, d;
            for(h = 0; h < c.length; h++)u[h] = o(c[h]);
            if (u.sort(), u.length > 0) {
                for(h = 1, d = 1; h < u.length; h++)u[h - 1] !== u[h] && (u[d] = u[h], d++);
                u.length = d;
            }
            switch(u.length){
                case 1:
                    return u[0];
                case 2:
                    return u[0] + " or " + u[1];
                default:
                    return u.slice(0, -1).join(", ") + ", or " + u[u.length - 1];
            }
        }
        function l(c) {
            return c ? '"' + i(c) + '"' : "end of input";
        }
        return "Expected " + a(n1) + " but " + l(t) + " found.";
    };
    function lZ(n1, t) {
        t = t !== void 0 ? t : {};
        var e = {}, r = {
            svg_path: je
        }, i = je, s = function(O) {
            if (!O) return [];
            for(var R = [], X = 0; X < O.length; X++)R = R.concat.apply(R, O[X]);
            var U = R[0];
            return U && U.code == "m" && (delete U.relative, U.code = "M"), R;
        }, o = function(O, R) {
            return Si(O, R);
        }, a = /^[Mm]/, l = Be([
            "M",
            "m"
        ], !1, !1), c = function(O, R, X) {
            var U = ui(O, [
                R
            ]);
            return X && (U = U.concat(ui(O == "M" ? "L" : "l", X[1]))), U;
        }, u = /^[Zz]/, h = Be([
            "Z",
            "z"
        ], !1, !1), d = function() {
            return ui("Z");
        }, f = /^[Ll]/, p = Be([
            "L",
            "l"
        ], !1, !1), m = function(O, R) {
            return ui(O, R);
        }, g = /^[Hh]/, y = Be([
            "H",
            "h"
        ], !1, !1), x = function(O, R) {
            return ui(O, R.map(function(X) {
                return {
                    x: X
                };
            }));
        }, v = /^[Vv]/, S = Be([
            "V",
            "v"
        ], !1, !1), w = function(O, R) {
            return ui(O, R.map(function(X) {
                return {
                    y: X
                };
            }));
        }, A = /^[Cc]/, T = Be([
            "C",
            "c"
        ], !1, !1), b = function(O, R, X) {
            return {
                x1: O.x,
                y1: O.y,
                x2: R.x,
                y2: R.y,
                x: X.x,
                y: X.y
            };
        }, M = /^[Ss]/, C = Be([
            "S",
            "s"
        ], !1, !1), P = function(O, R) {
            return {
                x2: O.x,
                y2: O.y,
                x: R.x,
                y: R.y
            };
        }, I = /^[Qq]/, _ = Be([
            "Q",
            "q"
        ], !1, !1), D = function(O, R) {
            return {
                x1: O.x,
                y1: O.y,
                x: R.x,
                y: R.y
            };
        }, L = /^[Tt]/, j = Be([
            "T",
            "t"
        ], !1, !1), V = /^[Aa]/, H = Be([
            "A",
            "a"
        ], !1, !1), W = function(O, R, X, U, ee, Pe) {
            return {
                rx: O,
                ry: R,
                xAxisRotation: X,
                largeArc: U,
                sweep: ee,
                x: Pe.x,
                y: Pe.y
            };
        }, q = function(O, R) {
            return {
                x: O,
                y: R
            };
        }, Q = function(O) {
            return O * 1;
        }, G = function(O) {
            return O.join("") * 1;
        }, Z = /^[01]/, te = Be([
            "0",
            "1"
        ], !1, !1), $ = function(O) {
            return O == "1";
        }, Y = function() {
            return "";
        }, oe = ",", ie = Ge(",", !1), re = function(O) {
            return O.join("");
        }, J = ".", Ee = Ge(".", !1), xe = /^[eE]/, de = Be([
            "e",
            "E"
        ], !1, !1), De = /^[+\-]/, Ce = Be([
            "+",
            "-"
        ], !1, !1), ze = /^[0-9]/, Ue = Be([
            [
                "0",
                "9"
            ]
        ], !1, !1), Ve = function(O) {
            return O.join("");
        }, Oe = /^[ \t\n\r]/, Ye = Be([
            " ",
            "	",
            `
`,
            "\r"
        ], !1, !1), F = 0, N = 0, B = [
            {
                line: 1,
                column: 1
            }
        ], ae = 0, ge = [], me = 0, Le;
        if ("startRule" in t) {
            if (!(t.startRule in r)) throw new Error(`Can't start parsing from rule "` + t.startRule + '".');
            i = r[t.startRule];
        }
        function Ne() {
            return n1.substring(N, F);
        }
        function Re() {
            return Tr(N, F);
        }
        function pe(O, R) {
            throw R = R !== void 0 ? R : Tr(N, F), Me([
                Bt(O)
            ], n1.substring(N, F), R);
        }
        function nt(O, R) {
            throw R = R !== void 0 ? R : Tr(N, F), ye(O, R);
        }
        function Ge(O, R) {
            return {
                type: "literal",
                text: O,
                ignoreCase: R
            };
        }
        function Be(O, R, X) {
            return {
                type: "class",
                parts: O,
                inverted: R,
                ignoreCase: X
            };
        }
        function et() {
            return {
                type: "any"
            };
        }
        function st() {
            return {
                type: "end"
            };
        }
        function Bt(O) {
            return {
                type: "other",
                description: O
            };
        }
        function dr(O) {
            var R = B[O], X;
            if (R) return R;
            for(X = O - 1; !B[X];)X--;
            for(R = B[X], R = {
                line: R.line,
                column: R.column
            }; X < O;)n1.charCodeAt(X) === 10 ? (R.line++, R.column = 1) : R.column++, X++;
            return B[O] = R, R;
        }
        function Tr(O, R) {
            var X = dr(O), U = dr(R);
            return {
                start: {
                    offset: O,
                    line: X.line,
                    column: X.column
                },
                end: {
                    offset: R,
                    line: U.line,
                    column: U.column
                }
            };
        }
        function K(O) {
            F < ae || (F > ae && (ae = F, ge = []), ge.push(O));
        }
        function ye(O, R) {
            return new ru(O, null, null, R);
        }
        function Me(O, R, X) {
            return new ru(ru.buildMessage(O, R), O, R, X);
        }
        function je() {
            var O, R, X, U, ee;
            for(O = F, R = [], X = Et(); X !== e;)R.push(X), X = Et();
            if (R !== e) {
                if (X = He(), X === e && (X = null), X !== e) {
                    for(U = [], ee = Et(); ee !== e;)U.push(ee), ee = Et();
                    U !== e ? (N = O, R = s(X), O = R) : (F = O, O = e);
                } else F = O, O = e;
            } else F = O, O = e;
            return O;
        }
        function He() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = _t(), R !== e) {
                for(X = [], U = F, ee = [], Pe = Et(); Pe !== e;)ee.push(Pe), Pe = Et();
                for(ee !== e ? (Pe = _t(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;){
                    for(X.push(U), U = F, ee = [], Pe = Et(); Pe !== e;)ee.push(Pe), Pe = Et();
                    ee !== e ? (Pe = _t(), Pe !== e ? (ee = [
                        ee,
                        Pe
                    ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                }
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function _t() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = Vr(), R !== e) {
                for(X = [], U = F, ee = [], Pe = Et(); Pe !== e;)ee.push(Pe), Pe = Et();
                for(ee !== e ? (Pe = Fr(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;){
                    for(X.push(U), U = F, ee = [], Pe = Et(); Pe !== e;)ee.push(Pe), Pe = Et();
                    ee !== e ? (Pe = Fr(), Pe !== e ? (ee = [
                        ee,
                        Pe
                    ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                }
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function Fr() {
            var O;
            return O = $o(), O === e && (O = Mr(), O === e && (O = Mn(), O === e && (O = cS(), O === e && (O = uS(), O === e && (O = ce(), O === e && (O = be(), O === e && (O = At(), O === e && (O = Ht())))))))), O;
        }
        function Vr() {
            var O, R, X, U, ee, Pe, fu;
            if (O = F, a.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(l)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = Ft(), U !== e ? (ee = F, Pe = gt(), Pe === e && (Pe = null), Pe !== e ? (fu = es(), fu !== e ? (Pe = [
                    Pe,
                    fu
                ], ee = Pe) : (F = ee, ee = e)) : (F = ee, ee = e), ee === e && (ee = null), ee !== e ? (N = O, R = c(R, U, ee), O = R) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function $o() {
            var O, R;
            return O = F, u.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(h)), R !== e && (N = O, R = d()), O = R, O;
        }
        function Mr() {
            var O, R, X, U;
            if (O = F, f.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(p)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = es(), U !== e ? (N = O, R = m(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function es() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = Ft(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = Ft(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = Ft(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function Mn() {
            var O, R, X, U;
            if (O = F, g.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(y)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = qf(), U !== e ? (N = O, R = x(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function qf() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = rn(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = rn(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = rn(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function cS() {
            var O, R, X, U;
            if (O = F, v.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(S)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = qf(), U !== e ? (N = O, R = w(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function uS() {
            var O, R, X, U;
            if (O = F, A.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(T)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = hS(), U !== e ? (N = O, R = m(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function hS() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = z(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = z(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = z(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function z() {
            var O, R, X, U, ee, Pe;
            return O = F, R = Ft(), R !== e ? (X = gt(), X === e && (X = null), X !== e ? (U = Ft(), U !== e ? (ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = Ft(), Pe !== e ? (N = O, R = b(R, U, Pe), O = R) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e), O;
        }
        function ce() {
            var O, R, X, U;
            if (O = F, M.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(C)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = ve(), U !== e ? (N = O, R = m(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function ve() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = se(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = se(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = se(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function se() {
            var O, R, X, U;
            return O = F, R = Ft(), R !== e ? (X = gt(), X === e && (X = null), X !== e ? (U = Ft(), U !== e ? (N = O, R = P(R, U), O = R) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e), O;
        }
        function be() {
            var O, R, X, U;
            if (O = F, I.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(_)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = ct(), U !== e ? (N = O, R = m(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function ct() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = mt(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = mt(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = mt(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function mt() {
            var O, R, X, U;
            return O = F, R = Ft(), R !== e ? (X = gt(), X === e && (X = null), X !== e ? (U = Ft(), U !== e ? (N = O, R = D(R, U), O = R) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e), O;
        }
        function At() {
            var O, R, X, U;
            if (O = F, L.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(j)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = Ct(), U !== e ? (N = O, R = m(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function Ct() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = Ft(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = Ft(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = Ft(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function Ht() {
            var O, R, X, U;
            if (O = F, V.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(H)), R !== e) {
                for(X = [], U = Et(); U !== e;)X.push(U), U = Et();
                X !== e ? (U = Nt(), U !== e ? (N = O, R = m(R, U), O = R) : (F = O, O = e)) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function Nt() {
            var O, R, X, U, ee, Pe;
            if (O = F, R = It(), R !== e) {
                for(X = [], U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = It(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e); U !== e;)X.push(U), U = F, ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = It(), Pe !== e ? (ee = [
                    ee,
                    Pe
                ], U = ee) : (F = U, U = e)) : (F = U, U = e);
                X !== e ? (N = O, R = o(R, X), O = R) : (F = O, O = e);
            } else F = O, O = e;
            return O;
        }
        function It() {
            var O, R, X, U, ee, Pe, fu, dS, Tg, fS, Mg, pS;
            return O = F, R = tn(), R !== e ? (X = gt(), X === e && (X = null), X !== e ? (U = tn(), U !== e ? (ee = gt(), ee === e && (ee = null), ee !== e ? (Pe = rn(), Pe !== e ? (fu = gt(), fu !== e ? (dS = lo(), dS !== e ? (Tg = gt(), Tg === e && (Tg = null), Tg !== e ? (fS = lo(), fS !== e ? (Mg = gt(), Mg === e && (Mg = null), Mg !== e ? (pS = Ft(), pS !== e ? (N = O, R = W(R, U, Pe, dS, fS, pS), O = R) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e), O;
        }
        function Ft() {
            var O, R, X, U;
            return O = F, R = rn(), R !== e ? (X = gt(), X === e && (X = null), X !== e ? (U = rn(), U !== e ? (N = O, R = q(R, U), O = R) : (F = O, O = e)) : (F = O, O = e)) : (F = O, O = e), O;
        }
        function tn() {
            var O, R;
            return O = F, R = uu(), R === e && (R = zn()), R !== e && (N = O, R = Q(R)), O = R, O;
        }
        function rn() {
            var O, R, X, U;
            return O = F, R = F, X = hu(), X === e && (X = null), X !== e ? (U = uu(), U !== e ? (X = [
                X,
                U
            ], R = X) : (F = R, R = e)) : (F = R, R = e), R === e && (R = F, X = hu(), X === e && (X = null), X !== e ? (U = zn(), U !== e ? (X = [
                X,
                U
            ], R = X) : (F = R, R = e)) : (F = R, R = e)), R !== e && (N = O, R = G(R)), O = R, O;
        }
        function lo() {
            var O, R;
            return O = F, Z.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(te)), R !== e && (N = O, R = $(R)), O = R, O;
        }
        function gt() {
            var O, R, X, U, ee;
            if (O = F, R = [], X = Et(), X !== e) for(; X !== e;)R.push(X), X = Et();
            else R = e;
            if (R !== e) {
                if (X = Rt(), X === e && (X = null), X !== e) {
                    for(U = [], ee = Et(); ee !== e;)U.push(ee), ee = Et();
                    U !== e ? (R = [
                        R,
                        X,
                        U
                    ], O = R) : (F = O, O = e);
                } else F = O, O = e;
            } else F = O, O = e;
            if (O === e) {
                if (O = F, R = F, X = Rt(), X !== e) {
                    for(U = [], ee = Et(); ee !== e;)U.push(ee), ee = Et();
                    U !== e ? (X = [
                        X,
                        U
                    ], R = X) : (F = R, R = e);
                } else F = R, R = e;
                R !== e && (N = O, R = Y()), O = R;
            }
            return O;
        }
        function Rt() {
            var O;
            return n1.charCodeAt(F) === 44 ? (O = oe, F++) : (O = e, me === 0 && K(ie)), O;
        }
        function uu() {
            var O, R, X, U;
            return O = F, R = F, X = ci(), X !== e ? (U = co(), U === e && (U = null), U !== e ? (X = [
                X,
                U
            ], R = X) : (F = R, R = e)) : (F = R, R = e), R === e && (R = F, X = zn(), X !== e ? (U = co(), U !== e ? (X = [
                X,
                U
            ], R = X) : (F = R, R = e)) : (F = R, R = e)), R !== e && (N = O, R = re(R)), O = R, O;
        }
        function ci() {
            var O, R, X, U, ee;
            return O = F, R = F, X = zn(), X === e && (X = null), X !== e ? (n1.charCodeAt(F) === 46 ? (U = J, F++) : (U = e, me === 0 && K(Ee)), U !== e ? (ee = zn(), ee !== e ? (X = [
                X,
                U,
                ee
            ], R = X) : (F = R, R = e)) : (F = R, R = e)) : (F = R, R = e), R === e && (R = F, X = zn(), X !== e ? (n1.charCodeAt(F) === 46 ? (U = J, F++) : (U = e, me === 0 && K(Ee)), U !== e ? (X = [
                X,
                U
            ], R = X) : (F = R, R = e)) : (F = R, R = e)), R !== e && (N = O, R = re(R)), O = R, O;
        }
        function co() {
            var O, R, X, U, ee;
            return O = F, R = F, xe.test(n1.charAt(F)) ? (X = n1.charAt(F), F++) : (X = e, me === 0 && K(de)), X !== e ? (U = hu(), U === e && (U = null), U !== e ? (ee = zn(), ee !== e ? (X = [
                X,
                U,
                ee
            ], R = X) : (F = R, R = e)) : (F = R, R = e)) : (F = R, R = e), R !== e && (N = O, R = re(R)), O = R, O;
        }
        function hu() {
            var O;
            return De.test(n1.charAt(F)) ? (O = n1.charAt(F), F++) : (O = e, me === 0 && K(Ce)), O;
        }
        function zn() {
            var O, R, X;
            if (O = F, R = [], ze.test(n1.charAt(F)) ? (X = n1.charAt(F), F++) : (X = e, me === 0 && K(Ue)), X !== e) for(; X !== e;)R.push(X), ze.test(n1.charAt(F)) ? (X = n1.charAt(F), F++) : (X = e, me === 0 && K(Ue));
            else R = e;
            return R !== e && (N = O, R = Ve(R)), O = R, O;
        }
        function Et() {
            var O, R;
            return O = F, Oe.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && K(Ye)), R !== e && (N = O, R = Y()), O = R, O;
        }
        function Si(O, R) {
            if (!R) return [
                O
            ];
            for(var X = [
                O
            ], U = 0, ee = R.length; U < ee; U++)X[U + 1] = R[U][1];
            return X;
        }
        var ts = {
            m: "moveto",
            l: "lineto",
            h: "horizontal lineto",
            v: "vertical lineto",
            c: "curveto",
            s: "smooth curveto",
            q: "quadratic curveto",
            t: "smooth quadratic curveto",
            a: "elliptical arc",
            z: "closepath"
        };
        for(var du in ts)ts[du.toUpperCase()] = ts[du];
        function ui(O, R) {
            R || (R = [
                {}
            ]);
            for(var X = R.length; X--;){
                var U = {
                    code: O,
                    command: ts[O]
                };
                O == O.toLowerCase() && (U.relative = !0);
                for(var ee in R[X])U[ee] = R[X][ee];
                R[X] = U;
            }
            return R;
        }
        if (Le = i(), Le !== e && F === n1.length) return Le;
        throw Le !== e && F < n1.length && K(st()), Me(ge, ae < n1.length ? n1.charAt(ae) : null, ae < n1.length ? Tr(ae, ae + 1) : Tr(ae, ae));
    }
    DL.exports = {
        SyntaxError: ru,
        parse: lZ
    };
});
var iT = cc((RFe, RL)=>{
    var Xx = OL().parse;
    Xx.parseSVG = Xx;
    Xx.makeAbsolute = cZ;
    RL.exports = Xx;
    function cZ(n1) {
        var t, e = {
            x: 0,
            y: 0
        }, r = {
            x: "x0",
            y: "y0",
            x1: "x0",
            y1: "y0",
            x2: "x0",
            y2: "y0"
        };
        return n1.forEach(function(i) {
            i.command === "moveto" && (t = i), i.x0 = e.x, i.y0 = e.y;
            for(var s in r)s in i && (i[s] += i.relative ? i[r[s]] : 0);
            "x" in i || (i.x = e.x), "y" in i || (i.y = e.y), i.relative = !1, i.code = i.code.toUpperCase(), i.command == "closepath" && (i.x = t.x, i.y = t.y), e = i;
        }), n1;
    }
});
var gF = cc((MYe, mF)=>{
    mF.exports = function(t, e) {
        for(var r = t.split("."), i = e.split("."), s = 0; s < 3; s++){
            var o = Number(r[s]), a = Number(i[s]);
            if (o > a) return 1;
            if (a > o) return -1;
            if (!isNaN(o) && isNaN(a)) return 1;
            if (isNaN(o) && !isNaN(a)) return -1;
        }
        return 0;
    };
});
var ca = "149";
var Xn = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
}, CF = 0, AM = 1, PF = 2;
var Oy = 1, _F = 2, rp = 3, Hn = 0, pi = 1, fi = 2;
var $t = 0, Za = 1, EM = 2, TM = 3, MM = 4, IF = 5, Pu = 100, DF = 101, OF = 102, CM = 103, PM = 104, RF = 200, LF = 201, BF = 202, NF = 203, tP = 204, rP = 205, FF = 206, VF = 207, kF = 208, UF = 209, zF = 210, GF = 0, jF = 1, HF = 2, JS = 3, WF = 4, qF = 5, YF = 6, XF = 7, iP = 0, KF = 1, QF = 2, Os = 0, ZF = 1, JF = 2, $F = 3, eV = 4, tV = 5, nP = 300, $a = 301, el = 302, $S = 303, ew = 304, $u = 306, Rs = 1e3, Qt = 1001, tw = 1002, Vt = 1003, _M = 1004;
var mS = 1005;
var rt = 1006, rV = 1007;
var yc = 1008;
var _r = 1009, iV = 1010, nV = 1011, sP = 1012, sV = 1013, Ds = 1014, br = 1015, Wn = 1016, oV = 1017, aV = 1018, Ja = 1020, lV = 1021, qr = 1023, cV = 1024, uV = 1025, mc = 1026, tl = 1027, hV = 1028, dV = 1029, eh = 1030, fV = 1031, Lw = 1033, gS = 33776, yS = 33777, vS = 33778, xS = 33779, IM = 35840, DM = 35841, OM = 35842, RM = 35843, pV = 36196, LM = 37492, BM = 37496, NM = 37808, FM = 37809, VM = 37810, kM = 37811, UM = 37812, zM = 37813, GM = 37814, jM = 37815, HM = 37816, WM = 37817, qM = 37818, YM = 37819, XM = 37820, KM = 37821, bS = 36492, mV = 36283, QM = 36284, ZM = 36285, JM = 36286, Bw = 2200, Nw = 2201, Tp = 2202, iy = 2300, ny = 2301, SS = 2302, _u = 2400, Iu = 2401, sy = 2402, Fw = 2500, gV = 2501;
var mn = 3e3, at = 3001, Bi = 3200, Vw = 3201, yV = 0, vV = 1;
var ho = "srgb", cp = "srgb-linear";
var wS = 7680;
var xV = 519, rw = 35044, oP = 35048;
var $M = "300 es", iw = 1035, pr = class {
    addEventListener(t, e) {
        this._listeners === void 0 && (this._listeners = {});
        let r = this._listeners;
        r[t] === void 0 && (r[t] = []), r[t].indexOf(e) === -1 && r[t].push(e);
    }
    hasEventListener(t, e) {
        if (this._listeners === void 0) return !1;
        let r = this._listeners;
        return r[t] !== void 0 && r[t].indexOf(e) !== -1;
    }
    removeEventListener(t, e) {
        if (this._listeners === void 0) return;
        let i = this._listeners[t];
        if (i !== void 0) {
            let s = i.indexOf(e);
            s !== -1 && i.splice(s, 1);
        }
    }
    dispatchEvent(t) {
        if (this._listeners === void 0) return;
        let r = this._listeners[t.type];
        if (r !== void 0) {
            t.target = this;
            let i = r.slice(0);
            for(let s = 0, o = i.length; s < o; s++)i[s].call(this, t);
            t.target = null;
        }
    }
}, nn = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
], eC = 1234567, np = Math.PI / 180, up = 180 / Math.PI;
function is() {
    let n1 = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
    return (nn[n1 & 255] + nn[n1 >> 8 & 255] + nn[n1 >> 16 & 255] + nn[n1 >> 24 & 255] + "-" + nn[t & 255] + nn[t >> 8 & 255] + "-" + nn[t >> 16 & 15 | 64] + nn[t >> 24 & 255] + "-" + nn[e & 63 | 128] + nn[e >> 8 & 255] + "-" + nn[e >> 16 & 255] + nn[e >> 24 & 255] + nn[r & 255] + nn[r >> 8 & 255] + nn[r >> 16 & 255] + nn[r >> 24 & 255]).toLowerCase();
}
function di(n1, t, e) {
    return Math.max(t, Math.min(e, n1));
}
function kw(n1, t) {
    return (n1 % t + t) % t;
}
function bV(n1, t, e, r, i) {
    return r + (n1 - t) * (i - r) / (e - t);
}
function SV(n1, t, e) {
    return n1 !== t ? (e - n1) / (t - n1) : 0;
}
function sp(n1, t, e) {
    return (1 - e) * n1 + e * t;
}
function wV(n1, t, e, r) {
    return sp(n1, t, 1 - Math.exp(-e * r));
}
function AV(n1, t = 1) {
    return t - Math.abs(kw(n1, t * 2) - t);
}
function EV(n1, t, e) {
    return n1 <= t ? 0 : n1 >= e ? 1 : (n1 = (n1 - t) / (e - t), n1 * n1 * (3 - 2 * n1));
}
function TV(n1, t, e) {
    return n1 <= t ? 0 : n1 >= e ? 1 : (n1 = (n1 - t) / (e - t), n1 * n1 * n1 * (n1 * (n1 * 6 - 15) + 10));
}
function MV(n1, t) {
    return n1 + Math.floor(Math.random() * (t - n1 + 1));
}
function CV(n1, t) {
    return n1 + Math.random() * (t - n1);
}
function PV(n1) {
    return n1 * (.5 - Math.random());
}
function _V(n1) {
    n1 !== void 0 && (eC = n1);
    let t = eC += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function IV(n1) {
    return n1 * np;
}
function DV(n1) {
    return n1 * up;
}
function nw(n1) {
    return (n1 & n1 - 1) === 0 && n1 !== 0;
}
function aP(n1) {
    return Math.pow(2, Math.ceil(Math.log(n1) / Math.LN2));
}
function oy(n1) {
    return Math.pow(2, Math.floor(Math.log(n1) / Math.LN2));
}
function OV(n1, t, e, r, i) {
    let s = Math.cos, o = Math.sin, a = s(e / 2), l = o(e / 2), c = s((t + r) / 2), u = o((t + r) / 2), h = s((t - r) / 2), d = o((t - r) / 2), f = s((r - t) / 2), p = o((r - t) / 2);
    switch(i){
        case "XYX":
            n1.set(a * u, l * h, l * d, a * c);
            break;
        case "YZY":
            n1.set(l * d, a * u, l * h, a * c);
            break;
        case "ZXZ":
            n1.set(l * h, l * d, a * u, a * c);
            break;
        case "XZX":
            n1.set(a * u, l * p, l * f, a * c);
            break;
        case "YXY":
            n1.set(l * f, a * u, l * p, a * c);
            break;
        case "ZYZ":
            n1.set(l * p, l * f, a * u, a * c);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
    }
}
function aa(n1, t) {
    switch(t.constructor){
        case Float32Array:
            return n1;
        case Uint16Array:
            return n1 / 65535;
        case Uint8Array:
            return n1 / 255;
        case Int16Array:
            return Math.max(n1 / 32767, -1);
        case Int8Array:
            return Math.max(n1 / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function xr(n1, t) {
    switch(t.constructor){
        case Float32Array:
            return n1;
        case Uint16Array:
            return Math.round(n1 * 65535);
        case Uint8Array:
            return Math.round(n1 * 255);
        case Int16Array:
            return Math.round(n1 * 32767);
        case Int8Array:
            return Math.round(n1 * 127);
        default:
            throw new Error("Invalid component type.");
    }
}
var we = Object.freeze({
    __proto__: null,
    DEG2RAD: np,
    RAD2DEG: up,
    ceilPowerOfTwo: aP,
    clamp: di,
    damp: wV,
    degToRad: IV,
    denormalize: aa,
    euclideanModulo: kw,
    floorPowerOfTwo: oy,
    generateUUID: is,
    inverseLerp: SV,
    isPowerOfTwo: nw,
    lerp: sp,
    mapLinear: bV,
    normalize: xr,
    pingpong: AV,
    radToDeg: DV,
    randFloat: CV,
    randFloatSpread: PV,
    randInt: MV,
    seededRandom: _V,
    setQuaternionFromProperEuler: OV,
    smootherstep: TV,
    smoothstep: EV
}), k = class {
    constructor(t = 0, e = 0){
        k.prototype.isVector2 = !0, this.x = t, this.y = e;
    }
    get width() {
        return this.x;
    }
    set width(t) {
        this.x = t;
    }
    get height() {
        return this.y;
    }
    set height(t) {
        this.y = t;
    }
    set(t, e) {
        return this.x = t, this.y = e, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this;
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    applyMatrix3(t) {
        let e = this.x, r = this.y, i = t.elements;
        return this.x = i[0] * e + i[3] * r + i[6], this.y = i[1] * e + i[4] * r + i[7], this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, r = this.y - t.y;
        return e * e + r * r;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this;
    }
    rotateAround(t, e) {
        let r = Math.cos(e), i = Math.sin(e), s = this.x - t.x, o = this.y - t.y;
        return this.x = s * r - o * i + t.x, this.y = s * i + o * r + t.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}, fr = class {
    constructor(){
        fr.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, r, i, s, o, a, l, c) {
        let u = this.elements;
        return u[0] = t, u[1] = i, u[2] = a, u[3] = e, u[4] = s, u[5] = l, u[6] = r, u[7] = o, u[8] = c, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(t) {
        let e = this.elements, r = t.elements;
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], this;
    }
    extractBasis(t, e, r) {
        return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), r.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(t) {
        let e = t.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let r = t.elements, i = e.elements, s = this.elements, o = r[0], a = r[3], l = r[6], c = r[1], u = r[4], h = r[7], d = r[2], f = r[5], p = r[8], m = i[0], g = i[3], y = i[6], x = i[1], v = i[4], S = i[7], w = i[2], A = i[5], T = i[8];
        return s[0] = o * m + a * x + l * w, s[3] = o * g + a * v + l * A, s[6] = o * y + a * S + l * T, s[1] = c * m + u * x + h * w, s[4] = c * g + u * v + h * A, s[7] = c * y + u * S + h * T, s[2] = d * m + f * x + p * w, s[5] = d * g + f * v + p * A, s[8] = d * y + f * S + p * T, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], c = t[7], u = t[8];
        return e * o * u - e * a * c - r * s * u + r * a * l + i * s * c - i * o * l;
    }
    invert() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], c = t[7], u = t[8], h = u * o - a * c, d = a * l - u * s, f = c * s - o * l, p = e * h + r * d + i * f;
        if (p === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let m = 1 / p;
        return t[0] = h * m, t[1] = (i * c - u * r) * m, t[2] = (a * r - i * o) * m, t[3] = d * m, t[4] = (u * e - i * l) * m, t[5] = (i * s - a * e) * m, t[6] = f * m, t[7] = (r * l - c * e) * m, t[8] = (o * e - r * s) * m, this;
    }
    transpose() {
        let t, e = this.elements;
        return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
    getNormalMatrix(t) {
        return this.setFromMatrix4(t).invert().transpose();
    }
    transposeIntoArray(t) {
        let e = this.elements;
        return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
    setUvTransform(t, e, r, i, s, o, a) {
        let l = Math.cos(s), c = Math.sin(s);
        return this.set(r * l, r * c, -r * (l * o + c * a) + o + t, -i * c, i * l, -i * (-c * o + l * a) + a + e, 0, 0, 1), this;
    }
    scale(t, e) {
        return this.premultiply(AS.makeScale(t, e)), this;
    }
    rotate(t) {
        return this.premultiply(AS.makeRotation(-t)), this;
    }
    translate(t, e) {
        return this.premultiply(AS.makeTranslation(t, e)), this;
    }
    makeTranslation(t, e) {
        return this.set(1, 0, t, 0, 1, e, 0, 0, 1), this;
    }
    makeRotation(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, -r, 0, r, e, 0, 0, 0, 1), this;
    }
    makeScale(t, e) {
        return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
    }
    equals(t) {
        let e = this.elements, r = t.elements;
        for(let i = 0; i < 9; i++)if (e[i] !== r[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let r = 0; r < 9; r++)this.elements[r] = t[r + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let r = this.elements;
        return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}, AS = new fr;
function lP(n1) {
    for(let t = n1.length - 1; t >= 0; --t)if (n1[t] >= 65535) return !0;
    return !1;
}
var RV = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function Pg(n1, t) {
    return new RV[n1](t);
}
function hp(n1) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", n1);
}
function gc(n1) {
    return n1 < .04045 ? n1 * .0773993808 : Math.pow(n1 * .9478672986 + .0521327014, 2.4);
}
function ry(n1) {
    return n1 < .0031308 ? n1 * 12.92 : 1.055 * Math.pow(n1, .41666) - .055;
}
var ES = {
    [ho]: {
        [cp]: gc
    },
    [cp]: {
        [ho]: ry
    }
}, dn = {
    legacyMode: !0,
    get workingColorSpace () {
        return cp;
    },
    set workingColorSpace (n){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(n1, t, e) {
        if (this.legacyMode || t === e || !t || !e) return n1;
        if (ES[t] && ES[t][e] !== void 0) {
            let r = ES[t][e];
            return n1.r = r(n1.r), n1.g = r(n1.g), n1.b = r(n1.b), n1;
        }
        throw new Error("Unsupported color space conversion.");
    },
    fromWorkingColorSpace: function(n1, t) {
        return this.convert(n1, this.workingColorSpace, t);
    },
    toWorkingColorSpace: function(n1, t) {
        return this.convert(n1, t, this.workingColorSpace);
    }
}, cP = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, wi = {
    r: 0,
    g: 0,
    b: 0
}, Ps = {
    h: 0,
    s: 0,
    l: 0
}, _g = {
    h: 0,
    s: 0,
    l: 0
};
function TS(n1, t, e) {
    return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? n1 + (t - n1) * 6 * e : e < 0.5 ? t : e < 2 / 3 ? n1 + (t - n1) * 6 * (2 / 3 - e) : n1;
}
function Ig(n1, t) {
    return t.r = n1.r, t.g = n1.g, t.b = n1.b, t;
}
var We = class {
    constructor(t, e, r){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, e === void 0 && r === void 0 ? this.set(t) : this.setRGB(t, e, r);
    }
    set(t) {
        return t && t.isColor ? this.copy(t) : typeof t == "number" ? this.setHex(t) : typeof t == "string" && this.setStyle(t), this;
    }
    setScalar(t) {
        return this.r = t, this.g = t, this.b = t, this;
    }
    setHex(t, e = ho) {
        return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, dn.toWorkingColorSpace(this, e), this;
    }
    setRGB(t, e, r, i = dn.workingColorSpace) {
        return this.r = t, this.g = e, this.b = r, dn.toWorkingColorSpace(this, i), this;
    }
    setHSL(t, e, r, i = dn.workingColorSpace) {
        if (t = kw(t, 1), e = di(e, 0, 1), r = di(r, 0, 1), e === 0) this.r = this.g = this.b = r;
        else {
            let s = r <= .5 ? r * (1 + e) : r + e - r * e, o = 2 * r - s;
            this.r = TS(o, s, t + 1 / 3), this.g = TS(o, s, t), this.b = TS(o, s, t - 1 / 3);
        }
        return dn.toWorkingColorSpace(this, i), this;
    }
    setStyle(t, e = ho) {
        function r(s) {
            s !== void 0 && parseFloat(s) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
        }
        let i;
        if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
            let s, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(255, parseInt(s[1], 10)) / 255, this.g = Math.min(255, parseInt(s[2], 10)) / 255, this.b = Math.min(255, parseInt(s[3], 10)) / 255, dn.toWorkingColorSpace(this, e), r(s[4]), this;
                    if (s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(100, parseInt(s[1], 10)) / 100, this.g = Math.min(100, parseInt(s[2], 10)) / 100, this.b = Math.min(100, parseInt(s[3], 10)) / 100, dn.toWorkingColorSpace(this, e), r(s[4]), this;
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) {
                        let l = parseFloat(s[1]) / 360, c = parseFloat(s[2]) / 100, u = parseFloat(s[3]) / 100;
                        return r(s[4]), this.setHSL(l, c, u, e);
                    }
                    break;
            }
        } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t)) {
            let s = i[1], o = s.length;
            if (o === 3) return this.r = parseInt(s.charAt(0) + s.charAt(0), 16) / 255, this.g = parseInt(s.charAt(1) + s.charAt(1), 16) / 255, this.b = parseInt(s.charAt(2) + s.charAt(2), 16) / 255, dn.toWorkingColorSpace(this, e), this;
            if (o === 6) return this.r = parseInt(s.charAt(0) + s.charAt(1), 16) / 255, this.g = parseInt(s.charAt(2) + s.charAt(3), 16) / 255, this.b = parseInt(s.charAt(4) + s.charAt(5), 16) / 255, dn.toWorkingColorSpace(this, e), this;
        }
        return t && t.length > 0 ? this.setColorName(t, e) : this;
    }
    setColorName(t, e = ho) {
        let r = cP[t.toLowerCase()];
        return r !== void 0 ? this.setHex(r, e) : console.warn("THREE.Color: Unknown color " + t), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
    copySRGBToLinear(t) {
        return this.r = gc(t.r), this.g = gc(t.g), this.b = gc(t.b), this;
    }
    copyLinearToSRGB(t) {
        return this.r = ry(t.r), this.g = ry(t.g), this.b = ry(t.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(t = ho) {
        return dn.fromWorkingColorSpace(Ig(this, wi), t), di(wi.r * 255, 0, 255) << 16 ^ di(wi.g * 255, 0, 255) << 8 ^ di(wi.b * 255, 0, 255) << 0;
    }
    getHexString(t = ho) {
        return ("000000" + this.getHex(t).toString(16)).slice(-6);
    }
    getHSL(t, e = dn.workingColorSpace) {
        dn.fromWorkingColorSpace(Ig(this, wi), e);
        let r = wi.r, i = wi.g, s = wi.b, o = Math.max(r, i, s), a = Math.min(r, i, s), l, c, u = (a + o) / 2;
        if (a === o) l = 0, c = 0;
        else {
            let h = o - a;
            switch(c = u <= .5 ? h / (o + a) : h / (2 - o - a), o){
                case r:
                    l = (i - s) / h + (i < s ? 6 : 0);
                    break;
                case i:
                    l = (s - r) / h + 2;
                    break;
                case s:
                    l = (r - i) / h + 4;
                    break;
            }
            l /= 6;
        }
        return t.h = l, t.s = c, t.l = u, t;
    }
    getRGB(t, e = dn.workingColorSpace) {
        return dn.fromWorkingColorSpace(Ig(this, wi), e), t.r = wi.r, t.g = wi.g, t.b = wi.b, t;
    }
    getStyle(t = ho) {
        return dn.fromWorkingColorSpace(Ig(this, wi), t), t !== ho ? `color(${t} ${wi.r} ${wi.g} ${wi.b})` : `rgb(${wi.r * 255 | 0},${wi.g * 255 | 0},${wi.b * 255 | 0})`;
    }
    offsetHSL(t, e, r) {
        return this.getHSL(Ps), Ps.h += t, Ps.s += e, Ps.l += r, this.setHSL(Ps.h, Ps.s, Ps.l), this;
    }
    add(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
    addColors(t, e) {
        return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
    addScalar(t) {
        return this.r += t, this.g += t, this.b += t, this;
    }
    sub(t) {
        return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
    multiply(t) {
        return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
    multiplyScalar(t) {
        return this.r *= t, this.g *= t, this.b *= t, this;
    }
    lerp(t, e) {
        return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
    lerpColors(t, e, r) {
        return this.r = t.r + (e.r - t.r) * r, this.g = t.g + (e.g - t.g) * r, this.b = t.b + (e.b - t.b) * r, this;
    }
    lerpHSL(t, e) {
        this.getHSL(Ps), t.getHSL(_g);
        let r = sp(Ps.h, _g.h, e), i = sp(Ps.s, _g.s, e), s = sp(Ps.l, _g.l, e);
        return this.setHSL(r, i, s), this;
    }
    equals(t) {
        return t.r === this.r && t.g === this.g && t.b === this.b;
    }
    fromArray(t, e = 0) {
        return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
    fromBufferAttribute(t, e) {
        return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
};
We.NAMES = cP;
var pu, ay = class {
    static getDataURL(t) {
        if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u") return t.src;
        let e;
        if (t instanceof HTMLCanvasElement) e = t;
        else {
            pu === void 0 && (pu = hp("canvas")), pu.width = t.width, pu.height = t.height;
            let r = pu.getContext("2d");
            t instanceof ImageData ? r.putImageData(t, 0, 0) : r.drawImage(t, 0, 0, t.width, t.height), e = pu;
        }
        return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
    static sRGBToLinear(t) {
        if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
            let e = hp("canvas");
            e.width = t.width, e.height = t.height;
            let r = e.getContext("2d");
            r.drawImage(t, 0, 0, t.width, t.height);
            let i = r.getImageData(0, 0, t.width, t.height), s = i.data;
            for(let o = 0; o < s.length; o++)s[o] = gc(s[o] / 255) * 255;
            return r.putImageData(i, 0, 0), e;
        } else if (t.data) {
            let e = t.data.slice(0);
            for(let r = 0; r < e.length; r++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[r] = Math.floor(gc(e[r] / 255) * 255) : e[r] = gc(e[r]);
            return {
                data: e,
                width: t.width,
                height: t.height
            };
        } else return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
}, ly = class {
    constructor(t = null){
        this.isSource = !0, this.uuid = is(), this.data = t, this.version = 0;
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.images[this.uuid] !== void 0) return t.images[this.uuid];
        let r = {
            uuid: this.uuid,
            url: ""
        }, i = this.data;
        if (i !== null) {
            let s;
            if (Array.isArray(i)) {
                s = [];
                for(let o = 0, a = i.length; o < a; o++)i[o].isDataTexture ? s.push(MS(i[o].image)) : s.push(MS(i[o]));
            } else s = MS(i);
            r.url = s;
        }
        return e || (t.images[this.uuid] = r), r;
    }
};
function MS(n1) {
    return typeof HTMLImageElement < "u" && n1 instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && n1 instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && n1 instanceof ImageBitmap ? ay.getDataURL(n1) : n1.data ? {
        data: Array.from(n1.data),
        width: n1.width,
        height: n1.height,
        type: n1.data.constructor.name
    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
var LV = 0, er = class extends pr {
    constructor(t = er.DEFAULT_IMAGE, e = er.DEFAULT_MAPPING, r = Qt, i = Qt, s = rt, o = yc, a = qr, l = _r, c = er.DEFAULT_ANISOTROPY, u = mn){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: LV++
        }), this.uuid = is(), this.name = "", this.source = new ly(t), this.mipmaps = [], this.mapping = e, this.wrapS = r, this.wrapT = i, this.magFilter = s, this.minFilter = o, this.anisotropy = c, this.format = a, this.internalFormat = null, this.type = l, this.offset = new k(0, 0), this.repeat = new k(1, 1), this.center = new k(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new fr, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = u, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
    }
    get image() {
        return this.source.data;
    }
    set image(t) {
        this.source.data = t;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.textures[this.uuid] !== void 0) return t.textures[this.uuid];
        let r = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(t).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (r.userData = this.userData), e || (t.textures[this.uuid] = r), r;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(t) {
        if (this.mapping !== nP) return t;
        if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch(this.wrapS){
            case Rs:
                t.x = t.x - Math.floor(t.x);
                break;
            case Qt:
                t.x = t.x < 0 ? 0 : 1;
                break;
            case tw:
                Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
                break;
        }
        if (t.y < 0 || t.y > 1) switch(this.wrapT){
            case Rs:
                t.y = t.y - Math.floor(t.y);
                break;
            case Qt:
                t.y = t.y < 0 ? 0 : 1;
                break;
            case tw:
                Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
                break;
        }
        return this.flipY && (t.y = 1 - t.y), t;
    }
    set needsUpdate(t) {
        t === !0 && (this.version++, this.source.needsUpdate = !0);
    }
};
er.DEFAULT_IMAGE = null;
er.DEFAULT_MAPPING = nP;
er.DEFAULT_ANISOTROPY = 1;
var Ze = class {
    constructor(t = 0, e = 0, r = 0, i = 1){
        Ze.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = r, this.w = i;
    }
    get width() {
        return this.z;
    }
    set width(t) {
        this.z = t;
    }
    get height() {
        return this.w;
    }
    set height(t) {
        this.w = t;
    }
    set(t, e, r, i) {
        return this.x = t, this.y = e, this.z = r, this.w = i, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setW(t) {
        return this.w = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            case 3:
                this.w = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
    applyMatrix4(t) {
        let e = this.x, r = this.y, i = this.z, s = this.w, o = t.elements;
        return this.x = o[0] * e + o[4] * r + o[8] * i + o[12] * s, this.y = o[1] * e + o[5] * r + o[9] * i + o[13] * s, this.z = o[2] * e + o[6] * r + o[10] * i + o[14] * s, this.w = o[3] * e + o[7] * r + o[11] * i + o[15] * s, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    setAxisAngleFromQuaternion(t) {
        this.w = 2 * Math.acos(t.w);
        let e = Math.sqrt(1 - t.w * t.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
    setAxisAngleFromRotationMatrix(t) {
        let e, r, i, s, l = t.elements, c = l[0], u = l[4], h = l[8], d = l[1], f = l[5], p = l[9], m = l[2], g = l[6], y = l[10];
        if (Math.abs(u - d) < .01 && Math.abs(h - m) < .01 && Math.abs(p - g) < .01) {
            if (Math.abs(u + d) < .1 && Math.abs(h + m) < .1 && Math.abs(p + g) < .1 && Math.abs(c + f + y - 3) < .1) return this.set(1, 0, 0, 0), this;
            e = Math.PI;
            let v = (c + 1) / 2, S = (f + 1) / 2, w = (y + 1) / 2, A = (u + d) / 4, T = (h + m) / 4, b = (p + g) / 4;
            return v > S && v > w ? v < .01 ? (r = 0, i = .707106781, s = .707106781) : (r = Math.sqrt(v), i = A / r, s = T / r) : S > w ? S < .01 ? (r = .707106781, i = 0, s = .707106781) : (i = Math.sqrt(S), r = A / i, s = b / i) : w < .01 ? (r = .707106781, i = .707106781, s = 0) : (s = Math.sqrt(w), r = T / s, i = b / s), this.set(r, i, s, e), this;
        }
        let x = Math.sqrt((g - p) * (g - p) + (h - m) * (h - m) + (d - u) * (d - u));
        return Math.abs(x) < .001 && (x = 1), this.x = (g - p) / x, this.y = (h - m) / x, this.z = (d - u) / x, this.w = Math.acos((c + f + y - 1) / 2), this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this.w = t.w + (e.w - t.w) * r, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}, dt = class extends pr {
    constructor(t = 1, e = 1, r = {}){
        super(), this.isWebGLRenderTarget = !0, this.width = t, this.height = e, this.depth = 1, this.scissor = new Ze(0, 0, t, e), this.scissorTest = !1, this.viewport = new Ze(0, 0, t, e);
        let i = {
            width: t,
            height: e,
            depth: 1
        };
        this.texture = new er(i, r.mapping, r.wrapS, r.wrapT, r.magFilter, r.minFilter, r.format, r.type, r.anisotropy, r.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = r.generateMipmaps !== void 0 ? r.generateMipmaps : !1, this.texture.internalFormat = r.internalFormat !== void 0 ? r.internalFormat : null, this.texture.minFilter = r.minFilter !== void 0 ? r.minFilter : rt, this.depthBuffer = r.depthBuffer !== void 0 ? r.depthBuffer : !0, this.stencilBuffer = r.stencilBuffer !== void 0 ? r.stencilBuffer : !1, this.depthTexture = r.depthTexture !== void 0 ? r.depthTexture : null, this.samples = r.samples !== void 0 ? r.samples : 0;
    }
    setSize(t, e, r = 1) {
        (this.width !== t || this.height !== e || this.depth !== r) && (this.width = t, this.height = e, this.depth = r, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = r, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.isRenderTargetTexture = !0;
        let e = Object.assign({}, t.texture.image);
        return this.texture.source = new ly(e), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, cy = class extends er {
    constructor(t = null, e = 1, r = 1, i = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: t,
            width: e,
            height: r,
            depth: i
        }, this.magFilter = Vt, this.minFilter = Vt, this.wrapR = Qt, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var uy = class extends er {
    constructor(t = null, e = 1, r = 1, i = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: t,
            width: e,
            height: r,
            depth: i
        }, this.magFilter = Vt, this.minFilter = Vt, this.wrapR = Qt, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var hy = class extends dt {
    constructor(t = 1, e = 1, r = 1, i = {}){
        super(t, e, i), this.isWebGLMultipleRenderTargets = !0;
        let s = this.texture;
        this.texture = [];
        for(let o = 0; o < r; o++)this.texture[o] = s.clone(), this.texture[o].isRenderTargetTexture = !0;
    }
    setSize(t, e, r = 1) {
        if (this.width !== t || this.height !== e || this.depth !== r) {
            this.width = t, this.height = e, this.depth = r;
            for(let i = 0, s = this.texture.length; i < s; i++)this.texture[i].image.width = t, this.texture[i].image.height = e, this.texture[i].image.depth = r;
            this.dispose();
        }
        return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
    }
    copy(t) {
        this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.texture.length = 0;
        for(let e = 0, r = t.texture.length; e < r; e++)this.texture[e] = t.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
        return this;
    }
}, Ke = class {
    constructor(t = 0, e = 0, r = 0, i = 1){
        this.isQuaternion = !0, this._x = t, this._y = e, this._z = r, this._w = i;
    }
    static slerpFlat(t, e, r, i, s, o, a) {
        let l = r[i + 0], c = r[i + 1], u = r[i + 2], h = r[i + 3], d = s[o + 0], f = s[o + 1], p = s[o + 2], m = s[o + 3];
        if (a === 0) {
            t[e + 0] = l, t[e + 1] = c, t[e + 2] = u, t[e + 3] = h;
            return;
        }
        if (a === 1) {
            t[e + 0] = d, t[e + 1] = f, t[e + 2] = p, t[e + 3] = m;
            return;
        }
        if (h !== m || l !== d || c !== f || u !== p) {
            let g = 1 - a, y = l * d + c * f + u * p + h * m, x = y >= 0 ? 1 : -1, v = 1 - y * y;
            if (v > Number.EPSILON) {
                let w = Math.sqrt(v), A = Math.atan2(w, y * x);
                g = Math.sin(g * A) / w, a = Math.sin(a * A) / w;
            }
            let S = a * x;
            if (l = l * g + d * S, c = c * g + f * S, u = u * g + p * S, h = h * g + m * S, g === 1 - a) {
                let w = 1 / Math.sqrt(l * l + c * c + u * u + h * h);
                l *= w, c *= w, u *= w, h *= w;
            }
        }
        t[e] = l, t[e + 1] = c, t[e + 2] = u, t[e + 3] = h;
    }
    static multiplyQuaternionsFlat(t, e, r, i, s, o) {
        let a = r[i], l = r[i + 1], c = r[i + 2], u = r[i + 3], h = s[o], d = s[o + 1], f = s[o + 2], p = s[o + 3];
        return t[e] = a * p + u * h + l * f - c * d, t[e + 1] = l * p + u * d + c * h - a * f, t[e + 2] = c * p + u * f + a * d - l * h, t[e + 3] = u * p - a * h - l * d - c * f, t;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(t) {
        this._w = t, this._onChangeCallback();
    }
    set(t, e, r, i) {
        return this._x = t, this._y = e, this._z = r, this._w = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(t) {
        return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
    setFromEuler(t, e) {
        let r = t._x, i = t._y, s = t._z, o = t._order, a = Math.cos, l = Math.sin, c = a(r / 2), u = a(i / 2), h = a(s / 2), d = l(r / 2), f = l(i / 2), p = l(s / 2);
        switch(o){
            case "XYZ":
                this._x = d * u * h + c * f * p, this._y = c * f * h - d * u * p, this._z = c * u * p + d * f * h, this._w = c * u * h - d * f * p;
                break;
            case "YXZ":
                this._x = d * u * h + c * f * p, this._y = c * f * h - d * u * p, this._z = c * u * p - d * f * h, this._w = c * u * h + d * f * p;
                break;
            case "ZXY":
                this._x = d * u * h - c * f * p, this._y = c * f * h + d * u * p, this._z = c * u * p + d * f * h, this._w = c * u * h - d * f * p;
                break;
            case "ZYX":
                this._x = d * u * h - c * f * p, this._y = c * f * h + d * u * p, this._z = c * u * p - d * f * h, this._w = c * u * h + d * f * p;
                break;
            case "YZX":
                this._x = d * u * h + c * f * p, this._y = c * f * h + d * u * p, this._z = c * u * p - d * f * h, this._w = c * u * h - d * f * p;
                break;
            case "XZY":
                this._x = d * u * h - c * f * p, this._y = c * f * h - d * u * p, this._z = c * u * p + d * f * h, this._w = c * u * h + d * f * p;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o);
        }
        return e !== !1 && this._onChangeCallback(), this;
    }
    setFromAxisAngle(t, e) {
        let r = e / 2, i = Math.sin(r);
        return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(r), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t) {
        let e = t.elements, r = e[0], i = e[4], s = e[8], o = e[1], a = e[5], l = e[9], c = e[2], u = e[6], h = e[10], d = r + a + h;
        if (d > 0) {
            let f = .5 / Math.sqrt(d + 1);
            this._w = .25 / f, this._x = (u - l) * f, this._y = (s - c) * f, this._z = (o - i) * f;
        } else if (r > a && r > h) {
            let f = 2 * Math.sqrt(1 + r - a - h);
            this._w = (u - l) / f, this._x = .25 * f, this._y = (i + o) / f, this._z = (s + c) / f;
        } else if (a > h) {
            let f = 2 * Math.sqrt(1 + a - r - h);
            this._w = (s - c) / f, this._x = (i + o) / f, this._y = .25 * f, this._z = (l + u) / f;
        } else {
            let f = 2 * Math.sqrt(1 + h - r - a);
            this._w = (o - i) / f, this._x = (s + c) / f, this._y = (l + u) / f, this._z = .25 * f;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(t, e) {
        let r = t.dot(e) + 1;
        return r < Number.EPSILON ? (r = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = r) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = r)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = r), this.normalize();
    }
    angleTo(t) {
        return 2 * Math.acos(Math.abs(di(this.dot(t), -1, 1)));
    }
    rotateTowards(t, e) {
        let r = this.angleTo(t);
        if (r === 0) return this;
        let i = Math.min(1, e / r);
        return this.slerp(t, i), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(t) {
        return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let t = this.length();
        return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
    multiply(t) {
        return this.multiplyQuaternions(this, t);
    }
    premultiply(t) {
        return this.multiplyQuaternions(t, this);
    }
    multiplyQuaternions(t, e) {
        let r = t._x, i = t._y, s = t._z, o = t._w, a = e._x, l = e._y, c = e._z, u = e._w;
        return this._x = r * u + o * a + i * c - s * l, this._y = i * u + o * l + s * a - r * c, this._z = s * u + o * c + r * l - i * a, this._w = o * u - r * a - i * l - s * c, this._onChangeCallback(), this;
    }
    slerp(t, e) {
        if (e === 0) return this;
        if (e === 1) return this.copy(t);
        let r = this._x, i = this._y, s = this._z, o = this._w, a = o * t._w + r * t._x + i * t._y + s * t._z;
        if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = o, this._x = r, this._y = i, this._z = s, this;
        let l = 1 - a * a;
        if (l <= Number.EPSILON) {
            let f = 1 - e;
            return this._w = f * o + e * this._w, this._x = f * r + e * this._x, this._y = f * i + e * this._y, this._z = f * s + e * this._z, this.normalize(), this._onChangeCallback(), this;
        }
        let c = Math.sqrt(l), u = Math.atan2(c, a), h = Math.sin((1 - e) * u) / c, d = Math.sin(e * u) / c;
        return this._w = o * h + this._w * d, this._x = r * h + this._x * d, this._y = i * h + this._y * d, this._z = s * h + this._z * d, this._onChangeCallback(), this;
    }
    slerpQuaternions(t, e, r) {
        return this.copy(t).slerp(e, r);
    }
    random() {
        let t = Math.random(), e = Math.sqrt(1 - t), r = Math.sqrt(t), i = 2 * Math.PI * Math.random(), s = 2 * Math.PI * Math.random();
        return this.set(e * Math.cos(i), r * Math.sin(s), r * Math.cos(s), e * Math.sin(i));
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
    fromArray(t, e = 0) {
        return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
    fromBufferAttribute(t, e) {
        return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}, E = class {
    constructor(t = 0, e = 0, r = 0){
        E.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = r;
    }
    set(t, e, r) {
        return r === void 0 && (r = this.z), this.x = t, this.y = e, this.z = r, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
    }
    multiplyVectors(t, e) {
        return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
    applyEuler(t) {
        return this.applyQuaternion(tC.setFromEuler(t));
    }
    applyAxisAngle(t, e) {
        return this.applyQuaternion(tC.setFromAxisAngle(t, e));
    }
    applyMatrix3(t) {
        let e = this.x, r = this.y, i = this.z, s = t.elements;
        return this.x = s[0] * e + s[3] * r + s[6] * i, this.y = s[1] * e + s[4] * r + s[7] * i, this.z = s[2] * e + s[5] * r + s[8] * i, this;
    }
    applyNormalMatrix(t) {
        return this.applyMatrix3(t).normalize();
    }
    applyMatrix4(t) {
        let e = this.x, r = this.y, i = this.z, s = t.elements, o = 1 / (s[3] * e + s[7] * r + s[11] * i + s[15]);
        return this.x = (s[0] * e + s[4] * r + s[8] * i + s[12]) * o, this.y = (s[1] * e + s[5] * r + s[9] * i + s[13]) * o, this.z = (s[2] * e + s[6] * r + s[10] * i + s[14]) * o, this;
    }
    applyQuaternion(t) {
        let e = this.x, r = this.y, i = this.z, s = t.x, o = t.y, a = t.z, l = t.w, c = l * e + o * i - a * r, u = l * r + a * e - s * i, h = l * i + s * r - o * e, d = -s * e - o * r - a * i;
        return this.x = c * l + d * -s + u * -a - h * -o, this.y = u * l + d * -o + h * -s - c * -a, this.z = h * l + d * -a + c * -o - u * -s, this;
    }
    project(t) {
        return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
    unproject(t) {
        return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
    transformDirection(t) {
        let e = this.x, r = this.y, i = this.z, s = t.elements;
        return this.x = s[0] * e + s[4] * r + s[8] * i, this.y = s[1] * e + s[5] * r + s[9] * i, this.z = s[2] * e + s[6] * r + s[10] * i, this.normalize();
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this;
    }
    cross(t) {
        return this.crossVectors(this, t);
    }
    crossVectors(t, e) {
        let r = t.x, i = t.y, s = t.z, o = e.x, a = e.y, l = e.z;
        return this.x = i * l - s * a, this.y = s * o - r * l, this.z = r * a - i * o, this;
    }
    projectOnVector(t) {
        let e = t.lengthSq();
        if (e === 0) return this.set(0, 0, 0);
        let r = t.dot(this) / e;
        return this.copy(t).multiplyScalar(r);
    }
    projectOnPlane(t) {
        return CS.copy(this).projectOnVector(t), this.sub(CS);
    }
    reflect(t) {
        return this.sub(CS.copy(t).multiplyScalar(2 * this.dot(t)));
    }
    angleTo(t) {
        let e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (e === 0) return Math.PI / 2;
        let r = this.dot(t) / e;
        return Math.acos(di(r, -1, 1));
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, r = this.y - t.y, i = this.z - t.z;
        return e * e + r * r + i * i;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
    setFromSpherical(t) {
        return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
    setFromSphericalCoords(t, e, r) {
        let i = Math.sin(e) * t;
        return this.x = i * Math.sin(r), this.y = Math.cos(e) * t, this.z = i * Math.cos(r), this;
    }
    setFromCylindrical(t) {
        return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
    setFromCylindricalCoords(t, e, r) {
        return this.x = t * Math.sin(e), this.y = r, this.z = t * Math.cos(e), this;
    }
    setFromMatrixPosition(t) {
        let e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
    setFromMatrixScale(t) {
        let e = this.setFromMatrixColumn(t, 0).length(), r = this.setFromMatrixColumn(t, 1).length(), i = this.setFromMatrixColumn(t, 2).length();
        return this.x = e, this.y = r, this.z = i, this;
    }
    setFromMatrixColumn(t, e) {
        return this.fromArray(t.elements, e * 4);
    }
    setFromMatrix3Column(t, e) {
        return this.fromArray(t.elements, e * 3);
    }
    setFromEuler(t) {
        return this.x = t._x, this.y = t._y, this.z = t._z, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        let t = (Math.random() - .5) * 2, e = Math.random() * Math.PI * 2, r = Math.sqrt(1 - t ** 2);
        return this.x = r * Math.cos(e), this.y = r * Math.sin(e), this.z = t, this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}, CS = new E, tC = new Ke, Wt = class {
    constructor(t = new E(1 / 0, 1 / 0, 1 / 0), e = new E(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromArray(t) {
        let e = 1 / 0, r = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, c = t.length; l < c; l += 3){
            let u = t[l], h = t[l + 1], d = t[l + 2];
            u < e && (e = u), h < r && (r = h), d < i && (i = d), u > s && (s = u), h > o && (o = h), d > a && (a = d);
        }
        return this.min.set(e, r, i), this.max.set(s, o, a), this;
    }
    setFromBufferAttribute(t) {
        let e = 1 / 0, r = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, c = t.count; l < c; l++){
            let u = t.getX(l), h = t.getY(l), d = t.getZ(l);
            u < e && (e = u), h < r && (r = h), d < i && (i = d), u > s && (s = u), h > o && (o = h), d > a && (a = d);
        }
        return this.min.set(e, r, i), this.max.set(s, o, a), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, r = t.length; e < r; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let r = uc.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
    }
    setFromObject(t, e = !1) {
        return this.makeEmpty(), this.expandByObject(t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    expandByObject(t, e = !1) {
        t.updateWorldMatrix(!1, !1);
        let r = t.geometry;
        if (r !== void 0) {
            if (e && r.attributes != null && r.attributes.position !== void 0) {
                let s = r.attributes.position;
                for(let o = 0, a = s.count; o < a; o++)uc.fromBufferAttribute(s, o).applyMatrix4(t.matrixWorld), this.expandByPoint(uc);
            } else r.boundingBox === null && r.computeBoundingBox(), PS.copy(r.boundingBox), PS.applyMatrix4(t.matrixWorld), this.union(PS);
        }
        let i = t.children;
        for(let s = 0, o = i.length; s < o; s++)this.expandByObject(i[s], e);
        return this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
    intersectsSphere(t) {
        return this.clampPoint(t.center, uc), uc.distanceToSquared(t.center) <= t.radius * t.radius;
    }
    intersectsPlane(t) {
        let e, r;
        return t.normal.x > 0 ? (e = t.normal.x * this.min.x, r = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, r = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, r += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, r += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, r += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, r += t.normal.z * this.min.z), e <= -t.constant && r >= -t.constant;
    }
    intersectsTriangle(t) {
        if (this.isEmpty()) return !1;
        this.getCenter(Yf), Dg.subVectors(this.max, Yf), mu.subVectors(t.a, Yf), gu.subVectors(t.b, Yf), yu.subVectors(t.c, Yf), qa.subVectors(gu, mu), Ya.subVectors(yu, gu), hc.subVectors(mu, yu);
        let e = [
            0,
            -qa.z,
            qa.y,
            0,
            -Ya.z,
            Ya.y,
            0,
            -hc.z,
            hc.y,
            qa.z,
            0,
            -qa.x,
            Ya.z,
            0,
            -Ya.x,
            hc.z,
            0,
            -hc.x,
            -qa.y,
            qa.x,
            0,
            -Ya.y,
            Ya.x,
            0,
            -hc.y,
            hc.x,
            0
        ];
        return !_S(e, mu, gu, yu, Dg) || (e = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !_S(e, mu, gu, yu, Dg)) ? !1 : (Og.crossVectors(qa, Ya), e = [
            Og.x,
            Og.y,
            Og.z
        ], _S(e, mu, gu, yu, Dg));
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return uc.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    getBoundingSphere(t) {
        return this.getCenter(t.center), t.radius = this.getSize(uc).length() * .5, t;
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    applyMatrix4(t) {
        return this.isEmpty() ? this : (ea[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), ea[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), ea[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), ea[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), ea[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), ea[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), ea[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), ea[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(ea), this);
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, ea = [
    new E,
    new E,
    new E,
    new E,
    new E,
    new E,
    new E,
    new E
], uc = new E, PS = new Wt, mu = new E, gu = new E, yu = new E, qa = new E, Ya = new E, hc = new E, Yf = new E, Dg = new E, Og = new E, dc = new E;
function _S(n1, t, e, r, i) {
    for(let s = 0, o = n1.length - 3; s <= o; s += 3){
        dc.fromArray(n1, s);
        let a = i.x * Math.abs(dc.x) + i.y * Math.abs(dc.y) + i.z * Math.abs(dc.z), l = t.dot(dc), c = e.dot(dc), u = r.dot(dc);
        if (Math.max(-Math.max(l, c, u), Math.min(l, c, u)) > a) return !1;
    }
    return !0;
}
var BV = new Wt, Xf = new E, IS = new E, Rr = class {
    constructor(t = new E, e = -1){
        this.center = t, this.radius = e;
    }
    set(t, e) {
        return this.center.copy(t), this.radius = e, this;
    }
    setFromPoints(t, e) {
        let r = this.center;
        e !== void 0 ? r.copy(e) : BV.setFromPoints(t).getCenter(r);
        let i = 0;
        for(let s = 0, o = t.length; s < o; s++)i = Math.max(i, r.distanceToSquared(t[s]));
        return this.radius = Math.sqrt(i), this;
    }
    copy(t) {
        return this.center.copy(t.center), this.radius = t.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t) {
        return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t) {
        return t.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t) {
        let e = this.radius + t.radius;
        return t.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t) {
        return t.intersectsSphere(this);
    }
    intersectsPlane(t) {
        return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t, e) {
        let r = this.center.distanceToSquared(t);
        return e.copy(t), r > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t) {
        return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
    applyMatrix4(t) {
        return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
    translate(t) {
        return this.center.add(t), this;
    }
    expandByPoint(t) {
        if (this.isEmpty()) return this.center.copy(t), this.radius = 0, this;
        Xf.subVectors(t, this.center);
        let e = Xf.lengthSq();
        if (e > this.radius * this.radius) {
            let r = Math.sqrt(e), i = (r - this.radius) * .5;
            this.center.addScaledVector(Xf, i / r), this.radius += i;
        }
        return this;
    }
    union(t) {
        return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (IS.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(Xf.copy(t.center).add(IS)), this.expandByPoint(Xf.copy(t.center).sub(IS))), this);
    }
    equals(t) {
        return t.center.equals(this.center) && t.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, ta = new E, DS = new E, Rg = new E, Xa = new E, OS = new E, Lg = new E, RS = new E, Ls = class {
    constructor(t = new E, e = new E(0, 0, -1)){
        this.origin = t, this.direction = e;
    }
    set(t, e) {
        return this.origin.copy(t), this.direction.copy(e), this;
    }
    copy(t) {
        return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
    at(t, e) {
        return e.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(t) {
        return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
    recast(t) {
        return this.origin.copy(this.at(t, ta)), this;
    }
    closestPointToPoint(t, e) {
        e.subVectors(t, this.origin);
        let r = e.dot(this.direction);
        return r < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(r).add(this.origin);
    }
    distanceToPoint(t) {
        return Math.sqrt(this.distanceSqToPoint(t));
    }
    distanceSqToPoint(t) {
        let e = ta.subVectors(t, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t) : (ta.copy(this.direction).multiplyScalar(e).add(this.origin), ta.distanceToSquared(t));
    }
    distanceSqToSegment(t, e, r, i) {
        DS.copy(t).add(e).multiplyScalar(.5), Rg.copy(e).sub(t).normalize(), Xa.copy(this.origin).sub(DS);
        let s = t.distanceTo(e) * .5, o = -this.direction.dot(Rg), a = Xa.dot(this.direction), l = -Xa.dot(Rg), c = Xa.lengthSq(), u = Math.abs(1 - o * o), h, d, f, p;
        if (u > 0) {
            if (h = o * l - a, d = o * a - l, p = s * u, h >= 0) {
                if (d >= -p) {
                    if (d <= p) {
                        let m = 1 / u;
                        h *= m, d *= m, f = h * (h + o * d + 2 * a) + d * (o * h + d + 2 * l) + c;
                    } else d = s, h = Math.max(0, -(o * d + a)), f = -h * h + d * (d + 2 * l) + c;
                } else d = -s, h = Math.max(0, -(o * d + a)), f = -h * h + d * (d + 2 * l) + c;
            } else d <= -p ? (h = Math.max(0, -(-o * s + a)), d = h > 0 ? -s : Math.min(Math.max(-s, -l), s), f = -h * h + d * (d + 2 * l) + c) : d <= p ? (h = 0, d = Math.min(Math.max(-s, -l), s), f = d * (d + 2 * l) + c) : (h = Math.max(0, -(o * s + a)), d = h > 0 ? s : Math.min(Math.max(-s, -l), s), f = -h * h + d * (d + 2 * l) + c);
        } else d = o > 0 ? -s : s, h = Math.max(0, -(o * d + a)), f = -h * h + d * (d + 2 * l) + c;
        return r && r.copy(this.direction).multiplyScalar(h).add(this.origin), i && i.copy(Rg).multiplyScalar(d).add(DS), f;
    }
    intersectSphere(t, e) {
        ta.subVectors(t.center, this.origin);
        let r = ta.dot(this.direction), i = ta.dot(ta) - r * r, s = t.radius * t.radius;
        if (i > s) return null;
        let o = Math.sqrt(s - i), a = r - o, l = r + o;
        return a < 0 && l < 0 ? null : a < 0 ? this.at(l, e) : this.at(a, e);
    }
    intersectsSphere(t) {
        return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
    distanceToPlane(t) {
        let e = t.normal.dot(this.direction);
        if (e === 0) return t.distanceToPoint(this.origin) === 0 ? 0 : null;
        let r = -(this.origin.dot(t.normal) + t.constant) / e;
        return r >= 0 ? r : null;
    }
    intersectPlane(t, e) {
        let r = this.distanceToPlane(t);
        return r === null ? null : this.at(r, e);
    }
    intersectsPlane(t) {
        let e = t.distanceToPoint(this.origin);
        return e === 0 || t.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t, e) {
        let r, i, s, o, a, l, c = 1 / this.direction.x, u = 1 / this.direction.y, h = 1 / this.direction.z, d = this.origin;
        return c >= 0 ? (r = (t.min.x - d.x) * c, i = (t.max.x - d.x) * c) : (r = (t.max.x - d.x) * c, i = (t.min.x - d.x) * c), u >= 0 ? (s = (t.min.y - d.y) * u, o = (t.max.y - d.y) * u) : (s = (t.max.y - d.y) * u, o = (t.min.y - d.y) * u), r > o || s > i || ((s > r || isNaN(r)) && (r = s), (o < i || isNaN(i)) && (i = o), h >= 0 ? (a = (t.min.z - d.z) * h, l = (t.max.z - d.z) * h) : (a = (t.max.z - d.z) * h, l = (t.min.z - d.z) * h), r > l || a > i) || ((a > r || r !== r) && (r = a), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(r >= 0 ? r : i, e);
    }
    intersectsBox(t) {
        return this.intersectBox(t, ta) !== null;
    }
    intersectTriangle(t, e, r, i, s) {
        OS.subVectors(e, t), Lg.subVectors(r, t), RS.crossVectors(OS, Lg);
        let o = this.direction.dot(RS), a;
        if (o > 0) {
            if (i) return null;
            a = 1;
        } else if (o < 0) a = -1, o = -o;
        else return null;
        Xa.subVectors(this.origin, t);
        let l = a * this.direction.dot(Lg.crossVectors(Xa, Lg));
        if (l < 0) return null;
        let c = a * this.direction.dot(OS.cross(Xa));
        if (c < 0 || l + c > o) return null;
        let u = -a * Xa.dot(RS);
        return u < 0 ? null : this.at(u / o, s);
    }
    applyMatrix4(t) {
        return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
    equals(t) {
        return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, ue = class {
    constructor(){
        ue.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, r, i, s, o, a, l, c, u, h, d, f, p, m, g) {
        let y = this.elements;
        return y[0] = t, y[4] = e, y[8] = r, y[12] = i, y[1] = s, y[5] = o, y[9] = a, y[13] = l, y[2] = c, y[6] = u, y[10] = h, y[14] = d, y[3] = f, y[7] = p, y[11] = m, y[15] = g, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return new ue().fromArray(this.elements);
    }
    copy(t) {
        let e = this.elements, r = t.elements;
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], e[9] = r[9], e[10] = r[10], e[11] = r[11], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], this;
    }
    copyPosition(t) {
        let e = this.elements, r = t.elements;
        return e[12] = r[12], e[13] = r[13], e[14] = r[14], this;
    }
    setFromMatrix3(t) {
        let e = t.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(t, e, r) {
        return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(t, e, r) {
        return this.set(t.x, e.x, r.x, 0, t.y, e.y, r.y, 0, t.z, e.z, r.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(t) {
        let e = this.elements, r = t.elements, i = 1 / vu.setFromMatrixColumn(t, 0).length(), s = 1 / vu.setFromMatrixColumn(t, 1).length(), o = 1 / vu.setFromMatrixColumn(t, 2).length();
        return e[0] = r[0] * i, e[1] = r[1] * i, e[2] = r[2] * i, e[3] = 0, e[4] = r[4] * s, e[5] = r[5] * s, e[6] = r[6] * s, e[7] = 0, e[8] = r[8] * o, e[9] = r[9] * o, e[10] = r[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromEuler(t) {
        let e = this.elements, r = t.x, i = t.y, s = t.z, o = Math.cos(r), a = Math.sin(r), l = Math.cos(i), c = Math.sin(i), u = Math.cos(s), h = Math.sin(s);
        if (t.order === "XYZ") {
            let d = o * u, f = o * h, p = a * u, m = a * h;
            e[0] = l * u, e[4] = -l * h, e[8] = c, e[1] = f + p * c, e[5] = d - m * c, e[9] = -a * l, e[2] = m - d * c, e[6] = p + f * c, e[10] = o * l;
        } else if (t.order === "YXZ") {
            let d = l * u, f = l * h, p = c * u, m = c * h;
            e[0] = d + m * a, e[4] = p * a - f, e[8] = o * c, e[1] = o * h, e[5] = o * u, e[9] = -a, e[2] = f * a - p, e[6] = m + d * a, e[10] = o * l;
        } else if (t.order === "ZXY") {
            let d = l * u, f = l * h, p = c * u, m = c * h;
            e[0] = d - m * a, e[4] = -o * h, e[8] = p + f * a, e[1] = f + p * a, e[5] = o * u, e[9] = m - d * a, e[2] = -o * c, e[6] = a, e[10] = o * l;
        } else if (t.order === "ZYX") {
            let d = o * u, f = o * h, p = a * u, m = a * h;
            e[0] = l * u, e[4] = p * c - f, e[8] = d * c + m, e[1] = l * h, e[5] = m * c + d, e[9] = f * c - p, e[2] = -c, e[6] = a * l, e[10] = o * l;
        } else if (t.order === "YZX") {
            let d = o * l, f = o * c, p = a * l, m = a * c;
            e[0] = l * u, e[4] = m - d * h, e[8] = p * h + f, e[1] = h, e[5] = o * u, e[9] = -a * u, e[2] = -c * u, e[6] = f * h + p, e[10] = d - m * h;
        } else if (t.order === "XZY") {
            let d = o * l, f = o * c, p = a * l, m = a * c;
            e[0] = l * u, e[4] = -h, e[8] = c * u, e[1] = d * h + m, e[5] = o * u, e[9] = f * h - p, e[2] = p * h - f, e[6] = a * u, e[10] = m * h + d;
        }
        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromQuaternion(t) {
        return this.compose(NV, t, FV);
    }
    lookAt(t, e, r) {
        let i = this.elements;
        return Gn.subVectors(t, e), Gn.lengthSq() === 0 && (Gn.z = 1), Gn.normalize(), Ka.crossVectors(r, Gn), Ka.lengthSq() === 0 && (Math.abs(r.z) === 1 ? Gn.x += 1e-4 : Gn.z += 1e-4, Gn.normalize(), Ka.crossVectors(r, Gn)), Ka.normalize(), Bg.crossVectors(Gn, Ka), i[0] = Ka.x, i[4] = Bg.x, i[8] = Gn.x, i[1] = Ka.y, i[5] = Bg.y, i[9] = Gn.y, i[2] = Ka.z, i[6] = Bg.z, i[10] = Gn.z, this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let r = t.elements, i = e.elements, s = this.elements, o = r[0], a = r[4], l = r[8], c = r[12], u = r[1], h = r[5], d = r[9], f = r[13], p = r[2], m = r[6], g = r[10], y = r[14], x = r[3], v = r[7], S = r[11], w = r[15], A = i[0], T = i[4], b = i[8], M = i[12], C = i[1], P = i[5], I = i[9], _ = i[13], D = i[2], L = i[6], j = i[10], V = i[14], H = i[3], W = i[7], q = i[11], Q = i[15];
        return s[0] = o * A + a * C + l * D + c * H, s[4] = o * T + a * P + l * L + c * W, s[8] = o * b + a * I + l * j + c * q, s[12] = o * M + a * _ + l * V + c * Q, s[1] = u * A + h * C + d * D + f * H, s[5] = u * T + h * P + d * L + f * W, s[9] = u * b + h * I + d * j + f * q, s[13] = u * M + h * _ + d * V + f * Q, s[2] = p * A + m * C + g * D + y * H, s[6] = p * T + m * P + g * L + y * W, s[10] = p * b + m * I + g * j + y * q, s[14] = p * M + m * _ + g * V + y * Q, s[3] = x * A + v * C + S * D + w * H, s[7] = x * T + v * P + S * L + w * W, s[11] = x * b + v * I + S * j + w * q, s[15] = x * M + v * _ + S * V + w * Q, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], r = t[4], i = t[8], s = t[12], o = t[1], a = t[5], l = t[9], c = t[13], u = t[2], h = t[6], d = t[10], f = t[14], p = t[3], m = t[7], g = t[11], y = t[15];
        return p * (+s * l * h - i * c * h - s * a * d + r * c * d + i * a * f - r * l * f) + m * (+e * l * f - e * c * d + s * o * d - i * o * f + i * c * u - s * l * u) + g * (+e * c * h - e * a * f - s * o * h + r * o * f + s * a * u - r * c * u) + y * (-i * a * u - e * l * h + e * a * d + i * o * h - r * o * d + r * l * u);
    }
    transpose() {
        let t = this.elements, e;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
    setPosition(t, e, r) {
        let i = this.elements;
        return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = r), this;
    }
    invert() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], c = t[7], u = t[8], h = t[9], d = t[10], f = t[11], p = t[12], m = t[13], g = t[14], y = t[15], x = h * g * c - m * d * c + m * l * f - a * g * f - h * l * y + a * d * y, v = p * d * c - u * g * c - p * l * f + o * g * f + u * l * y - o * d * y, S = u * m * c - p * h * c + p * a * f - o * m * f - u * a * y + o * h * y, w = p * h * l - u * m * l - p * a * d + o * m * d + u * a * g - o * h * g, A = e * x + r * v + i * S + s * w;
        if (A === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        let T = 1 / A;
        return t[0] = x * T, t[1] = (m * d * s - h * g * s - m * i * f + r * g * f + h * i * y - r * d * y) * T, t[2] = (a * g * s - m * l * s + m * i * c - r * g * c - a * i * y + r * l * y) * T, t[3] = (h * l * s - a * d * s - h * i * c + r * d * c + a * i * f - r * l * f) * T, t[4] = v * T, t[5] = (u * g * s - p * d * s + p * i * f - e * g * f - u * i * y + e * d * y) * T, t[6] = (p * l * s - o * g * s - p * i * c + e * g * c + o * i * y - e * l * y) * T, t[7] = (o * d * s - u * l * s + u * i * c - e * d * c - o * i * f + e * l * f) * T, t[8] = S * T, t[9] = (p * h * s - u * m * s - p * r * f + e * m * f + u * r * y - e * h * y) * T, t[10] = (o * m * s - p * a * s + p * r * c - e * m * c - o * r * y + e * a * y) * T, t[11] = (u * a * s - o * h * s - u * r * c + e * h * c + o * r * f - e * a * f) * T, t[12] = w * T, t[13] = (u * m * i - p * h * i + p * r * d - e * m * d - u * r * g + e * h * g) * T, t[14] = (p * a * i - o * m * i - p * r * l + e * m * l + o * r * g - e * a * g) * T, t[15] = (o * h * i - u * a * i + u * r * l - e * h * l - o * r * d + e * a * d) * T, this;
    }
    scale(t) {
        let e = this.elements, r = t.x, i = t.y, s = t.z;
        return e[0] *= r, e[4] *= i, e[8] *= s, e[1] *= r, e[5] *= i, e[9] *= s, e[2] *= r, e[6] *= i, e[10] *= s, e[3] *= r, e[7] *= i, e[11] *= s, this;
    }
    getMaxScaleOnAxis() {
        let t = this.elements, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], r = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
        return Math.sqrt(Math.max(e, r, i));
    }
    makeTranslation(t, e, r) {
        return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, r, 0, 0, 0, 1), this;
    }
    makeRotationX(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(1, 0, 0, 0, 0, e, -r, 0, 0, r, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, 0, r, 0, 0, 1, 0, 0, -r, 0, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, -r, 0, 0, r, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(t, e) {
        let r = Math.cos(e), i = Math.sin(e), s = 1 - r, o = t.x, a = t.y, l = t.z, c = s * o, u = s * a;
        return this.set(c * o + r, c * a - i * l, c * l + i * a, 0, c * a + i * l, u * a + r, u * l - i * o, 0, c * l - i * a, u * l + i * o, s * l * l + r, 0, 0, 0, 0, 1), this;
    }
    makeScale(t, e, r) {
        return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1), this;
    }
    makeShear(t, e, r, i, s, o) {
        return this.set(1, r, s, 0, t, 1, o, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
    compose(t, e, r) {
        let i = this.elements, s = e._x, o = e._y, a = e._z, l = e._w, c = s + s, u = o + o, h = a + a, d = s * c, f = s * u, p = s * h, m = o * u, g = o * h, y = a * h, x = l * c, v = l * u, S = l * h, w = r.x, A = r.y, T = r.z;
        return i[0] = (1 - (m + y)) * w, i[1] = (f + S) * w, i[2] = (p - v) * w, i[3] = 0, i[4] = (f - S) * A, i[5] = (1 - (d + y)) * A, i[6] = (g + x) * A, i[7] = 0, i[8] = (p + v) * T, i[9] = (g - x) * T, i[10] = (1 - (d + m)) * T, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
    }
    decompose(t, e, r) {
        let i = this.elements, s = vu.set(i[0], i[1], i[2]).length(), o = vu.set(i[4], i[5], i[6]).length(), a = vu.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (s = -s), t.x = i[12], t.y = i[13], t.z = i[14], _s.copy(this);
        let c = 1 / s, u = 1 / o, h = 1 / a;
        return _s.elements[0] *= c, _s.elements[1] *= c, _s.elements[2] *= c, _s.elements[4] *= u, _s.elements[5] *= u, _s.elements[6] *= u, _s.elements[8] *= h, _s.elements[9] *= h, _s.elements[10] *= h, e.setFromRotationMatrix(_s), r.x = s, r.y = o, r.z = a, this;
    }
    makePerspective(t, e, r, i, s, o) {
        let a = this.elements, l = 2 * s / (e - t), c = 2 * s / (r - i), u = (e + t) / (e - t), h = (r + i) / (r - i), d = -(o + s) / (o - s), f = -2 * o * s / (o - s);
        return a[0] = l, a[4] = 0, a[8] = u, a[12] = 0, a[1] = 0, a[5] = c, a[9] = h, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = d, a[14] = f, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
    makeOrthographic(t, e, r, i, s, o) {
        let a = this.elements, l = 1 / (e - t), c = 1 / (r - i), u = 1 / (o - s), h = (e + t) * l, d = (r + i) * c, f = (o + s) * u;
        return a[0] = 2 * l, a[4] = 0, a[8] = 0, a[12] = -h, a[1] = 0, a[5] = 2 * c, a[9] = 0, a[13] = -d, a[2] = 0, a[6] = 0, a[10] = -2 * u, a[14] = -f, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
    equals(t) {
        let e = this.elements, r = t.elements;
        for(let i = 0; i < 16; i++)if (e[i] !== r[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let r = 0; r < 16; r++)this.elements[r] = t[r + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let r = this.elements;
        return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t[e + 9] = r[9], t[e + 10] = r[10], t[e + 11] = r[11], t[e + 12] = r[12], t[e + 13] = r[13], t[e + 14] = r[14], t[e + 15] = r[15], t;
    }
}, vu = new E, _s = new ue, NV = new E(0, 0, 0), FV = new E(1, 1, 1), Ka = new E, Bg = new E, Gn = new E, rC = new ue, iC = new Ke, nr = class {
    constructor(t = 0, e = 0, r = 0, i = nr.DEFAULT_ORDER){
        this.isEuler = !0, this._x = t, this._y = e, this._z = r, this._order = i;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(t) {
        this._order = t, this._onChangeCallback();
    }
    set(t, e, r, i = this._order) {
        return this._x = t, this._y = e, this._z = r, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t) {
        return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t, e = this._order, r = !0) {
        let i = t.elements, s = i[0], o = i[4], a = i[8], l = i[1], c = i[5], u = i[9], h = i[2], d = i[6], f = i[10];
        switch(e){
            case "XYZ":
                this._y = Math.asin(di(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-u, f), this._z = Math.atan2(-o, s)) : (this._x = Math.atan2(d, c), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-di(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(a, f), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-h, s), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin(di(d, -1, 1)), Math.abs(d) < .9999999 ? (this._y = Math.atan2(-h, f), this._z = Math.atan2(-o, c)) : (this._y = 0, this._z = Math.atan2(l, s));
                break;
            case "ZYX":
                this._y = Math.asin(-di(h, -1, 1)), Math.abs(h) < .9999999 ? (this._x = Math.atan2(d, f), this._z = Math.atan2(l, s)) : (this._x = 0, this._z = Math.atan2(-o, c));
                break;
            case "YZX":
                this._z = Math.asin(di(l, -1, 1)), Math.abs(l) < .9999999 ? (this._x = Math.atan2(-u, c), this._y = Math.atan2(-h, s)) : (this._x = 0, this._y = Math.atan2(a, f));
                break;
            case "XZY":
                this._z = Math.asin(-di(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(a, s)) : (this._x = Math.atan2(-u, f), this._y = 0);
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }
        return this._order = e, r === !0 && this._onChangeCallback(), this;
    }
    setFromQuaternion(t, e, r) {
        return rC.makeRotationFromQuaternion(t), this.setFromRotationMatrix(rC, e, r);
    }
    setFromVector3(t, e = this._order) {
        return this.set(t.x, t.y, t.z, e);
    }
    reorder(t) {
        return iC.setFromEuler(this), this.setFromQuaternion(iC, t);
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
    fromArray(t) {
        return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
};
nr.DEFAULT_ORDER = "XYZ";
var dp = class {
    constructor(){
        this.mask = 1;
    }
    set(t) {
        this.mask = (1 << t | 0) >>> 0;
    }
    enable(t) {
        this.mask |= 1 << t | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(t) {
        this.mask ^= 1 << t | 0;
    }
    disable(t) {
        this.mask &= ~(1 << t | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(t) {
        return (this.mask & t.mask) !== 0;
    }
    isEnabled(t) {
        return (this.mask & (1 << t | 0)) !== 0;
    }
}, VV = 0, nC = new E, xu = new Ke, ra = new ue, Ng = new E, Kf = new E, kV = new E, UV = new Ke, sC = new E(1, 0, 0), oC = new E(0, 1, 0), aC = new E(0, 0, 1), zV = {
    type: "added"
}, lC = {
    type: "removed"
}, Tt = class extends pr {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: VV++
        }), this.uuid = is(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Tt.DEFAULT_UP.clone();
        let t = new E, e = new nr, r = new Ke, i = new E(1, 1, 1);
        function s() {
            r.setFromEuler(e, !1);
        }
        function o() {
            e.setFromQuaternion(r, void 0, !1);
        }
        e._onChange(s), r._onChange(o), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: r
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            modelViewMatrix: {
                value: new ue
            },
            normalMatrix: {
                value: new fr
            }
        }), this.matrix = new ue, this.matrixWorld = new ue, this.matrixAutoUpdate = Tt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Tt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new dp, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t) {
        return this.quaternion.premultiply(t), this;
    }
    setRotationFromAxisAngle(t, e) {
        this.quaternion.setFromAxisAngle(t, e);
    }
    setRotationFromEuler(t) {
        this.quaternion.setFromEuler(t, !0);
    }
    setRotationFromMatrix(t) {
        this.quaternion.setFromRotationMatrix(t);
    }
    setRotationFromQuaternion(t) {
        this.quaternion.copy(t);
    }
    rotateOnAxis(t, e) {
        return xu.setFromAxisAngle(t, e), this.quaternion.multiply(xu), this;
    }
    rotateOnWorldAxis(t, e) {
        return xu.setFromAxisAngle(t, e), this.quaternion.premultiply(xu), this;
    }
    rotateX(t) {
        return this.rotateOnAxis(sC, t);
    }
    rotateY(t) {
        return this.rotateOnAxis(oC, t);
    }
    rotateZ(t) {
        return this.rotateOnAxis(aC, t);
    }
    translateOnAxis(t, e) {
        return nC.copy(t).applyQuaternion(this.quaternion), this.position.add(nC.multiplyScalar(e)), this;
    }
    translateX(t) {
        return this.translateOnAxis(sC, t);
    }
    translateY(t) {
        return this.translateOnAxis(oC, t);
    }
    translateZ(t) {
        return this.translateOnAxis(aC, t);
    }
    localToWorld(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(ra.copy(this.matrixWorld).invert());
    }
    lookAt(t, e, r) {
        t.isVector3 ? Ng.copy(t) : Ng.set(t, e, r);
        let i = this.parent;
        this.updateWorldMatrix(!0, !1), Kf.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? ra.lookAt(Kf, Ng, this.up) : ra.lookAt(Ng, Kf, this.up), this.quaternion.setFromRotationMatrix(ra), i && (ra.extractRotation(i.matrixWorld), xu.setFromRotationMatrix(ra), this.quaternion.premultiply(xu.invert()));
    }
    add(t) {
        if (arguments.length > 1) {
            for(let e = 0; e < arguments.length; e++)this.add(arguments[e]);
            return this;
        }
        return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.parent !== null && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(zV)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
    remove(t) {
        if (arguments.length > 1) {
            for(let r = 0; r < arguments.length; r++)this.remove(arguments[r]);
            return this;
        }
        let e = this.children.indexOf(t);
        return e !== -1 && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(lC)), this;
    }
    removeFromParent() {
        let t = this.parent;
        return t !== null && t.remove(this), this;
    }
    clear() {
        for(let t = 0; t < this.children.length; t++){
            let e = this.children[t];
            e.parent = null, e.dispatchEvent(lC);
        }
        return this.children.length = 0, this;
    }
    attach(t) {
        return this.updateWorldMatrix(!0, !1), ra.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), ra.multiply(t.parent.matrixWorld)), t.applyMatrix4(ra), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
    getObjectById(t) {
        return this.getObjectByProperty("id", t);
    }
    getObjectByName(t) {
        return this.getObjectByProperty("name", t);
    }
    getObjectByProperty(t, e) {
        if (this[t] === e) return this;
        for(let r = 0, i = this.children.length; r < i; r++){
            let o = this.children[r].getObjectByProperty(t, e);
            if (o !== void 0) return o;
        }
    }
    getObjectsByProperty(t, e) {
        let r = [];
        this[t] === e && r.push(this);
        for(let i = 0, s = this.children.length; i < s; i++){
            let o = this.children[i].getObjectsByProperty(t, e);
            o.length > 0 && (r = r.concat(o));
        }
        return r;
    }
    getWorldPosition(t) {
        return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Kf, t, kV), t;
    }
    getWorldScale(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Kf, UV, t), t;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t) {
        t(this);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++)e[r].traverse(t);
    }
    traverseVisible(t) {
        if (this.visible === !1) return;
        t(this);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++)e[r].traverseVisible(t);
    }
    traverseAncestors(t) {
        let e = this.parent;
        e !== null && (t(e), e.traverseAncestors(t));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++){
            let s = e[r];
            (s.matrixWorldAutoUpdate === !0 || t === !0) && s.updateMatrixWorld(t);
        }
    }
    updateWorldMatrix(t, e) {
        let r = this.parent;
        if (t === !0 && r !== null && r.matrixWorldAutoUpdate === !0 && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), e === !0) {
            let i = this.children;
            for(let s = 0, o = i.length; s < o; s++){
                let a = i[s];
                a.matrixWorldAutoUpdate === !0 && a.updateWorldMatrix(!1, !0);
            }
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string", r = {};
        e && (t = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, r.metadata = {
            version: 4.5,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        let i = {};
        i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON()));
        function s(a, l) {
            return a[l.uuid] === void 0 && (a[l.uuid] = l.toJSON(t)), l.uuid;
        }
        if (this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(t).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = s(t.geometries, this.geometry);
            let a = this.geometry.parameters;
            if (a !== void 0 && a.shapes !== void 0) {
                let l = a.shapes;
                if (Array.isArray(l)) for(let c = 0, u = l.length; c < u; c++){
                    let h = l[c];
                    s(t.shapes, h);
                }
                else s(t.shapes, l);
            }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0) {
            if (Array.isArray(this.material)) {
                let a = [];
                for(let l = 0, c = this.material.length; l < c; l++)a.push(s(t.materials, this.material[l]));
                i.material = a;
            } else i.material = s(t.materials, this.material);
        }
        if (this.children.length > 0) {
            i.children = [];
            for(let a = 0; a < this.children.length; a++)i.children.push(this.children[a].toJSON(t).object);
        }
        if (this.animations.length > 0) {
            i.animations = [];
            for(let a = 0; a < this.animations.length; a++){
                let l = this.animations[a];
                i.animations.push(s(t.animations, l));
            }
        }
        if (e) {
            let a = o(t.geometries), l = o(t.materials), c = o(t.textures), u = o(t.images), h = o(t.shapes), d = o(t.skeletons), f = o(t.animations), p = o(t.nodes);
            a.length > 0 && (r.geometries = a), l.length > 0 && (r.materials = l), c.length > 0 && (r.textures = c), u.length > 0 && (r.images = u), h.length > 0 && (r.shapes = h), d.length > 0 && (r.skeletons = d), f.length > 0 && (r.animations = f), p.length > 0 && (r.nodes = p);
        }
        return r.object = i, r;
        function o(a) {
            let l = [];
            for(let c in a){
                let u = a[c];
                delete u.metadata, l.push(u);
            }
            return l;
        }
    }
    clone(t) {
        return new this.constructor().copy(this, t);
    }
    copy(t, e = !0) {
        if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), e === !0) for(let r = 0; r < t.children.length; r++){
            let i = t.children[r];
            this.add(i.clone());
        }
        return this;
    }
};
Tt.DEFAULT_UP = new E(0, 1, 0);
Tt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
Tt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var Is = new E, ia = new E, LS = new E, na = new E, bu = new E, Su = new E, cC = new E, BS = new E, NS = new E, FS = new E, Cr = class {
    constructor(t = new E, e = new E, r = new E){
        this.a = t, this.b = e, this.c = r;
    }
    static getNormal(t, e, r, i) {
        i.subVectors(r, e), Is.subVectors(t, e), i.cross(Is);
        let s = i.lengthSq();
        return s > 0 ? i.multiplyScalar(1 / Math.sqrt(s)) : i.set(0, 0, 0);
    }
    static getBarycoord(t, e, r, i, s) {
        Is.subVectors(i, e), ia.subVectors(r, e), LS.subVectors(t, e);
        let o = Is.dot(Is), a = Is.dot(ia), l = Is.dot(LS), c = ia.dot(ia), u = ia.dot(LS), h = o * c - a * a;
        if (h === 0) return s.set(-2, -1, -1);
        let d = 1 / h, f = (c * l - a * u) * d, p = (o * u - a * l) * d;
        return s.set(1 - f - p, p, f);
    }
    static containsPoint(t, e, r, i) {
        return this.getBarycoord(t, e, r, i, na), na.x >= 0 && na.y >= 0 && na.x + na.y <= 1;
    }
    static getUV(t, e, r, i, s, o, a, l) {
        return this.getBarycoord(t, e, r, i, na), l.set(0, 0), l.addScaledVector(s, na.x), l.addScaledVector(o, na.y), l.addScaledVector(a, na.z), l;
    }
    static isFrontFacing(t, e, r, i) {
        return Is.subVectors(r, e), ia.subVectors(t, e), Is.cross(ia).dot(i) < 0;
    }
    set(t, e, r) {
        return this.a.copy(t), this.b.copy(e), this.c.copy(r), this;
    }
    setFromPointsAndIndices(t, e, r, i) {
        return this.a.copy(t[e]), this.b.copy(t[r]), this.c.copy(t[i]), this;
    }
    setFromAttributeAndIndices(t, e, r, i) {
        return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, r), this.c.fromBufferAttribute(t, i), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
    getArea() {
        return Is.subVectors(this.c, this.b), ia.subVectors(this.a, this.b), Is.cross(ia).length() * .5;
    }
    getMidpoint(t) {
        return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t) {
        return Cr.getNormal(this.a, this.b, this.c, t);
    }
    getPlane(t) {
        return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t, e) {
        return Cr.getBarycoord(t, this.a, this.b, this.c, e);
    }
    getUV(t, e, r, i, s) {
        return Cr.getUV(t, this.a, this.b, this.c, e, r, i, s);
    }
    containsPoint(t) {
        return Cr.containsPoint(t, this.a, this.b, this.c);
    }
    isFrontFacing(t) {
        return Cr.isFrontFacing(this.a, this.b, this.c, t);
    }
    intersectsBox(t) {
        return t.intersectsTriangle(this);
    }
    closestPointToPoint(t, e) {
        let r = this.a, i = this.b, s = this.c, o, a;
        bu.subVectors(i, r), Su.subVectors(s, r), BS.subVectors(t, r);
        let l = bu.dot(BS), c = Su.dot(BS);
        if (l <= 0 && c <= 0) return e.copy(r);
        NS.subVectors(t, i);
        let u = bu.dot(NS), h = Su.dot(NS);
        if (u >= 0 && h <= u) return e.copy(i);
        let d = l * h - u * c;
        if (d <= 0 && l >= 0 && u <= 0) return o = l / (l - u), e.copy(r).addScaledVector(bu, o);
        FS.subVectors(t, s);
        let f = bu.dot(FS), p = Su.dot(FS);
        if (p >= 0 && f <= p) return e.copy(s);
        let m = f * c - l * p;
        if (m <= 0 && c >= 0 && p <= 0) return a = c / (c - p), e.copy(r).addScaledVector(Su, a);
        let g = u * p - f * h;
        if (g <= 0 && h - u >= 0 && f - p >= 0) return cC.subVectors(s, i), a = (h - u) / (h - u + (f - p)), e.copy(i).addScaledVector(cC, a);
        let y = 1 / (g + m + d);
        return o = m * y, a = d * y, e.copy(r).addScaledVector(bu, o).addScaledVector(Su, a);
    }
    equals(t) {
        return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
}, GV = 0, vc = class extends pr {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: GV++
        }), this.uuid = is(), this.name = "", this.type = "Material", this.blending = Za, this.side = Hn, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = tP, this.blendDst = rP, this.blendEquation = Pu, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = JS, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = xV, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = wS, this.stencilZFail = wS, this.stencilZPass = wS, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(t) {
        this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(t) {
        if (t !== void 0) for(let e in t){
            let r = t[e];
            if (r === void 0) {
                console.warn("THREE.Material: '" + e + "' parameter is undefined.");
                continue;
            }
            let i = this[e];
            if (i === void 0) {
                console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.");
                continue;
            }
            i && i.isColor ? i.set(r) : i && i.isVector3 && r && r.isVector3 ? i.copy(r) : this[e] = r;
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        e && (t = {
            textures: {},
            images: {}
        });
        let r = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.color && this.color.isColor && (r.color = this.color.getHex()), this.roughness !== void 0 && (r.roughness = this.roughness), this.metalness !== void 0 && (r.metalness = this.metalness), this.sheen !== void 0 && (r.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (r.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (r.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (r.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (r.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (r.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (r.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (r.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (r.shininess = this.shininess), this.clearcoat !== void 0 && (r.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (r.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (r.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (r.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, r.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (r.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (r.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (r.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (r.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (r.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.map && this.map.isTexture && (r.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (r.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (r.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (r.lightMap = this.lightMap.toJSON(t).uuid, r.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (r.aoMap = this.aoMap.toJSON(t).uuid, r.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (r.bumpMap = this.bumpMap.toJSON(t).uuid, r.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (r.normalMap = this.normalMap.toJSON(t).uuid, r.normalMapType = this.normalMapType, r.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (r.displacementMap = this.displacementMap.toJSON(t).uuid, r.displacementScale = this.displacementScale, r.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (r.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (r.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (r.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (r.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (r.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (r.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (r.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (r.combine = this.combine)), this.envMapIntensity !== void 0 && (r.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (r.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (r.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (r.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (r.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (r.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (r.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (r.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (r.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (r.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (r.size = this.size), this.shadowSide !== null && (r.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (r.sizeAttenuation = this.sizeAttenuation), this.blending !== Za && (r.blending = this.blending), this.side !== Hn && (r.side = this.side), this.vertexColors && (r.vertexColors = !0), this.opacity < 1 && (r.opacity = this.opacity), this.transparent === !0 && (r.transparent = this.transparent), r.depthFunc = this.depthFunc, r.depthTest = this.depthTest, r.depthWrite = this.depthWrite, r.colorWrite = this.colorWrite, r.stencilWrite = this.stencilWrite, r.stencilWriteMask = this.stencilWriteMask, r.stencilFunc = this.stencilFunc, r.stencilRef = this.stencilRef, r.stencilFuncMask = this.stencilFuncMask, r.stencilFail = this.stencilFail, r.stencilZFail = this.stencilZFail, r.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (r.rotation = this.rotation), this.polygonOffset === !0 && (r.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (r.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (r.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (r.linewidth = this.linewidth), this.dashSize !== void 0 && (r.dashSize = this.dashSize), this.gapSize !== void 0 && (r.gapSize = this.gapSize), this.scale !== void 0 && (r.scale = this.scale), this.dithering === !0 && (r.dithering = !0), this.alphaTest > 0 && (r.alphaTest = this.alphaTest), this.alphaToCoverage === !0 && (r.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (r.premultipliedAlpha = this.premultipliedAlpha), this.forceSinglePass === !0 && (r.forceSinglePass = this.forceSinglePass), this.wireframe === !0 && (r.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (r.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (r.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (r.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (r.flatShading = this.flatShading), this.visible === !1 && (r.visible = !1), this.toneMapped === !1 && (r.toneMapped = !1), this.fog === !1 && (r.fog = !1), Object.keys(this.userData).length > 0 && (r.userData = this.userData);
        function i(s) {
            let o = [];
            for(let a in s){
                let l = s[a];
                delete l.metadata, o.push(l);
            }
            return o;
        }
        if (e) {
            let s = i(t.textures), o = i(t.images);
            s.length > 0 && (r.textures = s), o.length > 0 && (r.images = o);
        }
        return r;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
        let e = t.clippingPlanes, r = null;
        if (e !== null) {
            let i = e.length;
            r = new Array(i);
            for(let s = 0; s !== i; ++s)r[s] = e[s].clone();
        }
        return this.clippingPlanes = r, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
}, on = class extends vc {
    constructor(t){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new We(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = iP, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
    }
}, hi = new E, Fg = new k, Xe = class {
    constructor(t, e, r = !1){
        if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = e, this.count = t !== void 0 ? t.length / e : 0, this.normalized = r, this.usage = rw, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
    }
    copyAt(t, e, r) {
        t *= this.itemSize, r *= e.itemSize;
        for(let i = 0, s = this.itemSize; i < s; i++)this.array[t + i] = e.array[r + i];
        return this;
    }
    copyArray(t) {
        return this.array.set(t), this;
    }
    applyMatrix3(t) {
        if (this.itemSize === 2) for(let e = 0, r = this.count; e < r; e++)Fg.fromBufferAttribute(this, e), Fg.applyMatrix3(t), this.setXY(e, Fg.x, Fg.y);
        else if (this.itemSize === 3) for(let e = 0, r = this.count; e < r; e++)hi.fromBufferAttribute(this, e), hi.applyMatrix3(t), this.setXYZ(e, hi.x, hi.y, hi.z);
        return this;
    }
    applyMatrix4(t) {
        for(let e = 0, r = this.count; e < r; e++)hi.fromBufferAttribute(this, e), hi.applyMatrix4(t), this.setXYZ(e, hi.x, hi.y, hi.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, r = this.count; e < r; e++)hi.fromBufferAttribute(this, e), hi.applyNormalMatrix(t), this.setXYZ(e, hi.x, hi.y, hi.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, r = this.count; e < r; e++)hi.fromBufferAttribute(this, e), hi.transformDirection(t), this.setXYZ(e, hi.x, hi.y, hi.z);
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    getX(t) {
        let e = this.array[t * this.itemSize];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    setX(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.array[t * this.itemSize] = e, this;
    }
    getY(t) {
        let e = this.array[t * this.itemSize + 1];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    setY(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
    }
    getZ(t) {
        let e = this.array[t * this.itemSize + 2];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    setZ(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
    }
    getW(t) {
        let e = this.array[t * this.itemSize + 3];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    setW(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
    }
    setXY(t, e, r) {
        return t *= this.itemSize, this.normalized && (e = xr(e, this.array), r = xr(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this;
    }
    setXYZ(t, e, r, i) {
        return t *= this.itemSize, this.normalized && (e = xr(e, this.array), r = xr(r, this.array), i = xr(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = i, this;
    }
    setXYZW(t, e, r, i, s) {
        return t *= this.itemSize, this.normalized && (e = xr(e, this.array), r = xr(r, this.array), i = xr(i, this.array), s = xr(s, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = i, this.array[t + 3] = s, this;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        let t = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return this.name !== "" && (t.name = this.name), this.usage !== rw && (t.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (t.updateRange = this.updateRange), t;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
};
var dy = class extends Xe {
    constructor(t, e, r){
        super(new Uint16Array(t), e, r);
    }
};
var po = class extends Xe {
    constructor(t, e, r){
        super(new Uint32Array(t), e, r);
    }
};
var Te = class extends Xe {
    constructor(t, e, r){
        super(new Float32Array(t), e, r);
    }
};
var jV = 0, rs = new ue, VS = new Tt, wu = new E, jn = new Wt, Qf = new Wt, Ri = new E, _e = class extends pr {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: jV++
        }), this.uuid = is(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(t) {
        return Array.isArray(t) ? this.index = new (lP(t) ? po : dy)(t, 1) : this.index = t, this;
    }
    getAttribute(t) {
        return this.attributes[t];
    }
    setAttribute(t, e) {
        return this.attributes[t] = e, this;
    }
    deleteAttribute(t) {
        return delete this.attributes[t], this;
    }
    hasAttribute(t) {
        return this.attributes[t] !== void 0;
    }
    addGroup(t, e, r = 0) {
        this.groups.push({
            start: t,
            count: e,
            materialIndex: r
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(t, e) {
        this.drawRange.start = t, this.drawRange.count = e;
    }
    applyMatrix4(t) {
        let e = this.attributes.position;
        e !== void 0 && (e.applyMatrix4(t), e.needsUpdate = !0);
        let r = this.attributes.normal;
        if (r !== void 0) {
            let s = new fr().getNormalMatrix(t);
            r.applyNormalMatrix(s), r.needsUpdate = !0;
        }
        let i = this.attributes.tangent;
        return i !== void 0 && (i.transformDirection(t), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t) {
        return rs.makeRotationFromQuaternion(t), this.applyMatrix4(rs), this;
    }
    rotateX(t) {
        return rs.makeRotationX(t), this.applyMatrix4(rs), this;
    }
    rotateY(t) {
        return rs.makeRotationY(t), this.applyMatrix4(rs), this;
    }
    rotateZ(t) {
        return rs.makeRotationZ(t), this.applyMatrix4(rs), this;
    }
    translate(t, e, r) {
        return rs.makeTranslation(t, e, r), this.applyMatrix4(rs), this;
    }
    scale(t, e, r) {
        return rs.makeScale(t, e, r), this.applyMatrix4(rs), this;
    }
    lookAt(t) {
        return VS.lookAt(t), VS.updateMatrix(), this.applyMatrix4(VS.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(wu).negate(), this.translate(wu.x, wu.y, wu.z), this;
    }
    setFromPoints(t) {
        let e = [];
        for(let r = 0, i = t.length; r < i; r++){
            let s = t[r];
            e.push(s.x, s.y, s.z || 0);
        }
        return this.setAttribute("position", new Te(e, 3)), this;
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Wt);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(new E(-1 / 0, -1 / 0, -1 / 0), new E(1 / 0, 1 / 0, 1 / 0));
            return;
        }
        if (t !== void 0) {
            if (this.boundingBox.setFromBufferAttribute(t), e) for(let r = 0, i = e.length; r < i; r++){
                let s = e[r];
                jn.setFromBufferAttribute(s), this.morphTargetsRelative ? (Ri.addVectors(this.boundingBox.min, jn.min), this.boundingBox.expandByPoint(Ri), Ri.addVectors(this.boundingBox.max, jn.max), this.boundingBox.expandByPoint(Ri)) : (this.boundingBox.expandByPoint(jn.min), this.boundingBox.expandByPoint(jn.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new Rr);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new E, 1 / 0);
            return;
        }
        if (t) {
            let r = this.boundingSphere.center;
            if (jn.setFromBufferAttribute(t), e) for(let s = 0, o = e.length; s < o; s++){
                let a = e[s];
                Qf.setFromBufferAttribute(a), this.morphTargetsRelative ? (Ri.addVectors(jn.min, Qf.min), jn.expandByPoint(Ri), Ri.addVectors(jn.max, Qf.max), jn.expandByPoint(Ri)) : (jn.expandByPoint(Qf.min), jn.expandByPoint(Qf.max));
            }
            jn.getCenter(r);
            let i = 0;
            for(let s = 0, o = t.count; s < o; s++)Ri.fromBufferAttribute(t, s), i = Math.max(i, r.distanceToSquared(Ri));
            if (e) for(let s = 0, o = e.length; s < o; s++){
                let a = e[s], l = this.morphTargetsRelative;
                for(let c = 0, u = a.count; c < u; c++)Ri.fromBufferAttribute(a, c), l && (wu.fromBufferAttribute(t, c), Ri.add(wu)), i = Math.max(i, r.distanceToSquared(Ri));
            }
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        let t = this.index, e = this.attributes;
        if (t === null || e.position === void 0 || e.normal === void 0 || e.uv === void 0) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        let r = t.array, i = e.position.array, s = e.normal.array, o = e.uv.array, a = i.length / 3;
        this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Xe(new Float32Array(4 * a), 4));
        let l = this.getAttribute("tangent").array, c = [], u = [];
        for(let C = 0; C < a; C++)c[C] = new E, u[C] = new E;
        let h = new E, d = new E, f = new E, p = new k, m = new k, g = new k, y = new E, x = new E;
        function v(C, P, I) {
            h.fromArray(i, C * 3), d.fromArray(i, P * 3), f.fromArray(i, I * 3), p.fromArray(o, C * 2), m.fromArray(o, P * 2), g.fromArray(o, I * 2), d.sub(h), f.sub(h), m.sub(p), g.sub(p);
            let _ = 1 / (m.x * g.y - g.x * m.y);
            !isFinite(_) || (y.copy(d).multiplyScalar(g.y).addScaledVector(f, -m.y).multiplyScalar(_), x.copy(f).multiplyScalar(m.x).addScaledVector(d, -g.x).multiplyScalar(_), c[C].add(y), c[P].add(y), c[I].add(y), u[C].add(x), u[P].add(x), u[I].add(x));
        }
        let S = this.groups;
        S.length === 0 && (S = [
            {
                start: 0,
                count: r.length
            }
        ]);
        for(let C = 0, P = S.length; C < P; ++C){
            let I = S[C], _ = I.start, D = I.count;
            for(let L = _, j = _ + D; L < j; L += 3)v(r[L + 0], r[L + 1], r[L + 2]);
        }
        let w = new E, A = new E, T = new E, b = new E;
        function M(C) {
            T.fromArray(s, C * 3), b.copy(T);
            let P = c[C];
            w.copy(P), w.sub(T.multiplyScalar(T.dot(P))).normalize(), A.crossVectors(b, P);
            let _ = A.dot(u[C]) < 0 ? -1 : 1;
            l[C * 4] = w.x, l[C * 4 + 1] = w.y, l[C * 4 + 2] = w.z, l[C * 4 + 3] = _;
        }
        for(let C = 0, P = S.length; C < P; ++C){
            let I = S[C], _ = I.start, D = I.count;
            for(let L = _, j = _ + D; L < j; L += 3)M(r[L + 0]), M(r[L + 1]), M(r[L + 2]);
        }
    }
    computeVertexNormals() {
        let t = this.index, e = this.getAttribute("position");
        if (e !== void 0) {
            let r = this.getAttribute("normal");
            if (r === void 0) r = new Xe(new Float32Array(e.count * 3), 3), this.setAttribute("normal", r);
            else for(let d = 0, f = r.count; d < f; d++)r.setXYZ(d, 0, 0, 0);
            let i = new E, s = new E, o = new E, a = new E, l = new E, c = new E, u = new E, h = new E;
            if (t) for(let d = 0, f = t.count; d < f; d += 3){
                let p = t.getX(d + 0), m = t.getX(d + 1), g = t.getX(d + 2);
                i.fromBufferAttribute(e, p), s.fromBufferAttribute(e, m), o.fromBufferAttribute(e, g), u.subVectors(o, s), h.subVectors(i, s), u.cross(h), a.fromBufferAttribute(r, p), l.fromBufferAttribute(r, m), c.fromBufferAttribute(r, g), a.add(u), l.add(u), c.add(u), r.setXYZ(p, a.x, a.y, a.z), r.setXYZ(m, l.x, l.y, l.z), r.setXYZ(g, c.x, c.y, c.z);
            }
            else for(let d = 0, f = e.count; d < f; d += 3)i.fromBufferAttribute(e, d + 0), s.fromBufferAttribute(e, d + 1), o.fromBufferAttribute(e, d + 2), u.subVectors(o, s), h.subVectors(i, s), u.cross(h), r.setXYZ(d + 0, u.x, u.y, u.z), r.setXYZ(d + 1, u.x, u.y, u.z), r.setXYZ(d + 2, u.x, u.y, u.z);
            this.normalizeNormals(), r.needsUpdate = !0;
        }
    }
    merge() {
        return console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead."), this;
    }
    normalizeNormals() {
        let t = this.attributes.normal;
        for(let e = 0, r = t.count; e < r; e++)Ri.fromBufferAttribute(t, e), Ri.normalize(), t.setXYZ(e, Ri.x, Ri.y, Ri.z);
    }
    toNonIndexed() {
        function t(a, l) {
            let c = a.array, u = a.itemSize, h = a.normalized, d = new c.constructor(l.length * u), f = 0, p = 0;
            for(let m = 0, g = l.length; m < g; m++){
                a.isInterleavedBufferAttribute ? f = l[m] * a.data.stride + a.offset : f = l[m] * u;
                for(let y = 0; y < u; y++)d[p++] = c[f++];
            }
            return new Xe(d, u, h);
        }
        if (this.index === null) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        let e = new _e, r = this.index.array, i = this.attributes;
        for(let a in i){
            let l = i[a], c = t(l, r);
            e.setAttribute(a, c);
        }
        let s = this.morphAttributes;
        for(let a in s){
            let l = [], c = s[a];
            for(let u = 0, h = c.length; u < h; u++){
                let d = c[u], f = t(d, r);
                l.push(f);
            }
            e.morphAttributes[a] = l;
        }
        e.morphTargetsRelative = this.morphTargetsRelative;
        let o = this.groups;
        for(let a = 0, l = o.length; a < l; a++){
            let c = o[a];
            e.addGroup(c.start, c.count, c.materialIndex);
        }
        return e;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
            let l = this.parameters;
            for(let c in l)l[c] !== void 0 && (t[c] = l[c]);
            return t;
        }
        t.data = {
            attributes: {}
        };
        let e = this.index;
        e !== null && (t.data.index = {
            type: e.array.constructor.name,
            array: Array.prototype.slice.call(e.array)
        });
        let r = this.attributes;
        for(let l in r){
            let c = r[l];
            t.data.attributes[l] = c.toJSON(t.data);
        }
        let i = {}, s = !1;
        for(let l in this.morphAttributes){
            let c = this.morphAttributes[l], u = [];
            for(let h = 0, d = c.length; h < d; h++){
                let f = c[h];
                u.push(f.toJSON(t.data));
            }
            u.length > 0 && (i[l] = u, s = !0);
        }
        s && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
        let o = this.groups;
        o.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(o)));
        let a = this.boundingSphere;
        return a !== null && (t.data.boundingSphere = {
            center: a.center.toArray(),
            radius: a.radius
        }), t;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        let e = {};
        this.name = t.name;
        let r = t.index;
        r !== null && this.setIndex(r.clone(e));
        let i = t.attributes;
        for(let c in i){
            let u = i[c];
            this.setAttribute(c, u.clone(e));
        }
        let s = t.morphAttributes;
        for(let c in s){
            let u = [], h = s[c];
            for(let d = 0, f = h.length; d < f; d++)u.push(h[d].clone(e));
            this.morphAttributes[c] = u;
        }
        this.morphTargetsRelative = t.morphTargetsRelative;
        let o = t.groups;
        for(let c = 0, u = o.length; c < u; c++){
            let h = o[c];
            this.addGroup(h.start, h.count, h.materialIndex);
        }
        let a = t.boundingBox;
        a !== null && (this.boundingBox = a.clone());
        let l = t.boundingSphere;
        return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, t.parameters !== void 0 && (this.parameters = Object.assign({}, t.parameters)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, uC = new ue, Au = new Ls, kS = new Rr, Zf = new E, Jf = new E, $f = new E, US = new E, Vg = new E, kg = new k, Ug = new k, zg = new k, zS = new E, Gg = new E, zt = class extends Tt {
    constructor(t = new _e, e = new on){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, r = Object.keys(e);
        if (r.length > 0) {
            let i = e[r[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, o = i.length; s < o; s++){
                    let a = i[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s;
                }
            }
        }
    }
    getVertexPosition(t, e) {
        let r = this.geometry, i = r.attributes.position, s = r.morphAttributes.position, o = r.morphTargetsRelative;
        e.fromBufferAttribute(i, t);
        let a = this.morphTargetInfluences;
        if (s && a) {
            Vg.set(0, 0, 0);
            for(let l = 0, c = s.length; l < c; l++){
                let u = a[l], h = s[l];
                u !== 0 && (US.fromBufferAttribute(h, t), o ? Vg.addScaledVector(US, u) : Vg.addScaledVector(US.sub(e), u));
            }
            e.add(Vg);
        }
        return this.isSkinnedMesh && this.boneTransform(t, e), e;
    }
    raycast(t, e) {
        let r = this.geometry, i = this.material, s = this.matrixWorld;
        if (i === void 0 || (r.boundingSphere === null && r.computeBoundingSphere(), kS.copy(r.boundingSphere), kS.applyMatrix4(s), t.ray.intersectsSphere(kS) === !1) || (uC.copy(s).invert(), Au.copy(t.ray).applyMatrix4(uC), r.boundingBox !== null && Au.intersectsBox(r.boundingBox) === !1)) return;
        let o, a = r.index, l = r.attributes.position, c = r.attributes.uv, u = r.attributes.uv2, h = r.groups, d = r.drawRange;
        if (a !== null) {
            if (Array.isArray(i)) for(let f = 0, p = h.length; f < p; f++){
                let m = h[f], g = i[m.materialIndex], y = Math.max(m.start, d.start), x = Math.min(a.count, Math.min(m.start + m.count, d.start + d.count));
                for(let v = y, S = x; v < S; v += 3){
                    let w = a.getX(v), A = a.getX(v + 1), T = a.getX(v + 2);
                    o = jg(this, g, t, Au, c, u, w, A, T), o && (o.faceIndex = Math.floor(v / 3), o.face.materialIndex = m.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, d.start), p = Math.min(a.count, d.start + d.count);
                for(let m = f, g = p; m < g; m += 3){
                    let y = a.getX(m), x = a.getX(m + 1), v = a.getX(m + 2);
                    o = jg(this, i, t, Au, c, u, y, x, v), o && (o.faceIndex = Math.floor(m / 3), e.push(o));
                }
            }
        } else if (l !== void 0) {
            if (Array.isArray(i)) for(let f = 0, p = h.length; f < p; f++){
                let m = h[f], g = i[m.materialIndex], y = Math.max(m.start, d.start), x = Math.min(l.count, Math.min(m.start + m.count, d.start + d.count));
                for(let v = y, S = x; v < S; v += 3){
                    let w = v, A = v + 1, T = v + 2;
                    o = jg(this, g, t, Au, c, u, w, A, T), o && (o.faceIndex = Math.floor(v / 3), o.face.materialIndex = m.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, d.start), p = Math.min(l.count, d.start + d.count);
                for(let m = f, g = p; m < g; m += 3){
                    let y = m, x = m + 1, v = m + 2;
                    o = jg(this, i, t, Au, c, u, y, x, v), o && (o.faceIndex = Math.floor(m / 3), e.push(o));
                }
            }
        }
    }
};
function HV(n1, t, e, r, i, s, o, a) {
    let l;
    if (t.side === pi ? l = r.intersectTriangle(o, s, i, !0, a) : l = r.intersectTriangle(i, s, o, t.side === Hn, a), l === null) return null;
    Gg.copy(a), Gg.applyMatrix4(n1.matrixWorld);
    let c = e.ray.origin.distanceTo(Gg);
    return c < e.near || c > e.far ? null : {
        distance: c,
        point: Gg.clone(),
        object: n1
    };
}
function jg(n1, t, e, r, i, s, o, a, l) {
    n1.getVertexPosition(o, Zf), n1.getVertexPosition(a, Jf), n1.getVertexPosition(l, $f);
    let c = HV(n1, t, e, r, Zf, Jf, $f, zS);
    if (c) {
        i && (kg.fromBufferAttribute(i, o), Ug.fromBufferAttribute(i, a), zg.fromBufferAttribute(i, l), c.uv = Cr.getUV(zS, Zf, Jf, $f, kg, Ug, zg, new k)), s && (kg.fromBufferAttribute(s, o), Ug.fromBufferAttribute(s, a), zg.fromBufferAttribute(s, l), c.uv2 = Cr.getUV(zS, Zf, Jf, $f, kg, Ug, zg, new k));
        let u = {
            a: o,
            b: a,
            c: l,
            normal: new E,
            materialIndex: 0
        };
        Cr.getNormal(Zf, Jf, $f, u.normal), c.face = u;
    }
    return c;
}
var mi = class extends _e {
    constructor(t = 1, e = 1, r = 1, i = 1, s = 1, o = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: t,
            height: e,
            depth: r,
            widthSegments: i,
            heightSegments: s,
            depthSegments: o
        };
        let a = this;
        i = Math.floor(i), s = Math.floor(s), o = Math.floor(o);
        let l = [], c = [], u = [], h = [], d = 0, f = 0;
        p("z", "y", "x", -1, -1, r, e, t, o, s, 0), p("z", "y", "x", 1, -1, r, e, -t, o, s, 1), p("x", "z", "y", 1, 1, t, r, e, i, o, 2), p("x", "z", "y", 1, -1, t, r, -e, i, o, 3), p("x", "y", "z", 1, -1, t, e, r, i, s, 4), p("x", "y", "z", -1, -1, t, e, -r, i, s, 5), this.setIndex(l), this.setAttribute("position", new Te(c, 3)), this.setAttribute("normal", new Te(u, 3)), this.setAttribute("uv", new Te(h, 2));
        function p(m, g, y, x, v, S, w, A, T, b, M) {
            let C = S / T, P = w / b, I = S / 2, _ = w / 2, D = A / 2, L = T + 1, j = b + 1, V = 0, H = 0, W = new E;
            for(let q = 0; q < j; q++){
                let Q = q * P - _;
                for(let G = 0; G < L; G++){
                    let Z = G * C - I;
                    W[m] = Z * x, W[g] = Q * v, W[y] = D, c.push(W.x, W.y, W.z), W[m] = 0, W[g] = 0, W[y] = A > 0 ? 1 : -1, u.push(W.x, W.y, W.z), h.push(G / T), h.push(1 - q / b), V += 1;
                }
            }
            for(let q = 0; q < b; q++)for(let Q = 0; Q < T; Q++){
                let G = d + Q + L * q, Z = d + Q + L * (q + 1), te = d + (Q + 1) + L * (q + 1), $ = d + (Q + 1) + L * q;
                l.push(G, Z, $), l.push(Z, te, $), H += 6;
            }
            a.addGroup(f, H, M), f += H, d += V;
        }
    }
    static fromJSON(t) {
        return new mi(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
};
function Lu(n1) {
    let t = {};
    for(let e in n1){
        t[e] = {};
        for(let r in n1[e]){
            let i = n1[e][r];
            i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? t[e][r] = i.clone() : Array.isArray(i) ? t[e][r] = i.slice() : t[e][r] = i;
        }
    }
    return t;
}
function pn(n1) {
    let t = {};
    for(let e = 0; e < n1.length; e++){
        let r = Lu(n1[e]);
        for(let i in r)t[i] = r[i];
    }
    return t;
}
function WV(n1) {
    let t = [];
    for(let e = 0; e < n1.length; e++)t.push(n1[e].clone());
    return t;
}
function uP(n1) {
    return n1.getRenderTarget() === null && n1.outputEncoding === at ? ho : cp;
}
var Ns = {
    clone: Lu,
    merge: pn
}, qV = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, YV = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`, it = class extends vc {
    constructor(t){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = qV, this.fragmentShader = YV, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv2: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, t !== void 0 && this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = Lu(t.uniforms), this.uniformsGroups = WV(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        e.glslVersion = this.glslVersion, e.uniforms = {};
        for(let i in this.uniforms){
            let o = this.uniforms[i].value;
            o && o.isTexture ? e.uniforms[i] = {
                type: "t",
                value: o.toJSON(t).uuid
            } : o && o.isColor ? e.uniforms[i] = {
                type: "c",
                value: o.getHex()
            } : o && o.isVector2 ? e.uniforms[i] = {
                type: "v2",
                value: o.toArray()
            } : o && o.isVector3 ? e.uniforms[i] = {
                type: "v3",
                value: o.toArray()
            } : o && o.isVector4 ? e.uniforms[i] = {
                type: "v4",
                value: o.toArray()
            } : o && o.isMatrix3 ? e.uniforms[i] = {
                type: "m3",
                value: o.toArray()
            } : o && o.isMatrix4 ? e.uniforms[i] = {
                type: "m4",
                value: o.toArray()
            } : e.uniforms[i] = {
                value: o
            };
        }
        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
        let r = {};
        for(let i in this.extensions)this.extensions[i] === !0 && (r[i] = !0);
        return Object.keys(r).length > 0 && (e.extensions = r), e;
    }
}, qn = class extends Tt {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new ue, this.projectionMatrix = new ue, this.projectionMatrixInverse = new ue;
    }
    copy(t, e) {
        return super.copy(t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(t, e) {
        super.updateWorldMatrix(t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, $r = class extends qn {
    constructor(t = 50, e = 1, r = .1, i = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = r, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = t.view === null ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
    setFocalLength(t) {
        let e = .5 * this.getFilmHeight() / t;
        this.fov = up * 2 * Math.atan(e), this.updateProjectionMatrix();
    }
    getFocalLength() {
        let t = Math.tan(np * .5 * this.fov);
        return .5 * this.getFilmHeight() / t;
    }
    getEffectiveFOV() {
        return up * 2 * Math.atan(Math.tan(np * .5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    setViewOffset(t, e, r, i, s, o) {
        this.aspect = t / e, this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = r, this.view.offsetY = i, this.view.width = s, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = this.near, e = t * Math.tan(np * .5 * this.fov) / this.zoom, r = 2 * e, i = this.aspect * r, s = -0.5 * i, o = this.view;
        if (this.view !== null && this.view.enabled) {
            let l = o.fullWidth, c = o.fullHeight;
            s += o.offsetX * i / l, e -= o.offsetY * r / c, i *= o.width / l, r *= o.height / c;
        }
        let a = this.filmOffset;
        a !== 0 && (s += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(s, s + i, e, e - r, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, this.view !== null && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
}, Eu = -90, Tu = 1, sw = class extends Tt {
    constructor(t, e, r){
        super(), this.type = "CubeCamera", this.renderTarget = r;
        let i = new $r(Eu, Tu, t, e);
        i.layers = this.layers, i.up.set(0, 1, 0), i.lookAt(1, 0, 0), this.add(i);
        let s = new $r(Eu, Tu, t, e);
        s.layers = this.layers, s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), this.add(s);
        let o = new $r(Eu, Tu, t, e);
        o.layers = this.layers, o.up.set(0, 0, -1), o.lookAt(0, 1, 0), this.add(o);
        let a = new $r(Eu, Tu, t, e);
        a.layers = this.layers, a.up.set(0, 0, 1), a.lookAt(0, -1, 0), this.add(a);
        let l = new $r(Eu, Tu, t, e);
        l.layers = this.layers, l.up.set(0, 1, 0), l.lookAt(0, 0, 1), this.add(l);
        let c = new $r(Eu, Tu, t, e);
        c.layers = this.layers, c.up.set(0, 1, 0), c.lookAt(0, 0, -1), this.add(c);
    }
    update(t, e) {
        this.parent === null && this.updateMatrixWorld();
        let r = this.renderTarget, [i, s, o, a, l, c] = this.children, u = t.getRenderTarget(), h = t.toneMapping, d = t.xr.enabled;
        t.toneMapping = Os, t.xr.enabled = !1;
        let f = r.texture.generateMipmaps;
        r.texture.generateMipmaps = !1, t.setRenderTarget(r, 0), t.render(e, i), t.setRenderTarget(r, 1), t.render(e, s), t.setRenderTarget(r, 2), t.render(e, o), t.setRenderTarget(r, 3), t.render(e, a), t.setRenderTarget(r, 4), t.render(e, l), r.texture.generateMipmaps = f, t.setRenderTarget(r, 5), t.render(e, c), t.setRenderTarget(u), t.toneMapping = h, t.xr.enabled = d, r.texture.needsPMREMUpdate = !0;
    }
}, Bu = class extends er {
    constructor(t, e, r, i, s, o, a, l, c, u){
        t = t !== void 0 ? t : [], e = e !== void 0 ? e : $a, super(t, e, r, i, s, o, a, l, c, u), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(t) {
        this.image = t;
    }
}, ow = class extends dt {
    constructor(t = 1, e = {}){
        super(t, t, e), this.isWebGLCubeRenderTarget = !0;
        let r = {
            width: t,
            height: t,
            depth: 1
        }, i = [
            r,
            r,
            r,
            r,
            r,
            r
        ];
        this.texture = new Bu(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = e.generateMipmaps !== void 0 ? e.generateMipmaps : !1, this.texture.minFilter = e.minFilter !== void 0 ? e.minFilter : rt;
    }
    fromEquirectangularTexture(t, e) {
        this.texture.type = e.type, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        let r = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        }, i = new mi(5, 5, 5), s = new it({
            name: "CubemapFromEquirect",
            uniforms: Lu(r.uniforms),
            vertexShader: r.vertexShader,
            fragmentShader: r.fragmentShader,
            side: pi,
            blending: $t
        });
        s.uniforms.tEquirect.value = e;
        let o = new zt(i, s), a = e.minFilter;
        return e.minFilter === yc && (e.minFilter = rt), new sw(1, 10, this).update(t, o), e.minFilter = a, o.geometry.dispose(), o.material.dispose(), this;
    }
    clear(t, e, r, i) {
        let s = t.getRenderTarget();
        for(let o = 0; o < 6; o++)t.setRenderTarget(this, o), t.clear(e, r, i);
        t.setRenderTarget(s);
    }
}, GS = new E, XV = new E, KV = new fr, kr = class {
    constructor(t = new E(1, 0, 0), e = 0){
        this.isPlane = !0, this.normal = t, this.constant = e;
    }
    set(t, e) {
        return this.normal.copy(t), this.constant = e, this;
    }
    setComponents(t, e, r, i) {
        return this.normal.set(t, e, r), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(t, e) {
        return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t, e, r) {
        let i = GS.subVectors(r, e).cross(XV.subVectors(t, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
    copy(t) {
        return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
    normalize() {
        let t = 1 / this.normal.length();
        return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t) {
        return this.normal.dot(t) + this.constant;
    }
    distanceToSphere(t) {
        return this.distanceToPoint(t.center) - t.radius;
    }
    projectPoint(t, e) {
        return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
    }
    intersectLine(t, e) {
        let r = t.delta(GS), i = this.normal.dot(r);
        if (i === 0) return this.distanceToPoint(t.start) === 0 ? e.copy(t.start) : null;
        let s = -(t.start.dot(this.normal) + this.constant) / i;
        return s < 0 || s > 1 ? null : e.copy(r).multiplyScalar(s).add(t.start);
    }
    intersectsLine(t) {
        let e = this.distanceToPoint(t.start), r = this.distanceToPoint(t.end);
        return e < 0 && r > 0 || r < 0 && e > 0;
    }
    intersectsBox(t) {
        return t.intersectsPlane(this);
    }
    intersectsSphere(t) {
        return t.intersectsPlane(this);
    }
    coplanarPoint(t) {
        return t.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t, e) {
        let r = e || KV.getNormalMatrix(t), i = this.coplanarPoint(GS).applyMatrix4(t), s = this.normal.applyMatrix3(r).normalize();
        return this.constant = -i.dot(s), this;
    }
    translate(t) {
        return this.constant -= t.dot(this.normal), this;
    }
    equals(t) {
        return t.normal.equals(this.normal) && t.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, Mu = new Rr, Hg = new E, fp = class {
    constructor(t = new kr, e = new kr, r = new kr, i = new kr, s = new kr, o = new kr){
        this.planes = [
            t,
            e,
            r,
            i,
            s,
            o
        ];
    }
    set(t, e, r, i, s, o) {
        let a = this.planes;
        return a[0].copy(t), a[1].copy(e), a[2].copy(r), a[3].copy(i), a[4].copy(s), a[5].copy(o), this;
    }
    copy(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++)e[r].copy(t.planes[r]);
        return this;
    }
    setFromProjectionMatrix(t) {
        let e = this.planes, r = t.elements, i = r[0], s = r[1], o = r[2], a = r[3], l = r[4], c = r[5], u = r[6], h = r[7], d = r[8], f = r[9], p = r[10], m = r[11], g = r[12], y = r[13], x = r[14], v = r[15];
        return e[0].setComponents(a - i, h - l, m - d, v - g).normalize(), e[1].setComponents(a + i, h + l, m + d, v + g).normalize(), e[2].setComponents(a + s, h + c, m + f, v + y).normalize(), e[3].setComponents(a - s, h - c, m - f, v - y).normalize(), e[4].setComponents(a - o, h - u, m - p, v - x).normalize(), e[5].setComponents(a + o, h + u, m + p, v + x).normalize(), this;
    }
    intersectsObject(t) {
        let e = t.geometry;
        return e.boundingSphere === null && e.computeBoundingSphere(), Mu.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(Mu);
    }
    intersectsSprite(t) {
        return Mu.center.set(0, 0, 0), Mu.radius = .7071067811865476, Mu.applyMatrix4(t.matrixWorld), this.intersectsSphere(Mu);
    }
    intersectsSphere(t) {
        let e = this.planes, r = t.center, i = -t.radius;
        for(let s = 0; s < 6; s++)if (e[s].distanceToPoint(r) < i) return !1;
        return !0;
    }
    intersectsBox(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++){
            let i = e[r];
            if (Hg.x = i.normal.x > 0 ? t.max.x : t.min.x, Hg.y = i.normal.y > 0 ? t.max.y : t.min.y, Hg.z = i.normal.z > 0 ? t.max.z : t.min.z, i.distanceToPoint(Hg) < 0) return !1;
        }
        return !0;
    }
    containsPoint(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++)if (e[r].distanceToPoint(t) < 0) return !1;
        return !0;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
function hP() {
    let n1 = null, t = !1, e = null, r = null;
    function i(s, o) {
        e(s, o), r = n1.requestAnimationFrame(i);
    }
    return {
        start: function() {
            t !== !0 && e !== null && (r = n1.requestAnimationFrame(i), t = !0);
        },
        stop: function() {
            n1.cancelAnimationFrame(r), t = !1;
        },
        setAnimationLoop: function(s) {
            e = s;
        },
        setContext: function(s) {
            n1 = s;
        }
    };
}
function QV(n1, t) {
    let e = t.isWebGL2, r = new WeakMap;
    function i(c, u) {
        let h = c.array, d = c.usage, f = n1.createBuffer();
        n1.bindBuffer(u, f), n1.bufferData(u, h, d), c.onUploadCallback();
        let p;
        if (h instanceof Float32Array) p = 5126;
        else if (h instanceof Uint16Array) {
            if (c.isFloat16BufferAttribute) {
                if (e) p = 5131;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else p = 5123;
        } else if (h instanceof Int16Array) p = 5122;
        else if (h instanceof Uint32Array) p = 5125;
        else if (h instanceof Int32Array) p = 5124;
        else if (h instanceof Int8Array) p = 5120;
        else if (h instanceof Uint8Array) p = 5121;
        else if (h instanceof Uint8ClampedArray) p = 5121;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
        return {
            buffer: f,
            type: p,
            bytesPerElement: h.BYTES_PER_ELEMENT,
            version: c.version
        };
    }
    function s(c, u, h) {
        let d = u.array, f = u.updateRange;
        n1.bindBuffer(h, c), f.count === -1 ? n1.bufferSubData(h, 0, d) : (e ? n1.bufferSubData(h, f.offset * d.BYTES_PER_ELEMENT, d, f.offset, f.count) : n1.bufferSubData(h, f.offset * d.BYTES_PER_ELEMENT, d.subarray(f.offset, f.offset + f.count)), f.count = -1), u.onUploadCallback();
    }
    function o(c) {
        return c.isInterleavedBufferAttribute && (c = c.data), r.get(c);
    }
    function a(c) {
        c.isInterleavedBufferAttribute && (c = c.data);
        let u = r.get(c);
        u && (n1.deleteBuffer(u.buffer), r.delete(c));
    }
    function l(c, u) {
        if (c.isGLBufferAttribute) {
            let d = r.get(c);
            (!d || d.version < c.version) && r.set(c, {
                buffer: c.buffer,
                type: c.type,
                bytesPerElement: c.elementSize,
                version: c.version
            });
            return;
        }
        c.isInterleavedBufferAttribute && (c = c.data);
        let h = r.get(c);
        h === void 0 ? r.set(c, i(c, u)) : h.version < c.version && (s(h.buffer, c, u), h.version = c.version);
    }
    return {
        get: o,
        remove: a,
        update: l
    };
}
var Li = class extends _e {
    constructor(t = 1, e = 1, r = 1, i = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: t,
            height: e,
            widthSegments: r,
            heightSegments: i
        };
        let s = t / 2, o = e / 2, a = Math.floor(r), l = Math.floor(i), c = a + 1, u = l + 1, h = t / a, d = e / l, f = [], p = [], m = [], g = [];
        for(let y = 0; y < u; y++){
            let x = y * d - o;
            for(let v = 0; v < c; v++){
                let S = v * h - s;
                p.push(S, -x, 0), m.push(0, 0, 1), g.push(v / a), g.push(1 - y / l);
            }
        }
        for(let y = 0; y < l; y++)for(let x = 0; x < a; x++){
            let v = x + c * y, S = x + c * (y + 1), w = x + 1 + c * (y + 1), A = x + 1 + c * y;
            f.push(v, S, A), f.push(S, w, A);
        }
        this.setIndex(f), this.setAttribute("position", new Te(p, 3)), this.setAttribute("normal", new Te(m, 3)), this.setAttribute("uv", new Te(g, 2));
    }
    static fromJSON(t) {
        return new Li(t.width, t.height, t.widthSegments, t.heightSegments);
    }
}, ZV = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vUv ).g;
#endif`, JV = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, $V = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, ek = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, tk = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, rk = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, ik = "vec3 transformed = vec3( position );", nk = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, sk = `vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#ifdef USE_IRIDESCENCE
	vec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif`, ok = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			 return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, ak = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vUv );
		vec2 dSTdy = dFdy( vUv );
		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = dFdx( surf_pos.xyz );
		vec3 vSigmaY = dFdy( surf_pos.xyz );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, lk = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, ck = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, uk = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, hk = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, dk = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, fk = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, pk = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, mk = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, gk = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}`, yk = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, vk = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, xk = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, bk = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );
#endif`, Sk = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, wk = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, Ak = "gl_FragColor = linearToOutputTexel( gl_FragColor );", Ek = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, Tk = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, Mk = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, Ck = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, Pk = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, _k = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, Ik = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, Dk = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, Ok = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, Rk = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, Lk = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, Bk = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vUv2 );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, Nk = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Fk = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, Vk = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, kk = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( PHYSICALLY_CORRECT_LIGHTS )
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#else
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, Uk = `#if defined( USE_ENVMAP )
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
#endif`, zk = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, Gk = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, jk = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, Hk = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, Wk = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULARINTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;
		#endif
		#ifdef USE_SPECULARCOLORMAP
			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEENCOLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEENROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;
	#endif
#endif`, qk = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	#ifdef USE_IRIDESCENCE
		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );
	#else
		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, Yk = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometry.viewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, Xk = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, Kk = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, Qk = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, Zk = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, Jk = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, $k = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, eU = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, tU = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, rU = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, iU = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	uniform mat3 uvTransform;
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, nU = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vUv );
	metalnessFactor *= texelMetalness.b;
#endif`, sU = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, oU = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, aU = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, lU = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, cU = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, uU = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	#ifdef USE_TANGENT
		vec3 tangent = normalize( vTangent );
		vec3 bitangent = normalize( vBitangent );
		#ifdef DOUBLE_SIDED
			tangent = tangent * faceDirection;
			bitangent = bitangent * faceDirection;
		#endif
		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )
			mat3 vTBN = mat3( tangent, bitangent, normal );
		#endif
	#endif
#endif
vec3 geometryNormal = normal;`, hU = `#ifdef OBJECTSPACE_NORMALMAP
	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( TANGENTSPACE_NORMALMAP )
	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	#ifdef USE_TANGENT
		normal = normalize( vTBN * mapN );
	#else
		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );
	#endif
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, dU = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, fU = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, pU = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, mU = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef OBJECTSPACE_NORMALMAP
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )
	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( vUv.st );
		vec2 st1 = dFdy( vUv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );
		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );
	}
#endif`, gU = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, yU = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	#ifdef USE_TANGENT
		clearcoatNormal = normalize( vTBN * clearcoatMapN );
	#else
		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );
	#endif
#endif`, vU = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif`, xU = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, bU = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha + 0.1;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, SU = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {
	return linearClipZ * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * invClipZ - far );
}`, wU = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, AU = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, EU = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, TU = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, MU = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vUv );
	roughnessFactor *= texelRoughness.g;
#endif`, CU = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, PU = `#if NUM_SPOT_LIGHT_COORDS > 0
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, _U = `#if NUM_SPOT_LIGHT_COORDS > 0
  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, IU = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, DU = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, OU = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, RU = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, LU = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, BU = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, NU = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, FU = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, VU = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, kU = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return toneMappingExposure * color;
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, UU = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmission = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );
#endif`, zU = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		#ifdef texture2DLodEXT
			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#else
			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#endif
	}
	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return radiance;
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
	}
#endif`, GU = `#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )
	varying vec2 vUv;
#endif`, jU = `#ifdef USE_UV
	#ifdef UVS_VERTEX_ONLY
		vec2 vUv;
	#else
		varying vec2 vUv;
	#endif
	uniform mat3 uvTransform;
#endif`, HU = `#ifdef USE_UV
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif`, WU = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	varying vec2 vUv2;
#endif`, qU = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;
#endif`, YU = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;
#endif`, XU = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`, KU = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, QU = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, ZU = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, JU = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, $U = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, ez = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, tz = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, rz = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, iz = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, nz = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, sz = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, oz = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, az = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, lz = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, cz = `#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, uz = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, hz = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, dz = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, fz = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, pz = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, mz = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	vViewPosition = - mvPosition.xyz;
#endif
}`, gz = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, yz = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, vz = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, xz = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, bz = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULARINTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
	#ifdef USE_SPECULARCOLORMAP
		uniform sampler2D specularColorMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEENCOLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEENROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Sz = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, wz = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Az = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, Ez = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, Tz = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Mz = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, Cz = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, Pz = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, xt = {
    alphamap_fragment: ZV,
    alphamap_pars_fragment: JV,
    alphatest_fragment: $V,
    alphatest_pars_fragment: ek,
    aomap_fragment: tk,
    aomap_pars_fragment: rk,
    begin_vertex: ik,
    beginnormal_vertex: nk,
    bsdfs: sk,
    iridescence_fragment: ok,
    bumpmap_pars_fragment: ak,
    clipping_planes_fragment: lk,
    clipping_planes_pars_fragment: ck,
    clipping_planes_pars_vertex: uk,
    clipping_planes_vertex: hk,
    color_fragment: dk,
    color_pars_fragment: fk,
    color_pars_vertex: pk,
    color_vertex: mk,
    common: gk,
    cube_uv_reflection_fragment: yk,
    defaultnormal_vertex: vk,
    displacementmap_pars_vertex: xk,
    displacementmap_vertex: bk,
    emissivemap_fragment: Sk,
    emissivemap_pars_fragment: wk,
    encodings_fragment: Ak,
    encodings_pars_fragment: Ek,
    envmap_fragment: Tk,
    envmap_common_pars_fragment: Mk,
    envmap_pars_fragment: Ck,
    envmap_pars_vertex: Pk,
    envmap_physical_pars_fragment: Uk,
    envmap_vertex: _k,
    fog_vertex: Ik,
    fog_pars_vertex: Dk,
    fog_fragment: Ok,
    fog_pars_fragment: Rk,
    gradientmap_pars_fragment: Lk,
    lightmap_fragment: Bk,
    lightmap_pars_fragment: Nk,
    lights_lambert_fragment: Fk,
    lights_lambert_pars_fragment: Vk,
    lights_pars_begin: kk,
    lights_toon_fragment: zk,
    lights_toon_pars_fragment: Gk,
    lights_phong_fragment: jk,
    lights_phong_pars_fragment: Hk,
    lights_physical_fragment: Wk,
    lights_physical_pars_fragment: qk,
    lights_fragment_begin: Yk,
    lights_fragment_maps: Xk,
    lights_fragment_end: Kk,
    logdepthbuf_fragment: Qk,
    logdepthbuf_pars_fragment: Zk,
    logdepthbuf_pars_vertex: Jk,
    logdepthbuf_vertex: $k,
    map_fragment: eU,
    map_pars_fragment: tU,
    map_particle_fragment: rU,
    map_particle_pars_fragment: iU,
    metalnessmap_fragment: nU,
    metalnessmap_pars_fragment: sU,
    morphcolor_vertex: oU,
    morphnormal_vertex: aU,
    morphtarget_pars_vertex: lU,
    morphtarget_vertex: cU,
    normal_fragment_begin: uU,
    normal_fragment_maps: hU,
    normal_pars_fragment: dU,
    normal_pars_vertex: fU,
    normal_vertex: pU,
    normalmap_pars_fragment: mU,
    clearcoat_normal_fragment_begin: gU,
    clearcoat_normal_fragment_maps: yU,
    clearcoat_pars_fragment: vU,
    iridescence_pars_fragment: xU,
    output_fragment: bU,
    packing: SU,
    premultiplied_alpha_fragment: wU,
    project_vertex: AU,
    dithering_fragment: EU,
    dithering_pars_fragment: TU,
    roughnessmap_fragment: MU,
    roughnessmap_pars_fragment: CU,
    shadowmap_pars_fragment: PU,
    shadowmap_pars_vertex: _U,
    shadowmap_vertex: IU,
    shadowmask_pars_fragment: DU,
    skinbase_vertex: OU,
    skinning_pars_vertex: RU,
    skinning_vertex: LU,
    skinnormal_vertex: BU,
    specularmap_fragment: NU,
    specularmap_pars_fragment: FU,
    tonemapping_fragment: VU,
    tonemapping_pars_fragment: kU,
    transmission_fragment: UU,
    transmission_pars_fragment: zU,
    uv_pars_fragment: GU,
    uv_pars_vertex: jU,
    uv_vertex: HU,
    uv2_pars_fragment: WU,
    uv2_pars_vertex: qU,
    uv2_vertex: YU,
    worldpos_vertex: XU,
    background_vert: KU,
    background_frag: QU,
    backgroundCube_vert: ZU,
    backgroundCube_frag: JU,
    cube_vert: $U,
    cube_frag: ez,
    depth_vert: tz,
    depth_frag: rz,
    distanceRGBA_vert: iz,
    distanceRGBA_frag: nz,
    equirect_vert: sz,
    equirect_frag: oz,
    linedashed_vert: az,
    linedashed_frag: lz,
    meshbasic_vert: cz,
    meshbasic_frag: uz,
    meshlambert_vert: hz,
    meshlambert_frag: dz,
    meshmatcap_vert: fz,
    meshmatcap_frag: pz,
    meshnormal_vert: mz,
    meshnormal_frag: gz,
    meshphong_vert: yz,
    meshphong_frag: vz,
    meshphysical_vert: xz,
    meshphysical_frag: bz,
    meshtoon_vert: Sz,
    meshtoon_frag: wz,
    points_vert: Az,
    points_frag: Ez,
    shadow_vert: Tz,
    shadow_frag: Mz,
    sprite_vert: Cz,
    sprite_frag: Pz
}, Ie = {
    common: {
        diffuse: {
            value: new We(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new fr
        },
        uv2Transform: {
            value: new fr
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new k(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new We(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new We(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new fr
        }
    },
    sprite: {
        diffuse: {
            value: new We(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new k(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new fr
        }
    }
}, fo = {
    basic: {
        uniforms: pn([
            Ie.common,
            Ie.specularmap,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.fog
        ]),
        vertexShader: xt.meshbasic_vert,
        fragmentShader: xt.meshbasic_frag
    },
    lambert: {
        uniforms: pn([
            Ie.common,
            Ie.specularmap,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new We(0)
                }
            }
        ]),
        vertexShader: xt.meshlambert_vert,
        fragmentShader: xt.meshlambert_frag
    },
    phong: {
        uniforms: pn([
            Ie.common,
            Ie.specularmap,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new We(0)
                },
                specular: {
                    value: new We(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: xt.meshphong_vert,
        fragmentShader: xt.meshphong_frag
    },
    standard: {
        uniforms: pn([
            Ie.common,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.roughnessmap,
            Ie.metalnessmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new We(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: xt.meshphysical_vert,
        fragmentShader: xt.meshphysical_frag
    },
    toon: {
        uniforms: pn([
            Ie.common,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.gradientmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new We(0)
                }
            }
        ]),
        vertexShader: xt.meshtoon_vert,
        fragmentShader: xt.meshtoon_frag
    },
    matcap: {
        uniforms: pn([
            Ie.common,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: xt.meshmatcap_vert,
        fragmentShader: xt.meshmatcap_frag
    },
    points: {
        uniforms: pn([
            Ie.points,
            Ie.fog
        ]),
        vertexShader: xt.points_vert,
        fragmentShader: xt.points_frag
    },
    dashed: {
        uniforms: pn([
            Ie.common,
            Ie.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: xt.linedashed_vert,
        fragmentShader: xt.linedashed_frag
    },
    depth: {
        uniforms: pn([
            Ie.common,
            Ie.displacementmap
        ]),
        vertexShader: xt.depth_vert,
        fragmentShader: xt.depth_frag
    },
    normal: {
        uniforms: pn([
            Ie.common,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: xt.meshnormal_vert,
        fragmentShader: xt.meshnormal_frag
    },
    sprite: {
        uniforms: pn([
            Ie.sprite,
            Ie.fog
        ]),
        vertexShader: xt.sprite_vert,
        fragmentShader: xt.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new fr
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: xt.background_vert,
        fragmentShader: xt.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: xt.backgroundCube_vert,
        fragmentShader: xt.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: xt.cube_vert,
        fragmentShader: xt.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: xt.equirect_vert,
        fragmentShader: xt.equirect_frag
    },
    distanceRGBA: {
        uniforms: pn([
            Ie.common,
            Ie.displacementmap,
            {
                referencePosition: {
                    value: new E
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: xt.distanceRGBA_vert,
        fragmentShader: xt.distanceRGBA_frag
    },
    shadow: {
        uniforms: pn([
            Ie.lights,
            Ie.fog,
            {
                color: {
                    value: new We(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: xt.shadow_vert,
        fragmentShader: xt.shadow_frag
    }
};
fo.physical = {
    uniforms: pn([
        fo.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new k(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new We(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new k
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new We(0)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new We(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: xt.meshphysical_vert,
    fragmentShader: xt.meshphysical_frag
};
var Wg = {
    r: 0,
    b: 0,
    g: 0
};
function _z(n1, t, e, r, i, s, o) {
    let a = new We(0), l = s === !0 ? 0 : 1, c, u, h = null, d = 0, f = null;
    function p(g, y) {
        let x = !1, v = y.isScene === !0 ? y.background : null;
        v && v.isTexture && (v = (y.backgroundBlurriness > 0 ? e : t).get(v));
        let S = n1.xr, w = S.getSession && S.getSession();
        w && w.environmentBlendMode === "additive" && (v = null), v === null ? m(a, l) : v && v.isColor && (m(v, 1), x = !0), (n1.autoClear || x) && n1.clear(n1.autoClearColor, n1.autoClearDepth, n1.autoClearStencil), v && (v.isCubeTexture || v.mapping === $u) ? (u === void 0 && (u = new zt(new mi(1, 1, 1), new it({
            name: "BackgroundCubeMaterial",
            uniforms: Lu(fo.backgroundCube.uniforms),
            vertexShader: fo.backgroundCube.vertexShader,
            fragmentShader: fo.backgroundCube.fragmentShader,
            side: pi,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), u.geometry.deleteAttribute("normal"), u.geometry.deleteAttribute("uv"), u.onBeforeRender = function(A, T, b) {
            this.matrixWorld.copyPosition(b.matrixWorld);
        }, Object.defineProperty(u.material, "envMap", {
            get: function() {
                return this.uniforms.envMap.value;
            }
        }), i.update(u)), u.material.uniforms.envMap.value = v, u.material.uniforms.flipEnvMap.value = v.isCubeTexture && v.isRenderTargetTexture === !1 ? -1 : 1, u.material.uniforms.backgroundBlurriness.value = y.backgroundBlurriness, u.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, u.material.toneMapped = v.encoding !== at, (h !== v || d !== v.version || f !== n1.toneMapping) && (u.material.needsUpdate = !0, h = v, d = v.version, f = n1.toneMapping), u.layers.enableAll(), g.unshift(u, u.geometry, u.material, 0, 0, null)) : v && v.isTexture && (c === void 0 && (c = new zt(new Li(2, 2), new it({
            name: "BackgroundMaterial",
            uniforms: Lu(fo.background.uniforms),
            vertexShader: fo.background.vertexShader,
            fragmentShader: fo.background.fragmentShader,
            side: Hn,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
            get: function() {
                return this.uniforms.t2D.value;
            }
        }), i.update(c)), c.material.uniforms.t2D.value = v, c.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, c.material.toneMapped = v.encoding !== at, v.matrixAutoUpdate === !0 && v.updateMatrix(), c.material.uniforms.uvTransform.value.copy(v.matrix), (h !== v || d !== v.version || f !== n1.toneMapping) && (c.material.needsUpdate = !0, h = v, d = v.version, f = n1.toneMapping), c.layers.enableAll(), g.unshift(c, c.geometry, c.material, 0, 0, null));
    }
    function m(g, y) {
        g.getRGB(Wg, uP(n1)), r.buffers.color.setClear(Wg.r, Wg.g, Wg.b, y, o);
    }
    return {
        getClearColor: function() {
            return a;
        },
        setClearColor: function(g, y = 1) {
            a.set(g), l = y, m(a, l);
        },
        getClearAlpha: function() {
            return l;
        },
        setClearAlpha: function(g) {
            l = g, m(a, l);
        },
        render: p
    };
}
function Iz(n1, t, e, r) {
    let i = n1.getParameter(34921), s = r.isWebGL2 ? null : t.get("OES_vertex_array_object"), o = r.isWebGL2 || s !== null, a = {}, l = g(null), c = l, u = !1;
    function h(D, L, j, V, H) {
        let W = !1;
        if (o) {
            let q = m(V, j, L);
            c !== q && (c = q, f(c.object)), W = y(D, V, j, H), W && x(D, V, j, H);
        } else {
            let q = L.wireframe === !0;
            (c.geometry !== V.id || c.program !== j.id || c.wireframe !== q) && (c.geometry = V.id, c.program = j.id, c.wireframe = q, W = !0);
        }
        H !== null && e.update(H, 34963), (W || u) && (u = !1, b(D, L, j, V), H !== null && n1.bindBuffer(34963, e.get(H).buffer));
    }
    function d() {
        return r.isWebGL2 ? n1.createVertexArray() : s.createVertexArrayOES();
    }
    function f(D) {
        return r.isWebGL2 ? n1.bindVertexArray(D) : s.bindVertexArrayOES(D);
    }
    function p(D) {
        return r.isWebGL2 ? n1.deleteVertexArray(D) : s.deleteVertexArrayOES(D);
    }
    function m(D, L, j) {
        let V = j.wireframe === !0, H = a[D.id];
        H === void 0 && (H = {}, a[D.id] = H);
        let W = H[L.id];
        W === void 0 && (W = {}, H[L.id] = W);
        let q = W[V];
        return q === void 0 && (q = g(d()), W[V] = q), q;
    }
    function g(D) {
        let L = [], j = [], V = [];
        for(let H = 0; H < i; H++)L[H] = 0, j[H] = 0, V[H] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: L,
            enabledAttributes: j,
            attributeDivisors: V,
            object: D,
            attributes: {},
            index: null
        };
    }
    function y(D, L, j, V) {
        let H = c.attributes, W = L.attributes, q = 0, Q = j.getAttributes();
        for(let G in Q)if (Q[G].location >= 0) {
            let te = H[G], $ = W[G];
            if ($ === void 0 && (G === "instanceMatrix" && D.instanceMatrix && ($ = D.instanceMatrix), G === "instanceColor" && D.instanceColor && ($ = D.instanceColor)), te === void 0 || te.attribute !== $ || $ && te.data !== $.data) return !0;
            q++;
        }
        return c.attributesNum !== q || c.index !== V;
    }
    function x(D, L, j, V) {
        let H = {}, W = L.attributes, q = 0, Q = j.getAttributes();
        for(let G in Q)if (Q[G].location >= 0) {
            let te = W[G];
            te === void 0 && (G === "instanceMatrix" && D.instanceMatrix && (te = D.instanceMatrix), G === "instanceColor" && D.instanceColor && (te = D.instanceColor));
            let $ = {};
            $.attribute = te, te && te.data && ($.data = te.data), H[G] = $, q++;
        }
        c.attributes = H, c.attributesNum = q, c.index = V;
    }
    function v() {
        let D = c.newAttributes;
        for(let L = 0, j = D.length; L < j; L++)D[L] = 0;
    }
    function S(D) {
        w(D, 0);
    }
    function w(D, L) {
        let j = c.newAttributes, V = c.enabledAttributes, H = c.attributeDivisors;
        j[D] = 1, V[D] === 0 && (n1.enableVertexAttribArray(D), V[D] = 1), H[D] !== L && ((r.isWebGL2 ? n1 : t.get("ANGLE_instanced_arrays"))[r.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](D, L), H[D] = L);
    }
    function A() {
        let D = c.newAttributes, L = c.enabledAttributes;
        for(let j = 0, V = L.length; j < V; j++)L[j] !== D[j] && (n1.disableVertexAttribArray(j), L[j] = 0);
    }
    function T(D, L, j, V, H, W) {
        r.isWebGL2 === !0 && (j === 5124 || j === 5125) ? n1.vertexAttribIPointer(D, L, j, H, W) : n1.vertexAttribPointer(D, L, j, V, H, W);
    }
    function b(D, L, j, V) {
        if (r.isWebGL2 === !1 && (D.isInstancedMesh || V.isInstancedBufferGeometry) && t.get("ANGLE_instanced_arrays") === null) return;
        v();
        let H = V.attributes, W = j.getAttributes(), q = L.defaultAttributeValues;
        for(let Q in W){
            let G = W[Q];
            if (G.location >= 0) {
                let Z = H[Q];
                if (Z === void 0 && (Q === "instanceMatrix" && D.instanceMatrix && (Z = D.instanceMatrix), Q === "instanceColor" && D.instanceColor && (Z = D.instanceColor)), Z !== void 0) {
                    let te = Z.normalized, $ = Z.itemSize, Y = e.get(Z);
                    if (Y === void 0) continue;
                    let oe = Y.buffer, ie = Y.type, re = Y.bytesPerElement;
                    if (Z.isInterleavedBufferAttribute) {
                        let J = Z.data, Ee = J.stride, xe = Z.offset;
                        if (J.isInstancedInterleavedBuffer) {
                            for(let de = 0; de < G.locationSize; de++)w(G.location + de, J.meshPerAttribute);
                            D.isInstancedMesh !== !0 && V._maxInstanceCount === void 0 && (V._maxInstanceCount = J.meshPerAttribute * J.count);
                        } else for(let de = 0; de < G.locationSize; de++)S(G.location + de);
                        n1.bindBuffer(34962, oe);
                        for(let de = 0; de < G.locationSize; de++)T(G.location + de, $ / G.locationSize, ie, te, Ee * re, (xe + $ / G.locationSize * de) * re);
                    } else {
                        if (Z.isInstancedBufferAttribute) {
                            for(let J = 0; J < G.locationSize; J++)w(G.location + J, Z.meshPerAttribute);
                            D.isInstancedMesh !== !0 && V._maxInstanceCount === void 0 && (V._maxInstanceCount = Z.meshPerAttribute * Z.count);
                        } else for(let J = 0; J < G.locationSize; J++)S(G.location + J);
                        n1.bindBuffer(34962, oe);
                        for(let J = 0; J < G.locationSize; J++)T(G.location + J, $ / G.locationSize, ie, te, $ * re, $ / G.locationSize * J * re);
                    }
                } else if (q !== void 0) {
                    let te = q[Q];
                    if (te !== void 0) switch(te.length){
                        case 2:
                            n1.vertexAttrib2fv(G.location, te);
                            break;
                        case 3:
                            n1.vertexAttrib3fv(G.location, te);
                            break;
                        case 4:
                            n1.vertexAttrib4fv(G.location, te);
                            break;
                        default:
                            n1.vertexAttrib1fv(G.location, te);
                    }
                }
            }
        }
        A();
    }
    function M() {
        I();
        for(let D in a){
            let L = a[D];
            for(let j in L){
                let V = L[j];
                for(let H in V)p(V[H].object), delete V[H];
                delete L[j];
            }
            delete a[D];
        }
    }
    function C(D) {
        if (a[D.id] === void 0) return;
        let L = a[D.id];
        for(let j in L){
            let V = L[j];
            for(let H in V)p(V[H].object), delete V[H];
            delete L[j];
        }
        delete a[D.id];
    }
    function P(D) {
        for(let L in a){
            let j = a[L];
            if (j[D.id] === void 0) continue;
            let V = j[D.id];
            for(let H in V)p(V[H].object), delete V[H];
            delete j[D.id];
        }
    }
    function I() {
        _(), u = !0, c !== l && (c = l, f(c.object));
    }
    function _() {
        l.geometry = null, l.program = null, l.wireframe = !1;
    }
    return {
        setup: h,
        reset: I,
        resetDefaultState: _,
        dispose: M,
        releaseStatesOfGeometry: C,
        releaseStatesOfProgram: P,
        initAttributes: v,
        enableAttribute: S,
        disableUnusedAttributes: A
    };
}
function Dz(n1, t, e, r) {
    let i = r.isWebGL2, s;
    function o(c) {
        s = c;
    }
    function a(c, u) {
        n1.drawArrays(s, c, u), e.update(u, s, 1);
    }
    function l(c, u, h) {
        if (h === 0) return;
        let d, f;
        if (i) d = n1, f = "drawArraysInstanced";
        else if (d = t.get("ANGLE_instanced_arrays"), f = "drawArraysInstancedANGLE", d === null) {
            console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        d[f](s, c, u, h), e.update(u, s, h);
    }
    this.setMode = o, this.render = a, this.renderInstances = l;
}
function Oz(n1, t, e) {
    let r;
    function i() {
        if (r !== void 0) return r;
        if (t.has("EXT_texture_filter_anisotropic") === !0) {
            let T = t.get("EXT_texture_filter_anisotropic");
            r = n1.getParameter(T.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else r = 0;
        return r;
    }
    function s(T) {
        if (T === "highp") {
            if (n1.getShaderPrecisionFormat(35633, 36338).precision > 0 && n1.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            T = "mediump";
        }
        return T === "mediump" && n1.getShaderPrecisionFormat(35633, 36337).precision > 0 && n1.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
    }
    let o = typeof WebGL2RenderingContext < "u" && n1 instanceof WebGL2RenderingContext, a = e.precision !== void 0 ? e.precision : "highp", l = s(a);
    l !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", l, "instead."), a = l);
    let c = o || t.has("WEBGL_draw_buffers"), u = e.logarithmicDepthBuffer === !0, h = n1.getParameter(34930), d = n1.getParameter(35660), f = n1.getParameter(3379), p = n1.getParameter(34076), m = n1.getParameter(34921), g = n1.getParameter(36347), y = n1.getParameter(36348), x = n1.getParameter(36349), v = d > 0, S = o || t.has("OES_texture_float"), w = v && S, A = o ? n1.getParameter(36183) : 0;
    return {
        isWebGL2: o,
        drawBuffers: c,
        getMaxAnisotropy: i,
        getMaxPrecision: s,
        precision: a,
        logarithmicDepthBuffer: u,
        maxTextures: h,
        maxVertexTextures: d,
        maxTextureSize: f,
        maxCubemapSize: p,
        maxAttributes: m,
        maxVertexUniforms: g,
        maxVaryings: y,
        maxFragmentUniforms: x,
        vertexTextures: v,
        floatFragmentTextures: S,
        floatVertexTextures: w,
        maxSamples: A
    };
}
function Rz(n1) {
    let t = this, e = null, r = 0, i = !1, s = !1, o = new kr, a = new fr, l = {
        value: null,
        needsUpdate: !1
    };
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, d) {
        let f = h.length !== 0 || d || r !== 0 || i;
        return i = d, r = h.length, f;
    }, this.beginShadows = function() {
        s = !0, u(null);
    }, this.endShadows = function() {
        s = !1;
    }, this.setGlobalState = function(h, d) {
        e = u(h, d, 0);
    }, this.setState = function(h, d, f) {
        let p = h.clippingPlanes, m = h.clipIntersection, g = h.clipShadows, y = n1.get(h);
        if (!i || p === null || p.length === 0 || s && !g) s ? u(null) : c();
        else {
            let x = s ? 0 : r, v = x * 4, S = y.clippingState || null;
            l.value = S, S = u(p, d, v, f);
            for(let w = 0; w !== v; ++w)S[w] = e[w];
            y.clippingState = S, this.numIntersection = m ? this.numPlanes : 0, this.numPlanes += x;
        }
    };
    function c() {
        l.value !== e && (l.value = e, l.needsUpdate = r > 0), t.numPlanes = r, t.numIntersection = 0;
    }
    function u(h, d, f, p) {
        let m = h !== null ? h.length : 0, g = null;
        if (m !== 0) {
            if (g = l.value, p !== !0 || g === null) {
                let y = f + m * 4, x = d.matrixWorldInverse;
                a.getNormalMatrix(x), (g === null || g.length < y) && (g = new Float32Array(y));
                for(let v = 0, S = f; v !== m; ++v, S += 4)o.copy(h[v]).applyMatrix4(x, a), o.normal.toArray(g, S), g[S + 3] = o.constant;
            }
            l.value = g, l.needsUpdate = !0;
        }
        return t.numPlanes = m, t.numIntersection = 0, g;
    }
}
function Lz(n1) {
    let t = new WeakMap;
    function e(o, a) {
        return a === $S ? o.mapping = $a : a === ew && (o.mapping = el), o;
    }
    function r(o) {
        if (o && o.isTexture && o.isRenderTargetTexture === !1) {
            let a = o.mapping;
            if (a === $S || a === ew) {
                if (t.has(o)) {
                    let l = t.get(o).texture;
                    return e(l, o.mapping);
                } else {
                    let l = o.image;
                    if (l && l.height > 0) {
                        let c = new ow(l.height / 2);
                        return c.fromEquirectangularTexture(n1, o), t.set(o, c), o.addEventListener("dispose", i), e(c.texture, o.mapping);
                    } else return null;
                }
            }
        }
        return o;
    }
    function i(o) {
        let a = o.target;
        a.removeEventListener("dispose", i);
        let l = t.get(a);
        l !== void 0 && (t.delete(a), l.dispose());
    }
    function s() {
        t = new WeakMap;
    }
    return {
        get: r,
        dispose: s
    };
}
var rl = class extends qn {
    constructor(t = -1, e = 1, r = 1, i = -1, s = .1, o = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = r, this.bottom = i, this.near = s, this.far = o, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = t.view === null ? null : Object.assign({}, t.view), this;
    }
    setViewOffset(t, e, r, i, s, o) {
        this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = r, this.view.offsetY = i, this.view.width = s, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), r = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2, s = r - t, o = r + t, a = i + e, l = i - e;
        if (this.view !== null && this.view.enabled) {
            let c = (this.right - this.left) / this.view.fullWidth / this.zoom, u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            s += c * this.view.offsetX, o = s + c * this.view.width, a -= u * this.view.offsetY, l = a - u * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(s, o, a, l, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, this.view !== null && (e.object.view = Object.assign({}, this.view)), e;
    }
}, Du = 4, hC = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], pc = 20, jS = new rl, dC = new We, HS = null, fc = (1 + Math.sqrt(5)) / 2, Cu = 1 / fc, fC = [
    new E(1, 1, 1),
    new E(-1, 1, 1),
    new E(1, 1, -1),
    new E(-1, 1, -1),
    new E(0, fc, Cu),
    new E(0, fc, -Cu),
    new E(Cu, 0, fc),
    new E(-Cu, 0, fc),
    new E(fc, Cu, 0),
    new E(-fc, Cu, 0)
], fy = class {
    constructor(t){
        this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }
    fromScene(t, e = 0, r = .1, i = 100) {
        HS = this._renderer.getRenderTarget(), this._setSize(256);
        let s = this._allocateTargets();
        return s.depthBuffer = !0, this._sceneToCubeUV(t, r, i, s), e > 0 && this._blur(s, 0, 0, e), this._applyPMREM(s), this._cleanup(s), s;
    }
    fromEquirectangular(t, e = null) {
        return this._fromTexture(t, e);
    }
    fromCubemap(t, e = null) {
        return this._fromTexture(t, e);
    }
    compileCubemapShader() {
        this._cubemapMaterial === null && (this._cubemapMaterial = gC(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        this._equirectMaterial === null && (this._equirectMaterial = mC(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
    }
    _setSize(t) {
        this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
        for(let t = 0; t < this._lodPlanes.length; t++)this._lodPlanes[t].dispose();
    }
    _cleanup(t) {
        this._renderer.setRenderTarget(HS), t.scissorTest = !1, qg(t, 0, 0, t.width, t.height);
    }
    _fromTexture(t, e) {
        t.mapping === $a || t.mapping === el ? this._setSize(t.image.length === 0 ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), HS = this._renderer.getRenderTarget();
        let r = e || this._allocateTargets();
        return this._textureToCubeUV(t, r), this._applyPMREM(r), this._cleanup(r), r;
    }
    _allocateTargets() {
        let t = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, r = {
            magFilter: rt,
            minFilter: rt,
            generateMipmaps: !1,
            type: Wn,
            format: qr,
            encoding: mn,
            depthBuffer: !1
        }, i = pC(t, e, r);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== t || this._pingPongRenderTarget.height !== e) {
            this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = pC(t, e, r);
            let { _lodMax: s } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = Bz(s)), this._blurMaterial = Nz(s, t, e);
        }
        return i;
    }
    _compileMaterial(t) {
        let e = new zt(this._lodPlanes[0], t);
        this._renderer.compile(e, jS);
    }
    _sceneToCubeUV(t, e, r, i) {
        let a = new $r(90, 1, e, r), l = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], c = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], u = this._renderer, h = u.autoClear, d = u.toneMapping;
        u.getClearColor(dC), u.toneMapping = Os, u.autoClear = !1;
        let f = new on({
            name: "PMREM.Background",
            side: pi,
            depthWrite: !1,
            depthTest: !1
        }), p = new zt(new mi, f), m = !1, g = t.background;
        g ? g.isColor && (f.color.copy(g), t.background = null, m = !0) : (f.color.copy(dC), m = !0);
        for(let y = 0; y < 6; y++){
            let x = y % 3;
            x === 0 ? (a.up.set(0, l[y], 0), a.lookAt(c[y], 0, 0)) : x === 1 ? (a.up.set(0, 0, l[y]), a.lookAt(0, c[y], 0)) : (a.up.set(0, l[y], 0), a.lookAt(0, 0, c[y]));
            let v = this._cubeSize;
            qg(i, x * v, y > 2 ? v : 0, v, v), u.setRenderTarget(i), m && u.render(p, a), u.render(t, a);
        }
        p.geometry.dispose(), p.material.dispose(), u.toneMapping = d, u.autoClear = h, t.background = g;
    }
    _textureToCubeUV(t, e) {
        let r = this._renderer, i = t.mapping === $a || t.mapping === el;
        i ? (this._cubemapMaterial === null && (this._cubemapMaterial = gC()), this._cubemapMaterial.uniforms.flipEnvMap.value = t.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = mC());
        let s = i ? this._cubemapMaterial : this._equirectMaterial, o = new zt(this._lodPlanes[0], s), a = s.uniforms;
        a.envMap.value = t;
        let l = this._cubeSize;
        qg(e, 0, 0, 3 * l, 2 * l), r.setRenderTarget(e), r.render(o, jS);
    }
    _applyPMREM(t) {
        let e = this._renderer, r = e.autoClear;
        e.autoClear = !1;
        for(let i = 1; i < this._lodPlanes.length; i++){
            let s = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]), o = fC[(i - 1) % fC.length];
            this._blur(t, i - 1, i, s, o);
        }
        e.autoClear = r;
    }
    _blur(t, e, r, i, s) {
        let o = this._pingPongRenderTarget;
        this._halfBlur(t, o, e, r, i, "latitudinal", s), this._halfBlur(o, t, r, r, i, "longitudinal", s);
    }
    _halfBlur(t, e, r, i, s, o, a) {
        let l = this._renderer, c = this._blurMaterial;
        o !== "latitudinal" && o !== "longitudinal" && console.error("blur direction must be either latitudinal or longitudinal!");
        let u = 3, h = new zt(this._lodPlanes[i], c), d = c.uniforms, f = this._sizeLods[r] - 1, p = isFinite(s) ? Math.PI / (2 * f) : 2 * Math.PI / (2 * pc - 1), m = s / p, g = isFinite(s) ? 1 + Math.floor(u * m) : pc;
        g > pc && console.warn(`sigmaRadians, ${s}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${pc}`);
        let y = [], x = 0;
        for(let T = 0; T < pc; ++T){
            let b = T / m, M = Math.exp(-b * b / 2);
            y.push(M), T === 0 ? x += M : T < g && (x += 2 * M);
        }
        for(let T = 0; T < y.length; T++)y[T] = y[T] / x;
        d.envMap.value = t.texture, d.samples.value = g, d.weights.value = y, d.latitudinal.value = o === "latitudinal", a && (d.poleAxis.value = a);
        let { _lodMax: v } = this;
        d.dTheta.value = p, d.mipInt.value = v - r;
        let S = this._sizeLods[i], w = 3 * S * (i > v - Du ? i - v + Du : 0), A = 4 * (this._cubeSize - S);
        qg(e, w, A, 3 * S, 2 * S), l.setRenderTarget(e), l.render(h, jS);
    }
};
function Bz(n1) {
    let t = [], e = [], r = [], i = n1, s = n1 - Du + 1 + hC.length;
    for(let o = 0; o < s; o++){
        let a = Math.pow(2, i);
        e.push(a);
        let l = 1 / a;
        o > n1 - Du ? l = hC[o - n1 + Du - 1] : o === 0 && (l = 0), r.push(l);
        let c = 1 / (a - 2), u = -c, h = 1 + c, d = [
            u,
            u,
            h,
            u,
            h,
            h,
            u,
            u,
            h,
            h,
            u,
            h
        ], f = 6, p = 6, m = 3, g = 2, y = 1, x = new Float32Array(m * p * f), v = new Float32Array(g * p * f), S = new Float32Array(y * p * f);
        for(let A = 0; A < f; A++){
            let T = A % 3 * 2 / 3 - 1, b = A > 2 ? 0 : -1, M = [
                T,
                b,
                0,
                T + 2 / 3,
                b,
                0,
                T + 2 / 3,
                b + 1,
                0,
                T,
                b,
                0,
                T + 2 / 3,
                b + 1,
                0,
                T,
                b + 1,
                0
            ];
            x.set(M, m * p * A), v.set(d, g * p * A);
            let C = [
                A,
                A,
                A,
                A,
                A,
                A
            ];
            S.set(C, y * p * A);
        }
        let w = new _e;
        w.setAttribute("position", new Xe(x, m)), w.setAttribute("uv", new Xe(v, g)), w.setAttribute("faceIndex", new Xe(S, y)), t.push(w), i > Du && i--;
    }
    return {
        lodPlanes: t,
        sizeLods: e,
        sigmas: r
    };
}
function pC(n1, t, e) {
    let r = new dt(n1, t, e);
    return r.texture.mapping = $u, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function qg(n1, t, e, r, i) {
    n1.viewport.set(t, e, r, i), n1.scissor.set(t, e, r, i);
}
function Nz(n1, t, e) {
    let r = new Float32Array(pc), i = new E(0, 1, 0);
    return new it({
        name: "SphericalGaussianBlur",
        defines: {
            n: pc,
            CUBEUV_TEXEL_WIDTH: 1 / t,
            CUBEUV_TEXEL_HEIGHT: 1 / e,
            CUBEUV_MAX_MIP: `${n1}.0`
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: r
            },
            latitudinal: {
                value: !1
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: i
            }
        },
        vertexShader: Uw(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $t,
        depthTest: !1,
        depthWrite: !1
    });
}
function mC() {
    return new it({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: Uw(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $t,
        depthTest: !1,
        depthWrite: !1
    });
}
function gC() {
    return new it({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: Uw(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $t,
        depthTest: !1,
        depthWrite: !1
    });
}
function Uw() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function Fz(n1) {
    let t = new WeakMap, e = null;
    function r(a) {
        if (a && a.isTexture) {
            let l = a.mapping, c = l === $S || l === ew, u = l === $a || l === el;
            if (c || u) {
                if (a.isRenderTargetTexture && a.needsPMREMUpdate === !0) {
                    a.needsPMREMUpdate = !1;
                    let h = t.get(a);
                    return e === null && (e = new fy(n1)), h = c ? e.fromEquirectangular(a, h) : e.fromCubemap(a, h), t.set(a, h), h.texture;
                } else {
                    if (t.has(a)) return t.get(a).texture;
                    {
                        let h = a.image;
                        if (c && h && h.height > 0 || u && h && i(h)) {
                            e === null && (e = new fy(n1));
                            let d = c ? e.fromEquirectangular(a) : e.fromCubemap(a);
                            return t.set(a, d), a.addEventListener("dispose", s), d.texture;
                        } else return null;
                    }
                }
            }
        }
        return a;
    }
    function i(a) {
        let l = 0, c = 6;
        for(let u = 0; u < c; u++)a[u] !== void 0 && l++;
        return l === c;
    }
    function s(a) {
        let l = a.target;
        l.removeEventListener("dispose", s);
        let c = t.get(l);
        c !== void 0 && (t.delete(l), c.dispose());
    }
    function o() {
        t = new WeakMap, e !== null && (e.dispose(), e = null);
    }
    return {
        get: r,
        dispose: o
    };
}
function Vz(n1) {
    let t = {};
    function e(r) {
        if (t[r] !== void 0) return t[r];
        let i;
        switch(r){
            case "WEBGL_depth_texture":
                i = n1.getExtension("WEBGL_depth_texture") || n1.getExtension("MOZ_WEBGL_depth_texture") || n1.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                i = n1.getExtension("EXT_texture_filter_anisotropic") || n1.getExtension("MOZ_EXT_texture_filter_anisotropic") || n1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                i = n1.getExtension("WEBGL_compressed_texture_s3tc") || n1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || n1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                i = n1.getExtension("WEBGL_compressed_texture_pvrtc") || n1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                i = n1.getExtension(r);
        }
        return t[r] = i, i;
    }
    return {
        has: function(r) {
            return e(r) !== null;
        },
        init: function(r) {
            r.isWebGL2 ? e("EXT_color_buffer_float") : (e("WEBGL_depth_texture"), e("OES_texture_float"), e("OES_texture_half_float"), e("OES_texture_half_float_linear"), e("OES_standard_derivatives"), e("OES_element_index_uint"), e("OES_vertex_array_object"), e("ANGLE_instanced_arrays")), e("OES_texture_float_linear"), e("EXT_color_buffer_half_float"), e("WEBGL_multisampled_render_to_texture");
        },
        get: function(r) {
            let i = e(r);
            return i === null && console.warn("THREE.WebGLRenderer: " + r + " extension not supported."), i;
        }
    };
}
function kz(n1, t, e, r) {
    let i = {}, s = new WeakMap;
    function o(h) {
        let d = h.target;
        d.index !== null && t.remove(d.index);
        for(let p in d.attributes)t.remove(d.attributes[p]);
        d.removeEventListener("dispose", o), delete i[d.id];
        let f = s.get(d);
        f && (t.remove(f), s.delete(d)), r.releaseStatesOfGeometry(d), d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount, e.memory.geometries--;
    }
    function a(h, d) {
        return i[d.id] === !0 || (d.addEventListener("dispose", o), i[d.id] = !0, e.memory.geometries++), d;
    }
    function l(h) {
        let d = h.attributes;
        for(let p in d)t.update(d[p], 34962);
        let f = h.morphAttributes;
        for(let p in f){
            let m = f[p];
            for(let g = 0, y = m.length; g < y; g++)t.update(m[g], 34962);
        }
    }
    function c(h) {
        let d = [], f = h.index, p = h.attributes.position, m = 0;
        if (f !== null) {
            let x = f.array;
            m = f.version;
            for(let v = 0, S = x.length; v < S; v += 3){
                let w = x[v + 0], A = x[v + 1], T = x[v + 2];
                d.push(w, A, A, T, T, w);
            }
        } else {
            let x = p.array;
            m = p.version;
            for(let v = 0, S = x.length / 3 - 1; v < S; v += 3){
                let w = v + 0, A = v + 1, T = v + 2;
                d.push(w, A, A, T, T, w);
            }
        }
        let g = new (lP(d) ? po : dy)(d, 1);
        g.version = m;
        let y = s.get(h);
        y && t.remove(y), s.set(h, g);
    }
    function u(h) {
        let d = s.get(h);
        if (d) {
            let f = h.index;
            f !== null && d.version < f.version && c(h);
        } else c(h);
        return s.get(h);
    }
    return {
        get: a,
        update: l,
        getWireframeAttribute: u
    };
}
function Uz(n1, t, e, r) {
    let i = r.isWebGL2, s;
    function o(d) {
        s = d;
    }
    let a, l;
    function c(d) {
        a = d.type, l = d.bytesPerElement;
    }
    function u(d, f) {
        n1.drawElements(s, f, a, d * l), e.update(f, s, 1);
    }
    function h(d, f, p) {
        if (p === 0) return;
        let m, g;
        if (i) m = n1, g = "drawElementsInstanced";
        else if (m = t.get("ANGLE_instanced_arrays"), g = "drawElementsInstancedANGLE", m === null) {
            console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        m[g](s, f, a, d * l, p), e.update(f, s, p);
    }
    this.setMode = o, this.setIndex = c, this.render = u, this.renderInstances = h;
}
function zz(n1) {
    let t = {
        geometries: 0,
        textures: 0
    }, e = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function r(s, o, a) {
        switch(e.calls++, o){
            case 4:
                e.triangles += a * (s / 3);
                break;
            case 1:
                e.lines += a * (s / 2);
                break;
            case 3:
                e.lines += a * (s - 1);
                break;
            case 2:
                e.lines += a * s;
                break;
            case 0:
                e.points += a * s;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", o);
                break;
        }
    }
    function i() {
        e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
    }
    return {
        memory: t,
        render: e,
        programs: null,
        autoReset: !0,
        reset: i,
        update: r
    };
}
function Gz(n1, t) {
    return n1[0] - t[0];
}
function jz(n1, t) {
    return Math.abs(t[1]) - Math.abs(n1[1]);
}
function Hz(n1, t, e) {
    let r = {}, i = new Float32Array(8), s = new WeakMap, o = new Ze, a = [];
    for(let c = 0; c < 8; c++)a[c] = [
        c,
        0
    ];
    function l(c, u, h, d) {
        let f = c.morphTargetInfluences;
        if (t.isWebGL2 === !0) {
            let p = u.morphAttributes.position || u.morphAttributes.normal || u.morphAttributes.color, m = p !== void 0 ? p.length : 0, g = s.get(u);
            if (g === void 0 || g.count !== m) {
                let L = function() {
                    _.dispose(), s.delete(u), u.removeEventListener("dispose", L);
                };
                g !== void 0 && g.texture.dispose();
                let v = u.morphAttributes.position !== void 0, S = u.morphAttributes.normal !== void 0, w = u.morphAttributes.color !== void 0, A = u.morphAttributes.position || [], T = u.morphAttributes.normal || [], b = u.morphAttributes.color || [], M = 0;
                v === !0 && (M = 1), S === !0 && (M = 2), w === !0 && (M = 3);
                let C = u.attributes.position.count * M, P = 1;
                C > t.maxTextureSize && (P = Math.ceil(C / t.maxTextureSize), C = t.maxTextureSize);
                let I = new Float32Array(C * P * 4 * m), _ = new cy(I, C, P, m);
                _.type = br, _.needsUpdate = !0;
                let D = M * 4;
                for(let j = 0; j < m; j++){
                    let V = A[j], H = T[j], W = b[j], q = C * P * 4 * j;
                    for(let Q = 0; Q < V.count; Q++){
                        let G = Q * D;
                        v === !0 && (o.fromBufferAttribute(V, Q), I[q + G + 0] = o.x, I[q + G + 1] = o.y, I[q + G + 2] = o.z, I[q + G + 3] = 0), S === !0 && (o.fromBufferAttribute(H, Q), I[q + G + 4] = o.x, I[q + G + 5] = o.y, I[q + G + 6] = o.z, I[q + G + 7] = 0), w === !0 && (o.fromBufferAttribute(W, Q), I[q + G + 8] = o.x, I[q + G + 9] = o.y, I[q + G + 10] = o.z, I[q + G + 11] = W.itemSize === 4 ? o.w : 1);
                    }
                }
                g = {
                    count: m,
                    texture: _,
                    size: new k(C, P)
                }, s.set(u, g), u.addEventListener("dispose", L);
            }
            let y = 0;
            for(let v = 0; v < f.length; v++)y += f[v];
            let x = u.morphTargetsRelative ? 1 : 1 - y;
            d.getUniforms().setValue(n1, "morphTargetBaseInfluence", x), d.getUniforms().setValue(n1, "morphTargetInfluences", f), d.getUniforms().setValue(n1, "morphTargetsTexture", g.texture, e), d.getUniforms().setValue(n1, "morphTargetsTextureSize", g.size);
        } else {
            let p = f === void 0 ? 0 : f.length, m = r[u.id];
            if (m === void 0 || m.length !== p) {
                m = [];
                for(let S = 0; S < p; S++)m[S] = [
                    S,
                    0
                ];
                r[u.id] = m;
            }
            for(let S = 0; S < p; S++){
                let w = m[S];
                w[0] = S, w[1] = f[S];
            }
            m.sort(jz);
            for(let S = 0; S < 8; S++)S < p && m[S][1] ? (a[S][0] = m[S][0], a[S][1] = m[S][1]) : (a[S][0] = Number.MAX_SAFE_INTEGER, a[S][1] = 0);
            a.sort(Gz);
            let g = u.morphAttributes.position, y = u.morphAttributes.normal, x = 0;
            for(let S = 0; S < 8; S++){
                let w = a[S], A = w[0], T = w[1];
                A !== Number.MAX_SAFE_INTEGER && T ? (g && u.getAttribute("morphTarget" + S) !== g[A] && u.setAttribute("morphTarget" + S, g[A]), y && u.getAttribute("morphNormal" + S) !== y[A] && u.setAttribute("morphNormal" + S, y[A]), i[S] = T, x += T) : (g && u.hasAttribute("morphTarget" + S) === !0 && u.deleteAttribute("morphTarget" + S), y && u.hasAttribute("morphNormal" + S) === !0 && u.deleteAttribute("morphNormal" + S), i[S] = 0);
            }
            let v = u.morphTargetsRelative ? 1 : 1 - x;
            d.getUniforms().setValue(n1, "morphTargetBaseInfluence", v), d.getUniforms().setValue(n1, "morphTargetInfluences", i);
        }
    }
    return {
        update: l
    };
}
function Wz(n1, t, e, r) {
    let i = new WeakMap;
    function s(l) {
        let c = r.render.frame, u = l.geometry, h = t.get(l, u);
        return i.get(h) !== c && (t.update(h), i.set(h, c)), l.isInstancedMesh && (l.hasEventListener("dispose", a) === !1 && l.addEventListener("dispose", a), e.update(l.instanceMatrix, 34962), l.instanceColor !== null && e.update(l.instanceColor, 34962)), h;
    }
    function o() {
        i = new WeakMap;
    }
    function a(l) {
        let c = l.target;
        c.removeEventListener("dispose", a), e.remove(c.instanceMatrix), c.instanceColor !== null && e.remove(c.instanceColor);
    }
    return {
        update: s,
        dispose: o
    };
}
var dP = new er, fP = new cy, pP = new uy, mP = new Bu, yC = [], vC = [], xC = new Float32Array(16), bC = new Float32Array(9), SC = new Float32Array(4);
function th(n1, t, e) {
    let r = n1[0];
    if (r <= 0 || r > 0) return n1;
    let i = t * e, s = yC[i];
    if (s === void 0 && (s = new Float32Array(i), yC[i] = s), t !== 0) {
        r.toArray(s, 0);
        for(let o = 1, a = 0; o !== t; ++o)a += e, n1[o].toArray(s, a);
    }
    return s;
}
function Ai(n1, t) {
    if (n1.length !== t.length) return !1;
    for(let e = 0, r = n1.length; e < r; e++)if (n1[e] !== t[e]) return !1;
    return !0;
}
function Ei(n1, t) {
    for(let e = 0, r = t.length; e < r; e++)n1[e] = t[e];
}
function Ry(n1, t) {
    let e = vC[t];
    e === void 0 && (e = new Int32Array(t), vC[t] = e);
    for(let r = 0; r !== t; ++r)e[r] = n1.allocateTextureUnit();
    return e;
}
function qz(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1f(this.addr, t), e[0] = t);
}
function Yz(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2f(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (Ai(e, t)) return;
        n1.uniform2fv(this.addr, t), Ei(e, t);
    }
}
function Xz(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3f(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else if (t.r !== void 0) (e[0] !== t.r || e[1] !== t.g || e[2] !== t.b) && (n1.uniform3f(this.addr, t.r, t.g, t.b), e[0] = t.r, e[1] = t.g, e[2] = t.b);
    else {
        if (Ai(e, t)) return;
        n1.uniform3fv(this.addr, t), Ei(e, t);
    }
}
function Kz(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4f(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (Ai(e, t)) return;
        n1.uniform4fv(this.addr, t), Ei(e, t);
    }
}
function Qz(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (Ai(e, t)) return;
        n1.uniformMatrix2fv(this.addr, !1, t), Ei(e, t);
    } else {
        if (Ai(e, r)) return;
        SC.set(r), n1.uniformMatrix2fv(this.addr, !1, SC), Ei(e, r);
    }
}
function Zz(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (Ai(e, t)) return;
        n1.uniformMatrix3fv(this.addr, !1, t), Ei(e, t);
    } else {
        if (Ai(e, r)) return;
        bC.set(r), n1.uniformMatrix3fv(this.addr, !1, bC), Ei(e, r);
    }
}
function Jz(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (Ai(e, t)) return;
        n1.uniformMatrix4fv(this.addr, !1, t), Ei(e, t);
    } else {
        if (Ai(e, r)) return;
        xC.set(r), n1.uniformMatrix4fv(this.addr, !1, xC), Ei(e, r);
    }
}
function $z(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1i(this.addr, t), e[0] = t);
}
function eG(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2i(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (Ai(e, t)) return;
        n1.uniform2iv(this.addr, t), Ei(e, t);
    }
}
function tG(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3i(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (Ai(e, t)) return;
        n1.uniform3iv(this.addr, t), Ei(e, t);
    }
}
function rG(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4i(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (Ai(e, t)) return;
        n1.uniform4iv(this.addr, t), Ei(e, t);
    }
}
function iG(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1ui(this.addr, t), e[0] = t);
}
function nG(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2ui(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (Ai(e, t)) return;
        n1.uniform2uiv(this.addr, t), Ei(e, t);
    }
}
function sG(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3ui(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (Ai(e, t)) return;
        n1.uniform3uiv(this.addr, t), Ei(e, t);
    }
}
function oG(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (Ai(e, t)) return;
        n1.uniform4uiv(this.addr, t), Ei(e, t);
    }
}
function aG(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture2D(t || dP, i);
}
function lG(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture3D(t || pP, i);
}
function cG(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTextureCube(t || mP, i);
}
function uG(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture2DArray(t || fP, i);
}
function hG(n1) {
    switch(n1){
        case 5126:
            return qz;
        case 35664:
            return Yz;
        case 35665:
            return Xz;
        case 35666:
            return Kz;
        case 35674:
            return Qz;
        case 35675:
            return Zz;
        case 35676:
            return Jz;
        case 5124:
        case 35670:
            return $z;
        case 35667:
        case 35671:
            return eG;
        case 35668:
        case 35672:
            return tG;
        case 35669:
        case 35673:
            return rG;
        case 5125:
            return iG;
        case 36294:
            return nG;
        case 36295:
            return sG;
        case 36296:
            return oG;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return aG;
        case 35679:
        case 36299:
        case 36307:
            return lG;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return cG;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return uG;
    }
}
function dG(n1, t) {
    n1.uniform1fv(this.addr, t);
}
function fG(n1, t) {
    let e = th(t, this.size, 2);
    n1.uniform2fv(this.addr, e);
}
function pG(n1, t) {
    let e = th(t, this.size, 3);
    n1.uniform3fv(this.addr, e);
}
function mG(n1, t) {
    let e = th(t, this.size, 4);
    n1.uniform4fv(this.addr, e);
}
function gG(n1, t) {
    let e = th(t, this.size, 4);
    n1.uniformMatrix2fv(this.addr, !1, e);
}
function yG(n1, t) {
    let e = th(t, this.size, 9);
    n1.uniformMatrix3fv(this.addr, !1, e);
}
function vG(n1, t) {
    let e = th(t, this.size, 16);
    n1.uniformMatrix4fv(this.addr, !1, e);
}
function xG(n1, t) {
    n1.uniform1iv(this.addr, t);
}
function bG(n1, t) {
    n1.uniform2iv(this.addr, t);
}
function SG(n1, t) {
    n1.uniform3iv(this.addr, t);
}
function wG(n1, t) {
    n1.uniform4iv(this.addr, t);
}
function AG(n1, t) {
    n1.uniform1uiv(this.addr, t);
}
function EG(n1, t) {
    n1.uniform2uiv(this.addr, t);
}
function TG(n1, t) {
    n1.uniform3uiv(this.addr, t);
}
function MG(n1, t) {
    n1.uniform4uiv(this.addr, t);
}
function CG(n1, t, e) {
    let r = this.cache, i = t.length, s = Ry(e, i);
    Ai(r, s) || (n1.uniform1iv(this.addr, s), Ei(r, s));
    for(let o = 0; o !== i; ++o)e.setTexture2D(t[o] || dP, s[o]);
}
function PG(n1, t, e) {
    let r = this.cache, i = t.length, s = Ry(e, i);
    Ai(r, s) || (n1.uniform1iv(this.addr, s), Ei(r, s));
    for(let o = 0; o !== i; ++o)e.setTexture3D(t[o] || pP, s[o]);
}
function _G(n1, t, e) {
    let r = this.cache, i = t.length, s = Ry(e, i);
    Ai(r, s) || (n1.uniform1iv(this.addr, s), Ei(r, s));
    for(let o = 0; o !== i; ++o)e.setTextureCube(t[o] || mP, s[o]);
}
function IG(n1, t, e) {
    let r = this.cache, i = t.length, s = Ry(e, i);
    Ai(r, s) || (n1.uniform1iv(this.addr, s), Ei(r, s));
    for(let o = 0; o !== i; ++o)e.setTexture2DArray(t[o] || fP, s[o]);
}
function DG(n1) {
    switch(n1){
        case 5126:
            return dG;
        case 35664:
            return fG;
        case 35665:
            return pG;
        case 35666:
            return mG;
        case 35674:
            return gG;
        case 35675:
            return yG;
        case 35676:
            return vG;
        case 5124:
        case 35670:
            return xG;
        case 35667:
        case 35671:
            return bG;
        case 35668:
        case 35672:
            return SG;
        case 35669:
        case 35673:
            return wG;
        case 5125:
            return AG;
        case 36294:
            return EG;
        case 36295:
            return TG;
        case 36296:
            return MG;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return CG;
        case 35679:
        case 36299:
        case 36307:
            return PG;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return _G;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return IG;
    }
}
var aw = class {
    constructor(t, e, r){
        this.id = t, this.addr = r, this.cache = [], this.setValue = hG(e.type);
    }
}, lw = class {
    constructor(t, e, r){
        this.id = t, this.addr = r, this.cache = [], this.size = e.size, this.setValue = DG(e.type);
    }
}, cw = class {
    constructor(t){
        this.id = t, this.seq = [], this.map = {};
    }
    setValue(t, e, r) {
        let i = this.seq;
        for(let s = 0, o = i.length; s !== o; ++s){
            let a = i[s];
            a.setValue(t, e[a.id], r);
        }
    }
}, WS = /(\w+)(\])?(\[|\.)?/g;
function wC(n1, t) {
    n1.seq.push(t), n1.map[t.id] = t;
}
function OG(n1, t, e) {
    let r = n1.name, i = r.length;
    for(WS.lastIndex = 0;;){
        let s = WS.exec(r), o = WS.lastIndex, a = s[1], l = s[2] === "]", c = s[3];
        if (l && (a = a | 0), c === void 0 || c === "[" && o + 2 === i) {
            wC(e, c === void 0 ? new aw(a, n1, t) : new lw(a, n1, t));
            break;
        } else {
            let h = e.map[a];
            h === void 0 && (h = new cw(a), wC(e, h)), e = h;
        }
    }
}
var Ru = class {
    constructor(t, e){
        this.seq = [], this.map = {};
        let r = t.getProgramParameter(e, 35718);
        for(let i = 0; i < r; ++i){
            let s = t.getActiveUniform(e, i), o = t.getUniformLocation(e, s.name);
            OG(s, o, this);
        }
    }
    setValue(t, e, r, i) {
        let s = this.map[e];
        s !== void 0 && s.setValue(t, r, i);
    }
    setOptional(t, e, r) {
        let i = e[r];
        i !== void 0 && this.setValue(t, r, i);
    }
    static upload(t, e, r, i) {
        for(let s = 0, o = e.length; s !== o; ++s){
            let a = e[s], l = r[a.id];
            l.needsUpdate !== !1 && a.setValue(t, l.value, i);
        }
    }
    static seqWithValue(t, e) {
        let r = [];
        for(let i = 0, s = t.length; i !== s; ++i){
            let o = t[i];
            o.id in e && r.push(o);
        }
        return r;
    }
};
function AC(n1, t, e) {
    let r = n1.createShader(t);
    return n1.shaderSource(r, e), n1.compileShader(r), r;
}
var RG = 0;
function LG(n1, t) {
    let e = n1.split(`
`), r = [], i = Math.max(t - 6, 0), s = Math.min(t + 6, e.length);
    for(let o = i; o < s; o++){
        let a = o + 1;
        r.push(`${a === t ? ">" : " "} ${a}: ${e[o]}`);
    }
    return r.join(`
`);
}
function BG(n1) {
    switch(n1){
        case mn:
            return [
                "Linear",
                "( value )"
            ];
        case at:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            return console.warn("THREE.WebGLProgram: Unsupported encoding:", n1), [
                "Linear",
                "( value )"
            ];
    }
}
function EC(n1, t, e) {
    let r = n1.getShaderParameter(t, 35713), i = n1.getShaderInfoLog(t).trim();
    if (r && i === "") return "";
    let s = /ERROR: 0:(\d+)/.exec(i);
    if (s) {
        let o = parseInt(s[1]);
        return e.toUpperCase() + `

` + i + `

` + LG(n1.getShaderSource(t), o);
    } else return i;
}
function NG(n1, t) {
    let e = BG(t);
    return "vec4 " + n1 + "( vec4 value ) { return LinearTo" + e[0] + e[1] + "; }";
}
function FG(n1, t) {
    let e;
    switch(t){
        case ZF:
            e = "Linear";
            break;
        case JF:
            e = "Reinhard";
            break;
        case $F:
            e = "OptimizedCineon";
            break;
        case eV:
            e = "ACESFilmic";
            break;
        case tV:
            e = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), e = "Linear";
    }
    return "vec3 " + n1 + "( vec3 color ) { return " + e + "ToneMapping( color ); }";
}
function VG(n1) {
    return [
        n1.extensionDerivatives || !!n1.envMapCubeUVHeight || n1.bumpMap || n1.tangentSpaceNormalMap || n1.clearcoatNormalMap || n1.flatShading || n1.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (n1.extensionFragDepth || n1.logarithmicDepthBuffer) && n1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        n1.extensionDrawBuffers && n1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (n1.extensionShaderTextureLOD || n1.envMap || n1.transmission) && n1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ].filter(ip).join(`
`);
}
function kG(n1) {
    let t = [];
    for(let e in n1){
        let r = n1[e];
        r !== !1 && t.push("#define " + e + " " + r);
    }
    return t.join(`
`);
}
function UG(n1, t) {
    let e = {}, r = n1.getProgramParameter(t, 35721);
    for(let i = 0; i < r; i++){
        let s = n1.getActiveAttrib(t, i), o = s.name, a = 1;
        s.type === 35674 && (a = 2), s.type === 35675 && (a = 3), s.type === 35676 && (a = 4), e[o] = {
            type: s.type,
            location: n1.getAttribLocation(t, o),
            locationSize: a
        };
    }
    return e;
}
function ip(n1) {
    return n1 !== "";
}
function TC(n1, t) {
    let e = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return n1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, e).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function MC(n1, t) {
    return n1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var zG = /^[ \t]*#include +<([\w\d./]+)>/gm;
function uw(n1) {
    return n1.replace(zG, GG);
}
function GG(n1, t) {
    let e = xt[t];
    if (e === void 0) throw new Error("Can not resolve #include <" + t + ">");
    return uw(e);
}
var jG = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function CC(n1) {
    return n1.replace(jG, HG);
}
function HG(n1, t, e, r) {
    let i = "";
    for(let s = parseInt(t); s < parseInt(e); s++)i += r.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s);
    return i;
}
function PC(n1) {
    let t = "precision " + n1.precision + ` float;
precision ` + n1.precision + " int;";
    return n1.precision === "highp" ? t += `
#define HIGH_PRECISION` : n1.precision === "mediump" ? t += `
#define MEDIUM_PRECISION` : n1.precision === "lowp" && (t += `
#define LOW_PRECISION`), t;
}
function WG(n1) {
    let t = "SHADOWMAP_TYPE_BASIC";
    return n1.shadowMapType === Oy ? t = "SHADOWMAP_TYPE_PCF" : n1.shadowMapType === _F ? t = "SHADOWMAP_TYPE_PCF_SOFT" : n1.shadowMapType === rp && (t = "SHADOWMAP_TYPE_VSM"), t;
}
function qG(n1) {
    let t = "ENVMAP_TYPE_CUBE";
    if (n1.envMap) switch(n1.envMapMode){
        case $a:
        case el:
            t = "ENVMAP_TYPE_CUBE";
            break;
        case $u:
            t = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return t;
}
function YG(n1) {
    let t = "ENVMAP_MODE_REFLECTION";
    if (n1.envMap) switch(n1.envMapMode){
        case el:
            t = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return t;
}
function XG(n1) {
    let t = "ENVMAP_BLENDING_NONE";
    if (n1.envMap) switch(n1.combine){
        case iP:
            t = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case KF:
            t = "ENVMAP_BLENDING_MIX";
            break;
        case QF:
            t = "ENVMAP_BLENDING_ADD";
            break;
    }
    return t;
}
function KG(n1) {
    let t = n1.envMapCubeUVHeight;
    if (t === null) return null;
    let e = Math.log2(t) - 2, r = 1 / t;
    return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 112)),
        texelHeight: r,
        maxMip: e
    };
}
function QG(n1, t, e, r) {
    let i = n1.getContext(), s = e.defines, o = e.vertexShader, a = e.fragmentShader, l = WG(e), c = qG(e), u = YG(e), h = XG(e), d = KG(e), f = e.isWebGL2 ? "" : VG(e), p = kG(s), m = i.createProgram(), g, y, x = e.glslVersion ? "#version " + e.glslVersion + `
` : "";
    e.isRawShaderMaterial ? (g = [
        p
    ].filter(ip).join(`
`), g.length > 0 && (g += `
`), y = [
        f,
        p
    ].filter(ip).join(`
`), y.length > 0 && (y += `
`)) : (g = [
        PC(e),
        "#define SHADER_NAME " + e.shaderName,
        p,
        e.instancing ? "#define USE_INSTANCING" : "",
        e.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        e.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + u : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.displacementMap && e.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.skinning ? "#define USE_SKINNING" : "",
        e.morphTargets ? "#define USE_MORPHTARGETS" : "",
        e.morphNormals && e.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        e.morphColors && e.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + e.morphTextureStride : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_COUNT " + e.morphTargetsCount : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
        "	attribute vec3 morphTarget0;",
        "	attribute vec3 morphTarget1;",
        "	attribute vec3 morphTarget2;",
        "	attribute vec3 morphTarget3;",
        "	#ifdef USE_MORPHNORMALS",
        "		attribute vec3 morphNormal0;",
        "		attribute vec3 morphNormal1;",
        "		attribute vec3 morphNormal2;",
        "		attribute vec3 morphNormal3;",
        "	#else",
        "		attribute vec3 morphTarget4;",
        "		attribute vec3 morphTarget5;",
        "		attribute vec3 morphTarget6;",
        "		attribute vec3 morphTarget7;",
        "	#endif",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`
    ].filter(ip).join(`
`), y = [
        f,
        PC(e),
        "#define SHADER_NAME " + e.shaderName,
        p,
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.matcap ? "#define USE_MATCAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + c : "",
        e.envMap ? "#define " + u : "",
        e.envMap ? "#define " + h : "",
        d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
        d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
        d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoat ? "#define USE_CLEARCOAT" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescence ? "#define USE_IRIDESCENCE" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.alphaTest ? "#define USE_ALPHATEST" : "",
        e.sheen ? "#define USE_SHEEN" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors || e.instancingColor ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.gradientMap ? "#define USE_GRADIENTMAP" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        e.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        e.toneMapping !== Os ? "#define TONE_MAPPING" : "",
        e.toneMapping !== Os ? xt.tonemapping_pars_fragment : "",
        e.toneMapping !== Os ? FG("toneMapping", e.toneMapping) : "",
        e.dithering ? "#define DITHERING" : "",
        e.opaque ? "#define OPAQUE" : "",
        xt.encodings_pars_fragment,
        NG("linearToOutputTexel", e.outputEncoding),
        e.useDepthPacking ? "#define DEPTH_PACKING " + e.depthPacking : "",
        `
`
    ].filter(ip).join(`
`)), o = uw(o), o = TC(o, e), o = MC(o, e), a = uw(a), a = TC(a, e), a = MC(a, e), o = CC(o), a = CC(a), e.isWebGL2 && e.isRawShaderMaterial !== !0 && (x = `#version 300 es
`, g = [
        "precision mediump sampler2DArray;",
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join(`
`) + `
` + g, y = [
        "#define varying in",
        e.glslVersion === $M ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        e.glslVersion === $M ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join(`
`) + `
` + y);
    let v = x + g + o, S = x + y + a, w = AC(i, 35633, v), A = AC(i, 35632, S);
    if (i.attachShader(m, w), i.attachShader(m, A), e.index0AttributeName !== void 0 ? i.bindAttribLocation(m, 0, e.index0AttributeName) : e.morphTargets === !0 && i.bindAttribLocation(m, 0, "position"), i.linkProgram(m), n1.debug.checkShaderErrors) {
        let M = i.getProgramInfoLog(m).trim(), C = i.getShaderInfoLog(w).trim(), P = i.getShaderInfoLog(A).trim(), I = !0, _ = !0;
        if (i.getProgramParameter(m, 35714) === !1) {
            I = !1;
            let D = EC(i, w, "vertex"), L = EC(i, A, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(m, 35715) + `

Program Info Log: ` + M + `
` + D + `
` + L);
        } else M !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", M) : (C === "" || P === "") && (_ = !1);
        _ && (this.diagnostics = {
            runnable: I,
            programLog: M,
            vertexShader: {
                log: C,
                prefix: g
            },
            fragmentShader: {
                log: P,
                prefix: y
            }
        });
    }
    i.deleteShader(w), i.deleteShader(A);
    let T;
    this.getUniforms = function() {
        return T === void 0 && (T = new Ru(i, m)), T;
    };
    let b;
    return this.getAttributes = function() {
        return b === void 0 && (b = UG(i, m)), b;
    }, this.destroy = function() {
        r.releaseStatesOfProgram(this), i.deleteProgram(m), this.program = void 0;
    }, this.name = e.shaderName, this.id = RG++, this.cacheKey = t, this.usedTimes = 1, this.program = m, this.vertexShader = w, this.fragmentShader = A, this;
}
var ZG = 0, hw = class {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(t) {
        let e = t.vertexShader, r = t.fragmentShader, i = this._getShaderStage(e), s = this._getShaderStage(r), o = this._getShaderCacheForMaterial(t);
        return o.has(i) === !1 && (o.add(i), i.usedTimes++), o.has(s) === !1 && (o.add(s), s.usedTimes++), this;
    }
    remove(t) {
        let e = this.materialCache.get(t);
        for (let r of e)r.usedTimes--, r.usedTimes === 0 && this.shaderCache.delete(r.code);
        return this.materialCache.delete(t), this;
    }
    getVertexShaderID(t) {
        return this._getShaderStage(t.vertexShader).id;
    }
    getFragmentShaderID(t) {
        return this._getShaderStage(t.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(t) {
        let e = this.materialCache, r = e.get(t);
        return r === void 0 && (r = new Set, e.set(t, r)), r;
    }
    _getShaderStage(t) {
        let e = this.shaderCache, r = e.get(t);
        return r === void 0 && (r = new dw(t), e.set(t, r)), r;
    }
}, dw = class {
    constructor(t){
        this.id = ZG++, this.code = t, this.usedTimes = 0;
    }
};
function JG(n1, t, e, r, i, s, o) {
    let a = new dp, l = new hw, c = [], u = i.isWebGL2, h = i.logarithmicDepthBuffer, d = i.vertexTextures, f = i.precision, p = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function m(b, M, C, P, I) {
        let _ = P.fog, D = I.geometry, L = b.isMeshStandardMaterial ? P.environment : null, j = (b.isMeshStandardMaterial ? e : t).get(b.envMap || L), V = !!j && j.mapping === $u ? j.image.height : null, H = p[b.type];
        b.precision !== null && (f = i.getMaxPrecision(b.precision), f !== b.precision && console.warn("THREE.WebGLProgram.getParameters:", b.precision, "not supported, using", f, "instead."));
        let W = D.morphAttributes.position || D.morphAttributes.normal || D.morphAttributes.color, q = W !== void 0 ? W.length : 0, Q = 0;
        D.morphAttributes.position !== void 0 && (Q = 1), D.morphAttributes.normal !== void 0 && (Q = 2), D.morphAttributes.color !== void 0 && (Q = 3);
        let G, Z, te, $;
        if (H) {
            let Ee = fo[H];
            G = Ee.vertexShader, Z = Ee.fragmentShader;
        } else G = b.vertexShader, Z = b.fragmentShader, l.update(b), te = l.getVertexShaderID(b), $ = l.getFragmentShaderID(b);
        let Y = n1.getRenderTarget(), oe = b.alphaTest > 0, ie = b.clearcoat > 0, re = b.iridescence > 0;
        return {
            isWebGL2: u,
            shaderID: H,
            shaderName: b.type,
            vertexShader: G,
            fragmentShader: Z,
            defines: b.defines,
            customVertexShaderID: te,
            customFragmentShaderID: $,
            isRawShaderMaterial: b.isRawShaderMaterial === !0,
            glslVersion: b.glslVersion,
            precision: f,
            instancing: I.isInstancedMesh === !0,
            instancingColor: I.isInstancedMesh === !0 && I.instanceColor !== null,
            supportsVertexTextures: d,
            outputEncoding: Y === null ? n1.outputEncoding : Y.isXRRenderTarget === !0 ? Y.texture.encoding : mn,
            map: !!b.map,
            matcap: !!b.matcap,
            envMap: !!j,
            envMapMode: j && j.mapping,
            envMapCubeUVHeight: V,
            lightMap: !!b.lightMap,
            aoMap: !!b.aoMap,
            emissiveMap: !!b.emissiveMap,
            bumpMap: !!b.bumpMap,
            normalMap: !!b.normalMap,
            objectSpaceNormalMap: b.normalMapType === vV,
            tangentSpaceNormalMap: b.normalMapType === yV,
            decodeVideoTexture: !!b.map && b.map.isVideoTexture === !0 && b.map.encoding === at,
            clearcoat: ie,
            clearcoatMap: ie && !!b.clearcoatMap,
            clearcoatRoughnessMap: ie && !!b.clearcoatRoughnessMap,
            clearcoatNormalMap: ie && !!b.clearcoatNormalMap,
            iridescence: re,
            iridescenceMap: re && !!b.iridescenceMap,
            iridescenceThicknessMap: re && !!b.iridescenceThicknessMap,
            displacementMap: !!b.displacementMap,
            roughnessMap: !!b.roughnessMap,
            metalnessMap: !!b.metalnessMap,
            specularMap: !!b.specularMap,
            specularIntensityMap: !!b.specularIntensityMap,
            specularColorMap: !!b.specularColorMap,
            opaque: b.transparent === !1 && b.blending === Za,
            alphaMap: !!b.alphaMap,
            alphaTest: oe,
            gradientMap: !!b.gradientMap,
            sheen: b.sheen > 0,
            sheenColorMap: !!b.sheenColorMap,
            sheenRoughnessMap: !!b.sheenRoughnessMap,
            transmission: b.transmission > 0,
            transmissionMap: !!b.transmissionMap,
            thicknessMap: !!b.thicknessMap,
            combine: b.combine,
            vertexTangents: !!b.normalMap && !!D.attributes.tangent,
            vertexColors: b.vertexColors,
            vertexAlphas: b.vertexColors === !0 && !!D.attributes.color && D.attributes.color.itemSize === 4,
            vertexUvs: !!b.map || !!b.bumpMap || !!b.normalMap || !!b.specularMap || !!b.alphaMap || !!b.emissiveMap || !!b.roughnessMap || !!b.metalnessMap || !!b.clearcoatMap || !!b.clearcoatRoughnessMap || !!b.clearcoatNormalMap || !!b.iridescenceMap || !!b.iridescenceThicknessMap || !!b.displacementMap || !!b.transmissionMap || !!b.thicknessMap || !!b.specularIntensityMap || !!b.specularColorMap || !!b.sheenColorMap || !!b.sheenRoughnessMap,
            uvsVertexOnly: !(!!b.map || !!b.bumpMap || !!b.normalMap || !!b.specularMap || !!b.alphaMap || !!b.emissiveMap || !!b.roughnessMap || !!b.metalnessMap || !!b.clearcoatNormalMap || !!b.iridescenceMap || !!b.iridescenceThicknessMap || b.transmission > 0 || !!b.transmissionMap || !!b.thicknessMap || !!b.specularIntensityMap || !!b.specularColorMap || b.sheen > 0 || !!b.sheenColorMap || !!b.sheenRoughnessMap) && !!b.displacementMap,
            fog: !!_,
            useFog: b.fog === !0,
            fogExp2: _ && _.isFogExp2,
            flatShading: !!b.flatShading,
            sizeAttenuation: b.sizeAttenuation,
            logarithmicDepthBuffer: h,
            skinning: I.isSkinnedMesh === !0,
            morphTargets: D.morphAttributes.position !== void 0,
            morphNormals: D.morphAttributes.normal !== void 0,
            morphColors: D.morphAttributes.color !== void 0,
            morphTargetsCount: q,
            morphTextureStride: Q,
            numDirLights: M.directional.length,
            numPointLights: M.point.length,
            numSpotLights: M.spot.length,
            numSpotLightMaps: M.spotLightMap.length,
            numRectAreaLights: M.rectArea.length,
            numHemiLights: M.hemi.length,
            numDirLightShadows: M.directionalShadowMap.length,
            numPointLightShadows: M.pointShadowMap.length,
            numSpotLightShadows: M.spotShadowMap.length,
            numSpotLightShadowsWithMaps: M.numSpotLightShadowsWithMaps,
            numClippingPlanes: o.numPlanes,
            numClipIntersection: o.numIntersection,
            dithering: b.dithering,
            shadowMapEnabled: n1.shadowMap.enabled && C.length > 0,
            shadowMapType: n1.shadowMap.type,
            toneMapping: b.toneMapped ? n1.toneMapping : Os,
            physicallyCorrectLights: n1.physicallyCorrectLights,
            premultipliedAlpha: b.premultipliedAlpha,
            doubleSided: b.side === fi,
            flipSided: b.side === pi,
            useDepthPacking: !!b.depthPacking,
            depthPacking: b.depthPacking || 0,
            index0AttributeName: b.index0AttributeName,
            extensionDerivatives: b.extensions && b.extensions.derivatives,
            extensionFragDepth: b.extensions && b.extensions.fragDepth,
            extensionDrawBuffers: b.extensions && b.extensions.drawBuffers,
            extensionShaderTextureLOD: b.extensions && b.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: u || r.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: u || r.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: u || r.has("EXT_shader_texture_lod"),
            customProgramCacheKey: b.customProgramCacheKey()
        };
    }
    function g(b) {
        let M = [];
        if (b.shaderID ? M.push(b.shaderID) : (M.push(b.customVertexShaderID), M.push(b.customFragmentShaderID)), b.defines !== void 0) for(let C in b.defines)M.push(C), M.push(b.defines[C]);
        return b.isRawShaderMaterial === !1 && (y(M, b), x(M, b), M.push(n1.outputEncoding)), M.push(b.customProgramCacheKey), M.join();
    }
    function y(b, M) {
        b.push(M.precision), b.push(M.outputEncoding), b.push(M.envMapMode), b.push(M.envMapCubeUVHeight), b.push(M.combine), b.push(M.vertexUvs), b.push(M.fogExp2), b.push(M.sizeAttenuation), b.push(M.morphTargetsCount), b.push(M.morphAttributeCount), b.push(M.numDirLights), b.push(M.numPointLights), b.push(M.numSpotLights), b.push(M.numSpotLightMaps), b.push(M.numHemiLights), b.push(M.numRectAreaLights), b.push(M.numDirLightShadows), b.push(M.numPointLightShadows), b.push(M.numSpotLightShadows), b.push(M.numSpotLightShadowsWithMaps), b.push(M.shadowMapType), b.push(M.toneMapping), b.push(M.numClippingPlanes), b.push(M.numClipIntersection), b.push(M.depthPacking);
    }
    function x(b, M) {
        a.disableAll(), M.isWebGL2 && a.enable(0), M.supportsVertexTextures && a.enable(1), M.instancing && a.enable(2), M.instancingColor && a.enable(3), M.map && a.enable(4), M.matcap && a.enable(5), M.envMap && a.enable(6), M.lightMap && a.enable(7), M.aoMap && a.enable(8), M.emissiveMap && a.enable(9), M.bumpMap && a.enable(10), M.normalMap && a.enable(11), M.objectSpaceNormalMap && a.enable(12), M.tangentSpaceNormalMap && a.enable(13), M.clearcoat && a.enable(14), M.clearcoatMap && a.enable(15), M.clearcoatRoughnessMap && a.enable(16), M.clearcoatNormalMap && a.enable(17), M.iridescence && a.enable(18), M.iridescenceMap && a.enable(19), M.iridescenceThicknessMap && a.enable(20), M.displacementMap && a.enable(21), M.specularMap && a.enable(22), M.roughnessMap && a.enable(23), M.metalnessMap && a.enable(24), M.gradientMap && a.enable(25), M.alphaMap && a.enable(26), M.alphaTest && a.enable(27), M.vertexColors && a.enable(28), M.vertexAlphas && a.enable(29), M.vertexUvs && a.enable(30), M.vertexTangents && a.enable(31), M.uvsVertexOnly && a.enable(32), b.push(a.mask), a.disableAll(), M.fog && a.enable(0), M.useFog && a.enable(1), M.flatShading && a.enable(2), M.logarithmicDepthBuffer && a.enable(3), M.skinning && a.enable(4), M.morphTargets && a.enable(5), M.morphNormals && a.enable(6), M.morphColors && a.enable(7), M.premultipliedAlpha && a.enable(8), M.shadowMapEnabled && a.enable(9), M.physicallyCorrectLights && a.enable(10), M.doubleSided && a.enable(11), M.flipSided && a.enable(12), M.useDepthPacking && a.enable(13), M.dithering && a.enable(14), M.specularIntensityMap && a.enable(15), M.specularColorMap && a.enable(16), M.transmission && a.enable(17), M.transmissionMap && a.enable(18), M.thicknessMap && a.enable(19), M.sheen && a.enable(20), M.sheenColorMap && a.enable(21), M.sheenRoughnessMap && a.enable(22), M.decodeVideoTexture && a.enable(23), M.opaque && a.enable(24), b.push(a.mask);
    }
    function v(b) {
        let M = p[b.type], C;
        if (M) {
            let P = fo[M];
            C = Ns.clone(P.uniforms);
        } else C = b.uniforms;
        return C;
    }
    function S(b, M) {
        let C;
        for(let P = 0, I = c.length; P < I; P++){
            let _ = c[P];
            if (_.cacheKey === M) {
                C = _, ++C.usedTimes;
                break;
            }
        }
        return C === void 0 && (C = new QG(n1, M, b, s), c.push(C)), C;
    }
    function w(b) {
        if (--b.usedTimes === 0) {
            let M = c.indexOf(b);
            c[M] = c[c.length - 1], c.pop(), b.destroy();
        }
    }
    function A(b) {
        l.remove(b);
    }
    function T() {
        l.dispose();
    }
    return {
        getParameters: m,
        getProgramCacheKey: g,
        getUniforms: v,
        acquireProgram: S,
        releaseProgram: w,
        releaseShaderCache: A,
        programs: c,
        dispose: T
    };
}
function $G() {
    let n1 = new WeakMap;
    function t(s) {
        let o = n1.get(s);
        return o === void 0 && (o = {}, n1.set(s, o)), o;
    }
    function e(s) {
        n1.delete(s);
    }
    function r(s, o, a) {
        n1.get(s)[o] = a;
    }
    function i() {
        n1 = new WeakMap;
    }
    return {
        get: t,
        remove: e,
        update: r,
        dispose: i
    };
}
function e4(n1, t) {
    return n1.groupOrder !== t.groupOrder ? n1.groupOrder - t.groupOrder : n1.renderOrder !== t.renderOrder ? n1.renderOrder - t.renderOrder : n1.material.id !== t.material.id ? n1.material.id - t.material.id : n1.z !== t.z ? n1.z - t.z : n1.id - t.id;
}
function _C(n1, t) {
    return n1.groupOrder !== t.groupOrder ? n1.groupOrder - t.groupOrder : n1.renderOrder !== t.renderOrder ? n1.renderOrder - t.renderOrder : n1.z !== t.z ? t.z - n1.z : n1.id - t.id;
}
function IC() {
    let n1 = [], t = 0, e = [], r = [], i = [];
    function s() {
        t = 0, e.length = 0, r.length = 0, i.length = 0;
    }
    function o(h, d, f, p, m, g) {
        let y = n1[t];
        return y === void 0 ? (y = {
            id: h.id,
            object: h,
            geometry: d,
            material: f,
            groupOrder: p,
            renderOrder: h.renderOrder,
            z: m,
            group: g
        }, n1[t] = y) : (y.id = h.id, y.object = h, y.geometry = d, y.material = f, y.groupOrder = p, y.renderOrder = h.renderOrder, y.z = m, y.group = g), t++, y;
    }
    function a(h, d, f, p, m, g) {
        let y = o(h, d, f, p, m, g);
        f.transmission > 0 ? r.push(y) : f.transparent === !0 ? i.push(y) : e.push(y);
    }
    function l(h, d, f, p, m, g) {
        let y = o(h, d, f, p, m, g);
        f.transmission > 0 ? r.unshift(y) : f.transparent === !0 ? i.unshift(y) : e.unshift(y);
    }
    function c(h, d) {
        e.length > 1 && e.sort(h || e4), r.length > 1 && r.sort(d || _C), i.length > 1 && i.sort(d || _C);
    }
    function u() {
        for(let h = t, d = n1.length; h < d; h++){
            let f = n1[h];
            if (f.id === null) break;
            f.id = null, f.object = null, f.geometry = null, f.material = null, f.group = null;
        }
    }
    return {
        opaque: e,
        transmissive: r,
        transparent: i,
        init: s,
        push: a,
        unshift: l,
        finish: u,
        sort: c
    };
}
function t4() {
    let n1 = new WeakMap;
    function t(r, i) {
        let s = n1.get(r), o;
        return s === void 0 ? (o = new IC, n1.set(r, [
            o
        ])) : i >= s.length ? (o = new IC, s.push(o)) : o = s[i], o;
    }
    function e() {
        n1 = new WeakMap;
    }
    return {
        get: t,
        dispose: e
    };
}
function r4() {
    let n1 = {};
    return {
        get: function(t) {
            if (n1[t.id] !== void 0) return n1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        direction: new E,
                        color: new We
                    };
                    break;
                case "SpotLight":
                    e = {
                        position: new E,
                        direction: new E,
                        color: new We,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    e = {
                        position: new E,
                        color: new We,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    e = {
                        direction: new E,
                        skyColor: new We,
                        groundColor: new We
                    };
                    break;
                case "RectAreaLight":
                    e = {
                        color: new We,
                        position: new E,
                        halfWidth: new E,
                        halfHeight: new E
                    };
                    break;
            }
            return n1[t.id] = e, e;
        }
    };
}
function i4() {
    let n1 = {};
    return {
        get: function(t) {
            if (n1[t.id] !== void 0) return n1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new k
                    };
                    break;
                case "SpotLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new k
                    };
                    break;
                case "PointLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new k,
                        shadowCameraNear: 1,
                        shadowCameraFar: 1e3
                    };
                    break;
            }
            return n1[t.id] = e, e;
        }
    };
}
var n4 = 0;
function s4(n1, t) {
    return (t.castShadow ? 2 : 0) - (n1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (n1.map ? 1 : 0);
}
function o4(n1, t) {
    let e = new r4, r = i4(), i = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let u = 0; u < 9; u++)i.probe.push(new E);
    let s = new E, o = new ue, a = new ue;
    function l(u, h) {
        let d = 0, f = 0, p = 0;
        for(let P = 0; P < 9; P++)i.probe[P].set(0, 0, 0);
        let m = 0, g = 0, y = 0, x = 0, v = 0, S = 0, w = 0, A = 0, T = 0, b = 0;
        u.sort(s4);
        let M = h !== !0 ? Math.PI : 1;
        for(let P = 0, I = u.length; P < I; P++){
            let _ = u[P], D = _.color, L = _.intensity, j = _.distance, V = _.shadow && _.shadow.map ? _.shadow.map.texture : null;
            if (_.isAmbientLight) d += D.r * L * M, f += D.g * L * M, p += D.b * L * M;
            else if (_.isLightProbe) for(let H = 0; H < 9; H++)i.probe[H].addScaledVector(_.sh.coefficients[H], L);
            else if (_.isDirectionalLight) {
                let H = e.get(_);
                if (H.color.copy(_.color).multiplyScalar(_.intensity * M), _.castShadow) {
                    let W = _.shadow, q = r.get(_);
                    q.shadowBias = W.bias, q.shadowNormalBias = W.normalBias, q.shadowRadius = W.radius, q.shadowMapSize = W.mapSize, i.directionalShadow[m] = q, i.directionalShadowMap[m] = V, i.directionalShadowMatrix[m] = _.shadow.matrix, S++;
                }
                i.directional[m] = H, m++;
            } else if (_.isSpotLight) {
                let H = e.get(_);
                H.position.setFromMatrixPosition(_.matrixWorld), H.color.copy(D).multiplyScalar(L * M), H.distance = j, H.coneCos = Math.cos(_.angle), H.penumbraCos = Math.cos(_.angle * (1 - _.penumbra)), H.decay = _.decay, i.spot[y] = H;
                let W = _.shadow;
                if (_.map && (i.spotLightMap[T] = _.map, T++, W.updateMatrices(_), _.castShadow && b++), i.spotLightMatrix[y] = W.matrix, _.castShadow) {
                    let q = r.get(_);
                    q.shadowBias = W.bias, q.shadowNormalBias = W.normalBias, q.shadowRadius = W.radius, q.shadowMapSize = W.mapSize, i.spotShadow[y] = q, i.spotShadowMap[y] = V, A++;
                }
                y++;
            } else if (_.isRectAreaLight) {
                let H = e.get(_);
                H.color.copy(D).multiplyScalar(L), H.halfWidth.set(_.width * .5, 0, 0), H.halfHeight.set(0, _.height * .5, 0), i.rectArea[x] = H, x++;
            } else if (_.isPointLight) {
                let H = e.get(_);
                if (H.color.copy(_.color).multiplyScalar(_.intensity * M), H.distance = _.distance, H.decay = _.decay, _.castShadow) {
                    let W = _.shadow, q = r.get(_);
                    q.shadowBias = W.bias, q.shadowNormalBias = W.normalBias, q.shadowRadius = W.radius, q.shadowMapSize = W.mapSize, q.shadowCameraNear = W.camera.near, q.shadowCameraFar = W.camera.far, i.pointShadow[g] = q, i.pointShadowMap[g] = V, i.pointShadowMatrix[g] = _.shadow.matrix, w++;
                }
                i.point[g] = H, g++;
            } else if (_.isHemisphereLight) {
                let H = e.get(_);
                H.skyColor.copy(_.color).multiplyScalar(L * M), H.groundColor.copy(_.groundColor).multiplyScalar(L * M), i.hemi[v] = H, v++;
            }
        }
        x > 0 && (t.isWebGL2 || n1.has("OES_texture_float_linear") === !0 ? (i.rectAreaLTC1 = Ie.LTC_FLOAT_1, i.rectAreaLTC2 = Ie.LTC_FLOAT_2) : n1.has("OES_texture_half_float_linear") === !0 ? (i.rectAreaLTC1 = Ie.LTC_HALF_1, i.rectAreaLTC2 = Ie.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), i.ambient[0] = d, i.ambient[1] = f, i.ambient[2] = p;
        let C = i.hash;
        (C.directionalLength !== m || C.pointLength !== g || C.spotLength !== y || C.rectAreaLength !== x || C.hemiLength !== v || C.numDirectionalShadows !== S || C.numPointShadows !== w || C.numSpotShadows !== A || C.numSpotMaps !== T) && (i.directional.length = m, i.spot.length = y, i.rectArea.length = x, i.point.length = g, i.hemi.length = v, i.directionalShadow.length = S, i.directionalShadowMap.length = S, i.pointShadow.length = w, i.pointShadowMap.length = w, i.spotShadow.length = A, i.spotShadowMap.length = A, i.directionalShadowMatrix.length = S, i.pointShadowMatrix.length = w, i.spotLightMatrix.length = A + T - b, i.spotLightMap.length = T, i.numSpotLightShadowsWithMaps = b, C.directionalLength = m, C.pointLength = g, C.spotLength = y, C.rectAreaLength = x, C.hemiLength = v, C.numDirectionalShadows = S, C.numPointShadows = w, C.numSpotShadows = A, C.numSpotMaps = T, i.version = n4++);
    }
    function c(u, h) {
        let d = 0, f = 0, p = 0, m = 0, g = 0, y = h.matrixWorldInverse;
        for(let x = 0, v = u.length; x < v; x++){
            let S = u[x];
            if (S.isDirectionalLight) {
                let w = i.directional[d];
                w.direction.setFromMatrixPosition(S.matrixWorld), s.setFromMatrixPosition(S.target.matrixWorld), w.direction.sub(s), w.direction.transformDirection(y), d++;
            } else if (S.isSpotLight) {
                let w = i.spot[p];
                w.position.setFromMatrixPosition(S.matrixWorld), w.position.applyMatrix4(y), w.direction.setFromMatrixPosition(S.matrixWorld), s.setFromMatrixPosition(S.target.matrixWorld), w.direction.sub(s), w.direction.transformDirection(y), p++;
            } else if (S.isRectAreaLight) {
                let w = i.rectArea[m];
                w.position.setFromMatrixPosition(S.matrixWorld), w.position.applyMatrix4(y), a.identity(), o.copy(S.matrixWorld), o.premultiply(y), a.extractRotation(o), w.halfWidth.set(S.width * .5, 0, 0), w.halfHeight.set(0, S.height * .5, 0), w.halfWidth.applyMatrix4(a), w.halfHeight.applyMatrix4(a), m++;
            } else if (S.isPointLight) {
                let w = i.point[f];
                w.position.setFromMatrixPosition(S.matrixWorld), w.position.applyMatrix4(y), f++;
            } else if (S.isHemisphereLight) {
                let w = i.hemi[g];
                w.direction.setFromMatrixPosition(S.matrixWorld), w.direction.transformDirection(y), g++;
            }
        }
    }
    return {
        setup: l,
        setupView: c,
        state: i
    };
}
function DC(n1, t) {
    let e = new o4(n1, t), r = [], i = [];
    function s() {
        r.length = 0, i.length = 0;
    }
    function o(h) {
        r.push(h);
    }
    function a(h) {
        i.push(h);
    }
    function l(h) {
        e.setup(r, h);
    }
    function c(h) {
        e.setupView(r, h);
    }
    return {
        init: s,
        state: {
            lightsArray: r,
            shadowsArray: i,
            lights: e
        },
        setupLights: l,
        setupLightsView: c,
        pushLight: o,
        pushShadow: a
    };
}
function a4(n1, t) {
    let e = new WeakMap;
    function r(s, o = 0) {
        let a = e.get(s), l;
        return a === void 0 ? (l = new DC(n1, t), e.set(s, [
            l
        ])) : o >= a.length ? (l = new DC(n1, t), a.push(l)) : l = a[o], l;
    }
    function i() {
        e = new WeakMap;
    }
    return {
        get: r,
        dispose: i
    };
}
var pp = class extends vc {
    constructor(t){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Bi, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
}, fw = class extends vc {
    constructor(t){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.referencePosition = new E, this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
}, l4 = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, c4 = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function u4(n1, t, e) {
    let r = new fp, i = new k, s = new k, o = new Ze, a = new pp({
        depthPacking: Vw
    }), l = new fw, c = {}, u = e.maxTextureSize, h = {
        [Hn]: pi,
        [pi]: Hn,
        [fi]: fi
    }, d = new it({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new k
            },
            radius: {
                value: 4
            }
        },
        vertexShader: l4,
        fragmentShader: c4
    }), f = d.clone();
    f.defines.HORIZONTAL_PASS = 1;
    let p = new _e;
    p.setAttribute("position", new Xe(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    let m = new zt(p, d), g = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = Oy, this.render = function(S, w, A) {
        if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || S.length === 0) return;
        let T = n1.getRenderTarget(), b = n1.getActiveCubeFace(), M = n1.getActiveMipmapLevel(), C = n1.state;
        C.setBlending($t), C.buffers.color.setClear(1, 1, 1, 1), C.buffers.depth.setTest(!0), C.setScissorTest(!1);
        for(let P = 0, I = S.length; P < I; P++){
            let _ = S[P], D = _.shadow;
            if (D === void 0) {
                console.warn("THREE.WebGLShadowMap:", _, "has no shadow.");
                continue;
            }
            if (D.autoUpdate === !1 && D.needsUpdate === !1) continue;
            i.copy(D.mapSize);
            let L = D.getFrameExtents();
            if (i.multiply(L), s.copy(D.mapSize), (i.x > u || i.y > u) && (i.x > u && (s.x = Math.floor(u / L.x), i.x = s.x * L.x, D.mapSize.x = s.x), i.y > u && (s.y = Math.floor(u / L.y), i.y = s.y * L.y, D.mapSize.y = s.y)), D.map === null) {
                let V = this.type !== rp ? {
                    minFilter: Vt,
                    magFilter: Vt
                } : {};
                D.map = new dt(i.x, i.y, V), D.map.texture.name = _.name + ".shadowMap", D.camera.updateProjectionMatrix();
            }
            n1.setRenderTarget(D.map), n1.clear();
            let j = D.getViewportCount();
            for(let V = 0; V < j; V++){
                let H = D.getViewport(V);
                o.set(s.x * H.x, s.y * H.y, s.x * H.z, s.y * H.w), C.viewport(o), D.updateMatrices(_, V), r = D.getFrustum(), v(w, A, D.camera, _, this.type);
            }
            D.isPointLightShadow !== !0 && this.type === rp && y(D, A), D.needsUpdate = !1;
        }
        g.needsUpdate = !1, n1.setRenderTarget(T, b, M);
    };
    function y(S, w) {
        let A = t.update(m);
        d.defines.VSM_SAMPLES !== S.blurSamples && (d.defines.VSM_SAMPLES = S.blurSamples, f.defines.VSM_SAMPLES = S.blurSamples, d.needsUpdate = !0, f.needsUpdate = !0), S.mapPass === null && (S.mapPass = new dt(i.x, i.y)), d.uniforms.shadow_pass.value = S.map.texture, d.uniforms.resolution.value = S.mapSize, d.uniforms.radius.value = S.radius, n1.setRenderTarget(S.mapPass), n1.clear(), n1.renderBufferDirect(w, null, A, d, m, null), f.uniforms.shadow_pass.value = S.mapPass.texture, f.uniforms.resolution.value = S.mapSize, f.uniforms.radius.value = S.radius, n1.setRenderTarget(S.map), n1.clear(), n1.renderBufferDirect(w, null, A, f, m, null);
    }
    function x(S, w, A, T, b, M) {
        let C = null, P = A.isPointLight === !0 ? S.customDistanceMaterial : S.customDepthMaterial;
        if (P !== void 0) C = P;
        else if (C = A.isPointLight === !0 ? l : a, n1.localClippingEnabled && w.clipShadows === !0 && Array.isArray(w.clippingPlanes) && w.clippingPlanes.length !== 0 || w.displacementMap && w.displacementScale !== 0 || w.alphaMap && w.alphaTest > 0 || w.map && w.alphaTest > 0) {
            let I = C.uuid, _ = w.uuid, D = c[I];
            D === void 0 && (D = {}, c[I] = D);
            let L = D[_];
            L === void 0 && (L = C.clone(), D[_] = L), C = L;
        }
        return C.visible = w.visible, C.wireframe = w.wireframe, M === rp ? C.side = w.shadowSide !== null ? w.shadowSide : w.side : C.side = w.shadowSide !== null ? w.shadowSide : h[w.side], C.alphaMap = w.alphaMap, C.alphaTest = w.alphaTest, C.map = w.map, C.clipShadows = w.clipShadows, C.clippingPlanes = w.clippingPlanes, C.clipIntersection = w.clipIntersection, C.displacementMap = w.displacementMap, C.displacementScale = w.displacementScale, C.displacementBias = w.displacementBias, C.wireframeLinewidth = w.wireframeLinewidth, C.linewidth = w.linewidth, A.isPointLight === !0 && C.isMeshDistanceMaterial === !0 && (C.referencePosition.setFromMatrixPosition(A.matrixWorld), C.nearDistance = T, C.farDistance = b), C;
    }
    function v(S, w, A, T, b) {
        if (S.visible === !1) return;
        if (S.layers.test(w.layers) && (S.isMesh || S.isLine || S.isPoints) && (S.castShadow || S.receiveShadow && b === rp) && (!S.frustumCulled || r.intersectsObject(S))) {
            S.modelViewMatrix.multiplyMatrices(A.matrixWorldInverse, S.matrixWorld);
            let P = t.update(S), I = S.material;
            if (Array.isArray(I)) {
                let _ = P.groups;
                for(let D = 0, L = _.length; D < L; D++){
                    let j = _[D], V = I[j.materialIndex];
                    if (V && V.visible) {
                        let H = x(S, V, T, A.near, A.far, b);
                        n1.renderBufferDirect(A, null, P, H, S, j);
                    }
                }
            } else if (I.visible) {
                let _ = x(S, I, T, A.near, A.far, b);
                n1.renderBufferDirect(A, null, P, _, S, null);
            }
        }
        let C = S.children;
        for(let P = 0, I = C.length; P < I; P++)v(C[P], w, A, T, b);
    }
}
function h4(n1, t, e) {
    let r = e.isWebGL2;
    function i() {
        let K = !1, ye = new Ze, Me = null, je = new Ze(0, 0, 0, 0);
        return {
            setMask: function(He) {
                Me !== He && !K && (n1.colorMask(He, He, He, He), Me = He);
            },
            setLocked: function(He) {
                K = He;
            },
            setClear: function(He, _t, Fr, Vr, $o) {
                $o === !0 && (He *= Vr, _t *= Vr, Fr *= Vr), ye.set(He, _t, Fr, Vr), je.equals(ye) === !1 && (n1.clearColor(He, _t, Fr, Vr), je.copy(ye));
            },
            reset: function() {
                K = !1, Me = null, je.set(-1, 0, 0, 0);
            }
        };
    }
    function s() {
        let K = !1, ye = null, Me = null, je = null;
        return {
            setTest: function(He) {
                He ? oe(2929) : ie(2929);
            },
            setMask: function(He) {
                ye !== He && !K && (n1.depthMask(He), ye = He);
            },
            setFunc: function(He) {
                if (Me !== He) {
                    switch(He){
                        case GF:
                            n1.depthFunc(512);
                            break;
                        case jF:
                            n1.depthFunc(519);
                            break;
                        case HF:
                            n1.depthFunc(513);
                            break;
                        case JS:
                            n1.depthFunc(515);
                            break;
                        case WF:
                            n1.depthFunc(514);
                            break;
                        case qF:
                            n1.depthFunc(518);
                            break;
                        case YF:
                            n1.depthFunc(516);
                            break;
                        case XF:
                            n1.depthFunc(517);
                            break;
                        default:
                            n1.depthFunc(515);
                    }
                    Me = He;
                }
            },
            setLocked: function(He) {
                K = He;
            },
            setClear: function(He) {
                je !== He && (n1.clearDepth(He), je = He);
            },
            reset: function() {
                K = !1, ye = null, Me = null, je = null;
            }
        };
    }
    function o() {
        let K = !1, ye = null, Me = null, je = null, He = null, _t = null, Fr = null, Vr = null, $o = null;
        return {
            setTest: function(Mr) {
                K || (Mr ? oe(2960) : ie(2960));
            },
            setMask: function(Mr) {
                ye !== Mr && !K && (n1.stencilMask(Mr), ye = Mr);
            },
            setFunc: function(Mr, es, Mn) {
                (Me !== Mr || je !== es || He !== Mn) && (n1.stencilFunc(Mr, es, Mn), Me = Mr, je = es, He = Mn);
            },
            setOp: function(Mr, es, Mn) {
                (_t !== Mr || Fr !== es || Vr !== Mn) && (n1.stencilOp(Mr, es, Mn), _t = Mr, Fr = es, Vr = Mn);
            },
            setLocked: function(Mr) {
                K = Mr;
            },
            setClear: function(Mr) {
                $o !== Mr && (n1.clearStencil(Mr), $o = Mr);
            },
            reset: function() {
                K = !1, ye = null, Me = null, je = null, He = null, _t = null, Fr = null, Vr = null, $o = null;
            }
        };
    }
    let a = new i, l = new s, c = new o, u = new WeakMap, h = new WeakMap, d = {}, f = {}, p = new WeakMap, m = [], g = null, y = !1, x = null, v = null, S = null, w = null, A = null, T = null, b = null, M = !1, C = null, P = null, I = null, _ = null, D = null, L = n1.getParameter(35661), j = !1, V = 0, H = n1.getParameter(7938);
    H.indexOf("WebGL") !== -1 ? (V = parseFloat(/^WebGL (\d)/.exec(H)[1]), j = V >= 1) : H.indexOf("OpenGL ES") !== -1 && (V = parseFloat(/^OpenGL ES (\d)/.exec(H)[1]), j = V >= 2);
    let W = null, q = {}, Q = n1.getParameter(3088), G = n1.getParameter(2978), Z = new Ze().fromArray(Q), te = new Ze().fromArray(G);
    function $(K, ye, Me) {
        let je = new Uint8Array(4), He = n1.createTexture();
        n1.bindTexture(K, He), n1.texParameteri(K, 10241, 9728), n1.texParameteri(K, 10240, 9728);
        for(let _t = 0; _t < Me; _t++)n1.texImage2D(ye + _t, 0, 6408, 1, 1, 0, 6408, 5121, je);
        return He;
    }
    let Y = {};
    Y[3553] = $(3553, 3553, 1), Y[34067] = $(34067, 34069, 6), a.setClear(0, 0, 0, 1), l.setClear(1), c.setClear(0), oe(2929), l.setFunc(JS), ze(!1), Ue(AM), oe(2884), De($t);
    function oe(K) {
        d[K] !== !0 && (n1.enable(K), d[K] = !0);
    }
    function ie(K) {
        d[K] !== !1 && (n1.disable(K), d[K] = !1);
    }
    function re(K, ye) {
        return f[K] !== ye ? (n1.bindFramebuffer(K, ye), f[K] = ye, r && (K === 36009 && (f[36160] = ye), K === 36160 && (f[36009] = ye)), !0) : !1;
    }
    function J(K, ye) {
        let Me = m, je = !1;
        if (K) {
            if (Me = p.get(ye), Me === void 0 && (Me = [], p.set(ye, Me)), K.isWebGLMultipleRenderTargets) {
                let He = K.texture;
                if (Me.length !== He.length || Me[0] !== 36064) {
                    for(let _t = 0, Fr = He.length; _t < Fr; _t++)Me[_t] = 36064 + _t;
                    Me.length = He.length, je = !0;
                }
            } else Me[0] !== 36064 && (Me[0] = 36064, je = !0);
        } else Me[0] !== 1029 && (Me[0] = 1029, je = !0);
        je && (e.isWebGL2 ? n1.drawBuffers(Me) : t.get("WEBGL_draw_buffers").drawBuffersWEBGL(Me));
    }
    function Ee(K) {
        return g !== K ? (n1.useProgram(K), g = K, !0) : !1;
    }
    let xe = {
        [Pu]: 32774,
        [DF]: 32778,
        [OF]: 32779
    };
    if (r) xe[CM] = 32775, xe[PM] = 32776;
    else {
        let K = t.get("EXT_blend_minmax");
        K !== null && (xe[CM] = K.MIN_EXT, xe[PM] = K.MAX_EXT);
    }
    let de = {
        [RF]: 0,
        [LF]: 1,
        [BF]: 768,
        [tP]: 770,
        [zF]: 776,
        [kF]: 774,
        [FF]: 772,
        [NF]: 769,
        [rP]: 771,
        [UF]: 775,
        [VF]: 773
    };
    function De(K, ye, Me, je, He, _t, Fr, Vr) {
        if (K === $t) {
            y === !0 && (ie(3042), y = !1);
            return;
        }
        if (y === !1 && (oe(3042), y = !0), K !== IF) {
            if (K !== x || Vr !== M) {
                if ((v !== Pu || A !== Pu) && (n1.blendEquation(32774), v = Pu, A = Pu), Vr) switch(K){
                    case Za:
                        n1.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case EM:
                        n1.blendFunc(1, 1);
                        break;
                    case TM:
                        n1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case MM:
                        n1.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", K);
                        break;
                }
                else switch(K){
                    case Za:
                        n1.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case EM:
                        n1.blendFunc(770, 1);
                        break;
                    case TM:
                        n1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case MM:
                        n1.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", K);
                        break;
                }
                S = null, w = null, T = null, b = null, x = K, M = Vr;
            }
            return;
        }
        He = He || ye, _t = _t || Me, Fr = Fr || je, (ye !== v || He !== A) && (n1.blendEquationSeparate(xe[ye], xe[He]), v = ye, A = He), (Me !== S || je !== w || _t !== T || Fr !== b) && (n1.blendFuncSeparate(de[Me], de[je], de[_t], de[Fr]), S = Me, w = je, T = _t, b = Fr), x = K, M = !1;
    }
    function Ce(K, ye) {
        K.side === fi ? ie(2884) : oe(2884);
        let Me = K.side === pi;
        ye && (Me = !Me), ze(Me), K.blending === Za && K.transparent === !1 ? De($t) : De(K.blending, K.blendEquation, K.blendSrc, K.blendDst, K.blendEquationAlpha, K.blendSrcAlpha, K.blendDstAlpha, K.premultipliedAlpha), l.setFunc(K.depthFunc), l.setTest(K.depthTest), l.setMask(K.depthWrite), a.setMask(K.colorWrite);
        let je = K.stencilWrite;
        c.setTest(je), je && (c.setMask(K.stencilWriteMask), c.setFunc(K.stencilFunc, K.stencilRef, K.stencilFuncMask), c.setOp(K.stencilFail, K.stencilZFail, K.stencilZPass)), Oe(K.polygonOffset, K.polygonOffsetFactor, K.polygonOffsetUnits), K.alphaToCoverage === !0 ? oe(32926) : ie(32926);
    }
    function ze(K) {
        C !== K && (K ? n1.frontFace(2304) : n1.frontFace(2305), C = K);
    }
    function Ue(K) {
        K !== CF ? (oe(2884), K !== P && (K === AM ? n1.cullFace(1029) : K === PF ? n1.cullFace(1028) : n1.cullFace(1032))) : ie(2884), P = K;
    }
    function Ve(K) {
        K !== I && (j && n1.lineWidth(K), I = K);
    }
    function Oe(K, ye, Me) {
        K ? (oe(32823), (_ !== ye || D !== Me) && (n1.polygonOffset(ye, Me), _ = ye, D = Me)) : ie(32823);
    }
    function Ye(K) {
        K ? oe(3089) : ie(3089);
    }
    function F(K) {
        K === void 0 && (K = 33984 + L - 1), W !== K && (n1.activeTexture(K), W = K);
    }
    function N(K, ye, Me) {
        Me === void 0 && (W === null ? Me = 33984 + L - 1 : Me = W);
        let je = q[Me];
        je === void 0 && (je = {
            type: void 0,
            texture: void 0
        }, q[Me] = je), (je.type !== K || je.texture !== ye) && (W !== Me && (n1.activeTexture(Me), W = Me), n1.bindTexture(K, ye || Y[K]), je.type = K, je.texture = ye);
    }
    function B() {
        let K = q[W];
        K !== void 0 && K.type !== void 0 && (n1.bindTexture(K.type, null), K.type = void 0, K.texture = void 0);
    }
    function ae() {
        try {
            n1.compressedTexImage2D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function ge() {
        try {
            n1.compressedTexImage3D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function me() {
        try {
            n1.texSubImage2D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function Le() {
        try {
            n1.texSubImage3D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function Ne() {
        try {
            n1.compressedTexSubImage2D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function Re() {
        try {
            n1.compressedTexSubImage3D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function pe() {
        try {
            n1.texStorage2D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function nt() {
        try {
            n1.texStorage3D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function Ge() {
        try {
            n1.texImage2D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function Be() {
        try {
            n1.texImage3D.apply(n1, arguments);
        } catch (K) {
            console.error("THREE.WebGLState:", K);
        }
    }
    function et(K) {
        Z.equals(K) === !1 && (n1.scissor(K.x, K.y, K.z, K.w), Z.copy(K));
    }
    function st(K) {
        te.equals(K) === !1 && (n1.viewport(K.x, K.y, K.z, K.w), te.copy(K));
    }
    function Bt(K, ye) {
        let Me = h.get(ye);
        Me === void 0 && (Me = new WeakMap, h.set(ye, Me));
        let je = Me.get(K);
        je === void 0 && (je = n1.getUniformBlockIndex(ye, K.name), Me.set(K, je));
    }
    function dr(K, ye) {
        let je = h.get(ye).get(K);
        u.get(ye) !== je && (n1.uniformBlockBinding(ye, je, K.__bindingPointIndex), u.set(ye, je));
    }
    function Tr() {
        n1.disable(3042), n1.disable(2884), n1.disable(2929), n1.disable(32823), n1.disable(3089), n1.disable(2960), n1.disable(32926), n1.blendEquation(32774), n1.blendFunc(1, 0), n1.blendFuncSeparate(1, 0, 1, 0), n1.colorMask(!0, !0, !0, !0), n1.clearColor(0, 0, 0, 0), n1.depthMask(!0), n1.depthFunc(513), n1.clearDepth(1), n1.stencilMask(4294967295), n1.stencilFunc(519, 0, 4294967295), n1.stencilOp(7680, 7680, 7680), n1.clearStencil(0), n1.cullFace(1029), n1.frontFace(2305), n1.polygonOffset(0, 0), n1.activeTexture(33984), n1.bindFramebuffer(36160, null), r === !0 && (n1.bindFramebuffer(36009, null), n1.bindFramebuffer(36008, null)), n1.useProgram(null), n1.lineWidth(1), n1.scissor(0, 0, n1.canvas.width, n1.canvas.height), n1.viewport(0, 0, n1.canvas.width, n1.canvas.height), d = {}, W = null, q = {}, f = {}, p = new WeakMap, m = [], g = null, y = !1, x = null, v = null, S = null, w = null, A = null, T = null, b = null, M = !1, C = null, P = null, I = null, _ = null, D = null, Z.set(0, 0, n1.canvas.width, n1.canvas.height), te.set(0, 0, n1.canvas.width, n1.canvas.height), a.reset(), l.reset(), c.reset();
    }
    return {
        buffers: {
            color: a,
            depth: l,
            stencil: c
        },
        enable: oe,
        disable: ie,
        bindFramebuffer: re,
        drawBuffers: J,
        useProgram: Ee,
        setBlending: De,
        setMaterial: Ce,
        setFlipSided: ze,
        setCullFace: Ue,
        setLineWidth: Ve,
        setPolygonOffset: Oe,
        setScissorTest: Ye,
        activeTexture: F,
        bindTexture: N,
        unbindTexture: B,
        compressedTexImage2D: ae,
        compressedTexImage3D: ge,
        texImage2D: Ge,
        texImage3D: Be,
        updateUBOMapping: Bt,
        uniformBlockBinding: dr,
        texStorage2D: pe,
        texStorage3D: nt,
        texSubImage2D: me,
        texSubImage3D: Le,
        compressedTexSubImage2D: Ne,
        compressedTexSubImage3D: Re,
        scissor: et,
        viewport: st,
        reset: Tr
    };
}
function d4(n1, t, e, r, i, s, o) {
    let a = i.isWebGL2, l = i.maxTextures, c = i.maxCubemapSize, u = i.maxTextureSize, h = i.maxSamples, d = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, f = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), p = new WeakMap, m, g = new WeakMap, y = !1;
    try {
        y = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch  {}
    function x(N, B) {
        return y ? new OffscreenCanvas(N, B) : hp("canvas");
    }
    function v(N, B, ae, ge) {
        let me = 1;
        if ((N.width > ge || N.height > ge) && (me = ge / Math.max(N.width, N.height)), me < 1 || B === !0) {
            if (typeof HTMLImageElement < "u" && N instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && N instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && N instanceof ImageBitmap) {
                let Le = B ? oy : Math.floor, Ne = Le(me * N.width), Re = Le(me * N.height);
                m === void 0 && (m = x(Ne, Re));
                let pe = ae ? x(Ne, Re) : m;
                return pe.width = Ne, pe.height = Re, pe.getContext("2d").drawImage(N, 0, 0, Ne, Re), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + N.width + "x" + N.height + ") to (" + Ne + "x" + Re + ")."), pe;
            } else return "data" in N && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + N.width + "x" + N.height + ")."), N;
        }
        return N;
    }
    function S(N) {
        return nw(N.width) && nw(N.height);
    }
    function w(N) {
        return a ? !1 : N.wrapS !== Qt || N.wrapT !== Qt || N.minFilter !== Vt && N.minFilter !== rt;
    }
    function A(N, B) {
        return N.generateMipmaps && B && N.minFilter !== Vt && N.minFilter !== rt;
    }
    function T(N) {
        n1.generateMipmap(N);
    }
    function b(N, B, ae, ge, me = !1) {
        if (a === !1) return B;
        if (N !== null) {
            if (n1[N] !== void 0) return n1[N];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + N + "'");
        }
        let Le = B;
        return B === 6403 && (ae === 5126 && (Le = 33326), ae === 5131 && (Le = 33325), ae === 5121 && (Le = 33321)), B === 33319 && (ae === 5126 && (Le = 33328), ae === 5131 && (Le = 33327), ae === 5121 && (Le = 33323)), B === 6408 && (ae === 5126 && (Le = 34836), ae === 5131 && (Le = 34842), ae === 5121 && (Le = ge === at && me === !1 ? 35907 : 32856), ae === 32819 && (Le = 32854), ae === 32820 && (Le = 32855)), (Le === 33325 || Le === 33326 || Le === 33327 || Le === 33328 || Le === 34842 || Le === 34836) && t.get("EXT_color_buffer_float"), Le;
    }
    function M(N, B, ae) {
        return A(N, ae) === !0 || N.isFramebufferTexture && N.minFilter !== Vt && N.minFilter !== rt ? Math.log2(Math.max(B.width, B.height)) + 1 : N.mipmaps !== void 0 && N.mipmaps.length > 0 ? N.mipmaps.length : N.isCompressedTexture && Array.isArray(N.image) ? B.mipmaps.length : 1;
    }
    function C(N) {
        return N === Vt || N === _M || N === mS ? 9728 : 9729;
    }
    function P(N) {
        let B = N.target;
        B.removeEventListener("dispose", P), _(B), B.isVideoTexture && p.delete(B);
    }
    function I(N) {
        let B = N.target;
        B.removeEventListener("dispose", I), L(B);
    }
    function _(N) {
        let B = r.get(N);
        if (B.__webglInit === void 0) return;
        let ae = N.source, ge = g.get(ae);
        if (ge) {
            let me = ge[B.__cacheKey];
            me.usedTimes--, me.usedTimes === 0 && D(N), Object.keys(ge).length === 0 && g.delete(ae);
        }
        r.remove(N);
    }
    function D(N) {
        let B = r.get(N);
        n1.deleteTexture(B.__webglTexture);
        let ae = N.source, ge = g.get(ae);
        delete ge[B.__cacheKey], o.memory.textures--;
    }
    function L(N) {
        let B = N.texture, ae = r.get(N), ge = r.get(B);
        if (ge.__webglTexture !== void 0 && (n1.deleteTexture(ge.__webglTexture), o.memory.textures--), N.depthTexture && N.depthTexture.dispose(), N.isWebGLCubeRenderTarget) for(let me = 0; me < 6; me++)n1.deleteFramebuffer(ae.__webglFramebuffer[me]), ae.__webglDepthbuffer && n1.deleteRenderbuffer(ae.__webglDepthbuffer[me]);
        else {
            if (n1.deleteFramebuffer(ae.__webglFramebuffer), ae.__webglDepthbuffer && n1.deleteRenderbuffer(ae.__webglDepthbuffer), ae.__webglMultisampledFramebuffer && n1.deleteFramebuffer(ae.__webglMultisampledFramebuffer), ae.__webglColorRenderbuffer) for(let me = 0; me < ae.__webglColorRenderbuffer.length; me++)ae.__webglColorRenderbuffer[me] && n1.deleteRenderbuffer(ae.__webglColorRenderbuffer[me]);
            ae.__webglDepthRenderbuffer && n1.deleteRenderbuffer(ae.__webglDepthRenderbuffer);
        }
        if (N.isWebGLMultipleRenderTargets) for(let me = 0, Le = B.length; me < Le; me++){
            let Ne = r.get(B[me]);
            Ne.__webglTexture && (n1.deleteTexture(Ne.__webglTexture), o.memory.textures--), r.remove(B[me]);
        }
        r.remove(B), r.remove(N);
    }
    let j = 0;
    function V() {
        j = 0;
    }
    function H() {
        let N = j;
        return N >= l && console.warn("THREE.WebGLTextures: Trying to use " + N + " texture units while this GPU supports only " + l), j += 1, N;
    }
    function W(N) {
        let B = [];
        return B.push(N.wrapS), B.push(N.wrapT), B.push(N.wrapR || 0), B.push(N.magFilter), B.push(N.minFilter), B.push(N.anisotropy), B.push(N.internalFormat), B.push(N.format), B.push(N.type), B.push(N.generateMipmaps), B.push(N.premultiplyAlpha), B.push(N.flipY), B.push(N.unpackAlignment), B.push(N.encoding), B.join();
    }
    function q(N, B) {
        let ae = r.get(N);
        if (N.isVideoTexture && Ye(N), N.isRenderTargetTexture === !1 && N.version > 0 && ae.__version !== N.version) {
            let ge = N.image;
            if (ge === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (ge.complete === !1) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                ie(ae, N, B);
                return;
            }
        }
        e.bindTexture(3553, ae.__webglTexture, 33984 + B);
    }
    function Q(N, B) {
        let ae = r.get(N);
        if (N.version > 0 && ae.__version !== N.version) {
            ie(ae, N, B);
            return;
        }
        e.bindTexture(35866, ae.__webglTexture, 33984 + B);
    }
    function G(N, B) {
        let ae = r.get(N);
        if (N.version > 0 && ae.__version !== N.version) {
            ie(ae, N, B);
            return;
        }
        e.bindTexture(32879, ae.__webglTexture, 33984 + B);
    }
    function Z(N, B) {
        let ae = r.get(N);
        if (N.version > 0 && ae.__version !== N.version) {
            re(ae, N, B);
            return;
        }
        e.bindTexture(34067, ae.__webglTexture, 33984 + B);
    }
    let te = {
        [Rs]: 10497,
        [Qt]: 33071,
        [tw]: 33648
    }, $ = {
        [Vt]: 9728,
        [_M]: 9984,
        [mS]: 9986,
        [rt]: 9729,
        [rV]: 9985,
        [yc]: 9987
    };
    function Y(N, B, ae) {
        if (ae ? (n1.texParameteri(N, 10242, te[B.wrapS]), n1.texParameteri(N, 10243, te[B.wrapT]), (N === 32879 || N === 35866) && n1.texParameteri(N, 32882, te[B.wrapR]), n1.texParameteri(N, 10240, $[B.magFilter]), n1.texParameteri(N, 10241, $[B.minFilter])) : (n1.texParameteri(N, 10242, 33071), n1.texParameteri(N, 10243, 33071), (N === 32879 || N === 35866) && n1.texParameteri(N, 32882, 33071), (B.wrapS !== Qt || B.wrapT !== Qt) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), n1.texParameteri(N, 10240, C(B.magFilter)), n1.texParameteri(N, 10241, C(B.minFilter)), B.minFilter !== Vt && B.minFilter !== rt && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), t.has("EXT_texture_filter_anisotropic") === !0) {
            let ge = t.get("EXT_texture_filter_anisotropic");
            if (B.magFilter === Vt || B.minFilter !== mS && B.minFilter !== yc || B.type === br && t.has("OES_texture_float_linear") === !1 || a === !1 && B.type === Wn && t.has("OES_texture_half_float_linear") === !1) return;
            (B.anisotropy > 1 || r.get(B).__currentAnisotropy) && (n1.texParameterf(N, ge.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(B.anisotropy, i.getMaxAnisotropy())), r.get(B).__currentAnisotropy = B.anisotropy);
        }
    }
    function oe(N, B) {
        let ae = !1;
        N.__webglInit === void 0 && (N.__webglInit = !0, B.addEventListener("dispose", P));
        let ge = B.source, me = g.get(ge);
        me === void 0 && (me = {}, g.set(ge, me));
        let Le = W(B);
        if (Le !== N.__cacheKey) {
            me[Le] === void 0 && (me[Le] = {
                texture: n1.createTexture(),
                usedTimes: 0
            }, o.memory.textures++, ae = !0), me[Le].usedTimes++;
            let Ne = me[N.__cacheKey];
            Ne !== void 0 && (me[N.__cacheKey].usedTimes--, Ne.usedTimes === 0 && D(B)), N.__cacheKey = Le, N.__webglTexture = me[Le].texture;
        }
        return ae;
    }
    function ie(N, B, ae) {
        let ge = 3553;
        (B.isDataArrayTexture || B.isCompressedArrayTexture) && (ge = 35866), B.isData3DTexture && (ge = 32879);
        let me = oe(N, B), Le = B.source;
        e.bindTexture(ge, N.__webglTexture, 33984 + ae);
        let Ne = r.get(Le);
        if (Le.version !== Ne.__version || me === !0) {
            e.activeTexture(33984 + ae), n1.pixelStorei(37440, B.flipY), n1.pixelStorei(37441, B.premultiplyAlpha), n1.pixelStorei(3317, B.unpackAlignment), n1.pixelStorei(37443, 0);
            let Re = w(B) && S(B.image) === !1, pe = v(B.image, Re, !1, u);
            pe = F(B, pe);
            let nt = S(pe) || a, Ge = s.convert(B.format, B.encoding), Be = s.convert(B.type), et = b(B.internalFormat, Ge, Be, B.encoding, B.isVideoTexture);
            Y(ge, B, nt);
            let st, Bt = B.mipmaps, dr = a && B.isVideoTexture !== !0, Tr = Ne.__version === void 0 || me === !0, K = M(B, pe, nt);
            if (B.isDepthTexture) et = 6402, a ? B.type === br ? et = 36012 : B.type === Ds ? et = 33190 : B.type === Ja ? et = 35056 : et = 33189 : B.type === br && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), B.format === mc && et === 6402 && B.type !== sP && B.type !== Ds && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), B.type = Ds, Be = s.convert(B.type)), B.format === tl && et === 6402 && (et = 34041, B.type !== Ja && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), B.type = Ja, Be = s.convert(B.type))), Tr && (dr ? e.texStorage2D(3553, 1, et, pe.width, pe.height) : e.texImage2D(3553, 0, et, pe.width, pe.height, 0, Ge, Be, null));
            else if (B.isDataTexture) {
                if (Bt.length > 0 && nt) {
                    dr && Tr && e.texStorage2D(3553, K, et, Bt[0].width, Bt[0].height);
                    for(let ye = 0, Me = Bt.length; ye < Me; ye++)st = Bt[ye], dr ? e.texSubImage2D(3553, ye, 0, 0, st.width, st.height, Ge, Be, st.data) : e.texImage2D(3553, ye, et, st.width, st.height, 0, Ge, Be, st.data);
                    B.generateMipmaps = !1;
                } else dr ? (Tr && e.texStorage2D(3553, K, et, pe.width, pe.height), e.texSubImage2D(3553, 0, 0, 0, pe.width, pe.height, Ge, Be, pe.data)) : e.texImage2D(3553, 0, et, pe.width, pe.height, 0, Ge, Be, pe.data);
            } else if (B.isCompressedTexture) {
                if (B.isCompressedArrayTexture) {
                    dr && Tr && e.texStorage3D(35866, K, et, Bt[0].width, Bt[0].height, pe.depth);
                    for(let ye = 0, Me = Bt.length; ye < Me; ye++)st = Bt[ye], B.format !== qr ? Ge !== null ? dr ? e.compressedTexSubImage3D(35866, ye, 0, 0, 0, st.width, st.height, pe.depth, Ge, st.data, 0, 0) : e.compressedTexImage3D(35866, ye, et, st.width, st.height, pe.depth, 0, st.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : dr ? e.texSubImage3D(35866, ye, 0, 0, 0, st.width, st.height, pe.depth, Ge, Be, st.data) : e.texImage3D(35866, ye, et, st.width, st.height, pe.depth, 0, Ge, Be, st.data);
                } else {
                    dr && Tr && e.texStorage2D(3553, K, et, Bt[0].width, Bt[0].height);
                    for(let ye = 0, Me = Bt.length; ye < Me; ye++)st = Bt[ye], B.format !== qr ? Ge !== null ? dr ? e.compressedTexSubImage2D(3553, ye, 0, 0, st.width, st.height, Ge, st.data) : e.compressedTexImage2D(3553, ye, et, st.width, st.height, 0, st.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : dr ? e.texSubImage2D(3553, ye, 0, 0, st.width, st.height, Ge, Be, st.data) : e.texImage2D(3553, ye, et, st.width, st.height, 0, Ge, Be, st.data);
                }
            } else if (B.isDataArrayTexture) dr ? (Tr && e.texStorage3D(35866, K, et, pe.width, pe.height, pe.depth), e.texSubImage3D(35866, 0, 0, 0, 0, pe.width, pe.height, pe.depth, Ge, Be, pe.data)) : e.texImage3D(35866, 0, et, pe.width, pe.height, pe.depth, 0, Ge, Be, pe.data);
            else if (B.isData3DTexture) dr ? (Tr && e.texStorage3D(32879, K, et, pe.width, pe.height, pe.depth), e.texSubImage3D(32879, 0, 0, 0, 0, pe.width, pe.height, pe.depth, Ge, Be, pe.data)) : e.texImage3D(32879, 0, et, pe.width, pe.height, pe.depth, 0, Ge, Be, pe.data);
            else if (B.isFramebufferTexture) {
                if (Tr) {
                    if (dr) e.texStorage2D(3553, K, et, pe.width, pe.height);
                    else {
                        let ye = pe.width, Me = pe.height;
                        for(let je = 0; je < K; je++)e.texImage2D(3553, je, et, ye, Me, 0, Ge, Be, null), ye >>= 1, Me >>= 1;
                    }
                }
            } else if (Bt.length > 0 && nt) {
                dr && Tr && e.texStorage2D(3553, K, et, Bt[0].width, Bt[0].height);
                for(let ye = 0, Me = Bt.length; ye < Me; ye++)st = Bt[ye], dr ? e.texSubImage2D(3553, ye, 0, 0, Ge, Be, st) : e.texImage2D(3553, ye, et, Ge, Be, st);
                B.generateMipmaps = !1;
            } else dr ? (Tr && e.texStorage2D(3553, K, et, pe.width, pe.height), e.texSubImage2D(3553, 0, 0, 0, Ge, Be, pe)) : e.texImage2D(3553, 0, et, Ge, Be, pe);
            A(B, nt) && T(ge), Ne.__version = Le.version, B.onUpdate && B.onUpdate(B);
        }
        N.__version = B.version;
    }
    function re(N, B, ae) {
        if (B.image.length !== 6) return;
        let ge = oe(N, B), me = B.source;
        e.bindTexture(34067, N.__webglTexture, 33984 + ae);
        let Le = r.get(me);
        if (me.version !== Le.__version || ge === !0) {
            e.activeTexture(33984 + ae), n1.pixelStorei(37440, B.flipY), n1.pixelStorei(37441, B.premultiplyAlpha), n1.pixelStorei(3317, B.unpackAlignment), n1.pixelStorei(37443, 0);
            let Ne = B.isCompressedTexture || B.image[0].isCompressedTexture, Re = B.image[0] && B.image[0].isDataTexture, pe = [];
            for(let ye = 0; ye < 6; ye++)!Ne && !Re ? pe[ye] = v(B.image[ye], !1, !0, c) : pe[ye] = Re ? B.image[ye].image : B.image[ye], pe[ye] = F(B, pe[ye]);
            let nt = pe[0], Ge = S(nt) || a, Be = s.convert(B.format, B.encoding), et = s.convert(B.type), st = b(B.internalFormat, Be, et, B.encoding), Bt = a && B.isVideoTexture !== !0, dr = Le.__version === void 0 || ge === !0, Tr = M(B, nt, Ge);
            Y(34067, B, Ge);
            let K;
            if (Ne) {
                Bt && dr && e.texStorage2D(34067, Tr, st, nt.width, nt.height);
                for(let ye = 0; ye < 6; ye++){
                    K = pe[ye].mipmaps;
                    for(let Me = 0; Me < K.length; Me++){
                        let je = K[Me];
                        B.format !== qr ? Be !== null ? Bt ? e.compressedTexSubImage2D(34069 + ye, Me, 0, 0, je.width, je.height, Be, je.data) : e.compressedTexImage2D(34069 + ye, Me, st, je.width, je.height, 0, je.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Bt ? e.texSubImage2D(34069 + ye, Me, 0, 0, je.width, je.height, Be, et, je.data) : e.texImage2D(34069 + ye, Me, st, je.width, je.height, 0, Be, et, je.data);
                    }
                }
            } else {
                K = B.mipmaps, Bt && dr && (K.length > 0 && Tr++, e.texStorage2D(34067, Tr, st, pe[0].width, pe[0].height));
                for(let ye = 0; ye < 6; ye++)if (Re) {
                    Bt ? e.texSubImage2D(34069 + ye, 0, 0, 0, pe[ye].width, pe[ye].height, Be, et, pe[ye].data) : e.texImage2D(34069 + ye, 0, st, pe[ye].width, pe[ye].height, 0, Be, et, pe[ye].data);
                    for(let Me = 0; Me < K.length; Me++){
                        let He = K[Me].image[ye].image;
                        Bt ? e.texSubImage2D(34069 + ye, Me + 1, 0, 0, He.width, He.height, Be, et, He.data) : e.texImage2D(34069 + ye, Me + 1, st, He.width, He.height, 0, Be, et, He.data);
                    }
                } else {
                    Bt ? e.texSubImage2D(34069 + ye, 0, 0, 0, Be, et, pe[ye]) : e.texImage2D(34069 + ye, 0, st, Be, et, pe[ye]);
                    for(let Me = 0; Me < K.length; Me++){
                        let je = K[Me];
                        Bt ? e.texSubImage2D(34069 + ye, Me + 1, 0, 0, Be, et, je.image[ye]) : e.texImage2D(34069 + ye, Me + 1, st, Be, et, je.image[ye]);
                    }
                }
            }
            A(B, Ge) && T(34067), Le.__version = me.version, B.onUpdate && B.onUpdate(B);
        }
        N.__version = B.version;
    }
    function J(N, B, ae, ge, me) {
        let Le = s.convert(ae.format, ae.encoding), Ne = s.convert(ae.type), Re = b(ae.internalFormat, Le, Ne, ae.encoding);
        r.get(B).__hasExternalTextures || (me === 32879 || me === 35866 ? e.texImage3D(me, 0, Re, B.width, B.height, B.depth, 0, Le, Ne, null) : e.texImage2D(me, 0, Re, B.width, B.height, 0, Le, Ne, null)), e.bindFramebuffer(36160, N), Oe(B) ? d.framebufferTexture2DMultisampleEXT(36160, ge, me, r.get(ae).__webglTexture, 0, Ve(B)) : (me === 3553 || me >= 34069 && me <= 34074) && n1.framebufferTexture2D(36160, ge, me, r.get(ae).__webglTexture, 0), e.bindFramebuffer(36160, null);
    }
    function Ee(N, B, ae) {
        if (n1.bindRenderbuffer(36161, N), B.depthBuffer && !B.stencilBuffer) {
            let ge = 33189;
            if (ae || Oe(B)) {
                let me = B.depthTexture;
                me && me.isDepthTexture && (me.type === br ? ge = 36012 : me.type === Ds && (ge = 33190));
                let Le = Ve(B);
                Oe(B) ? d.renderbufferStorageMultisampleEXT(36161, Le, ge, B.width, B.height) : n1.renderbufferStorageMultisample(36161, Le, ge, B.width, B.height);
            } else n1.renderbufferStorage(36161, ge, B.width, B.height);
            n1.framebufferRenderbuffer(36160, 36096, 36161, N);
        } else if (B.depthBuffer && B.stencilBuffer) {
            let ge = Ve(B);
            ae && Oe(B) === !1 ? n1.renderbufferStorageMultisample(36161, ge, 35056, B.width, B.height) : Oe(B) ? d.renderbufferStorageMultisampleEXT(36161, ge, 35056, B.width, B.height) : n1.renderbufferStorage(36161, 34041, B.width, B.height), n1.framebufferRenderbuffer(36160, 33306, 36161, N);
        } else {
            let ge = B.isWebGLMultipleRenderTargets === !0 ? B.texture : [
                B.texture
            ];
            for(let me = 0; me < ge.length; me++){
                let Le = ge[me], Ne = s.convert(Le.format, Le.encoding), Re = s.convert(Le.type), pe = b(Le.internalFormat, Ne, Re, Le.encoding), nt = Ve(B);
                ae && Oe(B) === !1 ? n1.renderbufferStorageMultisample(36161, nt, pe, B.width, B.height) : Oe(B) ? d.renderbufferStorageMultisampleEXT(36161, nt, pe, B.width, B.height) : n1.renderbufferStorage(36161, pe, B.width, B.height);
            }
        }
        n1.bindRenderbuffer(36161, null);
    }
    function xe(N, B) {
        if (B && B.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (e.bindFramebuffer(36160, N), !(B.depthTexture && B.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        (!r.get(B.depthTexture).__webglTexture || B.depthTexture.image.width !== B.width || B.depthTexture.image.height !== B.height) && (B.depthTexture.image.width = B.width, B.depthTexture.image.height = B.height, B.depthTexture.needsUpdate = !0), q(B.depthTexture, 0);
        let ge = r.get(B.depthTexture).__webglTexture, me = Ve(B);
        if (B.depthTexture.format === mc) Oe(B) ? d.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, ge, 0, me) : n1.framebufferTexture2D(36160, 36096, 3553, ge, 0);
        else if (B.depthTexture.format === tl) Oe(B) ? d.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, ge, 0, me) : n1.framebufferTexture2D(36160, 33306, 3553, ge, 0);
        else throw new Error("Unknown depthTexture format");
    }
    function de(N) {
        let B = r.get(N), ae = N.isWebGLCubeRenderTarget === !0;
        if (N.depthTexture && !B.__autoAllocateDepthBuffer) {
            if (ae) throw new Error("target.depthTexture not supported in Cube render targets");
            xe(B.__webglFramebuffer, N);
        } else if (ae) {
            B.__webglDepthbuffer = [];
            for(let ge = 0; ge < 6; ge++)e.bindFramebuffer(36160, B.__webglFramebuffer[ge]), B.__webglDepthbuffer[ge] = n1.createRenderbuffer(), Ee(B.__webglDepthbuffer[ge], N, !1);
        } else e.bindFramebuffer(36160, B.__webglFramebuffer), B.__webglDepthbuffer = n1.createRenderbuffer(), Ee(B.__webglDepthbuffer, N, !1);
        e.bindFramebuffer(36160, null);
    }
    function De(N, B, ae) {
        let ge = r.get(N);
        B !== void 0 && J(ge.__webglFramebuffer, N, N.texture, 36064, 3553), ae !== void 0 && de(N);
    }
    function Ce(N) {
        let B = N.texture, ae = r.get(N), ge = r.get(B);
        N.addEventListener("dispose", I), N.isWebGLMultipleRenderTargets !== !0 && (ge.__webglTexture === void 0 && (ge.__webglTexture = n1.createTexture()), ge.__version = B.version, o.memory.textures++);
        let me = N.isWebGLCubeRenderTarget === !0, Le = N.isWebGLMultipleRenderTargets === !0, Ne = S(N) || a;
        if (me) {
            ae.__webglFramebuffer = [];
            for(let Re = 0; Re < 6; Re++)ae.__webglFramebuffer[Re] = n1.createFramebuffer();
        } else {
            if (ae.__webglFramebuffer = n1.createFramebuffer(), Le) {
                if (i.drawBuffers) {
                    let Re = N.texture;
                    for(let pe = 0, nt = Re.length; pe < nt; pe++){
                        let Ge = r.get(Re[pe]);
                        Ge.__webglTexture === void 0 && (Ge.__webglTexture = n1.createTexture(), o.memory.textures++);
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (a && N.samples > 0 && Oe(N) === !1) {
                let Re = Le ? B : [
                    B
                ];
                ae.__webglMultisampledFramebuffer = n1.createFramebuffer(), ae.__webglColorRenderbuffer = [], e.bindFramebuffer(36160, ae.__webglMultisampledFramebuffer);
                for(let pe = 0; pe < Re.length; pe++){
                    let nt = Re[pe];
                    ae.__webglColorRenderbuffer[pe] = n1.createRenderbuffer(), n1.bindRenderbuffer(36161, ae.__webglColorRenderbuffer[pe]);
                    let Ge = s.convert(nt.format, nt.encoding), Be = s.convert(nt.type), et = b(nt.internalFormat, Ge, Be, nt.encoding, N.isXRRenderTarget === !0), st = Ve(N);
                    n1.renderbufferStorageMultisample(36161, st, et, N.width, N.height), n1.framebufferRenderbuffer(36160, 36064 + pe, 36161, ae.__webglColorRenderbuffer[pe]);
                }
                n1.bindRenderbuffer(36161, null), N.depthBuffer && (ae.__webglDepthRenderbuffer = n1.createRenderbuffer(), Ee(ae.__webglDepthRenderbuffer, N, !0)), e.bindFramebuffer(36160, null);
            }
        }
        if (me) {
            e.bindTexture(34067, ge.__webglTexture), Y(34067, B, Ne);
            for(let Re = 0; Re < 6; Re++)J(ae.__webglFramebuffer[Re], N, B, 36064, 34069 + Re);
            A(B, Ne) && T(34067), e.unbindTexture();
        } else if (Le) {
            let Re = N.texture;
            for(let pe = 0, nt = Re.length; pe < nt; pe++){
                let Ge = Re[pe], Be = r.get(Ge);
                e.bindTexture(3553, Be.__webglTexture), Y(3553, Ge, Ne), J(ae.__webglFramebuffer, N, Ge, 36064 + pe, 3553), A(Ge, Ne) && T(3553);
            }
            e.unbindTexture();
        } else {
            let Re = 3553;
            (N.isWebGL3DRenderTarget || N.isWebGLArrayRenderTarget) && (a ? Re = N.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), e.bindTexture(Re, ge.__webglTexture), Y(Re, B, Ne), J(ae.__webglFramebuffer, N, B, 36064, Re), A(B, Ne) && T(Re), e.unbindTexture();
        }
        N.depthBuffer && de(N);
    }
    function ze(N) {
        let B = S(N) || a, ae = N.isWebGLMultipleRenderTargets === !0 ? N.texture : [
            N.texture
        ];
        for(let ge = 0, me = ae.length; ge < me; ge++){
            let Le = ae[ge];
            if (A(Le, B)) {
                let Ne = N.isWebGLCubeRenderTarget ? 34067 : 3553, Re = r.get(Le).__webglTexture;
                e.bindTexture(Ne, Re), T(Ne), e.unbindTexture();
            }
        }
    }
    function Ue(N) {
        if (a && N.samples > 0 && Oe(N) === !1) {
            let B = N.isWebGLMultipleRenderTargets ? N.texture : [
                N.texture
            ], ae = N.width, ge = N.height, me = 16384, Le = [], Ne = N.stencilBuffer ? 33306 : 36096, Re = r.get(N), pe = N.isWebGLMultipleRenderTargets === !0;
            if (pe) for(let nt = 0; nt < B.length; nt++)e.bindFramebuffer(36160, Re.__webglMultisampledFramebuffer), n1.framebufferRenderbuffer(36160, 36064 + nt, 36161, null), e.bindFramebuffer(36160, Re.__webglFramebuffer), n1.framebufferTexture2D(36009, 36064 + nt, 3553, null, 0);
            e.bindFramebuffer(36008, Re.__webglMultisampledFramebuffer), e.bindFramebuffer(36009, Re.__webglFramebuffer);
            for(let nt = 0; nt < B.length; nt++){
                Le.push(36064 + nt), N.depthBuffer && Le.push(Ne);
                let Ge = Re.__ignoreDepthValues !== void 0 ? Re.__ignoreDepthValues : !1;
                if (Ge === !1 && (N.depthBuffer && (me |= 256), N.stencilBuffer && (me |= 1024)), pe && n1.framebufferRenderbuffer(36008, 36064, 36161, Re.__webglColorRenderbuffer[nt]), Ge === !0 && (n1.invalidateFramebuffer(36008, [
                    Ne
                ]), n1.invalidateFramebuffer(36009, [
                    Ne
                ])), pe) {
                    let Be = r.get(B[nt]).__webglTexture;
                    n1.framebufferTexture2D(36009, 36064, 3553, Be, 0);
                }
                n1.blitFramebuffer(0, 0, ae, ge, 0, 0, ae, ge, me, 9728), f && n1.invalidateFramebuffer(36008, Le);
            }
            if (e.bindFramebuffer(36008, null), e.bindFramebuffer(36009, null), pe) for(let nt = 0; nt < B.length; nt++){
                e.bindFramebuffer(36160, Re.__webglMultisampledFramebuffer), n1.framebufferRenderbuffer(36160, 36064 + nt, 36161, Re.__webglColorRenderbuffer[nt]);
                let Ge = r.get(B[nt]).__webglTexture;
                e.bindFramebuffer(36160, Re.__webglFramebuffer), n1.framebufferTexture2D(36009, 36064 + nt, 3553, Ge, 0);
            }
            e.bindFramebuffer(36009, Re.__webglMultisampledFramebuffer);
        }
    }
    function Ve(N) {
        return Math.min(h, N.samples);
    }
    function Oe(N) {
        let B = r.get(N);
        return a && N.samples > 0 && t.has("WEBGL_multisampled_render_to_texture") === !0 && B.__useRenderToTexture !== !1;
    }
    function Ye(N) {
        let B = o.render.frame;
        p.get(N) !== B && (p.set(N, B), N.update());
    }
    function F(N, B) {
        let ae = N.encoding, ge = N.format, me = N.type;
        return N.isCompressedTexture === !0 || N.isVideoTexture === !0 || N.format === iw || ae !== mn && (ae === at ? a === !1 ? t.has("EXT_sRGB") === !0 && ge === qr ? (N.format = iw, N.minFilter = rt, N.generateMipmaps = !1) : B = ay.sRGBToLinear(B) : (ge !== qr || me !== _r) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", ae)), B;
    }
    this.allocateTextureUnit = H, this.resetTextureUnits = V, this.setTexture2D = q, this.setTexture2DArray = Q, this.setTexture3D = G, this.setTextureCube = Z, this.rebindTextures = De, this.setupRenderTarget = Ce, this.updateRenderTargetMipmap = ze, this.updateMultisampleRenderTarget = Ue, this.setupDepthRenderbuffer = de, this.setupFrameBufferTexture = J, this.useMultisampledRTT = Oe;
}
function f4(n1, t, e) {
    let r = e.isWebGL2;
    function i(s, o = null) {
        let a;
        if (s === _r) return 5121;
        if (s === oV) return 32819;
        if (s === aV) return 32820;
        if (s === iV) return 5120;
        if (s === nV) return 5122;
        if (s === sP) return 5123;
        if (s === sV) return 5124;
        if (s === Ds) return 5125;
        if (s === br) return 5126;
        if (s === Wn) return r ? 5131 : (a = t.get("OES_texture_half_float"), a !== null ? a.HALF_FLOAT_OES : null);
        if (s === lV) return 6406;
        if (s === qr) return 6408;
        if (s === cV) return 6409;
        if (s === uV) return 6410;
        if (s === mc) return 6402;
        if (s === tl) return 34041;
        if (s === iw) return a = t.get("EXT_sRGB"), a !== null ? a.SRGB_ALPHA_EXT : null;
        if (s === hV) return 6403;
        if (s === dV) return 36244;
        if (s === eh) return 33319;
        if (s === fV) return 33320;
        if (s === Lw) return 36249;
        if (s === gS || s === yS || s === vS || s === xS) {
            if (o === at) {
                if (a = t.get("WEBGL_compressed_texture_s3tc_srgb"), a !== null) {
                    if (s === gS) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (s === yS) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (s === vS) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (s === xS) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else if (a = t.get("WEBGL_compressed_texture_s3tc"), a !== null) {
                if (s === gS) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (s === yS) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (s === vS) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (s === xS) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (s === IM || s === DM || s === OM || s === RM) {
            if (a = t.get("WEBGL_compressed_texture_pvrtc"), a !== null) {
                if (s === IM) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (s === DM) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (s === OM) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (s === RM) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (s === pV) return a = t.get("WEBGL_compressed_texture_etc1"), a !== null ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
        if (s === LM || s === BM) {
            if (a = t.get("WEBGL_compressed_texture_etc"), a !== null) {
                if (s === LM) return o === at ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                if (s === BM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        if (s === NM || s === FM || s === VM || s === kM || s === UM || s === zM || s === GM || s === jM || s === HM || s === WM || s === qM || s === YM || s === XM || s === KM) {
            if (a = t.get("WEBGL_compressed_texture_astc"), a !== null) {
                if (s === NM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (s === FM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (s === VM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (s === kM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (s === UM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (s === zM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (s === GM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (s === jM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (s === HM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (s === WM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (s === qM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (s === YM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (s === XM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (s === KM) return o === at ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        if (s === bS) {
            if (a = t.get("EXT_texture_compression_bptc"), a !== null) {
                if (s === bS) return o === at ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        if (s === mV || s === QM || s === ZM || s === JM) {
            if (a = t.get("EXT_texture_compression_rgtc"), a !== null) {
                if (s === bS) return a.COMPRESSED_RED_RGTC1_EXT;
                if (s === QM) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (s === ZM) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (s === JM) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        return s === Ja ? r ? 34042 : (a = t.get("WEBGL_depth_texture"), a !== null ? a.UNSIGNED_INT_24_8_WEBGL : null) : n1[s] !== void 0 ? n1[s] : null;
    }
    return {
        convert: i
    };
}
var pw = class extends $r {
    constructor(t = []){
        super(), this.isArrayCamera = !0, this.cameras = t;
    }
}, sn = class extends Tt {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}, p4 = {
    type: "move"
}, op = class {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return this._hand === null && (this._hand = new sn, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return this._targetRay === null && (this._targetRay = new sn, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new E, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new E), this._targetRay;
    }
    getGripSpace() {
        return this._grip === null && (this._grip = new sn, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new E, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new E), this._grip;
    }
    dispatchEvent(t) {
        return this._targetRay !== null && this._targetRay.dispatchEvent(t), this._grip !== null && this._grip.dispatchEvent(t), this._hand !== null && this._hand.dispatchEvent(t), this;
    }
    connect(t) {
        if (t && t.hand) {
            let e = this._hand;
            if (e) for (let r of t.hand.values())this._getHandJoint(e, r);
        }
        return this.dispatchEvent({
            type: "connected",
            data: t
        }), this;
    }
    disconnect(t) {
        return this.dispatchEvent({
            type: "disconnected",
            data: t
        }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
    }
    update(t, e, r) {
        let i = null, s = null, o = null, a = this._targetRay, l = this._grip, c = this._hand;
        if (t && e.session.visibilityState !== "visible-blurred") {
            if (c && t.hand) {
                o = !0;
                for (let m of t.hand.values()){
                    let g = e.getJointPose(m, r), y = this._getHandJoint(c, m);
                    g !== null && (y.matrix.fromArray(g.transform.matrix), y.matrix.decompose(y.position, y.rotation, y.scale), y.jointRadius = g.radius), y.visible = g !== null;
                }
                let u = c.joints["index-finger-tip"], h = c.joints["thumb-tip"], d = u.position.distanceTo(h.position), f = .02, p = .005;
                c.inputState.pinching && d > f + p ? (c.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: t.handedness,
                    target: this
                })) : !c.inputState.pinching && d <= f - p && (c.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: t.handedness,
                    target: this
                }));
            } else l !== null && t.gripSpace && (s = e.getPose(t.gripSpace, r), s !== null && (l.matrix.fromArray(s.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), s.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(s.linearVelocity)) : l.hasLinearVelocity = !1, s.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(s.angularVelocity)) : l.hasAngularVelocity = !1));
            a !== null && (i = e.getPose(t.targetRaySpace, r), i === null && s !== null && (i = s), i !== null && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(p4)));
        }
        return a !== null && (a.visible = i !== null), l !== null && (l.visible = s !== null), c !== null && (c.visible = o !== null), this;
    }
    _getHandJoint(t, e) {
        if (t.joints[e.jointName] === void 0) {
            let r = new sn;
            r.matrixAutoUpdate = !1, r.visible = !1, t.joints[e.jointName] = r, t.add(r);
        }
        return t.joints[e.jointName];
    }
}, ns = class extends er {
    constructor(t, e, r, i, s, o, a, l, c, u){
        if (u = u !== void 0 ? u : mc, u !== mc && u !== tl) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        r === void 0 && u === mc && (r = Ds), r === void 0 && u === tl && (r = Ja), super(null, i, s, o, a, l, u, r, c), this.isDepthTexture = !0, this.image = {
            width: t,
            height: e
        }, this.magFilter = a !== void 0 ? a : Vt, this.minFilter = l !== void 0 ? l : Vt, this.flipY = !1, this.generateMipmaps = !1;
    }
}, mw = class extends pr {
    constructor(t, e){
        super();
        let r = this, i = null, s = 1, o = null, a = "local-floor", l = 1, c = null, u = null, h = null, d = null, f = null, p = null, m = e.getContextAttributes(), g = null, y = null, x = [], v = [], S = new Set, w = new Map, A = new $r;
        A.layers.enable(1), A.viewport = new Ze;
        let T = new $r;
        T.layers.enable(2), T.viewport = new Ze;
        let b = [
            A,
            T
        ], M = new pw;
        M.layers.enable(1), M.layers.enable(2);
        let C = null, P = null;
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(G) {
            let Z = x[G];
            return Z === void 0 && (Z = new op, x[G] = Z), Z.getTargetRaySpace();
        }, this.getControllerGrip = function(G) {
            let Z = x[G];
            return Z === void 0 && (Z = new op, x[G] = Z), Z.getGripSpace();
        }, this.getHand = function(G) {
            let Z = x[G];
            return Z === void 0 && (Z = new op, x[G] = Z), Z.getHandSpace();
        };
        function I(G) {
            let Z = v.indexOf(G.inputSource);
            if (Z === -1) return;
            let te = x[Z];
            te !== void 0 && te.dispatchEvent({
                type: G.type,
                data: G.inputSource
            });
        }
        function _() {
            i.removeEventListener("select", I), i.removeEventListener("selectstart", I), i.removeEventListener("selectend", I), i.removeEventListener("squeeze", I), i.removeEventListener("squeezestart", I), i.removeEventListener("squeezeend", I), i.removeEventListener("end", _), i.removeEventListener("inputsourceschange", D);
            for(let G = 0; G < x.length; G++){
                let Z = v[G];
                Z !== null && (v[G] = null, x[G].disconnect(Z));
            }
            C = null, P = null, t.setRenderTarget(g), f = null, d = null, h = null, i = null, y = null, Q.stop(), r.isPresenting = !1, r.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(G) {
            s = G, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(G) {
            a = G, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return c || o;
        }, this.setReferenceSpace = function(G) {
            c = G;
        }, this.getBaseLayer = function() {
            return d !== null ? d : f;
        }, this.getBinding = function() {
            return h;
        }, this.getFrame = function() {
            return p;
        }, this.getSession = function() {
            return i;
        }, this.setSession = async function(G) {
            if (i = G, i !== null) {
                if (g = t.getRenderTarget(), i.addEventListener("select", I), i.addEventListener("selectstart", I), i.addEventListener("selectend", I), i.addEventListener("squeeze", I), i.addEventListener("squeezestart", I), i.addEventListener("squeezeend", I), i.addEventListener("end", _), i.addEventListener("inputsourceschange", D), m.xrCompatible !== !0 && await e.makeXRCompatible(), i.renderState.layers === void 0 || t.capabilities.isWebGL2 === !1) {
                    let Z = {
                        antialias: i.renderState.layers === void 0 ? m.antialias : !0,
                        alpha: m.alpha,
                        depth: m.depth,
                        stencil: m.stencil,
                        framebufferScaleFactor: s
                    };
                    f = new XRWebGLLayer(i, e, Z), i.updateRenderState({
                        baseLayer: f
                    }), y = new dt(f.framebufferWidth, f.framebufferHeight, {
                        format: qr,
                        type: _r,
                        encoding: t.outputEncoding,
                        stencilBuffer: m.stencil
                    });
                } else {
                    let Z = null, te = null, $ = null;
                    m.depth && ($ = m.stencil ? 35056 : 33190, Z = m.stencil ? tl : mc, te = m.stencil ? Ja : Ds);
                    let Y = {
                        colorFormat: 32856,
                        depthFormat: $,
                        scaleFactor: s
                    };
                    h = new XRWebGLBinding(i, e), d = h.createProjectionLayer(Y), i.updateRenderState({
                        layers: [
                            d
                        ]
                    }), y = new dt(d.textureWidth, d.textureHeight, {
                        format: qr,
                        type: _r,
                        depthTexture: new ns(d.textureWidth, d.textureHeight, te, void 0, void 0, void 0, void 0, void 0, void 0, Z),
                        stencilBuffer: m.stencil,
                        encoding: t.outputEncoding,
                        samples: m.antialias ? 4 : 0
                    });
                    let oe = t.properties.get(y);
                    oe.__ignoreDepthValues = d.ignoreDepthValues;
                }
                y.isXRRenderTarget = !0, this.setFoveation(l), c = null, o = await i.requestReferenceSpace(a), Q.setContext(i), Q.start(), r.isPresenting = !0, r.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function D(G) {
            for(let Z = 0; Z < G.removed.length; Z++){
                let te = G.removed[Z], $ = v.indexOf(te);
                $ >= 0 && (v[$] = null, x[$].disconnect(te));
            }
            for(let Z = 0; Z < G.added.length; Z++){
                let te = G.added[Z], $ = v.indexOf(te);
                if ($ === -1) {
                    for(let oe = 0; oe < x.length; oe++)if (oe >= v.length) {
                        v.push(te), $ = oe;
                        break;
                    } else if (v[oe] === null) {
                        v[oe] = te, $ = oe;
                        break;
                    }
                    if ($ === -1) break;
                }
                let Y = x[$];
                Y && Y.connect(te);
            }
        }
        let L = new E, j = new E;
        function V(G, Z, te) {
            L.setFromMatrixPosition(Z.matrixWorld), j.setFromMatrixPosition(te.matrixWorld);
            let $ = L.distanceTo(j), Y = Z.projectionMatrix.elements, oe = te.projectionMatrix.elements, ie = Y[14] / (Y[10] - 1), re = Y[14] / (Y[10] + 1), J = (Y[9] + 1) / Y[5], Ee = (Y[9] - 1) / Y[5], xe = (Y[8] - 1) / Y[0], de = (oe[8] + 1) / oe[0], De = ie * xe, Ce = ie * de, ze = $ / (-xe + de), Ue = ze * -xe;
            Z.matrixWorld.decompose(G.position, G.quaternion, G.scale), G.translateX(Ue), G.translateZ(ze), G.matrixWorld.compose(G.position, G.quaternion, G.scale), G.matrixWorldInverse.copy(G.matrixWorld).invert();
            let Ve = ie + ze, Oe = re + ze, Ye = De - Ue, F = Ce + ($ - Ue), N = J * re / Oe * Ve, B = Ee * re / Oe * Ve;
            G.projectionMatrix.makePerspective(Ye, F, N, B, Ve, Oe);
        }
        function H(G, Z) {
            Z === null ? G.matrixWorld.copy(G.matrix) : G.matrixWorld.multiplyMatrices(Z.matrixWorld, G.matrix), G.matrixWorldInverse.copy(G.matrixWorld).invert();
        }
        this.updateCamera = function(G) {
            if (i === null) return;
            M.near = T.near = A.near = G.near, M.far = T.far = A.far = G.far, (C !== M.near || P !== M.far) && (i.updateRenderState({
                depthNear: M.near,
                depthFar: M.far
            }), C = M.near, P = M.far);
            let Z = G.parent, te = M.cameras;
            H(M, Z);
            for(let Y = 0; Y < te.length; Y++)H(te[Y], Z);
            M.matrixWorld.decompose(M.position, M.quaternion, M.scale), G.matrix.copy(M.matrix), G.matrix.decompose(G.position, G.quaternion, G.scale);
            let $ = G.children;
            for(let Y = 0, oe = $.length; Y < oe; Y++)$[Y].updateMatrixWorld(!0);
            te.length === 2 ? V(M, A, T) : M.projectionMatrix.copy(A.projectionMatrix);
        }, this.getCamera = function() {
            return M;
        }, this.getFoveation = function() {
            if (!(d === null && f === null)) return l;
        }, this.setFoveation = function(G) {
            l = G, d !== null && (d.fixedFoveation = G), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = G);
        }, this.getPlanes = function() {
            return S;
        };
        let W = null;
        function q(G, Z) {
            if (u = Z.getViewerPose(c || o), p = Z, u !== null) {
                let te = u.views;
                f !== null && (t.setRenderTargetFramebuffer(y, f.framebuffer), t.setRenderTarget(y));
                let $ = !1;
                te.length !== M.cameras.length && (M.cameras.length = 0, $ = !0);
                for(let Y = 0; Y < te.length; Y++){
                    let oe = te[Y], ie = null;
                    if (f !== null) ie = f.getViewport(oe);
                    else {
                        let J = h.getViewSubImage(d, oe);
                        ie = J.viewport, Y === 0 && (t.setRenderTargetTextures(y, J.colorTexture, d.ignoreDepthValues ? void 0 : J.depthStencilTexture), t.setRenderTarget(y));
                    }
                    let re = b[Y];
                    re === void 0 && (re = new $r, re.layers.enable(Y), re.viewport = new Ze, b[Y] = re), re.matrix.fromArray(oe.transform.matrix), re.projectionMatrix.fromArray(oe.projectionMatrix), re.viewport.set(ie.x, ie.y, ie.width, ie.height), Y === 0 && M.matrix.copy(re.matrix), $ === !0 && M.cameras.push(re);
                }
            }
            for(let te = 0; te < x.length; te++){
                let $ = v[te], Y = x[te];
                $ !== null && Y !== void 0 && Y.update($, Z, c || o);
            }
            if (W && W(G, Z), Z.detectedPlanes) {
                r.dispatchEvent({
                    type: "planesdetected",
                    data: Z.detectedPlanes
                });
                let te = null;
                for (let $ of S)Z.detectedPlanes.has($) || (te === null && (te = []), te.push($));
                if (te !== null) for (let $ of te)S.delete($), w.delete($), r.dispatchEvent({
                    type: "planeremoved",
                    data: $
                });
                for (let $ of Z.detectedPlanes)if (!S.has($)) S.add($), w.set($, Z.lastChangedTime), r.dispatchEvent({
                    type: "planeadded",
                    data: $
                });
                else {
                    let Y = w.get($);
                    $.lastChangedTime > Y && (w.set($, $.lastChangedTime), r.dispatchEvent({
                        type: "planechanged",
                        data: $
                    }));
                }
            }
            p = null;
        }
        let Q = new hP;
        Q.setAnimationLoop(q), this.setAnimationLoop = function(G) {
            W = G;
        }, this.dispose = function() {};
    }
};
function m4(n1, t) {
    function e(m, g) {
        g.color.getRGB(m.fogColor.value, uP(n1)), g.isFog ? (m.fogNear.value = g.near, m.fogFar.value = g.far) : g.isFogExp2 && (m.fogDensity.value = g.density);
    }
    function r(m, g, y, x, v) {
        g.isMeshBasicMaterial || g.isMeshLambertMaterial ? i(m, g) : g.isMeshToonMaterial ? (i(m, g), u(m, g)) : g.isMeshPhongMaterial ? (i(m, g), c(m, g)) : g.isMeshStandardMaterial ? (i(m, g), h(m, g), g.isMeshPhysicalMaterial && d(m, g, v)) : g.isMeshMatcapMaterial ? (i(m, g), f(m, g)) : g.isMeshDepthMaterial ? i(m, g) : g.isMeshDistanceMaterial ? (i(m, g), p(m, g)) : g.isMeshNormalMaterial ? i(m, g) : g.isLineBasicMaterial ? (s(m, g), g.isLineDashedMaterial && o(m, g)) : g.isPointsMaterial ? a(m, g, y, x) : g.isSpriteMaterial ? l(m, g) : g.isShadowMaterial ? (m.color.value.copy(g.color), m.opacity.value = g.opacity) : g.isShaderMaterial && (g.uniformsNeedUpdate = !1);
    }
    function i(m, g) {
        m.opacity.value = g.opacity, g.color && m.diffuse.value.copy(g.color), g.emissive && m.emissive.value.copy(g.emissive).multiplyScalar(g.emissiveIntensity), g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.bumpMap && (m.bumpMap.value = g.bumpMap, m.bumpScale.value = g.bumpScale, g.side === pi && (m.bumpScale.value *= -1)), g.displacementMap && (m.displacementMap.value = g.displacementMap, m.displacementScale.value = g.displacementScale, m.displacementBias.value = g.displacementBias), g.emissiveMap && (m.emissiveMap.value = g.emissiveMap), g.normalMap && (m.normalMap.value = g.normalMap, m.normalScale.value.copy(g.normalScale), g.side === pi && m.normalScale.value.negate()), g.specularMap && (m.specularMap.value = g.specularMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
        let y = t.get(g).envMap;
        if (y && (m.envMap.value = y, m.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1, m.reflectivity.value = g.reflectivity, m.ior.value = g.ior, m.refractionRatio.value = g.refractionRatio), g.lightMap) {
            m.lightMap.value = g.lightMap;
            let S = n1.physicallyCorrectLights !== !0 ? Math.PI : 1;
            m.lightMapIntensity.value = g.lightMapIntensity * S;
        }
        g.aoMap && (m.aoMap.value = g.aoMap, m.aoMapIntensity.value = g.aoMapIntensity);
        let x;
        g.map ? x = g.map : g.specularMap ? x = g.specularMap : g.displacementMap ? x = g.displacementMap : g.normalMap ? x = g.normalMap : g.bumpMap ? x = g.bumpMap : g.roughnessMap ? x = g.roughnessMap : g.metalnessMap ? x = g.metalnessMap : g.alphaMap ? x = g.alphaMap : g.emissiveMap ? x = g.emissiveMap : g.clearcoatMap ? x = g.clearcoatMap : g.clearcoatNormalMap ? x = g.clearcoatNormalMap : g.clearcoatRoughnessMap ? x = g.clearcoatRoughnessMap : g.iridescenceMap ? x = g.iridescenceMap : g.iridescenceThicknessMap ? x = g.iridescenceThicknessMap : g.specularIntensityMap ? x = g.specularIntensityMap : g.specularColorMap ? x = g.specularColorMap : g.transmissionMap ? x = g.transmissionMap : g.thicknessMap ? x = g.thicknessMap : g.sheenColorMap ? x = g.sheenColorMap : g.sheenRoughnessMap && (x = g.sheenRoughnessMap), x !== void 0 && (x.isWebGLRenderTarget && (x = x.texture), x.matrixAutoUpdate === !0 && x.updateMatrix(), m.uvTransform.value.copy(x.matrix));
        let v;
        g.aoMap ? v = g.aoMap : g.lightMap && (v = g.lightMap), v !== void 0 && (v.isWebGLRenderTarget && (v = v.texture), v.matrixAutoUpdate === !0 && v.updateMatrix(), m.uv2Transform.value.copy(v.matrix));
    }
    function s(m, g) {
        m.diffuse.value.copy(g.color), m.opacity.value = g.opacity;
    }
    function o(m, g) {
        m.dashSize.value = g.dashSize, m.totalSize.value = g.dashSize + g.gapSize, m.scale.value = g.scale;
    }
    function a(m, g, y, x) {
        m.diffuse.value.copy(g.color), m.opacity.value = g.opacity, m.size.value = g.size * y, m.scale.value = x * .5, g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
        let v;
        g.map ? v = g.map : g.alphaMap && (v = g.alphaMap), v !== void 0 && (v.matrixAutoUpdate === !0 && v.updateMatrix(), m.uvTransform.value.copy(v.matrix));
    }
    function l(m, g) {
        m.diffuse.value.copy(g.color), m.opacity.value = g.opacity, m.rotation.value = g.rotation, g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
        let y;
        g.map ? y = g.map : g.alphaMap && (y = g.alphaMap), y !== void 0 && (y.matrixAutoUpdate === !0 && y.updateMatrix(), m.uvTransform.value.copy(y.matrix));
    }
    function c(m, g) {
        m.specular.value.copy(g.specular), m.shininess.value = Math.max(g.shininess, 1e-4);
    }
    function u(m, g) {
        g.gradientMap && (m.gradientMap.value = g.gradientMap);
    }
    function h(m, g) {
        m.roughness.value = g.roughness, m.metalness.value = g.metalness, g.roughnessMap && (m.roughnessMap.value = g.roughnessMap), g.metalnessMap && (m.metalnessMap.value = g.metalnessMap), t.get(g).envMap && (m.envMapIntensity.value = g.envMapIntensity);
    }
    function d(m, g, y) {
        m.ior.value = g.ior, g.sheen > 0 && (m.sheenColor.value.copy(g.sheenColor).multiplyScalar(g.sheen), m.sheenRoughness.value = g.sheenRoughness, g.sheenColorMap && (m.sheenColorMap.value = g.sheenColorMap), g.sheenRoughnessMap && (m.sheenRoughnessMap.value = g.sheenRoughnessMap)), g.clearcoat > 0 && (m.clearcoat.value = g.clearcoat, m.clearcoatRoughness.value = g.clearcoatRoughness, g.clearcoatMap && (m.clearcoatMap.value = g.clearcoatMap), g.clearcoatRoughnessMap && (m.clearcoatRoughnessMap.value = g.clearcoatRoughnessMap), g.clearcoatNormalMap && (m.clearcoatNormalScale.value.copy(g.clearcoatNormalScale), m.clearcoatNormalMap.value = g.clearcoatNormalMap, g.side === pi && m.clearcoatNormalScale.value.negate())), g.iridescence > 0 && (m.iridescence.value = g.iridescence, m.iridescenceIOR.value = g.iridescenceIOR, m.iridescenceThicknessMinimum.value = g.iridescenceThicknessRange[0], m.iridescenceThicknessMaximum.value = g.iridescenceThicknessRange[1], g.iridescenceMap && (m.iridescenceMap.value = g.iridescenceMap), g.iridescenceThicknessMap && (m.iridescenceThicknessMap.value = g.iridescenceThicknessMap)), g.transmission > 0 && (m.transmission.value = g.transmission, m.transmissionSamplerMap.value = y.texture, m.transmissionSamplerSize.value.set(y.width, y.height), g.transmissionMap && (m.transmissionMap.value = g.transmissionMap), m.thickness.value = g.thickness, g.thicknessMap && (m.thicknessMap.value = g.thicknessMap), m.attenuationDistance.value = g.attenuationDistance, m.attenuationColor.value.copy(g.attenuationColor)), m.specularIntensity.value = g.specularIntensity, m.specularColor.value.copy(g.specularColor), g.specularIntensityMap && (m.specularIntensityMap.value = g.specularIntensityMap), g.specularColorMap && (m.specularColorMap.value = g.specularColorMap);
    }
    function f(m, g) {
        g.matcap && (m.matcap.value = g.matcap);
    }
    function p(m, g) {
        m.referencePosition.value.copy(g.referencePosition), m.nearDistance.value = g.nearDistance, m.farDistance.value = g.farDistance;
    }
    return {
        refreshFogUniforms: e,
        refreshMaterialUniforms: r
    };
}
function g4(n1, t, e, r) {
    let i = {}, s = {}, o = [], a = e.isWebGL2 ? n1.getParameter(35375) : 0;
    function l(x, v) {
        let S = v.program;
        r.uniformBlockBinding(x, S);
    }
    function c(x, v) {
        let S = i[x.id];
        S === void 0 && (p(x), S = u(x), i[x.id] = S, x.addEventListener("dispose", g));
        let w = v.program;
        r.updateUBOMapping(x, w);
        let A = t.render.frame;
        s[x.id] !== A && (d(x), s[x.id] = A);
    }
    function u(x) {
        let v = h();
        x.__bindingPointIndex = v;
        let S = n1.createBuffer(), w = x.__size, A = x.usage;
        return n1.bindBuffer(35345, S), n1.bufferData(35345, w, A), n1.bindBuffer(35345, null), n1.bindBufferBase(35345, v, S), S;
    }
    function h() {
        for(let x = 0; x < a; x++)if (o.indexOf(x) === -1) return o.push(x), x;
        return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
    }
    function d(x) {
        let v = i[x.id], S = x.uniforms, w = x.__cache;
        n1.bindBuffer(35345, v);
        for(let A = 0, T = S.length; A < T; A++){
            let b = S[A];
            if (f(b, A, w) === !0) {
                let M = b.__offset, C = Array.isArray(b.value) ? b.value : [
                    b.value
                ], P = 0;
                for(let I = 0; I < C.length; I++){
                    let _ = C[I], D = m(_);
                    typeof _ == "number" ? (b.__data[0] = _, n1.bufferSubData(35345, M + P, b.__data)) : _.isMatrix3 ? (b.__data[0] = _.elements[0], b.__data[1] = _.elements[1], b.__data[2] = _.elements[2], b.__data[3] = _.elements[0], b.__data[4] = _.elements[3], b.__data[5] = _.elements[4], b.__data[6] = _.elements[5], b.__data[7] = _.elements[0], b.__data[8] = _.elements[6], b.__data[9] = _.elements[7], b.__data[10] = _.elements[8], b.__data[11] = _.elements[0]) : (_.toArray(b.__data, P), P += D.storage / Float32Array.BYTES_PER_ELEMENT);
                }
                n1.bufferSubData(35345, M, b.__data);
            }
        }
        n1.bindBuffer(35345, null);
    }
    function f(x, v, S) {
        let w = x.value;
        if (S[v] === void 0) {
            if (typeof w == "number") S[v] = w;
            else {
                let A = Array.isArray(w) ? w : [
                    w
                ], T = [];
                for(let b = 0; b < A.length; b++)T.push(A[b].clone());
                S[v] = T;
            }
            return !0;
        } else if (typeof w == "number") {
            if (S[v] !== w) return S[v] = w, !0;
        } else {
            let A = Array.isArray(S[v]) ? S[v] : [
                S[v]
            ], T = Array.isArray(w) ? w : [
                w
            ];
            for(let b = 0; b < A.length; b++){
                let M = A[b];
                if (M.equals(T[b]) === !1) return M.copy(T[b]), !0;
            }
        }
        return !1;
    }
    function p(x) {
        let v = x.uniforms, S = 0, w = 16, A = 0;
        for(let T = 0, b = v.length; T < b; T++){
            let M = v[T], C = {
                boundary: 0,
                storage: 0
            }, P = Array.isArray(M.value) ? M.value : [
                M.value
            ];
            for(let I = 0, _ = P.length; I < _; I++){
                let D = P[I], L = m(D);
                C.boundary += L.boundary, C.storage += L.storage;
            }
            if (M.__data = new Float32Array(C.storage / Float32Array.BYTES_PER_ELEMENT), M.__offset = S, T > 0) {
                A = S % w;
                let I = w - A;
                A !== 0 && I - C.boundary < 0 && (S += w - A, M.__offset = S);
            }
            S += C.storage;
        }
        return A = S % w, A > 0 && (S += w - A), x.__size = S, x.__cache = {}, this;
    }
    function m(x) {
        let v = {
            boundary: 0,
            storage: 0
        };
        return typeof x == "number" ? (v.boundary = 4, v.storage = 4) : x.isVector2 ? (v.boundary = 8, v.storage = 8) : x.isVector3 || x.isColor ? (v.boundary = 16, v.storage = 12) : x.isVector4 ? (v.boundary = 16, v.storage = 16) : x.isMatrix3 ? (v.boundary = 48, v.storage = 48) : x.isMatrix4 ? (v.boundary = 64, v.storage = 64) : x.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", x), v;
    }
    function g(x) {
        let v = x.target;
        v.removeEventListener("dispose", g);
        let S = o.indexOf(v.__bindingPointIndex);
        o.splice(S, 1), n1.deleteBuffer(i[v.id]), delete i[v.id], delete s[v.id];
    }
    function y() {
        for(let x in i)n1.deleteBuffer(i[x]);
        o = [], i = {}, s = {};
    }
    return {
        bind: l,
        update: c,
        dispose: y
    };
}
function y4() {
    let n1 = hp("canvas");
    return n1.style.display = "block", n1;
}
function zw(n1 = {}) {
    this.isWebGLRenderer = !0;
    let t = n1.canvas !== void 0 ? n1.canvas : y4(), e = n1.context !== void 0 ? n1.context : null, r = n1.depth !== void 0 ? n1.depth : !0, i = n1.stencil !== void 0 ? n1.stencil : !0, s = n1.antialias !== void 0 ? n1.antialias : !1, o = n1.premultipliedAlpha !== void 0 ? n1.premultipliedAlpha : !0, a = n1.preserveDrawingBuffer !== void 0 ? n1.preserveDrawingBuffer : !1, l = n1.powerPreference !== void 0 ? n1.powerPreference : "default", c = n1.failIfMajorPerformanceCaveat !== void 0 ? n1.failIfMajorPerformanceCaveat : !1, u;
    e !== null ? u = e.getContextAttributes().alpha : u = n1.alpha !== void 0 ? n1.alpha : !1;
    let h = null, d = null, f = [], p = [];
    this.domElement = t, this.debug = {
        checkShaderErrors: !0
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = mn, this.physicallyCorrectLights = !1, this.toneMapping = Os, this.toneMappingExposure = 1;
    let m = this, g = !1, y = 0, x = 0, v = null, S = -1, w = null, A = new Ze, T = new Ze, b = null, M = t.width, C = t.height, P = 1, I = null, _ = null, D = new Ze(0, 0, M, C), L = new Ze(0, 0, M, C), j = !1, V = new fp, H = !1, W = !1, q = null, Q = new ue, G = new k, Z = new E, te = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0
    };
    function $() {
        return v === null ? P : 1;
    }
    let Y = e;
    function oe(z, ce) {
        for(let ve = 0; ve < z.length; ve++){
            let se = z[ve], be = t.getContext(se, ce);
            if (be !== null) return be;
        }
        return null;
    }
    try {
        let z = {
            alpha: !0,
            depth: r,
            stencil: i,
            antialias: s,
            premultipliedAlpha: o,
            preserveDrawingBuffer: a,
            powerPreference: l,
            failIfMajorPerformanceCaveat: c
        };
        if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${ca}`), t.addEventListener("webglcontextlost", et, !1), t.addEventListener("webglcontextrestored", st, !1), t.addEventListener("webglcontextcreationerror", Bt, !1), Y === null) {
            let ce = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (m.isWebGL1Renderer === !0 && ce.shift(), Y = oe(ce, z), Y === null) throw oe(ce) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
        }
        Y.getShaderPrecisionFormat === void 0 && (Y.getShaderPrecisionFormat = function() {
            return {
                rangeMin: 1,
                rangeMax: 1,
                precision: 1
            };
        });
    } catch (z) {
        throw console.error("THREE.WebGLRenderer: " + z.message), z;
    }
    let ie, re, J, Ee, xe, de, De, Ce, ze, Ue, Ve, Oe, Ye, F, N, B, ae, ge, me, Le, Ne, Re, pe, nt;
    function Ge() {
        ie = new Vz(Y), re = new Oz(Y, ie, n1), ie.init(re), Re = new f4(Y, ie, re), J = new h4(Y, ie, re), Ee = new zz, xe = new $G, de = new d4(Y, ie, J, xe, re, Re, Ee), De = new Lz(m), Ce = new Fz(m), ze = new QV(Y, re), pe = new Iz(Y, ie, ze, re), Ue = new kz(Y, ze, Ee, pe), Ve = new Wz(Y, Ue, ze, Ee), me = new Hz(Y, re, de), B = new Rz(xe), Oe = new JG(m, De, Ce, ie, re, pe, B), Ye = new m4(m, xe), F = new t4, N = new a4(ie, re), ge = new _z(m, De, Ce, J, Ve, u, o), ae = new u4(m, Ve, re), nt = new g4(Y, Ee, re, J), Le = new Dz(Y, ie, Ee, re), Ne = new Uz(Y, ie, Ee, re), Ee.programs = Oe.programs, m.capabilities = re, m.extensions = ie, m.properties = xe, m.renderLists = F, m.shadowMap = ae, m.state = J, m.info = Ee;
    }
    Ge();
    let Be = new mw(m, Y);
    this.xr = Be, this.getContext = function() {
        return Y;
    }, this.getContextAttributes = function() {
        return Y.getContextAttributes();
    }, this.forceContextLoss = function() {
        let z = ie.get("WEBGL_lose_context");
        z && z.loseContext();
    }, this.forceContextRestore = function() {
        let z = ie.get("WEBGL_lose_context");
        z && z.restoreContext();
    }, this.getPixelRatio = function() {
        return P;
    }, this.setPixelRatio = function(z) {
        z !== void 0 && (P = z, this.setSize(M, C, !1));
    }, this.getSize = function(z) {
        return z.set(M, C);
    }, this.setSize = function(z, ce, ve) {
        if (Be.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        M = z, C = ce, t.width = Math.floor(z * P), t.height = Math.floor(ce * P), ve !== !1 && (t.style.width = z + "px", t.style.height = ce + "px"), this.setViewport(0, 0, z, ce);
    }, this.getDrawingBufferSize = function(z) {
        return z.set(M * P, C * P).floor();
    }, this.setDrawingBufferSize = function(z, ce, ve) {
        M = z, C = ce, P = ve, t.width = Math.floor(z * ve), t.height = Math.floor(ce * ve), this.setViewport(0, 0, z, ce);
    }, this.getCurrentViewport = function(z) {
        return z.copy(A);
    }, this.getViewport = function(z) {
        return z.copy(D);
    }, this.setViewport = function(z, ce, ve, se) {
        z.isVector4 ? D.set(z.x, z.y, z.z, z.w) : D.set(z, ce, ve, se), J.viewport(A.copy(D).multiplyScalar(P).floor());
    }, this.getScissor = function(z) {
        return z.copy(L);
    }, this.setScissor = function(z, ce, ve, se) {
        z.isVector4 ? L.set(z.x, z.y, z.z, z.w) : L.set(z, ce, ve, se), J.scissor(T.copy(L).multiplyScalar(P).floor());
    }, this.getScissorTest = function() {
        return j;
    }, this.setScissorTest = function(z) {
        J.setScissorTest(j = z);
    }, this.setOpaqueSort = function(z) {
        I = z;
    }, this.setTransparentSort = function(z) {
        _ = z;
    }, this.getClearColor = function(z) {
        return z.copy(ge.getClearColor());
    }, this.setClearColor = function() {
        ge.setClearColor.apply(ge, arguments);
    }, this.getClearAlpha = function() {
        return ge.getClearAlpha();
    }, this.setClearAlpha = function() {
        ge.setClearAlpha.apply(ge, arguments);
    }, this.clear = function(z = !0, ce = !0, ve = !0) {
        let se = 0;
        z && (se |= 16384), ce && (se |= 256), ve && (se |= 1024), Y.clear(se);
    }, this.clearColor = function() {
        this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
        this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
        this.clear(!1, !1, !0);
    }, this.dispose = function() {
        t.removeEventListener("webglcontextlost", et, !1), t.removeEventListener("webglcontextrestored", st, !1), t.removeEventListener("webglcontextcreationerror", Bt, !1), F.dispose(), N.dispose(), xe.dispose(), De.dispose(), Ce.dispose(), Ve.dispose(), pe.dispose(), nt.dispose(), Oe.dispose(), Be.dispose(), Be.removeEventListener("sessionstart", je), Be.removeEventListener("sessionend", He), q && (q.dispose(), q = null), _t.stop();
    };
    function et(z) {
        z.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
    }
    function st() {
        console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
        let z = Ee.autoReset, ce = ae.enabled, ve = ae.autoUpdate, se = ae.needsUpdate, be = ae.type;
        Ge(), Ee.autoReset = z, ae.enabled = ce, ae.autoUpdate = ve, ae.needsUpdate = se, ae.type = be;
    }
    function Bt(z) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", z.statusMessage);
    }
    function dr(z) {
        let ce = z.target;
        ce.removeEventListener("dispose", dr), Tr(ce);
    }
    function Tr(z) {
        K(z), xe.remove(z);
    }
    function K(z) {
        let ce = xe.get(z).programs;
        ce !== void 0 && (ce.forEach(function(ve) {
            Oe.releaseProgram(ve);
        }), z.isShaderMaterial && Oe.releaseShaderCache(z));
    }
    this.renderBufferDirect = function(z, ce, ve, se, be, ct) {
        ce === null && (ce = te);
        let mt = be.isMesh && be.matrixWorld.determinant() < 0, At = cS(z, ce, ve, se, be);
        J.setMaterial(se, mt);
        let Ct = ve.index, Ht = 1;
        se.wireframe === !0 && (Ct = Ue.getWireframeAttribute(ve), Ht = 2);
        let Nt = ve.drawRange, It = ve.attributes.position, Ft = Nt.start * Ht, tn = (Nt.start + Nt.count) * Ht;
        ct !== null && (Ft = Math.max(Ft, ct.start * Ht), tn = Math.min(tn, (ct.start + ct.count) * Ht)), Ct !== null ? (Ft = Math.max(Ft, 0), tn = Math.min(tn, Ct.count)) : It != null && (Ft = Math.max(Ft, 0), tn = Math.min(tn, It.count));
        let rn = tn - Ft;
        if (rn < 0 || rn === 1 / 0) return;
        pe.setup(be, se, At, ve, Ct);
        let lo, gt = Le;
        if (Ct !== null && (lo = ze.get(Ct), gt = Ne, gt.setIndex(lo)), be.isMesh) se.wireframe === !0 ? (J.setLineWidth(se.wireframeLinewidth * $()), gt.setMode(1)) : gt.setMode(4);
        else if (be.isLine) {
            let Rt = se.linewidth;
            Rt === void 0 && (Rt = 1), J.setLineWidth(Rt * $()), be.isLineSegments ? gt.setMode(1) : be.isLineLoop ? gt.setMode(2) : gt.setMode(3);
        } else be.isPoints ? gt.setMode(0) : be.isSprite && gt.setMode(4);
        if (be.isInstancedMesh) gt.renderInstances(Ft, rn, be.count);
        else if (ve.isInstancedBufferGeometry) {
            let Rt = ve._maxInstanceCount !== void 0 ? ve._maxInstanceCount : 1 / 0, uu = Math.min(ve.instanceCount, Rt);
            gt.renderInstances(Ft, rn, uu);
        } else gt.render(Ft, rn);
    }, this.compile = function(z, ce) {
        function ve(se, be, ct) {
            se.transparent === !0 && se.side === fi && se.forceSinglePass === !1 ? (se.side = pi, se.needsUpdate = !0, Mn(se, be, ct), se.side = Hn, se.needsUpdate = !0, Mn(se, be, ct), se.side = fi) : Mn(se, be, ct);
        }
        d = N.get(z), d.init(), p.push(d), z.traverseVisible(function(se) {
            se.isLight && se.layers.test(ce.layers) && (d.pushLight(se), se.castShadow && d.pushShadow(se));
        }), d.setupLights(m.physicallyCorrectLights), z.traverse(function(se) {
            let be = se.material;
            if (be) {
                if (Array.isArray(be)) for(let ct = 0; ct < be.length; ct++){
                    let mt = be[ct];
                    ve(mt, z, se);
                }
                else ve(be, z, se);
            }
        }), p.pop(), d = null;
    };
    let ye = null;
    function Me(z) {
        ye && ye(z);
    }
    function je() {
        _t.stop();
    }
    function He() {
        _t.start();
    }
    let _t = new hP;
    _t.setAnimationLoop(Me), typeof self < "u" && _t.setContext(self), this.setAnimationLoop = function(z) {
        ye = z, Be.setAnimationLoop(z), z === null ? _t.stop() : _t.start();
    }, Be.addEventListener("sessionstart", je), Be.addEventListener("sessionend", He), this.render = function(z, ce) {
        if (ce !== void 0 && ce.isCamera !== !0) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (g === !0) return;
        z.matrixWorldAutoUpdate === !0 && z.updateMatrixWorld(), ce.parent === null && ce.matrixWorldAutoUpdate === !0 && ce.updateMatrixWorld(), Be.enabled === !0 && Be.isPresenting === !0 && (Be.cameraAutoUpdate === !0 && Be.updateCamera(ce), ce = Be.getCamera()), z.isScene === !0 && z.onBeforeRender(m, z, ce, v), d = N.get(z, p.length), d.init(), p.push(d), Q.multiplyMatrices(ce.projectionMatrix, ce.matrixWorldInverse), V.setFromProjectionMatrix(Q), W = this.localClippingEnabled, H = B.init(this.clippingPlanes, W), h = F.get(z, f.length), h.init(), f.push(h), Fr(z, ce, 0, m.sortObjects), h.finish(), m.sortObjects === !0 && h.sort(I, _), H === !0 && B.beginShadows();
        let ve = d.state.shadowsArray;
        if (ae.render(ve, z, ce), H === !0 && B.endShadows(), this.info.autoReset === !0 && this.info.reset(), ge.render(h, z), d.setupLights(m.physicallyCorrectLights), ce.isArrayCamera) {
            let se = ce.cameras;
            for(let be = 0, ct = se.length; be < ct; be++){
                let mt = se[be];
                Vr(h, z, mt, mt.viewport);
            }
        } else Vr(h, z, ce);
        v !== null && (de.updateMultisampleRenderTarget(v), de.updateRenderTargetMipmap(v)), z.isScene === !0 && z.onAfterRender(m, z, ce), pe.resetDefaultState(), S = -1, w = null, p.pop(), p.length > 0 ? d = p[p.length - 1] : d = null, f.pop(), f.length > 0 ? h = f[f.length - 1] : h = null;
    };
    function Fr(z, ce, ve, se) {
        if (z.visible === !1) return;
        if (z.layers.test(ce.layers)) {
            if (z.isGroup) ve = z.renderOrder;
            else if (z.isLOD) z.autoUpdate === !0 && z.update(ce);
            else if (z.isLight) d.pushLight(z), z.castShadow && d.pushShadow(z);
            else if (z.isSprite) {
                if (!z.frustumCulled || V.intersectsSprite(z)) {
                    se && Z.setFromMatrixPosition(z.matrixWorld).applyMatrix4(Q);
                    let mt = Ve.update(z), At = z.material;
                    At.visible && h.push(z, mt, At, ve, Z.z, null);
                }
            } else if ((z.isMesh || z.isLine || z.isPoints) && (z.isSkinnedMesh && z.skeleton.frame !== Ee.render.frame && (z.skeleton.update(), z.skeleton.frame = Ee.render.frame), !z.frustumCulled || V.intersectsObject(z))) {
                se && Z.setFromMatrixPosition(z.matrixWorld).applyMatrix4(Q);
                let mt = Ve.update(z), At = z.material;
                if (Array.isArray(At)) {
                    let Ct = mt.groups;
                    for(let Ht = 0, Nt = Ct.length; Ht < Nt; Ht++){
                        let It = Ct[Ht], Ft = At[It.materialIndex];
                        Ft && Ft.visible && h.push(z, mt, Ft, ve, Z.z, It);
                    }
                } else At.visible && h.push(z, mt, At, ve, Z.z, null);
            }
        }
        let ct = z.children;
        for(let mt = 0, At = ct.length; mt < At; mt++)Fr(ct[mt], ce, ve, se);
    }
    function Vr(z, ce, ve, se) {
        let be = z.opaque, ct = z.transmissive, mt = z.transparent;
        d.setupLightsView(ve), H === !0 && B.setGlobalState(m.clippingPlanes, ve), ct.length > 0 && $o(be, ce, ve), se && J.viewport(A.copy(se)), be.length > 0 && Mr(be, ce, ve), ct.length > 0 && Mr(ct, ce, ve), mt.length > 0 && Mr(mt, ce, ve), J.buffers.depth.setTest(!0), J.buffers.depth.setMask(!0), J.buffers.color.setMask(!0), J.setPolygonOffset(!1);
    }
    function $o(z, ce, ve) {
        let se = re.isWebGL2;
        q === null && (q = new dt(1, 1, {
            generateMipmaps: !0,
            type: ie.has("EXT_color_buffer_half_float") ? Wn : _r,
            minFilter: yc,
            samples: se && s === !0 ? 4 : 0
        })), m.getDrawingBufferSize(G), se ? q.setSize(G.x, G.y) : q.setSize(oy(G.x), oy(G.y));
        let be = m.getRenderTarget();
        m.setRenderTarget(q), m.clear();
        let ct = m.toneMapping;
        m.toneMapping = Os, Mr(z, ce, ve), m.toneMapping = ct, de.updateMultisampleRenderTarget(q), de.updateRenderTargetMipmap(q), m.setRenderTarget(be);
    }
    function Mr(z, ce, ve) {
        let se = ce.isScene === !0 ? ce.overrideMaterial : null;
        for(let be = 0, ct = z.length; be < ct; be++){
            let mt = z[be], At = mt.object, Ct = mt.geometry, Ht = se === null ? mt.material : se, Nt = mt.group;
            At.layers.test(ve.layers) && es(At, ce, ve, Ct, Ht, Nt);
        }
    }
    function es(z, ce, ve, se, be, ct) {
        z.onBeforeRender(m, ce, ve, se, be, ct), z.modelViewMatrix.multiplyMatrices(ve.matrixWorldInverse, z.matrixWorld), z.normalMatrix.getNormalMatrix(z.modelViewMatrix), be.onBeforeRender(m, ce, ve, se, z, ct), be.transparent === !0 && be.side === fi && be.forceSinglePass === !1 ? (be.side = pi, be.needsUpdate = !0, m.renderBufferDirect(ve, ce, se, be, z, ct), be.side = Hn, be.needsUpdate = !0, m.renderBufferDirect(ve, ce, se, be, z, ct), be.side = fi) : m.renderBufferDirect(ve, ce, se, be, z, ct), z.onAfterRender(m, ce, ve, se, be, ct);
    }
    function Mn(z, ce, ve) {
        ce.isScene !== !0 && (ce = te);
        let se = xe.get(z), be = d.state.lights, ct = d.state.shadowsArray, mt = be.state.version, At = Oe.getParameters(z, be.state, ct, ce, ve), Ct = Oe.getProgramCacheKey(At), Ht = se.programs;
        se.environment = z.isMeshStandardMaterial ? ce.environment : null, se.fog = ce.fog, se.envMap = (z.isMeshStandardMaterial ? Ce : De).get(z.envMap || se.environment), Ht === void 0 && (z.addEventListener("dispose", dr), Ht = new Map, se.programs = Ht);
        let Nt = Ht.get(Ct);
        if (Nt !== void 0) {
            if (se.currentProgram === Nt && se.lightsStateVersion === mt) return qf(z, At), Nt;
        } else At.uniforms = Oe.getUniforms(z), z.onBuild(ve, At, m), z.onBeforeCompile(At, m), Nt = Oe.acquireProgram(At, Ct), Ht.set(Ct, Nt), se.uniforms = At.uniforms;
        let It = se.uniforms;
        (!z.isShaderMaterial && !z.isRawShaderMaterial || z.clipping === !0) && (It.clippingPlanes = B.uniform), qf(z, At), se.needsLights = hS(z), se.lightsStateVersion = mt, se.needsLights && (It.ambientLightColor.value = be.state.ambient, It.lightProbe.value = be.state.probe, It.directionalLights.value = be.state.directional, It.directionalLightShadows.value = be.state.directionalShadow, It.spotLights.value = be.state.spot, It.spotLightShadows.value = be.state.spotShadow, It.rectAreaLights.value = be.state.rectArea, It.ltc_1.value = be.state.rectAreaLTC1, It.ltc_2.value = be.state.rectAreaLTC2, It.pointLights.value = be.state.point, It.pointLightShadows.value = be.state.pointShadow, It.hemisphereLights.value = be.state.hemi, It.directionalShadowMap.value = be.state.directionalShadowMap, It.directionalShadowMatrix.value = be.state.directionalShadowMatrix, It.spotShadowMap.value = be.state.spotShadowMap, It.spotLightMatrix.value = be.state.spotLightMatrix, It.spotLightMap.value = be.state.spotLightMap, It.pointShadowMap.value = be.state.pointShadowMap, It.pointShadowMatrix.value = be.state.pointShadowMatrix);
        let Ft = Nt.getUniforms(), tn = Ru.seqWithValue(Ft.seq, It);
        return se.currentProgram = Nt, se.uniformsList = tn, Nt;
    }
    function qf(z, ce) {
        let ve = xe.get(z);
        ve.outputEncoding = ce.outputEncoding, ve.instancing = ce.instancing, ve.skinning = ce.skinning, ve.morphTargets = ce.morphTargets, ve.morphNormals = ce.morphNormals, ve.morphColors = ce.morphColors, ve.morphTargetsCount = ce.morphTargetsCount, ve.numClippingPlanes = ce.numClippingPlanes, ve.numIntersection = ce.numClipIntersection, ve.vertexAlphas = ce.vertexAlphas, ve.vertexTangents = ce.vertexTangents, ve.toneMapping = ce.toneMapping;
    }
    function cS(z, ce, ve, se, be) {
        ce.isScene !== !0 && (ce = te), de.resetTextureUnits();
        let ct = ce.fog, mt = se.isMeshStandardMaterial ? ce.environment : null, At = v === null ? m.outputEncoding : v.isXRRenderTarget === !0 ? v.texture.encoding : mn, Ct = (se.isMeshStandardMaterial ? Ce : De).get(se.envMap || mt), Ht = se.vertexColors === !0 && !!ve.attributes.color && ve.attributes.color.itemSize === 4, Nt = !!se.normalMap && !!ve.attributes.tangent, It = !!ve.morphAttributes.position, Ft = !!ve.morphAttributes.normal, tn = !!ve.morphAttributes.color, rn = se.toneMapped ? m.toneMapping : Os, lo = ve.morphAttributes.position || ve.morphAttributes.normal || ve.morphAttributes.color, gt = lo !== void 0 ? lo.length : 0, Rt = xe.get(se), uu = d.state.lights;
        if (H === !0 && (W === !0 || z !== w)) {
            let ui = z === w && se.id === S;
            B.setState(se, z, ui);
        }
        let ci = !1;
        se.version === Rt.__version ? (Rt.needsLights && Rt.lightsStateVersion !== uu.state.version || Rt.outputEncoding !== At || be.isInstancedMesh && Rt.instancing === !1 || !be.isInstancedMesh && Rt.instancing === !0 || be.isSkinnedMesh && Rt.skinning === !1 || !be.isSkinnedMesh && Rt.skinning === !0 || Rt.envMap !== Ct || se.fog === !0 && Rt.fog !== ct || Rt.numClippingPlanes !== void 0 && (Rt.numClippingPlanes !== B.numPlanes || Rt.numIntersection !== B.numIntersection) || Rt.vertexAlphas !== Ht || Rt.vertexTangents !== Nt || Rt.morphTargets !== It || Rt.morphNormals !== Ft || Rt.morphColors !== tn || Rt.toneMapping !== rn || re.isWebGL2 === !0 && Rt.morphTargetsCount !== gt) && (ci = !0) : (ci = !0, Rt.__version = se.version);
        let co = Rt.currentProgram;
        ci === !0 && (co = Mn(se, ce, be));
        let hu = !1, zn = !1, Et = !1, Si = co.getUniforms(), ts = Rt.uniforms;
        if (J.useProgram(co.program) && (hu = !0, zn = !0, Et = !0), se.id !== S && (S = se.id, zn = !0), hu || w !== z) {
            if (Si.setValue(Y, "projectionMatrix", z.projectionMatrix), re.logarithmicDepthBuffer && Si.setValue(Y, "logDepthBufFC", 2 / (Math.log(z.far + 1) / Math.LN2)), w !== z && (w = z, zn = !0, Et = !0), se.isShaderMaterial || se.isMeshPhongMaterial || se.isMeshToonMaterial || se.isMeshStandardMaterial || se.envMap) {
                let ui = Si.map.cameraPosition;
                ui !== void 0 && ui.setValue(Y, Z.setFromMatrixPosition(z.matrixWorld));
            }
            (se.isMeshPhongMaterial || se.isMeshToonMaterial || se.isMeshLambertMaterial || se.isMeshBasicMaterial || se.isMeshStandardMaterial || se.isShaderMaterial) && Si.setValue(Y, "isOrthographic", z.isOrthographicCamera === !0), (se.isMeshPhongMaterial || se.isMeshToonMaterial || se.isMeshLambertMaterial || se.isMeshBasicMaterial || se.isMeshStandardMaterial || se.isShaderMaterial || se.isShadowMaterial || be.isSkinnedMesh) && Si.setValue(Y, "viewMatrix", z.matrixWorldInverse);
        }
        if (be.isSkinnedMesh) {
            Si.setOptional(Y, be, "bindMatrix"), Si.setOptional(Y, be, "bindMatrixInverse");
            let ui = be.skeleton;
            ui && (re.floatVertexTextures ? (ui.boneTexture === null && ui.computeBoneTexture(), Si.setValue(Y, "boneTexture", ui.boneTexture, de), Si.setValue(Y, "boneTextureSize", ui.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
        }
        let du = ve.morphAttributes;
        if ((du.position !== void 0 || du.normal !== void 0 || du.color !== void 0 && re.isWebGL2 === !0) && me.update(be, ve, se, co), (zn || Rt.receiveShadow !== be.receiveShadow) && (Rt.receiveShadow = be.receiveShadow, Si.setValue(Y, "receiveShadow", be.receiveShadow)), se.isMeshGouraudMaterial && se.envMap !== null && (ts.envMap.value = Ct, ts.flipEnvMap.value = Ct.isCubeTexture && Ct.isRenderTargetTexture === !1 ? -1 : 1), zn && (Si.setValue(Y, "toneMappingExposure", m.toneMappingExposure), Rt.needsLights && uS(ts, Et), ct && se.fog === !0 && Ye.refreshFogUniforms(ts, ct), Ye.refreshMaterialUniforms(ts, se, P, C, q), Ru.upload(Y, Rt.uniformsList, ts, de)), se.isShaderMaterial && se.uniformsNeedUpdate === !0 && (Ru.upload(Y, Rt.uniformsList, ts, de), se.uniformsNeedUpdate = !1), se.isSpriteMaterial && Si.setValue(Y, "center", be.center), Si.setValue(Y, "modelViewMatrix", be.modelViewMatrix), Si.setValue(Y, "normalMatrix", be.normalMatrix), Si.setValue(Y, "modelMatrix", be.matrixWorld), be.previousModelViewMatrix && Si.setValue(Y, "previousModelViewMatrix", be.previousModelViewMatrix), z.previousProjectionMatrix && Si.setValue(Y, "previousProjectionMatrix", z.previousProjectionMatrix), se.isShaderMaterial || se.isRawShaderMaterial) {
            let ui = se.uniformsGroups;
            for(let O = 0, R = ui.length; O < R; O++)if (re.isWebGL2) {
                let X = ui[O];
                nt.update(X, co), nt.bind(X, co);
            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
        }
        return co;
    }
    function uS(z, ce) {
        z.ambientLightColor.needsUpdate = ce, z.lightProbe.needsUpdate = ce, z.directionalLights.needsUpdate = ce, z.directionalLightShadows.needsUpdate = ce, z.pointLights.needsUpdate = ce, z.pointLightShadows.needsUpdate = ce, z.spotLights.needsUpdate = ce, z.spotLightShadows.needsUpdate = ce, z.rectAreaLights.needsUpdate = ce, z.hemisphereLights.needsUpdate = ce;
    }
    function hS(z) {
        return z.isMeshLambertMaterial || z.isMeshToonMaterial || z.isMeshPhongMaterial || z.isMeshStandardMaterial || z.isShadowMaterial || z.isShaderMaterial && z.lights === !0;
    }
    this.getActiveCubeFace = function() {
        return y;
    }, this.getActiveMipmapLevel = function() {
        return x;
    }, this.getRenderTarget = function() {
        return v;
    }, this.setRenderTargetTextures = function(z, ce, ve) {
        xe.get(z.texture).__webglTexture = ce, xe.get(z.depthTexture).__webglTexture = ve;
        let se = xe.get(z);
        se.__hasExternalTextures = !0, se.__hasExternalTextures && (se.__autoAllocateDepthBuffer = ve === void 0, se.__autoAllocateDepthBuffer || ie.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), se.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(z, ce) {
        let ve = xe.get(z);
        ve.__webglFramebuffer = ce, ve.__useDefaultFramebuffer = ce === void 0;
    }, this.setRenderTarget = function(z, ce = 0, ve = 0) {
        v = z, y = ce, x = ve;
        let se = !0, be = null, ct = !1, mt = !1;
        if (z) {
            let Ct = xe.get(z);
            Ct.__useDefaultFramebuffer !== void 0 ? (J.bindFramebuffer(36160, null), se = !1) : Ct.__webglFramebuffer === void 0 ? de.setupRenderTarget(z) : Ct.__hasExternalTextures && de.rebindTextures(z, xe.get(z.texture).__webglTexture, xe.get(z.depthTexture).__webglTexture);
            let Ht = z.texture;
            (Ht.isData3DTexture || Ht.isDataArrayTexture || Ht.isCompressedArrayTexture) && (mt = !0);
            let Nt = xe.get(z).__webglFramebuffer;
            z.isWebGLCubeRenderTarget ? (be = Nt[ce], ct = !0) : re.isWebGL2 && z.samples > 0 && de.useMultisampledRTT(z) === !1 ? be = xe.get(z).__webglMultisampledFramebuffer : be = Nt, A.copy(z.viewport), T.copy(z.scissor), b = z.scissorTest;
        } else A.copy(D).multiplyScalar(P).floor(), T.copy(L).multiplyScalar(P).floor(), b = j;
        if (J.bindFramebuffer(36160, be) && re.drawBuffers && se && J.drawBuffers(z, be), J.viewport(A), J.scissor(T), J.setScissorTest(b), ct) {
            let Ct = xe.get(z.texture);
            Y.framebufferTexture2D(36160, 36064, 34069 + ce, Ct.__webglTexture, ve);
        } else if (mt) {
            let Ct = xe.get(z.texture), Ht = ce || 0;
            Y.framebufferTextureLayer(36160, 36064, Ct.__webglTexture, ve || 0, Ht);
        }
        S = -1;
    }, this.readRenderTargetPixels = function(z, ce, ve, se, be, ct, mt) {
        if (!(z && z.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let At = xe.get(z).__webglFramebuffer;
        if (z.isWebGLCubeRenderTarget && mt !== void 0 && (At = At[mt]), At) {
            J.bindFramebuffer(36160, At);
            try {
                let Ct = z.texture, Ht = Ct.format, Nt = Ct.type;
                if (Ht !== qr && Re.convert(Ht) !== Y.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                let It = Nt === Wn && (ie.has("EXT_color_buffer_half_float") || re.isWebGL2 && ie.has("EXT_color_buffer_float"));
                if (Nt !== _r && Re.convert(Nt) !== Y.getParameter(35738) && !(Nt === br && (re.isWebGL2 || ie.has("OES_texture_float") || ie.has("WEBGL_color_buffer_float"))) && !It) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                ce >= 0 && ce <= z.width - se && ve >= 0 && ve <= z.height - be && Y.readPixels(ce, ve, se, be, Re.convert(Ht), Re.convert(Nt), ct);
            } finally{
                let Ct = v !== null ? xe.get(v).__webglFramebuffer : null;
                J.bindFramebuffer(36160, Ct);
            }
        }
    }, this.copyFramebufferToTexture = function(z, ce, ve = 0) {
        let se = Math.pow(2, -ve), be = Math.floor(ce.image.width * se), ct = Math.floor(ce.image.height * se);
        de.setTexture2D(ce, 0), Y.copyTexSubImage2D(3553, ve, 0, 0, z.x, z.y, be, ct), J.unbindTexture();
    }, this.copyTextureToTexture = function(z, ce, ve, se = 0) {
        let be = ce.image.width, ct = ce.image.height, mt = Re.convert(ve.format), At = Re.convert(ve.type);
        de.setTexture2D(ve, 0), Y.pixelStorei(37440, ve.flipY), Y.pixelStorei(37441, ve.premultiplyAlpha), Y.pixelStorei(3317, ve.unpackAlignment), ce.isDataTexture ? Y.texSubImage2D(3553, se, z.x, z.y, be, ct, mt, At, ce.image.data) : ce.isCompressedTexture ? Y.compressedTexSubImage2D(3553, se, z.x, z.y, ce.mipmaps[0].width, ce.mipmaps[0].height, mt, ce.mipmaps[0].data) : Y.texSubImage2D(3553, se, z.x, z.y, mt, At, ce.image), se === 0 && ve.generateMipmaps && Y.generateMipmap(3553), J.unbindTexture();
    }, this.copyTextureToTexture3D = function(z, ce, ve, se, be = 0) {
        if (m.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        let ct = z.max.x - z.min.x + 1, mt = z.max.y - z.min.y + 1, At = z.max.z - z.min.z + 1, Ct = Re.convert(se.format), Ht = Re.convert(se.type), Nt;
        if (se.isData3DTexture) de.setTexture3D(se, 0), Nt = 32879;
        else if (se.isDataArrayTexture) de.setTexture2DArray(se, 0), Nt = 35866;
        else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        Y.pixelStorei(37440, se.flipY), Y.pixelStorei(37441, se.premultiplyAlpha), Y.pixelStorei(3317, se.unpackAlignment);
        let It = Y.getParameter(3314), Ft = Y.getParameter(32878), tn = Y.getParameter(3316), rn = Y.getParameter(3315), lo = Y.getParameter(32877), gt = ve.isCompressedTexture ? ve.mipmaps[0] : ve.image;
        Y.pixelStorei(3314, gt.width), Y.pixelStorei(32878, gt.height), Y.pixelStorei(3316, z.min.x), Y.pixelStorei(3315, z.min.y), Y.pixelStorei(32877, z.min.z), ve.isDataTexture || ve.isData3DTexture ? Y.texSubImage3D(Nt, be, ce.x, ce.y, ce.z, ct, mt, At, Ct, Ht, gt.data) : ve.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), Y.compressedTexSubImage3D(Nt, be, ce.x, ce.y, ce.z, ct, mt, At, Ct, gt.data)) : Y.texSubImage3D(Nt, be, ce.x, ce.y, ce.z, ct, mt, At, Ct, Ht, gt), Y.pixelStorei(3314, It), Y.pixelStorei(32878, Ft), Y.pixelStorei(3316, tn), Y.pixelStorei(3315, rn), Y.pixelStorei(32877, lo), be === 0 && se.generateMipmaps && Y.generateMipmap(Nt), J.unbindTexture();
    }, this.initTexture = function(z) {
        z.isCubeTexture ? de.setTextureCube(z, 0) : z.isData3DTexture ? de.setTexture3D(z, 0) : z.isDataArrayTexture || z.isCompressedArrayTexture ? de.setTexture2DArray(z, 0) : de.setTexture2D(z, 0), J.unbindTexture();
    }, this.resetState = function() {
        y = 0, x = 0, v = null, J.reset(), pe.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
var gw = class extends zw {
};
gw.prototype.isWebGL1Renderer = !0;
var Nu = class {
    constructor(t, e = 1, r = 1e3){
        this.isFog = !0, this.name = "", this.color = new We(t), this.near = e, this.far = r;
    }
    clone() {
        return new Nu(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}, ei = class extends Tt {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(t, e) {
        return super.copy(t, e), t.background !== null && (this.background = t.background.clone()), t.environment !== null && (this.environment = t.environment.clone()), t.fog !== null && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, t.overrideMaterial !== null && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return this.fog !== null && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (e.object.backgroundIntensity = this.backgroundIntensity), e;
    }
    get autoUpdate() {
        return console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate;
    }
    set autoUpdate(t) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate = t;
    }
}, py = class {
    constructor(t, e){
        this.isInterleavedBuffer = !0, this.array = t, this.stride = e, this.count = t !== void 0 ? t.length / e : 0, this.usage = rw, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0, this.uuid = is();
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
    copyAt(t, e, r) {
        t *= this.stride, r *= e.stride;
        for(let i = 0, s = this.stride; i < s; i++)this.array[t + i] = e.array[r + i];
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    clone(t) {
        t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = is()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        let e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), r = new this.constructor(e, this.stride);
        return r.setUsage(this.usage), r;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    toJSON(t) {
        return t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = is()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}, fn = new E, xc = class {
    constructor(t, e, r, i = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = e, this.offset = r, this.normalized = i;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(t) {
        this.data.needsUpdate = t;
    }
    applyMatrix4(t) {
        for(let e = 0, r = this.data.count; e < r; e++)fn.fromBufferAttribute(this, e), fn.applyMatrix4(t), this.setXYZ(e, fn.x, fn.y, fn.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, r = this.count; e < r; e++)fn.fromBufferAttribute(this, e), fn.applyNormalMatrix(t), this.setXYZ(e, fn.x, fn.y, fn.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, r = this.count; e < r; e++)fn.fromBufferAttribute(this, e), fn.transformDirection(t), this.setXYZ(e, fn.x, fn.y, fn.z);
        return this;
    }
    setX(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.data.array[t * this.data.stride + this.offset] = e, this;
    }
    setY(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
    setZ(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
    setW(t, e) {
        return this.normalized && (e = xr(e, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
    getX(t) {
        let e = this.data.array[t * this.data.stride + this.offset];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    getY(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 1];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    getZ(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 2];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    getW(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 3];
        return this.normalized && (e = aa(e, this.array)), e;
    }
    setXY(t, e, r) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = xr(e, this.array), r = xr(r, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this;
    }
    setXYZ(t, e, r, i) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = xr(e, this.array), r = xr(r, this.array), i = xr(i, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this.data.array[t + 2] = i, this;
    }
    setXYZW(t, e, r, i, s) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = xr(e, this.array), r = xr(r, this.array), i = xr(i, this.array), s = xr(s, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this.data.array[t + 2] = i, this.data.array[t + 3] = s, this;
    }
    clone(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let r = 0; r < this.count; r++){
                let i = r * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)e.push(this.data.array[i + s]);
            }
            return new Xe(new this.array.constructor(e), this.itemSize, this.normalized);
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new xc(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let r = 0; r < this.count; r++){
                let i = r * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)e.push(this.data.array[i + s]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: e,
                normalized: this.normalized
            };
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
};
var mp = class extends Tt {
    constructor(){
        super(), this.isBone = !0, this.type = "Bone";
    }
}, gi = class extends er {
    constructor(t = null, e = 1, r = 1, i, s, o, a, l, c = Vt, u = Vt, h, d){
        super(null, o, a, l, c, u, i, s, h, d), this.isDataTexture = !0, this.image = {
            data: t,
            width: e,
            height: r
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}, OC = new ue, v4 = new ue, il = class {
    constructor(t = [], e = []){
        this.uuid = is(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
    }
    init() {
        let t = this.bones, e = this.boneInverses;
        if (this.boneMatrices = new Float32Array(t.length * 16), e.length === 0) this.calculateInverses();
        else if (t.length !== e.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
            for(let r = 0, i = this.bones.length; r < i; r++)this.boneInverses.push(new ue);
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = new ue;
            this.bones[t] && r.copy(this.bones[t].matrixWorld).invert(), this.boneInverses.push(r);
        }
    }
    pose() {
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = this.bones[t];
            r && r.matrixWorld.copy(this.boneInverses[t]).invert();
        }
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = this.bones[t];
            r && (r.parent && r.parent.isBone ? (r.matrix.copy(r.parent.matrixWorld).invert(), r.matrix.multiply(r.matrixWorld)) : r.matrix.copy(r.matrixWorld), r.matrix.decompose(r.position, r.quaternion, r.scale));
        }
    }
    update() {
        let t = this.bones, e = this.boneInverses, r = this.boneMatrices, i = this.boneTexture;
        for(let s = 0, o = t.length; s < o; s++){
            let a = t[s] ? t[s].matrixWorld : v4;
            OC.multiplyMatrices(a, e[s]), OC.toArray(r, s * 16);
        }
        i !== null && (i.needsUpdate = !0);
    }
    clone() {
        return new il(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        let t = Math.sqrt(this.bones.length * 4);
        t = aP(t), t = Math.max(t, 4);
        let e = new Float32Array(t * t * 4);
        e.set(this.boneMatrices);
        let r = new gi(e, t, t, qr, br);
        return r.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = r, this.boneTextureSize = t, this;
    }
    getBoneByName(t) {
        for(let e = 0, r = this.bones.length; e < r; e++){
            let i = this.bones[e];
            if (i.name === t) return i;
        }
    }
    dispose() {
        this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
    }
    fromJSON(t, e) {
        this.uuid = t.uuid;
        for(let r = 0, i = t.bones.length; r < i; r++){
            let s = t.bones[r], o = e[s];
            o === void 0 && (console.warn("THREE.Skeleton: No bone found with UUID:", s), o = new mp), this.bones.push(o), this.boneInverses.push(new ue().fromArray(t.boneInverses[r]));
        }
        return this.init(), this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        t.uuid = this.uuid;
        let e = this.bones, r = this.boneInverses;
        for(let i = 0, s = e.length; i < s; i++){
            let o = e[i];
            t.bones.push(o.uuid);
            let a = r[i];
            t.boneInverses.push(a.toArray());
        }
        return t;
    }
}, mo = class extends Xe {
    constructor(t, e, r, i = 1){
        super(t, e, r), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
    }
    copy(t) {
        return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
}, RC = new ue, LC = new ue, Yg = [], x4 = new ue, ep = new zt, my = class extends zt {
    constructor(t, e, r){
        super(t, e), this.isInstancedMesh = !0, this.instanceMatrix = new mo(new Float32Array(r * 16), 16), this.instanceColor = null, this.count = r, this.frustumCulled = !1;
        for(let i = 0; i < r; i++)this.setMatrixAt(i, x4);
    }
    copy(t, e) {
        return super.copy(t, e), this.instanceMatrix.copy(t.instanceMatrix), t.instanceColor !== null && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, this;
    }
    getColorAt(t, e) {
        e.fromArray(this.instanceColor.array, t * 3);
    }
    getMatrixAt(t, e) {
        e.fromArray(this.instanceMatrix.array, t * 16);
    }
    raycast(t, e) {
        let r = this.matrixWorld, i = this.count;
        if (ep.geometry = this.geometry, ep.material = this.material, ep.material !== void 0) for(let s = 0; s < i; s++){
            this.getMatrixAt(s, RC), LC.multiplyMatrices(r, RC), ep.matrixWorld = LC, ep.raycast(t, Yg);
            for(let o = 0, a = Yg.length; o < a; o++){
                let l = Yg[o];
                l.instanceId = s, l.object = this, e.push(l);
            }
            Yg.length = 0;
        }
    }
    setColorAt(t, e) {
        this.instanceColor === null && (this.instanceColor = new mo(new Float32Array(this.instanceMatrix.count * 3), 3)), e.toArray(this.instanceColor.array, t * 3);
    }
    setMatrixAt(t, e) {
        e.toArray(this.instanceMatrix.array, t * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, ss = class extends vc {
    constructor(t){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new We(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
    }
}, BC = new E, NC = new E, FC = new ue, qS = new Ls, Xg = new Rr, bc = class extends Tt {
    constructor(t = new _e, e = new ss){
        super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), this.material = t.material, this.geometry = t.geometry, this;
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, r = [
                0
            ];
            for(let i = 1, s = e.count; i < s; i++)BC.fromBufferAttribute(e, i - 1), NC.fromBufferAttribute(e, i), r[i] = r[i - 1], r[i] += BC.distanceTo(NC);
            t.setAttribute("lineDistance", new Te(r, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(t, e) {
        let r = this.geometry, i = this.matrixWorld, s = t.params.Line.threshold, o = r.drawRange;
        if (r.boundingSphere === null && r.computeBoundingSphere(), Xg.copy(r.boundingSphere), Xg.applyMatrix4(i), Xg.radius += s, t.ray.intersectsSphere(Xg) === !1) return;
        FC.copy(i).invert(), qS.copy(t.ray).applyMatrix4(FC);
        let a = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = a * a, c = new E, u = new E, h = new E, d = new E, f = this.isLineSegments ? 2 : 1, p = r.index, g = r.attributes.position;
        if (p !== null) {
            let y = Math.max(0, o.start), x = Math.min(p.count, o.start + o.count);
            for(let v = y, S = x - 1; v < S; v += f){
                let w = p.getX(v), A = p.getX(v + 1);
                if (c.fromBufferAttribute(g, w), u.fromBufferAttribute(g, A), qS.distanceSqToSegment(c, u, d, h) > l) continue;
                d.applyMatrix4(this.matrixWorld);
                let b = t.ray.origin.distanceTo(d);
                b < t.near || b > t.far || e.push({
                    distance: b,
                    point: h.clone().applyMatrix4(this.matrixWorld),
                    index: v,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            let y = Math.max(0, o.start), x = Math.min(g.count, o.start + o.count);
            for(let v = y, S = x - 1; v < S; v += f){
                if (c.fromBufferAttribute(g, v), u.fromBufferAttribute(g, v + 1), qS.distanceSqToSegment(c, u, d, h) > l) continue;
                d.applyMatrix4(this.matrixWorld);
                let A = t.ray.origin.distanceTo(d);
                A < t.near || A > t.far || e.push({
                    distance: A,
                    point: h.clone().applyMatrix4(this.matrixWorld),
                    index: v,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, r = Object.keys(e);
        if (r.length > 0) {
            let i = e[r[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, o = i.length; s < o; s++){
                    let a = i[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s;
                }
            }
        }
    }
}, VC = new E, kC = new E, nl = class extends bc {
    constructor(t, e){
        super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, r = [];
            for(let i = 0, s = e.count; i < s; i += 2)VC.fromBufferAttribute(e, i), kC.fromBufferAttribute(e, i + 1), r[i] = i === 0 ? 0 : r[i - 1], r[i + 1] = r[i] + VC.distanceTo(kC);
            t.setAttribute("lineDistance", new Te(r, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
};
var gy = class extends er {
    constructor(t, e, r, i, s, o, a, l, c){
        super(t, e, r, i, s, o, a, l, c), this.isVideoTexture = !0, this.minFilter = o !== void 0 ? o : rt, this.magFilter = s !== void 0 ? s : rt, this.generateMipmaps = !1;
        let u = this;
        function h() {
            u.needsUpdate = !0, t.requestVideoFrameCallback(h);
        }
        "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(h);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        let t = this.image;
        "requestVideoFrameCallback" in t === !1 && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
};
var yy = class extends er {
    constructor(t, e, r, i, s, o, a, l, c){
        super(t, e, r, i, s, o, a, l, c), this.isCanvasTexture = !0, this.needsUpdate = !0;
    }
}, os = class {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200;
    }
    getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
    getPointAt(t, e) {
        let r = this.getUtoTmapping(t);
        return this.getPoint(r, e);
    }
    getPoints(t = 5) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPoint(r / t));
        return e;
    }
    getSpacedPoints(t = 5) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPointAt(r / t));
        return e;
    }
    getLength() {
        let t = this.getLengths();
        return t[t.length - 1];
    }
    getLengths(t = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        let e = [], r, i = this.getPoint(0), s = 0;
        e.push(0);
        for(let o = 1; o <= t; o++)r = this.getPoint(o / t), s += r.distanceTo(i), e.push(s), i = r;
        return this.cacheArcLengths = e, e;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(t, e) {
        let r = this.getLengths(), i = 0, s = r.length, o;
        e ? o = e : o = t * r[s - 1];
        let a = 0, l = s - 1, c;
        for(; a <= l;)if (i = Math.floor(a + (l - a) / 2), c = r[i] - o, c < 0) a = i + 1;
        else if (c > 0) l = i - 1;
        else {
            l = i;
            break;
        }
        if (i = l, r[i] === o) return i / (s - 1);
        let u = r[i], d = r[i + 1] - u, f = (o - u) / d;
        return (i + f) / (s - 1);
    }
    getTangent(t, e) {
        let i = t - 1e-4, s = t + 1e-4;
        i < 0 && (i = 0), s > 1 && (s = 1);
        let o = this.getPoint(i), a = this.getPoint(s), l = e || (o.isVector2 ? new k : new E);
        return l.copy(a).sub(o).normalize(), l;
    }
    getTangentAt(t, e) {
        let r = this.getUtoTmapping(t);
        return this.getTangent(r, e);
    }
    computeFrenetFrames(t, e) {
        let r = new E, i = [], s = [], o = [], a = new E, l = new ue;
        for(let f = 0; f <= t; f++){
            let p = f / t;
            i[f] = this.getTangentAt(p, new E);
        }
        s[0] = new E, o[0] = new E;
        let c = Number.MAX_VALUE, u = Math.abs(i[0].x), h = Math.abs(i[0].y), d = Math.abs(i[0].z);
        u <= c && (c = u, r.set(1, 0, 0)), h <= c && (c = h, r.set(0, 1, 0)), d <= c && r.set(0, 0, 1), a.crossVectors(i[0], r).normalize(), s[0].crossVectors(i[0], a), o[0].crossVectors(i[0], s[0]);
        for(let f = 1; f <= t; f++){
            if (s[f] = s[f - 1].clone(), o[f] = o[f - 1].clone(), a.crossVectors(i[f - 1], i[f]), a.length() > Number.EPSILON) {
                a.normalize();
                let p = Math.acos(di(i[f - 1].dot(i[f]), -1, 1));
                s[f].applyMatrix4(l.makeRotationAxis(a, p));
            }
            o[f].crossVectors(i[f], s[f]);
        }
        if (e === !0) {
            let f = Math.acos(di(s[0].dot(s[t]), -1, 1));
            f /= t, i[0].dot(a.crossVectors(s[0], s[t])) > 0 && (f = -f);
            for(let p = 1; p <= t; p++)s[p].applyMatrix4(l.makeRotationAxis(i[p], f * p)), o[p].crossVectors(i[p], s[p]);
        }
        return {
            tangents: i,
            normals: s,
            binormals: o
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
    fromJSON(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
}, Sc = class extends os {
    constructor(t = 0, e = 0, r = 1, i = 1, s = 0, o = Math.PI * 2, a = !1, l = 0){
        super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = r, this.yRadius = i, this.aStartAngle = s, this.aEndAngle = o, this.aClockwise = a, this.aRotation = l;
    }
    getPoint(t, e) {
        let r = e || new k, i = Math.PI * 2, s = this.aEndAngle - this.aStartAngle, o = Math.abs(s) < Number.EPSILON;
        for(; s < 0;)s += i;
        for(; s > i;)s -= i;
        s < Number.EPSILON && (o ? s = 0 : s = i), this.aClockwise === !0 && !o && (s === i ? s = -i : s = s - i);
        let a = this.aStartAngle + t * s, l = this.aX + this.xRadius * Math.cos(a), c = this.aY + this.yRadius * Math.sin(a);
        if (this.aRotation !== 0) {
            let u = Math.cos(this.aRotation), h = Math.sin(this.aRotation), d = l - this.aX, f = c - this.aY;
            l = d * u - f * h + this.aX, c = d * h + f * u + this.aY;
        }
        return r.set(l, c);
    }
    copy(t) {
        return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
}, yw = class extends Sc {
    constructor(t, e, r, i, s, o){
        super(t, e, r, r, i, s, o), this.isArcCurve = !0, this.type = "ArcCurve";
    }
};
function Gw() {
    let n1 = 0, t = 0, e = 0, r = 0;
    function i(s, o, a, l) {
        n1 = s, t = a, e = -3 * s + 3 * o - 2 * a - l, r = 2 * s - 2 * o + a + l;
    }
    return {
        initCatmullRom: function(s, o, a, l, c) {
            i(o, a, c * (a - s), c * (l - o));
        },
        initNonuniformCatmullRom: function(s, o, a, l, c, u, h) {
            let d = (o - s) / c - (a - s) / (c + u) + (a - o) / u, f = (a - o) / u - (l - o) / (u + h) + (l - a) / h;
            d *= u, f *= u, i(o, a, d, f);
        },
        calc: function(s) {
            let o = s * s, a = o * s;
            return n1 + t * s + e * o + r * a;
        }
    };
}
var Kg = new E, YS = new Gw, XS = new Gw, KS = new Gw, vw = class extends os {
    constructor(t = [], e = !1, r = "centripetal", i = .5){
        super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = r, this.tension = i;
    }
    getPoint(t, e = new E) {
        let r = e, i = this.points, s = i.length, o = (s - (this.closed ? 0 : 1)) * t, a = Math.floor(o), l = o - a;
        this.closed ? a += a > 0 ? 0 : (Math.floor(Math.abs(a) / s) + 1) * s : l === 0 && a === s - 1 && (a = s - 2, l = 1);
        let c, u;
        this.closed || a > 0 ? c = i[(a - 1) % s] : (Kg.subVectors(i[0], i[1]).add(i[0]), c = Kg);
        let h = i[a % s], d = i[(a + 1) % s];
        if (this.closed || a + 2 < s ? u = i[(a + 2) % s] : (Kg.subVectors(i[s - 1], i[s - 2]).add(i[s - 1]), u = Kg), this.curveType === "centripetal" || this.curveType === "chordal") {
            let f = this.curveType === "chordal" ? .5 : .25, p = Math.pow(c.distanceToSquared(h), f), m = Math.pow(h.distanceToSquared(d), f), g = Math.pow(d.distanceToSquared(u), f);
            m < 1e-4 && (m = 1), p < 1e-4 && (p = m), g < 1e-4 && (g = m), YS.initNonuniformCatmullRom(c.x, h.x, d.x, u.x, p, m, g), XS.initNonuniformCatmullRom(c.y, h.y, d.y, u.y, p, m, g), KS.initNonuniformCatmullRom(c.z, h.z, d.z, u.z, p, m, g);
        } else this.curveType === "catmullrom" && (YS.initCatmullRom(c.x, h.x, d.x, u.x, this.tension), XS.initCatmullRom(c.y, h.y, d.y, u.y, this.tension), KS.initCatmullRom(c.z, h.z, d.z, u.z, this.tension));
        return r.set(YS.calc(l), XS.calc(l), KS.calc(l)), r;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, r = this.points.length; e < r; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(new E().fromArray(i));
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
};
function UC(n1, t, e, r, i) {
    let s = (r - t) * .5, o = (i - e) * .5, a = n1 * n1, l = n1 * a;
    return (2 * e - 2 * r + s + o) * l + (-3 * e + 3 * r - 2 * s - o) * a + s * n1 + e;
}
function b4(n1, t) {
    let e = 1 - n1;
    return e * e * t;
}
function S4(n1, t) {
    return 2 * (1 - n1) * n1 * t;
}
function w4(n1, t) {
    return n1 * n1 * t;
}
function ap(n1, t, e, r) {
    return b4(n1, t) + S4(n1, e) + w4(n1, r);
}
function A4(n1, t) {
    let e = 1 - n1;
    return e * e * e * t;
}
function E4(n1, t) {
    let e = 1 - n1;
    return 3 * e * e * n1 * t;
}
function T4(n1, t) {
    return 3 * (1 - n1) * n1 * n1 * t;
}
function M4(n1, t) {
    return n1 * n1 * n1 * t;
}
function lp(n1, t, e, r, i) {
    return A4(n1, t) + E4(n1, e) + T4(n1, r) + M4(n1, i);
}
var an = class extends os {
    constructor(t = new k, e = new k, r = new k, i = new k){
        super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = i;
    }
    getPoint(t, e = new k) {
        let r = e, i = this.v0, s = this.v1, o = this.v2, a = this.v3;
        return r.set(lp(t, i.x, s.x, o.x, a.x), lp(t, i.y, s.y, o.y, a.y)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, wc = class extends os {
    constructor(t = new E, e = new E, r = new E, i = new E){
        super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = i;
    }
    getPoint(t, e = new E) {
        let r = e, i = this.v0, s = this.v1, o = this.v2, a = this.v3;
        return r.set(lp(t, i.x, s.x, o.x, a.x), lp(t, i.y, s.y, o.y, a.y), lp(t, i.z, s.z, o.z, a.z)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, ln = class extends os {
    constructor(t = new k, e = new k){
        super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new k) {
        let r = e;
        return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    getTangent(t, e) {
        let r = e || new k;
        return r.copy(this.v2).sub(this.v1).normalize(), r;
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, gp = class extends os {
    constructor(t = new E, e = new E){
        super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new E) {
        let r = e;
        return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, Yn = class extends os {
    constructor(t = new k, e = new k, r = new k){
        super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r;
    }
    getPoint(t, e = new k) {
        let r = e, i = this.v0, s = this.v1, o = this.v2;
        return r.set(ap(t, i.x, s.x, o.x), ap(t, i.y, s.y, o.y)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, xw = class extends os {
    constructor(t = new E, e = new E, r = new E){
        super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r;
    }
    getPoint(t, e = new E) {
        let r = e, i = this.v0, s = this.v1, o = this.v2;
        return r.set(ap(t, i.x, s.x, o.x), ap(t, i.y, s.y, o.y), ap(t, i.z, s.z, o.z)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, Fu = class extends os {
    constructor(t = []){
        super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
    }
    getPoint(t, e = new k) {
        let r = e, i = this.points, s = (i.length - 1) * t, o = Math.floor(s), a = s - o, l = i[o === 0 ? o : o - 1], c = i[o], u = i[o > i.length - 2 ? i.length - 1 : o + 1], h = i[o > i.length - 3 ? i.length - 1 : o + 2];
        return r.set(UC(a, l.x, c.x, u.x, h.x), UC(a, l.y, c.y, u.y, h.y)), r;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, r = this.points.length; e < r; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(new k().fromArray(i));
        }
        return this;
    }
}, C4 = Object.freeze({
    __proto__: null,
    ArcCurve: yw,
    CatmullRomCurve3: vw,
    CubicBezierCurve: an,
    CubicBezierCurve3: wc,
    EllipseCurve: Sc,
    LineCurve: ln,
    LineCurve3: gp,
    QuadraticBezierCurve: Yn,
    QuadraticBezierCurve3: xw,
    SplineCurve: Fu
}), yp = class extends os {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t) {
        this.curves.push(t);
    }
    closePath() {
        let t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
        t.equals(e) || this.curves.push(new ln(e, t));
    }
    getPoint(t, e) {
        let r = t * this.getLength(), i = this.getCurveLengths(), s = 0;
        for(; s < i.length;){
            if (i[s] >= r) {
                let o = i[s] - r, a = this.curves[s], l = a.getLength(), c = l === 0 ? 0 : 1 - o / l;
                return a.getPointAt(c, e);
            }
            s++;
        }
        return null;
    }
    getLength() {
        let t = this.getCurveLengths();
        return t[t.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        let t = [], e = 0;
        for(let r = 0, i = this.curves.length; r < i; r++)e += this.curves[r].getLength(), t.push(e);
        return this.cacheLengths = t, t;
    }
    getSpacedPoints(t = 40) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPoint(r / t));
        return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t = 12) {
        let e = [], r;
        for(let i = 0, s = this.curves; i < s.length; i++){
            let o = s[i], a = o.isEllipseCurve ? t * 2 : o.isLineCurve || o.isLineCurve3 ? 1 : o.isSplineCurve ? t * o.points.length : t, l = o.getPoints(a);
            for(let c = 0; c < l.length; c++){
                let u = l[c];
                r && r.equals(u) || (e.push(u), r = u);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
    copy(t) {
        super.copy(t), this.curves = [];
        for(let e = 0, r = t.curves.length; e < r; e++){
            let i = t.curves[e];
            this.curves.push(i.clone());
        }
        return this.autoClose = t.autoClose, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.autoClose = this.autoClose, t.curves = [];
        for(let e = 0, r = this.curves.length; e < r; e++){
            let i = this.curves[e];
            t.curves.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
        for(let e = 0, r = t.curves.length; e < r; e++){
            let i = t.curves[e];
            this.curves.push(new C4[i.type]().fromJSON(i));
        }
        return this;
    }
}, Ac = class extends yp {
    constructor(t){
        super(), this.type = "Path", this.currentPoint = new k, t && this.setFromPoints(t);
    }
    setFromPoints(t) {
        this.moveTo(t[0].x, t[0].y);
        for(let e = 1, r = t.length; e < r; e++)this.lineTo(t[e].x, t[e].y);
        return this;
    }
    moveTo(t, e) {
        return this.currentPoint.set(t, e), this;
    }
    lineTo(t, e) {
        let r = new ln(this.currentPoint.clone(), new k(t, e));
        return this.curves.push(r), this.currentPoint.set(t, e), this;
    }
    quadraticCurveTo(t, e, r, i) {
        let s = new Yn(this.currentPoint.clone(), new k(t, e), new k(r, i));
        return this.curves.push(s), this.currentPoint.set(r, i), this;
    }
    bezierCurveTo(t, e, r, i, s, o) {
        let a = new an(this.currentPoint.clone(), new k(t, e), new k(r, i), new k(s, o));
        return this.curves.push(a), this.currentPoint.set(s, o), this;
    }
    splineThru(t) {
        let e = [
            this.currentPoint.clone()
        ].concat(t), r = new Fu(e);
        return this.curves.push(r), this.currentPoint.copy(t[t.length - 1]), this;
    }
    arc(t, e, r, i, s, o) {
        let a = this.currentPoint.x, l = this.currentPoint.y;
        return this.absarc(t + a, e + l, r, i, s, o), this;
    }
    absarc(t, e, r, i, s, o) {
        return this.absellipse(t, e, r, r, i, s, o), this;
    }
    ellipse(t, e, r, i, s, o, a, l) {
        let c = this.currentPoint.x, u = this.currentPoint.y;
        return this.absellipse(t + c, e + u, r, i, s, o, a, l), this;
    }
    absellipse(t, e, r, i, s, o, a, l) {
        let c = new Sc(t, e, r, i, s, o, a, l);
        if (this.curves.length > 0) {
            let h = c.getPoint(0);
            h.equals(this.currentPoint) || this.lineTo(h.x, h.y);
        }
        this.curves.push(c);
        let u = c.getPoint(1);
        return this.currentPoint.copy(u), this;
    }
    copy(t) {
        return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.currentPoint = this.currentPoint.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
    }
}, Vu = class extends _e {
    constructor(t = [
        new k(0, -0.5),
        new k(.5, 0),
        new k(0, .5)
    ], e = 12, r = 0, i = Math.PI * 2){
        super(), this.type = "LatheGeometry", this.parameters = {
            points: t,
            segments: e,
            phiStart: r,
            phiLength: i
        }, e = Math.floor(e), i = di(i, 0, Math.PI * 2);
        let s = [], o = [], a = [], l = [], c = [], u = 1 / e, h = new E, d = new k, f = new E, p = new E, m = new E, g = 0, y = 0;
        for(let x = 0; x <= t.length - 1; x++)switch(x){
            case 0:
                g = t[x + 1].x - t[x].x, y = t[x + 1].y - t[x].y, f.x = y * 1, f.y = -g, f.z = y * 0, m.copy(f), f.normalize(), l.push(f.x, f.y, f.z);
                break;
            case t.length - 1:
                l.push(m.x, m.y, m.z);
                break;
            default:
                g = t[x + 1].x - t[x].x, y = t[x + 1].y - t[x].y, f.x = y * 1, f.y = -g, f.z = y * 0, p.copy(f), f.x += m.x, f.y += m.y, f.z += m.z, f.normalize(), l.push(f.x, f.y, f.z), m.copy(p);
        }
        for(let x = 0; x <= e; x++){
            let v = r + x * u * i, S = Math.sin(v), w = Math.cos(v);
            for(let A = 0; A <= t.length - 1; A++){
                h.x = t[A].x * S, h.y = t[A].y, h.z = t[A].x * w, o.push(h.x, h.y, h.z), d.x = x / e, d.y = A / (t.length - 1), a.push(d.x, d.y);
                let T = l[3 * A + 0] * S, b = l[3 * A + 1], M = l[3 * A + 0] * w;
                c.push(T, b, M);
            }
        }
        for(let x = 0; x < e; x++)for(let v = 0; v < t.length - 1; v++){
            let S = v + x * t.length, w = S, A = S + t.length, T = S + t.length + 1, b = S + 1;
            s.push(w, A, b), s.push(T, b, A);
        }
        this.setIndex(s), this.setAttribute("position", new Te(o, 3)), this.setAttribute("uv", new Te(a, 2)), this.setAttribute("normal", new Te(c, 3));
    }
    static fromJSON(t) {
        return new Vu(t.points, t.segments, t.phiStart, t.phiLength);
    }
};
var Ec = class extends _e {
    constructor(t = 1, e = 1, r = 1, i = 32, s = 1, o = !1, a = 0, l = Math.PI * 2){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: t,
            radiusBottom: e,
            height: r,
            radialSegments: i,
            heightSegments: s,
            openEnded: o,
            thetaStart: a,
            thetaLength: l
        };
        let c = this;
        i = Math.floor(i), s = Math.floor(s);
        let u = [], h = [], d = [], f = [], p = 0, m = [], g = r / 2, y = 0;
        x(), o === !1 && (t > 0 && v(!0), e > 0 && v(!1)), this.setIndex(u), this.setAttribute("position", new Te(h, 3)), this.setAttribute("normal", new Te(d, 3)), this.setAttribute("uv", new Te(f, 2));
        function x() {
            let S = new E, w = new E, A = 0, T = (e - t) / r;
            for(let b = 0; b <= s; b++){
                let M = [], C = b / s, P = C * (e - t) + t;
                for(let I = 0; I <= i; I++){
                    let _ = I / i, D = _ * l + a, L = Math.sin(D), j = Math.cos(D);
                    w.x = P * L, w.y = -C * r + g, w.z = P * j, h.push(w.x, w.y, w.z), S.set(L, T, j).normalize(), d.push(S.x, S.y, S.z), f.push(_, 1 - C), M.push(p++);
                }
                m.push(M);
            }
            for(let b = 0; b < i; b++)for(let M = 0; M < s; M++){
                let C = m[M][b], P = m[M + 1][b], I = m[M + 1][b + 1], _ = m[M][b + 1];
                u.push(C, P, _), u.push(P, I, _), A += 6;
            }
            c.addGroup(y, A, 0), y += A;
        }
        function v(S) {
            let w = p, A = new k, T = new E, b = 0, M = S === !0 ? t : e, C = S === !0 ? 1 : -1;
            for(let I = 1; I <= i; I++)h.push(0, g * C, 0), d.push(0, C, 0), f.push(.5, .5), p++;
            let P = p;
            for(let I = 0; I <= i; I++){
                let D = I / i * l + a, L = Math.cos(D), j = Math.sin(D);
                T.x = M * j, T.y = g * C, T.z = M * L, h.push(T.x, T.y, T.z), d.push(0, C, 0), A.x = L * .5 + .5, A.y = j * .5 * C + .5, f.push(A.x, A.y), p++;
            }
            for(let I = 0; I < i; I++){
                let _ = w + I, D = P + I;
                S === !0 ? u.push(D, D + 1, _) : u.push(D + 1, D, _), b += 3;
            }
            c.addGroup(y, b, S === !0 ? 1 : 2), y += b;
        }
    }
    static fromJSON(t) {
        return new Ec(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, sl = class extends Ec {
    constructor(t = 1, e = 1, r = 32, i = 1, s = !1, o = 0, a = Math.PI * 2){
        super(0, t, e, r, i, s, o, a), this.type = "ConeGeometry", this.parameters = {
            radius: t,
            height: e,
            radialSegments: r,
            heightSegments: i,
            openEnded: s,
            thetaStart: o,
            thetaLength: a
        };
    }
    static fromJSON(t) {
        return new sl(t.radius, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, ku = class extends _e {
    constructor(t = [], e = [], r = 1, i = 0){
        super(), this.type = "PolyhedronGeometry", this.parameters = {
            vertices: t,
            indices: e,
            radius: r,
            detail: i
        };
        let s = [], o = [];
        a(i), c(r), u(), this.setAttribute("position", new Te(s, 3)), this.setAttribute("normal", new Te(s.slice(), 3)), this.setAttribute("uv", new Te(o, 2)), i === 0 ? this.computeVertexNormals() : this.normalizeNormals();
        function a(x) {
            let v = new E, S = new E, w = new E;
            for(let A = 0; A < e.length; A += 3)f(e[A + 0], v), f(e[A + 1], S), f(e[A + 2], w), l(v, S, w, x);
        }
        function l(x, v, S, w) {
            let A = w + 1, T = [];
            for(let b = 0; b <= A; b++){
                T[b] = [];
                let M = x.clone().lerp(S, b / A), C = v.clone().lerp(S, b / A), P = A - b;
                for(let I = 0; I <= P; I++)I === 0 && b === A ? T[b][I] = M : T[b][I] = M.clone().lerp(C, I / P);
            }
            for(let b = 0; b < A; b++)for(let M = 0; M < 2 * (A - b) - 1; M++){
                let C = Math.floor(M / 2);
                M % 2 === 0 ? (d(T[b][C + 1]), d(T[b + 1][C]), d(T[b][C])) : (d(T[b][C + 1]), d(T[b + 1][C + 1]), d(T[b + 1][C]));
            }
        }
        function c(x) {
            let v = new E;
            for(let S = 0; S < s.length; S += 3)v.x = s[S + 0], v.y = s[S + 1], v.z = s[S + 2], v.normalize().multiplyScalar(x), s[S + 0] = v.x, s[S + 1] = v.y, s[S + 2] = v.z;
        }
        function u() {
            let x = new E;
            for(let v = 0; v < s.length; v += 3){
                x.x = s[v + 0], x.y = s[v + 1], x.z = s[v + 2];
                let S = g(x) / 2 / Math.PI + .5, w = y(x) / Math.PI + .5;
                o.push(S, 1 - w);
            }
            p(), h();
        }
        function h() {
            for(let x = 0; x < o.length; x += 6){
                let v = o[x + 0], S = o[x + 2], w = o[x + 4], A = Math.max(v, S, w), T = Math.min(v, S, w);
                A > .9 && T < .1 && (v < .2 && (o[x + 0] += 1), S < .2 && (o[x + 2] += 1), w < .2 && (o[x + 4] += 1));
            }
        }
        function d(x) {
            s.push(x.x, x.y, x.z);
        }
        function f(x, v) {
            let S = x * 3;
            v.x = t[S + 0], v.y = t[S + 1], v.z = t[S + 2];
        }
        function p() {
            let x = new E, v = new E, S = new E, w = new E, A = new k, T = new k, b = new k;
            for(let M = 0, C = 0; M < s.length; M += 9, C += 6){
                x.set(s[M + 0], s[M + 1], s[M + 2]), v.set(s[M + 3], s[M + 4], s[M + 5]), S.set(s[M + 6], s[M + 7], s[M + 8]), A.set(o[C + 0], o[C + 1]), T.set(o[C + 2], o[C + 3]), b.set(o[C + 4], o[C + 5]), w.copy(x).add(v).add(S).divideScalar(3);
                let P = g(w);
                m(A, C + 0, x, P), m(T, C + 2, v, P), m(b, C + 4, S, P);
            }
        }
        function m(x, v, S, w) {
            w < 0 && x.x === 1 && (o[v] = x.x - 1), S.x === 0 && S.z === 0 && (o[v] = w / 2 / Math.PI + .5);
        }
        function g(x) {
            return Math.atan2(x.z, -x.x);
        }
        function y(x) {
            return Math.atan2(-x.y, Math.sqrt(x.x * x.x + x.z * x.z));
        }
    }
    static fromJSON(t) {
        return new ku(t.vertices, t.indices, t.radius, t.details);
    }
}, Uu = class extends ku {
    constructor(t = 1, e = 0){
        let r = (1 + Math.sqrt(5)) / 2, i = 1 / r, s = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -i,
            -r,
            0,
            -i,
            r,
            0,
            i,
            -r,
            0,
            i,
            r,
            -i,
            -r,
            0,
            -i,
            r,
            0,
            i,
            -r,
            0,
            i,
            r,
            0,
            -r,
            0,
            -i,
            r,
            0,
            -i,
            -r,
            0,
            i,
            r,
            0,
            i
        ], o = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(s, o, t, e), this.type = "DodecahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new Uu(t.radius, t.detail);
    }
};
var la = class extends Ac {
    constructor(t){
        super(t), this.uuid = is(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(t) {
        let e = [];
        for(let r = 0, i = this.holes.length; r < i; r++)e[r] = this.holes[r].getPoints(t);
        return e;
    }
    extractPoints(t) {
        return {
            shape: this.getPoints(t),
            holes: this.getPointsHoles(t)
        };
    }
    copy(t) {
        super.copy(t), this.holes = [];
        for(let e = 0, r = t.holes.length; e < r; e++){
            let i = t.holes[e];
            this.holes.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.uuid = this.uuid, t.holes = [];
        for(let e = 0, r = this.holes.length; e < r; e++){
            let i = this.holes[e];
            t.holes.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
        for(let e = 0, r = t.holes.length; e < r; e++){
            let i = t.holes[e];
            this.holes.push(new Ac().fromJSON(i));
        }
        return this;
    }
}, P4 = {
    triangulate: function(n1, t, e = 2) {
        let r = t && t.length, i = r ? t[0] * e : n1.length, s = gP(n1, 0, i, e, !0), o = [];
        if (!s || s.next === s.prev) return o;
        let a, l, c, u, h, d, f;
        if (r && (s = R4(n1, t, s, e)), n1.length > 80 * e) {
            a = c = n1[0], l = u = n1[1];
            for(let p = e; p < i; p += e)h = n1[p], d = n1[p + 1], h < a && (a = h), d < l && (l = d), h > c && (c = h), d > u && (u = d);
            f = Math.max(c - a, u - l), f = f !== 0 ? 32767 / f : 0;
        }
        return vp(s, o, e, a, l, f, 0), o;
    }
};
function gP(n1, t, e, r, i) {
    let s, o;
    if (i === H4(n1, t, e, r) > 0) for(s = t; s < e; s += r)o = zC(s, n1[s], n1[s + 1], o);
    else for(s = e - r; s >= t; s -= r)o = zC(s, n1[s], n1[s + 1], o);
    return o && Ly(o, o.next) && (bp(o), o = o.next), o;
}
function Tc(n1, t) {
    if (!n1) return n1;
    t || (t = n1);
    let e = n1, r;
    do if (r = !1, !e.steiner && (Ly(e, e.next) || Ur(e.prev, e, e.next) === 0)) {
        if (bp(e), e = t = e.prev, e === e.next) break;
        r = !0;
    } else e = e.next;
    while (r || e !== t);
    return t;
}
function vp(n1, t, e, r, i, s, o) {
    if (!n1) return;
    !o && s && V4(n1, r, i, s);
    let a = n1, l, c;
    for(; n1.prev !== n1.next;){
        if (l = n1.prev, c = n1.next, s ? I4(n1, r, i, s) : _4(n1)) {
            t.push(l.i / e | 0), t.push(n1.i / e | 0), t.push(c.i / e | 0), bp(n1), n1 = c.next, a = c.next;
            continue;
        }
        if (n1 = c, n1 === a) {
            o ? o === 1 ? (n1 = D4(Tc(n1), t, e), vp(n1, t, e, r, i, s, 2)) : o === 2 && O4(n1, t, e, r, i, s) : vp(Tc(n1), t, e, r, i, s, 1);
            break;
        }
    }
}
function _4(n1) {
    let t = n1.prev, e = n1, r = n1.next;
    if (Ur(t, e, r) >= 0) return !1;
    let i = t.x, s = e.x, o = r.x, a = t.y, l = e.y, c = r.y, u = i < s ? i < o ? i : o : s < o ? s : o, h = a < l ? a < c ? a : c : l < c ? l : c, d = i > s ? i > o ? i : o : s > o ? s : o, f = a > l ? a > c ? a : c : l > c ? l : c, p = r.next;
    for(; p !== t;){
        if (p.x >= u && p.x <= d && p.y >= h && p.y <= f && Ou(i, a, s, l, o, c, p.x, p.y) && Ur(p.prev, p, p.next) >= 0) return !1;
        p = p.next;
    }
    return !0;
}
function I4(n1, t, e, r) {
    let i = n1.prev, s = n1, o = n1.next;
    if (Ur(i, s, o) >= 0) return !1;
    let a = i.x, l = s.x, c = o.x, u = i.y, h = s.y, d = o.y, f = a < l ? a < c ? a : c : l < c ? l : c, p = u < h ? u < d ? u : d : h < d ? h : d, m = a > l ? a > c ? a : c : l > c ? l : c, g = u > h ? u > d ? u : d : h > d ? h : d, y = bw(f, p, t, e, r), x = bw(m, g, t, e, r), v = n1.prevZ, S = n1.nextZ;
    for(; v && v.z >= y && S && S.z <= x;){
        if (v.x >= f && v.x <= m && v.y >= p && v.y <= g && v !== i && v !== o && Ou(a, u, l, h, c, d, v.x, v.y) && Ur(v.prev, v, v.next) >= 0 || (v = v.prevZ, S.x >= f && S.x <= m && S.y >= p && S.y <= g && S !== i && S !== o && Ou(a, u, l, h, c, d, S.x, S.y) && Ur(S.prev, S, S.next) >= 0)) return !1;
        S = S.nextZ;
    }
    for(; v && v.z >= y;){
        if (v.x >= f && v.x <= m && v.y >= p && v.y <= g && v !== i && v !== o && Ou(a, u, l, h, c, d, v.x, v.y) && Ur(v.prev, v, v.next) >= 0) return !1;
        v = v.prevZ;
    }
    for(; S && S.z <= x;){
        if (S.x >= f && S.x <= m && S.y >= p && S.y <= g && S !== i && S !== o && Ou(a, u, l, h, c, d, S.x, S.y) && Ur(S.prev, S, S.next) >= 0) return !1;
        S = S.nextZ;
    }
    return !0;
}
function D4(n1, t, e) {
    let r = n1;
    do {
        let i = r.prev, s = r.next.next;
        !Ly(i, s) && yP(i, r, r.next, s) && xp(i, s) && xp(s, i) && (t.push(i.i / e | 0), t.push(r.i / e | 0), t.push(s.i / e | 0), bp(r), bp(r.next), r = n1 = s), r = r.next;
    }while (r !== n1);
    return Tc(r);
}
function O4(n1, t, e, r, i, s) {
    let o = n1;
    do {
        let a = o.next.next;
        for(; a !== o.prev;){
            if (o.i !== a.i && z4(o, a)) {
                let l = vP(o, a);
                o = Tc(o, o.next), l = Tc(l, l.next), vp(o, t, e, r, i, s, 0), vp(l, t, e, r, i, s, 0);
                return;
            }
            a = a.next;
        }
        o = o.next;
    }while (o !== n1);
}
function R4(n1, t, e, r) {
    let i = [], s, o, a, l, c;
    for(s = 0, o = t.length; s < o; s++)a = t[s] * r, l = s < o - 1 ? t[s + 1] * r : n1.length, c = gP(n1, a, l, r, !1), c === c.next && (c.steiner = !0), i.push(U4(c));
    for(i.sort(L4), s = 0; s < i.length; s++)e = B4(i[s], e);
    return e;
}
function L4(n1, t) {
    return n1.x - t.x;
}
function B4(n1, t) {
    let e = N4(n1, t);
    if (!e) return t;
    let r = vP(e, n1);
    return Tc(r, r.next), Tc(e, e.next);
}
function N4(n1, t) {
    let e = t, r = -1 / 0, i, s = n1.x, o = n1.y;
    do {
        if (o <= e.y && o >= e.next.y && e.next.y !== e.y) {
            let d = e.x + (o - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
            if (d <= s && d > r && (r = d, i = e.x < e.next.x ? e : e.next, d === s)) return i;
        }
        e = e.next;
    }while (e !== t);
    if (!i) return null;
    let a = i, l = i.x, c = i.y, u = 1 / 0, h;
    e = i;
    do s >= e.x && e.x >= l && s !== e.x && Ou(o < c ? s : r, o, l, c, o < c ? r : s, o, e.x, e.y) && (h = Math.abs(o - e.y) / (s - e.x), xp(e, n1) && (h < u || h === u && (e.x > i.x || e.x === i.x && F4(i, e))) && (i = e, u = h)), e = e.next;
    while (e !== a);
    return i;
}
function F4(n1, t) {
    return Ur(n1.prev, n1, t.prev) < 0 && Ur(t.next, n1, n1.next) < 0;
}
function V4(n1, t, e, r) {
    let i = n1;
    do i.z === 0 && (i.z = bw(i.x, i.y, t, e, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
    while (i !== n1);
    i.prevZ.nextZ = null, i.prevZ = null, k4(i);
}
function k4(n1) {
    let t, e, r, i, s, o, a, l, c = 1;
    do {
        for(e = n1, n1 = null, s = null, o = 0; e;){
            for(o++, r = e, a = 0, t = 0; t < c && (a++, r = r.nextZ, !!r); t++);
            for(l = c; a > 0 || l > 0 && r;)a !== 0 && (l === 0 || !r || e.z <= r.z) ? (i = e, e = e.nextZ, a--) : (i = r, r = r.nextZ, l--), s ? s.nextZ = i : n1 = i, i.prevZ = s, s = i;
            e = r;
        }
        s.nextZ = null, c *= 2;
    }while (o > 1);
    return n1;
}
function bw(n1, t, e, r, i) {
    return n1 = (n1 - e) * i | 0, t = (t - r) * i | 0, n1 = (n1 | n1 << 8) & 16711935, n1 = (n1 | n1 << 4) & 252645135, n1 = (n1 | n1 << 2) & 858993459, n1 = (n1 | n1 << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, n1 | t << 1;
}
function U4(n1) {
    let t = n1, e = n1;
    do (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
    while (t !== n1);
    return e;
}
function Ou(n1, t, e, r, i, s, o, a) {
    return (i - o) * (t - a) >= (n1 - o) * (s - a) && (n1 - o) * (r - a) >= (e - o) * (t - a) && (e - o) * (s - a) >= (i - o) * (r - a);
}
function z4(n1, t) {
    return n1.next.i !== t.i && n1.prev.i !== t.i && !G4(n1, t) && (xp(n1, t) && xp(t, n1) && j4(n1, t) && (Ur(n1.prev, n1, t.prev) || Ur(n1, t.prev, t)) || Ly(n1, t) && Ur(n1.prev, n1, n1.next) > 0 && Ur(t.prev, t, t.next) > 0);
}
function Ur(n1, t, e) {
    return (t.y - n1.y) * (e.x - t.x) - (t.x - n1.x) * (e.y - t.y);
}
function Ly(n1, t) {
    return n1.x === t.x && n1.y === t.y;
}
function yP(n1, t, e, r) {
    let i = Zg(Ur(n1, t, e)), s = Zg(Ur(n1, t, r)), o = Zg(Ur(e, r, n1)), a = Zg(Ur(e, r, t));
    return !!(i !== s && o !== a || i === 0 && Qg(n1, e, t) || s === 0 && Qg(n1, r, t) || o === 0 && Qg(e, n1, r) || a === 0 && Qg(e, t, r));
}
function Qg(n1, t, e) {
    return t.x <= Math.max(n1.x, e.x) && t.x >= Math.min(n1.x, e.x) && t.y <= Math.max(n1.y, e.y) && t.y >= Math.min(n1.y, e.y);
}
function Zg(n1) {
    return n1 > 0 ? 1 : n1 < 0 ? -1 : 0;
}
function G4(n1, t) {
    let e = n1;
    do {
        if (e.i !== n1.i && e.next.i !== n1.i && e.i !== t.i && e.next.i !== t.i && yP(e, e.next, n1, t)) return !0;
        e = e.next;
    }while (e !== n1);
    return !1;
}
function xp(n1, t) {
    return Ur(n1.prev, n1, n1.next) < 0 ? Ur(n1, t, n1.next) >= 0 && Ur(n1, n1.prev, t) >= 0 : Ur(n1, t, n1.prev) < 0 || Ur(n1, n1.next, t) < 0;
}
function j4(n1, t) {
    let e = n1, r = !1, i = (n1.x + t.x) / 2, s = (n1.y + t.y) / 2;
    do e.y > s != e.next.y > s && e.next.y !== e.y && i < (e.next.x - e.x) * (s - e.y) / (e.next.y - e.y) + e.x && (r = !r), e = e.next;
    while (e !== n1);
    return r;
}
function vP(n1, t) {
    let e = new Sw(n1.i, n1.x, n1.y), r = new Sw(t.i, t.x, t.y), i = n1.next, s = t.prev;
    return n1.next = t, t.prev = n1, e.next = i, i.prev = e, r.next = e, e.prev = r, s.next = r, r.prev = s, r;
}
function zC(n1, t, e, r) {
    let i = new Sw(n1, t, e);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function bp(n1) {
    n1.next.prev = n1.prev, n1.prev.next = n1.next, n1.prevZ && (n1.prevZ.nextZ = n1.nextZ), n1.nextZ && (n1.nextZ.prevZ = n1.prevZ);
}
function Sw(n1, t, e) {
    this.i = n1, this.x = t, this.y = e, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function H4(n1, t, e, r) {
    let i = 0;
    for(let s = t, o = e - r; s < e; s += r)i += (n1[o] - n1[s]) * (n1[s + 1] + n1[o + 1]), o = s;
    return i;
}
var zu = class {
    static area(t) {
        let e = t.length, r = 0;
        for(let i = e - 1, s = 0; s < e; i = s++)r += t[i].x * t[s].y - t[s].x * t[i].y;
        return r * .5;
    }
    static isClockWise(t) {
        return zu.area(t) < 0;
    }
    static triangulateShape(t, e) {
        let r = [], i = [], s = [];
        GC(t), jC(r, t);
        let o = t.length;
        e.forEach(GC);
        for(let l = 0; l < e.length; l++)i.push(o), o += e[l].length, jC(r, e[l]);
        let a = P4.triangulate(r, i);
        for(let l = 0; l < a.length; l += 3)s.push(a.slice(l, l + 3));
        return s;
    }
};
function GC(n1) {
    let t = n1.length;
    t > 2 && n1[t - 1].equals(n1[0]) && n1.pop();
}
function jC(n1, t) {
    for(let e = 0; e < t.length; e++)n1.push(t[e].x), n1.push(t[e].y);
}
var Gu = class extends ku {
    constructor(t = 1, e = 0){
        let r = (1 + Math.sqrt(5)) / 2, i = [
            -1,
            r,
            0,
            1,
            r,
            0,
            -1,
            -r,
            0,
            1,
            -r,
            0,
            0,
            -1,
            r,
            0,
            1,
            r,
            0,
            -1,
            -r,
            0,
            1,
            -r,
            r,
            0,
            -1,
            r,
            0,
            1,
            -r,
            0,
            -1,
            -r,
            0,
            1
        ], s = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(i, s, t, e), this.type = "IcosahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new Gu(t.radius, t.detail);
    }
};
var Bs = class extends _e {
    constructor(t = 1, e = 32, r = 16, i = 0, s = Math.PI * 2, o = 0, a = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: t,
            widthSegments: e,
            heightSegments: r,
            phiStart: i,
            phiLength: s,
            thetaStart: o,
            thetaLength: a
        }, e = Math.max(3, Math.floor(e)), r = Math.max(2, Math.floor(r));
        let l = Math.min(o + a, Math.PI), c = 0, u = [], h = new E, d = new E, f = [], p = [], m = [], g = [];
        for(let y = 0; y <= r; y++){
            let x = [], v = y / r, S = 0;
            y == 0 && o == 0 ? S = .5 / e : y == r && l == Math.PI && (S = -0.5 / e);
            for(let w = 0; w <= e; w++){
                let A = w / e;
                h.x = -t * Math.cos(i + A * s) * Math.sin(o + v * a), h.y = t * Math.cos(o + v * a), h.z = t * Math.sin(i + A * s) * Math.sin(o + v * a), p.push(h.x, h.y, h.z), d.copy(h).normalize(), m.push(d.x, d.y, d.z), g.push(A + S, 1 - v), x.push(c++);
            }
            u.push(x);
        }
        for(let y = 0; y < r; y++)for(let x = 0; x < e; x++){
            let v = u[y][x + 1], S = u[y][x], w = u[y + 1][x], A = u[y + 1][x + 1];
            (y !== 0 || o > 0) && f.push(v, S, A), (y !== r - 1 || l < Math.PI) && f.push(S, w, A);
        }
        this.setIndex(f), this.setAttribute("position", new Te(p, 3)), this.setAttribute("normal", new Te(m, 3)), this.setAttribute("uv", new Te(g, 2));
    }
    static fromJSON(t) {
        return new Bs(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
    }
};
var ju = class extends _e {
    constructor(t = 1, e = .4, r = 12, i = 48, s = Math.PI * 2){
        super(), this.type = "TorusGeometry", this.parameters = {
            radius: t,
            tube: e,
            radialSegments: r,
            tubularSegments: i,
            arc: s
        }, r = Math.floor(r), i = Math.floor(i);
        let o = [], a = [], l = [], c = [], u = new E, h = new E, d = new E;
        for(let f = 0; f <= r; f++)for(let p = 0; p <= i; p++){
            let m = p / i * s, g = f / r * Math.PI * 2;
            h.x = (t + e * Math.cos(g)) * Math.cos(m), h.y = (t + e * Math.cos(g)) * Math.sin(m), h.z = e * Math.sin(g), a.push(h.x, h.y, h.z), u.x = t * Math.cos(m), u.y = t * Math.sin(m), d.subVectors(h, u).normalize(), l.push(d.x, d.y, d.z), c.push(p / i), c.push(f / r);
        }
        for(let f = 1; f <= r; f++)for(let p = 1; p <= i; p++){
            let m = (i + 1) * f + p - 1, g = (i + 1) * (f - 1) + p - 1, y = (i + 1) * (f - 1) + p, x = (i + 1) * f + p;
            o.push(m, g, x), o.push(g, y, x);
        }
        this.setIndex(o), this.setAttribute("position", new Te(a, 3)), this.setAttribute("normal", new Te(l, 3)), this.setAttribute("uv", new Te(c, 2));
    }
    static fromJSON(t) {
        return new ju(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc);
    }
}, Hu = class extends _e {
    constructor(t = 1, e = .4, r = 64, i = 8, s = 2, o = 3){
        super(), this.type = "TorusKnotGeometry", this.parameters = {
            radius: t,
            tube: e,
            tubularSegments: r,
            radialSegments: i,
            p: s,
            q: o
        }, r = Math.floor(r), i = Math.floor(i);
        let a = [], l = [], c = [], u = [], h = new E, d = new E, f = new E, p = new E, m = new E, g = new E, y = new E;
        for(let v = 0; v <= r; ++v){
            let S = v / r * s * Math.PI * 2;
            x(S, s, o, t, f), x(S + .01, s, o, t, p), g.subVectors(p, f), y.addVectors(p, f), m.crossVectors(g, y), y.crossVectors(m, g), m.normalize(), y.normalize();
            for(let w = 0; w <= i; ++w){
                let A = w / i * Math.PI * 2, T = -e * Math.cos(A), b = e * Math.sin(A);
                h.x = f.x + (T * y.x + b * m.x), h.y = f.y + (T * y.y + b * m.y), h.z = f.z + (T * y.z + b * m.z), l.push(h.x, h.y, h.z), d.subVectors(h, f).normalize(), c.push(d.x, d.y, d.z), u.push(v / r), u.push(w / i);
            }
        }
        for(let v = 1; v <= r; v++)for(let S = 1; S <= i; S++){
            let w = (i + 1) * (v - 1) + (S - 1), A = (i + 1) * v + (S - 1), T = (i + 1) * v + S, b = (i + 1) * (v - 1) + S;
            a.push(w, A, b), a.push(A, T, b);
        }
        this.setIndex(a), this.setAttribute("position", new Te(l, 3)), this.setAttribute("normal", new Te(c, 3)), this.setAttribute("uv", new Te(u, 2));
        function x(v, S, w, A, T) {
            let b = Math.cos(v), M = Math.sin(v), C = w / S * v, P = Math.cos(C);
            T.x = A * (2 + P) * .5 * b, T.y = A * (2 + P) * M * .5, T.z = A * Math.sin(C) * .5;
        }
    }
    static fromJSON(t) {
        return new Hu(t.radius, t.tube, t.tubularSegments, t.radialSegments, t.p, t.q);
    }
};
function Qa(n1, t, e) {
    return xP(n1) ? new n1.constructor(n1.subarray(t, e !== void 0 ? e : n1.length)) : n1.slice(t, e);
}
function Jg(n1, t, e) {
    return !n1 || !e && n1.constructor === t ? n1 : typeof t.BYTES_PER_ELEMENT == "number" ? new t(n1) : Array.prototype.slice.call(n1);
}
function xP(n1) {
    return ArrayBuffer.isView(n1) && !(n1 instanceof DataView);
}
function W4(n1) {
    function t(i, s) {
        return n1[i] - n1[s];
    }
    let e = n1.length, r = new Array(e);
    for(let i = 0; i !== e; ++i)r[i] = i;
    return r.sort(t), r;
}
function HC(n1, t, e) {
    let r = n1.length, i = new n1.constructor(r);
    for(let s = 0, o = 0; o !== r; ++s){
        let a = e[s] * t;
        for(let l = 0; l !== t; ++l)i[o++] = n1[a + l];
    }
    return i;
}
function bP(n1, t, e, r) {
    let i = 1, s = n1[0];
    for(; s !== void 0 && s[r] === void 0;)s = n1[i++];
    if (s === void 0) return;
    let o = s[r];
    if (o !== void 0) {
        if (Array.isArray(o)) do o = s[r], o !== void 0 && (t.push(s.time), e.push.apply(e, o)), s = n1[i++];
        while (s !== void 0);
        else if (o.toArray !== void 0) do o = s[r], o !== void 0 && (t.push(s.time), o.toArray(e, e.length)), s = n1[i++];
        while (s !== void 0);
        else do o = s[r], o !== void 0 && (t.push(s.time), e.push(o)), s = n1[i++];
        while (s !== void 0);
    }
}
var Wu = class {
    constructor(t, e, r, i){
        this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new e.constructor(r), this.sampleValues = e, this.valueSize = r, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(t) {
        let e = this.parameterPositions, r = this._cachedIndex, i = e[r], s = e[r - 1];
        e: {
            t: {
                let o;
                r: {
                    i: if (!(t < i)) {
                        for(let a = r + 2;;){
                            if (i === void 0) {
                                if (t < s) break i;
                                return r = e.length, this._cachedIndex = r, this.copySampleValue_(r - 1);
                            }
                            if (r === a) break;
                            if (s = i, i = e[++r], t < i) break t;
                        }
                        o = e.length;
                        break r;
                    }
                    if (!(t >= s)) {
                        let a = e[1];
                        t < a && (r = 2, s = a);
                        for(let l = r - 2;;){
                            if (s === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                            if (r === l) break;
                            if (i = s, s = e[--r - 1], t >= s) break t;
                        }
                        o = r, r = 0;
                        break r;
                    }
                    break e;
                }
                for(; r < o;){
                    let a = r + o >>> 1;
                    t < e[a] ? o = a : r = a + 1;
                }
                if (i = e[r], s = e[r - 1], s === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                if (i === void 0) return r = e.length, this._cachedIndex = r, this.copySampleValue_(r - 1);
            }
            this._cachedIndex = r, this.intervalChanged_(r, s, i);
        }
        return this.interpolate_(r, s, t, i);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(t) {
        let e = this.resultBuffer, r = this.sampleValues, i = this.valueSize, s = t * i;
        for(let o = 0; o !== i; ++o)e[o] = r[s + o];
        return e;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}, ww = class extends Wu {
    constructor(t, e, r, i){
        super(t, e, r, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: _u,
            endingEnd: _u
        };
    }
    intervalChanged_(t, e, r) {
        let i = this.parameterPositions, s = t - 2, o = t + 1, a = i[s], l = i[o];
        if (a === void 0) switch(this.getSettings_().endingStart){
            case Iu:
                s = t, a = 2 * e - r;
                break;
            case sy:
                s = i.length - 2, a = e + i[s] - i[s + 1];
                break;
            default:
                s = t, a = r;
        }
        if (l === void 0) switch(this.getSettings_().endingEnd){
            case Iu:
                o = t, l = 2 * r - e;
                break;
            case sy:
                o = 1, l = r + i[1] - i[0];
                break;
            default:
                o = t - 1, l = e;
        }
        let c = (r - e) * .5, u = this.valueSize;
        this._weightPrev = c / (e - a), this._weightNext = c / (l - r), this._offsetPrev = s * u, this._offsetNext = o * u;
    }
    interpolate_(t, e, r, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, c = l - a, u = this._offsetPrev, h = this._offsetNext, d = this._weightPrev, f = this._weightNext, p = (r - e) / (i - e), m = p * p, g = m * p, y = -d * g + 2 * d * m - d * p, x = (1 + d) * g + (-1.5 - 2 * d) * m + (-0.5 + d) * p + 1, v = (-1 - f) * g + (1.5 + f) * m + .5 * p, S = f * g - f * m;
        for(let w = 0; w !== a; ++w)s[w] = y * o[u + w] + x * o[c + w] + v * o[l + w] + S * o[h + w];
        return s;
    }
}, vy = class extends Wu {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t, e, r, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, c = l - a, u = (r - e) / (i - e), h = 1 - u;
        for(let d = 0; d !== a; ++d)s[d] = o[c + d] * h + o[l + d] * u;
        return s;
    }
}, Aw = class extends Wu {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t) {
        return this.copySampleValue_(t - 1);
    }
}, as = class {
    constructor(t, e, r, i){
        if (t === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (e === void 0 || e.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
        this.name = t, this.times = Jg(e, this.TimeBufferType), this.values = Jg(r, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }
    static toJSON(t) {
        let e = t.constructor, r;
        if (e.toJSON !== this.toJSON) r = e.toJSON(t);
        else {
            r = {
                name: t.name,
                times: Jg(t.times, Array),
                values: Jg(t.values, Array)
            };
            let i = t.getInterpolation();
            i !== t.DefaultInterpolation && (r.interpolation = i);
        }
        return r.type = t.ValueTypeName, r;
    }
    InterpolantFactoryMethodDiscrete(t) {
        return new Aw(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodLinear(t) {
        return new vy(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodSmooth(t) {
        return new ww(this.times, this.values, this.getValueSize(), t);
    }
    setInterpolation(t) {
        let e;
        switch(t){
            case iy:
                e = this.InterpolantFactoryMethodDiscrete;
                break;
            case ny:
                e = this.InterpolantFactoryMethodLinear;
                break;
            case SS:
                e = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (e === void 0) {
            let r = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === void 0) {
                if (t !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(r);
            }
            return console.warn("THREE.KeyframeTrack:", r), this;
        }
        return this.createInterpolant = e, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return iy;
            case this.InterpolantFactoryMethodLinear:
                return ny;
            case this.InterpolantFactoryMethodSmooth:
                return SS;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(t) {
        if (t !== 0) {
            let e = this.times;
            for(let r = 0, i = e.length; r !== i; ++r)e[r] += t;
        }
        return this;
    }
    scale(t) {
        if (t !== 1) {
            let e = this.times;
            for(let r = 0, i = e.length; r !== i; ++r)e[r] *= t;
        }
        return this;
    }
    trim(t, e) {
        let r = this.times, i = r.length, s = 0, o = i - 1;
        for(; s !== i && r[s] < t;)++s;
        for(; o !== -1 && r[o] > e;)--o;
        if (++o, s !== 0 || o !== i) {
            s >= o && (o = Math.max(o, 1), s = o - 1);
            let a = this.getValueSize();
            this.times = Qa(r, s, o), this.values = Qa(this.values, s * a, o * a);
        }
        return this;
    }
    validate() {
        let t = !0, e = this.getValueSize();
        e - Math.floor(e) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
        let r = this.times, i = this.values, s = r.length;
        s === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
        let o = null;
        for(let a = 0; a !== s; a++){
            let l = r[a];
            if (typeof l == "number" && isNaN(l)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, a, l), t = !1;
                break;
            }
            if (o !== null && o > l) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, a, l, o), t = !1;
                break;
            }
            o = l;
        }
        if (i !== void 0 && xP(i)) for(let a = 0, l = i.length; a !== l; ++a){
            let c = i[a];
            if (isNaN(c)) {
                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, a, c), t = !1;
                break;
            }
        }
        return t;
    }
    optimize() {
        let t = Qa(this.times), e = Qa(this.values), r = this.getValueSize(), i = this.getInterpolation() === SS, s = t.length - 1, o = 1;
        for(let a = 1; a < s; ++a){
            let l = !1, c = t[a], u = t[a + 1];
            if (c !== u && (a !== 1 || c !== t[0])) {
                if (i) l = !0;
                else {
                    let h = a * r, d = h - r, f = h + r;
                    for(let p = 0; p !== r; ++p){
                        let m = e[h + p];
                        if (m !== e[d + p] || m !== e[f + p]) {
                            l = !0;
                            break;
                        }
                    }
                }
            }
            if (l) {
                if (a !== o) {
                    t[o] = t[a];
                    let h = a * r, d = o * r;
                    for(let f = 0; f !== r; ++f)e[d + f] = e[h + f];
                }
                ++o;
            }
        }
        if (s > 0) {
            t[o] = t[s];
            for(let a = s * r, l = o * r, c = 0; c !== r; ++c)e[l + c] = e[a + c];
            ++o;
        }
        return o !== t.length ? (this.times = Qa(t, 0, o), this.values = Qa(e, 0, o * r)) : (this.times = t, this.values = e), this;
    }
    clone() {
        let t = Qa(this.times, 0), e = Qa(this.values, 0), r = this.constructor, i = new r(this.name, t, e);
        return i.createInterpolant = this.createInterpolant, i;
    }
};
as.prototype.TimeBufferType = Float32Array;
as.prototype.ValueBufferType = Float32Array;
as.prototype.DefaultInterpolation = ny;
var ol = class extends as {
};
ol.prototype.ValueTypeName = "bool";
ol.prototype.ValueBufferType = Array;
ol.prototype.DefaultInterpolation = iy;
ol.prototype.InterpolantFactoryMethodLinear = void 0;
ol.prototype.InterpolantFactoryMethodSmooth = void 0;
var xy = class extends as {
};
xy.prototype.ValueTypeName = "color";
var qu = class extends as {
};
qu.prototype.ValueTypeName = "number";
var Ew = class extends Wu {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t, e, r, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = (r - e) / (i - e), c = t * a;
        for(let u = c + a; c !== u; c += 4)Ke.slerpFlat(s, 0, o, c - a, o, c, l);
        return s;
    }
}, Mc = class extends as {
    InterpolantFactoryMethodLinear(t) {
        return new Ew(this.times, this.values, this.getValueSize(), t);
    }
};
Mc.prototype.ValueTypeName = "quaternion";
Mc.prototype.DefaultInterpolation = ny;
Mc.prototype.InterpolantFactoryMethodSmooth = void 0;
var al = class extends as {
};
al.prototype.ValueTypeName = "string";
al.prototype.ValueBufferType = Array;
al.prototype.DefaultInterpolation = iy;
al.prototype.InterpolantFactoryMethodLinear = void 0;
al.prototype.InterpolantFactoryMethodSmooth = void 0;
var Yu = class extends as {
};
Yu.prototype.ValueTypeName = "vector";
var Xu = class {
    constructor(t, e = -1, r, i = Fw){
        this.name = t, this.tracks = r, this.duration = e, this.blendMode = i, this.uuid = is(), this.duration < 0 && this.resetDuration();
    }
    static parse(t) {
        let e = [], r = t.tracks, i = 1 / (t.fps || 1);
        for(let o = 0, a = r.length; o !== a; ++o)e.push(Y4(r[o]).scale(i));
        let s = new this(t.name, t.duration, e, t.blendMode);
        return s.uuid = t.uuid, s;
    }
    static toJSON(t) {
        let e = [], r = t.tracks, i = {
            name: t.name,
            duration: t.duration,
            tracks: e,
            uuid: t.uuid,
            blendMode: t.blendMode
        };
        for(let s = 0, o = r.length; s !== o; ++s)e.push(as.toJSON(r[s]));
        return i;
    }
    static CreateFromMorphTargetSequence(t, e, r, i) {
        let s = e.length, o = [];
        for(let a = 0; a < s; a++){
            let l = [], c = [];
            l.push((a + s - 1) % s, a, (a + 1) % s), c.push(0, 1, 0);
            let u = W4(l);
            l = HC(l, 1, u), c = HC(c, 1, u), !i && l[0] === 0 && (l.push(s), c.push(c[0])), o.push(new qu(".morphTargetInfluences[" + e[a].name + "]", l, c).scale(1 / r));
        }
        return new this(t, -1, o);
    }
    static findByName(t, e) {
        let r = t;
        if (!Array.isArray(t)) {
            let i = t;
            r = i.geometry && i.geometry.animations || i.animations;
        }
        for(let i = 0; i < r.length; i++)if (r[i].name === e) return r[i];
        return null;
    }
    static CreateClipsFromMorphTargetSequences(t, e, r) {
        let i = {}, s = /^([\w-]*?)([\d]+)$/;
        for(let a = 0, l = t.length; a < l; a++){
            let c = t[a], u = c.name.match(s);
            if (u && u.length > 1) {
                let h = u[1], d = i[h];
                d || (i[h] = d = []), d.push(c);
            }
        }
        let o = [];
        for(let a in i)o.push(this.CreateFromMorphTargetSequence(a, i[a], e, r));
        return o;
    }
    static parseAnimation(t, e) {
        if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
        let r = function(h, d, f, p, m) {
            if (f.length !== 0) {
                let g = [], y = [];
                bP(f, g, y, p), g.length !== 0 && m.push(new h(d, g, y));
            }
        }, i = [], s = t.name || "default", o = t.fps || 30, a = t.blendMode, l = t.length || -1, c = t.hierarchy || [];
        for(let h = 0; h < c.length; h++){
            let d = c[h].keys;
            if (!(!d || d.length === 0)) {
                if (d[0].morphTargets) {
                    let f = {}, p;
                    for(p = 0; p < d.length; p++)if (d[p].morphTargets) for(let m = 0; m < d[p].morphTargets.length; m++)f[d[p].morphTargets[m]] = -1;
                    for(let m in f){
                        let g = [], y = [];
                        for(let x = 0; x !== d[p].morphTargets.length; ++x){
                            let v = d[p];
                            g.push(v.time), y.push(v.morphTarget === m ? 1 : 0);
                        }
                        i.push(new qu(".morphTargetInfluence[" + m + "]", g, y));
                    }
                    l = f.length * o;
                } else {
                    let f = ".bones[" + e[h].name + "]";
                    r(Yu, f + ".position", d, "pos", i), r(Mc, f + ".quaternion", d, "rot", i), r(Yu, f + ".scale", d, "scl", i);
                }
            }
        }
        return i.length === 0 ? null : new this(s, l, i, a);
    }
    resetDuration() {
        let t = this.tracks, e = 0;
        for(let r = 0, i = t.length; r !== i; ++r){
            let s = this.tracks[r];
            e = Math.max(e, s.times[s.times.length - 1]);
        }
        return this.duration = e, this;
    }
    trim() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].trim(0, this.duration);
        return this;
    }
    validate() {
        let t = !0;
        for(let e = 0; e < this.tracks.length; e++)t = t && this.tracks[e].validate();
        return t;
    }
    optimize() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].optimize();
        return this;
    }
    clone() {
        let t = [];
        for(let e = 0; e < this.tracks.length; e++)t.push(this.tracks[e].clone());
        return new this.constructor(this.name, this.duration, t, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
};
function q4(n1) {
    switch(n1.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return qu;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return Yu;
        case "color":
            return xy;
        case "quaternion":
            return Mc;
        case "bool":
        case "boolean":
            return ol;
        case "string":
            return al;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + n1);
}
function Y4(n1) {
    if (n1.type === void 0) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    let t = q4(n1.type);
    if (n1.times === void 0) {
        let e = [], r = [];
        bP(n1.keys, e, r, "value"), n1.times = e, n1.values = r;
    }
    return t.parse !== void 0 ? t.parse(n1) : new t(n1.name, n1.times, n1.values, n1.interpolation);
}
var by = {
    enabled: !1,
    files: {},
    add: function(n1, t) {
        this.enabled !== !1 && (this.files[n1] = t);
    },
    get: function(n1) {
        if (this.enabled !== !1) return this.files[n1];
    },
    remove: function(n1) {
        delete this.files[n1];
    },
    clear: function() {
        this.files = {};
    }
}, Sp = class {
    constructor(t, e, r){
        let i = this, s = !1, o = 0, a = 0, l, c = [];
        this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = r, this.itemStart = function(u) {
            a++, s === !1 && i.onStart !== void 0 && i.onStart(u, o, a), s = !0;
        }, this.itemEnd = function(u) {
            o++, i.onProgress !== void 0 && i.onProgress(u, o, a), o === a && (s = !1, i.onLoad !== void 0 && i.onLoad());
        }, this.itemError = function(u) {
            i.onError !== void 0 && i.onError(u);
        }, this.resolveURL = function(u) {
            return l ? l(u) : u;
        }, this.setURLModifier = function(u) {
            return l = u, this;
        }, this.addHandler = function(u, h) {
            return c.push(u, h), this;
        }, this.removeHandler = function(u) {
            let h = c.indexOf(u);
            return h !== -1 && c.splice(h, 2), this;
        }, this.getHandler = function(u) {
            for(let h = 0, d = c.length; h < d; h += 2){
                let f = c[h], p = c[h + 1];
                if (f.global && (f.lastIndex = 0), f.test(u)) return p;
            }
            return null;
        };
    }
}, X4 = new Sp, ll = class {
    constructor(t){
        this.manager = t !== void 0 ? t : X4, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t, e) {
        let r = this;
        return new Promise(function(i, s) {
            r.load(t, i, e, s);
        });
    }
    parse() {}
    setCrossOrigin(t) {
        return this.crossOrigin = t, this;
    }
    setWithCredentials(t) {
        return this.withCredentials = t, this;
    }
    setPath(t) {
        return this.path = t, this;
    }
    setResourcePath(t) {
        return this.resourcePath = t, this;
    }
    setRequestHeader(t) {
        return this.requestHeader = t, this;
    }
}, sa = {}, Tw = class extends Error {
    constructor(t, e){
        super(t), this.response = e;
    }
}, Ku = class extends ll {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        t === void 0 && (t = ""), this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s = by.get(t);
        if (s !== void 0) return this.manager.itemStart(t), setTimeout(()=>{
            e && e(s), this.manager.itemEnd(t);
        }, 0), s;
        if (sa[t] !== void 0) {
            sa[t].push({
                onLoad: e,
                onProgress: r,
                onError: i
            });
            return;
        }
        sa[t] = [], sa[t].push({
            onLoad: e,
            onProgress: r,
            onError: i
        });
        let o = new Request(t, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        }), a = this.mimeType, l = this.responseType;
        fetch(o).then((c)=>{
            if (c.status === 200 || c.status === 0) {
                if (c.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || c.body === void 0 || c.body.getReader === void 0) return c;
                let u = sa[t], h = c.body.getReader(), d = c.headers.get("Content-Length") || c.headers.get("X-File-Size"), f = d ? parseInt(d) : 0, p = f !== 0, m = 0, g = new ReadableStream({
                    start (y) {
                        x();
                        function x() {
                            h.read().then(({ done: v, value: S })=>{
                                if (v) y.close();
                                else {
                                    m += S.byteLength;
                                    let w = new ProgressEvent("progress", {
                                        lengthComputable: p,
                                        loaded: m,
                                        total: f
                                    });
                                    for(let A = 0, T = u.length; A < T; A++){
                                        let b = u[A];
                                        b.onProgress && b.onProgress(w);
                                    }
                                    y.enqueue(S), x();
                                }
                            });
                        }
                    }
                });
                return new Response(g);
            } else throw new Tw(`fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`, c);
        }).then((c)=>{
            switch(l){
                case "arraybuffer":
                    return c.arrayBuffer();
                case "blob":
                    return c.blob();
                case "document":
                    return c.text().then((u)=>new DOMParser().parseFromString(u, a));
                case "json":
                    return c.json();
                default:
                    if (a === void 0) return c.text();
                    {
                        let h = /charset="?([^;"\s]*)"?/i.exec(a), d = h && h[1] ? h[1].toLowerCase() : void 0, f = new TextDecoder(d);
                        return c.arrayBuffer().then((p)=>f.decode(p));
                    }
            }
        }).then((c)=>{
            by.add(t, c);
            let u = sa[t];
            delete sa[t];
            for(let h = 0, d = u.length; h < d; h++){
                let f = u[h];
                f.onLoad && f.onLoad(c);
            }
        }).catch((c)=>{
            let u = sa[t];
            if (u === void 0) throw this.manager.itemError(t), c;
            delete sa[t];
            for(let h = 0, d = u.length; h < d; h++){
                let f = u[h];
                f.onError && f.onError(c);
            }
            this.manager.itemError(t);
        }).finally(()=>{
            this.manager.itemEnd(t);
        }), this.manager.itemStart(t);
    }
    setResponseType(t) {
        return this.responseType = t, this;
    }
    setMimeType(t) {
        return this.mimeType = t, this;
    }
};
var Mw = class extends ll {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s = this, o = by.get(t);
        if (o !== void 0) return s.manager.itemStart(t), setTimeout(function() {
            e && e(o), s.manager.itemEnd(t);
        }, 0), o;
        let a = hp("img");
        function l() {
            u(), by.add(t, this), e && e(this), s.manager.itemEnd(t);
        }
        function c(h) {
            u(), i && i(h), s.manager.itemError(t), s.manager.itemEnd(t);
        }
        function u() {
            a.removeEventListener("load", l, !1), a.removeEventListener("error", c, !1);
        }
        return a.addEventListener("load", l, !1), a.addEventListener("error", c, !1), t.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (a.crossOrigin = this.crossOrigin), s.manager.itemStart(t), a.src = t, a;
    }
};
var Sy = class extends ll {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        let s = new er, o = new Mw(this.manager);
        return o.setCrossOrigin(this.crossOrigin), o.setPath(this.path), o.load(t, function(a) {
            s.image = a, s.needsUpdate = !0, e !== void 0 && e(s);
        }, r, i), s;
    }
}, cl = class extends Tt {
    constructor(t, e = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new We(t), this.intensity = e;
    }
    dispose() {}
    copy(t, e) {
        return super.copy(t, e), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, this.groundColor !== void 0 && (e.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (e.object.distance = this.distance), this.angle !== void 0 && (e.object.angle = this.angle), this.decay !== void 0 && (e.object.decay = this.decay), this.penumbra !== void 0 && (e.object.penumbra = this.penumbra), this.shadow !== void 0 && (e.object.shadow = this.shadow.toJSON()), e;
    }
}, wy = class extends cl {
    constructor(t, e, r){
        super(t, r), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Tt.DEFAULT_UP), this.updateMatrix(), this.groundColor = new We(e);
    }
    copy(t, e) {
        return super.copy(t, e), this.groundColor.copy(t.groundColor), this;
    }
}, QS = new ue, WC = new E, qC = new E, wp = class {
    constructor(t){
        this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new k(512, 512), this.map = null, this.mapPass = null, this.matrix = new ue, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new fp, this._frameExtents = new k(1, 1), this._viewportCount = 1, this._viewports = [
            new Ze(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(t) {
        let e = this.camera, r = this.matrix;
        WC.setFromMatrixPosition(t.matrixWorld), e.position.copy(WC), qC.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(qC), e.updateMatrixWorld(), QS.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(QS), r.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), r.multiply(QS);
    }
    getViewport(t) {
        return this._viewports[t];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t) {
        return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        let t = {};
        return this.bias !== 0 && (t.bias = this.bias), this.normalBias !== 0 && (t.normalBias = this.normalBias), this.radius !== 1 && (t.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
}, Cw = class extends wp {
    constructor(){
        super(new $r(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
    }
    updateMatrices(t) {
        let e = this.camera, r = up * 2 * t.angle * this.focus, i = this.mapSize.width / this.mapSize.height, s = t.distance || e.far;
        (r !== e.fov || i !== e.aspect || s !== e.far) && (e.fov = r, e.aspect = i, e.far = s, e.updateProjectionMatrix()), super.updateMatrices(t);
    }
    copy(t) {
        return super.copy(t), this.focus = t.focus, this;
    }
}, Ay = class extends cl {
    constructor(t, e, r = 0, i = Math.PI / 3, s = 0, o = 2){
        super(t, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(Tt.DEFAULT_UP), this.updateMatrix(), this.target = new Tt, this.distance = r, this.angle = i, this.penumbra = s, this.decay = o, this.map = null, this.shadow = new Cw;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(t) {
        this.intensity = t / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
}, YC = new ue, tp = new E, ZS = new E, Pw = class extends wp {
    constructor(){
        super(new $r(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new k(4, 2), this._viewportCount = 6, this._viewports = [
            new Ze(2, 1, 1, 1),
            new Ze(0, 1, 1, 1),
            new Ze(3, 1, 1, 1),
            new Ze(1, 1, 1, 1),
            new Ze(3, 0, 1, 1),
            new Ze(1, 0, 1, 1)
        ], this._cubeDirections = [
            new E(1, 0, 0),
            new E(-1, 0, 0),
            new E(0, 0, 1),
            new E(0, 0, -1),
            new E(0, 1, 0),
            new E(0, -1, 0)
        ], this._cubeUps = [
            new E(0, 1, 0),
            new E(0, 1, 0),
            new E(0, 1, 0),
            new E(0, 1, 0),
            new E(0, 0, 1),
            new E(0, 0, -1)
        ];
    }
    updateMatrices(t, e = 0) {
        let r = this.camera, i = this.matrix, s = t.distance || r.far;
        s !== r.far && (r.far = s, r.updateProjectionMatrix()), tp.setFromMatrixPosition(t.matrixWorld), r.position.copy(tp), ZS.copy(r.position), ZS.add(this._cubeDirections[e]), r.up.copy(this._cubeUps[e]), r.lookAt(ZS), r.updateMatrixWorld(), i.makeTranslation(-tp.x, -tp.y, -tp.z), YC.multiplyMatrices(r.projectionMatrix, r.matrixWorldInverse), this._frustum.setFromProjectionMatrix(YC);
    }
}, Ey = class extends cl {
    constructor(t, e, r = 0, i = 2){
        super(t, e), this.isPointLight = !0, this.type = "PointLight", this.distance = r, this.decay = i, this.shadow = new Pw;
    }
    get power() {
        return this.intensity * 4 * Math.PI;
    }
    set power(t) {
        this.intensity = t / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
}, _w = class extends wp {
    constructor(){
        super(new rl(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
    }
}, Ty = class extends cl {
    constructor(t, e){
        super(t, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Tt.DEFAULT_UP), this.updateMatrix(), this.target = new Tt, this.shadow = new _w;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t) {
        return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
};
var Ap = class extends _e {
    constructor(){
        super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(t) {
        return super.copy(t), this.instanceCount = t.instanceCount, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
}, Qu = class extends ll {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        let s = this, o = new Ku(s.manager);
        o.setPath(s.path), o.setRequestHeader(s.requestHeader), o.setWithCredentials(s.withCredentials), o.load(t, function(a) {
            try {
                e(s.parse(JSON.parse(a)));
            } catch (l) {
                i ? i(l) : console.error(l), s.manager.itemError(t);
            }
        }, r, i);
    }
    parse(t) {
        let e = {}, r = {};
        function i(f, p) {
            if (e[p] !== void 0) return e[p];
            let g = f.interleavedBuffers[p], y = s(f, g.buffer), x = Pg(g.type, y), v = new py(x, g.stride);
            return v.uuid = g.uuid, e[p] = v, v;
        }
        function s(f, p) {
            if (r[p] !== void 0) return r[p];
            let g = f.arrayBuffers[p], y = new Uint32Array(g).buffer;
            return r[p] = y, y;
        }
        let o = t.isInstancedBufferGeometry ? new Ap : new _e, a = t.data.index;
        if (a !== void 0) {
            let f = Pg(a.type, a.array);
            o.setIndex(new Xe(f, 1));
        }
        let l = t.data.attributes;
        for(let f in l){
            let p = l[f], m;
            if (p.isInterleavedBufferAttribute) {
                let g = i(t.data, p.data);
                m = new xc(g, p.itemSize, p.offset, p.normalized);
            } else {
                let g = Pg(p.type, p.array), y = p.isInstancedBufferAttribute ? mo : Xe;
                m = new y(g, p.itemSize, p.normalized);
            }
            p.name !== void 0 && (m.name = p.name), p.usage !== void 0 && m.setUsage(p.usage), p.updateRange !== void 0 && (m.updateRange.offset = p.updateRange.offset, m.updateRange.count = p.updateRange.count), o.setAttribute(f, m);
        }
        let c = t.data.morphAttributes;
        if (c) for(let f in c){
            let p = c[f], m = [];
            for(let g = 0, y = p.length; g < y; g++){
                let x = p[g], v;
                if (x.isInterleavedBufferAttribute) {
                    let S = i(t.data, x.data);
                    v = new xc(S, x.itemSize, x.offset, x.normalized);
                } else {
                    let S = Pg(x.type, x.array);
                    v = new Xe(S, x.itemSize, x.normalized);
                }
                x.name !== void 0 && (v.name = x.name), m.push(v);
            }
            o.morphAttributes[f] = m;
        }
        t.data.morphTargetsRelative && (o.morphTargetsRelative = !0);
        let h = t.data.groups || t.data.drawcalls || t.data.offsets;
        if (h !== void 0) for(let f = 0, p = h.length; f !== p; ++f){
            let m = h[f];
            o.addGroup(m.start, m.count, m.materialIndex);
        }
        let d = t.data.boundingSphere;
        if (d !== void 0) {
            let f = new E;
            d.center !== void 0 && f.fromArray(d.center), o.boundingSphere = new Rr(f, d.radius);
        }
        return t.name && (o.name = t.name), t.userData && (o.userData = t.userData), o;
    }
};
var My = class {
    constructor(t = !0){
        this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    start() {
        this.startTime = XC(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            let e = XC();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return t;
    }
};
function XC() {
    return (typeof performance > "u" ? Date : performance).now();
}
var Iw = class {
    constructor(t, e, r){
        this.binding = t, this.valueSize = r;
        let i, s, o;
        switch(e){
            case "quaternion":
                i = this._slerp, s = this._slerpAdditive, o = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(r * 6), this._workIndex = 5;
                break;
            case "string":
            case "bool":
                i = this._select, s = this._select, o = this._setAdditiveIdentityOther, this.buffer = new Array(r * 5);
                break;
            default:
                i = this._lerp, s = this._lerpAdditive, o = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(r * 5);
        }
        this._mixBufferRegion = i, this._mixBufferRegionAdditive = s, this._setIdentity = o, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }
    accumulate(t, e) {
        let r = this.buffer, i = this.valueSize, s = t * i + i, o = this.cumulativeWeight;
        if (o === 0) {
            for(let a = 0; a !== i; ++a)r[s + a] = r[a];
            o = e;
        } else {
            o += e;
            let a = e / o;
            this._mixBufferRegion(r, s, 0, a, i);
        }
        this.cumulativeWeight = o;
    }
    accumulateAdditive(t) {
        let e = this.buffer, r = this.valueSize, i = r * this._addIndex;
        this.cumulativeWeightAdditive === 0 && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t, r), this.cumulativeWeightAdditive += t;
    }
    apply(t) {
        let e = this.valueSize, r = this.buffer, i = t * e + e, s = this.cumulativeWeight, o = this.cumulativeWeightAdditive, a = this.binding;
        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, s < 1) {
            let l = e * this._origIndex;
            this._mixBufferRegion(r, i, l, 1 - s, e);
        }
        o > 0 && this._mixBufferRegionAdditive(r, i, this._addIndex * e, 1, e);
        for(let l = e, c = e + e; l !== c; ++l)if (r[l] !== r[l + e]) {
            a.setValue(r, i);
            break;
        }
    }
    saveOriginalState() {
        let t = this.binding, e = this.buffer, r = this.valueSize, i = r * this._origIndex;
        t.getValue(e, i);
        for(let s = r, o = i; s !== o; ++s)e[s] = e[i + s % r];
        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
    restoreOriginalState() {
        let t = this.valueSize * 3;
        this.binding.setValue(this.buffer, t);
    }
    _setAdditiveIdentityNumeric() {
        let t = this._addIndex * this.valueSize, e = t + this.valueSize;
        for(let r = t; r < e; r++)this.buffer[r] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        let t = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
        for(let r = 0; r < this.valueSize; r++)this.buffer[e + r] = this.buffer[t + r];
    }
    _select(t, e, r, i, s) {
        if (i >= .5) for(let o = 0; o !== s; ++o)t[e + o] = t[r + o];
    }
    _slerp(t, e, r, i) {
        Ke.slerpFlat(t, e, t, e, t, r, i);
    }
    _slerpAdditive(t, e, r, i, s) {
        let o = this._workIndex * s;
        Ke.multiplyQuaternionsFlat(t, o, t, e, t, r), Ke.slerpFlat(t, e, t, e, t, o, i);
    }
    _lerp(t, e, r, i, s) {
        let o = 1 - i;
        for(let a = 0; a !== s; ++a){
            let l = e + a;
            t[l] = t[l] * o + t[r + a] * i;
        }
    }
    _lerpAdditive(t, e, r, i, s) {
        for(let o = 0; o !== s; ++o){
            let a = e + o;
            t[a] = t[a] + t[r + o] * i;
        }
    }
}, jw = "\\[\\]\\.:\\/", K4 = new RegExp("[" + jw + "]", "g"), Hw = "[^" + jw + "]", Q4 = "[^" + jw.replace("\\.", "") + "]", Z4 = /((?:WC+[\/:])*)/.source.replace("WC", Hw), J4 = /(WCOD+)?/.source.replace("WCOD", Q4), $4 = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", Hw), ej = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", Hw), tj = new RegExp("^" + Z4 + J4 + $4 + ej + "$"), rj = [
    "material",
    "materials",
    "bones",
    "map"
], Dw = class {
    constructor(t, e, r){
        let i = r || Jt.parseTrackName(e);
        this._targetGroup = t, this._bindings = t.subscribe_(e, i);
    }
    getValue(t, e) {
        this.bind();
        let r = this._targetGroup.nCachedObjects_, i = this._bindings[r];
        i !== void 0 && i.getValue(t, e);
    }
    setValue(t, e) {
        let r = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, s = r.length; i !== s; ++i)r[i].setValue(t, e);
    }
    bind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, r = t.length; e !== r; ++e)t[e].bind();
    }
    unbind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, r = t.length; e !== r; ++e)t[e].unbind();
    }
}, Jt = class {
    constructor(t, e, r){
        this.path = e, this.parsedPath = r || Jt.parseTrackName(e), this.node = Jt.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(t, e, r) {
        return t && t.isAnimationObjectGroup ? new Jt.Composite(t, e, r) : new Jt(t, e, r);
    }
    static sanitizeNodeName(t) {
        return t.replace(/\s/g, "_").replace(K4, "");
    }
    static parseTrackName(t) {
        let e = tj.exec(t);
        if (e === null) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
        let r = {
            nodeName: e[2],
            objectName: e[3],
            objectIndex: e[4],
            propertyName: e[5],
            propertyIndex: e[6]
        }, i = r.nodeName && r.nodeName.lastIndexOf(".");
        if (i !== void 0 && i !== -1) {
            let s = r.nodeName.substring(i + 1);
            rj.indexOf(s) !== -1 && (r.nodeName = r.nodeName.substring(0, i), r.objectName = s);
        }
        if (r.propertyName === null || r.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
        return r;
    }
    static findNode(t, e) {
        if (e === void 0 || e === "" || e === "." || e === -1 || e === t.name || e === t.uuid) return t;
        if (t.skeleton) {
            let r = t.skeleton.getBoneByName(e);
            if (r !== void 0) return r;
        }
        if (t.children) {
            let r = function(s) {
                for(let o = 0; o < s.length; o++){
                    let a = s[o];
                    if (a.name === e || a.uuid === e) return a;
                    let l = r(a.children);
                    if (l) return l;
                }
                return null;
            }, i = r(t.children);
            if (i) return i;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(t, e) {
        t[e] = this.targetObject[this.propertyName];
    }
    _getValue_array(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)t[e++] = r[i];
    }
    _getValue_arrayElement(t, e) {
        t[e] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(t, e) {
        this.resolvedProperty.toArray(t, e);
    }
    _setValue_direct(t, e) {
        this.targetObject[this.propertyName] = t[e];
    }
    _setValue_direct_setNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)r[i] = t[e++];
    }
    _setValue_array_setNeedsUpdate(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)r[i] = t[e++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)r[i] = t[e++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e];
    }
    _setValue_arrayElement_setNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(t, e) {
        this.resolvedProperty.fromArray(t, e);
    }
    _setValue_fromArray_setNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(t, e) {
        this.bind(), this.getValue(t, e);
    }
    _setValue_unbound(t, e) {
        this.bind(), this.setValue(t, e);
    }
    bind() {
        let t = this.node, e = this.parsedPath, r = e.objectName, i = e.propertyName, s = e.propertyIndex;
        if (t || (t = Jt.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (r) {
            let c = e.objectIndex;
            switch(r){
                case "materials":
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    t = t.material.materials;
                    break;
                case "bones":
                    if (!t.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    t = t.skeleton.bones;
                    for(let u = 0; u < t.length; u++)if (t[u].name === c) {
                        c = u;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in t) {
                        t = t.map;
                        break;
                    }
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    t = t.material.map;
                    break;
                default:
                    if (t[r] === void 0) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    t = t[r];
            }
            if (c !== void 0) {
                if (t[c] === void 0) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
                    return;
                }
                t = t[c];
            }
        }
        let o = t[i];
        if (o === void 0) {
            let c = e.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + c + "." + i + " but it wasn't found.", t);
            return;
        }
        let a = this.Versioning.None;
        this.targetObject = t, t.needsUpdate !== void 0 ? a = this.Versioning.NeedsUpdate : t.matrixWorldNeedsUpdate !== void 0 && (a = this.Versioning.MatrixWorldNeedsUpdate);
        let l = this.BindingType.Direct;
        if (s !== void 0) {
            if (i === "morphTargetInfluences") {
                if (!t.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!t.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                t.morphTargetDictionary[s] !== void 0 && (s = t.morphTargetDictionary[s]);
            }
            l = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = s;
        } else o.fromArray !== void 0 && o.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (l = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
        this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][a];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
};
Jt.Composite = Dw;
Jt.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
Jt.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
Jt.prototype.GetterByBindingType = [
    Jt.prototype._getValue_direct,
    Jt.prototype._getValue_array,
    Jt.prototype._getValue_arrayElement,
    Jt.prototype._getValue_toArray
];
Jt.prototype.SetterByBindingTypeAndVersioning = [
    [
        Jt.prototype._setValue_direct,
        Jt.prototype._setValue_direct_setNeedsUpdate,
        Jt.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        Jt.prototype._setValue_array,
        Jt.prototype._setValue_array_setNeedsUpdate,
        Jt.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        Jt.prototype._setValue_arrayElement,
        Jt.prototype._setValue_arrayElement_setNeedsUpdate,
        Jt.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        Jt.prototype._setValue_fromArray,
        Jt.prototype._setValue_fromArray_setNeedsUpdate,
        Jt.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
var Ow = class {
    constructor(t, e, r = null, i = e.blendMode){
        this._mixer = t, this._clip = e, this._localRoot = r, this.blendMode = i;
        let s = e.tracks, o = s.length, a = new Array(o), l = {
            endingStart: _u,
            endingEnd: _u
        };
        for(let c = 0; c !== o; ++c){
            let u = s[c].createInterpolant(null);
            a[c] = u, u.settings = l;
        }
        this._interpolantSettings = l, this._interpolants = a, this._propertyBindings = new Array(o), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = Nw, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    play() {
        return this._mixer._activateAction(this), this;
    }
    stop() {
        return this._mixer._deactivateAction(this), this.reset();
    }
    reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(t) {
        return this._startTime = t, this;
    }
    setLoop(t, e) {
        return this.loop = t, this.repetitions = e, this;
    }
    setEffectiveWeight(t) {
        return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
    }
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(t) {
        return this._scheduleFading(t, 0, 1);
    }
    fadeOut(t) {
        return this._scheduleFading(t, 1, 0);
    }
    crossFadeFrom(t, e, r) {
        if (t.fadeOut(e), this.fadeIn(e), r) {
            let i = this._clip.duration, s = t._clip.duration, o = s / i, a = i / s;
            t.warp(1, o, e), this.warp(a, 1, e);
        }
        return this;
    }
    crossFadeTo(t, e, r) {
        return t.crossFadeFrom(this, e, r);
    }
    stopFading() {
        let t = this._weightInterpolant;
        return t !== null && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    setEffectiveTimeScale(t) {
        return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
    }
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(t) {
        return this.timeScale = this._clip.duration / t, this.stopWarping();
    }
    syncWith(t) {
        return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
    }
    halt(t) {
        return this.warp(this._effectiveTimeScale, 0, t);
    }
    warp(t, e, r) {
        let i = this._mixer, s = i.time, o = this.timeScale, a = this._timeScaleInterpolant;
        a === null && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
        let l = a.parameterPositions, c = a.sampleValues;
        return l[0] = s, l[1] = s + r, c[0] = t / o, c[1] = e / o, this;
    }
    stopWarping() {
        let t = this._timeScaleInterpolant;
        return t !== null && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    _update(t, e, r, i) {
        if (!this.enabled) {
            this._updateWeight(t);
            return;
        }
        let s = this._startTime;
        if (s !== null) {
            let l = (t - s) * r;
            l < 0 || r === 0 ? e = 0 : (this._startTime = null, e = r * l);
        }
        e *= this._updateTimeScale(t);
        let o = this._updateTime(e), a = this._updateWeight(t);
        if (a > 0) {
            let l = this._interpolants, c = this._propertyBindings;
            switch(this.blendMode){
                case gV:
                    for(let u = 0, h = l.length; u !== h; ++u)l[u].evaluate(o), c[u].accumulateAdditive(a);
                    break;
                case Fw:
                default:
                    for(let u = 0, h = l.length; u !== h; ++u)l[u].evaluate(o), c[u].accumulate(i, a);
            }
        }
    }
    _updateWeight(t) {
        let e = 0;
        if (this.enabled) {
            e = this.weight;
            let r = this._weightInterpolant;
            if (r !== null) {
                let i = r.evaluate(t)[0];
                e *= i, t > r.parameterPositions[1] && (this.stopFading(), i === 0 && (this.enabled = !1));
            }
        }
        return this._effectiveWeight = e, e;
    }
    _updateTimeScale(t) {
        let e = 0;
        if (!this.paused) {
            e = this.timeScale;
            let r = this._timeScaleInterpolant;
            if (r !== null) {
                let i = r.evaluate(t)[0];
                e *= i, t > r.parameterPositions[1] && (this.stopWarping(), e === 0 ? this.paused = !0 : this.timeScale = e);
            }
        }
        return this._effectiveTimeScale = e, e;
    }
    _updateTime(t) {
        let e = this._clip.duration, r = this.loop, i = this.time + t, s = this._loopCount, o = r === Tp;
        if (t === 0) return s === -1 ? i : o && (s & 1) === 1 ? e - i : i;
        if (r === Bw) {
            s === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
            e: {
                if (i >= e) i = e;
                else if (i < 0) i = 0;
                else {
                    this.time = i;
                    break e;
                }
                this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t < 0 ? -1 : 1
                });
            }
        } else {
            if (s === -1 && (t >= 0 ? (s = 0, this._setEndings(!0, this.repetitions === 0, o)) : this._setEndings(this.repetitions === 0, !0, o)), i >= e || i < 0) {
                let a = Math.floor(i / e);
                i -= e * a, s += Math.abs(a);
                let l = this.repetitions - s;
                if (l <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t > 0 ? 1 : -1
                });
                else {
                    if (l === 1) {
                        let c = t < 0;
                        this._setEndings(c, !c, o);
                    } else this._setEndings(!1, !1, o);
                    this._loopCount = s, this.time = i, this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: a
                    });
                }
            } else this.time = i;
            if (o && (s & 1) === 1) return e - i;
        }
        return i;
    }
    _setEndings(t, e, r) {
        let i = this._interpolantSettings;
        r ? (i.endingStart = Iu, i.endingEnd = Iu) : (t ? i.endingStart = this.zeroSlopeAtStart ? Iu : _u : i.endingStart = sy, e ? i.endingEnd = this.zeroSlopeAtEnd ? Iu : _u : i.endingEnd = sy);
    }
    _scheduleFading(t, e, r) {
        let i = this._mixer, s = i.time, o = this._weightInterpolant;
        o === null && (o = i._lendControlInterpolant(), this._weightInterpolant = o);
        let a = o.parameterPositions, l = o.sampleValues;
        return a[0] = s, l[0] = e, a[1] = s + t, l[1] = r, this;
    }
}, ij = new Float32Array(1), Cy = class extends pr {
    constructor(t){
        super(), this._root = t, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    _bindAction(t, e) {
        let r = t._localRoot || this._root, i = t._clip.tracks, s = i.length, o = t._propertyBindings, a = t._interpolants, l = r.uuid, c = this._bindingsByRootAndName, u = c[l];
        u === void 0 && (u = {}, c[l] = u);
        for(let h = 0; h !== s; ++h){
            let d = i[h], f = d.name, p = u[f];
            if (p !== void 0) ++p.referenceCount, o[h] = p;
            else {
                if (p = o[h], p !== void 0) {
                    p._cacheIndex === null && (++p.referenceCount, this._addInactiveBinding(p, l, f));
                    continue;
                }
                let m = e && e._propertyBindings[h].binding.parsedPath;
                p = new Iw(Jt.create(r, f, m), d.ValueTypeName, d.getValueSize()), ++p.referenceCount, this._addInactiveBinding(p, l, f), o[h] = p;
            }
            a[h].resultBuffer = p.buffer;
        }
    }
    _activateAction(t) {
        if (!this._isActiveAction(t)) {
            if (t._cacheIndex === null) {
                let r = (t._localRoot || this._root).uuid, i = t._clip.uuid, s = this._actionsByClip[i];
                this._bindAction(t, s && s.knownActions[0]), this._addInactiveAction(t, i, r);
            }
            let e = t._propertyBindings;
            for(let r = 0, i = e.length; r !== i; ++r){
                let s = e[r];
                s.useCount++ === 0 && (this._lendBinding(s), s.saveOriginalState());
            }
            this._lendAction(t);
        }
    }
    _deactivateAction(t) {
        if (this._isActiveAction(t)) {
            let e = t._propertyBindings;
            for(let r = 0, i = e.length; r !== i; ++r){
                let s = e[r];
                --s.useCount === 0 && (s.restoreOriginalState(), this._takeBackBinding(s));
            }
            this._takeBackAction(t);
        }
    }
    _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        let t = this;
        this.stats = {
            actions: {
                get total () {
                    return t._actions.length;
                },
                get inUse () {
                    return t._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return t._bindings.length;
                },
                get inUse () {
                    return t._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return t._controlInterpolants.length;
                },
                get inUse () {
                    return t._nActiveControlInterpolants;
                }
            }
        };
    }
    _isActiveAction(t) {
        let e = t._cacheIndex;
        return e !== null && e < this._nActiveActions;
    }
    _addInactiveAction(t, e, r) {
        let i = this._actions, s = this._actionsByClip, o = s[e];
        if (o === void 0) o = {
            knownActions: [
                t
            ],
            actionByRoot: {}
        }, t._byClipCacheIndex = 0, s[e] = o;
        else {
            let a = o.knownActions;
            t._byClipCacheIndex = a.length, a.push(t);
        }
        t._cacheIndex = i.length, i.push(t), o.actionByRoot[r] = t;
    }
    _removeInactiveAction(t) {
        let e = this._actions, r = e[e.length - 1], i = t._cacheIndex;
        r._cacheIndex = i, e[i] = r, e.pop(), t._cacheIndex = null;
        let s = t._clip.uuid, o = this._actionsByClip, a = o[s], l = a.knownActions, c = l[l.length - 1], u = t._byClipCacheIndex;
        c._byClipCacheIndex = u, l[u] = c, l.pop(), t._byClipCacheIndex = null;
        let h = a.actionByRoot, d = (t._localRoot || this._root).uuid;
        delete h[d], l.length === 0 && delete o[s], this._removeInactiveBindingsForAction(t);
    }
    _removeInactiveBindingsForAction(t) {
        let e = t._propertyBindings;
        for(let r = 0, i = e.length; r !== i; ++r){
            let s = e[r];
            --s.referenceCount === 0 && this._removeInactiveBinding(s);
        }
    }
    _lendAction(t) {
        let e = this._actions, r = t._cacheIndex, i = this._nActiveActions++, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _takeBackAction(t) {
        let e = this._actions, r = t._cacheIndex, i = --this._nActiveActions, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _addInactiveBinding(t, e, r) {
        let i = this._bindingsByRootAndName, s = this._bindings, o = i[e];
        o === void 0 && (o = {}, i[e] = o), o[r] = t, t._cacheIndex = s.length, s.push(t);
    }
    _removeInactiveBinding(t) {
        let e = this._bindings, r = t.binding, i = r.rootNode.uuid, s = r.path, o = this._bindingsByRootAndName, a = o[i], l = e[e.length - 1], c = t._cacheIndex;
        l._cacheIndex = c, e[c] = l, e.pop(), delete a[s], Object.keys(a).length === 0 && delete o[i];
    }
    _lendBinding(t) {
        let e = this._bindings, r = t._cacheIndex, i = this._nActiveBindings++, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _takeBackBinding(t) {
        let e = this._bindings, r = t._cacheIndex, i = --this._nActiveBindings, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _lendControlInterpolant() {
        let t = this._controlInterpolants, e = this._nActiveControlInterpolants++, r = t[e];
        return r === void 0 && (r = new vy(new Float32Array(2), new Float32Array(2), 1, ij), r.__cacheIndex = e, t[e] = r), r;
    }
    _takeBackControlInterpolant(t) {
        let e = this._controlInterpolants, r = t.__cacheIndex, i = --this._nActiveControlInterpolants, s = e[i];
        t.__cacheIndex = i, e[i] = t, s.__cacheIndex = r, e[r] = s;
    }
    clipAction(t, e, r) {
        let i = e || this._root, s = i.uuid, o = typeof t == "string" ? Xu.findByName(i, t) : t, a = o !== null ? o.uuid : t, l = this._actionsByClip[a], c = null;
        if (r === void 0 && (o !== null ? r = o.blendMode : r = Fw), l !== void 0) {
            let h = l.actionByRoot[s];
            if (h !== void 0 && h.blendMode === r) return h;
            c = l.knownActions[0], o === null && (o = c._clip);
        }
        if (o === null) return null;
        let u = new Ow(this, o, e, r);
        return this._bindAction(u, c), this._addInactiveAction(u, a, s), u;
    }
    existingAction(t, e) {
        let r = e || this._root, i = r.uuid, s = typeof t == "string" ? Xu.findByName(r, t) : t, o = s ? s.uuid : t, a = this._actionsByClip[o];
        return a !== void 0 && a.actionByRoot[i] || null;
    }
    stopAllAction() {
        let t = this._actions, e = this._nActiveActions;
        for(let r = e - 1; r >= 0; --r)t[r].stop();
        return this;
    }
    update(t) {
        t *= this.timeScale;
        let e = this._actions, r = this._nActiveActions, i = this.time += t, s = Math.sign(t), o = this._accuIndex ^= 1;
        for(let c = 0; c !== r; ++c)e[c]._update(i, t, s, o);
        let a = this._bindings, l = this._nActiveBindings;
        for(let c = 0; c !== l; ++c)a[c].apply(o);
        return this;
    }
    setTime(t) {
        this.time = 0;
        for(let e = 0; e < this._actions.length; e++)this._actions[e].time = 0;
        return this.update(t);
    }
    getRoot() {
        return this._root;
    }
    uncacheClip(t) {
        let e = this._actions, r = t.uuid, i = this._actionsByClip, s = i[r];
        if (s !== void 0) {
            let o = s.knownActions;
            for(let a = 0, l = o.length; a !== l; ++a){
                let c = o[a];
                this._deactivateAction(c);
                let u = c._cacheIndex, h = e[e.length - 1];
                c._cacheIndex = null, c._byClipCacheIndex = null, h._cacheIndex = u, e[u] = h, e.pop(), this._removeInactiveBindingsForAction(c);
            }
            delete i[r];
        }
    }
    uncacheRoot(t) {
        let e = t.uuid, r = this._actionsByClip;
        for(let o in r){
            let a = r[o].actionByRoot, l = a[e];
            l !== void 0 && (this._deactivateAction(l), this._removeInactiveAction(l));
        }
        let i = this._bindingsByRootAndName, s = i[e];
        if (s !== void 0) for(let o in s){
            let a = s[o];
            a.restoreOriginalState(), this._removeInactiveBinding(a);
        }
    }
    uncacheAction(t, e) {
        let r = this.existingAction(t, e);
        r !== null && (this._deactivateAction(r), this._removeInactiveAction(r));
    }
}, le = class {
    constructor(t){
        this.value = t;
    }
    clone() {
        return new le(this.value.clone === void 0 ? this.value : this.value.clone());
    }
};
var Zu = class {
    constructor(t, e, r = 0, i = 1 / 0){
        this.ray = new Ls(t, e), this.near = r, this.far = i, this.camera = null, this.layers = new dp, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(t, e) {
        this.ray.set(t, e);
    }
    setFromCamera(t, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
    intersectObject(t, e = !0, r = []) {
        return Rw(t, this, r, e), r.sort(KC), r;
    }
    intersectObjects(t, e = !0, r = []) {
        for(let i = 0, s = t.length; i < s; i++)Rw(t[i], this, r, e);
        return r.sort(KC), r;
    }
};
function KC(n1, t) {
    return n1.distance - t.distance;
}
function Rw(n1, t, e, r) {
    if (n1.layers.test(t.layers) && n1.raycast(t, e), r === !0) {
        let i = n1.children;
        for(let s = 0, o = i.length; s < o; s++)Rw(i[s], t, e, !0);
    }
}
var Ep = class {
    constructor(t = 1, e = 0, r = 0){
        return this.radius = t, this.phi = e, this.theta = r, this;
    }
    set(t, e, r) {
        return this.radius = t, this.phi = e, this.theta = r, this;
    }
    copy(t) {
        return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
    makeSafe() {
        return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
    }
    setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
    setFromCartesianCoords(t, e, r) {
        return this.radius = Math.sqrt(t * t + e * e + r * r), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, r), this.phi = Math.acos(di(e / this.radius, -1, 1))), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
var QC = new k, Ju = class {
    constructor(t = new k(1 / 0, 1 / 0), e = new k(-1 / 0, -1 / 0)){
        this.isBox2 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, r = t.length; e < r; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let r = QC.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y);
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return QC.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, ZC = new E, $g = new E, Ti = class {
    constructor(t = new E, e = new E){
        this.start = t, this.end = e;
    }
    set(t, e) {
        return this.start.copy(t), this.end.copy(e), this;
    }
    copy(t) {
        return this.start.copy(t.start), this.end.copy(t.end), this;
    }
    getCenter(t) {
        return t.addVectors(this.start, this.end).multiplyScalar(.5);
    }
    delta(t) {
        return t.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, e) {
        return this.delta(e).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(t, e) {
        ZC.subVectors(t, this.start), $g.subVectors(this.end, this.start);
        let r = $g.dot($g), s = $g.dot(ZC) / r;
        return e && (s = di(s, 0, 1)), s;
    }
    closestPointToPoint(t, e, r) {
        let i = this.closestPointToPointParameter(t, e);
        return this.delta(r).multiplyScalar(i).add(this.start);
    }
    applyMatrix4(t) {
        return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
    }
    equals(t) {
        return t.start.equals(this.start) && t.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, JC = new E, Py = class extends Tt {
    constructor(t, e){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
        let r = new _e, i = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let o = 0, a = 1, l = 32; o < l; o++, a++){
            let c = o / l * Math.PI * 2, u = a / l * Math.PI * 2;
            i.push(Math.cos(c), Math.sin(c), 1, Math.cos(u), Math.sin(u), 1);
        }
        r.setAttribute("position", new Te(i, 3));
        let s = new ss({
            fog: !1,
            toneMapped: !1
        });
        this.cone = new nl(r, s), this.add(this.cone), this.update();
    }
    dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
        let t = this.light.distance ? this.light.distance : 1e3, e = t * Math.tan(this.light.angle);
        this.cone.scale.set(e, e, t), JC.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(JC), this.color !== void 0 ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
    }
};
var _y = class extends zt {
    constructor(t, e, r){
        let i = new Bs(e, 4, 2), s = new on({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        });
        super(i, s), this.light = t, this.color = r, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.color !== void 0 ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
    }
};
var $C = new E, ey = new E, eP = new E, Iy = class extends Tt {
    constructor(t, e, r){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = r, this.type = "DirectionalLightHelper", e === void 0 && (e = 1);
        let i = new _e;
        i.setAttribute("position", new Te([
            -e,
            e,
            0,
            e,
            e,
            0,
            e,
            -e,
            0,
            -e,
            -e,
            0,
            -e,
            e,
            0
        ], 3));
        let s = new ss({
            fog: !1,
            toneMapped: !1
        });
        this.lightPlane = new bc(i, s), this.add(this.lightPlane), i = new _e, i.setAttribute("position", new Te([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3)), this.targetLine = new bc(i, s), this.add(this.targetLine), this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), $C.setFromMatrixPosition(this.light.matrixWorld), ey.setFromMatrixPosition(this.light.target.matrixWorld), eP.subVectors(ey, $C), this.lightPlane.lookAt(ey), this.color !== void 0 ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(ey), this.targetLine.scale.z = eP.length();
    }
}, ty = new E, Wr = new qn, ul = class extends nl {
    constructor(t){
        let e = new _e, r = new ss({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), i = [], s = [], o = {};
        a("n1", "n2"), a("n2", "n4"), a("n4", "n3"), a("n3", "n1"), a("f1", "f2"), a("f2", "f4"), a("f4", "f3"), a("f3", "f1"), a("n1", "f1"), a("n2", "f2"), a("n3", "f3"), a("n4", "f4"), a("p", "n1"), a("p", "n2"), a("p", "n3"), a("p", "n4"), a("u1", "u2"), a("u2", "u3"), a("u3", "u1"), a("c", "t"), a("p", "c"), a("cn1", "cn2"), a("cn3", "cn4"), a("cf1", "cf2"), a("cf3", "cf4");
        function a(p, m) {
            l(p), l(m);
        }
        function l(p) {
            i.push(0, 0, 0), s.push(0, 0, 0), o[p] === void 0 && (o[p] = []), o[p].push(i.length / 3 - 1);
        }
        e.setAttribute("position", new Te(i, 3)), e.setAttribute("color", new Te(s, 3)), super(e, r), this.type = "CameraHelper", this.camera = t, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = o, this.update();
        let c = new We(16755200), u = new We(16711680), h = new We(43775), d = new We(16777215), f = new We(3355443);
        this.setColors(c, u, h, d, f);
    }
    setColors(t, e, r, i, s) {
        let a = this.geometry.getAttribute("color");
        a.setXYZ(0, t.r, t.g, t.b), a.setXYZ(1, t.r, t.g, t.b), a.setXYZ(2, t.r, t.g, t.b), a.setXYZ(3, t.r, t.g, t.b), a.setXYZ(4, t.r, t.g, t.b), a.setXYZ(5, t.r, t.g, t.b), a.setXYZ(6, t.r, t.g, t.b), a.setXYZ(7, t.r, t.g, t.b), a.setXYZ(8, t.r, t.g, t.b), a.setXYZ(9, t.r, t.g, t.b), a.setXYZ(10, t.r, t.g, t.b), a.setXYZ(11, t.r, t.g, t.b), a.setXYZ(12, t.r, t.g, t.b), a.setXYZ(13, t.r, t.g, t.b), a.setXYZ(14, t.r, t.g, t.b), a.setXYZ(15, t.r, t.g, t.b), a.setXYZ(16, t.r, t.g, t.b), a.setXYZ(17, t.r, t.g, t.b), a.setXYZ(18, t.r, t.g, t.b), a.setXYZ(19, t.r, t.g, t.b), a.setXYZ(20, t.r, t.g, t.b), a.setXYZ(21, t.r, t.g, t.b), a.setXYZ(22, t.r, t.g, t.b), a.setXYZ(23, t.r, t.g, t.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, r.r, r.g, r.b), a.setXYZ(33, r.r, r.g, r.b), a.setXYZ(34, r.r, r.g, r.b), a.setXYZ(35, r.r, r.g, r.b), a.setXYZ(36, r.r, r.g, r.b), a.setXYZ(37, r.r, r.g, r.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, s.r, s.g, s.b), a.setXYZ(41, s.r, s.g, s.b), a.setXYZ(42, s.r, s.g, s.b), a.setXYZ(43, s.r, s.g, s.b), a.setXYZ(44, s.r, s.g, s.b), a.setXYZ(45, s.r, s.g, s.b), a.setXYZ(46, s.r, s.g, s.b), a.setXYZ(47, s.r, s.g, s.b), a.setXYZ(48, s.r, s.g, s.b), a.setXYZ(49, s.r, s.g, s.b), a.needsUpdate = !0;
    }
    update() {
        let t = this.geometry, e = this.pointMap, r = 1, i = 1;
        Wr.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), Jr("c", e, t, Wr, 0, 0, -1), Jr("t", e, t, Wr, 0, 0, 1), Jr("n1", e, t, Wr, -r, -i, -1), Jr("n2", e, t, Wr, r, -i, -1), Jr("n3", e, t, Wr, -r, i, -1), Jr("n4", e, t, Wr, r, i, -1), Jr("f1", e, t, Wr, -r, -i, 1), Jr("f2", e, t, Wr, r, -i, 1), Jr("f3", e, t, Wr, -r, i, 1), Jr("f4", e, t, Wr, r, i, 1), Jr("u1", e, t, Wr, r * .7, i * 1.1, -1), Jr("u2", e, t, Wr, -r * .7, i * 1.1, -1), Jr("u3", e, t, Wr, 0, i * 2, -1), Jr("cf1", e, t, Wr, -r, 0, 1), Jr("cf2", e, t, Wr, r, 0, 1), Jr("cf3", e, t, Wr, 0, -i, 1), Jr("cf4", e, t, Wr, 0, i, 1), Jr("cn1", e, t, Wr, -r, 0, -1), Jr("cn2", e, t, Wr, r, 0, -1), Jr("cn3", e, t, Wr, 0, -i, -1), Jr("cn4", e, t, Wr, 0, i, -1), t.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function Jr(n1, t, e, r, i, s, o) {
    ty.set(i, s, o).unproject(r);
    let a = t[n1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let c = 0, u = a.length; c < u; c++)l.setXYZ(a[c], ty.x, ty.y, ty.z);
    }
}
var hl = class extends nl {
    constructor(t, e = 16776960){
        let r = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), i = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ], s = new _e;
        s.setIndex(new Xe(r, 1)), s.setAttribute("position", new Te(i, 3)), super(s, new ss({
            color: e,
            toneMapped: !1
        })), this.box = t, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(t) {
        let e = this.box;
        e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t));
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var Dy = class extends nl {
    constructor(t = 1){
        let e = [
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t
        ], r = [
            1,
            0,
            0,
            1,
            .6,
            0,
            0,
            1,
            0,
            .6,
            1,
            0,
            0,
            0,
            1,
            0,
            .6,
            1
        ], i = new _e;
        i.setAttribute("position", new Te(e, 3)), i.setAttribute("color", new Te(r, 3));
        let s = new ss({
            vertexColors: !0,
            toneMapped: !1
        });
        super(i, s), this.type = "AxesHelper";
    }
    setColors(t, e, r) {
        let i = new We, s = this.geometry.attributes.color.array;
        return i.set(t), i.toArray(s, 0), i.toArray(s, 3), i.set(e), i.toArray(s, 6), i.toArray(s, 9), i.set(r), i.toArray(s, 12), i.toArray(s, 15), this.geometry.attributes.color.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var oa = nj();
function nj() {
    let n1 = new ArrayBuffer(4), t = new Float32Array(n1), e = new Uint32Array(n1), r = new Uint32Array(512), i = new Uint32Array(512);
    for(let l = 0; l < 256; ++l){
        let c = l - 127;
        c < -27 ? (r[l] = 0, r[l | 256] = 32768, i[l] = 24, i[l | 256] = 24) : c < -14 ? (r[l] = 1024 >> -c - 14, r[l | 256] = 1024 >> -c - 14 | 32768, i[l] = -c - 1, i[l | 256] = -c - 1) : c <= 15 ? (r[l] = c + 15 << 10, r[l | 256] = c + 15 << 10 | 32768, i[l] = 13, i[l | 256] = 13) : c < 128 ? (r[l] = 31744, r[l | 256] = 64512, i[l] = 24, i[l | 256] = 24) : (r[l] = 31744, r[l | 256] = 64512, i[l] = 13, i[l | 256] = 13);
    }
    let s = new Uint32Array(2048), o = new Uint32Array(64), a = new Uint32Array(64);
    for(let l = 1; l < 1024; ++l){
        let c = l << 13, u = 0;
        for(; (c & 8388608) === 0;)c <<= 1, u -= 8388608;
        c &= -8388609, u += 947912704, s[l] = c | u;
    }
    for(let l = 1024; l < 2048; ++l)s[l] = 939524096 + (l - 1024 << 13);
    for(let l = 1; l < 31; ++l)o[l] = l << 23;
    o[31] = 1199570944, o[32] = 2147483648;
    for(let l = 33; l < 63; ++l)o[l] = 2147483648 + (l - 32 << 23);
    o[63] = 3347054592;
    for(let l = 1; l < 64; ++l)l !== 32 && (a[l] = 1024);
    return {
        floatView: t,
        uint32View: e,
        baseTable: r,
        shiftTable: i,
        mantissaTable: s,
        exponentTable: o,
        offsetTable: a
    };
}
function sj(n1) {
    Math.abs(n1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), n1 = di(n1, -65504, 65504), oa.floatView[0] = n1;
    let t = oa.uint32View[0], e = t >> 23 & 511;
    return oa.baseTable[e] + ((t & 8388607) >> oa.shiftTable[e]);
}
function oj(n1) {
    let t = n1 >> 10;
    return oa.uint32View[0] = oa.mantissaTable[oa.offsetTable[t] + (n1 & 1023)] + oa.exponentTable[t], oa.floatView[0];
}
var SP = Object.freeze({
    __proto__: null,
    fromHalfFloat: oj,
    toHalfFloat: sj
});
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: ca
    }
}));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = ca);
var rh = ".", Mp = Symbol("target"), Ww = Symbol("unsubscribe");
function Cp(n1) {
    return n1 instanceof Date || n1 instanceof Set || n1 instanceof Map || n1 instanceof WeakSet || n1 instanceof WeakMap || ArrayBuffer.isView(n1);
}
function wP(n1) {
    return (typeof n1 == "object" ? n1 === null : typeof n1 != "function") || n1 instanceof RegExp;
}
var Kn = Array.isArray;
function Cc(n1) {
    return typeof n1 == "symbol";
}
var aj = {
    after: (n1, t)=>Kn(n1) ? n1.slice(t.length) : t === "" ? n1 : n1.slice(t.length + 1),
    concat: (n1, t)=>Kn(n1) ? (n1 = [
            ...n1
        ], t && n1.push(t), n1) : t && t.toString !== void 0 ? (n1 !== "" && (n1 += rh), Cc(t) ? n1 + t.toString() : n1 + t) : n1,
    initial: (n1)=>{
        if (Kn(n1)) return n1.slice(0, -1);
        if (n1 === "") return n1;
        let t = n1.lastIndexOf(rh);
        return t === -1 ? "" : n1.slice(0, t);
    },
    last: (n1)=>{
        if (Kn(n1)) return n1[n1.length - 1] || "";
        if (n1 === "") return n1;
        let t = n1.lastIndexOf(rh);
        return t === -1 ? n1 : n1.slice(t + 1);
    },
    walk: (n1, t)=>{
        if (Kn(n1)) for (let e of n1)t(e);
        else if (n1 !== "") {
            let e = 0, r = n1.indexOf(rh);
            if (r === -1) t(n1);
            else for(; e < n1.length;)r === -1 && (r = n1.length), t(n1.slice(e, r)), e = r + 1, r = n1.indexOf(rh, e);
        }
    },
    get (n1, t) {
        return this.walk(t, (e)=>{
            n1 && (n1 = n1[e]);
        }), n1;
    }
}, gn = aj;
function qw(n1) {
    return typeof n1 == "object" && typeof n1.next == "function";
}
function Yw(n1, t, e, r, i) {
    let s = n1.next;
    if (t.name === "entries") n1.next = function() {
        let o = s.call(this);
        return o.done === !1 && (o.value[0] = i(o.value[0], t, o.value[0], r), o.value[1] = i(o.value[1], t, o.value[0], r)), o;
    };
    else if (t.name === "values") {
        let o = e[Mp].keys();
        n1.next = function() {
            let a = s.call(this);
            return a.done === !1 && (a.value = i(a.value, t, o.next().value, r)), a;
        };
    } else n1.next = function() {
        let o = s.call(this);
        return o.done === !1 && (o.value = i(o.value, t, o.value, r)), o;
    };
    return n1;
}
function By(n1, t, e) {
    return n1.isUnsubscribed || t.ignoreSymbols && Cc(e) || t.ignoreUnderscores && e.charAt(0) === "_" || "ignoreKeys" in t && t.ignoreKeys.includes(e);
}
var Pp = class {
    constructor(t){
        this._equals = t, this._proxyCache = new WeakMap, this._pathCache = new WeakMap, this.isUnsubscribed = !1;
    }
    _getDescriptorCache() {
        return this._descriptorCache === void 0 && (this._descriptorCache = new WeakMap), this._descriptorCache;
    }
    _getProperties(t) {
        let e = this._getDescriptorCache(), r = e.get(t);
        return r === void 0 && (r = {}, e.set(t, r)), r;
    }
    _getOwnPropertyDescriptor(t, e) {
        if (this.isUnsubscribed) return Reflect.getOwnPropertyDescriptor(t, e);
        let r = this._getProperties(t), i = r[e];
        return i === void 0 && (i = Reflect.getOwnPropertyDescriptor(t, e), r[e] = i), i;
    }
    getProxy(t, e, r, i) {
        if (this.isUnsubscribed) return t;
        let s = t[i], o = s || t;
        this._pathCache.set(o, e);
        let a = this._proxyCache.get(o);
        return a === void 0 && (a = s === void 0 ? new Proxy(t, r) : t, this._proxyCache.set(o, a)), a;
    }
    getPath(t) {
        return this.isUnsubscribed ? void 0 : this._pathCache.get(t);
    }
    isDetached(t, e) {
        return !Object.is(t, gn.get(e, this.getPath(t)));
    }
    defineProperty(t, e, r) {
        return Reflect.defineProperty(t, e, r) ? (this.isUnsubscribed || (this._getProperties(t)[e] = r), !0) : !1;
    }
    setProperty(t, e, r, i, s) {
        if (!this._equals(s, r) || !(e in t)) {
            let o = this._getOwnPropertyDescriptor(t, e);
            return o !== void 0 && "set" in o ? Reflect.set(t, e, r, i) : Reflect.set(t, e, r);
        }
        return !0;
    }
    deleteProperty(t, e, r) {
        if (Reflect.deleteProperty(t, e)) {
            if (!this.isUnsubscribed) {
                let i = this._getDescriptorCache().get(t);
                i && (delete i[e], this._pathCache.delete(r));
            }
            return !0;
        }
        return !1;
    }
    isSameDescriptor(t, e, r) {
        let i = this._getOwnPropertyDescriptor(e, r);
        return t !== void 0 && i !== void 0 && Object.is(t.value, i.value) && (t.writable || !1) === (i.writable || !1) && (t.enumerable || !1) === (i.enumerable || !1) && (t.configurable || !1) === (i.configurable || !1) && t.get === i.get && t.set === i.set;
    }
    isGetInvariant(t, e) {
        let r = this._getOwnPropertyDescriptor(t, e);
        return r !== void 0 && r.configurable !== !0 && r.writable !== !0;
    }
    unsubscribe() {
        this._descriptorCache = null, this._pathCache = null, this._proxyCache = null, this.isUnsubscribed = !0;
    }
};
function ih(n1) {
    return toString.call(n1) === "[object Object]";
}
function nh() {
    return !0;
}
function dl(n1, t) {
    return n1.length !== t.length || n1.some((e, r)=>t[r] !== e);
}
var Ny = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
]);
var lj = new Set([
    "concat",
    "includes",
    "indexOf",
    "join",
    "keys",
    "lastIndexOf"
]), Xw = {
    push: nh,
    pop: nh,
    shift: nh,
    unshift: nh,
    copyWithin: dl,
    reverse: dl,
    sort: dl,
    splice: dl,
    flat: dl,
    fill: dl
}, AP = new Set([
    ...Ny,
    ...lj,
    ...Object.keys(Xw)
]);
function sh(n1, t) {
    if (n1.size !== t.size) return !0;
    for (let e of n1)if (!t.has(e)) return !0;
    return !1;
}
var Kw = [
    "keys",
    "values",
    "entries"
], Qw = new Set([
    "has",
    "toString"
]), Zw = {
    add: sh,
    clear: sh,
    delete: sh,
    forEach: sh
}, EP = new Set([
    ...Qw,
    ...Object.keys(Zw),
    ...Kw
]);
function oh(n1, t) {
    if (n1.size !== t.size) return !0;
    let e;
    for (let [r, i] of n1)if (e = t.get(r), e !== i || e === void 0 && !t.has(r)) return !0;
    return !1;
}
var cj = new Set([
    ...Qw,
    "get"
]), Jw = {
    set: oh,
    clear: oh,
    delete: oh,
    forEach: oh
}, TP = new Set([
    ...cj,
    ...Object.keys(Jw),
    ...Kw
]);
var Ni = class {
    constructor(t, e, r, i){
        this._path = e, this._isChanged = !1, this._clonedCache = new Set, this._hasOnValidate = i, this._changes = i ? [] : null, this.clone = e === void 0 ? t : this._shallowClone(t);
    }
    static isHandledMethod(t) {
        return Ny.has(t);
    }
    _shallowClone(t) {
        let e = t;
        if (ih(t)) e = {
            ...t
        };
        else if (Kn(t)) e = [
            ...t
        ];
        else if (t instanceof Date) e = new Date(t);
        else if (t instanceof Set) e = new Set([
            ...t
        ].map((r)=>this._shallowClone(r)));
        else if (t instanceof Map) {
            e = new Map;
            for (let [r, i] of t.entries())e.set(r, this._shallowClone(i));
        }
        return this._clonedCache.add(e), e;
    }
    preferredThisArg(t, e, r, i) {
        return t ? (Kn(i) ? this._onIsChanged = Xw[e] : i instanceof Set ? this._onIsChanged = Zw[e] : i instanceof Map && (this._onIsChanged = Jw[e]), i) : r;
    }
    update(t, e, r) {
        let i = gn.after(t, this._path);
        if (e !== "length") {
            let s = this.clone;
            gn.walk(i, (o)=>{
                s && s[o] && (this._clonedCache.has(s[o]) || (s[o] = this._shallowClone(s[o])), s = s[o]);
            }), this._hasOnValidate && this._changes.push({
                path: i,
                property: e,
                previous: r
            }), s && s[e] && (s[e] = r);
        }
        this._isChanged = !0;
    }
    undo(t) {
        let e;
        for(let r = this._changes.length - 1; r !== -1; r--)e = this._changes[r], gn.get(t, e.path)[e.property] = e.previous;
    }
    isChanged(t) {
        return this._onIsChanged === void 0 ? this._isChanged : this._onIsChanged(this.clone, t);
    }
};
var ah = class extends Ni {
    static isHandledMethod(t) {
        return AP.has(t);
    }
};
var _p = class extends Ni {
    undo(t) {
        t.setTime(this.clone.getTime());
    }
    isChanged(t, e) {
        return !e(this.clone.valueOf(), t.valueOf());
    }
};
var lh = class extends Ni {
    static isHandledMethod(t) {
        return EP.has(t);
    }
    undo(t) {
        for (let e of this.clone)t.add(e);
        for (let e of t)this.clone.has(e) || t.delete(e);
    }
};
var ch = class extends Ni {
    static isHandledMethod(t) {
        return TP.has(t);
    }
    undo(t) {
        for (let [e, r] of this.clone.entries())t.set(e, r);
        for (let e of t.keys())this.clone.has(e) || t.delete(e);
    }
};
var Ip = class extends Ni {
    constructor(t, e, r, i){
        super(void 0, e, r, i), this._arg1 = r[0], this._weakValue = t.has(this._arg1);
    }
    isChanged(t) {
        return this._weakValue !== t.has(this._arg1);
    }
    undo(t) {
        this._weakValue && !t.has(this._arg1) ? t.add(this._arg1) : t.delete(this._arg1);
    }
};
var Dp = class extends Ni {
    constructor(t, e, r, i){
        super(void 0, e, r, i), this._weakKey = r[0], this._weakHas = t.has(this._weakKey), this._weakValue = t.get(this._weakKey);
    }
    isChanged(t) {
        return this._weakValue !== t.get(this._weakKey);
    }
    undo(t) {
        let e = t.has(this._weakKey);
        this._weakHas && !e ? t.set(this._weakKey, this._weakValue) : !this._weakHas && e ? t.delete(this._weakKey) : this._weakValue !== t.get(this._weakKey) && t.set(this._weakKey, this._weakValue);
    }
};
var Fs = class {
    constructor(t){
        this._stack = [], this._hasOnValidate = t;
    }
    static isHandledType(t) {
        return ih(t) || Kn(t) || Cp(t);
    }
    static isHandledMethod(t, e) {
        return ih(t) ? Ni.isHandledMethod(e) : Kn(t) ? ah.isHandledMethod(e) : t instanceof Set ? lh.isHandledMethod(e) : t instanceof Map ? ch.isHandledMethod(e) : Cp(t);
    }
    get isCloning() {
        return this._stack.length > 0;
    }
    start(t, e, r) {
        let i = Ni;
        Kn(t) ? i = ah : t instanceof Date ? i = _p : t instanceof Set ? i = lh : t instanceof Map ? i = ch : t instanceof WeakSet ? i = Ip : t instanceof WeakMap && (i = Dp), this._stack.push(new i(t, e, r, this._hasOnValidate));
    }
    update(t, e, r) {
        this._stack[this._stack.length - 1].update(t, e, r);
    }
    preferredThisArg(t, e, r) {
        let { name: i } = t, s = Fs.isHandledMethod(r, i);
        return this._stack[this._stack.length - 1].preferredThisArg(s, i, e, r);
    }
    isChanged(t, e, r) {
        return this._stack[this._stack.length - 1].isChanged(t, e, r);
    }
    undo(t) {
        this._previousClone !== void 0 && this._previousClone.undo(t);
    }
    stop() {
        return this._previousClone = this._stack.pop(), this._previousClone.clone;
    }
};
var uj = {
    equals: Object.is,
    isShallow: !1,
    pathAsArray: !1,
    ignoreSymbols: !1,
    ignoreUnderscores: !1,
    ignoreDetached: !1,
    details: !1
}, $w = (n1, t, e = {})=>{
    e = {
        ...uj,
        ...e
    };
    let r = Symbol("ProxyTarget"), { equals: i, isShallow: s, ignoreDetached: o, details: a } = e, l = new Pp(i), c = typeof e.onValidate == "function", u = new Fs(c), h = (x, v, S, w, A)=>!c || u.isCloning || e.onValidate(gn.concat(l.getPath(x), v), S, w, A) === !0, d = (x, v, S, w)=>{
        !By(l, e, v) && !(o && l.isDetached(x, n1)) && f(l.getPath(x), v, S, w);
    }, f = (x, v, S, w, A)=>{
        u.isCloning ? u.update(x, v, w) : t(gn.concat(x, v), S, w, A);
    }, p = (x)=>x && (x[r] || x), m = (x, v, S, w)=>wP(x) || S === "constructor" || s && !Fs.isHandledMethod(v, S) || By(l, e, S) || l.isGetInvariant(v, S) || o && l.isDetached(v, n1) ? x : (w === void 0 && (w = l.getPath(v)), l.getProxy(x, gn.concat(w, S), g, r)), g = {
        get (x, v, S) {
            if (Cc(v)) {
                if (v === r || v === Mp) return x;
                if (v === Ww && !l.isUnsubscribed && l.getPath(x).length === 0) return l.unsubscribe(), x;
            }
            let w = Cp(x) ? Reflect.get(x, v) : Reflect.get(x, v, S);
            return m(w, x, v);
        },
        set (x, v, S, w) {
            S = p(S);
            let A = x[r] || x, T = A[v];
            if (i(T, S) && v in x) return !0;
            let b = h(x, v, S, T);
            return b && l.setProperty(A, v, S, w, T) ? (d(x, v, x[v], T), !0) : !b;
        },
        defineProperty (x, v, S) {
            if (!l.isSameDescriptor(S, x, v)) {
                let w = x[v];
                h(x, v, S.value, w) && l.defineProperty(x, v, S, w) && d(x, v, S.value, w);
            }
            return !0;
        },
        deleteProperty (x, v) {
            if (!Reflect.has(x, v)) return !0;
            let S = Reflect.get(x, v), w = h(x, v, void 0, S);
            return w && l.deleteProperty(x, v, S) ? (d(x, v, void 0, S), !0) : !w;
        },
        apply (x, v, S) {
            let w = v[r] || v;
            if (l.isUnsubscribed) return Reflect.apply(x, w, S);
            if ((a === !1 || a !== !0 && !a.includes(x.name)) && Fs.isHandledType(w)) {
                let A = gn.initial(l.getPath(x)), T = Fs.isHandledMethod(w, x.name);
                u.start(w, A, S);
                let b = Reflect.apply(x, u.preferredThisArg(x, v, w), T ? S.map((P)=>p(P)) : S), M = u.isChanged(w, i), C = u.stop();
                if (Fs.isHandledType(b) && T && (v instanceof Map && x.name === "get" && (A = gn.concat(A, S[0])), b = l.getProxy(b, A, g)), M) {
                    let P = {
                        name: x.name,
                        args: S,
                        result: b
                    }, I = u.isCloning ? gn.initial(A) : A, _ = u.isCloning ? gn.last(A) : "";
                    h(gn.get(n1, I), _, w, C, P) ? f(I, _, w, C, P) : u.undo(w);
                }
                return (v instanceof Map || v instanceof Set) && qw(b) ? Yw(b, x, v, A, m) : b;
            }
            return Reflect.apply(x, v, S);
        }
    }, y = l.getProxy(n1, e.pathAsArray ? [] : "", g);
    return t = t.bind(y), c && (e.onValidate = e.onValidate.bind(y)), y;
};
$w.target = (n1)=>n1 && n1[Mp] || n1;
$w.unsubscribe = (n1)=>n1[Ww] || n1;
var eA = $w;
var hj = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global, Fy = hj;
var dj = typeof self == "object" && self && self.Object === Object && self, fj = Fy || dj || Function("return this")(), Yr = fj;
var pj = Yr.Symbol, Fi = pj;
var MP = Object.prototype, mj = MP.hasOwnProperty, gj = MP.toString, Op = Fi ? Fi.toStringTag : void 0;
function yj(n1) {
    var t = mj.call(n1, Op), e = n1[Op];
    try {
        n1[Op] = void 0;
        var r = !0;
    } catch  {}
    var i = gj.call(n1);
    return r && (t ? n1[Op] = e : delete n1[Op]), i;
}
var CP = yj;
var vj = Object.prototype, xj = vj.toString;
function bj(n1) {
    return xj.call(n1);
}
var PP = bj;
var Sj = "[object Null]", wj = "[object Undefined]", _P = Fi ? Fi.toStringTag : void 0;
function Aj(n1) {
    return n1 == null ? n1 === void 0 ? wj : Sj : _P && _P in Object(n1) ? CP(n1) : PP(n1);
}
var Qn = Aj;
function Ej(n1) {
    return n1 != null && typeof n1 == "object";
}
var Wi = Ej;
var Tj = "[object Symbol]";
function Mj(n1) {
    return typeof n1 == "symbol" || Wi(n1) && Qn(n1) == Tj;
}
var go = Mj;
function Cj(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length, i = Array(r); ++e < r;)i[e] = t(n1[e], e, n1);
    return i;
}
var Vy = Cj;
var Pj = Array.isArray, Mi = Pj;
var _j = 1 / 0, IP = Fi ? Fi.prototype : void 0, DP = IP ? IP.toString : void 0;
function OP(n1) {
    if (typeof n1 == "string") return n1;
    if (Mi(n1)) return Vy(n1, OP) + "";
    if (go(n1)) return DP ? DP.call(n1) : "";
    var t = n1 + "";
    return t == "0" && 1 / n1 == -_j ? "-0" : t;
}
var RP = OP;
var Ij = /\s/;
function Dj(n1) {
    for(var t = n1.length; t-- && Ij.test(n1.charAt(t)););
    return t;
}
var LP = Dj;
var Oj = /^\s+/;
function Rj(n1) {
    return n1 && n1.slice(0, LP(n1) + 1).replace(Oj, "");
}
var BP = Rj;
function Lj(n1) {
    var t = typeof n1;
    return n1 != null && (t == "object" || t == "function");
}
var yi = Lj;
var NP = 0 / 0, Bj = /^[-+]0x[0-9a-f]+$/i, Nj = /^0b[01]+$/i, Fj = /^0o[0-7]+$/i, Vj = parseInt;
function kj(n1) {
    if (typeof n1 == "number") return n1;
    if (go(n1)) return NP;
    if (yi(n1)) {
        var t = typeof n1.valueOf == "function" ? n1.valueOf() : n1;
        n1 = yi(t) ? t + "" : t;
    }
    if (typeof n1 != "string") return n1 === 0 ? n1 : +n1;
    n1 = BP(n1);
    var e = Nj.test(n1);
    return e || Fj.test(n1) ? Vj(n1.slice(2), e ? 2 : 8) : Bj.test(n1) ? NP : +n1;
}
var tA = kj;
function Uj(n1) {
    return n1;
}
var ky = Uj;
var zj = "[object AsyncFunction]", Gj = "[object Function]", jj = "[object GeneratorFunction]", Hj = "[object Proxy]";
function Wj(n1) {
    if (!yi(n1)) return !1;
    var t = Qn(n1);
    return t == Gj || t == jj || t == zj || t == Hj;
}
var Uy = Wj;
var qj = Yr["__core-js_shared__"], zy = qj;
var FP = function() {
    var n1 = /[^.]+$/.exec(zy && zy.keys && zy.keys.IE_PROTO || "");
    return n1 ? "Symbol(src)_1." + n1 : "";
}();
function Yj(n1) {
    return !!FP && FP in n1;
}
var VP = Yj;
var Xj = Function.prototype, Kj = Xj.toString;
function Qj(n1) {
    if (n1 != null) {
        try {
            return Kj.call(n1);
        } catch  {}
        try {
            return n1 + "";
        } catch  {}
    }
    return "";
}
var ua = Qj;
var Zj = /[\\^$.*+?()[\]{}|]/g, Jj = /^\[object .+?Constructor\]$/, $j = Function.prototype, eH = Object.prototype, tH = $j.toString, rH = eH.hasOwnProperty, iH = RegExp("^" + tH.call(rH).replace(Zj, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function nH(n1) {
    if (!yi(n1) || VP(n1)) return !1;
    var t = Uy(n1) ? iH : Jj;
    return t.test(ua(n1));
}
var kP = nH;
function sH(n1, t) {
    return n1?.[t];
}
var UP = sH;
function oH(n1, t) {
    var e = UP(n1, t);
    return kP(e) ? e : void 0;
}
var Cn = oH;
var aH = Cn(Yr, "WeakMap"), Gy = aH;
var zP = Object.create, lH = function() {
    function n1() {}
    return function(t) {
        if (!yi(t)) return {};
        if (zP) return zP(t);
        n1.prototype = t;
        var e = new n1;
        return n1.prototype = void 0, e;
    };
}(), GP = lH;
function cH(n1, t, e) {
    switch(e.length){
        case 0:
            return n1.call(t);
        case 1:
            return n1.call(t, e[0]);
        case 2:
            return n1.call(t, e[0], e[1]);
        case 3:
            return n1.call(t, e[0], e[1], e[2]);
    }
    return n1.apply(t, e);
}
var jP = cH;
function uH(n1, t) {
    var e = -1, r = n1.length;
    for(t || (t = Array(r)); ++e < r;)t[e] = n1[e];
    return t;
}
var HP = uH;
var hH = 800, dH = 16, fH = Date.now;
function pH(n1) {
    var t = 0, e = 0;
    return function() {
        var r = fH(), i = dH - (r - e);
        if (e = r, i > 0) {
            if (++t >= hH) return arguments[0];
        } else t = 0;
        return n1.apply(void 0, arguments);
    };
}
var WP = pH;
function mH(n1) {
    return function() {
        return n1;
    };
}
var qP = mH;
var gH = function() {
    try {
        var n1 = Cn(Object, "defineProperty");
        return n1({}, "", {}), n1;
    } catch  {}
}(), uh = gH;
var yH = uh ? function(n1, t) {
    return uh(n1, "toString", {
        configurable: !0,
        enumerable: !1,
        value: qP(t),
        writable: !0
    });
} : ky, YP = yH;
var vH = WP(YP), XP = vH;
function xH(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length; ++e < r && t(n1[e], e, n1) !== !1;);
    return n1;
}
var KP = xH;
var bH = 9007199254740991, SH = /^(?:0|[1-9]\d*)$/;
function wH(n1, t) {
    var e = typeof n1;
    return t = t ?? bH, !!t && (e == "number" || e != "symbol" && SH.test(n1)) && n1 > -1 && n1 % 1 == 0 && n1 < t;
}
var hh = wH;
function AH(n1, t, e) {
    t == "__proto__" && uh ? uh(n1, t, {
        configurable: !0,
        enumerable: !0,
        value: e,
        writable: !0
    }) : n1[t] = e;
}
var jy = AH;
function EH(n1, t) {
    return n1 === t || n1 !== n1 && t !== t;
}
var dh = EH;
var TH = Object.prototype, MH = TH.hasOwnProperty;
function CH(n1, t, e) {
    var r = n1[t];
    (!(MH.call(n1, t) && dh(r, e)) || e === void 0 && !(t in n1)) && jy(n1, t, e);
}
var fh = CH;
function PH(n1, t, e, r) {
    var i = !e;
    e || (e = {});
    for(var s = -1, o = t.length; ++s < o;){
        var a = t[s], l = r ? r(e[a], n1[a], a, e, n1) : void 0;
        l === void 0 && (l = n1[a]), i ? jy(e, a, l) : fh(e, a, l);
    }
    return e;
}
var yo = PH;
var QP = Math.max;
function _H(n1, t, e) {
    return t = QP(t === void 0 ? n1.length - 1 : t, 0), function() {
        for(var r = arguments, i = -1, s = QP(r.length - t, 0), o = Array(s); ++i < s;)o[i] = r[t + i];
        i = -1;
        for(var a = Array(t + 1); ++i < t;)a[i] = r[i];
        return a[t] = e(o), jP(n1, this, a);
    };
}
var ZP = _H;
var IH = 9007199254740991;
function DH(n1) {
    return typeof n1 == "number" && n1 > -1 && n1 % 1 == 0 && n1 <= IH;
}
var ph = DH;
function OH(n1) {
    return n1 != null && ph(n1.length) && !Uy(n1);
}
var Hy = OH;
var RH = Object.prototype;
function LH(n1) {
    var t = n1 && n1.constructor, e = typeof t == "function" && t.prototype || RH;
    return n1 === e;
}
var mh = LH;
function BH(n1, t) {
    for(var e = -1, r = Array(n1); ++e < n1;)r[e] = t(e);
    return r;
}
var JP = BH;
var NH = "[object Arguments]";
function FH(n1) {
    return Wi(n1) && Qn(n1) == NH;
}
var rA = FH;
var $P = Object.prototype, VH = $P.hasOwnProperty, kH = $P.propertyIsEnumerable, UH = rA(function() {
    return arguments;
}()) ? rA : function(n1) {
    return Wi(n1) && VH.call(n1, "callee") && !kH.call(n1, "callee");
}, gh = UH;
function zH() {
    return !1;
}
var e_ = zH;
var i_ = exports && !exports.nodeType && exports, t_ = i_ && true && module && !module.nodeType && module, GH = t_ && t_.exports === i_, r_ = GH ? Yr.Buffer : void 0, jH = r_ ? r_.isBuffer : void 0, HH = jH || e_, Pc = HH;
var WH = "[object Arguments]", qH = "[object Array]", YH = "[object Boolean]", XH = "[object Date]", KH = "[object Error]", QH = "[object Function]", ZH = "[object Map]", JH = "[object Number]", $H = "[object Object]", e5 = "[object RegExp]", t5 = "[object Set]", r5 = "[object String]", i5 = "[object WeakMap]", n5 = "[object ArrayBuffer]", s5 = "[object DataView]", o5 = "[object Float32Array]", a5 = "[object Float64Array]", l5 = "[object Int8Array]", c5 = "[object Int16Array]", u5 = "[object Int32Array]", h5 = "[object Uint8Array]", d5 = "[object Uint8ClampedArray]", f5 = "[object Uint16Array]", p5 = "[object Uint32Array]", Ir = {};
Ir[o5] = Ir[a5] = Ir[l5] = Ir[c5] = Ir[u5] = Ir[h5] = Ir[d5] = Ir[f5] = Ir[p5] = !0;
Ir[WH] = Ir[qH] = Ir[n5] = Ir[YH] = Ir[s5] = Ir[XH] = Ir[KH] = Ir[QH] = Ir[ZH] = Ir[JH] = Ir[$H] = Ir[e5] = Ir[t5] = Ir[r5] = Ir[i5] = !1;
function m5(n1) {
    return Wi(n1) && ph(n1.length) && !!Ir[Qn(n1)];
}
var n_ = m5;
function g5(n1) {
    return function(t) {
        return n1(t);
    };
}
var yh = g5;
var s_ = exports && !exports.nodeType && exports, Rp = s_ && true && module && !module.nodeType && module, y5 = Rp && Rp.exports === s_, iA = y5 && Fy.process, v5 = function() {
    try {
        var n1 = Rp && Rp.require && Rp.require("util").types;
        return n1 || iA && iA.binding && iA.binding("util");
    } catch  {}
}(), ha = v5;
var o_ = ha && ha.isTypedArray, x5 = o_ ? yh(o_) : n_, Wy = x5;
var b5 = Object.prototype, S5 = b5.hasOwnProperty;
function w5(n1, t) {
    var e = Mi(n1), r = !e && gh(n1), i = !e && !r && Pc(n1), s = !e && !r && !i && Wy(n1), o = e || r || i || s, a = o ? JP(n1.length, String) : [], l = a.length;
    for(var c in n1)(t || S5.call(n1, c)) && !(o && (c == "length" || i && (c == "offset" || c == "parent") || s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || hh(c, l))) && a.push(c);
    return a;
}
var qy = w5;
function A5(n1, t) {
    return function(e) {
        return n1(t(e));
    };
}
var Yy = A5;
var E5 = Yy(Object.keys, Object), a_ = E5;
var T5 = Object.prototype, M5 = T5.hasOwnProperty;
function C5(n1) {
    if (!mh(n1)) return a_(n1);
    var t = [];
    for(var e in Object(n1))M5.call(n1, e) && e != "constructor" && t.push(e);
    return t;
}
var l_ = C5;
function P5(n1) {
    return Hy(n1) ? qy(n1) : l_(n1);
}
var vh = P5;
function _5(n1) {
    var t = [];
    if (n1 != null) for(var e in Object(n1))t.push(e);
    return t;
}
var c_ = _5;
var I5 = Object.prototype, D5 = I5.hasOwnProperty;
function O5(n1) {
    if (!yi(n1)) return c_(n1);
    var t = mh(n1), e = [];
    for(var r in n1)r == "constructor" && (t || !D5.call(n1, r)) || e.push(r);
    return e;
}
var u_ = O5;
function R5(n1) {
    return Hy(n1) ? qy(n1, !0) : u_(n1);
}
var ls = R5;
var L5 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, B5 = /^\w*$/;
function N5(n1, t) {
    if (Mi(n1)) return !1;
    var e = typeof n1;
    return e == "number" || e == "symbol" || e == "boolean" || n1 == null || go(n1) ? !0 : B5.test(n1) || !L5.test(n1) || t != null && n1 in Object(t);
}
var h_ = N5;
var F5 = Cn(Object, "create"), da = F5;
function V5() {
    this.__data__ = da ? da(null) : {}, this.size = 0;
}
var d_ = V5;
function k5(n1) {
    var t = this.has(n1) && delete this.__data__[n1];
    return this.size -= t ? 1 : 0, t;
}
var f_ = k5;
var U5 = "__lodash_hash_undefined__", z5 = Object.prototype, G5 = z5.hasOwnProperty;
function j5(n1) {
    var t = this.__data__;
    if (da) {
        var e = t[n1];
        return e === U5 ? void 0 : e;
    }
    return G5.call(t, n1) ? t[n1] : void 0;
}
var p_ = j5;
var H5 = Object.prototype, W5 = H5.hasOwnProperty;
function q5(n1) {
    var t = this.__data__;
    return da ? t[n1] !== void 0 : W5.call(t, n1);
}
var m_ = q5;
var Y5 = "__lodash_hash_undefined__";
function X5(n1, t) {
    var e = this.__data__;
    return this.size += this.has(n1) ? 0 : 1, e[n1] = da && t === void 0 ? Y5 : t, this;
}
var g_ = X5;
function xh(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
xh.prototype.clear = d_;
xh.prototype.delete = f_;
xh.prototype.get = p_;
xh.prototype.has = m_;
xh.prototype.set = g_;
var nA = xh;
function K5() {
    this.__data__ = [], this.size = 0;
}
var y_ = K5;
function Q5(n1, t) {
    for(var e = n1.length; e--;)if (dh(n1[e][0], t)) return e;
    return -1;
}
var fl = Q5;
var Z5 = Array.prototype, J5 = Z5.splice;
function $5(n1) {
    var t = this.__data__, e = fl(t, n1);
    if (e < 0) return !1;
    var r = t.length - 1;
    return e == r ? t.pop() : J5.call(t, e, 1), --this.size, !0;
}
var v_ = $5;
function eW(n1) {
    var t = this.__data__, e = fl(t, n1);
    return e < 0 ? void 0 : t[e][1];
}
var x_ = eW;
function tW(n1) {
    return fl(this.__data__, n1) > -1;
}
var b_ = tW;
function rW(n1, t) {
    var e = this.__data__, r = fl(e, n1);
    return r < 0 ? (++this.size, e.push([
        n1,
        t
    ])) : e[r][1] = t, this;
}
var S_ = rW;
function bh(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
bh.prototype.clear = y_;
bh.prototype.delete = v_;
bh.prototype.get = x_;
bh.prototype.has = b_;
bh.prototype.set = S_;
var pl = bh;
var iW = Cn(Yr, "Map"), ml = iW;
function nW() {
    this.size = 0, this.__data__ = {
        hash: new nA,
        map: new (ml || pl),
        string: new nA
    };
}
var w_ = nW;
function sW(n1) {
    var t = typeof n1;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n1 !== "__proto__" : n1 === null;
}
var A_ = sW;
function oW(n1, t) {
    var e = n1.__data__;
    return A_(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
var gl = oW;
function aW(n1) {
    var t = gl(this, n1).delete(n1);
    return this.size -= t ? 1 : 0, t;
}
var E_ = aW;
function lW(n1) {
    return gl(this, n1).get(n1);
}
var T_ = lW;
function cW(n1) {
    return gl(this, n1).has(n1);
}
var M_ = cW;
function uW(n1, t) {
    var e = gl(this, n1), r = e.size;
    return e.set(n1, t), this.size += e.size == r ? 0 : 1, this;
}
var C_ = uW;
function Sh(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
Sh.prototype.clear = w_;
Sh.prototype.delete = E_;
Sh.prototype.get = T_;
Sh.prototype.has = M_;
Sh.prototype.set = C_;
var _c = Sh;
var hW = "Expected a function";
function sA(n1, t) {
    if (typeof n1 != "function" || t != null && typeof t != "function") throw new TypeError(hW);
    var e = function() {
        var r = arguments, i = t ? t.apply(this, r) : r[0], s = e.cache;
        if (s.has(i)) return s.get(i);
        var o = n1.apply(this, r);
        return e.cache = s.set(i, o) || s, o;
    };
    return e.cache = new (sA.Cache || _c), e;
}
sA.Cache = _c;
var P_ = sA;
var dW = 500;
function fW(n1) {
    var t = P_(n1, function(r) {
        return e.size === dW && e.clear(), r;
    }), e = t.cache;
    return t;
}
var __ = fW;
var pW = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, mW = /\\(\\)?/g, gW = __(function(n1) {
    var t = [];
    return n1.charCodeAt(0) === 46 && t.push(""), n1.replace(pW, function(e, r, i, s) {
        t.push(i ? s.replace(mW, "$1") : r || e);
    }), t;
}), I_ = gW;
function yW(n1) {
    return n1 == null ? "" : RP(n1);
}
var D_ = yW;
function vW(n1, t) {
    return Mi(n1) ? n1 : h_(n1, t) ? [
        n1
    ] : I_(D_(n1));
}
var cs = vW;
var xW = 1 / 0;
function bW(n1) {
    if (typeof n1 == "string" || go(n1)) return n1;
    var t = n1 + "";
    return t == "0" && 1 / n1 == -xW ? "-0" : t;
}
var yl = bW;
function SW(n1, t) {
    t = cs(t, n1);
    for(var e = 0, r = t.length; n1 != null && e < r;)n1 = n1[yl(t[e++])];
    return e && e == r ? n1 : void 0;
}
var Xy = SW;
function wW(n1, t) {
    for(var e = -1, r = t.length, i = n1.length; ++e < r;)n1[i + e] = t[e];
    return n1;
}
var wh = wW;
var O_ = Fi ? Fi.isConcatSpreadable : void 0;
function AW(n1) {
    return Mi(n1) || gh(n1) || !!(O_ && n1 && n1[O_]);
}
var R_ = AW;
function L_(n1, t, e, r, i) {
    var s = -1, o = n1.length;
    for(e || (e = R_), i || (i = []); ++s < o;){
        var a = n1[s];
        t > 0 && e(a) ? t > 1 ? L_(a, t - 1, e, r, i) : wh(i, a) : r || (i[i.length] = a);
    }
    return i;
}
var B_ = L_;
function EW(n1) {
    var t = n1 == null ? 0 : n1.length;
    return t ? B_(n1, 1) : [];
}
var N_ = EW;
function TW(n1) {
    return XP(ZP(n1, void 0, N_), n1 + "");
}
var Ky = TW;
var MW = Yy(Object.getPrototypeOf, Object), Ah = MW;
var CW = "[object Object]", PW = Function.prototype, _W = Object.prototype, F_ = PW.toString, IW = _W.hasOwnProperty, DW = F_.call(Object);
function OW(n1) {
    if (!Wi(n1) || Qn(n1) != CW) return !1;
    var t = Ah(n1);
    if (t === null) return !0;
    var e = IW.call(t, "constructor") && t.constructor;
    return typeof e == "function" && e instanceof e && F_.call(e) == DW;
}
var V_ = OW;
function RW(n1, t, e) {
    var r = -1, i = n1.length;
    t < 0 && (t = -t > i ? 0 : i + t), e = e > i ? i : e, e < 0 && (e += i), i = t > e ? 0 : e - t >>> 0, t >>>= 0;
    for(var s = Array(i); ++r < i;)s[r] = n1[r + t];
    return s;
}
var k_ = RW;
function LW() {
    this.__data__ = new pl, this.size = 0;
}
var U_ = LW;
function BW(n1) {
    var t = this.__data__, e = t.delete(n1);
    return this.size = t.size, e;
}
var z_ = BW;
function NW(n1) {
    return this.__data__.get(n1);
}
var G_ = NW;
function FW(n1) {
    return this.__data__.has(n1);
}
var j_ = FW;
var VW = 200;
function kW(n1, t) {
    var e = this.__data__;
    if (e instanceof pl) {
        var r = e.__data__;
        if (!ml || r.length < VW - 1) return r.push([
            n1,
            t
        ]), this.size = ++e.size, this;
        e = this.__data__ = new _c(r);
    }
    return e.set(n1, t), this.size = e.size, this;
}
var H_ = kW;
function Eh(n1) {
    var t = this.__data__ = new pl(n1);
    this.size = t.size;
}
Eh.prototype.clear = U_;
Eh.prototype.delete = z_;
Eh.prototype.get = G_;
Eh.prototype.has = j_;
Eh.prototype.set = H_;
var Th = Eh;
function UW(n1, t) {
    return n1 && yo(t, vh(t), n1);
}
var W_ = UW;
function zW(n1, t) {
    return n1 && yo(t, ls(t), n1);
}
var q_ = zW;
var Q_ = exports && !exports.nodeType && exports, Y_ = Q_ && true && module && !module.nodeType && module, GW = Y_ && Y_.exports === Q_, X_ = GW ? Yr.Buffer : void 0, K_ = X_ ? X_.allocUnsafe : void 0;
function jW(n1, t) {
    if (t) return n1.slice();
    var e = n1.length, r = K_ ? K_(e) : new n1.constructor(e);
    return n1.copy(r), r;
}
var Z_ = jW;
function HW(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length, i = 0, s = []; ++e < r;){
        var o = n1[e];
        t(o, e, n1) && (s[i++] = o);
    }
    return s;
}
var J_ = HW;
function WW() {
    return [];
}
var Qy = WW;
var qW = Object.prototype, YW = qW.propertyIsEnumerable, $_ = Object.getOwnPropertySymbols, XW = $_ ? function(n1) {
    return n1 == null ? [] : (n1 = Object(n1), J_($_(n1), function(t) {
        return YW.call(n1, t);
    }));
} : Qy, Mh = XW;
function KW(n1, t) {
    return yo(n1, Mh(n1), t);
}
var e2 = KW;
var QW = Object.getOwnPropertySymbols, ZW = QW ? function(n1) {
    for(var t = []; n1;)wh(t, Mh(n1)), n1 = Ah(n1);
    return t;
} : Qy, Zy = ZW;
function JW(n1, t) {
    return yo(n1, Zy(n1), t);
}
var t2 = JW;
function $W(n1, t, e) {
    var r = t(n1);
    return Mi(n1) ? r : wh(r, e(n1));
}
var Jy = $W;
function e6(n1) {
    return Jy(n1, vh, Mh);
}
var Lp = e6;
function t6(n1) {
    return Jy(n1, ls, Zy);
}
var $y = t6;
var r6 = Cn(Yr, "DataView"), ev = r6;
var i6 = Cn(Yr, "Promise"), tv = i6;
var n6 = Cn(Yr, "Set"), rv = n6;
var r2 = "[object Map]", s6 = "[object Object]", i2 = "[object Promise]", n2 = "[object Set]", s2 = "[object WeakMap]", o2 = "[object DataView]", o6 = ua(ev), a6 = ua(ml), l6 = ua(tv), c6 = ua(rv), u6 = ua(Gy), Ic = Qn;
(ev && Ic(new ev(new ArrayBuffer(1))) != o2 || ml && Ic(new ml) != r2 || tv && Ic(tv.resolve()) != i2 || rv && Ic(new rv) != n2 || Gy && Ic(new Gy) != s2) && (Ic = function(n1) {
    var t = Qn(n1), e = t == s6 ? n1.constructor : void 0, r = e ? ua(e) : "";
    if (r) switch(r){
        case o6:
            return o2;
        case a6:
            return r2;
        case l6:
            return i2;
        case c6:
            return n2;
        case u6:
            return s2;
    }
    return t;
});
var fa = Ic;
var h6 = Object.prototype, d6 = h6.hasOwnProperty;
function f6(n1) {
    var t = n1.length, e = new n1.constructor(t);
    return t && typeof n1[0] == "string" && d6.call(n1, "index") && (e.index = n1.index, e.input = n1.input), e;
}
var a2 = f6;
var p6 = Yr.Uint8Array, Ch = p6;
function m6(n1) {
    var t = new n1.constructor(n1.byteLength);
    return new Ch(t).set(new Ch(n1)), t;
}
var Ph = m6;
function g6(n1, t) {
    var e = t ? Ph(n1.buffer) : n1.buffer;
    return new n1.constructor(e, n1.byteOffset, n1.byteLength);
}
var l2 = g6;
var y6 = /\w*$/;
function v6(n1) {
    var t = new n1.constructor(n1.source, y6.exec(n1));
    return t.lastIndex = n1.lastIndex, t;
}
var c2 = v6;
var u2 = Fi ? Fi.prototype : void 0, h2 = u2 ? u2.valueOf : void 0;
function x6(n1) {
    return h2 ? Object(h2.call(n1)) : {};
}
var d2 = x6;
function b6(n1, t) {
    var e = t ? Ph(n1.buffer) : n1.buffer;
    return new n1.constructor(e, n1.byteOffset, n1.length);
}
var f2 = b6;
var S6 = "[object Boolean]", w6 = "[object Date]", A6 = "[object Map]", E6 = "[object Number]", T6 = "[object RegExp]", M6 = "[object Set]", C6 = "[object String]", P6 = "[object Symbol]", _6 = "[object ArrayBuffer]", I6 = "[object DataView]", D6 = "[object Float32Array]", O6 = "[object Float64Array]", R6 = "[object Int8Array]", L6 = "[object Int16Array]", B6 = "[object Int32Array]", N6 = "[object Uint8Array]", F6 = "[object Uint8ClampedArray]", V6 = "[object Uint16Array]", k6 = "[object Uint32Array]";
function U6(n1, t, e) {
    var r = n1.constructor;
    switch(t){
        case _6:
            return Ph(n1);
        case S6:
        case w6:
            return new r(+n1);
        case I6:
            return l2(n1, e);
        case D6:
        case O6:
        case R6:
        case L6:
        case B6:
        case N6:
        case F6:
        case V6:
        case k6:
            return f2(n1, e);
        case A6:
            return new r;
        case E6:
        case C6:
            return new r(n1);
        case T6:
            return c2(n1);
        case M6:
            return new r;
        case P6:
            return d2(n1);
    }
}
var p2 = U6;
function z6(n1) {
    return typeof n1.constructor == "function" && !mh(n1) ? GP(Ah(n1)) : {};
}
var m2 = z6;
var G6 = "[object Map]";
function j6(n1) {
    return Wi(n1) && fa(n1) == G6;
}
var g2 = j6;
var y2 = ha && ha.isMap, H6 = y2 ? yh(y2) : g2, v2 = H6;
var W6 = "[object Set]";
function q6(n1) {
    return Wi(n1) && fa(n1) == W6;
}
var x2 = q6;
var b2 = ha && ha.isSet, Y6 = b2 ? yh(b2) : x2, S2 = Y6;
var X6 = 1, K6 = 2, Q6 = 4, w2 = "[object Arguments]", Z6 = "[object Array]", J6 = "[object Boolean]", $6 = "[object Date]", e8 = "[object Error]", A2 = "[object Function]", t8 = "[object GeneratorFunction]", r8 = "[object Map]", i8 = "[object Number]", E2 = "[object Object]", n8 = "[object RegExp]", s8 = "[object Set]", o8 = "[object String]", a8 = "[object Symbol]", l8 = "[object WeakMap]", c8 = "[object ArrayBuffer]", u8 = "[object DataView]", h8 = "[object Float32Array]", d8 = "[object Float64Array]", f8 = "[object Int8Array]", p8 = "[object Int16Array]", m8 = "[object Int32Array]", g8 = "[object Uint8Array]", y8 = "[object Uint8ClampedArray]", v8 = "[object Uint16Array]", x8 = "[object Uint32Array]", Pr = {};
Pr[w2] = Pr[Z6] = Pr[c8] = Pr[u8] = Pr[J6] = Pr[$6] = Pr[h8] = Pr[d8] = Pr[f8] = Pr[p8] = Pr[m8] = Pr[r8] = Pr[i8] = Pr[E2] = Pr[n8] = Pr[s8] = Pr[o8] = Pr[a8] = Pr[g8] = Pr[y8] = Pr[v8] = Pr[x8] = !0;
Pr[e8] = Pr[A2] = Pr[l8] = !1;
function iv(n1, t, e, r, i, s) {
    var o, a = t & X6, l = t & K6, c = t & Q6;
    if (e && (o = i ? e(n1, r, i, s) : e(n1)), o !== void 0) return o;
    if (!yi(n1)) return n1;
    var u = Mi(n1);
    if (u) {
        if (o = a2(n1), !a) return HP(n1, o);
    } else {
        var h = fa(n1), d = h == A2 || h == t8;
        if (Pc(n1)) return Z_(n1, a);
        if (h == E2 || h == w2 || d && !i) {
            if (o = l || d ? {} : m2(n1), !a) return l ? t2(n1, q_(o, n1)) : e2(n1, W_(o, n1));
        } else {
            if (!Pr[h]) return i ? n1 : {};
            o = p2(n1, h, a);
        }
    }
    s || (s = new Th);
    var f = s.get(n1);
    if (f) return f;
    s.set(n1, o), S2(n1) ? n1.forEach(function(g) {
        o.add(iv(g, t, e, g, n1, s));
    }) : v2(n1) && n1.forEach(function(g, y) {
        o.set(y, iv(g, t, e, y, n1, s));
    });
    var p = c ? l ? $y : Lp : l ? ls : vh, m = u ? void 0 : p(n1);
    return KP(m || n1, function(g, y) {
        m && (y = g, g = n1[y]), fh(o, y, iv(g, t, e, y, n1, s));
    }), o;
}
var nv = iv;
var b8 = 1, S8 = 4;
function w8(n1) {
    return nv(n1, b8 | S8);
}
var pa = w8;
var A8 = "__lodash_hash_undefined__";
function E8(n1) {
    return this.__data__.set(n1, A8), this;
}
var T2 = E8;
function T8(n1) {
    return this.__data__.has(n1);
}
var M2 = T8;
function sv(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.__data__ = new _c; ++t < e;)this.add(n1[t]);
}
sv.prototype.add = sv.prototype.push = T2;
sv.prototype.has = M2;
var C2 = sv;
function M8(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length; ++e < r;)if (t(n1[e], e, n1)) return !0;
    return !1;
}
var P2 = M8;
function C8(n1, t) {
    return n1.has(t);
}
var _2 = C8;
var P8 = 1, _8 = 2;
function I8(n1, t, e, r, i, s) {
    var o = e & P8, a = n1.length, l = t.length;
    if (a != l && !(o && l > a)) return !1;
    var c = s.get(n1), u = s.get(t);
    if (c && u) return c == t && u == n1;
    var h = -1, d = !0, f = e & _8 ? new C2 : void 0;
    for(s.set(n1, t), s.set(t, n1); ++h < a;){
        var p = n1[h], m = t[h];
        if (r) var g = o ? r(m, p, h, t, n1, s) : r(p, m, h, n1, t, s);
        if (g !== void 0) {
            if (g) continue;
            d = !1;
            break;
        }
        if (f) {
            if (!P2(t, function(y, x) {
                if (!_2(f, x) && (p === y || i(p, y, e, r, s))) return f.push(x);
            })) {
                d = !1;
                break;
            }
        } else if (!(p === m || i(p, m, e, r, s))) {
            d = !1;
            break;
        }
    }
    return s.delete(n1), s.delete(t), d;
}
var ov = I8;
function D8(n1) {
    var t = -1, e = Array(n1.size);
    return n1.forEach(function(r, i) {
        e[++t] = [
            i,
            r
        ];
    }), e;
}
var I2 = D8;
function O8(n1) {
    var t = -1, e = Array(n1.size);
    return n1.forEach(function(r) {
        e[++t] = r;
    }), e;
}
var D2 = O8;
var R8 = 1, L8 = 2, B8 = "[object Boolean]", N8 = "[object Date]", F8 = "[object Error]", V8 = "[object Map]", k8 = "[object Number]", U8 = "[object RegExp]", z8 = "[object Set]", G8 = "[object String]", j8 = "[object Symbol]", H8 = "[object ArrayBuffer]", W8 = "[object DataView]", O2 = Fi ? Fi.prototype : void 0, oA = O2 ? O2.valueOf : void 0;
function q8(n1, t, e, r, i, s, o) {
    switch(e){
        case W8:
            if (n1.byteLength != t.byteLength || n1.byteOffset != t.byteOffset) return !1;
            n1 = n1.buffer, t = t.buffer;
        case H8:
            return !(n1.byteLength != t.byteLength || !s(new Ch(n1), new Ch(t)));
        case B8:
        case N8:
        case k8:
            return dh(+n1, +t);
        case F8:
            return n1.name == t.name && n1.message == t.message;
        case U8:
        case G8:
            return n1 == t + "";
        case V8:
            var a = I2;
        case z8:
            var l = r & R8;
            if (a || (a = D2), n1.size != t.size && !l) return !1;
            var c = o.get(n1);
            if (c) return c == t;
            r |= L8, o.set(n1, t);
            var u = ov(a(n1), a(t), r, i, s, o);
            return o.delete(n1), u;
        case j8:
            if (oA) return oA.call(n1) == oA.call(t);
    }
    return !1;
}
var R2 = q8;
var Y8 = 1, X8 = Object.prototype, K8 = X8.hasOwnProperty;
function Q8(n1, t, e, r, i, s) {
    var o = e & Y8, a = Lp(n1), l = a.length, c = Lp(t), u = c.length;
    if (l != u && !o) return !1;
    for(var h = l; h--;){
        var d = a[h];
        if (!(o ? d in t : K8.call(t, d))) return !1;
    }
    var f = s.get(n1), p = s.get(t);
    if (f && p) return f == t && p == n1;
    var m = !0;
    s.set(n1, t), s.set(t, n1);
    for(var g = o; ++h < l;){
        d = a[h];
        var y = n1[d], x = t[d];
        if (r) var v = o ? r(x, y, d, t, n1, s) : r(y, x, d, n1, t, s);
        if (!(v === void 0 ? y === x || i(y, x, e, r, s) : v)) {
            m = !1;
            break;
        }
        g || (g = d == "constructor");
    }
    if (m && !g) {
        var S = n1.constructor, w = t.constructor;
        S != w && "constructor" in n1 && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof w == "function" && w instanceof w) && (m = !1);
    }
    return s.delete(n1), s.delete(t), m;
}
var L2 = Q8;
var Z8 = 1, B2 = "[object Arguments]", N2 = "[object Array]", av = "[object Object]", J8 = Object.prototype, F2 = J8.hasOwnProperty;
function $8(n1, t, e, r, i, s) {
    var o = Mi(n1), a = Mi(t), l = o ? N2 : fa(n1), c = a ? N2 : fa(t);
    l = l == B2 ? av : l, c = c == B2 ? av : c;
    var u = l == av, h = c == av, d = l == c;
    if (d && Pc(n1)) {
        if (!Pc(t)) return !1;
        o = !0, u = !1;
    }
    if (d && !u) return s || (s = new Th), o || Wy(n1) ? ov(n1, t, e, r, i, s) : R2(n1, t, l, e, r, i, s);
    if (!(e & Z8)) {
        var f = u && F2.call(n1, "__wrapped__"), p = h && F2.call(t, "__wrapped__");
        if (f || p) {
            var m = f ? n1.value() : n1, g = p ? t.value() : t;
            return s || (s = new Th), i(m, g, e, r, s);
        }
    }
    return d ? (s || (s = new Th), L2(n1, t, e, r, i, s)) : !1;
}
var V2 = $8;
function k2(n1, t, e, r, i) {
    return n1 === t ? !0 : n1 == null || t == null || !Wi(n1) && !Wi(t) ? n1 !== n1 && t !== t : V2(n1, t, e, r, k2, i);
}
var U2 = k2;
function eq(n1, t) {
    return n1 != null && t in Object(n1);
}
var z2 = eq;
function tq(n1, t, e) {
    t = cs(t, n1);
    for(var r = -1, i = t.length, s = !1; ++r < i;){
        var o = yl(t[r]);
        if (!(s = n1 != null && e(n1, o))) break;
        n1 = n1[o];
    }
    return s || ++r != i ? s : (i = n1 == null ? 0 : n1.length, !!i && ph(i) && hh(o, i) && (Mi(n1) || gh(n1)));
}
var G2 = tq;
function rq(n1, t) {
    return n1 != null && G2(n1, t, z2);
}
var j2 = rq;
var iq = function() {
    return Yr.Date.now();
}, lv = iq;
var nq = "Expected a function", sq = Math.max, oq = Math.min;
function aq(n1, t, e) {
    var r, i, s, o, a, l, c = 0, u = !1, h = !1, d = !0;
    if (typeof n1 != "function") throw new TypeError(nq);
    t = tA(t) || 0, yi(e) && (u = !!e.leading, h = "maxWait" in e, s = h ? sq(tA(e.maxWait) || 0, t) : s, d = "trailing" in e ? !!e.trailing : d);
    function f(A) {
        var T = r, b = i;
        return r = i = void 0, c = A, o = n1.apply(b, T), o;
    }
    function p(A) {
        return c = A, a = setTimeout(y, t), u ? f(A) : o;
    }
    function m(A) {
        var T = A - l, b = A - c, M = t - T;
        return h ? oq(M, s - b) : M;
    }
    function g(A) {
        var T = A - l, b = A - c;
        return l === void 0 || T >= t || T < 0 || h && b >= s;
    }
    function y() {
        var A = lv();
        if (g(A)) return x(A);
        a = setTimeout(y, m(A));
    }
    function x(A) {
        return a = void 0, d && r ? f(A) : (r = i = void 0, o);
    }
    function v() {
        a !== void 0 && clearTimeout(a), c = 0, r = l = i = a = void 0;
    }
    function S() {
        return a === void 0 ? o : x(lv());
    }
    function w() {
        var A = lv(), T = g(A);
        if (r = arguments, i = this, l = A, T) {
            if (a === void 0) return p(l);
            if (h) return clearTimeout(a), a = setTimeout(y, t), f(l);
        }
        return a === void 0 && (a = setTimeout(y, t)), o;
    }
    return w.cancel = v, w.flush = S, w;
}
var vo = aq;
function lq(n1) {
    var t = n1 == null ? 0 : n1.length;
    return t ? n1[t - 1] : void 0;
}
var H2 = lq;
function cq(n1, t) {
    return n1 > t;
}
var W2 = cq;
function uq(n1, t) {
    return t.length < 2 ? n1 : Xy(n1, k_(t, 0, -1));
}
var q2 = uq;
function hq(n1, t) {
    return U2(n1, t);
}
var Dc = hq;
function dq(n1, t, e) {
    for(var r = -1, i = n1.length; ++r < i;){
        var s = n1[r], o = t(s);
        if (o != null && (a === void 0 ? o === o && !go(o) : e(o, a))) var a = o, l = s;
    }
    return l;
}
var Y2 = dq;
function fq(n1) {
    return n1 && n1.length ? Y2(n1, ky, W2) : void 0;
}
var aA = fq;
function pq(n1, t) {
    return t = cs(t, n1), n1 = q2(n1, t), n1 == null || delete n1[yl(H2(t))];
}
var X2 = pq;
function mq(n1) {
    return V_(n1) ? void 0 : n1;
}
var K2 = mq;
var gq = 1, yq = 2, vq = 4, xq = Ky(function(n1, t) {
    var e = {};
    if (n1 == null) return e;
    var r = !1;
    t = Vy(t, function(s) {
        return s = cs(s, n1), r || (r = s.length > 1), s;
    }), yo(n1, $y(n1), e), r && (e = nv(e, gq | yq | vq, K2));
    for(var i = t.length; i--;)X2(e, t[i]);
    return e;
}), _h = xq;
function bq(n1, t, e, r) {
    if (!yi(n1)) return n1;
    t = cs(t, n1);
    for(var i = -1, s = t.length, o = s - 1, a = n1; a != null && ++i < s;){
        var l = yl(t[i]), c = e;
        if (l === "__proto__" || l === "constructor" || l === "prototype") return n1;
        if (i != o) {
            var u = a[l];
            c = r ? r(u, l, a) : void 0, c === void 0 && (c = yi(u) ? u : hh(t[i + 1]) ? [] : {});
        }
        fh(a, l, c), a = a[l];
    }
    return n1;
}
var Q2 = bq;
function Sq(n1, t, e) {
    for(var r = -1, i = t.length, s = {}; ++r < i;){
        var o = t[r], a = Xy(n1, o);
        e(a, o) && Q2(s, cs(o, n1), a);
    }
    return s;
}
var Z2 = Sq;
function wq(n1, t) {
    return Z2(n1, t, function(e, r) {
        return j2(n1, r);
    });
}
var J2 = wq;
var Aq = Ky(function(n1, t) {
    return n1 == null ? {} : J2(n1, t);
}), Pn = Aq;
var Eq = "Expected a function";
function Tq(n1, t, e) {
    var r = !0, i = !0;
    if (typeof n1 != "function") throw new TypeError(Eq);
    return yi(e) && (r = "leading" in e ? !!e.leading : r, i = "trailing" in e ? !!e.trailing : i), vo(n1, t, {
        leading: r,
        maxWait: t,
        trailing: i
    });
}
var lA = Tq;
function cv(n1) {
    for (let t of Object.keys(n1))n1[t] === void 0 && delete n1[t];
    return n1;
}
function qi(n1, t) {
    return Object.setPrototypeOf(n1, t), n1;
}
var Mq = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes(" electron/"), Cq = ()=>typeof window > "u" ? !1 : window.navigator.platform.toUpperCase().includes("MAC"), Pq = ()=>typeof window > "u" ? !1 : /iPad|iPhone|iPod/.test(window.navigator.userAgent) || Ih && "ontouchend" in document, _q = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1, Iq = ()=>typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0, Dq = ()=>{
    if (typeof window > "u") return !1;
    let n1 = navigator.userAgent, t = navigator.vendor;
    return /Safari/i.test(n1) && /Apple Computer/.test(t);
}, Oq = ()=>{
    if (typeof window > "u") return null;
    let t = navigator.userAgent.match(/Version\/(\d+\.\d)/);
    return t && t[1];
}, Rq = ()=>{
    if (typeof window > "u") return;
    let t = new URLSearchParams(window.location.search).get("desktop-app-version");
    return t ? (window.localStorage.setItem("desktop-app-version", t), t) : window.localStorage.getItem("desktop-app-version") ?? "0.0.6";
}, cA = Mq(), Xce = cA ? Rq() : void 0, Ih = Cq(), xo = Pq(), $2 = _q(), Ci = Iq(), uA = Dq(), eI = Number(Oq());
function uv(n1) {
    return Array.isArray(n1) ? n1 : [
        n1
    ];
}
function hv(n1, t) {
    let e = 0;
    for(; e < n1.length && e < t.length;){
        if (n1[e] < t[e]) return -1;
        if (n1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== n1.length ? 1 : 0;
}
function Bp(n1) {
    return Ih ? n1.metaKey : n1.ctrlKey;
}
function tI(n1) {
    return n1.wheelDeltaY === 0 || n1.deltaY === 0 ? Ih && n1.shiftKey && Math.abs(n1.wheelDeltaX) >= 120 ? !1 : n1.wheelDeltaX ? n1.wheelDeltaX === -3 * n1.deltaX || n1.wheelDeltaX === -3 * window.devicePixelRatio * n1.deltaX : n1.deltaMode === 0 : n1.wheelDeltaY ? n1.wheelDeltaY === -3 * n1.deltaY || n1.wheelDeltaY === -3 * window.devicePixelRatio * n1.deltaY : n1.deltaMode === 0;
}
var Je = [], fv = {}, Np = {}, dv = {};
function rI(n1) {
    Je.includes(n1) || Je.push(n1);
}
function Dh(n1) {
    delete fv[n1.pointerId];
    for(let t = 0; t < Je.length; t++)if (Je[t].pointerId === n1.pointerId) {
        Je.splice(t, 1);
        break;
    }
}
function iI() {
    Je.splice(0, Je.length);
}
function pv(n1) {
    if (n1.pointerType !== "touch") return;
    let t = fv[n1.pointerId];
    t === void 0 && (t = {
        x: 0,
        y: 0
    }, fv[n1.pointerId] = t), t.x = n1.pageX, t.y = n1.pageY;
}
function mv(n1) {
    let t = n1.pointerId === Je[0].pointerId ? Je[1] : Je[0];
    return fv[t.pointerId];
}
function nI(n1) {
    Np[n1.key] = !0, dv[n1.key] = dv[n1.key] === void 0 ? 1 : dv[n1.key] + 1;
}
function sI(n1) {
    if (Ih && Np.Meta) for(let t in Np)Np[t] = !1;
    else Np[n1.key] = !1;
    dv = {};
}
function oI(n1) {
    n1.addEventListener("pointerdown", rI, !0), n1.addEventListener("pointerdown", pv, !0), n1.addEventListener("pointermove", pv, !0), n1.addEventListener("pointerup", Dh, !0), n1.addEventListener("pointercancel", Dh, !0), n1.addEventListener("pointerleave", Dh, !0), window.addEventListener("keydown", nI, !0), window.addEventListener("keyup", sI, !0);
}
function aI(n1) {
    n1.removeEventListener("pointerdown", rI, !0), n1.removeEventListener("pointerdown", pv, !0), n1.removeEventListener("pointermove", pv, !0), n1.removeEventListener("pointerup", Dh, !0), n1.removeEventListener("pointercancel", Dh, !0), n1.removeEventListener("pointerleave", Dh, !0), window.removeEventListener("keydown", nI, !0), window.removeEventListener("keyup", sI, !0);
}
var lI, cI = new Promise((n1)=>{
    lI = n1;
});
var gv;

function uI() {
    if (gv) return gv;
    async function n1() {
        let e = "https://unpkg.com/@splinetool/navmesh-wasm@1.9.46/build", i = (parcelRequire("8b5hF")), [s, o] = await Promise.all([
            i,
            fetch(`${e}/navmesh.wasm`).then((c)=>c.arrayBuffer())
        ]), a = s.default, l = await a({
            wasmBinary: o
        });
        lI(l);
    }
    return gv = n1(), gv;
}
var hI, dI = new Promise((n1)=>{
    hI = n1;
});
var yv;

function fI() {
    if (yv) return yv;
    async function n1() {
        let e = await (parcelRequire("lUNnT"));
        await e.init(), hI(e);
    }
    return yv = n1(), yv;
}
var Qe = class {
    modifyById(t, e) {
        let r = this;
        if (r[t] === void 0) throw new Error("not expected");
        {
            let s = {
                ...r,
                [t]: e
            };
            return Object.setPrototypeOf(s, Qe.prototype), s;
        }
    }
    add(t, e) {
        return this.runOp({
            type: 1,
            id: t,
            data: e
        })?.data ?? this;
    }
    runOp(t) {
        let e = this;
        if (t.type === 1) {
            let r = e[t.id], i;
            r === void 0 ? i = {
                type: 2,
                id: t.id
            } : i = {
                type: 1,
                id: t.id,
                data: r
            };
            let { id: s, data: o } = t, a = {
                ...e,
                [s]: o
            };
            return Object.setPrototypeOf(a, Qe.prototype), {
                data: a,
                actual: t,
                reverse: i
            };
        } else if (t.type === 2) {
            let { id: r } = t, i = e[r];
            if (i === void 0) return null;
            {
                let s = {
                    ...e
                };
                return Object.setPrototypeOf(s, Qe.prototype), delete s[r], {
                    data: s,
                    actual: t,
                    reverse: {
                        type: 1,
                        id: r,
                        data: i
                    }
                };
            }
        }
        return null;
    }
};
function Fp(n1) {
    if (n1.deepFreeze !== void 0) {
        n1.deepFreeze(n1);
        return;
    }
    let t = Object.getOwnPropertyNames(n1);
    for (let e of t){
        let r = n1[e];
        r && typeof r == "object" && Fp(r);
    }
    return Object.freeze(n1);
}
function pI(n1, t) {
    let e = 0;
    for(; e < n1.length && e < t.length;){
        if (n1[e] < t[e]) return -1;
        if (n1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== n1.length ? 1 : 0;
}
var Oh = class extends Error {
};
function vv(n1) {
    let t = {
        ...n1
    };
    return Object.setPrototypeOf(t, Object.getPrototypeOf(n1)), t;
}
function bo(n1, t, e) {
    if (n1 === void 0 ? t === void 0 ? (n1 = 0, t = 10) : n1 = t - 10 : t === void 0 && (t = n1 + 10), n1 > t) {
        let s = n1;
        n1 = t, t = s;
    }
    let r = [], i = 1 / (e + 1);
    for(let s = 0; s < e; s++){
        let o = n1 + (t - n1) * (s + .75 + Math.random() * .5) * i;
        r.push(o);
    }
    return r;
}
function Rh(n1) {
    return n1 instanceof Uint8Array || n1 instanceof Uint16Array || n1 instanceof Uint32Array || n1 instanceof Int8Array || n1 instanceof Int16Array || n1 instanceof Int32Array || n1 instanceof Float32Array || n1 instanceof Float64Array;
}
function mI() {
    return typeof $hPtJY < "u";
}
function gI(n1, t) {
    for (let e of n1)t(e.id, e.data) !== !0 && gI(e.children, t);
}
function yI(n1, t) {
    if (t(n1.id, n1.data) !== !0) for (let e of n1.children)yI(e, t);
}
var gr = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, gr.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)Fp(this[e]), e++;
    }
    fillCaches0(e, r) {
        this.objCaches.set(e.id, e), this.parentCaches.set(e.id, r);
        for (let i of e.children)this.fillCaches0(i, e.id);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, this.parentCaches = new Map;
            for (let e of this)this.fillCaches0(e, null);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    nonExistOrDescendantOf(e, r) {
        if (!this.has(e)) return !0;
        for(; e;){
            let i = this.parent(e);
            if (i === r) return !0;
            e = i;
        }
        return !1;
    }
    rootAcestor(e) {
        for(; e;){
            let r = this.parent(e);
            if (r) e = r;
            else return e;
        }
        return e;
    }
    isDescendantOf(e, r) {
        for(; e;){
            let i = this.parent(e);
            if (i === r) return !0;
            e = i;
        }
        return !1;
    }
    data(e) {
        return this.get(e)?.data;
    }
    has(e) {
        return this.childrenOf(e) !== void 0;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    childrenOf(e) {
        return e === null ? this : this.get(e)?.children;
    }
    traverseFrom(e, r) {
        if (e === null) this.traverse(r);
        else {
            let i = this.get(e);
            i && yI(i, r);
        }
    }
    traverse(e) {
        gI(this, e);
    }
    totalSize() {
        return this.fillCaches(), this.objCaches.size;
    }
    parent(e) {
        return this.fillCaches(), this.parentCaches.get(e);
    }
    childrenArray(e) {
        return e === null ? this : this.get(e).children;
    }
    modifyById(e, r) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s = this.parent(e), o = this.childrenArray(s), a = o.findIndex((u)=>u.id === e);
            if (a < 0) throw new Error("not expected");
            let l = o[a];
            return o = [
                ...o
            ], o[a] = {
                ...l,
                data: r
            }, this.modifyArrayBy(s, o);
        }
    }
    modifyArrayBy(e, r) {
        let i = e, s = r;
        for(; i !== null;){
            let a = s, l = i;
            if (i = this.parent(i), i === void 0) throw new Error;
            s = this.childrenArray(i);
            let c = s.findIndex((u)=>u.id === l);
            if (c < 0) throw new Error;
            s = [
                ...s
            ], s[c] = {
                ...s[c],
                children: a
            };
        }
        Object.setPrototypeOf(s, gr.prototype);
        let o = s;
        return o.fillCaches(), o;
    }
    runOp(e) {
        switch(e.type){
            case 7:
                return this.addOp(e);
            case 8:
                return this.deleteOp(e);
            case 9:
                return this.moveOp(e);
        }
        return null;
    }
    checkDuplicatedIdRec({ id: e, children: r }) {
        if (this.get(e) !== void 0) return !0;
        for (let i of r)if (this.checkDuplicatedIdRec(i)) return !0;
        return !1;
    }
    addOp(e) {
        let { parent: r, fi: i, id: s, data: o, children: a } = e;
        if (r !== null && this.get(r) === void 0) return null;
        if (this.checkDuplicatedIdRec(e)) return null;
        {
            let l = r, c = this.childrenArray(l), u = {
                fi: i,
                id: s,
                data: o,
                children: a
            };
            return c = [
                ...c,
                u
            ], c.sort((d, f)=>d.fi - f.fi), e.localIndex = c.indexOf(u), {
                data: this.modifyArrayBy(l, c),
                actual: e,
                reverse: {
                    type: 8,
                    id: s
                }
            };
        }
    }
    deleteOp(e) {
        let { id: r } = e;
        if (this.get(r) === null) return null;
        {
            let i = this.parent(r);
            if (i === void 0) return null;
            let s = this.childrenArray(i), o = s.findIndex((c)=>c.id === r);
            e.localIndex = o, s = [
                ...s
            ];
            let a = s.splice(o, 1)[0];
            return {
                data: this.modifyArrayBy(i, s),
                actual: e,
                reverse: {
                    type: 7,
                    ...a,
                    parent: i
                }
            };
        }
    }
    moveOp(e) {
        let { parent: r, fi: i, id: s } = e;
        if (r !== null && this.get(r) === void 0) return this.deleteOp({
            type: 8,
            id: s
        });
        if (r !== null) {
            let f = r;
            for(; f !== null;){
                if (f === void 0) throw new Error;
                if (f === s) throw new Oh("cyclic tree");
                f = this.parent(f);
            }
        }
        let o = this.parent(s);
        if (o === void 0) return null;
        let a = o, l = this.childrenArray(o), c = l.findIndex((f)=>f.id === s);
        l = [
            ...l
        ];
        let u = l.splice(c, 1)[0], h = this.modifyArrayBy(o, l);
        o = r, l = h.childrenArray(o);
        let d = u.fi;
        return u = {
            ...u,
            fi: i
        }, l = [
            ...l,
            u
        ], l.sort((f, p)=>f.fi - p.fi), e.localIndex = l.indexOf(u), h = h.modifyArrayBy(o, l), {
            data: h,
            actual: e,
            reverse: {
                type: 9,
                parent: a,
                fi: d,
                id: s
            }
        };
    }
    previous(e, r) {
        if (r === null) {
            let s = this.childrenArray(e);
            return s.length === 0 ? null : s[s.length - 1].id;
        }
        let i = null;
        for (let s of this.childrenArray(e)){
            if (s.id === r) return i;
            i = s.id;
        }
        return null;
    }
    traverseSortNext(e) {
        let r = this.parent(e);
        if (r !== void 0) {
            let i = this.childrenArray(r), s = i.findIndex((o)=>o.id === e) + 1;
            if (s < i.length) return i[s].id;
            if (r) return this.traverseSortNext(r);
        }
    }
    sortNext(e) {
        let r = this.childrenArray(e);
        return r.length > 0 ? r[0].id : this.traverseSortNext(e);
    }
    traverseSortPrevious(e) {
        let r = this.childrenArray(e);
        return r.length > 0 ? this.traverseSortPrevious(r[r.length - 1].id) : e;
    }
    sortPrevious(e) {
        let r = this.parent(e);
        if (r !== void 0) {
            let i = this.childrenArray(r), s = i.findIndex((o)=>o.id === e) - 1;
            return s >= 0 ? this.traverseSortPrevious(i[s].id) : r;
        }
    }
    getAllSorted(e) {
        let r = [];
        for (let i of e){
            let s = this.getWithSortKey(i.id);
            s !== void 0 && r.push({
                ...i,
                ...s
            });
        }
        r.sort((i, s)=>pI(i.sortKey, s.sortKey));
        for (let i of r)delete i.sortKey;
        return r;
    }
    getWithSortKey(e) {
        var r = e;
        let i = [], s = this.get(r), o = s;
        if (s !== void 0) {
            for(; r;)i.splice(0, 0, s.fi), r = this.parent(r), r !== null && (s = this.get(r));
            return {
                ...o,
                sortKey: i
            };
        }
    }
    insertBeforeHelper(e, r, i) {
        return this.insertAfterHelper(e, this.previous(e, r), i);
    }
    insertAfterHelper(e, r, i) {
        let s = this.childrenArray(e);
        if (r === null) {
            if (s.length === 0) return bo(0, i, i);
            {
                let o = s[0].fi;
                return bo(o - i, o, i);
            }
        } else {
            let o = this.get(r);
            if (o === void 0 || this.parent(r) !== e) throw new Error("illegal args");
            let a = s.find((l)=>l.fi > o.fi);
            if (a === void 0) {
                let l = s[s.length - 1].fi;
                return bo(l, l + i, i);
            } else return bo(o.fi, a.fi, i);
        }
    }
};
var Lh;
((t)=>{
    function n1(e, r) {
        if (r.type !== 0) return null;
        if (Array.isArray(e)) {
            let i = r.props, s = {}, o = [
                ...e
            ], a = !1;
            if (i) for (let l of Object.keys(i)){
                let c = parseInt(l);
                if (isNaN(c)) throw new Error("wrong index");
                s[l] = o[c], o[c] = i[l], a = !0;
            }
            return a ? {
                data: o,
                actual: r,
                reverse: {
                    type: 0,
                    props: s
                }
            } : null;
        } else {
            let i = r.props, s = {}, o = {
                ...e
            }, a = !1;
            if (i) for (let l of Object.keys(i)){
                s[l] = o[l];
                let c = i[l];
                c === void 0 ? delete o[l] : o[l] = c, a = !0;
            }
            return a ? {
                data: o,
                actual: r,
                reverse: {
                    type: 0,
                    props: s
                }
            } : null;
        }
    }
    t.runOp = n1;
})(Lh || (Lh = {}));
var ke = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, ke.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)Fp(this[e]), e++;
    }
    fillCaches0(e) {
        this.objCaches.set(e.id, e);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, Object.getOwnPropertyDescriptor(this, "objCaches").enumerable = !1;
            for (let e of this)this.fillCaches0(e);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    data(e) {
        return this.get(e)?.data;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    modifyById(e, r) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s = this, o = s.findIndex((c)=>c.id === e);
            if (o < 0) throw new Error("not expected");
            let a = s[o];
            return s = [
                ...s
            ], s[o] = {
                ...a,
                data: r
            }, this.modifyArrayBy(s);
        }
    }
    modifyArrayBy(e) {
        Object.setPrototypeOf(e, ke.prototype);
        let r = e;
        return mI() || r.fillCaches(), r;
    }
    runOp(e) {
        switch(e.type){
            case 4:
                return this.addOp(e);
            case 5:
                return this.deleteOp(e);
            case 6:
                return this.moveOp(e);
        }
        return null;
    }
    addOp(e) {
        let { fi: r, id: i, data: s } = e, o = this, a = {
            fi: r,
            id: i,
            data: s
        };
        return o = [
            ...o,
            a
        ], o.sort((c, u)=>c.fi - u.fi), e.localIndex = o.indexOf(a), {
            data: this.modifyArrayBy(o),
            actual: e,
            reverse: {
                type: 5,
                id: i
            }
        };
    }
    deleteOp(e) {
        let { id: r } = e, i = this, s = i.findIndex((l)=>l.id === r);
        if (s === -1) return null;
        e.localIndex = s, i = [
            ...i
        ];
        let o = i.splice(s, 1)[0];
        return {
            data: this.modifyArrayBy(i),
            actual: e,
            reverse: {
                type: 4,
                ...o
            }
        };
    }
    moveOp(e) {
        let { fi: r, id: i } = e, s = this;
        s = [
            ...s
        ];
        let o = s.findIndex((u)=>u.id === i);
        if (o === -1) return null;
        let a = s[o].fi, l = {
            ...s[o],
            fi: r
        };
        return s[o] = l, s.sort((u, h)=>u.fi - h.fi), e.localIndex = s.indexOf(l), {
            data: this.modifyArrayBy(s),
            actual: e,
            reverse: {
                type: 6,
                fi: a,
                id: i
            }
        };
    }
    previous(e) {
        if (e === null) return this.length === 0 ? null : this[this.length - 1].id;
        let r = null;
        for (let i of this){
            if (i.id === e) return r;
            r = i.id;
        }
        return null;
    }
    insertBeforeHelper(e, r) {
        return this.insertAfterHelper(this.previous(e), r);
    }
    insertAfterHelper(e, r) {
        let i = this;
        if (e === null) {
            if (i.length === 0) return bo(0, r, r);
            {
                let s = i[0].fi;
                return bo(s - r, s, r);
            }
        } else {
            let s = this.get(e);
            if (s === void 0) throw new Error("illegal args");
            let o = i.find((a)=>a.fi > s.fi);
            if (o === void 0) {
                let a = i[i.length - 1].fi;
                return bo(a, a + r, r);
            } else return bo(s.fi, o.fi, r);
        }
    }
};
function Bh(n1) {
    return n1 && typeof n1 == "object" && n1 instanceof yr;
}
var yr = class {
    unusedFunOverridesTable(t) {}
    runOp(t) {
        let e = [], r = this, i = 0, s = {};
        for(; i < t.path.length;){
            if (e.push(r), r = r === void 0 ? void 0 : r[t.path[i]], r !== void 0 && !Bh(r)) return null;
            i += 1;
        }
        r = r ? vv(r) : new yr;
        for (let [l, c] of Object.entries(t.props)){
            let u = r[l];
            s[l] = u, c === void 0 ? delete r[l] : r[l] = c;
        }
        for(; i > 0;){
            if (Object.keys(r).length === 0) {
                let l = e[i - 1];
                l && (r = vv(l), delete r[t.path[i - 1]]);
            } else {
                let l = e[i - 1];
                if (l) {
                    let c = vv(l);
                    c[t.path[i - 1]] = r, r = c;
                } else {
                    let c = new yr;
                    c[t.path[i - 1]] = r, r = c;
                }
            }
            i -= 1;
        }
        let o = Object.setPrototypeOf(r, yr.prototype), a = {
            ...t,
            props: s
        };
        return {
            data: o,
            actual: t,
            reverse: a
        };
    }
}, So;
((r)=>{
    function n1(i, s) {
        return Vp(i, s) ?? i;
    }
    r.apply = n1;
    function t(i, s) {
        return dA(i, s);
    }
    r.merge = t;
    function e(i, s) {
        let o = 0, a = s.path, l = i;
        for(; o < a.length && l !== void 0;){
            if (l = Sr.zoomOnce(l, a[o]), l === void 0) return s;
            if (!Bh(l)) return;
            o += 1;
        }
        if (l === void 0) return s;
        if (!!Bh(l)) {
            if (s.type === 0) {
                let c = {
                    ...s.props
                };
                for (let u of Object.keys(l))delete c[u];
                return {
                    ...s,
                    props: c
                };
            } else if (s.type === 1 || s.type === 4 || s.type === 7) {
                let c = hA([
                    s
                ], l);
                return c ? (console.log(c), c) : s;
            } else return s;
        }
    }
    r.filterOp = e;
})(So || (So = {}));
function hA(n1, t) {
    if (t === void 0) return;
    let e = !1, r = n1.map((i)=>{
        let s = i.id, o = Vp(i.data, t[s]);
        if (e = e || o !== void 0, o === void 0 && (o = i.data), i.children) {
            let a = hA(i.children, t);
            return a !== void 0 ? e = !0 : a = i.children, {
                ...i,
                id: s,
                data: o,
                children: a
            };
        } else return {
            ...i,
            id: s,
            data: o
        };
    });
    if (e) return r;
}
function Lq(n1, t) {
    if (t === void 0) return;
    let e = !1, r = n1.map((i)=>{
        let s = i.id, o = Vp(i.data, t[s]);
        return e = e || o !== void 0, o === void 0 && (o = i.data), {
            ...i,
            id: s,
            data: o
        };
    });
    if (e) return Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r;
}
function Vp(n1, t) {
    if (!Bh(t)) return t;
    if (n1 instanceof gr) {
        let e = hA(n1, t);
        return e !== void 0 && Object.setPrototypeOf(e, Object.getPrototypeOf(n1)), e;
    } else {
        if (n1 instanceof ke) return Lq(n1, t);
        if (Array.isArray(n1)) {
            let e = !1, r = n1.map((i, s)=>{
                let o = Vp(i, t[s]);
                return e = e || o !== void 0, o === void 0 && (o = i), o;
            });
            return e ? (Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r) : void 0;
        } else {
            if (n1 instanceof yr) return dA(n1, t);
            if (n1 && typeof n1 == "object") {
                let e = {}, r = !1;
                for (let [i, s] of Object.entries(n1)){
                    let o = Vp(s, t[i]);
                    r = r || o !== void 0, o === void 0 && (o = s), e[i] = o;
                }
                return r ? (Object.setPrototypeOf(e, Object.getPrototypeOf(n1)), e) : void 0;
            }
        }
    }
}
function dA(n1, t) {
    if (n1 === void 0) return t;
    if (t === void 0) return n1;
    if (!Bh(t)) return t;
    if (!Bh(n1)) return So.apply(n1, t);
    let e = new Set;
    for (let i of Object.keys(n1))e.add(i);
    for (let i of Object.keys(t))e.add(i);
    let r = new yr;
    for (let i of e){
        let s = dA(n1 === void 0 ? void 0 : n1[i], t === void 0 ? void 0 : t[i]);
        r[i] = s;
    }
    return r;
}
function vI(n1, t) {
    let e = {
        cur: [],
        result: [],
        len: 0
    };
    return n1 = kp(n1, t, e) ?? n1, [
        n1,
        e.result
    ];
}
function xv(n1, t) {
    return n1 === null ? null : (n1.cur[n1.len] = t, n1.len += 1, n1);
}
function bv(n1) {
    n1 && (n1.len -= 1);
}
function Bq(n1) {
    if (n1 === null) return null;
    n1.result.push(n1.cur.slice(0, n1.len));
}
function xI(n1, t, e) {
    let r = !1, i = n1.map((s)=>{
        let o = s.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (r = !0, o = a, e !== null)) throw new Error("not supported");
        let l = kp(s.data, t, xv(e, o));
        bv(e), r = r || l !== void 0, l === void 0 && (l = s.data);
        let c = xI(s.children, t, e);
        return c !== void 0 ? r = !0 : c = s.children, {
            ...s,
            id: o,
            data: l,
            children: c
        };
    });
    if (r) return i;
}
function Nq(n1, t, e) {
    let r = !1, i = n1.map((s)=>{
        let o = s.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (r = !0, o = a, e !== null)) throw new Error("not supported");
        let l = kp(s.data, t, xv(e, o));
        return bv(e), r = r || l !== void 0, l === void 0 && (l = s.data), {
            ...s,
            id: o,
            data: l
        };
    });
    if (r) return Object.setPrototypeOf(i, Object.getPrototypeOf(n1)), i;
}
function kp(n1, t, e) {
    if (n1 instanceof gr) {
        let r = xI(n1, t, e);
        return r !== void 0 && Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r;
    } else {
        if (n1 instanceof ke) return Nq(n1, t, e);
        if (Array.isArray(n1)) {
            let r = !1, i = n1.map((s, o)=>{
                let a = kp(s, t, xv(e, o));
                return bv(e), r = r || a !== void 0, a === void 0 && (a = s), a;
            });
            return r ? (Object.setPrototypeOf(i, Object.getPrototypeOf(n1)), i) : void 0;
        } else if (n1 && typeof n1 == "object" && !Rh(n1)) {
            let r = {}, i = !1;
            for (let [s, o] of Object.entries(n1))if (s !== "name" && s !== "variableId") {
                let a = t[s];
                if (typeof a == "string") {
                    if (e !== null) throw new Error("not supported");
                    i = !0, s = a;
                }
                let l = kp(o, t, xv(e, s));
                bv(e), i = i || l !== void 0, l === void 0 && (l = o), r[s] = l;
            } else r[s] = o;
            return i ? (Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r) : void 0;
        } else if (typeof n1 == "string") {
            let r = t[n1];
            return r !== void 0 && Bq(e), r;
        } else return;
    }
}
var Nh;
((t)=>{
    function n1(e, r) {
        let i = Sr.zoom(r, e.path);
        if (typeof i == "object") {
            let s = {};
            for (let o of Object.keys(e.props))s[o] = i[o];
            return {
                ...e,
                props: s
            };
        } else return {
            ...e,
            props: {}
        };
    }
    t.replaceProps = n1;
})(Nh || (Nh = {}));
var Lr;
((a)=>{
    function n1(l, c) {
        return {
            ...l,
            path: l.path.slice(c)
        };
    }
    a.drop = n1;
    function t(l, c) {
        return e(l, c)?.data ?? l;
    }
    a.applySimple = t;
    function e(l, c) {
        let u = c.path;
        for(var h = [];;){
            let d;
            if (l instanceof yr && c.type === 0 && (d = l.runOp({
                ...c,
                path: u.slice(h.length)
            }), d === null && (d = void 0)), d === void 0 && h.length === u.length && (l instanceof gr || l instanceof ke || l instanceof Qe ? d = l.runOp(c) : d = Lh.runOp(l, c)), d !== void 0) {
                if (d !== null) {
                    let m = d.data;
                    for(let g = h.length - 1; g >= 0; g--){
                        let y = u[g], x = h[g];
                        if (x instanceof gr) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            m = x.modifyById(y, m);
                        } else if (x instanceof ke) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            m = x.modifyById(y, m);
                        } else if (x instanceof Qe) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            m = x.modifyById(y, m);
                        } else if (x instanceof yr) {
                            let v = {
                                ...x,
                                [y]: m
                            };
                            m = Object.setPrototypeOf(v, yr.prototype);
                        } else if (typeof x == "object") {
                            if (Array.isArray(x)) {
                                if (typeof y == "string" && (y = parseInt(y), isNaN(y))) throw new Error("Invalid path");
                                let v = m;
                                m = [
                                    ...x
                                ], m[y] = v;
                            } else m = {
                                ...x,
                                [y]: m
                            };
                        } else return null;
                    }
                    return {
                        data: m,
                        actual: {
                            ...d.actual,
                            path: u
                        },
                        reverse: {
                            ...d.reverse,
                            path: u
                        }
                    };
                } else return null;
            }
            let f = u[h.length], p;
            if (l instanceof gr) {
                if (typeof f == "number") throw new Error("");
                p = l.get(f)?.data;
            } else if (l instanceof ke) {
                if (typeof f == "number") throw new Error("");
                p = l.get(f)?.data;
            } else l !== null && (p = l[f]);
            if (p !== void 0) h.push(l), l = p;
            else return null;
        }
    }
    a.apply = e;
    function r(l, c) {
        for(let u = 0; u < l.length && u < c.length; u++)if (l[u] !== c[u]) return !0;
        return !1;
    }
    a.pathDisjoint = r;
    function i(l, c) {
        if (l.length !== c.length) return !1;
        for(let u = 0; u < l.length; u++)if (l[u] !== c[u]) return !1;
        return !0;
    }
    a.pathEq = i;
    function s(l, c) {
        return r(l.path, c.path);
    }
    a.commutative = s;
    function o(l, c) {
        return l.type === 0 && c.type === 0 && i(l.path, c.path) ? Object.keys(l.props).every((u)=>c.props[u] !== void 0) : !1;
    }
    a.subsumed = o;
})(Lr || (Lr = {}));
var Up;
((l)=>{
    function n1() {
        return [];
    }
    l.empty = n1;
    function t(c, u) {
        let h = [];
        for (let d of c){
            let [f, ...p] = d.path;
            f === u && h.push({
                ...d,
                path: p
            });
        }
        return h;
    }
    l.removePrefix = t;
    function e(c, u) {
        return c.map((h)=>({
                ...h,
                path: [
                    u,
                    ...h.path
                ]
            }));
    }
    l.addPrefix = e;
    function r(c, u) {
        return [
            ...c,
            ...u
        ];
    }
    l.concat = r;
    function i(c, u) {
        return [
            ...c.filter((d)=>!u.some((f)=>Lr.subsumed(d, f))),
            ...u
        ];
    }
    l.compress = i;
    function s(c, u) {
        return c.every((h)=>u.every((d)=>Lr.commutative(h, d)));
    }
    l.commutative = s;
    function o(c, u) {
        for (let h of u){
            let d = a(c, h);
            d !== null && (c = d.data);
        }
        return c;
    }
    l.applyAll = o;
    function a(c, u) {
        var h = c;
        let d = [], f = [];
        for (let p of u)try {
            if (p.type === 3 || p.type === 5 && p.path[p.path.length - 1] === "variables") {
                let m, g, y;
                if (p.type === 3 ? (m = Sr.zoom(h, [
                    ...p.path,
                    p.id
                ]), y = Lr.apply(h, {
                    ...p,
                    type: 2
                })) : (m = Sr.zoom(h, [
                    ...p.path,
                    p.id,
                    "value"
                ]), y = Lr.apply(h, p)), y !== null) {
                    h = y.data;
                    let [x, v] = vI(h, {
                        [p.id]: m
                    });
                    h = x;
                    for(let S = 0; S < v.length; S++){
                        let w = v[S], A = w.pop();
                        if (typeof A == "number") {
                            let T = [
                                A
                            ];
                            for(let M = S + 1; M < v.length; M++){
                                let C = v[M], P = C[C.length - 1];
                                if (typeof P == "number" && Sr.equal(w, C.slice(0, C.length - 1))) T.push(P), v.splice(M, 1);
                                else break;
                            }
                            let b = Sr.zoom(h, w);
                            g = b.map((M, C)=>T.includes(C) ? p.id : M), m = b, A = w.pop();
                        } else {
                            if (A === "alphaOverride" || A === "alpha") {
                                m /= 100;
                                let T = m, b = Sr.zoom(h, w.slice(0, w.length - 2)), M = b.layers.map((C)=>C.id === w[w.length - 1] ? {
                                        ...C,
                                        data: {
                                            ...C.data,
                                            [A]: T
                                        }
                                    } : C);
                                Object.setPrototypeOf(M, Object.getPrototypeOf(b.layers)), b.layers = M;
                            }
                            g = p.id;
                        }
                        d.push({
                            type: 0,
                            path: w,
                            props: {
                                [A]: m
                            }
                        }), f.push({
                            type: 0,
                            path: w,
                            props: {
                                [A]: g
                            }
                        });
                    }
                    f.push(y.reverse), d.push(y.actual);
                }
            } else {
                let m = Lr.apply(h, p);
                m !== null && (d.push(m.actual), h = m.data, f.push(m.reverse));
            }
        } catch (m) {
            if (m instanceof Oh) return null;
            throw m;
        }
        return {
            data: h,
            actual: d,
            reverse: f.reverse()
        };
    }
    l.apply = a;
})(Up || (Up = {}));
var bI = Symbol(), Fq = Symbol(), wv = Symbol(), Oc = class {
    reportOp(t, e, r = []) {
        let i = this;
        if (e === null) return;
        i._current = e.data;
        let s = r;
        for(; !(i instanceof Sv);){
            let o = i._path, a = i._current;
            if (o !== "" && s.splice(0, 0, o), i = i._parent, i === null) return;
            i.update(o, a);
        }
        i.push(s, t, e.actual, e.reverse);
    }
    deleteChildren(t) {
        if (this._children) {
            let e = this._children[t];
            if (e) {
                let r = e[wv];
                r && r(), delete this._children[t];
            }
        }
    }
}, pA = class extends Oc {
    constructor(t, e, r){
        super(), this._parent = t, this._path = e, this._current = r;
    }
    update(t, e) {
        if (Array.isArray(this._current)) {
            if (typeof t == "string" && (t = parseInt(t), isNaN(t))) throw new Error("Invalid path");
            this._current = [
                ...this._current
            ], this._current[t] = e;
        } else this._current = {
            ...this._current,
            [t]: e
        };
    }
    runOp(t) {
        this.reportOp(t, Lh.runOp(this._current, t), t.path);
    }
}, mA = class extends Oc {
    constructor(t, e, r){
        super(), this._parent = t, this._path = e, this._current = r;
    }
    update(t, e) {
        this._current = {
            ...this._current,
            [t]: e
        }, Object.setPrototypeOf(this._current, Qe.prototype);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
}, SI = {
    get (n1, t) {
        if (t === wv) return ()=>{
            n1._parent = null;
        };
        if (t === bI) return n1._current;
        if (t === Fq) return n1;
        let { _current: e, _children: r } = n1;
        if (t === "push" && Array.isArray(e)) throw new Error("not supported to expand array");
        let i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s = e[t], o = Av(n1, t, s);
        return o !== s ? (r === void 0 && (r = {}, n1._children = r), r[t] = o, o) : s;
    },
    has (n1, t) {
        return t in n1._current;
    },
    ownKeys (n1) {
        return Reflect.ownKeys(n1._current);
    },
    defineProperty () {
        throw Error("not supported");
    },
    getPrototypeOf (n1) {
        return Object.getPrototypeOf(n1._current);
    },
    setPrototypeOf () {
        throw Error("not supported");
    },
    getOwnPropertyDescriptor (n1, t) {
        let e = n1._current, r = Reflect.getOwnPropertyDescriptor(e, t);
        return r && {
            writable: !0,
            configurable: !0,
            enumerable: r.enumerable,
            value: e[t]
        };
    }
}, Vq = {
    ...SI,
    set (n1, t, e) {
        let r = {
            type: 0,
            props: {
                [t]: zr(e) ?? e
            }
        };
        return n1.deleteChildren(t), n1.runOp(r), !0;
    },
    deleteProperty (n1, t) {
        let e = {
            type: 0,
            props: {
                [t]: void 0
            }
        };
        return n1.deleteChildren(t), n1.runOp(e), !0;
    }
}, kq = {
    ...SI,
    set (n1, t, e) {
        return e === void 0 ? this.deleteProperty(n1, t) : (n1.deleteChildren(t), n1.runOp({
            type: 1,
            id: t,
            data: e
        })), !0;
    },
    deleteProperty (n1, t) {
        return n1.runOp({
            type: 2,
            id: t
        }), !0;
    }
}, Fh = class extends Oc {
    constructor(t, e, r){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = r, this[wv] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    randomId() {
        return this._current.randomId();
    }
    isDescendantOf(t, e) {
        return this._current.isDescendantOf(t, e);
    }
    childrenOf(t) {
        return this._current.childrenOf(t);
    }
    traverse(t) {
        return this._current.traverse(t);
    }
    get(t) {
        return this._current.get(t);
    }
    parent(t) {
        return this._current.parent(t);
    }
    traverse(t) {
        this._current.traverse((e, r)=>{
            t(e, this.data(e));
        });
    }
    data(t) {
        let { _current: e, _children: r } = this, i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s = e.get(t)?.data, o = Av(this, t, s);
        return o !== s ? (r === void 0 && (r = {}, this._children = r), r[t] = o, o) : s;
    }
    add(t, e, r, i, s) {
        this.runOp({
            type: 7,
            parent: t,
            fi: e,
            id: r,
            data: i,
            children: s
        });
    }
    move(t, e, r) {
        this.runOp({
            type: 9,
            parent: t,
            fi: e,
            id: r
        });
    }
    insertAfter(t, e, r) {
        let i = this._current.insertAfterHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.add(t, i[s], o.id, o.data, o.children);
        }
    }
    insertBefore(t, e, r) {
        let i = this._current.insertBeforeHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.add(t, i[s], o.id, o.data, o.children);
        }
    }
    moveAfter(t, e, r) {
        let i = this._current.insertAfterHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.move(t, i[s], o);
        }
    }
    moveBefore(t, e, r) {
        let i = this._current.insertBeforeHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.move(t, i[s], o);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 8,
            id: t
        });
    }
    sortNext(t) {
        return this._current.sortNext(t);
    }
    sortPrevious(t) {
        return this._current.sortPrevious(t);
    }
    getAllSorted(t) {
        return this._current.getAllSorted(t);
    }
}, Vh = class extends Oc {
    constructor(t, e, r){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = r, this[wv] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    get length() {
        return this._current.length;
    }
    forEach(t) {
        let e = this.length;
        for(let r = 0; r < e; r++){
            let i = this._current[r].id, s = this._current[r].fi;
            t(this.data(this._current[r].id), i, s);
        }
    }
    find(t) {
        let e = this.length;
        for(let r = 0; r < e; r++){
            let i = this._current[r].id;
            if (t(this.data(i), i)) return this.get(i);
        }
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    randomId() {
        return this._current.randomId();
    }
    get(t) {
        return {
            ...this._current.get(t),
            data: this.data(t)
        };
    }
    data(t) {
        let { _current: e, _children: r } = this, i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s = e.get(t)?.data, o = Av(this, t, s);
        return o !== s ? (r === void 0 && (r = {}, this._children = r), r[t] = o, o) : s;
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    add(t, e, r) {
        this.runOp({
            type: 4,
            fi: t,
            id: e,
            data: r
        });
    }
    move(t, e) {
        this.runOp({
            type: 6,
            fi: t,
            id: e
        });
    }
    insertAfter(t, e) {
        let r = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.add(r[i], s.id, s.data);
        }
    }
    insertBefore(t, e) {
        let r = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.add(r[i], s.id, s.data);
        }
    }
    moveAfter(t, e) {
        let r = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.move(r[i], s);
        }
    }
    moveBefore(t, e) {
        let r = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.move(r[i], s);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 5,
            id: t
        });
    }
};
function fA(n1, t, e) {
    if (n1.length > 0) {
        let r = n1[n1.length - 1];
        if (r.type === 0 && t.type === 0 && Sr.equal(r.path, e)) {
            Object.assign(r.props, t.props);
            return;
        }
    }
    n1.push({
        ...t,
        path: e
    });
}
var Sv = class extends Oc {
    constructor(t){
        super(), this.ts = [], this.actual = [], this.reverse = [], this._current = t;
    }
    update(t, e) {
        if (t !== "") throw new Error("");
        this._current = e;
    }
    push(t, e, r, i) {
        fA(this.ts, e, t), fA(this.actual, r, t), fA(this.reverse, i, t);
    }
    result() {
        return {
            data: this._current,
            ts: this.ts,
            actual: this.actual,
            reverse: this.reverse.reverse()
        };
    }
};
function Av(n1, t, e) {
    return e instanceof gr ? new Fh(n1, t, e) : e instanceof ke ? new Vh(n1, t, e) : e instanceof Qe ? new Proxy(new mA(n1, t, e), kq) : e !== null && typeof e == "object" ? Rh(e) ? e : new Proxy(new pA(n1, t, e), Vq) : e;
}
function gA(n1) {
    let t = new Sv(n1);
    return [
        Av(t, "", n1),
        t
    ];
}
function vl(n1, t) {
    let [e, r] = gA(n1);
    return t(e), r.result();
}
function zr(n1) {
    return n1 instanceof Fh || n1 instanceof Vh ? n1._current : n1 !== null && typeof n1 == "object" ? n1[bI] : n1;
}
var Sr;
((i)=>{
    function n1(s, o) {
        if (o.length === s.length) for(var a = 0; a < s.length;){
            if (s[a] !== o[a]) return !1;
            a += 1;
        }
        else return !1;
        return !0;
    }
    i.equal = n1;
    function t(s, o, a) {
        let l = r(a, s);
        if (l !== void 0 && typeof l == "object" && l !== null) {
            let c = {
                ...o
            };
            return Object.keys(l).forEach((u)=>{
                delete c[u];
            }), c;
        } else return o;
    }
    i.removeOverridden = t;
    function e(s, o) {
        if ((s instanceof gr || s instanceof Fh) && typeof o == "string") return s.data(o);
        if ((s instanceof ke || s instanceof Vh) && typeof o == "string") return s.data(o);
        if (typeof o == "number" && Array.isArray(s)) return s[o];
        if (typeof o == "string" && typeof s == "object" && s !== null) return s[o];
    }
    i.zoomOnce = e;
    function r(s, o, a = 0) {
        for(; a < o.length && s !== void 0;)s = e(s, o[a]), a += 1;
        return s;
    }
    i.zoom = r;
})(Sr || (Sr = {}));
function wI(n1, t) {
    let e = [];
    if (t.length === n1.length) for(var r = 0; r < n1.length;){
        if (t[r] === "*") e.push(n1[r]);
        else if (n1[r] !== t[r]) return null;
        r += 1;
    }
    else return null;
    return e;
}
function Lt(n1, t) {
    let e = [];
    if (t.length <= n1.length) for(var r = 0; r < t.length;){
        if (t[r] === "*") e.push(n1[r]);
        else if (n1[r] !== t[r]) return null;
        r += 1;
    }
    else return null;
    return e;
}
var Ev = class {
}, zp = class extends Ev {
    constructor(e){
        super();
        this.id = e;
    }
}, Gp = class extends Ev {
    constructor(e){
        super();
        this.data = e;
    }
};
var vA;
try {
    vA = new TextDecoder;
} catch  {}
var qe, bl, ne = 0;
var II = [], xA = II, bA = 0, _n = {}, Zt, xl, us = 0, wo = 0, Zn, ma, yn = [], sr, AI = {
    useRecords: !1,
    mapsAsObjects: !0
}, jp = class {
}, wA = new jp;
wA.name = "MessagePack 0xC1";
var kh = !1, Ao = class {
    constructor(t){
        t && (t.useRecords === !1 && t.mapsAsObjects === void 0 && (t.mapsAsObjects = !0), t.structures ? t.structures.sharedLength = t.structures.length : t.getStructures && ((t.structures = []).uninitialized = !0, t.structures.sharedLength = 0)), Object.assign(this, t);
    }
    unpack(t, e) {
        if (qe) return BI(()=>(Mv(), this ? this.unpack(t, e) : Ao.prototype.unpack.call(AI, t, e)));
        bl = e > -1 ? e : t.length, ne = 0, bA = 0, wo = 0, xl = null, xA = II, Zn = null, qe = t;
        try {
            sr = t.dataView || (t.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength));
        } catch (r) {
            throw qe = null, t instanceof Uint8Array ? r : new Error("Source must be a Uint8Array or Buffer but was a " + (t && typeof t == "object" ? t.constructor.name : typeof t));
        }
        if (this instanceof Ao) {
            if (_n = this, this.structures) return Zt = this.structures, Tv();
            (!Zt || Zt.length > 0) && (Zt = []);
        } else _n = AI, (!Zt || Zt.length > 0) && (Zt = []);
        return Tv();
    }
    unpackMultiple(t, e) {
        let r, i = 0;
        try {
            kh = !0;
            let s = t.length, o = this ? this.unpack(t, s) : _v.unpack(t, s);
            if (e) {
                for(e(o); ne < s;)if (i = ne, e(Tv()) === !1) return;
            } else {
                for(r = [
                    o
                ]; ne < s;)i = ne, r.push(Tv());
                return r;
            }
        } catch (s) {
            throw s.lastPosition = i, s.values = r, s;
        } finally{
            kh = !1, Mv();
        }
    }
    _mergeStructures(t, e) {
        t = t || [];
        for(let r = 0, i = t.length; r < i; r++){
            let s = t[r];
            s && (s.isShared = !0, r >= 32 && (s.highByte = r - 32 >> 5));
        }
        t.sharedLength = t.length;
        for(let r in e || [])if (r >= 0) {
            let i = t[r], s = e[r];
            s && (i && ((t.restoreStructures || (t.restoreStructures = []))[r] = i), t[r] = s);
        }
        return this.structures = t;
    }
    decode(t, e) {
        return this.unpack(t, e);
    }
};
function Tv() {
    try {
        if (!_n.trusted && !kh) {
            let t = Zt.sharedLength || 0;
            t < Zt.length && (Zt.length = t);
        }
        let n1 = Xr();
        if (ne == bl) Zt.restoreStructures && EI(), Zt = null, qe = null, ma && (ma = null);
        else if (ne > bl) {
            let t = new Error("Unexpected end of MessagePack data");
            throw t.incomplete = !0, t;
        } else if (!kh) throw new Error("Data read, but end of buffer not reached");
        return n1;
    } catch (n1) {
        throw Zt.restoreStructures && EI(), Mv(), (n1 instanceof RangeError || n1.message.startsWith("Unexpected end of buffer")) && (n1.incomplete = !0), n1;
    }
}
function EI() {
    for(let n1 in Zt.restoreStructures)Zt[n1] = Zt.restoreStructures[n1];
    Zt.restoreStructures = null;
}
function Xr() {
    let n1 = qe[ne++];
    if (n1 < 160) {
        if (n1 < 128) {
            if (n1 < 64) return n1;
            {
                let t = Zt[n1 & 63] || _n.getStructures && DI()[n1 & 63];
                return t ? (t.read || (t.read = AA(t, n1 & 63)), t.read()) : n1;
            }
        } else if (n1 < 144) {
            if (n1 -= 128, _n.mapsAsObjects) {
                let t = {};
                for(let e = 0; e < n1; e++)t[RI()] = Xr();
                return t;
            } else {
                let t = new Map;
                for(let e = 0; e < n1; e++)t.set(Xr(), Xr());
                return t;
            }
        } else {
            n1 -= 144;
            let t = new Array(n1);
            for(let e = 0; e < n1; e++)t[e] = Xr();
            return t;
        }
    } else if (n1 < 192) {
        let t = n1 - 160;
        if (wo >= ne) return xl.slice(ne - us, (ne += t) - us);
        if (wo == 0 && bl < 140) {
            let e = t < 16 ? EA(t) : OI(t);
            if (e != null) return e;
        }
        return SA(t);
    } else {
        let t;
        switch(n1){
            case 192:
                return null;
            case 193:
                return Zn ? (t = Xr(), t > 0 ? Zn[1].slice(Zn.position1, Zn.position1 += t) : Zn[0].slice(Zn.position0, Zn.position0 -= t)) : wA;
            case 194:
                return !1;
            case 195:
                return !0;
            case 196:
                return yA(qe[ne++]);
            case 197:
                return t = sr.getUint16(ne), ne += 2, yA(t);
            case 198:
                return t = sr.getUint32(ne), ne += 4, yA(t);
            case 199:
                return Rc(qe[ne++]);
            case 200:
                return t = sr.getUint16(ne), ne += 2, Rc(t);
            case 201:
                return t = sr.getUint32(ne), ne += 4, Rc(t);
            case 202:
                if (t = sr.getFloat32(ne), _n.useFloat32 > 2) {
                    let e = Pv[(qe[ne] & 127) << 1 | qe[ne + 1] >> 7];
                    return ne += 4, (e * t + (t > 0 ? .5 : -0.5) >> 0) / e;
                }
                return ne += 4, t;
            case 203:
                return t = sr.getFloat64(ne), ne += 8, t;
            case 204:
                return qe[ne++];
            case 205:
                return t = sr.getUint16(ne), ne += 2, t;
            case 206:
                return t = sr.getUint32(ne), ne += 4, t;
            case 207:
                return _n.int64AsNumber ? (t = sr.getUint32(ne) * 4294967296, t += sr.getUint32(ne + 4)) : t = sr.getBigUint64(ne), ne += 8, t;
            case 208:
                return sr.getInt8(ne++);
            case 209:
                return t = sr.getInt16(ne), ne += 2, t;
            case 210:
                return t = sr.getInt32(ne), ne += 4, t;
            case 211:
                return _n.int64AsNumber ? (t = sr.getInt32(ne) * 4294967296, t += sr.getUint32(ne + 4)) : t = sr.getBigInt64(ne), ne += 8, t;
            case 212:
                if (t = qe[ne++], t == 114) return _I(qe[ne++] & 63);
                {
                    let e = yn[t];
                    if (e) return e.read ? (ne++, e.read(Xr())) : e.noBuffer ? (ne++, e()) : e(qe.subarray(ne, ++ne));
                    throw new Error("Unknown extension " + t);
                }
            case 213:
                return t = qe[ne], t == 114 ? (ne++, _I(qe[ne++] & 63, qe[ne++])) : Rc(2);
            case 214:
                return Rc(4);
            case 215:
                return Rc(8);
            case 216:
                return Rc(16);
            case 217:
                return t = qe[ne++], wo >= ne ? xl.slice(ne - us, (ne += t) - us) : zq(t);
            case 218:
                return t = sr.getUint16(ne), ne += 2, wo >= ne ? xl.slice(ne - us, (ne += t) - us) : Gq(t);
            case 219:
                return t = sr.getUint32(ne), ne += 4, wo >= ne ? xl.slice(ne - us, (ne += t) - us) : jq(t);
            case 220:
                return t = sr.getUint16(ne), ne += 2, MI(t);
            case 221:
                return t = sr.getUint32(ne), ne += 4, MI(t);
            case 222:
                return t = sr.getUint16(ne), ne += 2, CI(t);
            case 223:
                return t = sr.getUint32(ne), ne += 4, CI(t);
            default:
                if (n1 >= 224) return n1 - 256;
                if (n1 === void 0) {
                    let e = new Error("Unexpected end of MessagePack data");
                    throw e.incomplete = !0, e;
                }
                throw new Error("Unknown MessagePack token " + n1);
        }
    }
}
var Uq = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function AA(n1, t) {
    function e() {
        if (e.count++ > 2) {
            let i = n1.read = new Function("r", "return function(){return {" + n1.map((s)=>Uq.test(s) ? s + ":r()" : "[" + JSON.stringify(s) + "]:r()").join(",") + "}}")(Xr);
            return n1.highByte === 0 && (n1.read = TI(t, n1.read)), i();
        }
        let r = {};
        for(let i = 0, s = n1.length; i < s; i++){
            let o = n1[i];
            r[o] = Xr();
        }
        return r;
    }
    return e.count = 0, n1.highByte === 0 ? TI(t, e) : e;
}
var TI = (n1, t)=>function() {
        let e = qe[ne++];
        if (e === 0) return t();
        let r = n1 < 32 ? -(n1 + (e << 5)) : n1 + (e << 5), i = Zt[r] || DI()[r];
        if (!i) throw new Error("Record id is not defined for " + r);
        return i.read || (i.read = AA(i, n1)), i.read();
    };
function DI() {
    let n1 = BI(()=>(qe = null, _n.getStructures()));
    return Zt = _n._mergeStructures(n1, Zt);
}
var SA = Cv, zq = Cv, Gq = Cv, jq = Cv;
function Cv(n1) {
    let t;
    if (n1 < 16 && (t = EA(n1))) return t;
    if (n1 > 64 && vA) return vA.decode(qe.subarray(ne, ne += n1));
    let e = ne + n1, r = [];
    for(t = ""; ne < e;){
        let i = qe[ne++];
        if ((i & 128) === 0) r.push(i);
        else if ((i & 224) === 192) {
            let s = qe[ne++] & 63;
            r.push((i & 31) << 6 | s);
        } else if ((i & 240) === 224) {
            let s = qe[ne++] & 63, o = qe[ne++] & 63;
            r.push((i & 31) << 12 | s << 6 | o);
        } else if ((i & 248) === 240) {
            let s = qe[ne++] & 63, o = qe[ne++] & 63, a = qe[ne++] & 63, l = (i & 7) << 18 | s << 12 | o << 6 | a;
            l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | l & 1023), r.push(l);
        } else r.push(i);
        r.length >= 4096 && (t += Vi.apply(String, r), r.length = 0);
    }
    return r.length > 0 && (t += Vi.apply(String, r)), t;
}
function MI(n1) {
    let t = new Array(n1);
    for(let e = 0; e < n1; e++)t[e] = Xr();
    return t;
}
function CI(n1) {
    if (_n.mapsAsObjects) {
        let t = {};
        for(let e = 0; e < n1; e++)t[RI()] = Xr();
        return t;
    } else {
        let t = new Map;
        for(let e = 0; e < n1; e++)t.set(Xr(), Xr());
        return t;
    }
}
var Vi = String.fromCharCode;
function OI(n1) {
    let t = ne, e = new Array(n1);
    for(let r = 0; r < n1; r++){
        let i = qe[ne++];
        if ((i & 128) > 0) {
            ne = t;
            return;
        }
        e[r] = i;
    }
    return Vi.apply(String, e);
}
function EA(n1) {
    if (n1 < 4) {
        if (n1 < 2) {
            if (n1 === 0) return "";
            {
                let t = qe[ne++];
                if ((t & 128) > 1) {
                    ne -= 1;
                    return;
                }
                return Vi(t);
            }
        } else {
            let t = qe[ne++], e = qe[ne++];
            if ((t & 128) > 0 || (e & 128) > 0) {
                ne -= 2;
                return;
            }
            if (n1 < 3) return Vi(t, e);
            let r = qe[ne++];
            if ((r & 128) > 0) {
                ne -= 3;
                return;
            }
            return Vi(t, e, r);
        }
    } else {
        let t = qe[ne++], e = qe[ne++], r = qe[ne++], i = qe[ne++];
        if ((t & 128) > 0 || (e & 128) > 0 || (r & 128) > 0 || (i & 128) > 0) {
            ne -= 4;
            return;
        }
        if (n1 < 6) {
            if (n1 === 4) return Vi(t, e, r, i);
            {
                let s = qe[ne++];
                if ((s & 128) > 0) {
                    ne -= 5;
                    return;
                }
                return Vi(t, e, r, i, s);
            }
        } else if (n1 < 8) {
            let s = qe[ne++], o = qe[ne++];
            if ((s & 128) > 0 || (o & 128) > 0) {
                ne -= 6;
                return;
            }
            if (n1 < 7) return Vi(t, e, r, i, s, o);
            let a = qe[ne++];
            if ((a & 128) > 0) {
                ne -= 7;
                return;
            }
            return Vi(t, e, r, i, s, o, a);
        } else {
            let s = qe[ne++], o = qe[ne++], a = qe[ne++], l = qe[ne++];
            if ((s & 128) > 0 || (o & 128) > 0 || (a & 128) > 0 || (l & 128) > 0) {
                ne -= 8;
                return;
            }
            if (n1 < 10) {
                if (n1 === 8) return Vi(t, e, r, i, s, o, a, l);
                {
                    let c = qe[ne++];
                    if ((c & 128) > 0) {
                        ne -= 9;
                        return;
                    }
                    return Vi(t, e, r, i, s, o, a, l, c);
                }
            } else if (n1 < 12) {
                let c = qe[ne++], u = qe[ne++];
                if ((c & 128) > 0 || (u & 128) > 0) {
                    ne -= 10;
                    return;
                }
                if (n1 < 11) return Vi(t, e, r, i, s, o, a, l, c, u);
                let h = qe[ne++];
                if ((h & 128) > 0) {
                    ne -= 11;
                    return;
                }
                return Vi(t, e, r, i, s, o, a, l, c, u, h);
            } else {
                let c = qe[ne++], u = qe[ne++], h = qe[ne++], d = qe[ne++];
                if ((c & 128) > 0 || (u & 128) > 0 || (h & 128) > 0 || (d & 128) > 0) {
                    ne -= 12;
                    return;
                }
                if (n1 < 14) {
                    if (n1 === 12) return Vi(t, e, r, i, s, o, a, l, c, u, h, d);
                    {
                        let f = qe[ne++];
                        if ((f & 128) > 0) {
                            ne -= 13;
                            return;
                        }
                        return Vi(t, e, r, i, s, o, a, l, c, u, h, d, f);
                    }
                } else {
                    let f = qe[ne++], p = qe[ne++];
                    if ((f & 128) > 0 || (p & 128) > 0) {
                        ne -= 14;
                        return;
                    }
                    if (n1 < 15) return Vi(t, e, r, i, s, o, a, l, c, u, h, d, f, p);
                    let m = qe[ne++];
                    if ((m & 128) > 0) {
                        ne -= 15;
                        return;
                    }
                    return Vi(t, e, r, i, s, o, a, l, c, u, h, d, f, p, m);
                }
            }
        }
    }
}
function yA(n1) {
    return _n.copyBuffers ? Uint8Array.prototype.slice.call(qe, ne, ne += n1) : qe.subarray(ne, ne += n1);
}
function Rc(n1) {
    let t = qe[ne++];
    if (yn[t]) return yn[t](qe.subarray(ne, ne += n1));
    throw new Error("Unknown extension type " + t);
}
var PI = new Array(4096);
function RI() {
    let n1 = qe[ne++];
    if (n1 >= 160 && n1 < 192) {
        if (n1 = n1 - 160, wo >= ne) return xl.slice(ne - us, (ne += n1) - us);
        if (!(wo == 0 && bl < 180)) return SA(n1);
    } else return ne--, Xr();
    let t = (n1 << 5 ^ (n1 > 1 ? sr.getUint16(ne) : n1 > 0 ? qe[ne] : 0)) & 4095, e = PI[t], r = ne, i = ne + n1 - 3, s, o = 0;
    if (e && e.bytes == n1) {
        for(; r < i;){
            if (s = sr.getUint32(r), s != e[o++]) {
                r = 1879048192;
                break;
            }
            r += 4;
        }
        for(i += 3; r < i;)if (s = qe[r++], s != e[o++]) {
            r = 1879048192;
            break;
        }
        if (r === i) return ne = r, e.string;
        i -= 3, r = ne;
    }
    for(e = [], PI[t] = e, e.bytes = n1; r < i;)s = sr.getUint32(r), e.push(s), r += 4;
    for(i += 3; r < i;)s = qe[r++], e.push(s);
    let a = n1 < 16 ? EA(n1) : OI(n1);
    return a != null ? e.string = a : e.string = SA(n1);
}
var _I = (n1, t)=>{
    var e = Xr();
    let r = n1;
    t !== void 0 && (n1 = n1 < 32 ? -((t << 5) + n1) : (t << 5) + n1, e.highByte = t);
    let i = Zt[n1];
    return i && i.isShared && ((Zt.restoreStructures || (Zt.restoreStructures = []))[n1] = i), Zt[n1] = e, e.read = AA(e, r), e.read();
}, LI = typeof self == "object" ? self : $parcel$global;
yn[0] = ()=>{};
yn[0].noBuffer = !0;
yn[101] = ()=>{
    let n1 = Xr();
    return (LI[n1[0]] || Error)(n1[1]);
};
yn[105] = (n1)=>{
    let t = sr.getUint32(ne - 4);
    ma || (ma = new Map);
    let e = qe[ne], r;
    e >= 144 && e < 160 || e == 220 || e == 221 ? r = [] : r = {};
    let i = {
        target: r
    };
    ma.set(t, i);
    let s = Xr();
    return i.used ? Object.assign(r, s) : (i.target = s, s);
};
yn[112] = (n1)=>{
    let t = sr.getUint32(ne - 4), e = ma.get(t);
    return e.used = !0, e.target;
};
yn[115] = ()=>new Set(Xr());
var TA = [
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64",
    "BigInt64",
    "BigUint64"
].map((n1)=>n1 + "Array");
yn[116] = (n1)=>{
    let t = n1[0], e = TA[t];
    if (!e) throw new Error("Could not find typed array for code " + t);
    return new LI[e](Uint8Array.prototype.slice.call(n1, 1).buffer);
};
yn[120] = ()=>{
    let n1 = Xr();
    return new RegExp(n1[0], n1[1]);
};
yn[98] = (n1)=>{
    let t = (n1[0] << 24) + (n1[1] << 16) + (n1[2] << 8) + n1[3], e = ne;
    ne += t - 4, Zn = [
        Xr(),
        Xr()
    ], Zn.position0 = 0, Zn.position1 = 0;
    let r = ne;
    ne = e;
    try {
        return Xr();
    } finally{
        ne = r;
    }
};
yn[255] = (n1)=>n1.length == 4 ? new Date((n1[0] * 16777216 + (n1[1] << 16) + (n1[2] << 8) + n1[3]) * 1e3) : n1.length == 8 ? new Date(((n1[0] << 22) + (n1[1] << 14) + (n1[2] << 6) + (n1[3] >> 2)) / 1e6 + ((n1[3] & 3) * 4294967296 + n1[4] * 16777216 + (n1[5] << 16) + (n1[6] << 8) + n1[7]) * 1e3) : n1.length == 12 ? new Date(((n1[0] << 24) + (n1[1] << 16) + (n1[2] << 8) + n1[3]) / 1e6 + ((n1[4] & 128 ? -281474976710656 : 0) + n1[6] * 1099511627776 + n1[7] * 4294967296 + n1[8] * 16777216 + (n1[9] << 16) + (n1[10] << 8) + n1[11]) * 1e3) : new Date("invalid");
function BI(n1) {
    let t = bl, e = ne, r = bA, i = us, s = wo, o = xl, a = xA, l = ma, c = Zn, u = new Uint8Array(qe.slice(0, bl)), h = Zt, d = Zt.slice(0, Zt.length), f = _n, p = kh, m = n1();
    return bl = t, ne = e, bA = r, us = i, wo = s, xl = o, xA = a, ma = l, Zn = c, qe = u, kh = p, Zt = h, Zt.splice(0, Zt.length, ...d), _n = f, sr = new DataView(qe.buffer, qe.byteOffset, qe.byteLength), m;
}
function Mv() {
    qe = null, ma = null, Zt = null;
}
function NI(n1) {
    n1.unpack ? yn[n1.type] = n1.unpack : yn[n1.type] = n1;
}
var Pv = new Array(147);
for(let n1 = 0; n1 < 256; n1++)Pv[n1] = +("1e" + Math.floor(45.15 - n1 * .30103));
var _v = new Ao({
    useRecords: !1
}), Hq = _v.unpack, Wq = _v.unpackMultiple, qq = _v.unpack, Iv = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
}, Yq = new Float32Array(1), she = new Uint8Array(Yq.buffer, 0, 4);
var Dv;
try {
    Dv = new TextEncoder;
} catch  {}
var Ov, CA, Rv = typeof $5059ff85b35ef8d7$require$Buffer < "u", MA = Rv ? $5059ff85b35ef8d7$require$Buffer.allocUnsafeSlow : Uint8Array, UI = Rv ? $5059ff85b35ef8d7$require$Buffer : Uint8Array, FI = Rv ? 4294967296 : 2144337920, Se, ti, he = 0, Eo, To = null, Xq = /[\u0080-\uFFFF]/, Hp = Symbol("record-id"), Lc = class extends Ao {
    constructor(t){
        super(t), this.offset = 0;
        let e, r, i, s, o, a, l = 0, c = UI.prototype.utf8Write ? function(b, M, C) {
            return Se.utf8Write(b, M, C);
        } : Dv && Dv.encodeInto ? function(b, M) {
            return Dv.encodeInto(b, Se.subarray(M)).written;
        } : !1, u = this;
        t || (t = {});
        let h = t && t.sequential, d = t.structures || t.saveStructures, f = t.maxSharedStructures;
        if (f == null && (f = d ? 32 : 0), f > 8160) throw new Error("Maximum maxSharedStructure is 8160");
        let p = t.maxOwnStructures;
        p == null && (p = d ? 32 : 64), h && !t.saveStructures && (this.structures = []);
        let m = f > 32 || p + f > 64, g = f + 64, y = f + p + 64;
        if (y > 8256) throw new Error("Maximum maxSharedStructure + maxOwnStructure is 8192");
        let x = [], v = 0, S = 0;
        this.pack = this.encode = function(b, M) {
            if (Se || (Se = new MA(8192), ti = new DataView(Se.buffer, 0, 8192), he = 0), Eo = Se.length - 10, Eo - he < 2048 ? (Se = new MA(Se.length), ti = new DataView(Se.buffer, 0, Se.length), Eo = Se.length - 10, he = 0) : he = he + 7 & 2147483640, r = he, a = u.structuredClone ? new Map : null, u.bundleStrings ? (To = [
                "",
                ""
            ], Se[he++] = 214, Se[he++] = 98, To.position = he - r, he += 4) : To = null, i = u.structures, i) {
                i.uninitialized && (i = u._mergeStructures(u.getStructures()));
                let C = i.sharedLength || 0;
                if (C > f) throw new Error("Shared structures is larger than maximum shared structures, try increasing maxSharedStructures to " + i.sharedLength);
                if (!i.transitions) {
                    i.transitions = Object.create(null);
                    for(let P = 0; P < C; P++){
                        let I = i[P];
                        if (!I) continue;
                        let _, D = i.transitions;
                        for(let L = 0, j = I.length; L < j; L++){
                            let V = I[L];
                            _ = D[V], _ || (_ = D[V] = Object.create(null)), D = _;
                        }
                        D[Hp] = P + 64;
                    }
                    l = C;
                }
                h || (i.nextId = C + 64);
            }
            s && (s = !1), o = i || [];
            try {
                if (w(b), To) {
                    ti.setUint32(To.position + r, he - To.position - r);
                    let C = To;
                    To = null, w(C[0]), w(C[1]);
                }
                if (u.offset = he, a && a.idsToInsert) {
                    he += a.idsToInsert.length * 6, he > Eo && T(he), u.offset = he;
                    let C = Qq(Se.subarray(r, he), a.idsToInsert);
                    return a = null, C;
                }
                return M & GI ? (Se.start = r, Se.end = he, Se) : Se.subarray(r, he);
            } finally{
                if (i) {
                    if (S < 10 && S++, v > 1e4) i.transitions = null, S = 0, v = 0, x.length > 0 && (x = []);
                    else if (x.length > 0 && !h) {
                        for(let C = 0, P = x.length; C < P; C++)x[C][Hp] = 0;
                        x = [];
                    }
                    if (s && u.saveStructures) {
                        let C = i.sharedLength || f;
                        i.length > C && (i = i.slice(0, C));
                        let P = Se.subarray(r, he);
                        return u.saveStructures(i, l) === !1 ? (u._mergeStructures(u.getStructures()), u.pack(b)) : (l = C, P);
                    }
                }
                M & i9 && (he = r);
            }
        };
        let w = (b)=>{
            he > Eo && (Se = T(he));
            var M = typeof b, C;
            if (M === "string") {
                let P = b.length;
                if (To && P >= 8 && P < 4096) {
                    let D = Xq.test(b);
                    To[D ? 0 : 1] += b, Se[he++] = 193, w(D ? -P : P);
                    return;
                }
                let I;
                P < 32 ? I = 1 : P < 256 ? I = 2 : P < 65536 ? I = 3 : I = 5;
                let _ = P * 3;
                if (he + _ > Eo && (Se = T(he + _)), P < 64 || !c) {
                    let D, L, j, V = he + I;
                    for(D = 0; D < P; D++)L = b.charCodeAt(D), L < 128 ? Se[V++] = L : L < 2048 ? (Se[V++] = L >> 6 | 192, Se[V++] = L & 63 | 128) : (L & 64512) === 55296 && ((j = b.charCodeAt(D + 1)) & 64512) === 56320 ? (L = 65536 + ((L & 1023) << 10) + (j & 1023), D++, Se[V++] = L >> 18 | 240, Se[V++] = L >> 12 & 63 | 128, Se[V++] = L >> 6 & 63 | 128, Se[V++] = L & 63 | 128) : (Se[V++] = L >> 12 | 224, Se[V++] = L >> 6 & 63 | 128, Se[V++] = L & 63 | 128);
                    C = V - he - I;
                } else C = c(b, he + I, _);
                C < 32 ? Se[he++] = 160 | C : C < 256 ? (I < 2 && Se.copyWithin(he + 2, he + 1, he + 1 + C), Se[he++] = 217, Se[he++] = C) : C < 65536 ? (I < 3 && Se.copyWithin(he + 3, he + 2, he + 2 + C), Se[he++] = 218, Se[he++] = C >> 8, Se[he++] = C & 255) : (I < 5 && Se.copyWithin(he + 5, he + 3, he + 3 + C), Se[he++] = 219, ti.setUint32(he, C), he += 4), he += C;
            } else if (M === "number") {
                if (b >>> 0 === b) b < 64 ? Se[he++] = b : b < 256 ? (Se[he++] = 204, Se[he++] = b) : b < 65536 ? (Se[he++] = 205, Se[he++] = b >> 8, Se[he++] = b & 255) : (Se[he++] = 206, ti.setUint32(he, b), he += 4);
                else if (b >> 0 === b) b >= -32 ? Se[he++] = 256 + b : b >= -128 ? (Se[he++] = 208, Se[he++] = b + 256) : b >= -32768 ? (Se[he++] = 209, ti.setInt16(he, b), he += 2) : (Se[he++] = 210, ti.setInt32(he, b), he += 4);
                else {
                    let P;
                    if ((P = this.useFloat32) > 0 && b < 4294967296 && b >= -2147483648) {
                        Se[he++] = 202, ti.setFloat32(he, b);
                        let I;
                        if (P < 4 || (I = b * Pv[(Se[he] & 127) << 1 | Se[he + 1] >> 7]) >> 0 === I) {
                            he += 4;
                            return;
                        } else he--;
                    }
                    Se[he++] = 203, ti.setFloat64(he, b), he += 8;
                }
            } else if (M === "object") {
                if (!b) Se[he++] = 192;
                else {
                    if (a) {
                        let I = a.get(b);
                        if (I) {
                            if (!I.id) {
                                let _ = a.idsToInsert || (a.idsToInsert = []);
                                I.id = _.push(I);
                            }
                            Se[he++] = 214, Se[he++] = 112, ti.setUint32(he, I.id), he += 4;
                            return;
                        } else a.set(b, {
                            offset: he - r
                        });
                    }
                    let P = b.constructor;
                    if (P === Object) A(b, !0);
                    else if (P === Array) {
                        C = b.length, C < 16 ? Se[he++] = 144 | C : C < 65536 ? (Se[he++] = 220, Se[he++] = C >> 8, Se[he++] = C & 255) : (Se[he++] = 221, ti.setUint32(he, C), he += 4);
                        for(let I = 0; I < C; I++)w(b[I]);
                    } else if (P === Map) {
                        C = b.size, C < 16 ? Se[he++] = 128 | C : C < 65536 ? (Se[he++] = 222, Se[he++] = C >> 8, Se[he++] = C & 255) : (Se[he++] = 223, ti.setUint32(he, C), he += 4);
                        for (let [I, _] of b)w(I), w(_);
                    } else {
                        for(let I = 0, _ = Ov.length; I < _; I++){
                            let D = CA[I];
                            if (b instanceof D) {
                                let L = Ov[I];
                                if (L.write) {
                                    L.type && (Se[he++] = 212, Se[he++] = L.type, Se[he++] = 0), w(L.write.call(this, b));
                                    return;
                                }
                                let j = Se, V = ti, H = he;
                                Se = null;
                                let W;
                                try {
                                    W = L.pack.call(this, b, (q)=>(Se = j, j = null, he += q, he > Eo && T(he), {
                                            target: Se,
                                            targetView: ti,
                                            position: he - q
                                        }), w);
                                } finally{
                                    j && (Se = j, ti = V, he = H, Eo = Se.length - 10);
                                }
                                W && (W.length + he > Eo && T(W.length + he), he = Kq(W, Se, he, L.type));
                                return;
                            }
                        }
                        A(b, !b.hasOwnProperty);
                    }
                }
            } else if (M === "boolean") Se[he++] = b ? 195 : 194;
            else if (M === "bigint") {
                if (b < BigInt(1) << BigInt(63) && b >= -(BigInt(1) << BigInt(63))) Se[he++] = 211, ti.setBigInt64(he, b);
                else if (b < BigInt(1) << BigInt(64) && b > 0) Se[he++] = 207, ti.setBigUint64(he, b);
                else if (this.largeBigIntToFloat) Se[he++] = 203, ti.setFloat64(he, Number(b));
                else throw new RangeError(b + " was too large to fit in MessagePack 64-bit integer format, set largeBigIntToFloat to convert to float-64");
                he += 8;
            } else if (M === "undefined") this.encodeUndefinedAsNil ? Se[he++] = 192 : (Se[he++] = 212, Se[he++] = 0, Se[he++] = 0);
            else if (M === "function") w(this.writeFunction && this.writeFunction());
            else throw new Error("Unknown type: " + M);
        }, A = this.useRecords === !1 ? this.variableMapSize ? (b)=>{
            let M = Object.keys(b), C = M.length;
            C < 16 ? Se[he++] = 128 | C : C < 65536 ? (Se[he++] = 222, Se[he++] = C >> 8, Se[he++] = C & 255) : (Se[he++] = 223, ti.setUint32(he, C), he += 4);
            let P;
            for(let I = 0; I < C; I++)w(P = M[I]), w(b[P]);
        } : (b, M)=>{
            Se[he++] = 222;
            let C = he - r;
            he += 2;
            let P = 0;
            for(let I in b)(M || b.hasOwnProperty(I)) && (w(I), w(b[I]), P++);
            Se[C++ + r] = P >> 8, Se[C + r] = P & 255;
        } : (b)=>{
            let M = Object.keys(b), C, P = o.transitions || (o.transitions = Object.create(null)), I = 0;
            for(let D = 0, L = M.length; D < L; D++){
                let j = M[D];
                C = P[j], C || (C = P[j] = Object.create(null), I++), P = C;
            }
            let _ = P[Hp];
            if (_) _ >= 96 && m ? (Se[he++] = ((_ -= 96) & 31) + 96, Se[he++] = _ >> 5) : Se[he++] = _;
            else {
                _ = o.nextId, _ || (_ = 64), _ < g && this.shouldShareStructure && !this.shouldShareStructure(M) ? (_ = o.nextOwnId, _ < y || (_ = g), o.nextOwnId = _ + 1) : (_ >= y && (_ = g), o.nextId = _ + 1);
                let D = M.highByte = _ >= 96 && m ? _ - 96 >> 5 : -1;
                P[Hp] = _, o[_ - 64] = M, _ < g ? (M.isShared = !0, o.sharedLength = _ - 63, s = !0, D >= 0 ? (Se[he++] = (_ & 31) + 96, Se[he++] = D) : Se[he++] = _) : (D >= 0 ? (Se[he++] = 213, Se[he++] = 114, Se[he++] = (_ & 31) + 96, Se[he++] = D) : (Se[he++] = 212, Se[he++] = 114, Se[he++] = _), I && (v += S * I), x.length >= p && (x.shift()[Hp] = 0), x.push(P), w(M));
            }
            for(let D = 0, L = M.length; D < L; D++)w(b[M[D]]);
        }, T = (b)=>{
            let M;
            if (b > 16777216) {
                if (b - r > FI) throw new Error("Packed buffer would be larger than maximum buffer size");
                M = Math.min(FI, Math.round(Math.max((b - r) * (b > 67108864 ? 1.25 : 2), 4194304) / 4096) * 4096);
            } else M = (Math.max(b - r << 2, Se.length - 1) >> 12) + 1 << 12;
            let C = new MA(M);
            return ti = new DataView(C.buffer, 0, M), Se.copy ? Se.copy(C, 0, r, b) : C.set(Se.slice(r, b)), he -= r, r = 0, Eo = C.length - 10, Se = C;
        };
    }
    useBuffer(t) {
        Se = t, ti = new DataView(Se.buffer, Se.byteOffset, Se.byteLength), he = 0;
    }
};
CA = [
    Date,
    Set,
    Error,
    RegExp,
    ArrayBuffer,
    Object.getPrototypeOf(Uint8Array.prototype).constructor,
    jp
];
Ov = [
    {
        pack (n1, t, e) {
            let r = n1.getTime() / 1e3;
            if ((this.useTimestamp32 || n1.getMilliseconds() === 0) && r >= 0 && r < 4294967296) {
                let { target: i, targetView: s, position: o } = t(6);
                i[o++] = 214, i[o++] = 255, s.setUint32(o, r);
            } else if (r > 0 && r < 17179869184) {
                let { target: i, targetView: s, position: o } = t(10);
                i[o++] = 215, i[o++] = 255, s.setUint32(o, n1.getMilliseconds() * 4e6 + (r / 1e3 / 4294967296 >> 0)), s.setUint32(o + 4, r);
            } else if (isNaN(r)) {
                if (this.onInvalidDate) return t(0), e(this.onInvalidDate());
                let { target: i, targetView: s, position: o } = t(3);
                i[o++] = 212, i[o++] = 255, i[o++] = 255;
            } else {
                let { target: i, targetView: s, position: o } = t(15);
                i[o++] = 199, i[o++] = 12, i[o++] = 255, s.setUint32(o, n1.getMilliseconds() * 1e6), s.setBigInt64(o + 4, BigInt(Math.floor(r)));
            }
        }
    },
    {
        pack (n1, t, e) {
            let r = Array.from(n1), { target: i, position: s } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (i[s++] = 212, i[s++] = 115, i[s++] = 0), e(r);
        }
    },
    {
        pack (n1, t, e) {
            let { target: r, position: i } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (r[i++] = 212, r[i++] = 101, r[i++] = 0), e([
                n1.name,
                n1.message
            ]);
        }
    },
    {
        pack (n1, t, e) {
            let { target: r, position: i } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (r[i++] = 212, r[i++] = 120, r[i++] = 0), e([
                n1.source,
                n1.flags
            ]);
        }
    },
    {
        pack (n1, t) {
            this.structuredClone ? VI(n1, 16, t) : kI(Rv ? $5059ff85b35ef8d7$require$Buffer.from(n1) : new Uint8Array(n1), t);
        }
    },
    {
        pack (n1, t) {
            let e = n1.constructor;
            e !== UI && this.structuredClone ? VI(n1, TA.indexOf(e.name), t) : kI(n1, t);
        }
    },
    {
        pack (n1, t) {
            let { target: e, position: r } = t(1);
            e[r] = 193;
        }
    }
];
function VI(n1, t, e, r) {
    let i = n1.byteLength;
    if (i + 1 < 256) {
        var { target: s, position: o } = e(4 + i);
        s[o++] = 199, s[o++] = i + 1;
    } else if (i + 1 < 65536) {
        var { target: s, position: o } = e(5 + i);
        s[o++] = 200, s[o++] = i + 1 >> 8, s[o++] = i + 1 & 255;
    } else {
        var { target: s, position: o, targetView: a } = e(7 + i);
        s[o++] = 201, a.setUint32(o, i + 1), o += 4;
    }
    s[o++] = 116, s[o++] = t, s.set(new Uint8Array(n1.buffer, n1.byteOffset, n1.byteLength), o);
}
function kI(n1, t) {
    let e = n1.byteLength;
    var r, i;
    if (e < 256) {
        var { target: r, position: i } = t(e + 2);
        r[i++] = 196, r[i++] = e;
    } else if (e < 65536) {
        var { target: r, position: i } = t(e + 3);
        r[i++] = 197, r[i++] = e >> 8, r[i++] = e & 255;
    } else {
        var { target: r, position: i, targetView: s } = t(e + 5);
        r[i++] = 198, s.setUint32(i, e), i += 4;
    }
    r.set(n1, i);
}
function Kq(n1, t, e, r) {
    let i = n1.length;
    switch(i){
        case 1:
            t[e++] = 212;
            break;
        case 2:
            t[e++] = 213;
            break;
        case 4:
            t[e++] = 214;
            break;
        case 8:
            t[e++] = 215;
            break;
        case 16:
            t[e++] = 216;
            break;
        default:
            i < 256 ? (t[e++] = 199, t[e++] = i) : i < 65536 ? (t[e++] = 200, t[e++] = i >> 8, t[e++] = i & 255) : (t[e++] = 201, t[e++] = i >> 24, t[e++] = i >> 16 & 255, t[e++] = i >> 8 & 255, t[e++] = i & 255);
    }
    return t[e++] = r, t.set(n1, e), e += i, e;
}
function Qq(n1, t) {
    let e, r = t.length * 6, i = n1.length - r;
    for(t.sort((s, o)=>s.offset > o.offset ? 1 : -1); e = t.pop();){
        let s = e.offset, o = e.id;
        n1.copyWithin(s + r, s, i), r -= 6;
        let a = s + r;
        n1[a++] = 214, n1[a++] = 105, n1[a++] = o >> 24, n1[a++] = o >> 16 & 255, n1[a++] = o >> 8 & 255, n1[a++] = o & 255, i = s;
    }
    return n1;
}
function Sl(n1) {
    if (n1.Class) {
        if (!n1.pack && !n1.write) throw new Error("Extension has no pack or write function");
        if (n1.pack && !n1.type) throw new Error("Extension has no type (numeric code to identify the extension)");
        CA.unshift(n1.Class), Ov.unshift(n1);
    }
    NI(n1);
}
var zI = new Lc({
    useRecords: !1
}), Zq = zI.pack, Jq = zI.pack;
var { NEVER: $q, ALWAYS: e9, DECIMAL_ROUND: t9, DECIMAL_FIT: r9 } = Iv, GI = 512, i9 = 1024;
var jI = new Lc({
    structuredClone: !0
});
Sl({
    Class: Qe.prototype.constructor,
    type: 1,
    write (n1) {
        return {
            ...n1
        };
    },
    read (n1) {
        return Object.setPrototypeOf(n1, Qe.prototype), n1;
    }
});
Sl({
    Class: ke.prototype.constructor,
    type: 2,
    write (n1) {
        return [
            ...n1
        ];
    },
    read (n1) {
        return Object.setPrototypeOf(n1, ke.prototype), n1;
    }
});
Sl({
    Class: gr.prototype.constructor,
    type: 3,
    write (n1) {
        return [
            ...n1
        ];
    },
    read (n1) {
        return Object.setPrototypeOf(n1, gr.prototype), n1;
    }
});
Sl({
    Class: zp.prototype.constructor,
    type: 4,
    write (n1) {
        return n1.id;
    },
    read (n1) {
        return new zp(n1);
    }
});
Sl({
    Class: Gp.prototype.constructor,
    type: 5,
    write (n1) {
        return n1.data;
    },
    read (n1) {
        return new Gp(n1);
    }
});
Sl({
    Class: yr.prototype.constructor,
    type: 6,
    write (n1) {
        return {
            ...n1
        };
    },
    read (n1) {
        return Object.setPrototypeOf(n1, yr.prototype), n1;
    }
});
function n9(n1) {
    var t = 0;
    if (n1.length === 0) return t;
    for(let e = 0; e < n1.length; e++){
        let r = n1[e];
        t = (t << 5) - t + r, t = t & t;
    }
    return t;
}
function PA(n1) {
    if (Rh(n1)) return n1;
    if (Array.isArray(n1)) return n1.map(PA);
    if (typeof n1 == "object" && n1 !== null) {
        let t = {};
        for (let e of Object.keys(n1).sort())t[e] = PA(n1[e]);
        return Object.setPrototypeOf(t, Object.getPrototypeOf(n1)), t;
    } else return n1;
}
var Lv;
((r)=>{
    function n1(i) {
        return jI.pack(i);
    }
    r.serialize = n1;
    function t(i) {
        return jI.unpack(i);
    }
    r.deserialize = t;
    function e(i) {
        return n9(n1(PA(i))).toString();
    }
    r.checksum = e;
})(Lv || (Lv = {}));
var HI;
((e)=>{
    function n1(r) {
        return r.type === "Conditional" ? r.condition.type === "Distance" ? "Distance" : "StateChange" : r.type;
    }
    e.toEventUIType = n1;
    function t(r) {
        return r === "Distance" || r === "StateChange" ? "Conditional" : r;
    }
    e.fromEventUIType = t;
})(HI || (HI = {}));
function IA(n1) {
    return n1 === "MouseDown" || n1 === "MouseUp" || n1 === "KeyDown" || n1 === "KeyUp" || n1 === "Collision" || n1 === "Trigger";
}
var Yi = {
    ["LookAt"]: [],
    ["Follow"]: [
        "Create"
    ],
    ["DragDrop"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Create",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MouseHover"]: [
        "Transition",
        "Animation",
        "Particles",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Scroll"]: [
        "Transition",
        "Animation",
        "Create",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Start"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Conditional"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MouseDown"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MouseUp"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MousePress"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["KeyDown"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["KeyUp"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["KeyPress"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "SwitchCamera",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["GameControl"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Create",
        "Conditional"
    ],
    ["Collision"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Trigger"]: [
        "Transition",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Resize"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["VariableChange"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["API"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["WEBHOOK"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["AIAssistantListener"]: [
        "SetVariable"
    ],
    ["AIAssistantTrigger"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ]
}, WI;
((e)=>{
    function n1(r) {
        return r.type === "MouseDown" || r.type === "MouseUp" || r.type === "MousePress" || r.type === "KeyDown" || r.type === "KeyUp" || r.type === "KeyPress";
    }
    e.is = n1;
    function t(r) {
        return r === "MouseDown" || r === "MouseUp" || r === "MousePress" ? {
            type: r,
            mode: "Object",
            disabled: !1,
            actions: new ke
        } : {
            type: r,
            disabled: !1,
            key: void 0,
            actions: new ke
        };
    }
    e.defaultData = t;
})(WI || (WI = {}));
var Bv;
((e)=>{
    function n1(r) {
        return {
            type: "Property",
            value: [
                r ?? null,
                "position",
                "x"
            ]
        };
    }
    e.propertyDefaultData = n1, e.valueDefaultData = {
        type: "Literal",
        value: 0
    };
})(Bv || (Bv = {}));
var _A;
((r)=>{
    function n1(i) {
        return {
            type: "Comparison",
            operator: "==",
            lOperand: Bv.propertyDefaultData(i),
            rOperand: {
                ...Bv.valueDefaultData
            }
        };
    }
    r.comparisonDefaultData = n1;
    function t(i) {
        return {
            type: "Distance",
            toObject: i ?? null,
            fromObject: i ?? null,
            distance: 200
        };
    }
    r.distanceDefaultData = t;
    function e(i, s) {
        return {
            type: "State",
            object: i ?? null,
            state: s ?? null
        };
    }
    r.stateDefaultData = e;
})(_A || (_A = {}));
var qI;
((t)=>{
    function n1(e) {
        return e.find((r)=>r === "ifActions" || r === "elseActions") !== void 0;
    }
    t.isConditionalSubActions = n1;
})(qI || (qI = {}));
var YI;
((e)=>{
    function n1(r) {
        return r.type === "Conditional";
    }
    e.is = n1;
    function t(r) {
        return {
            type: "Conditional",
            disabled: !1,
            inActions: new ke,
            outActions: new ke,
            condition: _A.distanceDefaultData(r)
        };
    }
    e.defaultData = t;
})(YI || (YI = {}));
var XI;
((t)=>t.defaultData = {
        type: "DragDrop",
        cursor: "hand",
        disabled: !1,
        dampingFactor: 1,
        objects: [],
        snapTo: "center",
        snapSurfaceMode: "bbox",
        snapSurfaceOffset: 0,
        dropOn: "all",
        autoOrient: !0,
        dropDestinations: [],
        plane: "adaptive",
        planeMode: "locked",
        referenceFrame: "global",
        limits: [
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0
        ],
        drop: !1,
        resetOnSnapFail: !1,
        snapSpeed: 20,
        resetSpeed: 20,
        dragDropActions: {
            drag: new ke,
            drop: new ke
        }
    })(XI || (XI = {}));
var Nv;
((t)=>t.defaultData = {
        type: "Follow",
        disabled: !1,
        maxDelta: 0,
        dampingFactor: 1,
        target: "cursor",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledTranslation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5,
        actions: new ke
    })(Nv || (Nv = {}));
var Fv;
((t)=>t.defaultData = {
        type: "LookAt",
        disabled: !1,
        distance: 1e3,
        dampingFactor: 1,
        target: "cursor",
        tilt: "up",
        axis: "z",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5
    })(Fv || (Fv = {}));
var KI;
((e)=>{
    function n1(r) {
        return r.type === "MouseHover";
    }
    e.is = n1;
    function t() {
        return {
            type: "MouseHover",
            disabled: !1,
            actions: new ke
        };
    }
    e.defaultData = t;
})(KI || (KI = {}));
var QI;
((e)=>{
    function n1(r) {
        return r.type === "Scroll";
    }
    e.is = n1;
    function t() {
        return {
            type: "Scroll",
            disabled: !1,
            steps: 100,
            trigger: "load",
            startFrom: "enter",
            enterAnchor: "top",
            startOffset: 0,
            endAfter: 400,
            actions: new ke
        };
    }
    e.defaultData = t;
})(QI || (QI = {}));
var ZI;
((e)=>{
    function n1(r) {
        return r.type === "Start";
    }
    e.is = n1;
    function t() {
        return {
            type: "Start",
            disabled: !1,
            actions: new ke
        };
    }
    e.defaultData = t;
})(ZI || (ZI = {}));
var JI;
((e)=>{
    function n1(r) {
        return r.type === "Collision";
    }
    e.is = n1;
    function t() {
        return {
            type: "Collision",
            disabled: !1,
            target: "character",
            actions: new ke
        };
    }
    e.defaultData = t;
})(JI || (JI = {}));
var $I;
((e)=>{
    function n1(r) {
        return r.type === "Trigger";
    }
    e.is = n1;
    function t(r, i) {
        return {
            type: "Trigger",
            disabled: !1,
            target: "all",
            triggeringObjects: [],
            actions: new ke,
            triggerZone: "box",
            position: i.toArray(),
            rotation: [
                0,
                0,
                0
            ],
            size: r.toArray(),
            radius: r.length() / 2,
            helperVisible: !0
        };
    }
    e.defaultData = t;
})($I || ($I = {}));
var Vv;
((o)=>{
    o.defaultSizes = {
        mobile: [
            480,
            480
        ],
        tablet: [
            768,
            768
        ],
        desktop: [
            1200,
            1200
        ],
        custom: [
            769,
            1200
        ]
    };
    function t(a) {
        return a.type === "Resize";
    }
    o.is = t;
    function e(a) {
        return typeof a == "string" ? a : "custom";
    }
    o.sizeToDevice = e;
    function r(a) {
        return typeof a == "string" ? [
            ...o.defaultSizes[a]
        ] : [
            ...a
        ];
    }
    o.deviceToSize = r;
    function i() {
        let a = {
            size: "mobile",
            operator: "<",
            actions: new ke
        }, l = {
            size: "tablet",
            operator: "<",
            actions: new ke
        }, c = {
            size: [
                ...o.defaultSizes.custom
            ],
            operator: "<>",
            actions: new ke
        }, u = new ke;
        return u.push({
            id: we.generateUUID(),
            fi: 0,
            data: a
        }, {
            id: we.generateUUID(),
            fi: 1,
            data: l
        }, {
            id: we.generateUUID(),
            fi: 2,
            data: c
        }), {
            type: "Resize",
            disabled: !1,
            orientation: "horizontal",
            breakpoints: u
        };
    }
    o.defaultData = i;
    function s() {
        return {
            size: [
                ...o.defaultSizes.custom
            ],
            operator: "<>",
            actions: new ke
        };
    }
    o.defaultBreakpointData = s;
})(Vv || (Vv = {}));
var kv;
((r)=>{
    r.propertyPaths = {
        Position: [
            "position"
        ],
        "Position X": [
            "position",
            "x"
        ],
        "Position Y": [
            "position",
            "y"
        ],
        "Position Z": [
            "position",
            "z"
        ],
        Rotation: [
            "rotation"
        ],
        "Rotation X": [
            "rotation",
            "x"
        ],
        "Rotation Y": [
            "rotation",
            "y"
        ],
        "Rotation Z": [
            "rotation",
            "z"
        ],
        Scale: [
            "scale"
        ],
        "Scale X": [
            "scale",
            "x"
        ],
        "Scale Y": [
            "scale",
            "y"
        ],
        "Scale Z": [
            "scale",
            "z"
        ],
        Width: [
            "width"
        ],
        Height: [
            "height"
        ],
        Depth: [
            "depth"
        ],
        "Mouse Position X": [
            "mouse",
            "x"
        ],
        "Mouse Position Y": [
            "mouse",
            "y"
        ],
        "Mouse Pressed": [
            "mouse",
            "pressed"
        ],
        "Screen Width": [
            "mouse",
            "width"
        ],
        "Screen Height": [
            "mouse",
            "height"
        ],
        "Hit Position X": [
            "raycast",
            "x"
        ],
        "Hit Position Y": [
            "raycast",
            "y"
        ],
        "Hit Position Z": [
            "raycast",
            "z"
        ],
        "Hit Object Position X": [
            "raycast",
            "objX"
        ],
        "Hit Object Position Y": [
            "raycast",
            "objY"
        ],
        "Hit Object Position Z": [
            "raycast",
            "objZ"
        ]
    };
    function t(i) {
        return i.type === "VariableChange";
    }
    r.is = t;
    function e() {
        return {
            disabled: !1,
            type: "VariableChange",
            actions: new ke,
            variableId: "",
            objectId: null,
            property: "Position X"
        };
    }
    r.defaultData = e;
})(kv || (kv = {}));
var eD;
((e)=>{
    function n1(r) {
        return r.type === "API";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            type: "API",
            successActions: new ke,
            errorActions: new ke,
            userAPIId: ""
        };
    }
    e.defaultData = t;
})(eD || (eD = {}));
var tD;
((e)=>{
    function n1(r) {
        return r.type === "WEBHOOK";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            type: "WEBHOOK",
            actions: new ke,
            userWebhookId: ""
        };
    }
    e.defaultData = t;
})(tD || (tD = {}));
var rD;
((e)=>{
    function n1(r) {
        return r.type === "AIAssistantListener";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            type: "AIAssistantListener",
            actions: new ke,
            analysis: "average",
            analysisRange: [
                0,
                71
            ],
            analysisSingle: 0
        };
    }
    e.defaultData = t;
})(rD || (rD = {}));
var iD;
((e)=>{
    function n1(r) {
        return r.type === "AIAssistantTrigger";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            description: "",
            type: "AIAssistantTrigger",
            actions: new ke
        };
    }
    e.defaultData = t;
})(iD || (iD = {}));
var hs = "personal camera", Al = "a218fcc3-276b-49b9-b485-49037fd14f5f", aD = 2960946, ii = 5526619;
var Vs;
((f)=>{
    function n1(p, m) {
        return p[0] === m[0] && p[1] === m[1];
    }
    f.isEqual = n1;
    function t(p, m, g) {
        return [
            p[0] + (m[0] - p[0]) * g,
            p[1] + (m[1] - p[1]) * g
        ];
    }
    f.lerp = t;
    function e(p, m) {
        return [
            p[0] + m[0],
            p[1] + m[1]
        ];
    }
    f.add = e;
    function r(p, m) {
        return [
            p[0] - m[0],
            p[1] - m[1]
        ];
    }
    f.sub = r;
    function i(p, m) {
        return [
            p[0] * m[0],
            p[1] * m[1]
        ];
    }
    f.multiply = i;
    function s(p, m) {
        return [
            p[0] / m[0],
            p[1] / m[1]
        ];
    }
    f.divide = s;
    function o(p, m) {
        return Math.pow(m[0] - p[0], 2) + Math.pow(m[1] - p[1], 2);
    }
    f.distanceSquared = o;
    function a(p, m) {
        return Math.sqrt(o(p, m));
    }
    f.distance = a;
    function l(p, m) {
        return p[0] * m[0] + p[1] * m[1];
    }
    f.dot = l;
    function c(p, m) {
        return [
            p[0] * m,
            p[1] * m
        ];
    }
    f.scalarMultiply = c;
    function u(p, m, g) {
        let y = f.sub(m, p), x = f.sub(g, p), v = f.dot(y, x) / f.dot(y, y), S = f.scalarMultiply(y, v);
        return f.add(p, S);
    }
    f.projectionOnto = u;
    function h(p, m, g) {
        return a(p, u(p, m, g));
    }
    f.projectionOntoDistance = h;
    function d(p, m) {
        return [
            (p[0] + m[0]) * .5,
            (p[1] + m[1]) * .5
        ];
    }
    f.center = d;
})(Vs || (Vs = {}));
var Mo;
((a)=>{
    function n1(l, c) {
        return l[0] === c[0] && l[1] === c[1] && l[2] === c[2];
    }
    a.isEqual = n1;
    function t(l, c) {
        return [
            l[0] + c[0],
            l[1] + c[1],
            l[2] + c[2]
        ];
    }
    a.add = t;
    function e(l, c) {
        return [
            l[0] - c[0],
            l[1] - c[1],
            l[2] - c[2]
        ];
    }
    a.sub = e;
    function r(l, c) {
        return [
            l[0] / c[0],
            l[1] / c[1],
            l[2] / c[2]
        ];
    }
    a.div = r;
    function i(l, c) {
        return [
            l[0] * c[0],
            l[1] * c[1],
            l[2] * c[2]
        ];
    }
    a.mul = i;
    function s(l, c) {
        return Math.hypot(l[0] - c[0], l[1] - c[1], l[2] - c[2]);
    }
    a.dist = s;
    function o(l, c, u) {
        return [
            l[0] + (c[0] - l[0]) * u,
            l[1] + (c[1] - l[1]) * u,
            l[2] + (c[2] - l[2]) * u
        ];
    }
    a.lerp = o;
})(Mo || (Mo = {}));
var Wp;
((e)=>{
    function n1(r, i) {
        return r[0] === i[0] && r[1] === i[1] && r[2] === i[2] && r[3] === i[3];
    }
    e.isEqual = n1;
    function t(r, i, s) {
        return [
            r[0] + (i[0] - r[0]) * s,
            r[1] + (i[1] - r[1]) * s,
            r[2] + (i[2] - r[2]) * s,
            r[3] + (i[3] - r[3]) * s
        ];
    }
    e.lerp = t;
})(Wp || (Wp = {}));
var nD;
((o)=>{
    let n1 = 180 / Math.PI, t = Math.PI / 180;
    function e(a) {
        return typeof a == "number" ? a * n1 : a;
    }
    function r(a) {
        return typeof a == "number" ? a * t : a;
    }
    function i(a) {
        return [
            e(a[0]),
            e(a[1]),
            e(a[2])
        ];
    }
    o.radToDeg = i;
    function s(a) {
        return [
            r(a[0]),
            r(a[1]),
            r(a[2])
        ];
    }
    o.degToRad = s;
})(nD || (nD = {}));
var wl;
((i)=>{
    i.identity = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    function t(s, o) {
        for(let a = 0; a < 16; a++)if (s[a] !== o[a]) return !1;
        return !0;
    }
    i.isEqual = t;
    function e(s) {
        return s ?? i.identity;
    }
    i.simplify = e;
    function r(s, o) {
        let a = o.slice(0);
        for(var l = 0, c = o.length; l < c; l += 3){
            let u = s[3] * o[l] + s[7] * o[l + 1] + s[11] * o[l + 2] + s[15];
            a[l] = (s[0] * o[l] + s[4] * o[l + 1] + s[8] * o[l + 2] + s[12]) / u, a[l + 1] = (s[1] * o[l] + s[5] * o[l + 1] + s[9] * o[l + 2] + s[13]) / u, a[l + 2] = (s[2] * o[l] + s[6] * o[l + 1] + s[10] * o[l + 2] + s[14]) / u;
        }
        return a;
    }
    i.applyMatrix4 = r;
})(wl || (wl = {}));
var ri;
((h)=>{
    function n1(d) {
        return typeof d == "object" && typeof d.r == "number" && typeof d.g == "number" && typeof d.b == "number";
    }
    h.isRGB = n1, h.white = {
        r: 1,
        g: 1,
        b: 1
    }, h.red = {
        r: 1,
        g: 0,
        b: 0
    }, h.black = {
        r: 0,
        g: 0,
        b: 0
    };
    function i(d) {
        return {
            r: Math.round(d.r * 255),
            g: Math.round(d.g * 255),
            b: Math.round(d.b * 255),
            a: 1
        };
    }
    h.toRgb255a1 = i;
    function s(d) {
        return {
            r: d.r,
            g: d.g,
            b: d.b
        };
    }
    h.clone = s;
    function o(d) {
        return d = Math.floor(d), {
            r: (d >> 16 & 255) / 255,
            g: (d >> 8 & 255) / 255,
            b: (d & 255) / 255
        };
    }
    h.fromHex = o;
    function a(d) {
        return Math.round(d.r * 255) * 65536 + Math.round(d.g * 255) * 256 + Math.round(d.b * 255);
    }
    h.toHex = a;
    function l(d, f) {
        return d.r === f.r && d.g === f.g && d.b === f.b;
    }
    h.equals = l;
    function c(d, f) {
        return d.r.toFixed(2) === f.r.toFixed(2) && d.g.toFixed(2) === f.g.toFixed(2) && d.b.toFixed(2) === f.b.toFixed(2);
    }
    h.equalsFixed = c;
    function u(d, f, p) {
        return {
            r: d.r + (f.r - d.r) * p,
            g: d.g + (f.g - d.g) * p,
            b: d.b + (f.b - d.b) * p
        };
    }
    h.lerp = u;
})(ri || (ri = {}));
var bt;
((c)=>{
    c.white = {
        ...ri.white,
        a: 1
    }, c.transparent = {
        ...ri.white,
        a: 0
    };
    function e(u) {
        return {
            r: u[0],
            g: u[1],
            b: u[2],
            a: u[3]
        };
    }
    c.from0to1 = e;
    function r(u, h) {
        return {
            ...ri.fromHex(u),
            a: h
        };
    }
    c.fromHexAndA = r;
    function i(u) {
        return {
            r: Math.round(u.r * 255),
            g: Math.round(u.g * 255),
            b: Math.round(u.b * 255),
            a: u.a
        };
    }
    c.toRgb255a1 = i;
    function s(u, h) {
        return ri.equals(u, h) && u.a === h.a;
    }
    c.equals = s;
    function o(u, h) {
        return ri.equalsFixed(u, h) && u.a.toFixed(2) === h.a.toFixed(2);
    }
    c.equalsFixed = o;
    function a(u, h, d) {
        return {
            r: u.r + (h.r - u.r) * d,
            g: u.g + (h.g - u.g) * d,
            b: u.b + (h.b - u.b) * d,
            a: u.a + (h.a - u.a) * d
        };
    }
    c.lerp = a;
    function l({ r: u, g: h, b: d, a: f } = c.white) {
        return `rgba(${u * 255}, ${h * 255}, ${d * 255}, ${f})`;
    }
    c.toStyle = l;
})(bt || (bt = {}));
var Uv;
((t)=>t.identity = {
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ],
        scale: [
            1,
            1,
            1
        ]
    })(Uv || (Uv = {}));
var sD;
((t)=>t.defaultData = {
        mass: 1,
        stiffness: 80,
        damping: 10,
        velocity: 0
    })(sD || (sD = {}));
var oD;
((t)=>t.defaultData = {
        control1: [
            .5,
            0
        ],
        control2: [
            .5,
            1
        ]
    })(oD || (oD = {}));
var ga;
((s)=>(s.linear = [
        0,
        0,
        1,
        1
    ], s.ease = [
        .25,
        .1,
        .25,
        1
    ], s.easeIn = [
        .42,
        0,
        1,
        1
    ], s.easeOut = [
        0,
        0,
        .58,
        1
    ], s.easeInOut = [
        .42,
        0,
        .58,
        1
    ]))(ga || (ga = {}));
function DA(n1) {
    return typeof n1 == "string" && n1.length === 36 ? /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(n1) : !1;
}
var ks;
((e)=>{
    e.all = [
        "PerspectiveCamera",
        "OrthographicCamera"
    ];
    function t(r) {
        return e.all.includes(r);
    }
    e.is = t;
})(ks || (ks = {}));
var El;
((i)=>{
    i.DefaultUp = [
        0,
        1,
        0
    ], i.DefaultTargetOffset = 1e3, i.defaultData = {
        far: 1e5,
        type: "OrthographicCamera",
        perspective: {
            near: 70,
            fov: 45,
            zoom: 1
        },
        orthographic: {
            near: -100000,
            zoom: 1
        },
        up: i.DefaultUp,
        isUpVectorFlipped: !1,
        targetOffset: i.DefaultTargetOffset
    };
    function r(s) {
        return s.type === "PerspectiveCamera" ? s.perspective?.zoom ?? 1 : s.orthographic?.zoom ?? 1;
    }
    i.getZoom = r;
})(El || (El = {}));
var Co;
((e)=>{
    function n1(r, i = .1) {
        return {
            disabled: !1,
            type: "linear",
            hideBase: !1,
            count: 3,
            radial: {
                radius: Math.max(r[0], r[1]) * 2,
                start: 0,
                end: 360,
                alignment: !1,
                axis: "y",
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ]
            },
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            linear: {
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    r[0] + r[0] * i,
                    0,
                    0
                ]
            },
            grid: {
                count: [
                    2,
                    2,
                    2
                ],
                size: r.map((s)=>s * (1 + i)),
                useCenter: !0
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        };
    }
    e.defaultData = n1;
    function t(r, i) {
        let s = {
            ...r
        };
        if (OA.forEach((o)=>{
            Object.assign(s, {
                [o]: i[o] ?? r[o]
            });
        }), s.radial = {
            ...r.radial
        }, i.radial) {
            let o = r.radial, a = i.radial;
            RA.forEach((l)=>{
                Object.assign(s.radial, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.linear = {
            ...r.linear
        }, i.linear) {
            let o = r.linear, a = i.linear;
            LA.forEach((l)=>{
                Object.assign(s.linear, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.grid = {
            ...r.grid
        }, i.grid) {
            let o = r.grid, a = i.grid;
            BA.forEach((l)=>{
                Object.assign(s.grid, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.toObject = {
            ...r.toObject
        }, i.toObject) {
            let o = r.toObject, a = i.toObject;
            NA.forEach((l)=>{
                Object.assign(s.toObject, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.randomnessObject = {
            ...r.randomnessObject
        }, i.randomnessObject) {
            let o = r.randomnessObject, a = i.randomnessObject;
            FA.forEach((l)=>{
                Object.assign(s.randomnessObject, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        return s;
    }
    e.merge = t;
})(Co || (Co = {}));
var zv;
((r)=>{
    r.defaultData = {
        radial: {},
        linear: {},
        grid: {},
        toObject: {},
        randomnessObject: {}
    };
    let t = [
        "radial",
        "linear",
        "grid",
        "toObject",
        "randomnessObject"
    ];
    function e(i, s) {
        let o = [];
        i.count !== void 0 && o.push({
            type: 0,
            path: s,
            props: {
                count: i.count
            }
        });
        for (let a of t){
            let l = i[a];
            l && Object.keys(l).length > 0 && o.push({
                type: 0,
                path: [
                    ...s,
                    a
                ],
                props: l
            });
        }
        return o;
    }
    r.toOps = e;
})(zv || (zv = {}));
var OA = [
    "count"
], RA = [
    "radius",
    "start",
    "end",
    "position",
    "scale",
    "rotation"
], LA = [
    "position",
    "scale",
    "rotation"
], BA = [
    "count",
    "size"
], NA = [
    "count",
    "position",
    "scale",
    "rotation"
], FA = [
    "strength",
    "scale",
    "rotation",
    "position",
    "movement",
    "seed",
    "freqScale"
];
var Gv;
((e)=>{
    e.all = [
        "PointLight",
        "SpotLight",
        "DirectionalLight",
        "HemisphereLight"
    ];
    function t(r) {
        return e.all.includes(r);
    }
    e.is = t;
})(Gv || (Gv = {}));
var jv;
((e)=>{
    function n1(r) {
        return t(r);
    }
    e.defaultData = n1;
    function t(r) {
        if (r === "PointLight") return {
            type: r,
            color: bt.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            shadowResolution: 1024,
            shadowRadius: 1,
            penumbraSize: .5,
            depth: 1e5
        };
        if (r === "SpotLight") return {
            type: r,
            color: bt.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            penumbra: 0,
            angle: 30 / 180 * Math.PI,
            depth: 1e5,
            penumbraSize: .5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        if (r === "DirectionalLight") return {
            type: r,
            color: bt.white,
            intensity: 1,
            shadows: !0,
            size: 2e3,
            depth: 1e5,
            penumbraSize: .5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        throw new Error("not implemented");
    }
})(jv || (jv = {}));
var Uh;
((r)=>(r.defaultShapeData = {
        type: "PlaneEmitterShape",
        size: [
            100,
            100,
            100
        ]
    }, r.defaultCollisionData = {
        colliderEntityId: null,
        collisionBounce: .75
    }, r.defaultData = {
        renderMaterial: {
            type: "particleMaterial",
            color: {
                r: 1,
                g: .2,
                b: .545,
                a: 1
            },
            color2: {
                r: .945,
                g: .714,
                b: .184,
                a: 1
            },
            coloring: "gradient",
            ease: "linearFadeOut",
            easeSize: "linearFadeOut",
            transparent: !0,
            size: [
                40,
                40
            ],
            texture: "pt_default_particle",
            spriteRotation: [
                0,
                0
            ]
        },
        birthRatePerSec: 50,
        gravity: 1,
        noiseStrength: 0,
        noiseScale: 0,
        noiseSeed: 1,
        noiseType: "curl",
        randomRotation: 0,
        randomScale: .2,
        randomMass: .5,
        rootObjectType: "instancedMesh",
        life: 1,
        direction: [
            0,
            0,
            0
        ],
        directionMode: "axis",
        speed: 10,
        shape: r.defaultShapeData,
        autoPlay: !0,
        emitTimeDelay: 0,
        emitTimeCycle: "infinity",
        emitTimeDuration: 1,
        ...r.defaultCollisionData
    }))(Uh || (Uh = {}));
var Tl;
((t)=>t.defaultData = {
        enabled: "visibility",
        fusedBody: !0,
        rigidBody: "positioned",
        density: 1,
        pointMass: 0,
        gravityScale: 1,
        friction: .5,
        damping: 0,
        restitution: .2,
        colliderType: "convex",
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        enabledTranslation: [
            !0,
            !0,
            !0
        ]
    })(Tl || (Tl = {}));
var VA;
((e)=>{
    e.defaultData = {
        castShadow: !0,
        receiveShadow: !0
    };
    function t(r, i) {
        return r.castShadow === i.castShadow && r.receiveShadow === i.receiveShadow;
    }
    e.equals = t;
})(VA || (VA = {}));
var kA;
((e)=>{
    e.defaultData = {
        flatShading: !1,
        wireframe: !1,
        side: 0
    };
    function t(r, i) {
        return r.flatShading === i.flatShading && r.side === i.side && r.wireframe === i.wireframe;
    }
    e.equals = t;
})(kA || (kA = {}));
var Hv;
((t)=>t.defaultData = {
        ...kA.defaultData,
        ...VA.defaultData
    })(Hv || (Hv = {}));
var lD;
((t)=>{
    function n1(e, r) {
        let i = [];
        if ("material" in e) {
            let s = typeof e.material == "string" ? r.materials[e.material] ?? r.lib.materials[e.material]?.asset : e.material;
            s && i.push(s);
        } else if ("materials" in e) for (let s of e.materials){
            let o = typeof s == "string" ? r.materials[s] ?? r.lib.materials[s]?.asset : s;
            o && i.push(o);
        }
        return i;
    }
    t.getMaterialData = n1;
})(lD || (lD = {}));
var zh;
((e)=>(e.defaultVideo = {
        data: "",
        thumb: "/_assets/_videos/catThumb.png",
        type: "video",
        name: "Cat video"
    }, e.maxSize = 3e7))(zh || (zh = {}));
var cD;
((t)=>{
    function n1(e) {
        return e === "texture" || e === "video" || e === "color" || e === "depth" || e === "normal" || e === "gradient" || e === "noise" || e === "fresnel" || e === "rainbow" || e === "toon" || e === "outline" || e === "particle" || e === "transmission" || e === "matcap" || e === "displace" || e === "pattern" || e === "light";
    }
    t.is = n1;
})(cD || (cD = {}));
function hD(n1) {
    return n1.type !== "displace";
}
var uD;
((t)=>{
    function n1(e) {
        return e === "phong" || e === "toon" || e === "lambert" || e === "physical";
    }
    t.is = n1;
})(uD || (uD = {}));
var Wv = [
    "mode",
    "gradientType",
    "noiseType",
    "displacementType",
    "projection",
    "cnormal",
    "crop",
    "axis",
    "side"
], dD = [
    "wrapping",
    "image",
    "video",
    "name",
    "minFilter",
    "magFilter"
], Gr;
((i)=>{
    function n1(s, o) {
        let { texture: a, ...l } = o;
        if (Object.assign(s, l), a) {
            let c = s.texture;
            c && Object.assign(c, a);
        }
    }
    i.patch = n1;
    function t(s, o) {
        return s === "light" && o ? e(o) : r(s);
    }
    i.defaultData = t;
    function e(s) {
        let o = {
            mode: 0,
            isMask: !1,
            visible: !0,
            bumpMap: void 0,
            bumpMapIntensity: 5,
            roughnessMap: void 0,
            alphaOverride: 1
        };
        switch(s){
            case "phong":
                return {
                    ...o,
                    category: "phong",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 5,
                    type: "light",
                    visible: !0,
                    mode: 0,
                    occlusion: !0,
                    alpha: .6
                };
            case "toon":
                return {
                    ...o,
                    category: "toon",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 10,
                    type: "light",
                    alpha: 1
                };
            case "lambert":
                return {
                    ...o,
                    category: "lambert",
                    emissive: {
                        r: 0,
                        g: 0,
                        b: 0
                    },
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
            case "physical":
                return {
                    ...o,
                    category: "physical",
                    roughness: .2,
                    metalness: .2,
                    reflectivity: .2,
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
        }
    }
    function r(s) {
        let o = {
            alpha: 1,
            mode: 0,
            isMask: !1,
            visible: !0
        };
        switch(s){
            case "texture":
                return {
                    ...o,
                    type: "texture",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        image: "image_0",
                        wrapping: 1e3,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: 0,
                        minFilter: 1008,
                        magFilter: 1006
                    },
                    crop: !1
                };
            case "video":
                return {
                    ...o,
                    type: "video",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        video: zh.defaultVideo,
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: 0,
                        minFilter: 1008,
                        magFilter: 1006
                    },
                    crop: !1
                };
            case "color":
                return {
                    ...o,
                    type: "color",
                    color: ri.fromHex(ii)
                };
            case "depth":
                return {
                    ...o,
                    type: "depth",
                    gradientType: 1,
                    smooth: !1,
                    isVector: !0,
                    isWorldSpace: !1,
                    origin: [
                        0,
                        0,
                        0
                    ],
                    direction: [
                        1,
                        0,
                        0
                    ],
                    colors: [
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1
                    ],
                    near: 50,
                    far: 200
                };
            case "normal":
                return {
                    ...o,
                    type: "normal",
                    cnormal: [
                        1,
                        1,
                        1
                    ]
                };
            case "gradient":
                return {
                    ...o,
                    type: "gradient",
                    gradientType: 0,
                    smooth: !1,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 2,
                    angle: 0,
                    offset: [
                        0,
                        0
                    ],
                    morph: [
                        0,
                        0
                    ]
                };
            case "noise":
                return {
                    ...o,
                    type: "noise",
                    size: [
                        100,
                        100,
                        100
                    ],
                    noiseType: 0,
                    scale: 1,
                    move: 1,
                    colorA: {
                        ...ri.fromHex(6710886),
                        a: 1
                    },
                    colorB: {
                        ...ri.fromHex(6710886),
                        a: 1
                    },
                    colorC: {
                        ...ri.fromHex(16777215),
                        a: 1
                    },
                    colorD: {
                        ...ri.fromHex(16777215),
                        a: 1
                    },
                    distortion: [
                        1,
                        1
                    ],
                    fA: [
                        1.7,
                        9.2
                    ],
                    fB: [
                        8.3,
                        2.8
                    ],
                    voronoiStyle: 0,
                    highCut: 1,
                    lowCut: 0,
                    smoothness: .3,
                    seed: 0,
                    quality: 1
                };
            case "fresnel":
                return {
                    ...o,
                    type: "fresnel",
                    color: bt.fromHexAndA(16777215, 1),
                    bias: .1,
                    scale: 1,
                    intensity: 2,
                    factor: 1
                };
            case "rainbow":
                return {
                    ...o,
                    type: "rainbow",
                    filmThickness: 30,
                    movement: 0,
                    wavelengths: [
                        0,
                        0,
                        0
                    ],
                    noiseStrength: 0,
                    noiseScale: 1,
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "toon":
                return {
                    ...o,
                    type: "toon",
                    positioning: 2,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        .475,
                        .525,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 4,
                    source: [
                        0,
                        1e3,
                        0
                    ],
                    isWorldSpace: !0,
                    noiseStrength: 0,
                    noiseScale: 1,
                    shadowColor: bt.fromHexAndA(0, 0),
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "outline":
                return {
                    ...o,
                    type: "outline",
                    outlineColor: bt.fromHexAndA(0, 1),
                    contourColor: bt.fromHexAndA(0, 1),
                    outlineWidth: 2,
                    contourWidth: 5,
                    outlineThreshold: .4,
                    contourThreshold: 0,
                    outlineSmoothing: 0,
                    contourFrequency: 10,
                    contourDirection: [
                        0,
                        1,
                        0
                    ],
                    positionalLines: !1,
                    compensation: !0
                };
            case "matcap":
                return {
                    ...o,
                    type: "matcap",
                    texture: {
                        image: "matcap_0",
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: 0,
                        minFilter: 1008,
                        magFilter: 1006
                    }
                };
            case "transmission":
                return {
                    ...o,
                    type: "transmission",
                    thickness: 10,
                    ior: 1.5,
                    roughness: 1
                };
            case "displace":
                return {
                    visible: !0,
                    type: "displace",
                    displacementType: "noise",
                    noiseType: 0,
                    scale: 10,
                    movement: 1,
                    offset: [
                        0,
                        0,
                        0
                    ],
                    intensity: 8,
                    voronoiStyle: 0,
                    smoothness: .3,
                    seed: 0,
                    highCut: 1,
                    lowCut: 0,
                    quality: 1
                };
            case "pattern":
                return {
                    ...o,
                    type: "pattern",
                    style: 0,
                    projection: 0,
                    axis: "y",
                    blending: 0,
                    offset: [
                        0,
                        0
                    ],
                    colorA: {
                        ...ri.fromHex(0),
                        a: 1
                    },
                    colorB: {
                        ...ri.fromHex(16777215),
                        a: 1
                    },
                    frequency: [
                        10,
                        10
                    ],
                    size: .5,
                    variation: 0,
                    smoothness: .5,
                    zigzag: 0,
                    rotation: 0,
                    vertical: [
                        0,
                        1
                    ],
                    horizontal: [
                        0,
                        1
                    ],
                    sides: 6
                };
        }
    }
})(Gr || (Gr = {}));
var Kr;
((c)=>{
    function n1(u) {
        return !u.layers.some((d)=>d.data.type === "texture" && d.data.projection !== 0 || d.data.type === "depth" && !d.data.isWorldSpace || d.data.type === "noise" || d.data.type === "displace");
    }
    c.isMergable = n1;
    function t(u) {
        let h = "";
        return u.layers.forEach((d)=>{
            Object.entries(d.data).forEach(([f, p])=>{
                h += `${f}${p}`, Array.isArray(p) ? p.forEach((m)=>h += `${m}`) : typeof p == "object" ? Object.values(p).forEach((m)=>{
                    typeof m == "number" ? h += `${m.toFixed(4)}` : h += `${m}`;
                }) : h += `${p}`;
            });
        }), h;
    }
    c.getHash = t;
    function e() {
        return {
            layers: new ke
        };
    }
    c.defaultEmptyData = e;
    function r(u = "layer1", h = "layer2") {
        return s("phong", u, h);
    }
    c.defaultData = r;
    function i(u, h) {
        return {
            ...u,
            name: h
        };
    }
    c.withName = i;
    function s(u, h = "layer1", d = "layer2") {
        let f = new ke;
        return f.push({
            fi: 0,
            data: Gr.defaultData("light", u),
            id: h
        }), f.push({
            fi: 1,
            data: Gr.defaultData("color"),
            id: d
        }), {
            layers: f
        };
    }
    c.defaultTwoLayerData = s;
    function o(u) {
        let h = Gr.defaultData("texture");
        u && Object.assign(h.texture, {
            image: u
        });
        let d = new ke;
        return d.push({
            fi: 0,
            data: h,
            id: "layer1"
        }), d.push({
            fi: 1,
            data: {
                ...Gr.defaultData("transmission"),
                alpha: 1
            },
            id: "layer2"
        }), d.push({
            fi: 2,
            data: {
                ...Gr.defaultData("light", "lambert"),
                alpha: 0
            },
            id: "layer3"
        }), {
            layers: d
        };
    }
    c.defaultUIObjectMaterial = o;
    function a(u, h = "phong", d = "layer1", f = "layer2") {
        let p = Gr.defaultData("texture");
        Object.assign(p.texture, {
            image: u
        });
        let m = new ke;
        return m.push({
            fi: 0,
            data: p,
            id: d
        }), m.push({
            fi: 1,
            data: Gr.defaultData("light", h),
            id: f
        }), {
            layers: m
        };
    }
    c.defaultTwoLayerTextureData = a;
    function l(u, h = "phong", d = "layer1", f = "layer2") {
        let p = Gr.defaultData("video");
        Object.assign(p.texture, {
            video: u
        });
        let m = new ke;
        return m.push({
            fi: 0,
            data: p,
            id: d
        }), m.push({
            fi: 1,
            data: Gr.defaultData("light", h),
            id: f
        }), {
            layers: m
        };
    }
    c.defaultTwoLayerVideoTextureData = l;
})(Kr || (Kr = {}));
var Gh;
((t)=>{
    function n1() {
        return {
            points: new ke,
            roundness: 0,
            shapeHoles: [],
            isClosed: !1
        };
    }
    t.defaultData = n1;
})(Gh || (Gh = {}));
var jh;
((t)=>{
    function n1() {
        return {
            points: new ke,
            lastInsertionPlane: null,
            subdivisions: 12,
            isClosed: !1
        };
    }
    t.defaultData = n1;
})(jh || (jh = {}));
var UA = {
    type: "Ellipse",
    width: 50,
    height: 50,
    spikes: 16,
    angle: 360,
    innerRadius: 0
};
var qv;
((t)=>{
    function n1(e, r) {
        let i = {
            ...e
        };
        return zA.forEach((s)=>{
            Object.assign(i, {
                [s]: r[s] ?? e[s]
            });
        }), i;
    }
    t.merge = n1;
})(qv || (qv = {}));
var Yv = {
    shape: UA,
    depth: 1,
    offset: 0,
    bevel: 50,
    bevelSides: 6,
    angle: 0,
    twist: 0,
    startScale: 1,
    endScale: 1,
    capType: "flat"
}, zA = [
    "depth",
    "offset",
    "angle",
    "twist",
    "startScale",
    "endScale"
];
var qp;
((e)=>{
    function n1(r) {
        return r === "PolygonGeometry" || r === "RectangleGeometry" || r === "StarGeometry" || r === "TriangleGeometry" || r === "EllipseGeometry" || r === "UIGeometry";
    }
    e.is2DParametricMesh = n1;
    function t(r) {
        return r === "PolygonGeometry" || r === "PolygonGeometry" || r === "RectangleGeometry" || r === "StarGeometry" || r === "TriangleGeometry" || r === "EllipseGeometry" || r === "PathGeometry" || r === "VectorGeometry" || r === "ConeGeometry" || r === "CubeGeometry" || r === "CylinderGeometry" || r === "DodecahedronGeometry" || r === "HelixGeometry" || r === "IcosahedronGeometry" || r === "LatheGeometry" || r === "PyramidGeometry" || r === "SphereGeometry" || r === "PlaneGeometry" || r === "BackdropGeometry" || r === "TorusGeometry" || r === "TorusKnotGeometry" || r === "BooleanGeometry" || r === "TextGeometry" || r === "InputGeometry";
    }
    e.isParametricMesh = t;
})(qp || (qp = {}));
var Xv;
((t)=>{
    function n1(e, r) {
        let i = {
            ...e
        };
        return Object.assign(i, r), i.type === "PathGeometry" && "extrusion" in r && r.extrusion && (i.extrusion = {
            ...e.extrusion
        }, Object.assign(i.extrusion, qv.merge(i.extrusion, r.extrusion))), i;
    }
    t.merge = n1;
})(Xv || (Xv = {}));
var ya;
((t)=>{
    function n1(e) {
        if (e === "RectangleGeometry") return {
            width: 320,
            height: 320,
            type: e,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "UIGeometry") return {
            type: e,
            frame: "",
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            width: 1,
            height: 1
        };
        if (e === "PathGeometry") return {
            type: e,
            width: 1,
            height: 1,
            depth: 1,
            path: jh.defaultData(),
            extrusion: Yv
        };
        if (e === "VectorGeometry") return {
            width: 1,
            height: 1,
            type: e,
            subdivisions: 12,
            shape: Gh.defaultData(),
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "BooleanGeometry") return {
            type: e,
            operation: 2,
            width: 0,
            height: 0,
            depth: 0,
            phongAngle: 35
        };
        if (e === "TextGeometry") return {
            type: e,
            width: 100,
            height: 100,
            depth: 0,
            horizontalAlign: 1,
            verticalAlign: 1,
            fontSize: 16,
            lineHeight: 1.2,
            letterSpacing: 0,
            text: {
                textValue: ""
            },
            textTransform: 1,
            font: "Roboto_regular",
            editable: !1,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "InputGeometry") return {
            ...t.defaultData("TextGeometry"),
            type: e,
            editable: !0
        };
        if (e === "SphereGeometry") return {
            type: "SphereGeometry",
            width: 100,
            height: 100,
            depth: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: 180
        };
        throw new Error("not implemented");
    }
    t.defaultData = n1;
})(ya || (ya = {}));
var Kv = [
    "width",
    "height",
    "depth"
];
var Qv;
((t)=>t.defaultData = {
        enabled: !1,
        useBackgroundColor: !1,
        color: ri.white,
        near: .1,
        far: 2e3
    })(Qv || (Qv = {}));
var Hh;
((e)=>{
    let n1 = {
        opacity: 1,
        blendFunction: 13,
        enabled: !1
    };
    e.defaultData = {
        enabled: !1,
        pixelation: {
            ...n1,
            blendFunction: 16,
            granularity: 15
        },
        bloom: {
            ...n1,
            blendFunction: 16,
            intensity: 1,
            blurScale: 1,
            luminanceThreshold: .25,
            luminanceSmoothing: .025,
            kernelSize: 3
        },
        chromaticAberration: {
            ...n1,
            offset: [
                2,
                2
            ]
        },
        vignette: {
            ...n1,
            darkness: 1,
            offset: 0
        },
        hueSaturation: {
            ...n1,
            hue: 3,
            saturation: 0
        },
        brightnessContrast: {
            ...n1,
            brightness: .25,
            contrast: 0
        },
        depthOfField: {
            ...n1,
            focusDistance: 100,
            focalLength: 20,
            bokehScale: 5
        },
        noise: {
            ...n1,
            blendFunction: 16
        }
    };
})(Hh || (Hh = {}));
var GA;
((t)=>t.defaultData = {
        softShadowQuality: "low"
    })(GA || (GA = {}));
var jA;
((t)=>t.defaultData = {
        enabled: !0,
        color: {
            r: .8274509803921568,
            g: .8274509803921568,
            b: .8274509803921568
        },
        intensity: .75
    })(jA || (jA = {}));
var HA;
((t)=>t.defaultData = {
        occlusion: !1,
        aoFullRes: !1,
        radius: 256,
        bias: .5,
        aoColor: {
            r: .19607843137254902,
            g: .19607843137254902,
            b: .19607843137254902
        }
    })(HA || (HA = {}));
var Ml;
((t)=>t.defaultData = {
        usePhysics: !1,
        gravity: -10
    })(Ml || (Ml = {}));
var WA;
((t)=>t.defaultData = {
        playCamera: hs,
        gameControlObject: null
    })(WA || (WA = {}));
var Zv;
((t)=>t.defaultData = {
        backgroundColor: bt.fromHexAndA(aD, 1),
        postprocessing: Hh.defaultData,
        fog: Qv.defaultData,
        globalPhysics: Ml.defaultData,
        ambient: jA.defaultData,
        ao: HA.defaultData,
        shadow: GA.defaultData,
        publish: WA.defaultData
    })(Zv || (Zv = {}));
var Jv;
((t)=>t.defaultData = {
        colliderType: "box",
        size: [
            100,
            100,
            100
        ],
        colliderHelperVisible: !0,
        forceType: "collider",
        forceRange: "global",
        forceIntensity: .5,
        forceDambing: .95
    })(Jv || (Jv = {}));
var fD;
((e)=>{
    function n1(r) {
        return r === "Component" || r === "Instance";
    }
    e.isComponentRelated = n1;
    function t(r) {
        return r === "Empty" || r === "Instance";
    }
    e.isEmptyOrComponent = t;
})(fD || (fD = {}));
var Wh;
((i)=>{
    i.identity = {
        ...Uv.identity,
        hiddenMatrix: wl.identity
    };
    function t(s) {
        return {
            position: s.position,
            rotation: s.rotation,
            scale: s.scale,
            hiddenMatrix: s.hiddenMatrix
        };
    }
    i.fromObject = t;
    function e(s, o) {
        return {
            position: o?.position || s.position,
            rotation: o?.rotation || s.rotation,
            scale: o?.scale || s.scale,
            hiddenMatrix: o?.hiddenMatrix || s.hiddenMatrix
        };
    }
    i.merge = e;
    function r(s, o) {
        return cv({
            position: Mo.isEqual(s.position, o.position) ? void 0 : o.position,
            rotation: Mo.isEqual(s.rotation, o.rotation) ? void 0 : o.rotation,
            scale: Mo.isEqual(s.scale, o.scale) ? null : o.scale,
            hiddenMatrix: wl.isEqual(s.hiddenMatrix, o.hiddenMatrix) ? void 0 : o.hiddenMatrix
        });
    }
    i.diff = r;
})(Wh || (Wh = {}));
var vi;
((t)=>t.defaultData = {
        states: new ke,
        events: new ke,
        visible: !0,
        raycastLock: !1,
        physics: Tl.defaultData,
        pathSnapping: {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        },
        ...Wh.identity,
        cloner: null
    })(vi || (vi = {}));
var $v;
((t)=>t.defaultData = {
        type: "Empty",
        ...vi.defaultData
    })($v || ($v = {}));
var pD;
((t)=>t.defaultData = {
        type: "ParticleCollider",
        ...Jv.defaultData,
        ...vi.defaultData
    })(pD || (pD = {}));
var mD;
((t)=>t.defaultData = {
        type: "Component",
        ...vi.defaultData
    })(mD || (mD = {}));
var gD;
((t)=>t.defaultData = {
        type: "Particle",
        ...vi.defaultData,
        ...Uh.defaultData
    })(gD || (gD = {}));
var Cl;
((t)=>t.defaultData = {
        type: "Mesh",
        ...vi.defaultData,
        ...Hv.defaultData
    })(Cl || (Cl = {}));
var Bc;
((t)=>t.defaultData = {
        ...vi.defaultData,
        ...Wh.identity,
        position: [
            0,
            0,
            El.DefaultTargetOffset
        ],
        ...El.defaultData
    })(Bc || (Bc = {}));
var e0;
((e)=>{
    function n1(r) {
        return {
            ...vi.defaultData,
            ...jv.defaultData(r)
        };
    }
    e.defaultData = n1, e.defaultDirectionalLightData = {
        ...e.defaultData("DirectionalLight"),
        position: [
            200,
            300,
            300
        ],
        name: "Directional Light",
        intensity: .7
    };
})(e0 || (e0 = {}));
var qh;
((e)=>{
    function n1(r, i, s = 0) {
        for(; s < i.length;){
            let o = r ? r[i[s]] : void 0;
            if (i.length === s + 1) return o;
            if (o) r = o.descendants, s += 1;
            else return;
        }
    }
    e.resolveWithDes = n1;
    function t(r, i, s = 0) {
        let o = n1(r, i, s);
        if (o) {
            let a = Object.keys(o);
            if (a.length === 1 && a[0] === "descendants") return;
        }
        return o;
    }
    e.resolve = t;
})(qh || (qh = {}));
var Po;
((s)=>{
    s.rootOverrideProps = [
        "physics",
        "events"
    ], s.compositeNonOptionalOverrideProps = [
        "geometry"
    ], s.compositeEntireOverrideOverrideProps = [
        "material"
    ];
    function r(o, a) {
        return {
            ...vi.defaultData,
            ...a,
            component: o,
            overrides: new yr,
            physics: void 0,
            events: void 0,
            type: "Instance"
        };
    }
    s.ofComponent = r;
    function i(o) {
        let a = Wh.fromObject(o.data);
        return r(o.id, a);
    }
    s.fromComponentData = i;
})(Po || (Po = {}));
var va;
((e)=>{
    e.defaultData = {
        type: "Page",
        ...vi.defaultData,
        physics: {
            ...Tl.defaultData,
            fusedBody: !1
        },
        ...Zv.defaultData,
        camera: Bc.defaultData
    };
    function t(r) {
        return r.uiScene !== void 0;
    }
    e.isUIPage = t;
})(va || (va = {}));
var t0;
((o)=>(o.defaultCamera = {
        position: [
            0,
            0,
            1e3
        ],
        scale: [
            1,
            1,
            1
        ],
        rotation: [
            0,
            0,
            0
        ],
        hiddenMatrix: wl.identity,
        name: "Play Camera",
        visible: !0,
        raycastLock: !1,
        physics: Tl.defaultData,
        states: new ke,
        events: new ke,
        cloner: null,
        pathSnapping: {
            pathId: null,
            orientation: "tangential",
            slide: 0,
            offset: 0
        },
        ...El.defaultData
    }, o.KeysByResetCategory = {
        States: [
            "states"
        ],
        Events: [
            "events"
        ],
        Material: [
            "material",
            "materials"
        ],
        Geometry: [
            "geometry"
        ],
        Position: [
            "position"
        ],
        Rotation: [
            "rotation"
        ],
        Scale: [
            "scale"
        ],
        Transform: [
            "position",
            "scale",
            "rotation",
            "hiddenMatrix"
        ],
        Name: [
            "name"
        ],
        Visibility: [
            "visible",
            "raycastLock",
            "flatShading",
            "wireframe",
            "side"
        ],
        Shadows: [
            "castShadow",
            "receiveShadow"
        ],
        Cloner: [
            "cloner"
        ],
        Physics: [
            "physics"
        ]
    }, o.defaultMeshObject = {
        name: "Rectangle",
        ...vi.defaultData,
        ...Cl.defaultData,
        geometry: ya.defaultData("RectangleGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, o.defaultBooleanObject = {
        name: "Boolean",
        ...vi.defaultData,
        ...Cl.defaultData,
        geometry: ya.defaultData("BooleanGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, o.defaultTextObject = {
        name: "Text",
        ...vi.defaultData,
        ...Cl.defaultData,
        geometry: ya.defaultData("TextGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, o.defaultInputObject = {
        name: "Input",
        ...vi.defaultData,
        ...Cl.defaultData,
        geometry: ya.defaultData("InputGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }))(t0 || (t0 = {}));
var xa;
((i)=>{
    function n1(s, o) {
        let a = {
            name: o
        };
        return s.type === "Mesh" ? (a.geometry = {}, "material" in s && (a.material = {
            layers: new yr
        }), "materials" in s && (a.materials = s.materials.map((l)=>({
                layers: new yr
            })))) : ks.is(s.type) && (a.perspective = {}, a.orthographic = {}), a;
    }
    i.newEmpty = n1;
    function t(s, o) {
        if (o === void 0) return s;
        let a = {
            ...s
        };
        return "material" in a && "material" in o && o.material && (a.material = vl(a.material, (l)=>{
            if (typeof l != "string") for (let [c, u] of Object.entries(o.material.layers)){
                let h = l.layers.data(c);
                h && Gr.patch(h, u);
            }
        }).data), a.materials && o.materials && (a.materials = vl(a.materials, (l)=>{
            for(let c = 0; c < a.materials.length; c++){
                let u = o.materials[c];
                if (typeof u != "string") for (let [h, d] of Object.entries(u.layers)){
                    let f = l[c]?.layers?.data(h);
                    f && Gr.patch(f, d);
                }
            }
        }).data), a;
    }
    function e(s, o) {
        let a, l = [], c = {
            orthographic: 0,
            perspective: 0,
            geometry: 0
        };
        function u(h, d) {
            for (let [f, p] of Object.entries(d.layers)){
                let { texture: m, ...g } = p;
                if (m !== void 0 && Object.keys(m).length > 0) {
                    let y = {
                        path: [
                            ...h,
                            "layers",
                            f,
                            "texture"
                        ],
                        props: m,
                        type: 0
                    };
                    l.push(y);
                }
                if (Object.keys(g).length > 0) {
                    let y = {
                        path: [
                            ...h,
                            "layers",
                            f
                        ],
                        props: g,
                        type: 0
                    };
                    l.push(y);
                }
            }
        }
        for (let [h, d] of Object.entries(o))if (h !== "name") {
            if (h === "cloner") l.push(...zv.toOps(d, [
                "cloner"
            ]));
            else if (h === "pathSnapping") l.push({
                path: [
                    h
                ],
                props: {
                    slide: d.slide,
                    offset: d.offset
                },
                type: 0
            });
            else if (h === "material") u([
                "material"
            ], d);
            else if (h === "materials") for (let [f, p] of Object.entries(d))u([
                "materials",
                f
            ], p);
            else if (c[h] === 0) {
                if (h === "geometry" && d.extrusion !== void 0) {
                    let f = {
                        path: [
                            h,
                            "extrusion"
                        ],
                        props: d.extrusion,
                        type: 0
                    };
                    l.push(f), d = {
                        ...d
                    }, delete d.extrusion;
                }
                if (Object.keys(d).length > 0) {
                    let f = {
                        path: [
                            h
                        ],
                        props: d,
                        type: 0
                    };
                    l.push(f);
                }
            } else a === void 0 && (a = {
                path: [],
                props: {},
                type: 0
            }, l.push(a)), a.props[h] = d;
        }
        return l;
    }
    i.toOps = e;
    function r(s, o) {
        if (o === void 0) return s;
        let a = {
            ...s
        };
        if (Object.assign(a, Wh.merge(a, o)), Object.assign(a, {
            pathSnapping: Object.assign({}, a.pathSnapping, {
                slide: o.pathSnapping?.slide ?? a.pathSnapping?.slide ?? 0,
                offset: o.pathSnapping?.offset ?? a.pathSnapping?.offset ?? 0
            })
        }), ks.is(s.type)) {
            a.orthographic = {
                ...a.orthographic
            }, a.perspective = {
                ...a.perspective
            };
            let l = o;
            l.orthographic?.zoom !== void 0 && (a.orthographic.zoom = l.orthographic.zoom), l.perspective?.zoom !== void 0 && (a.perspective.zoom = l.perspective.zoom), l.isUpVectorFlipped !== void 0 && (a.isUpVectorFlipped = l.isUpVectorFlipped), l.targetOffset !== void 0 && (a.targetOffset = l.targetOffset);
        } else if (s.type === "Mesh") "geometry" in o && Object.assign(a, {
            geometry: Xv.merge(a.geometry, o.geometry)
        }), (o.material || o.materials) && (a = t(a, o)), a.cloner && "cloner" in o && Object.assign(a, {
            cloner: Co.merge(a.cloner, o.cloner)
        });
        else if (s.type === "Empty") a.cloner && "cloner" in o && Object.assign(a, {
            cloner: Co.merge(a.cloner, o.cloner)
        });
        else if (Gv.is(s.type)) {
            let l = o;
            l.intensity !== void 0 && (a.intensity = l.intensity), l.color !== void 0 && (typeof l.color == "string" ? a.color = l.color : a.color = ri.clone(l.color));
        }
        return a;
    }
    i.patch = r;
})(xa || (xa = {}));
var Yh;
((t)=>t.defaultData = {
        enablePan: !0,
        enableZoom: !0,
        enableRotate: !0,
        enableDamping: !0,
        rotationLimitsMode: 0,
        rotationVerticalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationHorizontalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationSoftLimit: 2,
        panLimitsMode: 0,
        panVerticalOffset: {
            min: 250,
            max: 250
        },
        panHorizontalOffset: {
            min: 250,
            max: 250
        },
        panSoftLimit: 2,
        zoomLimitsEnabled: !1,
        zoomLimits: {
            min: .1,
            max: 2
        },
        autoRotate: !1,
        autoRotateSpeed: 2,
        autoRotateClockwise: !0,
        hoverRotatePanMode: 0,
        hoverRotatePanStrength: 20,
        hoverRotateDamping: .125,
        isTouchZoom: !0,
        orbitTouches: 2,
        panTouches: 3,
        resetHoverEffectOnPointerLeave: !0
    })(Yh || (Yh = {}));
var Us;
((t)=>t.defaultData = {
        orbitControls: Yh.defaultData,
        playPage: Al,
        withBackground: !0,
        preventScroll: !1,
        preventTouchScroll: !1,
        hideCursor: !1,
        mouseEventTarget: "canvas",
        joystickSizeAndXYOffset: Array(12).fill(0).map((e, r)=>{
            let i = 0, s = 0;
            return r < 5 ? s = -30 : r < 10 && (s = 30), r === 0 || r === 10 || r === 5 ? i = 30 : (r === 4 || r === 11 || r === 9) && (i = -30), [
                120,
                [
                    i,
                    s
                ],
                "show"
            ];
        }),
        settings: {
            image: {
                format: "jpg",
                ratio: 1
            },
            video: {
                format: "mp4",
                imageFormat: "jpg",
                fps: 30,
                mbps: 80,
                ratio: Math.max(1, typeof window < "u" ? Math.floor(window.devicePixelRatio) : 1),
                stopMode: "manual",
                duration: 5e3
            },
            web: {
                logo: !0,
                compress: !0,
                preset: 1,
                preload: !0,
                hint: !1,
                imageQuality: 70
            }
        },
        stopRaycast: !0,
        hdTransmission: !1
    })(Us || (Us = {}));
var qA;
((t)=>t.defaultData = {
        id: "basic",
        label: "Basic",
        style: "None",
        prompt: ""
    })(qA || (qA = {}));
var YA;
((t)=>t.defaultData = {
        weather: 0,
        shadows: 0,
        lightOrigin: 0,
        temperature: 0,
        sun: 0,
        camera: 0,
        environment: 0,
        particles: 0,
        nature: 0,
        floor: 0
    })(YA || (YA = {}));
var ba;
((e)=>(e.defaultData = ()=>({
            mode: "line-art-both",
            prompt: "",
            negativePrompt: "",
            style: {
                ...qA.defaultData
            },
            isRandomSeed: !0,
            seed: e.generateSeed(),
            guessMode: !1,
            advanced: !1,
            steps: 20,
            guidanceScale: 7.5,
            controlNetScale: 1,
            modifiers: YA.defaultData
        }), e.generateSeed = ()=>Math.round(Math.random() * 1e5)))(ba || (ba = {}));
var Pl;
((e)=>{
    function n1(r) {
        return r.find((i)=>i.data.type === "Page" && i.data.globalPhysics.usePhysics) !== void 0;
    }
    e.physicsEnabled = n1;
    function t(r, i, s) {
        r.scene.objects.traverseFrom(i, (o, a)=>{
            if (a.type === "Instance") {
                let l = Xh.getComponentData(r, a.component)?.data;
                l && s(o, a, l.events);
            } else s(o, a, a.events);
        });
    }
    e.traverseModuleInstances = t;
})(Pl || (Pl = {}));
var Sa;
((c)=>{
    c.TRASH_CAN_ID = "830a2708-8ed9-49cf-a68e-085299892222", c.defaultLight = {
        fi: -1,
        data: e0.defaultDirectionalLightData,
        id: "830a2708-8ed9-49cf-a68e-085299899103",
        children: []
    };
    function e(u = !0, h = []) {
        let d = [], f = t0.defaultMeshObject;
        u && (d.push({
            ...c.defaultLight
        }), d.push({
            fi: 1,
            id: "7ba78968-2a55-48f2-b14c-5191da3e075e",
            data: f,
            children: []
        })), d.push(...h);
        let p = new gr;
        return p.push({
            fi: 1,
            id: Al,
            data: {
                ...va.defaultData,
                name: "Scene 1"
            },
            children: d
        }), p;
    }
    c.createDefaultObjectTreeWithPage = e, c.defaultData = {
        objects: e(),
        publish: Us.defaultData,
        styles: ba.defaultData()
    }, c.emptyDataWithoutPage = function() {
        return {
            objects: new gr,
            publish: Us.defaultData,
            styles: ba.defaultData()
        };
    }, c.emptyDataWithPage = function(u = !0) {
        return {
            objects: e(u),
            publish: Us.defaultData,
            styles: ba.defaultData()
        };
    }, c.emptyData = function() {
        return {
            objects: new gr,
            publish: {
                ...Us.defaultData
            },
            styles: ba.defaultData()
        };
    };
    function a(u) {
        return {
            ...c.defaultData,
            objects: qi(u, gr.prototype)
        };
    }
    c.withObjs = a;
    function l(u, h) {
        return a([
            {
                id: u,
                data: h,
                children: [],
                fi: 0
            }
        ]);
    }
    c.withObj = l;
})(Sa || (Sa = {}));
var Kh;
((t)=>t.defaultData = {
        preset: "fullscreen",
        allowResponsive: !1,
        size: [
            512,
            512
        ],
        coords: [
            0,
            0
        ],
        sceneScale: 1,
        color: {
            r: 0,
            g: 0,
            b: 0,
            a: .5
        }
    })(Kh || (Kh = {}));
var r0;
((e)=>(e.defaultData = (r)=>({
            url: r,
            name: "New Webhook",
            parametersSchemas: new ke
        }), e.defaultParameterValueByType = (r)=>r === "number" ? 0 : r === "boolean" ? !1 : ""))(r0 || (r0 = {}));
var yD;
((t)=>t.defaultData = (e, r = "GET")=>({
            url: e,
            method: r,
            name: "New API",
            headers: new ke,
            queries: new ke,
            autoStart: !0
        }))(yD || (yD = {}));
var Br;
((s)=>{
    function n1(o) {
        return o.textValue !== void 0;
    }
    s.isTextValue = n1;
    function t(o) {
        return typeof o == "number";
    }
    s.isNumber = t;
    function e(o) {
        return typeof o == "boolean";
    }
    s.isBoolean = e;
    function r(o) {
        return n1(o) ? "string" : e(o) ? "boolean" : "number";
    }
    s.typeOfVariable = r;
    function i(o) {
        return s.isTextValue(o) ? Array.isArray(o.textValue) ? o.textValue.map((a)=>a.toString().padStart(o.padding ?? 2, "0")).join(o.deliminator ?? ":") + (o.suffix !== void 0 ? " " + o.suffix : "") : o.textValue.toString() : s.isBoolean(o) ? o ? "True" : "False" : s.isNumber(o) ? parseFloat(o.toFixed(3)).toString() : o.toString();
    }
    s.getDisplayedValue = i;
})(Br || (Br = {}));
var XA;
((t)=>t.all = [
        "images",
        "videos",
        "colors",
        "audios",
        "particles",
        "fonts",
        "materials",
        "variables"
    ])(XA || (XA = {}));
var vD;
((t)=>t.all = [
        ...XA.all,
        "components"
    ])(vD || (vD = {}));
var xD;
((t)=>{
    function n1() {
        return {
            images: new Qe,
            videos: new Qe,
            colors: new Qe,
            audios: new Qe,
            particles: new Qe,
            fonts: new Qe,
            materials: new Qe,
            components: new Qe,
            variables: new Qe,
            userAPIs: new Qe,
            userWebhooks: new Qe
        };
    }
    t.defaultData = n1;
})(xD || (xD = {}));
var zs;
((t)=>{
    function n1() {
        return {
            images: new Qe,
            videos: new Qe,
            colors: new Qe,
            audios: new Qe,
            particles: new Qe,
            fonts: new Qe,
            materials: new Qe,
            components: new Qe,
            variables: new Qe,
            userAPIs: new Qe,
            userWebhooks: new Qe
        };
    }
    t.defaultData = n1;
})(zs || (zs = {}));
var vn;
((s)=>{
    function n1() {
        let o = {};
        return o["89b10010-844c-11ec-a8a3-0242ac120002"] = {
            r: .5,
            g: .5,
            b: .5,
            a: 1,
            name: "Default Color"
        }, qi(o, Qe.prototype);
    }
    s.defaultColors = n1;
    function t() {
        return qi({}, Qe.prototype);
    }
    s.defaultImages = t;
    function e() {
        return {
            catelogs: new Qe,
            materials: new Qe,
            images: new Qe,
            videos: new Qe,
            colors: new Qe,
            audios: new Qe,
            particles: new Qe,
            fonts: new Qe,
            variables: new ke,
            userAPIs: new Qe,
            userWebhooks: new Qe,
            lib: zs.defaultData()
        };
    }
    s.emptyData = e;
    function r(o) {
        switch(o){
            case "number":
                return {
                    value: 0,
                    name: "Number"
                };
            case "boolean":
                return {
                    value: !1,
                    name: "Boolean"
                };
            case "string":
                return {
                    value: {
                        textValue: "String value"
                    },
                    name: "String"
                };
            case "time":
                let a = [
                    0,
                    0,
                    0
                ];
                return {
                    name: "Time",
                    value: {
                        textValue: a,
                        deliminator: ":",
                        padding: 2,
                        suffix: "AM"
                    },
                    dynamicVariableType: "time",
                    format: "HH:mm:ss",
                    format12h24h: "12ampm",
                    timeZone: null,
                    hasEnd: !1,
                    endValue: {
                        textValue: a,
                        deliminator: ":",
                        padding: 2,
                        suffix: "AM"
                    },
                    autoStart: !0,
                    repeat: !1
                };
            case "counter":
                return {
                    name: "Counter",
                    value: 0,
                    dynamicVariableType: "counter",
                    updateInterval: 1e3,
                    increment: 1,
                    autoStart: !0,
                    hasEnd: !0,
                    endValue: 60,
                    repeat: !0,
                    randomStart: !1,
                    range: [
                        0,
                        100
                    ],
                    decimals: 0
                };
            case "random":
                return {
                    name: "Random",
                    value: 0,
                    dynamicVariableType: "random",
                    updateInterval: 1e3,
                    increment: 1,
                    autoStart: !0,
                    isStatic: !1,
                    hasEnd: !0,
                    endValue: 60,
                    repeat: !0,
                    min: 0,
                    max: 100,
                    decimals: 0
                };
            default:
                console.error("Unknown variable type", o);
        }
    }
    s.defaultVariables = r;
    function i(o, a) {
        if (a.format === "HH:mm:ss") {
            let l = Math.floor(o / 3600), c = Math.floor((o - l * 3600) / 60), u = Math.round(o - l * 3600 - c * 60);
            return {
                textValue: [
                    l,
                    c,
                    u
                ]
            };
        } else if (a.format === "mm:ss") {
            let l = Math.floor(o / 60), c = Math.round(o - l * 60);
            return {
                textValue: [
                    l,
                    c
                ]
            };
        } else return a.format === "number" ? o = Math.round(o) : o = Math.round(o * 1e3) / 1e3, o;
    }
    s.getFormattedTimerTime = i;
})(vn || (vn = {}));
var Qh;
((t)=>t.list = [
        "idle",
        "move",
        "jump",
        "run"
    ])(Qh || (Qh = {}));
var Zh;
((e)=>(e.defaultColliderData = {
        type: "capsule",
        height: 200,
        radius: 50,
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ]
    }, e.defaultDataThirdPerson = {
        moveMode: "walk",
        forwardDirection: "+z",
        speedTranslate: 1e3,
        speedRotate: 100,
        runMultiplier: 2,
        rotationMode: "normal",
        rotBy: "keys",
        rotByTouch: "drag",
        delayPos: [
            .3,
            .3
        ],
        delayRot: [
            .3,
            .3
        ],
        keyAssignments: [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "\u25B2"
            ],
            [
                "rotPosY",
                "\u25C0"
            ],
            [
                "rotNegX",
                "\u25BC"
            ],
            [
                "rotNegY",
                "\u25B6"
            ],
            [
                "jump",
                "Space"
            ],
            [
                "run",
                "\u21E7"
            ],
            [
                "none",
                "Ctrl"
            ]
        ],
        touchControl: !0,
        joystickPosLoc: 5,
        joystickRotLoc: 11,
        jumpTouchButtonLoc: 9,
        collider: e.defaultColliderData,
        colliderHelperVisible: !0,
        collisionEnabled: !0,
        jumpPower: 100,
        resetYPosition: 3e3,
        alignToGround: !1,
        autoOrientMove: !0,
        orientWith: "camera",
        orientMode: "radial",
        delayPosCamera: .3,
        delayRotCamera: .3,
        camera: "",
        cameraXAxis: "Limit",
        cameraYAxis: "Free",
        cameraRotXLimits: [
            0,
            Math.PI / 2
        ],
        cameraRotYLimits: [
            -Math.PI / 2,
            Math.PI / 2
        ],
        gameActions: {
            idle: new ke,
            move: new ke,
            jump: new ke,
            run: new ke
        },
        navmesh: {
            enabled: !1,
            ch: 6,
            cs: 6,
            walkableClimb: 5,
            walkableHeight: 1,
            walkableRadius: 0,
            zones: "all",
            objects: [],
            helperVisible: !0,
            destinationHelperRadius: 0,
            destinationHelperColor: bt.fromHexAndA(3728051, 1)
        }
    }))(Zh || (Zh = {}));
function bD(n1) {
    n1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colorA !== void 0) {
            let e = t.colorA, r = t.colorB, i = [
                [
                    e.r,
                    e.g,
                    e.b,
                    e.a
                ],
                [
                    r.r,
                    r.g,
                    r.b,
                    r.a
                ]
            ], s = [
                0,
                1
            ];
            for(let a = 2; a < 10; a++)i.push(i[1]), s.push(1);
            let o = {
                ...Pn(zr(t), "type", "visible", "isVector", "isWorldSpace", "origin", "alpha", "mode"),
                near: Math.max(0, t.near),
                far: Math.max(0, t.far),
                colors: i,
                steps: s,
                num: 2,
                direction: [
                    1,
                    0,
                    0
                ],
                smooth: !1,
                gradientType: 1
            };
            Object.assign(t, o);
        } else if (t.type === "depth" && t.gradientType === 1 && (t.near < 0 || t.far < 0)) {
            let e = {
                ...zr(t),
                near: Math.max(t.near, 0),
                far: Math.max(t.far, 0)
            };
            Object.assign(t, e);
        }
    });
}
function wa(n1, t) {
    Object.values(n1.shared.materials).forEach((e)=>t(e));
}
function Aa(n1, t) {
    n1.scene.objects.traverse((e, r)=>{
        "materials" in r ? r.materials.forEach((i, s)=>{
            i === void 0 && (r.materials[s] = Kr.defaultData(), i = r.materials[s]), typeof i != "string" && t(i);
        }) : "material" in r ? typeof r.material != "string" && (r.material === void 0 && (r.material = Kr.defaultData()), t(r.material)) : r.type === "Mesh" && (r.material === void 0 && (r.material = Kr.defaultData()), t(r.material)), "overrides" in r && Object.values(r.overrides).forEach((i)=>{
            i.material && typeof i.material != "string" && Object.getPrototypeOf(i.material) !== yr.prototype && t(i.material);
        });
    });
}
function o9(n1) {
    Object.assign(n1.scene.publish, {
        orbitControls: {
            ...Yh.defaultData,
            ...zr(n1.scene.publish.orbitControls)
        }
    });
}
function a9(n1) {
    Object.assign(n1.scene.publish.settings, {
        video: {
            ...Us.defaultData.settings.video,
            ...zr(n1.scene.publish.settings.video)
        }
    });
}
function l9(n1) {
    function t(e) {
        if (e.layers) {
            for (let r of Object.values(e.layers))if (r) {
                for (let [i, s] of Object.entries(r))if ((Wv.includes(i) || typeof s == "boolean") && delete r[i], i === "texture") for (let [o, a] of Object.entries(s))(dD.includes(o) || typeof a == "boolean") && delete s[o];
            }
        }
    }
    n1.scene.objects.traverse((e, r)=>{
        r.states.forEach((i)=>{
            let s = i;
            s.material ? t(s.material) : s.materials && s.materials.forEach((o)=>{
                t(o);
            });
        });
    });
}
function c9(n1) {
    n1.scene.publish.withBackground = !0;
}
function u9(n1) {
    n1.scene.publish.settings.web = {
        compress: !0,
        preload: !0,
        preset: 1,
        logo: !0,
        hint: !1
    };
}
function h9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.cloner;
        r && (r.radial.scale = r.radial.scale.map((i)=>i + 1), r.linear.scale = r.linear.scale.map((i)=>i + 1));
    });
}
function d9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.geometry;
        r && (r.type === "DodecahedronGeometry" || r.type === "IcosahedronGeometry") && (r.detail = Math.round(r.detail));
    });
}
function f9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = n1.scene.objects.unproxy().parent(t);
        if (r) {
            let i = zr(n1.scene.objects.data(r));
            i && i.type === "Mesh" && i.geometry.type === "BooleanGeometry" && e.type === "Mesh" && (e.visible = zr(e).booleanExclude !== !0);
        }
    });
}
function p9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        if (e.type === "Mesh") {
            let r = e;
            e.geometry.type === "NonParametricGeometry" ? r.material !== void 0 && delete r.material : r.materials !== void 0 && delete r.materials;
        }
    });
}
function m9(n1) {
    function t(r) {
        Object.setPrototypeOf(r, yr.prototype), r.texture && Object.setPrototypeOf(r.texture, yr.prototype);
    }
    function e(r) {
        Object.setPrototypeOf(r, yr.prototype);
        for(let i in r)t(r[i]);
    }
    n1.scene.objects.traverse((r, i)=>{
        i.states.forEach((s)=>{
            let o = s;
            if (o.material) {
                let a = zr(o.material).layers;
                e(a), o.material.layers = a;
            }
            if (o.materials) for(let a = 0; a < o.materials.length; a++){
                let l = o.materials[a], c = zr(l).layers;
                e(c), l.layers = c;
            }
        });
    });
}
function SD(n1) {
    n1.layers === void 0 && Object.assign(n1, Kr.defaultTwoLayerData("lambert"));
}
function KA(n1) {
    !n1.layers || n1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colors.length === 10) {
            let e = [
                ...t.colors
            ];
            e.push(t.colors[9]);
            let r = [
                ...t.steps
            ];
            r.push(t.steps[9]);
            let i = {
                ...zr(t),
                colors: e,
                steps: r
            };
            Object.assign(t, i);
        }
    });
}
function g9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && (e.geometry.type === "BooleanGeometry" || e.geometry.type === "SubdivGeometry") && (e.geometry.phongAngle = 35);
    });
}
function wD(n1) {
    n1.scene.objects.traverse((t, e)=>{
        "materials" in e ? e.materials.forEach((r)=>{
            typeof r != "string" && KA(r);
        }) : "material" in e && typeof e.material != "string" && KA(e.material);
    }), Object.values(n1.shared.materials).forEach((t)=>KA(t));
}
function y9(n1) {
    n1.scene.environment.ambientLight.softShadows = !1, n1.scene.environment.ambientLight.softShadowQuality = "low", n1.scene.objects.traverse((t, e)=>{
        (e.type === "DirectionalLight" || e.type === "SpotLight") && (e.shadowResolution = 1024, e.shadowRadius = 1, e.depth = 1e5);
    }), n1.shared.penumbraSize = new Array(5).fill(.5);
}
function v9(n1) {
    n1.shared.audios = qi({}, Qe.prototype);
}
function x9(n1) {
    n1.shared.videos = qi({}, Qe.prototype);
}
function b9(n1) {
    let t = n1.shared.materials;
    Object.entries(t).forEach(([e, r])=>{
        if (!r.layers) {
            let i = {
                name: "Untitled Material",
                layers: [
                    {
                        fi: 0,
                        data: {
                            type: "light",
                            category: "phong",
                            alpha: .6,
                            visible: !0,
                            mode: 0,
                            specular: {
                                r: .2,
                                g: .2,
                                b: .2
                            },
                            shininess: 5
                        },
                        id: "layer1"
                    },
                    {
                        fi: 1,
                        data: {
                            type: "color",
                            alpha: 1,
                            visible: !0,
                            mode: 0,
                            color: {
                                r: .2823529411764706,
                                g: .2823529411764706,
                                b: .30196078431372547
                            }
                        },
                        id: "layer2"
                    }
                ]
            };
            Object.assign(t, {
                [e]: i
            });
        }
    });
}
function S9(n1) {
    Object.entries(zr(n1.shared.images)).filter((r)=>r[1].asset === !1).map((r)=>r[0]).forEach((r)=>{
        delete n1.shared.images[r];
    }), Object.entries(zr(n1.shared.audios)).filter((r)=>r[1].asset === !1).map((r)=>r[0]).forEach((r)=>{
        delete n1.shared.audios[r];
    });
}
function w9(n1) {
    n1.scene.publish.settings.web.preload = !1;
}
function AD(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "depth" && t.num !== void 0 && (t.colors = t.colors.slice(0, t.num), t.steps = t.steps.slice(0, t.num), delete t.num);
    });
}
function ED(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        hD(t) && t.isMask === void 0 && (t.isMask = !1), (t.type === "texture" || t.type === "video") && t.blending === void 0 && (t.blending = 0), (t.type === "noise" || t.type === "displace" && t.displacementType === "noise") && (t.voronoiStyle === void 0 && (t.voronoiStyle = 0), t.highCut === void 0 && (t.highCut = 1), t.lowCut === void 0 && (t.lowCut = 0), t.smoothness === void 0 && (t.smoothness = .3), t.seed === void 0 && (t.seed = 0), t.quality === void 0 && (t.quality = 1));
    });
}
function A9(n1) {
    n1.shared.fonts = qi({}, Qe.prototype);
}
function E9(n1) {
    return n1.replace(".typeface", "").replace(/optimer/gi, "open sans").replace("space_mono", "space mono").replace(/alma_mono/gi, "varela round").replace(/droid_sans_mono/gi, "noto sans mono").replace(/droid_sans|gentilis|gnomon_(simple|foreground)|helvetiker/gi, "roboto").replace(/droid_serif/gi, "roboto slab").replace("_sans", " sans").replace("crimson_text", "crimson text").replace("medium_medium", "medium").replace("fatface_fatface", "fatface").replace("100hairline", "thin").replace("200thin", "extralight").replace("300light", "light").replace("500medium", "medium").replace("600semi", "semibold").replace("800heavy", "extrabold").replace("900black", "black").replace(/bodoni_(11|16|24|36|48|72|96)([^_])/gi, "bodoni_$1_$2").replace(/bodoni_(11|16|24|36|48|72|96)/gi, "bodoni moda").replace(/(thin|hairline)(_regular)?/gi, "100").replace(/(extra|ultra)light(_regular)?/gi, "200").replace(/light(_regular)?/gi, "300").replace(/_book|_normal|_roman/gi, "_regular").replace(/medium(_regular)?/gi, "500").replace(/(semi|demi)bold(_regular)?/gi, "600").replace(/(extra|ultra)bold(_regular)?/gi, "800").replace(/bold(_regular)?/gi, "700").replace(/(black|heavy|fatface)(_regular)?/gi, "900").replace(/([1-9]00)_italic/gi, "$1italic").replace(/regularitalic/gi, "italic").replace(/regularitalic/gi, "italic").split(" ").map((e)=>e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function T9(n1) {
    let t = [];
    n1.scene.objects.traverse((e, r)=>{
        let i = r;
        if (i.type === "TextFrame") {
            let s = Kr.defaultTwoLayerData("phong"), o = typeof i.color == "string" ? n1.shared.colors[i.color] : i.color;
            s.layers[1].data.color = {
                r: o.r,
                g: o.g,
                b: o.b
            }, s.layers[1].data.alpha = i.alpha;
            let a = E9(i.font);
            n1.shared.fonts[a] === void 0 && (n1.shared.fonts[a] = {
                name: a
            });
            let l = {
                name: i.name,
                ...vi.defaultData,
                ...Cl.defaultData,
                flatShading: !1,
                wireframe: !1,
                geometry: {
                    ...ya.defaultData("TextGeometry"),
                    width: i.width,
                    height: i.height,
                    font: a,
                    depth: 0,
                    horizontalAlign: i.horizontalAlign,
                    verticalAlign: i.verticalAlign,
                    fontSize: i.fontSize * 1.40625,
                    lineHeight: i.lineHeight / 1.40625,
                    letterSpacing: i.letterSpacing - 1,
                    text: i.text,
                    textTransform: i.textTransform,
                    extrudeBevelSize: 0,
                    extrudeBevelSegments: 1
                },
                material: s,
                states: zr(i.states),
                events: zr(i.events),
                visible: i.visible,
                raycastLock: i.raycastLock,
                position: i.position,
                rotation: i.rotation,
                scale: i.scale,
                hiddenMatrix: i.hiddenMatrix
            }, c = zr(n1.scene.objects).parent(e);
            n1.scene.objects.insertAfter(c ?? null, e, [
                {
                    id: e + "new",
                    data: l,
                    children: []
                }
            ]), t.push(e);
        }
    }), t.forEach((e)=>{
        n1.scene.objects.delete(e);
    });
}
function M9(n1) {
    let t = {
        0: "MouseDown",
        1: "MouseUp",
        2: "MouseHover",
        5: "KeyDown",
        6: "KeyUp",
        7: "Start",
        9: "LookAt",
        10: "Follow",
        11: "Scroll",
        12: "Audio",
        13: "GameControl"
    };
    n1.scene.objects.traverse((e, r)=>{
        r.events.forEach((i)=>{
            if (!!t[Number(i.type)]) {
                if (Object.assign(i, {
                    type: t[Number(i.type)]
                }), i.type === "Audio" && "audioEvent" in i && (Object.assign(i, {
                    playAudio: i.audioEvent
                }), delete i.audioEvent), i.type === "GameControl") Object.assign(i, {
                    gameActions: {
                        idle: new ke,
                        move: new ke,
                        jump: new ke
                    }
                });
                else {
                    let s = new ke;
                    Object.assign(i, {
                        actions: s
                    }), (i.type === "MouseDown" || i.type === "MouseUp" || i.type === "KeyDown" || i.type === "KeyUp") && "url" in i && s.push({
                        fi: 0,
                        id: we.generateUUID(),
                        data: {
                            type: "Link",
                            url: i.url,
                            delay: 0
                        }
                    }), "targets" in i && (i.targets.forEach((o, a, l)=>{
                        let c = {
                            state: void 0,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            duration: 0,
                            easing: 4
                        }, u = {
                            easing: o.easing,
                            duration: o.duration
                        };
                        o.easing === 6 ? Object.assign(u, Pn(o, "mass", "stiffness", "damping", "velocity")) : o.easing === 5 && Object.assign(u, {
                            control1: {
                                ...o.control1
                            },
                            control2: {
                                ...o.control2
                            }
                        });
                        let h = {
                            repeat: o.repeat ? -1 : 0,
                            delay: o.delay,
                            delayDirection: o.delayDirection,
                            direction: o.cycle && o.rewind ? "pingpong-rewind" : o.cycle ? "pingpong" : "normal"
                        }, d = {
                            state: o.state,
                            ...h,
                            ...u
                        }, f = {
                            allowSlerp: !0,
                            type: "Transition",
                            object: o.object,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            tweens: new ke({
                                fi: 0,
                                id: we.generateUUID(),
                                data: c
                            }, {
                                fi: 1,
                                id: we.generateUUID(),
                                data: d
                            })
                        };
                        s.push({
                            fi: l,
                            id: a,
                            data: f
                        });
                    }), delete i.targets);
                }
            }
        });
    });
}
function C9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        function r(i, s) {
            let o = new ke, a = [];
            if (e.events.forEach((l, c, u)=>{
                if (l.type === "Audio" && l.trigger === s) {
                    let h;
                    a.push(c), l.interaction === "play" ? h = {
                        ...Pn(l, "interaction", "audio", "delay", "volume", "loop"),
                        triggerAfter: "after" in l ? l.after : void 0,
                        toggle: "after" in l ? l.toggle : void 0,
                        type: "Audio"
                    } : (l.interaction === "pause" || l.interaction === "stop") && (h = {
                        ...Pn(l, "interaction", "delay", "object", "playAudio"),
                        type: "Audio"
                    }), h && o.push({
                        fi: u,
                        id: c,
                        data: h
                    });
                }
            }), a.forEach((l)=>e.events.delete(l)), o.length) {
                let l = e.events.find((c)=>c.type === i)?.data;
                l ? "actions" in l && l.actions.insertBefore(null, o) : e.events.insertBefore(null, [
                    {
                        id: we.generateUUID(),
                        data: {
                            type: i,
                            actions: o
                        }
                    }
                ]);
            }
        }
        r("Start", "start"), r("MouseDown", "mouseDown"), r("MouseUp", "mouseUp"), r("KeyDown", "keyDown"), r("KeyUp", "keyUp");
    });
}
function TD(n1) {
    let t = n1.layers.find((e)=>e.type === "light")?.data;
    if (t?.category === "basic") {
        let e = Gr.defaultData("light", "phong"), r = t;
        Object.assign(r, e), r.visible = !1;
    }
}
function MD(n1) {
    wa(n1, TD), Aa(n1, TD);
}
function P9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "SubdivGeometry" && (e.geometry.scaleBaked || (e.geometry.scaleBaked = [
            1,
            1,
            1
        ]));
    });
}
function _9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        (e.type === "Empty" || e.type === "Mesh") && e.cloner && !e.cloner.randomnessObject && !e.cloner.toObject && !e.cloner.randomness && (e.cloner = {
            ...e.cloner,
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        });
    });
}
function I9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "NonParametricGeometry" && !("material" in e) && !("materials" in e) && (e.material = Kr.defaultTwoLayerData("phong"));
    });
}
function D9(n1) {
    n1.scene.publish.orbitControls.autoZoom === void 0 && (n1.scene.publish.orbitControls.autoZoom = !1), n1.scene.objects.traverse((t, e)=>{
        (e.type === "OrthographicCamera" || e.type === "PerspectiveCamera") && (e.orthographic.autoZoom === void 0 && (e.orthographic.autoZoom = !1), e.orthographic.autoZoomFrustumSize === void 0 && (e.orthographic.autoZoomFrustumSize = 790));
    });
}
function O9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.pathSnapping === void 0 && (e.pathSnapping = {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        }), e.pathSnapping.offset === void 0 && (e.pathSnapping.offset = 0);
    });
}
function R9(n1) {
    n1.scene.publish.mouseEventTarget === void 0 && (n1.scene.publish.mouseEventTarget = "canvas"), n1.scene.publish.settings.web.hint === void 0 && (n1.scene.publish.settings.web.hint = !1);
}
function L9(n1) {
    let { video: t } = n1.scene.publish.settings;
    t.format === "gif" && t.fps > 48 && (t.fps = 15);
}
function B9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.resetYPosition = Math.abs(r.resetYPosition - e.position[1]));
        });
    });
}
function N9(n1) {
    let t = n1.scene.environment.usePhysics;
    n1.scene.objects.traverse((e, r)=>{
        t && r.physics === null ? r.collision = !1 : r.collision = "visibility";
    });
}
function F9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.navmesh = Zh.defaultDataThirdPerson.navmesh);
        });
    });
}
function V9(n1) {
    n1.scene.styles || (n1.scene.styles = ba.defaultData());
}
function CD(n1) {
    n1.layers.forEach((t)=>{
        t.type === "light" && t.category !== "toon" && t.occlusion === void 0 && (t.occlusion = !0);
    });
}
function k9(n1) {
    n1.scene.environment.ambientLight.occlusion === void 0 && (n1.scene.environment.ambientLight.occlusion = !1), n1.scene.environment.ambientLight.aoFullRes === void 0 && (n1.scene.environment.ambientLight.aoFullRes = !1), n1.scene.environment.ambientLight.radius === void 0 && (n1.scene.environment.ambientLight.radius = 256), n1.scene.environment.ambientLight.bias === void 0 && (n1.scene.environment.ambientLight.bias = .5), n1.scene.environment.ambientLight.aoColor === void 0 && (n1.scene.environment.ambientLight.aoColor = {
        r: .19607843137254902,
        g: .19607843137254902,
        b: .19607843137254902
    }), Aa(n1, CD), wa(n1, CD);
}
function U9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && Object.assign(r.gameActions, {
                run: new ke
            });
        });
    });
}
function z9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.keyAssignments = [
                ...r.keyAssignments,
                [
                    "run",
                    "\u21E7"
                ],
                [
                    "none",
                    "Ctrl"
                ]
            ]);
        });
    });
}
function PD(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "light" && t.bumpMapIntensity === void 0 && (t.bumpMapIntensity = 5);
    });
}
function _D(n1, t) {
    if (t < 1 && (Aa(n1, bD), wa(n1, bD), n1.schema = 1), t < 2 && (o9(n1), n1.schema = 2), t < 3 && (l9(n1), n1.schema = 3), t < 4 && (c9(n1), n1.schema = 4), t < 5 && (u9(n1), n1.schema = 5), t < 6 && (h9(n1), n1.schema = 6), t < 7 && (d9(n1), n1.schema = 7), t < 8 && (n1.schema = 8), t < 9 && (wD(n1), n1.schema = 9), t < 10 && (g9(n1), n1.schema = 10), t < 11 && (y9(n1), n1.schema = 11), t < 12 && (wD(n1), n1.schema = 12), t < 13 && (v9(n1), n1.schema = 13), t < 14 && (b9(n1), n1.schema = 14), t < 15 && (S9(n1), n1.schema = 15), t < 16 && (w9(n1), n1.schema = 16), t < 17 && (Aa(n1, AD), wa(n1, AD), n1.schema = 17), t < 18 && (Aa(n1, SD), wa(n1, SD), n1.schema = 18), t < 19 && (a9(n1), n1.schema = 19), t < 20 && (A9(n1), T9(n1), n1.schema = 20), t < 21 && (M9(n1), C9(n1), n1.schema = 21), t < 22 && (MD(n1), n1.schema = 22), t < 23 && (P9(n1), n1.schema = 23), t < 24 && (_9(n1), n1.schema = 24), (t < 25 || n1.shared.videos === void 0) && (x9(n1), t < 25 && (n1.schema = 25)), t < 26 && (f9(n1), n1.schema = 26), t < 27 && (p9(n1), n1.schema = 27), t < 28 && (MD(n1), n1.schema = 28), t < 29 && (m9(n1), n1.schema = 29), t < 30 && (I9(n1), n1.schema = 30), t < 31 && (D9(n1), n1.schema = 31), t < 33 && (O9(n1), n1.schema = 33), t < 34 && (R9(n1), n1.schema = 34), t < 35 && (L9(n1), n1.schema = 35), t < 36 && (B9(n1), n1.schema = 36), t < 37 && (N9(n1), n1.schema = 37), t < 38 && (Aa(n1, ED), wa(n1, ED), n1.schema = 38), t < 39 && (F9(n1), n1.schema = 39), t < 40 && (V9(n1), n1.schema = 40), t < 41 && (k9(n1), n1.schema = 41), t < 42 && (U9(n1), n1.schema = 42), t < 43 && (z9(n1), n1.schema = 43), t < 99) {
        Aa(n1, PD), wa(n1, PD), n1.scene.publish.playCamera === null && (n1.scene.publish.playCamera = hs);
        let e = zr(n1.scene.objects), r = n1.scene.objects;
        n1.scene.publish.playPage = Al, r.insertBefore(null, null, [
            {
                id: Al,
                data: {
                    ...va.defaultData,
                    backgroundColor: n1.scene.backgroundColor,
                    fog: n1.scene.fog,
                    postprocessing: n1.scene.postprocessing,
                    ao: Pn(n1.scene.environment.ambientLight, "occlusion", "aoFullRes", "radius", "bias", "aoColor"),
                    publish: {
                        playCamera: n1.scene.publish.playCamera,
                        gameControlObject: n1.scene.publish.gameControlObject
                    },
                    shadow: Pn(n1.scene.environment.ambientLight, "softShadowQuality"),
                    globalPhysics: {
                        ...Ml.defaultData,
                        ...Pn(n1.scene.environment, "usePhysics", "gravity")
                    },
                    camera: zr(n1.scene.ownerCamera) ?? va.defaultData.camera,
                    name: "Scene"
                },
                children: []
            }
        ]);
        for (let o of e)o.id !== Sa.TRASH_CAN_ID && r.move(Al, o.fi, o.id);
        let i = 0, s = 0;
        n1.shared.penumbraSize && n1.scene.objects.traverse((o, a)=>{
            a.type === "DirectionalLight" ? (a.penumbraSize = n1.shared.penumbraSize[Math.min(i, 2)], i += 1) : a.type === "SpotLight" && (a.penumbraSize = n1.shared.penumbraSize[3 + Math.min(s, 1)], s += 1), (a.physics === void 0 || a.physics === null) && a.type !== "Instance" && (a.physics = {}, Object.assign(a.physics, Tl.defaultData)), a.physics !== void 0 && a.physics !== null && (a.physics.enabled = a.collision ?? "visibility", delete a.collision);
        }), n1.schema = 99;
    }
}
function ID(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "light" && t.alphaOverride === void 0 && (t.alphaOverride = 1);
    });
}
function G9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.geometry;
        r && r.type === "PathGeometry" && (r.extrusion.capType = "flat", r.extrusion.bevel = 50, r.extrusion.bevelSides = 6, r.extrusion.shape.type === "Custom" && (r.extrusion.shape.shapeQuality = "low"));
    });
}
function j9(n1) {
    Array.isArray(zr(n1.events)) && n1.events?.forEach((t)=>{
        "disabled" in t || (t.disabled = !1), (t.type === "MouseDown" || t.type === "MouseUp" || t.type === "MousePress") && (t.mode = t.mode || "Object");
    });
}
var Jh = 180 / Math.PI;
function DD(n1) {
    n1.rotation = n1.rotation.slice(0, 3).map((t)=>t * Jh);
}
function OD(n1) {
    DD(n1), n1.type === "Page" && DD(n1.camera), n1.states?.forEach((e)=>{
        e.rotation === void 0 || e.rotation === null || (e.rotation = e.rotation.slice(0, 3).map((r)=>r * Jh));
    });
    let t = n1.geometry;
    t && t.type === "SphereGeometry" && (t.thetaLength = (t.thetaLength ?? 180) * Jh), t && t.type === "TorusGeometry" && (t.arc = t.arc * Jh), t && t.type === "PathGeometry" && (t.extrusion.angle *= Jh, t.extrusion.twist *= Jh), n1.type === "Mesh" && n1.geometry.type === "TextGeometry" && (n1.geometry.text = {
        textValue: n1.geometry.text
    }), Array.isArray(zr(n1.events)) && n1.events?.forEach((e)=>{
        (e.type === "MouseDown" || e.type === "MouseUp" || e.type === "MousePress" || e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress" || e.type === "Collision" || e.type === "Trigger") && (e.runMode = e.toggle ? "Toggle" : "Repeat");
    });
}
function H9(n1) {
    n1.shared.variables = qi({}, Qe.prototype);
}
function W9(n1) {
    let t = zr(n1.shared.variables);
    n1.shared.variables = qi(Object.entries(t ?? {}).map(([e, r], i)=>({
            fi: i,
            id: e,
            data: r
        })), ke.prototype);
}
var _o = 115;
function RD(n1, t) {
    t(n1.data);
    for (let e of n1.children)RD(e, t);
}
function q9(n1) {
    let t = n1.schema ?? 104;
    t !== _o && t < 105 && (RD(n1.asset, OD), n1.schema = 105);
}
function Y9(n1) {
    n1.shared.particles = qi({}, Qe.prototype), n1.shared.lib && (n1.shared.lib.particles = zs.defaultData().particles);
}
function X9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Particle" && typeof e.renderMaterial.size == "number" && Object.assign(e.renderMaterial, {
            size: [
                e.renderMaterial.size,
                e.renderMaterial.size
            ]
        });
    });
}
function K9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Page" && (e.postprocessing.depthOfField.focusDistance = 100, e.postprocessing.depthOfField.focalLength = 20, e.postprocessing.depthOfField.bokehScale = 5);
    });
}
function Q9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        Array.isArray(zr(e.events)) !== !1 && e.events?.forEach((r)=>{
            let i = r.runMode;
            r.type === "MouseDown" || r.type === "MouseUp" || r.type === "KeyDown" || r.type === "KeyUp" || r.type === "Collision" || r.type === "Trigger" ? r.actions?.forEach((s)=>{
                s.type === "Transition" && (s.runMode = i ?? "Repeat"), (s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = i === "Toggle" ? "Toggle" : "Normal");
            }) : r.type === "MouseHover" || r.type === "MousePress" || r.type === "KeyPress" ? r.actions?.forEach((s)=>{
                (s.type === "Transition" || s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Toggle");
            }) : r.type === "GameControl" ? (delete r.actions, Object.keys(r.gameActions).forEach((o)=>{
                r.gameActions[o]?.forEach((a)=>{
                    a.type === "Transition" && (a.runMode = "Repeat"), a.type === "Animation" && (a.runMode = "Normal");
                });
            })) : r.type === "DragDrop" ? (delete r.actions, r.dragDropActions?.drag?.forEach((s)=>{
                (s.type === "Transition" || s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Toggle");
            }), r.dragDropActions?.drop?.forEach((s)=>{
                (s.type === "Transition" || s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Toggle");
            })) : r.type === "Resize" ? (delete r.actions, r.breakpoints?.forEach((s)=>{
                s.actions?.forEach((o)=>{
                    (o.type === "Transition" || o.type === "Animation" || o.type === "SwitchCamera") && (o.runMode = "Toggle");
                });
            })) : r.type === "Start" ? r.actions?.forEach((s)=>{
                s.type === "Transition" && (s.runMode = "Once"), (s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Normal");
            }) : r.type === "VariableChange" || r.type === "Scroll" ? r.actions?.forEach((s)=>{
                s.type === "Transition" && (s.runMode = "Repeat"), (s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Normal");
            }) : r.type === "Conditional" && (delete r.actions, r.inActions?.forEach((s)=>{
                s.type === "Transition" && (s.runMode = "Repeat"), (s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Normal");
            }), r.outActions?.forEach((s)=>{
                s.type === "Transition" && (s.runMode = "Repeat"), (s.type === "Animation" || s.type === "SwitchCamera") && (s.runMode = "Normal");
            }));
        });
    });
}
function Z9(n1) {
    n1.shared.userAPIs = qi({}, Qe.prototype), n1.shared.userWebhooks = qi({}, Qe.prototype), n1.shared.lib && (n1.shared.lib.userAPIs = zs.defaultData().userAPIs, n1.shared.lib.userWebhooks = zs.defaultData().userWebhooks);
}
function i0(n1) {
    let t = n1.schema ?? 0;
    if (t !== _o) {
        console.warn("updating from ", t, "to ", _o), _D(n1, t), t < 100 && (n1.scene.publish.joystickSizeAndXYOffset === void 0 && (n1.scene.publish.joystickSizeAndXYOffset = Us.defaultData.joystickSizeAndXYOffset), n1.schema = 100), t < 101 && (Aa(n1, ID), wa(n1, ID), n1.schema = 101), t < 102 && (G9(n1), n1.schema = 102), t < 104 && (n1.shared.catelogs = new Qe, n1.shared.lib = zs.defaultData(), n1.schema = 104), t < 105 && (H9(n1), n1.scene.objects.traverse((e, r)=>{
            OD(r);
        }), n1.schema = 105);
        for (let e of Object.values(n1.shared.lib.components))q9(e);
        t < 106 && (W9(n1), n1.schema = 106), t < 107 && (n1.shared.lib.variables = zs.defaultData().variables, n1.schema = 107), t < 109 && (Y9(n1), n1.schema = 109), t < 110 && (X9(n1), n1.schema = 110), t < 111 && (n1.scene.objects.traverse((e, r)=>{
            j9(r);
        }), n1.schema = 111), t < 112 && (K9(n1), n1.schema = 112), t < 113 && (Q9(n1), n1.schema = 113), t < 114 && (n1.scene.publish.settings.web.imageQuality === void 0 && (n1.scene.publish.settings.web.imageQuality = 70), n1.schema = 114), t < 115 && (Z9(n1), n1.schema = 115);
    }
}
var Xh;
((c)=>{
    c.defaultData = {
        schema: _o,
        scene: Sa.defaultData,
        frames: new Qe().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", Kh.defaultData),
        shared: {
            ...vn.emptyData(),
            colors: vn.defaultColors()
        }
    }, c.emptyDataForImports = function() {
        let u = Sa.emptyDataWithPage();
        return {
            schema: _o,
            scene: u,
            frames: new Qe().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", Kh.defaultData),
            shared: {
                ...vn.emptyData(),
                colors: vn.defaultColors(),
                images: vn.defaultImages()
            }
        };
    }, c.emptyData = function() {
        return {
            schema: _o,
            scene: Sa.emptyDataWithPage(),
            frames: new Qe().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", Kh.defaultData),
            shared: vn.emptyData()
        };
    }, c.clipboard2dData = function() {
        return {
            schema: _o,
            scene: Sa.emptyData(),
            frames: new Qe,
            shared: vn.emptyData()
        };
    }, c.collabHelper = {
        ...Up,
        updateSchema (u) {
            return (u.schema ?? 0) < _o ? vl(u, i0) : (u.schema ?? 0) - _o;
        }
    };
    function s(u) {
        let h = c.collabHelper.updateSchema(u);
        return typeof h == "number" ? h === 0 ? u : null : h.data;
    }
    c.updateSchemaDirectly = s;
    function o(u) {
        return {
            ...u,
            shared: {
                ...u.shared,
                lib: zs.defaultData()
            }
        };
    }
    c.withoutLib = o;
    function a(u, h) {
        let d = u.scene.objects.get(h);
        if (d && d.data.type === "Component") return d;
        {
            let f = u.shared.lib.components[h];
            if (f) return f.asset;
        }
    }
    c.getComponentData = a;
    function l(u) {
        let h = Object.values(u.shared.userAPIs);
        for (let d of h){
            let f = d.headers;
            for (let p of f)if (p.data.key.toLowerCase() === "authorization" && p.data.value !== "") return !0;
        }
        return !1;
    }
    c.hasSensitiveData = l;
})(Xh || (Xh = {}));
var n0;
((t)=>t.emptyImage = {
        data: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=",
        name: "empty"
    })(n0 || (n0 = {}));
var LD;
((t)=>{
    function n1(e) {
        return !0;
    }
    t.is = n1;
})(LD || (LD = {}));
var s0;
((r)=>{
    r.defaultData = {
        position: [
            0,
            0
        ],
        scale: [
            1,
            1
        ],
        rotation: 0,
        shear: [
            0,
            0
        ]
    };
    function t(i, s) {
        return {
            position: s?.position ?? i.position,
            rotation: s?.rotation ?? i.rotation,
            scale: s?.scale ?? i.scale,
            shear: s?.shear ?? i.shear
        };
    }
    r.merge = t;
    function e(i, s) {
        return cv({
            position: Vs.isEqual(i.position, s.position) ? void 0 : s.position,
            rotation: i.rotation === s.rotation ? void 0 : s.rotation,
            scale: Vs.isEqual(i.scale, s.scale) ? void 0 : s.scale,
            shear: i.shear && s.shear && Vs.isEqual(i.shear, s.shear) ? void 0 : s.shear
        });
    }
    r.diff = e;
})(s0 || (s0 = {}));
var QA;
((t)=>t.defaultData = {
        horizontalConstraint: 0,
        verticalConstraint: 0
    })(QA || (QA = {}));
var BD;
((t)=>t.defaultData = {
        direction: "row",
        wrap: "unwrap",
        align: "top-left",
        gap: 10,
        rowGap: 10,
        autoGap: !1,
        autoRowGap: !1,
        leftPadding: 8,
        rightPadding: 8,
        topPadding: 8,
        bottomPadding: 8
    })(BD || (BD = {}));
var o0;
((t)=>t.defaultData = {
        opacity: 1,
        fill: {
            color: bt.fromHexAndA(ii, 1),
            enabled: !0
        },
        stroke: {
            color: bt.from0to1([
                0,
                0,
                0,
                1
            ]),
            thickness: 1,
            enabled: !1,
            mode: "inside"
        },
        layerBlur: {
            radius: 2,
            enabled: !1
        },
        backgroundBlur: {
            radius: 2,
            enabled: !1
        },
        dropShadow: {
            offset: [
                10,
                10
            ],
            blurRadius: 10,
            color: bt.from0to1([
                0,
                0,
                0,
                1
            ]),
            enabled: !1,
            spread: 0
        },
        innerShadow: {
            offset: [
                10,
                10
            ],
            blurRadius: 10,
            color: bt.from0to1([
                0,
                0,
                0,
                1
            ]),
            enabled: !1,
            spread: 0
        }
    })(o0 || (o0 = {}));
var Ea;
((s)=>{
    function n1(o, a) {
        return {
            name: a
        };
    }
    s.newEmpty = n1;
    function t(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        }, c = [
            "width",
            "height",
            "cornerRadius"
        ];
        for (let u of c)u in l && u in a && a[u] !== void 0 && Object.assign(l, {
            [u]: a[u]
        });
        return l;
    }
    function e(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        };
        return "fill" in l && "fill" in a && a.fill !== void 0 && Object.assign(l, {
            fill: {
                ...l.fill,
                ...a.fill
            }
        }), "stroke" in l && "stroke" in a && a.stroke !== void 0 && Object.assign(l, {
            stroke: {
                ...l.stroke,
                ...a.stroke
            }
        }), "layerBlur" in l && "layerBlur" in a && a.layerBlur !== void 0 && Object.assign(l, {
            layerBlur: {
                ...l.layerBlur,
                ...a.layerBlur
            }
        }), "backgroundBlur" in l && "backgroundBlur" in a && a.backgroundBlur !== void 0 && Object.assign(l, {
            backgroundBlur: {
                ...l.backgroundBlur,
                ...a.backgroundBlur
            }
        }), "dropShadow" in l && "dropShadow" in a && a.dropShadow !== void 0 && Object.assign(l, {
            dropShadow: {
                ...l.dropShadow,
                ...a.dropShadow
            }
        }), "innerShadow" in l && "innerShadow" in a && a.innerShadow !== void 0 && Object.assign(l, {
            innerShadow: {
                ...l.innerShadow,
                ...a.innerShadow
            }
        }), l;
    }
    function r(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        };
        return Object.assign(l, s0.merge(l, a)), l = t(l, a), l = e(l, a), l;
    }
    s.patch = r;
    function i(o, a) {
        let l, c = [];
        for (let [u, h] of Object.entries(a))u !== "name" && (l === void 0 && (l = {
            path: [],
            props: {},
            type: 0
        }, c.push(l)), l.props[u] = h);
        return c;
    }
    s.toOps = i;
})(Ea || (Ea = {}));
var Yp;
((t)=>t.defaultData = {
        ...s0.defaultData,
        ...QA.defaultData,
        states: new ke,
        events: new ke,
        visible: !0,
        raycastLock: !1
    })(Yp || (Yp = {}));
var $h;
((t)=>t.defaultData = {
        ...Yp.defaultData,
        ...o0.defaultData
    })($h || ($h = {}));
var a0;
((t)=>t.defaultData = {
        cornerRadius: [
            0,
            0,
            0,
            0
        ]
    })(a0 || (a0 = {}));
var ZA;
((t)=>t.defaultData = {
        ...$h.defaultData,
        type: "ellipse2d",
        width: 100,
        height: 100,
        name: "Ellipse"
    })(ZA || (ZA = {}));
var ed;
((t)=>t.defaultData = {
        ...$h.defaultData,
        ...a0.defaultData,
        type: "rectangle2d",
        width: 100,
        height: 100,
        name: "Rectangle"
    })(ed || (ed = {}));
var JA;
((t)=>t.defaultData = {
        ...$h.defaultData,
        type: "text2d",
        width: 100,
        height: 100,
        fontSize: 12,
        lineHeight: 1.2,
        letterSpacing: 0,
        text: {
            textValue: "Hello world"
        },
        horizontalAlign: 1,
        verticalAlign: 1,
        textTransform: 1,
        font: "Roboto_regular",
        name: "Text"
    })(JA || (JA = {}));
var $A;
((t)=>t.defaultData = {
        ...$h.defaultData,
        type: "path2d",
        path: "",
        name: "Path"
    })($A || ($A = {}));
var ND;
((t)=>{
    function n1(e) {
        return e.type === "ellipse2d" || e.type === "rectangle2d" || e.type === "text2d" || e.type === "vector2d" || e.type === "path2d";
    }
    t.is = n1;
})(ND || (ND = {}));
var Xp;
((t)=>t.defaultData = {
        ...Yp.defaultData,
        name: "Group",
        type: "group2d"
    })(Xp || (Xp = {}));
var e1;
((t)=>t.defaultData = ()=>({
            ...Yp.defaultData,
            ...a0.defaultData,
            ...o0.defaultData,
            name: "Frame",
            type: "frame2d",
            clipped: !0,
            width: 200,
            height: 200,
            fill: {
                color: bt.fromHexAndA(4737101, 1),
                enabled: !0
            },
            stroke: {
                color: bt.fromHexAndA(0, 1),
                thickness: 1,
                enabled: !1,
                mode: "inside"
            },
            backgroundBlur: {
                radius: 2,
                enabled: !1
            },
            layerBlur: {
                radius: 2,
                enabled: !1
            }
        }))(e1 || (e1 = {}));
var Ta;
((s)=>{
    function n1(o) {
        switch(o){
            case "rectangle2d":
                return {
                    ...ed.defaultData
                };
            case "ellipse2d":
                return {
                    ...ZA.defaultData
                };
            case "text2d":
                return {
                    ...JA.defaultData
                };
            case "vector2d":
                return {
                    ...ed.defaultData
                };
            case "path2d":
                return {
                    ...$A.defaultData
                };
            case "frame2d":
                return {
                    ...e1.defaultData()
                };
            case "group2d":
                return {
                    ...Xp.defaultData
                };
        }
    }
    s.defaultData = n1;
    function t(o) {
        return "width" in o && "height" in o ? [
            typeof o.width == "number" ? o.width * .5 : 0,
            typeof o.height == "number" ? o.height * .5 : 0
        ] : [
            0,
            0
        ];
    }
    s.getPivot = t;
    function e(o) {
        return o.type === "rectangle2d" || o.type === "ellipse2d" || o.type === "text2d" || o.type === "frame2d";
    }
    s.isResizeable = e;
    function r(o) {
        return o.type === "frame2d" && o.autoLayout !== void 0;
    }
    s.isAutoLayoutable = r;
    function i(o) {
        return o.type === "rectangle2d" || o.type === "frame2d";
    }
    s.hasCorners = i;
})(Ta || (Ta = {}));
var l0;
((e)=>(e.defaultData = {
        name: "UI",
        type: "scene2d",
        objects: new gr
    }, e.emptyData = function() {
        return {
            type: "scene2d",
            objects: new gr
        };
    }))(l0 || (l0 = {}));
function Gs(n1, t = !1) {
    let e = n1[0].index !== null, r = new Set(Object.keys(n1[0].attributes)), i = new Set(Object.keys(n1[0].morphAttributes)), s = {}, o = {}, a = n1[0].morphTargetsRelative, l = new _e, c = 0;
    for(let u = 0; u < n1.length; ++u){
        let h = n1[u], d = 0;
        if (e !== (h.index !== null)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
        for(let f in h.attributes){
            if (!r.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u + '. All geometries must have compatible attributes; make sure "' + f + '" attribute exists among all geometries, or in none of them.'), null;
            s[f] === void 0 && (s[f] = []), s[f].push(h.attributes[f]), d++;
        }
        if (d !== r.size) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u + ". Make sure all geometries have the same number of attributes."), null;
        if (a !== h.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
        for(let f in h.morphAttributes){
            if (!i.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u + ".  .morphAttributes must be consistent throughout all geometries."), null;
            o[f] === void 0 && (o[f] = []), o[f].push(h.morphAttributes[f]);
        }
        if (t) {
            let f;
            if (e) f = h.index.count;
            else if (h.attributes.position !== void 0) f = h.attributes.position.count;
            else return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u + ". The geometry must have either an index or a position attribute"), null;
            l.addGroup(c, f, u), c += f;
        }
    }
    if (e) {
        let u = 0, h = [];
        for(let d = 0; d < n1.length; ++d){
            let f = n1[d].index;
            for(let p = 0; p < f.count; ++p)h.push(f.getX(p) + u);
            u += n1[d].attributes.position.count;
        }
        l.setIndex(h);
    }
    for(let u in s){
        let h = FD(s[u]);
        if (!h) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + u + " attribute."), null;
        l.setAttribute(u, h);
    }
    for(let u in o){
        let h = o[u][0].length;
        if (h === 0) break;
        l.morphAttributes = l.morphAttributes || {}, l.morphAttributes[u] = [];
        for(let d = 0; d < h; ++d){
            let f = [];
            for(let m = 0; m < o[u].length; ++m)f.push(o[u][m][d]);
            let p = FD(f);
            if (!p) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + u + " morphAttribute."), null;
            l.morphAttributes[u].push(p);
        }
    }
    return l;
}
function FD(n1) {
    let t, e, r, i = 0;
    for(let a = 0; a < n1.length; ++a){
        let l = n1[a];
        if (l.isInterleavedBufferAttribute) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported."), null;
        if (t === void 0 && (t = l.array.constructor), t !== l.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
        if (e === void 0 && (e = l.itemSize), e !== l.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
        if (r === void 0 && (r = l.normalized), r !== l.normalized) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
        i += l.array.length;
    }
    let s = new t(i), o = 0;
    for(let a = 0; a < n1.length; ++a)s.set(n1[a].array, o), o += n1[a].array.length;
    return new Xe(s, e, r);
}
var VD = Math.pow(2, -24);
var Nc = class {
    constructor(){}
};
function fs(n1, t, e) {
    return e.min.x = t[n1], e.min.y = t[n1 + 1], e.min.z = t[n1 + 2], e.max.x = t[n1 + 3], e.max.y = t[n1 + 4], e.max.z = t[n1 + 5], e;
}
function t1(n1) {
    let t = -1, e = -1 / 0;
    for(let r = 0; r < 3; r++){
        let i = n1[r + 3] - n1[r];
        i > e && (e = i, t = r);
    }
    return t;
}
function r1(n1, t) {
    t.set(n1);
}
function i1(n1, t, e) {
    let r, i;
    for(let s = 0; s < 3; s++){
        let o = s + 3;
        r = n1[s], i = t[s], e[s] = r < i ? r : i, r = n1[o], i = t[o], e[o] = r > i ? r : i;
    }
}
function Kp(n1, t, e) {
    for(let r = 0; r < 3; r++){
        let i = t[n1 + 2 * r], s = t[n1 + 2 * r + 1], o = i - s, a = i + s;
        o < e[r] && (e[r] = o), a > e[r + 3] && (e[r + 3] = a);
    }
}
function td(n1) {
    let t = n1[3] - n1[0], e = n1[4] - n1[1], r = n1[5] - n1[2];
    return 2 * (t * e + e * r + r * t);
}
function e7(n1, t) {
    if (!n1.index) {
        let e = n1.attributes.position.count, r = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, i;
        e > 65535 ? i = new Uint32Array(new r(4 * e)) : i = new Uint16Array(new r(2 * e)), n1.setIndex(new Xe(i, 1));
        for(let s = 0; s < e; s++)i[s] = s;
    }
}
function t7(n1) {
    if (!n1.groups || !n1.groups.length) return [
        {
            offset: 0,
            count: n1.index.count / 3
        }
    ];
    let t = [], e = new Set;
    for (let i of n1.groups)e.add(i.start), e.add(i.start + i.count);
    let r = Array.from(e.values()).sort((i, s)=>i - s);
    for(let i = 0; i < r.length - 1; i++){
        let s = r[i], o = r[i + 1];
        t.push({
            offset: s / 3,
            count: (o - s) / 3
        });
    }
    return t;
}
function s1(n1, t, e, r, i = null) {
    let s = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, c = -1 / 0, u = -1 / 0, h = 1 / 0, d = 1 / 0, f = 1 / 0, p = -1 / 0, m = -1 / 0, g = -1 / 0, y = i !== null;
    for(let x = t * 6, v = (t + e) * 6; x < v; x += 6){
        let S = n1[x + 0], w = n1[x + 1], A = S - w, T = S + w;
        A < s && (s = A), T > l && (l = T), y && S < h && (h = S), y && S > p && (p = S);
        let b = n1[x + 2], M = n1[x + 3], C = b - M, P = b + M;
        C < o && (o = C), P > c && (c = P), y && b < d && (d = b), y && b > m && (m = b);
        let I = n1[x + 4], _ = n1[x + 5], D = I - _, L = I + _;
        D < a && (a = D), L > u && (u = L), y && I < f && (f = I), y && I > g && (g = I);
    }
    r[0] = s, r[1] = o, r[2] = a, r[3] = l, r[4] = c, r[5] = u, y && (i[0] = h, i[1] = d, i[2] = f, i[3] = p, i[4] = m, i[5] = g);
}
function r7(n1, t, e, r) {
    let i = 1 / 0, s = 1 / 0, o = 1 / 0, a = -1 / 0, l = -1 / 0, c = -1 / 0;
    for(let u = t * 6, h = (t + e) * 6; u < h; u += 6){
        let d = n1[u + 0];
        d < i && (i = d), d > a && (a = d);
        let f = n1[u + 2];
        f < s && (s = f), f > l && (l = f);
        let p = n1[u + 4];
        p < o && (o = p), p > c && (c = p);
    }
    r[0] = i, r[1] = s, r[2] = o, r[3] = a, r[4] = l, r[5] = c;
}
function i7(n1, t, e, r, i) {
    let s = e, o = e + r - 1, a = i.pos, l = i.axis * 2;
    for(;;){
        for(; s <= o && t[s * 6 + l] < a;)s++;
        for(; s <= o && t[o * 6 + l] >= a;)o--;
        if (s < o) {
            for(let c = 0; c < 3; c++){
                let u = n1[s * 3 + c];
                n1[s * 3 + c] = n1[o * 3 + c], n1[o * 3 + c] = u;
                let h = t[s * 6 + c * 2 + 0];
                t[s * 6 + c * 2 + 0] = t[o * 6 + c * 2 + 0], t[o * 6 + c * 2 + 0] = h;
                let d = t[s * 6 + c * 2 + 1];
                t[s * 6 + c * 2 + 1] = t[o * 6 + c * 2 + 1], t[o * 6 + c * 2 + 1] = d;
            }
            s++, o--;
        } else return s;
    }
}
var Ma = 32, n7 = (n1, t)=>n1.candidate - t.candidate, _l = new Array(Ma).fill().map(()=>({
        count: 0,
        bounds: new Float32Array(6),
        rightCacheBounds: new Float32Array(6),
        leftCacheBounds: new Float32Array(6),
        candidate: 0
    })), c0 = new Float32Array(6);
function s7(n1, t, e, r, i, s) {
    let o = -1, a = 0;
    if (s === 0) o = t1(t), o !== -1 && (a = (t[o] + t[o + 3]) / 2);
    else if (s === 1) o = t1(n1), o !== -1 && (a = o7(e, r, i, o));
    else if (s === 2) {
        let l = td(n1), c = 1.25 * i, u = r * 6, h = (r + i) * 6;
        for(let d = 0; d < 3; d++){
            let f = t[d], g = (t[d + 3] - f) / Ma;
            if (i < Ma / 4) {
                let y = [
                    ..._l
                ];
                y.length = i;
                let x = 0;
                for(let S = u; S < h; S += 6, x++){
                    let w = y[x];
                    w.candidate = e[S + 2 * d], w.count = 0;
                    let { bounds: A, leftCacheBounds: T, rightCacheBounds: b } = w;
                    for(let M = 0; M < 3; M++)b[M] = 1 / 0, b[M + 3] = -1 / 0, T[M] = 1 / 0, T[M + 3] = -1 / 0, A[M] = 1 / 0, A[M + 3] = -1 / 0;
                    Kp(S, e, A);
                }
                y.sort(n7);
                let v = i;
                for(let S = 0; S < v; S++){
                    let w = y[S];
                    for(; S + 1 < v && y[S + 1].candidate === w.candidate;)y.splice(S + 1, 1), v--;
                }
                for(let S = u; S < h; S += 6){
                    let w = e[S + 2 * d];
                    for(let A = 0; A < v; A++){
                        let T = y[A];
                        w >= T.candidate ? Kp(S, e, T.rightCacheBounds) : (Kp(S, e, T.leftCacheBounds), T.count++);
                    }
                }
                for(let S = 0; S < v; S++){
                    let w = y[S], A = w.count, T = i - w.count, b = w.leftCacheBounds, M = w.rightCacheBounds, C = 0;
                    A !== 0 && (C = td(b) / l);
                    let P = 0;
                    T !== 0 && (P = td(M) / l);
                    let I = 1 + 1.25 * (C * A + P * T);
                    I < c && (o = d, c = I, a = w.candidate);
                }
            } else {
                for(let v = 0; v < Ma; v++){
                    let S = _l[v];
                    S.count = 0, S.candidate = f + g + v * g;
                    let w = S.bounds;
                    for(let A = 0; A < 3; A++)w[A] = 1 / 0, w[A + 3] = -1 / 0;
                }
                for(let v = u; v < h; v += 6){
                    let A = ~~((e[v + 2 * d] - f) / g);
                    A >= Ma && (A = Ma - 1);
                    let T = _l[A];
                    T.count++, Kp(v, e, T.bounds);
                }
                let y = _l[Ma - 1];
                r1(y.bounds, y.rightCacheBounds);
                for(let v = Ma - 2; v >= 0; v--){
                    let S = _l[v], w = _l[v + 1];
                    i1(S.bounds, w.rightCacheBounds, S.rightCacheBounds);
                }
                let x = 0;
                for(let v = 0; v < Ma - 1; v++){
                    let S = _l[v], w = S.count, A = S.bounds, b = _l[v + 1].rightCacheBounds;
                    w !== 0 && (x === 0 ? r1(A, c0) : i1(A, c0, c0)), x += w;
                    let M = 0, C = 0;
                    x !== 0 && (M = td(c0) / l);
                    let P = i - x;
                    P !== 0 && (C = td(b) / l);
                    let I = 1 + 1.25 * (M * x + C * P);
                    I < c && (o = d, c = I, a = S.candidate);
                }
            }
        }
    } else console.warn(`MeshBVH: Invalid build strategy value ${s} used.`);
    return {
        axis: o,
        pos: a
    };
}
function o7(n1, t, e, r) {
    let i = 0;
    for(let s = t, o = t + e; s < o; s++)i += n1[s * 6 + r * 2];
    return i / e;
}
function a7(n1, t) {
    let e = n1.attributes.position, r = n1.index.array, i = r.length / 3, s = new Float32Array(i * 6), o = e.normalized, a = e.array, l = e.offset || 0, c = 3;
    e.isInterleavedBufferAttribute && (c = e.data.stride);
    let u = [
        "getX",
        "getY",
        "getZ"
    ];
    for(let h = 0; h < i; h++){
        let d = h * 3, f = h * 6, p, m, g;
        o ? (p = r[d + 0], m = r[d + 1], g = r[d + 2]) : (p = r[d + 0] * c + l, m = r[d + 1] * c + l, g = r[d + 2] * c + l);
        for(let y = 0; y < 3; y++){
            let x, v, S;
            o ? (x = e[u[y]](p), v = e[u[y]](m), S = e[u[y]](g)) : (x = a[p + y], v = a[m + y], S = a[g + y]);
            let w = x;
            v < w && (w = v), S < w && (w = S);
            let A = x;
            v > A && (A = v), S > A && (A = S);
            let T = (A - w) / 2, b = y * 2;
            s[f + b + 0] = w + T, s[f + b + 1] = T + (Math.abs(w) + T) * VD, w < t[y] && (t[y] = w), A > t[y + 3] && (t[y + 3] = A);
        }
    }
    return s;
}
function l7(n1, t) {
    function e(y) {
        d && d(y / f);
    }
    function r(y, x, v, S = null, w = 0) {
        if (!p && w >= l && (p = !0, c && (console.warn(`MeshBVH: Max depth of ${l} reached when generating BVH. Consider increasing maxDepth.`), console.warn(n1))), v <= u || w >= l) return e(x + v), y.offset = x, y.count = v, y;
        let A = s7(y.boundingData, S, o, x, v, h);
        if (A.axis === -1) return e(x + v), y.offset = x, y.count = v, y;
        let T = i7(a, o, x, v, A);
        if (T === x || T === x + v) e(x + v), y.offset = x, y.count = v;
        else {
            y.splitAxis = A.axis;
            let b = new Nc, M = x, C = T - x;
            y.left = b, b.boundingData = new Float32Array(6), s1(o, M, C, b.boundingData, s), r(b, M, C, s, w + 1);
            let P = new Nc, I = T, _ = v - C;
            y.right = P, P.boundingData = new Float32Array(6), s1(o, I, _, P.boundingData, s), r(P, I, _, s, w + 1);
        }
        return y;
    }
    e7(n1, t);
    let i = new Float32Array(6), s = new Float32Array(6), o = a7(n1, i), a = n1.index.array, l = t.maxDepth, c = t.verbose, u = t.maxLeafTris, h = t.strategy, d = t.onProgress, f = n1.index.count / 3, p = !1, m = [], g = t7(n1);
    if (g.length === 1) {
        let y = g[0], x = new Nc;
        x.boundingData = i, r7(o, y.offset, y.count, s), r(x, y.offset, y.count, s), m.push(x);
    } else for (let y of g){
        let x = new Nc;
        x.boundingData = new Float32Array(6), s1(o, y.offset, y.count, x.boundingData, s), r(x, y.offset, y.count, s), m.push(x);
    }
    return m;
}
function zD(n1, t) {
    let e = l7(n1, t), r, i, s, o = [], a = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    for(let u = 0; u < e.length; u++){
        let h = e[u], d = l(h), f = new a(32 * d);
        r = new Float32Array(f), i = new Uint32Array(f), s = new Uint16Array(f), c(0, h), o.push(f);
    }
    return o;
    function l(u) {
        return u.count ? 1 : 1 + l(u.left) + l(u.right);
    }
    function c(u, h) {
        let d = u / 4, f = u / 2, p = !!h.count, m = h.boundingData;
        for(let g = 0; g < 6; g++)r[d + g] = m[g];
        if (p) {
            let g = h.offset, y = h.count;
            return i[d + 6] = g, s[f + 14] = y, s[f + 15] = 65535, u + 32;
        } else {
            let g = h.left, y = h.right, x = h.splitAxis, v;
            if (v = c(u + 32, g), v / 4 > Math.pow(2, 32)) throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
            return i[d + 6] = v / 4, v = c(v, y), i[d + 7] = x, v;
        }
    }
}
var In = class {
    constructor(){
        this.min = 1 / 0, this.max = -1 / 0;
    }
    setFromPointsField(t, e) {
        let r = 1 / 0, i = -1 / 0;
        for(let s = 0, o = t.length; s < o; s++){
            let l = t[s][e];
            r = l < r ? l : r, i = l > i ? l : i;
        }
        this.min = r, this.max = i;
    }
    setFromPoints(t, e) {
        let r = 1 / 0, i = -1 / 0;
        for(let s = 0, o = e.length; s < o; s++){
            let a = e[s], l = t.dot(a);
            r = l < r ? l : r, i = l > i ? l : i;
        }
        this.min = r, this.max = i;
    }
    isSeparated(t) {
        return this.min > t.max || t.min > this.max;
    }
};
In.prototype.setFromBox = function() {
    let n1 = new E;
    return function(e, r) {
        let i = r.min, s = r.max, o = 1 / 0, a = -1 / 0;
        for(let l = 0; l <= 1; l++)for(let c = 0; c <= 1; c++)for(let u = 0; u <= 1; u++){
            n1.x = i.x * l + s.x * (1 - l), n1.y = i.y * c + s.y * (1 - c), n1.z = i.z * u + s.z * (1 - u);
            let h = e.dot(n1);
            o = Math.min(h, o), a = Math.max(h, a);
        }
        this.min = o, this.max = a;
    };
}();
var ume = function() {
    let n1 = new In;
    return function(e, r) {
        let i = e.points, s = e.satAxes, o = e.satBounds, a = r.points, l = r.satAxes, c = r.satBounds;
        for(let u = 0; u < 3; u++){
            let h = o[u], d = s[u];
            if (n1.setFromPoints(d, a), h.isSeparated(n1)) return !1;
        }
        for(let u = 0; u < 3; u++){
            let h = c[u], d = l[u];
            if (n1.setFromPoints(d, i), h.isSeparated(n1)) return !1;
        }
    };
}();
var c7 = function() {
    let n1 = new E, t = new E, e = new E;
    return function(i, s, o) {
        let a = i.start, l = n1, c = s.start, u = t;
        e.subVectors(a, c), n1.subVectors(i.end, i.start), t.subVectors(s.end, s.start);
        let h = e.dot(u), d = u.dot(l), f = u.dot(u), p = e.dot(l), g = l.dot(l) * f - d * d, y, x;
        g !== 0 ? y = (h * d - p * f) / g : y = 0, x = (h + y * d) / f, o.x = y, o.y = x;
    };
}(), Qp = function() {
    let n1 = new k, t = new E, e = new E;
    return function(i, s, o, a) {
        c7(i, s, n1);
        let l = n1.x, c = n1.y;
        if (l >= 0 && l <= 1 && c >= 0 && c <= 1) {
            i.at(l, o), s.at(c, a);
            return;
        } else if (l >= 0 && l <= 1) {
            c < 0 ? s.at(0, a) : s.at(1, a), i.closestPointToPoint(a, !0, o);
            return;
        } else if (c >= 0 && c <= 1) {
            l < 0 ? i.at(0, o) : i.at(1, o), s.closestPointToPoint(o, !0, a);
            return;
        } else {
            let u;
            l < 0 ? u = i.start : u = i.end;
            let h;
            c < 0 ? h = s.start : h = s.end;
            let d = t, f = e;
            if (i.closestPointToPoint(h, !0, t), s.closestPointToPoint(u, !0, e), d.distanceToSquared(h) <= f.distanceToSquared(u)) {
                o.copy(d), a.copy(h);
                return;
            } else {
                o.copy(u), a.copy(f);
                return;
            }
        }
    };
}(), GD = function() {
    let n1 = new E, t = new E, e = new kr, r = new Ti;
    return function(s, o) {
        let { radius: a, center: l } = s, { a: c, b: u, c: h } = o;
        if (r.start = c, r.end = u, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a || (r.start = c, r.end = h, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a) || (r.start = u, r.end = h, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a)) return !0;
        let m = o.getPlane(e);
        if (Math.abs(m.distanceToPoint(l)) <= a) {
            let y = m.projectPoint(l, t);
            if (o.containsPoint(y)) return !0;
        }
        return !1;
    };
}();
var u7 = 1e-15;
function rd(n1) {
    return Math.abs(n1) < u7;
}
var Dn = class extends Cr {
    constructor(...t){
        super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(()=>new E), this.satBounds = new Array(4).fill().map(()=>new In), this.points = [
            this.a,
            this.b,
            this.c
        ], this.sphere = new Rr, this.plane = new kr, this.needsUpdate = !0;
    }
    intersectsSphere(t) {
        return GD(t, this);
    }
    update() {
        let t = this.a, e = this.b, r = this.c, i = this.points, s = this.satAxes, o = this.satBounds, a = s[0], l = o[0];
        this.getNormal(a), l.setFromPoints(a, i);
        let c = s[1], u = o[1];
        c.subVectors(t, e), u.setFromPoints(c, i);
        let h = s[2], d = o[2];
        h.subVectors(e, r), d.setFromPoints(h, i);
        let f = s[3], p = o[3];
        f.subVectors(r, t), p.setFromPoints(f, i), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(a, t), this.needsUpdate = !1;
    }
};
Dn.prototype.closestPointToSegment = function() {
    let n1 = new E, t = new E, e = new Ti;
    return function(i, s = null, o = null) {
        let { start: a, end: l } = i, c = this.points, u, h = 1 / 0;
        for(let d = 0; d < 3; d++){
            let f = (d + 1) % 3;
            e.start.copy(c[d]), e.end.copy(c[f]), Qp(e, i, n1, t), u = n1.distanceToSquared(t), u < h && (h = u, s && s.copy(n1), o && o.copy(t));
        }
        return this.closestPointToPoint(a, n1), u = a.distanceToSquared(n1), u < h && (h = u, s && s.copy(n1), o && o.copy(a)), this.closestPointToPoint(l, n1), u = l.distanceToSquared(n1), u < h && (h = u, s && s.copy(n1), o && o.copy(l)), Math.sqrt(h);
    };
}();
Dn.prototype.intersectsTriangle = function() {
    let n1 = new Dn, t = new Array(3), e = new Array(3), r = new In, i = new In, s = new E, o = new E, a = new E, l = new E, c = new Ti, u = new Ti, h = new Ti;
    return function(f, p = null, m = !1) {
        this.needsUpdate && this.update(), f.isExtendedTriangle ? f.needsUpdate && f.update() : (n1.copy(f), n1.update(), f = n1);
        let g = this.plane, y = f.plane;
        if (Math.abs(g.normal.dot(y.normal)) > 1 - 1e-10) {
            let x = this.satBounds, v = this.satAxes;
            e[0] = f.a, e[1] = f.b, e[2] = f.c;
            for(let A = 0; A < 4; A++){
                let T = x[A], b = v[A];
                if (r.setFromPoints(b, e), T.isSeparated(r)) return !1;
            }
            let S = f.satBounds, w = f.satAxes;
            t[0] = this.a, t[1] = this.b, t[2] = this.c;
            for(let A = 0; A < 4; A++){
                let T = S[A], b = w[A];
                if (r.setFromPoints(b, t), T.isSeparated(r)) return !1;
            }
            for(let A = 0; A < 4; A++){
                let T = v[A];
                for(let b = 0; b < 4; b++){
                    let M = w[b];
                    if (s.crossVectors(T, M), r.setFromPoints(s, t), i.setFromPoints(s, e), r.isSeparated(i)) return !1;
                }
            }
            return p && (m || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), p.start.set(0, 0, 0), p.end.set(0, 0, 0)), !0;
        } else {
            let x = this.points, v = !1, S = 0;
            for(let D = 0; D < 3; D++){
                let L = x[D], j = x[(D + 1) % 3];
                c.start.copy(L), c.end.copy(j), c.delta(o);
                let V = v ? u.start : u.end, H = rd(y.distanceToPoint(L));
                if (rd(y.normal.dot(o)) && H) {
                    u.copy(c), S = 2;
                    break;
                }
                if ((y.intersectLine(c, V) || H) && !rd(V.distanceTo(j))) {
                    if (S++, v) break;
                    v = !0;
                }
            }
            if (S === 1 && f.containsPoint(u.end)) return p && (p.start.copy(u.end), p.end.copy(u.end)), !0;
            if (S !== 2) return !1;
            let w = f.points, A = !1, T = 0;
            for(let D = 0; D < 3; D++){
                let L = w[D], j = w[(D + 1) % 3];
                c.start.copy(L), c.end.copy(j), c.delta(a);
                let V = A ? h.start : h.end, H = rd(g.distanceToPoint(L));
                if (rd(g.normal.dot(a)) && H) {
                    h.copy(c), T = 2;
                    break;
                }
                if ((g.intersectLine(c, V) || H) && !rd(V.distanceTo(j))) {
                    if (T++, A) break;
                    A = !0;
                }
            }
            if (T === 1 && this.containsPoint(h.end)) return p && (p.start.copy(h.end), p.end.copy(h.end)), !0;
            if (T !== 2) return !1;
            if (u.delta(o), h.delta(a), o.dot(a) < 0) {
                let D = h.start;
                h.start = h.end, h.end = D;
            }
            let b = u.start.dot(o), M = u.end.dot(o), C = h.start.dot(o), P = h.end.dot(o), I = M < C, _ = b < P;
            return b !== P && C !== M && I === _ ? !1 : (p && (l.subVectors(u.start, h.start), l.dot(o) > 0 ? p.start.copy(u.start) : p.start.copy(h.start), l.subVectors(u.end, h.end), l.dot(o) < 0 ? p.end.copy(u.end) : p.end.copy(h.end)), !0);
        }
    };
}();
Dn.prototype.distanceToPoint = function() {
    let n1 = new E;
    return function(e) {
        return this.closestPointToPoint(e, n1), e.distanceTo(n1);
    };
}();
Dn.prototype.distanceToTriangle = function() {
    let n1 = new E, t = new E, e = [
        "a",
        "b",
        "c"
    ], r = new Ti, i = new Ti;
    return function(o, a = null, l = null) {
        let c = a || l ? r : null;
        if (this.intersectsTriangle(o, c)) return (a || l) && (a && c.getCenter(a), l && c.getCenter(l)), 0;
        let u = 1 / 0;
        for(let h = 0; h < 3; h++){
            let d, f = e[h], p = o[f];
            this.closestPointToPoint(p, n1), d = p.distanceToSquared(n1), d < u && (u = d, a && a.copy(n1), l && l.copy(p));
            let m = this[f];
            o.closestPointToPoint(m, n1), d = m.distanceToSquared(n1), d < u && (u = d, a && a.copy(m), l && l.copy(n1));
        }
        for(let h = 0; h < 3; h++){
            let d = e[h], f = e[(h + 1) % 3];
            r.set(this[d], this[f]);
            for(let p = 0; p < 3; p++){
                let m = e[p], g = e[(p + 1) % 3];
                i.set(o[m], o[g]), Qp(r, i, n1, t);
                let y = n1.distanceToSquared(t);
                y < u && (u = y, a && a.copy(n1), l && l.copy(t));
            }
        }
        return Math.sqrt(u);
    };
}();
var On = class {
    constructor(t, e, r){
        this.isOrientedBox = !0, this.min = new E, this.max = new E, this.matrix = new ue, this.invMatrix = new ue, this.points = new Array(8).fill().map(()=>new E), this.satAxes = new Array(3).fill().map(()=>new E), this.satBounds = new Array(3).fill().map(()=>new In), this.alignedSatBounds = new Array(3).fill().map(()=>new In), this.needsUpdate = !1, t && this.min.copy(t), e && this.max.copy(e), r && this.matrix.copy(r);
    }
    set(t, e, r) {
        this.min.copy(t), this.max.copy(e), this.matrix.copy(r), this.needsUpdate = !0;
    }
    copy(t) {
        this.min.copy(t.min), this.max.copy(t.max), this.matrix.copy(t.matrix), this.needsUpdate = !0;
    }
};
On.prototype.update = function() {
    return function() {
        let t = this.matrix, e = this.min, r = this.max, i = this.points;
        for(let c = 0; c <= 1; c++)for(let u = 0; u <= 1; u++)for(let h = 0; h <= 1; h++){
            let d = 1 * c | 2 * u | 4 * h, f = i[d];
            f.x = c ? r.x : e.x, f.y = u ? r.y : e.y, f.z = h ? r.z : e.z, f.applyMatrix4(t);
        }
        let s = this.satBounds, o = this.satAxes, a = i[0];
        for(let c = 0; c < 3; c++){
            let u = o[c], h = s[c], d = 1 << c, f = i[d];
            u.subVectors(a, f), h.setFromPoints(u, i);
        }
        let l = this.alignedSatBounds;
        l[0].setFromPointsField(i, "x"), l[1].setFromPointsField(i, "y"), l[2].setFromPointsField(i, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
    };
}();
On.prototype.intersectsBox = function() {
    let n1 = new In;
    return function(e) {
        this.needsUpdate && this.update();
        let r = e.min, i = e.max, s = this.satBounds, o = this.satAxes, a = this.alignedSatBounds;
        if (n1.min = r.x, n1.max = i.x, a[0].isSeparated(n1) || (n1.min = r.y, n1.max = i.y, a[1].isSeparated(n1)) || (n1.min = r.z, n1.max = i.z, a[2].isSeparated(n1))) return !1;
        for(let l = 0; l < 3; l++){
            let c = o[l], u = s[l];
            if (n1.setFromBox(c, e), u.isSeparated(n1)) return !1;
        }
        return !0;
    };
}();
On.prototype.intersectsTriangle = function() {
    let n1 = new Dn, t = new Array(3), e = new In, r = new In, i = new E;
    return function(o) {
        this.needsUpdate && this.update(), o.isExtendedTriangle ? o.needsUpdate && o.update() : (n1.copy(o), n1.update(), o = n1);
        let a = this.satBounds, l = this.satAxes;
        t[0] = o.a, t[1] = o.b, t[2] = o.c;
        for(let d = 0; d < 3; d++){
            let f = a[d], p = l[d];
            if (e.setFromPoints(p, t), f.isSeparated(e)) return !1;
        }
        let c = o.satBounds, u = o.satAxes, h = this.points;
        for(let d = 0; d < 3; d++){
            let f = c[d], p = u[d];
            if (e.setFromPoints(p, h), f.isSeparated(e)) return !1;
        }
        for(let d = 0; d < 3; d++){
            let f = l[d];
            for(let p = 0; p < 4; p++){
                let m = u[p];
                if (i.crossVectors(f, m), e.setFromPoints(i, t), r.setFromPoints(i, h), e.isSeparated(r)) return !1;
            }
        }
        return !0;
    };
}();
On.prototype.closestPointToPoint = function() {
    return function(t, e) {
        return this.needsUpdate && this.update(), e.copy(t).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), e;
    };
}();
On.prototype.distanceToPoint = function() {
    let n1 = new E;
    return function(e) {
        return this.closestPointToPoint(e, n1), e.distanceTo(n1);
    };
}();
On.prototype.distanceToBox = function() {
    let n1 = [
        "x",
        "y",
        "z"
    ], t = new Array(12).fill().map(()=>new Ti), e = new Array(12).fill().map(()=>new Ti), r = new E, i = new E;
    return function(o, a = 0, l = null, c = null) {
        if (this.needsUpdate && this.update(), this.intersectsBox(o)) return (l || c) && (o.getCenter(i), this.closestPointToPoint(i, r), o.closestPointToPoint(r, i), l && l.copy(r), c && c.copy(i)), 0;
        let u = a * a, h = o.min, d = o.max, f = this.points, p = 1 / 0;
        for(let g = 0; g < 8; g++){
            let y = f[g];
            i.copy(y).clamp(h, d);
            let x = y.distanceToSquared(i);
            if (x < p && (p = x, l && l.copy(y), c && c.copy(i), x < u)) return Math.sqrt(x);
        }
        let m = 0;
        for(let g = 0; g < 3; g++)for(let y = 0; y <= 1; y++)for(let x = 0; x <= 1; x++){
            let v = (g + 1) % 3, S = (g + 2) % 3, w = y << v | x << S, A = 1 << g | y << v | x << S, T = f[w], b = f[A];
            t[m].set(T, b);
            let C = n1[g], P = n1[v], I = n1[S], _ = e[m], D = _.start, L = _.end;
            D[C] = h[C], D[P] = y ? h[P] : d[P], D[I] = x ? h[I] : d[P], L[C] = d[C], L[P] = y ? h[P] : d[P], L[I] = x ? h[I] : d[P], m++;
        }
        for(let g = 0; g <= 1; g++)for(let y = 0; y <= 1; y++)for(let x = 0; x <= 1; x++){
            i.x = g ? d.x : h.x, i.y = y ? d.y : h.y, i.z = x ? d.z : h.z, this.closestPointToPoint(i, r);
            let v = i.distanceToSquared(r);
            if (v < p && (p = v, l && l.copy(r), c && c.copy(i), v < u)) return Math.sqrt(v);
        }
        for(let g = 0; g < 12; g++){
            let y = t[g];
            for(let x = 0; x < 12; x++){
                let v = e[x];
                Qp(y, v, r, i);
                let S = r.distanceToSquared(i);
                if (S < p && (p = S, l && l.copy(r), c && c.copy(i), S < u)) return Math.sqrt(S);
            }
        }
        return Math.sqrt(p);
    };
}();
var id = new E, nd = new E, sd = new E, h0 = new k, d0 = new k, f0 = new k, jD = new E, HD = new E, WD = new E, p0 = new E;
function h7(n1, t, e, r, i, s) {
    let o;
    return s === pi ? o = n1.intersectTriangle(r, e, t, !0, i) : o = n1.intersectTriangle(t, e, r, s !== fi, i), o === null ? null : {
        distance: n1.origin.distanceTo(i),
        point: i.clone()
    };
}
function d7(n1, t, e, r, i, s, o, a, l) {
    id.fromBufferAttribute(t, s), nd.fromBufferAttribute(t, o), sd.fromBufferAttribute(t, a);
    let c = h7(n1, id, nd, sd, p0, l);
    if (c) {
        r && (h0.fromBufferAttribute(r, s), d0.fromBufferAttribute(r, o), f0.fromBufferAttribute(r, a), c.uv = Cr.getInterpolation(p0, id, nd, sd, h0, d0, f0, new k)), i && (h0.fromBufferAttribute(i, s), d0.fromBufferAttribute(i, o), f0.fromBufferAttribute(i, a), c.uv1 = Cr.getInterpolation(p0, id, nd, sd, h0, d0, f0, new k)), e && (jD.fromBufferAttribute(e, s), HD.fromBufferAttribute(e, o), WD.fromBufferAttribute(e, a), c.normal = Cr.getInterpolation(p0, id, nd, sd, jD, HD, WD, new E), c.normal.dot(n1.direction) > 0 && c.normal.multiplyScalar(-1));
        let u = {
            a: s,
            b: o,
            c: a,
            normal: new E,
            materialIndex: 0
        };
        Cr.getNormal(id, nd, sd, u.normal), c.face = u, c.faceIndex = s;
    }
    return c;
}
function a1(n1, t, e, r, i) {
    let s = r * 3, o = n1.index.getX(s), a = n1.index.getX(s + 1), l = n1.index.getX(s + 2), { position: c, normal: u, uv: h, uv1: d } = n1.attributes, f = d7(e, c, u, h, d, o, a, l, t);
    return f ? (f.faceIndex = r, i && i.push(f), f) : null;
}
function qD(n1, t, e, r, i, s) {
    for(let o = r, a = r + i; o < a; o++)a1(n1, t, e, o, s);
}
function YD(n1, t, e, r, i) {
    let s = 1 / 0, o = null;
    for(let a = r, l = r + i; a < l; a++){
        let c = a1(n1, t, e, a);
        c && c.distance < s && (o = c, s = c.distance);
    }
    return o;
}
function ps(n1, t, e, r) {
    let i = n1.a, s = n1.b, o = n1.c, a = t, l = t + 1, c = t + 2;
    e && (a = e.getX(t), l = e.getX(t + 1), c = e.getX(t + 2)), i.x = r.getX(a), i.y = r.getY(a), i.z = r.getZ(a), s.x = r.getX(l), s.y = r.getY(l), s.z = r.getZ(l), o.x = r.getX(c), o.y = r.getY(c), o.z = r.getZ(c);
}
function l1(n1, t, e, r, i, s, o) {
    let a = e.index, l = e.attributes.position;
    for(let c = n1, u = t + n1; c < u; c++)if (ps(o, c * 3, a, l), o.needsUpdate = !0, r(o, c, i, s)) return !0;
    return !1;
}
var od = class {
    constructor(t){
        this._getNewPrimitive = t, this._primitives = [];
    }
    getPrimitive() {
        let t = this._primitives;
        return t.length === 0 ? this._getNewPrimitive() : t.pop();
    }
    releasePrimitive(t) {
        this._primitives.push(t);
    }
};
function Ca(n1, t) {
    return t[n1 + 15] === 65535;
}
function Fc(n1, t) {
    return t[n1 + 6];
}
function ad(n1, t) {
    return t[n1 + 14];
}
function ld(n1) {
    return n1 + 8;
}
function cd(n1, t) {
    return t[n1 + 6];
}
function XD(n1, t) {
    return t[n1 + 7];
}
var ud = new Wt, g0 = new E, p7 = [
    "x",
    "y",
    "z"
];
function y0(n1, t, e, r, i) {
    let s = n1 * 2, o = hd, a = Il, l = Dl;
    if (Ca(s, a)) {
        let u = Fc(n1, l), h = ad(s, a);
        qD(t, e, r, u, h, i);
    } else {
        let u = ld(n1);
        x0(u, o, r, g0) && y0(u, t, e, r, i);
        let h = cd(n1, l);
        x0(h, o, r, g0) && y0(h, t, e, r, i);
    }
}
function v0(n1, t, e, r) {
    let i = n1 * 2, s = hd, o = Il, a = Dl;
    if (Ca(i, o)) {
        let c = Fc(n1, a), u = ad(i, o);
        return YD(t, e, r, c, u);
    } else {
        let c = XD(n1, a), u = p7[c], d = r.direction[u] >= 0, f, p;
        d ? (f = ld(n1), p = cd(n1, a)) : (f = cd(n1, a), p = ld(n1));
        let g = x0(f, s, r, g0) ? v0(f, t, e, r) : null;
        if (g) {
            let v = g.point[u];
            if (d ? v <= s[p + c] : v >= s[p + c + 3]) return g;
        }
        let x = x0(p, s, r, g0) ? v0(p, t, e, r) : null;
        return g && x ? g.distance <= x.distance ? g : x : g || x || null;
    }
}
var KD = function() {
    let n1, t, e = [], r = new od(()=>new Wt);
    return function(...o) {
        n1 = r.getPrimitive(), t = r.getPrimitive(), e.push(n1, t);
        let a = i(...o);
        r.releasePrimitive(n1), r.releasePrimitive(t), e.pop(), e.pop();
        let l = e.length;
        return l > 0 && (t = e[l - 1], n1 = e[l - 2]), a;
    };
    function i(s, o, a, l, c = null, u = 0, h = 0) {
        function d(v) {
            let S = v * 2, w = Il, A = Dl;
            for(; !Ca(S, w);)v = ld(v), S = v * 2;
            return Fc(v, A);
        }
        function f(v) {
            let S = v * 2, w = Il, A = Dl;
            for(; !Ca(S, w);)v = cd(v, A), S = v * 2;
            return Fc(v, A) + ad(S, w);
        }
        let p = s * 2, m = hd, g = Il, y = Dl;
        if (Ca(p, g)) {
            let v = Fc(s, y), S = ad(p, g);
            return fs(s, m, n1), l(v, S, !1, h, u + s, n1);
        } else {
            let v = ld(s), S = cd(s, y), w = v, A = S, T, b, M, C;
            if (c && (M = n1, C = t, fs(w, m, M), fs(A, m, C), T = c(M), b = c(C), b < T)) {
                w = S, A = v;
                let V = T;
                T = b, b = V, M = C;
            }
            M || (M = n1, fs(w, m, M));
            let P = Ca(w * 2, g), I = a(M, P, T, h + 1, u + w), _;
            if (I === 2) {
                let V = d(w), W = f(w) - V;
                _ = l(V, W, !0, h + 1, u + w, M);
            } else _ = I && i(w, o, a, l, c, u, h + 1);
            if (_) return !0;
            C = t, fs(A, m, C);
            let D = Ca(A * 2, g), L = a(C, D, b, h + 1, u + A), j;
            if (L === 2) {
                let V = d(A), W = f(A) - V;
                j = l(V, W, !0, h + 1, u + A, C);
            } else j = L && i(A, o, a, l, c, u, h + 1);
            return !!j;
        }
    }
}(), QD = function() {
    let n1 = new Dn, t = new Dn, e = new ue, r = new On, i = new On;
    return function s(o, a, l, c, u = null) {
        let h = o * 2, d = hd, f = Il, p = Dl;
        if (u === null && (l.boundingBox || l.computeBoundingBox(), r.set(l.boundingBox.min, l.boundingBox.max, c), u = r), Ca(h, f)) {
            let g = a, y = g.index, x = g.attributes.position, v = l.index, S = l.attributes.position, w = Fc(o, p), A = ad(h, f);
            if (e.copy(c).invert(), l.boundsTree) return fs(o, d, i), i.matrix.copy(e), i.needsUpdate = !0, l.boundsTree.shapecast({
                intersectsBounds: (b)=>i.intersectsBox(b),
                intersectsTriangle: (b)=>{
                    b.a.applyMatrix4(c), b.b.applyMatrix4(c), b.c.applyMatrix4(c), b.needsUpdate = !0;
                    for(let M = w * 3, C = (A + w) * 3; M < C; M += 3)if (ps(t, M, y, x), t.needsUpdate = !0, b.intersectsTriangle(t)) return !0;
                    return !1;
                }
            });
            for(let T = w * 3, b = A + w * 3; T < b; T += 3){
                ps(n1, T, y, x), n1.a.applyMatrix4(e), n1.b.applyMatrix4(e), n1.c.applyMatrix4(e), n1.needsUpdate = !0;
                for(let M = 0, C = v.count; M < C; M += 3)if (ps(t, M, v, S), t.needsUpdate = !0, n1.intersectsTriangle(t)) return !0;
            }
        } else {
            let g = o + 8, y = p[o + 6];
            return fs(g, d, ud), !!(u.intersectsBox(ud) && s(g, a, l, c, u) || (fs(y, d, ud), u.intersectsBox(ud) && s(y, a, l, c, u)));
        }
    };
}();
function x0(n1, t, e, r) {
    return fs(n1, t, ud), e.intersectBox(ud, r);
}
var c1 = [], m0, hd, Il, Dl;
function dd(n1) {
    m0 && c1.push(m0), m0 = n1, hd = new Float32Array(n1), Il = new Uint16Array(n1), Dl = new Uint32Array(n1);
}
function Zp() {
    m0 = null, hd = null, Il = null, Dl = null, c1.length && dd(c1.pop());
}
var u1 = Symbol("skip tree generation"), h1 = new Wt, d1 = new Wt, fd = new ue, Vc = new On, Jp = new On, $p = new E, b0 = new E, m7 = new E, g7 = new E, y7 = new E, ZD = new Wt, Io = new od(()=>new Dn), Do = class {
    static serialize(t, e = {}) {
        if (e.isBufferGeometry) return console.warn("MeshBVH.serialize: The arguments for the function have changed. See documentation for new signature."), Do.serialize(arguments[0], {
            cloneBuffers: arguments[2] === void 0 ? !0 : arguments[2]
        });
        e = {
            cloneBuffers: !0,
            ...e
        };
        let r = t.geometry, i = t._roots, s = r.getIndex(), o;
        return e.cloneBuffers ? o = {
            roots: i.map((a)=>a.slice()),
            index: s.array.slice()
        } : o = {
            roots: i,
            index: s.array
        }, o;
    }
    static deserialize(t, e, r = {}) {
        if (typeof r == "boolean") return console.warn("MeshBVH.deserialize: The arguments for the function have changed. See documentation for new signature."), Do.deserialize(arguments[0], arguments[1], {
            setIndex: arguments[2] === void 0 ? !0 : arguments[2]
        });
        r = {
            setIndex: !0,
            ...r
        };
        let { index: i, roots: s } = t, o = new Do(e, {
            ...r,
            [u1]: !0
        });
        if (o._roots = s, r.setIndex) {
            let a = e.getIndex();
            if (a === null) {
                let l = new Xe(t.index, 1, !1);
                e.setIndex(l);
            } else a.array !== i && (a.array.set(i), a.needsUpdate = !0);
        }
        return o;
    }
    constructor(t, e = {}){
        if (t.isBufferGeometry) {
            if (t.index && t.index.isInterleavedBufferAttribute) throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
        } else throw new Error("MeshBVH: Only BufferGeometries are supported.");
        if (e = Object.assign({
            strategy: 0,
            maxDepth: 40,
            maxLeafTris: 10,
            verbose: !0,
            useSharedArrayBuffer: !1,
            setBoundingBox: !0,
            onProgress: null,
            [u1]: !1
        }, e), e.useSharedArrayBuffer && typeof SharedArrayBuffer > "u") throw new Error("MeshBVH: SharedArrayBuffer is not available.");
        this._roots = null, e[u1] || (this._roots = zD(t, e), !t.boundingBox && e.setBoundingBox && (t.boundingBox = this.getBoundingBox(new Wt))), this.geometry = t;
    }
    refit(t = null) {
        t && Array.isArray(t) && (t = new Set(t));
        let e = this.geometry, r = e.index.array, i = e.attributes.position, s, o, a, l, c = 0, u = this._roots;
        for(let d = 0, f = u.length; d < f; d++)s = u[d], o = new Uint32Array(s), a = new Uint16Array(s), l = new Float32Array(s), h(0, c), c += s.byteLength;
        function h(d, f, p = !1) {
            let m = d * 2;
            if (a[m + 15] === 65535) {
                let y = o[d + 6], x = a[m + 14], v = 1 / 0, S = 1 / 0, w = 1 / 0, A = -1 / 0, T = -1 / 0, b = -1 / 0;
                for(let M = 3 * y, C = 3 * (y + x); M < C; M++){
                    let P = r[M], I = i.getX(P), _ = i.getY(P), D = i.getZ(P);
                    I < v && (v = I), I > A && (A = I), _ < S && (S = _), _ > T && (T = _), D < w && (w = D), D > b && (b = D);
                }
                return l[d + 0] !== v || l[d + 1] !== S || l[d + 2] !== w || l[d + 3] !== A || l[d + 4] !== T || l[d + 5] !== b ? (l[d + 0] = v, l[d + 1] = S, l[d + 2] = w, l[d + 3] = A, l[d + 4] = T, l[d + 5] = b, !0) : !1;
            } else {
                let y = d + 8, x = o[d + 6], v = y + f, S = x + f, w = p, A = !1, T = !1;
                t ? w || (A = t.has(v), T = t.has(S), w = !A && !T) : (A = !0, T = !0);
                let b = w || A, M = w || T, C = !1;
                b && (C = h(y, f, w));
                let P = !1;
                M && (P = h(x, f, w));
                let I = C || P;
                if (I) for(let _ = 0; _ < 3; _++){
                    let D = y + _, L = x + _, j = l[D], V = l[D + 3], H = l[L], W = l[L + 3];
                    l[d + _] = j < H ? j : H, l[d + _ + 3] = V > W ? V : W;
                }
                return I;
            }
        }
    }
    traverse(t, e = 0) {
        let r = this._roots[e], i = new Uint32Array(r), s = new Uint16Array(r);
        o(0);
        function o(a, l = 0) {
            let c = a * 2, u = s[c + 15] === 65535;
            if (u) {
                let h = i[a + 6], d = s[c + 14];
                t(l, u, new Float32Array(r, a * 4, 6), h, d);
            } else {
                let h = a + 8, d = i[a + 6], f = i[a + 7];
                t(l, u, new Float32Array(r, a * 4, 6), f) || (o(h, l + 1), o(d, l + 1));
            }
        }
    }
    raycast(t, e = Hn) {
        let r = this._roots, i = this.geometry, s = [], o = e.isMaterial, a = Array.isArray(e), l = i.groups, c = o ? e.side : e;
        for(let u = 0, h = r.length; u < h; u++){
            let d = a ? e[l[u].materialIndex].side : c, f = s.length;
            if (dd(r[u]), y0(0, i, d, t, s), Zp(), a) {
                let p = l[u].materialIndex;
                for(let m = f, g = s.length; m < g; m++)s[m].face.materialIndex = p;
            }
        }
        return s;
    }
    raycastFirst(t, e = Hn) {
        let r = this._roots, i = this.geometry, s = e.isMaterial, o = Array.isArray(e), a = null, l = i.groups, c = s ? e.side : e;
        for(let u = 0, h = r.length; u < h; u++){
            let d = o ? e[l[u].materialIndex].side : c;
            dd(r[u]);
            let f = v0(0, i, d, t);
            Zp(), f != null && (a == null || f.distance < a.distance) && (a = f, o && (f.face.materialIndex = l[u].materialIndex));
        }
        return a;
    }
    intersectsGeometry(t, e) {
        let r = this.geometry, i = !1;
        for (let s of this._roots)if (dd(s), i = QD(0, r, t, e), Zp(), i) break;
        return i;
    }
    shapecast(t, e, r) {
        let i = this.geometry;
        if (t instanceof Function) {
            if (e) {
                let d = e;
                e = (f, p, m, g)=>{
                    let y = p * 3;
                    return d(f, y, y + 1, y + 2, m, g);
                };
            }
            t = {
                boundsTraverseOrder: r,
                intersectsBounds: t,
                intersectsTriangle: e,
                intersectsRange: null
            }, console.warn("MeshBVH: Shapecast function signature has changed and now takes an object of callbacks as a second argument. See docs for new signature.");
        }
        let s = Io.getPrimitive(), { boundsTraverseOrder: o, intersectsBounds: a, intersectsRange: l, intersectsTriangle: c } = t;
        if (l && c) {
            let d = l;
            l = (f, p, m, g, y)=>d(f, p, m, g, y) ? !0 : l1(f, p, i, c, m, g, s);
        } else l || (c ? l = (d, f, p, m)=>l1(d, f, i, c, p, m, s) : l = (d, f, p)=>p);
        let u = !1, h = 0;
        for (let d of this._roots){
            if (dd(d), u = KD(0, i, a, l, o, h), Zp(), u) break;
            h += d.byteLength;
        }
        return Io.releasePrimitive(s), u;
    }
    bvhcast(t, e, r) {
        let { intersectsRanges: i, intersectsTriangles: s } = r, o = this.geometry.index, a = this.geometry.attributes.position, l = t.geometry.index, c = t.geometry.attributes.position;
        fd.copy(e).invert();
        let u = Io.getPrimitive(), h = Io.getPrimitive();
        if (s) {
            let f = function(p, m, g, y, x, v, S, w) {
                for(let A = g, T = g + y; A < T; A++){
                    ps(h, A * 3, l, c), h.a.applyMatrix4(e), h.b.applyMatrix4(e), h.c.applyMatrix4(e), h.needsUpdate = !0;
                    for(let b = p, M = p + m; b < M; b++)if (ps(u, b * 3, o, a), u.needsUpdate = !0, s(u, h, b, A, x, v, S, w)) return !0;
                }
                return !1;
            };
            if (i) {
                let p = i;
                i = function(m, g, y, x, v, S, w, A) {
                    return p(m, g, y, x, v, S, w, A) ? !0 : f(m, g, y, x, v, S, w, A);
                };
            } else i = f;
        }
        t.getBoundingBox(d1), d1.applyMatrix4(e);
        let d = this.shapecast({
            intersectsBounds: (f)=>d1.intersectsBox(f),
            intersectsRange: (f, p, m, g, y, x)=>(h1.copy(x), h1.applyMatrix4(fd), t.shapecast({
                    intersectsBounds: (v)=>h1.intersectsBox(v),
                    intersectsRange: (v, S, w, A, T)=>i(f, p, v, S, g, y, A, T)
                }))
        });
        return Io.releasePrimitive(u), Io.releasePrimitive(h), d;
    }
    intersectsBox(t, e) {
        return Vc.set(t.min, t.max, e), Vc.needsUpdate = !0, this.shapecast({
            intersectsBounds: (r)=>Vc.intersectsBox(r),
            intersectsTriangle: (r)=>Vc.intersectsTriangle(r)
        });
    }
    intersectsSphere(t) {
        return this.shapecast({
            intersectsBounds: (e)=>t.intersectsBox(e),
            intersectsTriangle: (e)=>e.intersectsSphere(t)
        });
    }
    closestPointToGeometry(t, e, r = {}, i = {}, s = 0, o = 1 / 0) {
        t.boundingBox || t.computeBoundingBox(), Vc.set(t.boundingBox.min, t.boundingBox.max, e), Vc.needsUpdate = !0;
        let a = this.geometry, l = a.attributes.position, c = a.index, u = t.attributes.position, h = t.index, d = Io.getPrimitive(), f = Io.getPrimitive(), p = b0, m = m7, g = null, y = null;
        i && (g = g7, y = y7);
        let x = 1 / 0, v = null, S = null;
        return fd.copy(e).invert(), Jp.matrix.copy(fd), this.shapecast({
            boundsTraverseOrder: (w)=>Vc.distanceToBox(w),
            intersectsBounds: (w, A, T)=>T < x && T < o ? (A && (Jp.min.copy(w.min), Jp.max.copy(w.max), Jp.needsUpdate = !0), !0) : !1,
            intersectsRange: (w, A)=>{
                if (t.boundsTree) return t.boundsTree.shapecast({
                    boundsTraverseOrder: (T)=>Jp.distanceToBox(T),
                    intersectsBounds: (T, b, M)=>M < x && M < o,
                    intersectsRange: (T, b)=>{
                        for(let M = T * 3, C = (T + b) * 3; M < C; M += 3){
                            ps(f, M, h, u), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                            for(let P = w * 3, I = (w + A) * 3; P < I; P += 3){
                                ps(d, P, c, l), d.needsUpdate = !0;
                                let _ = d.distanceToTriangle(f, p, g);
                                if (_ < x && (m.copy(p), y && y.copy(g), x = _, v = P / 3, S = M / 3), _ < s) return !0;
                            }
                        }
                    }
                });
                {
                    let T = h ? h.count : u.count;
                    for(let b = 0, M = T; b < M; b += 3){
                        ps(f, b, h, u), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                        for(let C = w * 3, P = (w + A) * 3; C < P; C += 3){
                            ps(d, C, c, l), d.needsUpdate = !0;
                            let I = d.distanceToTriangle(f, p, g);
                            if (I < x && (m.copy(p), y && y.copy(g), x = I, v = C / 3, S = b / 3), I < s) return !0;
                        }
                    }
                }
            }
        }), Io.releasePrimitive(d), Io.releasePrimitive(f), x === 1 / 0 ? null : (r.point ? r.point.copy(m) : r.point = m.clone(), r.distance = x, r.faceIndex = v, i && (i.point ? i.point.copy(y) : i.point = y.clone(), i.point.applyMatrix4(fd), m.applyMatrix4(fd), i.distance = m.sub(i.point).length(), i.faceIndex = S), r);
    }
    closestPointToPoint(t, e = {}, r = 0, i = 1 / 0) {
        let s = r * r, o = i * i, a = 1 / 0, l = null;
        if (this.shapecast({
            boundsTraverseOrder: (u)=>($p.copy(t).clamp(u.min, u.max), $p.distanceToSquared(t)),
            intersectsBounds: (u, h, d)=>d < a && d < o,
            intersectsTriangle: (u, h)=>{
                u.closestPointToPoint(t, $p);
                let d = t.distanceToSquared($p);
                return d < a && (b0.copy($p), a = d, l = h), d < s;
            }
        }), a === 1 / 0) return null;
        let c = Math.sqrt(a);
        return e.point ? e.point.copy(b0) : e.point = b0.clone(), e.distance = c, e.faceIndex = l, e;
    }
    getBoundingBox(t) {
        return t.makeEmpty(), this._roots.forEach((r)=>{
            fs(0, new Float32Array(r), ZD), t.union(ZD);
        }), t;
    }
};
var yx = Wa($D());
var v7 = .5 * (Math.sqrt(3) - 1), em = (3 - Math.sqrt(3)) / 6, x7 = 1 / 3, Oo = 1 / 6, ige = (Math.sqrt(5) - 1) / 4, nge = (5 - Math.sqrt(5)) / 20, tm = (n1)=>Math.floor(n1) | 0, eO = new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]), p1 = new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
function tO(n1 = Math.random) {
    let t = iO(n1), e = new Float64Array(t).map((i)=>eO[i % 12 * 2]), r = new Float64Array(t).map((i)=>eO[i % 12 * 2 + 1]);
    return function(s, o) {
        let a = 0, l = 0, c = 0, u = (s + o) * v7, h = tm(s + u), d = tm(o + u), f = (h + d) * em, p = h - f, m = d - f, g = s - p, y = o - m, x, v;
        g > y ? (x = 1, v = 0) : (x = 0, v = 1);
        let S = g - x + em, w = y - v + em, A = g - 1 + 2 * em, T = y - 1 + 2 * em, b = h & 255, M = d & 255, C = .5 - g * g - y * y;
        if (C >= 0) {
            let _ = b + t[M], D = e[_], L = r[_];
            C *= C, a = C * C * (D * g + L * y);
        }
        let P = .5 - S * S - w * w;
        if (P >= 0) {
            let _ = b + x + t[M + v], D = e[_], L = r[_];
            P *= P, l = P * P * (D * S + L * w);
        }
        let I = .5 - A * A - T * T;
        if (I >= 0) {
            let _ = b + 1 + t[M + 1], D = e[_], L = r[_];
            I *= I, c = I * I * (D * A + L * T);
        }
        return 70 * (a + l + c);
    };
}
function rO(n1 = Math.random) {
    let t = iO(n1), e = new Float64Array(t).map((s)=>p1[s % 12 * 3]), r = new Float64Array(t).map((s)=>p1[s % 12 * 3 + 1]), i = new Float64Array(t).map((s)=>p1[s % 12 * 3 + 2]);
    return function(o, a, l) {
        let c, u, h, d, f = (o + a + l) * x7, p = tm(o + f), m = tm(a + f), g = tm(l + f), y = (p + m + g) * Oo, x = p - y, v = m - y, S = g - y, w = o - x, A = a - v, T = l - S, b, M, C, P, I, _;
        w >= A ? A >= T ? (b = 1, M = 0, C = 0, P = 1, I = 1, _ = 0) : w >= T ? (b = 1, M = 0, C = 0, P = 1, I = 0, _ = 1) : (b = 0, M = 0, C = 1, P = 1, I = 0, _ = 1) : A < T ? (b = 0, M = 0, C = 1, P = 0, I = 1, _ = 1) : w < T ? (b = 0, M = 1, C = 0, P = 0, I = 1, _ = 1) : (b = 0, M = 1, C = 0, P = 1, I = 1, _ = 0);
        let D = w - b + Oo, L = A - M + Oo, j = T - C + Oo, V = w - P + 2 * Oo, H = A - I + 2 * Oo, W = T - _ + 2 * Oo, q = w - 1 + 3 * Oo, Q = A - 1 + 3 * Oo, G = T - 1 + 3 * Oo, Z = p & 255, te = m & 255, $ = g & 255, Y = .6 - w * w - A * A - T * T;
        if (Y < 0) c = 0;
        else {
            let J = Z + t[te + t[$]];
            Y *= Y, c = Y * Y * (e[J] * w + r[J] * A + i[J] * T);
        }
        let oe = .6 - D * D - L * L - j * j;
        if (oe < 0) u = 0;
        else {
            let J = Z + b + t[te + M + t[$ + C]];
            oe *= oe, u = oe * oe * (e[J] * D + r[J] * L + i[J] * j);
        }
        let ie = .6 - V * V - H * H - W * W;
        if (ie < 0) h = 0;
        else {
            let J = Z + P + t[te + I + t[$ + _]];
            ie *= ie, h = ie * ie * (e[J] * V + r[J] * H + i[J] * W);
        }
        let re = .6 - q * q - Q * Q - G * G;
        if (re < 0) d = 0;
        else {
            let J = Z + 1 + t[te + 1 + t[$ + 1]];
            re *= re, d = re * re * (e[J] * q + r[J] * Q + i[J] * G);
        }
        return 32 * (c + u + h + d);
    };
}
function iO(n1) {
    let e = new Uint8Array(512);
    for(let r = 0; r < 256; r++)e[r] = r;
    for(let r = 0; r < 255; r++){
        let i = r + ~~(n1() * (256 - r)), s = e[r];
        e[r] = e[i], e[i] = s;
    }
    for(let r = 256; r < 512; r++)e[r] = e[r - 256];
    return e;
}
var js = new Cr, S0 = class {
    constructor(t){
        this.weightAttribute = null;
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.distribution = null;
    }
    build() {
        let t = this.positionAttribute, e = new Float32Array(t.count / 3);
        for(let i = 0; i < t.count; i += 3){
            let s = 1;
            js.a.fromBufferAttribute(t, i), js.b.fromBufferAttribute(t, i + 1), js.c.fromBufferAttribute(t, i + 2), s *= js.getArea(), e[i / 3] = s;
        }
        this.distribution = new Float32Array(t.count / 3);
        let r = 0;
        for(let i = 0; i < e.length; i++)r += e[i], this.distribution[i] = r;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e) {
        if (this.distribution) {
            let r = this.distribution[this.distribution.length - 1], i = this.binarySearch(this.randomFunction() * r);
            return this.sampleFace(i, t, e);
        }
    }
    binarySearch(t) {
        if (!this.distribution) return 0;
        let e = this.distribution, r = 0, i = e.length - 1, s = -1;
        for(; r <= i;){
            let o = Math.ceil((r + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s = o;
                break;
            } else t < e[o] ? i = o - 1 : r = o + 1;
        }
        return s;
    }
    sampleFace(t, e, r) {
        let i = this.randomFunction(), s = this.randomFunction();
        return i + s > 1 && (i = 1 - i, s = 1 - s), js.a.fromBufferAttribute(this.positionAttribute, t * 3), js.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), js.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector(js.a, i).addScaledVector(js.b, s).addScaledVector(js.c, 1 - (i + s)), js.getNormal(r), this;
    }
};
var sO = Wa(m1()), b7 = new ue, S7 = new ue, w7 = new ue, pd;
((t)=>{
    function n1(e) {
        return e && e.__isSPEObject;
    }
    t.is = n1;
})(pd || (pd = {}));
var md = (n1)=>class extends n1 {
        constructor(){
            super(...arguments);
            this.previousModelViewMatrix = new ue;
            this.copyPreviousMatrix = !0;
            this.hiddenMatrix = new ue;
            this.matrixWorldRigid = new ue;
            this.shearScale = new ue;
            this.shearScaleInv = new ue;
        }
        get __isSPEObject() {
            return !0;
        }
        isDescendantOf(r) {
            r instanceof Tt && (r = r.uuid);
            let i = this;
            for(; i.parent;){
                if (i.parent.uuid === r) return !0;
                i = i.parent;
            }
            return !1;
        }
        updateMatrixWorld(r) {
            this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || r) && (this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, r = !0);
            for (let i of this.children)i.updateMatrixWorld(r);
        }
        updateWorldMatrix(r, i) {
            let s = this.parent;
            if (r && s !== null && s.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), i) for (let o of this.children)o.updateWorldMatrix(!1, !0);
        }
        traverseChildren(r, i = 0) {
            for (let s of this.children)pd.is(s) && s.traverseObject(r, i + 1);
        }
        traverseObject(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)pd.is(o) && o.traverseObject(r, i + 1);
        }
        updateMatrixWorldSVD() {
            let r = this.matrixWorld.elements, i = [
                [
                    r[0],
                    r[4],
                    r[8]
                ],
                [
                    r[1],
                    r[5],
                    r[9]
                ],
                [
                    r[2],
                    r[6],
                    r[10]
                ]
            ], { u: s, v: o, q: a } = (0, sO.SVD)(i), l = b7.set(s[0][0], s[0][1], s[0][2], 0, s[1][0], s[1][1], s[1][2], 0, s[2][0], s[2][1], s[2][2], 0, 0, 0, 0, 1), c = S7.set(o[0][0], o[0][1], o[0][2], 0, o[1][0], o[1][1], o[1][2], 0, o[2][0], o[2][1], o[2][2], 0, 0, 0, 0, 1), u = w7.copy(c).transpose();
            this.shearScale.makeScale(a[0], a[1], a[2]).multiply(u).premultiply(c), this.shearScaleInv.copy(this.shearScale).invert(), this.matrixWorldRigid.multiplyMatrices(l, u).copyPosition(this.matrixWorld), a.every((h)=>Math.abs(a[0] - h) < .01) ? this.hasNonUniformScale = !1 : this.hasNonUniformScale = !0;
        }
        attach(r, i) {
            this.updateWorldMatrix(!0, !1);
            let s = new ue().copy(this.matrixWorld).invert();
            return r.parent !== null && (r.parent.updateWorldMatrix(!0, !1), s.multiply(r.parent.matrixWorld)), "hiddenMatrix" in r && r.hiddenMatrix instanceof ue ? r.hiddenMatrix.premultiply(s) : r.applyMatrix4(s), r.updateWorldMatrix(!1, !1), this.add(r), i !== void 0 && (this.children.pop(), this.children.splice(i, 0, r)), this;
        }
        copy(r, i = !1) {
            return super.copy(r, i), this.hasNonUniformScale = r.hasNonUniformScale, this;
        }
        onAfterRender(r, i, s, o, a, l) {
            this.copyPreviousMatrix && this.previousModelViewMatrix.copy(this.modelViewMatrix);
        }
    };
var g1 = class extends md(Tt) {
}, A7 = (n1)=>n1.type === "Mesh", Nr = class extends g1 {
    constructor(e){
        super();
        this.object = e;
        this.matrixAutoUpdate = !1, this.hasNonUniformScale = e.hasNonUniformScale;
    }
    raycast(e, r) {}
    expand() {
        let e = 0, r = this.object.entityChildren(e);
        for(; r;){
            let i = this.children[e];
            i?.object !== r && (i && this.remove(i), i = new Nr(r), this.add(i), this.children.splice(e, 0, this.children.pop()), i.matrixWorldNeedsUpdate = !0, i.matrixAutoUpdate = !1, i.matrix = r.matrix, i.hiddenMatrix = r.hiddenMatrix), i.expand(), e += 1, r = this.object.entityChildren(e);
        }
        for(; this.children.length > e;)this.remove(this.children[e]);
    }
    get visible() {
        return this.playModeVisible !== void 0 ? this.playModeVisible : this.object.visible || this.object.dataPatched.visible && this.object.dataPatched.cloner?.hideBase === !0;
    }
    set visible(e) {}
    get castShadow() {
        return this.object.castShadow;
    }
    set castShadow(e) {}
    get receiveShadow() {
        return this.object.receiveShadow;
    }
    set receiveShadow(e) {}
    get isMesh() {
        return A7(this.object);
    }
    get isLight() {
        return this.object.isLight;
    }
    get layers() {
        return this.object.layers;
    }
    set layers(e) {}
    get isCamera() {
        return !1;
    }
    get geometry() {
        if (this.object.geometry) return this.object.geometry;
    }
    get material() {
        if (this.object.material) return this.object.material;
    }
};
var kc = new E, Uc = new E, gd = new ue, aO = [
    new E(-1, 1, 1),
    new E(-1, -1, 1),
    new E(1, -1, 1),
    new E(1, 1, 1),
    new E(-1, 1, -1),
    new E(-1, -1, -1),
    new E(1, -1, -1),
    new E(1, 1, -1)
], E7 = [
    [
        0,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        6
    ],
    [
        4,
        7
    ],
    [
        0,
        1
    ],
    [
        3,
        2
    ],
    [
        7,
        6
    ],
    [
        4,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        5
    ],
    [
        2,
        6
    ],
    [
        3,
        7
    ]
], T7 = [
    [
        0,
        2
    ],
    [
        7,
        5
    ],
    [
        4,
        1
    ],
    [
        3,
        6
    ],
    [
        4,
        3
    ],
    [
        1,
        6
    ]
], oO = (n1, t, e)=>{
    n1.updateEntityBoxSize(kc, Uc), gd.copy(t).multiply(n1.matrixWorld), Uc.x === 0 && Uc.y === 0 && Uc.z === 0 ? e.push(new E(kc.x, kc.y, kc.z).applyMatrix4(gd)) : aO.forEach((r)=>{
        e.push(r.clone().multiply(Uc).add(kc).applyMatrix4(gd));
    });
}, rm = class extends Wt {
    constructor(){
        super(...arguments);
        this.matrix = new ue;
        this.vertices = [];
        this.faces = [];
        this.edges = [];
        this.centerEdges = [];
    }
    copy(e) {
        return super.copy(e), this.matrix.copy(e.matrix), this.vertices = e.vertices.map((r)=>r.clone()), this.faces = e.faces.map((r)=>r.clone()), this.edges = e.edges.map((r)=>r.clone()), this.centerEdges = e.centerEdges.map((r)=>r.clone()), this;
    }
    setFromObjectSize(e, r = !1) {
        e.updateWorldMatrix(!1, r), this.makeEmpty(), this.matrix.copy(e.matrixWorld);
        let i = new ue().copy(e.matrixWorld).invert();
        return this.expandByObjectSize(e, i, r);
    }
    expandByObjectSize(e, r, i = !1) {
        let s = [];
        return i === !0 ? e.traverseEntity((o)=>{
            if (o.visible || o.cloner && o.data.visible) {
                if (!("geometry" in o)) {
                    s.push(new E);
                    return;
                }
                oO(o, r, s);
            }
        }) : oO(e, r, s), this.setFromPoints(s);
    }
    getCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(this.matrix), e;
    }
    getPositionToCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(gd.copy(this.matrix).setPosition(0, 0, 0)), e;
    }
    computeVertices() {
        this.getSize(Uc).multiplyScalar(.5), this.getCenter(kc), gd.copy(this.matrix).setPosition(kc), this.vertices = aO.map((e)=>e.clone().multiply(Uc).applyMatrix4(gd));
    }
    computeEdges() {
        this.vertices.length > 0 && this.computeVertices(), this.edges = E7.map(([e, r])=>new Ti(this.vertices[e], this.vertices[r])), this.centerEdges = this.edges.map((e)=>e.getCenter(new E));
    }
    computeFaces() {
        this.vertices.length > 0 && this.computeVertices(), this.faces = T7.map(([e, r])=>this.vertices[e].clone().add(this.vertices[r]).multiplyScalar(.5));
    }
};
var Hs = {
    Cloner: ()=>{},
    changeEntityProptotype: ()=>{},
    createEntity: ()=>{}
};
var v1 = class extends yp {
    constructor(){
        super();
    }
    getPoints(t = 12) {
        let e = [], r, i = this.getCurveLengths(), o = i[i.length - 1] / i.length;
        for(let a = 0, l = this.curves; a < l.length; a++){
            let c = l[a], u = a === 0 ? i[a] : i[a] - i[a - 1], h = Math.ceil(t * u / o), d = c.getPoints(h);
            for(let f = 0; f < d.length; f++){
                let p = d[f];
                r && r.equals(p) || (e.push(p), r = p);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
};
var x1 = .001;
function b1(n1, t, e) {
    return t.clone().sub(n1).cross(t.clone().sub(e)).length() <= x1;
}
function y1(n1, t) {
    let e = new E(...n1.position), r = new E(...n1.controlNext.position), i = new E(...t.controlPrevious.position), s = new E(...t.position);
    return b1(e, r, s) && b1(e, i, s);
}
function A0(n1) {
    let t = n1.points.map((u)=>new E(...u.data.position)), e = [
        n1.points[0]
    ], r = new E(...e[0].data.position);
    for(let u = 0; u < n1.points.length - 1; u++)b1(r, t[u], t[u + 1]) || (e.push(n1.points[u]), r = t[u]);
    e.push(n1.points[n1.points.length - 1]);
    let i = n1.isClosed, s = e.length - (i ? 0 : 1), o = e.length, a = [];
    for(let u = 0; u < o; u++){
        let h = e[u].data, d = new E(...h.position), f = new E(...h.controlPrevious.position), p = new E(...h.controlNext.position), m = {
            position: d,
            baseRoundness: h.roundness,
            controlPrevious: f,
            controlNext: p
        };
        if (h.roundness === 0 || !n1.isClosed && (u === 0 || u === o - 1)) {
            a[u] = {
                ...m,
                removedLength: 0
            };
            continue;
        }
        let g = i && u == 0 ? o - 1 : u - 1, y = i && u == o - 1 ? 0 : u + 1, x = e[g].data, v = e[y].data, S = new E(...x.position), w = new E(...v.position), A = S.clone().sub(d).normalize(), T = w.clone().sub(d).normalize();
        Object.assign(m, {
            prevDir: A,
            nextDir: T
        });
        let b = y1(x, h), M = y1(h, v);
        if (!b || !M) a[u] = {
            ...m,
            removedLength: 0
        };
        else {
            let C = A.clone().add(T).normalize(), P = C.clone().cross(A).length() / A.dot(C);
            a[u] = {
                ...m,
                tan: P,
                removedLength: h.roundness / P
            };
        }
    }
    for(let u = 0; u < s; u++){
        let h = u, d = i && u === o - 1 ? 0 : u + 1, f = a[h], p = a[d];
        if (f.removedLength !== 0 || p.removedLength !== 0) {
            let m = f.position.distanceTo(p.position);
            f.removedLength = Math.min(f.removedLength, m / 2), p.removedLength = Math.min(p.removedLength, m / 2);
        }
    }
    let l = [];
    for(let u = 0; u < s; u++){
        let h = u, d = i && u === o - 1 ? 0 : u + 1, f = a[h], p = a[d], m = null;
        if (!y1(e[h].data, e[d].data)) f.position.distanceTo(p.position) > x1 && (m = new wc(f.position, f.controlNext, p.controlPrevious, p.position));
        else {
            let g = f.position.clone(), y = p.position.clone();
            (f.removedLength !== 0 || p.removedLength !== 0) && (f.nextDir && g.add(f.nextDir.clone().setLength(f.removedLength)), p.prevDir && y.add(p.prevDir.clone().setLength(p.removedLength))), g.distanceTo(y) > x1 && (m = new wc(g, g.clone().lerp(y, .3), y.clone().lerp(g, .3), y));
        }
        l[2 * u + 1] = m;
    }
    for(let u = 0; u < o; u++){
        let h = a[u];
        if (h.removedLength === 0) {
            l[2 * u] = null;
            continue;
        }
        let d = h.position, f = h.prevDir.clone().multiplyScalar(h.removedLength).add(d), p = h.nextDir.clone().multiplyScalar(h.removedLength).add(d), m = h.tan * h.removedLength, g = h.prevDir.clone().add(h.nextDir).normalize(), y = f.clone().lerp(p, .5), x = f.distanceTo(p) / 2, v = g.clone().multiplyScalar(Math.sqrt(Math.pow(m, 2) - Math.pow(x, 2))).add(y), S = g.clone().multiplyScalar(-m).add(v), w = d.distanceTo(S) / d.distanceTo(y), A = h.prevDir.clone().multiplyScalar(w * d.distanceTo(f)).add(d), T = A.clone().lerp(S, 2), b = f.clone().lerp(A, 4 / 3), M = p.clone().lerp(T, 4 / 3);
        l[2 * u] = new wc(f, b, M, p);
    }
    let c = new v1;
    return l.forEach((u)=>{
        u && c.add(u);
    }), c;
}
var yt;
((t)=>{
    function n1(e) {
        return e && e.__isEntity;
    }
    t.is = n1;
})(yt || (yt = {}));
var Ro = (n1)=>yt.is(n1), M7 = {
    type: "completeState",
    isfromEntity: !0
}, C7 = [
    "x",
    "y",
    "z"
], S1 = new E, P7 = new E().set(0, 1, 0), yd = (n1)=>class extends md(n1) {
        constructor(){
            super(...arguments);
            this.raycastLock = !1;
            this.scaleLock = !1;
            this.disposed = !1;
            this.stateSelection = null;
            this.destroyedInAction = !1;
            this.instances = [];
            this.prevState = null;
            this.currentState = null;
            this.reversibleToState = null;
            this.currentTransitionEvent = null;
            this.previousAction = null;
            this._singleBBox = new rm;
            this._recursiveBBox = new rm;
            this.singleBBoxNeedsUpdate = !0;
            this.recursiveBBoxNeedsUpdate = !0;
            this._needApplyPathSnapping = !0;
            this.attachedPaths = new Set;
        }
        get __isEntity() {
            return !0;
        }
        entityChildren(r) {
            let i = this.children[r];
            if (yt.is(i)) return i;
        }
        entityChildrenCount() {
            let r = this.children.length;
            for(; r--;)if (yt.is(this.children[r])) return r + 1;
            return 0;
        }
        get isConcreteEntity() {
            return typeof this.identity == "string";
        }
        get isVirtualEntity() {
            return typeof this.identity != "string";
        }
        get isInstanceRoot() {
            return this.isConcreteEntity && this.data.type === "Instance";
        }
        nearestInstanceSelfOrParent() {
            let r = this;
            for(; r.data.type !== "Instance";){
                let i = r.parent;
                if (yt.is(i)) r = i;
                else return;
            }
            return r;
        }
        forInstancesRec(r) {
            this.instances.forEach((i)=>{
                i.disposed || r(i), i.forInstancesRec(r);
            });
        }
        super_Entity(r, i) {
            typeof r == "string" && (this.uuid = r), this.identity = r, this.data = i, this.matrixAutoUpdate = !1, this.dataPatched = this.data;
        }
        changeSelectedState(r, i, s = !1) {
            if (!(this.data.states.length === 0 && !s)) {
                for (let o of this.data.states)xa.toOps(this.data, o.data).forEach((l)=>{
                    let c = Nh.replaceProps(l, this.data);
                    this.dataPatched = this.data, this.updateByPatchedOp(c, this.data, i);
                });
                if (r !== null) {
                    let o = this.data.states.data(r);
                    o && (this.dataPatched = xa.patch(this.data, o), xa.toOps(this.data, o).forEach((l)=>{
                        this.updateByPatchedOp(l, this.dataPatched, i);
                    }));
                }
                s && this.updateTransformState(this.dataPatched, i), this.stateSelection = r, this.updatePathSnapping(this.dataPatched.pathSnapping);
            }
        }
        get singleBBox() {
            return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges(), this._singleBBox.computeFaces()), this._singleBBox;
        }
        get recursiveBBox() {
            return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges(), this._recursiveBBox.computeFaces()), this._recursiveBBox;
        }
        updateEntityBoxSize(r, i) {
            r.setScalar(0), i.setScalar(0);
        }
        resetBBoxNeedsUpdateSelf() {
            this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
        }
        resetBBoxNeedsUpdate() {
            this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((r)=>{
                Ro(r) && r.resetBBoxNeedsUpdateSelf();
            }), this.traverseEntity((r)=>{
                r.resetBBoxNeedsUpdateSelf();
            });
        }
        find(r) {
            let i;
            return this.traverseEntity((s)=>{
                s.uuid === r && (i = s);
            }), i;
        }
        traverseSortNextHelper() {
            let r = this.parent;
            if (r) {
                let i = r.children, s = i.indexOf(this) + 1;
                if (yt.is(i[s])) return i[s];
                if (yt.is(r)) return r.traverseSortNextHelper();
            }
        }
        sortNext() {
            let r = this.children;
            return this.children.length > 0 && yt.is(this.children[0]) ? r[0] : this.traverseSortNextHelper();
        }
        goUp(r) {
            let i = this;
            for(; r > 0 && i !== null;)i = i.parent, r -= 1;
            return i;
        }
        hasAnccestorOrSelf(r) {
            return this === r || this.hasAnccestor(r);
        }
        hasAnccestor(r) {
            let i = this.parent;
            for(; i;){
                if (r === i) return !0;
                i = i.parent;
            }
            return !1;
        }
        countToAccestor(r) {
            let i = 0, s = this;
            for(; s !== r;){
                if (s === null) return -1;
                s = s.parent, i += 1;
            }
            return i;
        }
        forEachEntity(r) {
            for (let i of this.children)Ro(i) && r(i);
        }
        traverseEntityAncestors(r) {
            this.traverseAncestors((i)=>{
                yt.is(i) && r(i);
            });
        }
        traverseConcreteEntity(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Ro(o) && o.isConcreteEntity && o.traverseEntity(r, i + 1);
        }
        traverseEntity(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Ro(o) && o.traverseEntity(r, i + 1);
        }
        traverseVisibleEntity(r) {
            r(this);
            for (let i of this.children)Ro(i) && i.visible && i.traverseVisibleEntity(r);
        }
        updateMatrix() {
            super.updateMatrix(), this.cloner && this.cloner.onObjUpdateMatrix(), this.dispatchEvent({
                type: "updateMatrix"
            });
        }
        updateMatrixWorld(r) {
            super.updateMatrixWorld(r), this.dispatchEvent({
                type: "updateMatrixWorld"
            });
        }
        copy(r, i = !1) {
            return super.copy(r, i), this.dataPatched = r.dataPatched, this.raycastLock = r.raycastLock, this.scaleLock = r.scaleLock, this.hiddenMatrix.copy(r.hiddenMatrix), this;
        }
        hasEntityChild() {
            return this.children.some((r)=>Ro(r));
        }
        isAncestorOf(r) {
            if (this.uuid === r) return !1;
            let i = !1;
            return this.traverseEntity((s)=>{
                s.uuid === r && (i = !0);
            }), i;
        }
        toObjectTransformState(r = []) {
            this.updateWorldMatrix(!0, !1);
            let i = {
                position: this.position.toArray(),
                rotation: [
                    this.rotation.x * we.RAD2DEG,
                    this.rotation.y * we.RAD2DEG,
                    this.rotation.z * we.RAD2DEG
                ],
                scale: this.scale.toArray(),
                hiddenMatrix: this.hiddenMatrix.toArray()
            };
            return _h(i, r);
        }
        getTransformValues(r, i, s) {
            return i[r].map((o, a)=>s?.shared.getVariable(o, [
                    this.uuid,
                    r,
                    C7[a]
                ]) ?? o);
        }
        updateTransformState(r, i) {
            let s = !1;
            return r.position && (this.position.fromArray(this.getTransformValues("position", r, i)), s = !0), r.rotation && (S1.fromArray(this.getTransformValues("rotation", r, i)).multiplyScalar(we.DEG2RAD), this.rotation.setFromVector3(S1), s = !0), r.scale && (this.scale.fromArray(this.getTransformValues("scale", r, i)), s = !0), r.hiddenMatrix !== void 0 && (s = !0, this.hiddenMatrix.fromArray(r.hiddenMatrix ?? wl.identity)), s && (this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((o)=>{
                o.invalidateClonerTransform(this);
            })), r.position && r.rotation && r.scale && r.hiddenMatrix !== void 0 && this.updateWorldMatrix(!1, !0), s;
        }
        onVariableUpdate(r = !1) {
            if (r) {
                this.resetBBoxNeedsUpdate();
                return;
            }
            this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((i)=>{
                i.invalidateClonerTransform(this);
            });
        }
        dispose() {
            this.disposed = !0, this.cloner && (this.cloner.removeFromParent(), this.cloner = void 0);
        }
        disposeChildrenRecursively() {
            for (let r of this.children)yt.is(r) && r.disposeRecursively();
        }
        disposeRecursively() {
            this.dispose(), this.children.forEach((r)=>{
                yt.is(r) && r.disposeRecursively();
            });
        }
        toState(r = []) {
            let i = {
                name: this.name,
                visible: this.visible,
                raycastLock: this.raycastLock,
                ...this.toObjectTransformState(r)
            };
            return _h(i, r);
        }
        updateByObjUpdateOp(r, i) {
            r !== void 0 && this.updateByOp({
                type: 0,
                props: r,
                path: []
            }, {
                ...this.data,
                ...r
            }, i, !1);
        }
        updateByOp(r, i, s, o) {
            let a = this.data;
            this.data = i;
            let l = r, c = Lt(r.path, [
                "states",
                "*"
            ]);
            if (c !== null) {
                if (r.type === 0) {
                    let [u] = c;
                    if (this?.stateSelection === u) {
                        let h = {
                            ...r.props
                        };
                        if (delete h.name, Object.values(r.props).some((d)=>d === void 0)) {
                            let d = this.data;
                            if (d !== void 0) {
                                let f = Sr.zoom(d, r.path.slice(2));
                                if (f) for(let p in r.props)r.props[p] === void 0 && p in f && (h[p] = f[p]);
                            }
                        }
                        l = {
                            ...r,
                            props: h,
                            path: r.path.slice(2)
                        };
                    }
                }
            } else if (r.type === 0) {
                let u = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
                if (u !== void 0) {
                    if (r.props.name !== void 0 && u.name) {
                        let { name: d, ...f } = u;
                        u = f;
                    }
                    if (r.props.material !== void 0 && "material" in u) {
                        let { material: d, ...f } = u;
                        u = f;
                    }
                    let h = Sr.removeOverridden(r.path, r.props, u);
                    l = {
                        ...r,
                        props: h
                    };
                }
            }
            if (this.updateByPatchedOpBase(l, xa.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), s), Lt(r.path, [
                "overrides"
            ])) {
                let u = [], h = [
                    ...r.path
                ];
                for(u.push(h[1]), h.splice(0, 2); h.length > 0 && h[0] === "descendants";)u.push(h[1]), h.splice(0, 2);
                if (u[u.length - 1] === void 0) {
                    if (r.type === 0) for (let d of Object.keys(r.props)){
                        u[u.length - 1] = d;
                        let f = s.scene.findInstance([
                            this.uuid,
                            ...u
                        ]);
                        f && (f.overrideData = r.props[d], f.updateState(So.apply(f.component.data, f.overrideData), s));
                    }
                } else {
                    let d = s.scene.findInstance([
                        this.uuid,
                        ...u
                    ]);
                    if (d) {
                        let f = Sr.zoom(d.component.data, h);
                        if (r = {
                            ...r,
                            path: h
                        }, r.type === 0) {
                            let p = r.props;
                            if (f) for (let [m, g] of Object.entries(r.props))g === void 0 && (p === r.props && (p = {
                                ...r.props
                            }), p[m] = f[m]);
                            r = {
                                ...r,
                                props: p
                            };
                        }
                        d.overrideData = qh.resolve(i.overrides, u), d.updateByOp(r, Lr.applySimple(d.data, r), s, !1);
                    }
                }
            } else if (this.instances.length > 0) {
                let u;
                if (r.path.length === 0 && r.type === 0) {
                    let h;
                    for (let d of Po.rootOverrideProps)d in r.props && (h === void 0 && (h = {}), h[d] = r.props[d]);
                    h && (u = {
                        ...r,
                        props: h
                    });
                } else for (let h of Po.rootOverrideProps)if (Lt(r.path, [
                    h
                ])) {
                    u = r;
                    break;
                }
                u !== void 0 && this.instances.forEach((h)=>{
                    if (h.isInstanceRoot) {
                        let d = So.filterOp(h.overrideData, u);
                        d && h.updateByOp(d, Lr.applySimple(h.data, d), s, !0);
                    }
                }), this.instances.forEach((h)=>{
                    if (!h.isInstanceRoot) {
                        let d = So.filterOp(h.overrideData, r);
                        if (d) {
                            let f;
                            a === h.data && r === d ? f = i : f = Lr.applySimple(h.data, d), h.updateByOp(d, f, s, !0);
                        }
                    }
                });
            }
        }
        updateByPatchedOpBase(r, i, s) {
            if (this.dataPatched = i, r.path.length === 0 && r.type === 0) r.props.type !== void 0 && !ks.is(r.props.type) && Hs.changeEntityProptotype(this, i, s);
            else if (r.path.length === 1 && r.path[0] === "geometry" && r.type === 0 && "type" in r.props) {
                Hs.changeEntityProptotype(this, i, s);
                for (let o of this.children)yt.is(o) && o.updateVisible(s.scene);
            }
            this.updateByPatchedOp(r, i, s);
        }
        updateByPatchedOp(r, i, s) {
            if (r.path.length === 0 && r.type === 0 && this.updateState(r.props, s), r.path[0] === "morphTargetInfluences" && r.type === 0) {
                let a = i.morphTargetInfluences.get(r.path[1])?.data.name;
                a && this.updateMorphInfluences(a, s.shared.getVariable(r.props.value, [
                    this.uuid,
                    "morphTargetInfluences",
                    a
                ]));
            }
            if (Lt(r.path, [
                "pathSnapping"
            ]) !== null && this.updatePathSnapping(i.pathSnapping), Lt(r.path, [
                "cloner"
            ]) !== null) {
                let o = Lr.drop(r, 1);
                o.path.length === 0 && o.type === 0 && o.props.disabled === !0 ? this.setFromClonerState(null, s) : this.cloner ? this.cloner.updateState(i.cloner, s.scene) : (this.setFromClonerState(i.cloner, s), this.expandCloner(s.scene)), this.updateVisible(s.scene);
            }
        }
        updatePathSnapping(r = this.dataPatched.pathSnapping) {
            this._updatedPathSnapping = r, this._needApplyPathSnapping = !0;
        }
        get updatedPathSnapping() {
            return this._updatedPathSnapping;
        }
        applyPathSnapping(r) {
            let i = this._updatedPathSnapping?.pathId ?? this.dataPatched.pathSnapping.pathId, s = this._updatedPathSnapping?.slide ?? this.dataPatched.pathSnapping.slide ?? 0, o = this._updatedPathSnapping?.offset ?? this.dataPatched.pathSnapping.offset ?? 0, a = this._updatedPathSnapping?.orientation ?? this.dataPatched.pathSnapping.orientation;
            if (i === null) return;
            let l = r.find(i);
            if (!l || this._needApplyPathSnapping === !1) return;
            this._needApplyPathSnapping = !1;
            let c = l.data;
            if (c.geometry.path.points.length <= 1) return;
            let u = A0(c.geometry.path), h = (s + o) % 1;
            s + o === 1 && h === 0 && (h = 1);
            let d = null;
            try {
                d = u.curves.length ? u.getPointAt(h) : null;
            } catch (g) {}
            if (d === null) return;
            let f = this.parent ? this.parent?.matrixWorld : new ue;
            l.updateMatrixWorld();
            let p = new ue().multiplyMatrices(f.clone().invert(), l.matrixWorld);
            d.applyMatrix4(p);
            let m = {
                position: d.toArray(),
                rotation: c.rotation
            };
            if (a === "tangential") {
                let g = new ue().extractRotation(l.matrixWorld), y = u.getTangentAt(h).applyMatrix4(g).add(d), x = new ue().lookAt(d, y, P7), v = S1.setFromEuler(new nr().setFromRotationMatrix(x)).multiplyScalar(we.RAD2DEG);
                m = {
                    ...m,
                    rotation: v.toArray()
                };
            }
            this.updateTransformState(m), this.traverseEntity((g)=>{
                g._cameraType && g.dispatchEvent(M7);
            });
        }
        updateVisible(r) {
            if (this.visible = this.dataPatched.visible && (!this.dataPatched.cloner || (this.dataPatched.cloner.disabled ?? !1) || this.dataPatched.cloner?.hideBase !== !0), !r) return;
            let i = !1;
            this.traverseEntity((s)=>{
                if (s.data.type === "Splat") return i = !0, !0;
            }), i && r.reloadSplats();
        }
        updateState_Entity(r, i) {
            r.name !== void 0 && (this.name = r.name), r.raycastLock !== void 0 && (this.raycastLock = r.raycastLock), r.visible !== void 0 && (this.updateVisible(i?.scene), this.resetBBoxNeedsUpdate()), i && "cloner" in r && r.cloner !== void 0 && (this.setFromClonerState(r.cloner, i), this.updateVisible(i.scene)), this.updateTransformState(r, i);
        }
        get attachedSurfaceCloners() {
            return this.children.filter((r)=>r instanceof Hs.Cloner && r.parameters.type === "toObject");
        }
        setFromClonerState(r, i) {
            this.disposed || (r === null || r.disabled ? (this.cloner && this.cloner.removeFromParent(), this.cloner = void 0) : this.cloner === void 0 ? (this.cloner = new Hs.Cloner(this, r), i.scene.addPendingExpandCloner(this)) : this.cloner.updateState(r, i.scene));
        }
        expandCloner(r) {
            !this.disposed && this.cloner && this.cloner.expandClones(r);
        }
        invalidateClonerTransform(r) {
            this.cloner && this.cloner.invalidateTransform(r);
        }
        requestRender() {
            this.dispatchEvent({
                type: "requestRender"
            });
        }
    };
var E0 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 64,
            heightSegments: 1,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadius: 8,
            cornerSegments: 8,
            hollow: 0
        }, n1.parameters);
        e.thetaLength = we.clamp(e.thetaLength, 0, 360);
        let r = e.width / 2, i = e.radiusTop ?? r, s = e.radiusBottom ?? r;
        return i === s ? (i = r, s = r) : i > s ? (i = r, s = s * r / i) : (i = i * r / s, s = r), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                radiusTop: i,
                radiusBottom: s
            })
        };
    }
    static build(n1) {
        let { width: t, depth: e, height: r, radialSegments: i, heightSegments: s, openEnded: o, thetaStart: a, thetaLength: l, radiusTop: c, radiusBottom: u, cornerRadius: h, cornerSegments: d, hollow: f } = n1.parameters, p;
        return l === 0 ? (p = new _e, p.setAttribute("position", new Te([], 3))) : h || f ? p = new im(c, u, r, i, s, o, a, l * Math.PI / 180, h, h, d, f) : p = new Ec(c, u, r, i, s, o, a, l * Math.PI / 180), p.scale(1, 1, e / t), Object.assign(p, {
            userData: {
                ...n1,
                type: "CylinderGeometry"
            }
        });
    }
};
function Ol(n1, t, e) {
    e.x = n1.x * t.x, e.y = n1.y, e.z = n1.x * t.y;
}
function lO(n1) {
    return new k(n1.y, -n1.x);
}
var im = class extends _e {
    constructor(t, e, r, i, s, o, a, l, c, u, h, d, f = !1){
        super(), this.type = "RoundedCylinderBufferGeometry", t = t !== void 0 ? t : 1, e = e !== void 0 ? e : 1, r = r || 1, i = Math.floor(i) || 8, s = Math.floor(s) || 1, o = o !== void 0 ? o : !1, a = a !== void 0 ? a : 0, l = l !== void 0 ? l : Math.PI * 2, o && (c = 0, u = 0);
        let p = [], m = [], g = [], y = [], x = 0, v = r / 2, S = new E, w = new E;
        f && t == 0 && (t = c), f && e == 0 && (e = u);
        let A = new k(t, v), T = new k(e, -v), b = null, M = null, C = null, P = null, I = A.clone().sub(T), _ = 0, D = 0, L = 0;
        d > 0 && (_ = Math.min(t, e) * (1 - d), D = t - _, L = e - _);
        let j = A.clone();
        j.x -= _;
        let V = Math.PI - I.angle(), H = I.angle(), W = Math.tan(H / 2), q = Math.tan(V / 2), Q = W + q, G = d ? Q : q, Z = d ? Q : W;
        if (c = Math.min(c, (t - D) / G, I.length() / Q), u = Math.min(u, (e - L) / Z, I.length() / Q), c > 0) {
            let re = c / W;
            b = A.clone().sub(new k(re, c)), d && (C = b.clone(), C.x -= _ - Q * c), A.sub(I.clone().setLength(re));
        }
        if (u > 0) {
            let re = u / q;
            M = T.clone().sub(new k(re, -u)), T.add(I.clone().setLength(re)), d && (P = M.clone(), P.x -= _ - Q * u, j.sub(I.clone().setLength(re)));
        }
        I = A.clone().sub(T);
        let te = I.length() < .5, $ = [];
        for(let re = 0; re <= i; re++){
            let J = [], Ee = re / i, xe = Ee * l + a, de = new k(Math.sin(xe), Math.cos(xe));
            P && M ? (Y(J, Ee, de, V, u, P, -1, !0), Y(J, Ee, de, H, u, M, -1, !1)) : M ? (oe(J, de, M.x, 0, -1), Y(J, Ee, de, H, u, M, -1, !1)) : o || oe(J, de, e, L, -1);
            let De = lO(I).normalize();
            if (Ol(De, de, S), !te) for(let Ce = 0; Ce <= s; Ce++){
                let ze = Ce / s, Ue = I.clone().multiplyScalar(ze).add(T);
                Ol(Ue, de, w), m.push(w.x, w.y, w.z), g.push(S.x, S.y, S.z), y.push(Ee, .5 + w.y / r), J.push(x++);
            }
            if (C && b ? (Y(J, Ee, de, V, c, b, 1, !1), Y(J, Ee, de, H, c, C, 1, !0)) : b ? (Y(J, Ee, de, V, c, b, 1, !1), oe(J, de, b.x, 0, 1)) : o || oe(J, de, t, D, 1), d && !te) {
                let Ce = lO(I).multiplyScalar(-1).normalize();
                Ol(Ce, de, S);
                for(let ze = 0; ze <= s; ze++){
                    let Ue = ze / s, Ve = I.clone().multiplyScalar(-Ue).add(j);
                    Ol(Ve, de, w), m.push(w.x, w.y, w.z), g.push(S.x, S.y, S.z), y.push(Ee, .5 + w.y / r), J.push(x++);
                }
            }
            d && !o && J.push(J[0]), $.push(J);
        }
        for(let re = 0; re < $.length - 1; re++)for(let J = 0; J < $[0].length - 1; J++){
            if (o && d && J == s) continue;
            let Ee = $[re][J], xe = $[re + 1][J], de = $[re + 1][J + 1], De = $[re][J + 1], Ce = m[de * 3 + 0], ze = m[de * 3 + 2];
            p.push(Ee, xe, De), (Ce != 0 || ze != 0) && p.push(xe, de, De);
        }
        l < Math.PI * 2 && (ie(-1, $[0], a), ie(1, $[$.length - 1], a + l)), this.setIndex(p), this.setAttribute("position", new Te(m, 3)), this.setAttribute("normal", new Te(g, 3)), this.setAttribute("uv", new Te(y, 2));
        function Y(re, J, Ee, xe, de, De, Ce, ze) {
            for(let Ue = 0; Ue < h + 1; Ue++){
                let Ve = Ue / h, Oe = Ce < 0 ? Ve : 1 - Ve;
                ze && (Oe -= 1), Oe *= xe;
                let Ye = new k(Math.sin(Oe), Math.cos(Oe) * Ce), F = Ye.clone().multiplyScalar(de).add(De);
                Ol(F, Ee, w), m.push(w.x, w.y, w.z), Ol(Ye, Ee, S), g.push(S.x, S.y, S.z), y.push(J, .5 + w.y / r), re.push(x++);
            }
        }
        function oe(re, J, Ee, xe, de) {
            let De = new E, Ce = new k, ze = [
                Ee,
                xe
            ];
            de < 0 && ze.reverse();
            for (let Ue of ze)Ce.set(Ue, v * de), Ol(Ce, J, De), m.push(De.x, De.y, De.z), g.push(0, de, 0), y.push(.5, .5), re.push(x++);
        }
        function ie(re, J, Ee) {
            let xe = new k(Math.sin(Ee), Math.cos(Ee)), de = new k(-Math.cos(Ee), Math.sin(Ee)), De = new E, Ce = re < 0 ? (Ve, Oe, Ye)=>p.push(Ve, Oe, Ye) : (Ve, Oe, Ye)=>p.push(Ve, Ye, Oe), ze = new k((t + e + D + L) / 4, 0);
            Ol(ze, xe, De), m.push(De.x, De.y, De.z), g.push(de.x, 0, de.y), y.push(.5, .5);
            let Ue = x++;
            for (let Ve of J){
                let Oe = m.slice(Ve * 3, Ve * 3 + 3);
                m.push(...Oe), g.push(de.x, 0, de.y);
                let Ye = y.slice(Ve * 2, Ve * 2 + 2);
                y.push(...Ye), x++;
            }
            for(let Ve = Ue + 1; Ve < x - 1; Ve++)Ce(Ue, Ve, Ve + 1);
            Ce(Ue, x - 1, Ue + 1);
        }
    }
};
var cO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            heightSegments: 8,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadiusTop: 8,
            cornerRadiusBottom: 8,
            cornerSegments: 8
        }, n1.parameters);
        return e.thetaLength = we.clamp(e.thetaLength, 0, 360), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, depth: e, height: r, radialSegments: i, heightSegments: s, openEnded: o, thetaStart: a, thetaLength: l, cornerRadiusTop: c, cornerRadiusBottom: u, cornerSegments: h } = n1.parameters, d;
        return l === 0 ? (d = new _e, d.setAttribute("position", new Te([], 3))) : c > 0 || u > 0 || l < 360 ? d = new im(0, t / 2, r, i, s, o, a, l * Math.PI / 180, c, u, h, 0, !0) : d = new sl(t / 2, r, i, s, o), d.scale(1, 1, e / t), Object.assign(d, {
            userData: {
                ...n1,
                type: "ConeGeometry"
            }
        });
    }
};
var uO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 1,
            heightSegments: 1,
            depthSegments: 1,
            cornerRadius: 8,
            cornerSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, widthSegments: i, heightSegments: s, depthSegments: o, cornerRadius: a, cornerSegments: l } = n1.parameters, c;
        return a === 0 ? c = new mi(t, e, r, i, s, o) : c = new A1(t, e, r, i, s, o, a, l), Object.assign(c, {
            userData: {
                ...n1,
                type: "CubeGeometry"
            }
        });
    }
}, w1 = Math.PI / 2, A1 = class extends _e {
    constructor(t = 1, e = 1, r = 1, i = 1, s = 1, o = 1, a = 0, l = 4){
        super(), this.type = "BoxGeometry", i = Math.floor(i), s = Math.floor(s), o = Math.floor(o), l = Math.floor(l), a = Math.min(a, t / 2, e / 2, r / 2);
        let c = [], u = [], h = [], d = [], f = 0;
        p("z", "y", "x", -1, -1, r, e, t, o, s), p("z", "y", "x", 1, -1, r, e, -t, o, s), p("x", "z", "y", 1, 1, t, r, e, i, o), p("x", "z", "y", 1, -1, t, r, -e, i, o), p("x", "y", "z", 1, -1, t, e, r, i, s), p("x", "y", "z", -1, -1, t, e, -r, i, s), a > 0 && (m("z", "y", "x", -1, -1, 1, r, e, t, o), m("z", "y", "x", 1, -1, -1, r, e, t, o), m("z", "y", "x", -1, 1, -1, r, e, t, o), m("z", "y", "x", 1, 1, 1, r, e, t, o), m("x", "y", "z", -1, -1, -1, t, e, r, i), m("x", "y", "z", 1, -1, 1, t, e, r, i), m("x", "y", "z", -1, 1, 1, t, e, r, i), m("x", "y", "z", 1, 1, -1, t, e, r, i), m("y", "x", "z", -1, -1, 1, e, t, r, s), m("y", "x", "z", 1, -1, -1, e, t, r, s), m("y", "x", "z", 1, 1, 1, e, t, r, s), m("y", "x", "z", -1, 1, -1, e, t, r, s), g(1, 1, 1), g(-1, 1, 1), g(1, -1, 1), g(-1, -1, 1), g(1, 1, -1), g(-1, 1, -1), g(1, -1, -1), g(-1, -1, -1)), this.setIndex(c), this.setAttribute("position", new Te(u, 3)), this.setAttribute("normal", new Te(h, 3)), this.setAttribute("uv", new Te(d, 2));
        function p(y, x, v, S, w, A, T, b, M, C) {
            let P = (A - 2 * a) / M, I = (T - 2 * a) / C, _ = A / 2 - a, D = T / 2 - a, L = b / 2, j = M + 1, V = C + 1, H = 0, W = new E;
            for(let q = 0; q < V; q++){
                let Q = q * I - D;
                for(let G = 0; G < j; G++){
                    let Z = G * P - _;
                    W[y] = Z * S, W[x] = Q * w, W[v] = L, u.push(W.x, W.y, W.z), W[y] = 0, W[x] = 0, W[v] = b > 0 ? 1 : -1, h.push(W.x, W.y, W.z), d.push(G / M), d.push(1 - q / C), H += 1;
                }
            }
            for(let q = 0; q < C; q++)for(let Q = 0; Q < M; Q++){
                let G = f + Q + j * q, Z = f + Q + j * (q + 1), te = f + (Q + 1) + j * (q + 1), $ = f + (Q + 1) + j * q;
                c.push(G, Z, $), c.push(Z, te, $);
            }
            f += H;
        }
        function m(y, x, v, S, w, A, T, b, M, C) {
            let P = (T - 2 * a) / C, I = T / 2 - a, _ = b / 2 - a, D = M / 2, L = C + 1, j = 0, V = new E, H = new E;
            for(let W = 0; W < l + 1; W++){
                let q = W / l * w1, Q = Math.sin(q) * a, G = (1 - Math.cos(q)) * a, Z = Math.sin(q), te = Math.cos(q);
                V[x] = (_ + Q) * w, V[v] = (D - G) * A, H[y] = 0, H[x] = Z * Math.sign(V[x]), H[v] = te * Math.sign(V[v]);
                for(let $ = 0; $ < L; $++){
                    let Y = $ * P - I;
                    V[y] = Y * S, u.push(V.x, V.y, V.z), h.push(H.x, H.y, H.z), d.push($ / C), d.push(0), j += 1;
                }
            }
            for(let W = 0; W < l; W++)for(let q = 0; q < C; q++){
                let Q = f + q + L * W, G = f + q + L * (W + 1), Z = f + (q + 1) + L * (W + 1), te = f + (q + 1) + L * W;
                c.push(Q, G, te), c.push(G, Z, te);
            }
            f += j;
        }
        function g(y, x, v) {
            let S = new E, w = new E(t / 2, e / 2, r / 2);
            w.subScalar(a);
            let A = [], T = y * x * v > 0 ? (M, C, P)=>c.push(M, C, P) : (M, C, P)=>c.push(M, P, C);
            for(let M = 0; M <= l; M++){
                let C = [], P = w1 * (1 - M / l), I = Math.cos(P), _ = Math.sin(P), D = 0;
                for(let L = 0; L <= M; L++){
                    let j = Math.cos(D), V = Math.sin(D);
                    S.x = I * j, S.y = _, S.z = I * V;
                    let H = w.clone().addScaledVector(S, a);
                    u.push(y * H.x, x * H.y, v * H.z), h.push(y * S.x, x * S.y, v * S.z), d.push(0, 0), C.push(f++), D += w1 / M;
                }
                A.push(C);
            }
            let b = A.length - 1;
            for(let M = 0; M < b; M++){
                let C = A[M], P = A[M + 1], I = C.length - 1;
                T(C[0], P[1], P[0]);
                for(let _ = 1; _ <= I; _++)T(C[_ - 1], C[_], P[_]), T(C[_], P[_ + 1], P[_]);
            }
        }
    }
};
var Rl = class extends _e {
    constructor(t = [], e = [], r = "", i = 1, s = .2, o = 4){
        super(), this.type = "PolyhedronGeometryRound";
        let a = [], l = [], c = [];
        u(), h(), this.setAttribute("position", new Te(a, 3)), this.setAttribute("normal", new Te(c, 3)), this.setAttribute("uv", new Te(l, 2));
        return;
        function u() {
            s = Math.min(1 - 1e-5, s), s == 0 && (o = 0);
            let f = {
                IcosahedronGeometry: 5,
                DodecahedronGeometry: 3,
                HexahedronGeometry: 3,
                OctahedronGeometry: 4,
                TetrahedronGeometry: 3
            }[r], p = new E, m = p.clone(), g = new Cr, y = s * i, x = i - y, v = o + 1, S = new E, w = (W, q)=>S.subVectors(W, q).normalize(), A = (W, q)=>Array(W).fill(void 0).map(q), T = A(t.length / 3, (W, q)=>new E().fromArray(t, q * 3).setLength(i)), b = [], M = 1e6;
            for(let W = 0; W < T.length; W++){
                let q = T[W], Q = [], G, Z, te, $ = 1e10, Y = -1;
                for(; (Y = e.indexOf(W, Y + 1)) != -1;){
                    let J = Y - Y % 3;
                    G = e[J + (Y + 1) % 3], Z = e[J + (Y + 2) % 3], te = q.distanceToSquared(T[G]), $ = Math.min($, te), Q.push([
                        G,
                        Z,
                        te
                    ]);
                }
                $ += 1e-6;
                let oe = [], ie = 0, re = Q.length;
                for(let J = 0; J < re; J++){
                    [G, Z, te] = Q[ie];
                    let Ee = b[G]?.includes(W) == !0;
                    te <= $ && oe.push(G + +Ee * M), ie = Q.findIndex((xe)=>xe[0] == Z);
                }
                b.push(oe);
            }
            let C = [];
            {
                let W = 0, q = 0, Q, G, Z = f == 3;
                for(let te = 0; te <= o; te++){
                    Q = te * (te + 1) / 2, G = (te + 1) * (te + 2) / 2;
                    for(let $ = 0; $ < o - te; $++)[W, q] = [
                        Q + $ + te + 2,
                        G + $ + te + 3
                    ], C.push(Q, G, ...Z ? [
                        q,
                        Q
                    ] : [
                        W,
                        G
                    ], q, W), [Q, G] = [
                        W,
                        q
                    ];
                    C.push(Q, G, Q + o + 2);
                }
            }
            let P = p.clone(), I = p.clone(), _ = p.clone(), D = p.clone(), L = p.clone(), j = [], V = A(T.length, ()=>A(f, ()=>p.clone()));
            for(let W = 0; W < T.length; W++){
                p.copy(T[W]).normalize(), P.copy(p).multiplyScalar(x);
                let q = b[W];
                for(let oe = 0; oe < q.length; oe++){
                    let ie = q[oe], re = q[(oe + 1) % f];
                    g.setFromPointsAndIndices(T, W, ie % M, re % M), g.b.sub(g.a).setLength(1e10).add(g.a), g.c.sub(g.a).setLength(1e10).add(g.a), g.closestPointToPoint(P, V[W][oe]);
                }
                let Q = [], G = [], Z = [], te = new E;
                o == 0 && [
                    ...V[W]
                ].reduce((oe, ie)=>oe.add(ie), te).multiplyScalar(1 / f);
                for(let oe = 0; oe < f; oe++){
                    let ie = [], re = (oe - 1 + f) % f, J = V[W][re], Ee = V[W][oe];
                    p.copy(J).sub(P), m.copy(Ee).sub(P);
                    let xe = P.angleTo(p), de = p.angleTo(m), De = Math.cos(xe) * y;
                    o == 0 ? I.copy(te) : I.copy(P).setLength(x + De), G.push(De);
                    let Ce = [
                        I,
                        J,
                        Ee
                    ];
                    for(let ze = 0; ze < 2; ze++){
                        let Ue = Ce[ze], Ve = Ce[ze + 1];
                        D.subVectors(Ue, P), L.subVectors(Ve, P), _.crossVectors(D, L).normalize();
                        for(let Oe = 0; Oe < v; Oe++){
                            let Ye = [
                                xe,
                                de
                            ][ze] * Oe / v;
                            p.copy(D).applyAxisAngle(_, Ye).add(P), Q.push(p.clone()), ze && (w(p, P), ie.push([
                                Oe == 0 ? Ue : p.clone(),
                                S.clone()
                            ]));
                        }
                        ze && (w(Ve, P), ie.push([
                            Ve,
                            S.clone()
                        ]));
                    }
                    Z.push(ie);
                }
                j.push(Z);
                let $ = 2 * v, Y = 2;
                for(let oe = 0; oe < f; oe++){
                    let ie = $ * oe, re = $ * ((oe + 1) % f), J = [
                        Q[ie]
                    ];
                    for(let xe = 1; xe < v; xe++){
                        D = Q[ie + xe], L = Q[re + xe], J.push(D);
                        for(let de = 1, De = xe - Y + 1; de <= De; de++)p.lerpVectors(D, L, de / (De + 1)), p.sub(P).setLength(G[oe]).add(P), J.push(p.clone());
                        J.push(L);
                    }
                    for(let xe = 0; xe < v; xe++)J.push(Q[xe + v + ie]);
                    J.push(Q[re + v]);
                    let Ee = C.map((xe)=>J[xe]);
                    a.push(...Ee.map((xe)=>[
                            xe.x,
                            xe.y,
                            xe.z
                        ]).flat()), c.push(...Ee.map((xe)=>(w(xe, P), [
                            S.x,
                            S.y,
                            S.z
                        ])).flat());
                }
            }
            let H = [];
            for(let W = 0; W < b.length; W++)for(let q = 0; q < f; q++){
                let Q = b[W][q];
                if (Q < M) {
                    let G = b[Q].findIndex(($)=>$ % M == W), Z = j[W][q], te = j[Q][G];
                    for(let $ = 0; $ < v; $++){
                        let Y = Z[$], oe = te[v - $], ie = Z[$ + 1], re = te[v - ($ + 1)];
                        [
                            Y,
                            oe,
                            ie,
                            ie,
                            oe,
                            re
                        ].forEach((J)=>{
                            a.push(J[0].x, J[0].y, J[0].z), c.push(J[1].x, J[1].y, J[1].z);
                        });
                    }
                    H.push(Z[0][0], te[v][0], Z[v][0], te[0][0]);
                }
            }
            for(; H.length;){
                let W, q, Q, G;
                [W, q] = H.splice(0, 2);
                let Z = [
                    W
                ];
                for(; W != q;)Z.push(q), Q = H.indexOf(q), G = Q % 2, q = H.splice(Q - G, 2)[1 - G];
                S.subVectors(Z[0], Z[1]).cross(p.subVectors(Z[0], Z[2])).normalize();
                let te = S.dot(Z[0]) < 0;
                te && S.negate();
                for(let $ = 1; $ <= Z.length - 2; $++)[
                    Z[$ + +te],
                    Z[$ + 1 - +te],
                    Z[0]
                ].forEach((Y)=>{
                    a.push(Y.x, Y.y, Y.z), c.push(S.x, S.y, S.z);
                });
            }
        }
        function h() {
            let d = new E;
            for(let T = 0; T < a.length; T += 3){
                d.x = a[T + 0], d.y = a[T + 1], d.z = a[T + 2];
                let b = w(d) / 2 / Math.PI + .5, M = A(d) / Math.PI + .5;
                l.push(b, 1 - M);
            }
            let f = new E, p = new E, m = new E, g = new E, y = new k, x = new k, v = new k, S = (T, b, M, C)=>{
                C < 0 && T.x === 1 && (l[b] = T.x - 1), M.x === 0 && M.z === 0 && (l[b] = C / 2 / Math.PI + .5);
            };
            for(let T = 0, b = 0; T < a.length; T += 9, b += 6){
                f.set(a[T + 0], a[T + 1], a[T + 2]), p.set(a[T + 3], a[T + 4], a[T + 5]), m.set(a[T + 6], a[T + 7], a[T + 8]), y.set(l[b + 0], l[b + 1]), x.set(l[b + 2], l[b + 3]), v.set(l[b + 4], l[b + 5]), g.copy(f).add(p).add(m).divideScalar(3);
                let M = w(g);
                S(y, b + 0, f, M), S(x, b + 2, p, M), S(v, b + 4, m, M);
            }
            for(let T = 0; T < l.length; T += 6){
                let b = l[T + 0], M = l[T + 2], C = l[T + 4], P = Math.max(b, M, C), I = Math.min(b, M, C);
                P > .9 && I < .1 && (b < .2 && (l[T + 0] += 1), M < .2 && (l[T + 2] += 1), C < .2 && (l[T + 4] += 1));
            }
            function w(T) {
                return Math.atan2(T.z, -T.x);
            }
            function A(T) {
                return Math.atan2(-T.y, Math.sqrt(T.x * T.x + T.z * T.z));
            }
        }
    }
    static fromJSON(t) {
        return new Rl(t.vertices, t.indices, t.radius, t.corner, t.cornerSides);
    }
};
var hO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, detail: i, corner: s, cornerSides: o } = n1.parameters, a = i === 0 && s !== 0 ? new nm(t * .5, s, o) : new Uu(t * .5, i);
        return a.scale(1, e / t, r / t), Object.assign(a, {
            userData: {
                ...n1,
                type: "DodecahedronGeometry"
            }
        });
    }
}, nm = class extends Rl {
    constructor(t = 1, e = .2, r = 4){
        let i = (1 + Math.sqrt(5)) / 2, s = 1 / i, o = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            0,
            -i,
            0,
            -s,
            i,
            0,
            -s,
            -i,
            0,
            s,
            i,
            0,
            s
        ], a = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ], l = "DodecahedronGeometry";
        super(o, a, l, t, e, r), this.type = l;
    }
    static fromJSON(t) {
        return new nm(t.radius, t.corner, t.cornerSides);
    }
};
var sm = 1e-12, vd = class {
    constructor(t){
        this.position = new k;
        this.startPosition = new k;
        this.uuid = we.generateUUID();
        this.position = t.clone();
    }
    start() {
        this.reset();
    }
    reset() {
        this.startPosition.copy(this.position);
    }
    applyOffset(t) {
        this.position.copy(this.startPosition).add(t);
    }
    copy(t) {
        return this.position.copy(t.position), this.startPosition.copy(t.startPosition), this;
    }
    clone() {
        return new vd(this.position).copy(this);
    }
    toJSON() {
        return [
            this.position.x,
            this.position.y
        ];
    }
}, xd = class extends vd {
    constructor(e){
        super(e.position);
        this.parent = e;
    }
    copy(e) {
        return super.copy(e), this;
    }
    clone() {
        return new xd(this.parent).copy(this);
    }
}, Ws = class extends vd {
    constructor(e, r){
        super(r);
        this.controls = [];
        this.roundness = 0;
        this.areControlsDirectionsMirrored = !0;
        this.uuid = e, this.controls.push(new xd(this), new xd(this));
    }
    static create(e, r) {
        let i = new Ws(e, new k(...r.position));
        return i.controls[0].position.set(...r.controlPrevious.position), i.controls[1].position.set(...r.controlNext.position), i.roundness = r.roundness, i.areControlsDirectionsMirrored = r.areControlsDirectionsMirrored, i;
    }
    getOppositeControl(e) {
        let r = this.controls.indexOf(e);
        return r === 0 ? this.controls[1] : r === 1 ? this.controls[0] : null;
    }
    applyOffsetToControls(e, r = 1) {
        for(let i = 0, s = this.controls.length; i < s; i++){
            let o = this.controls[i];
            this.position.distanceTo(o.position) <= r ? o.position.copy(this.position) : o.applyOffset(e);
        }
    }
    controlsMoved() {
        return !(this.position.equals(this.controls[0].position) && this.position.equals(this.controls[1].position));
    }
    copy(e) {
        return super.copy(e), this.controls[0].copy(e.controls[0]), this.controls[1].copy(e.controls[1]), this.roundness = e.roundness, this.uuid = e.uuid, this;
    }
    clone() {
        return new Ws(this.uuid, this.position).copy(this);
    }
    toJSON() {
        return super.toJSON().concat(this.controls[0].toJSON(), this.controls[1].toJSON(), [
            this.roundness
        ]);
    }
    computeTangents() {
        let e = this.curveBefore?.getTangentAt(1), r = this.curveAfter?.getTangentAt(0);
        return [
            e,
            r
        ];
    }
    computeNormals(e = new k, r = new k) {
        let [i, s] = this.computeTangents();
        return i && s && (dO(i, e), dO(s, r)), [
            e,
            r
        ];
    }
    computeTangent(e = new k) {
        let [r, i] = this.computeTangents();
        return r && i && e.copy(r).add(i).normalize(), e;
    }
    computeNormal(e = new k) {
        let [r, i] = this.computeNormals();
        return e.copy(r).add(i).normalize(), e;
    }
};
function dO(n1, t = new k) {
    let e = n1.length();
    return t.set(-n1.y / e, n1.x / e);
}
var T1 = (n1)=>n1, bd = new k, T0 = new k, _7 = new k, I7 = new k, D7 = new k, O7 = new k, pO = new E, mO = new E;
function gO(n1) {
    let t = new k;
    t.addVectors(n1.v0, bd.subVectors(n1.v1, n1.v0).multiplyScalar(2 / 3));
    let e = new k;
    return e.addVectors(n1.v2, T0.subVectors(n1.v1, n1.v2).multiplyScalar(2 / 3)), new an(n1.v0, t, e, n1.v2);
}
function om(n1, t, e = Number.EPSILON) {
    return Math.abs(n1 - t) < e;
}
function R7(n1, t, e = Number.EPSILON) {
    return n1.distanceTo(t) < e;
}
function L7(n1, t, e = Number.EPSILON) {
    return n1.distanceTo(t) < e;
}
function M1(n1, t, e) {
    let r = Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2)), i = Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)), s = Math.sqrt(Math.pow(e.x - n1.x, 2) + Math.pow(e.y - n1.y, 2));
    return Math.acos((i * i + r * r - s * s) / (2 * i * r));
}
function yO(n1, t, e) {
    return fO(n1, t) && fO(t, e) && E1(n1.position, t.position, e.position);
}
function E1(n1, t, e) {
    return bd.copy(t).sub(n1).cross(T0.copy(e).sub(n1)) === 0;
}
function vO(n1, t, e, r, i) {
    let s = Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2)), o = (n1.y + t.y) / 2, a = (n1.x + t.x) / 2, l = Math.sqrt(Math.pow(e, 2) - Math.pow(s / 2, 2)) * (n1.y - t.y) / s, c = Math.sqrt(Math.pow(e, 2) - Math.pow(s / 2, 2)) * (t.x - n1.x) / s;
    return r.set(a + l, o + c), i.set(a - l, o - c), [
        r,
        i
    ];
}
function xO(n1, t, e) {
    let r = n1.distanceTo(e), i = t.distanceTo(e);
    return r < i ? t : n1;
}
function bO(n1, t, e, r, i, s) {
    let o = t.x - n1.x, a = t.y - n1.y, l = e.x - n1.x, c = e.y - n1.y, u = Math.sqrt((o + l) * (o + l) + (a + c) * (a + c)), h;
    return M1(t, n1, e) > Math.PI && (u *= -1), om(c, a) ? h = (a + c) * (r / u - .5) * 8 / 3 / (o - l) : h = (o + l) * (r / u - .5) * 8 / 3 / (c - a), i.set(t.x - h * a, t.y + h * o), s.set(e.x + h * c, e.y - h * l), [
        i,
        s
    ];
}
function C1(n1, t) {
    return n1.position.equals(n1.controls[1].position) && t.position.equals(t.controls[0].position);
}
function fO(n1, t) {
    return E1(n1.position, n1.controls[1].position, t.position) && E1(n1.position, t.controls[0].position, t.position);
}
function SO(n1, t, e, r, i = .5) {
    let s = bd.subVectors(t, n1).multiplyScalar(i).add(n1), o = T0.subVectors(e, t).multiplyScalar(i).add(t), a = _7.subVectors(r, e).multiplyScalar(i).add(e), l = s, c = I7.subVectors(o, s).multiplyScalar(i).add(s), u = D7.subVectors(a, o).multiplyScalar(i).add(o), h = a, d = O7.subVectors(u, c).multiplyScalar(i).add(c);
    return [
        n1.x,
        n1.y,
        l.x,
        l.y,
        c.x,
        c.y,
        d.x,
        d.y,
        u.x,
        u.y,
        h.x,
        h.y,
        r.x,
        r.y
    ];
}
function wO(n1, t, e = 12, r = !0) {
    let i = mO.set(0, 0, 0), s, o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        let c = T1(t[l]), u = bd, h = Ll(c, e);
        a.push(h);
        for(let d = 0; d <= h; d++)if (c instanceof an || c instanceof Yn || c instanceof ln) {
            if (c.getPoint(d / h, u), i.set(u.x, u.y, 0), s !== void 0 && L7(s, i)) continue;
            s === void 0 && (s = pO), s.copy(i), n1.setXYZ(o, i.x, i.y, i.z), o++;
        }
    }
    return r && o > 1 && !(n1.getX(o - 1) === n1.getX(0) && n1.getY(o - 1) === n1.getY(0) && n1.getZ(o - 1) === n1.getZ(0)) && (n1.setXYZ(o, n1.getX(0), n1.getY(0), n1.getZ(0)), o++), n1;
}
function AO(n1, t, e, r = 12, i = !0) {
    let s = mO.set(0, 0, 0), o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        if (e[l] === !1) continue;
        let c, u = T1(t[l]), h = bd, d = Ll(u, r);
        a.push(d);
        for(let f = 0; f <= d; f++)if (u instanceof an || u instanceof Yn || u instanceof ln) {
            if (u.getPoint(f / d, h), s.set(h.x, h.y, 0), c?.equals(s)) continue;
            c === void 0 ? c = pO : (n1.setXYZ(o, c.x, c.y, c.z), o++, n1.setXYZ(o, s.x, s.y, s.z), o++), c.copy(s);
        }
    }
    return i && o > 1 && !(n1.getX(o - 1) === n1.getX(0) && n1.getY(o - 1) === n1.getY(0) && n1.getZ(o - 1) === n1.getZ(0)) && (n1.setXYZ(o, n1.getX(0), n1.getY(0), n1.getZ(0)), o++), a;
}
function P1(n1, t = 12, e = !1) {
    let r = [];
    for(let i = 0, s = n1.length; i < s; i++){
        let o = n1[i], a = 0;
        if (e && o.roundedCurveCorner !== void 0) {
            let l = Ll(o.roundedCurveCorner, t) * .5;
            i > 0 && (r[i - 1] += l), a += l;
        }
        o.curveAfter !== void 0 && (a += Ll(o.curveAfter, t)), r.push(a);
    }
    return n1.length > 0 && e && n1[0].roundedCurveCorner !== void 0 && (r[n1.length - 1] += Ll(n1[0].roundedCurveCorner, t) * .5), r;
}
function Ll(n1, t = 12) {
    return n1 && n1 instanceof Sc ? t * 2 : n1 && (n1 instanceof ln || n1 instanceof gp) ? 1 : n1 && n1 instanceof Fu ? t * n1.points.length : t;
}
function EO(n1, t, e = 12, r = !0) {
    let i, s = 0;
    for(let o = 0; o < t.length; o++){
        let a = T1(t[o]), l = Ll(a, e), c = bd;
        for(let u = 0; u <= l; u++)if (a instanceof an || a instanceof Yn || a instanceof ln) {
            if (a.getPoint(u / l, c), i !== void 0 && R7(i, c, sm)) continue;
            i === void 0 && (i = T0), i.copy(c), n1.push(c.x, c.y), s++;
        }
    }
    return om(n1[0], n1[n1.length - 2], sm) && om(n1[1], n1[n1.length - 1], sm) && (n1.pop(), n1.pop()), r && s > 1 && !(om(n1[s - 1], n1[1], sm) && om(n1[s - 2], n1[0], sm)) && (n1.push(n1[0], n1[1]), s++), n1;
}
var _1 = new k, B7 = new k, N7 = new k, F7 = new k, V7 = new k, k7 = new k, Xt = class extends la {
    constructor(e = 100, r = 100){
        super();
        this.points = [];
        this.shapeHoles = [];
        this.plane = new kr(new E(0, 0, -1));
        this.subdivision = 0;
        this.controlSnapDistance = 4;
        this.pointIDs = 0;
        this.isMesh2D = !1;
        this.isText = !1;
        this._roundness = 0;
        this.isClosed = !1;
        this.useCubicForRoundedCorners = !0;
        this.uuid = we.generateUUID();
        this.needsUpdate = !1;
        this.roundedCurves = [];
        this._width = e, this._height = r;
    }
    static createFromState(e, r, i) {
        let s = new Xt;
        return s.isClosed = e.isClosed, s.points = e.points.map((o)=>Ws.create(o.id, o.data)), typeof e.roundness == "number" && (s.roundness = e.roundness), s.shapeHoles = e.shapeHoles.map((o)=>Xt.createFromState(o)), r !== void 0 && i !== void 0 && s.applySize(r, i), s.update(), s;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get roundness() {
        return this._roundness;
    }
    set roundness(e) {
        if (this._roundness !== e) {
            this._roundness = e;
            for(let r = 0, i = this.points.length; r < i; r++)this.points[r].roundness = e;
            this.needsUpdate = !0;
        }
    }
    getPointsIndexesByIds(e) {
        return e.map((r)=>this.getPointIndexById(r)).filter((r)=>r >= 0);
    }
    getPointIndexById(e) {
        let r = this.points.length, i = this.points.findIndex((s)=>s.uuid === e);
        if (i < 0) {
            let s = r;
            for(let o = 0, a = this.shapeHoles.length; o < a; o++){
                let l = this.shapeHoles[o], c = l.points.length, u = l.getPointIndexById(e);
                if (u < 0) s += c;
                else return u + s;
            }
        }
        return i;
    }
    getLineIndexById(e) {
        return this.getPointIndexById(e);
    }
    getBezierPoint(e) {
        if (e <= this.points.length - 1) return this.points[e];
        if (this.shapeHoles.length > 0) {
            let r = this.points.length;
            for(let i = 0, s = this.shapeHoles.length; i < s; i++){
                let o = this.shapeHoles[i], a = e - r;
                if (a <= o.points.length - 1) return o.points[a];
                r += o.points.length;
            }
        }
        throw new Error("This shape does not have a point for this index: " + e);
    }
    getBezierPointIndex(e) {
        let r = this.points.indexOf(e);
        if (r >= 0) return r;
        if (r = this.points.length, this.shapeHoles.length > 0) for(let i = 0, s = this.shapeHoles.length; i < s; i++){
            let o = this.shapeHoles[i], a = o.points.indexOf(e);
            if (a >= 0) return r + a;
            r += o.points.length;
        }
        return -1;
    }
    getAllPoints() {
        let e = [].concat(...this.shapeHoles.map((r)=>r.points));
        return [
            ...this.points,
            ...e
        ];
    }
    applySize(e, r) {
        e === 0 && (e = .001), r === 0 && (r = .001), this._width = e, this._height = r;
    }
    applyScale(e, r) {
        let i = _1.set(e, r);
        for(let s = 0, o = this.points.length; s < o; s++){
            let a = this.points[s];
            a.position.multiply(i), a.controls[0].position.multiply(i), a.controls[1].position.multiply(i);
        }
        for(let s = 0, o = this.shapeHoles.length; s < o; s++)this.shapeHoles[s].applyScale(e, r);
        this._update();
    }
    createPoint(e, r = 0, i = we.generateUUID()) {
        let s;
        e instanceof k ? s = e : s = new k(e, r);
        let o = new Ws(i, s);
        return o.roundness = this.roundness, o;
    }
    addPoint(e) {
        this.points.push(e), this.needsUpdate = !0;
    }
    addPointAt(e, r) {
        this.points.splice(r, 0, e), this.needsUpdate = !0;
    }
    getPointByUuid(e) {
        for(let r = 0, i = this.points.length; r < i; r++){
            let s = this.points[r];
            if (s.uuid === e) return s;
        }
        for(let r = 0, i = this.shapeHoles.length; r < i; r++){
            let o = this.shapeHoles[r].getPointByUuid(e);
            if (o) return o;
        }
    }
    getFirstPoint() {
        return this.points[0];
    }
    getLastPoint() {
        return this.points[this.points.length - 1];
    }
    removePoint(e) {
        let r = this.points.indexOf(e);
        r >= 0 && this.points.splice(r, 1), this.needsUpdate = !0;
    }
    removePointById(e) {
        let r = this.points.find((i)=>i.uuid === e);
        r && this.removePoint(r);
    }
    update() {
        for(let e = 0, r = this.shapeHoles.length; e < r; e++)this.shapeHoles[e].update();
        this._update();
    }
    extractShapePointsToBuffer(e, r = 12, i = !1) {
        this.subdivision = r, this.curveDivisions === void 0 && this.computeCurveDivisions(r);
        let s = i ? this.roundedCurveDivisions : this.curveDivisions;
        return wO(e, i ? this.roundedCurves : this.curves, r, this.autoClose), s.reduce((o, a)=>o + a, 0) + 1;
    }
    computeCurveDivisions(e = 12) {
        return this.curveDivisions = P1(this.points, e, !1), this.roundedCurveDivisions = P1(this.points, e, !0), this.curveDivisions;
    }
    extractFilteredShapePointsToBuffer(e, r, i = 12) {
        return AO(e, this.curves, r, i, this.autoClose).reduce((o, a)=>o + a, 0) * 2;
    }
    extractShapePointsToFlatArray(e, r = 12) {
        return this.subdivision = r, this.curveDivisions === void 0 && this.computeCurveDivisions(r), EO(e, this.roundedCurves, r, this.autoClose);
    }
    getCurveIndexFromVertexId(e, r = !1) {
        let i = 0;
        this.curveDivisions === void 0 && this.computeCurveDivisions(this.subdivision);
        let s = r ? this.roundedCurveDivisions : this.curveDivisions, o = 0;
        r && this.points[0].roundedCurveCorner !== void 0 && (o = Ll(this.points[0].roundedCurveCorner, this.subdivision) * .5);
        let a = e - o;
        a < 0 && (a += s.reduce((l, c)=>l + c, 0));
        for(let l = 0, c = s.length; l < c; l++){
            let u = s[l];
            if (a < i + u) return [
                l,
                (a - i + 1) / u
            ];
            i += u;
        }
        return [
            0,
            1
        ];
    }
    getCurveT(e, r, i) {
        let s = this.points[e], o = this.points[e >= this.points.length - 1 ? 0 : e + 1], a = this.curveDivisions, l = a[e];
        if (C1(s, o)) {
            let h = s.position.distanceTo(o.position);
            return s.position.distanceTo(_1.set(i.x, i.y)) / h;
        }
        let c = 0;
        for(let h = 0; h < e; h++)c += a[h];
        return (r - c) / l;
    }
    dispose() {}
    _applyCurveForPoint(e, r) {
        C1(r, e) ? this.lineTo(e.position.x, e.position.y) : this.bezierCurveTo(r.controls[1].position.x, r.controls[1].position.y, e.controls[0].position.x, e.controls[0].position.y, e.position.x, e.position.y);
        let i = this.curves[this.curves.length - 1];
        e.curveBefore = i, r.curveAfter = i;
        let s = i.clone();
        e.roundedCurveBefore = s, r.roundedCurveAfter = s, e.roundedCurveCorner = void 0, this.roundedCurves.push(s);
    }
    _update() {
        if (this.curves = [], this.roundedCurves = [], !this.points.length) return;
        for(let r = 0, i = this.points.length; r < i; r++){
            let s = this.points[r];
            if (r === 0) this.moveTo(s.position.x, s.position.y);
            else {
                let o = this.points[r - 1];
                this._applyCurveForPoint(s, o);
            }
        }
        let e = this.getLastPoint();
        if (e?.curveAfter && (e.curveAfter = void 0), this.isClosed) {
            let r = this.points[0], i = this.points[this.points.length - 1];
            this._applyCurveForPoint(r, i);
        }
        if (this.points.length > 2) {
            let r = 0;
            for(let i = 0, s = this.points.length; i < s; i++){
                let o = this.points[i], a = this.points[i - 1] ?? this.points[this.points.length - 1], l = this.points[i + 1] ?? this.points[0], c = o.roundness, u = a && l && yO(a, o, l);
                if (!o.controlsMoved() && c > 0 && !u) {
                    let h = o.curveBefore, d = o.curveAfter;
                    if (h === void 0 || d === void 0) continue;
                    let f = o.roundedCurveBefore, p = o.roundedCurveAfter, m = h.getLength(), g = d.getLength(), y = Math.min(c, m * .499), x = Math.min(c, g * .499), v = Math.min(y, x), S = 1 - v / m, w = v / g, A = h.getPointAt(S, _1), T = d.getPointAt(w, B7);
                    this._subSplitCurve(h, f, S, A, void 0), this._subSplitCurve(d, p, w, void 0, T);
                    let b;
                    if (this.useCubicForRoundedCorners) {
                        let M = M1(A, o.position, T) / 2, C = Math.tan(M) * A.distanceTo(o.position), [P, I] = vO(A, T, C, N7, F7), _ = xO(P, I, o.position), [D, L] = bO(_, A, T, C, V7, k7);
                        b = new an(A.clone(), D.clone(), L.clone(), T.clone());
                    } else b = new Yn(A.clone(), o.position.clone(), T.clone());
                    o.roundedCurveCorner = b, this.roundedCurves.splice(i + r, 0, b), r++;
                }
            }
        }
    }
    _subSplitCurve(e, r, i, s, o) {
        if (e instanceof ln) s !== void 0 && r.v2.copy(s), o !== void 0 && r.v1.copy(o);
        else {
            let a = e, l = r, c = a.getUtoTmapping(i, 0), u = SO(a.v0, a.v1, a.v2, a.v3, c);
            return s !== void 0 && (l.v0.set(u[0], u[1]), l.v1.set(u[2], u[3]), l.v2.set(u[4], u[5]), l.v3.set(u[6], u[7])), o !== void 0 && (l.v0.set(u[6], u[7]), l.v1.set(u[8], u[9]), l.v2.set(u[10], u[11]), l.v3.set(u[12], u[13])), l;
        }
        return r;
    }
    clone() {
        let e = new Xt(this._width, this._height);
        return e.points = this.points.map((r)=>r.clone()), e.isClosed = this.isClosed, e.roundness = this.roundness, e.isMesh2D = this.isMesh2D, e.shapeHoles = this.shapeHoles.map((r)=>r.clone()), e;
    }
    toJSON() {
        return {
            points: this.points.reduce((e, r)=>e.concat(r.toJSON()), []),
            shapeHoles: this.shapeHoles.map((e)=>e.toJSON()),
            isClosed: this.isClosed,
            roundness: this.roundness
        };
    }
    fromJSON(e) {
        this.points = [], this.pointIDs = 0;
        let r = e.points.length / 7;
        for(let i = 0; i < r; i++){
            let s = i * 7, o = e.points[s + 0], a = e.points[s + 1], l = e.points[s + 2], c = e.points[s + 3], u = e.points[s + 4], h = e.points[s + 5], d = e.points[s + 6], f = new Ws(we.generateUUID(), new k(o, a));
            f.controls[0].position.set(l, c), f.controls[1].position.set(u, h), f.roundness = d, this.points.push(f);
        }
        return this.shapeHoles = e.shapeHoles?.length ? e.shapeHoles.map((i)=>{
            let s = new Xt;
            return s.fromJSON(i), s;
        }) : [], this.isClosed = e.isClosed, this._roundness = e.roundness, this._update(), this;
    }
    fromShape(e, r = !1) {
        this.isText = r;
        let i = (o, a)=>{
            a instanceof an && a.v3.equals(o.position) && o.controls[0].position.copy(a.v2);
        }, s = (o)=>{
            let a = [], l, c;
            for(l = 0, c = o.length; l < c; l++)o[l] instanceof Yn && (o[l] = gO(o[l]));
            for(l = 0, c = o.length; l < c; l++){
                let d = o[l], f = l > 0 ? o[l - 1] : null, p;
                d instanceof an ? (p = this.createPoint(d.v0), p.controls[1].position.copy(d.v1)) : d instanceof ln && (p = this.createPoint(d.v1)), p !== void 0 && (f !== null && i(p, f), a.push(p));
            }
            let u = o[o.length - 1], h = !1;
            return u instanceof an ? u.v3.equals(a[0].position) && (a[0].controls[0].position.copy(u.v2), h = !0) : u instanceof ln && u.v2.equals(a[0].position) && (h = !0), this.isClosed = h, a;
        };
        return this.points = s(e.curves), e instanceof la && (this.shapeHoles = e.holes.map((o)=>{
            let a = new Xt;
            return a.fromShape(o), a;
        })), this.update(), this;
    }
    updatePoint(e, r) {
        let i = this.getPointByUuid(e);
        i && (r.position !== void 0 && i.position.fromArray(r.position), r.roundness !== void 0 && (i.roundness = r.roundness), r.areControlsDirectionsMirrored !== void 0 && (i.areControlsDirectionsMirrored = r.areControlsDirectionsMirrored), this.needsUpdate = !0);
    }
    updatePreviousControl(e, r) {
        let s = this.getPointByUuid(e)?.controls[0];
        s && (r.position && s.position.fromArray(r.position), this.needsUpdate = !0);
    }
    updateNextControl(e, r) {
        let s = this.getPointByUuid(e)?.controls[1];
        s && (r.position && s.position.fromArray(r.position), this.needsUpdate = !0);
    }
};
var D1 = Math.PI * 2;
function I1({ x: n1, y: t }, e, r, i, s) {
    return {
        x: n1 * e + i,
        y: t * r + s
    };
}
function U7(n1, t) {
    let e = t === 1.5707963267948966 ? .551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), r = Math.cos(n1), i = Math.sin(n1), s = Math.cos(n1 + t), o = Math.sin(n1 + t);
    return [
        {
            x: r - i * e,
            y: i + r * e
        },
        {
            x: s + o * e,
            y: o - s * e
        },
        {
            x: s,
            y: o
        }
    ];
}
function TO(n1, t, e, r) {
    let i = n1 * r - t * e < 0 ? -1 : 1, s = Math.min(1, Math.max(-1, n1 * e + t * r));
    return i * Math.acos(s);
}
function z7(n1, t, e, r, i, s, o, a, l, c) {
    let u = Math.pow(i, 2), h = Math.pow(s, 2), d = Math.pow(o, 2), f = Math.pow(a, 2), p = u * h - u * f - h * d;
    p < 0 && (p = 0), p /= u * f + h * d, p = Math.sqrt(p) * (l === c ? -1 : 1);
    let m = p * i / s * a, g = p * -s / i * o, y = m + (n1 + e) / 2, x = g + (t + r) / 2, v = (o - m) / i, S = (a - g) / s, w = (-o - m) / i, A = (-a - g) / s, T = TO(1, 0, v, S), b = TO(v, S, w, A);
    return !c && b > 0 && (b -= D1), c && b < 0 && (b += D1), {
        centerx: y,
        centery: x,
        ang1: T,
        ang2: b
    };
}
function MO({ px: n1, py: t, cx: e, cy: r, rx: i, ry: s, largeArcFlag: o, sweepFlag: a }) {
    let l = [];
    if (i === 0 || s === 0) return [];
    let c = (n1 - e) / 2, u = (t - r) / 2;
    if (c === 0 && u === 0) return [];
    i = Math.abs(i), s = Math.abs(s);
    let h = Math.pow(c, 2) / Math.pow(i, 2) + Math.pow(u, 2) / Math.pow(s, 2);
    h > 1 && (i *= Math.sqrt(h), s *= Math.sqrt(h));
    let d = z7(n1, t, e, r, i, s, c, u, o, a), { ang1: f, ang2: p } = d, { centerx: m, centery: g } = d, y = Math.abs(p) / (D1 / 4);
    Math.abs(1 - y) < 1e-7 && (y = 1);
    let x = Math.max(Math.ceil(y), 1);
    p /= x;
    for(let v = 0; v < x; v++)l.push(U7(f, p)), f += p;
    return l.map((v)=>{
        let { x: S, y: w } = I1(v[0], i, s, m, g), { x: A, y: T } = I1(v[1], i, s, m, g), { x: b, y: M } = I1(v[2], i, s, m, g);
        return {
            x1: S,
            y1: w,
            x2: A,
            y2: T,
            x: b,
            y: M
        };
    });
}
var Gt;
(function(n1) {
    n1[n1.ODD = 0] = "ODD", n1[n1.NONZERO = 1] = "NONZERO", n1[n1.POSITIVE = 2] = "POSITIVE", n1[n1.NEGATIVE = 3] = "NEGATIVE", n1[n1.ABS_GEQ_TWO = 4] = "ABS_GEQ_TWO";
})(Gt || (Gt = {}));
var jr;
(function(n1) {
    n1[n1.POLYGONS = 0] = "POLYGONS", n1[n1.CONNECTED_POLYGONS = 1] = "CONNECTED_POLYGONS", n1[n1.BOUNDARY_CONTOURS = 2] = "BOUNDARY_CONTOURS";
})(jr || (jr = {}));
function ut(n1, t) {
    if (!n1) throw t || "Assertion Failed!";
}
var ot = function() {
    function n1() {}
    return n1.vertEq = function(t, e) {
        return t.s === e.s && t.t === e.t;
    }, n1.vertLeq = function(t, e) {
        return t.s < e.s || t.s === e.s && t.t <= e.t;
    }, n1.transLeq = function(t, e) {
        return t.t < e.t || t.t === e.t && t.s <= e.s;
    }, n1.edgeGoesLeft = function(t) {
        return n1.vertLeq(t.Dst, t.Org);
    }, n1.edgeGoesRight = function(t) {
        return n1.vertLeq(t.Org, t.Dst);
    }, n1.vertL1dist = function(t, e) {
        return Math.abs(t.s - e.s) + Math.abs(t.t - e.t);
    }, n1.edgeEval = function(t, e, r) {
        ut(n1.vertLeq(t, e) && n1.vertLeq(e, r));
        var i = e.s - t.s, s = r.s - e.s;
        return i + s > 0 ? i < s ? e.t - t.t + (t.t - r.t) * (i / (i + s)) : e.t - r.t + (r.t - t.t) * (s / (i + s)) : 0;
    }, n1.edgeSign = function(t, e, r) {
        ut(n1.vertLeq(t, e) && n1.vertLeq(e, r));
        var i = e.s - t.s, s = r.s - e.s;
        return i + s > 0 ? (e.t - r.t) * i + (e.t - t.t) * s : 0;
    }, n1.transEval = function(t, e, r) {
        ut(n1.transLeq(t, e) && n1.transLeq(e, r));
        var i = e.t - t.t, s = r.t - e.t;
        return i + s > 0 ? i < s ? e.s - t.s + (t.s - r.s) * (i / (i + s)) : e.s - r.s + (r.s - t.s) * (s / (i + s)) : 0;
    }, n1.transSign = function(t, e, r) {
        ut(n1.transLeq(t, e) && n1.transLeq(e, r));
        var i = e.t - t.t, s = r.t - e.t;
        return i + s > 0 ? (e.s - r.s) * i + (e.s - t.s) * s : 0;
    }, n1.vertCCW = function(t, e, r) {
        return t.s * (e.t - r.t) + e.s * (r.t - t.t) + r.s * (t.t - e.t) >= 0;
    }, n1.interpolate = function(t, e, r, i) {
        return t = t < 0 ? 0 : t, r = r < 0 ? 0 : r, t <= r ? r === 0 ? (e + i) / 2 : e + (i - e) * (t / (t + r)) : i + (e - i) * (r / (t + r));
    }, n1.intersect = function(t, e, r, i, s) {
        var o, a, l;
        n1.vertLeq(t, e) || (l = t, t = e, e = l), n1.vertLeq(r, i) || (l = r, r = i, i = l), n1.vertLeq(t, r) || (l = t, t = r, r = l, l = e, e = i, i = l), n1.vertLeq(r, e) ? n1.vertLeq(e, i) ? (o = n1.edgeEval(t, r, e), a = n1.edgeEval(r, e, i), o + a < 0 && (o = -o, a = -a), s.s = n1.interpolate(o, r.s, a, e.s)) : (o = n1.edgeSign(t, r, e), a = -n1.edgeSign(t, i, e), o + a < 0 && (o = -o, a = -a), s.s = n1.interpolate(o, r.s, a, i.s)) : s.s = (r.s + e.s) / 2, n1.transLeq(t, e) || (l = t, t = e, e = l), n1.transLeq(r, i) || (l = r, r = i, i = l), n1.transLeq(t, r) || (l = t, t = r, r = l, l = e, e = i, i = l), n1.transLeq(r, e) ? n1.transLeq(e, i) ? (o = n1.transEval(t, r, e), a = n1.transEval(r, e, i), o + a < 0 && (o = -o, a = -a), s.t = n1.interpolate(o, r.t, a, e.t)) : (o = n1.transSign(t, r, e), a = -n1.transSign(t, i, e), o + a < 0 && (o = -o, a = -a), s.t = n1.interpolate(o, r.t, a, i.t)) : s.t = (r.t + e.t) / 2;
    }, n1;
}(), am = function() {
    function n1() {
        this.next = null, this.prev = null, this.anEdge = null, this.trail = null, this.n = 0, this.marked = !1, this.inside = !1;
    }
    return n1;
}(), M0 = function() {
    function n1(t) {
        this.side = t, this.next = null, this.Org = null, this.Sym = null, this.Onext = null, this.Lnext = null, this.Lface = null, this.activeRegion = null, this.winding = 0;
    }
    return Object.defineProperty(n1.prototype, "Rface", {
        get: function() {
            return this.Sym.Lface;
        },
        set: function(t) {
            this.Sym.Lface = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dst", {
        get: function() {
            return this.Sym.Org;
        },
        set: function(t) {
            this.Sym.Org = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Oprev", {
        get: function() {
            return this.Sym.Lnext;
        },
        set: function(t) {
            this.Sym.Lnext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Lprev", {
        get: function() {
            return this.Onext.Sym;
        },
        set: function(t) {
            this.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dprev", {
        get: function() {
            return this.Lnext.Sym;
        },
        set: function(t) {
            this.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Rprev", {
        get: function() {
            return this.Sym.Onext;
        },
        set: function(t) {
            this.Sym.Onext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dnext", {
        get: function() {
            return this.Sym.Onext.Sym;
        },
        set: function(t) {
            this.Sym.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Rnext", {
        get: function() {
            return this.Sym.Lnext.Sym;
        },
        set: function(t) {
            this.Sym.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), n1;
}(), Sd = function() {
    function n1() {
        this.next = null, this.prev = null, this.anEdge = null, this.coords = [
            0,
            0,
            0
        ], this.s = 0, this.t = 0, this.pqHandle = 0, this.n = 0, this.idx = 0;
    }
    return n1;
}(), CO = function() {
    function n1() {
        var t = new Sd, e = new am, r = new M0(0), i = new M0(1);
        t.next = t.prev = t, t.anEdge = null, e.next = e.prev = e, r.next = r, r.Sym = i, i.next = i, i.Sym = r, this.vHead = t, this.fHead = e, this.eHead = r, this.eHeadSym = i;
    }
    return n1.prototype.makeEdge_ = function(t) {
        var e = new M0(0), r = new M0(1);
        t.Sym.side < t.side && (t = t.Sym);
        var i = t.Sym.next;
        return r.next = i, i.Sym.next = e, e.next = t, t.Sym.next = r, e.Sym = r, e.Onext = e, e.Lnext = r, e.Org = null, e.Lface = null, e.winding = 0, e.activeRegion = null, r.Sym = e, r.Onext = r, r.Lnext = e, r.Org = null, r.Lface = null, r.winding = 0, r.activeRegion = null, e;
    }, n1.prototype.splice_ = function(t, e) {
        var r = t.Onext, i = e.Onext;
        r.Sym.Lnext = e, i.Sym.Lnext = t, t.Onext = i, e.Onext = r;
    }, n1.prototype.makeVertex_ = function(t, e, r) {
        var i = t;
        ut(i, "Vertex can't be null!");
        var s = r.prev;
        i.prev = s, s.next = i, i.next = r, r.prev = i, i.anEdge = e;
        var o = e;
        do o.Org = i, o = o.Onext;
        while (o !== e);
    }, n1.prototype.makeFace_ = function(t, e, r) {
        var i = t;
        ut(i, "Face can't be null");
        var s = r.prev;
        i.prev = s, s.next = i, i.next = r, r.prev = i, i.anEdge = e, i.trail = null, i.marked = !1, i.inside = r.inside;
        var o = e;
        do o.Lface = i, o = o.Lnext;
        while (o !== e);
    }, n1.prototype.killEdge_ = function(t) {
        t.Sym.side < t.side && (t = t.Sym);
        var e = t.next, r = t.Sym.next;
        e.Sym.next = r, r.Sym.next = e;
    }, n1.prototype.killVertex_ = function(t, e) {
        var r = t.anEdge, i = r;
        do i.Org = e, i = i.Onext;
        while (i !== r);
        var s = t.prev, o = t.next;
        o.prev = s, s.next = o;
    }, n1.prototype.killFace_ = function(t, e) {
        var r = t.anEdge, i = r;
        do i.Lface = e, i = i.Lnext;
        while (i !== r);
        var s = t.prev, o = t.next;
        o.prev = s, s.next = o;
    }, n1.prototype.makeEdge = function() {
        var t = new Sd, e = new Sd, r = new am, i = this.makeEdge_(this.eHead);
        return this.makeVertex_(t, i, this.vHead), this.makeVertex_(e, i.Sym, this.vHead), this.makeFace_(r, i, this.fHead), i;
    }, n1.prototype.splice = function(t, e) {
        var r = !1, i = !1;
        if (t !== e) {
            if (e.Org !== t.Org && (i = !0, this.killVertex_(e.Org, t.Org)), e.Lface !== t.Lface && (r = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(e, t), !i) {
                var s = new Sd;
                this.makeVertex_(s, e, t.Org), t.Org.anEdge = t;
            }
            if (!r) {
                var o = new am;
                this.makeFace_(o, e, t.Lface), t.Lface.anEdge = t;
            }
        }
    }, n1.prototype.delete = function(t) {
        var e = t.Sym, r = !1;
        if (t.Lface !== t.Rface && (r = !0, this.killFace_(t.Lface, t.Rface)), t.Onext === t) this.killVertex_(t.Org, null);
        else if (t.Rface.anEdge = t.Oprev, t.Org.anEdge = t.Onext, this.splice_(t, t.Oprev), !r) {
            var i = new am;
            this.makeFace_(i, t, t.Lface);
        }
        e.Onext === e ? (this.killVertex_(e.Org, null), this.killFace_(e.Lface, null)) : (t.Lface.anEdge = e.Oprev, e.Org.anEdge = e.Onext, this.splice_(e, e.Oprev)), this.killEdge_(t);
    }, n1.prototype.addEdgeVertex = function(t) {
        var e = this.makeEdge_(t), r = e.Sym;
        this.splice_(e, t.Lnext), e.Org = t.Dst;
        var i = new Sd;
        return this.makeVertex_(i, r, e.Org), e.Lface = r.Lface = t.Lface, e;
    }, n1.prototype.splitEdge = function(t) {
        var e = this.addEdgeVertex(t), r = e.Sym;
        return this.splice_(t.Sym, t.Sym.Oprev), this.splice_(t.Sym, r), t.Dst = r.Org, r.Dst.anEdge = r.Sym, r.Rface = t.Rface, r.winding = t.winding, r.Sym.winding = t.Sym.winding, r.idx = t.idx, r.Sym.idx = t.Sym.idx, r;
    }, n1.prototype.connect = function(t, e) {
        var r = !1, i = this.makeEdge_(t), s = i.Sym;
        if (e.Lface !== t.Lface && (r = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(i, t.Lnext), this.splice_(s, e), i.Org = t.Dst, s.Org = e.Org, i.Lface = s.Lface = t.Lface, t.Lface.anEdge = s, !r) {
            var o = new am;
            this.makeFace_(o, i, t.Lface);
        }
        return i;
    }, n1.prototype.zapFace = function(t) {
        var e = t.anEdge, r, i, s, o, a;
        i = e.Lnext;
        do r = i, i = r.Lnext, r.Lface = null, r.Rface === null && (r.Onext === r ? this.killVertex_(r.Org, null) : (r.Org.anEdge = r.Onext, this.splice_(r, r.Oprev)), s = r.Sym, s.Onext === s ? this.killVertex_(s.Org, null) : (s.Org.anEdge = s.Onext, this.splice_(s, s.Oprev)), this.killEdge_(r));
        while (r != e);
        o = t.prev, a = t.next, a.prev = o, o.next = a;
    }, n1.prototype.countFaceVerts_ = function(t) {
        var e = t.anEdge, r = 0;
        do r++, e = e.Lnext;
        while (e !== t.anEdge);
        return r;
    }, n1.prototype.mergeConvexFaces = function(t) {
        var e, r, i, s, o, a, l;
        for(e = this.fHead.next; e !== this.fHead; e = e.next)if (!!e.inside) for(r = e.anEdge, o = r.Org; i = r.Lnext, s = r.Sym, s && s.Lface && s.Lface.inside && (a = this.countFaceVerts_(e), l = this.countFaceVerts_(s.Lface), a + l - 2 <= t && ot.vertCCW(r.Lprev.Org, r.Org, s.Lnext.Lnext.Org) && ot.vertCCW(s.Lprev.Org, s.Org, r.Lnext.Lnext.Org) && (i = s.Lnext, this.delete(s), r = null, s = null)), !(r && r.Lnext.Org === o);)r = i;
        return !0;
    }, n1.prototype.check = function() {
        var t = this.fHead, e = this.vHead, r = this.eHead, i, s, o, a, l, c;
        for(s = t, s = t; (i = s.next) !== t; s = i){
            ut(i.prev === s), l = i.anEdge;
            do ut(l.Sym !== l), ut(l.Sym.Sym === l), ut(l.Lnext.Onext.Sym === l), ut(l.Onext.Sym.Lnext === l), ut(l.Lface === i), l = l.Lnext;
            while (l !== i.anEdge);
        }
        for(ut(i.prev === s && i.anEdge === null), a = e, a = e; (o = a.next) !== e; a = o){
            ut(o.prev === a), l = o.anEdge;
            do ut(l.Sym !== l), ut(l.Sym.Sym === l), ut(l.Lnext.Onext.Sym === l), ut(l.Onext.Sym.Lnext === l), ut(l.Org === o), l = l.Onext;
            while (l !== o.anEdge);
        }
        for(ut(o.prev === a && o.anEdge === null), c = r, c = r; (l = c.next) !== r; c = l)ut(l.Sym.next === c.Sym), ut(l.Sym !== l), ut(l.Sym.Sym === l), ut(l.Org !== null), ut(l.Dst !== null), ut(l.Lnext.Onext.Sym === l), ut(l.Onext.Sym.Lnext === l);
        ut(l.Sym.next === c.Sym && l.Sym === this.eHeadSym && l.Sym.Sym === l && l.Org === null && l.Dst === null && l.Lface === null && l.Rface === null);
    }, n1;
}(), PO = function() {
    function n1() {
        this.handle = null;
    }
    return n1;
}(), _O = function() {
    function n1() {
        this.key = null, this.node = 0;
    }
    return n1;
}(), G7 = function() {
    function n1(t, e) {
        this.leq = e, this.max = 0, this.nodes = [], this.handles = [], this.initialized = !1, this.freeList = 0, this.size = 0, this.max = t, this.nodes = [], this.handles = [];
        for(var r = 0; r < t + 1; r++)this.nodes[r] = new PO, this.handles[r] = new _O;
        this.initialized = !1, this.nodes[1].handle = 1, this.handles[1].key = null;
    }
    return n1.prototype.floatDown_ = function(t) {
        var e = this.nodes, r = this.handles, i, s, o;
        for(i = e[t].handle;;){
            if (o = t << 1, o < this.size && this.leq(r[e[o + 1].handle].key, r[e[o].handle].key) && ++o, ut(o <= this.max), s = e[o].handle, o > this.size || this.leq(r[i].key, r[s].key)) {
                e[t].handle = i, r[i].node = t;
                break;
            }
            e[t].handle = s, r[s].node = t, t = o;
        }
    }, n1.prototype.floatUp_ = function(t) {
        var e = this.nodes, r = this.handles, i, s, o;
        for(i = e[t].handle;;){
            if (o = t >> 1, s = e[o].handle, o === 0 || this.leq(r[s].key, r[i].key)) {
                e[t].handle = i, r[i].node = t;
                break;
            }
            e[t].handle = s, r[s].node = t, t = o;
        }
    }, n1.prototype.init = function() {
        for(var t = this.size; t >= 1; --t)this.floatDown_(t);
        this.initialized = !0;
    }, n1.prototype.min = function() {
        return this.handles[this.nodes[1].handle].key;
    }, n1.prototype.insert = function(t) {
        var e, r;
        if (e = ++this.size, e * 2 > this.max) {
            this.max *= 2;
            var i, s;
            for(s = this.nodes.length, this.nodes.length = this.max + 1, i = s; i < this.nodes.length; i++)this.nodes[i] = new PO;
            for(s = this.handles.length, this.handles.length = this.max + 1, i = s; i < this.handles.length; i++)this.handles[i] = new _O;
        }
        return this.freeList === 0 ? r = e : (r = this.freeList, this.freeList = this.handles[r].node), this.nodes[e].handle = r, this.handles[r].node = e, this.handles[r].key = t, this.initialized && this.floatUp_(e), r;
    }, n1.prototype.extractMin = function() {
        var t = this.nodes, e = this.handles, r = t[1].handle, i = e[r].key;
        return this.size > 0 && (t[1].handle = t[this.size].handle, e[t[1].handle].node = 1, e[r].key = null, e[r].node = this.freeList, this.freeList = r, --this.size, this.size > 0 && this.floatDown_(1)), i;
    }, n1.prototype.delete = function(t) {
        var e = this.nodes, r = this.handles, i;
        ut(t >= 1 && t <= this.max && r[t].key !== null), i = r[t].node, e[i].handle = e[this.size].handle, r[e[i].handle].node = i, --this.size, i <= this.size && (i <= 1 || this.leq(r[e[i >> 1].handle].key, r[e[i].handle].key) ? this.floatDown_(i) : this.floatUp_(i)), r[t].key = null, r[t].node = this.freeList, this.freeList = t;
    }, n1;
}(), O1 = function() {
    function n1() {
        this.eUp = null, this.nodeUp = null, this.windingNumber = 0, this.inside = !1, this.sentinel = !1, this.dirty = !1, this.fixUpperEdge = !1;
    }
    return n1;
}(), IO = function() {
    function n1() {
        this.key = null, this.next = null, this.prev = null;
    }
    return n1;
}(), j7 = function() {
    function n1(t, e) {
        this.frame = t, this.leq = e, this.head = new IO, this.head.next = this.head, this.head.prev = this.head;
    }
    return n1.prototype.min = function() {
        return this.head.next;
    }, n1.prototype.max = function() {
        return this.head.prev;
    }, n1.prototype.insert = function(t) {
        return this.insertBefore(this.head, t);
    }, n1.prototype.search = function(t) {
        var e = this.head;
        do e = e.next;
        while (e.key !== null && !this.leq(this.frame, t, e.key));
        return e;
    }, n1.prototype.insertBefore = function(t, e) {
        do t = t.prev;
        while (t.key !== null && !this.leq(this.frame, t.key, e));
        var r = new IO;
        return r.key = e, r.next = t.next, t.next.prev = r, r.prev = t, t.next = r, r;
    }, n1.prototype.delete = function(t) {
        t.next.prev = t.prev, t.prev.next = t.next;
    }, n1;
}(), H7 = function() {
    function n1() {}
    return n1.regionBelow = function(t) {
        return t.nodeUp.prev.key;
    }, n1.regionAbove = function(t) {
        return t.nodeUp.next.key;
    }, n1.debugEvent = function(t) {}, n1.addWinding = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, n1.edgeLeq = function(t, e, r) {
        var i = t.event, s = e.eUp, o = r.eUp;
        if (s.Dst === i) return o.Dst === i ? ot.vertLeq(s.Org, o.Org) ? ot.edgeSign(o.Dst, s.Org, o.Org) <= 0 : ot.edgeSign(s.Dst, o.Org, s.Org) >= 0 : ot.edgeSign(o.Dst, i, o.Org) <= 0;
        if (o.Dst === i) return ot.edgeSign(s.Dst, i, s.Org) >= 0;
        var a = ot.edgeEval(s.Dst, i, s.Org), l = ot.edgeEval(o.Dst, i, o.Org);
        return a >= l;
    }, n1.deleteRegion = function(t, e) {
        e.fixUpperEdge && ut(e.eUp.winding === 0), e.eUp.activeRegion = null, t.dict.delete(e.nodeUp);
    }, n1.fixUpperEdge = function(t, e, r) {
        ut(e.fixUpperEdge), t.mesh.delete(e.eUp), e.fixUpperEdge = !1, e.eUp = r, r.activeRegion = e;
    }, n1.topLeftRegion = function(t, e) {
        var r = e.eUp.Org, i;
        do e = n1.regionAbove(e);
        while (e.eUp.Org === r);
        if (e.fixUpperEdge) {
            if (i = t.mesh.connect(n1.regionBelow(e).eUp.Sym, e.eUp.Lnext), i === null) return null;
            n1.fixUpperEdge(t, e, i), e = n1.regionAbove(e);
        }
        return e;
    }, n1.topRightRegion = function(t) {
        var e = t.eUp.Dst;
        do t = n1.regionAbove(t);
        while (t.eUp.Dst === e);
        return t;
    }, n1.addRegionBelow = function(t, e, r) {
        var i = new O1;
        return i.eUp = r, i.nodeUp = t.dict.insertBefore(e.nodeUp, i), i.fixUpperEdge = !1, i.sentinel = !1, i.dirty = !1, r.activeRegion = i, i;
    }, n1.isWindingInside = function(t, e) {
        switch(t.windingRule){
            case Gt.ODD:
                return (e & 1) !== 0;
            case Gt.NONZERO:
                return e !== 0;
            case Gt.POSITIVE:
                return e > 0;
            case Gt.NEGATIVE:
                return e < 0;
            case Gt.ABS_GEQ_TWO:
                return e >= 2 || e <= -2;
        }
        throw new Error("Invalid winding rulle");
    }, n1.computeWinding = function(t, e) {
        e.windingNumber = n1.regionAbove(e).windingNumber + e.eUp.winding, e.inside = n1.isWindingInside(t, e.windingNumber);
    }, n1.finishRegion = function(t, e) {
        var r = e.eUp, i = r.Lface;
        i.inside = e.inside, i.anEdge = r, n1.deleteRegion(t, e);
    }, n1.finishLeftRegions = function(t, e, r) {
        for(var i, s = null, o = e, a = e.eUp; o !== r;){
            if (o.fixUpperEdge = !1, s = n1.regionBelow(o), i = s.eUp, i.Org != a.Org) {
                if (!s.fixUpperEdge) {
                    n1.finishRegion(t, o);
                    break;
                }
                i = t.mesh.connect(a.Lprev, i.Sym), n1.fixUpperEdge(t, s, i);
            }
            a.Onext !== i && (t.mesh.splice(i.Oprev, i), t.mesh.splice(a, i)), n1.finishRegion(t, o), a = s.eUp, o = s;
        }
        return a;
    }, n1.addRightEdges = function(t, e, r, i, s, o) {
        var a, l, c, u, h = !0;
        c = r;
        do ut(ot.vertLeq(c.Org, c.Dst)), n1.addRegionBelow(t, e, c.Sym), c = c.Onext;
        while (c !== i);
        for(s === null && (s = n1.regionBelow(e).eUp.Rprev), l = e, u = s; a = n1.regionBelow(l), c = a.eUp.Sym, c.Org === u.Org;)c.Onext !== u && (t.mesh.splice(c.Oprev, c), t.mesh.splice(u.Oprev, c)), a.windingNumber = l.windingNumber - c.winding, a.inside = n1.isWindingInside(t, a.windingNumber), l.dirty = !0, !h && n1.checkForRightSplice(t, l) && (n1.addWinding(c, u), n1.deleteRegion(t, l), t.mesh.delete(u)), h = !1, l = a, u = c;
        l.dirty = !0, ut(l.windingNumber - c.winding === a.windingNumber), o && n1.walkDirtyRegions(t, l);
    }, n1.spliceMergeVertices = function(t, e, r) {
        t.mesh.splice(e, r);
    }, n1.vertexWeights = function(t, e, r) {
        var i = ot.vertL1dist(e, t), s = ot.vertL1dist(r, t), o = .5 * s / (i + s), a = .5 * i / (i + s);
        t.coords[0] += o * e.coords[0] + a * r.coords[0], t.coords[1] += o * e.coords[1] + a * r.coords[1], t.coords[2] += o * e.coords[2] + a * r.coords[2];
    }, n1.getIntersectData = function(t, e, r, i, s, o) {
        e.coords[0] = e.coords[1] = e.coords[2] = 0, e.idx = -1, n1.vertexWeights(e, r, i), n1.vertexWeights(e, s, o);
    }, n1.checkForRightSplice = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s = r.eUp;
        if (ot.vertLeq(i.Org, s.Org)) {
            if (ot.edgeSign(s.Dst, i.Org, s.Org) > 0) return !1;
            ot.vertEq(i.Org, s.Org) ? i.Org !== s.Org && (t.pq.delete(i.Org.pqHandle), n1.spliceMergeVertices(t, s.Oprev, i)) : (t.mesh.splitEdge(s.Sym), t.mesh.splice(i, s.Oprev), e.dirty = r.dirty = !0);
        } else {
            if (ot.edgeSign(i.Dst, s.Org, i.Org) < 0) return !1;
            n1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), t.mesh.splice(s.Oprev, i);
        }
        return !0;
    }, n1.checkForLeftSplice = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s = r.eUp, o;
        if (ut(!ot.vertEq(i.Dst, s.Dst)), ot.vertLeq(i.Dst, s.Dst)) {
            if (ot.edgeSign(i.Dst, s.Dst, i.Org) < 0) return !1;
            n1.regionAbove(e).dirty = e.dirty = !0, o = t.mesh.splitEdge(i), t.mesh.splice(s.Sym, o), o.Lface.inside = e.inside;
        } else {
            if (ot.edgeSign(s.Dst, i.Dst, s.Org) > 0) return !1;
            e.dirty = r.dirty = !0, o = t.mesh.splitEdge(s), t.mesh.splice(i.Lnext, s.Sym), o.Rface.inside = e.inside;
        }
        return !0;
    }, n1.checkForIntersect = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s = r.eUp, o = i.Org, a = s.Org, l = i.Dst, c = s.Dst, u, h, d = new Sd, f, p;
        if (ut(!ot.vertEq(c, l)), ut(ot.edgeSign(l, t.event, o) <= 0), ut(ot.edgeSign(c, t.event, a) >= 0), ut(o !== t.event && a !== t.event), ut(!e.fixUpperEdge && !r.fixUpperEdge), o === a || (u = Math.min(o.t, l.t), h = Math.max(a.t, c.t), u > h)) return !1;
        if (ot.vertLeq(o, a)) {
            if (ot.edgeSign(c, o, a) > 0) return !1;
        } else if (ot.edgeSign(l, a, o) < 0) return !1;
        return n1.debugEvent(t), ot.intersect(l, o, c, a, d), ut(Math.min(o.t, l.t) <= d.t), ut(d.t <= Math.max(a.t, c.t)), ut(Math.min(c.s, l.s) <= d.s), ut(d.s <= Math.max(a.s, o.s)), ot.vertLeq(d, t.event) && (d.s = t.event.s, d.t = t.event.t), f = ot.vertLeq(o, a) ? o : a, ot.vertLeq(f, d) && (d.s = f.s, d.t = f.t), ot.vertEq(d, o) || ot.vertEq(d, a) ? (n1.checkForRightSplice(t, e), !1) : !ot.vertEq(l, t.event) && ot.edgeSign(l, t.event, d) >= 0 || !ot.vertEq(c, t.event) && ot.edgeSign(c, t.event, d) <= 0 ? c === t.event ? (t.mesh.splitEdge(i.Sym), t.mesh.splice(s.Sym, i), e = n1.topLeftRegion(t, e), i = n1.regionBelow(e).eUp, n1.finishLeftRegions(t, n1.regionBelow(e), r), n1.addRightEdges(t, e, i.Oprev, i, i, !0), !0) : l === t.event ? (t.mesh.splitEdge(s.Sym), t.mesh.splice(i.Lnext, s.Oprev), r = e, e = n1.topRightRegion(e), p = n1.regionBelow(e).eUp.Rprev, r.eUp = s.Oprev, s = n1.finishLeftRegions(t, r, null), n1.addRightEdges(t, e, s.Onext, i.Rprev, p, !0), !0) : (ot.edgeSign(l, t.event, d) >= 0 && (n1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), i.Org.s = t.event.s, i.Org.t = t.event.t), ot.edgeSign(c, t.event, d) <= 0 && (e.dirty = r.dirty = !0, t.mesh.splitEdge(s.Sym), s.Org.s = t.event.s, s.Org.t = t.event.t), !1) : (t.mesh.splitEdge(i.Sym), t.mesh.splitEdge(s.Sym), t.mesh.splice(s.Oprev, i), i.Org.s = d.s, i.Org.t = d.t, i.Org.pqHandle = t.pq.insert(i.Org), n1.getIntersectData(t, i.Org, o, l, a, c), n1.regionAbove(e).dirty = e.dirty = r.dirty = !0, !1);
    }, n1.walkDirtyRegions = function(t, e) {
        for(var r = n1.regionBelow(e), i, s;;){
            for(; r.dirty;)e = r, r = n1.regionBelow(r);
            if (!e.dirty && (r = e, e = n1.regionAbove(e), e === null || !e.dirty)) return;
            if (e.dirty = !1, i = e.eUp, s = r.eUp, i.Dst !== s.Dst && n1.checkForLeftSplice(t, e) && (r.fixUpperEdge ? (n1.deleteRegion(t, r), t.mesh.delete(s), r = n1.regionBelow(e), s = r.eUp) : e.fixUpperEdge && (n1.deleteRegion(t, e), t.mesh.delete(i), e = n1.regionAbove(r), i = e.eUp)), i.Org !== s.Org) {
                if (i.Dst !== s.Dst && !e.fixUpperEdge && !r.fixUpperEdge && (i.Dst === t.event || s.Dst === t.event)) {
                    if (n1.checkForIntersect(t, e)) return;
                } else n1.checkForRightSplice(t, e);
            }
            i.Org === s.Org && i.Dst === s.Dst && (n1.addWinding(s, i), n1.deleteRegion(t, e), t.mesh.delete(i), e = n1.regionAbove(r));
        }
    }, n1.connectRightVertex = function(t, e, r) {
        var i, s = r.Onext, o = n1.regionBelow(e), a = e.eUp, l = o.eUp, c = !1;
        if (a.Dst !== l.Dst && n1.checkForIntersect(t, e), ot.vertEq(a.Org, t.event) && (t.mesh.splice(s.Oprev, a), e = n1.topLeftRegion(t, e), s = n1.regionBelow(e).eUp, n1.finishLeftRegions(t, n1.regionBelow(e), o), c = !0), ot.vertEq(l.Org, t.event) && (t.mesh.splice(r, l.Oprev), r = n1.finishLeftRegions(t, o, null), c = !0), c) {
            n1.addRightEdges(t, e, r.Onext, s, s, !0);
            return;
        }
        ot.vertLeq(l.Org, a.Org) ? i = l.Oprev : i = a, i = t.mesh.connect(r.Lprev, i), n1.addRightEdges(t, e, i, i.Onext, i.Onext, !1), i.Sym.activeRegion.fixUpperEdge = !0, n1.walkDirtyRegions(t, e);
    }, n1.connectLeftDegenerate = function(t, e, r) {
        var i, s, o, a, l;
        if (i = e.eUp, ot.vertEq(i.Org, r)) {
            ut(!1), n1.spliceMergeVertices(t, i, r.anEdge);
            return;
        }
        if (!ot.vertEq(i.Dst, r)) {
            t.mesh.splitEdge(i.Sym), e.fixUpperEdge && (t.mesh.delete(i.Onext), e.fixUpperEdge = !1), t.mesh.splice(r.anEdge, i), n1.sweepEvent(t, r);
            return;
        }
        ut(!1), e = n1.topRightRegion(e), l = n1.regionBelow(e), o = l.eUp.Sym, s = a = o.Onext, l.fixUpperEdge && (ut(s !== o), n1.deleteRegion(t, l), t.mesh.delete(o), o = s.Oprev), t.mesh.splice(r.anEdge, o), ot.edgeGoesLeft(s) || (s = null), n1.addRightEdges(t, e, o.Onext, a, s, !0);
    }, n1.connectLeftVertex = function(t, e) {
        var r, i, s, o, a, l, c = new O1;
        if (c.eUp = e.anEdge.Sym, r = t.dict.search(c).key, i = n1.regionBelow(r), !!i) {
            if (o = r.eUp, a = i.eUp, ot.edgeSign(o.Dst, e, o.Org) === 0) {
                n1.connectLeftDegenerate(t, r, e);
                return;
            }
            if (s = ot.vertLeq(a.Dst, o.Dst) ? r : i, r.inside || s.fixUpperEdge) {
                if (s === r) l = t.mesh.connect(e.anEdge.Sym, o.Lnext);
                else {
                    var u = t.mesh.connect(a.Dnext, e.anEdge);
                    l = u.Sym;
                }
                s.fixUpperEdge ? n1.fixUpperEdge(t, s, l) : n1.computeWinding(t, n1.addRegionBelow(t, r, l)), n1.sweepEvent(t, e);
            } else n1.addRightEdges(t, r, e.anEdge, e.anEdge, null, !0);
        }
    }, n1.sweepEvent = function(t, e) {
        t.event = e, n1.debugEvent(t);
        for(var r = e.anEdge; r.activeRegion === null;)if (r = r.Onext, r === e.anEdge) {
            n1.connectLeftVertex(t, e);
            return;
        }
        var i = n1.topLeftRegion(t, r.activeRegion);
        ut(i !== null);
        var s = n1.regionBelow(i), o = s.eUp, a = n1.finishLeftRegions(t, s, null);
        a.Onext === o ? n1.connectRightVertex(t, i, a) : n1.addRightEdges(t, i, a.Onext, o, o, !0);
    }, n1.addSentinel = function(t, e, r, i) {
        var s = new O1, o = t.mesh.makeEdge();
        o.Org.s = r, o.Org.t = i, o.Dst.s = e, o.Dst.t = i, t.event = o.Dst, s.eUp = o, s.windingNumber = 0, s.inside = !1, s.fixUpperEdge = !1, s.sentinel = !0, s.dirty = !1, s.nodeUp = t.dict.insert(s);
    }, n1.initEdgeDict = function(t) {
        t.dict = new j7(t, n1.edgeLeq);
        var e = t.bmax[0] - t.bmin[0], r = t.bmax[1] - t.bmin[1], i = t.bmin[0] - e, s = t.bmax[0] + e, o = t.bmin[1] - r, a = t.bmax[1] + r;
        n1.addSentinel(t, i, s, o), n1.addSentinel(t, i, s, a);
    }, n1.doneEdgeDict = function(t) {
        for(var e, r = 0; (e = t.dict.min().key) !== null;)e.sentinel || (ut(e.fixUpperEdge), ut(++r === 1)), ut(e.windingNumber === 0), n1.deleteRegion(t, e);
    }, n1.removeDegenerateEdges = function(t) {
        var e, r, i, s = t.mesh.eHead;
        for(e = s.next; e !== s; e = r)r = e.next, i = e.Lnext, ot.vertEq(e.Org, e.Dst) && e.Lnext.Lnext !== e && (n1.spliceMergeVertices(t, i, e), t.mesh.delete(e), e = i, i = e.Lnext), i.Lnext === e && (i !== e && ((i === r || i === r.Sym) && (r = r.next), t.mesh.delete(i)), (e === r || e === r.Sym) && (r = r.next), t.mesh.delete(e));
    }, n1.initPriorityQ = function(t) {
        var e, r, i, s = 0;
        for(i = t.mesh.vHead, r = i.next; r !== i; r = r.next)s++;
        for(s += 8, e = t.pq = new G7(s, ot.vertLeq), i = t.mesh.vHead, r = i.next; r !== i; r = r.next)r.pqHandle = e.insert(r);
        return r !== i ? !1 : (e.init(), !0);
    }, n1.donePriorityQ = function(t) {
        t.pq = null;
    }, n1.removeDegenerateFaces = function(t, e) {
        var r, i, s;
        for(r = e.fHead.next; r !== e.fHead; r = i)i = r.next, s = r.anEdge, ut(s.Lnext !== s), s.Lnext.Lnext === s && (n1.addWinding(s.Onext, s), t.mesh.delete(s));
        return !0;
    }, n1.computeInterior = function(t, e) {
        e === void 0 && (e = !0);
        var r, i;
        if (n1.removeDegenerateEdges(t), !n1.initPriorityQ(t)) return !1;
        for(n1.initEdgeDict(t); (r = t.pq.extractMin()) !== null;){
            for(; i = t.pq.min(), !(i === null || !ot.vertEq(i, r));)i = t.pq.extractMin(), n1.spliceMergeVertices(t, r.anEdge, i.anEdge);
            n1.sweepEvent(t, r);
        }
        return t.event = t.dict.min().key.eUp.Org, n1.debugEvent(t), n1.doneEdgeDict(t), n1.donePriorityQ(t), n1.removeDegenerateFaces(t, t.mesh) ? (e && t.mesh.check(), !0) : !1;
    }, n1;
}(), W7 = function() {
    function n1() {
        this.mesh = new CO, this.normal = [
            0,
            0,
            0
        ], this.sUnit = [
            0,
            0,
            0
        ], this.tUnit = [
            0,
            0,
            0
        ], this.bmin = [
            0,
            0
        ], this.bmax = [
            0,
            0
        ], this.windingRule = Gt.ODD, this.dict = null, this.pq = null, this.event = null, this.vertexIndexCounter = 0, this.vertices = [], this.vertexIndices = [], this.vertexCount = 0, this.elements = [], this.elementCount = 0;
    }
    return n1.prototype.dot_ = function(t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }, n1.prototype.normalize_ = function(t) {
        var e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2];
        if (!e) throw "Zero-size vector!";
        e = Math.sqrt(e), t[0] /= e, t[1] /= e, t[2] /= e;
    }, n1.prototype.longAxis_ = function(t) {
        var e = 0;
        return Math.abs(t[1]) > Math.abs(t[0]) && (e = 1), Math.abs(t[2]) > Math.abs(t[e]) && (e = 2), e;
    }, n1.prototype.computeNormal_ = function(t) {
        var e, r, i, s, o, a, l = [
            0,
            0,
            0
        ], c = [
            0,
            0,
            0
        ], u = [
            0,
            0,
            0
        ], h = [
            0,
            0,
            0
        ], d = [
            0,
            0,
            0
        ], f = [
            null,
            null,
            null
        ], p = [
            null,
            null,
            null
        ], m = this.mesh.vHead;
        e = m.next;
        for(var g = 0; g < 3; ++g)s = e.coords[g], c[g] = s, p[g] = e, l[g] = s, f[g] = e;
        for(e = m.next; e !== m; e = e.next)for(var y = 0; y < 3; ++y)s = e.coords[y], s < c[y] && (c[y] = s, p[y] = e), s > l[y] && (l[y] = s, f[y] = e);
        var x = 0;
        if (l[1] - c[1] > l[0] - c[0] && (x = 1), l[2] - c[2] > l[x] - c[x] && (x = 2), c[x] >= l[x]) {
            t[0] = 0, t[1] = 0, t[2] = 1;
            return;
        }
        for(a = 0, r = p[x], i = f[x], u[0] = r.coords[0] - i.coords[0], u[1] = r.coords[1] - i.coords[1], u[2] = r.coords[2] - i.coords[2], e = m.next; e !== m; e = e.next)h[0] = e.coords[0] - i.coords[0], h[1] = e.coords[1] - i.coords[1], h[2] = e.coords[2] - i.coords[2], d[0] = u[1] * h[2] - u[2] * h[1], d[1] = u[2] * h[0] - u[0] * h[2], d[2] = u[0] * h[1] - u[1] * h[0], o = d[0] * d[0] + d[1] * d[1] + d[2] * d[2], o > a && (a = o, t[0] = d[0], t[1] = d[1], t[2] = d[2]);
        a <= 0 && (t[0] = t[1] = t[2] = 0, t[this.longAxis_(u)] = 1);
    }, n1.prototype.checkOrientation_ = function() {
        for(var t = this.mesh.fHead, e, r = this.mesh.vHead, i, s = 0, o = t.next; o !== t; o = o.next)if (i = o.anEdge, !(i.winding <= 0)) do s += (i.Org.s - i.Dst.s) * (i.Org.t + i.Dst.t), i = i.Lnext;
        while (i !== o.anEdge);
        if (s < 0) {
            for(e = r.next; e !== r; e = e.next)e.t = -e.t;
            this.tUnit[0] = -this.tUnit[0], this.tUnit[1] = -this.tUnit[1], this.tUnit[2] = -this.tUnit[2];
        }
    }, n1.prototype.projectPolygon_ = function() {
        var t = this.mesh.vHead, e = [
            0,
            0,
            0
        ], r, i, s = !1;
        e[0] = this.normal[0], e[1] = this.normal[1], e[2] = this.normal[2], !e[0] && !e[1] && !e[2] && (this.computeNormal_(e), s = !0), r = this.sUnit, i = this.tUnit;
        var o = this.longAxis_(e);
        r[o] = 0, r[(o + 1) % 3] = 1, r[(o + 2) % 3] = 0, i[o] = 0, i[(o + 1) % 3] = 0, i[(o + 2) % 3] = e[o] > 0 ? 1 : -1;
        for(var a = t.next; a !== t; a = a.next)a.s = this.dot_(a.coords, r), a.t = this.dot_(a.coords, i);
        s && this.checkOrientation_();
        for(var l = !0, c = t.next; c !== t; c = c.next)l ? (this.bmin[0] = this.bmax[0] = c.s, this.bmin[1] = this.bmax[1] = c.t, l = !1) : (c.s < this.bmin[0] && (this.bmin[0] = c.s), c.s > this.bmax[0] && (this.bmax[0] = c.s), c.t < this.bmin[1] && (this.bmin[1] = c.t), c.t > this.bmax[1] && (this.bmax[1] = c.t));
    }, n1.prototype.addWinding_ = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, n1.prototype.tessellateMonoRegion_ = function(t, e) {
        var r, i;
        if (r = e.anEdge, !(r.Lnext !== r && r.Lnext.Lnext !== r)) throw "Mono region invalid";
        for(; ot.vertLeq(r.Dst, r.Org); r = r.Lprev);
        for(; ot.vertLeq(r.Org, r.Dst); r = r.Lnext);
        i = r.Lprev;
        for(var s = void 0; r.Lnext !== i;)if (ot.vertLeq(r.Dst, i.Org)) {
            for(; i.Lnext !== r && (ot.edgeGoesLeft(i.Lnext) || ot.edgeSign(i.Org, i.Dst, i.Lnext.Dst) <= 0);)s = t.connect(i.Lnext, i), i = s.Sym;
            i = i.Lprev;
        } else {
            for(; i.Lnext !== r && (ot.edgeGoesRight(r.Lprev) || ot.edgeSign(r.Dst, r.Org, r.Lprev.Org) >= 0);)s = t.connect(r, r.Lprev), r = s.Sym;
            r = r.Lnext;
        }
        if (i.Lnext === r) throw "Mono region invalid";
        for(; i.Lnext.Lnext !== r;)s = t.connect(i.Lnext, i), i = s.Sym;
        return !0;
    }, n1.prototype.tessellateInterior_ = function(t) {
        for(var e, r = t.fHead.next; r !== t.fHead; r = e)if (e = r.next, r.inside && !this.tessellateMonoRegion_(t, r)) return !1;
        return !0;
    }, n1.prototype.discardExterior_ = function(t) {
        for(var e, r = t.fHead.next; r !== t.fHead; r = e)e = r.next, r.inside || t.zapFace(r);
    }, n1.prototype.setWindingNumber_ = function(t, e, r) {
        for(var i, s = t.eHead.next; s !== t.eHead; s = i)i = s.next, s.Rface.inside !== s.Lface.inside ? s.winding = s.Lface.inside ? e : -e : r ? t.delete(s) : s.winding = 0;
    }, n1.prototype.getNeighbourFace_ = function(t) {
        return !t.Rface || !t.Rface.inside ? -1 : t.Rface.n;
    }, n1.prototype.outputPolymesh_ = function(t, e, r, i) {
        var s, o = 0, a = 0, l;
        r > 3 && t.mergeConvexFaces(r);
        for(var c = t.vHead.next; c !== t.vHead; c = c.next)c.n = -1;
        for(var u = t.fHead.next; u !== t.fHead; u = u.next)if (u.n = -1, !!u.inside) {
            s = u.anEdge, l = 0;
            do {
                var c = s.Org;
                c.n === -1 && (c.n = a, a++), l++, s = s.Lnext;
            }while (s !== u.anEdge);
            if (l > r) throw "Face vertex greater that support polygon";
            u.n = o, ++o;
        }
        this.elementCount = o, e === jr.CONNECTED_POLYGONS && (o *= 2), this.elements = [], this.elements.length = o * r, this.vertexCount = a, this.vertices = [], this.vertices.length = a * i, this.vertexIndices = [], this.vertexIndices.length = a;
        for(var c = t.vHead.next; c !== t.vHead; c = c.next)if (c.n !== -1) {
            var h = c.n * i;
            this.vertices[h + 0] = c.coords[0], this.vertices[h + 1] = c.coords[1], i > 2 && (this.vertices[h + 2] = c.coords[2]), this.vertexIndices[c.n] = c.idx;
        }
        for(var d = 0, u = t.fHead.next; u !== t.fHead; u = u.next)if (!!u.inside) {
            s = u.anEdge, l = 0;
            do {
                var c = s.Org;
                this.elements[d++] = c.n, l++, s = s.Lnext;
            }while (s !== u.anEdge);
            for(var f = l; f < r; ++f)this.elements[d++] = -1;
            if (e === jr.CONNECTED_POLYGONS) {
                s = u.anEdge;
                do this.elements[d++] = this.getNeighbourFace_(s), s = s.Lnext;
                while (s !== u.anEdge);
                for(var p = l; p < r; ++p)this.elements[d++] = -1;
            }
        }
    }, n1.prototype.outputContours_ = function(t, e) {
        var r, i, s = 0, o = 0;
        this.vertexCount = 0, this.elementCount = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            i = r = a.anEdge;
            do this.vertexCount++, r = r.Lnext;
            while (r !== i);
            this.elementCount++;
        }
        this.elements = [], this.elements.length = this.elementCount * 2, this.vertices = [], this.vertices.length = this.vertexCount * e, this.vertexIndices = [], this.vertexIndices.length = this.vertexCount;
        var l = 0, c = 0, u = 0;
        s = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            o = 0, i = r = a.anEdge;
            do this.vertices[l++] = r.Org.coords[0], this.vertices[l++] = r.Org.coords[1], e > 2 && (this.vertices[l++] = r.Org.coords[2]), this.vertexIndices[c++] = this.vertexIdCallback ? this.vertexIdCallback(r) : r.Org.idx, o++, r = r.Lnext;
            while (r !== i);
            this.elements[u++] = s, this.elements[u++] = o, s += o;
        }
    }, n1.prototype.addContour = function(t, e) {
        this.mesh === null && (this.mesh = new CO), t < 2 && (t = 2), t > 3 && (t = 3);
        for(var r = null, i = 0; i < e.length; i += t)r === null ? (r = this.mesh.makeEdge(), this.mesh.splice(r, r.Sym)) : (this.mesh.splitEdge(r), r = r.Lnext), r.Org.coords[0] = e[i + 0], r.Org.coords[1] = e[i + 1], t > 2 ? r.Org.coords[2] = e[i + 2] : r.Org.coords[2] = 0, r.Org.idx = this.vertexIndexCounter++, this.edgeCreateCallback && this.edgeCreateCallback(r), r.winding = 1, r.Sym.winding = -1;
    }, n1.prototype.tesselate = function(t, e, r, i, s, o) {
        if (t === void 0 && (t = Gt.ODD), e === void 0 && (e = jr.POLYGONS), o === void 0 && (o = !0), this.vertices = [], this.elements = [], this.vertexIndices = [], this.vertexIndexCounter = 0, s && (this.normal[0] = s[0], this.normal[1] = s[1], this.normal[2] = s[2]), this.windingRule = t, i < 2 && (i = 2), i > 3 && (i = 3), !this.mesh) return !1;
        this.projectPolygon_(), H7.computeInterior(this, o);
        var a = this.mesh;
        return e === jr.BOUNDARY_CONTOURS ? this.setWindingNumber_(a, 1, !0) : this.tessellateInterior_(a), o && a.check(), e === jr.BOUNDARY_CONTOURS ? this.outputContours_(a, i) : this.outputPolymesh_(a, e, r, i), !0;
    }, n1;
}();
function qs(n1) {
    var t = n1.windingRule, e = t === void 0 ? Gt.ODD : t, r = n1.elementType, i = r === void 0 ? jr.POLYGONS : r, s = n1.polySize, o = s === void 0 ? 3 : s, a = n1.vertexSize, l = a === void 0 ? 2 : a, c = n1.normal, u = c === void 0 ? [
        0,
        0,
        1
    ] : c, h = n1.contours, d = h === void 0 ? [] : h, f = n1.strict, p = f === void 0 ? !0 : f, m = n1.debug, g = m === void 0 ? !1 : m;
    if (!d && p) throw new Error("Contours can't be empty");
    if (!!d) {
        var y = new W7;
        n1.edgeCreateCallback && (y.edgeCreateCallback = n1.edgeCreateCallback), n1.vertexIdCallback && (y.vertexIdCallback = n1.vertexIdCallback);
        for(var x = 0; x < d.length; x++)y.addContour(l || 2, d[x]);
        return y.tesselate(e, i, o, l, u, p), {
            vertices: y.vertices,
            vertexIndices: y.vertexIndices,
            vertexCount: y.vertexCount,
            elements: y.elements,
            elementCount: y.elementCount,
            mesh: g ? y.mesh : void 0
        };
    }
}
var Rye = Gt.ODD, Lye = Gt.NONZERO, Bye = Gt.POSITIVE, Nye = Gt.NEGATIVE, Fye = Gt.ABS_GEQ_TWO, Vye = jr.POLYGONS, kye = jr.CONNECTED_POLYGONS, Uye = jr.BOUNDARY_CONTOURS;
var C0 = class {
    constructor(t = 256, e = !1){
        this.capacity = t, this.size = 0, this.debug = e, this.debug && console.log(`allocating with cap ${t}`);
        let r = t * C0.eSize;
        this.buffer = new ArrayBuffer(r);
        let i = Float32Array.BYTES_PER_ELEMENT, s = 0;
        this.positions = new Float32Array(this.buffer, s * i, 3 * t), s += 3 * t, this.normals = new Float32Array(this.buffer, s * i, 3 * t), s += 3 * t, this.uvs = new Float32Array(this.buffer, s * i, 2 * t);
    }
    realloc(t, e = !1) {
        if (t < this.size) throw Error("cannot shrink buffer");
        if (t <= this.capacity && !e) return;
        this.debug && console.log(`resizing from ${this.capacity} \u2192 ${t}`);
        let r = t * C0.eSize, i = new ArrayBuffer(r), s = Float32Array.BYTES_PER_ELEMENT, o = 0, a = new Float32Array(i, o * s, 3 * t);
        o += 3 * t;
        let l = new Float32Array(i, o * s, 3 * t);
        o += 3 * t;
        let c = new Float32Array(i, o * s, 2 * t);
        e ? (a.set(this.positions.subarray(0, this.size * 3)), l.set(this.normals.subarray(0, this.size * 3)), c.set(this.uvs.subarray(0, this.size * 2))) : (a.set(this.positions), l.set(this.normals), c.set(this.uvs)), this.buffer = i, this.positions = a, this.normals = l, this.uvs = c, this.capacity = t;
    }
    get(t = 1) {
        let e = this.size + t;
        if (e > this.capacity) {
            let i = this.capacity;
            for(; e > i;)i *= 2;
            this.realloc(i);
        }
        let r = this.size;
        return this.size = e, r;
    }
    reserve(t) {
        let e = this.size + t;
        e > this.capacity && this.realloc(e);
    }
    shrink() {
        this.debug && console.log(`shrinking ${this.capacity} \u2192 ${this.size}`), this.realloc(this.size, !0);
    }
}, lm = C0;
lm.eSize = 8 * Float32Array.BYTES_PER_ELEMENT;
var cm = class {
    constructor(t = [], e = (r, i)=>r < i ? -1 : r > i ? 1 : 0){
        if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
    }
    push(t) {
        this.data.push(t), this._up(this.length++);
    }
    pop() {
        if (this.length === 0) return;
        let t = this.data[0], e = this.data.pop();
        return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
    }
    peek() {
        return this.data[0];
    }
    _up(t) {
        let { data: e, compare: r } = this, i = e[t];
        for(; t > 0;){
            let s = t - 1 >> 1, o = e[s];
            if (r(i, o) >= 0) break;
            e[t] = o, t = s;
        }
        e[t] = i;
    }
    _down(t) {
        let { data: e, compare: r } = this, i = this.length >> 1, s = e[t];
        for(; t < i;){
            let o = (t << 1) + 1, a = o + 1;
            if (a < this.length && r(e[a], e[o]) < 0 && (o = a), r(e[o], s) >= 0) break;
            e[t] = e[o], t = o;
        }
        e[t] = s;
    }
};
function R1(n1, t, e = 1, r = !1) {
    let i = 1 / 0, s = 1 / 0, o = -1 / 0, a = -1 / 0;
    for (let [x, v] of n1[0])x < i && (i = x), v < s && (s = v), x > o && (o = x), v > a && (a = v);
    let l = o - i, c = a - s, u = Math.max(e, Math.min(l, c));
    if (u === e) {
        let x = [
            i,
            s
        ];
        return x.distance = 0, x.distance;
    }
    let h = new cm([], (x, v)=>v.max - x.max), d = Y7(n1), f = new P0(i + l / 2, s + c / 2, 0, n1);
    f.d > d.d && (d = f);
    let p = 2;
    function m(x, v, S) {
        let w = new P0(x, v, S, n1);
        if (p++, w.max > d.d + e && h.push(w), w.d > d.d && (d = w, r && console.log(`found best ${Math.round(1e4 * w.d) / 1e4} after ${p} probes`), d.d > t)) return t;
    }
    let g = u / 2;
    for(let x = i; x < o; x += u)for(let v = s; v < a; v += u)m(x + g, v + g, g);
    for(; h.length;){
        let { max: x, x: v, y: S, h: w } = h.pop();
        if (x - d.d <= e) break;
        g = w / 2, m(v - g, S - g, g), m(v + g, S - g, g), m(v - g, S + g, g), m(v + g, S + g, g);
    }
    r && console.log(`num probes: ${p}
best distance: ${d.d}`);
    let y = [
        d.x,
        d.y
    ];
    return y.distance = d.d, y.distance;
}
function P0(n1, t, e, r) {
    this.x = n1, this.y = t, this.h = e, this.d = q7(n1, t, r), this.max = this.d + this.h * Math.SQRT2;
}
function q7(n1, t, e) {
    let r = !1, i = 1 / 0;
    for (let s of e)for(let o = 0, a = s.length, l = a - 1; o < a; l = o++){
        let c = s[o], u = s[l];
        c[1] > t != u[1] > t && n1 < (u[0] - c[0]) * (t - c[1]) / (u[1] - c[1]) + c[0] && (r = !r), i = Math.min(i, X7(n1, t, c, u));
    }
    return i === 0 ? 0 : (r ? 1 : -1) * Math.sqrt(i);
}
function Y7(n1) {
    let t = 0, e = 0, r = 0, i = n1[0];
    for(let o = 0, a = i.length, l = a - 1; o < a; l = o++){
        let c = i[o], u = i[l], h = c[0] * u[1] - u[0] * c[1];
        e += (c[0] + u[0]) * h, r += (c[1] + u[1]) * h, t += h * 3;
    }
    let s = new P0(e / t, r / t, 0, n1);
    return t === 0 || s.d < 0 ? new P0(i[0][0], i[0][1], 0, n1) : s;
}
function X7(n1, t, e, r) {
    let i = e[0], s = e[1], o = r[0] - i, a = r[1] - s;
    if (o !== 0 || a !== 0) {
        let l = ((n1 - i) * o + (t - s) * a) / (o * o + a * a);
        l > 1 ? (i = r[0], s = r[1]) : l > 0 && (i += o * l, s += a * l);
    }
    return o = n1 - i, a = t - s, o * o + a * a;
}
var um = {
    vertices: [
        160,
        160,
        -160,
        160,
        -160,
        -160,
        160,
        -160
    ],
    vertexIndices: [
        1,
        0,
        3,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        4
    ],
    elementCount: 1,
    mesh: void 0
}, B1 = {
    vertices: [],
    vertexIndices: [],
    vertexCount: 0,
    elements: [],
    elementCount: 0,
    mesh: void 0
}, N1 = {
    vertices: [
        -160,
        160,
        160,
        -160,
        160,
        160,
        -160,
        -160
    ],
    vertexIndices: [
        1,
        3,
        0,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        1,
        2,
        1,
        0,
        3
    ],
    elementCount: 2,
    mesh: void 0
}, L1 = (n1, t)=>([e, r])=>(r < e && (r += t), (n1 >= e ? n1 : n1 + t) <= r), Bl = class extends _e {
    constructor(e, r, i = 0, s = 12, o = 3, a = Gt.ODD, l = !1){
        super();
        this.forPathBevel = l;
        this.type = "ShapeGeometry";
        this.vertexCache = {};
        this._shape = e, this._depth = r, this._curveSegments = s, this._bevelSegmentsInput = o;
        let c = this._shape.extractShapePointsToFlatArray([], s), u = this._shape.shapeHoles.map((P)=>{
            let I = P.extractShapePointsToFlatArray([], s), _ = [];
            for(let D = I.length - 1; D >= 1; D -= 2){
                let L = I[D - 1], j = I[D - 0];
                _.push(L, j);
            }
            return _;
        }), h = [], d = [];
        for(let P = 0; P < c.length; P += 2)d.push([
            c[P],
            c[P + 1]
        ]);
        h.push(d);
        for(let P = 0; P < u.length; P++){
            let I = u[P], _ = [];
            for(let D = 0; D < I.length; D += 2)_.push([
                I[D],
                I[D + 1]
            ]);
            h.push(_);
        }
        let f;
        e.isText ? f = new Ju().setFromPoints(e.points.map((I)=>I.position)).getSize(new k).length() * .1 : h[0].length === 0 ? f = i : i > 0 ? f = R1(h, i) : f = 1e-5, i <= 0 ? (this._bevel = 0, this._bevelSegments = 0) : (this._bevel = Math.min(i, f, r / 2), this._bevelSegments = Math.floor(o));
        let p;
        try {
            p = qs({
                windingRule: a,
                elementType: jr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    c
                ]
            });
        } catch  {
            p = um;
        }
        let m;
        try {
            m = qs({
                windingRule: Gt.ODD,
                elementType: jr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...u
                ]
            });
        } catch  {
            m = B1;
        }
        if (!p) throw new Error("error generating geometry");
        let g = p.elementCount;
        if (m) {
            p.elementCount += m.elementCount;
            for(let P = 0; P < m.elements.length; P++){
                let I = m.elements[P], _ = P % 2 === 0 ? p.vertexCount : 0;
                p.elements.push(I + _);
            }
            for(let P = 0; P < m.vertexIndices.length; P++){
                let I = m.vertexIndices[P], _ = p.vertexCount;
                p.vertexIndices.push(I + _);
            }
            for(let P = 0; P < m.vertices.length; P++){
                let I = m.vertices[P];
                p.vertices.push(I);
            }
        }
        let y = 1 / 0, x = -1 / 0, v = 1 / 0, S = -1 / 0;
        for(let P = 0, I = p.vertexCount; P < I; P++){
            let _ = P * 2, D = p.vertices[_ + 0], L = p.vertices[_ + 1];
            D < y && (y = D), D > x && (x = D), L < v && (v = L), L > S && (S = L);
        }
        this._minX = y, this._minY = v, this._width = x - y, this._height = S - v, this._buffer = new lm(this._computeBufferEstimatedSize(p));
        let w = [], A = [];
        for(let P = p.elementCount - 1; P >= 0; P--){
            let I = P >= g, _ = P * 2, D = p.elements[_ + 0], L = p.elements[_ + 1], j = D + L, V = {
                start: D,
                count: L,
                normals: [],
                continuous: [],
                concave: []
            }, H = D, W = j - 1, q = D + 1, Q = this._shape.roundedCurves.length;
            do {
                let Y = H - D, oe = p.vertices[W * 2 + 0], ie = p.vertices[W * 2 + 1], re = p.vertices[H * 2 + 0], J = p.vertices[H * 2 + 1], Ee = p.vertices[q * 2 + 0], xe = p.vertices[q * 2 + 1], de = re - oe, De = J - ie, Ce = Math.sqrt(de * de + De * De);
                de /= Ce, De /= Ce;
                let ze = re - Ee, Ue = J - xe, Ve = Math.sqrt(ze * ze + Ue * Ue);
                ze /= Ve, Ue /= Ve, V.normals[Y * 2 + 0] = -Ue, V.normals[Y * 2 + 1] = ze, V.concave[Y] = de * Ue - De * ze > 0;
                let Oe = p.vertexIndices[H];
                if (Array.isArray(Oe)) V.continuous[Y] = !1;
                else {
                    let [Ye, F] = this._shape.getCurveIndexFromVertexId(Oe - 1, !0);
                    if (F > 0 && F < 1) V.continuous[Y] = !0;
                    else {
                        let N = F === 1 ? Ye + 1 : Ye - 1;
                        N = (N + Q) % Q;
                        let B = F === 1 ? 0 : 1, ae = this._shape.roundedCurves[Ye].getTangent(F), ge = this._shape.roundedCurves[N].getTangent(B);
                        V.continuous[Y] = ae.dot(ge) > .95;
                    }
                }
                I && (V.normals[Y * 2 + 0] *= -1, V.normals[Y * 2 + 1] *= -1), [W, H, q] = [
                    H,
                    q,
                    q + 1
                ], q >= j && (q -= L);
            }while (q !== D + 1);
            let G = [];
            G.push({
                bevelI: 0,
                angle: 0,
                size: 0,
                boundary: {
                    vertices: p.vertices.slice(D * 2, j * 2),
                    vertexCount: L,
                    vertexIndices: new Array(L).fill(!0).map((Y, oe)=>[
                            oe,
                            oe
                        ]),
                    elements: [
                        0,
                        L
                    ],
                    elementCount: 1,
                    mesh: null
                },
                reverseMap: [],
                insetPoints: p.vertices.slice(D * 2, j * 2)
            });
            let Z = 0;
            for(let Y = 1; Y <= this._bevelSegments; Y++){
                let oe = Y / this._bevelSegments * Math.PI / 2, ie = (1 - Math.cos(oe)) * this._bevel, re = [], J = [], Ee = [], xe = [], de = 0;
                for(let Ce = 0; Ce < L; Ce++){
                    let ze = Ce * 2, Ue = (Ce - 1 + L) % L * 2, Ve = p.vertices[V.start * 2 + ze + 0], Oe = p.vertices[V.start * 2 + ze + 1], Ye = -V.normals[Ue + 0] * ie, F = -V.normals[Ue + 1] * ie, N = -V.normals[ze + 0] * ie, B = -V.normals[ze + 1] * ie;
                    if (V.concave[Ce] || !V.concave[Ce] && I) {
                        let ae = Math.atan2(F, Ye), ge = Math.atan2(B, N);
                        ge > ae && (ge -= Math.PI * 2);
                        let me = ge - ae;
                        if (V.continuous[Ce] || I) {
                            let Le = ae + me / 2, Ne = Math.cos(Le) * ie, Re = Math.sin(Le) * ie;
                            re[2 * de + 0] = Ve + Ne * (I ? -1 : 1), re[2 * de + 1] = Oe + Re * (I ? -1 : 1), xe[de] = Ce, de++;
                        } else {
                            let Le = Math.max(1, Math.floor(s / 4 * Math.abs(me) / Math.PI));
                            for(let Ne = 0; Ne <= Le; Ne++){
                                let Re = ae + me * (Ne / Le), pe = Math.cos(Re) * ie, nt = Math.sin(Re) * ie;
                                re[2 * de + 0] = Ve + pe, re[2 * de + 1] = Oe + nt, xe[de] = Ce, de++;
                            }
                        }
                    } else re[2 * de + 0] = Ve + Ye, re[2 * de + 1] = Oe + F, xe[de] = Ce, J[Ce] = de, de++, re[2 * de + 0] = Ve, re[2 * de + 1] = Oe, xe[de] = Ce, de++, re[2 * de + 0] = Ve + N, re[2 * de + 1] = Oe + B, xe[de] = Ce, Ee[Ce] = de, de++;
                }
                let De = qs({
                    windingRule: Gt.POSITIVE,
                    elementType: jr.BOUNDARY_CONTOURS,
                    vertexSize: 2,
                    strict: !0,
                    contours: [
                        re
                    ],
                    edgeCreateCallback: (Ce)=>{
                        let Ue = Ce.Org.idx, Ve = xe[Ue], Oe = xe[(Ue + 1) % xe.length];
                        Ce.idx = [
                            Ve,
                            Oe
                        ], Ce.Sym.idx = [
                            Oe,
                            Ve
                        ];
                    },
                    vertexIdCallback: (Ce)=>{
                        let ze = Ce.Lprev.idx;
                        return [
                            ze ? ze[1] : 0,
                            Ce.idx ? Ce.idx[0] : 0
                        ];
                    }
                });
                if (!De) throw console.log("Error"), new Error(`error generating bevel geometry for ${Y}'th loop`);
                if (!De.vertexCount) {
                    let Ce = (Y - 1) / this._bevelSegments * Math.PI / 2;
                    Z = (1 - Math.sin(Ce)) * this._bevel;
                    break;
                }
                for(let Ce = 0; Ce < De.vertexIndices.length; Ce++){
                    let [ze, Ue] = De.vertexIndices[Ce];
                    if (ze === Ue) continue;
                    let Ve = Ue;
                    Ue < ze && (Ve += L);
                    for(let Oe = ze; Oe < Ve; Oe++){
                        let Ye = Oe % L, F = (Oe + 1) % L;
                        if (!V.continuous[Ye] || !V.continuous[F]) {
                            De.vertexIndices[Ce] = [
                                ze,
                                Ye
                            ], De.vertexIndices.splice(Ce + 1, 0, [
                                F,
                                Ue
                            ]), De.vertices.splice((Ce + 1) * 2, 0, De.vertices[Ce * 2], De.vertices[Ce * 2 + 1]);
                            break;
                        }
                    }
                }
                G.push({
                    bevelI: Y,
                    angle: oe,
                    size: ie,
                    boundary: De,
                    reverseMap: xe,
                    insetPoints: re
                });
            }
            let te = (Y, oe, ie)=>{
                let re = 0, J = Y.boundary.vertexIndices.length;
                for(; re < J && ie(Y.boundary.vertexIndices[oe]);)oe = (oe + 1) % J, re++;
                return re;
            }, $ = w.length;
            for(let Y = 1; Y < G.length; Y++){
                let oe = G[Y - 1], ie = G[Y], re = oe.boundary.vertexIndices.length, J = ie.boundary.vertexIndices.length;
                if (!re || !J) break;
                let Ee = V.concave.length, xe = 0, de = L1(xe, L);
                for(; !oe.boundary.vertexIndices.filter(de).length || !ie.boundary.vertexIndices.filter(de).length;)xe++, de = L1(xe, L);
                let De = oe.boundary.vertexIndices.findIndex(de), Ce = ie.boundary.vertexIndices.findIndex(de);
                do De = (De + 1) % re;
                while (de(oe.boundary.vertexIndices[De]));
                do Ce = (Ce + 1) % J;
                while (de(ie.boundary.vertexIndices[Ce]));
                xe = (xe + 1) % L;
                let ze = xe, Ue = 0, Ve = this._buildBevelVert(V, oe, (De - 1 + re) % re, void 0, Ue), Oe = this._buildBevelVert(V, ie, (Ce - 1 + J) % J, void 0, Ue), Ye = Ve, F = Oe, N, B, ae = !1;
                do {
                    Ue = (xe || Ee) / Ee, de = L1(xe, L);
                    let ge = te(oe, De, de), me = te(ie, Ce, de), Le = ae;
                    if (ae = !1, ge && !me) {
                        for(let Ne = 0; Ne < ge; Ne++)N = this._buildBevelVert(V, oe, (De + Ne) % re, Ne / (ge - 1), Ue), w.push(Ye.topN, N.topP, F.topN), l === !1 && w.push(N.bottomP, Ye.bottomN, F.bottomN), Ye = N;
                        ae = !0;
                    } else if (!ge && me) for(let Ne = 0; Ne < me; Ne++)B = this._buildBevelVert(V, ie, (Ce + Ne) % J, Ne / (me - 1), Ue), w.push(F.topN, Ye.topP, B.topP), l === !1 && w.push(Ye.bottomP, F.bottomN, B.bottomP), F = B;
                    else if (ge && me) {
                        if (N = this._buildBevelVert(V, oe, De, 0, Ue), B = this._buildBevelVert(V, ie, Ce, 0, Ue), Le ? (w.push(Ye.topN, B.topP, F.topN), w.push(Ye.topN, N.topP, B.topP), l === !1 && (w.push(B.bottomP, Ye.bottomN, F.bottomN), w.push(B.bottomP, N.bottomP, Ye.bottomN))) : (w.push(F.topN, Ye.topN, N.topP), w.push(F.topN, N.topP, B.topP), l === !1 && (w.push(N.bottomP, Ye.bottomN, F.bottomN), w.push(N.bottomP, F.bottomN, B.bottomP))), Ye = N, F = B, ge === me) for(let Ne = 1; Ne < ge; Ne++)N = this._buildBevelVert(V, oe, (De + Ne) % re, Ne / (ge - 1), Ue), B = this._buildBevelVert(V, ie, (Ce + Ne) % J, Ne / (me - 1), Ue), w.push(Ye.topN, N.topP, F.topN), w.push(F.topN, N.topP, B.topP), l === !1 && (w.push(N.bottomP, Ye.bottomN, F.bottomN), w.push(N.bottomP, F.bottomN, B.bottomP)), Ye = N, F = B;
                        else if (ge > me) {
                            let Ne = ge / me, Re = 0;
                            for(let pe = 1; pe < ge; pe++)N = this._buildBevelVert(V, oe, (De + pe) % re, pe / (ge - 1), Ue), w.push(Ye.topN, N.topP, F.topN), l === !1 && w.push(N.bottomP, Ye.bottomN, F.bottomN), Ye = N, pe > (Re + 1) * Ne && (Re++, B = this._buildBevelVert(V, ie, (Ce + Re) % J, Re / (me - 1), Ue), w.push(F.topN, N.topP, B.topP), l === !1 && w.push(N.bottomP, F.bottomN, B.bottomP), F = B);
                        } else {
                            let Ne = me / ge, Re = 0;
                            for(let pe = 1; pe < me; pe++)B = this._buildBevelVert(V, ie, (Ce + pe) % J, pe / (me - 1), Ue), w.push(F.topN, N.topP, B.topP), l === !1 && w.push(N.bottomP, F.bottomN, B.bottomP), F = B, pe > (Re + 1) * Ne && (Re++, N = this._buildBevelVert(V, oe, (De + Re) % re, Re / (ge - 1), Ue), w.push(Ye.topN, N.topP, F.topN), l === !1 && w.push(N.bottomP, Ye.bottomN, F.bottomN), Ye = N);
                        }
                    }
                    De = (De + ge) % re, Ce = (Ce + me) % J, xe = (xe + 1) % Ee;
                }while (xe !== ze);
            }
            if (l === !1 && this._depth > this._bevel * 2 && this._buildWall(G, V, w), I) {
                let Y = [];
                for(let oe = w.length - 1; oe >= $ + 2; oe -= 3){
                    let ie = w[oe - 2], re = w[oe - 1], J = w[oe - 0];
                    Y.push(J, re, ie);
                }
                w.splice($, w.length - $, ...Y);
            }
            if (I) {
                let Y = [];
                for(let oe = G[G.length - 1].boundary.vertices.length - 1; oe >= 1; oe -= 2){
                    let ie = G[G.length - 1].boundary.vertices[oe - 1], re = G[G.length - 1].boundary.vertices[oe - 0];
                    Y.push(ie, re);
                }
                A.push(Y);
            }
            if (!I) {
                let Y = G[G.length - 1], oe;
                try {
                    oe = qs({
                        windingRule: G.length > 1 ? Gt.POSITIVE : Gt.ODD,
                        elementType: jr.POLYGONS,
                        vertexSize: 2,
                        strict: !0,
                        contours: [
                            Y.insetPoints,
                            ...A
                        ]
                    });
                } catch  {
                    oe = N1;
                }
                if (!oe) throw new Error("Error generating geometry for surface");
                u.length === 0 && this._bevel < f && Object.assign(this, {
                    useNgonForTopBottomFaceDuringBake: !0
                });
                for(let ie = 0; ie < oe.elementCount * 3; ie += 3){
                    let re = this._buildSurfaceVert(oe, oe.elements[ie + 0], Z), J = this._buildSurfaceVert(oe, oe.elements[ie + 1], Z), Ee = this._buildSurfaceVert(oe, oe.elements[ie + 2], Z);
                    w.push(re.top, J.top, Ee.top), l === !1 && w.push(Ee.bottom, J.bottom, re.bottom);
                }
            }
            this.vertexCache = {};
        }
        this._buffer.shrink();
        let T = new Xe(Uint32Array.from(w), 1), b = new Xe(this._buffer.positions, 3), M = new Xe(this._buffer.normals, 3), C = new Xe(this._buffer.uvs, 2);
        b.needsUpdate = !0, M.needsUpdate = !0, C.needsUpdate = !0, T.needsUpdate = !0, this.setAttribute("position", b), this.setAttribute("normal", M), this.setAttribute("uv", C), this.setIndex(T);
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, r, i) {
        let s = e[0];
        for(let o = 0, a = s.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(r, s, o), c = this._buildBevelVert(r, s, (o + 1) % a);
            i.push(c.topP, l.topN, l.bottomN), i.push(c.topP, l.bottomN, c.bottomP);
        }
    }
    _buildSurfaceVert(e, r, i) {
        let s = r.toString();
        if (s in this.vertexCache) return this.vertexCache[s];
        let o = e.vertices[r * 2 + 0], a = e.vertices[r * 2 + 1], l = (o - this._minX) / this._width, c = (a - this._minY) / this._height;
        this.forPathBevel && (c = 1);
        let u = this._buffer.get(this.forPathBevel ? 1 : 2), h = u * 3, d = u * 2, f = {
            top: u + 0,
            bottom: u + 1
        };
        return this._buffer.positions[h + 0] = o, this._buffer.positions[h + 1] = a, this._buffer.positions[h + 2] = this.forPathBevel ? this._bevel : this._depth - i, this._buffer.normals[h + 0] = 0, this._buffer.normals[h + 1] = 0, this._buffer.normals[h + 2] = 1, this._buffer.uvs[d + 0] = l, this._buffer.uvs[d + 1] = c, this.forPathBevel === !1 && (this._buffer.positions[h + 3] = o, this._buffer.positions[h + 4] = a, this._buffer.positions[h + 5] = i, this._buffer.normals[h + 3] = 0, this._buffer.normals[h + 4] = 0, this._buffer.normals[h + 5] = -1, this._buffer.uvs[d + 2] = l, this._buffer.uvs[d + 3] = c), this.vertexCache[s] = f, f;
    }
    _buildBevelVert(e, r, i, s = 1, o) {
        let a = `${r.bevelI}:${i}`;
        if (a in this.vertexCache && o !== 0 && o !== 1 && (!o || o === this.vertexCache[a].pathBevelUCoord)) return this.vertexCache[a];
        let [l, c] = r.boundary.vertexIndices[i], u, h, d, f;
        l !== c ? (h = l, u = c, f = !1, d = e.continuous[h] && e.continuous[u]) : (u = l, h = (u - 1 + e.count) % e.count, f = e.concave[u] && r.bevelI > 0, d = e.continuous[u] || f);
        let p = Math.cos(r.angle), m = Math.sin(r.angle), g = i * 2, y = u * 2, x = h * 2, v = r.boundary.vertices[g + 0], S = r.boundary.vertices[g + 1], w = (1 - m) * this._bevel, A = (v - this._minX) / this._width, T = (S - this._minY) / this._height;
        this.forPathBevel && (o !== void 0 && (A = o), T = 1);
        let b = e.normals[y + 0], M = e.normals[y + 1], C = e.normals[x + 0], P = e.normals[x + 1];
        if (f) {
            let j = C - b, V = P - M;
            b = b + j * (1 - s), M = M + V * (1 - s);
            let H = Math.sqrt(b * b + M * M);
            b /= H, M /= H;
        }
        let I = this.forPathBevel ? this._buffer.get(d ? 1 : 2) : this._buffer.get(d ? 2 : 4), _ = I * 3, D = I * 2, L = {
            i: i,
            fi: u,
            topP: I + 0,
            topN: I + 0,
            bottomP: I + 1,
            bottomN: I + 1,
            pathBevelUCoord: o
        };
        return this._buffer.positions[_ + 0] = v, this._buffer.positions[_ + 1] = S, this._buffer.positions[_ + 2] = (this.forPathBevel ? this._bevel : this._depth) - w, this._buffer.normals[_ + 0] = b * p, this._buffer.normals[_ + 1] = M * p, this._buffer.normals[_ + 2] = m, this._buffer.uvs[D + 0] = A, this._buffer.uvs[D + 1] = T, this.forPathBevel === !1 && (this._buffer.positions[_ + 3] = v, this._buffer.positions[_ + 4] = S, this._buffer.positions[_ + 5] = w, this._buffer.normals[_ + 3] = b * p, this._buffer.normals[_ + 4] = M * p, this._buffer.normals[_ + 5] = -m, this._buffer.uvs[D + 2] = T, this._buffer.uvs[D + 3] = A), d || (this.forPathBevel ? (I += 1, _ += 3, D += 2) : (I += 2, _ += 6, D += 4), L.topP = I + 0, L.bottomP = I + 1, this._buffer.positions[_ + 0] = v, this._buffer.positions[_ + 1] = S, this._buffer.positions[_ + 2] = (this.forPathBevel ? this._bevel : this._depth) - w, this._buffer.normals[_ + 0] = C * p, this._buffer.normals[_ + 1] = P * p, this._buffer.normals[_ + 2] = m, this._buffer.uvs[D + 0] = A, this._buffer.uvs[D + 1] = T, this.forPathBevel === !1 && (this._buffer.positions[_ + 3] = v, this._buffer.positions[_ + 4] = S, this._buffer.positions[_ + 5] = w, this._buffer.normals[_ + 3] = C * p, this._buffer.normals[_ + 4] = P * p, this._buffer.normals[_ + 5] = -m, this._buffer.uvs[D + 2] = T, this._buffer.uvs[D + 3] = A)), this.vertexCache[a] = L, L;
    }
    clone() {
        let e = new Bl(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = pa(this.userData), e;
    }
};
var wd = class extends _e {
    constructor(e, r = 12, i = {}){
        super();
        this.type = "ShapeGeometry";
        this.windingRule = Gt.ODD;
        this.elementType = jr.POLYGONS;
        this.polySize = 3;
        this.vertexSize = 2;
        this.strict = !0;
        this._shape = e, this._curveSegments = r, this._triangulationOptions = Object.assign({
            windingRule: Gt.ODD,
            elementType: jr.POLYGONS,
            polySize: 3,
            vertexSize: 2,
            strict: !0
        }, i);
        let s = this._shape.extractShapePointsToFlatArray([], this._curveSegments), o = this._shape.shapeHoles.map((p)=>p.extractShapePointsToFlatArray([], this._curveSegments)), a, l = !0, c = !0, u, h;
        for(let p = 0, m = s.length / 2; p < m; p++){
            let g = p * 2, y = s[g + 0], x = s[g + 1];
            if (u !== void 0 && y !== u && (l = !1), h !== void 0 && x !== h && (c = !1), u = y, h = x, !l && !c) break;
        }
        if (!l && !c) try {
            a = qs({
                contours: [
                    s,
                    ...o
                ],
                windingRule: this._triangulationOptions.windingRule,
                elementType: this._triangulationOptions.elementType,
                polySize: this._triangulationOptions.polySize,
                vertexSize: this._triangulationOptions.vertexSize,
                strict: this._triangulationOptions.strict
            });
        } catch  {
            a = um;
        }
        let d = a?.vertexCount ?? 1, f = a?.elementCount ?? 1;
        if (this._positionAttribute = new Xe(new Float32Array(d * 3), 3), this._normalAttribute = new Xe(new Float32Array(d * 3), 3), this._uvAttribute = new Xe(new Float32Array(d * 2), 2), this._indexAttribute = new Xe(new Uint32Array(f * 3), 1), a) {
            let p = 1 / 0, m = -1 / 0, g = 1 / 0, y = -1 / 0;
            for(let S = 0, w = d; S < w; S++){
                let A = S * 2, T = a.vertices[A + 0], b = a.vertices[A + 1];
                T < p && (p = T), T > m && (m = T), b < g && (g = b), b > y && (y = b);
            }
            let x = m - p, v = y - g;
            for(let S = 0, w = d; S < w; S++){
                let A = S * 2, T = a.vertices[A + 0], b = a.vertices[A + 1], M = (T - p) / x, C = (b - g) / v;
                this._positionAttribute.setXYZ(S, T, b, 0), this._normalAttribute.setXYZ(S, 0, 0, 1), this._uvAttribute.setXY(S, M, C);
            }
            for(let S = 0, w = f; S < w; S++){
                let A = S * 3, T = a.elements[A + 0], b = a.elements[A + 1], M = a.elements[A + 2];
                this._indexAttribute.setX(A + 0, T), this._indexAttribute.setX(A + 1, b), this._indexAttribute.setX(A + 2, M);
            }
        }
        this.setAttribute("position", this._positionAttribute), this.setAttribute("normal", this._normalAttribute), this.setAttribute("uv", this._uvAttribute), this.setIndex(this._indexAttribute), this.setDrawRange(0, (a?.elementCount ?? 1) * 3);
    }
    clone() {
        let e = new wd(this._shape, this._curveSegments);
        return e.userData = pa(this.userData), e;
    }
};
var Ad = class extends Bl {
    constructor(e, r, i = 0, s = 12, o = 3, a = Gt.ODD){
        super(e, r, i, s, o, a);
        this.type = "ShapeGeometry";
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, r, i) {
        let s = e[0];
        for(let o = 0, a = s.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(r, s, o), c = this._buildBevelVert(r, s, (o + 1) % a);
            i.push(c.topP, l.topN, l.bottomN), i.push(c.topP, l.bottomN, c.bottomP);
        }
    }
    clone() {
        let e = new Ad(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = pa(this.userData), e;
    }
};
var Rn = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            subdivisions: 40,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3,
            windingRule: Gt.ODD
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.abs(e.depth ?? 0), o = n1.shape ?? t?.shape, a = o?.roundness ?? e.roundness;
        o !== void 0 && (o instanceof Xt ? (o.width !== r || o.height !== i) && o.applySize(r, i) : o = new Xt(r, i).fromJSON(o), n1.parameters?.roundness !== void 0 && n1.parameters?.roundness > 0 && o.update());
        let l = o ?? new Xt(r, i);
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s,
                roundness: a
            }),
            shape: l
        };
    }
    static build(n1) {
        let { depth: t, extrudeBevelSize: e, extrudeBevelSegments: r, subdivisions: i, roundness: s, windingRule: o } = n1.parameters;
        n1.shape.roundness = s;
        let a;
        return t <= 0 ? a = new wd(n1.shape, i, {
            windingRule: o
        }) : a = new Ad(n1.shape, t, e, i, r, o), Object.assign(a, {
            userData: {
                ...n1,
                type: "VectorGeometry"
            }
        });
    }
};
var OO = Math.PI * 2, Td = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 64,
            angle: 360,
            innerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters);
        return e.angle = we.clamp(e.angle, 0, 360), {
            shape: n1.shape && n1.shape instanceof Xt ? n1.shape : new Xt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, spikes: r, angle: i, innerRadius: s, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l } = n1.parameters, c = n1.shape, u = t * .5, h = e * .5, d = K7(c, u, h, i * Math.PI / 180, r, s);
        c.isClosed = !0, c.update();
        let f;
        return i === 0 ? (f = new _e, f.setAttribute("position", new Te([], 3))) : f = Rn.create({
            shape: c,
            parameters: {
                subdivisions: d,
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        }), Object.assign(f, {
            userData: {
                ...n1,
                type: "EllipseGeometry"
            }
        });
    }
};
function K7(n1, t, e, r, i, s) {
    if (r >= OO) return i > 30 || i % 4 === 0 ? (Z7(n1, t, e, s), Math.round(i / 4)) : DO(n1, r, i, t, e, s);
    r = Math.max(r, .001);
    let o = {
        x: 0,
        y: e
    }, a = r + Math.PI * .5, l = {
        x: Math.cos(a) * t,
        y: Math.sin(a) * e
    }, c = MO({
        px: o.x,
        py: o.y,
        cx: l.x,
        cy: l.y,
        rx: t,
        ry: e,
        largeArcFlag: r > Math.PI,
        sweepFlag: !0
    });
    return i > 30 || i % c.length === 0 ? Q7(n1, o.x, o.y, c, i, t, e, s) : DO(n1, r, i, t, e, s);
}
function Q7(n1, t, e, r, i, s, o, a) {
    let l = Math.round(i / r.length);
    n1.addPoint(Ed(t, e));
    for(let c = 0, u = r.length; c < u; c++){
        let h = r[c], d = n1.points[c], f = Ed(h.x, h.y);
        d.controls[1].position.set(h.x1, h.y1), f.controls[0].position.set(h.x2, h.y2), n1.addPoint(f);
    }
    return a > 0 ? RO(n1, s, o, a) : n1.addPoint(Ed(0, 0)), l;
}
function DO(n1, t, e, r, i, s) {
    let o = -t / e;
    for(let a = 0; a <= e; a++){
        let l = o * a, c = Math.sin(l) * r, u = Math.cos(l) * i;
        n1.addPoint(Ed(c, u));
    }
    return t < OO ? s > 0 ? RO(n1, r, i, s) : n1.addPoint(Ed(0, 0)) : (n1.removePoint(n1.points[n1.points.length - 1]), s > 0 && LO(n1, r, i, s)), 1;
}
function Z7(n1, t, e, r = 0, i = 0, s = 0) {
    let o = .5522847498, a = t * o, l = e * o;
    n1.addPoint(_0(i - t, s, i - t, s - l, i - t, s + l)), n1.addPoint(_0(i, s + e, i - a, s + e, i + a, s + e)), n1.addPoint(_0(i + t, s, i + t, s + l, i + t, s - l)), n1.addPoint(_0(i, s - e, i + a, s - e, i - a, s - e)), r > 0 && LO(n1, t, e, r);
}
function Ed(n1, t) {
    return new Ws(we.generateUUID(), new k(n1, t));
}
function _0(n1, t, e, r, i, s) {
    let o = Ed(n1, t);
    return o.controls[0].position.set(e, r), o.controls[1].position.set(i, s), o;
}
function RO(n1, t, e, r) {
    BO(n1, t, e, r).forEach((s)=>n1.addPoint(s));
}
function LO(n1, t, e, r) {
    let i = BO(n1, t, e, r), s = new Xt;
    i.forEach((o)=>s.addPoint(o)), s.isClosed = !0, n1.shapeHoles.push(s);
}
function BO(n1, t, e, r) {
    let i = r * t / 100, s = i * (Math.abs(e) / Math.abs(t)), o = new k(i / t, s / e), a = n1.points.map((l)=>{
        let c = l.clone();
        return c.uuid = we.generateUUID(), c;
    }).reverse();
    return a.forEach((l)=>{
        l.position.multiply(o);
        let c = l.controls[0].position.clone().multiply(o), u = l.controls[1].position.clone().multiply(o);
        l.controls[0].position.copy(u), l.controls[1].position.copy(c);
    }), a;
}
var NO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            revolutions: 2,
            segments: 40,
            pathRadius: 10,
            pathType: 0,
            pathSegments: 30,
            cornerRadius: 30,
            cornerSegments: 4
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? r), s = Math.abs(e.depth ?? r), o = Math.abs(Math.min(r, s)) / 2;
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s,
                radius: o,
                segments: Math.round(e.segments),
                pathSegments: Math.round(e.pathSegments),
                cornerSegments: Math.round(e.cornerSegments)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radius: i, revolutions: s, segments: o, pathRadius: a, pathType: l, pathSegments: c, cornerRadius: u, cornerSegments: h } = n1.parameters, d = new hm(!1, t, e, r, i, s, o, a, l, c, u, h);
        return Object.assign(d, {
            userData: {
                ...n1,
                type: "HelixGeometry"
            }
        });
    }
}, F1 = new po([
    0,
    0,
    0
], 1), hm = class extends _e {
    constructor(t = !0, e = 1, r = 1, i = 1, s = 1, o = 1, a = 1, l = 1, c = 1, u = 1, h = 1, d = 1){
        if (super(), o === 0) return;
        let f = t && o === 1;
        f && (d = 0), h > 100 && (h = 100), h === 0 && (d = 0);
        let p = ()=>new E, m = new E, g = p(), y = p(), x = p(), v, S, w, A, T, b, M, C, P = p(), I = p(), _ = p(), D = p(), L = p(), j = p(), V = p(), H = p(), W = r - 2 * l + .001, q = W / o, Q = Math.ceil(a * o), G = Q + 1, Z = W / Q, te = -W / 2, $ = u + 1, Y = 2 * Math.PI / u, oe = Math.PI / 2 / d, ie = .01, re = Math.min((1 - h / 100) * l, l - ie), J = l - re, Ee = 0, xe = 2, de = d * xe + xe, De = $ * de / xe, Ce = De + $ * G, ze = Math.max(0, $ * (G + de)), [Ue, Ve, Oe] = [
            3,
            3,
            2
        ].map((Ge)=>Array(ze * Ge).fill(0)), Ye = [], F = s - l;
        function N(Ge, Be) {
            let et = Math.PI / 2;
            b = Be * Z, C = 2 * Math.PI * (b % q) / q + et, b += te, M = Math.sin(C) * F, T = Math.cos(C) * F, t ? Ge.set(T, M, b) : Ge.set(T, b, M);
        }
        N(m, -0.0000000001), N(g, 0), P.copy(m), N(m, 1);
        let B = m.distanceTo(g), ae = f ? 0 : J + re, ge = B * Q + 2 * ae, me = re, Le = ge - ae;
        for(let Ge = 0; Ge <= Q; Ge++){
            N(y, Ge), H.subVectors(y, P).normalize(), P.copy(y), j.copy(y).setComponent(+t + 1, 0).normalize(), V.crossVectors(H, j).normalize();
            let Be = Ge === 0, et = Ge === Q, st = Be ? 3 * Math.PI / 2 : oe, Bt = Be ? me : Le, dr = Be ? $ : Ce, Tr = Be ? 0 : ze - $, K = H.clone().multiplyScalar(Be ? -J : J).add(y), ye = H.clone().multiplyScalar(Be ? -1 : 1).normalize();
            for(let Me = 0; Me < $; Me++){
                let je = Me * Y;
                if (I.addVectors(m.copy(j).multiplyScalar(l * Math.cos(je)), g.copy(V).multiplyScalar(l * Math.sin(je))), _.copy(I).normalize(), Be || et) {
                    f || (Ee = Tr + Me, [
                        0,
                        1,
                        2
                    ].forEach((He)=>{
                        Ue[Ee * 3 + He] = K.getComponent(He), Ve[Ee * 3 + He] = ye.getComponent(He);
                    }), Oe[Ee * 2] = +et, Oe[Ee * 2 + 1] = Me / u), g.copy(_).multiplyScalar(re), x.addVectors(y, g);
                    for(let He = 0; He < d; He++){
                        let _t = He * oe + st;
                        D.addVectors(m.copy(H).multiplyScalar(J * Math.sin(_t)), g.copy(_).multiplyScalar(J * Math.cos(_t))), L.copy(D).normalize(), g.addVectors(x, D), D.normalize(), Ee = dr + He * $ + Me, [
                            0,
                            1,
                            2
                        ].forEach((Vr)=>{
                            Ue[Ee * 3 + Vr] = g.getComponent(Vr), Ve[Ee * 3 + Vr] = L.getComponent(Vr);
                        });
                        let Fr = +Be + Math.sin(_t);
                        Oe[Ee * 2] = (Bt + J * Fr) / ge, Oe[Ee * 2 + 1] = Me / u;
                    }
                }
                g.addVectors(y, I), Ee = De + Ge * $ + Me, [
                    0,
                    1,
                    2
                ].forEach((He)=>{
                    Ue[Ee * 3 + He] = g.getComponent(He), Ve[Ee * 3 + He] = _.getComponent(He);
                }), Oe[Ee * 2] = (ae + Ge * B) / ge, Oe[Ee * 2 + 1] = Me / u;
            }
        }
        let Ne = G + 2 * d + xe, Re = 1, [pe, nt] = [
            +f,
            Ne - 1
        ];
        for(let Ge = pe; Ge <= nt - 1; Ge++){
            let Be = f && Ge === nt - 1;
            for(let et = 0; et < $ - 1; et++)v = Ge * $ + et, S = v + 1, w = (Be ? et : v) + $, A = (Be ? et + 1 : S) + $, Ge === 0 ? Ye.push(S, A, w) : Ge === Ne - 2 ? Ye.push(v, S, w) : Ye.push(v, S, w, S, A, w);
        }
        this.setIndex(Ye), this.setAttribute("position", new Te(Ue, 3)), this.setAttribute("normal", new Te(Ve, 3)), this.setAttribute("uv", new Te(Oe, 2));
    }
    getClosedTorusIndicesForBooleanOrSubdiv() {
        let t = this.userData.parameters, e = Math.ceil(t.tubularSegments), r = t.radialSegments + 1, i = Array.from(this.getIndex().array), s, o, a, l, c = 6 * (e - 1) * t.radialSegments, u = e, h = u === e;
        for(let d = 0; d < t.radialSegments; d++)s = u * r + d, o = s + 1, a = (h ? d : s) + r, l = (h ? d + 1 : o) + r, i[c++] = s, i[c++] = o, i[c++] = a, i[c++] = o, i[c++] = l, i[c++] = a;
        return i.length = c, F1.array = i, F1.count = i.length, F1;
    }
};
var FO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, detail: i, corner: s, cornerSides: o } = n1.parameters, a = i === 0 && s !== 0 ? new dm(t * .5, s, o) : new Gu(t * .5, i);
        return a.scale(1, e / t, r / t), Object.assign(a, {
            userData: {
                ...n1,
                type: "IcosahedronGeometry"
            }
        });
    }
}, dm = class extends Rl {
    constructor(t = 1, e = .2, r = 4){
        let i = (1 + Math.sqrt(5)) / 2, s = [
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            0,
            0,
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            i,
            0,
            -1,
            i,
            0,
            1,
            -i,
            0,
            -1,
            -i,
            0,
            1
        ], o = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ], a = "IcosahedronGeometry";
        super(s, o, a, t, e, r), this.type = a;
    }
    static fromJSON(t) {
        return new dm(t.radius, t.corner, t.cornerSides);
    }
};
var VO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        (n1.parameters?.points ?? []).forEach((r)=>{
            Array.isArray(r) && (r.x = r[0], r.y = r[1]);
        });
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            segments: 64,
            verticalSegments: 64,
            points: [
                {
                    x: 0,
                    y: -50,
                    id: 0
                },
                {
                    x: 50,
                    y: -50,
                    id: 1
                },
                {
                    x: 50,
                    y: 50,
                    id: 2
                },
                {
                    x: 0,
                    y: 50,
                    id: 3
                }
            ]
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { points: t, segments: e, verticalSegments: r } = n1.parameters, i = new la;
        i.moveTo(t[0].x, t[0].y), i.bezierCurveTo(t[1].x, t[1].y, t[2].x, t[2].y, t[3].x, t[3].y);
        let s = new Vu(i.extractPoints(r).shape, e);
        return s.rotateZ(Math.PI), Object.assign(s, {
            userData: {
                ...n1,
                type: "LatheGeometry"
            }
        });
    }
};
var Lo = new ue, V1 = new Tt, I0 = new E, Nl = class extends pr {
    constructor(){
        super(), this.uuid = we.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    applyMatrix4(t) {
        let e = new fr().getNormalMatrix(t);
        for(let r = 0, i = this.vertices.length; r < i; r++)this.vertices[r].applyMatrix4(t);
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s = this.faces[r];
            s.normal.applyMatrix3(e).normalize();
            for(let o = 0, a = s.vertexNormals.length; o < a; o++)s.vertexNormals[o].applyMatrix3(e).normalize();
        }
        return this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
    }
    rotateX(t) {
        return Lo.makeRotationX(t), this.applyMatrix4(Lo), this;
    }
    rotateY(t) {
        return Lo.makeRotationY(t), this.applyMatrix4(Lo), this;
    }
    rotateZ(t) {
        return Lo.makeRotationZ(t), this.applyMatrix4(Lo), this;
    }
    translate(t, e, r) {
        return Lo.makeTranslation(t, e, r), this.applyMatrix4(Lo), this;
    }
    scale(t, e, r) {
        return Lo.makeScale(t, e, r), this.applyMatrix4(Lo), this;
    }
    lookAt(t) {
        return V1.lookAt(t), V1.updateMatrix(), this.applyMatrix4(V1.matrix), this;
    }
    fromBufferGeometry(t) {
        let e = this, r = t.index !== null ? t.index : void 0, i = t.attributes;
        if (i.position === void 0) return console.error("THREE.Geometry.fromBufferGeometry(): Position attribute required for conversion."), this;
        let s = i.position, o = i.normal, a = i.color, l = i.uv, c = i.uv2;
        c !== void 0 && (this.faceVertexUvs[1] = []);
        for(let d = 0; d < s.count; d++)e.vertices.push(new E().fromBufferAttribute(s, d)), a !== void 0 && e.colors.push(new We().fromBufferAttribute(a, d));
        function u(d, f, p, m) {
            let g = a === void 0 ? [] : [
                e.colors[d].clone(),
                e.colors[f].clone(),
                e.colors[p].clone()
            ], y = o === void 0 ? [] : [
                new E().fromBufferAttribute(o, d),
                new E().fromBufferAttribute(o, f),
                new E().fromBufferAttribute(o, p)
            ], x = new Md(d, f, p, y, g, m);
            e.faces.push(x), l !== void 0 && e.faceVertexUvs[0].push([
                new k().fromBufferAttribute(l, d),
                new k().fromBufferAttribute(l, f),
                new k().fromBufferAttribute(l, p)
            ]), c !== void 0 && e.faceVertexUvs[1].push([
                new k().fromBufferAttribute(c, d),
                new k().fromBufferAttribute(c, f),
                new k().fromBufferAttribute(c, p)
            ]);
        }
        let h = t.groups;
        if (h.length > 0) for(let d = 0; d < h.length; d++){
            let f = h[d], p = f.start, m = f.count;
            for(let g = p, y = p + m; g < y; g += 3)r !== void 0 ? u(r.getX(g), r.getX(g + 1), r.getX(g + 2), f.materialIndex) : u(g, g + 1, g + 2, f.materialIndex);
        }
        else if (r !== void 0) for(let d = 0; d < r.count; d += 3)u(r.getX(d), r.getX(d + 1), r.getX(d + 2));
        else for(let d = 0; d < s.count; d += 3)u(d, d + 1, d + 2);
        return this.computeFaceNormals(), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(I0).negate(), this.translate(I0.x, I0.y, I0.z), this;
    }
    normalize() {
        this.computeBoundingSphere();
        let t = this.boundingSphere.center, e = this.boundingSphere.radius, r = e === 0 ? 1 : 1 / e, i = new ue;
        return i.set(r, 0, 0, -r * t.x, 0, r, 0, -r * t.y, 0, 0, r, -r * t.z, 0, 0, 0, 1), this.applyMatrix4(i), this;
    }
    computeFaceNormals() {
        let t = new E, e = new E;
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s = this.faces[r], o = this.vertices[s.a], a = this.vertices[s.b], l = this.vertices[s.c];
            t.subVectors(l, a), e.subVectors(o, a), t.cross(e), t.normalize(), s.normal.copy(t);
        }
    }
    computeVertexNormals(t = !0) {
        let e = new Array(this.vertices.length);
        for(let r = 0, i = this.vertices.length; r < i; r++)e[r] = new E;
        if (t) {
            let r = new E, i = new E;
            for(let s = 0, o = this.faces.length; s < o; s++){
                let a = this.faces[s], l = this.vertices[a.a], c = this.vertices[a.b], u = this.vertices[a.c];
                r.subVectors(u, c), i.subVectors(l, c), r.cross(i), e[a.a].add(r), e[a.b].add(r), e[a.c].add(r);
            }
        } else {
            this.computeFaceNormals();
            for(let r = 0, i = this.faces.length; r < i; r++){
                let s = this.faces[r];
                e[s.a].add(s.normal), e[s.b].add(s.normal), e[s.c].add(s.normal);
            }
        }
        for(let r = 0, i = this.vertices.length; r < i; r++)e[r].normalize();
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s = this.faces[r], o = s.vertexNormals;
            o.length === 3 ? (o[0].copy(e[s.a]), o[1].copy(e[s.b]), o[2].copy(e[s.c])) : (o[0] = e[s.a].clone(), o[1] = e[s.b].clone(), o[2] = e[s.c].clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeFlatVertexNormals() {
        this.computeFaceNormals();
        for(let t = 0, e = this.faces.length; t < e; t++){
            let r = this.faces[t], i = r.vertexNormals;
            i.length === 3 ? (i[0].copy(r.normal), i[1].copy(r.normal), i[2].copy(r.normal)) : (i[0] = r.normal.clone(), i[1] = r.normal.clone(), i[2] = r.normal.clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeMorphNormals() {
        for(let e = 0, r = this.faces.length; e < r; e++){
            let i = this.faces[e];
            i.__originalFaceNormal ? i.__originalFaceNormal.copy(i.normal) : i.__originalFaceNormal = i.normal.clone(), i.__originalVertexNormals || (i.__originalVertexNormals = []);
            for(let s = 0, o = i.vertexNormals.length; s < o; s++)i.__originalVertexNormals[s] ? i.__originalVertexNormals[s].copy(i.vertexNormals[s]) : i.__originalVertexNormals[s] = i.vertexNormals[s].clone();
        }
        let t = new Nl;
        t.faces = this.faces;
        for(let e = 0, r = this.morphTargets.length; e < r; e++){
            if (!this.morphNormals[e]) {
                this.morphNormals[e] = {}, this.morphNormals[e].faceNormals = [], this.morphNormals[e].vertexNormals = [];
                let s = this.morphNormals[e].faceNormals, o = this.morphNormals[e].vertexNormals;
                for(let a = 0, l = this.faces.length; a < l; a++){
                    let c = new E, u = {
                        a: new E,
                        b: new E,
                        c: new E
                    };
                    s.push(c), o.push(u);
                }
            }
            let i = this.morphNormals[e];
            t.vertices = this.morphTargets[e].vertices, t.computeFaceNormals(), t.computeVertexNormals();
            for(let s = 0, o = this.faces.length; s < o; s++){
                let a = this.faces[s], l = i.faceNormals[s], c = i.vertexNormals[s];
                l.copy(a.normal), c.a.copy(a.vertexNormals[0]), c.b.copy(a.vertexNormals[1]), c.c.copy(a.vertexNormals[2]);
            }
        }
        for(let e = 0, r = this.faces.length; e < r; e++){
            let i = this.faces[e];
            i.normal = i.__originalFaceNormal, i.vertexNormals = i.__originalVertexNormals;
        }
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Wt), this.boundingBox.setFromPoints(this.vertices);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new Rr), this.boundingSphere.setFromPoints(this.vertices);
    }
    merge(t, e, r = 0) {
        if (!(t && t.isGeometry)) {
            console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", t);
            return;
        }
        let i, s = this.vertices.length, o = this.vertices, a = t.vertices, l = this.faces, c = t.faces, u = this.colors, h = t.colors;
        e !== void 0 && (i = new fr().getNormalMatrix(e));
        for(let d = 0, f = a.length; d < f; d++){
            let m = a[d].clone();
            e !== void 0 && m.applyMatrix4(e), o.push(m);
        }
        for(let d = 0, f = h.length; d < f; d++)u.push(h[d].clone());
        for(let d = 0, f = c.length; d < f; d++){
            let p = c[d], m, g, y = p.vertexNormals, x = p.vertexColors, v = new Md(p.a + s, p.b + s, p.c + s);
            v.normal.copy(p.normal), i !== void 0 && v.normal.applyMatrix3(i).normalize();
            for(let S = 0, w = y.length; S < w; S++)m = y[S].clone(), i !== void 0 && m.applyMatrix3(i).normalize(), v.vertexNormals.push(m);
            v.color.copy(p.color);
            for(let S = 0, w = x.length; S < w; S++)g = x[S], v.vertexColors.push(g.clone());
            v.materialIndex = p.materialIndex + r, l.push(v);
        }
        for(let d = 0, f = t.faceVertexUvs.length; d < f; d++){
            let p = t.faceVertexUvs[d];
            this.faceVertexUvs[d] === void 0 && (this.faceVertexUvs[d] = []);
            for(let m = 0, g = p.length; m < g; m++){
                let y = p[m], x = [];
                for(let v = 0, S = y.length; v < S; v++)x.push(y[v].clone());
                this.faceVertexUvs[d].push(x);
            }
        }
    }
    mergeMesh(t) {
        if (!(t && t.isMesh)) {
            console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", t);
            return;
        }
        t.matrixAutoUpdate && t.updateMatrix(), this.merge(t.geometry, t.matrix);
    }
    mergeVertices(t = 4) {
        let e = {}, r = [], i = [], s = Math.pow(10, t);
        for(let l = 0, c = this.vertices.length; l < c; l++){
            let u = this.vertices[l], h = Math.round(u.x * s) + "_" + Math.round(u.y * s) + "_" + Math.round(u.z * s);
            e[h] === void 0 ? (e[h] = l, r.push(this.vertices[l]), i[l] = r.length - 1) : i[l] = i[e[h]];
        }
        let o = [];
        for(let l = 0, c = this.faces.length; l < c; l++){
            let u = this.faces[l];
            u.a = i[u.a], u.b = i[u.b], u.c = i[u.c];
            let h = [
                u.a,
                u.b,
                u.c
            ];
            for(let d = 0; d < 3; d++)if (h[d] === h[(d + 1) % 3]) {
                o.push(l);
                break;
            }
        }
        for(let l = o.length - 1; l >= 0; l--){
            let c = o[l];
            this.faces.splice(c, 1);
            for(let u = 0, h = this.faceVertexUvs.length; u < h; u++)this.faceVertexUvs[u].splice(c, 1);
        }
        let a = this.vertices.length - r.length;
        return this.vertices = r, a;
    }
    setFromPoints(t) {
        this.vertices = [];
        for(let e = 0, r = t.length; e < r; e++){
            let i = t[e];
            this.vertices.push(new E(i.x, i.y, i.z || 0));
        }
        return this;
    }
    sortFacesByMaterialIndex() {
        let t = this.faces, e = t.length;
        for(let l = 0; l < e; l++)t[l]._id = l;
        function r(l, c) {
            return l.materialIndex - c.materialIndex;
        }
        t.sort(r);
        let i = this.faceVertexUvs[0], s = this.faceVertexUvs[1], o, a;
        i && i.length === e && (o = []), s && s.length === e && (a = []);
        for(let l = 0; l < e; l++){
            let c = t[l]._id;
            o && o.push(i[c]), a && a.push(s[c]);
        }
        o && (this.faceVertexUvs[0] = o), a && (this.faceVertexUvs[1] = a);
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Geometry",
                generator: "Geometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), this.parameters !== void 0) {
            let p = this.parameters;
            for(let m in p)p[m] !== void 0 && (t[m] = p[m]);
            return t;
        }
        let e = [];
        for(let p = 0; p < this.vertices.length; p++){
            let m = this.vertices[p];
            e.push(m.x, m.y, m.z);
        }
        let r = [], i = [], s = {}, o = [], a = {}, l = [], c = {};
        for(let p = 0; p < this.faces.length; p++){
            let m = this.faces[p], g = !0, y = !1, x = this.faceVertexUvs[0][p] !== void 0, v = m.normal.length() > 0, S = m.vertexNormals.length > 0, w = m.color.r !== 1 || m.color.g !== 1 || m.color.b !== 1, A = m.vertexColors.length > 0, T = 0;
            if (T = u(T, 0, 0), T = u(T, 1, g), T = u(T, 2, y), T = u(T, 3, x), T = u(T, 4, v), T = u(T, 5, S), T = u(T, 6, w), T = u(T, 7, A), r.push(T), r.push(m.a, m.b, m.c), r.push(m.materialIndex), x) {
                let b = this.faceVertexUvs[0][p];
                r.push(f(b[0]), f(b[1]), f(b[2]));
            }
            if (v && r.push(h(m.normal)), S) {
                let b = m.vertexNormals;
                r.push(h(b[0]), h(b[1]), h(b[2]));
            }
            if (w && r.push(d(m.color)), A) {
                let b = m.vertexColors;
                r.push(d(b[0]), d(b[1]), d(b[2]));
            }
        }
        function u(p, m, g) {
            return g ? p | 1 << m : p & ~(1 << m);
        }
        function h(p) {
            let m = p.x.toString() + p.y.toString() + p.z.toString();
            return s[m] !== void 0 || (s[m] = i.length / 3, i.push(p.x, p.y, p.z)), s[m];
        }
        function d(p) {
            let m = p.r.toString() + p.g.toString() + p.b.toString();
            return a[m] !== void 0 || (a[m] = o.length, o.push(p.getHex())), a[m];
        }
        function f(p) {
            let m = p.x.toString() + p.y.toString();
            return c[m] !== void 0 || (c[m] = l.length / 2, l.push(p.x, p.y)), c[m];
        }
        return t.data = {}, t.data.vertices = e, t.data.normals = i, o.length > 0 && (t.data.colors = o), l.length > 0 && (t.data.uvs = [
            l
        ]), t.data.faces = r, t;
    }
    clone() {
        return new Nl().copy(this);
    }
    copy(t) {
        this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = t.name;
        let e = t.vertices;
        for(let d = 0, f = e.length; d < f; d++)this.vertices.push(e[d].clone());
        let r = t.colors;
        for(let d = 0, f = r.length; d < f; d++)this.colors.push(r[d].clone());
        let i = t.faces;
        for(let d = 0, f = i.length; d < f; d++)this.faces.push(i[d].clone());
        for(let d = 0, f = t.faceVertexUvs.length; d < f; d++){
            let p = t.faceVertexUvs[d];
            this.faceVertexUvs[d] === void 0 && (this.faceVertexUvs[d] = []);
            for(let m = 0, g = p.length; m < g; m++){
                let y = p[m], x = [];
                for(let v = 0, S = y.length; v < S; v++){
                    let w = y[v];
                    x.push(w.clone());
                }
                this.faceVertexUvs[d].push(x);
            }
        }
        let s = t.morphTargets;
        for(let d = 0, f = s.length; d < f; d++){
            let p = {};
            if (p.name = s[d].name, s[d].vertices !== void 0) {
                p.vertices = [];
                for(let m = 0, g = s[d].vertices.length; m < g; m++)p.vertices.push(s[d].vertices[m].clone());
            }
            if (s[d].normals !== void 0) {
                p.normals = [];
                for(let m = 0, g = s[d].normals.length; m < g; m++)p.normals.push(s[d].normals[m].clone());
            }
            this.morphTargets.push(p);
        }
        let o = t.morphNormals;
        for(let d = 0, f = o.length; d < f; d++){
            let p = {};
            if (o[d].vertexNormals !== void 0) {
                p.vertexNormals = [];
                for(let m = 0, g = o[d].vertexNormals.length; m < g; m++){
                    let y = o[d].vertexNormals[m], x = {};
                    x.a = y.a.clone(), x.b = y.b.clone(), x.c = y.c.clone(), p.vertexNormals.push(x);
                }
            }
            if (o[d].faceNormals !== void 0) {
                p.faceNormals = [];
                for(let m = 0, g = o[d].faceNormals.length; m < g; m++)p.faceNormals.push(o[d].faceNormals[m].clone());
            }
            this.morphNormals.push(p);
        }
        let a = t.skinWeights;
        for(let d = 0, f = a.length; d < f; d++)this.skinWeights.push(a[d].clone());
        let l = t.skinIndices;
        for(let d = 0, f = l.length; d < f; d++)this.skinIndices.push(l[d].clone());
        let c = t.lineDistances;
        for(let d = 0, f = c.length; d < f; d++)this.lineDistances.push(c[d]);
        let u = t.boundingBox;
        u !== null && (this.boundingBox = u.clone());
        let h = t.boundingSphere;
        return h !== null && (this.boundingSphere = h.clone()), this.elementsNeedUpdate = t.elementsNeedUpdate, this.verticesNeedUpdate = t.verticesNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.lineDistancesNeedUpdate = t.lineDistancesNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, this;
    }
    toBufferGeometry() {
        let t = new k1().fromGeometry(this), e = new _e, r = new Float32Array(t.vertices.length * 3);
        if (e.setAttribute("position", D0.call(new Xe(r, 3), t.vertices)), t.normals.length > 0) {
            let i = new Float32Array(t.normals.length * 3);
            e.setAttribute("normal", D0.call(new Xe(i, 3), t.normals));
        }
        if (t.colors.length > 0) {
            let i = new Float32Array(t.colors.length * 3);
            e.setAttribute("color", kO.call(new Xe(i, 3), t.colors));
        }
        if (t.uvs.length > 0) {
            let i = new Float32Array(t.uvs.length * 2);
            e.setAttribute("uv", UO.call(new Xe(i, 2), t.uvs));
        }
        if (t.uvs2.length > 0) {
            let i = new Float32Array(t.uvs2.length * 2);
            e.setAttribute("uv2", UO.call(new Xe(i, 2), t.uvs2));
        }
        e.groups = t.groups;
        for(let i in t.morphTargets){
            let s = [], o = t.morphTargets[i];
            for(let a = 0, l = o.length; a < l; a++){
                let c = o[a], u = new Te(c.data.length * 3, 3);
                u.name = c.name, s.push(D0.call(u, c.data));
            }
            e.morphAttributes[i] = s;
        }
        if (t.skinIndices.length > 0) {
            let i = new Te(t.skinIndices.length * 4, 4);
            e.setAttribute("skinIndex", zO.call(i, t.skinIndices));
        }
        if (t.skinWeights.length > 0) {
            let i = new Te(t.skinWeights.length * 4, 4);
            e.setAttribute("skinWeight", zO.call(i, t.skinWeights));
        }
        return t.boundingSphere !== null && (e.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (e.boundingBox = t.boundingBox.clone()), e;
    }
    computeTangents() {
        console.error("THREE.Geometry: .computeTangents() has been removed.");
    }
    computeLineDistances() {
        console.error("THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.");
    }
    applyMatrix(t) {
        return console.warn("THREE.Geometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    static createBufferGeometryFromObject(t) {
        let e = new _e, r = t.geometry;
        if (t.isPoints || t.isLine) {
            let i = new Te(r.vertices.length * 3, 3), s = new Te(r.colors.length * 3, 3);
            if (e.setAttribute("position", D0.call(i, r.vertices)), e.setAttribute("color", kO.call(s, r.colors)), r.lineDistances && r.lineDistances.length === r.vertices.length) {
                let o = new Te(r.lineDistances.length, 1);
                e.setAttribute("lineDistance", J7.call(o, r.lineDistances));
            }
            r.boundingSphere !== null && (e.boundingSphere = r.boundingSphere.clone()), r.boundingBox !== null && (e.boundingBox = r.boundingBox.clone());
        } else t.isMesh && (e = r.toBufferGeometry());
        return e;
    }
};
Nl.prototype.isGeometry = !0;
var k1 = class {
    constructor(){
        this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    computeGroups(t) {
        let e = [], r, i, s, o = t.faces;
        for(i = 0; i < o.length; i++){
            let a = o[i];
            a.materialIndex !== s && (s = a.materialIndex, r !== void 0 && (r.count = i * 3 - r.start, e.push(r)), r = {
                start: i * 3,
                materialIndex: s
            });
        }
        r !== void 0 && (r.count = i * 3 - r.start, e.push(r)), this.groups = e;
    }
    fromGeometry(t) {
        let e = t.faces, r = t.vertices, i = t.faceVertexUvs, s = i[0] && i[0].length > 0, o = i[1] && i[1].length > 0, a = t.morphTargets, l = a.length, c;
        if (l > 0) {
            c = [];
            for(let y = 0; y < l; y++)c[y] = {
                name: a[y].name,
                data: []
            };
            this.morphTargets.position = c;
        }
        let u = t.morphNormals, h = u.length, d;
        if (h > 0) {
            d = [];
            for(let y = 0; y < h; y++)d[y] = {
                name: u[y].name,
                data: []
            };
            this.morphTargets.normal = d;
        }
        let f = t.skinIndices, p = t.skinWeights, m = f.length === r.length, g = p.length === r.length;
        r.length > 0 && e.length === 0 && console.error("THREE.DirectGeometry: Faceless geometries are not supported.");
        for(let y = 0; y < e.length; y++){
            let x = e[y];
            this.vertices.push(r[x.a], r[x.b], r[x.c]);
            let v = x.vertexNormals;
            if (v.length === 3) this.normals.push(v[0], v[1], v[2]);
            else {
                let w = x.normal;
                this.normals.push(w, w, w);
            }
            let S = x.vertexColors;
            if (S.length === 3) this.colors.push(S[0], S[1], S[2]);
            else {
                let w = x.color;
                this.colors.push(w, w, w);
            }
            if (s === !0) {
                let w = i[0][y];
                w !== void 0 ? this.uvs.push(w[0], w[1], w[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", y), this.uvs.push(new k, new k, new k));
            }
            if (o === !0) {
                let w = i[1][y];
                w !== void 0 ? this.uvs2.push(w[0], w[1], w[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", y), this.uvs2.push(new k, new k, new k));
            }
            for(let w = 0; w < l; w++){
                let A = a[w].vertices;
                c[w].data.push(A[x.a], A[x.b], A[x.c]);
            }
            for(let w = 0; w < h; w++){
                let A = u[w].vertexNormals[y];
                d[w].data.push(A.a, A.b, A.c);
            }
            m && this.skinIndices.push(f[x.a], f[x.b], f[x.c]), g && this.skinWeights.push(p[x.a], p[x.b], p[x.c]);
        }
        return this.computeGroups(t), this.verticesNeedUpdate = t.verticesNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), this;
    }
}, Md = class {
    constructor(t, e, r, i, s, o = 0){
        this.a = t, this.b = e, this.c = r, this.normal = i && i.isVector3 ? i : new E, this.vertexNormals = Array.isArray(i) ? i : [], this.color = s && s.isColor ? s : new We, this.vertexColors = Array.isArray(s) ? s : [], this.materialIndex = o;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.a = t.a, this.b = t.b, this.c = t.c, this.normal.copy(t.normal), this.color.copy(t.color), this.materialIndex = t.materialIndex;
        for(let e = 0, r = t.vertexNormals.length; e < r; e++)this.vertexNormals[e] = t.vertexNormals[e].clone();
        for(let e = 0, r = t.vertexColors.length; e < r; e++)this.vertexColors[e] = t.vertexColors[e].clone();
        return this;
    }
};
function J7(n1) {
    return this.array.set(n1), this;
}
function kO(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", r), s = new We), t[e++] = s.r, t[e++] = s.g, t[e++] = s.b;
    }
    return this;
}
function UO(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", r), s = new k), t[e++] = s.x, t[e++] = s.y;
    }
    return this;
}
function D0(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", r), s = new E), t[e++] = s.x, t[e++] = s.y, t[e++] = s.z;
    }
    return this;
}
function zO(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", r), s = new Ze), t[e++] = s.x, t[e++] = s.y, t[e++] = s.z, t[e++] = s.w;
    }
    return this;
}
var $7 = [
    "a",
    "b",
    "c"
];
function eY(n1, t) {
    switch(t){
        case "c":
            return n1.c;
        case "b":
            return n1.b;
        case "a":
        default:
            return n1.a;
    }
}
function U1(n1, t, e) {
    let r = Math.min(n1, t), i = Math.max(n1, t), s = r + "_" + i;
    return e.get(s);
}
function z1(n1, t, e, r, i, s) {
    let o = Math.min(n1, t), a = Math.max(n1, t), l = o + "_" + a, c;
    if (r.has(l)) c = r.get(l);
    else {
        let u = e[o], h = e[a];
        c = {
            a: u,
            b: h,
            newEdge: null,
            faces: []
        }, r.set(l, c);
    }
    c.faces.push(i), s[n1].edges.push(c), s[t].edges.push(c);
}
function tY(n1, t, e, r) {
    let i, s, o;
    for(i = 0, s = n1.length; i < s; i++)e[i] = {
        edges: []
    };
    for(i = 0, s = t.length; i < s; i++)o = t[i], z1(o.a, o.b, n1, r, o, e), z1(o.b, o.c, n1, r, o, e), z1(o.c, o.a, n1, r, o, e);
}
function O0(n1, t, e, r, i) {
    n1.push(new Md(t, e, r, void 0, void 0, i));
}
function Cd(n1, t) {
    return Math.abs(t - n1) / 2 + Math.min(n1, t);
}
function R0(n1, t, e, r) {
    n1.push([
        t.clone(),
        e.clone(),
        r.clone()
    ]);
}
var L0 = class {
    constructor(t = 1){
        this.subdivisions = t;
    }
    modify(t) {
        t instanceof _e ? t = new Nl().fromBufferGeometry(t) : t = t.clone(), t.mergeVertices();
        let e = this.subdivisions;
        for(; e-- > 0;)this._smooth(t);
        return t.computeFaceNormals(), t.computeVertexNormals(), t;
    }
    _smooth(t) {
        let e = new E, r, i, s, o, a, l = t.vertices, c = t.faces, u = t.faceVertexUvs[0], h = u !== void 0 && u.length > 0, d = [], f = new Map;
        tY(l, c, d, f);
        let p = [], m, g, y, x, v, S, w;
        for (let ie of Array.from(f.keys())){
            for(g = f.get(ie), y = new E, v = 3 / 8, S = 1 / 8, w = g.faces.length, w != 2 && (v = .5, S = 0, w), y.addVectors(g.a, g.b).multiplyScalar(v), e.set(0, 0, 0), o = 0; o < w; o++){
                for(x = g.faces[o], a = 0; a < 3 && (m = l[eY(x, $7[a])], !(m !== g.a && m !== g.b)); a++);
                m && e.add(m);
            }
            e.multiplyScalar(S), y.add(e), g.newEdge = p.length, p.push(y);
        }
        let A, T, b, M, C, P, I, _ = [];
        for(i = 0, s = l.length; i < s; i++){
            for(P = l[i], C = d[i].edges, r = C.length, r == 3 ? A = 3 / 16 : r > 3 && (A = 3 / (8 * r)), T = 1 - r * Number(A), b = A, r <= 2 && (r == 2 ? (T = 3 / 4, b = 1 / 8) : r == 1 || r), I = P.clone().multiplyScalar(T), e.set(0, 0, 0), o = 0; o < r; o++)M = C[o], m = M.a !== P ? M.a : M.b, e.add(m);
            e.multiplyScalar(Number(b)), I.add(e), _.push(I);
        }
        let D = _.concat(p), L = _.length, j, V, H, W = [], q = [], Q, G, Z, te, $ = new k, Y = new k, oe = new k;
        for(i = 0, s = c.length; i < s; i++)x = c[i], j = Number(U1(x.a, x.b, f).newEdge) + L, V = Number(U1(x.b, x.c, f).newEdge) + L, H = Number(U1(x.c, x.a, f).newEdge) + L, O0(W, j, V, H, x.materialIndex), O0(W, x.a, j, H, x.materialIndex), O0(W, x.b, V, j, x.materialIndex), O0(W, x.c, H, V, x.materialIndex), h && (Q = u[i], G = Q[0], Z = Q[1], te = Q[2], $.set(Cd(G.x, Z.x), Cd(G.y, Z.y)), Y.set(Cd(Z.x, te.x), Cd(Z.y, te.y)), oe.set(Cd(G.x, te.x), Cd(G.y, te.y)), R0(q, $, Y, oe), R0(q, G, $, oe), R0(q, Z, Y, $), R0(q, te, oe, Y));
        t.vertices = D, t.faces = W, h && (t.faceVertexUvs[0] = q);
    }
};
var Pi = new E, GO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = n1.geometry ?? t?.geometry ?? new _e().copy(new mi(100, 100, 100)), r;
        t === void 0 ? (e.computeBoundingBox(), e.boundingBox.getSize(Pi), r = {
            width: Pi.x,
            height: Pi.y,
            depth: Pi.z,
            subdivisions: 0
        }) : r = t.parameters;
        let i = {
            ...r,
            ...n1.parameters
        };
        return {
            parameters: {
                width: Math.abs(i.width),
                height: Math.abs(i.height),
                depth: Math.abs(i.depth),
                subdivisions: Math.abs(i.subdivisions)
            },
            geometry: e
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, subdivisions: i } = n1.parameters, s = n1.geometry ?? new _e().copy(new mi(100, 100, 100)), o = s.userData.parameters;
        o === void 0 ? (s.computeBoundingBox(), s.boundingBox.getSize(Pi)) : Pi.set(o.width, o.height, o.depth), (t !== Pi.x || e !== Pi.y || r !== Pi.z) && s.scale(Pi.x === 0 ? 1 : t / Pi.x, Pi.y === 0 ? 1 : e / Pi.y, Pi.z === 0 ? 1 : r / Pi.z);
        let a = s.originalGeometry;
        try {
            i > 0 ? (a === void 0 || o?.subdivisions !== i) && (a === void 0 && (a = s), s = new L0(i).modify(a).toBufferGeometry()) : (a !== void 0 && (s = a), a = void 0, s.getAttribute("normal") === void 0 && s.computeVertexNormals());
        } catch  {
            a !== void 0 && (s = a), a = void 0, s.getAttribute("normal") === void 0 && s.computeVertexNormals();
        }
        return a !== void 0 && Object.assign(s, {
            originalGeometry: a
        }), delete n1.geometry, Object.assign(s, {
            userData: {
                ...n1,
                type: "NonParametricGeometry"
            }
        });
    }
    static loadFromUrl(n1, t, e) {
        new Qu(e).load(n1, (i)=>{
            let s = this.normalizeInputs({
                geometry: i
            });
            i.boundingBox.getSize(Pi);
            let o = 100 / Pi.x;
            Object.assign(s.parameters, {
                width: 100,
                height: Pi.y * o,
                depth: Pi.z * o
            }), t(this.build(s));
        });
    }
};
var B0 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof Xt ? n1.shape : new Xt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, spikes: r, cornerRadius: i, depth: s, extrudeBevelSize: o, extrudeBevelSegments: a } = n1.parameters, l = n1.shape, c = t * .5, u = e * .5, h = 0, d = 0, f = 2 * Math.PI / r;
        for(let m = 0; m < r; m++){
            let g = f * m, y = h + Math.sin(g) * c, x = d + Math.cos(g) * u;
            l.addPoint(l.createPoint(y, x));
        }
        l.isClosed = !0;
        for(let m = 0, g = l.points.length; m < g; m++)l.points[m].roundness = i;
        l.roundness = i, l.update();
        let p = Rn.create({
            shape: l,
            parameters: {
                roundness: i,
                depth: s,
                extrudeBevelSize: o,
                extrudeBevelSegments: a
            }
        });
        return Object.assign(p, {
            userData: {
                ...n1,
                type: "PolygonGeometry"
            }
        });
    }
};
var jO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 4,
            heightSegments: 1,
            cornerRadius: 0,
            cornerSegments: 8,
            openEnded: !1
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radialSegments: i, heightSegments: s, openEnded: o, cornerRadius: a, cornerSegments: l } = n1.parameters, c = new j1(t * .5, e, i, s, o, a, l);
        return c.scale(1, 1, r / t), Object.assign(c, {
            userData: {
                ...n1,
                type: "PyramidGeometry"
            }
        });
    }
};
function fm(n1, t, e) {
    e.x = n1.x * t.x, e.y = n1.y, e.z = n1.x * t.y;
}
function G1(n1, t, e, r, i, s) {
    let o = t.clone().sub(n1), a = e.clone().sub(n1), l = o.angleTo(a);
    if (o.normalize(), a.normalize(), r === i) {
        let c = o.add(a).normalize();
        s.copy(n1).addScaledVector(c, r / Math.sin(l / 2));
    } else {
        let c = o.angleTo(a);
        s.copy(n1), s.addScaledVector(o, i / Math.sin(c)), s.addScaledVector(a, r / Math.sin(c));
    }
}
function rY(n1, t, e) {
    let r = n1.clone().sub(t), i = e.clone().sub(t);
    return r.projectOnVector(i), r.add(t);
}
var j1 = class extends _e {
    constructor(t = .5, e = 1, r = 4, i = 1, s = !1, o = 0, a = 4){
        super(), r = Math.floor(Math.max(3, r)), i = Math.floor(i), a = Math.floor(a);
        let l = [], c = [], u = [], h = [], d = 0, f = e / 2, p = Math.PI / r, m = t * Math.cos(Math.PI / r), g = 2 * Math.PI / r, y = (r - 2) * Math.PI / r, x = Math.PI - y, v = new E(0, -f, 0), S = new E(0, f, 0), w = new k(t, -f), A = new k(m, -f), T = new k(0, S.y).sub(A), b = new k(0, S.y).sub(w), M = new k(T.y, -T.x).normalize(), C = new k(b.y, -b.x).normalize(), I = t * Math.cos(Math.PI / r) * Math.tan((Math.PI - T.angle()) / 2) - 1e-8;
        o = Math.min(o, I);
        let _;
        {
            let q = new E(M.x, M.y, 0), Q = new E(Math.cos(g) * q.x, q.y, Math.sin(g) * q.x);
            _ = q.angleTo(Q);
        }
        let D = o / Math.tan((Math.PI - T.angle()) / 2), L = o / Math.tan((Math.PI - _) / 2), j = new E;
        if (!s) {
            c.push(v.x, v.y, v.z), u.push(0, -1, 0), h.push(0, 0);
            let q = d++, Q = [], G = w.clone(), Z = D / Math.cos(Math.PI / r);
            G.x -= Z;
            for(let te = 0; te < r; te++){
                let $ = te / r * Math.PI * 2 + p, Y = new k(Math.sin($), Math.cos($));
                fm(G, Y, j), c.push(j.x, j.y, j.z), u.push(0, -1, 0), h.push(0, 0), Q.push(d++);
            }
            for(let te = 0; te < Q.length; te++)l.push(Q[te], q, Q[(te + 1) % Q.length]);
        }
        let V = [];
        {
            let q = new E, Q = new E, G = new E, Z = new E, te = new E, $ = new E;
            for(let Y = 0; Y < r; Y++){
                let oe = Y / r * Math.PI * 2 + p, ie = (Y + .5) / r * Math.PI * 2 + p, re = (Y + 1) / r * Math.PI * 2 + p, J = new k(Math.sin(oe), Math.cos(oe)), Ee = new k(Math.sin(ie), Math.cos(ie)), xe = new k(Math.sin(re), Math.cos(re));
                fm(w, J, Q), fm(w, xe, G), fm(M, Ee, q), G1(S, Q, G, L, L, Z), c.push(Z.x, Z.y, Z.z), G1(Q, S, G, L, D, te), c.push(te.x, te.y, te.z), G1(G, Q, S, D, L, $), c.push($.x, $.y, $.z), u.push(q.x, q.y, q.z), u.push(q.x, q.y, q.z), u.push(q.x, q.y, q.z), h.push(0, 0), h.push(0, 0), h.push(0, 0);
                let de = d++, De = d++, Ce = d++;
                if (l.push(de, De, Ce), o > 0) {
                    {
                        let Ve = Q.clone().add(G).multiplyScalar(.5), Oe = S.clone().sub(Ve).normalize(), F = v.clone().sub(Ve).normalize().add(Oe).normalize().multiplyScalar(-1), N = $.clone().sub(te);
                        H(Ve, N, F, T.angle());
                    }
                    let ze, Ue;
                    {
                        let Ve = new E;
                        fm(C, xe, Ve);
                        let Oe = $.clone().add(Z).multiplyScalar(.5);
                        Oe = rY(Oe, G, S);
                        let Ye = $.clone().sub(Z);
                        [ze, Ue] = H(Oe, Ye, Ve, _, Z.y);
                    }
                    {
                        let Ve = ze, Oe = Ve.clone().setY(0).normalize(), Ye = new E(0, -1, 0), F = Oe.clone().cross(Ye);
                        W(Ve, Oe, Ye, F);
                    }
                    V.concat(Ue);
                    {
                        let Ve = T.angle(), Oe = Math.PI - Ve, Ye = S.clone();
                        Ye.y -= o / Math.sin(Ve - Math.PI / 2);
                        let F = new E, N = [];
                        for(let ae = 0; ae < a; ae++){
                            let ge = [], me = Math.PI / 2 - Oe * ae / a, Le = Math.cos(me), Ne = Math.sin(me), Re = ie;
                            for(let pe = 0; pe <= ae; pe++){
                                let nt = Math.cos(Re), Ge = Math.sin(Re);
                                q.x = Le * Ge, q.y = Ne, q.z = Le * nt, F.copy(Ye).addScaledVector(q, o), c.push(F.x, F.y, F.z), u.push(q.x, q.y, q.z), h.push(0, 0), ge.push(d++), Re += Math.PI * 2 / ae / r;
                            }
                            N.push(ge);
                        }
                        Ue.reverse(), N.push(Ue);
                        let B = N.length - 1;
                        for(let ae = 0; ae < B; ae++){
                            let ge = N[ae], me = N[ae + 1], Le = ge.length - 1;
                            l.push(me[1], ge[0], me[0]);
                            for(let Ne = 1; Ne <= Le; Ne++)l.push(ge[Ne], ge[Ne - 1], me[Ne]), l.push(me[Ne + 1], ge[Ne], me[Ne]);
                        }
                    }
                }
            }
        }
        this.setIndex(l), this.setAttribute("position", new Te(c, 3)), this.setAttribute("normal", new Te(u, 3)), this.setAttribute("uv", new Te(h, 2));
        function H(q, Q, G, Z, te) {
            let $ = -Z / 2, Y = (Math.PI - Z) / 2, oe = Q.clone().normalize().cross(G);
            q.addScaledVector(G, -o / Math.sin(Y));
            let ie = new E, re = new E, J = 1, Ee = d, xe = [];
            for(let de = 0; de <= a; de++){
                let De = $ + de / a * Z;
                re.set(0, 0, 0), re.addScaledVector(oe, Math.sin(De)), re.addScaledVector(G, Math.cos(De));
                for(let Ce = 0; Ce <= J; Ce++){
                    let ze = Ce / J - .5;
                    if (ie.copy(q), ie.addScaledVector(Q, ze), ie.addScaledVector(re, o), te != null) {
                        let Ue = Math.max(0, ie.y - te);
                        ie.addScaledVector(Q, -Ue / Q.y);
                    }
                    c.push(ie.x, ie.y, ie.z), u.push(re.x, re.y, re.z), h.push(0, 0), Ce === 0 && xe.push(d), d++;
                }
            }
            for(let de = 0; de < a; de++)for(let De = 0; De < J; De++){
                let Ce = Ee + De + (J + 1) * de, ze = Ce + (J + 1), Ue = ze + 1, Ve = Ce + 1;
                l.push(Ce, ze, Ve), l.push(ze, Ue, Ve);
            }
            return [
                q.clone().addScaledVector(Q, .5),
                xe
            ];
        }
        function W(q, Q, G, Z) {
            let te = Math.PI / 2, $ = b.angle() - te, Y = [], oe = new E, ie = new E;
            for(let J = 0; J <= a; J++){
                let Ee = [], xe = J / a;
                for(let de = 0; de <= J; de++){
                    let Ce = ((J ? de / J : 0) - .5) * x, ze = Math.cos(Ce), Ue = Math.sin(Ce), Ve = Math.atan(Math.tan($) * ze), Oe = (te + Ve) * xe, Ye = Math.cos(Oe), F = Math.sin(Oe);
                    oe.set(0, 0, 0), oe.addScaledVector(Q, F * ze), oe.addScaledVector(G, Ye), oe.addScaledVector(Z, F * Ue), ie.copy(q).addScaledVector(oe, o), c.push(ie.x, ie.y, ie.z), u.push(oe.x, oe.y, oe.z), h.push(0, 0), Ee.push(d++);
                }
                Y.push(Ee);
            }
            let re = Y.length - 1;
            for(let J = 0; J < re; J++){
                let Ee = Y[J], xe = Y[J + 1], de = Ee.length - 1;
                l.push(Ee[0], xe[1], xe[0]);
                for(let De = 1; De <= de; De++)l.push(Ee[De - 1], Ee[De], xe[De]), l.push(Ee[De], xe[De + 1], xe[De]);
            }
        }
    }
};
var Pd = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 1,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters), r = Object.assign(t?.ui ?? {
            enabledIndieCorners: !1
        }, n1.ui);
        return {
            shape: n1.shape && n1.shape instanceof Xt ? n1.shape : new Xt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            }),
            ui: r
        };
    }
    static build(n1) {
        let t = n1.shape, { width: e, height: r, cornerRadius: i, cornerType: s, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l } = n1.parameters, c = {
            x: e * .5,
            y: r * .5
        }, u = {
            x: -c.x,
            y: -c.y
        }, h = {
            x: c.x,
            y: c.y
        };
        function d(S, w, A) {
            return w > e && A > r ? Math.min(S * e / w, S * r / A) : w > e ? S * e / w : A > r ? S * r / A : S;
        }
        let f = [];
        f[0] = i[0] === 0 ? 0 : d(i[0], i[0] + i[3], i[0] + i[1]), f[1] = i[1] === 0 ? 0 : d(i[1], i[1] + i[2], i[1] + i[0]), f[2] = i[2] === 0 ? 0 : d(i[2], i[2] + i[1], i[2] + i[3]), f[3] = i[3] === 0 ? 0 : d(i[3], i[3] + i[0], i[3] + i[2]);
        let p = u.x, m = h.x, g = h.y, y = u.y;
        t.addPoint(t.createPoint(p, g)), t.addPoint(t.createPoint(m, g)), t.addPoint(t.createPoint(m, y)), t.addPoint(t.createPoint(p, y)), t.isClosed = !0;
        let x = !0;
        for(let S = 0, w = t.points.length; S < w; S++)t.points[S].roundness = f[S], S > 0 && f[S] !== f[S - 1] && (x = !1);
        x && (t.roundness = f[0]), t.useCubicForRoundedCorners = s !== 1, t.update();
        let v = Rn.create({
            shape: t,
            parameters: {
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        });
        return Object.assign(v, {
            userData: {
                ...n1,
                type: "RectangleGeometry"
            }
        });
    }
};
var HO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: 180
        }, n1.parameters);
        return e.thetaLength = we.clamp(e.thetaLength, 0, 180), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e = t, depth: r = t, widthSegments: i = 64, heightSegments: s = 64, phiStart: o, phiLength: a, thetaStart: l, thetaLength: c } = n1.parameters, u;
        return c === 0 ? (u = new _e, u.setAttribute("position", new Te([], 3))) : u = new Bs(.5 * t, i, s, o, a, l, c * we.DEG2RAD), u.scale(1, e / t, r / t), Object.assign(u, {
            userData: {
                ...n1,
                type: "SphereGeometry"
            }
        });
    }
};
var WO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            widthSegments: 8,
            heightSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: 0
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e = t, widthSegments: r = 8, heightSegments: i = 8 } = n1.parameters, s = new Li(t, e, r, i);
        return s.scale(1, 1, 1), Object.assign(s, {
            userData: {
                ...n1,
                type: "PlaneGeometry"
            }
        });
    }
};
var qO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            angle: 90,
            cornerRadius: 24,
            cornerSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, angle: i, cornerRadius: s, cornerSegments: o } = n1.parameters, a = new H1(t, e, r, i, s, o);
        return Object.assign(a, {
            userData: {
                ...n1,
                type: "BackdropGeometry"
            }
        });
    }
}, H1 = class extends _e {
    constructor(t = 1, e = 1, r = 1, i = 90, s = 10, o = 24){
        super(), this.type = "BackdropGeometry";
        let a = [], l = [], c = [], u = .001;
        s == 0 && (o = 1), o = Math.max(1, Math.floor(o)), s = Math.min(s, 100), i = Math.min(180 - u, i), i *= Math.PI / 180;
        let h = [], d = Math.PI / 2, f = (ie = 0, re = 0, J = 0)=>new E(ie, re, J), p = f(), m = f(), [g, y, x] = [
            e / 2,
            t / 2,
            r / 2
        ], v = -y, S = +y, [w, A, T] = [
            f(v, -g, +x),
            f(v, -g, -x),
            f(v, +g, -x)
        ], b = (ie, re = !1)=>Math.sin(ie - Math.PI / (1 + +re)), M = (ie, re = !1)=>Math.cos(ie - Math.PI / (1 + +re));
        T.y = Math.sin(i) * e - g;
        let C = Math.cos(i) * e - x, P = w.z - u;
        i <= d ? (T.z = Math.min(C, P), T.z == P && (T.y -= (C - P) / Math.tan(d - i))) : A.z = Math.min(A.z - C - x, w.z - u), p.subVectors(w, A), m.subVectors(T, A);
        let I = Math.min(p.length(), m.length()) * s / 100, _ = I * Math.tan(i / 2), D = I / Math.cos(i / 2), L = p.clone().normalize().add(m.normalize()).setLength(D).add(A);
        p.set(0, b(i, !0), M(i, !0)), h.push([
            T,
            p.clone()
        ]);
        let j = (Math.PI - i) / o;
        for(let ie = 0; ie <= o; ie++){
            let re = d + i + ie * j;
            p.set(0, Math.sin(re) * _, Math.cos(re) * _), p.add(L), m.set(0, b(re), M(re)), h.push([
                p.clone(),
                m.clone()
            ]);
        }
        h.push([
            w,
            f(0, 1, 0)
        ]);
        let V = Math.sin(j / 2) * _ * 2, H = h.length - 1, W = h[0][0].distanceTo(h[1][0]), q = h[H - 1][0].distanceTo(h[H][0]), Q = W + V * o + q;
        h[0].push(1);
        for(let ie = 0; ie <= o; ie++)h[ie + 1].push(1 - (W + ie * V) / Q);
        h[H].push(0);
        let [G, Z, te] = h[0], $, Y, oe;
        for(let ie = 1; ie < h.length; ie++)[$, Y, oe] = h[ie], a.push(v, G.y, G.z, v, $.y, $.z, S, G.y, G.z, S, G.y, G.z, v, $.y, $.z, S, $.y, $.z), l.push(0, Z.y, Z.z, 0, Y.y, Y.z, 0, Z.y, Z.z, 0, Z.y, Z.z, 0, Y.y, Y.z, 0, Y.y, Y.z), c.push(0, te, 0, oe, 1, te, 1, te, 0, oe, 1, oe), [G, Z, te] = [
            $,
            Y,
            oe
        ];
        this.setAttribute("position", new Te(a, 3)), this.setAttribute("normal", new Te(l, 3)), this.setAttribute("uv", new Te(c, 2));
    }
};
var N0 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            innerRadiusPercent: 38.19,
            spikes: 5,
            cornerRadius: 0,
            angle: 360,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof Xt ? n1.shape : new Xt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, innerRadiusPercent: r, spikes: i, cornerRadius: s, angle: o, depth: a, extrudeBevelSize: l, extrudeBevelSegments: c } = n1.parameters, u = n1.shape, h = t * .5, d = e * .5, f = 0, p = 0, m = o * Math.PI / 360 / i, g = Math.PI / 2 * -3, y = h * r / 100, x = d * r / 100;
        if (i === 3 && r === 50) {
            m = 2 * Math.PI / i;
            for(let S = 0; S < i; S++){
                let w = m * S, A = f + Math.sin(w) * h, T = p + Math.cos(w) * d;
                u.addPoint(u.createPoint(A, T));
            }
        } else for(let S = 0; S < i; S++){
            let w = f + Math.cos(g) * h, A = p + Math.sin(g) * d;
            u.addPoint(u.createPoint(w, A)), g += m, w = f + Math.cos(g) * y, A = p + Math.sin(g) * x, u.addPoint(u.createPoint(w, A)), g += m;
        }
        u.isClosed = !0;
        for(let S = 0, w = u.points.length; S < w; S++)u.points[S].roundness = s;
        u.roundness = s, u.update();
        let v = Rn.create({
            shape: u,
            parameters: {
                roundness: s,
                depth: a,
                extrudeBevelSize: l,
                extrudeBevelSegments: c
            }
        });
        return Object.assign(v, {
            userData: {
                ...n1,
                type: "StarGeometry"
            }
        });
    }
};
var YO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e } = n1.parameters, r = new Li(t, e);
        return Object.assign(r, {
            userData: {
                ...n1,
                type: "TextFrameGeometry"
            }
        });
    }
};
var XO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            tubularSegments: 64,
            arc: 360,
            cornerRadius: 30,
            cornerSegments: 8
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.round(Math.abs(e.depth ?? e.width * .25));
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radialSegments: i, tubularSegments: s, arc: o, cornerRadius: a, cornerSegments: l } = n1.parameters, c = iY(t, e, r, t * .5, o, s, 0, 0, i, a, l);
        return c.scale(1, e / t, 1), Object.assign(c, {
            userData: {
                ...n1,
                type: "TorusGeometry"
            }
        });
    }
};
function iY(n1, t, e, r, i, s, o, a, l, c, u) {
    [t, e] = [
        e,
        t
    ], o = t / 2;
    let h = we.clamp(i / 360, 0, 1);
    if (h === 0) {
        let d = new _e;
        return d.setAttribute("position", new Te([], 3)), d;
    }
    return h === 1 && (c = 0), new hm(!0, n1, t, e, r, h, s, o, a, l, c, u);
}
var KO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            tubularSegments: 64,
            radialSegments: 32,
            p: 2,
            q: 3
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                tube: e.tube ?? e.width * .125
            })
        };
    }
    static build(n1) {
        let { width: t, tube: e, tubularSegments: r, radialSegments: i, p: s, q: o } = n1.parameters, a = t * .5;
        a !== e && (a -= e);
        let l = new Hu(a, e, r, i, s, o);
        return Object.assign(l, {
            userData: {
                ...n1,
                type: "TorusKnotGeometry"
            }
        });
    }
};
var QO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1,
            isRect: !1
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof Xt ? n1.shape : new Xt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width * (e.isRect ? 1 : Math.sqrt(3) / 2)),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e, cornerRadius: r, depth: i, extrudeBevelSize: s, extrudeBevelSegments: o, isRect: a } = n1.parameters, l = n1.shape, c = t * .5, u = e * .5;
        a ? (l.addPoint(l.createPoint(-c, u)), l.addPoint(l.createPoint(c, -u)), l.addPoint(l.createPoint(-c, -u))) : (l.addPoint(l.createPoint(0, u)), l.addPoint(l.createPoint(c, -u)), l.addPoint(l.createPoint(-c, -u))), l.isClosed = !0;
        for(let d = 0, f = l.points.length; d < f; d++)l.points[d].roundness = r;
        l.roundness = r, l.update();
        let h = Rn.create({
            shape: l,
            parameters: {
                roundness: r,
                depth: i,
                extrudeBevelSize: s,
                extrudeBevelSegments: o
            }
        });
        return Object.assign(h, {
            userData: {
                ...n1,
                type: "TriangleGeometry"
            }
        });
    }
};
function ZO(n1, t) {
    let e = 2 * Math.PI;
    return (n1 % e + e) % e === (t % e + e) % e;
}
function nY(n1) {
    return /^(rgba)?\(\s*(\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(n1.toLowerCase());
}
function sY(n1, t, e) {
    let r, i, s, o = Math.floor(n1 * 6), a = n1 * 6 - o, l = e * (1 - t), c = e * (1 - a * t), u = e * (1 - (1 - a) * t);
    switch(o % 6){
        case 0:
            r = e, i = u, s = l;
            break;
        case 1:
            r = c, i = e, s = l;
            break;
        case 2:
            r = l, i = e, s = u;
            break;
        case 3:
            r = l, i = c, s = e;
            break;
        case 4:
            r = u, i = l, s = e;
            break;
        case 5:
        default:
            r = e, i = l, s = c;
            break;
    }
    return {
        r: r * 255,
        g: i * 255,
        b: s * 255
    };
}
function oY(n1, t, e) {
    n1 /= 255, t /= 255, e /= 255;
    let r = Math.max(n1, t, e), i = Math.min(n1, t, e), s = r, o = r - i, a = r == 0 ? 0 : o / r, l;
    if (r == i) l = 0;
    else {
        switch(r){
            case n1:
                l = (t - e) / o + (t < e ? 6 : 0);
                break;
            case t:
                l = (e - n1) / o + 2;
                break;
            case e:
            default:
                l = (n1 - t) / o + 4;
                break;
        }
        l /= 6;
    }
    return {
        h: l,
        s: a,
        v: s
    };
}
function aY(n1) {
    return n1 = Math.floor(n1), {
        r: n1 >> 16 & 255,
        g: n1 >> 8 & 255,
        b: n1 & 255
    };
}
function lY(n1, t, e) {
    return (n1 << 16) + (t << 8) + e;
}
function cY(n1, t, e) {
    return n1 = Math.round(n1), t = Math.round(t), e = Math.round(e), "#" + [
        n1,
        t,
        e
    ].map((r)=>r.toString(16).padStart(2, "0")).join("").toUpperCase();
}
function uY(n1) {
    let t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    n1 = n1.replace(t, (r, i, s, o)=>String(i + i + s + s + o + o));
    let e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n1);
    return e ? {
        r: parseInt(e[1], 16),
        g: parseInt(e[2], 16),
        b: parseInt(e[3], 16)
    } : null;
}
var JO = {
    parseRgba: nY,
    hsvToRgb: sY,
    rgbToHsv: oY,
    hexToRgb: aY,
    rgbToHex: lY,
    rgbToHexString: cY,
    hexStringToRgb: uY
};
var W1 = class {
    add(t, e, r) {
        if (typeof arguments[0] != "string") for(let i in arguments[0])this.add(i, arguments[0][i], arguments[1]);
        else (Array.isArray(t) ? t : [
            t
        ]).forEach(function(i) {
            this[i] = this[i] || [], e && this[i][r ? "unshift" : "push"](e);
        }, this);
    }
    run(t, e) {
        this[t] = this[t] || [], this[t].forEach(function(r) {
            r.call(e && e.context ? e.context : e, e);
        });
    }
}, q1 = class {
    constructor(t){
        this.jsep = t, this.registered = {};
    }
    register(...t) {
        t.forEach((e)=>{
            if (typeof e != "object" || !e.name || !e.init) throw new Error("Invalid JSEP plugin format");
            this.registered[e.name] || (e.init(this.jsep), this.registered[e.name] = e);
        });
    }
}, fe = class {
    static get version() {
        return "1.3.8";
    }
    static toString() {
        return "JavaScript Expression Parser (JSEP) v" + fe.version;
    }
    static addUnaryOp(t) {
        return fe.max_unop_len = Math.max(t.length, fe.max_unop_len), fe.unary_ops[t] = 1, fe;
    }
    static addBinaryOp(t, e, r) {
        return fe.max_binop_len = Math.max(t.length, fe.max_binop_len), fe.binary_ops[t] = e, r ? fe.right_associative.add(t) : fe.right_associative.delete(t), fe;
    }
    static addIdentifierChar(t) {
        return fe.additional_identifier_chars.add(t), fe;
    }
    static addLiteral(t, e) {
        return fe.literals[t] = e, fe;
    }
    static removeUnaryOp(t) {
        return delete fe.unary_ops[t], t.length === fe.max_unop_len && (fe.max_unop_len = fe.getMaxKeyLen(fe.unary_ops)), fe;
    }
    static removeAllUnaryOps() {
        return fe.unary_ops = {}, fe.max_unop_len = 0, fe;
    }
    static removeIdentifierChar(t) {
        return fe.additional_identifier_chars.delete(t), fe;
    }
    static removeBinaryOp(t) {
        return delete fe.binary_ops[t], t.length === fe.max_binop_len && (fe.max_binop_len = fe.getMaxKeyLen(fe.binary_ops)), fe.right_associative.delete(t), fe;
    }
    static removeAllBinaryOps() {
        return fe.binary_ops = {}, fe.max_binop_len = 0, fe;
    }
    static removeLiteral(t) {
        return delete fe.literals[t], fe;
    }
    static removeAllLiterals() {
        return fe.literals = {}, fe;
    }
    get char() {
        return this.expr.charAt(this.index);
    }
    get code() {
        return this.expr.charCodeAt(this.index);
    }
    constructor(t){
        this.expr = t, this.index = 0;
    }
    static parse(t) {
        return new fe(t).parse();
    }
    static getMaxKeyLen(t) {
        return Math.max(0, ...Object.keys(t).map((e)=>e.length));
    }
    static isDecimalDigit(t) {
        return t >= 48 && t <= 57;
    }
    static binaryPrecedence(t) {
        return fe.binary_ops[t] || 0;
    }
    static isIdentifierStart(t) {
        return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 128 && !fe.binary_ops[String.fromCharCode(t)] || fe.additional_identifier_chars.has(String.fromCharCode(t));
    }
    static isIdentifierPart(t) {
        return fe.isIdentifierStart(t) || fe.isDecimalDigit(t);
    }
    throwError(t) {
        let e = new Error(t + " at character " + this.index);
        throw e.index = this.index, e.description = t, e;
    }
    runHook(t, e) {
        if (fe.hooks[t]) {
            let r = {
                context: this,
                node: e
            };
            return fe.hooks.run(t, r), r.node;
        }
        return e;
    }
    searchHook(t) {
        if (fe.hooks[t]) {
            let e = {
                context: this
            };
            return fe.hooks[t].find(function(r) {
                return r.call(e.context, e), e.node;
            }), e.node;
        }
    }
    gobbleSpaces() {
        let t = this.code;
        for(; t === fe.SPACE_CODE || t === fe.TAB_CODE || t === fe.LF_CODE || t === fe.CR_CODE;)t = this.expr.charCodeAt(++this.index);
        this.runHook("gobble-spaces");
    }
    parse() {
        this.runHook("before-all");
        let t = this.gobbleExpressions(), e = t.length === 1 ? t[0] : {
            type: fe.COMPOUND,
            body: t
        };
        return this.runHook("after-all", e);
    }
    gobbleExpressions(t) {
        let e = [], r, i;
        for(; this.index < this.expr.length;)if (r = this.code, r === fe.SEMCOL_CODE || r === fe.COMMA_CODE) this.index++;
        else if (i = this.gobbleExpression()) e.push(i);
        else if (this.index < this.expr.length) {
            if (r === t) break;
            this.throwError('Unexpected "' + this.char + '"');
        }
        return e;
    }
    gobbleExpression() {
        let t = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
        return this.gobbleSpaces(), this.runHook("after-expression", t);
    }
    gobbleBinaryOp() {
        this.gobbleSpaces();
        let t = this.expr.substr(this.index, fe.max_binop_len), e = t.length;
        for(; e > 0;){
            if (fe.binary_ops.hasOwnProperty(t) && (!fe.isIdentifierStart(this.code) || this.index + t.length < this.expr.length && !fe.isIdentifierPart(this.expr.charCodeAt(this.index + t.length)))) return this.index += e, t;
            t = t.substr(0, --e);
        }
        return !1;
    }
    gobbleBinaryExpression() {
        let t, e, r, i, s, o, a, l, c;
        if (o = this.gobbleToken(), !o || (e = this.gobbleBinaryOp(), !e)) return o;
        for(s = {
            value: e,
            prec: fe.binaryPrecedence(e),
            right_a: fe.right_associative.has(e)
        }, a = this.gobbleToken(), a || this.throwError("Expected expression after " + e), i = [
            o,
            s,
            a
        ]; e = this.gobbleBinaryOp();){
            if (r = fe.binaryPrecedence(e), r === 0) {
                this.index -= e.length;
                break;
            }
            s = {
                value: e,
                prec: r,
                right_a: fe.right_associative.has(e)
            }, c = e;
            let u = (h)=>s.right_a && h.right_a ? r > h.prec : r <= h.prec;
            for(; i.length > 2 && u(i[i.length - 2]);)a = i.pop(), e = i.pop().value, o = i.pop(), t = {
                type: fe.BINARY_EXP,
                operator: e,
                left: o,
                right: a
            }, i.push(t);
            t = this.gobbleToken(), t || this.throwError("Expected expression after " + c), i.push(s, t);
        }
        for(l = i.length - 1, t = i[l]; l > 1;)t = {
            type: fe.BINARY_EXP,
            operator: i[l - 1].value,
            left: i[l - 2],
            right: t
        }, l -= 2;
        return t;
    }
    gobbleToken() {
        let t, e, r, i;
        if (this.gobbleSpaces(), i = this.searchHook("gobble-token"), i) return this.runHook("after-token", i);
        if (t = this.code, fe.isDecimalDigit(t) || t === fe.PERIOD_CODE) return this.gobbleNumericLiteral();
        if (t === fe.SQUOTE_CODE || t === fe.DQUOTE_CODE) i = this.gobbleStringLiteral();
        else if (t === fe.OBRACK_CODE) i = this.gobbleArray();
        else {
            for(e = this.expr.substr(this.index, fe.max_unop_len), r = e.length; r > 0;){
                if (fe.unary_ops.hasOwnProperty(e) && (!fe.isIdentifierStart(this.code) || this.index + e.length < this.expr.length && !fe.isIdentifierPart(this.expr.charCodeAt(this.index + e.length)))) {
                    this.index += r;
                    let s = this.gobbleToken();
                    return s || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
                        type: fe.UNARY_EXP,
                        operator: e,
                        argument: s,
                        prefix: !0
                    });
                }
                e = e.substr(0, --r);
            }
            fe.isIdentifierStart(t) ? (i = this.gobbleIdentifier(), fe.literals.hasOwnProperty(i.name) ? i = {
                type: fe.LITERAL,
                value: fe.literals[i.name],
                raw: i.name
            } : i.name === fe.this_str && (i = {
                type: fe.THIS_EXP
            })) : t === fe.OPAREN_CODE && (i = this.gobbleGroup());
        }
        return i ? (i = this.gobbleTokenProperty(i), this.runHook("after-token", i)) : this.runHook("after-token", !1);
    }
    gobbleTokenProperty(t) {
        this.gobbleSpaces();
        let e = this.code;
        for(; e === fe.PERIOD_CODE || e === fe.OBRACK_CODE || e === fe.OPAREN_CODE || e === fe.QUMARK_CODE;){
            let r;
            if (e === fe.QUMARK_CODE) {
                if (this.expr.charCodeAt(this.index + 1) !== fe.PERIOD_CODE) break;
                r = !0, this.index += 2, this.gobbleSpaces(), e = this.code;
            }
            this.index++, e === fe.OBRACK_CODE ? (t = {
                type: fe.MEMBER_EXP,
                computed: !0,
                object: t,
                property: this.gobbleExpression()
            }, this.gobbleSpaces(), e = this.code, e !== fe.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : e === fe.OPAREN_CODE ? t = {
                type: fe.CALL_EXP,
                arguments: this.gobbleArguments(fe.CPAREN_CODE),
                callee: t
            } : (e === fe.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), t = {
                type: fe.MEMBER_EXP,
                computed: !1,
                object: t,
                property: this.gobbleIdentifier()
            }), r && (t.optional = !0), this.gobbleSpaces(), e = this.code;
        }
        return t;
    }
    gobbleNumericLiteral() {
        let t = "", e, r;
        for(; fe.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
        if (this.code === fe.PERIOD_CODE) for(t += this.expr.charAt(this.index++); fe.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
        if (e = this.char, e === "e" || e === "E") {
            for(t += this.expr.charAt(this.index++), e = this.char, (e === "+" || e === "-") && (t += this.expr.charAt(this.index++)); fe.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
            fe.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + t + this.char + ")");
        }
        return r = this.code, fe.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + t + this.char + ")") : (r === fe.PERIOD_CODE || t.length === 1 && t.charCodeAt(0) === fe.PERIOD_CODE) && this.throwError("Unexpected period"), {
            type: fe.LITERAL,
            value: parseFloat(t),
            raw: t
        };
    }
    gobbleStringLiteral() {
        let t = "", e = this.index, r = this.expr.charAt(this.index++), i = !1;
        for(; this.index < this.expr.length;){
            let s = this.expr.charAt(this.index++);
            if (s === r) {
                i = !0;
                break;
            } else if (s === "\\") switch(s = this.expr.charAt(this.index++), s){
                case "n":
                    t += `
`;
                    break;
                case "r":
                    t += "\r";
                    break;
                case "t":
                    t += "	";
                    break;
                case "b":
                    t += "\b";
                    break;
                case "f":
                    t += "\f";
                    break;
                case "v":
                    t += "\v";
                    break;
                default:
                    t += s;
            }
            else t += s;
        }
        return i || this.throwError('Unclosed quote after "' + t + '"'), {
            type: fe.LITERAL,
            value: t,
            raw: this.expr.substring(e, this.index)
        };
    }
    gobbleIdentifier() {
        let t = this.code, e = this.index;
        for(fe.isIdentifierStart(t) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (t = this.code, fe.isIdentifierPart(t));)this.index++;
        return {
            type: fe.IDENTIFIER,
            name: this.expr.slice(e, this.index)
        };
    }
    gobbleArguments(t) {
        let e = [], r = !1, i = 0;
        for(; this.index < this.expr.length;){
            this.gobbleSpaces();
            let s = this.code;
            if (s === t) {
                r = !0, this.index++, t === fe.CPAREN_CODE && i && i >= e.length && this.throwError("Unexpected token " + String.fromCharCode(t));
                break;
            } else if (s === fe.COMMA_CODE) {
                if (this.index++, i++, i !== e.length) {
                    if (t === fe.CPAREN_CODE) this.throwError("Unexpected token ,");
                    else if (t === fe.CBRACK_CODE) for(let o = e.length; o < i; o++)e.push(null);
                }
            } else if (e.length !== i && i !== 0) this.throwError("Expected comma");
            else {
                let o = this.gobbleExpression();
                (!o || o.type === fe.COMPOUND) && this.throwError("Expected comma"), e.push(o);
            }
        }
        return r || this.throwError("Expected " + String.fromCharCode(t)), e;
    }
    gobbleGroup() {
        this.index++;
        let t = this.gobbleExpressions(fe.CPAREN_CODE);
        if (this.code === fe.CPAREN_CODE) return this.index++, t.length === 1 ? t[0] : t.length ? {
            type: fe.SEQUENCE_EXP,
            expressions: t
        } : !1;
        this.throwError("Unclosed (");
    }
    gobbleArray() {
        return this.index++, {
            type: fe.ARRAY_EXP,
            elements: this.gobbleArguments(fe.CBRACK_CODE)
        };
    }
}, hY = new W1;
Object.assign(fe, {
    hooks: hY,
    plugins: new q1(fe),
    COMPOUND: "Compound",
    SEQUENCE_EXP: "SequenceExpression",
    IDENTIFIER: "Identifier",
    MEMBER_EXP: "MemberExpression",
    LITERAL: "Literal",
    THIS_EXP: "ThisExpression",
    CALL_EXP: "CallExpression",
    UNARY_EXP: "UnaryExpression",
    BINARY_EXP: "BinaryExpression",
    ARRAY_EXP: "ArrayExpression",
    TAB_CODE: 9,
    LF_CODE: 10,
    CR_CODE: 13,
    SPACE_CODE: 32,
    PERIOD_CODE: 46,
    COMMA_CODE: 44,
    SQUOTE_CODE: 39,
    DQUOTE_CODE: 34,
    OPAREN_CODE: 40,
    CPAREN_CODE: 41,
    OBRACK_CODE: 91,
    CBRACK_CODE: 93,
    QUMARK_CODE: 63,
    SEMCOL_CODE: 59,
    COLON_CODE: 58,
    unary_ops: {
        "-": 1,
        "!": 1,
        "~": 1,
        "+": 1
    },
    binary_ops: {
        "||": 1,
        "&&": 2,
        "|": 3,
        "^": 4,
        "&": 5,
        "==": 6,
        "!=": 6,
        "===": 6,
        "!==": 6,
        "<": 7,
        ">": 7,
        "<=": 7,
        ">=": 7,
        "<<": 8,
        ">>": 8,
        ">>>": 8,
        "+": 9,
        "-": 9,
        "*": 10,
        "/": 10,
        "%": 10
    },
    right_associative: new Set,
    additional_identifier_chars: new Set([
        "$",
        "_"
    ]),
    literals: {
        true: !0,
        false: !1,
        null: null
    },
    this_str: "this"
});
fe.max_unop_len = fe.getMaxKeyLen(fe.unary_ops);
fe.max_binop_len = fe.getMaxKeyLen(fe.binary_ops);
var zc = (n1)=>new fe(n1).parse(), dY = Object.getOwnPropertyNames(fe);
dY.forEach((n1)=>{
    zc[n1] === void 0 && n1 !== "prototype" && (zc[n1] = fe[n1]);
});
zc.Jsep = fe;
var fY = "ConditionalExpression", pY = {
    name: "ternary",
    init (n1) {
        n1.hooks.add("after-expression", function(e) {
            if (e.node && this.code === n1.QUMARK_CODE) {
                this.index++;
                let r = e.node, i = this.gobbleExpression();
                if (i || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === n1.COLON_CODE) {
                    this.index++;
                    let s = this.gobbleExpression();
                    if (s || this.throwError("Expected expression"), e.node = {
                        type: fY,
                        test: r,
                        consequent: i,
                        alternate: s
                    }, r.operator && n1.binary_ops[r.operator] <= .9) {
                        let o = r;
                        for(; o.right.operator && n1.binary_ops[o.right.operator] <= .9;)o = o.right;
                        e.node.test = o.right, o.right = e.node, e.node = r;
                    }
                } else this.throwError("Expected :");
            }
        });
    }
};
zc.plugins.register(pY);
function Pa(n1) {
    return {
        all: n1 = n1 || new Map,
        on: function(t, e) {
            var r = n1.get(t);
            r ? r.push(e) : n1.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var r = n1.get(t);
            r && (e ? r.splice(r.indexOf(e) >>> 0, 1) : n1.set(t, []));
        },
        emit: function(t, e) {
            var r = n1.get(t);
            r && r.slice().map(function(i) {
                i(e);
            }), (r = n1.get("*")) && r.slice().map(function(i) {
                i(t, e);
            });
        }
    };
}
var _d = class {
    constructor(t, e, r){
        this.id = t;
        this.userAPI = e;
        this.result = void 0;
        this.error = "null";
        this.isPrefetched = !1;
        this.isLoading = !1;
        this.isLoaded = !1;
        this.prefetchPromise = new Promise((t)=>t());
        this.emitter = Pa();
        this._innerCallUserAPI = async (t)=>{
            this.emitter.emit("start", {
                userAPIId: this.id
            }), this.isLoading = !0, this.isLoading = !1;
            try {
                this.result = await xY(this.userAPI, t), this.error = "null", this.emitter.emit("success", {
                    userAPIId: this.id
                });
            } catch (e) {
                let r = e.message?.split("_:_")?.[0]?.replace("status:", "") ?? "null";
                this.error = r, this.result = null, this.emitter.emit("error", {
                    userAPIId: this.id
                });
            }
            this.isLoading = !1, this.isPrefetched = !0, this.isLoaded = !0;
        };
        e?.integration?.type === "OpenAI" ? this.result = {
            content: ""
        } : e.method === "GET" && e.url !== "" && (this.prefetchPromise = this.prefetch(r)), this._debouncedCallUserAPI = this._innerCallUserAPI, this._updateDebouncedCallUserAPI(), this._debouncedPrefetch = vo(this.prefetch, 1e3, {
            trailing: !0
        });
    }
    _updateDebouncedCallUserAPI() {
        this._debouncedCallUserAPI = this.userAPI.debounce !== void 0 && this.userAPI.debounce > 0 ? vo(this._innerCallUserAPI, this.userAPI.debounce, {
            leading: !0,
            trailing: !0
        }) : this._innerCallUserAPI;
    }
    async prefetch(t) {
        await this.callUserAPI(t);
    }
    async callUserAPI(t) {
        await this._debouncedCallUserAPI(t);
    }
    update(t, e, r = !0) {
        this.userAPI = t, this._updateDebouncedCallUserAPI(), this.userAPI.url !== "" && this.userAPI.method === "GET" && r && this._debouncedPrefetch(e);
    }
    retrieveValue(t) {
        if (this.result) try {
            return Sr.zoom(this.result, t);
        } catch (e) {
            console.error(e);
        }
    }
    retrieveZoomedKeyValues(t) {
        if (this.result) {
            let e = t && t.length ? Sr.zoom(this.result, t) : this.result;
            if (vY(e)) return Object.entries(e);
            if (yY(e)) return e.map((r, i)=>[
                    i.toString(),
                    r
                ]);
            throw gY(e) ? new Error("This path points to a value, use retrieveValue() instead. " + t?.join(".")) : new Error("Path error" + t?.join("."));
        }
    }
    dispose() {}
    on(t, e) {
        this.emitter.on(t, e);
    }
    off(t, e) {
        this.emitter.off(t, e);
    }
    get autostart() {
        return this.userAPI.autoStart;
    }
};
function mY(n1) {
    let t = new Headers;
    return n1.headers.forEach((e)=>{
        e.data.key !== "" && t.append(e.data.key, e.data.value);
    }), t;
}
function gY(n1) {
    return typeof n1 == "string" || typeof n1 == "number" || typeof n1 == "boolean" || n1 === null;
}
function yY(n1) {
    return Array.isArray(n1);
}
function vY(n1) {
    return typeof n1 == "object" && n1 !== null;
}
async function xY(n1, t, e = new AbortController) {
    let r, i = n1.url, s = n1.proxy?.enabled ?? !1, o;
    if (n1.integration?.type === "OpenAI") {
        let l = pm(n1.integration.prompt === "" ? [] : JSON.parse(n1.integration.prompt), t), c = n1.integration.behavior === "" ? [] : pm(JSON.parse(n1.integration.behavior), t);
        o = `{
		"model": "${n1.integration.model}",
		"messages": [${n1.integration.useBehavior ? `
		{
			"role": "system",
			"content": "${c}"
		},` : ""}
		{
			"role": "user",
			"content": "${l}"
		}
		]
	}`;
    }
    if (s) {
        i = `${"https://apis.spline.design/"}file/${n1.proxy.fileId}/external-api/request?uuidexternalapi=${n1.proxy.proxyId}`;
        let u;
        o !== void 0 ? u = o : n1.method === "POST" && n1.body && (u = pm(JSON.parse(n1.body), t)), u !== void 0 && (i += `&data=${encodeURIComponent(u.replace(/(\r\n|\n|\r|\t)/gm, ""))}`);
    } else n1.integration?.type === "OpenAI" ? r = o : n1.method === "POST" && n1.body && (r = pm(JSON.parse(n1.body), t));
    let a = await fetch(i, {
        method: s ? "GET" : n1.method,
        headers: s ? void 0 : mY(n1),
        signal: e.signal,
        body: r
    });
    if (!a.ok) throw new Error("status:" + a.status + "_:_" + a.statusText);
    if (n1.integration?.type === "OpenAI") {
        let l = await a.json();
        return s && (l = l.response), {
            content: l.choices[0].message.content
        };
    } else {
        let l = await a.json();
        return s && (l = l.response), l;
    }
}
var $O = (n1, t)=>{
    if (typeof n1 == "string") {
        let e = t.getVariable(n1);
        if (e) return $O(e, t);
    }
    return Br.isBoolean(n1) ? Br.getDisplayedValue(n1).toLowerCase() : Br.getDisplayedValue(n1);
}, pm = (n1, t)=>n1.map((e, r)=>{
        if ("text" in e) return e.text;
        if ("type" in e) {
            if (e.type === "paragraph") return (r > 0 ? `
` : "") + pm(e.children, t);
            if (e.type === "variable") {
                let i = t.getVariable(e.variableId);
                if (i !== void 0) return $O(i, t);
            }
        }
        return "";
    }).join("");
var bY = [
    "+",
    "-",
    "*",
    "/",
    "(",
    ")",
    "==",
    "!=",
    ">",
    "<",
    ">=",
    "<=",
    "and",
    "or",
    "!",
    "%",
    "^",
    ","
], SY = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "."
], wY = [
    "sin",
    "cos",
    "tan",
    "asin",
    "acos",
    "atan",
    "atan2",
    "sqrt",
    "abs",
    "log",
    "exp",
    "floor",
    "ceil",
    "round",
    "min",
    "max",
    "random"
];
function AY(n1) {
    return typeof n1 != "string" ? !1 : !isNaN(n1) && !isNaN(parseFloat(n1));
}
zc.addBinaryOp("^", 11, !0);
function F0(n1, t, e = "number") {
    let r = "";
    for(let o = 0; o < n1.length; o++){
        let a = n1[o];
        if ("objType" in a && a.objType === "api") {
            let l = JSON.parse(a.id), c = l[0], u = t.getUserAPI(c);
            if (u !== void 0 && u instanceof _d) {
                let h = u.retrieveValue(l.slice(1));
                h !== void 0 && (r += h);
            }
            continue;
        }
        if ("objType" in a && a.objType === "webhook") {
            let l = JSON.parse(a.id), [c, u] = l, h = t.getUserWebhook(c);
            if (h !== void 0) {
                let d = h.getParameterValue(u);
                d !== void 0 && (r += d);
            }
            continue;
        }
        if ("objType" in a && a.objType === "aiAssistant") {
            let l = t.openAIRealtime;
            if ("objId" in a && a.objId !== void 0) {
                let c;
                if (t.scene.data.objects.traverse((u, h)=>{
                    let d = h.events?.find((f)=>f.id === a.objId);
                    d && (c = d);
                }), c !== void 0 && c.data.type === "AIAssistantListener") {
                    let u = l?.computeAnalysisForListenerEvent(c.data);
                    if (u !== void 0) {
                        r += u;
                        continue;
                    }
                }
            }
            r += l?.voice ?? 0;
            continue;
        }
        if ("id" in a) {
            let l = n1[o - 1];
            if (o > 0 && "id" in l) {
                console.error("Two variables in a row", n1);
                return;
            }
            let c = t.getVariable(a.id), u = Br.getDisplayedValue(c);
            e === "number" && Br.isTextValue(c) && Array.isArray(c.textValue) && c.textValue.length === 1 ? u = parseFloat(u).toString() : e === "boolean" && Br.isBoolean(c) ? u = c ? "true" : "false" : e === "boolean" && Br.isTextValue(c) && !Array.isArray(c.textValue) && (u = '"' + u + '"'), r += u;
            continue;
        } else if (e === "string") {
            a.name !== '"' && (a.name !== "+" || a.escaped) && (r += a.name), a.name === "+" && !a.escaped && r[r.length - 1] === "\\" && (r = r.slice(0, -1) + a.name);
            continue;
        }
        if (a.name === "and") {
            r += "&&";
            continue;
        }
        if (a.name === "or") {
            r += "||";
            continue;
        }
        if (a.name === "True") {
            r += "true";
            continue;
        }
        if (a.name === "False") {
            r += "false";
            continue;
        }
        if (e === "boolean" && !AY(a.name) && !SY.includes(a.name) && !bY.includes(a.name) && !wY.includes(a.name.replace(/\($/g, ""))) {
            r += '"' + a.name + '"';
            continue;
        }
        r += a.name;
    }
    if (e === "string") return r;
    if (n1.length === 0) {
        if (e === "number") return 0;
        if (e === "boolean") return !1;
    }
    let i;
    try {
        i = zc(r);
    } catch (o) {
        console.error(r, o);
        return;
    }
    let s;
    try {
        s = qt(i);
    } catch (o) {
        console.error(r, i, o);
    }
    return s;
}
function qt(n1) {
    switch(n1.type){
        case "BinaryExpression":
            switch(n1.operator){
                case "==":
                    return Number(qt(n1.left) === qt(n1.right));
                case "!=":
                    return Number(qt(n1.left) !== qt(n1.right));
                case ">":
                    return Number(qt(n1.left) > qt(n1.right));
                case ">=":
                    return Number(qt(n1.left) >= qt(n1.right));
                case "<":
                    return Number(qt(n1.left) < qt(n1.right));
                case "<=":
                    return Number(qt(n1.left) <= qt(n1.right));
                case "+":
                    return qt(n1.left) + qt(n1.right);
                case "-":
                    return qt(n1.left) - qt(n1.right);
                case "*":
                    return qt(n1.left) * qt(n1.right);
                case "/":
                    return qt(n1.left) / qt(n1.right);
                case "%":
                    return qt(n1.left) % qt(n1.right);
                case "&&":
                    return qt(n1.left) && qt(n1.right);
                case "||":
                    return qt(n1.left) || qt(n1.right);
                case "^":
                    return Math.pow(qt(n1.left), qt(n1.right));
                default:
                    throw new Error("Unknown operator: " + n1.operator);
            }
        case "UnaryExpression":
            switch(n1.operator){
                case "-":
                    return -qt(n1.argument);
                case "!":
                    return Number(!qt(n1.argument));
                default:
                    throw new Error("Unknown operator: " + n1.operator);
            }
        case "Identifier":
            throw new Error("Unknown identifier: " + n1.name);
        case "Literal":
            return n1.value;
        case "CallExpression":
            if (n1.callee.type === "Identifier") {
                if (n1.callee.name === "random") {
                    let t = 0, e = 1;
                    if (n1.arguments.length >= 1) try {
                        t = qt(n1.arguments[0]);
                    } catch (r) {
                        console.warn(r);
                    }
                    if (n1.arguments.length >= 2) try {
                        e = qt(n1.arguments[1]);
                    } catch (r) {
                        console.warn(r);
                    }
                    return t = Math.min(e, t), e = Math.max(e, t), t + Math.random() * (e - t);
                }
                return Math[n1.callee.name].apply(null, n1.arguments.map(qt));
            } else throw new Error("Unknown node");
        default:
            throw new Error("Unknown node type: " + n1.type);
    }
}
var EY = new ue, TY = new ue;
function MY(n1, t, e) {
    let r = [
        new E,
        new E,
        new E
    ], i = [
        new E,
        new E,
        new E
    ];
    return n1.extractBasis(r[0], r[1], r[2]), t.extractBasis(i[0], i[1], i[2]), r.forEach((s, o)=>{
        let a = i[o], l = we.lerp(s.length(), a.length(), e);
        s.lerp(a, e).setLength(l);
    }), new ue().makeBasis(r[0], r[1], r[2]);
}
var eR = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            height: 100,
            depth: 1,
            subdivisions: 12,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.abs(e.depth ?? 0), o = t?.shapeData ?? Td.create({
            parameters: UA
        }).userData.shape;
        return {
            path: n1.path ?? jh.defaultData(),
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s,
                extrusion: {
                    ...Yv,
                    ...e.extrusion
                }
            }),
            shapeData: o
        };
    }
    static build(n1) {
        if (n1.path.points.length >= 2) {
            let e = new Y1(n1);
            return Object.assign(e, {
                userData: {
                    ...n1,
                    type: "PathGeometry"
                }
            });
        } else return Object.assign(new _e, {
            userData: {
                ...n1,
                type: "PathGeometry"
            }
        });
    }
}, Y1 = class extends _e {
    constructor(e){
        super();
        this.type = "PathExtrusionGeometry", this.inputs = e, this.build();
    }
    _isGeometryClosed() {
        return this.inputs.path.isClosed && this.inputs.parameters.extrusion.depth === 1;
    }
    _isOpenEnded() {
        let e = this.inputs.parameters.extrusion;
        return !(this.inputs.path.isClosed && e.depth === 1) || !ZO(e.twist, 0) || e.startScale !== e.endScale;
    }
    build() {
        let e = this._extractPathPoints();
        if (e.length < 2) return;
        let r = this._computeBasisMatrices(e), { depth: i, offset: s } = this.inputs.parameters.extrusion;
        i = Math.max(0, Math.min(i, 1)), s = Math.max(0, Math.min(s, 1));
        let o = this.inputs.path.isClosed ? e.length : e.length - 1, a = Math.floor(s * o), l = this.inputs.path.isClosed ? Math.ceil((i + s) * o) : Math.ceil(Math.min(1, i + s) * o), c = Math.min(Math.max(2, l - a + 1), o + 2), u = [], h = [];
        for(let W = 0; W < c; W++){
            let q = this.inputs.path.isClosed ? (W + a) % e.length : Math.min(W + a, e.length - 1);
            u.push(e[q].clone()), h.push(r[q].clone());
        }
        let d = (W, q, Q)=>{
            u[W] = u[W].clone().lerp(u[q], Q), h[W] = MY(h[W], h[q], Q);
        }, f = 0, p = s * o % 1;
        (!this.inputs.path.isClosed || i <= 1) && (p || s === 0) && (f = p, d(0, 1, f));
        let m = 0, g = (s + i) * o % 1;
        if ((this.inputs.path.isClosed && i <= 1 || !this.inputs.path.isClosed && s + i < 1) && g && (m = g, d(u.length - 1, u.length - 2, 1 - m)), i === 0) {
            let W = u.length - 1;
            u[W].copy(u[0]), h[W].copy(h[0]);
        }
        this._applyPathModifiers(h, f, m);
        let { bevel: y, bevelSides: x } = this.inputs.parameters.extrusion, v = y > 0 ? this.inputs.parameters.extrusion.capType : "flat", S = 5;
        this.inputs.parameters.extrusion.shape.type === "Custom" && (S = this.inputs.parameters.extrusion.shape.shapeQuality === "low" ? 5 : 12);
        let { regions: w, infos: A, vertices: T } = this._computeShapePoints(S), b = 0, M;
        v === "round" && (M = new Bl(this.inputs.shapeData, 2 * y, y, S, x, void 0, !0), b = M.getAttribute("position").count);
        let C = 0, P = 0;
        A.sort((W, q)=>W.start - q.start), A.forEach((W)=>{
            W.verticesStart = C, W.verticesCount = W.continuous.reduce((q, Q, G)=>q + (G === 0 || !Q ? 2 : 1), 0), P += W.verticesCount, C = P;
        });
        let I = P * c, _, D = 0;
        if (this._isOpenEnded() && v === "flat") {
            try {
                _ = qs({
                    windingRule: Gt.ODD,
                    elementType: jr.POLYGONS,
                    polySize: 3,
                    vertexSize: 2,
                    strict: !0,
                    contours: w
                });
            } catch  {
                _ = N1;
            }
            D = _.vertexCount;
        }
        let L = I + 2 * D + b * 2, j = I + 2 * D, V = {
            positions: new Float32Array(L * 3),
            normals: new Float32Array(L * 3),
            uvs: new Float32Array(L * 2)
        }, H = [];
        if (A.forEach((W)=>{
            this._extrudeRegion(W, T, h, u, V, H, this._isGeometryClosed() && !this._isOpenEnded());
        }), _ && (this._closeEnd(_, I, H, V, h[0], u[0], !1), this._closeEnd(_, I + D, H, V, h[h.length - 1], u[u.length - 1], !0)), M) {
            V.positions.set(M.getAttribute("position").array, j * 3), V.normals.set(M.getAttribute("normal").array, j * 3), V.uvs.set(M.getAttribute("uv").array, j * 2);
            for(let G = j; G < j + b; G++)V.uvs[G * 2 + 1] = 1e-4;
            let W = H.length;
            H.push(...M.getIndex().array.map((G)=>G + j)), j += b, V.positions.set(M.getAttribute("position").array, j * 3), V.normals.set(M.getAttribute("normal").array, j * 3), V.uvs.set(M.getAttribute("uv").array, j * 2);
            let q = H.length;
            H.push(...M.getIndex().array.map((G)=>G + j)), this.setAttribute("position", new Xe(V.positions, 3)), this.setAttribute("normal", new Xe(V.normals, 3)), this.setAttribute("uv", new Xe(V.uvs, 2)), this.setIndex(H);
            let Q = EY;
            Q.copy(h[h.length - 1]).setPosition(u[u.length - 1]), this.applyMatrix4OnRange(Q, j, L), Q.copy(h[0]).setPosition(u[0]).multiply(TY.makeScale(1, 1, -1)), this.applyMatrix4OnRange(Q, j - b, j), this.reverseIndicesOnRange(W, q);
        } else this.setAttribute("position", new Xe(V.positions, 3)), this.setAttribute("normal", new Xe(V.normals, 3)), this.setAttribute("uv", new Xe(V.uvs, 2)), this.setIndex(H);
    }
    _extractPathPoints() {
        let r = A0(this.inputs.path).getPoints(this.inputs.path.subdivisions);
        if (r.length < 2) return [];
        let i = [
            r[0]
        ];
        return r.forEach((o)=>{
            i[i.length - 1].distanceToSquared(o) > .001 && i.push(o);
        }), this.inputs.path.isClosed && i[i.length - 1].distanceTo(i[0]) < .001 && i.pop(), i;
    }
    _computeBasisMatrices(e) {
        let r = [], i = e.length, s = this.inputs.path.isClosed, o = new E, a = new E, l = new E, c = new E, u = new E(0, 1, 0);
        for(let g = 0; g < i; g++){
            let y = e[g], x;
            g === 0 ? x = s ? e[e.length - 2] : y.clone().multiplyScalar(2).sub(e[1]) : x = e[g - 1];
            let v;
            g === i - 1 ? v = s ? e[1] : y.clone().multiplyScalar(2).sub(e[g - 1]) : v = e[g + 1];
            let S = y.clone().sub(x).normalize(), w = v.clone().sub(y).normalize(), A = S.clone().add(w).normalize();
            l.copy(A), g === 0 && (A.equals(u) || A.clone().negate().equals(u)) && u.set(0, 0, 1);
            let T = u.clone().cross(A).normalize(), b = A.clone().cross(T).normalize();
            u.copy(b), c.copy(T), g === 0 && (o.copy(b), a.copy(A));
            let M = new ue().makeBasis(T, b, A);
            r.push(M);
        }
        let h = s ? a : l, d = s ? o : new E(0, 1, 0), f = h.clone().cross(c).normalize(), p = Math.acos(d.dot(f));
        if (isNaN(p)) return r;
        let m = d.clone().cross(f);
        h.dot(m) > 0 && (p *= -1);
        for(let g = 1; g < r.length; g++){
            let y = new ue().makeRotationZ(p * g / r.length);
            r[g].multiply(y);
        }
        return r;
    }
    _applyPathModifiers(e, r, i) {
        let s = e.length, { angle: o, twist: a, startScale: l, endScale: c } = this.inputs.parameters.extrusion, u = new ue, h = new ue;
        return e.forEach((d, f)=>{
            let p = f === 0 ? 0 : f === s - 1 ? 1 : (f - r) / (s - (i === 0 ? 0 : 1) - (r + (1 - i)));
            u.makeRotationZ(we.lerp(o, o + a, p) * we.DEG2RAD);
            let m = we.lerp(l, c, p);
            h.makeScale(m, m, m), d.multiply(u).multiply(h);
        }), e;
    }
    _computeShapePoints(e = 12, r = Gt.ODD) {
        let i = this.inputs.shapeData, s = i.extractShapePointsToFlatArray([], e), o = i.shapeHoles.map((m)=>{
            let g = m.extractShapePointsToFlatArray([], e), y = [];
            for(let x = g.length - 1; x >= 1; x -= 2){
                let v = g[x - 1], S = g[x - 0];
                y.push(v, S);
            }
            return y;
        }), a;
        try {
            a = qs({
                windingRule: r,
                elementType: jr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    s
                ]
            });
        } catch  {
            a = um;
        }
        let l;
        try {
            l = qs({
                windingRule: Gt.ODD,
                elementType: jr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...o
                ]
            });
        } catch  {
            l = B1;
        }
        if (!a) throw new Error("error generating geometry");
        let c = a.elementCount;
        if (l) {
            a.elementCount += l.elementCount;
            for(let m = 0; m < l.elements.length; m++){
                let g = l.elements[m], y = m % 2 === 0 ? a.vertexCount : 0;
                a.elements.push(g + y);
            }
            for(let m = 0; m < l.vertexIndices.length; m++){
                let g = l.vertexIndices[m], y = a.vertexCount;
                a.vertexIndices.push(g + y);
            }
            for(let m = 0; m < l.vertices.length; m++){
                let g = l.vertices[m];
                a.vertices.push(g);
            }
        }
        let u = 1 / 0, h = -1 / 0, d = 1 / 0, f = -1 / 0;
        for(let m = 0, g = a.vertexCount; m < g; m++){
            let y = m * 2, x = a.vertices[y + 0], v = a.vertices[y + 1];
            x < u && (u = x), x > h && (h = x), v < d && (d = v), v > f && (f = v);
        }
        let p = [];
        for(let m = a.elementCount - 1; m >= 0; m--){
            let g = m >= c, y = m * 2, x = a.elements[y + 0], v = a.elements[y + 1], S = x + v, w = {
                start: x,
                count: v,
                normals: [],
                isHole: g,
                continuous: [],
                verticesStart: 0,
                verticesCount: 0
            };
            p.push(w);
            let A = x, T = S - 1, b = x + 1, M = i.roundedCurves.length;
            do {
                let C = A - x, P = a.vertices[T * 2 + 0], I = a.vertices[T * 2 + 1], _ = a.vertices[A * 2 + 0], D = a.vertices[A * 2 + 1], L = a.vertices[b * 2 + 0], j = a.vertices[b * 2 + 1], V = _ - P, H = D - I, W = Math.sqrt(V * V + H * H);
                V /= W, H /= W;
                let q = _ - L, Q = D - j, G = Math.sqrt(q * q + Q * Q);
                q /= G, Q /= G, w.normals[C * 2 + 0] = -Q, w.normals[C * 2 + 1] = q;
                let Z = a.vertexIndices[A];
                if (Array.isArray(Z)) w.continuous[C] = !1;
                else {
                    let [te, $] = i.getCurveIndexFromVertexId(Z - 1, !0);
                    if ($ > 0 && $ < 1) w.continuous[C] = !0;
                    else {
                        let Y = $ === 1 ? te + 1 : te - 1;
                        Y = (Y + M) % M;
                        let oe = $ === 1 ? 0 : 1, ie = i.roundedCurves[te].getTangent($), re = i.roundedCurves[Y].getTangent(oe);
                        w.continuous[C] = ie.dot(re) > .95;
                    }
                }
                g && (w.normals[C * 2 + 0] *= -1, w.normals[C * 2 + 1] *= -1), [T, A, b] = [
                    A,
                    b,
                    b + 1
                ], b >= S && (b -= v);
            }while (b !== x + 1);
        }
        return {
            regions: [
                s,
                ...o
            ],
            infos: p,
            vertices: a.vertices
        };
    }
    _insertVertex(e, r, i, s, o) {
        let a = r * 2, l = r * 3;
        e.positions[l + 0] = i.x, e.positions[l + 1] = i.y, e.positions[l + 2] = i.z, e.normals[l + 0] = s.x, e.normals[l + 1] = s.y, e.normals[l + 2] = s.z, e.uvs[a + 0] = o.x, e.uvs[a + 1] = o.y;
    }
    _extrudeRegion(e, r, i, s, o, a, l) {
        let c = new E, u = new E, h = new E, d = new E, f = new k;
        i.forEach((m, g)=>{
            let y = s[g], x = e.verticesStart * i.length + e.verticesCount * g;
            for(let v = 0; v < e.count; v++){
                let S = (e.start + v) * 2;
                if (c.set(r[S + 0], r[S + 1], 0), h.copy(c).applyMatrix4(m).add(y), e.continuous[v]) d.set(e.normals[v * 2 + 0], e.normals[v * 2 + 1], 0);
                else {
                    let w = v === 0 ? (e.start + e.count - 1) * 2 : S - 2;
                    u.set(r[w + 0], r[w + 1], 0), d.copy(c).sub(u), d.set(-d.y, d.x, 0), e.isHole || d.negate();
                }
                if (d.applyMatrix4(m).normalize(), f.set(v === 0 ? 1 : v / e.count, g / (i.length - 1)), this._insertVertex(o, x, h, d, f), x++, !e.continuous[v] || v === 0) {
                    if (v === 0) d.set(e.normals[v * 2 + 0], e.normals[v * 2 + 1], 0), f.set(0, g / (i.length - 1));
                    else {
                        let w = v === e.count - 1 ? e.start * 2 : S + 2;
                        u.set(r[w + 0], r[w + 1], 0), d.copy(u).sub(c), d.set(-d.y, d.x, 0), e.isHole || d.negate();
                    }
                    d.applyMatrix4(m).normalize(), this._insertVertex(o, x, h, d, f), x++;
                }
            }
        });
        let p = i.length - 1;
        for(let m = 0; m < p; m++){
            let g = e.verticesStart * i.length + e.verticesCount * m, y = e.verticesStart * i.length + e.verticesCount * (m + 1), x = 0;
            for(let v = 0; v < e.count; v++){
                (!e.continuous[v] || v === 0) && x++;
                let S = v === e.count - 1 ? 0 : x + 1, w = g + x, A = g + S, T = y + S, b = y + x;
                e.isHole ? a.push(w, T, A, w, b, T) : a.push(w, A, T, w, T, b), x++;
            }
        }
    }
    _closeEnd(e, r, i, s, o, a, l) {
        let c = e.vertexCount, u = new E(0, 0, l ? -1 : 1).applyMatrix4(o), h = new E, d = new k;
        for(let p = 0; p < c; p++){
            let m = 2 * p;
            h.set(e.vertices[m + 0], e.vertices[m + 1], 0).applyMatrix4(o).add(a), this._insertVertex(s, r + p, h, u, d);
        }
        let f = e.elements;
        for(let p = 0; p < e.elementCount; p++){
            let m = 3 * p, g = f[m + 0] + r, y = f[m + (l ? 1 : 2)] + r, x = f[m + (l ? 2 : 1)] + r;
            i.push(g, y, x);
        }
    }
    applyMatrix4OnRange(e, r, i) {
        let s = e.elements, o = new fr().getNormalMatrix(e).elements, a, l, c, u, h = this.attributes.position, d = this.attributes.normal;
        if (!h || !d) return;
        let f = h.array, p = d.array, m = h.itemSize;
        for(let g = r * m, y = i * m; g < y; g += m){
            if (g === r) debugger;
            a = f[g + 0], l = f[g + 1], c = f[g + 2], u = 1 / (s[3] * a + s[7] * l + s[11] * c + s[15]), f[g + 0] = (s[0] * a + s[4] * l + s[8] * c + s[12]) * u, f[g + 1] = (s[1] * a + s[5] * l + s[9] * c + s[13]) * u, f[g + 2] = (s[2] * a + s[6] * l + s[10] * c + s[14]) * u, a = p[g + 0], l = p[g + 1], c = p[g + 2], p[g + 0] = o[0] * a + o[3] * l + o[6] * c, p[g + 1] = o[1] * a + o[4] * l + o[7] * c, p[g + 2] = o[2] * a + o[5] * l + o[8] * c;
        }
        h.needsUpdate = !0, d.needsUpdate = !0;
    }
    reverseIndicesOnRange(e, r) {
        let i = this.index;
        if (i) {
            for(let s = e; s < r; s += 3){
                let o = i.getX(s), a = i.getX(s + 1), l = i.getX(s + 2);
                i.setXYZ(s, l, a, o);
            }
            i.needsUpdate = !0;
        }
    }
};
function tR() {
    let n1 = new _e;
    return n1.setAttribute("position", new Xe(new Float32Array([]), 3)), n1.setIndex(new Xe(new Uint16Array([]), 1)), n1;
}
var PY = tR().attributes, _Y = 12, IY = 1, Gc = class extends _e {
    constructor(e, r){
        super();
        this.charWidths = [];
        this.charCoords = [];
        this.wrappedText = [];
        this.isLowResolution = !1;
        this.vectorShapes = [];
        Object.assign(this.attributes, PY), this.userData = {
            parameters: e,
            type: "TextGeometry"
        };
        let i = r.getFont(e.font);
        i?.isLoaded ? (this.font = i, this.update(e)) : this.updateFont(e.font, r).then(()=>{
            this.update(e), r?.requestRender();
        });
    }
    async updateFont(e, r) {
        let i = r.getFont(e);
        i && (this.font = i, await i.loadingPromise);
    }
    update(e) {
        let r = this.font;
        if (this.userData = {
            parameters: e,
            type: "TextGeometry"
        }, !r?.isLoaded) {
            console.warn("Cannot update text because its font is not loaded");
            return;
        }
        let { width: i, height: s, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l, text: c, textTransform: u } = e, h = Br.getDisplayedValue(c), d = u === 2 ? h.toUpperCase() : u === 3 ? h.toLowerCase() : h, f = DY(e, r, d), { shapes: p, charWidths: m, charCoords: g } = r.generateShapes(f, e), y = (typeof i == "number" ? i : 1) * .5, x = (typeof s == "number" ? s : 1) * .5, v = p.map((A)=>new Xt().fromShape(A, !0));
        this.vectorShapes = v;
        let S = v.map((A)=>Rn.create({
                shape: A,
                parameters: {
                    depth: o,
                    extrudeBevelSegments: l,
                    extrudeBevelSize: a,
                    windingRule: o <= 0 ? Gt.NONZERO : Gt.ODD,
                    subdivisions: this.isLowResolution && o > 0 ? IY : _Y
                }
            })), w = S.length ? Gs(S) : tR();
        w.translate(-y, x, 0), this.dispose(), this.wrappedText = f, this.charCoords = g, this.charWidths = m, this.deleteAttribute("extrudeNormal"), Object.entries(w.attributes).forEach(([A, T])=>{
            this.setAttribute(A, T);
        }), this.setIndex(w.index), this.computeBoundingSphere();
    }
    clone() {
        let e = qi(new _e, Gc.prototype);
        return e.copy(this), console.log("CloneGeometry", this, e), e;
    }
    copy(e) {
        return Object.entries(e.attributes).forEach(([r, i])=>{
            this.setAttribute(r, i);
        }), this.setIndex(e.index), this.userData = {
            parameters: {
                ...e.userData.parameters
            },
            type: "TextGeometry"
        }, this;
    }
    async setText(e) {
        this.font && await this.font.loadingPromise, await this.update({
            ...this.userData.parameters,
            text: {
                textValue: e
            }
        });
    }
    get text() {
        return this.userData.parameters.text ?? "";
    }
};
function DY(n1, t, e) {
    let r = [
        ""
    ], i = "";
    for (let s of e)i += s, s === " " || s === `
` ? (r[r.length - 1] += i, i = "", s === `
` && r.push("")) : t.getTextWidth(r[r.length - 1] + i, n1) > n1.width && (r[r.length - 1].length && r.push(""), t.getTextWidth(r[r.length - 1] + i, n1) > n1.width && (i.length === 1 ? (r[r.length - 1] += i, i = "") : (r[r.length - 1] += i.slice(0, -1), i = i[i.length - 1], r.push(""))));
    return r[r.length - 1] += i, r;
}
var iR, k0 = new Promise((n1)=>{
    iR = n1;
}), rR = !1;
var V0;

function nR() {
    if (rR) return;
    if (V0) return V0;
    async function n1() {
        let e = "https://unpkg.com/@splinetool/modelling-wasm@1.9.46/build", i = (parcelRequire("9CTrk")), [s, o] = await Promise.all([
            i,
            fetch(`${e}/process.wasm`).then((c)=>c.arrayBuffer())
        ]), a = s.default, l = await a({
            wasmBinary: o
        });
        iR(l), rR = !0;
    }
    return V0 = n1(), V0;
}
var OY = [
    "font"
];
function _a(n1, t, e, r) {
    let i, s, o;
    n1.type === "PathGeometry" ? (s = JSON.parse(JSON.stringify(n1)), o = [
        [],
        [
            "extrusion"
        ]
    ]) : (s = {
        ...n1
    }, o = [
        []
    ]);
    for (let c of o){
        let u = s;
        for (let h of c)u = u[h];
        for(i in u){
            let h = u[i];
            DA(h) && !OY.includes(i) && (u[i] = t.getVariable(h, [
                r.uuid,
                "geometry",
                ...c,
                i
            ]), DA(u[i]) && (u[i] = 1));
        }
    }
    let a = {
        parameters: s,
        type: s.type
    };
    if (s.type === "PathGeometry") a.path = s.path;
    else if (s.type === "VectorGeometry") {
        let c = Xt.createFromState(s.shape, s.width, s.height);
        a.shape = c;
    } else if (s.type === "NonParametricGeometry") {
        if (s.data.groups && s.data.groups?.forEach((c)=>c.materialIndex = Math.max(c.materialIndex ?? 0, 0)), a.geometry = new Qu().parse(s), a.geometry.groups.length === 0) {
            let c = a.geometry;
            c.addGroup(0, Math.max(c.getIndex()?.count ?? 0, c.getAttribute("position").count), 0);
        }
    } else if (s.type === "SubdivGeometry") {
        let c = new ni(s, e);
        return c.data = n1, c;
    } else {
        if (s.type === "TextGeometry") return new Gc(s, t);
        if (s.type === "InputGeometry") return new Gc(s, t);
        if (s.type === "UIGeometry") return Pd.create({
            parameters: {
                width: s.width,
                height: s.height,
                cornerRadius: s.cornerRadius,
                cornerType: s.cornerType
            }
        });
    }
    let l;
    try {
        l = X1(a);
    } catch (c) {
        console.error(c);
    }
    if (!l) {
        let c = Xt.createFromState(Gh.defaultData(), 100, 100);
        a.shape = c, l = X1(a);
    }
    return l;
}
var RY = new ue;
function mm(n1, t, e, r) {
    let i = n1.position.array, s = n1.normal.array, o = RY.makeScale(t, e, r).invert().elements, a, l, c;
    for(var u = 0, h = i.length; u < h; u += 3)i[u] *= t, i[u + 1] *= e, i[u + 2] *= r, a = s[u], l = s[u + 1], c = s[u + 2], s[u] = o[0] * a + o[4] * l + o[8] * c, s[u + 1] = o[1] * a + o[5] * l + o[9] * c, s[u + 2] = o[2] * a + o[6] * l + o[10] * c;
    n1.position.needsUpdate = !0, n1.normal.needsUpdate = !0;
}
var U0 = new Wt, Id = new E, lt;
k0.then((n1)=>{
    lt = n1;
});
var sR = new Float32Array([
    10,
    10,
    0,
    -10,
    10,
    0,
    -10,
    -10,
    0,
    10,
    -10,
    0
]), oR = new Uint32Array([
    0,
    1,
    2,
    3
]), aR = new Uint8Array([
    4
]), ni = class extends _e {
    constructor(e, r){
        super();
        this.data = e;
        this.flatShading = r;
        this.subdivPointer = 0;
        this.rebuild(), this.freeSubdivPointer();
    }
    mutateDirectlyScaleBaked(e, r) {
        this.freeSubdivPointer();
        let i = this.data.scaleBaked, s = Mo.div(r, i);
        this.subdividedGeometry && mm(this.subdividedGeometry.attributes, ...s), this.originalGeometry && mm(this.originalGeometry.attributes, ...s), this.data = e;
        let o = this.userData.parameters;
        this.userData.parameters = {
            width: o.width * s[0],
            height: o.height * s[1],
            depth: o.depth * s[2]
        }, this.originalGeometry.boundingSphere.center.multiply(Id.fromArray(s));
        let a = Id.set(o.width, o.height, o.depth).length();
        this.originalGeometry.boundingSphere.radius = a / 2;
    }
    ensureSubdivPointer() {
        return this.subdivPointer === 0 && this.rebuild(), this.subdivPointer;
    }
    rebuild() {
        let e, r, i;
        try {
            ({ originalGeometry: e, subdividedGeometry: r, subdivPointer: i } = ni.build(this.data, void 0, !this.flatShading, void 0));
        } catch  {
            e = new mi(100, 100, 100), i = 0;
        }
        this.subdivPointer = i, this.originalGeometry = e, this.subdividedGeometry = r ?? void 0;
        let s = this.subdividedGeometry ?? this.originalGeometry;
        Object.assign(this, s), this.calcBoundingBox();
    }
    freeSubdivPointer() {
        this.subdivPointer && (ni.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0);
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new Rr, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let r = e.attributes.position, i = e.boundingSphere.center;
        U0.setFromBufferAttribute(r), U0.getCenter(i), e.boundingSphere.radius = i.distanceTo(U0.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), U0.getSize(Id);
        let s = {
            width: Id.x,
            height: Id.y,
            depth: Id.z
        };
        return this.userData.parameters = s, s;
    }
    static build(e, r, i, s) {
        let o, a, l, c = e?.phongAngle ?? 35;
        i === !1 && (c = -1), r && (lt.free_bvh(r), lt.free_subdivision_surface(r));
        try {
            o = ni.allocate(e, s);
        } catch (u) {
            console.error(u, e), o = ni.allocate({
                positionWASM: sR,
                indexWASM: oR,
                verticesPerFaceWASM: aR
            }, s);
        }
        if (lt.set_destination_refinement_level(o, 0), a = ni.buildLevel(o, !0, c), e.subdivisions > 0) try {
            lt.set_destination_refinement_level(o, e.subdivisions), l = ni.buildLevel(o, !1, c);
        } catch  {
            try {
                lt.set_destination_refinement_level(o, e.subdivisions - 1), l = ni.buildLevel(o, !1, c);
            } catch  {
                l = null;
            }
        }
        else l = null;
        return {
            subdivPointer: o,
            originalGeometry: a,
            subdividedGeometry: l
        };
    }
    static primitiveToQuads(e, r, i) {
        e.widthSegments > 16 && (e.widthSegments = 16), e.heightSegments > 16 && (e.heightSegments = 16), e.depthSegments > 16 && (e.depthSegments = 16), e.radialSegments > 16 && (e.radialSegments = 16), e.type === "DodecahedronGeometry" && (e.detail = 0);
        let s = e.shape !== void 0 || e.path !== void 0 ? r.geometry : _a(e, i, !1), o;
        e.type === "TorusGeometry" && e.arc === Math.PI * 2 ? o = s.getClosedTorusIndicesForBooleanOrSubdiv() : o = s.getIndex();
        let a, l, c, u;
        ({ positions: a, triIndices: u } = jc(s.getAttribute("position"), o));
        let h;
        if (e.type === "CylinderGeometry" && e.cornerRadius === 0 && e.hollow === 0 && e.openEnded === !1) {
            let d = e.radialSegments * e.heightSegments * 6, f = d + e.radialSegments * 3;
            h = [
                d,
                f
            ];
        }
        return { indices: l, verticesPerFace: c } = J1(a, u, s, h), {
            positions: a,
            indices: l,
            verticesPerFace: c
        };
    }
    static allocate(e, r) {
        let i, s, o, a = [], l = [];
        e.positionWASM && e.positionWASM.length > 0 ? (i = e.positionWASM, s = e.indexWASM, o = e.verticesPerFaceWASM) : (i = sR, s = oR, o = aR);
        let c = i.length, u = s.length, h = o.length, d = i.length + a.length + l.length, f = s.length + o.length, p = d * Float32Array.BYTES_PER_ELEMENT + f * Uint32Array.BYTES_PER_ELEMENT, m = d * Float32Array.BYTES_PER_ELEMENT, g = f * Uint32Array.BYTES_PER_ELEMENT, y = lt._malloc(p), x = new Float32Array(lt.HEAPF32.buffer, y, d), v = new Uint32Array(lt.HEAPU32.buffer, y + m, f);
        x.set(i, 0), x.set(a, i.length), x.set(l, i.length + a.length), v.set(s, 0), v.set(o, s.length);
        let S;
        e?.scaleBaked?.some((A)=>A !== 1) && (S = new ue().makeScale(...e.scaleBaked)), r && (S ? S.premultiply(r) : S = r);
        let w = S ? lt.alloc_subdivision_surface2(y, c, y + m, u, y + m + s.length * Uint32Array.BYTES_PER_ELEMENT, h, S.elements) : lt.alloc_subdivision_surface(y, c, y + m, u, y + m + s.length * Uint32Array.BYTES_PER_ELEMENT, h);
        return lt._free(y), w;
    }
    static buildLevel(e, r, i, s, o) {
        let a = o ? lt.get_mesh_data2(e, r ? lt.Level.CONTROL : lt.Level.REFINED, i, o.elements) : lt.get_mesh_data(e, r ? lt.Level.CONTROL : lt.Level.REFINED, i), l = 8, c = lt.HEAPU32.subarray(a >> 2, (a >> 2) + l), u = c.subarray(4, 8), h = 0, d = lt.HEAPU32[c[h] >> 2], f = lt.HEAPF32.subarray(d >> 2, (d >> 2) + u[h]);
        h++;
        let p = lt.HEAPU32[c[h] >> 2], m = lt.HEAPF32.subarray(p >> 2, (p >> 2) + u[h]);
        h++;
        let g = lt.HEAPU32[c[h] >> 2], y = lt.HEAPU32.subarray(g >> 2, (g >> 2) + u[h]);
        h++;
        let x = lt.HEAPU32[c[h] >> 2], v = lt.HEAPU32.subarray(x >> 2, (x >> 2) + u[h]);
        if (h++, s === void 0) {
            let S = new _e;
            if (S.setIndex(new po(v, 1)), S.setAttribute("position", new Te(f, 3)), S.setAttribute("normal", new Te(m, 3)), r) {
                S.setAttribute("faceMap", new po(y, 1));
                let w = new Float32Array(m.length / 3 * 4).fill(0);
                S.setAttribute("color", new Xe(w, 4));
            }
            return lt.free_mesh_data(a), S.userData.type = "SubdivGeometry", S;
        }
        s.getAttribute("position").copyArray(f), s.getAttribute("normal").copyArray(m), s.attributes.position.needsUpdate = !0, s.attributes.normal.needsUpdate = !0, lt.free_mesh_data(a);
    }
    static freeSubdivPointer(e) {
        lt.free_bvh(e), lt.free_subdivision_surface(e);
    }
    static buildControlCageWireframe(e, r, i) {
        let s = lt.get_wireframe_data_for_base_level(e), o = 4, a = lt.HEAPU32.subarray(s >> 2, (s >> 2) + o), l = a.subarray(2, 4), c = 0, u = lt.HEAPU32[a[c] >> 2], h = lt.HEAPF32.subarray(u >> 2, (u >> 2) + l[c]);
        c++;
        let d = lt.HEAPU32[a[c] >> 2], f = lt.HEAPU32.subarray(d >> 2, (d >> 2) + l[c]);
        if (r === void 0) {
            let p = new _e;
            p.setAttribute("position", new Te(h, 3));
            let m = new Float32Array(h.length);
            for(let g = 0, y = h.length; g < y;)m[g++] = i.r, m[g++] = i.g, m[g++] = i.b;
            return p.setAttribute("color", new Xe(m, 3)), p.setIndex(new po(f, 1)), lt.free_wireframe_data_for_base_level(s), p;
        }
        r.getAttribute("position").copyArray(h), r.attributes.position.needsUpdate = !0, lt.free_wireframe_data_for_base_level(s);
    }
    static updateCollabMesh(e, r, i) {
        let s = r === 0;
        s || lt.set_destination_refinement_level(e, r);
        let o = i ? lt.get_topological_data2(e, s ? lt.Level.CONTROL : lt.Level.REFINED, i.elements) : lt.get_topological_data(e, s ? lt.Level.CONTROL : lt.Level.REFINED), a = 6, l = lt.HEAPU32.subarray(o >> 2, (o >> 2) + a), c = l.subarray(3, 6), u = 0, h = lt.HEAPU32[l[u] >> 2], d = new Float32Array(lt.HEAPF32.subarray(h >> 2, (h >> 2) + c[u]));
        u++;
        let f = lt.HEAPU32[l[u] >> 2], p = new Uint32Array(lt.HEAPU32.subarray(f >> 2, (f >> 2) + c[u]));
        u++;
        let m = lt.HEAPU32[l[u] >> 2], g = new Uint8Array(lt.HEAPU32.subarray(m >> 2, (m >> 2) + c[u]));
        return lt.free_topological_data(o), {
            positions: d,
            indices: p,
            verticesPerFace: g
        };
    }
};
var lR = [
    "getX",
    "getY",
    "getZ"
];
function jc(n1, t) {
    let e = {}, r = t ? t.count : n1.count, i = 0, s = [], o = [], a = 1e4;
    for(let c = 0; c < r; c++){
        let u = t ? t.getX(c) : c, h = "";
        for(let d = 0; d < 3; d++)h += `${~~(n1[lR[d]](u) * a)},`;
        if (h in e) s.push(e[h]);
        else {
            for(let d = 0; d < 3; d++)o.push(n1[lR[d]](u));
            e[h] = i, s.push(i), i++;
        }
    }
    let l = [];
    for(let c = 0; c < s.length; c += 3)s[c] === s[c + 1] || s[c] === s[c + 2] || s[c + 1] === s[c + 2] || l.push(s[c], s[c + 1], s[c + 2]);
    return {
        positions: o,
        triIndices: l
    };
}
var z0 = new E, K1 = new E, Q1 = new E, Z1 = new E;
function J1(n1, t, e, r) {
    let i = [], s = [];
    if (e.userData.shape !== void 0 && e.userData.parameters.depth === 0 && e.userData.shape.shapeHoles.length === 0) {
        let l = e.userData.shape.extractShapePointsToFlatArray([]), c = e.userData.parameters.spikes;
        if (e.userData.type === "EllipseGeometry" && c <= 24 && c % 4 === 0 && e.userData.parameters.angle >= 360) {
            let d = l.length / 2 / c;
            l = l.filter((f, p)=>Math.floor(p / 2) % d === 0);
        }
        let u = 0;
        for(let d = 0; d < l.length; d += 2)u += (l[d] - l[(d === 0 ? l.length : d) - 2]) * (l[d + 1] + l[(d === 0 ? l.length : d) - 1]);
        n1.length = 0;
        let h = 0;
        if (u < 0) for(let d = 0; d < l.length; d += 2)n1.push(l[d], l[d + 1], 0), i.push(h++);
        else for(let d = l.length - 2; d >= 0; d -= 2)n1.push(l[d], l[d + 1], 0), i.push(h++);
        return s.push(h), {
            indices: i,
            verticesPerFace: s
        };
    }
    let o = new Float32Array([
        e.userData.parameters.depth
    ])[0], a = 0;
    for(; a < t.length;){
        if (e.useNgonForTopBottomFaceDuringBake) {
            let l = 0;
            if ((n1[t[a] * 3 + 2] === o || n1[t[a] * 3 + 2] === 0) && l++, (n1[t[a + 1] * 3 + 2] === o || n1[t[a + 1] * 3 + 2] === 0) && l++, (n1[t[a + 2] * 3 + 2] === o || n1[t[a + 2] * 3 + 2] === 0) && l++, l === 3) break;
        }
        if (t[a + 1] === t[a + 3] && t[a + 2] === t[a + 5] || t[a + 0] === t[a + 3] && t[a + 2] === t[a + 4]) {
            z0.set(n1[t[a] * 3], n1[t[a] * 3 + 1], n1[t[a] * 3 + 2]), K1.set(n1[t[a + 1] * 3], n1[t[a + 1] * 3 + 1], n1[t[a + 1] * 3 + 2]), Q1.set(n1[t[a + 4] * 3], n1[t[a + 4] * 3 + 1], n1[t[a + 4] * 3 + 2]), Z1.set(n1[t[a + 5] * 3], n1[t[a + 5] * 3 + 1], n1[t[a + 5] * 3 + 2]), K1.sub(z0).normalize(), Q1.sub(z0).normalize(), Z1.sub(z0).normalize();
            let l = K1.cross(Q1).dot(Z1);
            Math.abs(l) > .005 || r && r.some((c, u)=>u % 2 === 1 ? !1 : a >= r[u] && a < r[u + 1]) ? (i.push(t[a], t[a + 1], t[a + 2]), s.push(3), a += 3) : (i.push(t[a], t[a + 1], t[a + 4], t[a + 5]), s.push(4), a += 6);
        } else i.push(t[a], t[a + 1], t[a + 2]), s.push(3), a += 3;
    }
    if (e.useNgonForTopBottomFaceDuringBake) {
        let l = [], c = [], u = 0;
        for(let h = 0, d = 0; h < n1.length; h += 3, d++)n1[h + 2] === 0 && (l.push(d), u++), n1[h + 2] === o && c.push(d);
        if (e.userData.parameters.extrudeBevelSize === 0) {
            let h = c[0];
            c[0] = c[1], c[1] = h;
        }
        l.reverse(), i.push(...l, ...c), s.push(u, u);
    }
    return {
        indices: i,
        verticesPerFace: s
    };
}
var ms = {};
TF(ms, {
    calcBoolean: ()=>NY,
    calcBooleanTopological: ()=>BY,
    freeMeshSet: ()=>UY,
    getMeshSet: ()=>FY,
    hasOpenEdges: ()=>VY,
    transformMeshSet: ()=>kY
});
var cR, uR = new Promise((n1)=>{
    cR = n1;
});
var G0;

function hR() {
    if (G0) return G0;
    async function n1() {
        let e = "https://unpkg.com/@splinetool/boolean-wasm@1.9.46/build", i = (parcelRequire("1Jpra")), [s, o] = await Promise.all([
            i,
            fetch(`${e}/boolean.wasm`).then((c)=>c.arrayBuffer())
        ]), a = s.default, l = await a({
            wasmBinary: o
        });
        cR(l);
    }
    return G0 = n1(), G0;
}
var Mt, Dd;
uR.then((n1)=>Mt = n1);
function LY(n1, t, e) {
    let r, i;
    n1.userData.parameters.type === "TorusGeometry" && n1.userData.parameters.arc === Math.PI * 2 ? i = n1.getClosedTorusIndicesForBooleanOrSubdiv() : i = n1.getIndex();
    let { positions: s, triIndices: o } = jc(n1.getAttribute("position"), i), a;
    if (t && e) {
        let { indices: l, verticesPerFace: c } = J1(s, o, n1);
        a = c.length, r = [];
        for(let u = 0, h = 0; u < a; u++){
            r.push(c[u]);
            for(let d = 0; d < c[u]; d++)r.push(l[h++]);
        }
    } else {
        let l = o.length;
        r = Array(l + l / 3), a = 0;
        for(let c = 0, u = 0; u < r.length;)r[u++] = 3, a++, r[u++] = o[c++], r[u++] = o[c++], r[u++] = o[c++];
    }
    return {
        positions: s,
        faceIndices: r,
        nFaces: a
    };
}
function dR(n1) {
    let t = n1.length, e = t * Uint32Array.BYTES_PER_ELEMENT, r = t * Float32Array.BYTES_PER_ELEMENT, i = Number.isInteger(n1[0]) ? e : r, s = Mt._malloc(i);
    return (Number.isInteger(n1[0]) ? new Uint32Array(Mt.HEAPU32.buffer, s, t) : new Float32Array(Mt.HEAPF32.buffer, s, t)).set(n1, 0), s;
}
function fR(n1) {
    switch(n1){
        case 0:
            return Mt.OP.UNION;
        case 1:
            return Mt.OP.INTERSECTION;
        case 2:
            return Mt.OP.A_MINUS_B;
        case 3:
            return Mt.OP.B_MINUS_A;
        case 4:
            return Mt.OP.SYMMETRIC_DIFFERENCE;
        case 5:
            return Mt.OP.ALL;
        default:
            throw new Error("Unknown boolean operation " + n1);
    }
}
function BY(n1, t) {
    Dd === void 0 && (Dd = Mt.init_csg());
    let e = dR(n1), r = Mt.csg_calc_topological(Dd, e, n1.length, fR(t));
    Mt._free(e);
    let i = 6, s = Mt.HEAPU32.subarray(r >> 2, (r >> 2) + i), o = s.subarray(3, 6), a = 0, l = Mt.HEAPU32[s[a] >> 2], c = new Float32Array(Mt.HEAPF32.subarray(l >> 2, (l >> 2) + o[a]));
    a++;
    let u = Mt.HEAPU32[s[a] >> 2], h = new Uint32Array(Mt.HEAPU32.subarray(u >> 2, (u >> 2) + o[a]));
    a++;
    let d = Mt.HEAPU32[s[a] >> 2], f = new Uint8Array(Mt.HEAPU32.subarray(d >> 2, (d >> 2) + o[a]));
    return Mt.free_mesh_data(r), {
        positions: c,
        indices: h,
        verticesPerFace: f
    };
}
function NY(n1, t, e, r) {
    Dd === void 0 && (Dd = Mt.init_csg());
    let i = dR(n1), s = Mt.csg_calc(Dd, i, n1.length, r, fR(t));
    Mt._free(i);
    let o = 5, a = Mt.HEAPU32.subarray(s >> 2, (s >> 2) + o), l = a.subarray(2, 5), c = 0, u = Mt.HEAPU32[a[c] >> 2], h = Mt.HEAPF32.subarray(u >> 2, (u >> 2) + l[c]);
    c++;
    let d = Mt.HEAPU32[a[c] >> 2], f = Mt.HEAPF32.subarray(d >> 2, (d >> 2) + l[c]);
    c++;
    let p = l[c];
    e.setAttribute("position", new Te(h, 3)), e.setAttribute("normal", new Te(f, 3));
    let m = Mt.HEAPF32.subarray((s >> 2) + 5, (s >> 2) + 5 + 6);
    return e.boundingSphere === null && (e.boundingSphere = new Rr), e.boundingSphere.center.set(m[0], m[1], m[2]), e.boundingSphere.radius = (m[3] ** 2 + m[4] ** 2 + m[5] ** 2) ** .5, e.userData.parameters = {
        width: m[3] * 2,
        height: m[4] * 2,
        depth: m[5] * 2
    }, Mt.free_mesh_data(s), p;
}
function FY(n1, t, e) {
    if (Mt === void 0) return -1;
    let r, i, s;
    if (t && n1.userData.positions !== void 0) {
        let y = n1.userData;
        s = y.verticesPerFace.length, r = y.positions, i = Array(y.verticesPerFace.reduce((x, v)=>x + v, 0) + s);
        for(let x = 0, v = 0, S = 0; x < y.verticesPerFace.length; x++){
            i[S++] = y.verticesPerFace[x];
            for(let w = 0; w < y.verticesPerFace[x]; w++)i[S++] = y.indices[v++];
        }
    } else ({ positions: r, faceIndices: i, nFaces: s } = LY(n1, t, e));
    let o = r.length, a = i.length, l = r.length, c = i.length, u = l * Float32Array.BYTES_PER_ELEMENT + c * Uint32Array.BYTES_PER_ELEMENT, h = l * Float32Array.BYTES_PER_ELEMENT, d = c * Uint32Array.BYTES_PER_ELEMENT, f = Mt._malloc(u), p = new Float32Array(Mt.HEAPF32.buffer, f, l), m = new Uint32Array(Mt.HEAPU32.buffer, f + h, c);
    p.set(r, 0), m.set(i, 0);
    let g = Mt.get_csg_mesh(f, o, f + h, a, s);
    return Mt._free(f), g;
}
function VY(n1) {
    return Mt.has_open_edges(n1);
}
function kY(n1, t) {
    Mt.transform_csg_mesh(n1, t.elements);
}
function UY(n1) {
    Mt.free_csg_mesh(n1);
}
var zY = {
    ConeGeometry: cO,
    CubeGeometry: uO,
    CylinderGeometry: E0,
    DodecahedronGeometry: hO,
    EllipseGeometry: Td,
    HelixGeometry: NO,
    IcosahedronGeometry: FO,
    LatheGeometry: VO,
    NonParametricGeometry: GO,
    PolygonGeometry: B0,
    PyramidGeometry: jO,
    RectangleGeometry: Pd,
    SphereGeometry: HO,
    PlaneGeometry: WO,
    BackdropGeometry: qO,
    StarGeometry: N0,
    TextFrameGeometry: YO,
    TorusGeometry: XO,
    TorusKnotGeometry: KO,
    TriangleGeometry: QO,
    PathGeometry: eR,
    VectorGeometry: Rn
}, X1 = (n1)=>zY[n1.type].create(n1);
function Od(n1) {
    return n1 !== null && "booleanOp" in n1;
}
var Rd = class extends yd(zt) {
    constructor(){
        super(...arguments);
        this.booleanMeshSetAddress = -1;
        this.booleanWasTransformed = !1;
        this.booleanMatrixInvOld = new ue;
    }
    updateVisible(e) {
        super.updateVisible(e), this.visible = !Od(this.parent) && this.visible, Od(this.parent) && this.parent.invalidateDownstreamBooleanData();
    }
    freeBooleanPointer() {
        this.booleanMeshSetAddress !== -1 && (ms.freeMeshSet(this.booleanMeshSetAddress), this.booleanMeshSetAddress = -1);
    }
    invalidateDownstreamBooleanData(e = !1) {
        return e ? this.booleanWasTransformed = !0 : this.freeBooleanPointer(), Od(this.parent) ? this.parent.invalidateDownstreamBooleanData() : this;
    }
    invalidateUpstreamBooleanData() {
        this.freeBooleanPointer();
        for (let e of this.children)e instanceof Rd && (e.freeBooleanPointer(), Od(e) && e.invalidateUpstreamBooleanData());
    }
    updateTransformState(e, r) {
        let i = super.updateTransformState(e, r);
        return i && Od(this.parent) && this.invalidateDownstreamBooleanData(!0), i;
    }
    onVariableUpdate(e = !1) {
        super.onVariableUpdate(e), Od(this.parent) && this.invalidateDownstreamBooleanData(!0);
    }
};
var j0 = new Wt;
function gm(n1, t = 0, e = n1.count, r, i) {
    let s = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, c = -1 / 0, u = -1 / 0;
    for(let h = t; h < e; h++){
        let d = n1.getX(h), f = n1.getY(h), p = n1.getZ(h);
        d < s && (s = d), f < o && (o = f), p < a && (a = p), d > l && (l = d), f > c && (c = f), p > u && (u = p);
    }
    j0.min.set(s, o, a), j0.max.set(l, c, u), j0.getCenter(r), j0.getSize(i).multiplyScalar(.5);
}
var GY = new _e, jY = new on, mr = class extends Rd {
    constructor(t, e){
        super(GY, jY), this.super_Entity(t, e);
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
    updateEntityBoxSize(t, e) {
        let r = this.geometry.getAttribute("position");
        r !== void 0 ? gm(r, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : r.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var Ia = class {
    constructor(t){
        this.hashProperties = void 0;
        this.isNode = !0;
        this.shortcuts = {};
        if (Ia.uuidContext === null) throw new Error("plz startContext");
        Ia.uuidContext === Ia.globalContext ? this.uuid = "_gid" + Ia.uuidContext.nodeContextUuid++ : this.uuid = "_uid" + Ia.uuidContext.nodeContextUuid++, this.type = t, this.name = "";
    }
    static startContext(t) {
        this.uuidContext === null || this.uuidContext === Ia.globalContext ? this.uuidContext = t : console.error("Can't start context twice");
    }
    static endContext(t) {
        this.uuidContext !== t && console.error("Can't end context twice"), this.uuidContext = null;
    }
    analyze(t, e) {
        e = e ?? {}, t.analyzing = !0, this.build(t.addFlow(e.slot, e.cache, e.context), "v4"), t.clearVertexNodeCode(), t.clearFragmentNodeCode(), t.removeFlow(), t.analyzing = !1;
    }
    analyzeAndFlow(t, e, r) {
        return r = r ?? {}, this.analyze(t, r), this.flow(t, e, r);
    }
    flow(t, e, r) {
        r = r ?? {}, t.addFlow(r.slot, r.cache, r.context);
        let i = {
            result: this.build(t, e),
            code: t.clearNodeCode(),
            extra: t.context.extra
        };
        return t.removeFlow(), i;
    }
    build(t, e, r) {
        e = e ?? this.getType(t, e);
        let i = t.getNodeData(r ?? this);
        return t.analyzing && this.appendDepsNode(t, i, e), t.nodes.indexOf(this) === -1 && t.nodes.push(this), this.updateFrame !== void 0 && t.updaters.indexOf(this) === -1 && t.updaters.push(this), this.generate(t, e, r);
    }
    updateFrame(t) {}
    generateReadonly(t, e, r, i, s, o) {
        return "";
    }
    generate(t, e, r, i, s) {
        return "";
    }
    parse(t, e, r, i) {}
    appendDepsNode(t, e, r) {
        e.deps = (e.deps || 0) + 1;
        let i = t.getTypeLength(r);
        (i > (e.outputMax || 0) || this.getType(t, r)) && (e.outputMax = i, e.output = r);
    }
    setName(t) {
        this.name = t;
    }
    getName() {
        return this.name;
    }
    getType(t, e) {
        return e === "sampler2D" || e === "samplerCube" ? e : this.type;
    }
}, or = Ia;
or.globalContext = {
    nodeContextUuid: 0
}, or.uuidContext = Ia.globalContext;
var ym = class {
    constructor(t){
        t = t ?? {}, this.name = t.name, this.type = t.type, this.node = t.node, this.size = t.size, this.needsUpdate = t.needsUpdate;
    }
    get value() {
        return this.node.value;
    }
    set value(t) {
        this.node.value = t;
    }
};
var $1 = class {
    constructor(){
        this.nodes = {};
        this.keywords = {};
    }
    add(t) {
        this.nodes[t.name] = t;
    }
    addKeyword(t, e, r) {
        r = r !== void 0 ? r : !0, this.keywords[t] = {
            callback: e,
            cache: r
        };
    }
    remove(t) {
        delete this.nodes[t.name];
    }
    removeKeyword(t) {
        delete this.keywords[t];
    }
    get(t) {
        return this.nodes[t];
    }
    getKeyword(t, e) {
        return this.keywords[t].callback(e);
    }
    getKeywordData(t) {
        return this.keywords[t];
    }
    contains(t) {
        return this.nodes[t] !== void 0;
    }
    containsKeyword(t) {
        return this.keywords[t] !== void 0;
    }
}, _i = new $1;
var tt = class extends or {
    constructor(e, r){
        super(e);
        this.scope = "";
        r = r ?? {}, this.shared = r.shared !== void 0 ? r.shared : !0, this.unique = r.unique !== void 0 ? r.unique : !1;
    }
    build(e, r, i, s) {
        if (r = r ?? this.getType(e), this.getShared(e, r)) {
            let o = this.getUnique(e, r);
            o && this.uuid === void 0 && (this.uuid = we.generateUUID()), i = e.getUUID(i ?? this.getUUID(), !o);
            let a = e.getNodeData(i), l = a.output || this.getType(e);
            if (e.analyzing) return (a.deps || 0) > 0 || this.getLabel() ? (this.appendDepsNode(e, a, r), this.generate(e, r, i)) : super.build(e, r, i);
            if (o) return a.name = a.name || super.build(e, r, i), a.name;
            if (!this.getLabel() && (!this.getShared(e, l) || e.context.ignoreCache || a.deps === 1)) return super.build(e, r, i);
            i = this.getUUID(!1);
            let c = this.getTemp(e, i);
            if (c) return e.format(c, l, r);
            {
                c = super.generate(e, r, i, a.output, s);
                let u = this.generate(e, l, i);
                return e.addNodeCode(c + " = " + u + ";"), e.format(c, l, r);
            }
        }
        return super.build(e, r, i);
    }
    getShared(e, r) {
        return r !== "sampler2D" && r !== "samplerCube" && this.shared;
    }
    getUnique(e, r) {
        return this.unique;
    }
    setLabel(e) {
        return this.label = e, this;
    }
    getLabel() {
        return this.label;
    }
    getUUID(e) {
        let r = this.uuid;
        return typeof this.scope == "string" && (r = this.scope + "-" + r), r;
    }
    getTemp(e, r) {
        r = r || this.uuid;
        let i = e.getVars()[r];
        return i ? i.name : void 0;
    }
    generate(e, r, i, s, o) {
        return this.getShared(e, r) || console.error("TempNode is not shared"), i = i ?? this.uuid, e.getTempVar(i, s ?? this.getType(e), o, this.getLabel()).name;
    }
};
var ar = class extends tt {
    constructor(e, r){
        r = r ?? {}, r.shared = r.shared !== void 0 ? r.shared : !1;
        super(e, r);
        this.readonly = !1;
    }
    setReadonly(e) {
        return this.readonly = e, this.hashProperties = this.readonly ? [
            "value"
        ] : void 0, this;
    }
    getReadonly() {
        return this.readonly;
    }
    generate(e, r, i, s, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s = s ?? this.getType(e);
        let l = e.getNodeData(i);
        return this.getReadonly() && this.generateReadonly !== void 0 ? this.generateReadonly(e, r, i, s, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s, this, o, a, this.getLabel())), e.format(l.vertex.name, s, r)) : (l.fragment || (l.fragment = e.createFragmentUniform(s, this, o, a, this.getLabel())), e.format(l.fragment.name, s, r));
    }
};
var Hr = class extends ar {
    constructor(e = 0, r){
        super("v2");
        this.nodeType = "Vector2";
        this.value = e instanceof k ? e : new k(e, r);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec2(" + this.value.x + ", " + this.value.y + ")", s, r);
    }
};
var Xi = class extends ar {
    constructor(e = 0, r, i){
        super("v3");
        this.nodeType = "Vector3";
        this.value = e instanceof E ? e : new E(e, r, i);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    get z() {
        return this.value.z;
    }
    set z(e) {
        this.value.z = e;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec3(" + this.value.x + ", " + this.value.y + ", " + this.value.z + ")", s, r);
    }
};
var vr = class extends We {
    constructor(e, r, i, s){
        super(e, r, i);
        this.isColorA = !0;
        this.a = s;
    }
    setRGBA(e, r, i, s) {
        super.setRGB(e, r, i), this.a = s;
    }
    copy(e) {
        return super.copy(e), this.a = "a" in e ? e.a : 1, this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
    equals(e) {
        return super.equals(e) && this.a === e.a;
    }
    setStyle(e, r = "srgb") {
        let i;
        if (e === "transparent") return this.setRGBA(0, 0, 0, 0), this;
        if (i = /^((?:rgb|hsl)a?)\(([^)]*)\)/.exec(e)) {
            let s, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "rgba" ? parseFloat(s[4]) : 1, super.setStyle(e, r);
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "hsla" ? parseFloat(s[4]) : 1, super.setStyle(e, r);
                    break;
            }
        }
        return super.setStyle(e, r);
    }
    get x() {
        return this.r;
    }
    get y() {
        return this.g;
    }
    get z() {
        return this.b;
    }
    get w() {
        return this.a;
    }
    set x(e) {
        this.r = e;
    }
    set y(e) {
        this.g = e;
    }
    set z(e) {
        this.b = e;
    }
    set w(e) {
        this.a = e;
    }
};
var Ln = class extends ar {
    constructor(e){
        super("v4");
        this.nodeType = "Vector4";
        this.value = e instanceof vr ? e : new vr(e.r, e.g, e.b, e.a);
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec4(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ", " + this.value.a + ")", s, r);
    }
};
var HY = /^\s*([a-z_0-9]+)\s([a-z_0-9]+)\s*\((.*?)\)/i, pR = /[a-z_0-9]+/gi, Ae = class extends tt {
    constructor(e, r, i, s, o){
        super(o);
        this.src = "";
        this.nodeType = "Function";
        this.useKeywords = !0;
        this.includes = [];
        this.extensions = {};
        this.keywords = {};
        this.isMethod = o === void 0, this.isInterface = !1, this.parse(e, r, i, s);
    }
    getShared(e, r) {
        return !this.isMethod;
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    getInputByName(e) {
        if (this.inputs) {
            let r = this.inputs.length;
            for(; r--;)if (this.inputs[r].name === e) return this.inputs[r];
        }
    }
    getIncludeByName(e) {
        if (this.includes) {
            let r = this.includes.length;
            for(; r--;)if (this.includes[r].name === e) return this.includes[r];
        }
    }
    generate(e, r, i, s, o) {
        let a, l = 0, c = this.src;
        if (this.includes) for(let h = 0; h < this.includes.length; h++)e.include(this.includes[h], this);
        for(let h in this.extensions)e.extensions[h] = !0;
        let u = [];
        for(; a = pR.exec(this.src);)u.push(a);
        for(let h = 0; h < u.length; h++){
            let d = u[h], f = d[0], p = this.isMethod ? !this.getInputByName(f) : !0, m = f;
            if (this.keywords[f] || this.useKeywords && p && _i.containsKeyword(f)) {
                let g = this.keywords[f];
                if (!g) {
                    let y = _i.getKeywordData(f);
                    y.cache && (g = e.keywords[f]), g = g || _i.getKeyword(f, e), y.cache && (e.keywords[f] = g);
                }
                m = g.build(e);
            }
            f !== m && c[d.index + l - 1] !== "." && (c = c.substring(0, d.index + l) + m + c.substring(d.index + f.length + l), l += m.length - f.length), this.getIncludeByName(m) === void 0 && _i.contains(m) && e.include(_i.get(m));
        }
        return r === "source" ? c : this.isMethod ? (this.isInterface || e.include(this, void 0, c), this.name) : e.format("( " + c + " )", this.getType(e), r);
    }
    parse(e, r, i, s) {
        if (this.src = e || "", this.includes = r ?? [], this.extensions = i ?? {}, this.keywords = s ?? {}, this.isMethod) {
            let o = HY.exec(this.src);
            if (this.inputs = [], o && o.length == 4) {
                this.type = o[1], this.name = o[2];
                let a = o[3].match(pR);
                if (a) {
                    let l = 0;
                    for(; l < a.length;){
                        let c = a[l++], u;
                        c === "in" || c === "out" || c === "inout" ? u = a[l++] : (u = c, c = "");
                        let h = a[l++];
                        this.inputs.push({
                            name: h,
                            type: u,
                            qualifier: c
                        });
                    }
                }
                this.isInterface = this.src.indexOf("{") === -1;
            } else this.type = "", this.name = "";
        }
    }
};
var WY = /^([a-z_0-9]+)\s([a-z_0-9]+)\s?\=?\s?(.*?)(\;|$)/i, eE = class extends tt {
    constructor(e = "", r){
        super();
        this.src = "";
        this.useDefine = !1;
        this.nodeType = "Const";
        this.parse(e || eE.PI, void 0, void 0, void 0, r);
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    parse(e, r, i, s, o) {
        this.src = e || "";
        let a, l, c = "", u = WY.exec(e);
        this.useDefine = o ?? this.src.charAt(0) === "#", u && u.length > 1 ? (l = u[1], a = u[2], c = u[3]) : (a = this.src, l = "f"), this.name = a, this.type = l, this.value = c;
    }
    build(e, r) {
        if (r === "source") {
            if (this.value) return this.useDefine ? "#define " + this.name + " " + this.value : "const " + this.type + " " + this.name + " = " + this.value + ";";
            if (this.useDefine) return this.src;
        }
        return e.include(this), e.format(this.name, this.getType(e), r);
    }
    generate(e, r, i, s, o) {
        return e.format(this.name, this.getType(e), r);
    }
}, kt = eE;
kt.PI = "PI", kt.PI2 = "PI2", kt.RECIPROCAL_PI = "RECIPROCAL_PI", kt.RECIPROCAL_PI2 = "RECIPROCAL_PI2", kt.LOG2 = "LOG2", kt.EPSILON = "EPSILON";
var qY = new RegExp(`^structs*([a-z_0-9]+)s*{s*((.|
)*?)}`, "gim"), YY = new RegExp("s*(w*?)s*(w*?)(=|;)", "gim"), Ld = class extends tt {
    constructor(e = ""){
        super();
        this.inputs = [];
        this.src = "";
        this.nodeType = "Struct";
        this.parse(e);
    }
    getType(e) {
        return e.getTypeByFormat(this.name);
    }
    getInputByName(e) {
        let r = this.inputs.length;
        for(; r--;)if (this.inputs[r].name === e) return this.inputs[r];
    }
    generate(e, r, i, s, o) {
        return r === "source" ? this.src + ";" : e.format("( " + this.src + " )", this.getType(e), r);
    }
    parse(e = "") {
        this.src = e, this.inputs = [];
        let r = qY.exec(e);
        if (r) {
            let i = r[2], s;
            for(; s = YY.exec(i);)this.inputs.push({
                type: s[1],
                name: s[2]
            });
            this.name = r[1];
        } else this.name = "";
        this.type = this.name;
    }
};
var Bd = class extends tt {
    constructor(e){
        super("v2", {
            shared: !1
        });
        this.nodeType = "UV";
        this.index = e ?? 0;
    }
    generate(e, r) {
        e.requires.uv[this.index] = !0;
        let i = this.index > 0 ? this.index + 1 : "", s = e.isShader("vertex") ? "uv" + i : "vUv" + i;
        return e.format(s, this.getType(e), r);
    }
};
_i.addKeyword("uv", function() {
    return new Bd;
});
_i.addKeyword("uv2", function() {
    return new Bd(1);
});
var Hc = class extends tt {
    constructor(e, r){
        super("v4");
        this.nodeType = "ColorSpace";
        this.input = e, this.method = r ?? Hc.LINEAR_TO_LINEAR, this.hashProperties = [
            "method"
        ];
    }
    static getEncodingComponents(e) {
        switch(e){
            case mn:
                return [
                    "Linear"
                ];
            case at:
                return [
                    "sRGB"
                ];
            default:
                return [];
        }
    }
    generate(e, r) {
        let i = this.input.build(e, "v4"), s = this.getType(e), o = Hc.Nodes[this.method], a = e.include(o);
        if (a === Hc.LINEAR_TO_LINEAR) return e.format(i, s, r);
        if (o.inputs?.length === 2) {
            let l = this.factor.build(e, "f");
            return e.format(a + "( " + i + ", " + l + " )", s, r);
        } else return e.format(a + "( " + i + " )", s, r);
    }
    fromEncoding(e) {
        let r = Hc.getEncodingComponents(e);
        this.method = "LinearTo" + r[0], this.factor = r[1];
    }
    fromDecoding(e) {
        let r = Hc.getEncodingComponents(e);
        this.method = r[0] + "ToLinear", this.factor = r[1];
    }
}, xn = Hc;
xn.Nodes = {
    LinearToLinear: new Ae([
        "vec4 LinearToLinear( in vec4 value ) {",
        "	return value;",
        "}"
    ].join(`
`)),
    sRGBToLinear: new Ae([
        "vec4 sRGBToLinear( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );",
        "}"
    ].join(`
`)),
    LinearTosRGB: new Ae([
        "vec4 LinearTosRGB( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );",
        "}"
    ].join(`
`))
}, xn.LINEAR_TO_LINEAR = "LinearToLinear", xn.SRGB_TO_LINEAR = "sRGBToLinear", xn.LINEAR_TO_SRGB = "LinearTosRGB";
var Kt = class extends Ae {
    constructor(e = "", r, i, s, o){
        super(e, o, s, i, r);
        this.nodeType = "Expression";
    }
};
var bn = class extends ar {
    constructor(e = new er, r, i, s){
        super("v4", {
            shared: !0
        });
        this.nodeType = "Texture";
        this.value = e, this.uv = r ?? new Bd, this.bias = i, this.project = s !== void 0 ? s : !1;
    }
    getTexture(e, r) {
        return super.generate(e, r, this.value.uuid, "t");
    }
    generate(e, r) {
        if (r === "sampler2D") return this.getTexture(e, r);
        let i = this.getTexture(e, r), s = this.uv.build(e, this.project ? "v4" : "v2"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a, l;
        this.project ? a = "texture2DProj" : a = o ? "tex2DBias" : "tex2D", o ? l = a + "( " + i + ", " + s + ", " + o + " )" : l = a + "( " + i + ", " + s + " )";
        let c = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, u = this.getType(e);
        return e.addContext(c), this.colorSpace = this.colorSpace ?? new xn(new Kt("", u)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(l), l = this.colorSpace.build(e, u), e.removeContext(), e.format(l, u, r);
    }
};
var Fe = class extends ar {
    constructor(e){
        super("f");
        this.nodeType = "Float";
        this.value = e ?? 0;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format(this.value + (this.value % 1 ? "" : ".0"), s, r);
    }
};
var vm = class extends tt {
    constructor(e, r){
        super();
        this.inputs = [];
        this.nodeType = "FunctionCall";
        this.value = e, this.inputs = r ?? [];
    }
    getFunction() {
        return this.value;
    }
    getType(e) {
        return this.value.getType(e);
    }
    generate(e, r, i, s, o) {
        s = this.getType(e);
        let a = this.value, l = a.build(e, r) + "( ", c = [];
        if (a.inputs) {
            for(let u = 0; u < a.inputs.length; u++){
                let h = a.inputs[u], d = this.inputs[u] || this.inputs[h.name];
                c.push(d.build(e, e.getTypeByFormat(h.type)));
            }
            l += c.join(", ") + " )";
        }
        return e.format(l, s, r);
    }
};
var tE = class extends tt {
    constructor(e, r, i = tE.ADD){
        super();
        this.nodeType = "Operator";
        this.type = e.type, this.a = e, this.b = r, this.op = i;
    }
    getType(e) {
        let r = this.a.getType(e), i = this.b.getType(e);
        return e.isTypeMatrix(r) ? "v4" : e.getTypeLength(i) > e.getTypeLength(r) ? i : r;
    }
    generate(e, r) {
        let i = this.getType(e);
        this.type = i;
        let s = this.a.build(e, i), o = this.b.build(e, i);
        return e.format("( " + s + " " + this.op + " " + o + " )", i, r);
    }
}, ki = tE;
ki.ADD = "+", ki.SUB = "-", ki.MUL = "*", ki.DIV = "/";
var lr = class extends tt {
    constructor(e, r = lr.ABS, i, s){
        super();
        this.nodeType = "Math";
        this.a = e, typeof r != "string" ? this.b = r : s = r, typeof i != "string" ? this.c = i : s = i, this.method = s, this.hashProperties = [
            "method"
        ];
    }
    getNumInputs(e) {
        switch(this.method){
            case lr.MIX:
            case lr.CLAMP:
            case lr.REFRACT:
            case lr.SMOOTHSTEP:
            case lr.FACEFORWARD:
                return 3;
            case lr.MIN:
            case lr.MAX:
            case lr.MOD:
            case lr.STEP:
            case lr.REFLECT:
            case lr.DISTANCE:
            case lr.DOT:
            case lr.CROSS:
            case lr.POW:
                return 2;
            default:
                return 1;
        }
    }
    getInputType(e) {
        let r = e.getTypeLength(this.a.getType(e)), i = this.b ? e.getTypeLength(this.b.getType(e)) : 0, s = this.c ? e.getTypeLength(this.c.getType(e)) : 0;
        return r > i && r > s ? this.a.getType(e) : i > s ? this.b.getType(e) : this.c.getType(e);
    }
    getType(e) {
        switch(this.method){
            case lr.LENGTH:
            case lr.DISTANCE:
            case lr.DOT:
                return "f";
            case lr.CROSS:
                return "v3";
        }
        return this.getInputType(e);
    }
    generate(e, r) {
        let i, s, o, a = this.a ? e.getTypeLength(this.a.getType(e)) : 0, l = this.b ? e.getTypeLength(this.b.getType(e)) : 0, c = this.c ? e.getTypeLength(this.c.getType(e)) : 0, u = this.getInputType(e), h = this.getType(e);
        switch(this.type = h, this.method){
            case lr.NEGATE:
                return e.format("( -" + this.a.build(e, u) + " )", u, r);
            case lr.INVERT:
                return e.format("( 1.0 - " + this.a.build(e, u) + " )", u, r);
            case lr.CROSS:
                i = this.a.build(e, "v3"), s = this.b.build(e, "v3");
                break;
            case lr.STEP:
                i = this.a.build(e, a === 1 ? "f" : u), s = this.b.build(e, u);
                break;
            case lr.MIN:
            case lr.MAX:
            case lr.MOD:
                i = this.a.build(e, u), s = this.b.build(e, l === 1 ? "f" : u);
                break;
            case lr.REFRACT:
                i = this.a.build(e, u), s = this.b.build(e, u), o = this.c.build(e, "f");
                break;
            case lr.MIX:
                i = this.a.build(e, u), s = this.b.build(e, u), o = this.c.build(e, c === 1 ? "f" : u);
                break;
            default:
                i = this.a.build(e, u), this.b && (s = this.b.build(e, u)), this.c && (o = this.c.build(e, u));
                break;
        }
        let d = [];
        d.push(i), s && d.push(s), o && d.push(o);
        let f = this.getNumInputs(e);
        if (d.length !== f) throw Error(`Arguments not match used in "${this.method}". Require ${f}, currently ${d.length}.`);
        return e.format(this.method + "( " + d.join(", ") + " )", h, r);
    }
}, ft = lr;
ft.RAD = "radians", ft.DEG = "degrees", ft.EXP = "exp", ft.EXP2 = "exp2", ft.LOG = "log", ft.LOG2 = "log2", ft.SQRT = "sqrt", ft.INV_SQRT = "inversesqrt", ft.FLOOR = "floor", ft.CEIL = "ceil", ft.NORMALIZE = "normalize", ft.FRACT = "fract", ft.SATURATE = "saturate", ft.SIN = "sin", ft.COS = "cos", ft.TAN = "tan", ft.ASIN = "asin", ft.ACOS = "acos", ft.ARCTAN = "atan", ft.ABS = "abs", ft.SIGN = "sign", ft.LENGTH = "length", ft.NEGATE = "negate", ft.INVERT = "invert", ft.MIN = "min", ft.MAX = "max", ft.MOD = "mod", ft.STEP = "step", ft.REFLECT = "reflect", ft.DISTANCE = "distance", ft.DOT = "dot", ft.CROSS = "cross", ft.POW = "pow", ft.MIX = "mix", ft.CLAMP = "clamp", ft.REFRACT = "refract", ft.SMOOTHSTEP = "smoothstep", ft.FACEFORWARD = "faceforward";
var Nd = class extends tt {
    constructor(e, r, i){
        super("v4");
        this.nodeType = "TextureCubeUV";
        this.value = e, this.uv = r, this.bias = i;
    }
    bilinearCubeUV(e, r, i, s) {
        let o = new vm(Nd.Nodes.bilinearCubeUV, [
            r,
            i,
            s
        ]);
        this.colorSpaceTL = this.colorSpaceTL ?? new xn(new Kt("", "v4")), this.colorSpaceTL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTL.input.parse(o.build(e) + ".tl"), this.colorSpaceTR = this.colorSpaceTR ?? new xn(new Kt("", "v4")), this.colorSpaceTR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTR.input.parse(o.build(e) + ".tr"), this.colorSpaceBL = this.colorSpaceBL ?? new xn(new Kt("", "v4")), this.colorSpaceBL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBL.input.parse(o.build(e) + ".bl"), this.colorSpaceBR = this.colorSpaceBR ?? new xn(new Kt("", "v4")), this.colorSpaceBR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBR.input.parse(o.build(e) + ".br");
        let a = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        };
        e.addContext(a), this.colorSpaceTLExp = new Kt(this.colorSpaceTL.build(e, "v4"), "v4"), this.colorSpaceTRExp = new Kt(this.colorSpaceTR.build(e, "v4"), "v4"), this.colorSpaceBLExp = new Kt(this.colorSpaceBL.build(e, "v4"), "v4"), this.colorSpaceBRExp = new Kt(this.colorSpaceBR.build(e, "v4"), "v4"), e.removeContext();
        let l = new Kt("mix( mix( cubeUV_TL, cubeUV_TR, cubeUV.f.x ), mix( cubeUV_BL, cubeUV_BR, cubeUV.f.x ), cubeUV.f.y )", "v4");
        return l.keywords.cubeUV_TL = this.colorSpaceTLExp, l.keywords.cubeUV_TR = this.colorSpaceTRExp, l.keywords.cubeUV_BL = this.colorSpaceBLExp, l.keywords.cubeUV_BR = this.colorSpaceBRExp, l.keywords.cubeUV = o, l;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = this.uv, s = this.bias || e.context.roughness, o = new vm(Nd.Nodes.roughnessToMip, [
                s
            ]), a = new ft(o, Nd.Nodes.m0, Nd.Nodes.cubeUV_maxMipLevel, ft.CLAMP), l = new ft(a, ft.FLOOR), c = new ft(a, ft.FRACT), u = this.bilinearCubeUV(e, this.value, i, l), h = this.bilinearCubeUV(e, this.value, i, new ki(l, new Fe(1).setReadonly(!0), ki.ADD)), d = new ft(u, h, c, ft.MIX);
            return e.format(d.build(e), "v4", r);
        } else return console.warn("TextureCubeUVNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), r);
    }
}, Fd = Nd;
Fd.Nodes = function() {
    let e = new Ld(`struct TextureCubeUVData {
			vec4 tl;
			vec4 tr;
			vec4 br;
			vec4 bl;
			vec2 f;
		}`), r = new kt("float cubeUV_maxMipLevel 8.0", !0), i = new kt("float cubeUV_minMipLevel 4.0", !0), s = new kt("float cubeUV_maxTileSize 256.0", !0), o = new kt("float cubeUV_minTileSize 16.0", !0), a = new Ae(`float getFace(vec3 direction) {
				vec3 absDirection = abs(direction);
				float face = -1.0;
				if (absDirection.x > absDirection.z) {
					if (absDirection.x > absDirection.y)
						face = direction.x > 0.0 ? 0.0 : 3.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				} else {
					if (absDirection.z > absDirection.y)
						face = direction.z > 0.0 ? 2.0 : 5.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				}
				return face;
		}`);
    a.useKeywords = !1;
    let l = new Ae(`vec2 getUV(vec3 direction, float face) {
				vec2 uv;
				if (face == 0.0) {
					uv = vec2(direction.z, direction.y) / abs(direction.x); // pos x
				} else if (face == 1.0) {
					uv = vec2(-direction.x, -direction.z) / abs(direction.y); // pos y
				} else if (face == 2.0) {
					uv = vec2(-direction.x, direction.y) / abs(direction.z); // pos z
				} else if (face == 3.0) {
					uv = vec2(-direction.z, direction.y) / abs(direction.x); // neg x
				} else if (face == 4.0) {
					uv = vec2(-direction.x, direction.z) / abs(direction.y); // neg y
				} else {
					uv = vec2(direction.x, direction.y) / abs(direction.z); // neg z
				}
				return 0.5 * (uv + 1.0);
		}`);
    l.useKeywords = !1;
    let c = new Ae(`TextureCubeUVData bilinearCubeUV(sampler2D envMap, vec3 direction, float mipInt) {
			float face = getFace(direction);
			float filterInt = max(cubeUV_minMipLevel - mipInt, 0.0);
			mipInt = max(mipInt, cubeUV_minMipLevel);
			float faceSize = exp2(mipInt);
			float texelSize = 1.0 / (3.0 * cubeUV_maxTileSize);
			vec2 uv = getUV(direction, face) * (faceSize - 1.0);
			vec2 f = fract(uv);
			uv += 0.5 - f;
			if (face > 2.0) {
				uv.y += faceSize;
				face -= 3.0;
			}
			uv.x += face * faceSize;
			if(mipInt < cubeUV_maxMipLevel){
				uv.y += 2.0 * cubeUV_maxTileSize;
			}
			uv.y += filterInt * 2.0 * cubeUV_minTileSize;
			uv.x += 3.0 * max(0.0, cubeUV_maxTileSize - 2.0 * faceSize);
			uv *= texelSize;
			vec4 tl = texture2D(envMap, uv);
			uv.x += texelSize;
			vec4 tr = texture2D(envMap, uv);
			uv.y += texelSize;
			vec4 br = texture2D(envMap, uv);
			uv.x -= texelSize;
			vec4 bl = texture2D(envMap, uv);
			return TextureCubeUVData( tl, tr, br, bl, f );
		}`, [
        e,
        a,
        l,
        r,
        i,
        s,
        o
    ]);
    c.useKeywords = !1;
    let u = new kt("float r0 1.0", !0), h = new kt("float v0 0.339", !0), d = new kt("float m0 -2.0", !0), f = new kt("float r1 0.8", !0), p = new kt("float v1 0.276", !0), m = new kt("float m1 -1.0", !0), g = new kt("float r4 0.4", !0), y = new kt("float v4 0.046", !0), x = new kt("float m4 2.0", !0), v = new kt("float r5 0.305", !0), S = new kt("float v5 0.016", !0), w = new kt("float m5 3.0", !0), A = new kt("float r6 0.21", !0), T = new kt("float v6 0.0038", !0), b = new kt("float m6 4.0", !0), M = [
        u,
        h,
        d,
        f,
        p,
        m,
        g,
        y,
        x,
        v,
        S,
        w,
        A,
        T,
        b
    ], C = new Ae(`float roughnessToMip(float roughness) {
			float mip = 0.0;
			if (roughness >= r1) {
				mip = (r0 - roughness) * (m1 - m0) / (r0 - r1) + m0;
			} else if (roughness >= r4) {
				mip = (r1 - roughness) * (m4 - m1) / (r1 - r4) + m1;
			} else if (roughness >= r5) {
				mip = (r4 - roughness) * (m5 - m4) / (r4 - r5) + m4;
			} else if (roughness >= r6) {
				mip = (r5 - roughness) * (m6 - m5) / (r5 - r6) + m5;
			} else {
				mip = -2.0 * log2(1.16 * roughness);// 1.16 = 1.79^0.25
			}
			return mip;
		}`, M);
    return {
        bilinearCubeUV: c,
        roughnessToMip: C,
        m0: d,
        cubeUV_maxMipLevel: r
    };
}();
var Wc = class extends tt {
    constructor(e){
        super("v3");
        this.nodeType = "Normal";
        this.scope = e ?? Wc.VIEW;
    }
    getShared() {
        return this.scope === Wc.WORLD;
    }
    build(e, r, i, s) {
        let o = e.context[this.scope + "Normal"];
        return o ? o.build(e, r, i, s) : super.build(e, r, i);
    }
    generate(e, r, i, s, o) {
        let a;
        switch(this.scope){
            case Wc.VIEW:
                e.isShader("vertex") ? a = "transformedNormal" : a = "geometryNormal";
                break;
            case Wc.LOCAL:
                e.isShader("vertex") ? a = "objectNormal" : (e.requires.normal = !0, a = "vObjectNormal");
                break;
            case Wc.WORLD:
                e.isShader("vertex") ? a = "inverseTransformDirection( transformedNormal, viewMatrix ).xyz" : (e.requires.worldNormal = !0, a = "vWNormal");
                break;
        }
        return e.format(a, this.getType(e), r);
    }
}, Ui = Wc;
Ui.LOCAL = "local", Ui.WORLD = "world", Ui.VIEW = "view", Ui.NORMAL = "normal";
_i.addKeyword("viewNormal", function() {
    return new Ui(Ui.VIEW);
});
_i.addKeyword("localNormal", function() {
    return new Ui(Ui.NORMAL);
});
_i.addKeyword("worldNormal", function() {
    return new Ui(Ui.WORLD);
});
var Bo = class extends tt {
    constructor(e){
        super("v3");
        this.nodeType = "Position";
        this.scope = e ?? Bo.LOCAL;
    }
    getType() {
        switch(this.scope){
            case Bo.PROJECTION:
                return "v4";
        }
        return this.type;
    }
    getShader() {
        switch(this.scope){
            case Bo.LOCAL:
            case Bo.WORLD:
                return !1;
        }
        return !0;
    }
    generate(e, r, i, s, o) {
        let a;
        switch(this.scope){
            case Bo.LOCAL:
                e.isShader("vertex") ? a = "transformed" : (e.requires.position = !0, a = "vPosition");
                break;
            case Bo.WORLD:
                if (e.isShader("vertex")) return "( modelMatrix * vec4( transformed, 1.0 ) ).xyz";
                e.requires.worldPosition = !0, a = "vWPosition";
                break;
            case Bo.VIEW:
                a = e.isShader("vertex") ? "-mvPosition.xyz" : "vViewPosition";
                break;
            case Bo.PROJECTION:
                a = e.isShader("vertex") ? "( projectionMatrix * modelViewMatrix * vec4( position, 1.0 ) )" : "vec4( 0.0 )";
                break;
        }
        return e.format(a, this.getType(), r);
    }
}, Bn = Bo;
Bn.LOCAL = "local", Bn.WORLD = "world", Bn.VIEW = "view", Bn.PROJECTION = "projection";
_i.addKeyword("position", function() {
    return new Bn;
});
_i.addKeyword("worldPosition", function() {
    return new Bn(Bn.WORLD);
});
_i.addKeyword("viewPosition", function() {
    return new Bn(Bn.VIEW);
});
var Ys = class extends tt {
    constructor(e){
        super("v3");
        this.nodeType = "Reflect";
        this.scope = e ?? Ys.CUBE;
    }
    getUnique(e) {
        return !e.context.viewNormal;
    }
    getType() {
        switch(this.scope){
            case Ys.SPHERE:
                return "v2";
        }
        return this.type;
    }
    generate(e, r) {
        let i = this.getUnique(e);
        if (e.isShader("fragment")) {
            let s;
            switch(this.scope){
                case Ys.VECTOR:
                    {
                        let o = new Ui(Ui.VIEW), a = e.context.roughness, l = o.build(e, "v3"), c = new Bn(Bn.VIEW).build(e, "v3"), u = a ? a.build(e, "f") : void 0, h = `reflect( -normalize( ${c} ), ${l} )`;
                        u && (h = `normalize( mix( ${h}, ${l}, ${u} * ${u} ) )`);
                        let d = `inverseTransformDirection( ${h}, viewMatrix )`;
                        i ? (e.addNodeCode(`vec3 reflectVec = ${d};`), s = "reflectVec") : s = d;
                        break;
                    }
                case Ys.CUBE:
                    {
                        let o = new Ys(Ys.VECTOR).build(e, "v3"), a = "vec3( -" + o + ".x, " + o + ".yz )";
                        i ? (e.addNodeCode(`vec3 reflectCubeVec = ${a};`), s = "reflectCubeVec") : s = a;
                        break;
                    }
                case Ys.SPHERE:
                    {
                        let a = "normalize( ( viewMatrix * vec4( " + new Ys(Ys.VECTOR).build(e, "v3") + ", 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) ).xy * 0.5 + 0.5";
                        i ? (e.addNodeCode(`vec2 reflectSphereVec = ${a};`), s = "reflectSphereVec") : s = a;
                        break;
                    }
            }
            return e.format(s, this.getType(), r);
        } else return console.warn("ReflectNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.type, r);
    }
}, No = Ys;
No.CUBE = "cube", No.SPHERE = "sphere", No.VECTOR = "vector";
var H0 = class extends tt {
    constructor(e = new bn, r, i){
        super("v4");
        this.nodeType = "TextureCube";
        this.value = e, this.radianceNode = new Fd(this.value, r ?? new No(No.VECTOR), i), this.irradianceNode = new Fd(this.value, new Ui(Ui.WORLD), new Fe(1).setReadonly(!0));
    }
    generate(e, r) {
        return e.isShader("fragment") ? (e.require("irradiance"), e.context.bias && e.context.bias.setTexture(this.value), (e.slot === "irradiance" ? this.irradianceNode : this.radianceNode).build(e, r)) : (console.warn("TextureCubeNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), r));
    }
};
var W0 = class extends ar {
    constructor(e = new Bu, r, i){
        super("v4", {
            shared: !0
        });
        this.nodeType = "CubeTexture";
        this.value = e, this.uv = r ?? new No, this.bias = i;
    }
    getTexture(e, r) {
        return super.generate(e, r, this.value.uuid, "tc");
    }
    generate(e, r) {
        if (r === "samplerCube") return this.getTexture(e, r);
        let i = this.getTexture(e, r), s = this.uv?.build(e, "v3"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a;
        o ? a = "texCubeBias( " + i + ", " + s + ", " + o + " )" : a = "texCube( " + i + ", " + s + " )";
        let l = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, c = this.getType(e);
        return e.addContext(l), this.colorSpace = this.colorSpace ?? new xn(new Kt("", c)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(a), a = this.colorSpace.build(e, c), e.removeContext(), e.format(a, c, r);
    }
};
var mR = `
uniform int frameIndex;
uniform vec2 resolution;
uniform mat4 previousModelViewMatrix;
uniform mat4 previousProjectionMatrix;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;
`, gR = `
layout(location = 1) out vec4 gVelocity;

uniform int frameIndex;
uniform vec2 resolution;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;

const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

vec2 vogelDiskSample(int sampleIndex, int sampleCount, float angle) {
  const float goldenAngle = 2.399963f; // radians
  float r = sqrt(float(sampleIndex) + 0.5f) / sqrt(float(sampleCount));
  float theta = float(sampleIndex) * goldenAngle + angle;
  float sine = sin(theta);
  float cosine = cos(theta);
  return vec2(cosine, sine) * r;
}

// Derived from the interleaved gradient function from Jimenez 2014 http:goo.gl/eomGso
float getNoiseInterleavedGradient(vec2 screenPos) {
    vec3 magic = vec3(0.06711056f, 0.00583715f, 52.9829189f);
    return fract(magic.z * fract(dot(screenPos, magic.xy)));
}

`, yR = `
// TODO: This could be generated CPU side and passed to the shader every frame
const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

// TODO: Pass correct view size
vec2 offset = haltonSequence[frameIndex];
offset.x /= resolution.x;
offset.y /= resolution.y;

vec4 currentPosition = gl_Position;
vec4 currentPositionJittered = currentPosition + (vec4(offset.x, offset.y, 0.0, 0.0) * currentPosition.w);

// We want to calculate the velocity with unjittered positions
// so that things that are not moving get a velocity = 0
vCurrentPosition = currentPosition;
vPreviousPosition = previousProjectionMatrix * previousModelViewMatrix * vec4(transformed, 1.0);
#ifdef OUTLINE_COMPENSATION
vPreviousPosition.xy += OUTLINE_COMPENSATION;
#endif
gl_Position = currentPositionJittered;

`, vR = `
vec2 oldPos = vPreviousPosition.xy;
    oldPos /= vPreviousPosition.w;
    oldPos.xy = (oldPos.xy+1.)/2.0;

vec2 newPos = vCurrentPosition.xy;
    newPos /= vCurrentPosition.w;
    newPos.xy = (newPos.xy+1.)/2.0;

vec2 velocity = (newPos - oldPos);

// Discard fully transparent pixels 
if (gl_FragColor.a <= 0.0) discard;

gVelocity = vec4(velocity, 0.0, 1.0);
`, xR = `
layout(location = 1) out vec4 gVelocity;
`, bR = `
    // Discard fully transparent pixels 
    if (gl_FragColor.a <= 0.0) discard;

    gVelocity = vec4(0.0, 0.0, 0.0, 1.0);
`;
var SR = [
    "x",
    "y",
    "z",
    "w"
], XY = [
    "float",
    "vec2",
    "vec3",
    "vec4"
], KY = {
    float: "f",
    vec2: "v2",
    vec3: "v3",
    vec4: "v4",
    mat4: "v4",
    int: "i",
    bool: "b",
    "float[]": "f[]",
    "vec4[]": "v4[]"
}, QY = {
    t: "sampler2D",
    tc: "samplerCube",
    b: "bool",
    i: "int",
    f: "float",
    c: "vec3",
    v2: "vec2",
    v3: "vec3",
    v4: "vec4",
    m3: "mat3",
    m4: "mat4",
    "f[]": "float[]",
    "v4[]": "vec4[]"
}, Vd = class {
    constructor(){
        this.includes = {
            consts: {},
            functions: {},
            structs: {}
        };
        this.cache = "";
        this.slot = "";
        this.shader = "";
        this.context = {};
        this.needsJitter = !0;
        this.getIncludesCode = function() {
            function t(e, r) {
                return e.deps.length - r.deps.length;
            }
            return function(r, i) {
                let s = this.getIncludes(r, i);
                if (!s) return "";
                let o = "";
                s = s.sort(t);
                for(let a = 0; a < s.length; a++)s[a].src && (o += s[a].src + `
`);
                return o;
            };
        }();
        this.slots = [], this.caches = [], this.contexts = [], this.keywords = {}, this.nodeData = {}, this.fragmentVariables = {}, this.fragmentParsVariables = {}, this.vertexParsVariables = {}, this.requires = {
            uv: [],
            color: [],
            transparent: !1,
            irradiance: !1,
            position: !1,
            worldPosition: !1,
            normal: !1,
            worldNormal: !1,
            vWorldViewDir: !1,
            modelMatrix: !1,
            viewMatrix: !1,
            projectionMatrix: !1
        }, this.includes = {
            consts: [],
            functions: [],
            structs: []
        }, this.attributes = {}, this.prefixCode = [
            "#ifdef TEXTURE_LOD_EXT",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCubeLodEXT(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2DLodEXT(a, b, c)",
            "#else",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCube(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2D(a, b, c)",
            "#endif",
            `
			// NOTE: Include Spline's blending modes. This could be part of BlendNode
			#define SPE_BLENDING_NORMAL 0
			#define SPE_BLENDING_MULTIPLY 1
			#define SPE_BLENDING_SCREEN 2
			#define SPE_BLENDING_OVERLAY 3

			vec3 spe_normalBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, b, alpha );
			}

			vec3 spe_multiplyBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, a * b, alpha );
			}

			vec3 spe_screenBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = 1.0 - ( 1.0 - a ) * ( 1.0 - b );
				return mix( a, tmp, alpha );
			}

			vec3 spe_overlayBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = mix( 1. - 2. * (1. - a) * (1. - b), 2. * a * b, step( a, vec3(.5) ) );
				return clamp( mix( a, tmp, alpha ), 0.0, 1.0 );
			}

			vec3 spe_blend( vec3 a, vec3 b, float alpha, int mode ) {
				if ( mode == SPE_BLENDING_NORMAL ) return spe_normalBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_MULTIPLY ) return spe_multiplyBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_SCREEN ) return spe_screenBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_OVERLAY ) return spe_overlayBlend( a, b, alpha );
				return vec3( 1.0 );
			}
			`,
            "#include <packing>",
            "#include <common>"
        ].join(`
`), this.parsCode = {
            vertex: [
                "float neighbor_offset = 0.0001;",
                ""
            ].join(`
`),
            fragment: [
                "float accumAlpha = 0.0;",
                `void accumulateAlpha(float alpha) {
					accumAlpha += (1.0 - accumAlpha) * alpha;
				}`,
                ""
            ].join(`
`)
        }, this.code = {
            vertex: "",
            fragment: ""
        }, this.nodeCode = {
            vertex: "",
            fragment: ""
        }, this.resultCode = {
            vertex: "",
            fragment: ""
        }, this.finalCode = {
            vertex: "",
            fragment: ""
        }, this.inputs = {
            uniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            arrayUniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            vars: {
                varying: [],
                vertex: [],
                fragment: []
            }
        }, this.defines = {}, this.uniforms = {}, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.updaters = [], this.nodes = [], this.analyzing = !1;
    }
    build(t, e) {
        this.addVertexParsCode(mR), this.addFragmentParsCode(gR), this.buildShader("vertex", t), this.buildShader("fragment", e);
        for(let r = 0; r < this.requires.uv.length; r++)if (this.requires.uv[r]) {
            let i = r > 0 ? r + 1 : "";
            this.addVaryCode("varying vec2 vUv" + i + ";"), r > 0 && this.addVertexParsCode("attribute vec2 uv" + i + ";"), this.addVertexFinalCode("vUv" + i + " = uv" + i + ";");
        }
        return this.requires.color[0] && (this.addVaryCode("varying vec4 vColor;"), this.addVertexParsCode("attribute vec4 color;"), this.addVertexFinalCode("vColor = color;")), this.requires.color[1] && (this.addVaryCode("varying vec4 vColor2;"), this.addVertexParsCode("attribute vec4 color2;"), this.addVertexFinalCode("vColor2 = color2;")), this.requires.position && (this.addVaryCode("varying vec3 vPosition;"), this.addVertexFinalCode("vPosition = transformed;")), this.requires.worldPosition, this.requires.normal && (this.addVaryCode("varying vec3 vObjectNormal;"), this.addVertexFinalCode("vObjectNormal = normal;")), this.requires.modelMatrix && this.addFragmentParsCode("uniform mat4 modelMatrix;"), this.requires.viewMatrix && this.addFragmentParsCode("uniform mat4 viewMatrix;"), this.requires.projectionMatrix && this.addFragmentParsCode("uniform mat4 projectionMatrix;"), this.requires.worldNormal && (this.addVaryCode("varying vec3 vWNormal;"), this.addVertexFinalCode("vWNormal = inverseTransformDirection( transformedNormal, viewMatrix ).xyz;")), this.requires.vWorldViewDir && (this.addVaryCode("varying vec3 vWorldViewDir;"), this.addVertexFinalCode("vWorldViewDir = isPerspectiveMatrix( projectionMatrix ) ?  ( (modelMatrix * vec4(position, 1.0)).xyz - cameraPosition ) : vec3( -viewMatrix[0][2], -viewMatrix[1][2], -viewMatrix[2][2] );")), this.needsJitter && (this.addVertexFinalCode(yR), this.addFragmentFinalCode(vR)), this;
    }
    buildShader(t, e) {
        this.resultCode[t] = e.build(this.setShader(t), "v4");
    }
    setMaterial(t, e) {
        return this.defines = {}, this;
    }
    addFlow(t, e, r) {
        return this.addSlot(t).addCache(e).addContext(r);
    }
    removeFlow() {
        return this.removeSlot().removeCache().removeContext();
    }
    addCache(t) {
        return this.cache = t ?? "", this.caches.push(this.cache), this;
    }
    removeCache() {
        return this.caches.pop(), this.cache = this.caches[this.caches.length - 1] || "", this;
    }
    addContext(t) {
        return this.context = Object.assign({}, this.context, t), this.context.extra = this.context.extra || {}, this.contexts.push(this.context), this;
    }
    removeContext() {
        return this.contexts.pop(), this.context = this.contexts[this.contexts.length - 1] || {}, this;
    }
    addSlot(t) {
        return this.slot = t || "", this.slots.push(this.slot), this;
    }
    removeSlot() {
        return this.slots.pop(), this.slot = this.slots[this.slots.length - 1] || "", this;
    }
    addFragmentVariable(t, e) {
        this.fragmentVariables[t] === void 0 && (this.addFragmentCode(`${e} ${t};`), this.fragmentVariables[t] = "");
    }
    addFragmentParsVariable(t, e) {
        this.fragmentParsVariables[t] === void 0 && (this.addFragmentParsCode(`${e} ${t};`), this.fragmentParsVariables[t] = "");
    }
    addVertexParsVariable(t, e) {
        this.vertexParsVariables[t] === void 0 && (this.addVertexParsCode(`${e} ${t};`), this.vertexParsVariables[t] = "");
    }
    addVertexCode(t) {
        this.addCode(t, "vertex");
    }
    addFragmentCode(t) {
        this.addCode(t, "fragment");
    }
    addCode(t, e) {
        this.code[e ?? this.shader] += t + `
`;
    }
    addVertexNodeCode(t) {
        this.addNodeCode(t, "vertex");
    }
    addFragmentNodeCode(t) {
        this.addNodeCode(t, "fragment");
    }
    addNodeCode(t, e) {
        this.nodeCode[e ?? this.shader] += t + `
`;
    }
    clearNodeCode(t) {
        t = t ?? this.shader;
        let e = this.nodeCode[t];
        return this.nodeCode[t] = "", e;
    }
    clearVertexNodeCode() {
        return this.clearNodeCode("vertex");
    }
    clearFragmentNodeCode() {
        return this.clearNodeCode("fragment");
    }
    addVertexFinalCode(t) {
        this.addFinalCode(t, "vertex");
    }
    addFragmentFinalCode(t) {
        this.addFinalCode(t, "fragment");
    }
    addFinalCode(t, e) {
        this.finalCode[e ?? this.shader] += t + `
`;
    }
    addVertexParsCode(t) {
        this.addParsCode(t, "vertex");
    }
    addFragmentParsCode(t) {
        this.addParsCode(t, "fragment");
    }
    addParsCode(t, e) {
        this.parsCode[e ?? this.shader] += t + `
`;
    }
    addVaryCode(t) {
        this.addVertexParsCode(t), this.addFragmentParsCode(t);
    }
    isCache(t) {
        return this.caches.indexOf(t) !== -1;
    }
    isSlot(t) {
        return this.slots.indexOf(t) !== -1;
    }
    define(t, e) {
        this.defines[t] = e === void 0 ? 1 : e;
    }
    require(t) {
        this.requires[t] = !0;
    }
    isDefined(t) {
        return this.defines[t] !== void 0;
    }
    getVar(t, e, r, i = "varying", s = "V", o = "") {
        let a = this.getVars(i), l = a[t];
        if (!l) {
            let c = a.length;
            l = {
                name: r || "node" + s + c + (o ? "_" + o : ""),
                type: e
            }, a.push(l), a[t] = l;
        }
        return l;
    }
    getTempVar(t, e, r, i) {
        return this.getVar(t, e, r, this.shader, "T", i);
    }
    getAttribute(t, e) {
        if (!this.attributes[t]) {
            let r = this.getVar(t, e);
            this.addVertexParsCode("attribute " + e + " " + t + ";"), this.addVertexFinalCode(r.name + " = " + t + ";"), this.attributes[t] = {
                varying: r,
                name: t,
                type: e
            };
        }
        return this.attributes[t];
    }
    getCode(t) {
        return [
            this.prefixCode,
            this.parsCode[t],
            this.getVarListCode(this.getVars("varying"), "varying"),
            this.getVarListCode(this.inputs.uniforms[t], "uniform"),
            this.getVarListCode(this.inputs.arrayUniforms[t], "uniform"),
            this.getIncludesCode("consts", t),
            this.getIncludesCode("structs", t),
            this.getIncludesCode("functions", t),
            "void main() {",
            this.getVarListCode(this.getVars(t)),
            this.code[t],
            this.resultCode[t],
            this.finalCode[t],
            "}"
        ].join(`
`);
    }
    getVarListCode(t, e) {
        e = e ?? "";
        let r = "";
        for(let i = 0, s = t.length; i < s; ++i){
            let o = t[i], a = o.type, l = o.name, c = o.size, u = this.getFormatByType(a);
            if (u === void 0) throw new Error("Node pars " + u + " not found.");
            u.includes("[]") ? r += e + " " + u.substring(0, u.length - 2) + " " + l + `[${c}];
` : r += e + " " + u + " " + l + `;
`;
        }
        return r;
    }
    getVars(t) {
        return this.inputs.vars[t ?? this.shader];
    }
    getNodeData(t) {
        let e = t instanceof or ? t.uuid : t;
        return this.nodeData[e] = this.nodeData[e] || {};
    }
    createUniform(t, e, r, i, s, o) {
        if (e.includes("[]")) {
            let a = this.inputs.arrayUniforms, l = a.list.length, c = new ym({
                type: e,
                size: r.size,
                name: i || "nodeUA" + l + (o ? "_" + o : ""),
                node: r,
                needsUpdate: s
            });
            return a.list.push(c), a[t].push(c), a[t][c.name] = c, this.uniforms[c.name] = c, c;
        } else {
            let a = this.inputs.uniforms, l = a.list.length, c = new ym({
                type: e,
                name: i || "nodeU" + l + (o ? "_" + o : ""),
                node: r,
                needsUpdate: s
            });
            return a.list.push(c), a[t].push(c), a[t][c.name] = c, this.uniforms[c.name] = c, c;
        }
    }
    createVertexUniform(t, e, r, i, s) {
        return this.createUniform("vertex", t, e, r, i, s);
    }
    createFragmentUniform(t, e, r, i, s) {
        return this.createUniform("fragment", t, e, r, i, s);
    }
    include(t, e, r) {
        let i;
        if (t = typeof t == "string" ? _i.get(t) : t, this.context.include === !1) return t.name;
        t instanceof Ae ? i = this.includes.functions : t instanceof kt ? i = this.includes.consts : t instanceof Ld && (i = this.includes.structs);
        let s = i[this.shader] = i[this.shader] || [];
        if (t) {
            let o = s[t.name];
            if (o || (o = s[t.name] = {
                node: t,
                deps: []
            }, s.push(o), o.src = t.build(this, "source")), t instanceof Ae && e && s[e.name] && s[e.name].deps.indexOf(t) === -1 && (s[e.name].deps.push(t), t.includes?.length)) {
                let a = 0;
                do this.include(t.includes[a++], e);
                while (a < t.includes.length);
            }
            return r && (o.src = r), t.name;
        } else throw new Error("Include not found.");
    }
    colorToVectorProperties(t) {
        return t.replace("r", "x").replace("g", "y").replace("b", "z").replace("a", "w");
    }
    colorToVector(t) {
        return t.replace(/c/g, "v3");
    }
    getIncludes(t, e) {
        return this.includes[t][e || this.shader];
    }
    getConstructorFromLength(t) {
        return XY[t - 1];
    }
    isTypeMatrix(t) {
        return /^m/.test(t);
    }
    getTypeLength(t) {
        return t === "f" ? 1 : parseInt(this.colorToVector(t).substr(1));
    }
    getTypeFromLength(t) {
        return t === 1 ? "f" : "v" + t;
    }
    findNode(...t) {
        for(let e = 0; e < arguments.length; e++){
            let r = t[e];
            if (r?.isNode) return r;
        }
    }
    resolve(...t) {
        for(let e = 0; e < arguments.length; e++){
            let r = t[e];
            if (r !== void 0) {
                if (r.isNode) return r;
                if (r.isTexture) switch(r.mapping){
                    case $a:
                    case el:
                        return new W0(r);
                    case $u:
                        return new H0(new bn(r));
                    default:
                        return new bn(r);
                }
                else {
                    if (r.isVector2) return new Hr(r);
                    if (r.isVector3) return new Xi(r);
                    if (r.isVector4) return new Ln(r);
                }
            }
        }
    }
    format(t, e, r) {
        switch(this.colorToVector(r + " <- " + e)){
            case "f <- v2":
                return t + ".x";
            case "f <- v3":
                return t + ".x";
            case "f <- v4":
                return t + ".x";
            case "f <- i":
            case "f <- b":
                return "float( " + t + " )";
            case "v2 <- f":
                return "vec2( " + t + " )";
            case "v2 <- v3":
                return t + ".xy";
            case "v2 <- v4":
                return t + ".xy";
            case "v2 <- i":
            case "v2 <- b":
                return "vec2( float( " + t + " ) )";
            case "v3 <- f":
                return "vec3( " + t + " )";
            case "v3 <- v2":
                return "vec3( " + t + ", 0.0 )";
            case "v3 <- v4":
                return t + ".xyz";
            case "v3 <- i":
            case "v3 <- b":
                return "vec2( float( " + t + " ) )";
            case "v4 <- f":
                return "vec4( " + t + " )";
            case "v4 <- v2":
                return "vec4( " + t + ", 0.0, 1.0 )";
            case "v4 <- v3":
                return "vec4( " + t + ", 1.0 )";
            case "v4 <- i":
            case "v4 <- b":
                return "vec4( float( " + t + " ) )";
            case "i <- f":
            case "i <- b":
                return "int( " + t + " )";
            case "i <- v2":
                return "int( " + t + ".x )";
            case "i <- v3":
                return "int( " + t + ".x )";
            case "i <- v4":
                return "int( " + t + ".x )";
            case "b <- f":
                return "( " + t + " != 0.0 )";
            case "b <- v2":
                return "( " + t + " != vec2( 0.0 ) )";
            case "b <- v3":
                return "( " + t + " != vec3( 0.0 ) )";
            case "b <- v4":
                return "( " + t + " != vec4( 0.0 ) )";
            case "b <- i":
                return "( " + t + " != 0 )";
        }
        return t;
    }
    getTypeByFormat(t) {
        return KY[t] || t;
    }
    getFormatByType(t) {
        return QY[t] || t;
    }
    getUUID(t, e) {
        return e = e !== void 0 ? e : !0, e && this.cache && (t = this.cache + "-" + t), t;
    }
    getElementByIndex(t) {
        return SR[t];
    }
    getIndexByElement(t) {
        return SR.indexOf(t);
    }
    isShader(t) {
        return this.shader === t;
    }
    setShader(t) {
        return this.shader = t, this;
    }
    mergeDefines(t) {
        for(let e in t)this.defines[e] = t[e];
        return this.defines;
    }
    mergeUniform(t) {
        for(let e in t)this.uniforms[e] = t[e];
        return this.uniforms;
    }
    getTextureEncodingFromMap(t) {
        let e;
        return t ? t.isTexture && (e = t.encoding) : e = mn, e === mn && this.context.gamma && (e = at), e;
    }
};
var tr = class extends ar {
    constructor(e = 0, r, i, s){
        super("c");
        this.nodeType = "Color";
        this.value = e instanceof vr ? e : new vr(e || 0, r, i, s);
    }
    setRGBA(e) {
        this.value.setRGBA(e.r, e.g, e.b, e.a);
    }
    generate(e, r, i, s, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s = s ?? this.getType(e);
        let l = e.getNodeData(i), c = this.getReadonly() && this.generateReadonly !== void 0;
        if (this.alpha) {
            let u = this.alpha.build(e, "f");
            e.addFragmentNodeCode(`accumAlpha += ( 1.0 - accumAlpha ) * ${u};`);
        }
        return c ? this.generateReadonly(e, r, i, s, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s, this, o, a, this.getLabel())), e.format(l.vertex.name, s, r)) : (l.fragment || (l.fragment = e.createFragmentUniform(s, this, o, a, this.getLabel())), e.format(l.fragment.name, s, r));
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec3(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ")", s, r);
    }
};
var Dt = class extends ar {
    constructor(e){
        super("i");
        this.nodeType = "Int";
        this.value = Math.floor(e ?? 0);
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format(this.value.toString(), s, r);
    }
};
var Qr = class extends ar {
    constructor(e){
        super("b");
        this.nodeType = "Bool";
        this.value = e ?? !1;
    }
    generateReadonly(e, r, i, s) {
        return e.format(this.value ? "true" : "false", s, r);
    }
};
var Xs = class extends ar {
    constructor(e = 1, r){
        super("f[]");
        this.nodeType = "FloatArray";
        this.size = e, this.value = Array.isArray(r) ? r : typeof r == "number" ? new Array(e).fill(r) : new Array(e).fill(0);
    }
};
var Vl = class extends ar {
};
var q0 = class extends Vl {
    constructor(e){
        super("v3");
        this.image = e;
        this._value = new E;
    }
    get value() {
        return this._value.x = this.image.isVideo ? this.image.img.videoWidth ?? 0 : this.image.img.width, this._value.y = this.image.isVideo ? this.image.img.videoHeight ?? 0 : this.image.img.height, this._value;
    }
};
var qc = class extends Vl {
    constructor(e, r, i = 1008, s = 1006){
        super("t");
        this.image = e;
        this.wrap = r;
        this.minFilter = i;
        this.magFilter = s;
    }
    get value() {
        return this.image.getTexture(this.wrap, this.minFilter, this.magFilter);
    }
};
var kd = class extends ar {
    constructor(e){
        super("m3");
        this.nodeType = "Matrix3";
        this.value = e ?? new fr;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("mat3(" + this.value.elements.join(", ") + ")", s, r);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
var Ki = class extends ar {
    constructor(e){
        super("m4");
        this.nodeType = "Matrix4";
        this.value = e ?? new ue;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("mat4(" + this.value.elements.join(", ") + ")", s, r);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
function wR(n1, t, e, r = 0) {
    n1.setUvTransform(e[0], e[1], t[0], t[1], 0, 0, 0).premultiply(new fr().makeRotation(r * we.DEG2RAD));
}
var Y0 = class extends kd {
    constructor(e, r, i = 0){
        super(new fr);
        this.repeat = e;
        this.offset = r;
        this.rotation = i;
        wR(this.value, e, r, i);
    }
    updateMatrix() {
        wR(this.value, this.repeat, this.offset, this.rotation);
    }
};
var Ks = class extends ar {
    constructor(e = 1, r){
        super("v4[]");
        this.nodeType = "Vector4Array";
        this.size = e, this.value = Array.isArray(r) ? r : r instanceof Ze ? new Array(e).fill(r) : new Array(e).fill(new Ze(0));
    }
};
var Ud = class extends tt {
    constructor(e, r, i, s){
        super("v3");
        this.nodeType = "Blend";
        this.a = e, this.b = r, this.alpha = i, this.mode = s;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = [];
            return i.push(this.a.build(e, "c")), i.push(this.b.build(e, "c")), i.push(this.alpha.build(e, "f")), i.push(this.mode.build(e, "i")), e.format("spe_blend(" + i.join(",") + ")", this.getType(e), r);
        } else return console.warn("BlendNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
};
var rE = class extends tt {
    constructor(e, r){
        super("v3");
        this.nodeType = "CustomColor";
        this.color = e, this.alpha = r, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = e.include(rE.Nodes.customColor);
            e.addFragmentVariable(this.calpha, "float");
            let s = [];
            return s.push(this.color.build(e, "v3")), s.push(this.mask ? `luminance(${this.mask.build(e, "v3")})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("CustomColorNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Yc = rE;
Yc.Nodes = function() {
    return {
        customColor: new Ae(`vec3 customColor(vec3 color, float mask, float alpha, out float calpha) {
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color;
			}`)
    };
}();
var iE = class extends tt {
    constructor(e, r){
        super("v3");
        this.nodeType = "CustomNormal";
        this.cnormal = e, this.alpha = r, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = e.include(iE.Nodes.customNormal);
            e.addFragmentVariable(this.calpha, "float");
            let s = [];
            return s.push(this.cnormal.build(e, "v3")), s.push("normal"), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("CustomNormalNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, zd = iE;
zd.Nodes = function() {
    return {
        customNormal: new Ae(`vec3 customNormal(vec3 cnormal, vec3 norm, float mask, float alpha, out float calpha) {
				vec3 normal = packNormalToRGB( norm ).rgb;
				normal *= step( vec3(0.5), cnormal );

				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * lalpha;

				return normal;
			}`)
    };
}();
var Gd = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h, d, f){
        super("v3");
        this.nodeType = "CustomTexture";
        this.texture = e, this.textureSize = r, this.crop = i, this.projection = s, this.axis = o, this.side = a, this.size = l, this.blending = c, this.mat = u, this.isMask = f, this.alpha = h, this.mode = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        e.require("position"), e.require("normal"), e.require("uv"), e.requires.uv = [
            !0
        ], e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0;
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s;
        switch(this.projection.value){
            case 3:
                s = e.include(Gd.Nodes.cylindrical);
                break;
            case 2:
                s = e.include(Gd.Nodes.spherical);
                break;
            case 1:
                let a = [
                    "vec3(1.0, 0.0, 0.0)",
                    "vec3(0.0, 1.0, 0.0)",
                    "vec3(0.0, 0.0, 1.0)"
                ][this.axis.value], l = [
                    "zy",
                    "xz",
                    "xy"
                ][this.axis.value], c = new Ae(`
		vec3 ${i}_planarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
				vec2 projected = (1. + (position.${l})) / 2.;
				vec2 uvs = ( mat * vec3( (projected * 2. - 1.) / (size * .5), 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				${this.side.value === 2 ? "" : `lalpha *= step(0.0, ${this.side.value === 1 ? "-1.0 * " : ""}dot(vObjectNormal, ${a}));`}

				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`);
                s = e.include(c);
                break;
            case 4:
                s = e.include(Gd.Nodes.triplanar);
                break;
            default:
                s = e.include(Gd.Nodes.uv);
                break;
        }
        e.addFragmentVariable(this.calpha, "float");
        let o = [];
        if (o.push("normal"), o.push(this.texture.generate(e, "t")), o.push(this.textureSize.build(e, "v2")), o.push(this.crop.build(e, "f")), o.push(this.mat.build(e, "mat3")), o.push(this.size.build(e, "v2")), o.push(this.blending.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), this.projection.value === 4) {
            let a = `${i}_writeUvs`, l = a + "0", c = a + "1", u = a + "2", h = `${i}_triplanarWeights`;
            e.addFragmentVariable(l, "vec2"), e.addFragmentVariable(c, "vec2"), e.addFragmentVariable(u, "vec2"), e.addFragmentVariable(h, "vec3"), o.push(l), o.push(c), o.push(u), o.push(h);
        } else {
            let a = `${i}_writeUvs`;
            e.addFragmentVariable(a, "vec2"), o.push(a);
        }
        return e.format(s + "(" + o.join(",") + ")", this.getType(e), r);
    }
}, kl = Gd;
kl.Nodes = function() {
    let e = new Ae(`
vec3 cylindricalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
                vec3 posN = normalize(position);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float scaledHeight = position.y / (size.y * 0.5);
                float v =  (scaledHeight / 2.) + .5;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;

				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), r = new Ae(`
vec3 sphericalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
                vec3 posN = normalize(vPosition);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float v = 0.5 + asin(posN.y) / 3.1415;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;
				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), i = new Ae(`vec3 uvTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
				vec2 uvs = ( mat * vec3( vUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;

				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`), s = new Ae(`vec3 triplanarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUvs0, out vec2 writeUvs1, out vec2 writeUvs2, out vec3 writeWeights) {
				vec3 p = position;
				vec2 uv0 = (1.0 + p.xy) / 2.0;     
				vec2 uv1 = (1.0 + p.zy) / 2.0;		
				vec2 uv2 = (1.0 + p.xz) / 2.0;		
	
				uv0 = (mat * vec3((uv0 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv1 = (mat * vec3((uv1 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv2 = (mat * vec3((uv2 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;

				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));

				// Write out all sets of UVs that we generated
				writeUvs0 = uv0;
				writeUvs1 = uv1;
				writeUvs2 = uv2;
				writeWeights = weights;

				// Derivatives for LOD
				vec2 df0 = fwidth(uv0);
				vec2 df1 = fwidth(uv1);
				vec2 df2 = fwidth(uv2);
				if (df0.x > 0.5) df0.x = 0.0;
				if (df1.x > 0.5) df1.x = 0.0;
				if (df2.x > 0.5) df2.x = 0.0;

				#ifdef GL_EXT_shader_texture_lod
                	vec4 tmp = 
						texture2DLodEXT(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						texture2DLodEXT(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						texture2DLodEXT(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#else
                	vec4 tmp = 
						textureLod(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						textureLod(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						textureLod(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;

				// Apply cropping across all 3 planes
				if ( crop > 0.5 ) {
					if ( uv0.x < 0.0 || uv0.x > 1.0 || uv0.y < 0.0 || uv0.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv1.x < 0.0 || uv1.x > 1.0 || uv1.y < 0.0 || uv1.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv2.x < 0.0 || uv2.x > 1.0 || uv2.y < 0.0 || uv2.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;//n * 0.5 + 0.5;
			}			
			`);
    return {
        cylindrical: e,
        spherical: r,
        uv: i,
        triplanar: s
    };
}();
var jd = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h, d, f){
        super("v3");
        this.nodeType = "Depth";
        this.gradientType = e, this.smooth = r, this.near = i, this.far = s, this.isVector = o, this.isWorldSpace = a, this.origin = l, this.direction = c, this.colors = u, this.steps = h, this.isMask = f, this.alpha = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s = new Ae(`vec3 ${i}_sdepth(float near, float far, vec3 origin, vec3 direction, vec4 colors[${i}_MAX_COLORS], float steps[${i}_MAX_COLORS], bool isMask, float mask, float alpha, out float calpha) {
               vec4 color = colors[0];
               #ifdef ${i}_IS_VECTOR
                   #ifdef ${i}_LINEAR
                       #ifdef ${i}_WORLDSPACE
                       float depth = vectorLinearWorldSpaceDepth(direction, origin, near, far);
                       #else
                       float depth = vectorLinearObjectSpaceDepth(direction, origin, near, far);
                       #endif
                   #else
                       #ifdef ${i}_WORLDSPACE
                           float depth = vectorSphericalWorldSpaceDepth(origin, near, far);
                       #else
                           float depth = vectorSphericalObjectSpaceDepth(origin, near, far);
                       #endif
                   #endif
               #else
                   float dist = length(vWPosition - cameraPosition);
			       float depth = ( dist - near ) / ( far - near );
               #endif


              float p;
              #ifdef ${i}_SMOOTH
				for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
						p = clamp( ( depth - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}
              #else
                for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
                   p = clamp(( depth - steps[i - 1] ) / ( steps[i] - steps[i - 1] ), 0.0, 1.0);
                   color = mix(color, colors[i], p);
                 }
              #endif

               float lalpha = alpha * color.a * mask;
               calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
			   accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
			   
               return color.rgb;
			}`, [
            jd.Nodes.vectorLinearWorldSpaceDepth,
            jd.Nodes.vectorLinearObjectSpaceDepth,
            jd.Nodes.vectorSphericalObjectSpaceDepth,
            jd.Nodes.vectorSphericalWorldSpaceDepth
        ]);
        if (e.isShader("fragment")) {
            e.define(`${i}_MAX_COLORS`, this.colors.value.length), this.smooth.value && e.define(`${i}_SMOOTH`), this.isVector.value > .5 && e.define(`${i}_IS_VECTOR`), this.gradientType.value === 0 && e.define(`${i}_LINEAR`), this.isWorldSpace.value > .5 && e.define(`${i}_WORLDSPACE`), e.require("worldPosition"), e.addFragmentVariable(this.calpha, "float");
            let o = e.include(s), a = [];
            return a.push(this.near.build(e, "f")), a.push(this.far.build(e, "f")), a.push(this.origin.build(e, "v3")), a.push(this.direction.build(e, "v3")), a.push(this.colors.build(e, "v4[]")), a.push(this.steps.build(e, "f[]")), a.push(this.isMask.build(e, "b")), a.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), a.push(this.alpha.build(e, "f")), a.push(this.calpha), e.format(o + "(" + a.join(",") + ")", this.getType(e), r);
        } else return console.warn("DepthNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Hd = jd;
Hd.Nodes = function() {
    let e = new Ae(`float vectorLinearWorldSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(vWPosition.x - origin.x) + n.y*(vWPosition.y - origin.y) + n.z*(vWPosition.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), r = new Ae(`float vectorLinearObjectSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(position.x - origin.x) + n.y*(position.y - origin.y) + n.z*(position.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), i = new Ae(`float vectorSphericalWorldSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(vWPosition - origin);
               return ( dist - near ) / ( far - near );
            }`), s = new Ae(`float vectorSphericalObjectSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(position - origin);
               return ( dist - near ) / ( far - near );
            }`);
    return {
        vectorLinearWorldSpaceDepth: e,
        vectorLinearObjectSpaceDepth: r,
        vectorSphericalWorldSpaceDepth: i,
        vectorSphericalObjectSpaceDepth: s
    };
}();
var xm = class extends tt {
    constructor(e, r, i, s, o, a, l, c){
        super("v3");
        this.nodeType = "Fresnel";
        this.color = e, this.bias = r, this.scale = i, this.intensity = s, this.factor = o, this.isMask = c, this.alpha = a, this.mode = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = new Ae(`vec3 fresnel(vec3 color, float bias, float scale, float intensity, float factor, bool isMask, float mask, float alpha, int mode, out float calpha) {
					float fresnel = bias + scale * pow( abs( factor + dot( normalize( vWorldViewDir ), normalize( vWNormal ) ) ), intensity );

					float lalpha = clamp(fresnel, 0.0, 1.0) * alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return color;
				}`), s = e.include(i), o = [];
            return o.push(this.color.build(e, "c")), o.push(this.bias.build(e, "f")), o.push(this.scale.build(e, "f")), o.push(this.intensity.build(e, "f")), o.push(this.factor.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), e.format(s + "(" + o.join(",") + ")", this.getType(e), r);
        } else return console.warn("FresnelNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
};
var nE = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u){
        super("v3");
        this.nodeType = "Gradient";
        this.gradientType = e, this.smooth = r, this.colors = i, this.steps = s, this.offset = o, this.morph = a, this.angle = l, this.isMask = u, this.alpha = c, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.define("GRAD_MAX", 10), e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(nE.Nodes.gradient), s = [];
            return s.push(this.gradientType.build(e, "i")), s.push(this.smooth.build(e, "b")), s.push(this.colors.build(e, "v4[]")), s.push(this.steps.build(e, "f[]")), s.push(this.offset.build(e, "v2")), s.push(this.morph.build(e, "v2")), s.push(this.angle.build(e, "f")), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("GradientNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Wd = nE;
Wd.Nodes = function() {
    return {
        gradient: new Ae(`vec3 gradient(int gradientType, bool smoothed, vec4 colors[GRAD_MAX], float steps[GRAD_MAX], vec2 offset, vec2 morph, float angle, bool isMask, float mask, float alpha, out float calpha) {
				vec4 color = colors[0];
				vec2 m = morph / vUv.xy;
				vec2 rot = vec2( 0.5 + m.x, m.y );
				vec2 dt = vec2(
					cos( angle ) * rot.x - sin( angle ) * rot.y,
					sin( angle ) * rot.x + cos( angle ) * rot.y
				);
				vec2 pt = ( vUv - 0.5 + offset ) / 2.0 + dt / 2.0;
				float t = dot( pt, dt ) / dot( dt, dt );
				if ( gradientType == 1 ) {
					t = distance (
						( vUv + morph ) * 3.0,
						( vUv + offset ) + 1.0
					) + angle;
				} else if ( gradientType == 2 ) {
					float polar = atan(
						vUv.x + morph.x - 0.5 + offset.x,
						vUv.y + morph.y - 0.5 + offset.y
					) * -1.0;
					t = fract( ( angle / PI / -2.0 ) + 0.5 * ( polar / PI ) );
				}

				float p;
				if (smoothed) {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}

				} else {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], p);
					}
				}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
				
				return color.xyz;
			}`)
    };
}();
var sE = class extends tt {
    constructor(e, r, i, s, o){
        super("v3");
        this.nodeType = "Matcap";
        this.texture = e, this.isMask = s, this.alpha = r, this.mode = i, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`, this.rotation = o;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = e.include(sE.Nodes.matcap);
            e.require("normal"), e.requires.normal = !0;
            let s = [];
            return s.push(this.texture.generate(e, "t")), s.push("normal"), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.mode.build(e, "i")), s.push(this.calpha), s.push(this.rotation.build(e, "f")), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("MatcapNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, qd = sE;
qd.Nodes = function() {
    return {
        matcap: new Ae(`vec3 matcap(sampler2D matcapTex, vec3 normal, bool isMask, float mask, float alpha, int mode, out float calpha, float rotation) {
					vec3 viewDir = normalize( vViewPosition );
					vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
					vec3 y = cross( viewDir, x );
					vec2 uv = vec2( dot( x, normal ), dot( y, normal ) );
					uv = mat2( cos(rotation), sin(rotation), -sin(rotation), cos(rotation) ) * uv;
					uv = uv * 0.495 + 0.5;
					vec4 matcapColor = texture2D( matcapTex, uv );

					float lalpha = alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
					
					return matcapColor.rgb;
            	}`)
    };
}();
var zi = function() {
    let t = new Ae(`vec3 random3(vec3 c) {
			float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));
			vec3 r;
			r.z = fract(512.0*j);
			j *= .125;
			r.x = fract(512.0*j);
			j *= .125;
			r.y = fract(512.0*j);
			return r-0.5;
		}`), e = new Ae(`float simplexFast(vec3 p) {
			 vec3 s = floor(p + dot(p, vec3(F3)));
			 mediump vec3 x = p - s + dot(s, vec3(G3));
			 mediump vec3 hs = s;
			 
			 mediump vec3 e = step(vec3(0.0), x - x.yzx);
			 mediump vec3 i1 = e*(1.0 - e.zxy);
			 mediump vec3 i2 = 1.0 - e.zxy*(1.0 - e);
				
			 mediump vec3 x1 = x - i1 + G3;
			 mediump vec3 x2 = x - i2 + 2.0*G3;
			 mediump vec3 x3 = x - 1.0 + 3.0*G3;
			 
			 mediump vec4 w, d;
			 
			 w.x = dot(x, x);
			 w.y = dot(x1, x1);
			 w.z = dot(x2, x2);
			 w.w = dot(x3, x3);
			 
			 w = max(0.6 - w, 0.0);
			 
			 d.x = dot(random3(hs), x);
			 d.y = dot(random3(hs + i1), x1);
			 d.z = dot(random3(hs + i2), x2);
			 d.w = dot(random3(hs + 1.0), x3);
			 
			 w *= w;
			 w *= w;
			 d *= w;
			 
			 return dot(d, vec4(52.0));
		}`, [
        t
    ]);
    e.keywords.F3 = new kt("float F3 0.3333333"), e.keywords.G3 = new kt("float G3 0.1666667");
    let r = new Ae(`float simplexPrecise(vec3 p) {
			 vec3 s = floor(p + dot(p, vec3(F3)));
			 vec3 x = p - s + dot(s, vec3(G3));
			 
			 vec3 e = step(vec3(0.0), x - x.yzx);
			 vec3 i1 = e*(1.0 - e.zxy);
			 vec3 i2 = 1.0 - e.zxy*(1.0 - e);
				
			 vec3 x1 = x - i1 + G3;
			 vec3 x2 = x - i2 + 2.0*G3;
			 vec3 x3 = x - 1.0 + 3.0*G3;
			 
			 vec4 w, d;
			 
			 w.x = dot(x, x);
			 w.y = dot(x1, x1);
			 w.z = dot(x2, x2);
			 w.w = dot(x3, x3);
			 
			 w = max(0.6 - w, 0.0);
			 
			 d.x = dot(random3(s), x);
			 d.y = dot(random3(s + i1), x1);
			 d.z = dot(random3(s + i2), x2);
			 d.w = dot(random3(s + 1.0), x3);
			 
			 w *= w;
			 w *= w;
			 d *= w;
			 
			 return dot(d, vec4(52.0));
		}`, [
        t
    ]);
    r.keywords.F3 = new kt("float F3 0.3333333"), r.keywords.G3 = new kt("float G3 0.1666667");
    let i = new Ae(`float simplexFractal(vec3 m) {
			mat3 rot1 = mat3(-0.37, 0.36, 0.85,-0.14,-0.93, 0.34,0.92, 0.01,0.4);
			mat3 rot2 = mat3(-0.55,-0.39, 0.74, 0.33,-0.91,-0.24,0.77, 0.12,0.63);
			mat3 rot3 = mat3(-0.71, 0.52,-0.47,-0.08,-0.72,-0.68,-0.7,-0.45,0.56);
			return 0.5333333 * simplexFast(m * rot1)
				 + 0.2666667 * simplexFast(2.0 * m * rot2)
				 + 0.1333333 * simplexFast(4.0 * m * rot3)
				 + 0.0666667 * simplexFast(8.0 * m);
		}`, [
        e
    ]), s = new Ae("vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}"), o = new Ae("vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}"), a = new Ae(`float simplexAshima(vec3 v) {
		  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
		  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
		  vec3 i  = floor(v + dot(v, C.yyy) );
		  vec3 x0 =   v - i + dot(i, C.xxx) ;
		  vec3 g = step(x0.yzx, x0.xyz);
		  vec3 l = 1.0 - g;
		  vec3 i1 = min( g.xyz, l.zxy );
		  vec3 i2 = max( g.xyz, l.zxy );
		  vec3 x1 = x0 - i1 + 1.0 * C.xxx;
		  vec3 x2 = x0 - i2 + 2.0 * C.xxx;
		  vec3 x3 = x0 - 1. + 3.0 * C.xxx;
		  i = mod(i, 289.0 ); 
		  vec4 p = permute( permute( permute( 
					 i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
				   + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
				   + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
		  float n_ = 1.0/7.0; // N=7
		  vec3  ns = n_ * D.wyz - D.xzx;
		  vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)
		  vec4 x_ = floor(j * ns.z);
		  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
		  vec4 x = x_ *ns.x + ns.yyyy;
		  vec4 y = y_ *ns.x + ns.yyyy;
		  vec4 h = 1.0 - abs(x) - abs(y);
		  vec4 b0 = vec4( x.xy, y.xy );
		  vec4 b1 = vec4( x.zw, y.zw );
		  vec4 s0 = floor(b0)*2.0 + 1.0;
		  vec4 s1 = floor(b1)*2.0 + 1.0;
		  vec4 sh = -step(h, vec4(0.0));
		  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
		  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
		  vec3 p0 = vec3(a0.xy,h.x);
		  vec3 p1 = vec3(a0.zw,h.y);
		  vec3 p2 = vec3(a1.xy,h.z);
		  vec3 p3 = vec3(a1.zw,h.w);
		  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
		  p0 *= norm.x;
		  p1 *= norm.y;
		  p2 *= norm.z;
		  p3 *= norm.w;
		  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
		  m = m * m;
		  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
										dot(p2,x2), dot(p3,x3) ) );
		}`, [
        s,
        o
    ]), l = new Ae("vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}"), c = new Ae("vec4 perm(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}", [
        l
    ]), u = new Ae(`float noise(vec3 p){
			vec3 a = floor(p);
			vec3 d = p - a;
			d = d * d * (3.0 - 2.0 * d);
			vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
			vec4 k1 = perm(b.xyxy);
			vec4 k2 = perm(k1.xyxy + b.zzww);
			vec4 c = k2 + a.zzzz;
			vec4 k3 = perm(c);
			vec4 k4 = perm(c + 1.0);
			vec4 o1 = fract(k3 * (1.0 / 41.0));
			vec4 o2 = fract(k4 * (1.0 / 41.0));
			vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
			vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);
			return o4.y * d.y + o4.x * (1.0 - d.y);
		}`, [
        c
    ]), h = new Ae(`float fbm(vec3 x) {
			float v = 0.0;
			float a = 0.5;
			vec3 shift = vec3(100);
			for (int i = 0; i < NUM_OCTAVES; ++i) {
				v += a * noise(x);
				x = x * 2.0 + shift;
				a *= 0.5;
			}
			return v;
		}`, [
        u
    ]);
    h.keywords.NUM_OCTAVES = new kt(`int NUM_OCTAVES ${5}`);
    let d = new Ae("vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}"), f = new Ae(`float perlin(vec3 P){
		  vec3 Pi0 = floor(P);
		  vec3 Pi1 = Pi0 + vec3(1.0);
		  Pi0 = mod(Pi0, 289.0);
		  Pi1 = mod(Pi1, 289.0);
		  vec3 Pf0 = fract(P);
		  vec3 Pf1 = Pf0 - vec3(1.0);
		  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
		  vec4 iy = vec4(Pi0.yy, Pi1.yy);
		  vec4 iz0 = Pi0.zzzz;
		  vec4 iz1 = Pi1.zzzz;
		  vec4 ixy = permute(permute(ix) + iy);
		  vec4 ixy0 = permute(ixy + iz0);
		  vec4 ixy1 = permute(ixy + iz1);
		  vec4 gx0 = ixy0 / 7.0;
		  vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
		  gx0 = fract(gx0);
		  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
		  vec4 sz0 = step(gz0, vec4(0.0));
		  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
		  gy0 -= sz0 * (step(0.0, gy0) - 0.5);
		  vec4 gx1 = ixy1 / 7.0;
		  vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
		  gx1 = fract(gx1);
		  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
		  vec4 sz1 = step(gz1, vec4(0.0));
		  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
		  gy1 -= sz1 * (step(0.0, gy1) - 0.5);
		  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
		  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
		  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
		  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
		  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
		  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
		  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
		  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);
		  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
		  g000 *= norm0.x;
		  g010 *= norm0.y;
		  g100 *= norm0.z;
		  g110 *= norm0.w;
		  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
		  g001 *= norm1.x;
		  g011 *= norm1.y;
		  g101 *= norm1.z;
		  g111 *= norm1.w;
		  float n000 = dot(g000, Pf0);
		  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
		  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
		  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
		  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
		  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
		  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
		  float n111 = dot(g111, Pf1);
		  vec3 fade_xyz = fade(Pf0);
		  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
		  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
		  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
		  return 2.2 * n_xyz;
		}`, [
        s,
        o,
        d
    ]), p = new Ae(`float hashwithoutsine13(vec3 p3)
		{
			p3  = fract(p3 * .1031);
			p3 += dot(p3, p3.yzx + 33.33);
			return fract((p3.x + p3.y) * p3.z);
		}`), m = new Ae(`vec3 hashwithoutsine33(vec3 p3)
		{
			p3 = fract(p3 * vec3(.1031, .1030, .0973));
			p3 += dot(p3, p3.yxz+33.33);
			return fract((p3.xxy + p3.yxx)*p3.zyx);
		}`), g = new Ae(`float metric(in vec3 p)
		{
			// L2 
			return length(p);

			// Chebyshev 
			// vec3 a = abs(p);
			// return max(a.x, max(a.y, a.z));
		}`), y = new Ae(`float smin( float a, float b, float k )
		{
			float h = smoothstep(0.0, 1.0, 0.5 + 0.5 * (b - a) / k);
			float correction = k * h * (1.0 - h);
			return mix(b, a, h) - correction;
		}`), x = new Ae(`float smax( float a, float b, float k )
		{
			float h = smoothstep(1.0, 0.0, 0.5 + 0.5 * (a - b) / k);
			float correction = k * h * (1.0 - h);
			return mix(a, b, h) + correction;
		}`), v = new Ae(`float remap(float value, float input_min, float input_max, float output_min, float output_max) {
			// Compute width of each interval
			float input_width = input_max - input_min;
			float output_width = output_max - output_min;
		
			// Convert input range into a 0-1 range 
			float scaled = (value - input_min) / input_width;
		
			// Convert the 0-1 range into a value in output range
			return output_min + (scaled * output_width);
		}`), S = new Ae(`float voronoi(in vec3 x, in int style, in float smoothness, in float seed, in int quality) 
		{
			// Integer and fractional parts of this point's coordinates
			ivec3 p = ivec3(floor(x));
			vec3 f = fract(x);

			// Different variables that we will use to construct noise:
			//
			// f1: distance to the closest feature point
			// f2: distance to the second closest feature point
			// e: distance to the closest edge (cell boundary)
			//
			// We also compute "smooth" versions of all of the above quantites, essentially
			// replacing "hard" minimums with "smooth" minimums (described by IQ)
			float f1_smooth = 8.0;
			float f1 = 8.0;
			float f2_smooth = 8.0;
			float f2 = 8.0;
			float e_smooth = 8.0;
			float e = 8.0;

			// Variables stored from closest cell
			ivec3 mb;
			vec3 mr; 

			int steps = quality;
			
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				ivec3 b = ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d = length(r);
				
				f1_smooth = smin(d, f1_smooth, smoothness);

				// Store un-smoothed distances too 
				if (d < f1) 
				{
					f2 = f1;
					f1 = d;

					mb = ivec3(x, y, z);
					mr = r;
				} 
				else if (d < f2) 
				{
					f2 = d;
				}
			}	
			
			// Second pass for edge distance  
			// skip for styles don't need
			if (style != 0 &&  style != 5 && style != 7)
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				// Start search at the cell that contains the closest point to "x" (found in 1st pass)
				ivec3 b = mb + ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d1 = dot(0.5 * (mr + r), (r - mr)); 				// IQ normalizes "r - mr" but that breaks things for the smooth version?
				float d2 = dot(0.5 * (mr + r), normalize(r - mr));

				e_smooth = smin(d1, e_smooth, smoothness);

				e = min(e, d2);

				// Also compute a smooth version of F2 in this pass
				{
					ivec3 b = ivec3(x, y, z);
					if (b != mb) 
					{
						vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
						float d = length(r);

						f2_smooth = smin(d, f2_smooth, smoothness);
					}
				}
			}

			// Different visualization modes 
			if (style == 0) 
			{
				return f1_smooth;
			}
			if (style == 1) 
			{
				return f2_smooth;
			}
			if (style == 2) 
			{
				return f2_smooth - f1_smooth;
				
				// "Pebbles" also cool
				//return step(0.2, f2_smooth - f1_smooth);
			}
			if (style == 3) 
			{
				// This one is really good for rock / stone effects
				float a = f1; 
				float b = f2;
				float k = 3.0;
				float h = max(k - abs(a - b), 0.0) / k;
				float final = min(a, b) - h * h * k * (1.0 / 4.0);
				return final;
			}
			if (style == 4) 
			{
				// Some random adjustments to make this style stand out more 
				return exp(5.0 * e_smooth);
			}
			if (style == 5) 
			{
				return pow(f1_smooth, 3.0);
			}
			if (style == 6) 
			{				
				const float eps = 0.0125;

				// Thicker lines as the user increases the smoothness slider
				float thickness = smoothness * 0.25 + eps;

				// Blurrier lines as the user increases the smoothness slider
				float blur = pow(smoothness, 3.0) * 0.25 + eps;

				return smoothstep(
					thickness - thickness * blur, 
					thickness + thickness * blur, 
					e
				);
			}
			if (style == 7) 
			{
				return hashwithoutsine13(vec3(p + mb) + seed);
			}
		}
	`, [
        p,
        m,
        g,
        y,
        x,
        v
    ]);
    return {
        simplexFast: e,
        simplexPrecise: r,
        simplexFractal: i,
        simplexAshima: a,
        fbm: h,
        perlin: f,
        voronoi: S
    };
}();
var Yd = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h, d, f, p, m, g, y, x, v, S){
        super("v3");
        this.nodeType = "Noise";
        this.scale = e, this.size = r, this.move = i, this.fA = s, this.fB = o, this.distortion = a, this.colorA = l, this.colorB = c, this.colorC = u, this.colorD = h, this.noiseType = f, this.voronoiStyle = m, this.highCut = g, this.lowCut = y, this.smoothness = x, this.seed = v, this.quality = S, this.isMask = p, this.alpha = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r, i, s, o) {
        e.require("uv"), e.requires.uv = [
            !0
        ], e.addFragmentVariable(this.calpha, "float");
        let l = [
            "simplexFast",
            "simplexFractal",
            "simplexAshima",
            "fbm",
            "perlin",
            "voronoi"
        ][this.noiseType.value], c = l == "voronoi" ? `
		float v = ${l}(st + move, voronoiStyle, smoothness, seed, quality);

		// Apply clipping to colors
		v = remap(v, lowCut, highCut, 0.0, 1.0);
		v = smax(v, 0.0, smoothness * 0.25);
		v = smin(v, 1.0, smoothness * 0.25);

		// Note that the voronoi mode only uses colors "A" and "C" from the UI 
		vec4 color = mix(colorA, colorC, v); 
		` : `
		vec3 q = vec3(${l}(st),
					   ${l}(st + vec3(1.0)),
					   ${l}(st + vec3(1.0)));
		vec3 r = vec3(${l}(st + vec3(distortion, 1.0) * q + vec3(fA, 1.0) + move),
					  ${l}(st + vec3(distortion, 1.0) * q + vec3(fB, 1.0) + move), 
					  ${l}(st * q));
		float f = ${l}(st + r);
		vec4 color;
		color = mix(colorA, colorB, clamp((f * f) * 4.0, 0.0, 1.0));
		color = mix(color, colorC, clamp(length(q), 0.0, 1.0));
		color = mix(color, colorD, clamp(length(r.x), 0.0, 1.0));
		`, u = new Ae(`vec3 ${l}customNoise(float scale, vec3 size, float move, vec2 fA, vec2 fB, vec2 distortion, vec4 colorA, vec4 colorB, vec4 colorC, vec4 colorD, int voronoiStyle, float highCut, float lowCut, float smoothness, float seed, int quality, bool isMask, float mask, float alpha, out float calpha) 
			{
                // Prevent scale of zero 
				scale = max(abs(scale), 0.001);

				vec3 st = position / size;
				st /= scale;

				${c}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return clamp(color, 0.0, 1.0).rgb;
			}`, [
            zi.simplexFast,
            zi.simplexFractal,
            zi.simplexAshima,
            zi.fbm,
            zi.perlin,
            zi.voronoi
        ]), h = e.include(u), d = [];
        return d.push(this.scale.build(e, "f")), d.push(this.size.build(e, "v3")), d.push(this.move.build(e, "f")), d.push(this.fA.build(e, "v2")), d.push(this.fB.build(e, "v2")), d.push(this.distortion.build(e, "v2")), d.push(this.colorA.build(e, "v4")), d.push(this.colorB.build(e, "v4")), d.push(this.colorC.build(e, "v4")), d.push(this.colorD.build(e, "v4")), d.push(this.voronoiStyle.build(e, "i")), d.push(this.highCut.build(e, "f")), d.push(this.lowCut.build(e, "f")), d.push(this.smoothness.build(e, "f")), d.push(this.seed.build(e, "f")), d.push(this.quality.build(e, "i")), d.push(this.isMask.build(e, "b")), d.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), d.push(this.alpha.build(e, "f")), d.push(this.calpha), e.format(h + "(" + d.join(",") + ")", this.getType(e), r);
    }
};
Yd.numOctaves = 5;
var oE = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h, d, f, p, m, g, y){
        super("v3");
        this.nodeType = "Outline";
        this.firstTime = !0, this.outlineColor = e, this.contourColor = r, this.outlineWidth = i, this.contourWidth = s, this.contourThreshold = o, this.outlineThreshold = a, this.contourFrequency = l, this.outlineSmoothing = c, this.contourDirection = u, this.positionalLines = h, this.compensation = d, this.resolution = f, this.normalMap = p, this.depthMap = m, this.pixelRatio = g, this.alpha = y, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`;
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.extensions.derivatives = !0, this.compensation.value && e.define("OUTLINE_COMPENSATION", `${i}_offset`), this.firstTime) {
            let s = this.outlineWidth.build(e, "f"), o = this.resolution.build(e, "v2"), a = this.compensation.build(e, "b"), l = this.pixelRatio.build(e, "f");
            e.addVertexParsVariable("randomColor", "attribute vec3"), e.addVertexParsVariable("extrudeNormal", "attribute vec3"), e.addVertexParsVariable(s, "uniform float"), e.addVertexParsVariable(o, "uniform vec2"), e.addVertexParsVariable(a, "uniform bool"), e.addVertexParsVariable(l, "uniform float"), e.addVertexParsVariable("vID", "flat out float"), e.addFragmentParsVariable("vID", "flat in float"), e.addVertexFinalCode(`
                vID = randomColor.r;
                vec2 ${i}_offset = vec2(0.0);
                if (${a}) {
                    vec4 ${i}_clipPosition = projectionMatrix * (modelViewMatrix * vec4(transformed, 1.0));
                    // NOTE: For certain shapes, like spheres, we get incorrect extrusion when the
                    // normals face the camera directly. So we hackily fix this by offsetting the normal
                    // by a tiny amount.
                    vec3 ${i}_clipNormal = mat3(projectionMatrix) * (mat3(modelViewMatrix) * extrudeNormal) + 0.0000001;
                    ${i}_offset = normalize(${i}_clipNormal.xy) / ${o} * (${s} / 2.0) * ${i}_clipPosition.w * 2.0 * ${l};
                    ${i}_clipPosition.xy += ${i}_offset;
                    // TODO(MAX): To handle multiple outline layers, we only want to extrude
                    // if this offset is the biggest of all the potential offsets
                    gl_Position = ${i}_clipPosition;
                }
            `);
        }
        if (e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let s = e.include(oE.Nodes.outline), o = [];
            return o.push(this.outlineColor.build(e, "c")), o.push(this.contourColor.build(e, "c")), o.push(this.outlineWidth.build(e, "f")), o.push(this.contourWidth.build(e, "f")), o.push(this.contourThreshold.build(e, "f")), o.push(this.outlineThreshold.build(e, "f")), o.push(this.contourFrequency.build(e, "f")), o.push(this.outlineSmoothing.build(e, "f")), o.push(this.contourDirection.build(e, "v3")), o.push(this.positionalLines.build(e, "b")), o.push(this.resolution.build(e, "v2")), o.push(this.normalMap.getTexture(e, "t")), o.push(this.depthMap.getTexture(e, "t")), o.push(this.pixelRatio.build(e, "f")), o.push(this.compensation.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.calpha), this.firstTime = !this.firstTime, e.format(s + "(" + o.join(",") + ")", this.getType(e), r);
        } else return console.warn("OutlineNode is not compatible with " + e.shader + " shader."), "";
    }
}, Xd = oE;
Xd.Nodes = function() {
    let e = new Ae(`
float sobelSample(sampler2D t, sampler2D d, vec2 uv, vec2 resolution, float outlineWidth, float pixelRatio)
{
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    vec2 texelSize = (vec2(1.0) / resolution);
    vec2 offsetSize = texelSize * outlineWidth * pixelRatio;

    vec2 uvSamples[9];
    vec4 normalSamples[9];

	uvSamples[0] = uv + vec2( -offsetSize.x, -offsetSize.y) + (vogelDiskSample(0, 9, temporalAngle) * texelSize);
	uvSamples[1] = uv + vec2(0.0, -offsetSize.y) + (vogelDiskSample(1, 9, temporalAngle) * texelSize);
	uvSamples[2] = uv + vec2(  offsetSize.x, -offsetSize.y) + (vogelDiskSample(2, 9, temporalAngle) * texelSize);
	uvSamples[3] = uv + vec2( -offsetSize.x, 0.0) + (vogelDiskSample(3, 9, temporalAngle) * texelSize);
	uvSamples[4] = uv;
	uvSamples[5] = uv + vec2(  offsetSize.x, 0.0) + (vogelDiskSample(5, 9, temporalAngle) * texelSize);
	uvSamples[6] = uv + vec2( -offsetSize.x, offsetSize.y) + (vogelDiskSample(6, 9, temporalAngle) * texelSize);
	uvSamples[7] = uv + vec2(0.0, offsetSize.y) + (vogelDiskSample(7, 9, temporalAngle) * texelSize);
	uvSamples[8] = uv + vec2(  offsetSize.x, offsetSize.y) + (vogelDiskSample(8, 9, temporalAngle) * texelSize);


    normalSamples[0] = texture2D(t, uvSamples[0]);
    normalSamples[1] = texture2D(t, uvSamples[1]);
    normalSamples[2] = texture2D(t, uvSamples[2]);
    normalSamples[3] = texture2D(t, uvSamples[3]);
    normalSamples[4] = texture2D(t, uvSamples[4]);
    normalSamples[5] = texture2D(t, uvSamples[5]);
    normalSamples[6] = texture2D(t, uvSamples[6]);
    normalSamples[7] = texture2D(t, uvSamples[7]);
    normalSamples[8] = texture2D(t, uvSamples[8]);

    float depthBias = 0.0001;
    // TODO(MAX): Can we somehow reduce the number of conditionals here with MATH?!
    if (normalSamples[0].a != vID && normalSamples[0].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[0]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[1].a != vID && normalSamples[1].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[1]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[2].a != vID && normalSamples[2].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[2]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[3].a != vID && normalSamples[3].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[3]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }


    if (normalSamples[4].a != vID && normalSamples[4].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[4]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[5].a != vID && normalSamples[5].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[5]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[6].a != vID && normalSamples[6].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[6]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[7].a != vID && normalSamples[7].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[7]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[8].a != vID && normalSamples[8].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[8]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    vec3 sobel_edge_h = normalSamples[2].rgb + (2.0*normalSamples[5].rgb) + normalSamples[8].rgb - (normalSamples[0].rgb + (2.0*normalSamples[3].rgb) + normalSamples[6].rgb);
  	vec3 sobel_edge_v = normalSamples[0].rgb + (2.0*normalSamples[1].rgb) + normalSamples[2].rgb - (normalSamples[6].rgb + (2.0*normalSamples[7].rgb) + normalSamples[8].rgb);

    float edgeNormal = sqrt(dot(sobel_edge_h, sobel_edge_h) + dot(sobel_edge_v, sobel_edge_v));
    return edgeNormal;
}
`);
    return {
        outline: new Ae(`vec3 outline(vec3 outlineColor, vec3 contourColor, float outlineWidth, float contourWidth, float outlineThreshold, float contourThreshold, float outlineSmoothing, float contourFrequency, vec3 contourDirection, bool positionalLines, vec2 resolution, sampler2D normalMap, sampler2D depthMap, float pixelRatio, bool compensation, float mask, float alpha, out float calpha) {
                vec3 result = outlineColor;
                float resultAlpha = 0.0;

                vec3 N = normalize(vWNormal);
                vec2 nuv = (gl_FragCoord.xy / resolution);
                float sobelSample = compensation ? sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth / 2., pixelRatio) : sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth, pixelRatio);
                resultAlpha = smoothstep(outlineThreshold - outlineSmoothing, outlineThreshold + outlineSmoothing, sobelSample);

                //resultAlpha = 1.0;
                //result = vec3(sobelSample);

                float t = 1.0 - contourThreshold;
                if(positionalLines) {
                    vec3 NDir = position * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float f  = fract(NT * contourFrequency * 0.01);
                    float df = fwidth(NT * contourFrequency);

                    float g = smoothstep(df * (contourWidth * 0.01), df * (contourWidth * 0.01 * 2.0), f);
                    if (g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0;
                    }
                 }
                 else {
                    vec3 NDir = N * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float df = fwidth(NT * contourThreshold);
                    float f = sin(NT * 1.0 * contourFrequency);
                    float g = smoothstep(0.0, df * contourWidth, 1.0 - f);

                    if (df > (t * 0.5) && g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0 - g;
                    }
                 }

                 float lalpha = alpha * resultAlpha * mask;
                 calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
                 accumAlpha += ( 1.0 - accumAlpha ) * lalpha;
				 
                 return result;
             }`, [
            e
        ])
    };
}();
var Fo = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h, d, f, p, m, g, y, x, v){
        super("v3");
        this.nodeType = "Pattern";
        this.style = e, this.projection = r, this.axis = i, this.blending = s, this.offset = o, this.colorA = a, this.colorB = l, this.frequency = c, this.size = u, this.variation = h, this.smoothness = d, this.zigzag = f, this.rotation = p, this.vertical = m, this.horizontal = g, this.sides = y, this.isMask = v, this.alpha = x, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.require("position"), e.require("uv"), e.requires.uv = [
                !0
            ], e.require("normal"), e.requires.normal = !0, e.addFragmentVariable(this.calpha, "float");
            let i;
            switch(this.style.value){
                case 0:
                    i = "circle";
                    break;
                case 1:
                    i = "ring";
                    break;
                case 2:
                    i = "polygon";
                    break;
                case 3:
                    i = "xcross";
                    break;
                case 4:
                    i = "diamond";
                    break;
                case 5:
                    i = "checkerboard";
                    break;
                case 6:
                    i = "line";
                    break;
                case 7:
                    i = "wave";
                    break;
                default:
                    i = "circle";
                    break;
            }
            let s = `g${this.uuid.toString().replace(/-/g, "")}`, o = new Ae(`float hashwithoutsine12(vec2 p)
				{
					vec3 p3 = fract(vec3(p.xyx) * .1031);
					p3 += dot(p3, p3.yzx + 33.33);
					return fract((p3.x + p3.y) * p3.z);
				}`), a = new Ae(`vec2 rotate_uv(in vec2 uv, float a, bool repeat) 
				{
					const float mid = 0.5;
					float radians = a * (PI / 180.0);
					vec2 rotated = vec2(
						cos(radians) * (uv.x - mid) + sin(radians) * (uv.y - mid) + mid,
						cos(radians) * (uv.y - mid) - sin(radians) * (uv.x - mid) + mid
					);
					return repeat ? fract(rotated): rotated;
				}`), l = "";
            if (this.projection.value === 4) {
                let d = this.style.value === 2 ? `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = this.style.value === 2 ? `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, p = this.style.value === 2 ? `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation)`;
                l = `
				vec3 p = position;
				float factor = 0.0125;
				vec2 uv0 = fract(p.xy * factor);
				vec2 uv1 = fract(p.zy * factor);
				vec2 uv2 = fract(p.xz * factor);
				
				uv0 = rotate_uv(uv0 + offset, rotation, true);
				uv1 = rotate_uv(uv1 + offset, rotation, true);
				uv2 = rotate_uv(uv2 + offset, rotation, true);
	
				float d0 = ${d};
				float d1 = ${f};
				float d2 = ${p};
				
				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));
				d0 *= weights.z;
				d1 *= weights.x;
				d2 *= weights.y;
				float draw = d0 + d1 + d2;
	
				vec2 custom_uv = uv0 * weights.z + uv1 * weights.x + uv2 * weights.y;
				`;
            } else {
                let d = this.style.value === 2 ? `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = "";
                this.axis.value === 0 ? f = `float radius = length(p);
					float theta = atan(p.y, p.z);
					float phi = acos(p.x / radius);` : this.axis.value === 1 ? f = `float radius = length(p);
					float theta = atan(p.x, p.z);
					float phi = acos(p.y / radius);` : (this.axis.value, f = `float radius = length(p);
					float theta = atan(p.y, p.x);
					float phi = acos(p.z / radius);`);
                let p = "";
                switch(this.projection.value){
                    case 0:
                        p = "custom_uv = vUv.st;";
                        break;
                    case 1:
                        break;
                    case 2:
                        p = `
							vec3 p = position;
							${f}
							custom_uv = vec2(theta, phi);
							custom_uv /= PI;
							`;
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
                l = `
				vec2 custom_uv;
				${p}
	
				custom_uv += offset;
				custom_uv = fract(custom_uv);
				custom_uv = rotate_uv(custom_uv, rotation, true);
	
				float draw = ${d};
				`;
            }
            let c = new Ae(`vec3 ${s}_pattern(vec3 normal, float blending, int style, vec2 offset, vec4 colorA, vec4 colorB, vec2 frequency, float size, float variation, float smoothness, float zigzag, float rotation, vec2 vertical, vec2 horizontal, int sides, bool isMask, float mask, float alpha, out float calpha) {
					const float TWO_PI = PI * 2.0;
					float smoothness_remapped = pow(smoothness, 5.0);	

					${l}

					// Construct final output color
					vec4 color = mix(colorA, colorB, draw);
					color.a = clamp(color.a, 0.0, 1.0);

					// Apply cuts
					color.a *= 
						step(vertical.x, custom_uv.y) * 
						step(custom_uv.y, vertical.y);
					color.a *= 
						step(horizontal.x, abs(custom_uv.x)) * 
						step(abs(custom_uv.x), horizontal.y);

					// Accumulate alpha 
					float lalpha = alpha * clamp(color.a, 0.0, 1.0) * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return clamp(color, 0.0, 1.0).rgb;
				}`, [
                a,
                o,
                Fo.DrawFunctions.circle,
                Fo.DrawFunctions.ring,
                Fo.DrawFunctions.polygon,
                Fo.DrawFunctions.cross,
                Fo.DrawFunctions.diamond,
                Fo.DrawFunctions.checkerboard,
                Fo.DrawFunctions.line,
                Fo.DrawFunctions.wave
            ]), u = e.include(c), h = [];
            return h.push("normal"), h.push(this.blending.build(e, "f")), h.push(this.style.build(e, "i")), h.push(this.offset.build(e, "v2")), h.push(this.colorA.build(e, "v4")), h.push(this.colorB.build(e, "v4")), h.push(this.frequency.build(e, "v2")), h.push(this.size.build(e, "f")), h.push(this.variation.build(e, "f")), h.push(this.smoothness.build(e, "f")), h.push(this.zigzag.build(e, "f")), h.push(this.rotation.build(e, "f")), h.push(this.vertical.build(e, "v2")), h.push(this.horizontal.build(e, "v2")), h.push(this.sides.build(e, "i")), h.push(this.isMask.build(e, "b")), h.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), h.push(this.alpha.build(e, "f")), h.push(this.calpha), e.format(u + "(" + h.join(",") + ")", this.getType(e), r);
        } else return console.warn("PatterNode is not compatible with " + e.shader + " shader."), e.format("vec3(0.0)", this.getType(e), r);
    }
}, Kd = Fo;
Kd.DrawFunctions = function() {
    let e = new Ae(`float hashwithoutsine12(vec2 p) {
				vec3 p3 = fract(vec3(p.xyx) * 0.1031);
				p3 += dot(p3, p3.yzx + 33.33);
				return fract((p3.x + p3.y) * p3.z);
			}`), r = new Ae(`vec2 tile_and_center(in vec2 uv, in vec2 frequency, in float variation, in float zigzag, in float rotation) {
                // Create tiles in UV-space
                uv *= frequency;

                // Integer coords
                vec2 i = floor(uv);

                // Offset every other row based on zigzag param, then compute fractional coords
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = fract(uv);

				// Rotate the tile itself:
				// const float mid = 0.5;
				// f = vec2(
				// 	cos(rotation) * (f.x - mid) + sin(rotation) * (f.y - mid) + mid,
				// 	cos(rotation) * (f.y - mid) - sin(rotation) * (f.x - mid) + mid
				// );
				// f = fract(f);

                f = f * 2.0 - 1.0;

				// Recompute integer coords after shifting - then, random value per tile 
				i = floor(uv);
				float rand = (hashwithoutsine12(i) * 5.0 + 1.0);
				float jitter = mix(1.0, rand, variation);
				f *= jitter;

                return f;
            }`, [
        e
    ]), i = new Ae(`float circle(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(
                    -smoothness, 
                     smoothness, 
                     length(f) - size
                );
            }`, [
        r
    ]), s = new Ae(`float ring(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);

				float d = length(f);
                const float inner_width = 0.5;

                float outer = smoothstep(-smoothness, smoothness, d - size);
                float inner = smoothstep(-smoothness, smoothness, d - size * inner_width);
				return outer + (1.0 - inner);   
            }`, [
        r
    ]), o = new Ae(`float sdf_ngon(in vec2 p, in float r, in int n) {
                float an = (PI * 2.0) / float(n);
                float he = r * tan(0.5 * an);
                
                // Rotate to first sector
                p = -p.yx; 
                float bn = an * floor((atan(p.y, p.x) + 0.5 * an) / an);
                vec2  cs = vec2(cos(bn), sin(bn));
                p = mat2(cs.x, -cs.y, cs.y, cs.x)*p;
            
                // Side of polygon
                return length(p - vec2(r, clamp(p.y, -he, he))) * sign(p.x - r);
            }
            
            float polygon(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation, in int sides) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_ngon(f, size, sides));
            }`, [
        r
    ]), a = new Ae(`float sdf_cross(in vec2 p, in vec2 b, float r ) {
                p = abs(p); 
				p = (p.y > p.x) ? p.yx : p.xy;
                vec2  q = p - b;
                float k = max(q.y, q.x);
                vec2  w = (k > 0.0) ? q : vec2(b.y - p.x, -k);
                return sign(k) * length(max(w, 0.0)) + r;
            }
            
            // Avoid namespace conflicts 
            float xcross(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_cross(f, vec2(size, size * 0.25), smoothness));
            }`, [
        r
    ]), l = new Ae(`float ndot(vec2 a, vec2 b) { 
                return a.x*b.x - a.y*b.y; 
            }
            
            float sdf_diamond(in vec2 p, in vec2 b) {
                p = abs(p);
                float h = clamp(ndot(b - 2.0 * p, b) / dot(b, b), -1.0, 1.0);
                float d = length(p - 0.5 * b * vec2(1.0 - h, 1.0 + h));
                return d * sign(p.x * b.y + p.y * b.x - b.x * b.y);
            }

            float diamond(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
	            return smoothstep(-smoothness, smoothness, sdf_diamond(f, vec2(size)));
            }`, [
        r
    ]), c = new Ae(`float checkerboard(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                uv *= frequency;
                vec2 i = floor(uv);

                float offset = mod(i.y, 2.0);

                uv.x += offset + zigzag * offset;
                float x = floor(uv.x);
                
                return mod(x, 2.0);
            }`), u = new Ae(`float line(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, 0.0, zigzag, rotation);
				
				// Different approach for variation param here
				float row = floor(uv * frequency).y;
				float rand = hashwithoutsine12(vec2(row));
				float s = mix(size, size * rand, variation);

				return smoothstep(
					s - smoothness, 
					s + smoothness, 
					abs(f.y)
				);
            }`, [
        r
    ]), h = new Ae(`// Uses bisection 
            float udf_cos(in vec2 p, in float a, in float b, in float c, in float d) {
                // Convert all data to a primitive cosine wave
                p = c * (p - vec2(d, a));
                
                const float TWO_PI = PI * 2.0;

                // Reduce to principal half cycle
                p.x = mod(p.x, TWO_PI); 
                if (p.x > PI) {
                    p.x = TWO_PI - p.x;
                }
            
                // Find zero of derivative (minimize distance)
                float xa = 0.0;
                float xb = TWO_PI;

                // 24 bit precision
                for (int i = 0; i < 24; i++) {
                    float x = 0.5 * (xa + xb);
                    float y = x - p.x + b * c * sin(x) * (p.y - b * c * cos(x));
                    if (y < 0.0) xa = x; 
                    else xb = x;
                }
                float x = 0.5 * (xa + xb);
                
                // Compute distance    
                vec2 q = vec2(x, b * c * cos(x));
                return length(p - q) / c;
            }

            float wave(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                float repeat = frequency.x;
                uv *= repeat;
                vec2 i = floor(uv);
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = vec2(uv.x, fract(uv.y));

                // Generalized cosine: y(x) = a + b * cos(cx + d)
                const float amplitude = 0.125;
                float wave_frequency = frequency.y * 0.1;
                float distance_estimate = udf_cos(f, 0.50, amplitude, wave_frequency * (2.0 * PI), 0.0);

				// Different approach for variation param here
				float rand = hashwithoutsine12(vec2(i.y));
				float s = mix(size, size * rand, variation);

                return smoothstep(-smoothness, smoothness, distance_estimate - s * 0.5);
            }`);
    return {
        tileAndCenter: r,
        circle: i,
        ring: s,
        polygon: o,
        cross: a,
        diamond: l,
        checkerboard: c,
        line: u,
        wave: h
    };
}();
var aE = class extends tt {
    constructor(e, r, i, s, o, a, l, c){
        super("v3");
        this.nodeType = "Rainbow";
        this.filmThickness = e, this.movement = r, this.wavelengths = i, this.noiseStrength = s, this.noiseScale = o, this.offset = a, this.isMask = c, this.alpha = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(aE.Nodes.rainbow), s = [];
            return s.push(this.filmThickness.build(e, "f")), s.push(this.movement.build(e, "f")), s.push(this.wavelengths.build(e, "v3")), s.push(this.noiseStrength.build(e, "f")), s.push(this.noiseScale.build(e, "f")), s.push(this.offset.build(e, "v3")), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("RainbowNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Qd = aE;
Qd.Nodes = function() {
    let e = new Ae(`vec3 attenuation(vec3 wavelengths, float filmThickness, float movement, float noiseStrength, float noiseScale, vec3 offset) {
				float f = 0.0;
				
				if (noiseStrength != 0.0) {
					vec3 st = position / noiseScale;
					float noise = simplexFast(1.6 * st + vec3(1.8, 1.5, 1.9) * simplexFast(st) + vec3(1.7, 9.2, 1.0));
					f = noise * noiseStrength;
				}

				vec3 waves = wavelengths * vec3(1.0, 0.8, 0.6) + 1.0;
				float angle = dot(normalize(vWorldViewDir + (offset * -0.001)), normalize(vWNormal));

				mediump vec3 color = cos((((filmThickness + f) / waves) * angle) + movement);
				return .5 + .5 * color;
			 }`, [
        zi.simplexFast
    ]);
    return {
        rainbow: new Ae(`vec3 rainbow(float filmThickness, float movement, vec3 wavelengths, float noiseStrength, float noiseScale, vec3 offset, bool isMask, float mask, float alpha, out float calpha) {
				mediump vec3 res = clamp(attenuation(wavelengths, filmThickness, movement, noiseStrength, noiseScale, offset), 0.0, 2.0);

				float rainbowContribution = clamp(res.r + res.g + res.b, 0.0, 1.0);

				float lalpha = alpha * rainbowContribution * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return res;
			 }`, [
            e
        ])
    };
}();
var lE = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h){
        super("v3");
        this.nodeType = "Toon";
        this.positioning = e, this.colors = r, this.steps = i, this.source = s, this.isWorldSpace = o, this.noiseStrength = a, this.noiseScale = l, this.shadowColor = c, this.offset = u, this.alpha = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("worldNormal"), e.require("worldPosition"), e.isShader("fragment")) {
            e.define("COLORS_MAX", 10), e.addFragmentVariable(this.calpha, "float");
            let i = e.include(lE.Nodes.toon), s = [];
            return s.push(this.positioning.build(e, "i")), s.push(this.colors.build(e, "v4[]")), s.push(this.steps.build(e, "f[]")), s.push(this.source.build(e, "v3")), s.push(this.isWorldSpace.build(e, "b")), s.push(this.noiseStrength.build(e, "f")), s.push(this.noiseScale.build(e, "f")), s.push(this.shadowColor.build(e, "v4")), s.push(this.offset.build(e, "v3")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("ToonNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Zd = lE;
Zd.Nodes = function() {
    let e = new Ae(`float rand(float n) {
				return fract(sin(n) * 43758.5453123);
			}`), r = new Ae(`float hash1(float p) { 
				p = fract(p * 0.011); 
				p *= p + 7.5; 
				p *= p + p; 
				return fract(p); 
			}`), i = new Ae(`float valueNoise(vec3 x) {
				const vec3 step = vec3(110, 241, 171);
			
				vec3 i = floor(x);
				vec3 f = fract(x);
			 
				// For performance, compute the base input to a 1D hash from the integer part of the argument and the 
				// incremental change to the 1D based on the 3D -> 1D wrapping
				float n = dot(i, step);
			
				vec3 u = f * f * (3.0 - 2.0 * f);
				return mix(mix(mix( hash1(n + dot(step, vec3(0, 0, 0))), hash1(n + dot(step, vec3(1, 0, 0))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 0))), hash1(n + dot(step, vec3(1, 1, 0))), u.x), u.y),
						   mix(mix( hash1(n + dot(step, vec3(0, 0, 1))), hash1(n + dot(step, vec3(1, 0, 1))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 1))), hash1(n + dot(step, vec3(1, 1, 1))), u.x), u.y), u.z);
			}`, [
        r
    ]), s = new Ae(`vec3 hash3(vec3 x) {
				x = vec3(dot(x,vec3(127.1, 311.7, 74.7)),
						 dot(x,vec3(269.5, 183.3, 246.1)),
						 dot(x,vec3(113.5, 271.9, 124.6)));
			
				return fract(sin(x)*43758.5453123);
			}`), o = new Ae(`vec3 voronoiNoise(in vec3 x)
			{
				vec3 p = floor(x);
				vec3 f = fract(x);

				float id = 0.0;
				vec2 res = vec2(100.0);

				for(int k=-1; k<=1; k++)
				for(int j=-1; j<=1; j++)
				for(int i=-1; i<=1; i++)
				{
					vec3 b = vec3(float(i), float(j), float(k));

					// Comment out the "+ hash(p + b);" part below to get "square" cells
					vec3 r = vec3(b) - f + hash3(p + b);
					float d = dot(r, r);

					if (d < res.x)
					{
						id = dot(p + b, vec3(1.0, 57.0, 113.0));
						res = vec2(d, res.x);			
					}
					else if (d < res.y)
					{
						res.y = d;
					}
				}

				return vec3(sqrt(res), abs(id));
			}
			`, [
        s
    ]);
    return {
        toon: new Ae(`vec3 toon(int positioning, vec4 colors[COLORS_MAX], float steps[COLORS_MAX], vec3 source, bool isWorldSpace, float noiseStrength, float noiseScale, vec4 shadowColor, vec3 offset, float mask, float alpha, out float calpha) {
				float t = 0.0;
				float shadow = 1.0;

				if (positioning == 0) {

					// Can't do this mode if lighting is "none"
					#if (defined(PHONG) || defined(LAMBERT) || defined(STANDARD))

						// Algorithm from Chapter 10 of Graphics Shaders
						const vec3 weights = vec3(0.2125, 0.7154, 0.0721);
						vec3 lpos;
						vec3 l;
						float dproduct;

						#if (NUM_POINT_LIGHTS > 0)

							#if defined(USE_SHADOWMAP) && (NUM_POINT_LIGHT_SHADOWS > 0)
								PointLightShadow pointLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_POINT_LIGHTS; i++) {
								// Light positions are in view-space for some reason?
								lpos = (inverse(viewMatrix) * vec4(pointLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								
								// TODO: we want to use "intensity" but it isn't available in the shader code
								//dproduct += dot(pointLights[UNROLLED_LOOP_INDEX].color, weights);

								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS)
									pointLightShadow = pointLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getPointShadow( 
											pointShadowMap[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowMapSize, 
											pointLightShadow.shadowBias, 
											pointLightShadow.shadowRadius,
											vPointShadowCoord[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowCameraNear, 
											pointLightShadow.shadowCameraFar);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_DIR_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_DIR_LIGHT_SHADOWS > 0)
								DirectionalLightShadow directionalLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_DIR_LIGHTS; i++) {
								// Use the direction vector for directional lights instead
								l = (inverse(viewMatrix) * vec4(directionalLights[UNROLLED_LOOP_INDEX].direction, 0.0)).xyz;
		
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS)
									directionalLightShadow = directionalLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow( 
										UNROLLED_LOOP_INDEX,
										directionalShadowMap[UNROLLED_LOOP_INDEX], 
										directionalLightShadow.shadowMapSize, 
										directionalLightShadow.shadowBias, 
										directionalLightShadow.shadowRadius, 
										vDirectionalShadowCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_SPOT_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_SPOT_LIGHT_SHADOWS > 0)
								SpotLightShadow spotLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_SPOT_LIGHTS; i++) {
								lpos = (inverse(viewMatrix) * vec4(spotLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS)
									spotLightShadow = spotLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow(
										UNROLLED_LOOP_INDEX,
										spotShadowMap[UNROLLED_LOOP_INDEX], 
										spotLightShadow.shadowMapSize, 
										spotLightShadow.shadowBias, 
										spotLightShadow.shadowRadius, 
										vSpotLightCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						t = clamp(t, 0.0, 1.0);
				
					#endif

				} else if (positioning == 1) {
					
					vec3 origin = mix(position, worldPosition, float(isWorldSpace));
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	

				} else {

					vec3 origin = worldPosition;
					vec3 source = cameraPosition - offset;
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	
					
				}

				if (noiseStrength > 0.0) {
					// Distort with noise
					vec3 st = position / noiseScale;
					
					// Voronoi "smooth" noise
					float noise = 1.0 - voronoiNoise(st).x;

					// Voronoi cellular noise
					//float noise = 1.0 - rand(voronoiNoise(st).z);

					// Position warp noise
					// vec3 offset = vec3(
					// 	simplexFast(st),
					// 	simplexFast(st + vec3(111.1, 143.89, 217.19)),
					// 	simplexFast(st + vec3(171.1, 247.89, 117.23))
					// );
					// st += offset;
					// float noise = valueNoise(st);

					t += noise * noiseStrength;
				}

				t = clamp(t, 0.0, 1.0);

				// Compute ramp color
				float p;
				vec4 color = colors[0];
				for (int i = 1; i < COLORS_MAX; i++) {
					p = clamp((t - steps[i-1]) / (steps[i] - steps[i-1]), 0.0, 1.0);
					color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
				}

				// Incorporate custom shadow color
				if (positioning == 0) {

					vec3 blendedShadow = mix(color.rgb, shadowColor.rgb, shadowColor.a);
					color.rgb = mix(blendedShadow, color.rgb, shadow);
				
				}

				// Accumulate alpha as usual
				float lalpha = alpha * color.a * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color.xyz;

            }`, [
            zi.simplexFast,
            e,
            i,
            o
        ])
    };
}();
var AR = function() {
    return {
        textureBicubic: new Ae(`float w0( float a ) {
            return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
        }
    
        float w1( float a ) {
            return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
        }
    
        float w2( float a ){
            return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
        }
    
        float w3( float a ) {
            return ( 1.0 / 6.0 ) * ( a * a * a );
        }
    
        // g0 and g1 are the two amplitude functions
        float g0( float a ) {
            return w0( a ) + w1( a );
        }
    
        float g1( float a ) {
            return w2( a ) + w3( a );
        }
    
        // h0 and h1 are the two offset functions
        float h0( float a ) {
            return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
        }
    
        float h1( float a ) {
            return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
        }
    
        vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
            uv = uv * texelSize.zw + 0.5;
    
            vec2 iuv = floor( uv );
            vec2 fuv = fract( uv );
    
            float g0x = g0( fuv.x );
            float g1x = g1( fuv.x );
            float h0x = h0( fuv.x );
            float h1x = h1( fuv.x );
            float h0y = h0( fuv.y );
            float h1y = h1( fuv.y );
    
            vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
            vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
            vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
            vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
    
            return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) + 
                   g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
        }

        vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
            vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
            vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
            vec2 fLodSizeInv = 1.0 / fLodSize;
            vec2 cLodSizeInv = 1.0 / cLodSize;
            vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
            vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
            return mix( fSample, cSample, fract( lod ) );
        }`)
    };
}();
function ER(n1, t) {
    return n1 >= t ? new k(t / n1, 1) : new k(1, n1 / t);
}
var cE = class extends tt {
    constructor(e, r, i, s, o, a, l, c){
        super("v3");
        this.nodeType = "Transmission";
        this.thickness = e, this.ior = r, this.roughness = i, this.transmissionSamplerSize = s, this.transmissionSamplerMap = o, this.transmissionDepthMap = a, this.aspectRatio = l, this.alpha = c, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0, e.isShader("fragment")) {
            e.define("NUM_SAMPLES", 6), e.define("BLUR_SLOD", Math.pow(2, $e.transmissionLod.value)), e.require("worldPosition"), e.requires.worldNormal = !0, e.requires.modelMatrix = !0, e.requires.projectionMatrix = !0, e.addFragmentVariable(this.calpha, "float");
            let i = e.include(cE.Nodes.transmission), s = [];
            return s.push(this.thickness.build(e, "f")), s.push(this.ior.build(e, "f")), s.push(this.roughness.build(e, "f")), s.push(this.transmissionSamplerSize.build(e, "v2")), s.push(this.transmissionSamplerMap.getTexture(e, "t")), s.push(this.transmissionDepthMap.getTexture(e, "t")), s.push(this.aspectRatio.build(e, "v2")), s.push("normal"), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("TransmissionNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Jd = cE;
Jd.Nodes = function() {
    let e = new Ae(`vec3 blur(sampler2D sp, vec2 U, vec2 scale, float lod, sampler2D dm, vec2 unrefractedU, vec2 aspectRatio) {
                // Slightly modified version of this:
                // https://www.shadertoy.com/view/ltScRG

				// Special case for blur == 0.0
				if (lod == 0.0) {
					#ifdef TEXTURE_LOD_EXT
					return texture2DLodEXT( sp, U, 0.0).rgb;
					#else
					return textureLod( sp, U, 0.0).rgb;
					#endif
				}
				
				vec2 texelSize = vec2(1.0) / resolution;
                vec2 halton = haltonSequence[frameIndex];
                float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
                float temporalAngle  = temporalOffset * PI2;
				vec3 res = vec3(0.0);
                vec2 uv = vec2(0.0);
                vec2 offset = vec2(0.0);
                vec2 vogelSample = vec2(0.0);
                for (int i = 0; i < NUM_SAMPLES; i++) {
                    vogelSample =  vogelDiskSample(i, NUM_SAMPLES, temporalAngle) * texelSize;
                    offset = vogelSample * scale * (lod * 10.0); // TODO: used to be hardcoded to 20
                    uv = U + offset;
                    float opaqueDepth = unpackRGBAToDepth(textureLod(dm, uv, lod));
                    if (opaqueDepth != 0.0 && opaqueDepth < gl_FragCoord.z) {
                        uv = unrefractedU;
                        lod = lod > 4.0 ? lod : lod / 2.0;
                    }
                    res += textureLod(sp, uv, lod).rgb;
                }
                return res / float(NUM_SAMPLES);
            }`), r = new Ae(`vec3 getVolumeTransmissionRay( vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix ) {
		        // Direction of refracted light.
		        vec3 refractionVector = refract( -v,  n, 1.0 / ior );
		        
				// Compute rotation-independant scaling of the model matrix.
		        vec3 modelScale;
		        modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		        modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		        modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );

		        // The thickness is specified in local space
		        return normalize( refractionVector ) * thickness * modelScale;
	        }`), i = new Ae(`float applyIorToRoughness( float roughness, float ior ) {
				// Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
				// an IOR of 1.5 results in the default amount of microfacet refraction.
				return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
			}`), s = new Ae(`vec3 getTransmissionSample( vec2 fragCoord, float roughness, float ior, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 unrefractedCoords, vec2 aspectRatio) {
				// Threejs exports do not pass a depth map to this shader, so we have to fallback to the "Threejs method of blurring" - see
				// also the code in convertTransmission.ts, which runs during export
				#ifdef IS_THREEJS_EXPORT
					float lod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness / 5.0, ior);
					return textureBicubic(transmissionSamplerMap, fragCoord.xy, lod).rgb;
				#else
					float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
					float lod = applyIorToRoughness(roughness, ior);
					return blur(transmissionSamplerMap, fragCoord, vec2(lod), min(framebufferLod / 5.5, 8.5), transmissionDepthMap, unrefractedCoords, aspectRatio);
				#endif
			}`, [
        AR.textureBicubic,
        i,
        e
    ]), o = new Ae(`vec3 getIBLVolumeRefraction( vec3 n, vec3 v, float roughness, vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;

				// Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
				vec4 ndcPos = projMatrix * viewMatrix *  vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;

				vec4 ndcPosUnrefracted = projMatrix * viewMatrix * vec4(position, 1.0 );
				vec2 unrefractedCoords = ndcPosUnrefracted.xy / ndcPosUnrefracted.w;
				unrefractedCoords += 1.0;
				unrefractedCoords /= 2.0;

				// Sample framebuffer to get pixel the refracted ray hits.
				return getTransmissionSample( refractionCoords, roughness, ior, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, unrefractedCoords, aspectRatio );
    		}`, [
        s,
        r
    ]);
    return {
        transmission: new Ae(`vec3 transmission(float thickness, float ior, float roughness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio, vec3 normal, float mask, float alpha, out float calpha) {
                vec3 v = vec3(0.);
                if (isOrthographic) {
                    v = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
                } else {
                    v = normalize(vWPosition - cameraPosition);
                }
                vec3 transmission = getIBLVolumeRefraction(vWNormal, -v, roughness,  vWPosition, modelMatrix, viewMatrix, projectionMatrix, ior, thickness, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, aspectRatio );
                
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * alpha;

				return transmission;
            }`, [
            o
        ])
    };
}();
var uE = ((e)=>(e.NOISE = "noise", e.MAP = "map", e))(uE || {}), hE = class extends tt {
    constructor(e, r, i, s, o, a, l, c, u, h, d){
        super("v3");
        this.displacementTypeIndex = new Dt(0);
        this.nodeType = "VertexDisplacement";
        this.intensity = e, this.movementOrTexture = r, Object.values(uE)[this.displacementTypeIndex.value] === "map" && (this.mat = new kd(this.movementOrTexture.value.matrix)), this.cropOrOffset = i, this.scale = h, this.noiseFunctionIndex = d, this.voronoiStyle = s, this.smoothness = o, this.seed = a, this.highCut = l, this.lowCut = c, this.quality = u;
    }
    generate(e, r) {
        if (e.isShader("vertex")) {
            e.define("USE_LAYER_DISPLACE");
            let i, s = [];
            switch(s.push("displaced_position"), s.push("displaced_normal"), Object.values(uE)[this.displacementTypeIndex.value]){
                case "map":
                    i = e.include(hE.Nodes.map), s.push(this.movementOrTexture.getTexture(e, "t")), s.push("uv"), s.push(this.cropOrOffset.build(e, "f")), this.mat && s.push(this.mat.build(e, "mat3"));
                    break;
                case "noise":
                    {
                        let l = [
                            "simplexPrecise",
                            "simplexFractal",
                            "simplexAshima",
                            "fbm",
                            "perlin",
                            "voronoi"
                        ][this.noiseFunctionIndex.value], c = new Ae(`vec3 orthogonal(vec3 v) {
							return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
						}`), u = l == "voronoi" ? `
					float v = ${l}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1), voronoiStyle, smoothness, seed, quality);
					v = remap(v, lowCut, highCut, 0.0, 1.0);
					v = smax(v, 0.0, smoothness * 0.25);
					v = smin(v, 1.0, smoothness * 0.25);

					return p + n * v * intensity;
					` : `
					return p + n * ${l}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1)) * intensity;
					`, h = new Ae(`vec3 distorted(vec3 p, vec3 n, float scale, float intensity, vec3 offset, float neighbour_offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality) {
							${u}
						}`, [
                            zi.simplexPrecise,
                            zi.simplexFractal,
                            zi.simplexAshima,
                            zi.fbm,
                            zi.perlin,
                            zi.voronoi
                        ]), d = new Ae(`vec3 vertexDisplacementNoise(vec3 position, vec3 normal, float scale, vec3 offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality, float intensity, out vec3 displaced_normal) {
							vec3 displaced_position = distorted(position, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 tangent1 = orthogonal(normal);
							vec3 tangent2 = normalize(cross(normal, tangent1));

                            // TODO(Max): The distance to the neighbors was originally scaled by 0.1.
                            // This caused some small oval/circular visual artifacts in the lighting.
                            // For now, simply using neighbors further away betters the problem,
                            // but we should figure out the underlying cause when we have some time.
                            // Maybe its related to how we calculate the tangent and bitangent?
							vec3 nearby1 = position + tangent1;
							vec3 nearby2 = position + tangent2;
							vec3 distorted1 = distorted(nearby1, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 distorted2 = distorted(nearby2, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
							return displaced_position;
						}`, [
                            h,
                            c
                        ]);
                        i = e.include(d), s.push(this.scale.build(e, "f")), s.push(this.cropOrOffset.build(e, "v3")), s.push(this.movementOrTexture.build(e, "f")), s.push(this.voronoiStyle.build(e, "i")), s.push(this.smoothness.build(e, "f")), s.push(this.seed.build(e, "f")), s.push(this.highCut.build(e, "f")), s.push(this.lowCut.build(e, "f")), s.push(this.quality.build(e, "i"));
                        break;
                    }
            }
            return s.push(this.intensity.build(e, "f")), s.push("displaced_normal"), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("VertexDisplacementNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, $d = hE;
$d.Nodes = function() {
    let e = new Ae(`vec3 orthogonal(vec3 v) {
				return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
			}`), r = new Ae(`float displacementMapTexture(sampler2D tex, float crop, vec2 uv, mat3 mat, vec2 offset) {
				vec2 uvs = (mat * vec3(uv * 2.0 - 1.0, 1.0) / 2.0 + 0.5).xy + offset;
				vec4 tmp = texture2D(tex, uvs);
				vec3 col = tmp.rgb;
				if (crop > 0.5) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						return 0.0;
					}
				}
				return col.r;
			}`);
    return {
        map: new Ae(`vec3 vertexDisplacementMap(vec3 position, vec3 normal, sampler2D tex, vec2 uv, float crop, mat3 mat, float intensity, out vec3 displaced_normal) {
				vec3 displaced_position = position + normal * displacementMapTexture(tex, crop, uv, mat, vec2(0.0)) * intensity;
				vec3 tangent1 = normalize(orthogonal(normal));
				vec3 tangent2 = normalize(cross(normal, tangent1));
				vec3 nearby1 = position + tangent1 * 0.1;
				vec3 nearby2 = position + tangent2 * 0.1;
				vec3 distorted1 = nearby1 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				vec3 distorted2 = nearby2 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
				return displaced_position;
			}`, [
            e,
            r
        ])
    };
}();
var $e = {
    normalRenderTarget: new bn,
    normalRenderTargetDepth: new bn,
    transmissionRenderTarget: new bn,
    aspectRatio: new Hr,
    transmissionSize: new Hr(2048, 2048),
    transmissionRenderTargetDepth: new bn,
    aoRenderTarget: new bn,
    aoEnabled: new Qr,
    pixelRatioNode: new Fe(1),
    resolution: new Hr,
    penumbraSize: new Xs(5, .5),
    frameIndex: new Dt(0),
    transmissionLod: new Dt(2)
};
for (let n1 of Object.values($e))n1.isRenderGlobal = !0;
var X0 = {
    skiaWasmUrl: "https://unpkg.com/@splinetool/ui-wasm@1.9.46/build/ui.wasm"
};
var Da = class extends or {
    constructor(){
        super("basic");
        this.nodeType = "Basic";
        this.color = new tr(ii), this.shadingAlpha = new Fe(1), this.shadingBlend = new Dt(0), this.previousModelViewMatrix = new Ki, this.previouseProjectionMatrix = new Ki;
    }
    get category() {
        return "phong";
    }
    generate(e) {
        let r;
        if (e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                resolution: $e.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ie.fog
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "	vNormal = transformedNormal;", "#endif"), s.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            this.color === void 0 && (this.color = new tr(ii)), this.color.analyze(e, {
                slot: "color"
            }), this.alpha && this.alpha.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            });
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.alpha ? this.alpha.flow(e, "f") : void 0, o = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0, a = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0;
            e.requires.transparent = s !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "#include <fog_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "varying vec3 vViewPosition;",
                "#include <normal_pars_fragment>"
            ].join(`
`));
            let l = [
                "#include <normal_fragment_begin>",
                i.code
            ];
            s && l.push(s.code, "#ifdef ALPHATEST", " if ( " + s.result + " <= ALPHATEST ) discard;", "#endif"), a ? l.push(a.code, `vec3 outgoingLight = ${i.result};`, `vec3 finalColor = spe_blend(outgoingLight, ${a.result}, 1.0, SPE_BLENDING_NORMAL);`) : l.push(`vec3 finalColor = ${i.result};`);
            let c = "1.0";
            this.mask && (this.mask.analyze(e), c = `luminance(${this.mask.flow(e, "v3").result})`), s ? l.push(`gl_FragColor = vec4( finalColor, accumAlpha * ${s.result} * ${c} );`) : l.push("gl_FragColor = vec4(" + i.result + ", 1.0 );"), o && l.push(`gl_FragColor.a *= ${o.result};`), l.push("#include <fog_fragment>", "#include <dithering_fragment>"), r = l.join(`
`);
        }
        return r;
    }
};
var bm = class extends or {
    constructor(){
        super("lambert");
        this.nodeType = "Lambert";
        this.color = new tr(ii), this.emissive = new tr(0), this.emissiveIntensity = new Fe(1), this.previousModelViewMatrix = new Ki, this.previouseProjectionMatrix = new Ki, this.shadingAlpha = new Fe(1), this.shadingBlend = new Dt(0), this.occlusion = new Qr(!0);
    }
    get category() {
        return "lambert";
    }
    build(e) {
        let r;
        if (e.define("LAMBERT"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                resolution: $e.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ie.fog,
                Ie.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <color_pars_vertex>",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", `
					vec3 diffuse = vec3( 1.0 );
					GeometricContext geometry;
					geometry.position = mvPosition.xyz;
					geometry.normal = normalize( transformedNormal );
					geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );
				`), s.push(`
					GeometricContext backGeometry;
					backGeometry.position = geometry.position;
					backGeometry.normal = -geometry.normal;
					backGeometry.viewDir = geometry.viewDir;
					vLightFront = vec3( 0.0 );
					vIndirectFront = vec3( 0.0 );
					#ifdef DOUBLE_SIDED
						vLightBack = vec3( 0.0 );
						vIndirectBack = vec3( 0.0 );
					#endif
					IncidentLight directLight;
					float dotNL;
					vec3 directLightColor_Diffuse;
					vIndirectFront += getAmbientLightIrradiance( ambientLightColor );
					vIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );
					#ifdef DOUBLE_SIDED
						vIndirectBack += getAmbientLightIrradiance( ambientLightColor );
						vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );
					#endif
					#if NUM_POINT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
							getPointLightInfo( pointLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_SPOT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
							getSpotLightInfo( spotLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_DIR_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
							getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_HEMI_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
							vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
							#ifdef DOUBLE_SIDED
								vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );
							#endif
						}
						#pragma unroll_loop_end
					#endif
				`, "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: $e.penumbraSize
            }), e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                aoMap: $e.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: $e.aoEnabled
            }), this.color === void 0 && (this.color = new tr(ii)), this.color.analyze(e, {
                slot: "color"
            }), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.emissive.flow(e, "c", {
                slot: "emissive"
            }), o = this.emissiveIntensity.flow(e, "f", {
                slot: "emissive"
            }), a = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            }), l = this.shadingAlpha.flow(e, "f"), c = this.shadingBlend.flow(e, "i"), u = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, h = this.alpha ? this.alpha.flow(e, "f") : void 0, d = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = h !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#include <normal_pars_fragment>",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <fog_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <shadowmask_pars_fragment>",
                "#include <clipping_planes_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let f = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx, viewdy));
				bool isFrontFacing = (dot(normal, faceNormal) >= 0.0);
				`,
                "#include <clipping_planes_fragment>"
            ];
            f.push(i.code, "vec3 diffuseColor = " + i.result + ";", "ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );"), h && f.push(h.code, "#ifdef ALPHATEST", "if ( " + h.result + " <= ALPHATEST ) discard;", "#endif"), f.push("#ifdef DOUBLE_SIDED", "	reflectedLight.indirectDiffuse += ( isFrontFacing ) ? vIndirectFront : vIndirectBack;", "#else", "	reflectedLight.indirectDiffuse += vIndirectFront;", "#endif", "#include <lightmap_fragment>", "reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );", "#ifdef DOUBLE_SIDED", "	reflectedLight.directDiffuse = ( isFrontFacing ) ? vLightFront : vLightBack;", "#else", "	reflectedLight.directDiffuse = vLightFront;", "#endif", "reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();"), s && f.push(s.code, "reflectedLight.directDiffuse += " + s.result + " * " + o.result + ";"), f.push("vec3 ao = aoEnabled && " + a.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = (reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) ;");
            let p = "1.0";
            this.mask && (this.mask.analyze(e), p = `luminance(${this.mask.flow(e, "v3").result})`), f.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${p} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${p}, ${c.result} );

					outgoingLight *= ao;
				}
				`), u && f.push(u.code, `outgoingLight = spe_blend(outgoingLight, ${u.result}, 1.0, SPE_BLENDING_NORMAL);`), h ? f.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${h.result} );`) : f.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), d && f.push(`gl_FragColor.a *= ${d.result};`), f.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = f.join(`
`);
        }
        return r;
    }
};
var Oa = function() {
    let n1 = new Ae(`vec2 dHdxy(sampler2D bumpMap, vec2 bumpMapUv, float bumpScale) {

            // Gradient of UVs w.r.t. X coordinate (in screen-space)
            vec2 dSTdx = dFdx(bumpMapUv);

            // Gradient of UVs w.r.t. Y coordinate (in screen-space)
            vec2 dSTdy = dFdy(bumpMapUv);
            
            // Forward differencing
            float Hll = bumpScale * luminance(texture(bumpMap, bumpMapUv).rgb);
            float dBx = bumpScale * luminance(texture(bumpMap, bumpMapUv + dSTdx).rgb) - Hll;
            float dBy = bumpScale * luminance(texture(bumpMap, bumpMapUv + dSTdy).rgb) - Hll;
            
            return vec2( dBx, dBy );
        }`), t = new Ae(`vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
            vec3 vSigmaX = dFdx( surf_pos.xyz );
            vec3 vSigmaY = dFdy( surf_pos.xyz );
            vec3 vN = surf_norm; // normalized
            
            vN = normalize(vN);

            vec3 R1 = cross( vSigmaY, vN );
            vec3 R2 = cross( vN, vSigmaX );

            R1 = normalize(R1);
            R2 = normalize(R2);
    
            float fDet = dot( vSigmaX, R1 ) * faceDirection;
    
            vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
            return normalize( abs( fDet ) * vN - vGrad );
        }`);
    return {
        dHdxy: n1,
        perturbNormalArb: t
    };
}();
var Sm = class extends or {
    constructor(){
        super("phong");
        this.nodeType = "Phong";
        this.color = new tr(ii), this.specular = new tr(1118481), this.shininess = new Fe(30), this.previousModelViewMatrix = new Ki, this.previouseProjectionMatrix = new Ki, this.shadingAlpha = new Fe(1), this.shadingBlend = new Dt(0), this.occlusion = new Qr(!0);
    }
    get category() {
        return "phong";
    }
    build(e) {
        let r;
        if (e.define("PHONG"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                resolution: $e.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ie.fog,
                Ie.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: $e.penumbraSize
            }), e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                aoMap: $e.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: $e.aoEnabled
            }), this.color === void 0 && (this.color = new tr(ii)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e);
            let i = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let s = this.color.flow(e, "c", {
                slot: "color"
            }), o = this.specular.flow(e, "c"), a = this.shininess.flow(e, "f"), l = this.shadingAlpha.flow(e, "f"), c = this.shadingBlend.flow(e, "i"), u = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, h = this.alpha ? this.alpha.flow(e, "f") : void 0, d = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = h !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "uniform vec3 emissive;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_phong_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let f = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	BlinnPhongMaterial material;"
            ];
            if (this.bumpMap) {
                e.include(Oa.dHdxy), e.include(Oa.perturbNormalArb);
                let m = this.bumpMap.texture.flow(e, "t"), g = this.bumpMap.flow(e, "v3"), y = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", x = "";
                this.bumpMap.projection.value === 4 ? x = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${m.result}, uv0, ${y});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${m.result}, uv1, ${y});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${m.result}, uv2, ${y});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : x = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${m.result}, bumpMapCachedUv, ${y});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, f.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${g.result};
					${x}
					`);
            }
            f.push(s.code, "	vec3 diffuseColor = " + s.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", "	vec3 totalEmissiveRadiance = emissive;", o.code, "	vec3 specular = " + o.result + ";", a.code, "	float shininess = max( 0.0001, " + a.result + " );", "	float specularStrength = 1.0;"), h && f.push(h.code, "#ifdef ALPHATEST", "if ( " + h.result + " <= ALPHATEST ) discard;", "#endif"), f.push("material.diffuseColor = diffuseColor;"), f.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), f.push("vec3 ao = aoEnabled && " + i.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;");
            let p = "1.0";
            this.mask && (this.mask.analyze(e), p = `luminance(${this.mask.flow(e, "v3").result})`), f.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${p} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${p}, ${c.result} );
					
					outgoingLight *= ao;
				}
				`), u && f.push(u.code, `outgoingLight = spe_blend(outgoingLight, ${u.result}, 1.0, SPE_BLENDING_NORMAL);`), h ? f.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${h.result});`) : f.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), d && f.push(`gl_FragColor.a *= ${d.result};`), f.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = f.join(`
`);
        }
        return r;
    }
};
var wm = class extends or {
    constructor(){
        super("standard");
        this.nodeType = "Standard";
        this.color = new tr(ii), this.roughness = new Fe(.3), this.metalness = new Fe(0), this.reflectivity = new Fe(.5), this.previousModelViewMatrix = new Ki, this.previouseProjectionMatrix = new Ki, this.shadingAlpha = new Fe(1), this.shadingBlend = new Dt(0), this.occlusion = new Qr(!0);
    }
    get category() {
        return "physical";
    }
    build(e) {
        let r;
        if (e.define("STANDARD"), e.requires.lights = !0, e.extensions.derivatives = !0, e.extensions.shaderTextureLOD = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                resolution: $e.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ie.fog,
                Ie.lights
            ])), Ie.LTC_1 && (e.uniforms.ltc_1 = {
                value: void 0
            }, e.uniforms.ltc_2 = {
                value: void 0
            }), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>", "#include <shadowmap_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: $e.penumbraSize
            }), e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                aoMap: $e.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: $e.aoEnabled
            });
            let i = {
                gamma: !0
            };
            this.color === void 0 && (this.color = new tr(ii)), this.color.analyze(e, {
                slot: "color",
                context: i
            }), this.roughness.analyze(e), this.metalness.analyze(e);
            let s = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e), this.reflectivity && this.reflectivity.analyze(e);
            let o = this.color.flow(e, "c", {
                slot: "color",
                context: i
            }), a = this.roughness.flow(e, "f"), l = this.metalness.flow(e, "f"), c = this.shadingAlpha.flow(e, "f"), u = this.shadingBlend.flow(e, "i"), h = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, d = this.alpha ? this.alpha.flow(e, "f") : void 0, f = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0, p = this.reflectivity ? this.reflectivity.flow(e, "f") : void 0;
            e.requires.transparent = d !== void 0, e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_physical_pars_fragment>",
                "#include <shadowmap_pars_fragment>"
            ].join(`
`));
            let m = [
                "#include <clipping_planes_fragment>",
                "	#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	PhysicalMaterial material;",
                "	material.diffuseColor = vec3( 1.0 );"
            ];
            if (this.bumpMap) {
                e.include(Oa.dHdxy), e.include(Oa.perturbNormalArb);
                let y = this.bumpMap.texture.flow(e, "t"), x = this.bumpMap.flow(e, "v3"), v = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", S = "";
                this.bumpMap.projection.value === 4 ? S = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${y.result}, uv0, ${v});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${y.result}, uv1, ${v});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${y.result}, uv2, ${v});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : S = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${y.result}, bumpMapCachedUv, ${v});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, m.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${x.result};
					${S}
					`);
            }
            if (m.push(o.code, "	vec3 diffuseColor = " + o.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", l.code, "	float metalnessFactor = " + l.result + ";"), this.roughnessMap) {
                let y = this.roughnessMap.texture.flow(e, "t"), x = this.roughnessMap.flow(e, "v3"), v = "";
                this.roughnessMap.projection.value === 4 ? v = `
					float roughnessChange = 1.0;
					{
						vec2 uv0 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						float r0 = luminance(texture(${y.result}, uv0).rgb) * roughnessScale;
						float r1 = luminance(texture(${y.result}, uv1).rgb) * roughnessScale;
						float r2 = luminance(texture(${y.result}, uv2).rgb) * roughnessScale;

						roughnessChange = (r0 * weights.z + r1 * weights.x + r2 * weights.y);
					}
					float roughnessFactor = roughnessChange * ${a.result};
					` : v = `
					vec2 roughnessMapCachedUv = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs;

					vec4 vals = texture(${y.result},  roughnessMapCachedUv);
					float roughnessFactor = luminance(vals.rgb) * ${a.result};
					`, m.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${x.result};

					const float roughnessScale = 1.0;

					${v}
				`);
            } else m.push(a.code, "	float roughnessFactor = " + a.result + ";");
            d && m.push(d.code, "#ifdef ALPHATEST", "	if ( " + d.result + " <= ALPHATEST ) discard;", "#endif"), m.push("vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );", "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );"), m.push("material.diffuseColor = diffuseColor * ( 1.0 - metalnessFactor );", "material.roughness = max( roughnessFactor, 0.0525 );", "material.roughness += geometryRoughness;", "material.roughness = min( material.roughness, 1.0 );", "material.roughness = clamp( roughnessFactor, 0.04, 1.0 );"), p ? m.push(p.code, "material.specularColor = mix( vec3( 0.16 * pow2( " + p.result + " ) ), diffuseColor, metalnessFactor );") : m.push("material.specularColor = mix( vec3( 0.04 ), diffuseColor, metalnessFactor );"), m.push("#include <lights_fragment_begin>"), m.push("#include <lights_fragment_end>"), m.push("vec3 ao = aoEnabled && " + s.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular;");
            let g = "1.0";
            this.mask && (this.mask.analyze(e), g = `luminance(${this.mask.flow(e, "v3").result})`), m.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${c.result} * ${g} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${c.result} * ${g}, ${u.result} );
					
					outgoingLight *= ao;
				}
				`), h && m.push(h.code, `outgoingLight = spe_blend(outgoingLight, ${h.result}, 1.0, SPE_BLENDING_NORMAL);`), d ? m.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${d.result} );`) : m.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), f && m.push(`gl_FragColor.a *= ${f.result};`), m.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = m.join(`
`);
        }
        return r;
    }
};
var Am = class extends or {
    constructor(){
        super("toon");
        this.nodeType = "Toon";
        this.color = new tr(ii), this.specular = new tr(1118481), this.shininess = new Fe(30), this.previousModelViewMatrix = new Ki, this.previouseProjectionMatrix = new Ki, this.shadingAlpha = new Fe(1), this.shadingBlend = new Dt(0);
    }
    get category() {
        return "toon";
    }
    build(e) {
        let r;
        if (e.define("TOON"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                resolution: $e.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ie.fog,
                Ie.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <fog_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: $e.penumbraSize
            }), e.mergeUniform({
                frameIndex: $e.frameIndex
            }), e.mergeUniform({
                aoMap: $e.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: $e.aoEnabled
            }), this.color === void 0 && (this.color = new tr(ii)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.specular.flow(e, "c"), o = this.shininess.flow(e, "f"), a = this.shadingAlpha.flow(e, "f"), l = this.shadingBlend.flow(e, "i"), c = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, u = this.alpha ? this.alpha.flow(e, "f") : void 0, h = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = u !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vWPosition;",
                "#include <normal_pars_fragment>",
                "#include <gradientmap_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <dithering_pars_fragment>",
                `
					varying vec3 vViewPosition;
					struct ToonMaterial {
						vec3	diffuseColor;
						vec3	specularColor;
						float	specularShininess;
						float	specularStrength;
					};
					void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
			
						reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
						reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
					}
					void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
					}
					#define RE_Direct				RE_Direct_Toon
					#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon
					#define Material_LightProbeLOD( material )	(0)
					`,
                "#include <shadowmap_pars_fragment>",
                "#include <bumpmap_pars_fragment>",
                "#include <normalmap_pars_fragment>"
            ].join(`
`));
            let d = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	ToonMaterial material;"
            ];
            if (this.bumpMap) {
                e.include(Oa.dHdxy), e.include(Oa.perturbNormalArb);
                let p = this.bumpMap.texture.flow(e, "t"), m = this.bumpMap.flow(e, "v3"), g = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", y = "";
                this.bumpMap.projection.value === 4 ? y = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${p.result}, uv0, ${g});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${p.result}, uv1, ${g});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${p.result}, uv2, ${g});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : y = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${p.result}, bumpMapCachedUv, ${g});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, d.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${m.result};
					${y}
					`);
            }
            d.push(i.code, "	vec3 diffuseColor = " + i.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", s.code, "	vec3 specular = " + s.result + ";", o.code, "	float shininess = max( 0.0001, " + o.result + " );", "	float specularStrength = 1.0;"), u && d.push(u.code, "#ifdef ALPHATEST", "if ( " + u.result + " <= ALPHATEST ) discard;", "#endif"), d.push("material.diffuseColor = diffuseColor;"), d.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), d.push("vec3 ao = aoEnabled ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) * ao) + reflectedLight.directSpecular;");
            let f = "1.0";
            this.mask && (this.mask.analyze(e), f = `luminance(${this.mask.flow(e, "v3").result})`), d.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${a.result} * ${f} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${a.result} * ${f}, ${l.result} );
				}
				`), c && d.push(c.code, `outgoingLight = spe_blend(outgoingLight, ${c.result}, 1.0, SPE_BLENDING_NORMAL);`), u ? d.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${u.result} );`) : d.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), h && d.push(`gl_FragColor.a *= ${h.result};`), d.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = d.join(`
`);
        }
        return r;
    }
};
var K0 = class {
    constructor(t = 10000){
        this.timeout = t;
        this.cache = new Map;
        this.head = {
            data: null,
            time: 0,
            src: null,
            next: null,
            prev: null
        };
        this.tail = {
            data: null,
            time: 1 / 0,
            src: null,
            next: null,
            prev: null
        };
        this.hasClean = !1;
        this.head.next = this.tail, this.tail.prev = this.head;
    }
    log(...t) {}
    remove(t) {
        let e = this.cache.get(t);
        e && (this.dispose(t, e.data), this.cache.delete(t), e.prev.next = e.next, e.next.prev = e.prev);
    }
    scheduleCleanup() {
        this.hasClean || (this.log("scheduled cleanup"), this.hasClean = !0, setTimeout(()=>{
            this.hasClean = !1, this.log("cleaning");
            let t = Date.now(), e = this.head.next;
            for(; e.time < t - this.timeout;)this.dispose(e.src, e.data), this.cache.delete(e.src), e = e.next, e.prev = this.head, this.head.next = e;
            this.head.next !== this.tail ? this.scheduleCleanup() : this.log("no more cleanup");
        }, this.timeout + 1e3));
    }
    has(t) {
        return this.cache.get(t)?.data;
    }
    load(t) {
        let e = Date.now(), r = this.cache.get(t);
        return r === void 0 ? (r = {
            data: this.create(t),
            src: t,
            time: e,
            next: null,
            prev: null
        }, this.cache.set(t, r)) : (r.time = e, r.prev.next = r.next, r.next.prev = r.prev), r.prev = this.tail.prev, r.next = this.tail, this.tail.prev.next = r, this.tail.prev = r, this.scheduleCleanup(), r.data;
    }
};
var fE = class extends K0 {
    create(t) {
        return URL.createObjectURL(new Blob([
            t
        ]));
    }
    dispose(t, e) {
        URL.revokeObjectURL(e);
    }
}, dE;
function TR(n1) {
    return typeof n1 == "string" ? n1 : (dE || (dE = new fE), dE.load(n1));
}
var Q0 = class {
    constructor(t, e){
        this.data = t;
        this.cache = e;
        this.refCount = 0;
    }
    deref() {
        this.refCount;
        this.refCount -= 1, this.refCount === 0 && (this.cache.remove(this), this.dispose());
    }
    dispose() {
        this.refCount;
    }
}, Z0 = class {
    constructor(){
        this.cache = new Map;
    }
    remove(t) {
        this.cache.delete(t.data);
    }
    load(t) {
        let e = this.cache.get(t);
        return e === void 0 && (e = this.create(t), this.cache.set(t, e)), e.refCount += 1, e;
    }
};
var ef = class extends Q0 {
    constructor(e, r){
        super(e, r.imageHolderCache);
        this.data = e;
        this.shared = r;
        this.loaded = !1;
        this.isVideo = !1;
        this.isBuffer = !1;
        this._cache = {
            [1e3]: {},
            [1001]: {},
            [1002]: {}
        };
        this.isVideo = e.type === "video", this.isBuffer = e.isWebGLRenderTarget === !0, this.loadPromise = this.updateSrc(this.isBuffer ? e : e.data);
    }
    async updateSrc(e) {
        if (typeof document > "u") return;
        this.disposeTextures(), this.loaded = !1;
        let r = ()=>{
            this.loaded = !0;
            for (let s of Object.values(this._cache))for (let o of Object.values(s))for (let a of Object.values(o))a && (a.image = this.img, a.needsUpdate = !0);
            this.shared.requestRender();
        };
        if (this.isBuffer) this.img = e, this.loaded = !0;
        else if (this.isVideo) {
            if (this.img = document.createElement("video"), this.img.preload = "auto", this.img.playsInline = !0, this.img.currentTime = .01, typeof e != "string") {
                var i = new FileReader;
                i.readAsDataURL(new Blob([
                    e
                ], {
                    type: "video/mp4"
                }));
                let s;
                await new Promise((o)=>{
                    i.onloadend = (a)=>{
                        s = a.target?.result, o(null);
                    };
                }), this.img.src = s;
            } else this.img.src = e;
            this.img.onloadeddata = ()=>{
                r();
            };
        } else this.img = new Image, this.img.src = TR(e), this.img.onload = r, await new Promise((s)=>{
            this.img.onload = ()=>{
                r(), s(null);
            };
        });
    }
    getTexture(e, r = 1008, i = 1006) {
        let s = this._cache[e]?.[r]?.[i];
        if (s) return s;
        {
            let o;
            return this.isBuffer ? o = this.img.texture : this.isVideo ? o = new gy(this.img, void 0, e, e) : o = new er(this.img, void 0, e, e, i, r), this.loaded && (o.needsUpdate = !0), this._cache[e] === void 0 && (this._cache[e] = {}), this._cache[e][r] === void 0 && (this._cache[e][r] = {}), this._cache[e][r][i] = o, o;
        }
    }
    setNeedsUpdate(e) {
        for (let r of Object.values(this._cache))for (let i of Object.values(r))for (let s of Object.values(i))s && (s.needsUpdate = e);
    }
    disposeTextures() {
        for (let [e, r] of Object.entries(this._cache))for (let [i, s] of Object.entries(r))for (let [o, a] of Object.entries(s))a?.dispose(), this._cache[e] !== void 0 && this._cache[e][i] !== void 0 && (this._cache[e][i][o] = void 0);
    }
    dispose() {
        super.dispose(), this.disposeTextures();
    }
};
var Jn = class extends ef {
};
function mE(n1, t) {
    var e = tX(t);
    return e.formatToParts ? $Y(e, n1) : eX(e, n1);
}
var JY = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $Y(n1, t) {
    try {
        for(var e = n1.formatToParts(t), r = [], i = 0; i < e.length; i++){
            var s = JY[e[i].type];
            s >= 0 && (r[s] = parseInt(e[i].value, 10));
        }
        return r;
    } catch (o) {
        if (o instanceof RangeError) return [
            NaN
        ];
        throw o;
    }
}
function eX(n1, t) {
    var e = n1.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(e);
    return [
        r[3],
        r[1],
        r[2],
        r[4],
        r[5],
        r[6]
    ];
}
var pE = {};
function tX(n1) {
    if (!pE[n1]) {
        var t = new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: "America/New_York",
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z")), e = t === "06/25/2014, 00:00:00" || t === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        pE[n1] = e ? new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: n1,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: n1,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return pE[n1];
}
function J0(n1, t, e, r, i, s, o) {
    var a = new Date(0);
    return a.setUTCFullYear(n1, t, e), a.setUTCHours(r, i, s, o), a;
}
var MR = 36e5, rX = 6e4, gE = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Em(n1, t, e) {
    var r, i;
    if (!n1 || (r = gE.timezoneZ.exec(n1), r)) return 0;
    var s;
    if (r = gE.timezoneHH.exec(n1), r) return s = parseInt(r[1], 10), CR(s) ? -(s * MR) : NaN;
    if (r = gE.timezoneHHMM.exec(n1), r) {
        s = parseInt(r[1], 10);
        var o = parseInt(r[2], 10);
        return CR(s, o) ? (i = Math.abs(s) * MR + o * rX, s > 0 ? -i : i) : NaN;
    }
    if (sX(n1)) {
        t = new Date(t || Date.now());
        var a = e ? t : iX(t), l = yE(a, n1), c = e ? l : nX(t, l, n1);
        return -c;
    }
    return NaN;
}
function iX(n1) {
    return J0(n1.getFullYear(), n1.getMonth(), n1.getDate(), n1.getHours(), n1.getMinutes(), n1.getSeconds(), n1.getMilliseconds());
}
function yE(n1, t) {
    var e = mE(n1, t), r = J0(e[0], e[1] - 1, e[2], e[3] % 24, e[4], e[5], 0).getTime(), i = n1.getTime(), s = i % 1e3;
    return i -= s >= 0 ? s : 1e3 + s, r - i;
}
function nX(n1, t, e) {
    var r = n1.getTime(), i = r - t, s = yE(new Date(i), e);
    if (t === s) return t;
    i -= s - t;
    var o = yE(new Date(i), e);
    return s === o ? s : Math.max(s, o);
}
function CR(n1, t) {
    return -23 <= n1 && n1 <= 23 && (t == null || 0 <= t && t <= 59);
}
var PR = {};
function sX(n1) {
    if (PR[n1]) return !0;
    try {
        return new Intl.DateTimeFormat(void 0, {
            timeZone: n1
        }), PR[n1] = !0, !0;
    } catch  {
        return !1;
    }
}
var VR = Wa(IR(), 1), bE = Wa(OR(), 1);
var lX = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, RR = lX;
var vE = 36e5, LR = 6e4, cX = 2, Sn = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    timeZone: RR
};
function SE(n1, t) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (n1 === null) return new Date(NaN);
    var e = t || {}, r = e.additionalDigits == null ? cX : (0, VR.default)(e.additionalDigits);
    if (r !== 2 && r !== 1 && r !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (n1 instanceof Date || typeof n1 == "object" && Object.prototype.toString.call(n1) === "[object Date]") return new Date(n1.getTime());
    if (typeof n1 == "number" || Object.prototype.toString.call(n1) === "[object Number]") return new Date(n1);
    if (!(typeof n1 == "string" || Object.prototype.toString.call(n1) === "[object String]")) return new Date(NaN);
    var i = uX(n1), s = hX(i.date, r), o = s.year, a = s.restDateString, l = dX(a, o);
    if (isNaN(l)) return new Date(NaN);
    if (l) {
        var c = l.getTime(), u = 0, h;
        if (i.time && (u = fX(i.time), isNaN(u))) return new Date(NaN);
        if (i.timeZone || e.timeZone) {
            if (h = Em(i.timeZone || e.timeZone, new Date(c + u)), isNaN(h)) return new Date(NaN);
        } else h = (0, bE.default)(new Date(c + u)), h = (0, bE.default)(new Date(c + u + h));
        return new Date(c + u + h);
    } else return new Date(NaN);
}
function uX(n1) {
    var t = {}, e = Sn.dateTimePattern.exec(n1), r;
    if (e ? (t.date = e[1], r = e[3]) : (e = Sn.datePattern.exec(n1), e ? (t.date = e[1], r = e[2]) : (t.date = null, r = n1)), r) {
        var i = Sn.timeZone.exec(r);
        i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
    }
    return t;
}
function hX(n1, t) {
    var e = Sn.YYY[t], r = Sn.YYYYY[t], i;
    if (i = Sn.YYYY.exec(n1) || r.exec(n1), i) {
        var s = i[1];
        return {
            year: parseInt(s, 10),
            restDateString: n1.slice(s.length)
        };
    }
    if (i = Sn.YY.exec(n1) || e.exec(n1), i) {
        var o = i[1];
        return {
            year: parseInt(o, 10) * 100,
            restDateString: n1.slice(o.length)
        };
    }
    return {
        year: null
    };
}
function dX(n1, t) {
    if (t === null) return null;
    var e, r, i, s;
    if (n1.length === 0) return r = new Date(0), r.setUTCFullYear(t), r;
    if (e = Sn.MM.exec(n1), e) return r = new Date(0), i = parseInt(e[1], 10) - 1, NR(t, i) ? (r.setUTCFullYear(t, i), r) : new Date(NaN);
    if (e = Sn.DDD.exec(n1), e) {
        r = new Date(0);
        var o = parseInt(e[1], 10);
        return gX(t, o) ? (r.setUTCFullYear(t, 0, o), r) : new Date(NaN);
    }
    if (e = Sn.MMDD.exec(n1), e) {
        r = new Date(0), i = parseInt(e[1], 10) - 1;
        var a = parseInt(e[2], 10);
        return NR(t, i, a) ? (r.setUTCFullYear(t, i, a), r) : new Date(NaN);
    }
    if (e = Sn.Www.exec(n1), e) return s = parseInt(e[1], 10) - 1, FR(t, s) ? BR(t, s) : new Date(NaN);
    if (e = Sn.WwwD.exec(n1), e) {
        s = parseInt(e[1], 10) - 1;
        var l = parseInt(e[2], 10) - 1;
        return FR(t, s, l) ? BR(t, s, l) : new Date(NaN);
    }
    return null;
}
function fX(n1) {
    var t, e, r;
    if (t = Sn.HH.exec(n1), t) return e = parseFloat(t[1].replace(",", ".")), xE(e) ? e % 24 * vE : NaN;
    if (t = Sn.HHMM.exec(n1), t) return e = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), xE(e, r) ? e % 24 * vE + r * LR : NaN;
    if (t = Sn.HHMMSS.exec(n1), t) {
        e = parseInt(t[1], 10), r = parseInt(t[2], 10);
        var i = parseFloat(t[3].replace(",", "."));
        return xE(e, r, i) ? e % 24 * vE + r * LR + i * 1e3 : NaN;
    }
    return null;
}
function BR(n1, t, e) {
    t = t || 0, e = e || 0;
    var r = new Date(0);
    r.setUTCFullYear(n1, 0, 4);
    var i = r.getUTCDay() || 7, s = t * 7 + e + 1 - i;
    return r.setUTCDate(r.getUTCDate() + s), r;
}
var pX = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], mX = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function kR(n1) {
    return n1 % 400 === 0 || n1 % 4 === 0 && n1 % 100 !== 0;
}
function NR(n1, t, e) {
    if (t < 0 || t > 11) return !1;
    if (e != null) {
        if (e < 1) return !1;
        var r = kR(n1);
        if (r && e > mX[t] || !r && e > pX[t]) return !1;
    }
    return !0;
}
function gX(n1, t) {
    if (t < 1) return !1;
    var e = kR(n1);
    return !(e && t > 366 || !e && t > 365);
}
function FR(n1, t, e) {
    return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function xE(n1, t, e) {
    return !(n1 != null && (n1 < 0 || n1 >= 25) || t != null && (t < 0 || t >= 60) || e != null && (e < 0 || e >= 60));
}
function tx(n1, t, e) {
    var r = SE(n1, e), i = Em(t, r, !0), s = new Date(r.getTime() - i), o = new Date(0);
    return o.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), o.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), o;
}
function Qi(n1, t) {
    return t.color(n1);
}
function wE(n1 = new Date, t) {
    let e = t.format, r = n1.getSeconds(), i = n1;
    t && t.timeZone !== null && (i = tx(new Date, t.timeZone));
    let s = i.getHours(), o = i.getMinutes(), a;
    t.format12h24h === "12ampm" && (a = s >= 12 ? "PM" : "AM");
    let l = s;
    t.format12h24h !== "24" && (l = s % 12, l === 0 && (l = 12));
    let c, u;
    switch(e){
        case "HH:mm:ss":
            c = [
                l,
                o,
                r
            ];
            break;
        case "HH:mm":
            c = [
                l,
                o
            ];
            break;
        case "HH":
            c = [
                l
            ], a = void 0;
            break;
        case "mm":
            c = [
                o
            ], a = void 0;
            break;
        case "ss":
            c = [
                r
            ], a = void 0;
            break;
        case "year":
            u = i.getFullYear();
            break;
        case "month":
            u = i.getMonth() + 1;
            break;
        case "dayOfYear":
            u = Math.floor((i.getTime() - new Date(i.getFullYear(), 0, 0).getTime()) / 864e5);
            break;
        case "dayOfMonth":
            u = i.getDate();
            break;
        case "secondOfDay":
            u = s * 3600 + o * 60 + r;
            break;
        default:
            console.error("Unknown time format", e), u = 0;
            break;
    }
    return c !== void 0 ? {
        textValue: c,
        suffix: a
    } : u;
}
function UR(n1, t) {
    switch(n1.type){
        case "fresnel":
            return xX(n1, t);
        case "gradient":
            return bX(n1, t);
        case "depth":
            return SX(n1, t);
        case "normal":
            return wX(n1, t);
        case "noise":
            return AX(n1, t);
        case "rainbow":
            return EX(n1, t);
        case "toon":
            return TX(n1, t);
        case "outline":
            return MX(n1, t);
        case "transmission":
            return CX(n1, t);
        case "color":
            return vX(n1, t);
        case "pattern":
            return PX(n1, t);
    }
}
function yX(n1) {
    return {
        type: n1.type
    };
}
function Qs(n1, t) {
    let { alpha: e, mode: r, isMask: i } = n1, s = typeof e == "string" ? (Number(t.getVariable(e)) ?? 100) / 100 : e;
    return {
        ...yX(n1),
        alpha: s,
        mode: r,
        isMask: i
    };
}
function vX(n1, t) {
    return {
        ...Qs(n1, t),
        color: Qi(n1.color, t)
    };
}
function xX(n1, t) {
    let { bias: e, scale: r, intensity: i, factor: s, color: o } = n1;
    return {
        ...Qs(n1, t),
        color: Qi(o, t),
        bias: e,
        scale: r,
        intensity: i,
        factor: s
    };
}
function bX(n1, t) {
    let { gradientType: e, smooth: r, colors: i, steps: s, angle: o, offset: a, morph: l } = n1;
    return {
        ...Qs(n1, t),
        gradientType: e,
        smooth: r,
        colors: i.map((c)=>new Ze(c[0], c[1], c[2], c[3])),
        num: i.length,
        steps: s,
        offset: new k(...a),
        morph: new k(...l),
        angle: o
    };
}
function SX(n1, t) {
    let { gradientType: e, near: r, far: i, isVector: s, isWorldSpace: o, origin: a, direction: l, colors: c, steps: u, smooth: h } = n1;
    return {
        ...Qs(n1, t),
        gradientType: e,
        near: r,
        far: i,
        isVector: s,
        isWorldSpace: o,
        origin: new E(...a),
        direction: l ? new E(...l) : new E(1, 0, 0),
        colors: c.map((d)=>d !== void 0 ? new Ze(d[0], d[1], d[2], d[3]) : new Ze(0, 0, 0, 0)),
        steps: u.slice(0, c.length),
        smooth: h
    };
}
function wX(n1, t) {
    let { cnormal: e } = n1;
    return {
        ...Qs(n1, t),
        cnormal: new E(e[0], e[1], e[2])
    };
}
function AX(n1, t) {
    return {
        ...Qs(n1, t),
        scale: n1.scale,
        move: n1.move,
        fA: new k(...n1.fA),
        fB: new k(...n1.fB),
        size: new E(...n1.size),
        distortion: new k(...n1.distortion),
        colorA: Qi(n1.colorA, t),
        colorB: Qi(n1.colorB, t),
        colorC: Qi(n1.colorC, t),
        colorD: Qi(n1.colorD, t),
        noiseType: n1.noiseType,
        voronoiStyle: n1.voronoiStyle,
        highCut: n1.highCut,
        lowCut: n1.lowCut,
        smoothness: n1.smoothness,
        seed: n1.seed,
        quality: n1.quality
    };
}
function EX(n1, t) {
    return {
        ...Qs(n1, t),
        filmThickness: n1.filmThickness,
        movement: n1.movement,
        wavelengths: new E(...n1.wavelengths),
        noiseStrength: n1.noiseStrength,
        noiseScale: n1.noiseScale,
        offset: new E(...n1.offset)
    };
}
function TX(n1, t) {
    return {
        ...Qs(n1, t),
        positioning: n1.positioning,
        colors: n1.colors.map((e)=>new Ze(e[0], e[1], e[2], e[3])),
        num: n1.colors.length,
        steps: n1.steps,
        source: new E(...n1.source),
        isWorldSpace: n1.isWorldSpace,
        noiseStrength: n1.noiseStrength,
        noiseScale: n1.noiseScale,
        shadowColor: Qi(n1.shadowColor, t),
        offset: new E(...n1.offset)
    };
}
function MX(n1, t) {
    return {
        ...Qs(n1, t),
        outlineColor: Qi(n1.outlineColor, t),
        contourColor: Qi(n1.contourColor, t),
        outlineWidth: n1.outlineWidth,
        contourWidth: n1.contourWidth,
        outlineThreshold: n1.outlineThreshold,
        contourThreshold: n1.contourThreshold,
        outlineSmoothing: n1.outlineSmoothing,
        contourFrequency: n1.contourFrequency,
        contourDirection: new E(...n1.contourDirection),
        positionalLines: n1.positionalLines,
        compensation: n1.compensation
    };
}
function CX(n1, t) {
    return {
        ...Qs(n1, t),
        thickness: n1.thickness,
        ior: n1.ior,
        roughness: n1.roughness
    };
}
function PX(n1, t) {
    return {
        ...Qs(n1, t),
        style: n1.style,
        projection: n1.projection,
        axis: n1.axis,
        blending: n1.blending,
        offset: new k(...n1.offset),
        colorA: Qi(n1.colorA, t),
        colorB: Qi(n1.colorB, t),
        frequency: new k(...n1.frequency),
        size: n1.size,
        variation: n1.variation,
        smoothness: n1.smoothness,
        zigzag: n1.zigzag,
        rotation: n1.rotation,
        vertical: new k(...n1.vertical),
        horizontal: new k(...n1.horizontal),
        sides: n1.sides
    };
}
var Ul = class extends vr {
};
var _X = {
    noise: [
        "noiseType"
    ],
    texture: [
        "projection",
        "axis",
        "side"
    ],
    video: [
        "projection",
        "axis",
        "side"
    ],
    displace: [
        "noiseType"
    ],
    light: [
        "roughnessMap",
        "bumpMap"
    ],
    depth: [
        "smooth",
        "isWorldSpace",
        "gradientType",
        "isVector"
    ],
    pattern: [
        "style",
        "projection",
        "axis"
    ]
}, IX = {
    depth: [
        "colors"
    ]
};
function DX(n1, t, e) {
    if (t === "isMask") return !0;
    let r = _X[n1.type], i = IX[n1.type];
    if (i !== void 0) {
        let s = n1.color;
        if (i.includes(t)) {
            let o = s[t]?.value?.length;
            if (o !== void 0 && o !== e.length) return !0;
        }
    }
    return r !== void 0 ? r.includes(t) : !1;
}
function AE(n1, t, e) {
    let r = e.uniforms[`f${e.id}_texture`];
    if (!r) return !1;
    let i = !1, s = n1;
    if ("image" in s) {
        let o = s.image, a = t.image(o), l = r;
        l.image instanceof Jn || l.image.deref(), l.image = a;
    }
    if ("video" in s) {
        let o = s.video, a = t.video(o), l = r;
        l.image instanceof Jn || l.image.deref(), l.image = a;
    }
    if ("wrapping" in s) {
        let o = r;
        o.wrap = s.wrapping;
    }
    if ("minFilter" in s) {
        let o = r;
        o.minFilter = s.minFilter;
    }
    if ("magFilter" in s) {
        let o = r;
        o.magFilter = s.magFilter;
    }
    if ("rotation" in s && e.uniforms[`f${e.id}_rotation`]) return e.uniforms[`f${e.id}_rotation`].value = (s.rotation ?? 0) * we.DEG2RAD, i;
    if ("repeat" in s || "offset" in s || "rotation" in s) {
        let o = "mat", a = e.uniforms[`f${e.id}_${o}`];
        "repeat" in s && (a.repeat = s.repeat), "offset" in s && (a.offset = s.offset), "rotation" in s && (a.rotation = s.rotation ?? 0), a.updateMatrix();
    }
    return i;
}
function zR(n1, t, e, r) {
    let i = !1;
    for (let [s, o] of Object.entries(n1)){
        if (s === "bumpMap" || s === "roughnessMap") {
            i = !0;
            continue;
        }
        if (!s || o === void 0) continue;
        if (EE(s, e, r, t)) {
            s === "visible" && e.type === "light" && (i = !0);
            continue;
        }
        e.visible = r.visible;
        let a = e.uniforms[`f${e.id}_${s}`];
        if (!!a && !(a instanceof Vl)) switch(i = i || DX(e, s, o), a.constructor){
            case tr:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof Ul ? a.value = new vr(l.r, l.g, l.b, l.a) : a.setRGBA(l);
                    break;
                }
            case Ln:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof Ul ? a.value = new vr(l.r, l.g, l.b, l.a) : a.value.setRGBA(l.r, l.g, l.b, l.a);
                    break;
                }
            case Hr:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]);
                    break;
                }
            case Xi:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]), a.value.setZ(l[2]);
                    break;
                }
            case bn:
                AE(o, t, e);
                break;
            case Ks:
                a.value = o.map((l)=>new Ze(...l));
                break;
            default:
                a.value = o;
                break;
        }
    }
    return i;
}
var zl = (n1, t, e)=>Math.max(0, Math.min(1, Number(t.getVariable(typeof n1 == "number" ? n1 * 100 : n1, e) ?? 100) / 100)) ?? 1, Gl = class {
    constructor(t, e, r, i, s){
        this.id = t;
        this.uuid = e;
        this.data = r;
        this.uniforms = {};
        for(let o in i)this.uniforms[`f${this.id}_${o}`] = i[o];
        for(let o in r)EE(o, this, r, s);
    }
    get type() {
        return this.data.type;
    }
    static create(t, e, r, i) {
        if (r.type === "light") return wn.createLightLayer(t, e, r, i);
        if (r.type === "texture" || r.type === "video") {
            let s = r.type === "texture" ? i.uiBuffer(r.texture.image) ?? i.image(r.texture.image) : i.video(r.texture.video), o = new qc(s, r.texture.wrapping, r.texture.minFilter ?? 1008, r.texture.magFilter ?? 1006), a = new q0(s), l = new Y0(r.texture.repeat, r.texture.offset, r.texture.rotation ?? 0), c = new Fe(r.crop ? 1 : 0), u = new Dt(r.projection ?? 0), h = new Dt([
                "x",
                "y",
                "z"
            ].indexOf(r.axis) ?? 0), d = new Dt(r.side ?? 0), f = new Hr(r.size ? new k(r.size[0], r.size[1]) : new k(100, 100)), p = new Fe(r.blending ?? 0), m = new Fe(zl(r.alpha, i)), g = new Dt(r.mode ?? 0), y = new Qr(r.isMask ?? !1), x = new kl(o, a, c, u, h, d, f, p, l, m, g, y), v = new Kt(x.calpha, "f");
            return new Or(t, e, r, {
                texture: o,
                textureSize: a,
                crop: c,
                projection: u,
                axis: h,
                side: d,
                size: f,
                blending: p,
                mat: l,
                alpha: m,
                mode: g,
                isMask: y
            }, x, g, v, y, i);
        } else if (r.type === "matcap") {
            let s = i.image(r.texture.image), o = new qc(s, r.texture.wrapping, r.texture.minFilter ?? 1008, r.texture.magFilter ?? 1006), a = new Fe(zl(r.alpha, i)), l = new Dt(r.mode ?? 0), c = new Qr(r.isMask ?? !1), u = new Fe((r.texture.rotation ?? 0) * we.DEG2RAD), h = new qd(o, a, l, c, u), d = new Kt(h.calpha, "f");
            return new Or(t, e, r, {
                texture: o,
                alpha: a,
                mode: l,
                isMask: c,
                rotation: u
            }, h, l, d, c, i);
        } else if (r.type === "displace") {
            if (r.displacementType === "noise") {
                let s = new Xi(new E(...r.offset)), o = new Fe(r.scale ?? 10), a = new Fe(r.intensity ?? 8), l = new Fe(r.movement ?? 1), c = new Dt(r.noiseType ?? 0), u = new Dt(r.voronoiStyle ?? 0), h = new Fe(r.smoothness ?? .5), d = new Fe(r.seed ?? 0), f = new Fe(r.highCut ?? 1), p = new Fe(r.lowCut ?? 0), m = new Dt(r.quality ?? 1), g = new $d(a, l, s, u, h, d, f, p, m, o, c);
                return new Tm(t, e, r, {
                    offset: s,
                    scale: o,
                    intensity: a,
                    movement: l,
                    noiseType: c,
                    voronoiStyle: u,
                    smoothness: h,
                    seed: d,
                    highCut: f,
                    lowCut: p,
                    quality: m
                }, g, i);
            } else throw new Error;
        } else return LX(t, e, r, i);
    }
    updateByOp(t, e, r) {
        let i = t;
        if (i.path[0] === void 0) {
            if (i.type === 0) return "type" in i.props || "category" in i.props || "visible" in i.props || "noiseType" in i.props ? (r.scene.markNeedsUpdateRendererDirty(), !0) : zR(i.props, r.shared, this, e);
        } else if (i.path[0] === "texture") return "texture" in e || "video" in e ? AE(i.props, r.shared, this) : !0;
        return !1;
    }
    dispose() {
        if (OX(this)) {
            let t = this.uniforms[`f${this.id}_texture`];
            if (!t) return !1;
            let e = t;
            e.image instanceof Jn || e.image.deref();
        }
    }
    hasValueByKey(t) {
        return this.uniforms[t] !== void 0;
    }
    hasValue(t) {
        return this.hasValueByKey(`f${this.id}_${t}`);
    }
    setValue(t, e) {
        let r = `f${this.id}_${t}`;
        this.hasValueByKey(r) && e !== void 0 && (this.uniforms[r].value = e);
    }
    getNode(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e];
    }
    getValue(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e].value;
    }
    getName(t) {
        let r = /f\d+_(.*)/.exec(t);
        if (r && r.length > 1) return r[1];
        console.log(`Layer.getName: error ${t}`);
    }
    getNames() {
        let t = [];
        for(let e in this.uniforms){
            let r = this.getName(e);
            r && t.push(r);
        }
        return t;
    }
}, Or = class extends Gl {
    constructor(e, r, i, s, o, a, l, c, u){
        super(e, r, i, s, u);
        this.params = s;
        this.color = o;
        this.mode = a;
        this.alpha = l;
        this.isMask = c;
    }
}, Tm = class extends Gl {
    constructor(e, r, i, s, o, a){
        super(e, r, i, s, a);
        this.position = o;
    }
}, wn = class extends Gl {
    constructor(e, r, i, s, o, a){
        super(e, r, i, o, a);
        this.node = s;
    }
    static createLightLayer(e, r, i, s) {
        let o, a = new Fe(zl(i.alpha, s)), l = new Dt(i.mode), c = new Fe(i.bumpMapIntensity), u = new Fe(zl(i.alphaOverride, s)), h;
        if (!i.visible) o = new Da, h = {};
        else if (i.category === "lambert") {
            o = new bm;
            let d = new tr(s.color(i.emissive) ?? 0), f = new Qr(i.occlusion ?? !0);
            h = {
                emissive: d,
                occlusion: f
            }, o.emissive = d, o.occlusion = f;
        } else if (i.category === "toon") {
            o = new Am;
            let d = new Fe(i.shininess ?? 30), f = new tr(s.color(i.specular) ?? 1118481);
            h = {
                shininess: d,
                specular: f
            }, o.shininess = d, o.specular = f;
        } else if (i.category === "physical") {
            o = new wm;
            let d = new Fe(i.roughness ?? .3), f = new Fe(i.metalness ?? 0), p = new Fe(i.reflectivity ?? .5), m = new Qr(i.occlusion ?? !0);
            h = {
                roughness: d,
                metalness: f,
                reflectivity: p,
                occlusion: m
            }, o.roughness = d, o.metalness = f, o.reflectivity = p, o.occlusion = m;
        } else {
            o = new Sm;
            let d = new Fe(i.shininess ?? 30), f = new tr(i.specular !== void 0 ? s.color(i.specular) ?? 1118481 : 1118481), p = new Qr(i.occlusion ?? !0);
            h = {
                shininess: d,
                specular: f,
                occlusion: p
            }, o.shininess = d, o.specular = f, o.occlusion = p;
        }
        return o.alpha = new Fe(1), o.shadingAlpha = a, o.shadingBlend = l, o.bumpMapIntensity = c, o.alphaOverride = u, h.alpha = o.shadingAlpha, h.mode = o.shadingBlend, h.bumpMapIntensity = o.bumpMapIntensity, h.alphaOverride = o.alphaOverride, new wn(e, r, i, o, h, s);
    }
    get category() {
        return this.node.category;
    }
};
function OX(n1) {
    let t = n1 instanceof Gl ? n1.type : n1;
    return t === "texture" || t === "video" || t === "displace_map" || t === "matcap";
}
function gs(n1) {
    return {
        alpha: new Fe(n1.alpha ?? 1),
        mode: new Dt(n1.mode ?? 0),
        isMask: new Qr(n1.isMask ?? !1)
    };
}
function RX(n1, t, e, r, i) {
    switch(n1.type){
        case "color":
            {
                let s = new tr(r.color ?? ii), o = gs(r), a = new Yc(s, o.alpha), l = new Kt(a.calpha, "f");
                return new Or(t, e, n1, {
                    color: s,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
        case "fresnel":
            {
                let s = new tr(r.color ?? 16777215), o = new Fe(r.bias ?? .1), a = new Fe(r.scale ?? 1), l = new Fe(r.intensity ?? 2), c = new Fe(r.factor ?? 1), u = gs(r), h = new xm(s, o, a, l, c, u.alpha, u.mode, u.isMask), d = new Kt(h.calpha, "f");
                return new Or(t, e, n1, {
                    color: s,
                    bias: o,
                    scale: a,
                    intensity: l,
                    factor: c,
                    ...u
                }, h, u.mode, d, u.isMask, i);
            }
        case "rainbow":
            {
                let s = new Fe(r.filmThickness ?? 30), o = new Fe(r.movement ?? 0), a = new Xi(r.wavelengths ?? new E(0, 0, 0)), l = new Fe(r.noiseStrength ?? 0), c = new Fe(r.noiseScale ?? 1), u = new Xi(r.offset ?? new E(0, 0, 0)), h = gs(r), d = new Qd(s, o, a, l, c, u, h.alpha, h.isMask), f = new Kt(d.calpha, "f");
                return new Or(t, e, n1, {
                    filmThickness: s,
                    movement: o,
                    wavelengths: a,
                    noiseStrength: l,
                    noiseScale: c,
                    offset: u,
                    ...h
                }, d, h.mode, f, h.isMask, i);
            }
        case "transmission":
            {
                let s = new Fe(r.thickness ?? 10), o = new Fe(r.ior ?? 1.5), a = new Fe(r.roughness ?? .5), l = $e.transmissionSize, c = $e.transmissionRenderTarget, u = $e.transmissionRenderTargetDepth, h = window.innerWidth, d = window.innerHeight, f = h >= d ? new Hr(d / h, 1) : new Hr(1, h / d), p = gs(r), m = new Jd(s, o, a, l, c, u, f, p.alpha), g = new Kt(m.calpha, "f");
                return new Or(t, e, n1, {
                    thickness: s,
                    ior: o,
                    roughness: a,
                    aspectRatio: f,
                    ...p
                }, m, p.mode, g, p.isMask, i);
            }
        case "toon":
            {
                let s = new Dt(r.positioning ?? 0), o;
                r.colors ? o = new Ks(r.colors.length, r.colors) : (o = new Ks(10, new Ze(0, 0, 0, 1)), o.value[1] = new Ze(1, 1, 1, 1));
                let a;
                r.steps ? a = new Xs(r.steps.length, r.steps) : (a = new Xs(10, 1), a.value[0] = 0);
                let l = new Xi(r.source ?? new E(0, 0, 0)), c = new Qr(r.isWorldSpace ?? !0), u = new Fe(r.noiseStrength ?? 0), h = new Fe(r.noiseScale ?? 1), d = new Ln(r.shadowColor), f = new Xi(r.offset ?? new E(0, 0, 0)), p = gs(r), m = new Zd(s, o, a, l, c, u, h, d, f, p.alpha), g = new Kt(m.calpha, "f");
                return new Or(t, e, n1, {
                    positioning: s,
                    colors: o,
                    steps: a,
                    source: l,
                    isWorldSpace: c,
                    noiseStrength: u,
                    noiseScale: h,
                    shadowColor: d,
                    offset: f,
                    ...p
                }, m, p.mode, g, p.isMask, i);
            }
        case "outline":
            {
                let s = new tr(r.outlineColor ?? 16777215), o = new tr(r.contourColor ?? 16777215), a = new Fe(r.outlineWidth ?? .1), l = new Fe(r.contourWidth ?? .1), c = new Fe(r.outlineThreshold ?? .1), u = new Fe(r.contourThreshold ?? .1), h = new Fe(r.outlineSmoothing ?? .1), d = new Fe(r.contourFrequency ?? .1), f = new Xi(r.contourDirection ?? new E(0, 1, 0)), p = new Qr(r.positionalLines ?? !1), m = new Qr(r.compensation ?? !0), g = $e.normalRenderTarget, y = $e.normalRenderTargetDepth, x = $e.pixelRatioNode, v = $e.resolution, S = gs(r), w = new Xd(s, o, a, l, c, u, h, d, f, p, m, v, g, y, x, S.alpha), A = new Kt(w.calpha, "f");
                return new Or(t, e, n1, {
                    outlineColor: s,
                    contourColor: o,
                    outlineWidth: a,
                    contourWidth: l,
                    outlineThreshold: c,
                    contourThreshold: u,
                    outlineSmoothing: h,
                    contourFrequency: d,
                    contourDirection: f,
                    positionalLines: p,
                    compensation: m,
                    ...S
                }, w, S.mode, A, S.isMask, i);
            }
        case "depth":
            {
                let s = new Dt(r.gradientType ?? 0), o = new Qr(r.smooth ?? !1), a = new Fe(r.near ?? 50), l = new Fe(r.far ?? 200), c = new Fe(r.isVector ?? 1), u = new Fe(r.isWorldSpace ?? 0), h = new Xi(r.origin ?? new E), d = new Xi(r.direction ?? new E), f;
                r.colors ? f = new Ks(r.colors.length, r.colors) : (f = new Ks(2, new Ze(0, 0, 0, 1)), f.value[1] = new Ze(1, 1, 1, 1));
                let p;
                r.steps ? p = new Xs(r.steps.length, r.steps) : (p = new Xs(2, 1), p.value[0] = 0);
                let m = gs(r), g = new Hd(s, o, a, l, c, u, h, d, f, p, m.alpha, m.isMask), y = new Kt(g.calpha, "f");
                return new Or(t, e, n1, {
                    gradientType: s,
                    smooth: o,
                    near: a,
                    far: l,
                    isVector: c,
                    isWorldSpace: u,
                    origin: h,
                    direction: d,
                    colors: f,
                    steps: p,
                    ...m
                }, g, m.mode, y, m.isMask, i);
            }
        case "noise":
            {
                let s = new Fe(r.scale ?? 1), o = new Xi(r.size ?? new E(100, 100, 100)), a = new Fe(r.move ?? 1), l = new Hr(r.fA ?? new k(1.7, 9.2)), c = new Hr(r.fB ?? new k(8.3, 2.8)), u = new Hr(r.distortion ?? new k(1, 1)), h = new Ln(r.colorA), d = new Ln(r.colorB), f = new Ln(r.colorC), p = new Ln(r.colorD), m = new Dt(r.noiseType ?? 0), g = new Dt(r.voronoiStyle ?? 0), y = new Fe(r.highCut ?? 1), x = new Fe(r.lowCut ?? 0), v = new Fe(r.smoothness ?? .5), S = new Fe(r.seed ?? .5), w = new Dt(r.quality ?? 1), A = gs(r), T = new Yd(s, o, a, l, c, u, h, d, f, p, A.alpha, m, A.isMask, g, y, x, v, S, w), b = new Kt(T.calpha, "f");
                return new Or(t, e, n1, {
                    scale: s,
                    size: o,
                    move: a,
                    fA: l,
                    fB: c,
                    distortion: u,
                    colorA: h,
                    colorB: d,
                    colorC: f,
                    colorD: p,
                    noiseType: m,
                    ...A,
                    voronoiStyle: g,
                    highCut: y,
                    lowCut: x,
                    smoothness: v,
                    seed: S,
                    quality: w
                }, T, A.mode, b, A.isMask, i);
            }
        case "normal":
            {
                let s = new Xi(r.cnormal ?? new E(1, 1, 1)), o = gs(r), a = new zd(s, o.alpha), l = new Kt(a.calpha, "f");
                return new Or(t, e, n1, {
                    cnormal: s,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
        case "gradient":
            {
                let s = new Dt(r.gradientType ?? 0), o = new Qr(r.smooth ?? !1), a;
                r.colors ? a = new Ks(r.colors.length, r.colors) : (a = new Ks(10, new Ze(0, 0, 0, 1)), a.value[1] = new Ze(1, 1, 1, 1));
                let l;
                r.steps ? l = new Xs(r.steps.length, r.steps) : (l = new Xs(10, 1), l.value[0] = 0);
                let c = new Hr(r.offset ?? new k(0, 0)), u = new Hr(r.morph ?? new k(0, 0)), h = new Fe(r.angle ?? 0), d = gs(r), f = new Wd(s, o, a, l, c, u, h, d.alpha, d.isMask), p = new Kt(f.calpha, "f");
                return new Or(t, e, n1, {
                    gradientType: s,
                    smooth: o,
                    colors: a,
                    steps: l,
                    offset: c,
                    morph: u,
                    angle: h,
                    ...d
                }, f, d.mode, p, d.isMask, i);
            }
        case "pattern":
            {
                let s = new Dt(r.style ?? 0), o = new Dt(r.projection ?? 0), a = new Dt([
                    "x",
                    "y",
                    "z"
                ].indexOf(r.axis) ?? 0), l = new Fe(r.blending ?? 0), c = new Hr(r.offset ?? new k(0, 0)), u = new Ln(r.colorA), h = new Ln(r.colorB), d = new Hr(r.frequency ?? new k(10, 10)), f = new Fe(r.size ?? .5), p = new Fe(r.variation ?? 0), m = new Fe(r.smoothness ?? .5), g = new Fe(r.zigzag ?? 0), y = new Fe(r.rotation ?? 0), x = new Hr(r.vertical ?? new k(0, 1)), v = new Hr(r.horizontal ?? new k(0, 1)), S = new Dt(r.sides ?? 6), w = gs(r), A = new Kd(s, o, a, l, c, u, h, d, f, p, m, g, y, x, v, S, w.alpha, w.isMask), T = new Kt(A.calpha, "f");
                return new Or(t, e, n1, {
                    style: s,
                    projection: o,
                    axis: a,
                    blending: l,
                    offset: c,
                    colorA: u,
                    colorB: h,
                    frequency: d,
                    size: f,
                    variation: p,
                    smoothness: m,
                    zigzag: g,
                    rotation: y,
                    vertical: x,
                    horizontal: v,
                    sides: S,
                    ...w
                }, A, w.mode, T, w.isMask, i);
            }
        default:
            {
                let s = new tr(1, 0, 0, 1), o = gs(r), a = new Yc(s, o.alpha), l = new Kt(a.calpha, "f");
                return new Or(t, e, n1, {
                    color: s,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
    }
}
function LX(n1, t, e, r) {
    let i = UR(e, r);
    return RX(e, n1, t, i, r);
}
function EE(n1, t, e, r) {
    if (e.type === "displace" && (n1 === "intensity" || n1 === "visible")) {
        let i = t.uniforms[`f${t.id}_intensity`];
        return i ? (i.value = e.intensity * (e.visible ? 1 : 0), i) : void 0;
    }
    if (e.type !== "displace" && (n1 === "alpha" || n1 === "visible")) {
        let i = t.uniforms[`f${t.id}_alpha`];
        if (!i) return;
        if (i.value = zl(e.alpha, r) * (e.visible ? 1 : 0), e.type === "outline" && n1 === "visible") {
            let s = t.uniforms[`f${t.id}_compensation`];
            s && (s.value = e.compensation && e.visible);
        }
        return i;
    }
}
function Kc(n1, t) {
    let e = 0, r = n1.layers.find((i)=>i.data.type === "light");
    if (r) {
        let i = r.data, s = Number(t.getVariable(i.alphaOverride));
        if ((typeof i.alphaOverride == "string" ? s / 100 : i.alphaOverride) < 1) return !0;
    }
    for (let i of n1.layers){
        if (i.data.type !== "displace" && i.data.isMask) return !0;
        if (i.data.type !== "displace" && "alpha" in i.data && i.data.type !== "light" && i.data.type !== "fresnel" && i.data.type !== "texture" && i.data.type !== "matcap" && i.data.type !== "rainbow" && i.data.type !== "outline" && i.data.type !== "pattern") {
            let s = i.data.visible ? i.data.alpha : 0;
            if (typeof s == "string" && (s = Math.max(0, Math.min(1, Number(t.getVariable(s) ?? 100) / 100))), s === 1 && i.data.type === "depth" || i.data.type === "gradient") {
                for (let o of i.data.colors)if (o[3] < 1) {
                    s = o[3];
                    break;
                }
            } else if (s === 1 && i.data.type === "noise") {
                let o = t.color(i.data.colorA).a, a = t.color(i.data.colorB).a, l = t.color(i.data.colorC).a, c = t.color(i.data.colorD).a, u = Math.min(o, Math.min(a, Math.min(l, c)));
                u < 1 && (s = u);
            }
            e += (1 - e) * s;
        }
    }
    return e < 1;
}
var Nn = class extends it {
    constructor(){
        super(void 0);
        this.flatShading = !1;
        this.needsJitter = !0;
        this.nodeContextUuid = 0;
        this.fog = !0, this.dithering = !0, this.vertexColors = !0, this.transparent = !0;
    }
    customProgramCacheKey() {
        return "";
    }
}, rx = class extends Nn {
    constructor(e, r, i, s){
        super();
        this.flatShading = e;
        this.side = r;
        this.wireframe = i;
        this.root = s;
    }
    updateAfterBuild() {
        let e = this.root;
        this.lights = e.lights, this.vertexShader = e.vertexShader, this.fragmentShader = e.fragmentShader, this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.transparent = e.transparent, this.cacheKey = e.customProgramCacheKey() + "flat" + this.flatShading + this.side;
    }
    onBeforeCompile(e, r) {
        this.root.onBeforeCompile(e);
    }
    get data() {
        return this.root.data;
    }
    get category() {
        return this.root.category;
    }
    get hasAO() {
        return this.root.hasAO;
    }
    getFlavor(e, r, i) {
        return this.root.getFlavor(e, r, i);
    }
    get layers() {
        return this.root.layers;
    }
    get fragment() {
        return this.root.fragment;
    }
    getLayersOfType(e) {
        return this.root.getLayersOfType(e);
    }
    getLayerByUuid(e) {
        return this.root.getLayerByUuid(e);
    }
    updateByOp(e, r, i) {
        this.root.updateByOp(e, r, i);
    }
    nodeMaterialDispose() {
        this.root.nodeMaterialDispose();
    }
}, Ra = class extends Nn {
    constructor(e, r, i = !0){
        super();
        this.data = e;
        this.allowVariableSaves = i;
        this.layerIdGen = 0;
        this.flavors = [];
        this.masks = {};
        this.type = "NodeMaterial";
        this.updaters = [], this.needsJitter = r.shared.needsJitter, or.startContext(this), this.reset0(e, r), or.endContext(this);
    }
    get nodeMaterial() {
        return this;
    }
    getFlavor(e, r, i) {
        let s = i ? 6 : (e ? 3 : 0) + r;
        if (s === 0) return this;
        this.flavors === void 0 && (this.flavors = []), s -= 1;
        let o = this.flavors[s];
        return o === void 0 && (o = new rx(e, r, i, this), o.needsJitter = this.needsJitter, this.flavors[s] = o, o.flatShading = e, o.side = r, o.updateAfterBuild()), o;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    get category() {
        return this.lightLayer.category;
    }
    get hasAO() {
        return this.lightLayer.getNode("occlusion")?.value ?? !1;
    }
    reset(e, r, i = !1) {
        or.startContext(this), (this.data !== e || i) && this.reset0(e, r), or.endContext(this);
    }
    reset0(e, r) {
        this.data = e;
        let i = e.layers ?? Kr.defaultTwoLayerData("phong").layers;
        try {
            this.layers = i.map((s)=>Gl.create(this.layerIdGen++, s.id, s.data, r.shared));
        } catch  {
            this.layers = [];
        }
        this.layers.reverse(), this.name = e.name ?? "Untitled Material", this.onUpdate(r.shared), this.transparent = Kc(e, r.shared), this.saveVariableLocations(r);
    }
    onVariableUpdate(e, r, i) {
        if (e[0] === "alphaOverride") this.transparent = Kc(this.data, i.shared), this.lightLayer.setValue("alphaOverride", Math.max(0, Math.min(Number(r) / 100, 1)));
        else if (e[0] === "layer") {
            let s = e[1], o = e[2];
            if (s && o) {
                let a = this.layers.find((l)=>l.uuid === s);
                a?.hasValue(o) && (o === "alpha" ? (this.transparent = Kc(this.data, i.shared), a.setValue(o, Math.max(0, Math.min(Number(r) / 100, 1)))) : a.setValue(o, r));
            }
        }
    }
    saveVariableLocations(e) {
        if (!this.allowVariableSaves) return;
        let r = this.data.layers.find((i)=>i.data.type === "light");
        r && e.shared.getVariable(r.data.alphaOverride, [
            "material",
            this.uuid,
            "alphaOverride"
        ]), this.data.layers.forEach((i)=>{
            "alpha" in i.data && typeof i.data.alpha == "string" && e.shared.getVariable(i.data.alpha, [
                "material",
                this.uuid,
                "layer",
                i.id,
                "alpha"
            ]);
        });
    }
    getLayersOfType(e) {
        return this.layers.filter((r)=>r.type === e);
    }
    getLayerByUuid(e) {
        return this.layers.find((r)=>r.uuid === e);
    }
    onUpdate(e) {
        this.lightLayer = this.layers.find((r)=>r instanceof wn), this.lightLayer === void 0 && (this.lightLayer = new wn(0, "", {
            ...Gr.defaultData("light", "phong"),
            visible: !1
        }, new Da, {}, e)), this.dispose();
        for (let r of this.flavors)r && r.dispose();
        this.applyTextureMaps(), this.applyMasks(), this.blendColors(), this.blendAfterColors(), this.blendPositions(), this.build(), this.nodeContextUuid = 0;
    }
    applyTextureMaps() {
        let e = this.layers.find((o)=>o instanceof wn);
        if (!e) return;
        let r = e.data, i = r.bumpMap, s = r.roughnessMap;
        e.node.bumpMap = void 0, e.node.roughnessMap = void 0;
        for(let o = 0; o < this.layers.length; ++o){
            let a = this.layers[o];
            a instanceof Or && a.color instanceof kl && (a.uuid === i && (e.node.bumpMap = a.color), a.uuid === s && (e.node.roughnessMap = a.color));
        }
    }
    updateByOp(e, r, i) {
        if (or.startContext(this), r !== void 0 ? this.data = r : r = this.data, this.transparent = Kc(r, i.shared), e.path[0] === "layers") {
            let s = i.shared, o = e.path[1];
            if (o === void 0) i.scene.markNeedsUpdateRendererDirty(), this.reset0(r, i);
            else {
                e.type === 0 && e.props.occlusion !== void 0 && i.scene.markNeedsUpdateRendererDirty();
                let a = this.layers.find((l)=>l.uuid === o);
                if (a) {
                    let l = r.layers.data(o), c;
                    e.type === 0 && ("alpha" in e.props || "alphaOverride" in e.props) && ("alpha" in e.props ? c = {
                        ...e.props,
                        alpha: zl(e.props.alpha, s, [
                            "material",
                            this.uuid,
                            "layer",
                            o,
                            "alpha"
                        ])
                    } : c = {
                        ...e.props,
                        alphaOverride: zl(e.props.alphaOverride, s, [
                            "material",
                            this.uuid,
                            "alphaOverride"
                        ])
                    }), a.updateByOp({
                        ...e,
                        ...c ? {
                            props: c
                        } : {},
                        path: e.path.slice(2)
                    }, l, i) && this.reset0(r, i);
                }
            }
        } else this.reset0(r, i);
        or.endContext(this);
    }
    applyMasks() {
        for(let e = 0; e < this.layers.length; ++e){
            let r = this.layers[e];
            r instanceof Or ? r.color.mask = void 0 : r instanceof wn && (r.node.mask = void 0);
        }
        for(let e = 0; e < this.layers.length; ++e){
            let r = this.layers[e];
            if (r instanceof Or && r.isMask.value && r.data.visible && e > 0) {
                let i = e - 1, s = this.layers[i];
                s instanceof wn ? s.node.mask = new ki(r.color, r.alpha, ki.MUL) : s instanceof Or && (s.isMask.value || (s.color.mask = new ki(r.color, r.alpha, ki.MUL)));
            }
        }
    }
    blendColors() {
        let e = this.layers.findIndex((i)=>i instanceof Or), r = this.layers.findIndex((i)=>i instanceof wn);
        if (e !== -1 && e < r) {
            let i = this.layers[e].color;
            for(let s = e + 1; s < r; ++s){
                let o = this.layers[s];
                if (o instanceof Or) {
                    if (o.isMask.value) continue;
                    i = new Ud(i, o.color, o.alpha, o.mode);
                }
            }
            this.fragment.color = i;
        } else this.fragment.color = void 0;
    }
    blendAfterColors() {
        let e = new Kt("outgoingLight", "f"), r = this.layers.findIndex((i)=>i instanceof wn);
        if (this.layers.length > r + 1) {
            for(let i = r + 1; i < this.layers.length; ++i){
                let s = this.layers[i];
                if (s instanceof Or) {
                    if (s.isMask.value) continue;
                    e = new Ud(e, s.color, s.alpha, s.mode);
                }
            }
            this.fragment.afterColor = e;
        } else this.fragment.afterColor = void 0;
    }
    blendPositions() {
        let e = this.layers.filter((r)=>r instanceof Tm);
        if (e.length > 0) {
            let r = e[0].position;
            for(let i = 1; i < e.length; ++i)e[i] && (r = new ki(r, e[i].position, ki.ADD), r = new ki(r, new Fe(.5).setReadonly(!0), ki.MUL));
            this.fragment.position = r;
        } else this.fragment.position = void 0;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getVertexShader() {
        return this.vertexShader;
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    onBeforeCompile(e) {
        e.defines = this.defines, e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.extensionDerivatives = this.extensions.derivatives === !0, e.extensionFragDepth = this.extensions.fragDepth === !0, e.extensionDrawBuffers = this.extensions.drawBuffers === !0, e.extensionShaderTextureLOD = this.extensions.shaderTextureLOD === !0;
    }
    clampUniformsForPreview(e, r) {
        let i = (s, o, a)=>Math.min(Math.max(s, o), a);
        for (let s of this.layers)if (s.type === "displace") {
            let o = i(s.uniforms[`f${s.id}_intensity`].value, e, r);
            s.uniforms[`f${s.id}_intensity`].value = o;
        }
    }
    updateFrame(e) {
        for(let r = 0; r < this.updaters.length; ++r)e.updateNode(this.updaters[r]);
    }
    build() {
        let e = new Vd;
        e.needsJitter = this.needsJitter, this.lights = this.lightLayer.data.visible, e.build(this.fragment, this.fragment), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.updaters = e.updaters;
        for (let r of this.flavors)r && r.updateAfterBuild();
        return this;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
        for (let e of this.flavors)e && e.dispose();
    }
    assetsLoaded() {
        for (let e of this.layers)if (e instanceof Or) {
            let r = e.params.texture;
            if (r instanceof qc && !r.image.loaded) return !1;
        }
        return !0;
    }
};
Object.defineProperties(Nn.prototype, {
    properties: {
        get: function() {
            return this.fragment.properties;
        }
    }
});
var Qc = class extends Ra {
    constructor(t, e, r){
        super(t, e, !1), this.uuid = r, this.allowVariableSaves = !0, this.saveVariableLocations(e);
    }
};
var GR = new Map;
function jR(n1) {
    if (typeof n1 == "string") return n1;
    let t = GR.get(n1);
    return t || (t = {
        url: URL.createObjectURL(new Blob([
            n1
        ]))
    }, GR.set(n1, t)), t.url;
}
var WR, qR = new Promise((n1)=>{
    WR = n1;
}), HR = !1;
var ix;

function YR() {
    if (HR) return;
    if (ix) return ix;
    async function n1() {
        await (parcelRequire("fQPhc")), WR(window !== void 0 ? window : $parcel$global), HR = !0;
    }
    return ix = n1(), ix;
}
var XR;
qR.then((n1)=>XR = n1);
function KR(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        if (r.events === void 0 || Array.isArray(r.events) === !1) return !0;
        let i = [];
        r.events.forEach((s)=>{
            "dragDropActions" in s.data ? (i.push(...s.data.dragDropActions.drag), i.push(...s.data.dragDropActions.drop)) : "inActions" in s.data ? (i.push(...s.data.inActions), i.push(...s.data.outActions)) : "gameActions" in s.data ? (i.push(...s.data.gameActions.idle), i.push(...s.data.gameActions.move), i.push(...s.data.gameActions.jump), i.push(...s.data.gameActions.run)) : "breakpoints" in s.data ? s.data.breakpoints.forEach((o)=>{
                i.push(...o.data.actions);
            }) : "actions" in s.data && i.push(...s.data.actions), t = t || i.some((o)=>o.data.type === "Audio");
        });
    }), t;
}
var La = class {
    constructor({ src: t, volume: e, delay: r, loop: i }){
        this._volume = 1;
        this.delay = 0;
        this._loop = 1;
        this.loopsRemaining = 0;
        this._status = "stopped";
        this.onEnd = ()=>{
            this.loopsRemaining === 1 / 0 ? this.replay() : this.loopsRemaining > 1 ? (this.replay(), this.loopsRemaining--) : (this._status = "stopped", this.loopsRemaining = this._loop);
        };
        let s;
        typeof t == "string" ? s = {
            src: t
        } : s = {
            src: jR(t),
            format: "wav"
        }, this.sound = new XR.Howl(s), this.sound.on("end", this.onEnd), this.src = t, e !== void 0 && (this.volume = e), r !== void 0 && (this.delay = r), i !== void 0 && (this.loop = i);
    }
    get status() {
        return this._status;
    }
    get volume() {
        return this._volume;
    }
    set volume(t) {
        this._volume = t, this.sound.volume(t);
    }
    get loop() {
        return this._loop;
    }
    set loop(t) {
        this._loop = t, this.loopsRemaining = t;
    }
    replay() {
        this.clearDelay(), this.delayTimerId = window.setTimeout(()=>{
            this.sound.play(), this.clearDelay();
        }, this.delay);
    }
    fade(t, e = 1e3) {
        t ? (this.sound.volume(this._volume), this.clearFade(), this.fadeTimerId = window.setTimeout(()=>{
            this.sound.fade(this._volume, 0, e), this.clearFade();
        }, t)) : this.sound.fade(this._volume, 0, e);
    }
    on(t, e, r) {
        this.sound.on(t, e, r);
    }
    off(t, e, r) {
        this.sound.off(t, e, r);
    }
    play() {
        this._status === "playing" || this.sound.playing() || (this._status === "paused" ? (this.sound.seek() === 0 ? this.replay() : this.sound.play(), this._status = "playing") : this._status === "stopped" && (this.replay(), this._status = "playing"));
    }
    pause() {
        this._status === "playing" && (this.sound.pause(), this.clearFade(), this.clearDelay(), this._status = "paused");
    }
    stop() {
        this.sound.stop(), this.loopsRemaining = this._loop, this.clearFade(), this.clearDelay(), this._status = "stopped";
    }
    clearFade() {
        this.fadeTimerId && (clearTimeout(this.fadeTimerId), delete this.fadeTimerId);
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    dispose(t = !1) {
        this.off(), this.stop(), this.clearFade(), this.clearDelay();
    }
};
var nx = class {
    constructor(){
        this.type = "ShapePath";
        this.color = new We;
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(t, e) {
        return this.currentPath = new Ac, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
    }
    lineTo(t, e) {
        return this.currentPath?.lineTo(t, e), this;
    }
    quadraticCurveTo(t, e, r, i) {
        return this.currentPath?.quadraticCurveTo(t, e, r, i), this;
    }
    bezierCurveTo(t, e, r, i, s, o) {
        return this.currentPath?.bezierCurveTo(t, e, r, i, s, o), this;
    }
    splineThru(t) {
        return this.currentPath?.splineThru(t), this;
    }
    toShapes() {
        let e = {
            ORIGIN: 0,
            DESTINATION: 1,
            BETWEEN: 2,
            LEFT: 3,
            RIGHT: 4,
            BEHIND: 5,
            BEYOND: 6
        }, r = {
            loc: e.ORIGIN,
            t: 0
        };
        function i(m, g, y, x) {
            let v = m.x, S = g.x, w = y.x, A = x.x, T = m.y, b = g.y, M = y.y, C = x.y, P = (A - w) * (T - M) - (C - M) * (v - w), I = (S - v) * (T - M) - (b - T) * (v - w), _ = (C - M) * (S - v) - (A - w) * (b - T), D = P / _, L = I / _;
            if (_ === 0 && P !== 0 || D <= 0 || D >= 1 || L < 0 || L > 1) return null;
            if (P === 0 && _ === 0) {
                for(let j = 0; j < 2; j++)if (s(j === 0 ? y : x, m, g), r.loc === e.ORIGIN) {
                    let V = j === 0 ? y : x;
                    return {
                        x: V.x,
                        y: V.y,
                        t: r.t
                    };
                } else if (r.loc === e.BETWEEN) {
                    let V = +(v + r.t * (S - v)).toPrecision(10), H = +(T + r.t * (b - T)).toPrecision(10);
                    return {
                        x: V,
                        y: H,
                        t: r.t
                    };
                }
                return null;
            } else {
                for(let H = 0; H < 2; H++)if (s(H === 0 ? y : x, m, g), r.loc === e.ORIGIN) {
                    let W = H === 0 ? y : x;
                    return {
                        x: W.x,
                        y: W.y,
                        t: r.t
                    };
                }
                let j = +(v + D * (S - v)).toPrecision(10), V = +(T + D * (b - T)).toPrecision(10);
                return {
                    x: j,
                    y: V,
                    t: D
                };
            }
        }
        function s(m, g, y) {
            let x = y.x - g.x, v = y.y - g.y, S = m.x - g.x, w = m.y - g.y, A = x * w - S * v;
            if (m.x === g.x && m.y === g.y) {
                r.loc = e.ORIGIN, r.t = 0;
                return;
            }
            if (m.x === y.x && m.y === y.y) {
                r.loc = e.DESTINATION, r.t = 1;
                return;
            }
            if (A < -Number.EPSILON) {
                r.loc = e.LEFT;
                return;
            }
            if (A > Number.EPSILON) {
                r.loc = e.RIGHT;
                return;
            }
            if (x * S < 0 || v * w < 0) {
                r.loc = e.BEHIND;
                return;
            }
            if (Math.sqrt(x * x + v * v) < Math.sqrt(S * S + w * w)) {
                r.loc = e.BEYOND;
                return;
            }
            let T;
            x !== 0 ? T = S / x : T = w / v, r.loc = e.BETWEEN, r.t = T;
        }
        function o(m, g) {
            let y = [], x = [];
            for(let v = 1; v < m.length; v++){
                let S = m[v - 1], w = m[v];
                for(let A = 1; A < g.length; A++){
                    let T = g[A - 1], b = g[A], M = i(S, w, T, b);
                    M !== null && y.find((C)=>C.t <= M.t + Number.EPSILON && C.t >= M.t - Number.EPSILON) === void 0 && (y.push(M), x.push(new k(M.x, M.y)));
                }
            }
            return x;
        }
        function a(m, g, y) {
            let x = new k;
            g.getCenter(x);
            let v = [];
            return y.forEach((S)=>{
                S.boundingBox.containsPoint(x) && o(m, S.points).forEach((A)=>{
                    v.push({
                        identifier: S.identifier,
                        isCW: S.isCW,
                        point: A
                    });
                });
            }), v.sort((S, w)=>S.point.x - w.point.x), v;
        }
        function l(m, g, y, x, v) {
            (v == null || v === "") && (v = "nonzero");
            let S = new k;
            m.boundingBox.getCenter(S);
            let w = [
                new k(y, S.y),
                new k(x, S.y)
            ], A = a(w, m.boundingBox, g);
            A.sort((I, _)=>I.point.x - _.point.x);
            let T = [], b = [];
            A.forEach((I)=>{
                I.identifier === m.identifier ? T.push(I) : b.push(I);
            });
            let M = T[0].point.x, C = [], P = 0;
            for(; P < b.length && b[P].point.x < M;)C.length > 0 && C[C.length - 1] === b[P].identifier ? C.pop() : C.push(b[P].identifier), P++;
            if (C.push(m.identifier), v === "evenodd") {
                let I = C.length % 2 === 0, _ = C[C.length - 2];
                return {
                    identifier: m.identifier,
                    isHole: I,
                    for: _
                };
            } else if (v === "nonzero") {
                let I = !0, _ = null, D = null;
                for(let L = 0; L < C.length; L++){
                    let j = C[L];
                    g[j] && (I ? (D = g[j].isCW, I = !1, _ = j) : D !== g[j].isCW && (D = g[j].isCW, I = !0));
                }
                return {
                    identifier: m.identifier,
                    isHole: I,
                    for: _
                };
            } else console.warn('fill-rule: "' + v + '" is currently not implemented.');
        }
        let c = 0, u = 999999999, h = -999999999, d = [];
        this.subPaths.forEach((m)=>{
            let g = m.getPoints(), y = -999999999, x = 999999999, v = -999999999, S = 999999999;
            for(let w = 0; w < g.length; w++){
                let A = g[w];
                A.y > y && (y = A.y), A.y < x && (x = A.y), A.x > v && (v = A.x), A.x < S && (S = A.x);
            }
            h <= v && (h = v + 1), u >= S && (u = S - 1), g.length && d.push({
                curves: m.curves,
                points: g,
                isCW: zu.isClockWise(g),
                identifier: c++,
                boundingBox: new Ju(new k(S, x), new k(v, y))
            });
        });
        let f = d.map((m)=>l(m, d, u, h, this.userData?.style.fillRule)), p = [];
        return d.forEach((m)=>{
            let g = f[m.identifier];
            if (g && !g.isHole) {
                let y = new la;
                y.curves = m.curves, f.filter((v)=>v?.isHole && v.for === m.identifier).forEach((v)=>{
                    if (v) {
                        let S = d[v.identifier], w = new Ac;
                        w.curves = S.curves, y.holes.push(w);
                    }
                }), p.push(y);
            }
        }), p;
    }
};
var TE = !1, ZR, ME = new Promise((n1)=>{
    ZR = n1;
}), QR = !1;
var sx;

function JR() {
    if (TE = !0, QR) return;
    if (sx) return sx;
    async function n1() {
        let e = await (parcelRequire("14X3t"));
        ZR(e), QR = !0;
    }
    return sx = n1(), sx;
}
var Mm = class {
    async load(t, e, r = ()=>{}) {
        let { load: i } = await ME;
        i(t, (s, o)=>{
            s || !o ? r(s ?? "Something went wrong") : e(o);
        });
    }
    async parse(t) {
        let { parse: e, Bidi: r } = await ME;
        try {
            let i = e(t), s = new r, o = (a)=>i.charToGlyphIndex(a.char);
            return s.registerModifier("glyphIndex", null, o), s.applyFeatures(i, i.defaultRenderOptions.features), {
                font: i,
                bidi: s
            };
        } catch (i) {
            console.error(i);
        }
    }
};
async function BX(n1) {
    return await (await fetch(n1)).arrayBuffer();
}
var NX = new Mm;
async function CE(n1) {
    let t, e, r = !1;
    if (n1.url ? (t = await BX(n1.url), e = n1.url, r = n1.url.startsWith("/")) : n1.data && (t = n1.data.buffer.slice(n1.data.byteOffset, n1.data.byteOffset + n1.data.byteLength)), t) {
        if (TE) {
            let i = await NX.parse(t);
            if (i) return {
                font: i.font,
                url: e,
                intercepted: r,
                arr: t,
                bidi: i.bidi
            };
        } else return {
            font: void 0,
            url: e,
            intercepted: r,
            arr: t,
            bidi: null
        };
    }
}
function FX(n1, t) {
    return t.state.glyphIndex === n1 || t.state.fina === n1 || t.state.medi === n1 || t.state.init === n1;
}
var ox = class {
    constructor(t){
        this._arrayBuffer = new ArrayBuffer(1);
        this._isLoaded = !1;
        this._intercepted = !1;
        this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = CE(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    update(t) {
        this._isLoaded = !1, this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = CE(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    get url() {
        return this._url;
    }
    get intercepted() {
        return this._intercepted;
    }
    get isLoaded() {
        return this._isLoaded;
    }
    get loadingPromise() {
        return this._loadingPromise;
    }
    reverseLigaturesTable(t, e, r) {
        if (!this._bidi) return [];
        let i = this._bidi;
        i.getTextGlyphs(e);
        let s = i.tokenizer.tokens, o = [], a = 0, l = r.length === s.length;
        for(let c = 0; c < r.length; c++){
            let u = r[c].index, h = String.fromCharCode(r[c].unicode), d = s[a];
            if (FX(u, d) || l) o.push({
                char: h,
                index: u,
                replacements: [
                    d.state.glyphIndex
                ],
                replacementChars: [
                    d.char
                ]
            }), a++;
            else {
                let f = d.char, p = "", m = [
                    d.state.glyphIndex
                ], g = [], y = !1;
                for(; !y;)a++, p = e.charAt(a), f += p, m.push(t.charToGlyphIndex(p)), g = t.stringToGlyphs(f), g.length === 1 && g[0].index === u && (y = !0), a > e.length && (y = !0);
                o.push({
                    char: h,
                    index: u,
                    replacements: m,
                    replacementChars: Array.from(f)
                }), a++;
            }
        }
        return o;
    }
    generateShapes(t, e) {
        if (!this._isLoaded) return;
        let r = this.font, i = e.fontSize / this.unitsPerEm, s = e.fontSize * e.lineHeight, o = t.map((x)=>this.getTextWidth(x, e)), a = e.width, l = this.getCharWidth(`
`, e), c = e.horizontalAlign === 1 ? l : 0, u = this.computeSpaceWidthForLine(t, 0, e), h = this.getLineInitialOffsetX(o[0], a, e.horizontalAlign, t[0], l), d = this.getLineInitialOffsetY(s, t.length, e.height, i, e.verticalAlign), f = [], p = t.map((x)=>[]), m = t.map((x)=>[]), g;
        for(let x = 0; x < t.length; x++){
            let v = t[x], S = {
                features: {
                    liga: !0
                }
            }, w = [];
            try {
                w = r.stringToGlyphs(v, S);
            } catch (T) {
                console.warn(T);
            }
            h = this.getLineInitialOffsetX(o[x], a, e.horizontalAlign, v, l);
            let A = [];
            try {
                A = this.reverseLigaturesTable(r, v, w);
            } catch (T) {
                console.warn(T);
            }
            u = this.computeSpaceWidthForLine(t, x, e);
            for(let T = 0; T < w.length; T++){
                let b = w[T], M = b.index === 0 ? `
` : b.unicode ? String.fromCharCode(b.unicode) : void 0, C = A[T], P = 0, I = 0;
                T === 0 && e.horizontalAlign === 2 && b.leftSideBearing !== void 0 && (I = -b.leftSideBearing * i), g && (P = r.getKerningValue(b, g) * i), h += I + P;
                let _ = 0;
                if (M === `
`) _ = c;
                else if (M === " ") _ = u;
                else {
                    let D = this.createPath(b, i, h, d, e);
                    D && (_ = D.offsetX - (P + I), f.push(D.path));
                }
                if (C.replacements.length === 1) m[x].push([
                    h,
                    d
                ]), p[x].push(_);
                else {
                    let D = C.replacements.map((H)=>(r.glyphs.get(H).advanceWidth ?? 0) * i), L = D.reduce((H, W)=>H += W, 0), j = D.map((H)=>H / L), V = h;
                    for(let H = 0; H < j.length; H++){
                        let W = _ * j[H];
                        m[x].push([
                            V,
                            d
                        ]), p[x].push(W), V += W;
                    }
                }
                h += _, g = b;
            }
            d -= s;
        }
        let y = [];
        for(let x = 0, v = f.length; x < v; x++)y.push(...f[x].toShapes());
        return {
            shapes: y,
            charWidths: p,
            lineWidths: o,
            charCoords: m
        };
    }
    get isUserFont() {
        return this._isUserFont;
    }
    get arrayBuffer() {
        return this._arrayBuffer;
    }
    get ascender() {
        return this.font?.ascender ?? 0;
    }
    get descender() {
        return this.font?.descender ?? 0;
    }
    get familyName() {
        return this.font?.names.fontFamily ?? "";
    }
    get subfamilyName() {
        return this.font?.names.fontSubfamily ?? "";
    }
    get unitsPerEm() {
        return this.font?.unitsPerEm ?? 1;
    }
    getLineInitialOffsetX(t, e, r, i, s) {
        return (r === 3 || r === 2) && i.indexOf(`
`) >= 0 && (t -= s), r === 3 ? e * .5 - t * .5 : r === 2 ? e - t : 0;
    }
    getLineInitialOffsetY(t, e, r, i, s) {
        let o = e * t, a = Math.abs(this.ascender - this.descender) * i, l = t - a, c = -this.ascender * i - l / 2;
        return s === 3 ? -(r - o - c) : s === 2 ? -(r * .5 - o * .5 - c) : c;
    }
    createPath(t, e, r, i, s) {
        let o = t.getPath(r, -i, s.fontSize, {
            kerning: !1,
            letterSpacing: s.letterSpacing
        });
        if (!o) {
            console.error('THREE.Font: character "' + t + '" does not exists in font family ' + this.familyName + ".");
            return;
        }
        let a = new nx, l = (t.advanceWidth ?? 1) * e;
        if (t) for (let c of o.commands){
            let u = a.currentPath?.currentPoint;
            if (!(u && c.type !== "Z" && u.x === c.x && -u.y === c.y)) switch(c.type){
                case "M":
                    a.moveTo(c.x, -c.y);
                    break;
                case "L":
                    a.lineTo(c.x, -c.y);
                    break;
                case "Q":
                    a.quadraticCurveTo(c.x1, -c.y1, c.x, -c.y);
                    break;
                case "C":
                    a.bezierCurveTo(c.x1, -c.y1, c.x2, -c.y2, c.x, -c.y);
                    break;
            }
        }
        return a.subPaths.forEach((c)=>{
            let u = VX(c.curves);
            u !== void 0 && c.currentPoint.distanceTo(u) > 0 && c.lineTo(u.x, u.y);
        }), {
            offsetX: l + s.fontSize * s.letterSpacing,
            path: a
        };
    }
    getCharWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    getTextWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    computeSpaceWidthForLine(t, e, r) {
        let i = this.getCharWidth(" ", r), s = t[e];
        if (s) {
            let o = this.countSpaces(s.trimEnd());
            if (r.horizontalAlign === 4 && e < t.length - 1 && o) {
                let a = r.width, l = this.getTextWidth(s, r);
                return (a - (l - o * i)) / o;
            }
        }
        return i;
    }
    countSpaces(t) {
        return (t.match(/ /g) || []).length;
    }
};
function VX(n1) {
    if (n1.length) {
        let t = n1[0];
        if (t instanceof ln) return t.v1;
        if (t instanceof an || t instanceof Yn) return t.v0;
    }
}
var PE = class {
    constructor(){
        this.objects = new Map;
        this.unreachable = new Set;
    }
    getCached(t) {
        return this.objects.get(t);
    }
    get size() {
        return this.objects.size;
    }
    get(t, e, r) {
        let i = this.objects.get(t);
        return i === void 0 ? (i = this.createObject(t, e, r), this.objects.set(t, i)) : i.isShared = !0, i;
    }
    forceDelete(t) {
        let e = this.objects.get(t);
        e && (this.disposeObject(e), this.objects.delete(t));
    }
    mutateIfUnique(t, e) {
        let r = this.objects.get(t);
        if (r && r.isShared !== !0) return this.objects.delete(t), this.objects.set(e, r), r;
    }
    startGc() {
        this.unreachable = new Set(this.objects.keys());
    }
    markAsReachable(t, e) {
        let r = this.objects.get(t);
        e === r && this.unreachable.delete(t);
    }
    endGc() {
        this.unreachable.forEach((t)=>{
            this.disposeObject(this.objects.get(t)), this.objects.delete(t);
        }), this.unreachable.clear();
    }
    dispose() {
        this.objects.forEach((t)=>{
            this.disposeObject(t);
        }), this.objects.clear();
    }
}, Cm = class extends PE {
    constructor(e){
        super();
        this.flatShading = e;
    }
    disposeObject(e) {
        e.dispose();
    }
    createObject(e, r, i) {
        let s = _a(e, r, this.flatShading, i);
        return s.computeBoundingSphere(), s;
    }
};
var $R = {
    markNeedsUpdateRendererDirty: ()=>{}
};
var ax = 1e3, e3 = 512 * ax;
function kX(n1, t) {
    let e = typeof n1;
    return !!((t === "string" || t === "number") && e === t || t === "boolean" && (n1 === "true" || n1 === "false" || n1 === !0 || n1 === !1) || t === "image" && e === "string" && n1.startsWith("http"));
}
var t3 = "https://hooks.spline.design", UX = `${t3}/events?hashFile=`, APe = `${t3}/`, lx = class {
    constructor(t, e){
        this.id = t;
        this.userWebhook = e;
        this.result = void 0;
        this._connected = !1;
        this.emitter = Pa();
        this.reconnectWaitFor = ax;
        this._onError = (t)=>{
            this.eventSource?.removeEventListener("message", this._onMessage), this.eventSource?.removeEventListener("error", this._onError), this.eventSource?.removeEventListener("open", this._onConnected), this._scheduleReconnect();
        };
        this._onConnected = (t)=>{
            clearTimeout(this.scheduledReconnectHandle), this.reconnectWaitFor = ax, this._connected = !0;
        };
        this._onDisconnected = ()=>{
            clearTimeout(this.scheduledReconnectHandle), this.reconnectWaitFor = ax, this._connected = !1;
        };
        this._onMessage = (t)=>{
            let e = t.data, r;
            try {
                r = JSON.parse(e);
            } catch (i) {
                console.error("Error parsing webhook message", i);
            }
            if (r) {
                let i = !1;
                this.userWebhook.parametersSchemas.forEach(({ data: s })=>{
                    r[s.name] !== void 0 && kX(r[s.name], s.type) && (this.result === void 0 && (this.result = {}), this.result[s.name] = r[s.name], i = !0);
                }), i && this.emitter.emit("message", {
                    userWebhookId: this.id
                });
            }
        };
    }
    connect() {
        clearTimeout(this.scheduledReconnectHandle), this.userWebhook.url && (this.eventSource = new EventSource(UX + this.userWebhook.url), this.eventSource.addEventListener("message", this._onMessage), this.eventSource.addEventListener("error", this._onError), this.eventSource.addEventListener("open", this._onConnected));
    }
    disconnect() {
        this.eventSource?.removeEventListener("message", this._onMessage), this.eventSource?.removeEventListener("error", this._onError), this.eventSource?.removeEventListener("open", this._onConnected), this.eventSource?.close(), this._onDisconnected(), clearTimeout(this.scheduledReconnectHandle);
    }
    _scheduleReconnect() {
        this.reconnectWaitFor *= 2, this.reconnectWaitFor > e3 && (this.reconnectWaitFor = e3), clearTimeout(this.scheduledReconnectHandle), this.scheduledReconnectHandle = setTimeout(()=>{
            this.scheduledReconnectHandle = void 0, this.connect();
        }, this.reconnectWaitFor);
    }
    update(t) {
        this.userWebhook = t;
    }
    dispose() {
        this._connected && this.disconnect();
    }
    get connected() {
        return this._connected;
    }
    on(t, e) {
        this.emitter.on(t, e);
    }
    off(t, e) {
        this.emitter.off(t, e);
    }
    getParametersKeys() {
        return this.userWebhook.parametersSchemas.map((t)=>t.data.name);
    }
    getParameterValue(t) {
        if (this.getParametersKeys().includes(t)) {
            if (this.result) return this.result?.[t];
            for (let r of this.userWebhook.parametersSchemas)if (r.data.name === t) return r0.defaultParameterValueByType(r.data.type);
        }
    }
};
var zX = globalThis.atob, GX = globalThis.btoa, ys = class {
    static floatTo16BitPCM(t) {
        let e = new ArrayBuffer(t.length * 2), r = new DataView(e), i = 0;
        for(let s = 0; s < t.length; s++, i += 2){
            let o = Math.max(-1, Math.min(1, t[s]));
            r.setInt16(i, o < 0 ? o * 32768 : o * 32767, !0);
        }
        return e;
    }
    static base64ToArrayBuffer(t) {
        let e = zX(t), r = e.length, i = new Uint8Array(r);
        for(let s = 0; s < r; s++)i[s] = e.charCodeAt(s);
        return i.buffer;
    }
    static arrayBufferToBase64(t) {
        t instanceof Float32Array ? t = this.floatTo16BitPCM(t) : t instanceof Int16Array && (t = t.buffer);
        let e = "", r = new Uint8Array(t), i = 32768;
        for(let s = 0; s < r.length; s += i){
            let o = r.subarray(s, s + i);
            e += String.fromCharCode.apply(null, o);
        }
        return GX(e);
    }
    static mergeInt16Arrays(t, e) {
        if (t instanceof ArrayBuffer && (t = new Int16Array(t)), e instanceof ArrayBuffer && (e = new Int16Array(e)), !(t instanceof Int16Array) || !(e instanceof Int16Array)) throw new Error("Both items must be Int16Array");
        let r = new Int16Array(t.length + e.length);
        for(let i = 0; i < t.length; i++)r[i] = t[i];
        for(let i = 0; i < e.length; i++)r[t.length + i] = e[i];
        return r;
    }
    static generateId(t, e = 21) {
        let r = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", i = Array(e - t.length).fill(0).map((s)=>r[Math.floor(Math.random() * r.length)]).join("");
        return `${t}${i}`;
    }
};
var jX = (n1)=>new Promise((t)=>setTimeout(()=>t(), n1)), tf = class {
    constructor(){
        this.eventHandlers = {}, this.nextEventHandlers = {};
    }
    clearEventHandlers() {
        return this.eventHandlers = {}, this.nextEventHandlers = {}, !0;
    }
    on(t, e) {
        return this.eventHandlers[t] = this.eventHandlers[t] || [], this.eventHandlers[t].push(e), e;
    }
    onNext(t, e) {
        return this.nextEventHandlers[t] = this.nextEventHandlers[t] || [], this.nextEventHandlers[t].push(e), e;
    }
    off(t, e) {
        let r = this.eventHandlers[t] || [];
        if (e) {
            let i = r.indexOf(e);
            if (i === -1) throw new Error(`Could not turn off specified event listener for "${t}": not found as a listener`);
            r.splice(i, 1);
        } else delete this.eventHandlers[t];
        return !0;
    }
    offNext(t, e) {
        let r = this.nextEventHandlers[t] || [];
        if (e) {
            let i = r.indexOf(e);
            if (i === -1) throw new Error(`Could not turn off specified next event listener for "${t}": not found as a listener`);
            r.splice(i, 1);
        } else delete this.nextEventHandlers[t];
        return !0;
    }
    async waitForNext(t, e = null) {
        let r = Date.now(), i;
        for(this.onNext(t, (s)=>i = s); !i;){
            if (e && Date.now() - r > e) return null;
            await jX(1);
        }
        return i;
    }
    dispatch(t, e) {
        let r = [].concat(this.eventHandlers[t] || []);
        for (let s of r)s(e);
        let i = [].concat(this.nextEventHandlers[t] || []);
        for (let s of i)s(e);
        return delete this.nextEventHandlers[t], !0;
    }
};
var Pm = class extends tf {
    constructor({ url: t, apiKey: e, dangerouslyAllowAPIKeyInBrowser: r, debug: i } = {}){
        if (super(), this.defaultUrl = "wss://api.openai.com/v1/realtime", this.url = t || this.defaultUrl, this.apiKey = e || null, this.debug = !!i, this.ws = null, globalThis.document && this.apiKey && !r) throw new Error('Can not provide API key in the browser without "dangerouslyAllowAPIKeyInBrowser" set to true');
    }
    isConnected() {
        return !!this.ws;
    }
    log(...t) {
        let r = [
            `[Websocket/${new Date().toISOString()}]`
        ].concat(t).map((i)=>typeof i == "object" && i !== null ? JSON.stringify(i, null, 2) : i);
        return this.debug && console.log(...r), !0;
    }
    async connect({ model: t } = {
        model: "gpt-4o-realtime-preview-2024-10-01"
    }) {
        if (!this.apiKey && this.url === this.defaultUrl && console.warn(`No apiKey provided for connection to "${this.url}"`), this.isConnected()) throw new Error("Already connected");
        if (globalThis.document) {
            this.apiKey && console.warn("Warning: Connecting using API key in the browser, this is not recommended");
            let e = globalThis.WebSocket, r = new e(`${this.url}${t ? `?model=${t}` : ""}`, [
                "realtime",
                `openai-insecure-api-key.${this.apiKey}`,
                "openai-beta.realtime-v1"
            ]);
            return r.addEventListener("message", (i)=>{
                let s = JSON.parse(i.data);
                this.receive(s.type, s);
            }), new Promise((i, s)=>{
                let o = ()=>{
                    this.disconnect(r), s(new Error(`Could not connect to "${this.url}"`));
                };
                r.addEventListener("error", o), r.addEventListener("open", ()=>{
                    this.log(`Connected to "${this.url}"`), r.removeEventListener("error", o), r.addEventListener("error", ()=>{
                        this.disconnect(r), this.log(`Error, disconnected from "${this.url}"`), this.dispatch("close", {
                            error: !0
                        });
                    }), r.addEventListener("close", ()=>{
                        this.disconnect(r), this.log(`Disconnected from "${this.url}"`), this.dispatch("close", {
                            error: !1
                        });
                    }), this.ws = r, i(!0);
                });
            });
        }
    }
    disconnect(t) {
        if (!t || this.ws === t) return this.ws && this.ws.close(), this.ws = null, !0;
    }
    receive(t, e) {
        return this.log("received:", t, e), this.dispatch(`server.${t}`, e), this.dispatch("server.*", e), !0;
    }
    send(t, e) {
        if (!this.isConnected()) throw new Error("RealtimeAPI is not connected");
        if (e = e || {}, typeof e != "object") throw new Error("data must be an object");
        let r = {
            event_id: ys.generateId("evt_"),
            type: t,
            ...e
        };
        return this.dispatch(`client.${t}`, r), this.dispatch("client.*", r), this.log("sent:", t, r), this.ws.send(JSON.stringify(r)), !0;
    }
};
var _m = class {
    constructor(){
        uo(this, "defaultFrequency", 24e3);
        uo(this, "EventProcessors", {
            "conversation.item.created": (t)=>{
                let { item: e } = t, r = JSON.parse(JSON.stringify(e));
                if (this.itemLookup[r.id] || (this.itemLookup[r.id] = r, this.items.push(r)), r.formatted = {}, r.formatted.audio = new Int16Array(0), r.formatted.text = "", r.formatted.transcript = "", this.queuedSpeechItems[r.id] && (r.formatted.audio = this.queuedSpeechItems[r.id].audio, delete this.queuedSpeechItems[r.id]), r.content) {
                    let i = r.content.filter((s)=>[
                            "text",
                            "input_text"
                        ].includes(s.type));
                    for (let s of i)r.formatted.text += s.text;
                }
                return this.queuedTranscriptItems[r.id] && (r.formatted.transcript = this.queuedTranscriptItems.transcript, delete this.queuedTranscriptItems[r.id]), r.type === "message" ? r.role === "user" ? (r.status = "completed", this.queuedInputAudio && (r.formatted.audio = this.queuedInputAudio, this.queuedInputAudio = null)) : r.status = "in_progress" : r.type === "function_call" ? (r.formatted.tool = {
                    type: "function",
                    name: r.name,
                    call_id: r.call_id,
                    arguments: ""
                }, r.status = "in_progress") : r.type === "function_call_output" && (r.status = "completed", r.formatted.output = r.output), {
                    item: r,
                    delta: null
                };
            },
            "conversation.item.truncated": (t)=>{
                let { item_id: e, audio_end_ms: r } = t, i = this.itemLookup[e];
                if (!i) throw new Error(`item.truncated: Item "${e}" not found`);
                let s = Math.floor(r * this.defaultFrequency / 1e3);
                return i.formatted.transcript = "", i.formatted.audio = i.formatted.audio.slice(0, s), {
                    item: i,
                    delta: null
                };
            },
            "conversation.item.deleted": (t)=>{
                let { item_id: e } = t, r = this.itemLookup[e];
                if (!r) throw new Error(`item.deleted: Item "${e}" not found`);
                delete this.itemLookup[r.id];
                let i = this.items.indexOf(r);
                return i > -1 && this.items.splice(i, 1), {
                    item: r,
                    delta: null
                };
            },
            "conversation.item.input_audio_transcription.completed": (t)=>{
                let { item_id: e, content_index: r, transcript: i } = t, s = this.itemLookup[e], o = i || " ";
                return s ? (s.content[r].transcript = i, s.formatted.transcript = o, {
                    item: s,
                    delta: {
                        transcript: i
                    }
                }) : (this.queuedTranscriptItems[e] = {
                    transcript: o
                }, {
                    item: null,
                    delta: null
                });
            },
            "input_audio_buffer.speech_started": (t)=>{
                let { item_id: e, audio_start_ms: r } = t;
                return this.queuedSpeechItems[e] = {
                    audio_start_ms: r
                }, {
                    item: null,
                    delta: null
                };
            },
            "input_audio_buffer.speech_stopped": (t, e)=>{
                let { item_id: r, audio_end_ms: i } = t;
                this.queuedSpeechItems[r] || (this.queuedSpeechItems[r] = {
                    audio_start_ms: i
                });
                let s = this.queuedSpeechItems[r];
                if (s.audio_end_ms = i, e) {
                    let o = Math.floor(s.audio_start_ms * this.defaultFrequency / 1e3), a = Math.floor(s.audio_end_ms * this.defaultFrequency / 1e3);
                    s.audio = e.slice(o, a);
                }
                return {
                    item: null,
                    delta: null
                };
            },
            "response.created": (t)=>{
                let { response: e } = t;
                return this.responseLookup[e.id] || (this.responseLookup[e.id] = e, this.responses.push(e)), {
                    item: null,
                    delta: null
                };
            },
            "response.output_item.added": (t)=>{
                let { response_id: e, item: r } = t, i = this.responseLookup[e];
                if (!i) throw new Error(`response.output_item.added: Response "${e}" not found`);
                return i.output.push(r.id), {
                    item: null,
                    delta: null
                };
            },
            "response.output_item.done": (t)=>{
                let { item: e } = t;
                if (!e) throw new Error('response.output_item.done: Missing "item"');
                let r = this.itemLookup[e.id];
                if (!r) throw new Error(`response.output_item.done: Item "${e.id}" not found`);
                return r.status = e.status, {
                    item: r,
                    delta: null
                };
            },
            "response.content_part.added": (t)=>{
                let { item_id: e, part: r } = t, i = this.itemLookup[e];
                if (!i) throw new Error(`response.content_part.added: Item "${e}" not found`);
                return i.content.push(r), {
                    item: i,
                    delta: null
                };
            },
            "response.audio_transcript.delta": (t)=>{
                let { item_id: e, content_index: r, delta: i } = t, s = this.itemLookup[e];
                if (!s) throw new Error(`response.audio_transcript.delta: Item "${e}" not found`);
                return s.content[r].transcript += i, s.formatted.transcript += i, {
                    item: s,
                    delta: {
                        transcript: i
                    }
                };
            },
            "response.audio.delta": (t)=>{
                let { item_id: e, content_index: r, delta: i } = t, s = this.itemLookup[e];
                if (!s) throw new Error(`response.audio.delta: Item "${e}" not found`);
                let o = ys.base64ToArrayBuffer(i), a = new Int16Array(o);
                return s.formatted.audio = ys.mergeInt16Arrays(s.formatted.audio, a), {
                    item: s,
                    delta: {
                        audio: a
                    }
                };
            },
            "response.text.delta": (t)=>{
                let { item_id: e, content_index: r, delta: i } = t, s = this.itemLookup[e];
                if (!s) throw new Error(`response.text.delta: Item "${e}" not found`);
                return s.content[r].text += i, s.formatted.text += i, {
                    item: s,
                    delta: {
                        text: i
                    }
                };
            },
            "response.function_call_arguments.delta": (t)=>{
                let { item_id: e, delta: r } = t, i = this.itemLookup[e];
                if (!i) throw new Error(`response.function_call_arguments.delta: Item "${e}" not found`);
                return i.arguments += r, i.formatted.tool.arguments += r, {
                    item: i,
                    delta: {
                        arguments: r
                    }
                };
            }
        });
        this.clear();
    }
    clear() {
        return this.itemLookup = {}, this.items = [], this.responseLookup = {}, this.responses = [], this.queuedSpeechItems = {}, this.queuedTranscriptItems = {}, this.queuedInputAudio = null, !0;
    }
    queueInputAudio(t) {
        return this.queuedInputAudio = t, t;
    }
    processEvent(t, ...e) {
        if (!t.event_id) throw console.error(t), new Error('Missing "event_id" on event');
        if (!t.type) throw console.error(t), new Error('Missing "type" on event');
        let r = this.EventProcessors[t.type];
        if (!r) throw new Error(`Missing conversation event processor for "${t.type}"`);
        return r.call(this, t, ...e);
    }
    getItem(t) {
        return this.itemLookup[t] || null;
    }
    getItems() {
        return this.items.slice();
    }
};
var rf = class extends tf {
    constructor({ url: t, apiKey: e, dangerouslyAllowAPIKeyInBrowser: r, debug: i } = {}){
        super(), this.defaultSessionConfig = {
            modalities: [
                "text",
                "audio"
            ],
            instructions: "",
            voice: "alloy",
            input_audio_format: "pcm16",
            output_audio_format: "pcm16",
            input_audio_transcription: null,
            turn_detection: null,
            tools: [],
            tool_choice: "auto",
            temperature: .8,
            max_response_output_tokens: 4096
        }, this.sessionConfig = {}, this.transcriptionModels = [
            {
                model: "whisper-1"
            }
        ], this.defaultServerVadConfig = {
            type: "server_vad",
            threshold: .5,
            prefix_padding_ms: 300,
            silence_duration_ms: 200
        }, this.realtime = new Pm({
            url: t,
            apiKey: e,
            dangerouslyAllowAPIKeyInBrowser: r,
            debug: i
        }), this.conversation = new _m, this._resetConfig(), this._addAPIEventHandlers();
    }
    _resetConfig() {
        return this.sessionCreated = !1, this.tools = {}, this.sessionConfig = JSON.parse(JSON.stringify(this.defaultSessionConfig)), this.inputAudioBuffer = new Int16Array(0), !0;
    }
    _addAPIEventHandlers() {
        this.realtime.on("client.*", (i)=>{
            let s = {
                time: new Date().toISOString(),
                source: "client",
                event: i
            };
            this.dispatch("realtime.event", s);
        }), this.realtime.on("server.*", (i)=>{
            let s = {
                time: new Date().toISOString(),
                source: "server",
                event: i
            };
            this.dispatch("realtime.event", s);
        }), this.realtime.on("server.session.created", ()=>this.sessionCreated = !0);
        let t = (i, ...s)=>{
            let { item: o, delta: a } = this.conversation.processEvent(i, ...s);
            return {
                item: o,
                delta: a
            };
        }, e = (i, ...s)=>{
            let { item: o, delta: a } = t(i, ...s);
            return o && this.dispatch("conversation.updated", {
                item: o,
                delta: a
            }), {
                item: o,
                delta: a
            };
        }, r = async (i)=>{
            try {
                let s = JSON.parse(i.arguments), o = this.tools[i.name];
                if (!o) throw new Error(`Tool "${i.name}" has not been added`);
                let a = await o.handler(s);
                this.realtime.send("conversation.item.create", {
                    item: {
                        type: "function_call_output",
                        call_id: i.call_id,
                        output: JSON.stringify(a)
                    }
                });
            } catch (s) {
                this.realtime.send("conversation.item.create", {
                    item: {
                        type: "function_call_output",
                        call_id: i.call_id,
                        output: JSON.stringify({
                            error: s.message
                        })
                    }
                });
            }
            this.createResponse();
        };
        return this.realtime.on("server.response.created", t), this.realtime.on("server.response.output_item.added", t), this.realtime.on("server.response.content_part.added", t), this.realtime.on("server.input_audio_buffer.speech_started", (i)=>{
            t(i), this.dispatch("conversation.interrupted");
        }), this.realtime.on("server.input_audio_buffer.speech_stopped", (i)=>t(i, this.inputAudioBuffer)), this.realtime.on("server.conversation.item.created", (i)=>{
            let { item: s } = e(i);
            this.dispatch("conversation.item.appended", {
                item: s
            }), s.status === "completed" && this.dispatch("conversation.item.completed", {
                item: s
            });
        }), this.realtime.on("server.conversation.item.truncated", e), this.realtime.on("server.conversation.item.deleted", e), this.realtime.on("server.conversation.item.input_audio_transcription.completed", e), this.realtime.on("server.response.audio_transcript.delta", e), this.realtime.on("server.response.audio.delta", e), this.realtime.on("server.response.text.delta", e), this.realtime.on("server.response.function_call_arguments.delta", e), this.realtime.on("server.response.output_item.done", async (i)=>{
            let { item: s } = e(i);
            s.status === "completed" && this.dispatch("conversation.item.completed", {
                item: s
            }), s.formatted.tool && r(s.formatted.tool);
        }), !0;
    }
    isConnected() {
        return this.realtime.isConnected();
    }
    reset() {
        return this.disconnect(), this.clearEventHandlers(), this.realtime.clearEventHandlers(), this._resetConfig(), this._addAPIEventHandlers(), !0;
    }
    async connect() {
        if (this.isConnected()) throw new Error("Already connected, use .disconnect() first");
        return await this.realtime.connect(), this.updateSession(), !0;
    }
    async waitForSessionCreated() {
        if (!this.isConnected()) throw new Error("Not connected, use .connect() first");
        for(; !this.sessionCreated;)await new Promise((t)=>setTimeout(()=>t(), 1));
        return !0;
    }
    disconnect() {
        this.sessionCreated = !1, this.realtime.isConnected() && this.realtime.disconnect(), this.conversation.clear();
    }
    getTurnDetectionType() {
        return this.sessionConfig.turn_detection?.type || null;
    }
    addTool(t, e) {
        if (!t?.name) throw new Error("Missing tool name in definition");
        let r = t?.name;
        if (this.tools[r]) throw new Error(`Tool "${r}" already added. Please use .removeTool("${r}") before trying to add again.`);
        if (typeof e != "function") throw new Error(`Tool "${r}" handler must be a function`);
        return this.tools[r] = {
            definition: t,
            handler: e
        }, this.updateSession(), this.tools[r];
    }
    removeTool(t) {
        if (!this.tools[t]) throw new Error(`Tool "${t}" does not exist, can not be removed.`);
        return delete this.tools[t], !0;
    }
    deleteItem(t) {
        return this.realtime.send("conversation.item.delete", {
            item_id: t
        }), !0;
    }
    updateSession({ modalities: t, instructions: e, voice: r, input_audio_format: i, output_audio_format: s, input_audio_transcription: o, turn_detection: a, tools: l, tool_choice: c, temperature: u, max_response_output_tokens: h } = {}) {
        t !== void 0 && (this.sessionConfig.modalities = t), e !== void 0 && (this.sessionConfig.instructions = e), r !== void 0 && (this.sessionConfig.voice = r), i !== void 0 && (this.sessionConfig.input_audio_format = i), s !== void 0 && (this.sessionConfig.output_audio_format = s), o !== void 0 && (this.sessionConfig.input_audio_transcription = o), a !== void 0 && (this.sessionConfig.turn_detection = a), l !== void 0 && (this.sessionConfig.tools = l), c !== void 0 && (this.sessionConfig.tool_choice = c), u !== void 0 && (this.sessionConfig.temperature = u), h !== void 0 && (this.sessionConfig.max_response_output_tokens = h);
        let d = [].concat((l || []).map((p)=>{
            let m = {
                type: "function",
                ...p
            };
            if (this.tools[m?.name]) throw new Error(`Tool "${m?.name}" has already been defined`);
            return m;
        }), Object.keys(this.tools).map((p)=>({
                type: "function",
                ...this.tools[p].definition
            }))), f = {
            ...this.sessionConfig
        };
        return f.tools = d, this.realtime.isConnected() && this.realtime.send("session.update", {
            session: f
        }), !0;
    }
    sendUserMessageContent(t = []) {
        if (t.length) {
            for (let e of t)e.type === "input_audio" && (e.audio instanceof ArrayBuffer || e.audio instanceof Int16Array) && (e.audio = ys.arrayBufferToBase64(e.audio));
            this.realtime.send("conversation.item.create", {
                item: {
                    type: "message",
                    role: "user",
                    content: t
                }
            });
        }
        return this.createResponse(), !0;
    }
    appendInputAudio(t) {
        return t.byteLength > 0 && (this.realtime.send("input_audio_buffer.append", {
            audio: ys.arrayBufferToBase64(t)
        }), this.inputAudioBuffer = ys.mergeInt16Arrays(this.inputAudioBuffer, t)), !0;
    }
    createResponse() {
        return this.getTurnDetectionType() === null && this.inputAudioBuffer.byteLength > 0 && (this.realtime.send("input_audio_buffer.commit"), this.conversation.queueInputAudio(this.inputAudioBuffer), this.inputAudioBuffer = new Int16Array(0)), this.realtime.send("response.create"), !0;
    }
    cancelResponse(t, e = 0) {
        if (t) {
            if (t) {
                let r = this.conversation.getItem(t);
                if (!r) throw new Error(`Could not find item "${t}"`);
                if (r.type !== "message") throw new Error('Can only cancelResponse messages with type "message"');
                if (r.role !== "assistant") throw new Error('Can only cancelResponse messages with role "assistant"');
                this.realtime.send("response.cancel");
                let i = r.content.findIndex((s)=>s.type === "audio");
                if (i === -1) throw new Error("Could not find audio on item to cancel");
                return this.realtime.send("conversation.item.truncate", {
                    item_id: t,
                    content_index: i,
                    audio_end_ms: Math.floor(e / this.conversation.defaultFrequency * 1e3)
                }), {
                    item: r
                };
            }
        } else return this.realtime.send("response.cancel"), {
            item: null
        };
    }
    async waitForNextItem() {
        let t = await this.waitForNext("conversation.item.appended"), { item: e } = t;
        return {
            item: e
        };
    }
    async waitForNextCompletedItem() {
        let t = await this.waitForNext("conversation.item.completed"), { item: e } = t;
        return {
            item: e
        };
    }
};
var HX = `
class AudioProcessor extends AudioWorkletProcessor {

  constructor() {
    super();
    this.port.onmessage = this.receive.bind(this);
    this.initialize();
  }

  initialize() {
    this.foundAudio = false;
    this.recording = false;
    this.chunks = [];
  }

  /**
   * Concatenates sampled chunks into channels
   * Format is chunk[Left[], Right[]]
   */
  readChannelData(chunks, channel = -1, maxChannels = 9) {
    let channelLimit;
    if (channel !== -1) {
      if (chunks[0] && chunks[0].length - 1 < channel) {
        throw new Error(
          \`Channel \${channel} out of range: max \${chunks[0].length}\`
        );
      }
      channelLimit = channel + 1;
    } else {
      channel = 0;
      channelLimit = Math.min(chunks[0] ? chunks[0].length : 1, maxChannels);
    }
    const channels = [];
    for (let n = channel; n < channelLimit; n++) {
      const length = chunks.reduce((sum, chunk) => {
        return sum + chunk[n].length;
      }, 0);
      const buffers = chunks.map((chunk) => chunk[n]);
      const result = new Float32Array(length);
      let offset = 0;
      for (let i = 0; i < buffers.length; i++) {
        result.set(buffers[i], offset);
        offset += buffers[i].length;
      }
      channels[n] = result;
    }
    return channels;
  }

  /**
   * Combines parallel audio data into correct format,
   * channels[Left[], Right[]] to float32Array[LRLRLRLR...]
   */
  formatAudioData(channels) {
    if (channels.length === 1) {
      // Simple case is only one channel
      const float32Array = channels[0].slice();
      const meanValues = channels[0].slice();
      return { float32Array, meanValues };
    } else {
      const float32Array = new Float32Array(
        channels[0].length * channels.length
      );
      const meanValues = new Float32Array(channels[0].length);
      for (let i = 0; i < channels[0].length; i++) {
        const offset = i * channels.length;
        let meanValue = 0;
        for (let n = 0; n < channels.length; n++) {
          float32Array[offset + n] = channels[n][i];
          meanValue += channels[n][i];
        }
        meanValues[i] = meanValue / channels.length;
      }
      return { float32Array, meanValues };
    }
  }

  /**
   * Converts 32-bit float data to 16-bit integers
   */
  floatTo16BitPCM(float32Array) {
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;
    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, float32Array[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return buffer;
  }

  /**
   * Retrieves the most recent amplitude values from the audio stream
   * @param {number} channel
   */
  getValues(channel = -1) {
    const channels = this.readChannelData(this.chunks, channel);
    const { meanValues } = this.formatAudioData(channels);
    return { meanValues, channels };
  }

  /**
   * Exports chunks as an audio/wav file
   */
  export() {
    const channels = this.readChannelData(this.chunks);
    const { float32Array, meanValues } = this.formatAudioData(channels);
    const audioData = this.floatTo16BitPCM(float32Array);
    return {
      meanValues: meanValues,
      audio: {
        bitsPerSample: 16,
        channels: channels,
        data: audioData,
      },
    };
  }

  receive(e) {
    const { event, id } = e.data;
    let receiptData = {};
    switch (event) {
      case 'start':
        this.recording = true;
        break;
      case 'stop':
        this.recording = false;
        break;
      case 'clear':
        this.initialize();
        break;
      case 'export':
        receiptData = this.export();
        break;
      case 'read':
        receiptData = this.getValues();
        break;
      default:
        break;
    }
    // Always send back receipt
    this.port.postMessage({ event: 'receipt', id, data: receiptData });
  }

  sendChunk(chunk) {
    const channels = this.readChannelData([chunk]);
    const { float32Array, meanValues } = this.formatAudioData(channels);
    const rawAudioData = this.floatTo16BitPCM(float32Array);
    const monoAudioData = this.floatTo16BitPCM(meanValues);
    this.port.postMessage({
      event: 'chunk',
      data: {
        mono: monoAudioData,
        raw: rawAudioData,
      },
    });
  }

  process(inputList, outputList, parameters) {
    // Copy input to output (e.g. speakers)
    // Note that this creates choppy sounds with Mac products
    const sourceLimit = Math.min(inputList.length, outputList.length);
    for (let inputNum = 0; inputNum < sourceLimit; inputNum++) {
      const input = inputList[inputNum];
      const output = outputList[inputNum];
      const channelCount = Math.min(input.length, output.length);
      for (let channelNum = 0; channelNum < channelCount; channelNum++) {
        input[channelNum].forEach((sample, i) => {
          output[channelNum][i] = sample;
        });
      }
    }
    const inputs = inputList[0];
    // There's latency at the beginning of a stream before recording starts
    // Make sure we actually receive audio data before we start storing chunks
    let sliceIndex = 0;
    if (!this.foundAudio) {
      for (const channel of inputs) {
        sliceIndex = 0; // reset for each channel
        if (this.foundAudio) {
          break;
        }
        if (channel) {
          for (const value of channel) {
            if (value !== 0) {
              // find only one non-zero entry in any channel
              this.foundAudio = true;
              break;
            } else {
              sliceIndex++;
            }
          }
        }
      }
    }
    if (inputs && inputs[0] && this.foundAudio && this.recording) {
      // We need to copy the TypedArray, because the \`process\`
      // internals will reuse the same buffer to hold each input
      const chunk = inputs.map((input) => input.slice(sliceIndex));
      this.chunks.push(chunk);
      this.sendChunk(chunk);
    }
    return true;
  }
}

registerProcessor('audio_processor', AudioProcessor);
`, WX = new Blob([
    HX
], {
    type: "application/javascript"
}), qX = URL.createObjectURL(WX), r3 = qX;
var i3 = [
    4186.01,
    4434.92,
    4698.63,
    4978.03,
    5274.04,
    5587.65,
    5919.91,
    6271.93,
    6644.88,
    7040,
    7458.62,
    7902.13
], YX = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
], Ba = [], ux = [];
for(let n1 = 1; n1 <= 8; n1++)for(let t = 0; t < i3.length; t++){
    let e = i3[t];
    Ba.push(e / Math.pow(2, 8 - n1)), ux.push(YX[t] + n1);
}
var cx = [
    32,
    2e3
], _E = Ba.filter((n1, t)=>Ba[t] > cx[0] && Ba[t] < cx[1]), n3 = ux.filter((n1, t)=>Ba[t] > cx[0] && Ba[t] < cx[1]);
var jl = class {
    static getFrequencies(t, e, r, i = "frequency", s = -100, o = -30) {
        r || (r = new Float32Array(t.frequencyBinCount), t.getFloatFrequencyData(r));
        let a = e / 2, l = 1 / r.length * a, c, u, h;
        if (i === "music" || i === "voice") {
            let p = i === "voice" ? _E : Ba, m = Array(p.length).fill(s);
            for(let g = 0; g < r.length; g++){
                let y = g * l, x = r[g];
                for(let v = p.length - 1; v >= 0; v--)if (y > p[v]) {
                    m[v] = Math.max(m[v], x);
                    break;
                }
            }
            c = m, u = i === "voice" ? _E : Ba, h = i === "voice" ? n3 : ux;
        } else c = Array.from(r), u = c.map((p, m)=>l * m), h = u.map((p)=>`${p.toFixed(2)} Hz`);
        let d = c.map((p)=>Math.max(0, Math.min((p - s) / (o - s), 1)));
        return {
            values: new Float32Array(d),
            frequencies: u,
            labels: h
        };
    }
    constructor(t, e = null){
        if (this.fftResults = [], e) {
            let { length: r, sampleRate: i } = e, s = new OfflineAudioContext({
                length: r,
                sampleRate: i
            }), o = s.createBufferSource();
            o.buffer = e;
            let a = s.createAnalyser();
            a.fftSize = 8192, a.smoothingTimeConstant = .1, o.connect(a);
            let l = 1 / 60, c = r / i, u = (h)=>{
                let d = l * h;
                d < c && s.suspend(d).then(()=>{
                    let f = new Float32Array(a.frequencyBinCount);
                    a.getFloatFrequencyData(f), this.fftResults.push(f), u(h + 1);
                }), h === 1 ? s.startRendering() : s.resume();
            };
            o.start(0), u(1), this.audio = t, this.context = s, this.analyser = a, this.sampleRate = i, this.audioBuffer = e;
        } else {
            let r = new AudioContext, i = r.createMediaElementSource(t), s = r.createAnalyser();
            s.fftSize = 8192, s.smoothingTimeConstant = .1, i.connect(s), s.connect(r.destination), this.audio = t, this.context = r, this.analyser = s, this.sampleRate = this.context.sampleRate, this.audioBuffer = null;
        }
    }
    getFrequencies(t = "frequency", e = -100, r = -30) {
        let i = null;
        if (this.audioBuffer && this.fftResults.length) {
            let s = this.audio.currentTime / this.audio.duration, o = Math.min(s * this.fftResults.length | 0, this.fftResults.length - 1);
            i = this.fftResults[o];
        }
        return jl.getFrequencies(this.analyser, this.sampleRate, i, t, e, r);
    }
    async resumeIfSuspended() {
        return this.context.state === "suspended" && await this.context.resume(), !0;
    }
};
var Na = class {
    static floatTo16BitPCM(t) {
        let e = new ArrayBuffer(t.length * 2), r = new DataView(e), i = 0;
        for(let s = 0; s < t.length; s++, i += 2){
            let o = Math.max(-1, Math.min(1, t[s]));
            r.setInt16(i, o < 0 ? o * 32768 : o * 32767, !0);
        }
        return e;
    }
    static mergeBuffers(t, e) {
        let r = new Uint8Array(t.byteLength + e.byteLength);
        return r.set(new Uint8Array(t), 0), r.set(new Uint8Array(e), t.byteLength), r.buffer;
    }
    _packData(t, e) {
        return [
            new Uint8Array([
                e,
                e >> 8
            ]),
            new Uint8Array([
                e,
                e >> 8,
                e >> 16,
                e >> 24
            ])
        ][t];
    }
    pack(t, e) {
        if (e?.bitsPerSample) {
            if (e?.channels) {
                if (!e?.data) throw new Error('Missing "data"');
            } else throw new Error('Missing "channels"');
        } else throw new Error('Missing "bitsPerSample"');
        let { bitsPerSample: r, channels: i, data: s } = e, o = [
            "RIFF",
            this._packData(1, 52),
            "WAVE",
            "fmt ",
            this._packData(1, 16),
            this._packData(0, 1),
            this._packData(0, i.length),
            this._packData(1, t),
            this._packData(1, t * i.length * r / 8),
            this._packData(0, i.length * r / 8),
            this._packData(0, r),
            "data",
            this._packData(1, i[0].length * i.length * r / 8),
            s
        ], a = new Blob(o, {
            type: "audio/mpeg"
        }), l = URL.createObjectURL(a);
        return {
            blob: a,
            url: l,
            channelCount: i.length,
            sampleRate: t,
            duration: s.byteLength / (i.length * t * 2)
        };
    }
};
var Im = class {
    constructor({ sampleRate: t = 44100, outputToSpeakers: e = !1, debug: r = !1 } = {}){
        this.scriptSrc = r3, this.sampleRate = t, this.outputToSpeakers = e, this.debug = !!r, this._deviceChangeCallback = null, this._devices = [], this.stream = null, this.processor = null, this.source = null, this.node = null, this.recording = !1, this._lastEventId = 0, this.eventReceipts = {}, this.eventTimeout = 5e3, this._chunkProcessor = ()=>{}, this._chunkProcessorSize = void 0, this._chunkProcessorBuffer = {
            raw: new ArrayBuffer(0),
            mono: new ArrayBuffer(0)
        };
    }
    static async decode(t, e = 44100, r = -1) {
        let i = new AudioContext({
            sampleRate: e
        }), s, o;
        if (t instanceof Blob) {
            if (r !== -1) throw new Error('Can not specify "fromSampleRate" when reading from Blob');
            o = t, s = await o.arrayBuffer();
        } else if (t instanceof ArrayBuffer) {
            if (r !== -1) throw new Error('Can not specify "fromSampleRate" when reading from ArrayBuffer');
            s = t, o = new Blob([
                s
            ], {
                type: "audio/wav"
            });
        } else {
            let u, h;
            if (t instanceof Int16Array) {
                h = t, u = new Float32Array(t.length);
                for(let m = 0; m < t.length; m++)u[m] = t[m] / 32768;
            } else if (t instanceof Float32Array) u = t;
            else if (t instanceof Array) u = new Float32Array(t);
            else throw new Error('"audioData" must be one of: Blob, Float32Arrray, Int16Array, ArrayBuffer, Array<number>');
            if (r === -1) throw new Error('Must specify "fromSampleRate" when reading from Float32Array, In16Array or Array');
            if (r < 3e3) throw new Error('Minimum "fromSampleRate" is 3000 (3kHz)');
            h || (h = Na.floatTo16BitPCM(u));
            let d = {
                bitsPerSample: 16,
                channels: [
                    u
                ],
                data: h
            };
            o = new Na().pack(r, d).blob, s = await o.arrayBuffer();
        }
        let a = await i.decodeAudioData(s), l = a.getChannelData(0), c = URL.createObjectURL(o);
        return {
            blob: o,
            url: c,
            values: l,
            audioBuffer: a
        };
    }
    log() {
        return this.debug && this.log(...arguments), !0;
    }
    getSampleRate() {
        return this.sampleRate;
    }
    getStatus() {
        return this.processor ? this.recording ? "recording" : "paused" : "ended";
    }
    async _event(t, e = {}, r = null) {
        if (r = r || this.processor, !r) throw new Error("Can not send events without recording first");
        let i = {
            event: t,
            id: this._lastEventId++,
            data: e
        };
        r.port.postMessage(i);
        let s = new Date().valueOf();
        for(; !this.eventReceipts[i.id];){
            if (new Date().valueOf() - s > this.eventTimeout) throw new Error(`Timeout waiting for "${t}" event`);
            await new Promise((a)=>setTimeout(()=>a(!0), 1));
        }
        let o = this.eventReceipts[i.id];
        return delete this.eventReceipts[i.id], o;
    }
    listenForDeviceChange(t) {
        if (t === null && this._deviceChangeCallback) navigator.mediaDevices.removeEventListener("devicechange", this._deviceChangeCallback), this._deviceChangeCallback = null;
        else if (t !== null) {
            let e = 0, r = [], i = (o)=>o.map((a)=>a.deviceId).sort().join(","), s = async ()=>{
                let o = ++e, a = await this.listDevices();
                o === e && i(r) !== i(a) && (r = a, t(a.slice()));
            };
            navigator.mediaDevices.addEventListener("devicechange", s), s(), this._deviceChangeCallback = s;
        }
        return !0;
    }
    async requestPermission() {
        let t = await navigator.permissions.query({
            name: "microphone"
        });
        if (t.state === "denied") window.alert("You must grant microphone access to use this feature.");
        else if (t.state === "prompt") try {
            (await navigator.mediaDevices.getUserMedia({
                audio: !0
            })).getTracks().forEach((i)=>i.stop());
        } catch  {
            window.alert("You must grant microphone access to use this feature.");
        }
        return !0;
    }
    async listDevices() {
        if (!navigator.mediaDevices || !("enumerateDevices" in navigator.mediaDevices)) throw new Error("Could not request user devices");
        await this.requestPermission();
        let e = (await navigator.mediaDevices.enumerateDevices()).filter((s)=>s.kind === "audioinput"), r = e.findIndex((s)=>s.deviceId === "default"), i = [];
        if (r !== -1) {
            let s = e.splice(r, 1)[0], o = e.findIndex((a)=>a.groupId === s.groupId);
            o !== -1 && (s = e.splice(o, 1)[0]), s.default = !0, i.push(s);
        }
        return i.concat(e);
    }
    async begin(t) {
        if (this.processor) throw new Error("Already connected: please call .end() to start a new session");
        if (!navigator.mediaDevices || !("getUserMedia" in navigator.mediaDevices)) throw new Error("Could not request user media");
        try {
            let a = {
                audio: !0
            };
            t && (a.audio = {
                deviceId: {
                    exact: t
                }
            }), this.stream = await navigator.mediaDevices.getUserMedia(a);
        } catch  {
            throw new Error("Could not start media stream");
        }
        let e = new AudioContext({
            sampleRate: this.sampleRate
        }), r = e.createMediaStreamSource(this.stream);
        try {
            await e.audioWorklet.addModule(this.scriptSrc);
        } catch (a) {
            throw console.error(a), new Error(`Could not add audioWorklet module: ${this.scriptSrc}`);
        }
        let i = new AudioWorkletNode(e, "audio_processor");
        i.port.onmessage = (a)=>{
            let { event: l, id: c, data: u } = a.data;
            if (l === "receipt") this.eventReceipts[c] = u;
            else if (l === "chunk") {
                if (this._chunkProcessorSize) {
                    let h = this._chunkProcessorBuffer;
                    this._chunkProcessorBuffer = {
                        raw: Na.mergeBuffers(h.raw, u.raw),
                        mono: Na.mergeBuffers(h.mono, u.mono)
                    }, this._chunkProcessorBuffer.mono.byteLength >= this._chunkProcessorSize && (this._chunkProcessor(this._chunkProcessorBuffer), this._chunkProcessorBuffer = {
                        raw: new ArrayBuffer(0),
                        mono: new ArrayBuffer(0)
                    });
                } else this._chunkProcessor(u);
            }
        };
        let s = r.connect(i), o = e.createAnalyser();
        return o.fftSize = 8192, o.smoothingTimeConstant = .1, s.connect(o), this.outputToSpeakers && (console.warn(`Warning: Output to speakers may affect sound quality,
especially due to system audio feedback preventative measures.
use only for debugging`), o.connect(e.destination)), this.source = r, this.node = s, this.analyser = o, this.processor = i, !0;
    }
    getFrequencies(t = "frequency", e = -100, r = -30) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        return jl.getFrequencies(this.analyser, this.sampleRate, null, t, e, r);
    }
    async pause() {
        if (this.processor) {
            if (!this.recording) throw new Error("Already paused: please call .record() first");
        } else throw new Error("Session ended: please call .begin() first");
        return this._chunkProcessorBuffer.raw.byteLength && this._chunkProcessor(this._chunkProcessorBuffer), this.log("Pausing ..."), await this._event("stop"), this.recording = !1, !0;
    }
    async record(t = ()=>{}, e = 8192) {
        if (this.processor) {
            if (this.recording) throw new Error("Already recording: please call .pause() first");
            if (typeof t != "function") throw new Error("chunkProcessor must be a function");
        } else throw new Error("Session ended: please call .begin() first");
        return this._chunkProcessor = t, this._chunkProcessorSize = e, this._chunkProcessorBuffer = {
            raw: new ArrayBuffer(0),
            mono: new ArrayBuffer(0)
        }, this.log("Recording ..."), await this._event("start"), this.recording = !0, !0;
    }
    async clear() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        return await this._event("clear"), !0;
    }
    async read() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        return this.log("Reading ..."), await this._event("read");
    }
    async save(t = !1) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        if (!t && this.recording) throw new Error("Currently recording: please call .pause() first, or call .save(true) to force");
        this.log("Exporting ...");
        let e = await this._event("export");
        return new Na().pack(this.sampleRate, e.audio);
    }
    async end() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        let t = this.processor;
        this.log("Stopping ..."), await this._event("stop"), this.recording = !1, this.stream.getTracks().forEach((o)=>o.stop()), this.log("Exporting ...");
        let r = await this._event("export", {}, t);
        return this.processor.disconnect(), this.source.disconnect(), this.node.disconnect(), this.analyser.disconnect(), this.stream = null, this.processor = null, this.source = null, this.node = null, new Na().pack(this.sampleRate, r.audio);
    }
    async quit() {
        return this.listenForDeviceChange(null), this.processor && await this.end(), !0;
    }
};
var XX = `
class StreamProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.hasStarted = false;
    this.hasInterrupted = false;
    this.outputBuffers = [];
    this.bufferLength = 128;
    this.write = { buffer: new Float32Array(this.bufferLength), trackId: null };
    this.writeOffset = 0;
    this.trackSampleOffsets = {};
    this.port.onmessage = (event) => {
      if (event.data) {
        const payload = event.data;
        if (payload.event === 'write') {
          const int16Array = payload.buffer;
          const float32Array = new Float32Array(int16Array.length);
          for (let i = 0; i < int16Array.length; i++) {
            float32Array[i] = int16Array[i] / 0x8000; // Convert Int16 to Float32
          }
          this.writeData(float32Array, payload.trackId);
        } else if (
          payload.event === 'offset' ||
          payload.event === 'interrupt'
        ) {
          const requestId = payload.requestId;
          const trackId = this.write.trackId;
          const offset = this.trackSampleOffsets[trackId] || 0;
          this.port.postMessage({
            event: 'offset',
            requestId,
            trackId,
            offset,
          });
          if (payload.event === 'interrupt') {
            this.hasInterrupted = true;
          }
        } else {
          throw new Error(\`Unhandled event "\${payload.event}"\`);
        }
      }
    };
  }

  writeData(float32Array, trackId = null) {
    let { buffer } = this.write;
    let offset = this.writeOffset;
    for (let i = 0; i < float32Array.length; i++) {
      buffer[offset++] = float32Array[i];
      if (offset >= buffer.length) {
        this.outputBuffers.push(this.write);
        this.write = { buffer: new Float32Array(this.bufferLength), trackId };
        buffer = this.write.buffer;
        offset = 0;
      }
    }
    this.writeOffset = offset;
    return true;
  }

  process(inputs, outputs, parameters) {
    const output = outputs[0];
    const outputChannelData = output[0];
    const outputBuffers = this.outputBuffers;
    if (this.hasInterrupted) {
      this.port.postMessage({ event: 'stop' });
      return false;
    } else if (outputBuffers.length) {
      this.hasStarted = true;
      const { buffer, trackId } = outputBuffers.shift();
      for (let i = 0; i < outputChannelData.length; i++) {
        outputChannelData[i] = buffer[i] || 0;
      }
      if (trackId) {
        this.trackSampleOffsets[trackId] =
          this.trackSampleOffsets[trackId] || 0;
        this.trackSampleOffsets[trackId] += buffer.length;
      }
      return true;
    } else if (this.hasStarted) {
      this.port.postMessage({ event: 'stop' });
      return false;
    } else {
      return true;
    }
  }
}

registerProcessor('stream_processor', StreamProcessor);
`, KX = new Blob([
    XX
], {
    type: "application/javascript"
}), QX = URL.createObjectURL(KX), s3 = QX;
var hx = class {
    constructor({ sampleRate: t = 44100 } = {}){
        this.scriptSrc = s3, this.sampleRate = t, this.context = null, this.stream = null, this.analyser = null, this.trackSampleOffsets = {}, this.interruptedTrackIds = {};
    }
    async connect() {
        this.context = new AudioContext({
            sampleRate: this.sampleRate
        }), this.context.state === "suspended" && await this.context.resume();
        try {
            await this.context.audioWorklet.addModule(this.scriptSrc);
        } catch (e) {
            throw console.error(e), new Error(`Could not add audioWorklet module: ${this.scriptSrc}`);
        }
        let t = this.context.createAnalyser();
        return t.fftSize = 8192, t.smoothingTimeConstant = .1, this.analyser = t, !0;
    }
    getFrequencies(t = "frequency", e = -100, r = -30) {
        if (!this.analyser) throw new Error("Not connected, please call .connect() first");
        return jl.getFrequencies(this.analyser, this.sampleRate, null, t, e, r);
    }
    _start() {
        let t = new AudioWorkletNode(this.context, "stream_processor");
        return t.connect(this.context.destination), t.port.onmessage = (e)=>{
            let { event: r } = e.data;
            if (r === "stop") t.disconnect(), this.stream = null;
            else if (r === "offset") {
                let { requestId: i, trackId: s, offset: o } = e.data, a = o / this.sampleRate;
                this.trackSampleOffsets[i] = {
                    trackId: s,
                    offset: o,
                    currentTime: a
                };
            }
        }, this.analyser.disconnect(), t.connect(this.analyser), this.stream = t, !0;
    }
    add16BitPCM(t, e = "default") {
        if (typeof e != "string") throw new Error("trackId must be a string");
        if (this.interruptedTrackIds[e]) return;
        this.stream || this._start();
        let r;
        if (t instanceof Int16Array) r = t;
        else if (t instanceof ArrayBuffer) r = new Int16Array(t);
        else throw new Error("argument must be Int16Array or ArrayBuffer");
        return this.stream.port.postMessage({
            event: "write",
            buffer: r,
            trackId: e
        }), r;
    }
    async getTrackSampleOffset(t = !1) {
        if (!this.stream) return null;
        let e = crypto.randomUUID();
        this.stream.port.postMessage({
            event: t ? "interrupt" : "offset",
            requestId: e
        });
        let r;
        for(; !r;)r = this.trackSampleOffsets[e], await new Promise((s)=>setTimeout(()=>s(), 1));
        let { trackId: i } = r;
        return t && i && (this.interruptedTrackIds[i] = !0), r;
    }
    async interrupt() {
        return this.getTrackSampleOffset(!0);
    }
};
var o3 = ()=>"https://relayserver.spline.design/", Dm = class {
    constructor(t, e, r){
        this.data = t;
        this.id = e;
        this.shared = r;
        this.items = [];
        this.isConnected = !1;
        this.rafId = 0;
        this.emitter = Pa();
        this.voice = 0;
        this.frequencies = new Float32Array([
            0
        ]);
        this.onRealTimeEvent = ({ time: t, source: e, event: r })=>{
            e === "server" && r.type === "spline.ready" ? this.onSessionCreated(r) : e === "server" && r.type === "session.created" && (this.client.createResponse(), this.client.on("realtime.event", this.onRealTimeEvent));
        };
        this.onSessionCreated = async (t)=>{
            let e = Object.values(this.client.tools).map((r)=>({
                    type: "function",
                    ...r.definition
                }));
            this.client.realtime.send("spline.tools", {
                tools: e
            }), this.client.realtime.send("spline.connect", {}), await this.wavRecorder.record((r)=>this.client.isConnected() && this.client.appendInputAudio(r.mono));
        };
        this.animate = ()=>{
            if (this.rafId = requestAnimationFrame(this.animate), this.isConnected) {
                let t = this.wavStreamPlayer.analyser ? this.wavStreamPlayer.getFrequencies("voice") : {
                    values: new Float32Array([
                        0
                    ])
                }, e = t.values.reduce((r, i)=>r + i, 0) / t.values.length;
                this.voice = e, this.frequencies = t.values, this.emitter.emit("voice", {
                    value: e,
                    frequencies: t.values
                });
            }
        };
        this.client = new rf({
            url: o3() + "?uuidfile=" + t.integration.hash
        }), this.wavRecorder = new Im({
            sampleRate: 24e3
        }), this.wavStreamPlayer = new hx({
            sampleRate: 24e3
        });
    }
    update(t) {
        this.data = t, this.client = new rf({
            url: o3() + "?uuidfile=" + t.integration.hash
        });
    }
    setColorByName(t, e) {
        let r = this.shared.getColorByName(t);
        if (r) {
            let { id: i } = r, { r: s, g: o, b: a } = JO.hexStringToRgb(e) ?? {
                r: 0,
                g: 0,
                b: 0
            };
            this.shared.updateColor(i, {
                r: s / 255,
                g: o / 255,
                b: a / 255
            });
        }
    }
    connect() {
        if (this.isConnected) return;
        this.isConnected = !0, this.client.updateSession({
            turn_detection: {
                type: "server_vad"
            }
        }), this.client.addTool({
            name: "set_personality_color",
            description: "returns a color based on the voice personality of the ai assistant. This should be called by the voice assistant each time it is asks to speak differently. If a color cannot be associated to the personality, the color should be a neutral color.",
            parameters: {
                type: "object",
                properties: {
                    color: {
                        type: "string",
                        description: "css hex color string, reflecting the personality"
                    },
                    personality: {
                        type: "string",
                        description: "the personality of the voice assistant"
                    }
                },
                required: [
                    "color",
                    "personality"
                ]
            }
        }, ({ color: s })=>{
            this.setColorByName("Voice Assistant Color", s);
        });
        let t = this.shared.getVariablesNames().join(", ");
        this.client.addTool({
            name: "set_variable",
            description: "Sets a Spline variable value when asked by the user.",
            parameters: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        description: `The name of the variable that needs to be set. Here's a list of available variables: ${t}. It the variable does not exist, don't call the function and warn the user about it.`
                    },
                    value: {
                        type: "string",
                        description: "The new value for this variable, should always be a string even for number and boolean variables, assume that the value will be cast to the proper type afterwards."
                    }
                },
                required: [
                    "name",
                    "value",
                    "type"
                ]
            }
        }, ({ name: s, value: o })=>{
            let a = this.shared.getVariableByName(s);
            if (a) {
                let l = this.shared.getVariable(a.id), c;
                typeof l == "number" ? c = parseFloat(o) : typeof l == "boolean" ? c = o.toLowerCase() === "true" : c = {
                    textValue: o
                }, this.shared.updateVariable(a.id, c);
            }
        });
        let e = this.shared.getColorNames().join(", ");
        this.client.addTool({
            name: "set_color",
            description: "Sets a Spline color asset value when asked by the user.",
            parameters: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        description: `The name of the color asset that needs to be set. Here's a list of available color assets: ${e}. It the color asset does not exist, don't call the function and warn the user about it.`
                    },
                    value: {
                        type: "string",
                        description: "css hex color string"
                    }
                },
                required: [
                    "name",
                    "value"
                ]
            }
        }, ({ name: s, value: o })=>{
            this.setColorByName(s, o);
        });
        let r = this.shared.scene, i = [];
        r.traverseEntity((s)=>{
            s.data.events.forEach((o)=>{
                if (o.data.type === "AIAssistantTrigger") {
                    let { description: a } = o.data;
                    i.push(a);
                }
            });
        }), this.client.addTool({
            name: "trigger_event",
            description: "Trigger an event by name, here are the available events, please match what the user is asking for to one of these if it applies, otherwise don't call the function and warn the user.",
            parameters: {
                type: "object",
                properties: {
                    description: {
                        type: "string",
                        description: `The name of the event that needs to be triggered. Here's a list of available events: ${JSON.stringify(i)}.`
                    },
                    direction: {
                        type: "string",
                        description: "default is forward, but can be forward or backward. Always set to forward unless the user ask to reverse or cancel the event, then set to backward."
                    }
                },
                required: [
                    "description",
                    "direction"
                ]
            }
        }, ({ description: s, direction: o })=>{
            this.emitter.emit("trigger_event", {
                description: s,
                direction: o
            });
        }), this.client.on("error", (s)=>console.error(s)), this.client.on("conversation.interrupted", async ()=>{
            let s = await this.wavStreamPlayer.interrupt();
            if (s?.trackId) {
                let { trackId: o, offset: a } = s;
                await this.client.cancelResponse(o, a);
            }
        }), this.client.on("conversation.updated", async ({ item: s, delta: o })=>{
            let a = this.client.conversation.getItems();
            if (o?.audio && this.wavStreamPlayer.add16BitPCM(o.audio, s.id), s.status === "completed" && s.formatted.audio?.length) {
                let l = await Im.decode(s.formatted.audio, 24e3, 24e3);
                s.formatted.file = l;
            }
            this.items = a;
        }), this.animate();
    }
    disconnect() {
        cancelAnimationFrame(this.rafId), this.voice = 0, this.isConnected = !1;
    }
    async start() {
        try {
            await this.wavRecorder.end();
        } catch  {}
        await this.wavRecorder.begin(), this.client.on("realtime.event", this.onRealTimeEvent), await this.wavStreamPlayer.connect(), await this.client.connect();
    }
    async stop() {
        try {
            this.client.off("realtime.event", this.onRealTimeEvent);
        } catch (t) {
            console.error(t);
        }
        this.client.disconnect(), await this.wavRecorder.end(), await this.wavStreamPlayer.interrupt();
    }
    computeAnalysisForListenerEvent(t) {
        if (t.analysis === "range") {
            let e = this.frequencies.slice(...t.analysisRange);
            return e.reduce((r, i)=>r + i, 0) / e.length;
        }
        return t.analysis === "single" ? this.frequencies[t.analysisSingle] : this.voice;
    }
    on(t, e) {
        this.emitter.on(t, e);
    }
    off(t, e) {
        this.emitter.off(t, e);
    }
};
function dx(n1) {
    return "variable_" + n1;
}
var IE = class extends Z0 {
    constructor(e){
        super();
        this.shared = e;
    }
    create(e) {
        return new ef(e, this.shared);
    }
}, Zc = class {
    constructor(t, e = {}, r = !0, i = !1){
        this.data = t;
        this.needsJitter = r;
        this.enableLocalStorageForPersistentVariables = i;
        this.geometryCache = new Cm(!0);
        this.geometryCache2 = new Cm(!1);
        this.imageHolderCache = new IE(this);
        this.thisContext = {
            scene: $R,
            shared: this
        };
        this.deletedMaterial = new Qc(Kr.defaultTwoLayerData("phong"), this.thisContext, "");
        this.deletedImage = new Jn(n0.emptyImage, this);
        this.deletedVideo = new Jn(zh.defaultVideo, this);
        this.materials = {};
        this.images = {};
        this.uiBuffers = {};
        this.videos = {};
        this.colors = {};
        this.audios = {};
        this.particles = {};
        this.fonts = {};
        this.variables = {};
        this.userAPIs = {};
        this.userWebhooks = {};
        this.mouseProperty = null;
        this.raycastProperty = null;
        this.requestRender = ()=>{
            this._requestRender && this._requestRender();
        };
        if (e.images) for (let [s, o] of Object.entries(e.images))this.addImage(s, o);
        if (e.videos) for (let [s, o] of Object.entries(e.videos))this.addVideo(s, o);
        if (e.audios) for (let [s, o] of Object.entries(e.audios))this.addAudio(s, o);
        if (e.particles) for (let [s, o] of Object.entries(e.particles))this.addParticle(s, o);
        this.reset(t);
    }
    setRequestRender(t) {
        this._requestRender = t;
    }
    getImageLoadPromises() {
        return Object.values(this.images).map((t)=>t.loadPromise);
    }
    setEntityOpContext(t) {
        this.entityOpContext = t;
    }
    reset(t, e = !1) {
        this.data = t, this.resetLib(t.lib);
        for (let { id: r, data: i } of t.variables)this.addVariableHolder(r, i), e && this.updateVariableHolder(r, i);
        for (let [r, i] of Object.entries(t.userAPIs))this.addUserAPI(r, i);
        for (let [r, i] of Object.entries(t.userWebhooks))this.addUserWebhook(r, i);
        for (let [r, i] of Object.entries(t.images))this.addImage(r, i);
        for (let [r, i] of Object.entries(t.videos))this.addVideo(r, i);
        for (let [r, i] of Object.entries(t.colors))this.addColor(r, i);
        for (let [r, i] of Object.entries(t.materials))this.addMaterial(r, i);
        for (let [r, i] of Object.entries(t.audios))this.addAudio(r, i);
        for (let [r, i] of Object.entries(t.particles))this.addParticle(r, i);
        for (let [r, i] of Object.entries(t.fonts))this.addFont(r, i);
    }
    addMaterial(t, e) {
        if (this.materials[t]) {
            let r = this.materials[t];
            r.reset(e, this.thisContext), r.dispose();
        } else {
            let r = new Qc(e, this.thisContext, t);
            this.materials[t] = r;
        }
    }
    deleteMaterial(t) {
        this.materials[t] && (this.materials[t].nodeMaterialDispose(), delete this.materials[t]);
    }
    getMaterial(t) {
        let e = this.materials[t];
        return e;
    }
    getMaterialOrDeletedPlaceholder(t) {
        return this.materials[t] ?? this.deletedMaterial;
    }
    material(t) {
        return typeof t == "string" ? this.getMaterialOrDeletedPlaceholder(t) : t == null ? (console.error("material is undefined or null"), this.deletedMaterial) : new Ra(t, this.thisContext);
    }
    getMaterials() {
        return this.materials;
    }
    addImage(t, e) {
        return this.images[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.images[t].updateSrc(e.data), !0) : (this.images[t] = new Jn(e, this), !1);
    }
    deleteImage(t) {
        let e = this.images[t];
        e && (e.dispose(), delete this.images[t]);
    }
    getDefaultImage() {
        return this.images.image_0;
    }
    getImage(t) {
        return this.images[t] ?? this.deletedImage;
    }
    image(t) {
        return typeof t == "string" ? this.getImage(t) : this.imageHolderCache.load(t);
    }
    addUIBuffer(t, e) {
        return this.uiBuffers[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.uiBuffers[t].updateSrc(e), !0) : (this.uiBuffers[t] = new Jn(e, this), !1);
    }
    uiBuffer(t) {
        return this.uiBuffers[t];
    }
    addVideo(t, e) {
        return this.videos[t] ? (this.videos[t].updateSrc(e.data), !0) : (this.videos[t] = new Jn(e, this), !1);
    }
    deleteVideo(t) {
        let e = this.videos[t];
        e && (e.dispose(), delete this.videos[t]);
    }
    getVideo(t) {
        return this.videos[t] ?? this.deletedVideo;
    }
    video(t) {
        return typeof t == "string" ? this.getVideo(t) : this.imageHolderCache.load(t);
    }
    addColor(t, e) {
        return this.colors[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), "a" in e ? this.colors[t].setRGBA(e.r, e.g, e.b, e.a) : this.colors[t].setRGBA(e.r, e.g, e.b, 1), !0) : ("a" in e ? this.colors[t] = new Ul(e.r, e.g, e.b, e.a) : this.colors[t] = new Ul(e.r, e.g, e.b, 1), !1);
    }
    updateColor(t, e) {
        if (this.colors[t]) {
            this.onColorOrImageUpdate && this.onColorOrImageUpdate();
            let r = this.colors[t];
            return this.colors[t].r = e.r ?? r.r, this.colors[t].g = e.g ?? r.g, this.colors[t].b = e.b ?? r.b, this.colors[t].a = e.a ?? r.a, !0;
        }
        return !1;
    }
    deleteColor(t) {
        this.colors[t] && delete this.colors[t];
    }
    getColor(t) {
        return this.colors[t];
    }
    getColorNames() {
        return Object.values(this.data.colors).map((t)=>t.name);
    }
    getColorByName(t) {
        for(let e in this.data.colors)if (this.data.colors[e].name === t) return {
            color: this.colors[e],
            id: e
        };
    }
    color(t) {
        let e;
        if (typeof t == "string") {
            let r = this.getColor(t);
            r ? e = r : (console.warn("Tried to create color layer params with a color key that does not exist in the assets manager"), e = new vr(0, 0, 0, 0));
        } else return "a" in t ? new vr(t.r, t.g, t.b, t.a) : new vr(t.r, t.g, t.b, 1);
        return e;
    }
    addAudio(t, e) {
        this.audios[t] = e;
    }
    getAudio(t) {
        let e = this.audios[t];
        if (e instanceof La) return e;
        {
            let r = new La({
                src: e.data
            });
            return this.audios[t] = r, r;
        }
    }
    addParticle(t, e) {
        this.particles[t] = e;
    }
    getParticle(t) {
        return this.particles[t];
    }
    deleteParticle(t) {
        this.particles[t] && delete this.particles[t];
    }
    deleteAudio(t) {
        let e = this.audios[t];
        e && (e instanceof La && e.dispose(), delete this.audios[t]);
    }
    addFont(t, e) {
        this.fonts[t] = new ox(e), this.fonts[t].loadingPromise.then(()=>this.requestRender());
    }
    getFont(t) {
        return this.fonts[t];
    }
    deleteFont(t) {
        this.fonts[t] && delete this.fonts[t];
    }
    dispose() {
        Object.keys(this.materials).forEach((e)=>this.deleteMaterial(e)), this._requestRender = void 0, Object.values(this.audios).forEach((e)=>{
            e instanceof La && e.dispose();
        }), this.audios = {}, this.particles = {}, this.geometryCache.dispose(), this.geometryCache2.dispose();
    }
    addVariableHolder(t, e) {
        if (this.variables[t] === void 0) {
            let r = e.value;
            if (this.enableLocalStorageForPersistentVariables && e.persistent) {
                let i = localStorage.getItem(dx(t));
                r = i !== null ? JSON.parse(i) : e.value;
            }
            return this.variables[t] = {
                value: r,
                locations: [],
                persistent: e.persistent
            }, "dynamicVariableType" in e && (this.variables[t].dynamicVariablePlayState = "Playing", this.variables[t].dynamicVariableToggleIsForward = void 0), !0;
        }
        return this.variables[t].value = e.value, !1;
    }
    resetDynamicVariablePlayState() {
        for(let t in this.variables)this.variables[t].dynamicVariablePlayState !== void 0 && (this.variables[t].dynamicVariablePlayState = "Playing", this.variables[t].dynamicVariableToggleIsForward = void 0);
    }
    updateVariableHolder(t, e) {
        this.updateVariable(t, e.value);
    }
    updateVariable(t, e) {
        if (this.variables[t] === void 0) return !1;
        this.variables[t].value = e, this.enableLocalStorageForPersistentVariables && this.variables[t].persistent && localStorage.setItem(dx(t), JSON.stringify(e));
        let r = e;
        for(; typeof r == "string";)r = this.variables[r].value;
        let i = this.entityOpContext.scene;
        for(let s = this.variables[t].locations.length - 1; s >= 0; s--){
            let o = this.variables[t].locations[s];
            if (o[0] === "material") {
                let a = o[1], l = r, c = {
                    scene: i,
                    shared: this
                }, u = o.slice(2);
                i.traverseMaterial((d)=>{
                    let f = d.root ?? d;
                    f.uuid === a && f.onVariableUpdate(u, l, c);
                });
                let h = this.materials[a];
                h && h.onVariableUpdate(u, l, c);
            } else {
                let a = i.find(o[0]);
                if (a === void 0) {
                    this.variables[t].locations.splice(s, 1);
                    continue;
                }
                if (o[1] !== "geometry" && o[1] !== "particles") {
                    for(let l = 1; l < o.length - 1; l++)a = a[o[l]];
                    o[1] === "rotation" ? a[o[o.length - 1]] = r * we.DEG2RAD : a[o[o.length - 1]] = r;
                }
                if (a = i.find(o[0]), a.type === "ParticleEmitter" && a.updateVariableState(r, o), yt.is(a)) {
                    if (o[1] === "position" || o[1] === "rotation" || o[1] === "scale") a.onVariableUpdate();
                    else if (o[1] === "geometry") {
                        let l = a;
                        a.component && (l = a.component);
                        let c = l.dataPatched;
                        l.chooseGeoemtryCache(this).forceDelete(c.geometry), l.createGeometryDelayed(this.entityOpContext), l.onVariableUpdate(!0), l.invalidateDownstreamBooleanData(), l.instances.forEach((u)=>{
                            let h = u.dataPatched;
                            u.chooseGeoemtryCache(this).forceDelete(h.geometry), u.createGeometryDelayed(this.entityOpContext), u.onVariableUpdate(!0), u.invalidateDownstreamBooleanData();
                        });
                    } else o[1] === "morphTargetInfluences" && a.updateMorphInfluences(o[2], r);
                }
            }
        }
        return this.requestRender(), !0;
    }
    deleteVariable(t) {
        this.variables[t] && delete this.variables[t];
    }
    getVariable(t, e) {
        if (Array.isArray(t)) {
            if (t[0] === "mouse") return this.mouseProperty?.[t[1]] ?? 0;
            if (t[0] === "raycast") return this.raycastProperty?.[t[1]] ?? 0;
            let r = this.entityOpContext.scene.find(t[0]);
            if (t[1] === "width" || t[1] === "height" || t[1] === "depth") return r.geometry.userData.parameters[t[1]];
            for(let i = 1; i < t.length; i++)r = r[t[i]];
            return t[1] === "rotation" && (r *= we.RAD2DEG), r;
        }
        for(let r in this.variables){
            if (e === void 0) break;
            let i = this.variables[r], s = i.locations?.findIndex((o)=>Sr.equal(o, e));
            s !== void 0 && s !== -1 && i.locations.splice(s, 1);
        }
        if (typeof t == "string") {
            let r = t, i = t;
            do {
                if (i = r, this.variables[r] === void 0) break;
                let s = this.variables[r].value;
                e && this.variables[i] !== void 0 && this.variables[i].locations.push(e), r = s;
            }while (typeof r == "string");
            return r;
        } else return t;
    }
    getVariables() {
        return this.variables;
    }
    getVariablesNames() {
        return this.data.variables.map((t)=>t.data.name);
    }
    getVariableByName(t) {
        for (let e of this.data.variables)if (e.data.name === t) return {
            variable: e.data,
            id: e.id
        };
    }
    getDynamicVariablePlayState(t) {
        return this.variables[t]?.dynamicVariablePlayState;
    }
    setDynamicVariablePlayState(t, e) {
        this.variables[t] !== void 0 && (this.variables[t].dynamicVariablePlayState = e);
    }
    getDynamicVariableToggleIsForward(t) {
        return this.variables[t]?.dynamicVariableToggleIsForward;
    }
    setDynamicVariableToggleIsForward(t, e) {
        this.variables[t] !== void 0 && (this.variables[t].dynamicVariableToggleIsForward = e);
    }
    resetLib(t) {
        for (let [e, r] of Object.entries(t.images))this.addImage(e, r.asset);
        for (let [e, r] of Object.entries(t.audios))this.addAudio(e, r.asset);
        for (let [e, r] of Object.entries(t.particles))this.addParticle(e, r.asset);
        for (let [e, r] of Object.entries(t.colors))this.addColor(e, r.asset);
        for (let [e, r] of Object.entries(t.fonts))this.addFont(e, r.asset);
        for (let [e, r] of Object.entries(t.materials))this.addMaterial(e, r.asset);
        for (let [e, r] of Object.entries(t.videos))this.addVideo(e, r.asset);
        for (let [e, r] of Object.entries(t.variables))this.addVariableHolder(e, r.asset);
    }
    updateLibByOp(t, e) {
        t.path[0] === "images" ? t.path.length === 1 && t.type === 1 ? this.addImage(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteImage(t.id) : t.path[0] === "videos" ? t.path.length === 1 && t.type === 1 ? this.addVideo(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteVideo(t.id) : t.path[0] === "audios" ? t.path.length === 1 && t.type === 1 ? this.addAudio(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteAudio(t.id) : t.path[0] === "particles" ? t.path.length === 1 && t.type === 1 ? this.addParticle(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteParticle(t.id) : t.path[0] === "colors" ? t.path.length === 1 && t.type === 1 ? this.addColor(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteColor(t.id) : t.path[0] === "materials" ? t.path.length === 1 && t.type === 1 ? this.addMaterial(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteMaterial(t.id) : t.path[0] === "fonts" ? t.path.length === 1 && t.type === 1 ? this.addFont(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteFont(t.id) : t.path[0] === "variables" ? t.path.length === 1 && t.type === 1 ? this.addVariableHolder(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteVariable(t.id) : t.path[0] === "components" && e.updateByLibOp(t, this);
    }
    updateByOp(t, e, r) {
        if (this.data = e, t.path[0] === "images") t.path.length === 2 && t.type === 0 ? t.props.data && this.getImage(t.path[1]).updateSrc(t.props.data) : t.path.length === 1 && t.type === 1 ? this.addImage(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteImage(t.id);
        else if (t.path[0] === "videos") t.path.length === 2 && t.type === 0 ? t.props.data && this.getVideo(t.path[1]).updateSrc(t.props.data) : t.path.length === 1 && t.type === 1 ? this.addVideo(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteVideo(t.id);
        else if (t.path[0] === "audios") t.path.length === 2 && t.type === 0 ? t.props.data && this.addAudio(t.path[1], e.audios[t.path[1]]) : t.path.length === 1 && t.type === 1 ? this.addAudio(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteAudio(t.id);
        else if (t.path[0] === "particles") t.path.length === 2 && t.type === 0 ? t.props.data && this.addParticle(t.path[1], e.particles[t.path[1]]) : t.path.length === 1 && t.type === 1 ? this.addParticle(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteParticle(t.id);
        else if (t.path[0] === "colors") t.path.length === 2 && t.type === 0 ? this.updateColor(t.path[1], t.props) : t.path.length === 1 && t.type === 1 ? this.addColor(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteColor(t.id);
        else if (t.path[0] === "materials") t.path.length === 1 && t.type === 1 ? this.addMaterial(t.id, t.data) : t.path.length === 1 && t.type === 2 ? this.deleteMaterial(t.id) : t.path.length > 1 && this.getMaterial(t.path[1]).updateByOp(Lr.drop(t, 2), e.materials[t.path[1]], {
            shared: this,
            scene: r
        });
        else if (t.path[0] === "fonts") t.path.length === 2 && t.type === 0 ? this.updateFont(t.path[1], t, r) : t.path.length === 1 && t.type === 1 ? this.addFont(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteFont(t.id);
        else if (t.path[0] === "variables") t.path.length === 2 && t.type === 0 ? "value" in t.props ? this.updateVariable(t.path[1], t.props.value) : "persistent" in t.props && (this.variables[t.path[1]].persistent = t.props.persistent) : t.path.length === 1 && t.type === 4 ? this.addVariableHolder(t.id, t.data) : t.path.length === 1 && t.type === 5 && this.deleteVariable(t.id);
        else if (t.path[0] === "userAPIs") {
            if (t.path.length === 1 && t.type === 1) this.addUserAPI(t.id, t.data);
            else if (t.path.length === 1 && t.type === 2) this.deleteUserAPI(t.id);
            else if (typeof t.path[1] == "string") {
                let i = e.userAPIs[t.path[1]];
                if (i) {
                    let s = t.type === 0 && t.props.debounce === void 0, o = this.getUserAPI(t.path[1]);
                    o instanceof Dm ? o.update(i) : o?.update(i, this, s);
                }
            }
        } else if (t.path[0] === "userWebhooks") {
            if (t.path.length === 1 && t.type === 1) this.addUserWebhook(t.id, t.data);
            else if (t.path.length === 1 && t.type === 2) this.deleteUserWebhook(t.id);
            else if (typeof t.path[1] == "string") {
                let i = e.userWebhooks[t.path[1]];
                i && this.getUserWebhook(t.path[1])?.update(i);
            }
        } else t.path[0] === "lib" && this.updateLibByOp(Lr.drop(t, 1), r);
    }
    updateFont(t, e, r) {
        if (e.props.url) {
            let i = this.getFont(t), s = {
                ...this.data.fonts[t],
                url: e.props.url
            };
            i.update(s), i.loadingPromise.then(()=>this.requestRender()), r.updateFont(t, this);
        }
    }
    addUserAPI(t, e) {
        return this.userAPIs[t] ? (this.userAPIs[t].update(e, this), !0) : this.openAIRealtime?.id === t ? (this.openAIRealtime.update(e), !0) : e.integration?.type === "VoiceAssistant" ? (this.openAIRealtime = new Dm(e, t, this), !1) : (this.userAPIs[t] = new _d(t, e, this), !1);
    }
    getUserAPI(t) {
        return this.openAIRealtime?.id === t ? this.openAIRealtime : this.userAPIs[t];
    }
    getUserAPIs() {
        return this.userAPIs;
    }
    deleteUserAPI(t) {
        let e = this.userAPIs[t];
        e && (e.dispose(), delete this.userAPIs[t]);
    }
    addUserWebhook(t, e) {
        return this.userWebhooks[t] ? (this.userWebhooks[t].update(e), !0) : (this.userWebhooks[t] = new lx(t, e), !1);
    }
    getUserWebhook(t) {
        return this.userWebhooks[t];
    }
    getUserWebhooks() {
        return this.userWebhooks;
    }
    deleteUserWebhook(t) {
        let e = this.userWebhooks[t];
        e && (e.dispose(), delete this.userWebhooks[t]);
    }
    get scene() {
        return this.entityOpContext.scene;
    }
}, q_e = new Zc(vn.emptyData());
var vs = class extends mr {
    updateByPatchedOp(e, r, i) {
        if (super.updateByPatchedOp(e, r, i), wI(e.path, [
            "materials"
        ]) !== null && e.type === 0 && Array.isArray(this.material)) for (let [s, o] of Object.entries(e.props)){
            let a = i.shared.material(o);
            this.material[Number(s)] = a;
        }
        else if (Lt(e.path, [
            "material"
        ]) && this.material instanceof Nn) "material" in r && typeof r.material != "string" && this.material.updateByOp(Lr.drop(e, 1), r.material, i);
        else if (Lt(e.path, [
            "materials",
            "*"
        ]) && Array.isArray(this.material)) {
            let s = e.path[1];
            if ("materials" in r && s < this.material.length) {
                let o = r.materials[s];
                typeof o != "string" && this.material[s].updateByOp(Lr.drop(e, 2), o, i);
            }
        }
    }
    get needsAO() {
        return this.material !== void 0 ? (Array.isArray(this.material) ? this.material[0] : this.material).hasAO : !1;
    }
    updateState(e, r) {
        super.updateState(e, r), e.castShadow !== void 0 && (this.castShadow = e.castShadow), e.receiveShadow !== void 0 && (this.receiveShadow = e.receiveShadow);
        let i = this.dataPatched;
        if (e.geometry?.type !== "NonParametricGeometry" && "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = r.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe), r.scene.markNeedsUpdateRendererDirty()), (e.geometry?.type === "NonParametricGeometry" || "materials" in e) && ("materials" in e && e.materials !== void 0 ? (this.disposeMaterial(), this.material = e.materials.map((s)=>r.shared.material(s).getFlavor(i.flatShading, i.side, i.wireframe)), r.scene.markNeedsUpdateRendererDirty()) : "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = [
            r.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe)
        ], r.scene.markNeedsUpdateRendererDirty())), e.flatShading !== void 0 || e.wireframe !== void 0 || e.side !== void 0) {
            if (Array.isArray(this.material)) for(let s = 0; s < this.material.length; s++)this.material[s] = this.material[s].getFlavor(i.flatShading, i.side, i.wireframe);
            else this.material = this.material.getFlavor(i.flatShading, i.side, i.wireframe);
        }
    }
    disposeMaterial() {
        this.material && uv(this.material).forEach((e)=>{
            e instanceof Nn && (e instanceof Qc || e.nodeMaterialDispose());
        });
    }
    dispose() {
        this.disposeMaterial(), super.dispose();
    }
};
var a3 = new E, l3 = new Ze, c3 = new Ze, JX = new E, u3 = new ue, cr = class extends vs {
    constructor(e, r, i){
        super(e, r);
        this.data = r;
        this.isSkinnedMesh = !1;
        this.localGeometry = void 0, r.bindMode && r.bindMatrix && (this.bindMode = r.bindMode, this.bindMatrix = new ue().fromArray(r.bindMatrix), this.bindMatrixInverse = new ue);
    }
    chooseGeoemtryCache(e) {
        return e.geometryCache;
    }
    markGeometryAsReachable(e) {
        this.geometryCreateDeleyed instanceof _e && this.chooseGeoemtryCache(e).markAsReachable(this.dataPatched.geometry, this.geometryCreateDeleyed);
    }
    get geometry() {
        if (this.localGeometry !== void 0) return this.localGeometry;
        if (this.geometryCreateDeleyed instanceof Zc) {
            let e = this.geometryCreateDeleyed, r = this.chooseGeoemtryCache(e);
            this.geometryCreateDeleyed = r.get(this.dataPatched.geometry, e, this);
        }
        return this.geometryCreateDeleyed;
    }
    set geometry(e) {
        this.localGeometry = e;
    }
    get is2DAndNoDepth() {
        let e = this.dataPatched.geometry;
        return qp.is2DParametricMesh(e.type) && e.depth === 0;
    }
    get is2DType() {
        return qp.is2DParametricMesh(this.geometry.userData.type);
    }
    get isNonParametric() {
        return this.geometry.userData.type === "NonParametricGeometry";
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), Lt(e.path, [
            "geometry"
        ]) && this.updateByPatchedOpGeometry(Lr.drop(e, 1), r.geometry, i);
    }
    removeInteractionGeometry(e) {
        this.localGeometry?.dispose(), this.localGeometry = void 0;
    }
    updateGeometryInteractions(e, r) {
        this.invalidateDownstreamBooleanData();
        let i = this.data.geometry.type;
        if (i === "NonParametricGeometry" || i === "SubdivGeometry") {
            let s = e;
            if (this.localGeometry === void 0) {
                let u = {
                    ...this.data.geometry,
                    ...s
                };
                this.localGeometry = _a(u, r, this.data.flatShading, this);
            }
            let o, a, l;
            s.scaleBaked ? [o, a, l] = s.scaleBaked : { width: o, height: a, depth: l } = s;
            let c = this.localGeometry.userData;
            c.sxPrev !== void 0 && mm(this.localGeometry.attributes, o / c.sxPrev, a / c.syPrev, l / c.szPrev), c.sxPrev = o, c.syPrev = a, c.szPrev = l;
        } else {
            let s = {
                ...this.data.geometry,
                ...e
            };
            this.localGeometry?.dispose(), this.localGeometry = _a(s, r, this.data.flatShading, this);
        }
    }
    refreshAttachedClonersInteractions() {
        for (let e of this.attachedSurfaceCloners)e.update();
    }
    refreshAttachedCloners(e) {
        for (let r of this.attachedSurfaceCloners)e.scene.addPendingUpdateCloner(r.object);
    }
    refreshAttachedPaths(e) {
        for (let r of this.attachedPaths)e.scene.addPendingCommand(()=>r.updateShape());
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.refreshAttachedCloners(e), this.refreshAttachedPaths(e);
    }
    updateByPatchedOpGeometry(e, r, i) {
        let s = !1;
        e.type === 0 && e.path.length === 0 && Object.keys(e.props).includes("scaleBaked") && this.geometryCreateDeleyed instanceof ni && this.chooseGeoemtryCache(i.shared).mutateIfUnique(this.geometryCreateDeleyed.data, r) === this.geometryCreateDeleyed && (s = !0, this.geometryCreateDeleyed.mutateDirectlyScaleBaked(r, e.props.scaleBaked), this.refreshAttachedCloners(i), this.refreshAttachedPaths(i)), s || (i.scene?.markGeometryCacheDirty(), this.createGeometryDelayed(i)), this.resetBBoxNeedsUpdate(), this.invalidateDownstreamBooleanData();
    }
    updateGeometryOnStateUpdate(e, r) {
        this.createGeometryDelayed(r);
    }
    updateState(e, r) {
        e.geometry !== void 0 && this.updateGeometryOnStateUpdate(e.geometry, r);
        let i = e.morphTargetInfluences;
        if (i) {
            this.updateMorphTargets(), this.geometry.morphTargetsRelative = !0;
            for (let { data: { name: s, value: o } } of i)this.updateMorphInfluences(s, r.shared.getVariable(o, [
                this.uuid,
                "morphTargetInfluences",
                s
            ]));
        }
        super.updateState(e, r);
    }
    updateMorphInfluences(e, r) {
        if (this.morphTargetDictionary === void 0) return;
        let i = this.morphTargetDictionary[e];
        i !== void 0 && (this.morphTargetInfluences[i] = r);
    }
    updateGeometryGroupsIfNeeded() {
        Array.isArray(this.material) && this.geometry.groups.length === 0 && this.geometry.addGroup(0, Math.max(this.geometry.getIndex()?.count ?? 0, this.geometry.getAttribute("position").count), 0);
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.userData.parameters;
        this.is2DType ? e.set(0, 0, i.depth * .5) : this.isNonParametric ? (e.setScalar(0), this.geometry.boundingSphere && e.copy(this.geometry.boundingSphere.center), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5)) : e.setScalar(0), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.bindMode === "attached" ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === "detached" && this.bindMatrixInverse.copy(this.bindMatrix).invert();
    }
    bind(e, r) {
        this.skeleton = e, this.isSkinnedMesh = !0, r === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), r = this.matrixWorld), this.bindMatrix.copy(r), this.bindMatrixInverse.copy(r).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights(e) {
        let r = new Ze, i = this.geometry.attributes.skinWeight;
        for(let s = 0, o = i.count; s < o; s++){
            r.fromBufferAttribute(i, s);
            let a = 1 / r.manhattanLength();
            a !== 1 / 0 ? r.multiplyScalar(a) : r.set(1, 0, 0, 0), i.setXYZW(s, r.x, r.y, r.z, r.w);
        }
    }
    boneTransform(e, r) {
        let i = this.skeleton;
        if (i === void 0) return;
        let s = this.geometry;
        l3.fromBufferAttribute(s.attributes.skinIndex, e), c3.fromBufferAttribute(s.attributes.skinWeight, e), a3.copy(r).applyMatrix4(this.bindMatrix), r.set(0, 0, 0);
        for(let o = 0; o < 4; o++){
            let a = c3.getComponent(o);
            if (a !== 0) {
                let l = l3.getComponent(o);
                u3.multiplyMatrices(i.bones[l].matrixWorld, i.boneInverses[l]), r.addScaledVector(JX.copy(a3).applyMatrix4(u3), a);
            }
        }
        return r.applyMatrix4(this.bindMatrixInverse);
    }
};
function $X(n1) {
    if (n1.geometry.attributes.extrudeNormal || !n1.geometry.attributes.position || !n1.geometry.attributes.normal) return;
    let t = new Map, e = n1.geometry.attributes, r = e.position.array, i = e.normal.array, s = new Float32Array(r.length);
    for(let o = 0; o < r.length; o += 3){
        let a = `${r[o]}_${r[o + 1]}_${r[o + 2]}`, l = new E(i[o], i[o + 1], i[o + 2]);
        t.has(a) ? t.get(a)?.normals.push(l) : t.set(a, {
            normals: [
                l
            ],
            result: new E
        });
    }
    t.forEach((o, a)=>{
        for (let l of o.normals)o.result.add(l);
        o.result.divideScalar(o.normals.length);
    });
    for(let o = 0; o < r.length; o += 3){
        let a = `${r[o]}_${r[o + 1]}_${r[o + 2]}`, l = t.get(a)?.result;
        l && (s[o] = l.x, s[o + 1] = l.y, s[o + 2] = l.z);
    }
    n1.geometry.setAttribute("extrudeNormal", new Te(s, 3));
}
function eK(n1) {
    if (n1.geometry.attributes.extrudeNormals || !n1.geometry.attributes.position) return;
    let e = n1.geometry.attributes.position.array, r = new Float32Array(e.length), i = new E;
    for(let s = 0; s < e.length; s += 3)i.set(e[s], e[s + 1], e[s + 2]).normalize(), r[s] = i.x, r[s + 1] = i.y, r[s + 2] = i.z;
    n1.geometry.setAttribute("extrudeNormal", new Te(r, 3));
}
function nf(n1) {
    if (Array.isArray(n1.material)) {
        for (let t of n1.material)if (t.getLayersOfType("outline").length === 0) return;
    } else if (!(n1.material instanceof Nn) || n1.material.getLayersOfType("outline").length === 0) return;
    n1 instanceof cr && n1.is2DAndNoDepth ? eK(n1) : $X(n1);
}
function sf(n1) {
    if (!n1.geometry.attributes.position) return;
    let e = n1.geometry.attributes.position.array, r = new Float32Array(e.length), i = parseInt(n1.uuid.replace(/\D/g, "")), s = [
        we.seededRandom(i),
        we.seededRandom(i + 1e4),
        we.seededRandom(i + 2e4)
    ];
    for(let o = 0; o < e.length; o++)r[o] = s[o % 3];
    n1.geometry.setAttribute("randomColor", new Xe(r, 3));
}
var Vo = new Wt, Om = new E;
function h3(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && r.geometry.type === "SubdivGeometry" && (t = !0);
    }), t;
}
var Zs = class extends cr {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
        this.hiddenMatrixOld = new ue;
        this.smoothShading = !0;
        this.skipReactionUpdate = !1;
    }
    chooseGeoemtryCache(e) {
        return this.dataPatched.flatShading ? e.geometryCache : e.geometryCache2;
    }
    get subdivPointerNew() {
        return this.localGeometry !== void 0 ? this.subdivPointer : this.geometry.ensureSubdivPointer();
    }
    get originalGeometryNew() {
        return this.localGeometry !== void 0 ? this.originalGeometry : this.geometry.originalGeometry;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.userData.parameters;
        e.copy(this.originalGeometryNew.boundingSphere.center), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    createGeometryByControls(e) {
        if (this.skipReactionUpdate === !0) return;
        let r = this.localGeometry?.uuid, { originalGeometry: i, subdividedGeometry: s, subdivPointer: o } = ni.build(e, this.subdivPointer, this.smoothShading, this.hasNonUniformScale ? this.shearScale : void 0);
        this.subdivPointer = o, i !== void 0 && (this.originalGeometry?.dispose(), this.originalGeometry = i), s !== void 0 && (this.subdividedGeometry?.dispose(), this.subdividedGeometry = s ?? void 0), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry, nf(this), sf(this), this.calcBoundingBox(), r && (this.localGeometry.uuid = r);
    }
    updateState(e, r) {
        if (super.updateState(e, r), e.flatShading !== void 0) {
            let i = this.material;
            this.material = Array.isArray(i) ? i.map((s)=>s.getFlavor(!1, s.side, s.wireframe)) : i.getFlavor(!1, i.side, i.wireframe), this.smoothShading = !e.flatShading, this.createGeometryDelayed(r);
        }
    }
    updateMesh(e = !1) {
        ni.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1, this.originalGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0), this.subdividedGeometry && ni.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1, this.subdividedGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0);
    }
    updateTopology() {
        this.originalGeometry.dispose(), this.originalGeometry = ni.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1), this.subdividedGeometry && (this.subdividedGeometry.dispose(), this.subdividedGeometry = ni.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1)), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry;
    }
    raycast(e, r) {
        let i = this.localGeometry;
        this.localGeometry = this.originalGeometryNew, mr.prototype.raycast.call(this, e, r), this.localGeometry = i;
    }
    activateSVDCompensation() {
        !this.hasNonUniformScale || (this.matrix.copy(this.matrixWorldRigid), this.hiddenMatrixOld.copy(this.hiddenMatrix), this.hiddenMatrix.copy(this.parent.matrixWorld).invert());
    }
    deactivateSVDCompensation() {
        !this.hasNonUniformScale || (this.updateMatrix(), this.hasNonUniformScale = void 0, this.hiddenMatrix.copy(this.hiddenMatrixOld));
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new Rr, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let r = e.attributes.position, i = e.boundingSphere.center;
        Vo.setFromBufferAttribute(r), Vo.getCenter(i), e.boundingSphere.radius = i.distanceTo(Vo.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), Vo.getSize(Om), this.hasNonUniformScale && Om.divide(this.scale);
        let s = {
            width: Om.x,
            height: Om.y,
            depth: Om.z
        };
        return this.geometry.userData.parameters = s, s;
    }
    updateBoundingSphere(e) {
        let r = this.originalGeometry;
        Vo.min.set(e[0], e[2], e[4]), Vo.max.set(e[1], e[3], e[5]), this.hasNonUniformScale && (Vo.min.applyMatrix4(this.shearScaleInv), Vo.max.applyMatrix4(this.shearScaleInv)), r.boundingSphere === null && (r.boundingSphere = new Rr);
        let i = r.boundingSphere.center;
        Vo.getCenter(i), r.boundingSphere.radius = i.distanceTo(Vo.max);
    }
    freeSubdivPointer() {
        this.subdivPointer && (ni.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0), this.localGeometry = void 0, this.originalGeometry?.dispose(), this.subdividedGeometry?.dispose();
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    updateByPatchedOpGeometry(e, r, i) {
        super.updateByPatchedOpGeometry(e, r, i), this.localGeometry && this.createGeometryByControls(r);
    }
};
var d3 = -1, tK = 1, f3 = {
    x: [
        1,
        0,
        0
    ],
    "-x": [
        -1,
        0,
        0
    ],
    y: [
        0,
        1,
        0
    ],
    "-y": [
        0,
        -1,
        0
    ],
    z: [
        0,
        0,
        1
    ],
    "-z": [
        0,
        0,
        -1
    ]
}, p3 = {
    polygon_center: 0,
    edge: 1,
    vertex: 2
}, Rm = (n1, t)=>(e, r)=>!t || e === 0 || n1 === 0 ? 0 : n1 * r / 100, vt = (n1, t)=>{
    let e = Math.abs(t), r = e * -1;
    return (n1 - d3) * (e - r) / (tK - d3) + r;
}, rK = new E, fx = new E, iK = new E, nK = new E;
function of(n1, t) {
    let e = iK.fromArray(n1), r = nK.fromArray(t);
    fx.copy(r).sub(e);
    let i = fx.length();
    return fx.normalize().multiplyScalar(i * .5), rK.copy(e).add(fx).toArray();
}
var xs = new Cr, px = new E, mx = new E, Jc = new E;
function m3(n1) {
    let t = [];
    for(let e = 0; e <= n1.index.count; e++)if (px.fromArray(n1.index.array, e * 3), xs.setFromAttributeAndIndices(n1.attributes.position, px.x, px.y, px.z), xs.getNormal(mx), xs.getMidpoint(Jc), !(isNaN(Jc.x) || isNaN(Jc.y) || isNaN(Jc.z))) {
        let { a: r, b: i, c: s } = xs, o = r.toArray(), a = i.toArray(), l = s.toArray(), c = r.distanceTo(i), u = i.distanceTo(s), h = s.distanceTo(r), d = of(o, a), f = of(a, l), p = of(l, o), m = [
            c,
            u,
            h
        ], g = Math.max(...m), y = m.filter((S)=>Math.round(S) === Math.round(g)).length > 1, x = [], v = xs.getMidpoint(Jc).toArray();
        g === c && !y && (x = [
            f,
            p,
            p
        ], v = d), g === u && !y && (x = [
            d,
            p,
            p
        ], v = f), g === h && !y && (x = [
            d,
            f,
            f
        ], v = p), y && (x = [
            d,
            f,
            p
        ]), t.push({
            vertices: [
                o,
                a,
                l
            ],
            faceCenters: x,
            midpoint: v,
            norm: xs.getNormal(mx).toArray()
        });
    }
    return t;
}
function g3(n1) {
    let t = [], { position: e } = n1.attributes;
    for(let r = 0; r < e.count; r++){
        xs.setFromAttributeAndIndices(e, r * 3, r * 3 + 1, r * 3 + 2), xs.getNormal(mx), xs.getMidpoint(Jc);
        let i = xs.a.toArray(), s = xs.b.toArray(), o = xs.c.toArray();
        t.push({
            vertices: [
                i,
                s,
                o
            ],
            faceCenters: [
                of(i, s),
                of(s, o),
                of(o, i)
            ],
            midpoint: Jc.toArray(),
            norm: mx.toArray()
        });
    }
    return t;
}
var sK = 4, oK = .5, DE = (n1)=>.5 * (1 - Math.cos(n1 * Math.PI)), OE = class {
    constructor(){
        this.perlin = new Array(4096);
    }
    noise(t, e = 0, r = 0) {
        if (this.perlin == null) {
            this.perlin = new Array(4096);
            for(let y = 0; y < 4096; y++)this.perlin[y] = Math.random();
        }
        t < 0 && (t = -t), e < 0 && (e = -e), r < 0 && (r = -r);
        let i = Math.floor(t), s = Math.floor(e), o = Math.floor(r), a = t - i, l = e - s, c = r - o, u, h, d = 0, f = .5, p, m, g;
        for(let y = 0; y < sK; y++){
            let x = i + (s << 4) + (o << 8);
            u = DE(a), h = DE(l), p = this.perlin[x & 4095], p += u * (this.perlin[x + 1 & 4095] - p), m = this.perlin[x + 16 & 4095], m += u * (this.perlin[x + 16 + 1 & 4095] - m), p += h * (m - p), x += 256, m = this.perlin[x & 4095], m += u * (this.perlin[x + 1 & 4095] - m), g = this.perlin[x + 16 & 4095], g += u * (this.perlin[x + 16 + 1 & 4095] - g), m += h * (g - m), p += DE(c) * (m - p), d += p * f, f *= oK, i <<= 1, a *= 2, s <<= 1, l *= 2, o <<= 1, c *= 2, a >= 1 && (i++, a--), l >= 1 && (s++, l--), c >= 1 && (o++, c--);
        }
        return d;
    }
    noiseSeed(t) {
        let e = (()=>{
            let o, a;
            return {
                setSeed (l) {
                    a = o = (l ?? Math.random() * 4294967296) >>> 0;
                },
                getSeed () {
                    return o;
                },
                rand () {
                    return a = (1664525 * a + 1013904223) % 4294967296, a / 4294967296;
                }
            };
        })();
        e.setSeed(t), this.perlin = new Array(4096);
        for(let r = 0; r < 4096; r++)this.perlin[r] = e.rand();
    }
}, y3 = OE;
var v3 = new E, x3 = new ue, b3 = new Ls;
function RE(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && (r.geometry.type === "TextGeometry" || r.geometry.type === "InputGeometry") && (t = !0);
    }), t;
}
var Hl = class extends cr {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
    }
    get textGeometry() {
        return this.geometry;
    }
    get charWidths() {
        return this.textGeometry.charWidths;
    }
    get charCoords() {
        return this.textGeometry.charCoords;
    }
    get wrappedText() {
        return this.textGeometry.wrappedText;
    }
    get font() {
        return this.textGeometry.font;
    }
    get initialOffsetY() {
        let e = this.dataPatched;
        return this.font?.getLineInitialOffsetY(this.lineHeight, this.wrappedText.length, e.geometry.height, this.fontScale, e.geometry.verticalAlign) ?? 0;
    }
    get fontScale() {
        let e = this.dataPatched;
        return this.font ? e.geometry.fontSize / this.font.unitsPerEm : 1;
    }
    get AD() {
        return Math.abs(this.ascender - this.descender);
    }
    get ascender() {
        return (this.font?.ascender ?? 1) * this.fontScale;
    }
    get descender() {
        return (this.font?.descender ?? 1) * this.fontScale;
    }
    get lineHeight() {
        let e = this.dataPatched;
        return e.geometry.fontSize * e.geometry.lineHeight;
    }
    raycast(e, r) {
        let { matrixWorld: i } = this;
        if (!(isNaN(e.ray.origin.x) || this.scale.x === 0 || this.scale.y === 0 || this.scale.z === 0) && (x3.copy(i).invert(), b3.copy(e.ray).applyMatrix4(x3), b3.intersectBox(this.singleBBox, v3))) {
            let s = v3.applyMatrix4(i), o = e.ray.origin.distanceTo(s);
            r.push({
                distance: o,
                point: s.clone(),
                object: this
            });
        }
    }
};
var An = 1e-4, ko, A3, E3, T3, S3 = new E, w3 = new E;
k0.then((n1)=>{
    ko = n1, A3 = [
        ko.get_face_center,
        ko.get_edge_midpoint,
        ko.get_vertex_position
    ], E3 = [
        ko.get_face_normal,
        ko.get_edge_normal,
        ko.get_vertex_normal
    ], T3 = [
        ko.face_count,
        ko.edge_count,
        ko.vertex_count
    ];
});
var aK = new ue, lK = new ue, Wl = new E, gx = new E, Lm = new E, LE = new E, cK = new E, uK = new E;
var BE = class {
    constructor(t, e){
        this.data = t;
        this.is3D = e;
        this.perlin = new y3;
        t.noiseType === "perlin" ? (this.perlin.noiseSeed(t.seed), e ? this.noise = (i, s, o)=>this.perlin.noise(i, s, o) : this.noise = (i)=>this.perlin.noise(i)) : e ? this.noise = rO((0, yx.default)(t.seed)) : this.noise = tO((0, yx.default)(t.seed));
    }
}, Gi = class extends md(Tt) {
    constructor(e, r){
        super();
        this.parameters = r;
        this.objectForSample = void 0;
        this._pendingMediaLoad = !1;
        this.random = null;
        this.object = e;
    }
    resetOnMove() {
        this.removeFromParent(), this.parent = null;
    }
    expandClones(e) {
        if (this.parent === null) this.updateState(this.parameters, e);
        else for (let r of this.children)r instanceof Nr && r.expand();
    }
    invalidateTransform(e) {
        this.matrixWorldNeedsUpdate = !0, this.traverse((r)=>{
            r instanceof Nr && r.object === e && (r.matrixWorldNeedsUpdate = !0);
        });
    }
    onObjUpdateMatrix() {
        this.parameters.type !== "toObject" && (this.matrixWorldNeedsUpdate = !0);
    }
    update() {
        switch(this._updateCount(), this.parameters.type){
            case "radial":
                this._updateRadial(this.parameters);
                break;
            case "linear":
                this._updateLinear(this.parameters);
                break;
            case "grid":
                this._updateGrid(this.parameters);
                break;
            case "toObject":
                this._updateToObject(this.parameters);
        }
        for (let e of this.children)e.updateMatrix(), e.hasNonUniformScale && (e.updateMatrixWorld(), e.updateMatrixWorldSVD());
    }
    _updateCount(e) {
        let r;
        if (e !== void 0 ? r = e : r = this.parameters.type === "grid" ? Math.round(this.parameters.grid.count[0]) * Math.round(this.parameters.grid.count[1]) * Math.round(this.parameters.grid.count[2]) : this.parameters.count, this.parameters.type === "toObject" && !this.parameters.toObject.object && (r = 0), this.parameters.type === "toObject" && this.objectForSample) {
            let i = this.children;
            if (i.length === r) return;
            if (i.length < r) for(let s = 0, o = r - i.length; s < o; ++s){
                let a = new Nr(this.object);
                a.expand(), this.add(a);
            }
            else for(let s = 0, o = i.length - r; s < o; ++s)this.remove(i[s]);
        } else {
            if (this.children.length === r) return;
            if (this.children.length < r) for(let i = 0, s = r - this.children.length; i < s; ++i){
                let o = new Nr(this.object);
                o.expand(), this.add(o);
            }
            else for(let i = 0, s = this.children.length - r; i < s; ++i)this.remove(this.children[i]);
        }
    }
    getRandom(e, r = !1) {
        return (this.random === null || this.random.data.seed !== e.seed || this.random.is3D !== r) && (this.random = new BE(e, r)), this.random;
    }
    _updateRadial(e) {
        let r = e.radial, i = r.start * we.DEG2RAD, s = r.end * we.DEG2RAD, o = i - s, a = new nr(r.rotation[0], r.rotation[1], r.rotation[2]), l;
        switch(r.axis){
            case "z":
                l = new E(0, 0, 1);
                break;
            case "y":
                l = new E(0, 1, 0);
                break;
            default:
            case "x":
                l = new E(1, 0, 0);
                break;
        }
        let c = e.randomnessObject ?? Co.defaultData([
            1,
            1,
            1
        ]).randomnessObject, u = this.getRandom(c), h = Rm(c.strength, this.parameters.randomness);
        for (let [d, f] of this.children.entries()){
            let p = d * (c.freqScale / 10) + c.movement, m = u.noise(p, p, p), g = d + 1;
            f.scale.x = r.scale[0] + h(g, vt(m, c.scale[0])) || An, f.scale.y = r.scale[1] + h(g, vt(m, c.scale[1])) || An, f.scale.z = r.scale[2] + h(g, vt(m, c.scale[2])) || An, f.position.setScalar(0);
            let y = o / e.count * d - i;
            switch(r.axis){
                case "x":
                    f.rotation.set(0, y, 0);
                    break;
                case "y":
                    f.rotation.set(0, 0, y);
                    break;
                case "z":
                    f.rotation.set(y, 0, 0);
                    break;
            }
            f.translateOnAxis(l, r.radius), f.position.x += r.position[0] + h(g, vt(m, c.position[0])), f.position.y += r.position[1] + h(g, vt(m, c.position[1])), f.position.z += r.position[2] + h(g, vt(m, c.position[2]));
            let x = h(g, vt(m, c.rotation[0])), v = h(g, vt(m, c.rotation[1])), S = h(g, vt(m, c.rotation[2]));
            r.alignment === !0 ? (f.rotation.x += a.x + x, f.rotation.y += a.y + v, f.rotation.z += a.z + S) : f.rotation.set(a.x + x, a.y + v, a.z + S);
        }
    }
    _updateLinear(e) {
        if (e.type !== "linear") throw new Error;
        let r = e.linear, i = new nr(r.rotation[0], r.rotation[1], r.rotation[2]), s = e.randomnessObject ?? Co.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = this.getRandom(s), a = Rm(s.strength, this.parameters.randomness);
        for (let [l, c] of this.children.entries()){
            let u = l * (s.freqScale / 10) + s.movement, h = o.noise(u, u, u), d = l + 1, f = a(d, vt(h, s.rotation[0])), p = a(d, vt(h, s.rotation[1])), m = a(d, vt(h, s.rotation[2]));
            c.scale.x = 1 + (r.scale[0] - 1) * l + a(d, vt(h, s.scale[0])) || An, c.scale.y = 1 + (r.scale[1] - 1) * l + a(d, vt(h, s.scale[1])) || An, c.scale.z = 1 + (r.scale[2] - 1) * l + a(d, vt(h, s.scale[2])) || An, c.rotation.x = i.x * l + f, c.rotation.y = i.y * l + p, c.rotation.z = i.z * l + m, c.position.x = r.position[0] * l + a(d, vt(h, s.position[0])), c.position.y = r.position[1] * l + a(d, vt(h, s.position[1])), c.position.z = r.position[2] * l + a(d, vt(h, s.position[2]));
        }
    }
    _updateGrid(e) {
        let r = 0, i = e.grid, s = e.randomnessObject ?? Co.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = this.getRandom(s, !0), a = Rm(s.strength, this.parameters.randomness);
        if (i.useCenter === !0) {
            let l = {
                x: i.count[0] % 2 === 0 ? 2 : 1,
                y: i.count[1] % 2 === 0 ? 2 : 1,
                z: i.count[2] % 2 === 0 ? 2 : 1
            }, c = new E(i.size[0] * (i.count[0] - l.x) * .5, i.size[1] * (i.count[1] - l.y) * .5, i.size[2] * (i.count[2] - l.z) * .5);
            for(let u = 0; u < i.count[0]; u++)for(let h = 0; h < i.count[1]; h++)for(let d = 0; d < i.count[2]; d++){
                let f = o.noise((u + 1) * (s.freqScale / 10) + s.movement, (h + 1) * (s.freqScale / 10) + s.movement, (d + 1) * (s.freqScale / 10) + s.movement), p = this.children[r++];
                p.scale.x = 1 + a(r, vt(f, s.scale[0])) || An, p.scale.y = 1 + a(r, vt(f, s.scale[1])) || An, p.scale.z = 1 + a(r, vt(f, s.scale[2])) || An;
                let m = a(r, vt(f, s.rotation[0])), g = a(r, vt(f, s.rotation[1])), y = a(r, vt(f, s.rotation[2]));
                p.rotation.set(m, g, y), p.position.x = i.size[0] * u - c.x + a(r, vt(f, s.position[0])), p.position.y = i.size[1] * h - c.y + a(r, vt(f, s.position[1])), p.position.z = i.size[2] * d - c.z + a(r, vt(f, s.position[2]));
            }
        } else for(let l = 0; l < i.count[0]; l++)for(let c = 0; c < i.count[1]; c++)for(let u = 0; u < i.count[2]; u++){
            let h = o.noise((l + 1) * (s.freqScale / 10) + s.movement, (c + 1) * (s.freqScale / 10) + s.movement, (u + 1) * (s.freqScale / 10) + s.movement), d = this.children[r++];
            d.scale.x = 1 + a(r, vt(h, s.scale[0])) || An, d.scale.y = 1 + a(r, vt(h, s.scale[1])) || An, d.scale.z = 1 + a(r, vt(h, s.scale[2])) || An;
            let f = a(r, vt(h, s.rotation[0])), p = a(r, vt(h, s.rotation[1])), m = a(r, vt(h, s.rotation[2]));
            d.rotation.set(f, p, m), d.position.x = i.size[0] * l + a(r, vt(h, s.position[0])), d.position.y = -i.size[1] * c + a(r, vt(h, s.position[1])), d.position.z = -i.size[2] * u + a(r, vt(h, s.position[2]));
        }
    }
    _updateToObject(e) {
        if (e.type !== "toObject") throw new Error;
        let { toObject: r } = e, i = new nr(r.rotation[0], r.rotation[1], r.rotation[2]), s = e.randomnessObject ?? Co.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = this.getRandom(s), a = Rm(s.strength, this.parameters.randomness);
        if (!r.object) {
            for (let [, d] of this.children.entries())d.position.set(0, 0, 0), d.scale.setScalar(1), d.rotation.set(0, 0, 0);
            this.objectForSample = void 0;
            return;
        }
        if (!this.objectForSample) return;
        if (this.objectForSample instanceof Hl) {
            if (!this.objectForSample.font?.isLoaded || this.objectForSample.geometry.attributes.position === void 0) {
                this._pendingMediaLoad = !0;
                return;
            } else this._pendingMediaLoad = !1;
        }
        if (this.objectForSample.geometry === void 0 && this.objectForSample.isAncestorOf(this.object.uuid)) {
            console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) seem to be a child/descendant of the object it's being cloned to. Please re-parent it so that they are siblings instead.`);
            return;
        }
        let l = this.getSubdivData();
        if (l.length > 0) {
            let d = Math.round(l.length * r.count / 100);
            this._updateCount(d);
        } else {
            let d = this.objectForSample.geometry.getAttribute("position");
            if (!d || isNaN(d.count) || d.count === 0) {
                console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) cannot be cloned on the surface of "${this.objectForSample.name}" (${this.objectForSample.uuid}) because the latter does not have a valid geometry.`);
                return;
            }
        }
        this.objectForSample.updateMatrixWorld();
        let c = new S0(this.objectForSample).build(), u = f3[r.axis], h = this.children;
        c.setRandomGenerator((0, yx.default)(this.object.uuid + r.seed));
        for (let [d, f] of h.entries()){
            let p = d * (s.freqScale / 10) + s.movement, m = o.noise(p, p, p), g = d + 1, y = a(g, vt(m, s.rotation[0])), x = a(g, vt(m, s.rotation[1])), v = a(g, vt(m, s.rotation[2]));
            r.spreadType === "random" ? c.sample(Lm, LE) : (l.length && (Lm.fromArray(l[d].pos), LE.fromArray(l[d].norm)), this.objectForSample instanceof Zs && Lm.applyMatrix4(aK.copy(this.objectForSample.matrixWorld).invert())), Lm.applyMatrix4(this.object.hiddenMatrix.clone().invert()), f.position.copy(Lm), Wl.fromArray(u);
            let S = r.align === "normal" ? LE : this.object.getWorldDirection(uK), w = gx.fromArray(r.position);
            gx.x += a(g, vt(m, s.position[0])), gx.y += a(g, vt(m, s.position[1])), gx.z += a(g, vt(m, s.position[2]));
            let A = Math.acos(S.dot(Wl)), T = cK.crossVectors(Wl, S).normalize(), b = lK.makeRotationAxis(T, A), M = S.clone().cross(this.object.up).normalize(), C = M.clone().cross(S).normalize(), P = new ue().makeBasis(M, S, C), I = new E(Wl.y, Wl.z, Wl.x).normalize(), _ = I.clone().cross(Wl).normalize(), D = new ue().makeBasis(I, Wl, _).invert(), L = new ue().multiplyMatrices(P, D);
            f.rotation.setFromRotationMatrix(L), w.applyMatrix4(b), f.position.add(w), f.rotation.x = f.rotation.x + i.x + y, f.rotation.y = f.rotation.y + i.y + x, f.rotation.z = f.rotation.z + i.z + v, f.scale.setScalar(1), f.scale.x = f.scale.x + r.scale[0] + a(g, vt(m, s.scale[0])) || An, f.scale.y = f.scale.y + r.scale[1] + a(g, vt(m, s.scale[1])) || An, f.scale.z = f.scale.z + r.scale[2] + a(g, vt(m, s.scale[2])) || An, f.scale.multiply(this.object.scale), f.hiddenMatrix = this.object.hiddenMatrix;
        }
    }
    getSubdivData() {
        if (!this.objectForSample) return [];
        let e = this.parameters.toObject.spreadType, r = new Map, i = (o, a)=>{
            let l = Math.round(o[0] * 1e4) + "_" + Math.round(o[1] * 1e4) + "_" + Math.round(o[2] * 1e4), c = r.get(l);
            c ? (c.pos[0] += o[0], c.pos[1] += o[1], c.pos[2] += o[2], c.norm[0] += a[0], c.norm[1] += a[1], c.norm[2] += a[2], c.count += 1) : r.set(l, {
                pos: [
                    ...o
                ],
                norm: [
                    ...a
                ],
                count: 1
            });
        };
        if (e === "random") return [];
        if (this.objectForSample instanceof Zs) {
            let o = this.objectForSample, a = p3[e], l = T3[a], c = A3[a], u = E3[a], h = l(o.subdivPointerNew);
            for(let d = 0; d <= h - 1; d++){
                let f = c(o.subdivPointerNew, d), p = u(o.subdivPointerNew, d);
                S3.fromArray(f).applyMatrix4(o.matrixWorld), w3.fromArray(p), i(S3.toArray(), w3.toArray());
            }
        } else (this.objectForSample.geometry.index ? m3(this.objectForSample.geometry) : g3(this.objectForSample.geometry)).forEach((a, l)=>{
            e === "polygon_center" && i(a.midpoint, a.norm), e === "vertex" && (i(a.vertices[0], a.norm), i(a.vertices[1], a.norm), i(a.vertices[2], a.norm)), e === "edge" && (i(a.faceCenters[0], a.norm), i(a.faceCenters[1], a.norm), i(a.faceCenters[2], a.norm));
        });
        let s = Array.from(r.values());
        for (let o of s)o.pos[0] /= o.count, o.pos[1] /= o.count, o.pos[2] /= o.count, o.norm[0] /= o.count, o.norm[1] /= o.count, o.norm[2] /= o.count;
        return s;
    }
    updateState(e, r) {
        if (this.parameters = pa(e), this.parameters.type !== "toObject") (this.parent === null || this.parent !== this.object) && (this.removeFromParent(), this.object.parent?.add(this), this.matrix = this.object.matrix, this.hiddenMatrix = this.object.hiddenMatrix, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1);
        else if (this.parent === null || this.parent.uuid !== this.parameters.toObject.object) {
            this.removeFromParent();
            let i = r.find(this.parameters.toObject.object);
            i instanceof mr ? this.objectForSample = i : this.objectForSample = void 0, this.matrix = new ue, this.hiddenMatrix = new ue, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1, i && i.add(this);
        }
        this.update();
    }
    get pendingMediaLoad() {
        return this._pendingMediaLoad;
    }
};
var Uo = (n1)=>{
    var t;
    return t = class extends n1 {
    }, t.geometryHelper = new mi(30, 30, 30), t;
};
var vx = new Ls, NE = new Rr, M3 = new ue, zo = (n1, t, e, r, i = !1, s = n1)=>{
    let o = t, a = s.matrixWorld;
    if (o.boundingSphere === null && o.computeBoundingSphere(), NE.copy(o.boundingSphere), NE.applyMatrix4(a), e.ray.intersectsSphere(NE) === !1 || (M3.copy(a).invert(), vx.copy(e.ray).applyMatrix4(M3), o.boundingBox !== null && vx.intersectsBox(o.boundingBox) === !1)) return;
    let l, c, u, h, d = o.index, f = o.attributes.position, p = o.drawRange, m, g;
    if (i === !1) {
        let x = Math.max(0, p.start), v = Math.min(d.count, p.start + p.count);
        for(m = x, g = v; m < g; m += 3)if (c = d.getX(m), u = d.getX(m + 1), h = d.getX(m + 2), l = y(n1, e, vx, f, c, u, h), l) {
            l.faceIndex = Math.floor(m / 3), r.push(l);
            return;
        }
    } else {
        let v = o.attributes.position, S = new E, w = new E, A = new E, T = new E, b = 2, C = 1 / ((s.scale.x + s.scale.y + s.scale.z) / 3), P = C * C, I = Math.max(0, p.start), _ = Math.min(v.count, p.start + p.count);
        for(let D = I, L = _ - 1; D < L; D += b){
            if (S.fromBufferAttribute(v, D), w.fromBufferAttribute(v, D + 1), vx.distanceSqToSegment(S, w, T, A) > P) continue;
            T.applyMatrix4(s.matrixWorld);
            let V = e.ray.origin.distanceTo(T);
            V < e.near || V > e.far || r.push({
                distance: V,
                point: A.clone().applyMatrix4(s.matrixWorld),
                object: n1
            });
        }
    }
    function y(x, v, S, w, A, T, b) {
        let M = new E, C = new E, P = new E, I = new E, _ = new E;
        if (M.fromBufferAttribute(w, A), C.fromBufferAttribute(w, T), P.fromBufferAttribute(w, b), S.intersectTriangle(M, C, P, !1, I) === null) return null;
        _.copy(I), _.applyMatrix4(x.matrixWorld);
        let L = v.ray.origin.distanceTo(_);
        return L < v.near || L > v.far ? null : {
            faceIndex: 1,
            distance: L,
            point: _.clone(),
            object: x
        };
    }
};
var xx = new E, bs = new qn, FE = class extends nl {
    constructor(e){
        let r = new _e, i = new ss({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), s = [], o = [], a = {}, l = new We(15711266), c = new We(15711266), u = new We(2857471);
        h("n1", "n2", l), h("n2", "n4", l), h("n4", "n3", l), h("n3", "n1", l), h("f1", "f2", l), h("f2", "f4", l), h("f4", "f3", l), h("f3", "f1", l), h("n1", "f1", l), h("n2", "f2", l), h("n3", "f3", l), h("n4", "f4", l), h("p", "n1", c), h("p", "n2", c), h("p", "n3", c), h("p", "n4", c), h("u1", "u2", u), h("u2", "u3", u), h("u3", "u1", u);
        function h(f, p, m) {
            d(f, m), d(p, m);
        }
        function d(f, p) {
            s.push(0, 0, 0), o.push(p.r, p.g, p.b), a[f] === void 0 && (a[f] = []), a[f].push(s.length / 3 - 1);
        }
        r.setAttribute("position", new Te(s, 3)), r.setAttribute("color", new Te(o, 3));
        super(r, i);
        this.type = "CameraHelper", this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
    }
    update() {
        let e = this.geometry, r = this.pointMap, i = !0;
        bs.projectionMatrixInverse.elements = [
            .5112609807824982,
            -0,
            -0,
            -0,
            -0,
            .41421356237309503,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0.099999,
            -0,
            -0,
            -1.0000000000000002,
            .100001
        ];
        let s = 1, o = 1, a = i ? .8 : 1e-4;
        Js("n1", r, e, bs, -s, -o, a), Js("n2", r, e, bs, s, -o, a), Js("n3", r, e, bs, -s, o, a), Js("n4", r, e, bs, s, o, a);
        let l = a;
        Js("f1", r, e, bs, -s, -o, l), Js("f2", r, e, bs, s, -o, l), Js("f3", r, e, bs, -s, o, l), Js("f4", r, e, bs, s, o, l);
        let c = l, u = .5;
        Js("u1", r, e, bs, s * .7 * u, o * 1.1, c), Js("u2", r, e, bs, -s * .7 * u, o * 1.1, c), Js("u3", r, e, bs, 0, o * (1.1 + .9 * u), c), e.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function Js(n1, t, e, r, i, s, o) {
    xx.set(i, s, o).unproject(r);
    let a = t[n1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let c = 0, u = a.length; c < u; c++)l.setXYZ(a[c], xx.x, xx.y, xx.z);
    }
}
var bx = class extends Uo(FE) {
    constructor(e){
        super(e);
        this.object = e;
        this.object = e, this.name = `CombinedCameraHelper: ${e.uuid}`;
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.updateTarget();
    }
    updateTarget() {
        let e = this.object.getTarget();
        this.updateWorldMatrix(!0, !1), this.worldToLocal(e);
    }
    raycast(e, r) {
        zo(this.object, this.geometry, e, r, !0);
    }
};
var Sx;
((t)=>t.is = (e)=>"objectHelper" in e)(Sx || (Sx = {}));
var Ss = (n1, t)=>class extends yd(n1) {
        constructor(){
            super(...arguments);
            this.objectHelper = new t(this);
            this.gizmos = {};
        }
        get geometryHelper() {
            return t.geometryHelper;
        }
        raycast(i, s) {
            this.objectHelper.raycast(i, s);
        }
        showGizmos() {
            for(let i in this.gizmos){
                let s = this.gizmos[i];
                s instanceof hl && (s.visible = !0);
            }
        }
        updateEntityBoxSize(i, s) {
            this.objectHelper.visible && this.geometryHelper instanceof mi ? (i.setScalar(0), s.set(this.geometryHelper.parameters.width, this.geometryHelper.parameters.height, this.geometryHelper.parameters.height).multiplyScalar(.5)) : super.updateEntityBoxSize(i, s);
        }
        hideGizmos() {
            for(let i in this.gizmos){
                let s = this.gizmos[i];
                s instanceof hl && (s.visible = !1);
            }
        }
    };
var wx = 790, af = new E, VE = new E, kE = new Ke, UE = new E, Bm = new E, zE = new E, wr = class extends Ss(qn, bx) {
    constructor(e = "", r = {
        ...Bc.defaultData,
        name: ""
    }){
        super();
        this._cameraType = "OrthographicCamera";
        this.targetOffset = El.DefaultTargetOffset;
        this.isUpVectorFlipped = !1;
        this.angleOffsetFromUp = 0;
        this.wasMovedByUser = !1;
        this.wasMovedBySwitchCameraAction = !1;
        this.super_Entity(e, r), this.previousProjectionMatrix = new ue, this.matrixAutoUpdate = !0, this.width = window.innerWidth, this.height = window.innerHeight;
        let i = this.width, s = this.height;
        this.orthoCamera = new rl(i * -0.5, i * .5, s * .5, s * -0.5, -50000, 1e4), this.perspCamera = new $r(45, i / s, 50, 1e4), this.left = this.orthoCamera.left, this.right = this.orthoCamera.right, this.top = this.orthoCamera.top, this.bottom = this.orthoCamera.bottom, this.far = this.orthoCamera.far, this.view = this.orthoCamera.view, this.aspect = this.perspCamera.aspect, this.focus = this.perspCamera.focus, this.filmGauge = this.perspCamera.filmGauge, this.filmOffset = this.perspCamera.filmOffset, this.objectHelper.update();
    }
    get isPerspectiveCamera() {
        return this.cameraType === "PerspectiveCamera";
    }
    get isOrthographicCamera() {
        return !this.isPerspectiveCamera;
    }
    get cameraType() {
        return this._cameraType;
    }
    set fov(e) {
        this.perspCamera.fov = e;
    }
    get fov() {
        return this.perspCamera.fov;
    }
    setNear(e, r) {
        e === "PerspectiveCamera" ? this.perspCamera.near = r : this.orthoCamera.near = r;
    }
    setZoom(e, r) {
        r >= 0 && (e === "PerspectiveCamera" ? this.perspCamera.zoom = r : this.orthoCamera.zoom = r);
    }
    set cameraType(e) {
        e === "PerspectiveCamera" ? this.toPerspective() : e === "OrthographicCamera" && this.toOrthographic();
    }
    get near() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.near : this.orthoCamera.near;
    }
    set near(e) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.near = e : this.orthoCamera.near = e;
    }
    get zoom() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom : this.orthoCamera.zoom;
    }
    set zoom(e) {
        e >= 0 && (this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom = e : this.orthoCamera.zoom = e);
    }
    lookAt(e, r, i) {
        typeof e == "number" && (e = new E(e, r, i)), super.lookAt(e), this.getWorldPosition(af), this.targetOffset = af.distanceTo(e);
    }
    getTarget(e = new E) {
        return this.getWorldDirection(VE), this.getWorldPosition(af), VE.multiplyScalar(this.targetOffset), e.copy(af).add(VE), e;
    }
    getDistanceToTarget() {
        let e = this.getTarget();
        return this.getWorldPosition(af), af.distanceTo(e);
    }
    updateUp() {
        this.getWorldQuaternion(kE), UE.set(0, 0, 1).applyQuaternion(kE), Bm.copy(Tt.DEFAULT_UP), this.isUpVectorFlipped && Bm.negate(), Bm.applyQuaternion(kE), zE.copy(Tt.DEFAULT_UP).projectOnPlane(UE), this.angleOffsetFromUp = zE.angleTo(Bm), this.angleOffsetFromUp *= zE.cross(Bm).dot(UE) >= 0 ? 1 : -1;
    }
    updateTransformState(e, r) {
        let i = super.updateTransformState(e, r);
        return e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateUp(), i;
    }
    getViewFrontToObject(e) {
        let r = e.getWorldPosition(new E), s = e.getWorldDirection(new E).multiplyScalar(this.targetOffset);
        return {
            position: r.clone().add(s),
            target: r
        };
    }
    getViewToTarget(e) {
        let i = this.getWorldDirection(new E).multiplyScalar(this.targetOffset);
        return {
            position: e.clone().sub(i),
            target: e
        };
    }
    getViewToObject(e) {
        let r = new E, i = e.getWorldPosition(r);
        return this.getViewToTarget(r);
    }
    setViewplaneSize(e, r, i = !1) {
        if (this.aspect = e / r, i) {
            let s = e > r ? this.aspect : 1, o = e > r ? 1 : this.aspect;
            this.left = -wx * .5 * s, this.right = wx * .5 * s, this.top = wx * .5 * (1 / o), this.bottom = -wx * .5 * (1 / o);
        } else this.left = -e * .5, this.right = e * .5, this.top = r * .5, this.bottom = -r * .5;
        this.updateProjectionMatrix();
    }
    copyViewPlaneSize(e) {
        this.aspect = e.aspect, this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.updateProjectionMatrix();
    }
    toOrthographic() {
        this.orthoCamera.left = this.left, this.orthoCamera.right = this.right, this.orthoCamera.top = this.top, this.orthoCamera.bottom = this.bottom, this.orthoCamera.view = this.view, this.orthoCamera.far = this.far, this.orthoCamera.updateProjectionMatrix(), this.projectionMatrix = this.orthoCamera.projectionMatrix, this.projectionMatrixInverse = this.orthoCamera.projectionMatrixInverse, this._cameraType = "OrthographicCamera", this.objectHelper && this.objectHelper.update();
    }
    toPerspective() {
        this.perspCamera.aspect = this.aspect, this.perspCamera.fov = this.fov, this.perspCamera.view = this.view, this.perspCamera.far = this.far, this.perspCamera.updateProjectionMatrix(), this.projectionMatrix = this.perspCamera.projectionMatrix, this.projectionMatrixInverse = this.perspCamera.projectionMatrixInverse, this._cameraType = "PerspectiveCamera", this.objectHelper && this.objectHelper.update();
    }
    setFocalLength(e) {
        this.perspCamera.setFocalLength(e), this.toPerspective();
    }
    getFocalLength() {
        return this.perspCamera.getFocalLength();
    }
    getEffectiveFOV() {
        return this.perspCamera.getEffectiveFOV();
    }
    getFilmWidth() {
        return this.perspCamera.getFilmWidth();
    }
    getFilmHeight() {
        return this.perspCamera.getFilmHeight();
    }
    setViewOffset(e, r, i, s, o, a) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.setViewOffset(e, r, i, s, o, a) : this.orthoCamera.setViewOffset(e, r, i, s, o, a);
    }
    clearViewOffset() {
        this._cameraType === "PerspectiveCamera" ? (this.perspCamera.clearViewOffset(), this.toPerspective()) : (this.orthoCamera.clearViewOffset(), this.toOrthographic());
    }
    copyHistory() {
        this.previousProjectionMatrix && this.previousProjectionMatrix.copy(this.projectionMatrix);
    }
    updateProjectionMatrix() {
        this._cameraType === "PerspectiveCamera" ? this.toPerspective() : this._cameraType === "OrthographicCamera" && this.toOrthographic();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, r) {
        super.updateWorldMatrix(e, r), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    copy(e, r) {
        return super.copy(e, r), this.parent = e.parent, this.orthoCamera.copy(e.orthoCamera), this.perspCamera.copy(e.perspCamera), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.far = e.far, this.view = e.view === null ? null : Object.assign({}, e.view), this._cameraType = e._cameraType, this.aspect = e.aspect, this.fov = e.fov, this.focus = e.focus, this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this.targetOffset = e.targetOffset, this.updateProjectionMatrix(), this;
    }
    toCameraState(e = []) {
        let r = {
            type: this.cameraType,
            far: this.far,
            orthographic: {
                near: this.orthoCamera.near,
                zoom: this.orthoCamera.zoom
            },
            perspective: {
                near: this.perspCamera.near,
                fov: this.perspCamera.fov,
                zoom: this.perspCamera.zoom
            },
            up: this.up.toArray(),
            targetOffset: this.targetOffset,
            isUpVectorFlipped: this.isUpVectorFlipped
        };
        return _h(r, e);
    }
    updateCameraSubtype(e, r) {
        let i = e === "perspective" ? "PerspectiveCamera" : "OrthographicCamera";
        r.zoom !== void 0 && this.setZoom(i, r.zoom), r.near !== void 0 && this.setNear(i, r.near), r.fov !== void 0 && i === "PerspectiveCamera" && (this.fov = r.fov);
    }
    updateState(e, r) {
        this.updateCameraState(e, r);
    }
    updateCameraState(e, r) {
        this.updateState_Entity(e, r), e.far !== void 0 && (this.far = e.far), e.orthographic !== void 0 && this.updateCameraSubtype("orthographic", e.orthographic), e.perspective !== void 0 && this.updateCameraSubtype("perspective", e.perspective), e.type !== void 0 && (this.cameraType = e.type), e.up !== void 0 && this.up.fromArray(e.up), e.targetOffset !== void 0 && (this.targetOffset = e.targetOffset), e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateProjectionMatrix();
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.path.length === 1 && e.type === 0 && this.updateCameraSubtype(e.path[0], e.props);
    }
    toState(e) {
        return {
            ...super.toState(e),
            ...this.toCameraState(e),
            type: this.cameraType
        };
    }
};
var lf = new ue, fK = new ue;
function GE(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.geometry?.type === "BooleanGeometry" && (t = !0);
    }), t;
}
var Fn = class extends vs {
    constructor(e, r, i){
        super(e, r);
        this.data = r;
        this.meshSetAddresses = [];
        this.needsTransformForDownstream = !1;
        this.geometry = new _e;
        this.onAfterRender = (e, r, i, s, o, a)=>{
            super.onAfterRender(e, r, i, s, o, a), this.recomputeBoolean();
        };
        this.geometry.userData.parameters = {
            width: 0,
            height: 0,
            depth: 0
        };
    }
    get booleanOp() {
        return this.data.geometry.operation;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    get isLOD() {
        return this.recomputeBoolean(), !1;
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.path.length === 1 && e.path[0] === "geometry" && e.type === 0 && e.props.operation !== void 0 && (this.freeBooleanPointer(), this.resetBBoxNeedsUpdate());
    }
    freeBooleanPointer() {
        super.freeBooleanPointer(), this.geometry.dispose();
    }
    recomputeBoolean(e, r = !0) {
        if (this.booleanMeshSetAddress !== -1 && !e) return;
        for(let s = 0; s < this.children.length; s++){
            let o = this.children[s];
            o instanceof Fn && o.dataPatched.visible === !0 && o.recomputeBoolean(e === !0, r);
        }
        this.meshSetAddresses = [];
        for(let s = 0; s < this.children.length; s++){
            let o = this.children[s];
            if (o instanceof mr && o.dataPatched.visible === !0 && o.geometry.attributes.position?.count > 0 && o.geometry.drawRange.count > 0 && o.booleanMeshSetAddress !== 0) {
                lf.multiplyMatrices(o.hiddenMatrix, o.matrix);
                try {
                    if (o.booleanMeshSetAddress === -1) {
                        if ((o.geometry.index ?? o.geometry.getAttribute("position")).count / 3 < 15e5 && (o.booleanMeshSetAddress = ms.getMeshSet(o.geometry, e === !0, r)), o.booleanMeshSetAddress === -1) return;
                        ms.transformMeshSet(o.booleanMeshSetAddress, lf), o.booleanMatrixInvOld.copy(lf).invert(), o.booleanWasTransformed = !1;
                    } else o instanceof Fn && o.needsTransformForDownstream === !0 ? (ms.transformMeshSet(o.booleanMeshSetAddress, lf), o.needsTransformForDownstream = !1) : o.booleanWasTransformed === !0 && (ms.transformMeshSet(o.booleanMeshSetAddress, fK.multiplyMatrices(lf, o.booleanMatrixInvOld)), o.booleanMatrixInvOld.copy(lf).invert(), o.booleanWasTransformed = !1);
                } catch (a) {
                    console.error(a), o.booleanMeshSetAddress = 0, o.geometry.userData.booleanOperationDidFail = !0;
                    continue;
                }
                ms.hasOpenEdges(o.booleanMeshSetAddress) === !1 || s === this.children.length - 1 && this.booleanOp === 2 ? (this.meshSetAddresses.push(o.booleanMeshSetAddress), o.geometry.userData.booleanOperationDidFail = !1) : o.geometry.userData.booleanOperationDidFail = "openEdges";
            }
        }
        if (this.meshSetAddresses.length === 0) {
            this.geometry.setAttribute("position", new Te([], 0)), this.geometry.setDrawRange(0, 0);
            return;
        }
        if (e === !0) return ms.calcBooleanTopological(this.meshSetAddresses, this.booleanOp);
        let i = this.geometry;
        i.dispose(), this.geometry = new _e, this.geometry.userData = i.userData, this.geometry.boundingSphere = i.boundingSphere;
        try {
            this.booleanMeshSetAddress = ms.calcBoolean(this.meshSetAddresses, this.booleanOp, this.geometry, this.phongAngle);
        } catch (s) {
            this.booleanMeshSetAddress = 0, this.geometry.userData.booleanOperationDidFail = !0, console.error(s);
        }
        this.booleanMatrixInvOld.copy(this.matrix).invert(), this.needsTransformForDownstream = !0, nf(this), sf(this);
    }
    dispose() {
        super.dispose(), this.geometry.dispose();
    }
};
var Ax;
((t)=>{
    function n1(e) {
        return yt.is(e) && e instanceof cl;
    }
    t.is = n1;
})(Ax || (Ax = {}));
var cf = (n1, t)=>class extends Ss(n1, t) {
        updateState_Light(r, i) {
            this.updateState_Entity(r, i), r.color !== void 0 && (this.color = i.shared.color(r.color)), r.intensity !== void 0 && (this.intensity = r.intensity), r.depth !== void 0 && (this.shadow.camera.far = r.depth, this.shadow.needsUpdate = !0), r.shadows !== void 0 && (this.castShadow = r.shadows);
        }
    };
var cn = (n1)=>n1 instanceof mr, En = (n1)=>n1 !== null && n1 instanceof Fn, C3 = (n1)=>n1 instanceof wr, P3 = (n1)=>Ax.is(n1), Nm = (n1)=>Sx.is(n1);
var pK = new E(1, 1, 1), _3 = new E, mK = new E, I3 = new Ke, ws = class extends Uo(Dy) {
    constructor(e, r = 15){
        super(r);
        this.object = e;
        this.dummy = new sn;
        this.object.updateMatrixWorld(), this.name = `EmptyObjectHelper: ${e.uuid}`, this.matrix = this.dummy.matrixWorld, this.matrixAutoUpdate = !1, this.object.isBone && (this.visible = !1);
    }
    raycast(e, r) {
        zo(this.object, ws.geometryHelper, e, r, !1, this.dummy);
    }
    update() {}
    updateMatrix() {}
    updateMatrixWorld(e) {
        this.object.matrixWorld.decompose(_3, I3, mK), this.matrix.compose(_3, I3, pK), super.updateMatrixWorld(e);
    }
    updateWorldMatrix(e, r) {}
};
var As = class extends Ss(sn, ws) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Entity(t, e), "buffer" in t && Object.keys(t).length === 1 && e.scene.reloadSplats();
    }
};
var ql = class extends Ss(sn, ws) {
    constructor(e, r, i){
        super();
        this.super_Entity(e, r), this.context = i, this.objectHelper.update();
    }
    updateState(e, r) {
        this.updateState_Entity(e, r);
    }
};
var F3 = {
    RED: 0,
    GREEN: 1,
    BLUE: 2,
    ALPHA: 3
};
var Fm = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
var gK = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D cocBuffer;uniform vec2 texelSize;uniform float scale;uniform vec4 kernel64[32];varying vec2 vUv;void main(){
#ifdef FOREGROUND
vec2 CoCNearFar=texture2D(cocBuffer,vUv).rg;float CoC=CoCNearFar.r*scale;
#else
float CoC=texture2D(cocBuffer,vUv).g*scale;
#endif
if(CoC==0.0){gl_FragColor=texture2D(inputBuffer,vUv);}else{
#ifdef FOREGROUND
vec2 step=texelSize*max(CoC,CoCNearFar.g*scale);
#else
vec2 step=texelSize*CoC;
#endif
vec4 acc=vec4(0.0);for(int i=0;i<32;++i){vec4 kernel=kernel64[i];vec2 uv=step*kernel.xy+vUv;acc+=texture2D(inputBuffer,uv);uv=step*kernel.zw+vUv;acc+=texture2D(inputBuffer,uv);}gl_FragColor=acc/64.0;}}`, Ex = class extends it {
    constructor(n1 = !1, t = !1){
        super({
            name: "BokehMaterial",
            defines: {
                PASS: n1 ? "2" : "1"
            },
            uniforms: {
                kernel64: new le(null),
                kernel16: new le(null),
                inputBuffer: new le(null),
                cocBuffer: new le(null),
                texelSize: new le(new k),
                scale: new le(1)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: gK,
            vertexShader: Fm
        }), this.toneMapped = !1, t && (this.defines.FOREGROUND = "1"), this.generateKernel();
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    set cocBuffer(n1) {
        this.uniforms.cocBuffer.value = n1;
    }
    setCoCBuffer(n1) {
        this.uniforms.cocBuffer.value = n1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(n1) {
        this.uniforms.scale.value = n1;
    }
    getScale(n1) {
        return this.uniforms.scale.value = n1;
    }
    setScale(n1) {
        this.uniforms.scale.value = n1;
    }
    generateKernel() {
        let n1 = 2.39996323, t = new Float32Array(128), e = new Float32Array(32), r = 0, i = 0;
        for(let a = 0; a < 80; ++a){
            let l = a * n1, c = Math.sqrt(a) / Math.sqrt(80), u = c * Math.cos(l), h = c * Math.sin(l);
            a % 5 === 0 ? (e[i++] = u, e[i++] = h) : (t[r++] = u, t[r++] = h);
        }
        let s = [], o = [];
        for(let a = 0; a < 128;)s.push(new Ze(t[a++], t[a++], t[a++], t[a++]));
        for(let a = 0; a < 32;)o.push(new Ze(e[a++], e[a++], e[a++], e[a++]));
        this.uniforms.kernel64.value = s, this.uniforms.kernel16.value = o;
    }
    setTexelSize(n1, t) {
        this.uniforms.texelSize.value.set(n1, t);
    }
    setSize(n1, t) {
        this.uniforms.texelSize.value.set(1 / n1, 1 / t);
    }
};
function D3(n1, t, e) {
    return n1 * (t - e) - t;
}
function YE(n1, t, e) {
    return Math.min(Math.max((n1 + t) / (t - e), 0), 1);
}
var yK = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform float focusDistance;uniform float focusRange;uniform float cameraNear;uniform float cameraFar;varying vec2 vUv;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}void main(){float depth=readDepth(vUv);
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
float signedDistance=linearDepth-focusDistance;float magnitude=smoothstep(0.0,focusRange,abs(signedDistance));gl_FragColor.rg=magnitude*vec2(step(signedDistance,0.0),step(0.0,signedDistance));}`, vK = class extends it {
    constructor(n1){
        super({
            name: "CircleOfConfusionMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new le(null),
                focusDistance: new le(0),
                focusRange: new le(0),
                cameraNear: new le(.3),
                cameraFar: new le(1e3)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: yK,
            vertexShader: Fm
        }), this.toneMapped = !1, this.uniforms.focalLength = this.uniforms.focusRange, this.adoptCameraSettings(n1);
    }
    get near() {
        return this.uniforms.cameraNear.value;
    }
    get far() {
        return this.uniforms.cameraFar.value;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = Bi) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    get focusDistance() {
        return this.uniforms.focusDistance.value;
    }
    set focusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    get worldFocusDistance() {
        return -D3(this.focusDistance, this.near, this.far);
    }
    set worldFocusDistance(n1) {
        this.focusDistance = YE(-n1, this.near, this.far);
    }
    getFocusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    setFocusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    get focalLength() {
        return this.focusRange;
    }
    set focalLength(n1) {
        this.focusRange = n1;
    }
    get focusRange() {
        return this.uniforms.focusRange.value;
    }
    set focusRange(n1) {
        this.uniforms.focusRange.value = n1;
    }
    get worldFocusRange() {
        return -D3(this.focusRange, this.near, this.far);
    }
    set worldFocusRange(n1) {
        this.focusRange = YE(-n1, this.near, this.far);
    }
    getFocalLength(n1) {
        return this.focusRange;
    }
    setFocalLength(n1) {
        this.focusRange = n1;
    }
    adoptCameraSettings(n1) {
        n1 && (this.uniforms.cameraNear.value = n1.near, this.uniforms.cameraFar.value = n1.far, n1 instanceof $r ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
}, xK = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <encodings_fragment>
#include <dithering_fragment>
}`, bK = "uniform vec2 texelSize;uniform vec2 halfTexelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize*vec2(kernel)+halfTexelSize)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}", O3 = class extends it {
    constructor(n1 = new k){
        super({
            name: "KawaseBlurMaterial",
            uniforms: {
                inputBuffer: new le(null),
                texelSize: new le(new k),
                halfTexelSize: new le(new k),
                kernel: new le(0),
                scale: new le(1)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: xK,
            vertexShader: bK
        }), this.toneMapped = !1, this.setTexelSize(n1.x, n1.y);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.inputBuffer = n1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(n1) {
        this.uniforms.scale.value = n1;
    }
    getScale() {
        return this.uniforms.scale.value;
    }
    setScale(n1) {
        this.uniforms.scale.value = n1;
    }
    getKernel() {
        return null;
    }
    get kernel() {
        return this.uniforms.kernel.value;
    }
    set kernel(n1) {
        this.uniforms.kernel.value = n1;
    }
    setKernel(n1) {
        this.kernel = n1;
    }
    setTexelSize(n1, t) {
        this.uniforms.texelSize.value.set(n1, t), this.uniforms.halfTexelSize.value.set(n1, t).multiplyScalar(.5);
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / n1, 1 / t), e.halfTexelSize.value.copy(e.texelSize.value).multiplyScalar(.5);
    }
}, SK = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <encodings_fragment>
}`, wK = class extends it {
    constructor(){
        super({
            name: "CopyMaterial",
            uniforms: {
                inputBuffer: new le(null),
                opacity: new le(1)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: SK,
            vertexShader: Fm
        }), this.toneMapped = !1;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    getOpacity(n1) {
        return this.uniforms.opacity.value;
    }
    setOpacity(n1) {
        this.uniforms.opacity.value = n1;
    }
};
var AK = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`, EK = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`, uf = {
    DEPTH: 0,
    LUMA: 1,
    COLOR: 2
}, TK = {
    DISABLED: 0,
    DEPTH: 1,
    CUSTOM: 2
}, MK = class extends it {
    constructor(n1 = new k, t = uf.COLOR){
        super({
            name: "EdgeDetectionMaterial",
            defines: {
                THREE_REVISION: ca.replace(/\D+/g, ""),
                LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                EDGE_THRESHOLD: "0.1",
                DEPTH_THRESHOLD: "0.01",
                PREDICATION_MODE: "0",
                PREDICATION_THRESHOLD: "0.01",
                PREDICATION_SCALE: "2.0",
                PREDICATION_STRENGTH: "1.0",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                inputBuffer: new le(null),
                depthBuffer: new le(null),
                predicationBuffer: new le(null),
                texelSize: new le(n1)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: AK,
            vertexShader: EK
        }), this.toneMapped = !1, this.edgeDetectionMode = t;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = Bi) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    get edgeDetectionMode() {
        return Number(this.defines.EDGE_DETECTION_MODE);
    }
    set edgeDetectionMode(n1) {
        this.defines.EDGE_DETECTION_MODE = n1.toFixed(0), this.needsUpdate = !0;
    }
    getEdgeDetectionMode() {
        return this.edgeDetectionMode;
    }
    setEdgeDetectionMode(n1) {
        this.edgeDetectionMode = n1;
    }
    get localContrastAdaptationFactor() {
        return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
    }
    set localContrastAdaptationFactor(n1) {
        this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getLocalContrastAdaptationFactor() {
        return this.localContrastAdaptationFactor;
    }
    setLocalContrastAdaptationFactor(n1) {
        this.localContrastAdaptationFactor = n1;
    }
    get edgeDetectionThreshold() {
        return Number(this.defines.EDGE_THRESHOLD);
    }
    set edgeDetectionThreshold(n1) {
        this.defines.EDGE_THRESHOLD = n1.toFixed("6"), this.defines.DEPTH_THRESHOLD = (n1 * .1).toFixed("6"), this.needsUpdate = !0;
    }
    getEdgeDetectionThreshold() {
        return this.edgeDetectionThreshold;
    }
    setEdgeDetectionThreshold(n1) {
        this.edgeDetectionThreshold = n1;
    }
    get predicationMode() {
        return Number(this.defines.PREDICATION_MODE);
    }
    set predicationMode(n1) {
        this.defines.PREDICATION_MODE = n1.toFixed(0), this.needsUpdate = !0;
    }
    getPredicationMode() {
        return this.predicationMode;
    }
    setPredicationMode(n1) {
        this.predicationMode = n1;
    }
    set predicationBuffer(n1) {
        this.uniforms.predicationBuffer.value = n1;
    }
    setPredicationBuffer(n1) {
        this.uniforms.predicationBuffer.value = n1;
    }
    get predicationThreshold() {
        return Number(this.defines.PREDICATION_THRESHOLD);
    }
    set predicationThreshold(n1) {
        this.defines.PREDICATION_THRESHOLD = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationThreshold() {
        return this.predicationThreshold;
    }
    setPredicationThreshold(n1) {
        this.predicationThreshold = n1;
    }
    get predicationScale() {
        return Number(this.defines.PREDICATION_SCALE);
    }
    set predicationScale(n1) {
        this.defines.PREDICATION_SCALE = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationScale() {
        return this.predicationScale;
    }
    setPredicationScale(n1) {
        this.predicationScale = n1;
    }
    get predicationStrength() {
        return Number(this.defines.PREDICATION_STRENGTH);
    }
    set predicationStrength(n1) {
        this.defines.PREDICATION_STRENGTH = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationStrength() {
        return this.predicationStrength;
    }
    setPredicationStrength(n1) {
        this.predicationStrength = n1;
    }
    setSize(n1, t) {
        this.uniforms.texelSize.value.set(1 / n1, 1 / t);
    }
}, CK = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if THREE_REVISION >= 137
vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}FRAGMENT_HEADvoid main(){FRAGMENT_MAIN_UVvec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGEgl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <encodings_fragment>
#endif
#include <dithering_fragment>
}`, PK = "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEADvoid main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORTgl_Position=vec4(position.xy,1.0,1.0);}", $s = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
}, XE = class extends it {
    constructor(n1, t, e, r, i = !1){
        super({
            name: "EffectMaterial",
            defines: {
                THREE_REVISION: ca.replace(/\D+/g, ""),
                DEPTH_PACKING: "0",
                ENCODE_OUTPUT: "1"
            },
            uniforms: {
                inputBuffer: new le(null),
                depthBuffer: new le(null),
                resolution: new le(new k),
                texelSize: new le(new k),
                cameraNear: new le(.3),
                cameraFar: new le(1e3),
                aspect: new le(1),
                time: new le(0)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            dithering: i
        }), this.toneMapped = !1, n1 && this.setShaderParts(n1), t && this.setDefines(t), e && this.setUniforms(e), this.adoptCameraSettings(r);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    get depthPacking() {
        return Number(this.defines.DEPTH_PACKING);
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = Bi) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    setShaderParts(n1) {
        return this.fragmentShader = CK.replace($s.FRAGMENT_HEAD, n1.get($s.FRAGMENT_HEAD)).replace($s.FRAGMENT_MAIN_UV, n1.get($s.FRAGMENT_MAIN_UV)).replace($s.FRAGMENT_MAIN_IMAGE, n1.get($s.FRAGMENT_MAIN_IMAGE)), this.vertexShader = PK.replace($s.VERTEX_HEAD, n1.get($s.VERTEX_HEAD)).replace($s.VERTEX_MAIN_SUPPORT, n1.get($s.VERTEX_MAIN_SUPPORT)), this.needsUpdate = !0, this;
    }
    setDefines(n1) {
        for (let t of n1.entries())this.defines[t[0]] = t[1];
        return this.needsUpdate = !0, this;
    }
    setUniforms(n1) {
        for (let t of n1.entries())this.uniforms[t[0]] = t[1];
        return this;
    }
    setExtensions(n1) {
        this.extensions = {};
        for (let t of n1)this.extensions[t] = !0;
        return this;
    }
    get encodeOutput() {
        return this.defines.ENCODE_OUTPUT !== void 0;
    }
    set encodeOutput(n1) {
        this.encodeOutput !== n1 && (n1 ? this.defines.ENCODE_OUTPUT = "1" : delete this.defines.ENCODE_OUTPUT, this.needsUpdate = !0);
    }
    isOutputEncodingEnabled(n1) {
        return this.encodeOutput;
    }
    setOutputEncodingEnabled(n1) {
        this.encodeOutput = n1;
    }
    get time() {
        return this.uniforms.time.value;
    }
    set time(n1) {
        this.uniforms.time.value = n1;
    }
    setDeltaTime(n1) {
        this.uniforms.time.value += n1;
    }
    adoptCameraSettings(n1) {
        n1 && (this.uniforms.cameraNear.value = n1.near, this.uniforms.cameraFar.value = n1.far, n1 instanceof $r ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.resolution.value.set(n1, t), e.texelSize.value.set(1 / n1, 1 / t), e.aspect.value = n1 / t;
    }
    static get Section() {
        return $s;
    }
};
var _K = `#include <common>
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);l*=low*high;
#elif defined(THRESHOLD)
l=smoothstep(threshold,threshold+smoothing,l);
#endif
#ifdef COLOR
gl_FragColor=vec4(texel.rgb*l,l);
#else
gl_FragColor=vec4(l);
#endif
}`, IK = class extends it {
    constructor(n1 = !1, t = null){
        super({
            name: "LuminanceMaterial",
            defines: {
                THREE_REVISION: ca.replace(/\D+/g, "")
            },
            uniforms: {
                inputBuffer: new le(null),
                threshold: new le(0),
                smoothing: new le(1),
                range: new le(null)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: _K,
            vertexShader: Fm
        }), this.toneMapped = !1, this.colorOutput = n1, this.luminanceRange = t;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get threshold() {
        return this.uniforms.threshold.value;
    }
    set threshold(n1) {
        this.smoothing > 0 || n1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.threshold.value = n1;
    }
    getThreshold() {
        return this.threshold;
    }
    setThreshold(n1) {
        this.threshold = n1;
    }
    get smoothing() {
        return this.uniforms.smoothing.value;
    }
    set smoothing(n1) {
        this.threshold > 0 || n1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.smoothing.value = n1;
    }
    getSmoothingFactor() {
        return this.smoothing;
    }
    setSmoothingFactor(n1) {
        this.smoothing = n1;
    }
    get useThreshold() {
        return this.threshold > 0 || this.smoothing > 0;
    }
    set useThreshold(n1) {}
    get colorOutput() {
        return this.defines.COLOR !== void 0;
    }
    set colorOutput(n1) {
        n1 ? this.defines.COLOR = "1" : delete this.defines.COLOR, this.needsUpdate = !0;
    }
    isColorOutputEnabled(n1) {
        return this.colorOutput;
    }
    setColorOutputEnabled(n1) {
        this.colorOutput = n1;
    }
    get useRange() {
        return this.luminanceRange !== null;
    }
    set useRange(n1) {
        this.luminanceRange = null;
    }
    get luminanceRange() {
        return this.uniforms.range.value;
    }
    set luminanceRange(n1) {
        n1 !== null ? this.defines.RANGE = "1" : delete this.defines.RANGE, this.uniforms.range.value = n1, this.needsUpdate = !0;
    }
    getLuminanceRange() {
        return this.luminanceRange;
    }
    setLuminanceRange(n1) {
        this.luminanceRange = n1;
    }
}, DK = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef MASK_PRECISION_HIGH
uniform mediump sampler2D maskTexture;
#else
uniform lowp sampler2D maskTexture;
#endif
#if MASK_FUNCTION != 0
uniform float strength;
#endif
varying vec2 vUv;void main(){
#if COLOR_CHANNEL == 0
float mask=texture2D(maskTexture,vUv).r;
#elif COLOR_CHANNEL == 1
float mask=texture2D(maskTexture,vUv).g;
#elif COLOR_CHANNEL == 2
float mask=texture2D(maskTexture,vUv).b;
#else
float mask=texture2D(maskTexture,vUv).a;
#endif
#if MASK_FUNCTION == 0
#ifdef INVERTED
mask=step(mask,0.0);
#else
mask=1.0-step(mask,0.0);
#endif
#else
mask=clamp(mask*strength,0.0,1.0);
#ifdef INVERTED
mask=1.0-mask;
#endif
#endif
#if MASK_FUNCTION == 2
gl_FragColor=vec4(mask*texture2D(inputBuffer,vUv).rgb,mask);
#else
gl_FragColor=mask*texture2D(inputBuffer,vUv);
#endif
}`, V3 = {
    DISCARD: 0,
    MULTIPLY: 1,
    MULTIPLY_RGB_SET_ALPHA: 2
}, OK = class extends it {
    constructor(n1 = null){
        super({
            name: "MaskMaterial",
            uniforms: {
                maskTexture: new le(n1),
                inputBuffer: new le(null),
                strength: new le(1)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: DK,
            vertexShader: Fm
        }), this.toneMapped = !1, this.setColorChannel(F3.RED), this.setMaskFunction(V3.DISCARD);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    set maskTexture(n1) {
        this.uniforms.maskTexture.value = n1, delete this.defines.MASK_PRECISION_HIGH, n1.type !== _r && (this.defines.MASK_PRECISION_HIGH = "1"), this.needsUpdate = !0;
    }
    setMaskTexture(n1) {
        this.maskTexture = n1;
    }
    set colorChannel(n1) {
        this.defines.COLOR_CHANNEL = n1.toFixed(0), this.needsUpdate = !0;
    }
    setColorChannel(n1) {
        this.colorChannel = n1;
    }
    set maskFunction(n1) {
        this.defines.MASK_FUNCTION = n1.toFixed(0), this.needsUpdate = !0;
    }
    setMaskFunction(n1) {
        this.maskFunction = n1;
    }
    get inverted() {
        return this.defines.INVERTED !== void 0;
    }
    set inverted(n1) {
        this.inverted && !n1 ? delete this.defines.INVERTED : n1 && (this.defines.INVERTED = "1"), this.needsUpdate = !0;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(n1) {
        this.inverted = n1;
    }
    get strength() {
        return this.uniforms.strength.value;
    }
    set strength(n1) {
        this.uniforms.strength.value = n1;
    }
    getStrength() {
        return this.strength;
    }
    setStrength(n1) {
        this.strength = n1;
    }
};
var RK = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`, LK = "uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}", BK = class extends it {
    constructor(n1 = new k, t = new k){
        super({
            name: "SMAAWeightsMaterial",
            defines: {
                MAX_SEARCH_STEPS_INT: "16",
                MAX_SEARCH_STEPS_FLOAT: "16.0",
                MAX_SEARCH_STEPS_DIAG_INT: "8",
                MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                CORNER_ROUNDING: "25",
                CORNER_ROUNDING_NORM: "0.25",
                AREATEX_MAX_DISTANCE: "16.0",
                AREATEX_MAX_DISTANCE_DIAG: "20.0",
                AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
            },
            uniforms: {
                inputBuffer: new le(null),
                searchTexture: new le(null),
                areaTexture: new le(null),
                resolution: new le(t),
                texelSize: new le(n1)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: RK,
            vertexShader: LK
        }), this.toneMapped = !1;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get searchTexture() {
        return this.uniforms.searchTexture.value;
    }
    set searchTexture(n1) {
        this.uniforms.searchTexture.value = n1;
    }
    get areaTexture() {
        return this.uniforms.areaTexture.value;
    }
    set areaTexture(n1) {
        this.uniforms.areaTexture.value = n1;
    }
    setLookupTextures(n1, t) {
        this.searchTexture = n1, this.areaTexture = t;
    }
    get orthogonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_INT);
    }
    set orthogonalSearchSteps(n1) {
        let t = Math.min(Math.max(n1, 0), 112);
        this.defines.MAX_SEARCH_STEPS_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setOrthogonalSearchSteps(n1) {
        this.orthogonalSearchSteps = n1;
    }
    get diagonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
    }
    set diagonalSearchSteps(n1) {
        let t = Math.min(Math.max(n1, 0), 20);
        this.defines.MAX_SEARCH_STEPS_DIAG_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setDiagonalSearchSteps(n1) {
        this.diagonalSearchSteps = n1;
    }
    get diagonalDetection() {
        return this.defines.DISABLE_DIAG_DETECTION === void 0;
    }
    set diagonalDetection(n1) {
        n1 ? delete this.defines.DISABLE_DIAG_DETECTION : this.defines.DISABLE_DIAG_DETECTION = "1", this.needsUpdate = !0;
    }
    isDiagonalDetectionEnabled() {
        return this.diagonalDetection;
    }
    setDiagonalDetectionEnabled(n1) {
        this.diagonalDetection = n1;
    }
    get cornerRounding() {
        return Number(this.defines.CORNER_ROUNDING);
    }
    set cornerRounding(n1) {
        let t = Math.min(Math.max(n1, 0), 100);
        this.defines.CORNER_ROUNDING = t.toFixed("4"), this.defines.CORNER_ROUNDING_NORM = (t / 100).toFixed("4"), this.needsUpdate = !0;
    }
    setCornerRounding(n1) {
        this.cornerRounding = n1;
    }
    get cornerDetection() {
        return this.defines.DISABLE_CORNER_DETECTION === void 0;
    }
    set cornerDetection(n1) {
        n1 ? delete this.defines.DISABLE_CORNER_DETECTION : this.defines.DISABLE_CORNER_DETECTION = "1", this.needsUpdate = !0;
    }
    isCornerRoundingEnabled() {
        return this.cornerDetection;
    }
    setCornerRoundingEnabled(n1) {
        this.cornerDetection = n1;
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / n1, 1 / t), e.resolution.value.set(n1, t);
    }
};
var NK = new qn, Yl = null;
function FK() {
    if (Yl === null) {
        let n1 = new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), t = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        Yl = new _e, Yl.setAttribute !== void 0 ? (Yl.setAttribute("position", new Xe(n1, 3)), Yl.setAttribute("uv", new Xe(t, 2))) : (Yl.addAttribute("position", new Xe(n1, 3)), Yl.addAttribute("uv", new Xe(t, 2)));
    }
    return Yl;
}
var xi = class {
    constructor(n1 = "Pass", t = new ei, e = NK){
        this.name = n1, this.renderer = null, this.scene = t, this.camera = e, this.screen = null, this.rtt = !0, this.needsSwap = !0, this.needsDepthTexture = !1, this.enabled = !0;
    }
    get renderToScreen() {
        return !this.rtt;
    }
    set renderToScreen(n1) {
        if (this.rtt === n1) {
            let t = this.getFullscreenMaterial();
            t !== null && (t.needsUpdate = !0), this.rtt = !n1;
        }
    }
    setRenderer(n1) {
        this.renderer = n1;
    }
    isEnabled() {
        return this.enabled;
    }
    setEnabled(n1) {
        this.enabled = n1;
    }
    get fullscreenMaterial() {
        return this.screen !== null ? this.screen.material : null;
    }
    set fullscreenMaterial(n1) {
        let t = this.screen;
        t !== null ? t.material = n1 : (t = new zt(FK(), n1), t.frustumCulled = !1, this.scene === null && (this.scene = new ei), this.scene.add(t), this.screen = t);
    }
    getFullscreenMaterial() {
        return this.fullscreenMaterial;
    }
    setFullscreenMaterial(n1) {
        this.fullscreenMaterial = n1;
    }
    getDepthTexture() {
        return null;
    }
    setDepthTexture(n1, t = Bi) {}
    render(n1, t, e, r, i) {
        throw new Error("Render method not implemented!");
    }
    setSize(n1, t) {}
    initialize(n1, t, e) {}
    dispose() {
        for (let n1 of Object.keys(this)){
            let t = this[n1];
            if (t !== null && typeof t == "object" && typeof t.dispose == "function") {
                if (t instanceof ei || t === this.renderer) continue;
                this[n1].dispose();
            }
        }
    }
}, Vm = class extends xi {
    constructor(n1, t = !0){
        super("CopyPass"), this.fullscreenMaterial = new wK, this.needsSwap = !1, this.renderTarget = n1, n1 === void 0 && (this.renderTarget = new dt(1, 1, {
            minFilter: rt,
            magFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "CopyPass.Target"), this.autoResize = t;
    }
    get resize() {
        return this.autoResize;
    }
    set resize(n1) {
        this.autoResize = n1;
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    setAutoResizeEnabled(n1) {
        this.autoResize = n1;
    }
    render(n1, t, e, r, i) {
        this.fullscreenMaterial.inputBuffer = t.texture, n1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), n1.render(this.scene, this.camera);
    }
    setSize(n1, t) {
        this.autoResize && this.renderTarget.setSize(n1, t);
    }
    initialize(n1, t, e) {
        e !== void 0 && (this.renderTarget.texture.type = e, e !== _r ? this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1" : n1.outputEncoding === at && (this.renderTarget.texture.encoding = at));
    }
};
var k3 = class extends xi {
    constructor(){
        super("ClearMaskPass", null, null), this.needsSwap = !1;
    }
    render(n1, t, e, r, i) {
        let s = n1.state.buffers.stencil;
        s.setLocked(!1), s.setTest(!1);
    }
}, jE = new We, KE = class extends xi {
    constructor(n1 = !0, t = !0, e = !1){
        super("ClearPass", null, null), this.needsSwap = !1, this.color = n1, this.depth = t, this.stencil = e, this.overrideClearColor = null, this.overrideClearAlpha = -1;
    }
    setClearFlags(n1, t, e) {
        this.color = n1, this.depth = t, this.stencil = e;
    }
    getOverrideClearColor() {
        return this.overrideClearColor;
    }
    setOverrideClearColor(n1) {
        this.overrideClearColor = n1;
    }
    getOverrideClearAlpha() {
        return this.overrideClearAlpha;
    }
    setOverrideClearAlpha(n1) {
        this.overrideClearAlpha = n1;
    }
    render(n1, t, e, r, i) {
        let s = this.overrideClearColor, o = this.overrideClearAlpha, a = n1.getClearAlpha(), l = s !== null, c = o >= 0;
        l ? (jE.copy(n1.getClearColor(jE)), n1.setClearColor(s, c ? o : a)) : c && n1.setClearAlpha(o), n1.setRenderTarget(this.renderToScreen ? null : t), n1.clear(this.color, this.depth, this.stencil), l ? n1.setClearColor(jE, a) : c && n1.setClearAlpha(a);
    }
}, Xl = -1, Vn = class extends pr {
    constructor(n1, t = Xl, e = Xl, r = 1){
        super(), this.resizable = n1, this.base = new k(1, 1), this.preferred = new k(t, e), this.target = this.preferred, this.s = r;
    }
    get width() {
        let { base: n1, preferred: t, scale: e } = this, r;
        return t.width !== Xl ? r = t.width : t.height !== Xl ? r = Math.round(t.height * (n1.width / Math.max(n1.height, 1))) : r = Math.round(n1.width * e), r;
    }
    set width(n1) {
        this.preferredWidth = n1;
    }
    get height() {
        let { base: n1, preferred: t, scale: e } = this, r;
        return t.height !== Xl ? r = t.height : t.width !== Xl ? r = Math.round(t.width / Math.max(n1.width / Math.max(n1.height, 1), 1)) : r = Math.round(n1.height * e), r;
    }
    set height(n1) {
        this.preferredHeight = n1;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    get scale() {
        return this.s;
    }
    set scale(n1) {
        this.s !== n1 && (this.s = n1, this.preferred.setScalar(Xl), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getScale() {
        return this.scale;
    }
    setScale(n1) {
        this.scale = n1;
    }
    get baseWidth() {
        return this.base.width;
    }
    set baseWidth(n1) {
        this.base.width !== n1 && (this.base.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseWidth() {
        return this.base.width;
    }
    setBaseWidth(n1) {
        this.base.width !== n1 && (this.base.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get baseHeight() {
        return this.base.height;
    }
    set baseHeight(n1) {
        this.base.height !== n1 && (this.base.height = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseHeight() {
        return this.baseHeight;
    }
    setBaseHeight(n1) {
        this.baseHeight = n1;
    }
    setBaseSize(n1, t) {
        (this.base.width !== n1 || this.base.height !== t) && (this.base.set(n1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get preferredWidth() {
        return this.preferred.width;
    }
    set preferredWidth(n1) {
        this.preferred.width !== n1 && (this.preferred.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredWidth() {
        return this.preferredWidth;
    }
    setPreferredWidth(n1) {
        this.preferredWidth = n1;
    }
    get preferredHeight() {
        return this.preferred.height;
    }
    set preferredHeight(n1) {
        this.preferred.height !== n1 && (this.preferred.height = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredHeight() {
        return this.preferredHeight;
    }
    setPreferredHeight(n1) {
        this.preferredHeight = n1;
    }
    setPreferredSize(n1, t) {
        (this.preferred.width !== n1 || this.preferred.height !== t) && (this.preferred.set(n1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    copy(n1) {
        this.base.set(n1.getBaseWidth(), n1.getBaseHeight()), this.preferred.set(n1.getPreferredWidth(), n1.getPreferredHeight()), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height);
    }
    static get AUTO_SIZE() {
        return Xl;
    }
}, HE = !1, R3 = class {
    constructor(n1 = null){
        this.originalMaterials = new Map, this.material = null, this.materials = null, this.materialsBackSide = null, this.materialsDoubleSide = null, this.materialsFlatShaded = null, this.materialsFlatShadedBackSide = null, this.materialsFlatShadedDoubleSide = null, this.setMaterial(n1), this.meshCount = 0, this.replaceMaterial = (t)=>{
            if (t.isMesh) {
                let e;
                if (t.material.flatShading) switch(t.material.side){
                    case fi:
                        e = this.materialsFlatShadedDoubleSide;
                        break;
                    case pi:
                        e = this.materialsFlatShadedBackSide;
                        break;
                    default:
                        e = this.materialsFlatShaded;
                        break;
                }
                else switch(t.material.side){
                    case fi:
                        e = this.materialsDoubleSide;
                        break;
                    case pi:
                        e = this.materialsBackSide;
                        break;
                    default:
                        e = this.materials;
                        break;
                }
                this.originalMaterials.set(t, t.material), t.isSkinnedMesh ? t.material = e[2] : t.isInstancedMesh ? t.material = e[1] : t.material = e[0], ++this.meshCount;
            }
        };
    }
    setMaterial(n1) {
        if (this.disposeMaterials(), this.material = n1, n1 !== null) {
            let t = this.materials = [
                n1.clone(),
                n1.clone(),
                n1.clone()
            ];
            for (let e of t)e.uniforms = Object.assign({}, n1.uniforms), e.side = Hn;
            t[2].skinning = !0, this.materialsBackSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.side = pi, r;
            }), this.materialsDoubleSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.side = fi, r;
            }), this.materialsFlatShaded = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r;
            }), this.materialsFlatShadedBackSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r.side = pi, r;
            }), this.materialsFlatShadedDoubleSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r.side = fi, r;
            });
        }
    }
    render(n1, t, e) {
        let r = n1.shadowMap.enabled;
        if (n1.shadowMap.enabled = !1, HE) {
            let i = this.originalMaterials;
            this.meshCount = 0, t.traverse(this.replaceMaterial), n1.render(t, e);
            for (let s of i)s[0].material = s[1];
            this.meshCount !== i.size && i.clear();
        } else {
            let i = t.overrideMaterial;
            t.overrideMaterial = this.material, n1.render(t, e), t.overrideMaterial = i;
        }
        n1.shadowMap.enabled = r;
    }
    disposeMaterials() {
        if (this.material !== null) {
            let n1 = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
            for (let t of n1)t.dispose();
        }
    }
    dispose() {
        this.originalMaterials.clear(), this.disposeMaterials();
    }
    static get workaroundEnabled() {
        return HE;
    }
    static set workaroundEnabled(n1) {
        HE = n1;
    }
}, VK = class extends xi {
    constructor(n1, t, e = null){
        super("RenderPass", n1, t), this.needsSwap = !1, this.clearPass = new KE, this.overrideMaterialManager = e === null ? null : new R3(e), this.ignoreBackground = !1, this.skipShadowMapUpdate = !1, this.selection = null;
    }
    get renderToScreen() {
        return super.renderToScreen;
    }
    set renderToScreen(n1) {
        super.renderToScreen = n1, this.clearPass.renderToScreen = n1;
    }
    get overrideMaterial() {
        let n1 = this.overrideMaterialManager;
        return n1 !== null ? n1.material : null;
    }
    set overrideMaterial(n1) {
        let t = this.overrideMaterialManager;
        n1 !== null ? t !== null ? t.setMaterial(n1) : this.overrideMaterialManager = new R3(n1) : t !== null && (t.dispose(), this.overrideMaterialManager = null);
    }
    getOverrideMaterial() {
        return this.overrideMaterial;
    }
    setOverrideMaterial(n1) {
        this.overrideMaterial = n1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(n1) {
        this.clearPass.enabled = n1;
    }
    getSelection() {
        return this.selection;
    }
    setSelection(n1) {
        this.selection = n1;
    }
    isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    setBackgroundDisabled(n1) {
        this.ignoreBackground = n1;
    }
    isShadowMapDisabled() {
        return this.skipShadowMapUpdate;
    }
    setShadowMapDisabled(n1) {
        this.skipShadowMapUpdate = n1;
    }
    getClearPass() {
        return this.clearPass;
    }
    render(n1, t, e, r, i) {
        let s = this.scene, o = this.camera, a = this.selection, l = o.layers.mask, c = s.background, u = n1.shadowMap.autoUpdate, h = this.renderToScreen ? null : t;
        a !== null && o.layers.set(a.getLayer()), this.skipShadowMapUpdate && (n1.shadowMap.autoUpdate = !1), (this.ignoreBackground || this.clearPass.overrideClearColor !== null) && (s.background = null), this.clearPass.enabled && this.clearPass.render(n1, t), n1.setRenderTarget(h), this.overrideMaterialManager !== null ? this.overrideMaterialManager.render(n1, s, o) : n1.render(s, o), o.layers.mask = l, s.background = c, n1.shadowMap.autoUpdate = u;
    }
}, QE = class extends xi {
    constructor(n1, t, { resolutionScale: e = 1, width: r = Vn.AUTO_SIZE, height: i = Vn.AUTO_SIZE, renderTarget: s } = {}){
        super("DepthPass"), this.needsSwap = !1, this.renderPass = new VK(n1, t, new pp({
            depthPacking: Vw
        }));
        let o = this.renderPass;
        o.skipShadowMapUpdate = !0, o.ignoreBackground = !0;
        let a = o.getClearPass();
        a.overrideClearColor = new We(16777215), a.overrideClearAlpha = 1, this.renderTarget = s, this.renderTarget === void 0 && (this.renderTarget = new dt(1, 1, {
            minFilter: Vt,
            magFilter: Vt,
            stencilBuffer: !1
        }), this.renderTarget.texture.name = "DepthPass.Target");
        let l = this.resolution = new Vn(this, r, i, e);
        l.addEventListener("change", (c)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    render(n1, t, e, r, i) {
        let s = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(n1, s);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height);
    }
};
var ZDe = new Float32Array([
    255 / 256 / 256 ** 3,
    255 / 256 / 65536,
    255 / 256 / 256,
    255 / 256
]);
var Pt = {
    SKIP: 0,
    ADD: 1,
    ALPHA: 2,
    AVERAGE: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    EXCLUSION: 8,
    LIGHTEN: 9,
    MULTIPLY: 10,
    DIVIDE: 11,
    NEGATION: 12,
    NORMAL: 13,
    OVERLAY: 14,
    REFLECT: 15,
    SCREEN: 16,
    SOFT_LIGHT: 17,
    SUBTRACT: 18
}, kK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x+y,1.0)*opacity+x*(1.0-opacity);}", UK = "vec3 blend(const in vec3 x,const in vec3 y,const in float opacity){return y*opacity+x*(1.0-opacity);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){float a=min(y.a,opacity);return vec4(blend(x.rgb,y.rgb,a),max(x.a,a));}", zK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y)*0.5*opacity+x*(1.0-opacity);}", GK = "float blend(const in float x,const in float y){return(y==0.0)?y:max(1.0-(1.0-x)/y,0.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", jK = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", HK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x,y)*opacity+x*(1.0-opacity);}", WK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return abs(x-y)*opacity+x*(1.0-opacity);}", qK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y-2.0*x*y)*opacity+x*(1.0-opacity);}", YK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x,y)*opacity+x*(1.0-opacity);}", XK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return x*y*opacity+x*(1.0-opacity);}", KK = "float blend(const in float x,const in float y){return(y>0.0)?min(x/y,1.0):1.0;}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", QK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-abs(1.0-x-y))*opacity+x*(1.0-opacity);}", ZK = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y*opacity+x*(1.0-opacity);}", JK = "float blend(const in float x,const in float y){return(x<0.5)?(2.0*x*y):(1.0-2.0*(1.0-x)*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", $K = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x*x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", eQ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-(1.0-x)*(1.0-y))*opacity+x*(1.0-opacity);}", tQ = "float blend(const in float x,const in float y){return(y<0.5)?(2.0*x*y+x*x*(1.0-2.0*y)):(sqrt(x)*(2.0*y-1.0)+2.0*x*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", rQ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x+y-1.0,0.0)*opacity+x*(1.0-opacity);}", iQ = new Map([
    [
        Pt.SKIP,
        null
    ],
    [
        Pt.ADD,
        kK
    ],
    [
        Pt.ALPHA,
        UK
    ],
    [
        Pt.AVERAGE,
        zK
    ],
    [
        Pt.COLOR_BURN,
        GK
    ],
    [
        Pt.COLOR_DODGE,
        jK
    ],
    [
        Pt.DARKEN,
        HK
    ],
    [
        Pt.DIFFERENCE,
        WK
    ],
    [
        Pt.EXCLUSION,
        qK
    ],
    [
        Pt.LIGHTEN,
        YK
    ],
    [
        Pt.MULTIPLY,
        XK
    ],
    [
        Pt.DIVIDE,
        KK
    ],
    [
        Pt.NEGATION,
        QK
    ],
    [
        Pt.NORMAL,
        ZK
    ],
    [
        Pt.OVERLAY,
        JK
    ],
    [
        Pt.REFLECT,
        $K
    ],
    [
        Pt.SCREEN,
        eQ
    ],
    [
        Pt.SOFT_LIGHT,
        tQ
    ],
    [
        Pt.SUBTRACT,
        rQ
    ]
]), nQ = class extends pr {
    constructor(n1, t = 1){
        super(), this.f = n1, this.opacity = new le(t);
    }
    getOpacity() {
        return this.opacity.value;
    }
    setOpacity(n1) {
        this.opacity.value = n1;
    }
    get blendFunction() {
        return this.f;
    }
    set blendFunction(n1) {
        this.f = n1, this.dispatchEvent({
            type: "change"
        });
    }
    getBlendFunction() {
        return this.blendFunction;
    }
    setBlendFunction(n1) {
        this.blendFunction = n1;
    }
    getShaderCode() {
        return iQ.get(this.blendFunction);
    }
}, Go = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2
};
var jo = class extends pr {
    constructor(n1, t, { attributes: e = Go.NONE, blendFunction: r = Pt.SCREEN, defines: i = new Map, uniforms: s = new Map, extensions: o = null, vertexShader: a = null } = {}){
        super(), this.name = n1, this.renderer = null, this.attributes = e, this.fragmentShader = t, this.vertexShader = a, this.defines = i, this.uniforms = s, this.extensions = o, this.blendMode = new nQ(r), this.blendMode.addEventListener("change", (l)=>this.setChanged());
    }
    getName() {
        return this.name;
    }
    setRenderer(n1) {
        this.renderer = n1;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getExtensions() {
        return this.extensions;
    }
    getBlendMode() {
        return this.blendMode;
    }
    getAttributes() {
        return this.attributes;
    }
    setAttributes(n1) {
        this.attributes = n1, this.setChanged();
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    setFragmentShader(n1) {
        this.fragmentShader = n1, this.setChanged();
    }
    getVertexShader() {
        return this.vertexShader;
    }
    setVertexShader(n1) {
        this.vertexShader = n1, this.setChanged();
    }
    setChanged() {
        this.dispatchEvent({
            type: "change"
        });
    }
    setDepthTexture(n1, t = Bi) {}
    update(n1, t, e) {}
    setSize(n1, t) {}
    initialize(n1, t, e) {}
    dispose() {
        for (let n1 of Object.keys(this)){
            let t = this[n1];
            if (t !== null && typeof t == "object" && typeof t.dispose == "function") {
                if (t instanceof ei || t === this.renderer) continue;
                this[n1].dispose();
            }
        }
    }
};
function L3(n1, t, e) {
    for (let r of t){
        let i = "$1" + n1 + r.charAt(0).toUpperCase() + r.slice(1), s = new RegExp("([^\\.])(\\b" + r + "\\b)", "g");
        for (let o of e.entries())o[1] !== null && e.set(o[0], o[1].replace(s, i));
    }
}
function sQ(n1, t, e, r, i, s, o) {
    let a = new Map([
        [
            "fragment",
            t.getFragmentShader()
        ],
        [
            "vertex",
            t.getVertexShader()
        ]
    ]), l = a.get("fragment") !== void 0 && /mainImage/.test(a.get("fragment")), c = a.get("fragment") !== void 0 && /mainUv/.test(a.get("fragment")), u = [], h = [], d = !1, f = !1;
    if (a.get("fragment") === void 0) console.error("Missing fragment shader", t);
    else if (c && (o & Go.CONVOLUTION) !== 0) console.error("Effects that transform UV coordinates are incompatible with convolution effects", t);
    else if (!l && !c) console.error("The fragment shader contains neither a mainImage nor a mainUv function", t);
    else {
        let p = /(?:\w+\s+(\w+)\([\w\s,]*\)\s*{[^}]+})/g, m = XE.Section;
        if (c) {
            let y = `	${n1}MainUv(UV);
`;
            e.set(m.FRAGMENT_MAIN_UV, e.get(m.FRAGMENT_MAIN_UV) + y), d = !0;
        }
        if (a.get("vertex") !== null && /mainSupport/.test(a.get("vertex"))) {
            let y = `	${n1}MainSupport(`;
            y += /mainSupport *\([\w\s]*?uv\s*?\)/.test(a.get("vertex")) ? `vUv);
` : `);
`, e.set(m.VERTEX_MAIN_SUPPORT, e.get(m.VERTEX_MAIN_SUPPORT) + y), u = u.concat([
                ...a.get("vertex").matchAll(/(?:varying\s+\w+\s+(\w*))/g)
            ].map((x)=>x[1])), h = h.concat(u).concat([
                ...a.get("vertex").matchAll(p)
            ].map((x)=>x[1]));
        }
        h = h.concat([
            ...a.get("fragment").matchAll(p)
        ].map((y)=>y[1])), h = h.concat([
            ...t.defines.keys()
        ].map((y)=>y.replace(/\([\w\s,]*\)/g, ""))), h = h.concat([
            ...t.uniforms.keys()
        ]), t.uniforms.forEach((y, x)=>s.set(n1 + x.charAt(0).toUpperCase() + x.slice(1), y)), t.defines.forEach((y, x)=>i.set(n1 + x.charAt(0).toUpperCase() + x.slice(1), y)), L3(n1, h, i), L3(n1, h, a);
        let g = t.blendMode;
        if (r.set(g.blendFunction, g), l) {
            let y = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/, x = `${n1}MainImage(color0, UV, `;
            (o & Go.DEPTH) !== 0 && y.test(a.get("fragment")) && (x += "depth, ", f = !0), x += `color1);
	`;
            let v = n1 + "BlendOpacity";
            s.set(v, g.opacity), x += `color0 = blend${g.blendFunction}(color0, color1, ${v});

	`, e.set(m.FRAGMENT_MAIN_IMAGE, e.get(m.FRAGMENT_MAIN_IMAGE) + x), x = `uniform float ${v};

`, e.set(m.FRAGMENT_HEAD, e.get(m.FRAGMENT_HEAD) + x);
        }
        e.set(m.FRAGMENT_HEAD, e.get(m.FRAGMENT_HEAD) + a.get("fragment") + `
`), a.get("vertex") !== null && e.set(m.VERTEX_HEAD, e.get(m.VERTEX_HEAD) + a.get("vertex") + `
`);
    }
    return {
        varyings: u,
        transformedUv: d,
        readDepth: f
    };
}
var $c = class extends xi {
    constructor(n1, ...t){
        super("EffectPass"), this.fullscreenMaterial = new XE(null, null, null, n1), this.effects = t.sort((e, r)=>r.attributes - e.attributes), this.skipRendering = !1, this.uniformCount = 0, this.varyingCount = 0, this.minTime = 1, this.maxTime = Number.POSITIVE_INFINITY;
    }
    get encodeOutput() {
        return this.fullscreenMaterial.encodeOutput;
    }
    set encodeOutput(n1) {
        this.fullscreenMaterial.encodeOutput = n1;
    }
    get dithering() {
        return this.fullscreenMaterial.dithering;
    }
    set dithering(n1) {
        let t = this.fullscreenMaterial;
        t.dithering = n1, t.needsUpdate = !0;
    }
    verifyResources() {
        let n1 = this.renderer.capabilities, t = Math.min(n1.maxFragmentUniforms, n1.maxVertexUniforms);
        this.uniformCount > t && console.warn("The current rendering context doesn't support more than " + t + " uniforms, but " + this.uniformCount + " were defined"), t = n1.maxVaryings, this.varyingCount > t && console.warn("The current rendering context doesn't support more than " + t + " varyings, but " + this.varyingCount + " were defined");
    }
    updateMaterial() {
        let n1 = XE.Section, t = new Map([
            [
                n1.FRAGMENT_HEAD,
                ""
            ],
            [
                n1.FRAGMENT_MAIN_UV,
                ""
            ],
            [
                n1.FRAGMENT_MAIN_IMAGE,
                ""
            ],
            [
                n1.VERTEX_HEAD,
                ""
            ],
            [
                n1.VERTEX_MAIN_SUPPORT,
                ""
            ]
        ]), e = new Map, r = new Map, i = new Map, s = new Set, o = 0, a = 0, l = 0, c = !1, u = !1;
        for (let d of this.effects)if (d.blendMode.blendFunction === Pt.SKIP) l |= d.getAttributes() & Go.DEPTH;
        else if ((l & d.getAttributes() & Go.CONVOLUTION) !== 0) console.error("Convolution effects cannot be merged", d);
        else {
            l |= d.getAttributes();
            let f = "e" + o++, p = sQ(f, d, t, e, r, i, l);
            if (a += p.varyings.length, c = c || p.transformedUv, u = u || p.readDepth, d.extensions !== null) for (let m of d.extensions)s.add(m);
        }
        let h = /\bblend\b/g;
        for (let d of e.values()){
            let f = d.getShaderCode().replace(h, `blend${d.blendFunction}`);
            t.set(n1.FRAGMENT_HEAD, t.get(n1.FRAGMENT_HEAD) + f + `
`);
        }
        if ((l & Go.DEPTH) !== 0) {
            if (u) {
                let d = `float depth = readDepth(UV);

	`;
                t.set(n1.FRAGMENT_MAIN_IMAGE, d + t.get(n1.FRAGMENT_MAIN_IMAGE));
            }
            this.needsDepthTexture = this.getDepthTexture() === null;
        } else this.needsDepthTexture = !1;
        if (c) {
            let d = `vec2 transformedUv = vUv;
`;
            t.set(n1.FRAGMENT_MAIN_UV, d + t.get(n1.FRAGMENT_MAIN_UV)), r.set("UV", "transformedUv");
        } else r.set("UV", "vUv");
        t.forEach((d, f, p)=>p.set(f, d.trim().replace(/^#/, `
#`))), this.uniformCount = i.size, this.varyingCount = a, this.skipRendering = o === 0, this.needsSwap = !this.skipRendering, this.fullscreenMaterial.setShaderParts(t).setExtensions(s).setUniforms(i).setDefines(r);
    }
    recompile() {
        this.updateMaterial(), this.verifyResources();
    }
    getDepthTexture() {
        return this.fullscreenMaterial.depthBuffer;
    }
    setDepthTexture(n1, t = Bi) {
        this.fullscreenMaterial.depthBuffer = n1, this.fullscreenMaterial.depthPacking = t;
        for (let e of this.effects)e.setDepthTexture(n1, t);
    }
    render(n1, t, e, r, i) {
        for (let s of this.effects)s.update(n1, t, r);
        if (!this.skipRendering || this.renderToScreen) {
            let s = this.fullscreenMaterial;
            s.inputBuffer = t.texture, s.time += r, n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(this.scene, this.camera);
        }
    }
    setSize(n1, t) {
        this.fullscreenMaterial.setSize(n1, t);
        for (let e of this.effects)e.setSize(n1, t);
    }
    initialize(n1, t, e) {
        this.renderer = n1;
        for (let r of this.effects)r.initialize(n1, t, e), r.addEventListener("change", (i)=>this.handleEvent(i));
        this.updateMaterial(), this.verifyResources(), e !== void 0 && e !== _r && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
    dispose() {
        super.dispose();
        for (let n1 of this.effects)n1.dispose();
    }
    handleEvent(n1) {
        switch(n1.type){
            case "change":
                this.recompile();
                break;
        }
    }
}, oQ = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0,
        1,
        1
    ]),
    new Float32Array([
        0,
        1,
        1,
        2
    ]),
    new Float32Array([
        0,
        1,
        2,
        2,
        3
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        4,
        5
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        5,
        7,
        8,
        9,
        10
    ])
], Mx = class extends xi {
    constructor({ resolutionScale: n1 = .5, width: t = Vn.AUTO_SIZE, height: e = Vn.AUTO_SIZE, kernelSize: r = km.LARGE } = {}){
        super("KawaseBlurPass"), this.renderTargetA = new dt(1, 1, {
            minFilter: rt,
            magFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetA.texture.name = "Blur.Target.A", this.renderTargetB = this.renderTargetA.clone(), this.renderTargetB.texture.name = "Blur.Target.B";
        let i = this.resolution = new Vn(this, t, e, n1);
        i.addEventListener("change", (s)=>this.setSize(i.baseWidth, i.baseHeight)), this.blurMaterial = new O3, this.ditheredBlurMaterial = new O3, this.ditheredBlurMaterial.uniforms.scale = this.blurMaterial.uniforms.scale, this.ditheredBlurMaterial.dithering = !0, this.dithering = !1, this.kernelSize = r;
    }
    getResolution() {
        return this.resolution;
    }
    get width() {
        return this.resolution.width;
    }
    set width(n1) {
        this.resolution.preferredWidth = n1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(n1) {
        this.resolution.preferredHeight = n1;
    }
    get scale() {
        return this.blurMaterial.scale;
    }
    set scale(n1) {
        this.blurMaterial.scale = n1;
    }
    getScale() {
        return this.blurMaterial.scale;
    }
    setScale(n1) {
        this.blurMaterial.scale = n1;
    }
    getKernelSize() {
        return this.kernelSize;
    }
    setKernelSize(n1) {
        this.kernelSize = n1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    render(n1, t, e, r, i) {
        let s = this.scene, o = this.camera, a = this.renderTargetA, l = this.renderTargetB, c = oQ[this.kernelSize], u = this.blurMaterial, h = t, d, f;
        for(this.fullscreenMaterial = u, d = 0, f = c.length - 1; d < f; ++d){
            let p = (d & 1) === 0 ? a : l;
            u.kernel = c[d], u.inputBuffer = h.texture, n1.setRenderTarget(p), n1.render(s, o), h = p;
        }
        this.dithering && (u = this.ditheredBlurMaterial, this.fullscreenMaterial = u), u.kernel = c[d], u.inputBuffer = h.texture, n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(s, o);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t);
        let r = e.width, i = e.height;
        this.renderTargetA.setSize(r, i), this.renderTargetB.setSize(r, i), this.blurMaterial.setSize(r, i), this.ditheredBlurMaterial.setSize(r, i);
    }
    initialize(n1, t, e) {
        e !== void 0 && (this.renderTargetA.texture.type = e, this.renderTargetB.texture.type = e, e !== _r ? (this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1", this.ditheredBlurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1") : n1.outputEncoding === at && (this.renderTargetA.texture.encoding = at, this.renderTargetB.texture.encoding = at));
    }
    static get AUTO_SIZE() {
        return Vn.AUTO_SIZE;
    }
};
var aQ = class extends xi {
    constructor({ width: n1 = Vn.AUTO_SIZE, height: t = Vn.AUTO_SIZE, renderTarget: e, luminanceRange: r, colorOutput: i } = {}){
        super("LuminancePass"), this.fullscreenMaterial = new IK(i, r), this.needsSwap = !1, this.renderTarget = e, this.renderTarget === void 0 && (this.renderTarget = new dt(1, 1, {
            minFilter: rt,
            magFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "LuminancePass.Target", this.renderTarget.texture.generateMipmaps = !1);
        let s = this.resolution = new Vn(this, n1, t);
        s.addEventListener("change", (o)=>this.setSize(s.baseWidth, s.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    render(n1, t, e, r, i) {
        let s = this.fullscreenMaterial;
        s.inputBuffer = t.texture, n1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), n1.render(this.scene, this.camera);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height);
    }
    initialize(n1, t, e) {
        e !== void 0 && e !== _r && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, U3 = class extends xi {
    constructor(n1, t){
        super("MaskPass", n1, t), this.needsSwap = !1, this.clearPass = new KE(!1, !1, !0), this.inverse = !1;
    }
    get inverted() {
        return this.inverse;
    }
    set inverted(n1) {
        this.inverse = n1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(n1) {
        this.clearPass.enabled = n1;
    }
    getClearPass() {
        return this.clearPass;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(n1) {
        this.inverted = n1;
    }
    render(n1, t, e, r, i) {
        let s = n1.getContext(), o = n1.state.buffers, a = this.scene, l = this.camera, c = this.clearPass, u = this.inverted ? 0 : 1, h = 1 - u;
        o.color.setMask(!1), o.depth.setMask(!1), o.color.setLocked(!0), o.depth.setLocked(!0), o.stencil.setTest(!0), o.stencil.setOp(s.REPLACE, s.REPLACE, s.REPLACE), o.stencil.setFunc(s.ALWAYS, u, 4294967295), o.stencil.setClear(h), o.stencil.setLocked(!0), this.clearPass.enabled && (this.renderToScreen ? c.render(n1, null) : (c.render(n1, t), c.render(n1, e))), this.renderToScreen ? (n1.setRenderTarget(null), n1.render(a, l)) : (n1.setRenderTarget(t), n1.render(a, l), n1.setRenderTarget(e), n1.render(a, l)), o.color.setLocked(!1), o.depth.setLocked(!1), o.stencil.setLocked(!1), o.stencil.setFunc(s.EQUAL, 1, 4294967295), o.stencil.setOp(s.KEEP, s.KEEP, s.KEEP), o.stencil.setLocked(!0);
    }
};
var hn = class extends xi {
    constructor(n1, t = "inputBuffer"){
        super("ShaderPass"), this.fullscreenMaterial = n1, this.inputBufferUniform = null, this.setInput(t);
    }
    setInput(n1) {
        if (this.inputBufferUniform = null, this.fullscreenMaterial !== null) {
            let t = this.fullscreenMaterial.uniforms;
            t !== void 0 && t[n1] !== void 0 && (this.inputBufferUniform = t[n1]);
        }
    }
    render(n1, t, e, r, i) {
        this.inputBufferUniform !== null && t !== null && (this.inputBufferUniform.value = t.texture), n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(this.scene, this.camera);
    }
    initialize(n1, t, e) {
        e !== void 0 && e !== _r && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, WE = 0.001, lQ = 1e3, z3 = class {
    constructor(){
        this.previousTime = 0, this.currentTime = 0, this.delta = 0, this.fixedDelta = 1e3 / 60, this.elapsed = 0, this.timescale = 1, this.fixedDeltaEnabled = !1, this.autoReset = !1;
    }
    setFixedDeltaEnabled(n1) {
        return this.fixedDeltaEnabled = n1, this;
    }
    isAutoResetEnabled(n1) {
        return this.autoReset;
    }
    setAutoResetEnabled(n1) {
        return typeof document < "u" && document.hidden !== void 0 && (n1 ? document.addEventListener("visibilitychange", this) : document.removeEventListener("visibilitychange", this), this.autoReset = n1), this;
    }
    getDelta() {
        return this.delta * WE;
    }
    getFixedDelta() {
        return this.fixedDelta * WE;
    }
    setFixedDelta(n1) {
        return this.fixedDelta = n1 * lQ, this;
    }
    getElapsed() {
        return this.elapsed * WE;
    }
    getTimescale() {
        return this.timescale;
    }
    setTimescale(n1) {
        return this.timescale = n1, this;
    }
    update(n1) {
        return this.fixedDeltaEnabled ? this.delta = this.fixedDelta : (this.previousTime = this.currentTime, this.currentTime = n1 !== void 0 ? n1 : performance.now(), this.delta = this.currentTime - this.previousTime), this.delta *= this.timescale, this.elapsed += this.delta, this;
    }
    reset() {
        return this.delta = 0, this.elapsed = 0, this.currentTime = performance.now(), this;
    }
    handleEvent(n1) {
        document.hidden || (this.currentTime = performance.now());
    }
    dispose() {
        this.setAutoResetEnabled(!1);
    }
};
var km = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5
};
var cQ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=clamp(texture2D(map,uv)*intensity,0.0,1.0);}`, G3 = class extends jo {
    constructor({ blendFunction: n1 = Pt.SCREEN, luminanceThreshold: t = .9, luminanceSmoothing: e = .025, resolutionScale: r = .5, intensity: i = 1, width: s = Vn.AUTO_SIZE, height: o = Vn.AUTO_SIZE, kernelSize: a = km.LARGE } = {}){
        super("BloomEffect", cQ, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "map",
                    new le(null)
                ],
                [
                    "intensity",
                    new le(i)
                ]
            ])
        }), this.renderTarget = new dt(1, 1, {
            minFilter: rt,
            magFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "Bloom.Target", this.renderTarget.texture.generateMipmaps = !1, this.uniforms.get("map").value = this.renderTarget.texture, this.luminancePass = new aQ({
            renderTarget: this.renderTarget,
            colorOutput: !0
        }), this.luminanceMaterial.threshold = t, this.luminanceMaterial.smoothingFactor = e, this.blurPass = new Mx({
            resolutionScale: r,
            width: s,
            height: o,
            kernelSize: a
        });
        let l = this.blurPass.getResolution();
        l.addEventListener("change", (c)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    get resolution() {
        return this.blurPass.resolution;
    }
    getResolution() {
        return this.blurPass.resolution;
    }
    getBlurPass() {
        return this.blurPass;
    }
    getLuminancePass() {
        return this.luminancePass;
    }
    get luminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    getLuminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    get width() {
        return this.resolution.width;
    }
    set width(n1) {
        this.resolution.preferredWidth = n1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(n1) {
        this.resolution.preferredHeight = n1;
    }
    get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(n1) {
        this.blurPass.dithering = n1;
    }
    get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(n1) {
        this.blurPass.kernelSize = n1;
    }
    get distinction() {
        return console.warn(this.name, "distinction was removed"), 1;
    }
    set distinction(n1) {
        console.warn(this.name, "distinction was removed");
    }
    get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(n1) {
        this.uniforms.get("intensity").value = n1;
    }
    getIntensity() {
        return this.intensity;
    }
    setIntensity(n1) {
        this.intensity = n1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    update(n1, t, e) {
        let r = this.renderTarget;
        this.luminancePass.enabled ? (this.luminancePass.render(n1, t, r), this.blurPass.render(n1, r, r)) : this.blurPass.render(n1, t, r);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height), this.luminancePass.resolution.copy(e);
    }
    initialize(n1, t, e) {
        this.blurPass.initialize(n1, t, e), e !== void 0 && (this.renderTarget.texture.type = e, n1.outputEncoding === at && (this.renderTarget.texture.encoding = at));
    }
};
var uQ = "uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(min(color+vec3(0.5),1.0),inputColor.a);}", j3 = class extends jo {
    constructor({ blendFunction: n1 = Pt.NORMAL, brightness: t = 0, contrast: e = 0 } = {}){
        super("BrightnessContrastEffect", uQ, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "brightness",
                    new le(t)
                ],
                [
                    "contrast",
                    new le(e)
                ]
            ])
        });
    }
    get brightness() {
        return this.uniforms.get("brightness").value;
    }
    set brightness(n1) {
        this.uniforms.get("brightness").value = n1;
    }
    getBrightness(n1) {
        return this.brightness;
    }
    setBrightness(n1) {
        this.brightness = n1;
    }
    get contrast() {
        return this.uniforms.get("contrast").value;
    }
    set contrast(n1) {
        this.uniforms.get("contrast").value = n1;
    }
    getContrast(n1) {
        return this.contrast;
    }
    setContrast(n1) {
        this.contrast = n1;
    }
}, hQ = "void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(vec3(average(inputColor.rgb)),inputColor.a);}", H3 = class extends jo {
    constructor(n1 = Pt.NORMAL){
        super("ColorAverageEffect", hQ, {
            blendFunction: n1
        });
    }
};
var dQ = "varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=texture2D(inputBuffer,vUvR).ra;vec2 ba=texture2D(inputBuffer,vUvB).ba;outputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}", fQ = "uniform vec2 offset;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vUvR=uv+shift;vUvB=uv-shift;}", W3 = class extends jo {
    constructor({ blendFunction: n1 = Pt.NORMAL, offset: t = new k(.001, 5e-4) } = {}){
        super("ChromaticAberrationEffect", dQ, {
            vertexShader: fQ,
            blendFunction: n1,
            attributes: Go.CONVOLUTION,
            uniforms: new Map([
                [
                    "offset",
                    new le(t)
                ]
            ])
        });
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(n1) {
        this.uniforms.get("offset").value = n1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(n1) {
        this.offset = n1;
    }
};
var pQ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D nearColorBuffer;uniform mediump sampler2D farColorBuffer;
#else
uniform lowp sampler2D nearColorBuffer;uniform lowp sampler2D farColorBuffer;
#endif
uniform lowp sampler2D nearCoCBuffer;uniform float scale;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec4 colorNear=texture2D(nearColorBuffer,uv);vec4 colorFar=texture2D(farColorBuffer,uv);float CoCNear=texture2D(nearCoCBuffer,uv).r;CoCNear=min(CoCNear*scale,1.0);vec4 result=inputColor*(1.0-colorFar.a)+colorFar;result=mix(result,colorNear,CoCNear);outputColor=result;}`, q3 = class extends jo {
    constructor(n1, { blendFunction: t = Pt.NORMAL, worldFocusDistance: e, worldFocusRange: r, focusDistance: i = 0, focalLength: s = .1, focusRange: o = s, bokehScale: a = 1, width: l = Vn.AUTO_SIZE, height: c = Vn.AUTO_SIZE } = {}){
        super("DepthOfFieldEffect", pQ, {
            blendFunction: t,
            attributes: Go.DEPTH,
            uniforms: new Map([
                [
                    "nearColorBuffer",
                    new le(null)
                ],
                [
                    "farColorBuffer",
                    new le(null)
                ],
                [
                    "nearCoCBuffer",
                    new le(null)
                ],
                [
                    "scale",
                    new le(1)
                ]
            ])
        }), this.camera = n1, this.renderTarget = new dt(1, 1, {
            minFilter: rt,
            magFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "DoF.Intermediate", this.renderTarget.texture.generateMipmaps = !1, this.renderTargetMasked = this.renderTarget.clone(), this.renderTargetMasked.texture.name = "DoF.Masked.Far", this.renderTargetNear = this.renderTarget.clone(), this.renderTargetNear.texture.name = "DoF.Bokeh.Near", this.uniforms.get("nearColorBuffer").value = this.renderTargetNear.texture, this.renderTargetFar = this.renderTarget.clone(), this.renderTargetFar.texture.name = "DoF.Bokeh.Far", this.uniforms.get("farColorBuffer").value = this.renderTargetFar.texture, this.renderTargetCoC = this.renderTarget.clone(), this.renderTargetCoC.texture.name = "DoF.CoC", this.renderTargetCoCBlurred = this.renderTargetCoC.clone(), this.renderTargetCoCBlurred.texture.name = "DoF.CoC.Blurred", this.uniforms.get("nearCoCBuffer").value = this.renderTargetCoCBlurred.texture, this.cocPass = new hn(new vK(n1));
        let u = this.cocMaterial;
        u.focusDistance = i, u.focusRange = o, e !== void 0 && (u.worldFocusDistance = e), r !== void 0 && (u.worldFocusRange = r), this.blurPass = new Mx({
            kernelSize: km.MEDIUM,
            width: l,
            height: c
        });
        let h = this.blurPass.getResolution();
        h.addEventListener("change", (f)=>this.setSize(h.getBaseWidth(), h.getBaseHeight())), this.maskPass = new hn(new OK(this.renderTargetCoC.texture));
        let d = this.maskPass.fullscreenMaterial;
        d.maskFunction = V3.MULTIPLY, d.colorChannel = F3.GREEN, this.bokehNearBasePass = new hn(new Ex(!1, !0)), this.bokehNearBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehNearFillPass = new hn(new Ex(!0, !0)), this.bokehNearFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehFarBasePass = new hn(new Ex(!1, !1)), this.bokehFarBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.bokehFarFillPass = new hn(new Ex(!0, !1)), this.bokehFarFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.target = null, this.bokehScale = a;
    }
    get cocTexture() {
        return this.renderTargetCoC.texture;
    }
    get cocMaterial() {
        return this.cocPass.fullscreenMaterial;
    }
    get circleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    getCircleOfConfusionMaterial() {
        return this.circleOfConfusionMaterial;
    }
    getBlurPass() {
        return this.blurPass;
    }
    get resolution() {
        return this.blurPass.getResolution();
    }
    getResolution() {
        return this.blurPass.getResolution();
    }
    get bokehScale() {
        return this.uniforms.get("scale").value;
    }
    set bokehScale(n1) {
        let t = [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        for (let e of t)e.fullscreenMaterial.setScale(n1);
        this.maskPass.fullscreenMaterial.setStrength(n1), this.uniforms.get("scale").value = n1;
    }
    getBokehScale() {
        return this.bokehScale;
    }
    setBokehScale(n1) {
        this.bokehScale = n1;
    }
    getTarget() {
        return this.target;
    }
    setTarget(n1) {
        this.target = n1;
    }
    calculateFocusDistance(n1) {
        let t = this.camera, e = t.position.distanceTo(n1);
        return YE(-e, t.near, t.far);
    }
    setDepthTexture(n1, t = Bi) {
        this.circleOfConfusionMaterial.depthBuffer = n1, this.circleOfConfusionMaterial.depthPacking = t;
    }
    update(n1, t, e) {
        let r = this.renderTarget, i = this.renderTargetCoC, s = this.renderTargetCoCBlurred, o = this.renderTargetMasked;
        if (this.target !== null) {
            let a = this.calculateFocusDistance(this.target);
            this.circleOfConfusionMaterial.focusDistance = a;
        }
        this.cocPass.render(n1, null, i), this.blurPass.render(n1, i, s), this.maskPass.render(n1, t, o), this.bokehFarBasePass.render(n1, o, r), this.bokehFarFillPass.render(n1, r, this.renderTargetFar), this.bokehNearBasePass.render(n1, t, r), this.bokehNearFillPass.render(n1, r, this.renderTargetNear);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t);
        let r = e.width, i = e.height, s = [
            this.cocPass,
            this.blurPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        s.push(this.renderTargetCoC, this.renderTargetMasked), s.forEach((a)=>a.setSize(n1, t)), s = [
            this.renderTarget,
            this.renderTargetNear,
            this.renderTargetFar,
            this.renderTargetCoCBlurred
        ], s.forEach((a)=>a.setSize(r, i)), [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((a)=>a.fullscreenMaterial.setSize(r, i));
    }
    initialize(n1, t, e) {
        [
            this.cocPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((i)=>i.initialize(n1, t, e)), this.blurPass.initialize(n1, t, _r), e !== void 0 && (this.renderTarget.texture.type = e, this.renderTargetNear.texture.type = e, this.renderTargetFar.texture.type = e, this.renderTargetMasked.texture.type = e, n1.outputEncoding === at && (this.renderTarget.texture.encoding = at, this.renderTargetNear.texture.encoding = at, this.renderTargetFar.texture.encoding = at, this.renderTargetMasked.texture.encoding = at));
    }
};
var cOe = new E, uOe = new ue;
var mQ = "uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}", Y3 = class extends jo {
    constructor({ blendFunction: n1 = Pt.NORMAL, hue: t = 0, saturation: e = 0 } = {}){
        super("HueSaturationEffect", mQ, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "hue",
                    new le(new E)
                ],
                [
                    "saturation",
                    new le(e)
                ]
            ])
        }), this.hue = t;
    }
    get saturation() {
        return this.uniforms.get("saturation").value;
    }
    set saturation(n1) {
        this.uniforms.get("saturation").value = n1;
    }
    getSaturation() {
        return this.saturation;
    }
    setSaturation(n1) {
        this.saturation = n1;
    }
    get hue() {
        let n1 = this.uniforms.get("hue").value;
        return Math.acos((n1.x * 3 - 1) / 2);
    }
    set hue(n1) {
        let t = Math.sin(n1), e = Math.cos(n1);
        this.uniforms.get("hue").value.set((2 * e + 1) / 3, (-Math.sqrt(3) * t - e + 1) / 3, (Math.sqrt(3) * t - e + 1) / 3);
    }
    getHue() {
        return this.hue;
    }
    setHue(n1) {
        this.hue = n1;
    }
};
var fOe = new We;
var gQ = `void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 noise=vec3(rand(uv*time));
#ifdef PREMULTIPLY
outputColor=vec4(min(inputColor.rgb*noise,vec3(1.0)),inputColor.a);
#else
outputColor=vec4(noise,inputColor.a);
#endif
}`, X3 = class extends jo {
    constructor({ blendFunction: n1 = Pt.SCREEN, premultiply: t = !1 } = {}){
        super("NoiseEffect", gQ, {
            blendFunction: n1
        }), this.premultiply = t;
    }
    get premultiply() {
        return this.defines.has("PREMULTIPLY");
    }
    set premultiply(n1) {
        this.premultiply !== n1 && (n1 ? this.defines.set("PREMULTIPLY", "1") : this.defines.delete("PREMULTIPLY"), this.setChanged());
    }
    isPremultiplied() {
        return this.premultiply;
    }
    setPremultiplied(n1) {
        this.premultiply = n1;
    }
};
var yQ = "uniform bool active;uniform vec2 d;void mainUv(inout vec2 uv){if(active){uv=vec2(d.x*(floor(uv.x/d.x)+0.5),d.y*(floor(uv.y/d.y)+0.5));}}", K3 = class extends jo {
    constructor(n1 = 30){
        super("PixelationEffect", yQ, {
            uniforms: new Map([
                [
                    "active",
                    new le(!1)
                ],
                [
                    "d",
                    new le(new k)
                ]
            ])
        }), this.resolution = new k, this.d = 0, this.granularity = n1;
    }
    get granularity() {
        return this.d;
    }
    set granularity(n1) {
        let t = Math.floor(n1);
        t % 2 > 0 && (t += 1), this.d = t, this.uniforms.get("active").value = t > 0, this.setSize(this.resolution.width, this.resolution.height);
    }
    getGranularity() {
        return this.granularity;
    }
    setGranularity(n1) {
        this.granularity = n1;
    }
    setSize(n1, t) {
        this.resolution.set(n1, t), this.uniforms.get("d").value.setScalar(this.d).divide(this.resolution);
    }
};
var gOe = Math.PI * .5, yOe = new E, vOe = new E;
var B3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC", N3 = "data:image/png;base64,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", vQ = "uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}", xQ = "varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}", Fa = {
    LOW: 0,
    MEDIUM: 1,
    HIGH: 2,
    ULTRA: 3
}, Cx = class extends jo {
    constructor({ preset: n1 = Fa.MEDIUM, edgeDetectionMode: t = uf.COLOR, predicationMode: e = TK.DISABLED } = {}){
        super("SMAAEffect", vQ, {
            vertexShader: xQ,
            blendFunction: Pt.NORMAL,
            attributes: Go.CONVOLUTION | Go.DEPTH,
            uniforms: new Map([
                [
                    "weightMap",
                    new le(null)
                ]
            ])
        });
        let r, i;
        arguments.length > 1 && (r = arguments[0], i = arguments[1], arguments.length > 2 && (n1 = arguments[2]), arguments.length > 3 && (t = arguments[3])), this.renderTargetEdges = new dt(1, 1, {
            minFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetEdges.texture.name = "SMAA.Edges", this.renderTargetWeights = this.renderTargetEdges.clone(), this.renderTargetWeights.texture.name = "SMAA.Weights", this.uniforms.get("weightMap").value = this.renderTargetWeights.texture, this.clearPass = new KE(!0, !1, !1), this.clearPass.overrideClearColor = new We(0), this.clearPass.overrideClearAlpha = 1, this.edgeDetectionPass = new hn(new MK), this.edgeDetectionMaterial.edgeDetectionMode = t, this.edgeDetectionMaterial.predicationMode = e, this.weightsPass = new hn(new BK);
        let s = new Sp;
        s.onLoad = ()=>{
            let o = new er(r);
            o.name = "SMAA.Search", o.magFilter = Vt, o.minFilter = Vt, o.generateMipmaps = !1, o.needsUpdate = !0, o.flipY = !0, this.weightsMaterial.searchTexture = o;
            let a = new er(i);
            a.name = "SMAA.Area", a.magFilter = rt, a.minFilter = rt, a.generateMipmaps = !1, a.needsUpdate = !0, a.flipY = !1, this.weightsMaterial.areaTexture = a, this.dispatchEvent({
                type: "load"
            });
        }, s.itemStart("search"), s.itemStart("area"), r !== void 0 && i !== void 0 ? (s.itemEnd("search"), s.itemEnd("area")) : typeof Image < "u" && (r = new Image, i = new Image, r.addEventListener("load", ()=>s.itemEnd("search")), i.addEventListener("load", ()=>s.itemEnd("area")), r.src = B3, i.src = N3), this.applyPreset(n1);
    }
    get edgesTexture() {
        return this.renderTargetEdges.texture;
    }
    getEdgesTexture() {
        return this.edgesTexture;
    }
    get weightsTexture() {
        return this.renderTargetWeights.texture;
    }
    getWeightsTexture() {
        return this.weightsTexture;
    }
    get edgeDetectionMaterial() {
        return this.edgeDetectionPass.fullscreenMaterial;
    }
    get colorEdgesMaterial() {
        return this.edgeDetectionMaterial;
    }
    getEdgeDetectionMaterial() {
        return this.edgeDetectionMaterial;
    }
    get weightsMaterial() {
        return this.weightsPass.fullscreenMaterial;
    }
    getWeightsMaterial() {
        return this.weightsMaterial;
    }
    setEdgeDetectionThreshold(n1) {
        this.edgeDetectionMaterial.edgeDetectionThreshold = n1;
    }
    setOrthogonalSearchSteps(n1) {
        this.weightsMaterial.orthogonalSearchSteps = n1;
    }
    applyPreset(n1) {
        let t = this.edgeDetectionMaterial, e = this.weightsMaterial;
        switch(n1){
            case Fa.LOW:
                t.edgeDetectionThreshold = .15, e.orthogonalSearchSteps = 4, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case Fa.MEDIUM:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 8, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case Fa.HIGH:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 16, e.diagonalSearchSteps = 8, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
            case Fa.ULTRA:
                t.edgeDetectionThreshold = .05, e.orthogonalSearchSteps = 32, e.diagonalSearchSteps = 16, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
        }
    }
    setDepthTexture(n1, t = Bi) {
        this.edgeDetectionMaterial.depthBuffer = n1, this.edgeDetectionMaterial.depthPacking = t;
    }
    update(n1, t, e) {
        this.clearPass.render(n1, this.renderTargetEdges), this.edgeDetectionPass.render(n1, t, this.renderTargetEdges), this.weightsPass.render(n1, this.renderTargetEdges, this.renderTargetWeights);
    }
    setSize(n1, t) {
        this.edgeDetectionMaterial.setSize(n1, t), this.weightsMaterial.setSize(n1, t), this.renderTargetEdges.setSize(n1, t), this.renderTargetWeights.setSize(n1, t);
    }
    dispose() {
        let { searchTexture: n1, areaTexture: t } = this.weightsMaterial;
        n1 !== null && t !== null && (n1.dispose(), t.dispose()), super.dispose();
    }
    static get searchImageDataURL() {
        return B3;
    }
    static get areaImageDataURL() {
        return N3;
    }
};
var bQ = `uniform float offset;uniform float darkness;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){const vec2 center=vec2(0.5);vec3 color=inputColor.rgb;
#if VIGNETTE_TECHNIQUE == 0
float d=distance(uv,center);color*=smoothstep(0.8,offset*0.799,d*(darkness+offset));
#else
vec2 coord=(uv-center)*vec2(offset);color=mix(color,vec3(1.0-darkness),dot(coord,coord));
#endif
outputColor=vec4(color,inputColor.a);}`, Tx = {
    DEFAULT: 0,
    ESKIL: 1
}, Q3 = class extends jo {
    constructor({ blendFunction: n1 = Pt.NORMAL, technique: t = Tx.DEFAULT, eskil: e = !1, offset: r = .5, darkness: i = .5 } = {}){
        super("VignetteEffect", bQ, {
            blendFunction: n1,
            defines: new Map([
                [
                    "VIGNETTE_TECHNIQUE",
                    t.toFixed(0)
                ]
            ]),
            uniforms: new Map([
                [
                    "offset",
                    new le(r)
                ],
                [
                    "darkness",
                    new le(i)
                ]
            ])
        });
    }
    get technique() {
        return Number(this.defines.get("VIGNETTE_TECHNIQUE"));
    }
    set technique(n1) {
        this.technique !== n1 && (this.defines.set("VIGNETTE_TECHNIQUE", n1.toFixed(0)), this.setChanged());
    }
    get eskil() {
        return this.technique === Tx.ESKIL;
    }
    set eskil(n1) {
        this.technique = n1 ? Tx.ESKIL : Tx.DEFAULT;
    }
    getTechnique() {
        return this.technique;
    }
    setTechnique(n1) {
        this.technique = n1;
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(n1) {
        this.uniforms.get("offset").value = n1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(n1) {
        this.offset = n1;
    }
    get darkness() {
        return this.uniforms.get("darkness").value;
    }
    set darkness(n1) {
        this.uniforms.get("darkness").value = n1;
    }
    getDarkness() {
        return this.darkness;
    }
    setDarkness(n1) {
        this.darkness = n1;
    }
}, SOe = [
    new Float32Array(3),
    new Float32Array(3)
], wOe = [
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3)
], AOe = [
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ]
];
var EOe = [
    new Float32Array(2),
    new Float32Array(2)
];
var TOe = new Float32Array([
    0,
    -0.25,
    .25,
    -0.125,
    .125,
    -0.375,
    .375
]), MOe = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        .25,
        -0.25
    ]),
    new Float32Array([
        -0.25,
        .25
    ]),
    new Float32Array([
        .125,
        -0.125
    ]),
    new Float32Array([
        -0.125,
        .125
    ])
], COe = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        3,
        3
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        4,
        0
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        4,
        3
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        0,
        4
    ]),
    new Uint8Array([
        3,
        4
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        4,
        1
    ]),
    new Uint8Array([
        1,
        4
    ]),
    new Uint8Array([
        4,
        4
    ])
], POe = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        0,
        2
    ]),
    new Uint8Array([
        1,
        2
    ]),
    new Uint8Array([
        2,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        2,
        2
    ]),
    new Uint8Array([
        3,
        2
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        2,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        2,
        3
    ]),
    new Uint8Array([
        3,
        3
    ])
];
var _Oe = new Map([
    [
        un(0, 0, 0, 0),
        new Float32Array([
            0,
            0,
            0,
            0
        ])
    ],
    [
        un(0, 0, 0, 1),
        new Float32Array([
            0,
            0,
            0,
            1
        ])
    ],
    [
        un(0, 0, 1, 0),
        new Float32Array([
            0,
            0,
            1,
            0
        ])
    ],
    [
        un(0, 0, 1, 1),
        new Float32Array([
            0,
            0,
            1,
            1
        ])
    ],
    [
        un(0, 1, 0, 0),
        new Float32Array([
            0,
            1,
            0,
            0
        ])
    ],
    [
        un(0, 1, 0, 1),
        new Float32Array([
            0,
            1,
            0,
            1
        ])
    ],
    [
        un(0, 1, 1, 0),
        new Float32Array([
            0,
            1,
            1,
            0
        ])
    ],
    [
        un(0, 1, 1, 1),
        new Float32Array([
            0,
            1,
            1,
            1
        ])
    ],
    [
        un(1, 0, 0, 0),
        new Float32Array([
            1,
            0,
            0,
            0
        ])
    ],
    [
        un(1, 0, 0, 1),
        new Float32Array([
            1,
            0,
            0,
            1
        ])
    ],
    [
        un(1, 0, 1, 0),
        new Float32Array([
            1,
            0,
            1,
            0
        ])
    ],
    [
        un(1, 0, 1, 1),
        new Float32Array([
            1,
            0,
            1,
            1
        ])
    ],
    [
        un(1, 1, 0, 0),
        new Float32Array([
            1,
            1,
            0,
            0
        ])
    ],
    [
        un(1, 1, 0, 1),
        new Float32Array([
            1,
            1,
            0,
            1
        ])
    ],
    [
        un(1, 1, 1, 0),
        new Float32Array([
            1,
            1,
            1,
            0
        ])
    ],
    [
        un(1, 1, 1, 1),
        new Float32Array([
            1,
            1,
            1,
            1
        ])
    ]
]);
function qE(n1, t, e) {
    return n1 + (t - n1) * e;
}
function un(n1, t, e, r) {
    let i = qE(n1, t, .75), s = qE(e, r, 0.75);
    return qE(i, s, 0.875);
}
var si = class {
    constructor(t, e){
        this.enabled = !1;
        this.effect = new t(e), Object.defineProperty(this, "opacity", {
            enumerable: !0,
            set (r) {
                this.effect.blendMode.opacity.value = r;
            },
            get () {
                return this.effect.blendMode.opacity.value;
            }
        }), Object.defineProperty(this, "blendFunction", {
            enumerable: !0,
            set (r) {
                this.effect.blendMode.setBlendFunction(Number(r));
            },
            get () {
                return this.effect.blendMode.blendFunction;
            }
        }), this.blendFunction = Pt.NORMAL;
    }
};
var hf = class extends si {
    constructor(){
        super(G3), this.blendFunction = Pt.SCREEN;
    }
    set intensity(t) {
        this.effect.intensity = t;
    }
    get intensity() {
        return this.effect.intensity;
    }
    set luminanceThreshold(t) {
        this.effect.luminanceMaterial.threshold = t;
    }
    get luminanceThreshold() {
        return this.effect.luminanceMaterial.threshold;
    }
    set luminanceSmoothing(t) {
        this.effect.luminanceMaterial.smoothing = t;
    }
    get luminanceSmoothing() {
        return this.effect.luminanceMaterial.smoothing;
    }
    set blurScale(t) {
        this.effect.blurPass.scale = t;
    }
    get blurScale() {
        return this.effect.blurPass.scale;
    }
    set kernelSize(t) {
        this.effect.blurPass.kernelSize = t;
    }
    get kernelSize() {
        return this.effect.blurPass.kernelSize;
    }
};
var df = class extends si {
    constructor(){
        super(j3);
    }
    set contrast(t) {
        this.effect.uniforms.get("contrast").value = t;
    }
    get contrast() {
        return this.effect.uniforms.get("contrast").value;
    }
    set brightness(t) {
        this.effect.uniforms.get("brightness").value = t;
    }
    get brightness() {
        return this.effect.uniforms.get("brightness").value;
    }
};
var ff = class extends si {
    constructor(){
        super(W3), this.effect.offset = new k(.01, .01);
    }
    set offset(t) {
        this.effect.offset.set(t[0] / 1e3, t[1] / 1e3);
    }
    get offset() {
        return [
            this.effect.offset.x * 1e3,
            this.effect.offset.y * 1e3
        ];
    }
};
var pf = class extends si {
    constructor(){
        super(H3);
    }
};
var mf = class extends si {
    constructor(){
        super(Y3);
        this._hue = 0;
    }
    set hue(e) {
        this._hue = e, this.effect.setHue(e);
    }
    get hue() {
        return this._hue;
    }
    set saturation(e) {
        this.effect.uniforms.get("saturation").value = e;
    }
    get saturation() {
        return this.effect.uniforms.get("saturation").value;
    }
};
var gf = class extends si {
    constructor(){
        super(X3), this.blendFunction = Pt.OVERLAY;
    }
};
var yf = class extends si {
    constructor(){
        super(Q3);
    }
    get eskil() {
        return this.effect.eskil;
    }
    set eskil(t) {
        this.effect.eskil = t;
    }
    get darkness() {
        return this.effect.uniforms.get("darkness").value;
    }
    set darkness(t) {
        this.effect.uniforms.get("darkness").value = t;
    }
    get offset() {
        return this.effect.uniforms.get("offset").value;
    }
    set offset(t) {
        this.effect.uniforms.get("offset").value = t;
    }
};
var vf = class extends si {
    constructor(e){
        super(q3);
    }
    set focalLength(e) {
        this.effect.circleOfConfusionMaterial.uniforms.focalLength.value = e / 2e3;
    }
    get focalLength() {
        return this.effect.circleOfConfusionMaterial.uniforms.focalLength.value;
    }
    set focusDistance(e) {
        this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value = this.isPerspectiveCamera ? e / 2e3 : (e + 992) / 2e3;
    }
    get focusDistance() {
        return this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value;
    }
    get bokehScale() {
        return this.effect.bokehScale;
    }
    set bokehScale(e) {
        this.effect.bokehScale = e;
    }
    setCamera(e) {
        let r = !1;
        (e.isPerspectiveCamera && this.isPerspectiveCamera === !1 || !e.isPerspectiveCamera && this.isPerspectiveCamera === !0) && (r = !0), e.isPerspectiveCamera ? (this.effect.circleOfConfusionMaterial.adoptCameraSettings(e.perspCamera), this.isPerspectiveCamera = !0) : (this.effect.circleOfConfusionMaterial.adoptCameraSettings(e), this.isPerspectiveCamera = !1), r && this.effect.setChanged();
    }
};
var xf = class extends si {
    constructor(){
        super(K3);
    }
    get granularity() {
        return this.effect.getGranularity();
    }
    set granularity(t) {
        this.effect.setGranularity(t);
    }
};
var Z3 = `#define GLSLIFY 1
varying vec2 vUv;varying vec2 vTexCoords[9];uniform vec2 resolution;void main(){vUv=position.xy*0.5+0.5;vec2 texelSize=vec2(1.0)/resolution;vTexCoords[0]=vUv+vec2(-texelSize.x,-texelSize.y);vTexCoords[1]=vUv+vec2(0.0,-texelSize.y);vTexCoords[2]=vUv+vec2(texelSize.x,-texelSize.y);vTexCoords[3]=vUv+vec2(-texelSize.x,0.0);vTexCoords[4]=vUv+vec2(0.0,0.0);vTexCoords[5]=vUv+vec2(texelSize.x,0.0);vTexCoords[6]=vUv+vec2(-texelSize.x,texelSize.y);vTexCoords[7]=vUv+vec2(0.0,texelSize.y);vTexCoords[8]=vUv+vec2(texelSize.x,texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
var J3 = `#define GLSLIFY 1
#include <common>
varying vec2 vUv;varying vec2 vTexCoords[9];uniform sampler2D inputBuffer;uniform sampler2D historyBuffer;uniform sampler2D velocityBuffer;uniform sampler2D depthBuffer;uniform vec2 resolution;
#define USE_YCOCG
#define USE_CATMULL_ROM
const float feedback_min=0.5;const float feedback_max=0.95;vec3 RGB_YCoCg(vec3 c){return vec3(c.x/4.0+c.y/2.0+c.z/4.0,c.x/2.0-c.z/2.0,-c.x/4.0+c.y/2.0-c.z/4.0);}vec3 YCoCg_RGB(vec3 c){return clamp(vec3(c.x+c.y-c.z,c.x+c.z,c.x-c.y-c.z),vec3(0.0),vec3(1.0));}vec4 sample_color(sampler2D tex,vec2 uv){
#ifdef USE_YCOCG
vec4 c=texture(tex,uv);return vec4(RGB_YCoCg(c.rgb),c.a);
#else
return texture(tex,uv);
#endif
}vec4 sample_catmull_rom(sampler2D tex,vec2 uv,vec2 texSize){vec2 samplePos=uv*texSize;vec2 texPos1=floor(samplePos-0.5)+0.5;vec2 f=samplePos-texPos1;vec2 w0=f*(-0.5+f*(1.0-0.5*f));vec2 w1=1.0+f*f*(-2.5+1.5*f);vec2 w2=f*(0.5+f*(2.0-1.5*f));vec2 w3=f*f*(-0.5+0.5*f);vec2 w12=w1+w2;vec2 offset12=w2/(w1+w2);vec2 texPos0=texPos1-1.0;vec2 texPos3=texPos1+2.0;vec2 texPos12=texPos1+offset12;texPos0/=texSize;texPos3/=texSize;texPos12/=texSize;vec4 result=vec4(0.0);result+=texture2D(tex,vec2(texPos12.x,texPos0.y))*w12.x*w0.y;result+=texture2D(tex,vec2(texPos0.x,texPos12.y))*w0.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos12.y))*w12.x*w12.y;result+=texture2D(tex,vec2(texPos3.x,texPos12.y))*w3.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos3.y))*w12.x*w3.y;return result;}vec3 choose_motion_vector(){
#ifdef CHOOSE_LONGEST_MOTION_VECTOR
float longest=-1.0;vec3 v_choose=vec3(-1.0);for(int i=0;i<9;i++){vec3 v=texture2D(velocityBuffer,vTexCoords[i]).rgb;float l=length(v.xy);if(l>longest){longest=l;v_choose=v;}}return v_choose;
#else
float closest_depth=1000.0;vec2 closest_uv_offset=vec2(0.0);for(int i=0;i<9;i++){float neighbor_depth=texture2D(depthBuffer,vTexCoords[i]).r;if(neighbor_depth<closest_depth){closest_uv_offset=vTexCoords[i];closest_depth=neighbor_depth;}}return texture2D(velocityBuffer,closest_uv_offset).rgb;
#endif
}vec4 clipAabb(vec3 aabb_min,vec3 aabb_max,vec4 avg,vec4 input_texel){const float FLT_EPS=0.00000001;vec3 p_clip=0.5*(aabb_max+aabb_min);vec3 e_clip=0.5*(aabb_max-aabb_min)+FLT_EPS;vec4 v_clip=input_texel-vec4(p_clip,avg.w);vec3 v_unit=v_clip.xyz/e_clip;vec3 a_unit=abs(v_unit);float ma_unit=max(a_unit.x,max(a_unit.y,a_unit.z));if(ma_unit>1.0){return vec4(p_clip,avg.w)+v_clip/ma_unit;}else{return input_texel;}}vec3 clip_aabb_variance(in vec3 cOld,in vec3 cNew,in vec3 centre,in vec3 halfSize){if(all(lessThanEqual(abs(cOld-centre),halfSize))){return cOld;}vec3 dir=(cNew-cOld);vec3 near=centre-sign(dir)*halfSize;vec3 tAll=(near-cOld)/dir;float t=0.0001;for(int i=0;i<3;i++){if(tAll[i]>=0.0&&tAll[i]<t){t=tAll[i];}}if(t>=0.0001){return cOld;}return cOld+dir*t;}void main(){vec3 v=choose_motion_vector();vec2 velocity=v.rg;vec2 previousPixelPos=vUv-velocity;vec4 currentColor=sample_color(inputBuffer,vUv);
#ifdef USE_CATMULL_ROM
vec4 previousColor=sample_catmull_rom(historyBuffer,previousPixelPos,resolution);
#else
vec4 previousColor=sample_color(historyBuffer,previousPixelPos);
#endif
#ifdef USE_YCOCG
previousColor=vec4(RGB_YCoCg(previousColor.rgb),previousColor.a);
#endif
vec4 ctl=sample_color(inputBuffer,vTexCoords[0]);vec4 ctc=sample_color(inputBuffer,vTexCoords[1]);vec4 ctr=sample_color(inputBuffer,vTexCoords[2]);vec4 cml=sample_color(inputBuffer,vTexCoords[3]);vec4 cmc=sample_color(inputBuffer,vTexCoords[4]);vec4 cmr=sample_color(inputBuffer,vTexCoords[5]);vec4 cbl=sample_color(inputBuffer,vTexCoords[6]);vec4 cbc=sample_color(inputBuffer,vTexCoords[7]);vec4 cbr=sample_color(inputBuffer,vTexCoords[8]);vec4 cmin=min(ctl,min(ctc,min(ctr,min(cml,min(cmc,min(cmr,min(cbl,min(cbc,cbr))))))));vec4 cmax=max(ctl,max(ctc,max(ctr,max(cml,max(cmc,max(cmr,max(cbl,max(cbc,cbr))))))));vec4 cavg=(ctl+ctc+ctr+cml+cmc+cmr+cbl+cbc+cbr)/9.0;vec4 cmin5=min(ctc,min(cml,min(cmc,min(cmr,cbc))));vec4 cmax5=max(ctc,max(cml,max(cmc,max(cmr,cbc))));vec4 cavg5=(ctc+cml+cmc+cmr+cbc)/5.0;cmin=0.5*(cmin+cmin5);cmax=0.5*(cmax+cmax5);cavg=0.5*(cavg+cavg5);
#ifdef USE_YCOCG
vec2 chroma_extent=vec2(0.25*0.5*(cmax.r-cmin.r));vec2 chroma_center=currentColor.gb;cmin.yz=chroma_center-chroma_extent;cmax.yz=chroma_center+chroma_extent;cavg.yz=chroma_center;
#endif
vec4 previousColorClipped=clamp(previousColor,cmin,cmax);
#ifdef LUMINANCE_DIFFERENCES
#ifdef USE_YCOCG
float lum0=currentColor.r;float lum1=previousColorClipped.r;
#else
float lum0=luminance(currentColor.rgb);float lum1=luminance(previousColorClipped.rgb);
#endif
float unbiased_diff=abs(lum0-lum1)/max(lum0,max(lum1,0.2));float unbiased_weight=1.0-unbiased_diff;float unbiased_weight_sqr=unbiased_weight*unbiased_weight;float k_feedback=mix(feedback_min,feedback_max,unbiased_weight_sqr);vec4 result=mix(currentColor,previousColorClipped,vec4(k_feedback));
#else
const float alpha=0.1;vec4 result=mix(currentColor,previousColorClipped,1.0-alpha);
#endif
#ifdef USE_YCOCG
gl_FragColor=vec4(YCoCg_RGB(result.rgb).rgb,result.a);
#else
gl_FragColor=result;
#endif
}`;
var $3 = `#define GLSLIFY 1
varying vec2 vUv;void main(){gl_Position=vec4(position.xy,1.0,1.0);vUv=position.xy*0.5+0.5;}`;
var eL = `#define GLSLIFY 1
layout(location=1)out vec4 gVelocity;varying vec2 vUv;uniform sampler2D inputBuffer;void main(){gl_FragColor=texture2D(inputBuffer,vUv);gVelocity=vec4(0.0);}`;
var bf = class extends it {
    constructor(){
        super({
            name: "PassthroughMaterial",
            uniforms: {
                inputBuffer: new le(null)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: $3,
            fragmentShader: eL
        });
    }
    set inputBuffer(t) {
        this.uniforms.inputBuffer.value = t;
    }
}, Px = class extends xi {
    constructor(){
        super("TAAResolvePass");
        this.MRTCompatible = !0;
        this.needsSwap = !1, this.passThroughMaterial = new bf, this.resolutionVector = new k, this.resolveMaterial = new it({
            name: "TAAResolveMaterial",
            uniforms: {
                inputBuffer: new le(null),
                historyBuffer: new le(null),
                velocityBuffer: new le(null),
                depthBuffer: new le(null),
                resolution: new le(new k)
            },
            blending: $t,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: Z3,
            fragmentShader: J3
        }), this.historyRenderTarget = new dt(1024, 1024, {
            minFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.historyRenderTarget.texture.name = "TAA.History", this.resultRenderTarget = new dt(1024, 1024, {
            minFilter: rt,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.resultRenderTarget.texture.name = "TAA.Output";
    }
    setSize(e, r) {
        this.historyRenderTarget.setSize(e, r), this.resultRenderTarget.setSize(e, r);
    }
    render(e, r) {
        this.fullscreenMaterial = this.resolveMaterial, this.resolveMaterial.uniforms.inputBuffer.value = r.texture[0], this.resolveMaterial.uniforms.velocityBuffer.value = r.texture[1], this.resolveMaterial.uniforms.depthBuffer.value = r.depthTexture, this.resolveMaterial.uniforms.historyBuffer.value = this.historyRenderTarget.texture, this.resolveMaterial.uniforms.resolution.value.set(r.width, r.height), e.setRenderTarget(this.resultRenderTarget), e.render(this.scene, this.camera), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(this.historyRenderTarget), e.render(this.scene, this.camera);
        let i = this.renderToScreen ? null : r;
        this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(i), e.render(this.scene, this.camera);
    }
    dispose() {
        this.resultRenderTarget.dispose(), this.historyRenderTarget.dispose(), this.resolveMaterial.dispose(), this.passThroughMaterial.dispose();
    }
};
var _x = class extends xi {
    constructor(e, r, i){
        super("TransmissionPass", void 0, r);
        this.MRTCompatible = !0;
        this.depthPass = new QE(e, r, {
            renderTarget: i.transmissionDepthTarget
        }), this.passThroughMaterial = new bf, this.splineScene = e, this.needsSwap = !1;
    }
    updatePasses(e) {
        this.passThroughMaterial = new bf, this.depthPass = new QE(this.splineScene, this.camera, {
            renderTarget: e.transmissionDepthTarget
        });
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    render(e, r, i) {
        let s = this.camera.layers.mask, o = e;
        o.setRenderTarget(o.transmissionRenderTarget), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = r.texture[0], o.clear(), o.render(this.scene, this.camera), this.camera.layers.disable(3), this.depthPass.render(e, r, i), o.shadowMap.needsUpdate = !1, o.shadowMap.autoUpdate = !1;
        let a = this.renderToScreen ? null : r;
        this.camera.layers.set(3), e.setRenderTarget(a), e.render(this.splineScene, this.camera), this.camera.layers.mask = s;
    }
};
var tL = new ei, MQ = new it({
    transparent: !0,
    vertexShader: `
        void main() {
            gl_Position = vec4(0.0);
        }
    `,
    fragmentShader: `
        layout(location = 1) out vec4 gVelocity;

        void main() {
            gl_FragColor = vec4(0.0);
			gVelocity = vec4(0.0);
        }
    `
}), eu = class extends xi {
    constructor(e, r, i){
        super("OpaquePass", r ?? tL, i);
        this.MRTCompatible = !0;
        this.originalMaterials = [];
        this.hasTransmissionPass = !1;
        this.clear = !0;
        this.clearColorOnly = !1;
        this.clearDepth = !1;
        this.needsSwap = !1, this.MRTCompatible = e;
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.scene = e ?? tL;
    }
    getScene() {
        return this.scene;
    }
    render(e, r) {
        this.camera.layers.enable(3), this.hasTransmissionPass && (this.originalMaterials.length = 0, this.scene.traverse((s)=>{
            s.layers.isEnabled(3) && s instanceof mr && (this.originalMaterials.push([
                s,
                s.material
            ]), s.material = MQ);
        }), e.shadowMap.needsUpdate = !0, e.shadowMap.autoUpdate = !0), this.camera.layers.enable(8);
        let i = this.renderToScreen ? null : r;
        e.setRenderTarget(i), this.clearColorOnly && e.clear(!0, !1, !0), this.clear && e.clear(), e.render(this.scene, this.camera), this.clearDepth && e.clear(!1, !0, !1), this.hasTransmissionPass && this.originalMaterials.forEach((s)=>{
            s[0].material = s[1];
        });
    }
};
var Ix = class {
    constructor(t, { depthBuffer: e = !0, stencilBuffer: r = !1, multisampling: i = 0, frameBufferType: s = 0 } = {}){
        this.renderer = t;
        this.helperStartIndex = 0;
        this.copyPass = new Vm;
        this.depthTexture = null;
        this.timer = new z3;
        this._width = 1;
        this._height = 1;
        this.passes = [];
        this.helperPasses = [];
        this.autoRenderToScreen = !0;
        this.inputBuffer = this.createBuffer(e, r, s, i, !0, "input buffer mrt"), this.inputBufferSingle = this.createBuffer(e, r, s, i, !1, " input buffer single"), this.inputBufferSingle.texture.dispose(), this.inputBufferSingle.depthTexture.dispose(), this.inputBufferSingle.texture = this.inputBuffer.texture[0], this.inputBufferSingle.depthTexture = this.inputBuffer.depthTexture, this.outputBuffer = this.inputBuffer.clone(), this.outputBuffer.name = "output buffer mrt", this.outputBufferSingle = this.createBuffer(e, r, s, i, !1, "output buffer single"), this.outputBufferSingle.texture.dispose(), this.outputBufferSingle.depthTexture.dispose(), this.outputBufferSingle.texture = this.outputBuffer.texture[0], this.outputBufferSingle.depthTexture = this.outputBuffer.depthTexture, this.setRenderer(t);
    }
    get multisampling() {
        return this.inputBuffer.samples || 0;
    }
    set multisampling(t) {
        let e = this.inputBuffer, r = this.multisampling;
        r > 0 && t > 0 ? (this.inputBuffer.samples = t, this.outputBuffer.samples = t, this.inputBuffer.dispose(), this.outputBuffer.dispose()) : r !== t && (this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("creating new input buffer"), this.inputBuffer = this.createBuffer(e.depthBuffer, e.stencilBuffer, e.texture.type, t, !0, "new input buffer"), this.inputBuffer.depthTexture = this.depthTexture, this.outputBuffer = this.inputBuffer.clone());
    }
    getTimer() {
        return this.timer;
    }
    getRenderer() {
        return this.renderer;
    }
    setRenderer(t) {
        if (this.renderer = t, t !== null) {
            let e = t.getSize(new k), r = t.getContext().getContextAttributes()?.alpha ?? !1, i = this.inputBuffer.texture[0].type;
            i === _r && t.outputEncoding === at && (this.inputBuffer.texture[0].encoding = at, this.outputBuffer.texture[0].encoding = at, this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("doing some kinda dispose??")), t.autoClear = !1, this.setSize(e.width, e.height, !1);
            for (let s of this.passes)s.initialize(t, r, i);
        }
    }
    replaceRenderer(t, e = !0) {
        let r = this.renderer, i = r.domElement.parentNode;
        return this.setRenderer(t), e && i !== null && (i.removeChild(r.domElement), i.appendChild(t.domElement)), r;
    }
    createDepthTexture() {
        let t = this.depthTexture = new ns(this._width, this._height);
        return this.inputBuffer.depthTexture = t, this.inputBuffer.stencilBuffer ? (t.format = tl, t.type = Ja) : t.type = Ds, t;
    }
    deleteDepthTexture() {
        if (this.depthTexture !== null) {
            this.depthTexture.dispose(), this.depthTexture = null, this.inputBuffer.depthTexture = null, this.inputBuffer.dispose();
            for (let t of this.passes)t.setDepthTexture(null);
        }
    }
    createBuffer(t, e, r, i, s, o) {
        let a = this.renderer, l = a === null ? new k : a.getDrawingBufferSize(new k), c = {
            minFilter: rt,
            magFilter: rt,
            wrapS: Qt,
            wrapT: Qt,
            stencilBuffer: e,
            depthBuffer: t
        }, u;
        return i > 0 ? (u = new dt(l.width, l.height, c), u.samples = i) : (s ? (u = new hy(l.width, l.height, 2, c), u.texture[1].type = Wn) : u = new dt(l.width, l.height, c), u.depthTexture = new ns(2048, 2048), u.depthTexture.type = br), r === _r && a !== null && a.outputEncoding === at && (Array.isArray(u.texture) ? u.texture.forEach((h)=>h.encoding = at) : u.texture.encoding = at), Array.isArray(u.texture) ? u.texture.forEach((h, d)=>{
            h.name = `EffectComposer.Buffer ${s} ${d}`, h.generateMipmaps = !1;
        }) : (u.texture.name = `EffectComposer.Buffer ${s}`, u.texture.generateMipmaps = !1), u.name = o, u;
    }
    addPass(t, e) {
        let r = this.passes, i = this.renderer, s = i.getDrawingBufferSize(new k), o = i.getContext().getContextAttributes()?.alpha ?? !1, a;
        if (t.MRTCompatible && (a = this.inputBuffer.texture[0].type), t.MRTCompatible || (a = this.inputBuffer.texture.type), t.setRenderer(i), t.setSize(s.width, s.height), t.initialize(i, o, a), this.autoRenderToScreen && (r.length > 0 && (r[r.length - 1].renderToScreen = !1), t.renderToScreen && (this.autoRenderToScreen = !1)), e !== void 0 ? r.splice(e, 0, t) : r.push(t), this.autoRenderToScreen && (r[r.length - 1].renderToScreen = !0), t.needsDepthTexture || this.depthTexture !== null) {
            if (this.depthTexture === null) {
                let l = this.createDepthTexture();
                for (t of r)t.setDepthTexture(l);
            } else t.setDepthTexture(this.depthTexture);
        }
    }
    setHelperStartIndex(t) {
        this.helperStartIndex = t;
    }
    removePass(t) {
        let e = this.passes, r = e.indexOf(t);
        if (r !== -1 && e.splice(r, 1).length > 0) {
            if (this.depthTexture !== null) {
                let o = (l, c)=>l || c.needsDepthTexture;
                e.reduce(o, !1) || t.getDepthTexture() === this.depthTexture && t.setDepthTexture(null);
            }
            this.autoRenderToScreen && r === e.length && (t.renderToScreen = !1, e.length > 0 && (e[e.length - 1].renderToScreen = !0));
        }
    }
    removeAllPasses() {
        let t = this.passes;
        t.length > 0 && (this.autoRenderToScreen && (t[t.length - 1].renderToScreen = !1), this.passes = []);
    }
    render(t) {
        let e = this.renderer, r = this.copyPass, i = this.inputBuffer, s = this.outputBuffer, o = this.inputBufferSingle, a = this.outputBufferSingle, l = !1, c, u, h, d;
        t === void 0 && (t = this.timer.update().getDelta());
        for (let f of this.passes)f.enabled && (f.MRTCompatible ? f.render(e, i, s, t, l) : f.render(e, o, a, t, l), f.needsSwap && (l && (r.renderToScreen = f.renderToScreen, c = e.getContext(), u = e.state.buffers.stencil, u.setFunc(c.NOTEQUAL, 1, 4294967295), r.render(e, i, s, t, l), u.setFunc(c.EQUAL, 1, 4294967295)), h = i, d = o, i = s, o = a, s = h, a = d), f instanceof U3 ? l = !0 : f instanceof k3 && (l = !1));
    }
    setSize(t, e, r) {
        let i = this.renderer;
        if (this._width = t, this._height = e, t === void 0 || e === void 0) {
            let o = i.getSize(new k);
            t = o.width, e = o.height;
        }
        i.setSize(t, e, r);
        let s = i.getDrawingBufferSize(new k);
        this.inputBuffer.setSize(s.width, s.height), this.outputBuffer.setSize(s.width, s.height), this.inputBufferSingle.setSize(s.width, s.height), this.outputBufferSingle.setSize(s.width, s.height);
        for (let o of this.passes)o.setSize(s.width, s.height);
    }
    reset() {
        let t = this.timer.isAutoResetEnabled();
        this.dispose(), this.autoRenderToScreen = !0, this.timer.setAutoResetEnabled(t);
    }
    dispose() {
        for (let t of this.passes)t.dispose();
        this.passes = [], this.inputBuffer !== null && this.inputBuffer.dispose(), this.outputBuffer !== null && this.outputBuffer.dispose(), this.inputBufferSingle !== null && this.inputBufferSingle.dispose(), this.outputBufferSingle !== null && this.outputBufferSingle.dispose(), this.deleteDepthTexture(), this.copyPass.dispose(), this.timer.dispose();
    }
};
var CQ = new it({
    name: "CombineMaterial",
    uniforms: {
        inputBufferA: new le(null),
        inputBufferB: new le(null)
    },
    blending: $t,
    depthWrite: !1,
    depthTest: !1,
    vertexShader: `
varying vec2 vUv;
void main() {
    gl_Position = vec4(position.xy, 1.0, 1.0);
    vUv = position.xy * 0.5 + 0.5;
}
`,
    fragmentShader: `
    varying vec2 vUv;
    uniform sampler2D inputBufferA;
    uniform sampler2D inputBufferB;

    // TODO: Why do we need these when postpro of framemode is enabled???
    layout(location = 1) out vec4 gVelocity;

    void main() {
	vec4 resA = texture2D(inputBufferA, vUv);
	vec4 resB = texture2D(inputBufferB, vUv);
    float a = resA.a + resB.a * ( 1.0 - resA.a );

	vec4 res;
	res.rgb =  resA.rgb + (resB.rgb * (1.0 - resA.a));
	res.a = resA.a + resB.a * (1.0 - resA.a);
	gl_FragColor = res;
    gVelocity = vec4(0.0);
    }
`
}), Dx = class extends xi {
    constructor(e){
        super("HelperPass", void 0, e);
        this.MRTCompatible = !1;
        this.fullscreenMaterial = CQ, this.helperPass = new eu(!1, void 0, this.camera), this.helperPass.hasTransmissionPass = !1, this.helperPass.clear = !1, this.helperPass.renderToScreen = !1, this.helperPassOnTop = new eu(!1, void 0, this.camera), this.helperPassOnTop.hasTransmissionPass = !1, this.helperPassOnTop.clear = !1, this.helperPassOnTop.renderToScreen = !1;
        let r = new Cx({
            preset: Fa.LOW,
            edgeDetectionMode: uf.COLOR
        });
        this.effectPass = new $c(this.camera, r), this.rt = new dt(10, 10, {
            minFilter: rt,
            magFilter: rt,
            wrapS: Qt,
            wrapT: Qt,
            depthBuffer: !0
        });
    }
    setSize(e, r) {
        this.rt.setSize(e, r), this.effectPass.setSize(e, r);
    }
    set sceneHelpers(e) {
        this.helperPass.setScene(e);
    }
    get sceneHelpers() {
        return this.helperPass.getScene();
    }
    set sceneHelpersOnTop(e) {
        this.helperPassOnTop.setScene(e);
    }
    get sceneHelpersOnTop() {
        return this.helperPassOnTop.getScene();
    }
    setCamera(e) {
        this.helperPass.setCamera(e), this.helperPassOnTop.setCamera(e);
    }
    initialize(e, r, i) {
        super.initialize(e, r, i), this.effectPass.initialize(e, r, i);
    }
    dispose() {
        super.dispose(), this.rt.dispose(), this.effectPass.dispose();
    }
    render(e, r, i) {
        this.rt.depthTexture = r.depthTexture;
        let s = e.getClearAlpha();
        e.setClearAlpha(0), this.helperPass.clearDepth = !0, this.helperPass.clearColorOnly = !0, this.helperPass.render(e, this.rt), this.helperPassOnTop.render(e, this.rt), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.rt, i), this.fullscreenMaterial.uniforms.inputBufferA.value = i.texture, this.fullscreenMaterial.uniforms.inputBufferB.value = r.texture, e.setClearAlpha(s), e.setRenderTarget(null), e.clear(), e.render(this.scene, this.camera);
    }
};
var rL = `#define GLSLIFY 1
#include <skinning_pars_vertex>
#include <morphtarget_pars_vertex>
out vec3 n;void main(){
#include <beginnormal_vertex>
#include <morphnormal_vertex>
#include <skinbase_vertex>
#include <skinnormal_vertex>
#include <defaultnormal_vertex>
#include <begin_vertex>
#include <morphtarget_vertex>
#include <skinning_vertex>
vec4 view_space=viewMatrix*modelMatrix*vec4(transformed,1.0);gl_Position=projectionMatrix*view_space;n=normalize(transformedNormal);}`;
var iL = `#define GLSLIFY 1
in vec3 n;void main(){gl_FragColor=vec4(n,1.0);}`;
var nL = `#define GLSLIFY 1
out vec2 v_uv;void main(){v_uv=uv;gl_Position=vec4(position.xy,1.0,1.0);}`;
var sL = `#define GLSLIFY 1
in vec2 v_uv;const float pi=3.14159265;const float num_steps=4.0;const float num_directions=4.0;uniform float near;uniform float far;uniform float fov;uniform vec4 proj_info;uniform bool is_ortho;uniform vec2 resolution;uniform float radius_of_influence;uniform float radius_in_screen_space;uniform float exponent;uniform vec3 ao_color;uniform float bias;uniform sampler2D texture_depth;uniform sampler2D texture_normals;uniform sampler2D texture_blue_noise;uniform sampler2D texture_blue_noise_in_disk;uniform sampler2D texture_color_pass;uniform int frame_index;uniform bool fog_enabled;uniform float fog_near;uniform float fog_far;vec3 uv_to_view_space(vec2 uv,float eye_z){return vec3((uv*proj_info.xy+proj_info.zw)*(is_ortho ? 1.0 : eye_z),eye_z);}float linearize_depth(float depth_sampled){float z=is_ortho ? depth_sampled : depth_sampled*2.0-1.0;return mix((2.0*near*far)/(far+near-z*(far-near)),near+z*(far-near),float(is_ortho));}vec3 get_view_position(vec2 uv_coords){float linear_depth=linearize_depth(texture(texture_depth,uv_coords).x);return uv_to_view_space(uv_coords,linear_depth);}vec3 min_difference(vec3 p,vec3 right,vec3 left){vec3 v1=right-p;vec3 v2=p-left;return(dot(v1,v1)<dot(v2,v2))? v1 : v2;}vec3 rebuild_normal(in vec2 uv,in vec3 p){vec2 one_over_resolution=1.0/resolution;vec3 r=get_view_position(uv+vec2(one_over_resolution.x,0));vec3 l=get_view_position(uv+vec2(-one_over_resolution.x,0));vec3 t=get_view_position(uv+vec2(0,one_over_resolution.y));vec3 b=get_view_position(uv+vec2(0,-one_over_resolution.y));return normalize(cross(min_difference(p,r,l),min_difference(p,t,b)));}float falloff(float distance_squared){float neg_inv_r2=-1.0/(radius_of_influence*radius_of_influence);return distance_squared*neg_inv_r2+1.0;}float ao_contribution(vec3 P,vec3 N,vec3 S){vec3 to_sample=S-P;float norm_squared=dot(to_sample,to_sample);float norm=sqrt(norm_squared);float cos_theta=dot(N,to_sample)/norm;return clamp(cos_theta-bias,0.0,1.0)*clamp(falloff(norm_squared),0.0,1.0);}float compute_ambient_occlusion(vec2 uv,float radius_in_screen_space,vec3 pc,vec3 view_space_n){vec2 one_over_resolution=1.0/resolution;ivec2 noise_uv=ivec2(int(mod(gl_FragCoord.x,128.0)),int(mod(gl_FragCoord.y,128.0)));float noise=texelFetch(texture_blue_noise,noise_uv,0).r;noise=fract(noise+0.61803398875*float(frame_index));float theta=noise*2.0*3.1415;float ct=cos(theta);float st=sin(theta);float step_size=radius_in_screen_space/(num_steps+1.0);const float angle_step=2.0*pi/num_directions;float contribution=0.0;for(int i=0;i<int(num_directions);++i){float current_pixel=step_size+1.0;for(int j=0;j<int(num_steps);++j){int index=i*int(num_steps)+j;vec2 blue_noise_sample=texelFetch(texture_blue_noise_in_disk,ivec2(index,0),0).rg;vec2 disk_point;disk_point.x=blue_noise_sample.x*ct-blue_noise_sample.y*st;disk_point.y=blue_noise_sample.x*st+blue_noise_sample.y*ct;vec2 sample_direction=disk_point;vec2 snapped_uv=round(current_pixel*sample_direction)*one_over_resolution+uv;vec3 ps=get_view_position(snapped_uv);current_pixel+=step_size;contribution+=ao_contribution(pc,view_space_n,ps);}}float mult=1.0/(1.0-bias);contribution*=mult/(num_directions*num_steps);return clamp(1.0-contribution*2.0,0.0,1.0);}
#define USE_GBUFFER_NORMALS
void main(){vec3 view_space_p=get_view_position(v_uv);
#ifdef USE_GBUFFER_NORMALS
vec3 view_space_n=texture(texture_normals,v_uv).rgb;view_space_n.z*=-1.0;
#else
vec3 view_space_n=-rebuild_normal(v_uv,view_space_p);
#endif
float radius_ss=radius_in_screen_space/(is_ortho ? 1.0 : view_space_p.z);float ao=compute_ambient_occlusion(v_uv,radius_ss,view_space_p,view_space_n);float final=pow(ao,exponent);if(view_space_p.z>=far){final=1.0;}vec3 color=mix(ao_color,vec3(1.0),final);if(fog_enabled){float fog_factor=smoothstep(fog_near,fog_far,view_space_p.z);color=mix(color,vec3(1.0),fog_factor);}gl_FragColor=vec4(color,1.0);}`;
var oL = `#define GLSLIFY 1
out vec2 v_uv;void main(){gl_Position=vec4(position.xy,1.0,1.0);v_uv=uv;}`;
var aL = `#define GLSLIFY 1
in vec2 v_uv;uniform sampler2D texture_ao_lrez;uniform sampler2D texture_depth_lrez;uniform sampler2D texture_depth_hrez;uniform float near;uniform float far;float linearize_depth(float depth_sampled){float z=depth_sampled*2.0-1.0;return(2.0*near*far)/(far+near-z*(far-near));}vec2 nearest_depth_filter(in vec2 uv){vec2 resolution=vec2(textureSize(texture_depth_lrez,0));vec2 texel_size=1.0/resolution;vec2 offset=uv-0.5*texel_size;float d_hrez=texture(texture_depth_hrez,uv).r;float a=abs(d_hrez-texture(texture_depth_lrez,offset).r);float b=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,0.0)).r);float c=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(0.0,texel_size.y)).r);float d=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,texel_size.y)).r);float min_diff=min(a,min(b,min(c,d)));if(min_diff==a)return offset;if(min_diff==b)return offset+vec2(texel_size.x,0.0);if(min_diff==c)return offset+vec2(0.0,texel_size.y);if(min_diff==d)return offset+vec2(texel_size.x,texel_size.y);}void main(){
#ifdef DEBUG
float d_lrez=texture(texture_depth_lrez,v_uv).r;float d_hrez=texture(texture_depth_hrez,v_uv).r;float output_d=mix(linearize_depth(d_lrez)/far,linearize_depth(d_hrez)/far,step(0.5,v_uv.x));gl_FragColor=vec4(vec3(output_d),1.0);
#else
vec2 filtered_uv=nearest_depth_filter(v_uv);vec4 ao=texture(texture_ao_lrez,filtered_uv);gl_FragColor=vec4(ao.rgb,1.0);gl_FragColor=ao;
#endif
}`;
var Sf = [
    [
        .478712,
        .875764
    ],
    [
        -0.337956,
        -0.793959
    ],
    [
        -0.955259,
        -0.028164
    ],
    [
        .864527,
        .325689
    ],
    [
        .209342,
        -0.395657
    ],
    [
        -0.106779,
        .672585
    ],
    [
        .156213,
        .235113
    ],
    [
        -0.413644,
        -0.082856
    ],
    [
        -0.415667,
        .323909
    ],
    [
        .141896,
        -0.93998
    ],
    [
        .954932,
        -0.182516
    ],
    [
        -0.766184,
        .410799
    ],
    [
        -0.434912,
        -0.458845
    ],
    [
        .415242,
        -0.078724
    ],
    [
        .728335,
        -0.491777
    ],
    [
        -0.058086,
        -0.066401
    ],
    [
        .20299,
        .686837
    ],
    [
        -0.808362,
        -0.556402
    ],
    [
        .507386,
        -0.640839
    ],
    [
        -0.723494,
        -0.22924
    ],
    [
        .48974,
        .317826
    ],
    [
        -0.622663,
        .765301
    ],
    [
        -0.01064,
        .929347
    ],
    [
        .663146,
        .647618
    ],
    [
        -0.096674,
        -0.413835
    ],
    [
        .525945,
        -0.321063
    ],
    [
        -0.122533,
        .366019
    ],
    [
        .195235,
        -0.687983
    ],
    [
        -0.563203,
        .098748
    ],
    [
        .418563,
        .561335
    ],
    [
        -0.378595,
        .800367
    ],
    [
        .826922,
        .001024
    ],
    [
        -0.085372,
        -0.766651
    ],
    [
        -0.92192,
        .183673
    ],
    [
        -0.590008,
        -0.721799
    ],
    [
        .167751,
        -0.164393
    ],
    [
        .032961,
        -0.56253
    ],
    [
        .6329,
        -0.107059
    ],
    [
        -0.46408,
        .569669
    ],
    [
        -0.173676,
        -0.958758
    ],
    [
        -0.242648,
        -0.234303
    ],
    [
        -0.275362,
        .157163
    ],
    [
        .382295,
        -0.795131
    ],
    [
        .562955,
        .115562
    ],
    [
        .190586,
        .470121
    ],
    [
        .770764,
        -0.297576
    ],
    [
        .237281,
        .93105
    ],
    [
        -0.666642,
        -0.455871
    ],
    [
        -0.905649,
        -0.298379
    ],
    [
        .33952,
        .157829
    ],
    [
        .701438,
        -0.7041
    ],
    [
        -0.062758,
        .160346
    ],
    [
        -0.220674,
        .957141
    ],
    [
        .642692,
        .432706
    ],
    [
        -0.77339,
        -0.015272
    ],
    [
        -0.671467,
        .24688
    ],
    [
        .158051,
        .062859
    ],
    [
        .806009,
        .527232
    ],
    [
        -0.05762,
        -0.247071
    ],
    [
        .333436,
        -0.51671
    ],
    [
        -0.550658,
        -0.315773
    ],
    [
        -0.652078,
        .589846
    ],
    [
        .008818,
        .530556
    ],
    [
        -0.210004,
        .519896
    ]
];
var LQ = new it({
    vertexShader: rL,
    fragmentShader: iL
}), wf = new it({
    vertexShader: oL,
    fragmentShader: aL,
    uniforms: {
        texture_ao_lrez: new le(null),
        texture_depth_lrez: new le(null),
        texture_depth_hrez: new le(null),
        near: new le(null),
        far: new le(null)
    }
}), Ox = class extends xi {
    constructor(e, r){
        super("AmbientOcclusionPass", void 0, r);
        this.fogEnabled = !1;
        this.fogNear = 1;
        this.fogFar = 1e3;
        this.frameIndex = 0;
        this._runHalfRes = !0;
        this._width = 1;
        this._height = 1;
        let i = 1024, s = 1024;
        this.gBuffer = new dt(i, s, {
            type: xo ? Wn : br,
            depthTexture: new ns(i, s),
            minFilter: rt,
            magFilter: rt
        }), this.depthBufferHighRes = new dt(i, s, {
            depthTexture: new ns(i, s)
        }), this.aoBuffer = new dt(i, s, {
            minFilter: rt,
            magFilter: rt
        }), this.splineScene = e, this.splineCamera = r;
        let o = new Float32Array(Sf.length * 2);
        for(let l = 0; l < Sf.length; l++){
            let c = l * 2;
            o[c + 0] = Sf[l][0], o[c + 1] = Sf[l][1];
        }
        this.blueNoiseInDiskTexture = new gi(o, Sf.length, 1, eh, br), this.blueNoiseInDiskTexture.wrapS = Rs, this.blueNoiseInDiskTexture.wrapT = Rs, this.blueNoiseInDiskTexture.needsUpdate = !0, this.hbaoMaterial = new it({
            vertexShader: nL,
            fragmentShader: sL,
            uniforms: {
                near: new le(null),
                far: new le(null),
                fov: new le(null),
                proj_info: new le(new Ze),
                is_ortho: new le(!1),
                resolution: new le(new k),
                radius_of_influence: new le(8),
                radius_in_screen_space: new le(1),
                exponent: new le(1),
                ao_color: new le(new E),
                bias: new le(.5),
                texture_depth: new le(null),
                texture_normals: new le(null),
                texture_blue_noise: new le(null),
                texture_blue_noise_in_disk: new le(this.blueNoiseInDiskTexture),
                frame_index: new le(0),
                fog_enabled: new le(!1),
                fog_near: new le(1),
                fog_far: new le(1e3)
            }
        }), this.radius = 128, this.aoColor = {
            r: 0,
            g: 0,
            b: 0
        }, this.bias = .5, this.hbaoMaterial.uniforms.texture_depth.value = this.gBuffer.depthTexture, this.hbaoMaterial.uniforms.texture_normals.value = this.gBuffer.texture, this.needsSwap = !0, this.aaBuffer = new dt(i, s, {
            minFilter: rt,
            magFilter: rt,
            wrapS: Qt,
            wrapT: Qt,
            depthBuffer: !1,
            type: br
        });
        let a = new Cx({
            preset: Fa.ULTRA,
            edgeDetectionMode: uf.COLOR
        });
        this.effectPass = new $c(this.camera, a);
    }
    initialize(e, r, i) {
        super.initialize(e, r, i), this.effectPass.initialize(e, r, i);
    }
    setBlueNoiseTexture(e) {
        this.hbaoMaterial.uniforms.texture_blue_noise.value = e;
    }
    setSize(e, r) {
        this._width = e, this._height = r, this.depthBufferHighRes.setSize(e, r);
        let i = this._runHalfRes ? .5 : 1, s = e * i, o = r * i;
        this.gBuffer.setSize(s, o), this.aoBuffer.setSize(s, o), this.hbaoMaterial.uniforms.resolution.value.set(s, o), this.aaBuffer.setSize(s, o), this.effectPass.setSize(s, o);
    }
    get runHalfRes() {
        return this._runHalfRes;
    }
    set runHalfRes(e) {
        this._runHalfRes = e, this.setSize(this._width, this._height);
    }
    setCamera(e) {
        this.splineCamera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    setDepthTexture(e) {
        this.depthBufferHighRes.depthTexture = e, wf.uniforms.texture_depth_hrez.value = e, wf.needsUpdate = !0;
    }
    render(e, r, i) {
        this.splineScene.overrideMaterial = LQ;
        let s = this.splineCamera.layers.mask;
        if (this.splineCamera.layers.set(5), e.setRenderTarget(this.gBuffer), e.clear(), e.render(this.splineScene, this.splineCamera), e.setRenderTarget(this.depthBufferHighRes), e.clear(), e.render(this.splineScene, this.splineCamera), this.splineScene.overrideMaterial = null, this.splineCamera.layers.mask = s, this.hbaoMaterial.uniforms.radius_of_influence.value = this.radius, this.hbaoMaterial.uniforms.ao_color.value.set(this.aoColor.r, this.aoColor.g, this.aoColor.b), this.hbaoMaterial.uniforms.bias.value = this.bias, this.hbaoMaterial.uniforms.fog_enabled.value = this.fogEnabled, this.hbaoMaterial.uniforms.fog_near.value = this.fogNear, this.hbaoMaterial.uniforms.fog_far.value = this.fogFar, this.hbaoMaterial.uniforms.frame_index.value = this.frameIndex, this.frameIndex++, this.splineCamera.isPerspectiveCamera) {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.perspCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.perspCamera.far;
            let o = this.splineCamera.perspCamera.projectionMatrix.elements, a = 2 / o[0], l = 2 / o[5], c = -(1 - o[8]) / o[0], u = -(1 + o[9]) / o[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(a, l, c, u);
            let d = this.splineCamera.perspCamera.fov * (Math.PI / 180), p = this.hbaoMaterial.uniforms.resolution.value.y / (Math.tan(d * .5) * 2), m = this.hbaoMaterial.uniforms.radius_of_influence.value * .5 * p;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = m, this.hbaoMaterial.uniforms.is_ortho.value = !1;
        } else {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.orthoCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.orthoCamera.far;
            let o = this.splineCamera.orthoCamera.projectionMatrix.elements, a = 2 / o[0], l = 2 / o[5], c = -(1 + o[12]) / o[0], u = -(1 - o[13]) / o[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(a, l, c, u);
            let d = .5 * (this.hbaoMaterial.uniforms.resolution.value.y / l), f = this.hbaoMaterial.uniforms.radius_of_influence.value * d;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = f, this.hbaoMaterial.uniforms.is_ortho.value = !0;
        }
        this.runHalfRes ? (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aoBuffer), e.clear(), e.render(this.scene, this.camera), this.fullscreenMaterial = wf, wf.uniforms.texture_ao_lrez.value = this.aoBuffer.texture, wf.uniforms.texture_depth_lrez.value = this.gBuffer.depthTexture, wf.uniforms.texture_depth_hrez.value = this.depthBufferHighRes.depthTexture, e.setRenderTarget(e.aoRenderTarget), e.clear(), e.render(this.scene, this.camera)) : (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aaBuffer), e.clear(), e.render(this.scene, this.camera), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.aaBuffer, e.aoRenderTarget));
    }
    dispose() {
        this.gBuffer.dispose(), this.depthBufferHighRes.dispose(), this.aoBuffer.dispose();
    }
};
var BQ = `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, NQ = `
uniform sampler2D tInput;
uniform sampler2D tMap;
uniform vec2 resolution;
varying vec2 vUv;

uniform vec2 uResolution;
uniform vec2 uCoords;

// Draws a rectangle at center <st> with size <size>
float rectangle(vec2 st, vec2 size) {
    size = vec2(0.5) - size * 0.5;
    vec2 uv = vec2(step(size.x, st.x), step(size.y, st.y));
    uv *= vec2(step(size.x, 1.0 - st.x), step(size.y, 1.0 - st.y));

    return uv.x * uv.y;
}

uniform vec2 uSize;
uniform float uScale;
uniform float uDPR;
uniform float uCurrent;
uniform vec3 uSceneColor;

void main() {
    vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
    screenUv *= 1.0 / uDPR;

    vec2 center = vec2(0.5, -0.5);
    vec2 outsideUv = screenUv;
    outsideUv += center;
    outsideUv -= uCoords.xy / uResolution.xy;
    outsideUv = (outsideUv - 0.5) + 0.5;
    outsideUv -= center;
    vec2 s = (uSize / uResolution) * uScale;
    float isOutside = 1.0 - rectangle(outsideUv, s);
    
    vec2 mid = vec2(0.5);
    vec2 insideUv = (screenUv - mid + s * mid) / s;
    vec4 background = texture2D(tInput, screenUv);
    vec4 image = texture2D(tMap, insideUv);
    gl_FragColor = mix(image, background, isOutside);
}
`, Rx = class extends hn {
    constructor(){
        super(new it({
            vertexShader: BQ,
            fragmentShader: NQ,
            uniforms: {
                tInput: new le(null),
                tMap: new le(null),
                uResolution: new le(new k),
                uSize: new le(new k),
                uCoords: new le(new k),
                uScale: new le(1),
                uSceneColor: new le(new We(16711680)),
                uDPR: new le(1),
                uCurrent: new le(0)
            }
        }), "tInput"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.tMap.value;
    }
    set texture(t) {
        this.uniforms.tMap.value = t;
    }
};
var FQ = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, VQ = `
uniform sampler2D toScene;
uniform sampler2D fromScene;
uniform vec2 resolution;

uniform vec2 uResolution;
uniform float uDPR;

uniform float mixRatio;
uniform sampler2D tMixTexture;
uniform int useTexture;
uniform float threshold;

void main() {
	vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
	screenUv *= 1.0 / uDPR;

	vec4 texel1 = texture2D( fromScene, screenUv );
	vec4 texel2 = texture2D( toScene, screenUv );

	if (useTexture==1) {
		
		vec4 transitionTexel = texture2D( tMixTexture, screenUv );
		float r = mixRatio * (1.0 + threshold * 2.0) - threshold;
		float mixf=clamp((transitionTexel.r - r)*(1.0/threshold), 0.0, 1.0);
		
		gl_FragColor = mix( texel1, texel2, mixf );
	} else {
		
		gl_FragColor = mix( texel1, texel2, mixRatio );
		
	}
}
`, kQ = [], Lx = class extends hn {
    constructor(){
        super(new it({
            vertexShader: FQ,
            fragmentShader: VQ,
            uniforms: {
                toScene: new le(null),
                fromScene: new le(null),
                uResolution: new le(new k),
                uDPR: new le(1),
                mixRatio: new le(0),
                threshold: new le(.1),
                useTexture: new le(0),
                tMixTexture: {
                    value: kQ[0]
                }
            }
        }), "toScene"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.fromScene.value;
    }
    set texture(t) {
        this.uniforms.fromScene.value = t;
    }
};
var UQ = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, zQ = `
uniform sampler2D inputBuffer;
uniform sampler2D blurredInputBuffer;
uniform sampler2D overlay;
uniform float blurIntensity;

uniform vec2 uResolution;
uniform float uDPR;

void main() {
	vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
	screenUv *= 1.0 / uDPR;

	vec4 texel1 = texture2D( overlay, screenUv );
	vec4 texel2 = texture2D( inputBuffer, screenUv );
	vec4 texel3 = texture2D( blurredInputBuffer, screenUv );

	float blurMask2 = max(sign(texel1.a), 0.0) * blurIntensity;
    gl_FragColor = mix( mix(texel2, texel3, blurMask2), texel1, texel1.a );
}
`, Bx = class extends hn {
    constructor(){
        super(new it({
            vertexShader: UQ,
            fragmentShader: zQ,
            uniforms: {
                inputBuffer: new le(null),
                blurredInputBuffer: new le(null),
                overlay: new le(null),
                uResolution: new le(new k),
                uDPR: new le(1),
                blurIntensity: new le(0)
            }
        }));
        this._blurEnabled = !1;
        this.blurTarget = new dt(1, 1, {
            minFilter: rt,
            magFilter: rt,
            wrapS: Qt,
            wrapT: Qt
        }), this.blurPass = new Mx({
            width: window.innerWidth,
            height: window.innerHeight,
            kernelSize: km.HUGE,
            resolutionScale: .25
        }), this.blurPass.renderToScreen = !1, this.uniforms.blurredInputBuffer.value = this.blurTarget.texture;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.overlay.value;
    }
    set texture(e) {
        this.uniforms.overlay.value = e;
    }
    setResolution(e, r, i = 1) {
        this.uniforms.uResolution.value.set(e, r), this.uniforms.uDPR.value = i, this.blurPass.setSize(e, r), this.blurTarget.setSize(e, r), this.blurPass.setSize(e, r);
    }
    get uiCanvas() {
        return this._uiCanvas;
    }
    set uiCanvas(e) {
        this._uiCanvas = e, e.texture && (this.uniforms.overlay.value = e.texture);
        let i = e.frame;
        if (i) {
            let s = i.data.backgroundBlur, o = s.radius;
            this._blurEnabled = s.enabled, this.uniforms.blurIntensity.value = this._blurEnabled ? 1 : 0, this.blurPass.scale = o / 3;
        }
    }
    render(e, r, i, s, o) {
        this._blurEnabled && (this.blurPass.setDepthTexture(this.getDepthTexture()), this.blurPass.render(e, r, this.blurTarget, s, o)), super.render(e, r, i, s, o);
    }
};
var GQ = `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, jQ = `
uniform sampler2D tInput;
uniform sampler2D tOverlayImage;
varying vec2 vUv;
uniform vec2 uResolution;
uniform vec2 uRightBottom;
uniform vec2 uImageSize;
uniform float uScale;
uniform float uDPR;

vec3 blendNormal(vec3 base, vec3 blend) {
	return blend;
}

vec3 blendNormal(vec3 base, vec3 blend, float opacity) {
	return (blendNormal(base, blend) * opacity + base * (1.0 - opacity));
}

vec4 drawFixedSizeImage(sampler2D image, vec2 screenUV, vec2 imageSize, vec2 imageCoords, vec2 screenSize, float dpr) {
	vec2 uv = (screenUV * screenSize * dpr - imageCoords) / (imageSize * dpr);
	if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
		return vec4(0.0);
	}
	return texture2D(image, uv);
}

void main() {
    vec2 screenUV = gl_FragCoord.xy / (uResolution.xy * uDPR);
	vec2 imageCoords = vec2(uResolution.x * uDPR - uImageSize.x * uScale * uDPR - uRightBottom.x * uDPR, uRightBottom.y * uDPR);
    vec4 background = texture2D(tInput, screenUV);
    vec4 image = drawFixedSizeImage(tOverlayImage, screenUV, uImageSize * uScale, imageCoords, uResolution, uDPR);
    gl_FragColor = vec4(blendNormal(background.rgb, image.rgb, image.a), max(background.a, image.a));
}
`, Nx = class extends hn {
    constructor(){
        super(new it({
            vertexShader: GQ,
            fragmentShader: jQ,
            uniforms: {
                tInput: new le(null),
                tOverlayImage: new le(null),
                uResolution: new le(new k),
                uImageSize: new le(new k),
                uRightBottom: new le(new k(20, 20)),
                uScale: new le(.25),
                uDPR: new le(1)
            }
        }), "tInput");
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.tOverlayImage.value;
    }
    set texture(t) {
        this.uniforms.tOverlayImage.value = t, this.uniforms.uImageSize.value.set(t.image.width, t.image.height);
    }
};
function cL(n1, t) {
    return t && t.enabled && n1.push(t.effect), n1;
}
var HQ = (n1)=>Object.values(Pt).includes(n1) ? n1 : Pt.NORMAL, Um = class extends pr {
    constructor(e, r){
        super();
        this._needsDOFResize = r;
        this.postprocessingState = Hh.defaultData;
        this._scene = new ei;
        this._camera = new wr;
        this.effects = new Map;
        this.blueNoiseTexture = new gi;
        this._renderToScreen = !0;
        this._isUIOverlayEnabled = !1;
        this.clock = new My, this.renderer = e, this.debug = !1, this.effects.set("bloom", new hf), this.effects.set("chromaticAberration", new ff), this.effects.set("vignette", new yf), this.effects.set("noise", new gf), this.effects.set("colorAverage", new pf), this.effects.set("hueSaturation", new mf), this.effects.set("brightnessContrast", new df), this.effects.set("depthOfField", new vf), this.effects.set("pixelation", new xf), this.effectComposer = new Ix(this.renderer), this.effectComposer.autoRenderToScreen = !1, this.opaquePass = new eu(!0, this.scene, this.camera), this.opaquePass.clear = !0, this.transmissionPass = new _x(this.scene, this.camera, this.renderer), this.aoPass = new Ox(this.scene, this.camera), this.taaPass = new Px, this.taaPass.renderToScreen = !1, this.helperPass = new Dx(this.camera), this.helperPass.renderToScreen = !1, this.stylesOverlayPass = new Rx, this.stylesOverlayPass.enabled = !1, this.uiOverlayPass = new Bx, this.uiOverlayPass.enabled = !1, this.logoOverlayPass = new Nx, this.logoOverlayPass.enabled = !1, this.sceneTransitionPass = new Lx, this.sceneTransitionPass.enabled = !1, this._initCopyPass(), this._initPasses();
    }
    set overlayTexture(e) {
        e !== void 0 ? (this.stylesOverlayPass.texture = e, this.stylesOverlayPass.enabled = !0) : this.stylesOverlayPass.enabled = !1;
    }
    get overlayTexture() {
        return this.stylesOverlayPass.texture;
    }
    set sceneHelpers(e) {
        this.helperPass.sceneHelpers = e;
    }
    get sceneHelpers() {
        return this.helperPass.sceneHelpers;
    }
    set sceneHelpersOnTop(e) {
        this.helperPass.sceneHelpersOnTop = e;
    }
    get sceneHelpersOnTop() {
        return this.helperPass.sceneHelpersOnTop;
    }
    get scene() {
        return this._scene;
    }
    set scene(e) {
        this._scene = e, this.opaquePass.setScene(e), this.transmissionPass.setScene(e), this.aoPass.setScene(e);
    }
    get camera() {
        return this._camera;
    }
    set camera(e) {
        let r = this._camera !== e;
        this._camera = e, this.opaquePass.setCamera(e), this.transmissionPass.setCamera(e), r && this.transmissionPass.updatePasses(this.renderer), this.aoPass.setCamera(e), this.helperPass.setCamera(e), this.effects.get("depthOfField").setCamera(e);
    }
    updateRenderToScreen() {
        let e = !1;
        for(let r = this.effectComposer.passes.length - 1; r >= 0; r--){
            let i = this.effectComposer.passes[r];
            if (i.enabled === !0 && !e && this._renderToScreen) {
                i.renderToScreen = !0, e = !0;
                continue;
            }
            i.renderToScreen = !1;
        }
    }
    get isUIOverlayEnabled() {
        return this._isUIOverlayEnabled;
    }
    disableUIOverlay() {
        this._isUIOverlayEnabled = !1;
    }
    enableUIOverlay() {
        this._isUIOverlayEnabled = !0;
    }
    disableHelpers() {
        this.helperPass.enabled = !1, this.updateRenderToScreen();
    }
    enableHelpers() {
        this.helperPass.enabled = !0, this.updateRenderToScreen();
    }
    updateBlueNoiseTexture(e) {
        this.blueNoiseTexture = new gi(e, 128, 128), this.blueNoiseTexture.wrapS = Rs, this.blueNoiseTexture.wrapT = Rs, this.blueNoiseTexture.minFilter = Vt, this.blueNoiseTexture.magFilter = Vt, this.blueNoiseTexture.needsUpdate = !0;
    }
    setAmbientOcclusionParams(e, r, i, s, o, a, l, c) {
        this.aoPass.enabled = e, this.aoPass.radius = r, this.aoPass.bias = i, this.aoPass.aoColor = s, this.aoPass.fogEnabled = o, this.aoPass.fogNear = a, this.aoPass.fogFar = l, this.aoPass.runHalfRes !== !c && (this.aoPass.runHalfRes = !c);
    }
    setTransmissionPassEnabled(e) {
        this.transmissionPass.enabled = e, this.opaquePass.hasTransmissionPass = e;
    }
    _initPasses() {
        if (this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.removeAllPasses(), this.transmissionPass.updatePasses(this.renderer), this.effectComposer.addPass(this.aoPass), this.effectComposer.addPass(this.opaquePass), this.effectComposer.addPass(this.transmissionPass), this.effectComposer.addPass(this.taaPass), this.postprocessingState.enabled) {
            let e = [
                this.effects.get("pixelation")
            ].reduce(cL, []);
            e.length > 0 && (this.uvEffectPass = new $c(this.camera, ...e), this.uvEffectPass.renderToScreen = !1, this.effectComposer.addPass(this.uvEffectPass));
            let r = [
                this.effects.get("chromaticAberration"),
                this.effects.get("bloom"),
                this.effects.get("depthOfField"),
                this.effects.get("colorAverage"),
                this.effects.get("hueSaturation"),
                this.effects.get("brightnessContrast"),
                this.effects.get("vignette"),
                this.effects.get("noise")
            ].reduce(cL, []);
            if (r.length > 0 && (this.effectPass = new $c(this.camera, ...r), this.effectPass.renderToScreen = !1, this.effectComposer.addPass(this.effectPass), this._needsDOFResize && this.effects.get("depthOfField")?.enabled && window !== void 0)) {
                let i = this.renderer.viewportWidth, s = this.renderer.viewportHeight;
                this.renderer.setSize(i - 1, s - 1), this.renderer.setSize(i, s);
            }
        }
        this.effectComposer.addPass(this.stylesOverlayPass), this.effectComposer.addPass(this.uiOverlayPass), this.effectComposer.addPass(this.sceneTransitionPass), this.effectComposer.addPass(this.helperPass), this.effectComposer.addPass(this.logoOverlayPass);
    }
    _initCopyPass() {
        if (this._savePass) return;
        let e = new k;
        this.renderer.getDrawingBufferSize(e), this._rt = new dt(e.x, e.y, {
            depthBuffer: !1,
            stencilBuffer: !1,
            wrapS: Rs,
            wrapT: Rs
        }), this._rt.samples = 0, this._savePass = new Vm(this._rt, !1), this._savePass.renderToScreen = !1;
    }
    setCopyPass(e) {
        this._rt = e, this._savePass = new Vm(this._rt, !1), this.renderToScreen = !1;
    }
    get renderToScreen() {
        return this._renderToScreen;
    }
    set renderToScreen(e) {
        if (this._renderToScreen === e) return;
        let r = this.effectComposer;
        !r || (e === !0 ? r.removePass(this._savePass) : r.addPass(this._savePass), this._renderToScreen = e, this.updateRenderToScreen());
    }
    set sceneTransitionFromTexture(e) {
        e !== this.sceneTransitionPass.texture && (e !== null ? this.sceneTransitionPass.enabled = !0 : (this.sceneTransitionPass.enabled = !1, this.updateRenderToScreen()), this.sceneTransitionPass.texture = e);
    }
    setWatermark(e) {
        this.logoOverlayPass.enabled = e !== null, e && (this.logoOverlayPass.texture = e);
    }
    get texture() {
        return this._rt && this._rt.texture;
    }
    get renderTarget() {
        return this._rt;
    }
    updatePostprocessing(e) {
        let { enabled: r, ...i } = e, s = !1;
        r !== this.postprocessingState.enabled && (s = !0);
        for (let o of Object.entries(i)){
            let a = o[1], l = this.effects.get(o[0]);
            if (l) {
                l.enabled !== a.enabled && (s = !0), l.enabled = a.enabled;
                for (let [c, u] of Object.entries(a))c === "blendFunction" ? l.blendFunction = HQ(u) : l[c] = u;
            }
        }
        this.postprocessingState = e, s && this._initPasses();
    }
    render() {
        this.effectComposer.render(this.clock.getDelta());
    }
    setScissor(e, r, i, s) {
        e instanceof Ze ? (this.effectComposer.inputBuffer.scissor.set(e.x, e.y, e.z, e.w), this.effectComposer.outputBuffer.scissor.set(e.x, e.y, e.z, e.w)) : (this.effectComposer.inputBuffer.scissor.set(e, r, i, s), this.effectComposer.outputBuffer.scissor.set(e, r, i, s));
        let o = this.renderer.getPixelRatio();
        this.effectComposer.inputBuffer.scissor.multiplyScalar(o), this.effectComposer.outputBuffer.scissor.multiplyScalar(o), this.renderer.setScissor(e, r, i, s);
    }
    setScissorTest(e) {
        this.effectComposer.inputBuffer.scissorTest = e, this.effectComposer.outputBuffer.scissorTest = e, this.renderer.setScissorTest(e);
    }
    setViewport(e, r, i, s) {
        e instanceof Ze ? (this.effectComposer.inputBuffer.viewport.copy(e), this.effectComposer.outputBuffer.viewport.copy(e)) : (this.effectComposer.inputBuffer.viewport.set(e, r, i, s), this.effectComposer.outputBuffer.viewport.set(e, r, i, s));
    }
    resize(e, r, i) {
        if (this.effectComposer.setSize(e, r, i), this._rt) {
            let s = this.renderer.getPixelRatio();
            this._rt.setSize(e * s, r * s);
        }
    }
    dispose() {
        this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.dispose();
    }
};
var WQ = (n1)=>`

// PCSS implementation based on:
// https://www.gamedev.net/articles/programming/graphics/contact-hardening-soft-shadows-made-fast-r4906/
// NOTE: This number affects how big the shadow blur can
// possibly get. Bigger number == bigger blur, but less precise results

const float  gPenumbraFilterSize = 80.0;
const int   gPenumbraSamples = ${n1};
const int gShadowSamples = ${n1};
const float gShadowSamplesRpc = 1.0f / float(gShadowSamples);

#ifdef USE_SHADOWMAP
    #if NUM_DIR_LIGHT_SHADOWS > 0

        uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
        varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];

        struct DirectionalLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];

    #endif

    #if NUM_SPOT_LIGHT_SHADOWS > 0

        uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
        varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_SHADOWS ];

        struct SpotLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];

    #endif

    #if NUM_POINT_LIGHT_SHADOWS > 0

        uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
        varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];

        struct PointLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
            float shadowCameraNear;
            float shadowCameraFar;
        };

        uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];

    #endif

    /*
    #if NUM_RECT_AREA_LIGHTS > 0

        // TODO (abelnation): create uniforms for area light shadows

    #endif
    */

float computePenumbra(int index, sampler2D shadowMap, float temporalAngle, float texelSize, vec2 uv, float compare, float texelScalar, float shadowRadius)
{
    float penumbra = 1.0;
    float blockerDepthAvg = 0.0;
    float blockerCount = 0.0;

    #pragma unroll_loop_start
    for(int i = 0; i < gPenumbraSamples; i ++)
    {
        vec2 offset = (vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize) * texelScalar;
        float depth = unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) );

        if(depth < compare + 0.0001)
        {
            blockerDepthAvg += depth;
            blockerCount++;
        }
    }
    #pragma unroll_loop_end

    if (blockerCount > 0.0)
    {
        blockerDepthAvg /= blockerCount;

        // Compute penumbra
        penumbra = (compare - blockerDepthAvg) / (blockerDepthAvg);
        penumbra *= penumbra;
        penumbra *= 200.0 * penumbraSize[min(index, ${5} - 1)]; // Magic number that affects how quickly the penumbra grows

        return clamp(penumbra, 0.00, 1.0);
    }
    return 0.0;
}

float vogelShadow(int index, sampler2D shadowMap, vec2 uv, float texelSize, float compare, float shadowRadius)
{
    float shadow         = 0.0f;

    // NOTE: When using TAA, we should use screen space interleaved gradient noise
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    float texelScalar = (gPenumbraFilterSize) / (texelSize * 1024.);
    float penumbra = computePenumbra(index, shadowMap, temporalAngle, texelSize, uv, compare, texelScalar, shadowRadius);
    if (penumbra == -1.0) {
        return 1.0;
    }

    #pragma unroll_loop_start
    for (int i = 0; i < gShadowSamples; i++)
    {
        vec2 vogelSample =  vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;
        // Overall blurring offset
        vec2 offset = vogelSample * (shadowRadius * 2.);

        // Penumbra offset
        offset += vogelSample * (penumbra * texelScalar);

        shadow += step( compare, unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) ) );
    }
    #pragma unroll_loop_end

    return shadow * gShadowSamplesRpc;
}


    float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {

        return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );

    }

    vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {

        return unpackRGBATo2Half( texture2D( shadow, uv ) );

    }

    float VSMShadow (sampler2D shadow, vec2 uv, float compare ){

        float occlusion = 1.0;

        vec2 distribution = texture2DDistribution( shadow, uv );

        float hard_shadow = step( compare , distribution.x ); // Hard Shadow

        if (hard_shadow != 1.0 ) {

            float distance = compare - distribution.x ;
            float variance = max( 0.00000, distribution.y * distribution.y );
            float softness_probability = variance / (variance + distance * distance ); // Chebeyshevs inequality
            softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 ); // 0.3 reduces light bleed
            occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );

        }
        return occlusion;

    }

    float getShadow( int i, sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {

        float shadow = 1.0;

        shadowCoord.xyz /= shadowCoord.w;
        shadowCoord.z += shadowBias;

        // if ( something && something ) breaks ATI OpenGL shader compiler
        // if ( all( something, something ) ) using this instead

        bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );
        bool inFrustum = all( inFrustumVec );

        bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );

        bool frustumTest = all( frustumTestVec );

        if ( frustumTest ) {

        #if defined( SHADOWMAP_TYPE_PCF )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            return vogelShadow(i, shadowMap, shadowCoord.xy, texelSize.x, shadowCoord.z, shadowRadius );

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            float dx = texelSize.x;
            float dy = texelSize.y;

            vec2 uv = shadowCoord.xy;
            vec2 f = fract( uv * shadowMapSize + 0.5 );
            uv -= f * texelSize;

            shadow = (
                texture2DCompare( shadowMap, uv, shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
                          f.x ),
                     mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
                          f.x ),
                     f.y )
            ) * ( 1.0 / 9.0 );

        #elif defined( SHADOWMAP_TYPE_VSM )

            shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );

        #else // no percentage-closer filtering:

            shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );

        #endif

        }

        return shadow;

    }

    // cubeToUV() maps a 3D direction vector suitable for cube texture mapping to a 2D
    // vector suitable for 2D texture mapping. This code uses the following layout for the
    // 2D texture:
    //
    // xzXZ
    //  y Y
    //
    // Y - Positive y direction
    // y - Negative y direction
    // X - Positive x direction
    // x - Negative x direction
    // Z - Positive z direction
    // z - Negative z direction
    //
    // Source and test bed:
    // https://gist.github.com/tschw/da10c43c467ce8afd0c4

    vec2 cubeToUV( vec3 v, float texelSizeY ) {

        // Number of texels to avoid at the edge of each square

        vec3 absV = abs( v );

        // Intersect unit cube

        float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
        absV *= scaleToCube;

        // Apply scale to avoid seams

        // two texels less per square (one texel will do for NEAREST)
        v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );

        // Unwrap

        // space: -1 ... 1 range for each square
        //
        // #X##         dim    := ( 4 , 2 )
        //  # #         center := ( 1 , 1 )

        vec2 planar = v.xy;

        float almostATexel = 1.5 * texelSizeY;
        float almostOne = 1.0 - almostATexel;

        if ( absV.z >= almostOne ) {

            if ( v.z > 0.0 )
                planar.x = 4.0 - v.x;

        } else if ( absV.x >= almostOne ) {

            float signX = sign( v.x );
            planar.x = v.z * signX + 2.0 * signX;

        } else if ( absV.y >= almostOne ) {

            float signY = sign( v.y );
            planar.x = v.x + 2.0 * signY + 2.0;
            planar.y = v.z * signY - 2.0;

        }

        // Transform to UV space

        // scale := 0.5 / dim
        // translate := ( center + 0.5 ) / dim
        return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );

    }

    float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {

        float shadow = 1.0;
        vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );

        // for point lights, the uniform @vShadowCoord is re-purposed to hold
        // the vector from the light to the world-space position of the fragment.
        vec3 lightToPosition = shadowCoord.xyz;

        // dp = normalized distance from light to fragment position
        float compare = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear ); // need to clamp?
        compare += shadowBias;

        // bd3D = base direction 3D
        vec3 bd3D = normalize( lightToPosition );

        vec2 halton = haltonSequence[frameIndex];
        float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
        float temporalAngle  = temporalOffset * PI2;

        #if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_VSM )
            for (int i = 0; i < gShadowSamples; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                // NOTE: Removed for now
                // Penumbra offset
                //offset += vec3(vogelSample.x, vogelSample.y, vogelSample.y)  * (penumbra * gPenumbraFilterSize);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * gShadowSamplesRpc;

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )
            for (int i = 0; i < 16; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * (1.0 / 16.0);
        #else // no percentage-closer filtering

            return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), compare );

        #endif

    }

#endif
`, qQ = xt.lights_fragment_begin, YQ = xt.shadowmask_pars_fragment, uL = null, XQ = (n1)=>{
    switch(n1){
        case "low":
            return 8;
        case "medium":
            return 16;
        case "high":
            return 32;
        default:
            return 16;
    }
}, hL = (n1 = "medium")=>{
    if (uL === n1) return !1;
    uL = n1;
    let t = XQ(n1);
    xt.shadowmap_pars_fragment = WQ(t);
    let e = qQ.slice();
    e = e.replace("getShadow( spotShadowMap[ i ]", `getShadow( UNROLLED_LOOP_INDEX + ${3}, spotShadowMap[ i ]`), e = e.replace("getShadow( directionalShadowMap[ i ]", "getShadow( UNROLLED_LOOP_INDEX, directionalShadowMap[ i ]"), xt.lights_fragment_begin = e;
    let r = YQ.slice();
    return r = r.replaceAll("getShadow(", "getShadow( UNROLLED_LOOP_INDEX, "), xt.shadowmask_pars_fragment = r, !0;
};
var KQ = `
attribute vec3 randomColor;
varying vec3 vNormal;
flat out vec3 vColor;
#include <skinning_pars_vertex>
#include <morphtarget_pars_vertex>
	
void main()
{
#include <beginnormal_vertex>
#include <morphnormal_vertex>
#include <skinbase_vertex>
#include <skinnormal_vertex>
vec3 transformed = vec3(position);
#include <morphtarget_vertex>
#include <skinning_vertex>

vNormal = normal;
vColor = randomColor;
gl_Position = projectionMatrix * (modelViewMatrix * vec4(transformed, 1.0));
}
`, QQ = `
uniform float depthContrast;
varying vec3 vNormal;
flat in vec3 vColor;
void main()
{
vec3 normal = (normalize(vNormal)).rgb;

float contrastDepth = (gl_FragCoord.z - 0.5) * depthContrast + 0.5;

vec3 resultColor = mix(mix(vColor, normal, 0.2), vec3(contrastDepth), 0.4);
gl_FragColor = vec4(resultColor, vColor.r);
gl_FragColor = vec4(resultColor, vColor.r);
}
`, Fx = new it({
    vertexShader: KQ,
    fragmentShader: QQ,
    uniforms: {
        depthContrast: {
            value: 1
        }
    }
});
var dL = new er, fL = new k, Vx = class extends zw {
    constructor(e){
        super(e);
        this._pixelRatio = this.getPixelRatio();
        this.viewportWidth = 1;
        this.viewportHeight = 1;
        this.resolution = new k;
        this.dummyCamera = new wr;
        this.sceneTransitionDuration = 0;
        this.sceneTransitionTimeRemaining = -1;
        this.isXRCopyPassSet = !1;
        this.clear = (e = !0, r = !0, i = !0)=>{
            let s = this.getContext(), o = 0;
            e && (o |= s.COLOR_BUFFER_BIT), r && (o |= s.DEPTH_BUFFER_BIT), i && (o |= s.STENCIL_BUFFER_BIT), s.clear(o), s.clearBufferfv(s.COLOR, 1, [
                0,
                0,
                0,
                1
            ]);
        };
        this.pipeline = new Um(this, e?.needsDOFResize ?? !1), this.autoClear = !1;
        let r = this.setPixelRatio.bind(this), i = this.setSize.bind(this);
        this.shadowMap.enabled = !0, this.shadowMap.type = Oy, this.dummyCamera.matrixAutoUpdate = !1, this.domElement.removeAttribute("data-engine");
        let s = this.getContext();
        if (s && "drawingBufferColorSpace" in s) try {
            s.drawingBufferColorSpace = "display-p3";
        } catch (o) {
            console.warn(o);
        }
        this.setPixelRatio = (o)=>{
            this._pixelRatio !== o && (this._pixelRatio = o, r(o));
        }, this.setSize = (o, a, l = !0)=>{
            (this.viewportWidth !== o || this.viewportHeight !== a) && (this.viewportWidth = o, this.viewportHeight = a, i(o, a, l), this.normalRenderTarget?.setSize(o * this._pixelRatio, a * this._pixelRatio), this._resizeTransmission(o, a), this.transmissionDepthTarget?.setSize(o * this._pixelRatio / 2, a * this._pixelRatio / 2), this.pipeline.resize(o, a, l));
        }, this._superDispose = this.dispose, this.dispose = this._currentDispose;
    }
    createAORenderTarget() {
        this.aoRenderTarget === void 0 && (this.aoRenderTarget = new dt(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: rt,
            magFilter: rt,
            wrapS: Qt,
            wrapT: Qt,
            depthBuffer: !1
        }));
    }
    _resizeTransmission(e, r) {
        this.transmissionRenderTarget?.setSize(e * this._pixelRatio / (this.hdTransmission ? 1 : 2), r * this._pixelRatio / (this.hdTransmission ? 1 : 2)), this.aoRenderTarget?.setSize(e * this._pixelRatio / 1, r * this._pixelRatio / 1);
    }
    get hdTransmission() {
        return $e.transmissionLod.value === 1;
    }
    set hdTransmission(e) {
        $e.transmissionLod.value = e === !0 ? 1 : 2, this._resizeTransmission(this.viewportWidth, this.viewportHeight);
    }
    createTransmissionRenderTarget() {
        this.transmissionRenderTarget === void 0 && (this.transmissionRenderTarget = new dt(this.viewportWidth * this._pixelRatio / (this.hdTransmission ? 1 : 2), this.viewportHeight * this._pixelRatio / (this.hdTransmission ? 1 : 2), {
            generateMipmaps: !0,
            minFilter: yc,
            magFilter: rt,
            wrapS: Qt,
            wrapT: Qt,
            depthBuffer: !1
        }), this.transmissionDepthTarget = new dt(this.viewportWidth * this._pixelRatio / 2, this.viewportHeight * this._pixelRatio / 2, {
            minFilter: Vt,
            magFilter: Vt,
            depthBuffer: !1
        }));
    }
    createNormalRenderTarget() {
        this.normalRenderTarget === void 0 && (this.normalRenderTarget = new dt(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: Vt,
            magFilter: Vt,
            type: br,
            depthTexture: new ns(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio)
        }));
    }
    renderNormal(e, r, i) {
        this.normalRenderTarget && (this.setClearColor(0), i.layers.enable(8), i.layers.disable(0), i.layers.disable(3), r.traverseEntity((s)=>{
            s.layers.isEnabled(8) && (s.copyPreviousMatrix = !1);
        }), this.setRenderTarget(this.normalRenderTarget), this.clear(), i instanceof wr ? Fx.uniforms.depthContrast.value = (i.far - i.near) / 1e4 : Fx.uniforms.depthContrast.value = 1, r.overrideMaterial = Fx, this.render(r, i), this.setClearColor(r.bgColor, r.bgColor.a), this.setRenderTarget(null), r.overrideMaterial = e.wireframeState ? kx : null, i.layers.enable(0), i.layers.enable(3), r.traverseEntity((s)=>{
            s.layers.isEnabled(8) && (s.copyPreviousMatrix = !0);
        }));
    }
    renderSplineSceneWithDummyCamera(e, r, i = 1) {
        this.dummyCamera.updateCameraState(r.dataPatched), this.dummyCamera.matrix.copy(r.matrixWorld);
        let s = r.height, o = r.width, a = this.viewportWidth / this.viewportHeight;
        o < s ? o = s * a : s = o / a, this.dummyCamera.setViewplaneSize(o, s);
        for(let l = 0; l < i; l++)this.renderSplineScene(e, this.dummyCamera);
    }
    renderSplineScene(e, r, { sceneHelpers: i = this.sceneHelpers, sceneHelpersOnTop: s = this.sceneHelpersOnTop, overrideTransmission: o, overrideNormal: a } = {}) {
        let l = e instanceof Kl ? e.activePage : e, c = l.visible;
        l.visible = !0;
        let u = l.scene;
        this.xr.enabled && (this.isXRCopyPassSet === !1 && this.getRenderTarget() !== null && (this.pipeline.setCopyPass(this.getRenderTarget()), this.isXRCopyPassSet = !0), this.xr.updateCamera(r)), this.setClearColor(l.bgColor, l.bgColor.a), l.penumbraSizeArray.forEach((p, m)=>{
            $e.penumbraSize.value[m] = p;
        }), $e.pixelRatioNode.value = this.getPixelRatio(), this.resolution.x !== 0 && this.resolution.y !== 0 ? $e.resolution.value.set(this.resolution.x, this.resolution.y) : $e.resolution.value.set(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio), a !== void 0 ? ($e.normalRenderTarget.value = a, $e.normalRenderTargetDepth.value = dL) : u.needsNormal() && (this.createNormalRenderTarget(), $e.normalRenderTarget.value = this.normalRenderTarget.texture, $e.normalRenderTargetDepth.value = this.normalRenderTarget.depthTexture, this.renderNormal(u, l, r));
        let h = l.data.ao, d = h.occlusion;
        if (d && (this.createAORenderTarget(), $e.aoRenderTarget.value = this.aoRenderTarget.texture), $e.aoEnabled.value = d, this.pipeline.setAmbientOcclusionParams(h.occlusion, h.radius, h.bias, l.aoColor, l.fog !== null, l.backupFog.near, l.backupFog.far, h.aoFullRes && !xo), this.pipeline.aoPass.setBlueNoiseTexture(this.pipeline.blueNoiseTexture), this.pipeline.isUIOverlayEnabled && l.uiCanvas?.enabled && l.uiCanvas.texture && l.uiCanvas.texture.image.width > 0) {
            let p = this.getSize(fL), m = this.getPixelRatio();
            (l.uiCanvas.width !== this.viewportWidth || l.uiCanvas.height !== this.viewportHeight || l.uiCanvas.dpr !== m) && l.uiCanvas.applySize({
                width: this.viewportWidth,
                height: this.viewportHeight
            }, m), l.uiCanvas.render(this), this.pipeline.uiOverlayPass.uiCanvas = l.uiCanvas, this.pipeline.uiOverlayPass.enabled = !0, this.pipeline.uiOverlayPass.setResolution(p.x, p.y, m), this.pipeline.updateRenderToScreen();
        } else this.pipeline.uiOverlayPass.enabled = !1, this.pipeline.updateRenderToScreen();
        if (this.pipeline.logoOverlayPass.enabled) {
            let p = this.getSize(fL), m = this.getPixelRatio();
            this.pipeline.logoOverlayPass.uniforms.uResolution.value.set(p.x, p.y), this.pipeline.logoOverlayPass.uniforms.uDPR.value = m;
        }
        let f = !1;
        if (o !== void 0) $e.transmissionRenderTarget.value = o, $e.transmissionRenderTargetDepth.value = dL, this.pipeline.setTransmissionPassEnabled(!1);
        else {
            let p = u.needsTransmission();
            p && (this.transmissionRenderTarget === void 0 && (f = !0), this.createTransmissionRenderTarget(), $e.transmissionRenderTarget.value = this.transmissionRenderTarget.texture, $e.aspectRatio.value = ER(this.viewportWidth, this.viewportHeight), $e.transmissionRenderTargetDepth.value = this.transmissionDepthTarget.texture), this.pipeline.setTransmissionPassEnabled(p);
        }
        r.layers.enable(3), r.layers.enable(8), this.pipeline.sceneHelpers = i, this.pipeline.sceneHelpersOnTop = s, this.pipeline.scene = l, this.pipeline.camera = r, f && this.pipeline.transmissionPass.updatePasses(this), this.pipeline.postprocessingState !== l.postprocessing && (this.pipeline.updatePostprocessing(l.postprocessing), !i && !s && this.pipeline.disableHelpers()), this.clearAlphaOverride !== void 0 && this.setClearAlpha(this.clearAlphaOverride), l.overrideMaterial = u.wireframeState ? kx : null, this.pipeline.render(), $e.frameIndex.value = ($e.frameIndex.value + 1) % 16, r instanceof wr && r.copyHistory(), l.visible = c;
    }
    renderFromSceneForSceneTransitionPass(e, r, i) {
        this.pipeline.renderToScreen = !1, this.pipeline.renderTarget, this.renderSplineScene(e, r), this.pipeline.sceneTransitionFromTexture = this.pipeline.renderTarget.texture, this.sceneTransitionDuration = i, this.sceneTransitionTimeRemaining = i, this.pipeline.renderToScreen = !0;
        let s = this.pipeline.sceneTransitionPass.uniforms;
        s.uDPR.value = window.devicePixelRatio, s.uResolution.value.set(this.domElement.width, this.domElement.height).divideScalar(window.devicePixelRatio);
    }
    _currentDispose() {
        this._superDispose(), this.pipeline.dispose(), this.aoRenderTarget?.dispose(), this.transmissionRenderTarget?.dispose(), this.transmissionDepthTarget?.dispose(), this.normalRenderTarget?.dispose(), this.normalRenderTarget?.depthTexture?.dispose();
    }
};
var Af = class extends Uo(Iy) {
    constructor(e, r = 15, i = 10066329){
        super(e, r, i);
        this.object = e;
        this.added = !1;
        this.name = `DirectionalLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        zo(this.object, Af.geometryHelper, e, r);
    }
};
var Ef = class extends Uo(_y) {
    constructor(e, r = 15, i = 6710886){
        super(e, r, i);
        this.object = e;
        this.name = `PointLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        zo(this.object, Ef.geometryHelper, e, r);
    }
};
var Ux = class extends Uo(Py) {
    constructor(e, r = 6710886){
        super(e, r);
        this.object = e;
        this.name = `SpotLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        zo(this.object, Ux.geometryHelper, e, r);
    }
    update() {
        if (this.object !== void 0) {
            let e = Ux._vector, r = this.object.distance ? this.object.distance : 1e3, i = r * Math.tan(this.object.angle);
            this.cone.scale.set(i, i, r), e.setFromMatrixPosition(this.object.target.matrixWorld), this.cone.lookAt(e);
            let s = this.color !== void 0 ? this.color : this.light.color;
            if (this.cone.material instanceof Array) for(let o = 0, a = this.cone.material.length; o < a; o++)this.cone.material[o].color.set(s);
            else this.cone.material.color.set(s);
        }
    }
}, zm = Ux;
zm._vector = new E;
var Tf = class extends sn {
    constructor(){
        super();
        this.caretIndex = 0;
        this._caretVisibleAlpha = 1;
        this._selectionVisibleAlpha = .3;
        this.current = {
            start: 0,
            end: void 0
        };
        this.matrixAutoUpdate = !1, this.caretMesh = new zt(new Li(1, 1), new on({
            transparent: !0,
            opacity: 0,
            side: fi
        })), this.add(this.caretMesh), this.selectionMesh = new zt(new Li(1, 1), new on({
            color: 2857471,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1,
            opacity: 0,
            side: fi
        })), this.add(this.selectionMesh), this.hide();
    }
    get caretHeight() {
        return this.object?.AD ?? 0;
    }
    show(e) {
        this.visible = !0, this.object = e, this.caretMesh.scale.set(1, this.caretHeight, 1), this.caretMesh.position.y = -this.caretHeight * .5, this.setCaretPosition(this.caretIndex), this.update();
    }
    hide() {
        this.visible = !1;
    }
    update() {
        if (this.object === void 0) return;
        this.updateHelperMatrix();
        let { depth: e } = this.object.geometry.userData.parameters;
        this.caretMesh.position.z = e, this.selectionMesh.position.z = e;
    }
    updateHelperMatrix() {
        if (this.object === void 0) return;
        let e = this.object, r = e.parent;
        r !== null && r.updateWorldMatrix(!0, !1), e.matrixAutoUpdate && e.updateMatrix(), r !== null ? (this.matrixWorld.multiplyMatrices(r.matrixWorld, e.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, e.matrix)) : this.matrixWorld.multiplyMatrices(e.hiddenMatrix, e.matrix), this.matrix.copy(this.matrixWorld);
        for (let i of this.children)i.matrixWorld.copy(this.matrixWorld);
        e.updateWorldMatrix(!0, !0);
    }
    setCaretColor(e) {
        let r = this.caretMesh.material;
        r.color.setRGB(e.r, e.g, e.b);
        let i = this._caretVisibleAlpha === r.opacity;
        this._caretVisibleAlpha = e.a, i && (r.opacity = this._caretVisibleAlpha);
    }
    setSelectionColor(e) {
        this.selectionMesh.material.color.setRGB(e.r, e.g, e.b);
    }
    setCaretPosition(e, r = {}) {
        if (this.object === void 0) return;
        this.caretIndex = e;
        let i = this.object.wrappedText, [s, o] = zx(i, e), [a, l] = e > 0 ? zx(i, e - 1) : [
            null,
            null
        ];
        (e > 0 && i.length ? i[a].charAt(l) : null) === `
` && (s++, o = 0), this.current.start = e, this.current.end = void 0;
        let [u, h] = JE(this.object, s, o), { AD: d, descender: f } = this.object, p = f + d * .5, { width: m, height: g, depth: y } = this.object.geometry.userData.parameters, x = typeof m == "string" ? 0 : m, v = typeof g == "string" ? 0 : g;
        this.caretMesh.scale.set(1, this.caretHeight, 1), this.caretMesh.position.set(u - x * .5, h + p + v * .5, y), this.hideSelectionMesh(), this.showCaretMesh();
    }
    setSelection(e, r) {
        if (this.object === void 0) return;
        let i = this.object.wrappedText;
        this.current.start = e, this.current.end = r;
        let s = [], o = [], a = $Q(i, e, r), { lineHeight: l, AD: c, descender: u } = this.object, h = u + c * .5 - l * .5;
        for (let [x, v, S] of a)if (v !== S) {
            let [w, A] = JE(this.object, x, v), [T, b] = JE(this.object, x, S);
            A += h, b += h, b += l;
            let M = s.length / 3;
            s.push(w, A, 0), s.push(T, A, 0), s.push(T, b, 0), s.push(w, b, 0), o.push(M + 0, M + 1, M + 2), o.push(M + 2, M + 3, M + 0);
        }
        let d = new _e;
        d.setIndex(o), d.setAttribute("position", new Te(s, 3));
        let { width: f, height: p, depth: m } = this.object.geometry.userData.parameters, g = typeof f == "string" ? 0 : f, y = typeof p == "string" ? 0 : p;
        this.selectionMesh.geometry.dispose(), this.selectionMesh.geometry = d, this.selectionMesh.position.x = -g * .5, this.selectionMesh.position.y = y * .5, this.selectionMesh.position.z = m, this.showSelectionMesh(), this.hideCaretMesh();
    }
    getSelectionFromPosition(e, r, i = "previous") {
        if (this.object === void 0 || this.object.font === void 0) return;
        let s = this.object.wrappedText, o = s.length, a = this.object.lineHeight, l = o * a, { height: c, verticalAlign: u } = this.object.geometry.userData.parameters, h = typeof c == "string" ? 0 : c, d = 0;
        u === 3 ? d = h - l : u === 2 && (d = h * .5 - l * .5);
        let f = Math.min(Math.floor(Math.max(Math.min(-r - d, l), 0) / a), o - 1), p = this.object.charCoords[f], m = this.object.charWidths[f], g = 0, y = !1;
        if (i === "previous") {
            for(let v = 0; v < p.length; v++)if (p[v][0] + m[v] * .5 - e > 0) {
                g = v, y = !0;
                break;
            }
        } else if (i === "closest") {
            let v = 1 / 0;
            for(let S = 0; S < p.length; S++){
                let w = p[S][0] + m[S] * .5, A = Math.abs(w - e);
                A < v && (v = A, g = S, y = !0);
            }
        } else for(let v = 0; v < p.length; v++){
            let S = p[v][0], w = p[v][0] + m[v];
            if (e >= S && e < w) {
                g = v, y = !0;
                break;
            }
        }
        return y || (g = p.length), {
            index: this.getGlobalIndexFromLineAndCharIndexes(s, f, g),
            lineIndex: f,
            characterIndex: g
        };
    }
    getGlobalIndexFromLineAndCharIndexes(e, r, i) {
        return e.slice(0, r).reduce((s, o)=>s += o.length, 0) + i;
    }
    showSelectionMesh() {
        this.selectionMesh.material.opacity = this._selectionVisibleAlpha;
    }
    hideSelectionMesh() {
        this.selectionMesh.material.opacity = 0;
    }
    showCaretMesh() {
        this.caretMesh.material.opacity = this._caretVisibleAlpha;
    }
    hideCaretMesh() {
        this.caretMesh.material.opacity = 0;
    }
};
function JE(n1, t, e) {
    let { charCoords: r, charWidths: i, initialOffsetY: s, lineHeight: o } = n1;
    if (r[t] && r[t].length === 0 || r.length === 0) {
        let u = 0, { horizontalAlign: h } = n1.data.geometry, d = n1.wrappedText, { width: f } = n1.geometry.userData.parameters;
        return d.length === 1 && d[0].length === 0 && (h === 3 ? u = f * .5 : h === 2 && (u = f)), [
            u,
            s - o * t
        ];
    }
    let a = r[t];
    if (a === void 0 || a.length === 0) return [
        0,
        0
    ];
    let [l, c] = a[Math.min(e, a.length - 1)];
    return e >= a.length && (l += i[t][e - 1]), [
        l,
        c
    ];
}
function zx(n1, t) {
    let e = 0;
    for(let r = 0; r < n1.length; r++){
        let i = n1[r], s = t - e;
        if (s <= i.length) return [
            r,
            s
        ];
        e += i.length;
    }
    return [
        Math.max(0, n1.length - 1),
        n1[n1.length - 1]?.length ?? 0
    ];
}
function $Q(n1, t, e) {
    let [r, i] = zx(n1, t), [s, o] = zx(n1, e), a = [];
    i >= n1[r].length && (r++, i = 0);
    for(let l = r; l <= s; l++){
        let c = n1[l], u = l === r ? i : 0, h = l === s ? o : c.length;
        a.push([
            l,
            u,
            h
        ]);
    }
    return a;
}
function pL(n1, t) {
    let e = ri.fromHex(3223857), r = .8;
    for (let i of n1.layers){
        if (i.data.type === "light" || i.data.type === "displace" || i.data.type === "fresnel" || i.data.type === "matcap" || i.data.type === "texture" || i.data.type === "toon" || i.data.type === "outline" || i.data.type === "transmission" || i.data.type === "noise") continue;
        let s = typeof i.data.alpha == "string" ? Number(t.getVariable(i.data.alpha)) : i.data.alpha;
        if (i.data.type === "color" && s > .3) {
            e = eZ(i.data.color, t), r = s;
            break;
        } else if ((i.data.type === "depth" || i.data.type === "gradient") && s > .3) {
            let o = tZ(i.data);
            e = {
                r: o[0],
                g: o[1],
                b: o[2]
            }, r = typeof i.data.alpha == "string" ? 1 : i.data.alpha;
            break;
        }
    }
    return {
        ...e,
        a: r
    };
}
function eZ(n1, t) {
    return typeof n1 == "string" ? t.data.colors[n1] : n1;
}
function tZ(n1) {
    return n1.colors[0];
}
function rZ(n1, t) {
    n1.shadow.camera.right = t / 2, n1.shadow.camera.left = -t / 2, n1.shadow.camera.top = t / 2, n1.shadow.camera.bottom = -t / 2, n1.shadow.needsUpdate = !0;
}
var Mf = class extends cf(Ty, Af) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 2048, this.shadow.mapSize.height = 2048, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.top = 1250, s.bottom = -1250, s.right = 1250, s.left = -1250, s.near = -10000, s.far = 2500;
        let o = new ul(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o;
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof ul && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e);
        let r = t.depth !== void 0 && t.depth !== this.shadow.camera.far || t.size !== void 0 && t.size / 2 !== this.shadow.camera.right;
        t.size !== void 0 && rZ(this, t.size), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null)), t.penumbraSize !== void 0 && e.scene.markPenumbraSizeDirty(), r && this.update();
    }
};
var mL = new E, gL = new E, yL = new Ke, Cf = class extends cf(Ay, zm) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.fov = we.RAD2DEG * 2 * this.angle, s.aspect = 1, s.near = 100, s.far = 2500;
        let o = new ul(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o, this.update();
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof ul && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), gL.setFromMatrixPosition(this.matrixWorld), yL.setFromRotationMatrix(this.matrixWorld), mL.copy(this.up).applyQuaternion(yL).negate().multiplyScalar(this.distance), this.target.position.copy(gL).add(mL), this.target.updateMatrixWorld(), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.angle !== void 0 && (this.angle = t.angle), t.penumbra !== void 0 && (this.penumbra = t.penumbra), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.penumbraSize !== void 0 && e.scene.markPenumbraSizeDirty(), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
function iZ(n1) {
    let t = (n1[0][0] + n1[1][1]) / 2, e = (n1[0][0] - n1[1][1]) / 2, r = (n1[1][0] + n1[0][1]) / 2, i = (n1[1][0] - n1[0][1]) / 2, s = Math.sqrt(t * t + i * i), o = Math.sqrt(e * e + r * r), a = s + o, l = s - o, c = Math.atan2(r, e), u = Math.atan2(i, t), h = (u - c) / 2, d = (u + c) / 2, f = [
        [
            Math.cos(d),
            Math.sin(d)
        ],
        [
            -Math.sin(d),
            Math.cos(d)
        ]
    ], p = [
        [
            a,
            0
        ],
        [
            0,
            l
        ]
    ], m = [
        [
            Math.cos(h),
            Math.sin(h)
        ],
        [
            -Math.sin(h),
            Math.cos(h)
        ]
    ];
    return f[0][0] *= -1, f[0][1] *= -1, m[0][0] *= -1, m[1][0] *= -1, [
        f,
        p,
        m
    ];
}
function Gx(n1, t) {
    return [
        [
            n1[0][0] * t[0][0] + n1[0][1] * t[1][0],
            n1[0][0] * t[0][1] + n1[0][1] * t[1][1]
        ],
        [
            n1[1][0] * t[0][0] + n1[1][1] * t[1][0],
            n1[1][0] * t[0][1] + n1[1][1] * t[1][1]
        ]
    ];
}
function vL(n1) {
    return [
        [
            n1[0][0],
            n1[1][0]
        ],
        [
            n1[0][1],
            n1[1][1]
        ]
    ];
}
function xL(n1) {
    let [t, e, r] = iZ(n1), i = Gx(t, vL(r)), s = Gx(Gx(r, e), vL(r)), o = Math.atan2(i[1][0], i[0][0]), a = [
        s[0][0],
        s[1][1]
    ], l = [
        s[0][1] / s[1][1],
        s[1][0] / s[0][0]
    ];
    return {
        rotation: o,
        scale: a,
        shear: l
    };
}
function bL({ rotation: n1, scale: t, shear: e }) {
    let r = Math.cos(n1), i = Math.sin(n1), s = [
        [
            r,
            -i
        ],
        [
            i,
            r
        ]
    ], o = [
        [
            t[0],
            e[0] * t[1]
        ],
        [
            e[1] * t[0],
            t[1]
        ]
    ], a = Gx(s, o);
    return [
        a[0][0],
        a[1][0],
        a[0][1],
        a[1][1]
    ];
}
var St;
((w)=>{
    function n1() {
        return [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    w.identity = n1;
    function t(A, T = w.identity()) {
        for(let b = 0, M = A.length; b < M; b++)T[b] = A[b];
        return T;
    }
    w.copy = t;
    function e(A, T, b, M, C, P) {
        return w.setAbcdef(w.identity(), A, T, b, M, C, P);
    }
    w.create = e;
    function r(A, T, b, M, C, P, I) {
        return A[0] = T, A[1] = M, A[2] = P, A[3] = b, A[4] = C, A[5] = I, A;
    }
    w.setAbcdef = r;
    function i(A, T) {
        let [b, M, C, P, I, _] = o(A), [D, L, j, V, H, W] = o(T), q = D * b + L * C, Q = D * M + L * P, G = j * b + V * C, Z = j * M + V * P, te = H * b + W * C + I, $ = H * M + W * P + _;
        return w.create(q, Q, G, Z, te, $);
    }
    w.append = i;
    function s(A, T) {
        let [b, M, C, P, I, _] = o(A), [D, L, j, V, H, W] = o(T), q = b, Q = M, G = C, Z = P;
        (D !== 1 || L !== 0 || j !== 0 || V !== 1) && (q = b * D + M * j, Q = b * L + M * V, G = C * D + P * j, Z = C * L + P * V);
        let te = I * D + _ * j + H, $ = I * L + _ * V + W;
        return w.create(q, Q, G, Z, te, $);
    }
    w.prepend = s;
    function o(A) {
        return [
            A[0],
            A[3],
            A[1],
            A[4],
            A[2],
            A[5]
        ];
    }
    w.getAbcdef = o;
    function a(A) {
        let [T, b, M, C, P, I] = w.getAbcdef(A), _ = T * C - b * M, D = C / _, L = -b / _, j = -M / _, V = T / _, H = (M * I - C * P) / _, W = -(T * I - b * P) / _;
        return w.create(D, L, j, V, H, W);
    }
    w.invert = a;
    function l([A, T], b) {
        let [M, C, P, I, _, D] = w.getAbcdef(b);
        return [
            M * A + P * T + _,
            C * A + I * T + D
        ];
    }
    w.apply = l;
    function c(A, T) {
        let [b, M, C, P, I, _] = w.getAbcdef(T), D = 1 / (b * P + C * -M), [L, j] = A;
        return [
            P * D * L + -C * D * j + (_ * C - I * P) * D,
            b * D * j + -M * D * L + (-_ * b + I * M) * D
        ];
    }
    w.applyInverse = c;
    function u(A, T, b = T) {
        let [M, C, P, I, _, D] = w.getAbcdef(A);
        return w.setAbcdef(A, M * T, C * b, P * T, I * b, _ * T, D * b), A;
    }
    w.scale = u;
    function h(A, T) {
        let b = Math.cos(T), M = Math.sin(T), [C, P, I, _, D, L] = w.getAbcdef(A);
        return w.setAbcdef(A, C * b - P * M, C * M + P * b, I * b - _ * M, I * M + _ * b, D * b - L * M, D * M + L * b), A;
    }
    w.rotate = h;
    function d(A, T, b) {
        let [M, C] = b, P = w.translate(A, -M, -C);
        return P = w.rotate(P, T), P = w.translate(P, M, C), P;
    }
    w.rotateAround = d;
    function f(A, T, b) {
        let [M, C, P, I, _, D] = w.getAbcdef(A);
        return w.setAbcdef(A, M, C, P, I, _ + T, D + b), A;
    }
    w.translate = f;
    function p(A, T, b) {
        let [M, C, P, I] = w.getAbcdef(A);
        return w.setAbcdef(A, M, C, P, I, T, b), A;
    }
    w.setTranslate = p;
    function m(A, T, b) {
        let [M, C, P, I] = w.getAbcdef(A);
        return w.setAbcdef(A, M, C, P, I, T, b), A;
    }
    w.setPosition = m;
    function g(A) {
        let [T, b, M, C] = w.getAbcdef(A), P = Math.sqrt(T * T + b * b), I = Math.sqrt(M * M + C * C);
        return [
            P,
            I
        ];
    }
    w.getScale = g;
    function y(A) {
        let [, , , , T, b] = w.getAbcdef(A);
        return [
            T,
            b
        ];
    }
    w.getPosition = y;
    function x(A, T) {
        return w.decompose(A, T).rotation;
    }
    w.getRotation = x;
    function v(A, T) {
        let [b, M, C, P, I, _] = w.getAbcdef(A), { rotation: D, scale: L, shear: j } = xL([
            [
                b,
                C
            ],
            [
                M,
                P
            ]
        ]);
        return {
            position: [
                I + (T[0] * b + T[1] * C) - T[0],
                _ + (T[0] * M + T[1] * P) - T[1]
            ],
            scale: L,
            rotation: D,
            shear: j,
            pivot: T
        };
    }
    w.decompose = v;
    function S(A, T, b, M, C = [
        0,
        0
    ]) {
        let [P, I] = A, [_, D] = M, [L, j, V, H] = bL({
            rotation: b,
            scale: T,
            shear: C
        }), W = P - (_ * L + D * V) + _, q = I - (_ * j + D * H) + D;
        return w.create(L, j, V, H, W, q);
    }
    w.compose = S;
})(St || (St = {}));
var nZ = Math.PI / 180, $Be = 180 / Math.PI;
function SL(n1, t, e, r, i, s) {
    let o = n1 - e, a = t - r;
    return o * o / (i * i) + a * a / (s * s) <= 1;
}
function wL(n1) {
    return n1 * nZ;
}
var rr = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.localMatrix = St.identity();
        this.worldMatrix = St.identity();
        this.ignoreCameraZoom = !1;
        this.visible = !0;
        this._singleBBox = new Ql;
        this._recursiveBBox = new Ql;
        this.singleBBoxNeedsUpdate = !0;
        this.recursiveBBoxNeedsUpdate = !0;
        this.stateSelection = null;
        this.prevState = null;
        this.currentState = null;
        this.reversibleToState = null;
        this.currentTransitionEvent = null;
        this.previousAction = null;
        this.name = "";
        this.position = [
            0,
            0
        ];
        this.scale = [
            1,
            1
        ];
        this.rotation = 0;
        this.shear = [
            0,
            0
        ];
        this.emitter = Pa();
        this.dpr = r.dpr ?? 1, this.dataPatched = e;
    }
    project(t, e) {
        let r = this.worldMatrix;
        return e && (r = St.append(e.worldMatrix, r)), St.applyInverse(t, r);
    }
    intersects(t, e, r, i = !1) {
        return this.visible && !this.data.raycastLock && this.intersectsInLocalSpace(...this.project([
            t,
            e
        ], r), i);
    }
    intersectsInLocalSpace(t, e, r = !1) {
        let { min: i, max: s } = r ? this.recursiveBBox : this.singleBBox;
        return t >= i[0] && t <= s[0] && e >= i[1] && e <= s[1];
    }
    applyTransforms(t) {
        t.setTransform(this.worldMatrix, this.ignoreCameraZoom);
    }
    get singleBBox() {
        return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges()), this._singleBBox;
    }
    get recursiveBBox() {
        return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges()), this._recursiveBBox;
    }
    updateLocalMatrix() {
        this.localMatrix = St.compose(this.position, this.scale, wL(this.rotation), Ta.getPivot(this.dataPatched), this.shear);
    }
    updateWorldMatrix(t, e, r) {
        let i = this.parent;
        e && i !== null && i !== void 0 && i.updateWorldMatrix(t, !0, !1), t && this.updateLocalMatrix(), this.parent ? this.worldMatrix = St.append(this.parent.worldMatrix, this.localMatrix) : this.worldMatrix = St.copy(this.localMatrix), this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
    }
    get pivot() {
        return Ta.getPivot(this.data);
    }
    getCenter() {
        return [
            0,
            0
        ];
    }
    getHalfSize() {
        return [
            0,
            0
        ];
    }
    get id() {
        return this.uuid;
    }
    resetBBoxNeedsUpdateSelf() {
        this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
    }
    resetBBoxNeedsUpdate() {
        this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((t)=>{
            t.resetBBoxNeedsUpdateSelf();
        });
    }
    updateTransformState(t) {
        let e = !1;
        t.position !== void 0 && (e = !0, this.position = t.position), t.rotation !== void 0 && (e = !0, this.rotation = t.rotation), t.scale !== void 0 && (e = !0, this.scale = t.scale), t.shear !== void 0 && (e = !0, this.shear = t.shear), e && (this.updateWorldMatrix(!0, !1, !0), this.resetBBoxNeedsUpdate());
    }
    updateByOp(t, e, r) {
        t.type === 0 && t.props.visible !== void 0 && (this.visible = t.props.visible), this.data = e, this.data = e;
        let i = t, s = Lt(t.path, [
            "states",
            "*"
        ]);
        if (s !== null) {
            if (t.type === 0) {
                let [o] = s;
                if (this?.stateSelection === o) {
                    let a = {
                        ...t.props
                    };
                    if (delete a.name, Object.values(t.props).some((l)=>l === void 0)) {
                        let l = this.data;
                        if (l !== void 0) {
                            let c = Sr.zoom(l, t.path.slice(2));
                            if (c) for(let u in t.props)t.props[u] === void 0 && u in c && (a[u] = c[u]);
                        }
                    }
                    i = {
                        ...t,
                        props: a,
                        path: t.path.slice(2)
                    };
                }
            }
        } else if (t.type === 0) {
            let o = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
            if (o !== void 0) {
                if (t.props.name !== void 0 && o.name) {
                    let { name: l, ...c } = o;
                    o = c;
                }
                let a = Sr.removeOverridden(t.path, t.props, o);
                i = {
                    ...t,
                    props: a
                };
            }
        }
        this.updateByPatchedOpBase(i, Ea.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), r);
    }
    changeSelectedState(t, e, r = !1) {
        if (!(this.data.states.length === 0 && !r)) {
            for (let i of this.data.states)Ea.toOps(this.data, i.data).forEach((o)=>{
                let a = Nh.replaceProps(o, this.data);
                this.dataPatched = this.data, this.updateByPatchedOp(a, this.data, e);
            });
            if (t !== null) {
                let i = this.data.states.data(t);
                i && (this.dataPatched = Ea.patch(this.data, i), Ea.toOps(this.data, i).forEach((o)=>{
                    this.updateByPatchedOp(o, this.dataPatched, e);
                }));
            }
            r && this.updateTransformState(this.dataPatched), this.stateSelection = t;
        }
    }
    updateState(t, e) {
        t.name !== void 0 && (this.name = t.name), t.visible !== void 0 && (this.visible = t.visible), this.updateTransformState(t);
    }
    updateByPatchedOpBase(t, e, r) {
        this.dataPatched = e, this.updateByPatchedOp(t, e, r);
    }
    updateByPatchedOp(t, e, r) {
        t.path.length === 0 && t.type === 0 && this.updateState(t.props, r), this.requestRender();
    }
    traverseFrameAncestors(t) {
        this.traverseAncestors((e)=>{
            e.data.type === "frame2d" && t(e);
        });
    }
    traverseAncestors(t) {
        let e = this.parent;
        for(; e;)t(e), e = e.parent;
    }
    requestRender() {
        this.traverseFrameAncestors((t)=>{
            t.requestRender();
        });
    }
    clone(t) {
        let e = new rr(this.uuid, this.data, t);
        return e.parent = void 0, e;
    }
    addEventListener(t, e) {
        this.emitter.on(t, e);
    }
    removeEventListener(t, e) {
        this.emitter.off(t, e);
    }
    dispatchEvent(t) {
        this.emitter.emit(t.type, {
            ...t,
            target: t.target ?? this
        });
    }
    traverseSortNextHelper() {
        let t = this.parent;
        if (t) {
            let e = t.children;
            if (e) {
                let r = e.indexOf(this) + 1;
                return e[r] ? e[r] : t.traverseSortNextHelper();
            }
        }
    }
    sortNext() {
        let t = this.children;
        return t && t.length > 0 && t[0] ? t[0] : this.traverseSortNextHelper();
    }
    isDescendantOf(t) {
        t instanceof rr && (t = t.uuid);
        let e = this;
        for(; e.parent;){
            if (e.parent.uuid === t) return !0;
            e = e.parent;
        }
        return !1;
    }
};
var Zi = class extends rr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.context = i;
        this.children = [];
    }
    add(e) {
        e.parent && e.parent instanceof Zi && e.parent.remove(e), this.children.push(e), e.parent = this;
    }
    remove(e) {
        let r = this.children.indexOf(e);
        r >= 0 && (this.children.splice(r, 1), e.parent = void 0);
    }
    traverse(e) {
        let r = e(this);
        if (r !== !0) for (let i of this.children)i instanceof Zi ? i.traverse(e) : r = e(i);
    }
    intersectsChildrenHelper(e, r, i, s, o) {
        for (let a of this.children)if (a.intersects(e, r, i, !1) && (o.push(a), s) || a instanceof Zi && a.intersectsChildrenHelper(e, r, i, s, o)) return !0;
        return !1;
    }
    intersectsChildren(e, r, i, s = !1, o = [], a = !1) {
        return this.intersectsChildrenHelper(e, r, i, s, o), o;
    }
    intersectsChildrenHelperReverse(e, r, i, s, o) {
        for (let a of this.children)if (a instanceof Zi && a.intersectsChildrenHelperReverse(e, r, i, s, o) || a.intersects(e, r, i, !1) && (o.push(a), s)) return !0;
        return !1;
    }
    intersectsChildrenReverse(e, r, i, s = !1, o = [], a = !1) {
        return this.intersectsChildrenHelperReverse(e, r, i, s, o), o;
    }
    updateWorldMatrix(e, r, i) {
        if (super.updateWorldMatrix(e, r, i), i && this.children) for (let s of this.children)s.updateWorldMatrix(e, !1, !0);
    }
    find(e) {
        let r;
        return this.traverse((i)=>{
            i.uuid === e && (r = i);
        }), r;
    }
    innerDrawChildren(e) {
        for(let r = this.children.length - 1; r >= 0; r--)this.children[r].draw(e);
    }
    resetBBoxNeedsUpdate() {
        super.resetBBoxNeedsUpdate(), this.traverse((e)=>{
            e.resetBBoxNeedsUpdateSelf();
        });
    }
    clone(e) {
        let r = new Zi(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
}, kn = class extends Zi {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.updateState(r, i);
    }
    draw(e) {
        !this.visible || (e.save(), this.applyTransforms(e), this.innerDrawChildren(e), e.restore());
    }
    clone(e) {
        let r = new kn(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
};
function sZ(n1, t) {
    let [[e, r], [i, s]] = n1, [[o, a], [l, c]] = t, u = (e - i) * (a - c) - (r - s) * (o - l);
    if (u === 0) return !1;
    let h = ((e - o) * (a - c) - (r - a) * (o - l)) / u, d = -((e - i) * (r - a) - (r - s) * (e - o)) / u;
    return h >= 0 && h <= 1 && d >= 0 && d <= 1;
}
var EL = [
    [
        -1,
        1
    ],
    [
        -1,
        -1
    ],
    [
        1,
        -1
    ],
    [
        1,
        1
    ]
], AL = (n1, t, e)=>{
    let r = n1.getCenter(), i = n1.getHalfSize(), s = St.append(t, n1.worldMatrix);
    i[0] === 0 && i[1] === 0 ? e.push(St.apply(r, s)) : EL.forEach((o)=>{
        let a = [
            o[0] * i[0] + r[0],
            o[1] * i[1] + r[1]
        ];
        e.push(St.apply(a, s));
    });
}, Ql = class {
    constructor(){
        this.matrix = St.identity();
        this.min = [
            1 / 0,
            1 / 0
        ];
        this.max = [
            -1 / 0,
            -1 / 0
        ];
        this.vertices = [];
        this.edges = [];
    }
    setFromObjectSize(t, e = !1) {
        t.updateWorldMatrix(), this.makeEmpty(), St.copy(t.worldMatrix, this.matrix);
        let r = St.invert(t.worldMatrix);
        this.expandByObjectSize(t, r, e);
    }
    expandByObjectSize(t, e, r = !1) {
        let i = [];
        r === !0 && t instanceof Zi ? t.traverse((s)=>{
            s.visible && AL(s, e, i);
        }) : AL(t, e, i), this.setFromPoints(i);
    }
    setFromSize(t, e, r) {
        this.makeEmpty(), St.copy(r, this.matrix), this.expandBySize(t, e, r);
    }
    expandBySize(t, e, r) {
        [
            St.apply([
                0,
                0
            ], r),
            St.apply([
                0,
                e
            ], r),
            St.apply([
                t,
                e
            ], r),
            St.apply([
                t,
                0
            ], r)
        ].forEach((s)=>this.expandByPoint(s));
    }
    getCenter() {
        let [t, e] = this.min, [r, i] = this.getHalfSize();
        return St.apply([
            t + r,
            e + i
        ], this.matrix);
    }
    getSize() {
        return [
            this.max[0] - this.min[0],
            this.max[1] - this.min[1]
        ];
    }
    getHalfSize() {
        return [
            (this.max[0] - this.min[0]) * .5,
            (this.max[1] - this.min[1]) * .5
        ];
    }
    makeEmpty() {
        this.min = [
            1 / 0,
            1 / 0
        ], this.max = [
            -1 / 0,
            -1 / 0
        ];
    }
    setFromPoints(t) {
        this.makeEmpty();
        for (let e of t)this.expandByPoint(e);
    }
    expandByPoint(t) {
        this.min = [
            Math.min(this.min[0], t[0]),
            Math.min(this.min[1], t[1])
        ], this.max = [
            Math.max(this.max[0], t[0]),
            Math.max(this.max[1], t[1])
        ];
    }
    computeVertices() {
        let [t, e] = this.getHalfSize(), r = this.getCenter(), [i, s, o, a] = St.getAbcdef(this.matrix), l = St.create(i, s, o, a, r[0], r[1]);
        this.vertices = EL.map(([c, u])=>St.apply([
                c * t,
                u * e
            ], l));
    }
    computeEdges() {
        this.edges = [];
        for(let t = 0, e = this.vertices.length; t < e; ++t)this.edges.push([
            this.vertices[t],
            this.vertices[(t + 1) % e]
        ]);
    }
    project(t, e) {
        let r = this.matrix;
        return e && (r = St.append(e.worldMatrix, r)), St.applyInverse(t, r);
    }
    intersects(t, e, r) {
        return this.intersectsInLocalSpace(...this.project([
            t,
            e
        ], r));
    }
    intersectsInLocalSpace(t, e) {
        let { min: r, max: i } = this;
        return t >= r[0] && t <= i[0] && e >= r[1] && e <= i[1];
    }
    containsPoint(t) {
        let [e, r] = t, [i, s] = this.min, [o, a] = this.max;
        return e >= i && e <= o && r >= s && r <= a;
    }
    intersectsBBox2D(t) {
        for(let e = 0, r = this.edges.length; e < r; e++){
            let i = this.edges[e];
            for(let s = 0, o = t.edges.length; s < o; s++){
                let a = t.edges[s];
                if (sZ(i, a)) return !0;
            }
        }
        for(let e = 0, r = t.vertices.length; e < r; e++){
            let i = t.vertices[e];
            if (this.containsPoint(i)) return !0;
        }
        return !1;
    }
    ensureMinMax() {
        let t = this.min, e = this.max;
        this.min = [
            Math.min(t[0], e[0]),
            Math.min(t[1], e[1])
        ], this.max = [
            Math.max(t[0], e[0]),
            Math.max(t[1], e[1])
        ];
    }
    copy(t) {
        this.min = [
            ...t.min
        ], this.max = [
            ...t.max
        ], St.copy(t.matrix, this.matrix), this.computeVertices(), this.computeEdges();
    }
    clone() {
        let t = new Ql;
        return t.copy(this), t;
    }
};
var ML, CL = new Promise((n1)=>{
    ML = n1;
}), TL = !1;
var jx;

function PL() {
    if (TL) return;
    if (jx) return jx;
    async function n1() {
        let e = await (parcelRequire("836Xp"));
        ML(e.default ?? e), TL = !0;
    }
    return jx = n1(), jx;
}
function eT(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        (r.type === "Mesh" && r.geometry.type === "UIGeometry" || r.type === "Page" && r.uiFrame !== void 0) && (t = !0);
    }), t;
}
var pt, $E;
async function oZ(n1) {
    let t = await CL;
    pt || ($E || ($E = t({
        locateFile: ()=>n1
    })), pt = await $E);
}
var _L = St.identity(), Gm = class {
    constructor(t, e = 1){
        this.canvas = t;
        this._dpr = e;
        this._width = 0;
        this._height = 0;
        this._strokeMode = "inside";
        this._layerBlur = 0;
        this._backgroundBlur = 0;
        this._dropShadowBlur = 0;
        this._dropShadowOffsetX = 0;
        this._dropShadowOffsetY = 0;
        this._dropShadowColor = bt.transparent;
        this._innerShadowBlur = 0;
        this._innerShadowOffsetX = 0;
        this._innerShadowOffsetY = 0;
        this._innerShadowSpread = 0;
        this._innerShadowColor = bt.transparent;
        this._fonts = new Map;
        this._isSizeDirty = !1;
        try {
            let r = t.getBoundingClientRect();
            t.width = r.width * e, t.height = r.height * e;
        } catch  {
            console.log(t.width, e);
        }
        this._currentM3Transform = _L, this._currentTransform = new Float32Array(_L);
    }
    get dpr() {
        return this._dpr;
    }
    set dpr(t) {
        this._dpr = t, this._isSizeDirty = !0;
    }
    async init() {
        if (!this.wasmURL) throw Error("Your must set the wasm binary url with renderer.wasmURL = ... before you can call renderer.init");
        await oZ(this.wasmURL), this._surface = pt.MakeWebGLCanvasSurface(this.canvas), this.ctx = this._surface?.getCanvas(), this._paint = new pt.Paint, this._paint.setAntiAlias(!0), this._paintFill = this._paint.copy(), this._paintFill.setStyle(pt.PaintStyle.Fill), this._paintStroke = this._paint.copy(), this._paintStroke.setStyle(pt.PaintStyle.Stroke), this.ctx?.scale(this.dpr, this.dpr);
    }
    get currentTransform() {
        return this._currentM3Transform;
    }
    get currentTransformBuffer() {
        return this._currentTransform;
    }
    set currentTransform(t) {
        this._currentM3Transform = t, this._currentTransform.set(t);
    }
    async loadFont(t, e) {
        let r = await (await fetch(t)).arrayBuffer();
        this.registerFont(r, e);
    }
    registerFont(t, e) {
        if (this._fonts.has(e)) return;
        let r = pt.FontMgr.FromData(t);
        if (r) this._fonts.set(e, r);
        else throw new Error("Invalid font data for " + e);
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    set strokeColor(t) {
        this._paintStroke && this._paintStroke.setColor(Hx(t), pt.ColorSpace.DISPLAY_P3);
    }
    set fillColor(t) {
        this._paintFill && this._paintFill.setColor(Hx(t), pt.ColorSpace.DISPLAY_P3);
    }
    set lineWidth(t) {
        this._paintStroke && this._paintStroke.setStrokeWidth(this._strokeMode === "center" ? t : t * 2);
    }
    set strokeMode(t) {
        this._strokeMode = t;
    }
    set dropShadowBlur(t) {
        this._dropShadowBlur = t;
    }
    set dropShadowColor(t) {
        this._dropShadowColor = t;
    }
    set dropShadowOffsetX(t) {
        this._dropShadowOffsetX = t;
    }
    set dropShadowOffsetY(t) {
        this._dropShadowOffsetY = t;
    }
    set innerShadowBlur(t) {
        this._innerShadowBlur = t;
    }
    set innerShadowColor(t) {
        this._innerShadowColor = t;
    }
    set innerShadowOffsetX(t) {
        this._innerShadowOffsetX = t;
    }
    set innerShadowOffsetY(t) {
        this._innerShadowOffsetY = t;
    }
    set innerShadowSpread(t) {
        this._innerShadowSpread = t;
    }
    set layerBlur(t) {
        this._layerBlur = t;
    }
    set backgroundBlur(t) {
        this._backgroundBlur = t;
    }
    clear() {
        this.ctx?.clear(pt.TRANSPARENT);
    }
    save() {
        this.ctx?.save();
    }
    restore() {
        this.ctx?.restore();
    }
    beginPath() {
        this._currentPath?.delete(), this._currentPath = new pt.Path;
    }
    closePath() {
        let t = this._currentPath;
        if (t) {
            if (t.isEmpty()) return;
            let e = t.getBounds();
            (e[3] - e[1] || e[2] - e[0]) && t.close();
        }
    }
    fill() {
        this._paintInner(this._paintFill, !0);
    }
    stroke() {
        this._paintInner(this._paintStroke, !1);
    }
    clipRect(t, e, r, i, s = 0, o = 0, a = 0, l = 0) {
        let c = pt.XYWHRect(t, e, r, i);
        if (s === 0 && o === 0 && l === 0 && a === 0) this.ctx?.clipRect(c, pt.ClipOp.Intersect, !0);
        else {
            let u = pt.RRectXY(c, s, s);
            u[4] = u[5] = s, u[6] = u[7] = o, u[8] = u[9] = a, u[10] = u[11] = l, this.ctx?.clipRRect(u, pt.ClipOp.Intersect, !0);
        }
    }
    _applyShadowOffsetMatrix() {
        if (this.ctx) {
            let t = St.invert(this.currentTransform);
            this.ctx.concat(t);
            let e = St.translate(St.identity(), this._dropShadowOffsetX, this._dropShadowOffsetY);
            this.ctx.concat(e), this.ctx.concat(this._currentTransform);
        }
    }
    _applyEffectsToPaint(t, e, r = !0) {
        if (this.ctx && this._currentPath) {
            let i, s = !1;
            if (r && this._hasDropShadow()) {
                let o = t.copy();
                o.setColor(Hx(this._dropShadowColor));
                let a;
                this._dropShadowBlur > 0 && (a = pt.MaskFilter.MakeBlur(pt.BlurStyle.Normal, this._dropShadowBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(a)), this.ctx.save(), this.ctx.clipPath(this._currentPath, pt.ClipOp.Difference, !0), this._applyShadowOffsetMatrix(), e(o), this.ctx.restore(), o.delete(), a?.delete();
            }
            if (this._backgroundBlur > 0 && r) {
                this.ctx.save(), this.ctx.clipPath(this._currentPath, pt.ClipOp.Intersect, !0);
                let o = pt.ImageFilter.MakeBlur(this._backgroundBlur, this._backgroundBlur, pt.TileMode.Clamp, null), a = t.copy();
                a.setImageFilter(o), a.setAlphaf(1);
                let l = this._currentPath.computeTightBounds();
                this.ctx.saveLayer(a, l, null, pt.SaveLayerInitWithPrevious), this.ctx.drawColor(t.getColor()), this.ctx.restore(), this.ctx.restore(), a.delete(), o.delete(), s = !0;
            }
            if (this._layerBlur > 0) {
                let o = t.copy();
                i = pt.MaskFilter.MakeBlur(pt.BlurStyle.Normal, this._layerBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(i), e(o), o.delete(), i.delete(), s = !0;
            }
            if (s || e(t), r && this._hasInnerShadow()) {
                let o = new pt.Paint;
                o.setAntiAlias(!0), o.setStyle(pt.PaintStyle.Fill), o.setColor(Hx(this._innerShadowColor));
                let a;
                this._innerShadowBlur > 0 && (a = pt.MaskFilter.MakeBlur(pt.BlurStyle.Normal, this._innerShadowBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(a));
                let l = this._currentPath.computeTightBounds(), [c, u, h, d] = l, f = h - c, p = d - u;
                this.ctx.save(), this.ctx.clipPath(this._currentPath, pt.ClipOp.Intersect, !0), this.ctx.saveLayer(o, l, null, pt.SaveLayerInitWithPrevious), this.ctx?.translate(this._innerShadowOffsetX, this._innerShadowOffsetY), this.ctx.drawRect(pt.XYWHRect(-1000 - this._innerShadowOffsetX, -1000 - this._innerShadowOffsetY, 2e3 + f + Math.abs(this._innerShadowOffsetX * 2), 2e3 + p + Math.abs(this._innerShadowOffsetY * 2)), o), o.setBlendMode(pt.BlendMode.Clear), this.ctx.drawPath(this._currentPath, o), this.ctx.restore(), this.ctx.restore(), o.delete(), a?.delete();
            }
        }
    }
    _paintInner(t, e = !0) {
        if (this.ctx && this._currentPath && t) {
            let r = this.ctx, i = this._currentPath;
            this._applyEffectsToPaint(t, (s)=>{
                let o = !1;
                !e && this._strokeMode !== "center" && (r.save(), r.clipPath(i, this._strokeMode === "outside" ? pt.ClipOp.Difference : pt.ClipOp.Intersect, !0), o = !0), r.drawPath(i, s), o && r.restore();
            }, e);
        }
    }
    _hasDropShadow() {
        return this._dropShadowColor?.a > 0;
    }
    _hasInnerShadow() {
        return this._innerShadowColor?.a > 0;
    }
    path(t) {
        this._currentPath?.addPath(pt.Path.MakeFromSVGString(t));
    }
    ellipse(t, e, r, i, s, o, a, l) {
        if (!IL([
            t,
            e,
            r,
            i
        ]) || !this._currentPath) return;
        if (r < 0 || i < 0) throw Error("radii cannot be negative");
        let c = pt.XYWHRect(t - r, e - i, r * 2, i * 2);
        this._currentPath?.addOval(c);
    }
    rect(t, e, r, i, s = 0, o = 0, a = 0, l = 0) {
        let c = pt.XYWHRect(t, e, r, i);
        if (!!IL(c)) {
            if (s === 0 && o === 0 && l === 0 && a === 0) this._currentPath?.addRect(c);
            else {
                let u = pt.RRectXY(c, s, s);
                u[4] = u[5] = s, u[6] = u[7] = o, u[8] = u[9] = a, u[10] = u[11] = l, this._currentPath?.addRRect(u);
            }
        }
    }
    getHorizontalAlign(t) {
        switch(t){
            case 2:
                return pt.TextAlign.Right;
            case 3:
                return pt.TextAlign.Center;
            case 4:
                return pt.TextAlign.Justify;
            case 1:
            default:
                return pt.TextAlign.Left;
        }
    }
    drawTextInner(t, e, r, [i, s, o, a], l, c, u = !0) {
        let h = 0, { ctx: d } = this;
        if (!d) return h;
        let f = c.copy(), p = c.copy();
        return p.setAlphaf(0), this._applyEffectsToPaint(f, (m)=>{
            e.pushPaintStyle(r, m, p), e.addText(t);
            let g = e.build();
            g.layout(o);
            let y = s;
            l === 2 ? y += (a - g.getHeight()) / 2 : l === 3 && (y += a - g.getHeight()), d.drawParagraph(g, i, y), h = g.getHeight(), e.reset(), g.delete();
        }, u), f.delete(), p.delete(), h;
    }
    drawText(t, e) {
        let r = 0, i = this._fonts.get(e.font), { ctx: s, _paintFill: o, _paintStroke: a } = this;
        if (i && s) {
            let l = new pt.TextStyle({
                fontFamilies: [
                    e.font
                ],
                fontSize: e.fontSize,
                heightMultiplier: e.lineHeight,
                letterSpacing: e.letterSpacing
            }), c = new pt.ParagraphStyle({
                textStyle: l,
                textAlign: this.getHorizontalAlign(e.horizontalAlign)
            }), u = pt.XYWHRect(e.x, e.y, e.width, e.height), h = pt.ParagraphBuilder.Make(c, i);
            o && (r = this.drawTextInner(t, h, l, u, e.verticalAlign, o, !0)), a && (r = this.drawTextInner(t, h, l, u, e.verticalAlign, a, !1)), h.delete();
        }
        return {
            height: r
        };
    }
    render() {
        this._surface?.flush();
    }
    moveTo(t, e) {
        this._currentPath?.moveTo(t, e);
    }
    lineTo(t, e) {
        this._currentPath?.lineTo(t, e);
    }
    bezierCurveTo(t, e, r, i, s, o) {
        this._currentPath?.cubicTo(t, e, r, i, s, o);
    }
    quadraticCurveTo(t, e, r, i) {
        this._currentPath?.quadTo(t, e, r, i);
    }
    setTransform(t, e = !1) {
        if (!this.ctx) return;
        let r = this.ctx.getTotalMatrix(), i = St.invert(r);
        if (i && this.ctx.concat(i), this.ctx?.scale(this.dpr, this.dpr), this.camera?.enabled && (this.ctx?.concat(this.camera.worldMatrix), e)) {
            let s = St.getScale(this.camera.worldMatrix);
            this.ctx?.scale(1 / s[0], 1 / s[1]);
        }
        this.ctx?.concat(t), this.currentTransform = t;
    }
    transform(t) {
        this.ctx?.concat(t);
    }
    setSize(t, e) {
        !this._isSizeDirty && t === this._width && e === this._height || (this._isSizeDirty = !1, this._width = t, this._height = e, this.canvas.style.width = t + "px", this.canvas.style.height = e + "px", this.canvas.width = t * this.dpr, this.canvas.height = e * this.dpr, this._surface && (this._surface = pt.MakeWebGLCanvasSurface(this.canvas), this.ctx = this._surface?.getCanvas()));
    }
};
function IL(n1) {
    for(let t = 0; t < n1.length; t++)if (n1[t] !== void 0 && !Number.isFinite(n1[t])) return !1;
    return !0;
}
function Hx({ r: n1, g: t, b: e, a: r }) {
    return pt.Color4f(n1, t, e, r);
}
var jm = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = bt.transparent;
        this.blurRadius = 0;
        this.offset = [
            0,
            0
        ];
        this.spread = 0;
        this.update(e);
    }
    update(t) {
        t.color !== void 0 && (this.color = t.color), t.enabled !== void 0 && (this.enabled = t.enabled), t.blurRadius !== void 0 && (this.blurRadius = t.blurRadius), t.offset !== void 0 && (this.offset = t.offset), t.spread !== void 0 && (this.spread = t.spread);
    }
};
var Hm = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.radius = 0;
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.radius !== void 0 && (this.radius = t.radius);
    }
};
var Wx = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = bt.transparent;
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.color !== void 0 && (this.color = t.color);
    }
};
var qx = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = bt.transparent;
        this.thickness = 0;
        this.mode = "inside";
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.color !== void 0 && (this.color = t.color), t.thickness !== void 0 && (this.thickness = t.thickness), t.mode !== void 0 && (this.mode = t.mode);
    }
};
var Ar = class extends rr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.autoClose = !0;
        this.fill = new Wx(e + "-fill", r.fill, i), this.stroke = new qx(e + "-stroke", r.stroke, i), this.dropShadow = new jm(e + "-dropShadow", r.dropShadow, i), this.innerShadow = new jm(e + "-innerShadow", r.innerShadow, i), this.backgroundBlur = new Hm(e + "-backgroundBlur", r.backgroundBlur, i), this.layerBlur = new Hm(e + "-layerBlur", r.layerBlur, i);
    }
    applyFillStroke(e) {
        e.fillColor = this.fill.enabled ? this.fill.color : bt.transparent, e.strokeColor = this.stroke.enabled && this.stroke.thickness > 0 ? this.stroke.color : bt.transparent, e.strokeMode = this.stroke.mode, e.lineWidth = this.stroke.thickness;
    }
    applyFilters(e) {
        this.layerBlur.enabled ? e.layerBlur = this.layerBlur.radius * 5 : e.layerBlur = 0, this.backgroundBlur.enabled ? e.backgroundBlur = this.backgroundBlur.radius * 5 : e.backgroundBlur = 0, this.dropShadow.enabled ? (e.dropShadowBlur = this.dropShadow.blurRadius * 5, e.dropShadowColor = this.dropShadow.color, e.dropShadowOffsetX = this.dropShadow.offset[0], e.dropShadowOffsetY = this.dropShadow.offset[1]) : e.dropShadowColor = bt.transparent, this.innerShadow.enabled ? (e.innerShadowSpread = this.innerShadow.spread, e.innerShadowBlur = this.innerShadow.blurRadius * 5, e.innerShadowColor = this.innerShadow.color, e.innerShadowOffsetX = this.innerShadow.offset[0], e.innerShadowOffsetY = this.innerShadow.offset[1]) : e.innerShadowColor = bt.transparent;
    }
    innerDraw(e) {}
    draw(e) {
        !this.visible || (e.save(), this.applyTransforms(e), this.applyFilters(e), this.applyFillStroke(e), e.beginPath(), this.innerDraw(e), this.autoClose && e.closePath(), this.fill.enabled && e.fill(), this.stroke.enabled && e.stroke(), e.restore());
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.type === 0 && (Lt(e.path, [
            "fill"
        ]) ? this.fill.update(e.props) : Lt(e.path, [
            "stroke"
        ]) ? this.stroke.update(e.props) : Lt(e.path, [
            "dropShadow"
        ]) ? this.dropShadow.update(e.props) : Lt(e.path, [
            "innerShadow"
        ]) ? this.innerShadow.update(e.props) : Lt(e.path, [
            "layerBlur"
        ]) ? this.layerBlur.update(e.props) : Lt(e.path, [
            "backgroundBlur"
        ]) ? this.backgroundBlur.update(e.props) : this.resetBBoxNeedsUpdate());
    }
    updateState(e, r) {
        super.updateState(e, r), e.fill !== void 0 && this.fill.update(e.fill), e.stroke !== void 0 && this.stroke.update(e.stroke), e.dropShadow !== void 0 && this.dropShadow.update(e.dropShadow), e.innerShadow !== void 0 && this.innerShadow.update(e.innerShadow), e.layerBlur !== void 0 && this.layerBlur.update(e.layerBlur), e.backgroundBlur !== void 0 && this.backgroundBlur.update(e.backgroundBlur);
    }
    clone(e) {
        let r = new Ar(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Zl = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.width = 0;
        this.height = 0;
        this.updateState(r, i);
    }
    innerDraw(e) {
        e.ellipse(this.width * .5, this.height * .5, this.width * .5, this.height * .5, 0, 0, Math.PI * 2);
    }
    intersectsInLocalSpace(e, r) {
        return SL(e, r, this.width * .5, this.height * .5, this.width * .5, this.height * .5);
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e);
    }
    clone(e) {
        let r = new Zl(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Es = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.width = 0;
        this.height = 0;
        this.cornerRadius = [
            0,
            0,
            0,
            0
        ];
        this.updateState(r, i);
    }
    innerDraw(e) {
        e.rect(0, 0, this.width, this.height, ...this.cornerRadius);
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateCornerState(e) {
        e.cornerRadius !== void 0 && (this.cornerRadius = e.cornerRadius);
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateCornerState(e);
    }
    clone(e) {
        let r = new Es(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Jl = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this._textHeight = 0;
        this._textHeightDirty = !0;
        this.width = 0;
        this.height = 0;
        this.updateState(r, i);
    }
    get textHeight() {
        return this._textHeight;
    }
    applyFillStroke(e) {
        e.fillColor = this.fill.enabled ? this.fill.color : bt.transparent, e.strokeColor = this.stroke.enabled && this.stroke.thickness > 0 ? this.stroke.color : bt.transparent, e.strokeMode = "center", e.lineWidth = this.stroke.thickness;
    }
    innerDraw(e) {
        this._fontHolder?.arrayBuffer && this._fontHolder.arrayBuffer.byteLength > 1 && this.data.font && e.registerFont(this._fontHolder.arrayBuffer, this.data.font);
        let r = this.data.textTransform, i = this.data.text.textValue.toString(), s = r === 2 ? i.toUpperCase() : r === 3 ? i.toLowerCase() : i, { height: o } = e.drawText(s, {
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            fontSize: this.data.fontSize,
            lineHeight: this.data.lineHeight ?? 1,
            letterSpacing: this.data.letterSpacing ?? 0,
            horizontalAlign: this.data.horizontalAlign,
            verticalAlign: this.data.verticalAlign,
            font: this.data.font
        });
        this._textHeight = o;
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateFontState(e, { shared: r }) {
        e.font !== void 0 && (this._fontHolder = r.getFont(e.font), this._fontHolder && !this._fontHolder.isLoaded && this._fontHolder.loadingPromise.then(()=>{
            this.requestRender();
        }));
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateFontState(e, r);
    }
    clone(e) {
        let r = new Jl(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Pf = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.curves = [];
        this.extremasBBox = {
            min: [
                0,
                0
            ],
            max: [
                0,
                0
            ]
        };
        this.updateState(r, i);
    }
    computeExtremas() {
        this.curves.length === 0 && this.computeCurves();
        let e = this.curves.map((s)=>Yx.extremas(s)), r = [
            1 / 0,
            1 / 0
        ], i = [
            -1 / 0,
            -1 / 0
        ];
        for(let s = 0, o = e.length; s < o; s++){
            let a = e[s];
            a[0][0] < r[0] && (r[0] = a[0][0]), a[0][1] < r[1] && (r[1] = a[0][1]), a[1][0] > i[0] && (i[0] = a[1][0]), a[1][1] > i[1] && (i[1] = a[1][1]);
        }
        return this.extremasBBox.min = [
            r[0],
            r[1]
        ], this.extremasBBox.max = [
            i[0],
            i[1]
        ], this.extremasBBox;
    }
    computeCurves() {
        this.curves = [];
        for(let i = 1, s = this.data.points.length; i < s; i++){
            let o = this.data.points[i].data, a = this.data.points[i - 1].data, l = {
                start: a.position,
                cp1: a.controlNext.position,
                cp2: o.controlPrevious.position,
                end: o.position
            };
            this.curves.push(l);
        }
        let e = this.data.points[0].data, r = this.data.points[this.data.points.length - 1].data;
        if (this.data.isClosed) {
            let i = {
                start: r.position,
                cp1: r.controlNext.position,
                cp2: e.controlPrevious.position,
                end: e.position
            };
            this.curves.push(i);
        }
    }
    getCenter() {
        let [e, r] = this.extremasBBox.min, [i, s] = this.getHalfSize();
        return [
            e + i,
            r + s
        ];
    }
    getHalfSize() {
        let { min: e, max: r } = this.extremasBBox;
        return [
            (r[0] - e[0]) * .5,
            (r[1] - e[1]) * .5
        ];
    }
    innerDraw(e) {
        for(let s = 0, o = this.data.points.length; s < o; s++){
            let a = this.data.points[s].data;
            if (s === 0) {
                let [l, c] = a.position;
                e.moveTo(l, c);
            } else {
                let l = this.data.points[s - 1].data, [c, u] = l.controlNext.position, [h, d] = a.controlPrevious.position, [f, p] = a.position, m = {
                    start: l.position,
                    cp1: l.controlNext.position,
                    cp2: a.controlPrevious.position,
                    end: a.position
                };
                Yx.derive(m), e.bezierCurveTo(c, u, h, d, f, p);
            }
        }
        let r = this.data.points[0].data, i = this.data.points[this.data.points.length - 1].data;
        if (this.data.isClosed) {
            let [s, o] = i.controlNext.position, [a, l] = r.controlPrevious.position, [c, u] = r.position;
            e.bezierCurveTo(s, o, a, l, c, u);
        }
    }
    updateState(e, r) {
        super.updateState(e, r), this.computeExtremas();
    }
    clone(e) {
        let r = new Pf(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
}, Yx;
((s)=>{
    function n1(o) {
        let a = o.start, l = o.cp1, c = o.cp2, u = o.end, h = [
            3 * (l[0] - a[0]),
            3 * (l[1] - a[1])
        ], d = [
            3 * (c[0] - l[0]),
            3 * (c[1] - l[1])
        ], f = [
            3 * (u[0] - c[0]),
            3 * (u[1] - c[1])
        ], p = {
            start: h,
            cp: d,
            end: f
        };
        return o.derivative = p, p.derivative = tT.derive(p), p;
    }
    s.derive = n1;
    function t(o, a, l, c = !1) {
        let u = o - 2 * a + l;
        if (u !== 0) {
            let h = -Math.sqrt(Math.abs(a * a - o * l)), d = -o + a, f = -(h + d) / u, p = -(-h + d) / u;
            return [
                f,
                p
            ];
        } else if (a !== l && u === 0) return [
            (2 * a - l) / (2 * (a - l))
        ];
        return [];
    }
    function e(o) {
        let a = o.derivative ?? s.derive(o), l = a.start, c = a.cp, u = a.end;
        return [
            t(l[0], c[0], u[0]),
            t(l[1], c[1], u[1])
        ];
    }
    s.droot = e;
    function r(o) {
        let [a, l] = s.droot(o), c = [
            o.start[0],
            o.end[0]
        ], u = [
            o.start[1],
            o.end[1]
        ];
        for (let h of a)c.push(s.compute(o, Math.min(1, Math.max(0, h)))[0]);
        for (let h of l)u.push(s.compute(o, Math.min(1, Math.max(0, h)))[1]);
        return c.sort((h, d)=>h - d), u.sort((h, d)=>h - d), [
            [
                c[0],
                u[0]
            ],
            [
                c[c.length - 1],
                u[u.length - 1]
            ]
        ];
    }
    s.extremas = r;
    function i(o, a) {
        if (a === 0) return [
            ...o.start
        ];
        if (a === 1) return [
            ...o.end
        ];
        let l = 1 - a, c = l * l, u = a * a, h = c * l, d = c * a * 3, f = l * u * 3, p = a * u;
        return [
            h * o.start[0] + d * o.cp1[0] + f * o.cp2[0] + p * o.end[0],
            h * o.start[1] + d * o.cp1[1] + f * o.cp2[1] + p * o.end[1]
        ];
    }
    s.compute = i;
})(Yx || (Yx = {}));
var tT;
((r)=>{
    function n1(i) {
        let s = i.start, o = i.cp, a = i.end, l = [
            2 * (o[0] - s[0]),
            2 * (o[1] - s[1])
        ], c = [
            2 * (a[0] - o[0]),
            2 * (a[1] - o[1])
        ], u = {
            start: l,
            end: c
        };
        return u.derivative = rT.derive(u), i.derivative = u, u;
    }
    r.derive = n1;
    function t(i) {
        let s = i.derivative ?? r.derive(i), o = s.start, a = s.end;
        return [
            o[0] !== a[0] ? o[0] / (o[0] - a[0]) : 0,
            o[1] !== a[1] ? o[1] / (o[1] - a[1]) : 0
        ];
    }
    r.droot = t;
    function e(i, s) {
        if (s === 0) return [
            ...i.start
        ];
        if (s === 1) return [
            ...i.end
        ];
        let o = 1 - s, a = o * o, l = s * s, c = a, u = o * s * 2, h = l;
        return [
            c * i.start[0] + u * i.cp[0] + h * i.end[0],
            c * i.start[1] + u * i.cp[1] + h * i.end[1]
        ];
    }
    r.compute = e;
})(tT || (tT = {}));
var rT;
((e)=>{
    function n1(r) {
        let i = r.start, s = r.end, o = [
            s[0] - i[0],
            s[1] - i[1]
        ];
        return r.derivative = o, r.derivative;
    }
    e.derive = n1;
    function t(r, i) {
        if (i === 0) return [
            ...r.start
        ];
        if (i === 1) return [
            ...r.end
        ];
        let s = r.start, o = r.end;
        return [
            s[0] + (o[0] - s[0]) * i,
            s[1] + (o[1] - s[1]) * i
        ];
    }
    e.compute = t;
})(rT || (rT = {}));
var Ji = class extends Zi {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.width = 0;
        this.height = 0;
        this.clipped = !0;
        this.background = new Es(e + "-background", ed.defaultData, i), this.background.parent = this, this.updateState(r, i);
    }
    get fill() {
        return this.background.fill;
    }
    get stroke() {
        return this.background.stroke;
    }
    get backgroundBlur() {
        return this.background.backgroundBlur;
    }
    get layerBlur() {
        return this.background.layerBlur;
    }
    get dropShadow() {
        return this.background.dropShadow;
    }
    get innerShadow() {
        return this.background.innerShadow;
    }
    get cornerRadius() {
        return this.background.cornerRadius;
    }
    set cornerRadius(e) {
        this.background.cornerRadius = e;
    }
    updateLocalMatrix() {
        super.updateLocalMatrix(), this.background?.updateLocalMatrix();
    }
    updateWorldMatrix(e, r, i) {
        super.updateWorldMatrix(e, r, i), this.background?.updateWorldMatrix(e, r, i);
    }
    draw(e) {
        if (!this.visible) return;
        e.save();
        let r = this.width, i = this.height;
        this.applyTransforms(e), this.background.width = r, this.background.height = i, this.background.draw(e), this.clipped && e.clipRect(0, 0, r, i, ...this.cornerRadius), this.innerDrawChildren(e), e.restore();
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateCornerState(e) {
        e.cornerRadius !== void 0 && (this.cornerRadius = e.cornerRadius);
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateCornerState(e), e.fill !== void 0 && this.fill.update(e.fill), e.stroke !== void 0 && this.stroke.update(e.stroke), e.dropShadow !== void 0 && this.dropShadow.update(e.dropShadow), e.innerShadow !== void 0 && this.innerShadow.update(e.innerShadow), e.layerBlur !== void 0 && this.layerBlur.update(e.layerBlur), e.backgroundBlur !== void 0 && this.backgroundBlur.update(e.backgroundBlur), e.clipped !== void 0 && (this.clipped = e.clipped);
    }
    requestRender() {
        super.requestRender(), this.dispatchEvent({
            type: "render"
        });
    }
    dispose() {
        this.removeEventListener("render");
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.type === 0 && (Lt(e.path, [
            "fill"
        ]) ? this.fill.update(e.props) : Lt(e.path, [
            "stroke"
        ]) ? this.stroke.update(e.props) : Lt(e.path, [
            "dropShadow"
        ]) ? this.dropShadow.update(e.props) : Lt(e.path, [
            "innerShadow"
        ]) ? this.innerShadow.update(e.props) : Lt(e.path, [
            "layerBlur"
        ]) ? this.layerBlur.update(e.props) : Lt(e.path, [
            "backgroundBlur"
        ]) ? this.backgroundBlur.update(e.props) : this.resetBBoxNeedsUpdate());
    }
    clone(e) {
        let r = new Ji(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
};
var LL = Wa(iT(), 1), Va = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this._pathBBox = new DOMRect;
        this.path = "";
        this.updateState(r, i), this.autoClose = !1, this.computeSVGBBox();
    }
    computeSVGBBox() {
        let e = document.createElementNS("http://www.w3.org/2000/svg", "svg"), r = document.createElementNS("http://www.w3.org/2000/svg", "path");
        document.body.appendChild(e), r.setAttribute("d", this.path), e.appendChild(r), this._pathBBox = r.getBBox(), e.remove();
    }
    innerDraw(e) {
        e.path(this.path);
    }
    intersectsInLocalSpace(e, r) {
        return e >= this._pathBBox.x && e <= this._pathBBox.x + this._pathBBox.width && r >= this._pathBBox.y && r <= this._pathBBox.y + this._pathBBox.height;
    }
    getCenter() {
        return [
            (this._pathBBox.x + this._pathBBox.width) / 2,
            (this._pathBBox.y + this._pathBBox.height) / 2
        ];
    }
    getHalfSize() {
        return [
            (this._pathBBox.x + this._pathBBox.width) / 2,
            (this._pathBBox.y + this._pathBBox.height) / 2
        ];
    }
    updateState(e, r) {
        super.updateState(e, r), e.path !== void 0 && (this.path = e.path, this.computeSVGBBox());
    }
    clone(e) {
        let r = new Va(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
function BL(n1, t = 1, e = 1) {
    if (t <= 0 || e <= 0) return n1;
    let i = (0, LL.parseSVG)(n1).map((s)=>{
        let o = {
            ...s
        };
        return "x" in o && (o.x = o.x * t), "y" in o && (o.y = o.y * e), "x1" in o && (o.x1 = o.x1 * t), "x2" in o && (o.x2 = o.x2 * t), "y1" in o && (o.y1 = o.y1 * e), "y2" in o && (o.y2 = o.y2 * e), "rx" in o && (o.rx = o.rx * t), "ry" in o && (o.ry = o.ry * e), o;
    });
    return NL(i);
}
function NL(n1) {
    let t = [
        "rx",
        "ry",
        "xAxisRotation",
        "largeArc",
        "sweep",
        "x1",
        "y1",
        "x2",
        "y2",
        "x",
        "y"
    ], e;
    return n1.map((r)=>{
        let i = [];
        t.forEach((o)=>{
            if (o in r) {
                let a = r[o] * 1;
                i.length && a >= 0 && i.push(","), i.push(a);
            }
        });
        let s = (e === r.code ? i[0] < 0 ? "" : "," : r.code) + i.join("");
        return e = r.code, s;
    }).join("");
}
function FL(n1, t, e) {
    switch(t.type){
        case "ellipse2d":
            return new Zl(n1, t, e);
        case "rectangle2d":
            return new Es(n1, t, e);
        case "text2d":
            return new Jl(n1, t, e);
        case "vector2d":
            return new Pf(n1, t, e);
        case "path2d":
            return new Va(n1, t, e);
        case "frame2d":
            return new Ji(n1, t, e);
        case "group2d":
        default:
            return new kn(n1, t, e);
    }
}
var nT = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.group = new kn(nT.GROUP_ID, {
            ...Xp.defaultData
        }, r), this.createChildrenObjects(e.objects, this.group, r);
    }
    createObject(t, e, r, i, s, o) {
        let a = FL(t, e, o);
        a && (i.add(a), i.children.splice(s, 0, i.children.pop()), a.updateWorldMatrix(), r.length > 0 && (a instanceof kn || a instanceof Ji) && this.createChildrenObjects(r, a, o));
    }
    createChildrenObjects(t, e, r) {
        let i = 0;
        for (let s of t)this.createObject(s.id, s.data, s.children, e, i, r), i += 1;
    }
    draw(t) {
        this.group.draw(t);
    }
    updateEntityByOp(t, e, r, i) {
        let s = this.find(t);
        if (s) try {
            s.updateByOp(e, r, {
                shared: i
            });
        } catch (o) {
            console.error(o);
        }
    }
    updateTreeByOp(t, e) {
        if (t.path.length === 0 && t.type === 7) {
            let r = t.parent === null ? this.group : this.find(t.parent);
            r !== void 0 && r instanceof Zi && (this.createObject(t.id, t.data, t.children, r, t.localIndex, e), r.requestRender());
        } else if (t.path.length === 0 && t.type === 8) {
            let r = this.find(t.id);
            if (r !== void 0 && r.parent !== void 0 && r.parent instanceof Zi) {
                let i = r.parent;
                r.resetBBoxNeedsUpdate(), i?.remove(r), i?.requestRender();
            }
        } else if (t.path.length === 0 && t.type === 9) {
            let r = this.find(t.id);
            if (r !== void 0) {
                let i = r.parent, s = t.parent === null ? this : this.find(t.parent);
                if (s, s instanceof Zi || s === this) {
                    s.add(r);
                    let o = t.localIndex;
                    s.children.splice(o, 0, s.children.pop()), r.updateWorldMatrix(!0, !1, !0), i?.requestRender(), r.requestRender();
                }
                r.resetBBoxNeedsUpdate();
            }
        }
    }
    add(t) {
        this.group.add(t);
    }
    remove(t) {
        this.group.remove(t);
    }
    traverse(t) {
        this.group.traverse((e)=>{
            e !== this.group && t(e);
        });
    }
    intersectsChildren(t, e, r, i = !1, s = []) {
        return this.group.intersectsChildren(t, e, r, i, s, !0);
    }
    intersectsChildrenReverse(t, e, r, i = !1, s = []) {
        return this.group.intersectsChildrenReverse(t, e, r, i, s, !0);
    }
    find(t) {
        return this.group.find(t);
    }
    get children() {
        return this.group.children;
    }
    project(t, e) {
        return this.group.project(t, e);
    }
    getWithSortKey(t) {
        let e = this.find(t);
        if (e === void 0) return;
        let r = [], i = e;
        for(; i !== this.group;){
            let s = i;
            i = i.parent;
            let o = i.children.indexOf(s);
            r.splice(0, 0, o);
        }
        return {
            entity: e,
            sortKey: r
        };
    }
    getAllSorted(t) {
        let e = [];
        for (let r of t){
            let i = this.getWithSortKey(r.id);
            i !== void 0 && e.push(i);
        }
        return e.sort((r, i)=>hv(r.sortKey, i.sortKey)), e.map((r)=>r.entity);
    }
}, iu = nT;
iu.GROUP_ID = "scene2d";
function sT({ constraints: n1, newParentWidth: t, newParentHeight: e, initialParentWidth: r, initialParentHeight: i, objectInitialWidth: s, objectInitialHeight: o, objectInitialPosition: a }) {
    let { horizontalConstraint: l, verticalConstraint: c } = n1, u = t - r, h = e - i, d = s, f = o, p = a[0], m = a[1];
    if (l !== 0) {
        if (l === 1) p += u;
        else if (l === 3) p += u / 2;
        else if (l === 2) d = Math.max(1, d + u);
        else if (l === 4) {
            let g = t / r;
            d *= g, p *= g;
        }
    }
    if (c !== 0) {
        if (c === 1) m += h;
        else if (c === 3) m += h / 2;
        else if (c === 2) f = Math.max(1, f + h);
        else if (c === 4) {
            let g = e / i;
            f *= g, m *= g;
        }
    }
    return {
        width: d,
        height: f,
        position: [
            p,
            m
        ]
    };
}
var uZ = Wa(iT(), 1);
var MVe = {
    mm: {
        mm: 1,
        cm: .1,
        in: 1 / 25.4,
        pt: 72 / 25.4,
        pc: 6 / 25.4,
        px: -1
    },
    cm: {
        mm: 10,
        cm: 1,
        in: 1 / 2.54,
        pt: 72 / 2.54,
        pc: 6 / 2.54,
        px: -1
    },
    in: {
        mm: 25.4,
        cm: 2.54,
        in: 1,
        pt: 72,
        pc: 6,
        px: -1
    },
    pt: {
        mm: 25.4 / 72,
        cm: 2.54 / 72,
        in: 1 / 72,
        pt: 1,
        pc: 6 / 72,
        px: -1
    },
    pc: {
        mm: 25.4 / 6,
        cm: 2.54 / 6,
        in: 1 / 6,
        pt: 12,
        pc: 1,
        px: -1
    },
    px: {
        mm: 1,
        px: 1,
        cm: 1,
        in: 1,
        pt: 1,
        pc: 1
    }
};
var dZ = `
	varying vec2 vUv;
	void main() {
		vUv = uv;
		gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
	}`, fZ = `
	uniform sampler2D tDiffuse;
	varying vec2 vUv;
	void main() {
		vec4 texel = texture2D( tDiffuse, vUv );
		gl_FragColor = texel;
	}`, pZ = new rl(-1, 1, 1, -1, 0, 1), lT = class extends _e {
    constructor(){
        super(), this.setAttribute("position", new Te([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3)), this.setAttribute("uv", new Te([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}, mZ = new lT, cT = class {
    constructor(t){
        this._mesh = new zt(mZ, t);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(t) {
        t.render(this._mesh, pZ);
    }
    get material() {
        return this._mesh.material;
    }
    set material(t) {
        this._mesh.material = t;
    }
}, VL = new it({
    defines: {},
    uniforms: {
        tDiffuse: new le(null)
    },
    vertexShader: dZ,
    fragmentShader: fZ
}), gZ = new cT(VL), oT = null, aT = null, yZ = ()=>(oT === null && (oT = document.createElement("canvas")), oT), vZ = (n1)=>(aT === null && (aT = new Gm(n1)), aT), xZ = St.identity(), _f = class {
    constructor(t, e, r, i){
        this.uuid = t;
        this.width = e;
        this.height = r;
        this.context = i;
        this.enabled = !0;
        this.isScreenSpace = !1;
        this.dpr = window.devicePixelRatio;
        this.isFrameDirty = !1;
        this.onRenderRequestedDownstream = ()=>{
            this.isFrameDirty = !0, this.context.shared.requestRender();
        };
        this._innerApplySize = ()=>{
            let t = this.width, e = this.height, r = this.dpr;
            this.renderer.dpr = this.isScreenSpace ? r : Math.floor(2048 / Math.max(t, e)), this.renderer.setSize(t, e);
        };
        this.onFrameOverrideObjectEvent = (t)=>{
            if (t.target?.uuid !== void 0) {
                let e = this.frameRoot?.find(t.target.uuid);
                e && e.dispatchEvent({
                    ...t,
                    target: e
                });
            }
        };
        this.scene2d = new iu(we.generateUUID(), l0.defaultData, {
            dpr: window.devicePixelRatio,
            shared: i.shared
        }), this.canvas = yZ(), this.renderer = vZ(this.canvas), this.promise = this.init(), this.renderTarget = new dt(1, 1, {
            type: Wn,
            stencilBuffer: !1,
            depthBuffer: !1
        }), i.shared.addUIBuffer(this.uuid, this.renderTarget), this.textureHolder = i.shared.uiBuffer(this.uuid);
    }
    get canvasTexture() {
        return this._canvasTexture || (this._canvasTexture = new yy(this.canvas)), this._canvasTexture;
    }
    async init() {
        this.renderer instanceof Gm && (this.renderer.wasmURL = X0.skiaWasmUrl), await this.renderer.init();
    }
    render(t) {
        if (this.isFrameDirty) {
            this.isFrameDirty = !1, this._innerApplySize(), this.renderer.clear(), this.frameOverride?.draw(this.renderer), this.renderer.render(), VL.uniforms.tDiffuse.value = this.canvasTexture, this.canvasTexture.needsUpdate = !0;
            let e = t.getRenderTarget();
            t.setRenderTarget(this.renderTarget), t.clear(), gZ.render(t), t.setRenderTarget(e), this.textureHolder?.setNeedsUpdate(!0);
        }
    }
    updateEntity2DByOp(t, e, r, i) {
        this.scene2d.updateEntityByOp(t, e, r, i), this.applySize();
    }
    updateTreeByOp(t, e) {
        this.scene2d.updateTreeByOp(t, e), this.applySize();
    }
    applyOverrides(t) {
        if (this.frameOverride && this.frameRoot) {
            this.frameOverride.position = [
                0,
                0
            ], this.frameOverride.rotation = 0;
            let e = t?.width ?? this.width, r = t?.height ?? this.height;
            this.frameOverride.width = e, this.frameOverride.height = r, this.frameOverride.localMatrix = xZ, this.isScreenSpace && (this.frameOverride.fill.color = bt.from0to1([
                0,
                0,
                0,
                0
            ])), this.frameOverride.data = {
                ...this.frameOverride.data,
                width: e,
                height: r
            }, kL({
                objectOverride: this.frameOverride,
                objectRoot: this.frameRoot,
                newParentWidth: this.frameOverride.width,
                newParentHeight: this.frameOverride.height,
                initialParentWidth: this.frameRoot.width,
                initialParentHeight: this.frameRoot.height
            }), this.frameOverride.updateWorldMatrix(!0, !1, !0);
        }
    }
    applySize(t, e = window.devicePixelRatio) {
        let r = Math.max(1, t?.width ?? this.width), i = Math.max(1, t?.height ?? this.height);
        this.dpr = e, this.width = r, this.height = i, this._innerApplySize();
        let s = 1, o = 512, a = 512;
        (r * e < o || i * e < a) && (s = Math.max(o / (r * e), a / (i * e))), this.renderTarget.setSize(r * e * s, i * e * s), this._canvasTexture?.dispose(), this._canvasTexture = void 0, this.applyOverrides(t), this.frameOverride?.requestRender();
    }
    applyFrame(t) {
        let e = this.context.scene.find2D(t);
        if (!(!e || !(e instanceof Ji))) return this.disposeFrameOverride(), this.frameRoot = e, this.frameOverride = e.clone({
            dpr: this.renderer.dpr,
            shared: this.context.shared
        }), this.scene2d.add(this.frameOverride), this.applySize(), this.frame?.addEventListener("render", this.onRenderRequestedDownstream), this.frameOverride.traverse((r)=>{
            r.addEventListener("beginState", this.onFrameOverrideObjectEvent);
        }), this.frameOverride.traverse((r)=>{
            r.addEventListener("completeState", this.onFrameOverrideObjectEvent);
        }), this.frame?.requestRender(), e;
    }
    get frame() {
        return this.frameOverride;
    }
    get frameId() {
        return this.frame?.uuid;
    }
    find(t) {
        return this.scene2d.find(t);
    }
    get texture() {
        return this.textureHolder?.getTexture(1001);
    }
    disposeFrameOverride() {
        this.frameOverride?.removeEventListener("render", this.onRenderRequestedDownstream), this.frameOverride?.traverse((t)=>{
            t.removeEventListener("beginStateChange", this.onFrameOverrideObjectEvent);
        }), this.frameOverride?.traverse((t)=>{
            t.removeEventListener("completeState", this.onFrameOverrideObjectEvent);
        }), this.frameOverride && this.scene2d.remove(this.frameOverride);
    }
};
function kL({ objectOverride: n1, objectRoot: t, newParentWidth: e, newParentHeight: r, initialParentWidth: i, initialParentHeight: s }) {
    if (n1 instanceof Ji && t instanceof Ji || n1 instanceof kn && t instanceof kn) for(let o = 0, a = n1.children.length; o < a; o++){
        let l = n1.children[o], c = t.children[o];
        l && c && l.uuid === c.uuid && SZ({
            objectOverride: l,
            objectRoot: c,
            newParentWidth: e,
            newParentHeight: r,
            initialParentWidth: i,
            initialParentHeight: s
        });
    }
}
function bZ(n1) {
    if (uT(n1)) return [
        n1.width,
        n1.height
    ];
    if (n1 instanceof Va) {
        let [t, e] = n1.getHalfSize();
        return [
            t * 2,
            e * 2
        ];
    } else if (n1 instanceof kn) {
        let [t, e] = n1.recursiveBBox.getHalfSize();
        return [
            t * 2,
            e * 2
        ];
    }
    return [
        0,
        0
    ];
}
function SZ({ objectOverride: n1, objectRoot: t, newParentWidth: e, newParentHeight: r, initialParentWidth: i, initialParentHeight: s }) {
    let [o, a] = bZ(t), { width: l, height: c, position: u } = sT({
        constraints: n1.data,
        newParentWidth: e,
        newParentHeight: r,
        initialParentWidth: i,
        initialParentHeight: s,
        objectInitialWidth: o,
        objectInitialHeight: a,
        objectInitialPosition: t.position
    });
    if (n1.position = u, n1.data = {
        ...n1.data,
        position: u
    }, n1.states) for(let h in n1.states)wZ({
        stateId: h,
        objectOverride: n1,
        objectRoot: t,
        newParentWidth: e,
        newParentHeight: r,
        initialParentWidth: i,
        initialParentHeight: s
    });
    if (uT(n1) || n1 instanceof kn) uT(n1) && (n1.width = l, n1.height = c, n1.data = {
        ...n1.data,
        width: l,
        height: c
    }), kL({
        objectOverride: n1,
        objectRoot: t,
        newParentWidth: l,
        newParentHeight: c,
        initialParentWidth: o,
        initialParentHeight: a
    });
    else if (n1 instanceof Va) {
        let h = t, d = o !== 0 ? l / o : 1, f = a !== 0 ? c / a : 1;
        n1.path = BL(h.path, d, f), n1.data = {
            ...n1.data,
            path: n1.path
        };
    }
}
function wZ({ stateId: n1, objectOverride: t, objectRoot: e, newParentWidth: r, newParentHeight: i, initialParentWidth: s, initialParentHeight: o }) {
    let a = t.states?.[n1], l = e.states?.[n1];
    if (a && l) {
        let { width: c, height: u, position: h } = sT({
            constraints: t.data,
            newParentWidth: r,
            newParentHeight: i,
            initialParentWidth: s,
            initialParentHeight: o,
            objectInitialWidth: Ta.isResizeable(l) ? l.width : 0,
            objectInitialHeight: Ta.isResizeable(l) ? l.height : 0,
            objectInitialPosition: l.position
        });
        Object.assign(t.states[n1], {
            position: h
        }), Ta.isResizeable(a) && Object.assign(t.states[n1], {
            width: c,
            height: u
        });
    }
}
function uT(n1) {
    return n1 instanceof Es || n1 instanceof Ji || n1 instanceof Zl || n1 instanceof Jl;
}
var ur = class extends yd(ei) {
    constructor(e, r, i){
        super();
        this.data = r;
        this.bgColor = new vr(1, 1, 1, 1);
        this.fog = null;
        this.backupFog = new Nu(16777215, .1, 2e3);
        this.fogUseBGColor = !1;
        this.isActive = !1;
        this.aoColor = new We;
        this.penumbraSizeArrayCache = null;
        this.super_Entity(e, r), this.personalCamera = new wr(hs, {
            ...Bc.defaultData,
            ...r.camera,
            name: "Personal Camera"
        }), this.personalCamera.objectHelper.visible = !1, this.add(this.personalCamera), this.activeCamera = this.personalCamera, this.ambientLight = new wy(13882323, 8553090, .75), this.ambientLight.name = "Default Ambient Light", this.ambientLight.layers.enable(3), this.ambientLight.removeFromParent(), this.add(this.ambientLight), r.uiScene ? this.uiScene = new iu((Array.isArray(e) ? e[0] : e) + "-ui", r.uiScene, {
            dpr: window.devicePixelRatio,
            shared: i.shared
        }) : r.uiFrame && this.createUICanvas(r.uiFrame, i);
    }
    get scene() {
        return this.parent;
    }
    get postprocessing() {
        return this.data.postprocessing;
    }
    get frameId() {
        return this.data.uiFrame;
    }
    get frame() {
        return this.uiCanvas?.frame;
    }
    createUICanvas(e, r) {
        this.uiCanvas = new _f(this.uuid + "-uiscreen", window.innerWidth, window.innerHeight, r), this.uiCanvas.isScreenSpace = !0, this.uiCanvas.promise.then(()=>{
            this.uiCanvas?.applyFrame(e), this.uiCanvas?.applySize();
        });
    }
    updateVisible() {}
    setBackgroundColor(e) {
        this.bgColor = e, this.fogUseBGColor === !0 && (this.backupFog.color = e);
    }
    entityChildrenCount() {
        return this.uiScene ? this.uiScene.children.length : super.entityChildrenCount();
    }
    updateAmbientLight(e, r) {
        e.color !== void 0 && (this.ambientLight.color = Qi(e.color, r)), e.intensity !== void 0 && (this.ambientLight.intensity = e.intensity), e.enabled !== void 0 && (e.enabled ? this.add(this.ambientLight) : this.remove(this.ambientLight));
    }
    onDeactive() {
        this.isActive = !1;
    }
    onActive(e) {
        this.isActive = !0, e.fog = this.fog, this.traverseEntity((r)=>{
            r instanceof Fn && r.recomputeBoolean();
        }), this.updateShadow(this.data.shadow);
    }
    forceMaterialsUpdate() {
        this.traverseEntity((e)=>{
            if (e instanceof vs) {
                if (Array.isArray(e.material)) for (let r of e.material)r.needsUpdate = !0;
                else e.material.needsUpdate = !0, e.material.dispose();
            }
        });
    }
    updateShadow(e) {
        e.softShadowQuality !== void 0 && this.isActive && hL(e.softShadowQuality) && this.forceMaterialsUpdate();
    }
    updateFog(e, r) {
        if (e.enabled ? this.fog = this.backupFog : this.fog = null, this.isActive) {
            let i = this.scene;
            i.fog = this.fog;
        }
        this.fogUseBGColor = e.useBackgroundColor, e.useBackgroundColor ? this.backupFog.color.set(this.bgColor) : this.backupFog.color = Qi(e.color, r), this.backupFog.near = e.near, this.backupFog.far = e.far;
    }
    updateAo(e, r) {
        e.aoColor !== void 0 && (this.aoColor = Qi(e.aoColor, r));
    }
    updateByOp(e, r, i, s) {
        let o = this.data.uiFrame;
        super.updateByOp(e, r, i, s);
        let a = r;
        Lt(e.path, [
            "fog"
        ]) ? this.updateFog(a.fog, i.shared) : Lt(e.path, [
            "ao"
        ]) ? this.updateAo(a.ao, i.shared) : Lt(e.path, [
            "ambient"
        ]) ? this.updateAmbientLight(a.ambient, i.shared) : Lt(e.path, [
            "shadow"
        ]) ? this.updateShadow(a.shadow) : e.type === 0 && e.path.length === 0 && (e.props.uiFrame !== void 0 || o !== a.uiFrame) && this.updateUIFrame(e.props.uiFrame, i);
    }
    updateUIFrame(e, r) {
        e ? (this.uiCanvas || this.createUICanvas(e, r), this.uiCanvas.enabled = !0, this.uiCanvas.applyFrame(e)) : this.uiCanvas && (this.uiCanvas.enabled = !1);
    }
    updateState(e, r) {
        this.updateState_Entity(e, r), e.backgroundColor !== void 0 && this.setBackgroundColor(Qi(e.backgroundColor, r.shared)), e.fog !== void 0 && this.updateFog(e.fog, r.shared), e.ambient !== void 0 && this.updateAmbientLight(e.ambient, r.shared), e.ao !== void 0 && this.updateAo(e.ao, r.shared), e.shadow !== void 0 && this.updateShadow(e.shadow);
    }
    createFrame(e, r) {}
    raycast(e, r) {
        super.raycast(e, r);
    }
    switchActiveCamera(e) {
        e && e.isDescendantOf(this) && (this.activeCamera !== this.personalCamera && (this.activeCamera.objectHelper.visible = !0), this.activeCamera = e, e.objectHelper.visible = !1);
    }
    get playCamera() {
        return this.scene?.find(this.data.publish.playCamera) ?? this.personalCamera;
    }
    switchToPlayCamera() {
        this.switchActiveCamera(this.playCamera);
    }
    get penumbraSizeArray() {
        return this.penumbraSizeArrayCache === null && this.updatePenumbraSizeArray(), this.penumbraSizeArrayCache;
    }
    updatePenumbraSizeArray() {
        this.penumbraSizeArrayCache = new Array(5).fill(.5);
        let e = 0, r = 0;
        this.traverseEntity((i)=>{
            if (!i.visible) return !0;
            i instanceof Mf && i.visible && e < 3 && (this.penumbraSizeArrayCache[e] = i.data.penumbraSize ?? .5, e += 1), i instanceof Cf && i.visible && e < 2 && (this.penumbraSizeArrayCache[3 + r] = i.data.penumbraSize ?? .5, r += 1);
        });
    }
    raycastWithClones(e) {
        let r = [], i = (s)=>{
            for (let o of s.children){
                let a = o.cloner;
                yt.is(o) && (o.visible || a?.object.data.visible) && ((cn(o) || Nm(o) && this.scene.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, r), Wm(o, e, r, !0)), i(o));
            }
        };
        return i(this), r;
    }
    updateEntity2DByOp(e, r, i, s) {
        this.uiCanvas?.updateEntity2DByOp(e, r, i, s);
    }
};
var Kx = class extends cf(Ey, Ef) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.fov = 90, s.aspect = 1, s.near = 100, s.far = 2500;
        let o = new E(-s.far + this.position.x, -s.far + this.position.y, -s.far + this.position.z), a = new E(s.far + this.position.x, s.far + this.position.y, s.far + this.position.z), l = new Wt(o, a), c = new hl(l, new We(16755200));
        c.visible = !1, this.gizmos.shadowmap = c, this.update();
    }
    update() {
        if (this.shadow && (this.shadow.camera.updateProjectionMatrix(), this.gizmos)) for(let t in this.gizmos){
            let e = this.gizmos[t];
            if (e instanceof hl) {
                let r = this.shadow.camera, i = new E(-r.far + this.position.x, -r.far + this.position.y, -r.far + this.position.z), s = new E(r.far + this.position.x, r.far + this.position.y, r.far + this.position.z);
                e.box.set(i, s), e.updateMatrixWorld(!0);
            }
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
var Qx = class extends cr {
    get forceComputeSize() {
        return !0;
    }
    get shape() {
        return this.geometry.userData.shape;
    }
    updateEntityBoxSize(t, e) {
        let r = this.geometry.getAttribute("position");
        r !== void 0 ? gm(r, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : r.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var $l = class extends cr {
    constructor(e, r, i){
        super(e, r, i);
        this._shapeId = null;
        this._context = i;
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateShape(), this.refreshAttachedCloners(r);
    }
    updateShape() {
        let e = {
            ...this.data.geometry.extrusion.shape
        };
        for(let s in e)typeof e[s] == "string" && (e[s] = this._context.shared.getVariable(e[s], [
            this.uuid,
            "geometry",
            "extrusion",
            "shape",
            s
        ]));
        let r;
        if (e.type === "Custom") {
            let s = e.shapeId;
            if (s !== this._shapeId && this.detachShape(), s) {
                this._shapeId = s;
                let o = this._context.scene.find(s);
                o?.data && (o.attachedPaths.add(this), r = o.geometry.userData?.shape), r || this._context.scene.addPendingCommand(()=>this.updateShape());
            }
        } else {
            let s;
            switch(e.type){
                case "Rectangle":
                    s = Pd;
                    break;
                case "Ellipse":
                    s = Td;
                    break;
                case "Polygon":
                    s = B0;
                    break;
                case "Star":
                    s = N0;
                    break;
                default:
                    throw new Error(`Unknown shape type: ${e.type}`);
            }
            r = s.create({
                parameters: e
            }).userData.shape;
        }
        let i = this.geometry;
        r && i.inputs && (i.inputs.shapeData = r, i.build());
    }
    detachShape() {
        this._shapeId !== null && this._context.scene.find(this._shapeId)?.attachedPaths.delete(this);
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.updateShape(), this.refreshAttachedPaths(e);
    }
    updateTransformState(e, r) {
        return super.updateTransformState(e, r);
    }
    updateGeometryInteractions(e, r) {
        super.updateGeometryInteractions(e, r), this.updateShape();
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.getAttribute("position");
        i !== void 0 ? gm(i, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : i.count, e, r) : super.updateEntityBoxSize(e, r);
    }
};
var ec = class extends Hl {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
    }
};
var eo = class extends Ss(sn, ws) {
    constructor(e, r, i){
        super();
        r.type === "Instance" && typeof e == "string" && (r = this.transformAssignData(r, i)), this.super_Entity(e, r), this.objectHelper.update();
    }
    get isComponentRoot() {
        return this.data.type === "Component" && typeof this.identity == "string";
    }
    get isInstanceRoot() {
        return this.data.type === "Instance" && typeof this.identity == "string";
    }
    transformAssignData(e, r) {
        let i = Xh.getComponentData({
            scene: r.scene.data,
            shared: r.shared.data
        }, e.component);
        if (i) {
            let s, o;
            for (let a of Po.rootOverrideProps)e[a] === void 0 ? (s === void 0 && (s = {
                ...e
            }), s[a] = i.data[a]) : (o === void 0 && (o = {}), o[a] = e[a], s === void 0 && (s = {
                ...e
            }), s[a] = So.apply(i.data[a], e[a]));
            return this.overrideData = o, s;
        } else return {
            ...vi.defaultData,
            ...e,
            ...Pn(vi.defaultData, Po.rootOverrideProps)
        };
    }
    updateByOp(e, r, i, s) {
        let o;
        if (this.isInstanceRoot && !s) {
            if (r = this.transformAssignData(r, i), e.type === 0 && e.path.length === 0 && this.component) for (let a of Po.rootOverrideProps)a in e.props && e.props[a] === void 0 && (o === void 0 && (o = {
                ...e,
                props: {
                    ...e.props
                }
            }), o.props[a] = this.component.data[a]);
            else if (e.type === 0 && e.path.length > 0 && Po.rootOverrideProps.includes(e.path[0])) {
                let a = e.path[0];
                o === void 0 && (o = {
                    ...e,
                    path: [],
                    props: {
                        [a]: r[a]
                    }
                });
            }
        }
        super.updateByOp(o ?? e, r, i, s);
    }
    updateState(e, r) {
        this.updateState_Entity(e, r);
    }
    expandInstanceChildren(e) {
        let r = this.data;
        if (this.component === void 0) {
            let i = e.scene.find(r.component) ?? null, s = !1;
            if (i !== this.oldComponent) {
                if (this.oldComponent) {
                    let o = 0;
                    for (let a of this.children)if (yt.is(a)) e.scene.disposeAndUnregisterEntityRecursivelyIfNotReregistered(a), Zx(a), o += 1;
                    else break;
                    this.children.splice(0, o);
                }
                s = !0;
            }
            if (i) {
                let o = {};
                zL(e, [
                    this.uuid
                ], r.overrides, this, i, i, 0, s, o);
                for (let a of this.children)if (yt.is(a)) {
                    let l = a.data;
                    l.type === "Empty" && l.animations && a.traverseEntity((c)=>{
                        let u = c.dataPatched;
                        if (c instanceof cr && u.bones && u.boneInverses) {
                            let h = c.dataPatched;
                            if (h.bones && h.boneInverses) {
                                let d = h.bones.map((m)=>e.scene.find(o[m])), f = h.boneInverses.map((m)=>new ue().fromArray(m)), p = new il(d, f);
                                c.bind(p, c.bindMatrix);
                            }
                        } else c.matrixAutoUpdate = !0;
                    });
                }
            }
            this.oldComponent = this.component;
        }
    }
};
function Zx(n1) {
    if (n1.component) {
        let t = n1.component.instances.indexOf(n1);
        t >= 0 && n1.component.instances.splice(t, 1);
        for (let e of n1.children)yt.is(e) && Zx(e);
    }
}
function UL(n1, t, e, r) {
    return n1.component === t && Dc(n1.identity, r) ? n1.overrideData === e ? 2 : 1 : 0;
}
function zL(n1, t, e, r, i, s, o, a, l) {
    if (o > 50) return !1;
    if (r.component !== i) {
        if (r.component) {
            let u = r.component.instances.indexOf(r);
            u >= 0 && r.component.instances.splice(u, 1);
        }
        i.instances.find((u)=>u === r) || i.instances.push(r), r.component = i;
    }
    i instanceof eo && i.isInstanceRoot && i.expandInstanceChildren(n1);
    let c = 0;
    for (let u of i.children)if (yt.is(u)) {
        let h = [
            ...t,
            ...typeof u.identity == "string" ? [
                u.identity
            ] : u.identity
        ], d = qh.resolve(e, h, 1);
        if (d != null && !(d instanceof yr)) Object.setPrototypeOf(d, yr.prototype), console.error("wrong prototype");
        let f = null, p;
        if (!a) {
            let m = r.children[c];
            if (f = yt.is(m) ? m : null, f !== null) {
                let g = UL(f, u, d, h);
                p = g >= 1 ? f.stateSelection : void 0, g !== 2 && (f = null);
            }
            if (f === null && (f = n1.scene.findInstance(h) ?? null, f !== null)) {
                let g = UL(f, u, d, h);
                if (p = g >= 1 ? f.stateSelection : void 0, g !== 2) f = null;
                else {
                    let y = f.parent.children.indexOf(f);
                    f.parent.children.splice(y, 1), r.children.splice(c, 0, f), f.parent === r ? y <= c && console.error("not possible") : (f.parent = r, f.matrixWorldNeedsUpdate = !0, f.resetBBoxNeedsUpdate(), f.updateVisible(), n1.pendingDeletes.delete(f));
                }
            }
        }
        if (f === null) {
            let m = d ? So.apply(u.data, d) : u.data;
            ks.is(m.type) && (m = {
                ...m,
                type: "Empty"
            }), f = Hs.createEntity(h, m, n1), f.overrideData = d, r.add(f), r.children.splice(r.children.length - 1, 1), r.children.splice(c, 0, f), f.updateState(f.data, n1), p && f.changeSelectedState(p, n1), n1.scene.registerInstanceAndSetUuid(f);
        }
        if (f.isBone) {
            let m = f.identity[f.identity.length - 1];
            l[m] = f.uuid;
        }
        c += 1, zL(n1, t, e, f, u, s, o + 1, a, l);
    }
    if (!a) {
        let u = c;
        for(;;){
            let h = r.children[c];
            if (yt.is(h)) n1.pendingDeletes.add(h);
            else break;
            c += 1;
        }
        r.children.splice(u, c - u);
    }
    return !0;
}
var Jx = class extends Ss(mp, ws) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update(), this.matrixAutoUpdate = !0;
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
};
var Er = class extends cr {
    constructor(e, r, i){
        super(e, r, i);
        this.onBeforeRender = (e)=>{
            this.uiCanvas.render(e);
        };
        this.uiCanvas = new _f(e + "-canvas", r.geometry.width, r.geometry.height, i), this.uiCanvas.promise.then(()=>{
            this.applyFrame(this.dataPatched.geometry.frame, i.shared);
        });
    }
    updateByPatchedOpGeometry(e, r, i) {
        super.updateByPatchedOpGeometry(e, r, i), e.type === 0 && (e.props.frame !== void 0 && this.applyFrame(e.props.frame, i.shared), (e.props.width !== void 0 || e.props.height !== void 0) && this.applySize(e.props, i.shared));
    }
    applySize(e, r) {
        let i = e?.width ?? this.dataPatched.geometry.width, s = e?.height ?? this.dataPatched.geometry.height;
        this.uiCanvas.applySize({
            width: i,
            height: s
        }), this.applyGeometryParametersFromFrame(r);
    }
    applyFrame(e, r) {
        this.uiCanvas.applyFrame(e), this.applyGeometryParametersFromFrame(r), this.applyMaterialParametersFromFrame({
            shared: r
        });
    }
    applyGeometryParametersFromFrame(e) {
        let r = this.frame;
        r && (Object.assign(this.data, {
            geometry: Object.assign(this.data.geometry, {
                cornerRadius: r.cornerRadius,
                cornerType: 0
            })
        }), Object.assign(this.dataPatched, {
            geometry: Object.assign(this.dataPatched.geometry, {
                cornerRadius: r.cornerRadius,
                cornerType: 0
            })
        }), this.localGeometry?.dispose(), this.localGeometry = _a(this.dataPatched.geometry, e, this.data.flatShading, this));
    }
    applyMaterialParametersFromFrame(e) {
        let r = this.frame;
        if (r) {
            let i = r.data.backgroundBlur;
            Object.assign(this.data.material.layers[0].data.texture, {
                image: this.uiCanvas.uuid
            }), Object.assign(this.data.material.layers[1].data, {
                roughness: i.radius,
                alpha: i.enabled ? 1 : 0
            }), Object.assign(this.dataPatched.material.layers[0].data.texture, {
                image: this.uiCanvas.uuid
            }), Object.assign(this.dataPatched.material.layers[1].data, {
                roughness: i.radius,
                alpha: i.enabled ? 1 : 0
            }), this.material.reset(this.dataPatched.material, e, !0);
        }
    }
    updateEntity2DByOp(e, r, i, s) {
        this.uiCanvas.updateEntity2DByOp(e, r, i, s), e === this.frameId && r.type === 0 && (r.props.cornerRadius !== void 0 ? this.applyGeometryParametersFromFrame(s) : Lt(r.path, [
            "backgroundBlur"
        ]) && this.applyMaterialParametersFromFrame({
            shared: s
        }));
    }
    get frame() {
        return this.uiCanvas.frame;
    }
    get frameId() {
        return this.frame?.uuid;
    }
    removeInteractionGeometry(e) {
        super.removeInteractionGeometry(e), this.applySize({}, e);
    }
    updateGeometryInteractions(e, r) {
        super.updateGeometryInteractions(e, r), this.applySize({
            width: e.width,
            height: e.height
        }, r);
    }
};
var $x = class {
    constructor(t, e, r){
        this.variables = [], this.currentTextureIndex = 0;
        let i = br, s = new ei, o = new qn;
        o.position.z = 1;
        let a = {
            passThruTexture: {
                value: null
            }
        }, l = h(f(), a), c = new zt(new Li(2, 2), l);
        s.add(c), this.setDataType = function(p) {
            return i = p, this;
        }, this.addVariable = function(p, m, g) {
            let y = this.createShaderMaterial(m), x = {
                name: p,
                initialValueTexture: g,
                material: y,
                dependencies: null,
                renderTargets: [],
                wrapS: null,
                wrapT: null,
                minFilter: Vt,
                magFilter: Vt
            };
            return this.variables.push(x), x;
        }, this.setVariableDependencies = function(p, m) {
            p.dependencies = m;
        }, this.init = function() {
            if (r.capabilities.isWebGL2 === !1 && r.extensions.has("OES_texture_float") === !1) return "No OES_texture_float support for float textures.";
            if (r.capabilities.maxVertexTextures === 0) return "No support for vertex shader textures.";
            for(let p = 0; p < this.variables.length; p++){
                let m = this.variables[p];
                m.renderTargets[0] = this.createRenderTarget(t, e, m.wrapS, m.wrapT, m.minFilter, m.magFilter), m.renderTargets[1] = this.createRenderTarget(t, e, m.wrapS, m.wrapT, m.minFilter, m.magFilter), this.renderTexture(m.initialValueTexture, m.renderTargets[0]), this.renderTexture(m.initialValueTexture, m.renderTargets[1]);
                let g = m.material, y = g.uniforms;
                if (m.dependencies !== null) for(let x = 0; x < m.dependencies.length; x++){
                    let v = m.dependencies[x];
                    if (v.name !== m.name) {
                        let S = !1;
                        for(let w = 0; w < this.variables.length; w++)if (v.name === this.variables[w].name) {
                            S = !0;
                            break;
                        }
                        if (!S) return "Variable dependency not found. Variable=" + m.name + ", dependency=" + v.name;
                    }
                    y[v.name] = {
                        value: null
                    }, g.fragmentShader = `
uniform sampler2D ` + v.name + `;
` + g.fragmentShader;
                }
            }
            return this.currentTextureIndex = 0, null;
        }, this.compute = function() {
            let p = this.currentTextureIndex, m = this.currentTextureIndex === 0 ? 1 : 0;
            for(let g = 0, y = this.variables.length; g < y; g++){
                let x = this.variables[g];
                if (x.dependencies !== null) {
                    let v = x.material.uniforms;
                    for(let S = 0, w = x.dependencies.length; S < w; S++){
                        let A = x.dependencies[S];
                        v[A.name].value = A.renderTargets[p].texture;
                    }
                }
                this.doRenderTarget(x.material, x.renderTargets[m]);
            }
            this.currentTextureIndex = m;
        }, this.getCurrentRenderTarget = function(p) {
            return p.renderTargets[this.currentTextureIndex];
        }, this.getAlternateRenderTarget = function(p) {
            return p.renderTargets[this.currentTextureIndex === 0 ? 1 : 0];
        }, this.dispose = function() {
            c.geometry.dispose(), c.material.dispose();
            let p = this.variables;
            for(let m = 0; m < p.length; m++){
                let g = p[m];
                g.initialValueTexture && g.initialValueTexture.dispose();
                let y = g.renderTargets;
                for(let x = 0; x < y.length; x++)y[x].dispose();
            }
        };
        function u(p) {
            p.defines.resolution = "vec2( " + t.toFixed(1) + ", " + e.toFixed(1) + " )";
        }
        this.addResolutionDefine = u;
        function h(p, m) {
            m = m || {};
            let g = new it({
                uniforms: m,
                vertexShader: d(),
                fragmentShader: p
            });
            return u(g), g;
        }
        this.createShaderMaterial = h, this.createRenderTarget = function(p, m, g, y, x, v) {
            return p = p || t, m = m || e, g = g || Qt, y = y || Qt, x = x || Vt, v = v || Vt, new dt(p, m, {
                wrapS: g,
                wrapT: y,
                minFilter: x,
                magFilter: v,
                format: qr,
                type: i,
                depthBuffer: !1
            });
        }, this.createTexture = function() {
            let p = new Float32Array(t * e * 4), m = new gi(p, t, e, qr, br);
            return m.needsUpdate = !0, m;
        }, this.renderTexture = function(p, m) {
            a.passThruTexture.value = p, this.doRenderTarget(l, m), a.passThruTexture.value = null;
        }, this.doRenderTarget = function(p, m) {
            let g = r.getRenderTarget(), y = r.xr.enabled, x = r.shadowMap.autoUpdate, v = r.outputEncoding, S = r.toneMapping;
            r.xr.enabled = !1, r.shadowMap.autoUpdate = !1, r.outputEncoding = mn, r.toneMapping = Os, c.material = p, r.setRenderTarget(m), r.render(s, o), c.material = l, r.xr.enabled = y, r.shadowMap.autoUpdate = x, r.outputEncoding = v, r.toneMapping = S, r.setRenderTarget(g);
        };
        function d() {
            return `void main()	{

	gl_Position = vec4( position, 1.0 );

}
`;
        }
        function f() {
            return `uniform sampler2D passThruTexture;

void main() {

	vec2 uv = gl_FragCoord.xy / resolution.xy;

	gl_FragColor = texture2D( passThruTexture, uv );

}
`;
        }
    }
};
var $i = new Cr, eb = new E, tb = class {
    constructor(t){
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (console.warn("THREE.MeshSurfaceSampler: Converting geometry to non-indexed BufferGeometry."), e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.colorAttribute = this.geometry.getAttribute("color"), this.weightAttribute = null, this.distribution = null;
    }
    setWeightAttribute(t) {
        return this.weightAttribute = t ? this.geometry.getAttribute(t) : null, this;
    }
    build() {
        let t = this.positionAttribute, e = this.weightAttribute, r = new Float32Array(t.count / 3);
        for(let s = 0; s < t.count; s += 3){
            let o = 1;
            e && (o = e.getX(s) + e.getX(s + 1) + e.getX(s + 2)), $i.a.fromBufferAttribute(t, s), $i.b.fromBufferAttribute(t, s + 1), $i.c.fromBufferAttribute(t, s + 2), o *= $i.getArea(), r[s / 3] = o;
        }
        this.distribution = new Float32Array(t.count / 3);
        let i = 0;
        for(let s = 0; s < r.length; s++)i += r[s], this.distribution[s] = i;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e, r) {
        let i = this.distribution[this.distribution.length - 1], s = this.binarySearch(this.randomFunction() * i);
        return this.sampleFace(s, t, e, r);
    }
    binarySearch(t) {
        let e = this.distribution, r = 0, i = e.length - 1, s = -1;
        for(; r <= i;){
            let o = Math.ceil((r + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s = o;
                break;
            } else t < e[o] ? i = o - 1 : r = o + 1;
        }
        return s;
    }
    sampleFace(t, e, r, i) {
        let s = this.randomFunction(), o = this.randomFunction();
        return s + o > 1 && (s = 1 - s, o = 1 - o), $i.a.fromBufferAttribute(this.positionAttribute, t * 3), $i.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), $i.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector($i.a, s).addScaledVector($i.b, o).addScaledVector($i.c, 1 - (s + o)), r !== void 0 && $i.getNormal(r), i !== void 0 && this.colorAttribute !== void 0 && ($i.a.fromBufferAttribute(this.colorAttribute, t * 3), $i.b.fromBufferAttribute(this.colorAttribute, t * 3 + 1), $i.c.fromBufferAttribute(this.colorAttribute, t * 3 + 2), eb.set(0, 0, 0).addScaledVector($i.a, s).addScaledVector($i.b, o).addScaledVector($i.c, 1 - (s + o)), i.r = eb.x, i.g = eb.y, i.b = eb.z), this;
    }
};
function GL(n1) {
    let t = new Float32Array(n1 * n1 * 2);
    for(let e = 0; e < n1; e++)for(let r = 0; r < n1; r++){
        let i = e * n1 + r;
        t[i * 2 + 0] = e / (n1 - 1), t[i * 2 + 1] = r / (n1 - 1);
    }
    return t;
}
function jL(n1) {
    let t = Math.ceil(Math.sqrt(n1));
    return Math.max(t, 1);
}
function HL(n1, t) {
    let e = new zt(n1.geometry, n1.material), r = [], i = [], s = new E, o = new E;
    e.geometry.index !== null && (e.geometry = e.geometry.toNonIndexed());
    let a = new tb(e).build();
    for(let u = 0; u < t; u++)a.sample(s, o), r.push(s.x, s.y, s.z), i.push(o.x, o.y, o.z);
    let l = new Float32Array(r), c = new Float32Array(i);
    return {
        positions: l,
        normals: c
    };
}
function hT(n1, t) {
    let e = n1, r = new Float32Array(4 * t * t);
    for(let s = 0; s < t * t; s++)r[4 * s] = e[3 * s], r[4 * s + 1] = e[3 * s + 1], r[4 * s + 2] = e[3 * s + 2], r[4 * s + 3] = 0;
    let i = new gi(r, t, t, qr, br);
    return i.needsUpdate = !0, i;
}
function WL({ size: n1 }) {
    let t = new Float32Array(4 * n1 * n1);
    for(let r = 0; r < n1 * n1; r++)t[4 * r] = r, t[4 * r + 1] = 0, t[4 * r + 2] = 0, t[4 * r + 3] = 0;
    let e = new gi(t, n1, n1, qr, br);
    return e.needsUpdate = !0, e;
}
function qL(n1) {
    let t = new Float32Array(4 * n1 * n1);
    for(let r = 0; r < n1 * n1; r++)t[4 * r] = 0, t[4 * r + 1] = 0, t[4 * r + 2] = 0, t[4 * r + 3] = 0;
    let e = new gi(t, n1, n1, qr, br);
    return e.needsUpdate = !0, e;
}
var YL = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU
uniform sampler2D uOriginalPosition;
uniform float uTime;
uniform float uSpeed;     // update speed of the particles
uniform vec3 uWorldOffset;    
uniform vec4 uWorldQuaternion;
uniform float uMaxLifeTime;
uniform vec3 uEmitterSize;
uniform float uFPSRatio;     // 1  for 60 FPS

float random (vec2 st) {
    return fract(sin(dot(st.xy,
        vec2(12.9898,78.233)))*
        43758.5453123);
}
vec3 applyQuaternionToVector( vec4 q, vec3 v ){
    return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
}

vec3 applyForce(vec3 force, float mass) {
    vec3 acceleration = force / mass;
    
    return acceleration;
  }
  

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    vec3 position = texture2D( uCurrentPosition, vUv ).xyz;
    float currentLife = texture2D( uCurrentPosition, vUv ).w;   // from 1 to 0
    float isSpawning = texture2D( uCurrentEmissionRate, vUv ).r;        // 1. = spawning, 0. = not spawning
    float isActive = texture2D( uCurrentEmissionRate, vUv ).g;          // 1. = active, 0. = not active
    float timeStart = texture2D( uCurrentEmissionRate, vUv ).b;         // timeStart in seconds when the particle was emitted
    vec3 originalPosition = ((texture2D( uOriginalPosition, vUv ).xyz) * uEmitterSize);
    vec3 velocity = texture2D( uCurrentVelocity, vUv ).xyz;
    float collisionFlag = texture2D( uCurrentVelocity, vUv ).w;             // 1. = collided, 0. = not collided
    float lifeTime = uMaxLifeTime;

    // Calculate the position adjustment based on collision
    //     if (collisionFlag > .5) {  
    float isColliding = step(0.5, collisionFlag); // 1.0 if collisionFlag > 0.5, otherwise 0.0
    float bounceOffset = 3.0 * isColliding; // Becomes 3.0 if colliding, 0.0 otherwise
    vec3 collisionAdjustedVelocity = velocity * (1.0 + bounceOffset);

    // Update position based on collision or normal movement
    vec3 fpsVelocity = velocity * min(uFPSRatio, 5.0);
    position += mix(fpsVelocity, collisionAdjustedVelocity, isColliding);

    // EMISSION RATE - BIRTH
    // if (isSpawning == 1.0) {
    // Better Approach to avoid If statement
    vec3 newPosition = applyQuaternionToVector(uWorldQuaternion, originalPosition) + uWorldOffset;
    originalPosition = mix(originalPosition, newPosition, isSpawning);
    position = mix(position, originalPosition, isSpawning);;
    timeStart = mix(timeStart, uTime, isSpawning);

    // Calculate timeLeft for life normalization
    float timeLeft = max(lifeTime - (uTime - timeStart), 0.0);
    float life_Normalize = timeLeft / lifeTime;

    // Use isActive to blend between the calculated color and black
    vec4 activeColor = vec4(position, life_Normalize);
    // if (isActive == 1.0) {
    gl_FragColor = mix(vec4(0.0), activeColor, isActive);

}
`;
var XL = `

    vec3 mod289(vec3 x) {
      return x - floor(x * (1.0 / 289.0)) * 289.0;
    }
    
    vec4 mod289(vec4 x) {
    return x - floor(x * (1.0 / 289.0)) * 289.0;
    }
    
    vec4 permute(vec4 x) {
        return mod289(((x*34.0)+1.0)*x);
    }
    
    vec4 taylorInvSqrt(vec4 r)
    {
    return 1.79284291400159 - 0.85373472095314 * r;
    }
    
    vec3 fade(vec3 t) {
  return t*t*t*(t*(t*6.0-15.0)+10.0);
}

    float snoise(vec3 v)
    {
    const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
    const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
    vec3 i  = floor(v + dot(v, C.yyy) );
    vec3 x0 =   v - i + dot(i, C.xxx) ;
    vec3 g = step(x0.yzx, x0.xyz);
    vec3 l = 1.0 - g;
    vec3 i1 = min( g.xyz, l.zxy );
    vec3 i2 = max( g.xyz, l.zxy );
    vec3 x1 = x0 - i1 + C.xxx;
    vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
    vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y
    
    // Permutations
    i = mod289(i);
    vec4 p = permute( permute( permute(
                i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
              + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
              + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
    
    // Gradients: 7x7 points over a square, mapped onto an octahedron.
    // The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
    float n_ = 0.142857142857; // 1.0/7.0
    vec3  ns = n_ * D.wyz - D.xzx;
    
    vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)
    
    vec4 x_ = floor(j * ns.z);
    vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
    
    vec4 x = x_ *ns.x + ns.yyyy;
    vec4 y = y_ *ns.x + ns.yyyy;
    vec4 h = 1.0 - abs(x) - abs(y);
    
    vec4 b0 = vec4( x.xy, y.xy );
    vec4 b1 = vec4( x.zw, y.zw );
    
    vec4 s0 = floor(b0)*2.0 + 1.0;
    vec4 s1 = floor(b1)*2.0 + 1.0;
    vec4 sh = -step(h, vec4(0.0));
    
    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
    
    vec3 p0 = vec3(a0.xy,h.x);
    vec3 p1 = vec3(a0.zw,h.y);
    vec3 p2 = vec3(a1.xy,h.z);
    vec3 p3 = vec3(a1.zw,h.w);
    
    //Normalise gradients
    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;
    
    // Mix final noise value
    vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
    m = m * m;
    return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                  dot(p2,x2), dot(p3,x3) ) );
    }
    
    vec3 snoiseVec3( vec3 x ){
    
      float s  = snoise(vec3( x ));
      float s1 = snoise(vec3( x.y - 19.1 , x.z + 33.4 , x.x + 47.2 ));
      float s2 = snoise(vec3( x.z + 74.2 , x.x - 124.5 , x.y + 99.4 ));
      vec3 c = vec3( s , s1 , s2 );
      return c;
    
    }
    
      
    vec3 curlNoise( vec3 p, float seed){
      p += seed;
      const float e = .1;
      vec3 dx = vec3( e   , 0.0 , 0.0 );
      vec3 dy = vec3( 0.0 , e   , 0.0 );
      vec3 dz = vec3( 0.0 , 0.0 , e   );
    
      vec3 p_x0 = snoiseVec3( p - dx );
      vec3 p_x1 = snoiseVec3( p + dx );
      vec3 p_y0 = snoiseVec3( p - dy );
      vec3 p_y1 = snoiseVec3( p + dy );
      vec3 p_z0 = snoiseVec3( p - dz );
      vec3 p_z1 = snoiseVec3( p + dz );
    
      float x = p_y1.z - p_y0.z - p_z1.y + p_z0.y;
      float y = p_z1.x - p_z0.x - p_x1.z + p_x0.z;
      float z = p_x1.y - p_x0.y - p_y1.x + p_y0.x;
    
      const float divisor = 1.0 / ( 2.0 * e );
      return normalize( vec3( x , y , z ) * divisor );
    
    }


// Classic Perlin noise
float cnoise(vec3 P)
{
  vec3 Pi0 = floor(P); // Integer part for indexing
  vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1
  Pi0 = mod289(Pi0);
  Pi1 = mod289(Pi1);
  vec3 Pf0 = fract(P); // Fractional part for interpolation
  vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
  vec4 iy = vec4(Pi0.yy, Pi1.yy);
  vec4 iz0 = Pi0.zzzz;
  vec4 iz1 = Pi1.zzzz;

  vec4 ixy = permute(permute(ix) + iy);
  vec4 ixy0 = permute(ixy + iz0);
  vec4 ixy1 = permute(ixy + iz1);

  vec4 gx0 = ixy0 * (1.0 / 7.0);
  vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;
  gx0 = fract(gx0);
  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
  vec4 sz0 = step(gz0, vec4(0.0));
  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
  gy0 -= sz0 * (step(0.0, gy0) - 0.5);

  vec4 gx1 = ixy1 * (1.0 / 7.0);
  vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;
  gx1 = fract(gx1);
  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
  vec4 sz1 = step(gz1, vec4(0.0));
  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
  gy1 -= sz1 * (step(0.0, gy1) - 0.5);

  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);

  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
  g000 *= norm0.x;
  g010 *= norm0.y;
  g100 *= norm0.z;
  g110 *= norm0.w;
  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
  g001 *= norm1.x;
  g011 *= norm1.y;
  g101 *= norm1.z;
  g111 *= norm1.w;

  float n000 = dot(g000, Pf0);
  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
  float n111 = dot(g111, Pf1);

  vec3 fade_xyz = fade(Pf0);
  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
  return 2.2 * n_xyz;
}


vec3 fbm_vec3(vec3 p, float frequency, float offset)
{
  return vec3(
    cnoise((p+vec3(offset))*frequency),
    cnoise((p+vec3(offset+20.0))*frequency),
    cnoise((p+vec3(offset-30.0))*frequency)
  );
}

`;
var KL = `
  #ifdef USE_COLLIDER
    float restitution = max(uBounce * 2., .01); // Energy Loss
    // SPHERE COLLIDER
    // **************************************************************
    #ifdef USE_SPHERE_COLLIDER       
      // Convert collider size to radii (assuming uColliderSize is the diameter in each axis)
      vec3 radii = uColliderSize;
      // Adjust position relative to collider
      vec3 relPos = position - uColliderPos;
      // Apply rotation of the collider to the relative position
      relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
      // Scale relative position by radii (for ellipsoid collision detection)
      vec3 scaledPos = relPos / radii;
      // Calculate ellipsoidal distance
      float dist = length(scaledPos); // Distance in terms of ellipsoid
      
      // Check for collision
      if (dist <= 1. + particleSize / length(radii) && collisionFlag == 0.0) {
          // Compute the normal at the collision point, accounting for particle size
        vec3 adjustedPos = scaledPos * (1.0 + particleSize / length(radii));          
        // Compute the normal at the collision point
        vec3 normal = ellipsoidNormal(adjustedPos, radii);
        // Rotate the normal back to world space
        normal = applyQuaternionToVector(uColliderQuaternion, normal);
        // Reflect the velocity vector off the normal
        velocity = reflect(velocity, normal) * restitution;

        collisionFlag = 1.0;
      } else {
        collisionFlag = 0.0;
      }
    #endif

    // BOX COLLIDER or PLANE COLLIDER 
    // **************************************************************
    #ifdef USE_BOX_COLLIDER
      // Box dimensions and repulsion variables
      vec3 boxHalfSize = uColliderSize / 2.0;
      // Convert world position to box's local space
      vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
      // Collision detection
      vec3 localDistance = abs(localPos) - boxHalfSize;
      float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));    

      // Collision Detected
      if (distToSurface <= particleSize * 0.5 && collisionFlag == 0.0) {      
        // Find the nearest face normal for bounce direction
        vec3 normal;
        if (localDistance.x > localDistance.y && localDistance.x > localDistance.z) {
            normal = vec3(sign(localPos.x), 0.0, 0.0);
        } else if (localDistance.y > localDistance.z) {
            normal = vec3(0.0, sign(localPos.y), 0.0);
        } else {
            normal = vec3(0.0, 0.0, sign(localPos.z));
        }            
        // Rotate normal back to world space
        normal = applyQuaternionToVector(uColliderQuaternion, normal);      
        // Reflect velocity and apply repulsion force
        velocity = reflect(velocity, normal) * restitution;
        
        collisionFlag = 1.0;
      } else {
        collisionFlag = 0.0;
      }
    #endif      
  #endif      
  // END COLLIDER    
`;
var QL = `
  #ifdef USE_ATTRACTOR

      #ifdef USE_SPHERE_COLLIDER      
        // Convert collider size to radii (assuming uColliderSize is the diameter in each axis)
        vec3 radii = uColliderSize;
        // Adjust position relative to collider
        vec3 relPos = position - uColliderPos;
        // Apply rotation of the collider to the relative position
        relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
        // Scale relative position by radii (for ellipsoid collision detection)
        vec3 scaledPos = relPos / radii;
        // Calculate ellipsoidal distance
        float distToSurface = length(scaledPos); // Distance in terms of ellipsoid
        float insideCheck = 1.0;

      #endif


      #ifdef USE_BOX_COLLIDER
        // Box dimensions
        vec3 boxHalfSize = uColliderSize / 2.0;
        // Convert world position to box's local space
        vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
        vec3 localDistance = abs(localPos) - boxHalfSize;
        float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));
        float insideCheck = particleSize;
      #endif      
  
      // Apply vortex force inside the Helper
      #ifdef USE_FORCE_LOCAL_SPACE
        if (distToSurface <= insideCheck ) {    
            // Define parameters for the attractor field
            #ifdef USE_SPHERE_COLLIDER      
              float attractorStrength = (1.0 - distToSurface ) * uForceIntensity; // Adjust as needed
            #endif

            #ifdef USE_BOX_COLLIDER
              float attractorStrength = max((1.0 - insideCheck / distToSurface), 0.) * uForceIntensity; // Adjust as needed
              #endif

            float attractorDamping = uForceDamping;  // Adjust as needed (higher values will attenuate velocity more)
          
            // Use the same radii calculation code as for the collider
            vec3 attractorRadii = uColliderSize;
            // Adjust position relative to attractor center
            vec3 relPos = position - uColliderPos;
            // Apply rotation of the collider to the relative position
            relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
            // Scale relative position by radii (for ellipsoid attraction)
            vec3 scaledPos = relPos / attractorRadii;

            // Calculate ellipsoidal distance as attractor radius
            float attractorRadius = length(scaledPos);
            // Calculate the distance from the attractor center
            vec3 relativePosition = position - uColliderPos;
            // Calculate the force vector towards the attractor center
            vec3 attractorForce = normalize(relativePosition) * attractorStrength;
            // Apply the attractor force to the particle
            velocity -= attractorForce;
            // Attenuate the particle's velocity
            velocity *= attractorDamping;
        }
      #else 
            // Calculate the distance from the attractor center
            vec3 relativePosition = position - uColliderPos;
            // Calculate the force vector towards the attractor center
            vec3 attractorForce = normalize(relativePosition) * uForceIntensity;
            // Apply the attractor force to the particle
            velocity -= attractorForce;
            // Attenuate the particle's velocity
            velocity *= uForceDamping;
      #endif    
  #endif      
`;
var ZL = `
  #ifdef USE_VORTEX
    // Box dimensions
    vec3 boxHalfSize = uColliderSize / 2.0;
    // Convert world position to box's local space
    vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
    vec3 localDistance = abs(localPos) - boxHalfSize;
    float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));

    // Apply vortex force inside the box
    if (distToSurface <= particleSize) {
      float vortexStrength = uForceIntensity;
      vec3 localTopCenter = vec3(0.0, 0., 0.0);

      // Transform the local top center to the world space
      vec3 vortexCenter = uColliderPos + applyQuaternionToVector(uColliderQuaternion, localTopCenter);
      // Calculate the vector from particle to vortex center
      vec3 vortexVector = vortexCenter - position;

      // Calculate the rotation axis from the inverse of the collider's quaternion and the fixed up vector
      // Note: important to add a tiny z component to the up vector to avoid instability
      vec3 upVector = vec3(0.0, 1.0, 0.01);
      vec3 rotationAxis = cross(upVector, applyQuaternionToVector(uColliderQuaternion, vortexVector));
      rotationAxis = normalize(rotationAxis);

      // Add rotational component to velocity
      float rotationSpeed = length(vortexVector * vortexStrength * 3.0) ; 

      vec3 rotationVelocity = rotationAxis * rotationSpeed;
      // velocity += rotationVelocity * 0.005 ;
      velocity = rotationVelocity * 0.005 ;

      // Calculate vortex force
      // vec3 vortexForce = normalize(vortexVector) * uSpeed * .1 ;
      // Apply the vortex force to the particle
      vec3 originDirection = applyQuaternionToVector(uWorldQuaternion, directions);
      velocity += applyForce( originDirection * uSpeed * (1. - uForceDamping) , mass * .5);
    }
  #endif      
`;
var JL = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU
uniform sampler2D uOriginalPosition;
uniform sampler2D uDirections;     
uniform vec3 uDirectionsAxis;
uniform vec4 uWorldQuaternion;
uniform vec3 uGravity;        
uniform float uNoiseStrength;     // Variation of the noise
uniform float uNoiseScale;        // Scale of the noise
uniform float uNoiseSeed;         // Seed of the noise
uniform float particleSize;
uniform float uSpeed;     // update speed of the particles
uniform float uRandomMassFactor;

// COLLIDER
uniform vec3 uColliderPos;                // Collider Position
uniform vec3 uColliderSize;               // Collider Dimension
uniform vec4 uColliderQuaternion;         // Collider Rotation
uniform vec4 uColliderQuaternionInvert;   // Collider Rotation
uniform float uBounce;                    // Bounce factor
uniform float uForceDamping;
uniform float uForceIntensity;


` + XL + `
float rand(vec2 co){
    return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}
vec3 applyQuaternionToVector( vec4 q, vec3 v ){
    return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
 } 
vec3 applyForce(vec3 force, float mass) {
  vec3 acceleration = force / mass;
  
  return acceleration;
}

vec4 conjugate(vec4 q) {
  return vec4(q.w, -q.x, -q.y, -q.z);
}

// Function to compute the normal of the ellipsoid at a given point
vec3 ellipsoidNormal(vec3 p, vec3 radii) {
  return normalize(p / (radii * radii));
}

float friction = .3;

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    vec3 position = texture2D( uCurrentPosition, vUv ).xyz;
    vec3 originalPosition = texture2D( uOriginalPosition, vUv ).xyz;
    float timeLeft = texture2D( uCurrentPosition, vUv ).w;
    vec3 directions = texture2D( uDirections, vUv ).xyz;    
    vec3 velocity = texture2D( uCurrentVelocity, vUv ).xyz;
    float mass = rand(originalPosition.xy) * 0.5 + 0.5;
    float isSpawning = texture2D( uCurrentEmissionRate, vUv ).x;        // 1. = spawning, 0. = not spawning
    float isActive = texture2D( uCurrentEmissionRate, vUv ).y;          // 1. = active, 0. = not active
    float collisionFlag =texture2D( uCurrentVelocity, vUv ).w;          // Indicate collision

    // Randomness Mass
    mass = (1.0 - (uRandomMassFactor * mass));
    
    if (isActive == 1.0) {
      // **************************************************************
      // FORCES NOISES
      // **************************************************************
      #ifdef USE_CURL_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = curlNoise(position * uNoiseScale * .002, uNoiseSeed) * ( uNoiseStrength + 1.0) * .05 * uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0 ) {
          velocity += curlNoise( position, uNoiseSeed)  * uNoiseStrength * 0.05 * uSpeed;
        }
      #endif
      // **************************************************************
      #ifdef USE_SIMPLEX_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = vec3(snoise(position * uNoiseScale * .001) * ( uNoiseStrength + 1.0) * .1);
          velocity *= uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0) {
          velocity += vec3(snoise(position * uNoiseStrength * .001) * .05 * uSpeed);
        }
      #endif
      // ************************************************************** 
      #ifdef USE_FBM_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = fbm_vec3(position * uNoiseScale * .001, ( uNoiseStrength + 1.0), uNoiseSeed);
          velocity *= uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0 ) {      
          velocity += fbm_vec3(position * uNoiseStrength * .001, ( uNoiseStrength + 1.0), uNoiseSeed) * .1 * uSpeed;
        }
      #endif

      // COLLIDER
      ${KL}
      // ATTRACTION
      ${QL}  
      // VORTEX
      ${ZL}
    } 
    // End isActive

    // SPAWN BIRTH 
    // **************************************************************
    // if (isSpawning == 1.)
    #ifdef USE_NORMALS
      velocity = mix(velocity, applyQuaternionToVector(uWorldQuaternion, directions) * uSpeed, isSpawning);
    #else
      velocity = mix(velocity, applyQuaternionToVector(uWorldQuaternion, uDirectionsAxis) * uSpeed, isSpawning);    
    #endif
    
    // if (collisionFlag == 0.0)
    velocity += applyForce(uGravity, mass * .5) * (1.0 - collisionFlag);

    gl_FragColor = vec4(velocity, collisionFlag);
}
`;
var dT = `

  // Linear Fade In
  float linearFadeIn(float t) {
    return t;
  }


  // linear fade out
  float linearFadeOut(float t) {
    return 1.0 - t;
  }
  
  float linearInOut(float t) {
    return t < 0.5 ? t :  (1.0 - t);  
  }

    // lerp
    float lerp(float a, float b, float t) {
      return a + (b - a) * t;
    }

  // Ease In Out Quart
  float exponentialInOut(float t) {
    return t < 0.4 ? lerp(0.0, 1.0, t / 0.4) :
    t > 0.6 ? lerp(1.0, 0.0, (t - 0.6) / 0.4) :
    1.0;
   }

  // constant
  float constant(float t) {
    return 1.0;
  } 
`;
var $L = `

float rand(vec3 co){
  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
}

vec3 applyQuaternionToVector( vec4 q, vec3 v ){
  return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
}

vec3 applyForce(vec3 force, float mass) {
  vec3 acceleration = force / mass;
    
  return acceleration;
}
`;
var eB = `
vec3 rgb2xyz (in vec3 rgb) {
    float r = rgb.r;
	float g = rgb.g;
	float b = rgb.b;

	r = r > 0.04045 ? pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	float x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	float y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	float z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
    
    vec3 xyz = vec3(
        (r * 0.4124) + (g * 0.3576) + (b * 0.1805) * 100.0,
        (r * 0.2126) + (g * 0.7152) + (b * 0.0722) * 100.0,
        (r * 0.0193) + (g * 0.1192) + (b * 0.9505) * 100.0
    );
    return(xyz);
}

vec3 xyz2lab (in vec3 xyz) {
	float x = xyz.x / 95.047;
	float y = xyz.y / 100.0;
	float z = xyz.z / 108.883;

	x = x > 0.008856 ? pow(x, 1.0 / 3.0) : (7.787 * x) + (16.0 / 116.0);
	y = y > 0.008856 ? pow(y, 1.0 / 3.0) : (7.787 * y) + (16.0 / 116.0);
	z = z > 0.008856 ? pow(z, 1.0 / 3.0) : (7.787 * z) + (16.0 / 116.0);

    vec3 lab = vec3((116.0 * y) - 16.0, 500.0 * (x - y), 200.0 * (y - z));
    return(lab);
}

vec3 rgb2lab(in vec3 rgb) {
    vec3 xyz = rgb2xyz(rgb);
    vec3 lab = xyz2lab(xyz);
    return(lab);
}

vec3 xyz2rgb (in vec3 xyz) {
	float x = xyz.x / 100.0;
	float y = xyz.y / 100.0;
	float z = xyz.z / 100.0;
	
    
	float r = (x *  3.2406) + (y * -1.5372) + (z * -0.4986);
	float g = (x * -0.9689) + (y *  1.8758) + (z *  0.0415);
	float b = (x *  0.0557) + (y * -0.2040) + (z *  1.0570);

	r = r > 0.0031308 ? ((1.055 * pow(r, 1.0 / 2.4)) - 0.055) : r * 12.92;
	g = g > 0.0031308 ? ((1.055 * pow(g, 1.0 / 2.4)) - 0.055) : g * 12.92;
	b = b > 0.0031308 ? ((1.055 * pow(b, 1.0 / 2.4)) - 0.055) : b * 12.92;

	r = min(max(0.0, r), 1.0);
	g = min(max(0.0, g), 1.0);
	b = min(max(0.0, b), 1.0);

	return(vec3(r, g, b));
}

vec3 lab2xyz (in vec3 lab) {
    float l = lab.x;
	float a = lab.y;
	float b = lab.z;

  	float y = (l + 16.0) / 116.0;
	float x = a / 500.0 + y;
	float z = y - b / 200.0;

	float y2 = pow(y, 3.0);
	float x2 = pow(x, 3.0);
	float z2 = pow(z, 3.0);

  	y = y2 > 0.008856 ? y2 : (y - 16.0 / 116.0) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16.0 / 116.0) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16.0 / 116.0) / 7.787;

	x *= 95.047;
	y *= 100.0;
	z *= 108.883;

	return(vec3(x, y, z));
}
vec3 lab2rgb (in vec3 lab) {
    vec3 xyz = lab2xyz(lab);
    vec3 rgb = xyz2rgb(xyz);
    return(rgb);
}

`;
var tB = `
  uniform sampler2D uPosition;
  uniform float uSize;
  uniform float uSizeEnd;
  uniform vec3 uWorldOffset;
  uniform vec4 uWorldQuaternion;
  // Billboard Behavior - Currently at Zero, but we can change that
  uniform float uRotation;
  uniform float uRotationEnd;
  uniform vec2 center;

  // Randomness
  uniform float uRandScaleFactor;
  uniform float uRandRotationFactor;

  attribute vec2 ref;

  varying float v_LifeLeft;    // normalized lifetime 1 to 0
  varying vec2 vUv;
  varying vec2 vRef;

  ${$L}
  ${dT}
`, rB = ({ easeSize: n1 = "linearFadeOut" })=>`
  vUv = uv;  
  vRef = ref;
  // Normalized LifeTime 1 to 0
  float lifeLeft = texture2D(uPosition, ref).w;
  v_LifeLeft = lifeLeft;
  // Position From DataTexture Simulation
  vec3 pos = texture2D(uPosition, ref).rgb - uWorldOffset;
  // Apply World Quaternion
  pos = applyQuaternionToVector(uWorldQuaternion, pos);  
            
  #ifdef  USE_SIZE_END
    // Scaled Over Time
    float t = 1. - lifeLeft;
    float currentSize = mix(uSize, uSizeEnd, t); // Linearly interpolate between uSize and uSizeEnd
    vec3 scaledPosition = position * vec3(currentSize);
  #else
    // Change Size Behavior over LifeTime
    float easeSize = ${n1}(1. - lifeLeft);
    // Scaled Over Time
    vec3 scaledPosition = position * vec3(uSize * easeSize);
  #endif

  // Billboard Behavior
  vec2 scale;
  scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
  scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );    
  // Randomness 
  float randRef = rand(ref);
  scale *= (1.0 - (uRandScaleFactor * randRef));
  // Rotation
  float randRotation =  2.0 * PI * ( uRandRotationFactor * randRef);
  float originalRotation = (1.0 - uRotation) * 2.0 * PI;
  float originalRotationEnd = (1.0 - uRotationEnd) * 2.0 * PI;
  // OverTime
  float finalRotation = mix(originalRotation + randRotation, originalRotationEnd + randRotation, lifeLeft);

  vec2 alignedPosition = ( scaledPosition.xy - ( center - vec2( 0.5 ) ) ) * scale;
  vec2 rotatedPosition;
  rotatedPosition.x = cos( finalRotation ) * alignedPosition.x - sin( finalRotation ) * alignedPosition.y;
  rotatedPosition.y = sin( finalRotation ) * alignedPosition.x + cos( finalRotation ) * alignedPosition.y;
  
  mat4 instanceMatrix = mat4(
    vec4(1.0, 0.0, 0.0, 0.0),
    vec4(0.0, 1.0, 0.0, 0.0),
    vec4(0.0, 0.0, 1.0, 0.0),
    vec4(pos.x, pos.y, pos.z, 1.0)
  );  

  mvPosition = modelViewMatrix * instanceMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
  mvPosition.xy += rotatedPosition;
  gl_Position = projectionMatrix  * mvPosition;   
`, iB = `
  uniform vec4 uColor;                // start color
  uniform vec4 uColor2;               // end color
  uniform sampler2D uTexture;         // texture
  varying float v_LifeLeft;   // normalized lifetime 1 to 0
  varying vec2 vUv;
  varying vec2 vRef;

  float random(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
  }
  ` + dT + `  
  ${eB}

`, nB = ({ easeOpacity: n1 = "linearFadeOut" })=>`  
  // if Particle is dead, hide it
  if (v_LifeLeft <= 0.005 ) {
    discard;
  }

  #ifdef USE_RANDOM_COLORING
    float randVal = random(vRef); // Generate a random value based on the reference
    vec4 color = mix(uColor, uColor2, randVal); // Interpolate between the two colors
  #else
    vec4 color = mix(uColor, uColor2, 1. - v_LifeLeft);
  #endif

  // Opacity over Life Time
  float finalAlpha = ${n1}(1. - v_LifeLeft);  
  vec4 textureColor = texture2D(uTexture, vUv).rgba; 
  finalColor = textureColor.rgb * color.rgb;
  finalAlpha = color.a * textureColor.a * finalAlpha;
  
  gl_FragColor = vec4(finalColor, finalAlpha);     

`;
var rb = class extends it {
    constructor(e, r){
        super();
        this.needsJitter = !0;
        this.type = "ParticleMaterial";
        this.easeOpacity = "linearFadeIn";
        this.easeSize = "linearFadeIn";
        this.useSizeEnd = !1;
        this.isColoringRandom = !1;
        this.init(e, r), this.context = r;
    }
    reset() {}
    init(e, r) {
        this.transparent = !0, this.depthTest = !0, this.depthWrite = !1, this.easeOpacity = e.ease, this.easeSize = e.easeSize, this.layers = [], or.startContext(or.globalContext), this.lightLayer = new wn(0, "", {
            ...Gr.defaultData("light", "phong"),
            visible: !1
        }, new Da, {}, r.shared), or.endContext(or.globalContext), this.build();
    }
    updateState(e) {
        e.coloring !== void 0 && (this.isColoringRandom = e.coloring === "random"), e.color !== void 0 && (e.color instanceof Array ? this.uniforms.uColor.value = e.color : this.uniforms.uColor.value = this.context.shared.color(e.color)), e.color2 !== void 0 && (e.color2 instanceof Array ? this.uniforms.uColor2.value = e.color2 : this.uniforms.uColor2.value = this.context.shared.color(e.color2)), e.size !== void 0 && (this.uniforms.uSize.value = e.size[0], this.uniforms.uSizeEnd.value = e.size[1], e.size[0] !== e.size[1] ? this.useSizeEnd = !0 : this.useSizeEnd = !1), e.ease !== void 0 && (this.easeOpacity = e.ease, this.build()), e.easeSize !== void 0 && (this.easeSize = e.easeSize, this.build()), this.needsUpdate = !0;
    }
    onBeforeCompile(e) {
        this.build(), e.defines = this.defines, e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
    }
    build() {
        let e = new Vd;
        return e.needsJitter = this.needsJitter, e.addFragmentParsCode(xR), e.buildShader("vertex", this.fragment), e.buildShader("fragment", this.fragment), e.addFragmentFinalCode(bR), this.isColoringRandom && e.define("USE_RANDOM_COLORING"), this.useSizeEnd && e.define("USE_SIZE_END"), e.addVertexParsCode(tB), e.addFragmentParsCode(iB), e.addVertexFinalCode(rB({
            easeSize: this.easeSize
        })), e.addFragmentFinalCode(nB({
            easeOpacity: this.easeOpacity
        })), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = {
            ...e.uniforms,
            ...this.uniforms
        }, this.extensions = e.extensions, this;
    }
    get nodeMaterial() {
        return this;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    getDefines() {
        return this.defines;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
    }
};
var If = class {
    constructor(t, e, r, i){
        this.type = "SphereEmitterShape";
        this.targetMesh = void 0;
        this.size = t, this.type = r, this.textureSize = jL(e);
        let s = 1;
        this.targetMesh = i?.type === "Mesh" && i ? i : this.getMesh(r, s);
        let { positions: o, dataTexture: a, dataTextureNormals: l } = this.createPositions(this.textureSize, this.targetMesh ?? this.getMesh(r, s));
        this.positionsTexture = a, this.positionsAttribute = o, this.directionsTexture = l;
    }
    createPositions(t, e) {
        let { positions: r, normals: i } = HL(e, t * t), s = hT(r, t), o = hT(i, t);
        return {
            dataTexture: s,
            positions: r,
            dataTextureNormals: o
        };
    }
    getMesh(t, e) {
        let r = null;
        switch(t){
            case "SphereEmitterShape":
                r = new Bs(e * .5, 32, 32);
                break;
            case "TorusEmitterShape":
                r = new ju(e * .5, .3, 15, 40);
                break;
            case "ConeEmitterShape":
                r = new sl(e, e, 15);
                break;
            case "BoxEmitterShape":
                r = new mi(e, e, e);
                break;
            case "PlaneEmitterShape":
                r = new Li(e, e), r.rotateX(-Math.PI / 2);
                break;
            case "MeshEmitterShape":
                r = new Bs(e, 32, 32);
                break;
            default:
                r = new Bs(e, 32, 32);
                break;
        }
        return new zt(r, new on({
            color: 16711680
        }));
    }
    applyToShader(t, e) {
        this.size = new E().fromArray(e.size), t.uEmitterSize.value = this.size;
    }
    dispose() {
        this.positionsTexture.dispose(), this.directionsTexture.dispose(), this.positionsAttribute = new Float32Array;
    }
};
function tc(n1) {
    let t = {
        ...n1
    }, e = Uh.defaultData;
    t.forceFieldObjectId && (t.colliderEntityId = t.forceFieldObjectId);
    let r = {
        ...e.shape,
        ...t.shape
    }, i = {
        ...e.renderMaterial,
        ...t.renderMaterial
    };
    return {
        ...e,
        ...t,
        shape: r,
        renderMaterial: i
    };
}
var sB = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU

uniform sampler2D uIndex; // Texture with corresponding index
uniform float uLastIndexEmitted; // Last emitted index
uniform float uParticlesToEmit; // Number of particles to emit on that frame
uniform float uTime;

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    float particleIndex = texture(uIndex, vUv).x;
    float timeLeft = texture2D( uCurrentPosition, vUv ).w;
    float isActive = texture2D( uCurrentEmissionRate, vUv ).g;    // 1. = active, 0. = not active
    float timeStart = texture2D( uCurrentEmissionRate, vUv ).b;


    // ********** Detect Colision to Create a flag and use it in position **********
    // We are doing this here, so

    // ********** Emit Particles **********
    // X = isSpawning 0.0 or 1.0
    // Y = isActive 0.0 or 1.0
    // Check if the vertex index is between the first value and the last value
    // if (particleIndex >= uLastIndexEmitted && particleIndex < uLastIndexEmitted + uParticlesToEmit) {
    //     // Emit a particle by writing 1 to the red channel of the color output
    //     // r: 1. == emit the particle
    //     // g: 1. == particle is now active
    //     timeStart = uTime;
    //     gl_FragColor = vec4(1.0, 1.0, timeStart, 1.0);
    // } else {
    //     // The Particle is either already emitted or not in the range of the particles to emit
    //     // Do not emit a particle by writing 0 to the red channel of the color output        
    //     gl_FragColor = vec4(0.0, isActive, timeStart, 1.0);
    // }
    // Determine if the particle is within the emission range
    float emitLowerBound = step(uLastIndexEmitted, particleIndex);
    float emitUpperBound = step(particleIndex, uLastIndexEmitted + uParticlesToEmit - 1.0);
    float emitParticle = emitLowerBound * emitUpperBound; // 1.0 if in range, 0.0 otherwise

    // Set timeStart and color
    timeStart = mix(timeStart, uTime, emitParticle);
    gl_FragColor = vec4(emitParticle, mix(isActive, 1.0, emitParticle), timeStart, 1.0);


}
`;
var fT = 10, ib = class extends Tt {
    constructor(e, r){
        super();
        this.type = "ParticleEmitter";
        this.debugMode = !1;
        this.worldSpace = !0;
        this.rootObject = null;
        this.gpuCompute = null;
        this.positionSimRT = null;
        this.velocitySimRT = null;
        this.emissionRateSimRT = null;
        this.emitterShape = void 0;
        this.isEmitting = !1;
        this.hasBeenReset = !1;
        this.emittedParticlesAmount = 0;
        this.lastEmitTime = 0;
        this.globalTime = 0;
        this.targetFPS = 60;
        this.previousRatio = 1;
        this.lerpFactor = .4;
        this.particlesAmount = 0;
        this.noiseStrength = 0;
        this.noiseScale = 0;
        this.isBillboardBased = !0;
        this.simFeaturesDefinition = {
            USE_COLLIDER: !1,
            USE_ATTRACTOR: !1,
            USE_VORTEX: !1,
            USE_SPHERE_COLLIDER: !1,
            USE_BOX_COLLIDER: !1,
            USE_FORCE_LOCAL_SPACE: !1,
            USE_NORMALS: !1,
            USE_CURL_NOISE: !0,
            USE_SIMPLEX_NOISE: !1,
            USE_FBM_NOISE: !1
        };
        this.textureLoader = new Sy;
        this.currentWorldPosition = new E;
        this.systemQuaternion = new Ke;
        this.worldGravity = new E(0, 0, 0);
        this.directionAxis = new E(0, 0, 0);
        this.colliderV3 = new E(0, 0, 0);
        this.colliderQuaternion = new Ke(0, 0, 0, 1);
        this.matrixAutoUpdate = !0, this.renderer = e, this.system = r, this.shared = r.context.shared;
        let i = r.data;
        this.material = new rb(i.renderMaterial, r.context), this.material.uniforms = {
            uSize: {
                value: 0
            },
            uSizeEnd: {
                value: 0
            },
            uColor: {
                value: i.renderMaterial.color
            },
            uColor2: {
                value: i.renderMaterial.color2
            },
            uPosition: {
                value: new E(0, 0, 0)
            },
            uEmissionData: {
                value: new E(0, 0, 0)
            },
            uTexture: {
                value: this.defaultTexture
            },
            uWorldOffset: {
                value: new E(0, 0, 0)
            },
            uWorldQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uRandScaleFactor: {
                value: i.randomScale ?? 0
            },
            uRandRotationFactor: {
                value: i.randomRotation ?? 0
            },
            uRotation: {
                value: i.renderMaterial.spriteRotation[0] ?? 0
            },
            uRotationEnd: {
                value: i.renderMaterial.spriteRotation[1] ?? 0
            }
        }, this.setTexture(this.material.uniforms, i.renderMaterial.texture), this.init(i);
    }
    setTexture(e, r) {
        let i = r.data;
        if (typeof r == "string") {
            let s = this.shared.image(r), o = new er(s.img);
            o.needsUpdate = !0, e.uTexture.value = o;
            return;
        }
        if (typeof i != "string") {
            let s = new Image;
            s.onload = ()=>{
                let l = new er(s);
                l.needsUpdate = !0, e.uTexture.value = l;
            };
            let o = new Blob([
                i
            ], {
                type: "image/*"
            }), a = URL.createObjectURL(o);
            s.src = a;
        }
    }
    updateGeometryAttributes(e, r) {
        let i = GL(r);
        !this.emitterShape?.positionsAttribute || e.geometry.setAttribute("ref", new mo(i, 2));
    }
    applyWorldSpace() {
        if (!this.system.started || !this.worldSpace || !this.positionSimRT || !this.velocitySimRT) return;
        let e = this.system;
        e.getWorldQuaternion(this.systemQuaternion), this.systemQuaternion.invert(), e.getWorldPosition(this.currentWorldPosition), this.material.uniforms.uWorldOffset.value = this.currentWorldPosition, this.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize()), this.positionSimRT.material.uniforms.uWorldOffset.value = this.currentWorldPosition, this.systemQuaternion.invert(), this.positionSimRT.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize()), this.velocitySimRT.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize());
    }
    update(e, r) {
        if (!this.gpuCompute || !this.positionSimRT || !this.velocitySimRT || !this.emissionRateSimRT || this.hasBeenReset) return;
        if (this.checkIfAllParticlesAreDead() && !this.hasBeenReset) {
            this.reset();
            return;
        }
        this.applyWorldSpace(), this.globalTime = e, this.positionSimRT.material.uniforms.uTime.value = e, this.emissionRateSimRT.material.uniforms.uTime.value = e;
        let i = 1e3 / r, s = this.targetFPS / i, o = this.previousRatio + (s - this.previousRatio) * this.lerpFactor;
        this.positionSimRT.material.uniforms.uFPSRatio.value = o, this.previousRatio = o;
        let a = this.isEmitting ? this.GoEmitSomeParticles(e, this.system.data.birthRatePerSec) : 0;
        this.emissionRateSimRT.material.uniforms.uLastIndexEmitted.value = this.emittedParticlesAmount, this.emissionRateSimRT.material.uniforms.uParticlesToEmit.value = a, this.material.uniforms.uPosition.value = this.gpuCompute.getCurrentRenderTarget(this.positionSimRT)?.texture, this.system.colliderEntities.length > 0 && this.renderColliders(), this.gpuCompute.compute();
    }
    renderColliders() {
        if (!this.velocitySimRT) return;
        let e = this.system.colliderEntities[0], r = this.simFeaturesDefinition.USE_COLLIDER || this.simFeaturesDefinition.USE_ATTRACTOR || this.simFeaturesDefinition.USE_VORTEX;
        if (e.destroyedInAction && r && this.init(tc({
            ...this.system.data,
            colliderEntityId: null
        })), !e || e.destroyedInAction) return;
        e.getWorldPosition(this.colliderV3), this.colliderV3.y === 0 && (this.colliderV3.y = 1e-4), this.velocitySimRT.material.uniforms.uColliderPos.value.copy(this.colliderV3);
        let i = e.data.size;
        this.colliderV3.fromArray(i), this.velocitySimRT.material.uniforms.uColliderSize.value.copy(this.simFeaturesDefinition.USE_SPHERE_COLLIDER ? this.colliderV3.multiplyScalar(.5) : this.colliderV3), e.getWorldQuaternion(this.colliderQuaternion), this.velocitySimRT.material.uniforms.uColliderQuaternion.value.copy(this.colliderQuaternion.normalize()), this.velocitySimRT.material.uniforms.uColliderQuaternionInvert.value.copy(this.colliderQuaternion.normalize().invert());
    }
    updateState(e) {
        !this.velocitySimRT || !this.positionSimRT || (e.renderMaterial && this.updateMaterialState(e.renderMaterial), this.updateParticleState(e));
    }
    updateVariableState(e, r) {
        if (!this.velocitySimRT || !this.positionSimRT) return;
        r[2] === "size" && this.material.updateState({
            size: [
                e,
                this.material.uniforms.uSizeEnd.value
            ]
        }), r[2] === "sizeEnd" && this.material.updateState({
            size: [
                this.material.uniforms.uSize.value,
                e
            ]
        });
        let i = (s, o)=>{
            let a = [
                ...this.system.data.shape.size
            ];
            a[s] = o, this.updateParticleState({
                shape: {
                    ...this.system.data.shape,
                    size: a
                }
            });
        };
        r[2] === "shape_size_0" && i(0, e), r[2] === "shape_size_1" && i(1, e), r[2] === "shape_size_2" && i(2, e), r[2] === "speed" && (this.velocitySimRT.material.uniforms.uSpeed.value = e / fT), r[2] === "gravity" && this.worldGravity.set(0, e / 100, 0), r[2] === "noiseStrength" && (this.noiseStrength = e, this.velocitySimRT.material.uniforms.uNoiseStrength.value = this.noiseStrength), r[2] === "noiseScale" && (this.noiseScale = e, this.velocitySimRT.material.uniforms.uNoiseScale.value = this.noiseScale), r[2] === "direction_x" && (this.directionAxis = this.getDirectionAxis([
            Number(e),
            this.system.data.direction[1],
            this.system.data.direction[2]
        ])), r[2] === "direction_y" && (this.directionAxis = this.getDirectionAxis([
            this.system.data.direction[0],
            Number(e),
            this.system.data.direction[2]
        ])), r[2] === "direction_z" && (this.directionAxis = this.getDirectionAxis([
            this.system.data.direction[0],
            this.system.data.direction[1],
            Number(e)
        ]));
    }
    updateMaterialState(e) {
        this.material.updateState({
            ...e,
            size: e.size ? [
                Number(this.shared.getVariable(e.size[0], [
                    this.uuid,
                    "particles",
                    "size"
                ])),
                Number(this.shared.getVariable(e.size[1], [
                    this.uuid,
                    "particles",
                    "sizeEnd"
                ]))
            ] : [
                0,
                0
            ]
        }), e.texture && (this.setTexture(this.material.uniforms, e.texture), this.material.needsUpdate = !0);
    }
    updateParticleState(e) {
        if (!(!this.positionSimRT || !this.velocitySimRT)) {
            if (this.shouldReInitGPUCompute(e) && this.init(tc(this.system.data)), e.life !== void 0 && (this.positionSimRT.material.uniforms.uMaxLifeTime.value = e.life), e.speed !== void 0 && (this.velocitySimRT.material.uniforms.uSpeed.value = Number(this.shared.getVariable(e.speed, [
                this.uuid,
                "particles",
                "speed"
            ])) / fT), e.collisionBounce !== void 0 && (this.velocitySimRT.material.uniforms.uBounce.value = e.collisionBounce), e.noiseStrength !== void 0 && (this.noiseStrength = Number(this.shared.getVariable(e.noiseStrength, [
                this.uuid,
                "particles",
                "noiseStrength"
            ])), this.velocitySimRT.material.uniforms.uNoiseStrength.value = this.noiseStrength), e.noiseScale !== void 0 && (this.noiseScale = Number(this.shared.getVariable(e.noiseScale, [
                this.uuid,
                "particles",
                "noiseScale"
            ])), this.velocitySimRT.material.uniforms.uNoiseScale.value = this.noiseScale), e.noiseSeed !== void 0 && (this.velocitySimRT.material.uniforms.uNoiseSeed.value = e.noiseSeed), e.randomMass !== void 0 && (this.velocitySimRT.material.uniforms.uRandomMassFactor.value = e.randomMass), e.renderMaterial?.size !== void 0) {
                let r = this.shared.getVariable(e.renderMaterial.size[0], [
                    this.uuid,
                    "particles",
                    "size"
                ]);
                this.velocitySimRT.material.uniforms.particleSize.value = Number(r);
            }
            if (e.renderMaterial?.spriteRotation !== void 0 && (this.material.uniforms.uRotation.value = e.renderMaterial.spriteRotation[0], this.material.uniforms.uRotationEnd.value = e.renderMaterial.spriteRotation[1]), e.shape !== void 0) {
                let r = e.shape.size ?? this.system.data.shape.size, i = [
                    Number(this.shared.getVariable(r[0], [
                        this.uuid,
                        "particles",
                        "shape_size_0"
                    ])),
                    Number(this.shared.getVariable(r[1], [
                        this.uuid,
                        "particles",
                        "shape_size_1"
                    ])),
                    Number(this.shared.getVariable(r[2], [
                        this.uuid,
                        "particles",
                        "shape_size_2"
                    ]))
                ], s = {
                    ...tc(this.system.data).shape,
                    size: i
                };
                this.emitterShape?.applyToShader(this.positionSimRT.material.uniforms, s);
            }
            if (e.gravity !== void 0 && (this.worldGravity.set(0, Number(this.shared.getVariable(this.system.data.gravity, [
                this.uuid,
                "particles",
                "gravity"
            ])) / 100, 0), this.velocitySimRT.material.uniforms.uGravity = {
                value: this.worldGravity
            }), e.direction !== void 0) {
                let r = this.getDirectionFromVariable(e.direction);
                this.directionAxis = this.getDirectionAxis(r), this.velocitySimRT.material.uniforms.uDirectionsAxis.value = this.directionAxis;
            }
            e.randomRotation !== void 0 && (this.material.uniforms.uRandRotationFactor.value = e.randomRotation), e.randomScale !== void 0 && (this.material.uniforms.uRandScaleFactor.value = e.randomScale);
        }
    }
    updateForceFieldParameters(e) {
        !this.velocitySimRT || (e.forceIntensity !== void 0 && (this.velocitySimRT.material.uniforms.uForceIntensity.value = e.forceIntensity), e.forceDambing !== void 0 && (this.velocitySimRT.material.uniforms.uForceDamping.value = e.forceDambing));
    }
    getDirectionAxis(e) {
        let r = [
            Number(e[0]) * we.DEG2RAD,
            Number(e[1]) * we.DEG2RAD,
            Number(e[2]) * we.DEG2RAD
        ], i = new nr(r[0], r[1], r[2], "XYZ");
        return this.directionAxis.set(0, 1, 0).applyEuler(i).normalize(), this.velocitySimRT && (this.velocitySimRT.material.uniforms.uDirectionsAxis.value = this.directionAxis), this.directionAxis;
    }
    shouldReInitGPUCompute(e) {
        let { birthRatePerSec: r, rootObjectType: i, colliderEntityId: s, shape: o, emitTimeDuration: a, emitTimeCycle: l, life: c, directionMode: u, noiseType: h } = e;
        return r !== void 0 || i !== void 0 || s || s === null || l !== void 0 || o !== void 0 || c !== void 0 || a !== void 0 || u !== void 0 || h !== void 0;
    }
    init(e) {
        this.dispose(), this.particlesAmount = this.getMaxParticlesAmount({
            birthRatePerSecond: e.birthRatePerSec,
            particleMaxLifeTime: e.life,
            loopDuration: e.emitTimeCycle === "infinity" ? 0 : e.emitTimeDuration
        }), this.particlesAmount > 1e5 && (console.warn(`The maximum number of particles is limited to ${1e5}.`), this.particlesAmount = 1e5), this.emitterShape = this.createShape(e.shape, this.particlesAmount);
        let r = setInterval(()=>{
            if (!!this.emitterShape) {
                if (isNaN(this.emitterShape.positionsTexture.source.data.data[0])) {
                    this.init(e);
                    return;
                } else clearInterval(r);
            }
        }, 100);
        if (!this.emitterShape) return;
        let i = new $x(this.emitterShape.textureSize, this.emitterShape.textureSize, this.renderer), s = this.updateSimulationDefinition(e), o = i.addVariable("uCurrentPosition", s + YL, this.emitterShape.positionsTexture), a = i.addVariable("uCurrentVelocity", s + JL, this.emitterShape.directionsTexture), l = i.addVariable("uCurrentEmissionRate", sB, qL(this.emitterShape.textureSize));
        i.setVariableDependencies(o, [
            o,
            a,
            l
        ]), i.setVariableDependencies(a, [
            o,
            a,
            l
        ]), i.setVariableDependencies(l, [
            o,
            a,
            l
        ]);
        let c = WL({
            size: this.emitterShape.textureSize
        }), u = {
            uOriginalPosition: {
                value: this.emitterShape.positionsTexture
            },
            uWorldOffset: {
                value: new E(0, 0, 0)
            },
            uWorldQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uTime: {
                value: 0
            },
            uFPSRatio: {
                value: 1
            },
            uMaxLifeTime: {
                value: e.life
            },
            uEmitterSize: {
                value: new E(Number(this.shared.getVariable(e.shape.size[0], [
                    this.uuid,
                    "particles",
                    "shape_size_0"
                ])), Number(this.shared.getVariable(e.shape.size[1], [
                    this.uuid,
                    "particles",
                    "shape_size_1"
                ])), Number(this.shared.getVariable(e.shape.size[2], [
                    this.uuid,
                    "particles",
                    "shape_size_2"
                ])))
            },
            particleSize: {
                value: 0
            }
        };
        o.material.uniforms = u;
        let h = this.getDirectionFromVariable(e.direction);
        this.directionAxis = this.getDirectionAxis(h), this.worldGravity.set(0, Number(this.shared.getVariable(this.system.data.gravity, [
            this.uuid,
            "particles",
            "gravity"
        ])) / 100, 0), this.noiseStrength = Number(this.shared.getVariable(e.noiseStrength, [
            this.uuid,
            "particles",
            "noiseStrength"
        ])), this.noiseScale = Number(this.shared.getVariable(e.noiseScale, [
            this.uuid,
            "particles",
            "noiseScale"
        ]));
        let d = e.colliderEntityId && this.system.getColliderData(e.colliderEntityId), f = {
            uOriginalPosition: {
                value: this.emitterShape.positionsTexture
            },
            uDirections: {
                value: this.emitterShape.directionsTexture
            },
            uDirectionsAxis: {
                value: this.directionAxis
            },
            uWorldQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uColliderPos: {
                value: new E(0, 0, 0)
            },
            uColliderSize: {
                value: new E(0, 0, 0)
            },
            uForceIntensity: {
                value: d ? d.forceIntensity : 0
            },
            uForceDamping: {
                value: d ? d.forceDambing : 0
            },
            uColliderQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uColliderQuaternionInvert: {
                value: new Ze(0, 0, 0, 1)
            },
            particleSize: {
                value: 0
            },
            uGravity: {
                value: this.worldGravity
            },
            uNoiseStrength: {
                value: this.noiseStrength
            },
            uNoiseScale: {
                value: this.noiseScale
            },
            uNoiseSeed: {
                value: e.noiseSeed
            },
            uRandomMassFactor: {
                value: e.randomMass
            },
            uBounce: {
                value: e.collisionBounce
            },
            uSpeed: {
                value: Number(this.shared.getVariable(e.speed, [
                    this.uuid,
                    "particles",
                    "speed"
                ])) / fT
            }
        };
        a.material.uniforms = f;
        let p = {
            uIndex: {
                value: c
            },
            uTime: {
                value: 0
            },
            uLastIndexEmitted: {
                value: 0
            },
            uParticlesToEmit: {
                value: 0
            }
        };
        l.material.uniforms = p;
        let m = [
            Number(this.shared.getVariable(e.shape.size[0], [
                this.uuid,
                "particles",
                "shape_size_0"
            ])),
            Number(this.shared.getVariable(e.shape.size[1], [
                this.uuid,
                "particles",
                "shape_size_1"
            ])),
            Number(this.shared.getVariable(e.shape.size[2], [
                this.uuid,
                "particles",
                "shape_size_2"
            ]))
        ], g = {
            ...tc(this.system.data).shape,
            size: m
        };
        this.emitterShape.applyToShader(o.material.uniforms, g), i.init(), this.gpuCompute = i, this.positionSimRT = o, this.velocitySimRT = a, this.emissionRateSimRT = l, this.rootObject = this.createPrimaryEmitter(this.emitterShape.textureSize), this.add(this.rootObject), this.material.needsUpdate = !0;
    }
    getDirectionFromVariable(e) {
        let r = Number(this.shared.getVariable(e[0], [
            this.uuid,
            "particles",
            "direction_x"
        ])), i = Number(this.shared.getVariable(e[1], [
            this.uuid,
            "particles",
            "direction_y"
        ])), s = Number(this.shared.getVariable(e[2], [
            this.uuid,
            "particles",
            "direction_z"
        ]));
        return [
            r,
            i,
            s
        ];
    }
    updateSimulationDefinition(e) {
        if (this.simFeaturesDefinition.USE_COLLIDER = !1, this.simFeaturesDefinition.USE_ATTRACTOR = !1, this.simFeaturesDefinition.USE_VORTEX = !1, this.simFeaturesDefinition.USE_SPHERE_COLLIDER = !1, this.simFeaturesDefinition.USE_BOX_COLLIDER = !1, this.simFeaturesDefinition.USE_FORCE_LOCAL_SPACE = !1, this.simFeaturesDefinition.USE_NORMALS = !1, this.simFeaturesDefinition.USE_CURL_NOISE = !1, this.simFeaturesDefinition.USE_SIMPLEX_NOISE = !1, this.simFeaturesDefinition.USE_FBM_NOISE = !1, e.colliderEntityId && this.system.colliderEntities.length > 0) {
            let i = this.system.getColliderData(e.colliderEntityId);
            switch(i?.forceType){
                case "attractor":
                    this.simFeaturesDefinition.USE_ATTRACTOR = !0;
                    break;
                case "collider":
                    this.simFeaturesDefinition.USE_COLLIDER = !0;
                    break;
                case "vortex":
                    this.simFeaturesDefinition.USE_VORTEX = !0;
                    break;
            }
            let s = i?.colliderType;
            s === "sphere" && (this.simFeaturesDefinition.USE_SPHERE_COLLIDER = !0), s === "box" && (this.simFeaturesDefinition.USE_BOX_COLLIDER = !0), i?.forceRange === "helper" && (this.simFeaturesDefinition.USE_FORCE_LOCAL_SPACE = !0);
        }
        e.directionMode === "normals" && (this.simFeaturesDefinition.USE_NORMALS = !0), e.noiseType === "curl" && (this.simFeaturesDefinition.USE_CURL_NOISE = !0), e.noiseType === "simplex" && (this.simFeaturesDefinition.USE_SIMPLEX_NOISE = !0), e.noiseType === "fbm" && (this.simFeaturesDefinition.USE_FBM_NOISE = !0);
        let r = "";
        for (let [i, s] of Object.entries(this.simFeaturesDefinition))s && (r += `#define ${i}
`);
        return r;
    }
    createShape(e, r) {
        this.emitterShape && this.emitterShape.dispose();
        let i = new E(Number(this.shared.getVariable(e.size[0], [
            this.uuid,
            "particles",
            "shape_size_0"
        ])), Number(this.shared.getVariable(e.size[1], [
            this.uuid,
            "particles",
            "shape_size_1"
        ])), Number(this.shared.getVariable(e.size[2], [
            this.uuid,
            "particles",
            "shape_size_2"
        ])));
        if (e.type === "MeshEmitterShape") {
            let s = null;
            return this.system.context.scene.traverseEntity((o)=>{
                o.uuid === e.fromMeshId && (s = o);
            }), s ? new If(i, r, e.type, s) : new If(i, r, "SphereEmitterShape");
        } else return new If(i, r, e.type);
    }
    createPrimaryEmitter(e) {
        let r, i = e * e;
        return r = new my(new Li(1, 1, 1), this.material, i), this.updateGeometryAttributes(r, e), this.material.needsUpdate = !0, r.onBeforeRender = ()=>{
            this.applyWorldSpace();
        }, r;
    }
    getMaxParticlesAmount({ birthRatePerSecond: e, particleMaxLifeTime: r, loopDuration: i = 0 }) {
        return Math.ceil(e * (r + i));
    }
    dispose() {
        !this.gpuCompute || (this.rootObject?.parent?.remove(this.rootObject), this.gpuCompute.dispose(), this.material.nodeMaterialDispose(), this.emitterShape?.dispose());
    }
    GoEmitSomeParticles(e, r) {
        let i = e - this.lastEmitTime, s = 1 / r;
        if (i >= s) {
            let o = Math.max(1, Math.floor(i / s));
            return this.lastEmitTime = e, this.emittedParticlesAmount + o > this.particlesAmount && (this.emittedParticlesAmount = 0), this.emittedParticlesAmount += o, o;
        }
        return 0;
    }
    checkIfAllParticlesAreDead() {
        return this.lastEmitTime + this.system.data.life + 1 < this.globalTime;
    }
    reset() {
        this.hasBeenReset = !0, this.lastEmitTime = 0, this.emittedParticlesAmount = 0, this.gpuCompute && this.init(tc(this.system.data));
    }
    startEmitting(e) {
        this.isEmitting = !0, this.hasBeenReset = !1, this.lastEmitTime = e;
    }
    stopEmitting() {
        this.isEmitting = !1;
    }
};
var rc = class extends mr {
    constructor(e, r, i){
        super(e, r);
        this.type = "ParticleSystem";
        this.geometry = new _e;
        this.actualTime = 0;
        this.currentLoopTime = 0;
        this.started = !1;
        this.stopped = !1;
        this.timeoutId = void 0;
        this.isFrozen = !1;
        this.isIdle = !0;
        this.emitter = null;
        this.colliderEntities = [];
        this.renderer = null;
        this.isPreWarm = !1;
        this._hasOnAfterRenderBeenCalled = !1;
        this.onAfterRender = (e)=>{
            this._hasOnAfterRenderBeenCalled || (this._hasOnAfterRenderBeenCalled = !0, this.init(e));
        };
        this.context = i, this.data = {
            ...r,
            ...tc(r)
        }, this.geometry.setAttribute("position", new Te([], 3)), this.material = new on({
            colorWrite: !1
        }), this.frustumCulled = !1;
    }
    init(e) {
        this.renderer = e, this.emitter = new ib(e, this), this.add(this.emitter), this.updateParticleState(this.data);
    }
    update(e) {
        if (!this.isReady || !this.started || this.isFrozen || this.isIdle) return;
        this.actualTime += e, this.stopped || (this.currentLoopTime += e);
        let r = this.data.emitTimeCycle === "one_time";
        if ((this.data.emitTimeCycle === "loop" || r) && this.currentLoopTime > this.data.emitTimeDuration * 1e3 && (this.stopped || (this.stop(), r || this.start(this.data.emitTimeDelay * 1e3))), this.emitter && this.started) {
            let s = this.actualTime / 1e3;
            this.emitter.update(s, e);
        }
        this.scale.set(1, 1, 1), this.updateMatrix();
    }
    isReady() {
        return !!this.emitter;
    }
    hasCollider(e) {
        return this.colliderEntities.some((r)=>r.identity === e);
    }
    getColliderData(e) {
        let r = this.colliderEntities.find((i)=>i.identity === e);
        return r ? r.data : null;
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), Lt(e.path, [
            "renderMaterial"
        ]) && this.updateParticleState({
            renderMaterial: {
                ...this.data.renderMaterial,
                ...Lr.drop(e, 1).props
            }
        }), Lt(e.path, [
            "shape"
        ]) && this.updateParticleState({
            shape: {
                ...this.data.shape,
                ...Lr.drop(e, 1).props
            }
        });
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateParticleState(e);
    }
    updateParticleState(e) {
        if (!!this.emitter) {
            if (e.colliderEntityId !== void 0 && e.colliderEntityId !== null) {
                let r = this.context.scene.find(e.colliderEntityId);
                this.colliderEntities = r ? [
                    r
                ] : [];
            }
            e.colliderEntityId === null && (this.colliderEntities = []), this.emitter.updateState(e), e.emitTimeCycle && this.started && this.start();
        }
    }
    updateFromColliderEntity(e) {
        !this.emitter || (this.emitter.updateForceFieldParameters(e), this.stop(), this.start());
    }
    start(e = 0) {
        if (this.currentLoopTime = 0, e) {
            this.timeoutId = window.setTimeout(()=>{
                this.start(0);
            }, e);
            return;
        }
        this.started = !0, this.stopped = !1, this.isFrozen = !1, this.emitter?.startEmitting(this.actualTime / 1e3);
    }
    froze() {
        this.isFrozen = !0;
    }
    unFroze() {
        this.isFrozen = !1;
    }
    stop() {
        this.stopped = !0, this.currentLoopTime = 0, this.emitter?.stopEmitting(), clearTimeout(this.timeoutId);
    }
    reset() {
        this.started = !1, this.stopped = !1, this.emitter?.reset();
    }
    wakeUp() {
        this.isIdle = !1;
    }
    sleep() {
        this.isIdle = !0, this.reset();
    }
};
function AZ() {
    try {
        let n1 = window.location.href;
        if (n1.includes("reducesubdiv=")) {
            let t = n1.indexOf("reducesubdiv=") + 13;
            return parseInt(n1.slice(t, t + 1));
        }
    } catch  {}
}
var pT = AZ();
function EZ(n1, t, e) {
    pT !== void 0 && (t?.geometry?.subdivisions ?? 0) > pT && (console.log("reducing subdivisions", t.name, t.geometry.subdivisions), t.geometry.subdivisions = pT);
    let r;
    return t.geometry.type === "TextGeometry" ? new Hl(n1, t, e) : t.geometry.type === "InputGeometry" ? new ec(n1, t, e) : (t.geometry.type === "SubdivGeometry" ? r = new Zs(n1, t, e) : t.geometry.type === "PathGeometry" ? r = new $l(n1, t, e) : t.geometry.type === "VectorGeometry" ? r = new Qx(n1, t, e) : t.geometry.type === "BooleanGeometry" ? r = new Fn(n1, t, e) : t.geometry.type === "UIGeometry" ? r = new Er(n1, t, e) : r = new cr(n1, t, e), r);
}
function nb(n1, t, e) {
    return console.assert(t.type !== void 0), t.type === "Mesh" ? EZ(n1, t, e) : t.type === "Empty" ? new As(n1, t) : t.type === "Particle" ? new rc(n1, t, e) : t.type === "ParticleCollider" ? new ql(n1, t, e) : t.type === "Splat" ? new As(n1, t) : t.type === "Bone" ? new Jx(n1, t) : t.type === "Page" ? new ur(n1, t, e) : t.type === "PointLight" ? new Kx(n1, t, e) : t.type === "SpotLight" ? new Cf(n1, t, e) : t.type === "DirectionalLight" ? new Mf(n1, t, e) : t.type === "Component" || t.type === "Instance" ? new eo(n1, t, e) : ks.is(t.type) ? new wr(n1, t) : (console.error(t), new As(n1, t));
}
Hs.createEntity = nb;
function TZ(n1, t, e) {
    let r = nb(n1.identity, t, e), i = n1.children, s = n1.attachedPaths, o = n1.parent, a = n1.component, l = n1.instances, c = n1.overrideData, u = n1.uuid, h = n1.stateSelection;
    n1.dispose();
    for (let d of Object.keys(n1))delete n1[d];
    Object.setPrototypeOf(n1, Object.getPrototypeOf(r));
    for (let d of Object.keys(r))n1[d] = r[d];
    n1.children = [
        ...n1.children,
        ...i
    ], n1.attachedPaths = s, n1.parent = o, n1.component = a, n1.instances = l, n1.uuid = u, n1.overrideData = c, n1.updateState(n1.data, e), h && n1.changeSelectedState(h, e), n1.resetBBoxNeedsUpdate();
}
Hs.changeEntityProptotype = TZ;
Hs.Cloner = Gi;
function aB(n1, t, e, r) {
    n1.updateByOp(t, e, r, !1);
}
function lB(n1, t) {
    let e = !1, r = t.getLayersOfType("transmission"), i = t.getLayersOfType("outline");
    return i.length > 0 && (n1.layers.set(8), r.length > 0 && n1.layers.enable(3), e = !0, sf(n1), nf(n1)), r.length === 0 && i.length === 0 && n1.layers.set(0), n1 instanceof vs && n1.needsAO && n1.layers.enable(5), e;
}
function cB(n1, t) {
    if (!t.layers) return !1;
    let e = !1, r = t.getLayersOfType("transmission").filter((s)=>s.data.visible), i = t.getLayersOfType("outline").filter((s)=>s.data.visible);
    return r.length > 0 && (n1.layers.set(3), i.length > 0 && n1.layers.enable(8), e = !0), r.length === 0 && i.length === 0 && n1.layers.set(0), n1.needsAO && n1.layers.enable(5), e;
}
function uB(n1) {
    let t = !1;
    return n1.traverseEntity((e)=>{
        if (e instanceof vs) {
            if (Array.isArray(e.material)) for(let r = 0; r < e.material.length; r++)lB(e, e.material[r]) && (t = !0);
            else lB(e, e.material) && (t = !0);
        }
    }), t;
}
function hB(n1) {
    let t = !1;
    return n1.traverseEntity((e)=>{
        if (e instanceof vs) {
            if (Array.isArray(e.material)) for(let r = 0; r < e.material.length; r++)cB(e, e.material[r]) && (t = !0);
            else cB(e, e.material) && (t = !0);
        }
    }), t;
}
var MZ = new Zu, CZ = new ue, PZ = new Ls;
function Wm(n1, t, e, r = !1) {
    let i = n1.cloner;
    if (i) for (let s of i.children){
        let o = CZ.copy(s.matrixWorld).invert(), a = PZ.copy(t.ray).applyMatrix4(o), l = n1.matrixWorld;
        a.applyMatrix4(l);
        let c = MZ;
        c.set(a.origin, a.direction), c.near = t.near, c.far = t.far;
        let u = c.intersectObject(n1, !1);
        u.length > 0 && e.push({
            ...u[0],
            object: r ? s : n1
        });
    }
}
var sb = class {
    constructor(){
        this._constraints = new Map;
    }
    setConstraint(t, e) {
        e === null ? this._constraints.delete(t) : this._constraints.set(t, e);
    }
    removeDependencies(t) {
        this._constraints.delete(t);
    }
    applyConstraints(t) {
        let e = new Set;
        this._constraints.forEach((r, i)=>{
            let s = [
                i,
                r
            ], o = r;
            for(; this._constraints.has(o);){
                if (o = this._constraints.get(o), s.includes(o)) {
                    console.warn(`circular dependency detected: ${s.join(" -> ")}`);
                    break;
                }
                e.has(o) || s.push(o);
            }
            for(let a = s.length - 2; a >= 0; a--)if (!e.has(s[a])) {
                let l = t.find(s[a]);
                l ? l.applyPathSnapping(t) : console.warn(`missing entity ${s[a]}`), e.add(s[a]);
            }
        });
    }
    findDependency(t, e) {
        let r = t;
        for(; this._constraints.has(r);)if (r = this._constraints.get(r), r === e) return !0;
        return !1;
    }
};
var dB = "AGFzbQEAAAAADwhkeWxpbmsuMAEEAAAAAAETA2AAAGAIf39/f39/f38AYAABfwISAQNlbnYGbWVtb3J5AgMAgIAEAwQDAAECBzkDEV9fd2FzbV9jYWxsX2N0b3JzAAALc29ydEluZGV4ZXMAARNlbXNjcmlwdGVuX3Rsc19pbml0AAIK3gMDAwABC9IDAwF/BnwBfgJAIAdFDQAgAysDUCEMIAMrAzAhDSADKwMQIQ5BACEDRP///////+9/IQtEAAAAAAAAEAAhCgNAIAIgA0ECdGoCfyAOIAEgA0EMbGoiCCoCALuiIA0gCCoCBLuioCAMIAgqAgi7oqBEAAAAAAAAsECiIgmZRAAAAAAAAOBBYwRAIAmqDAELQYCAgIB4CzYCACAJIAsgCSALYxshCyAJIAogCSAKZBshCiADQQFqIgMgB0cNAAsgB0UNACAGuCAKIAuhoyEJQQAhAwNAAn8gCSACIANBAnRqIgEoAgC3IAuhoiIKmUQAAAAAAADgQWMEQCAKqgwBC0GAgICAeAshCCABIAg2AgAgBCAIQQJ0aiIBIAEoAgBBAWo2AgAgA0EBaiIDIAdHDQALCyAGQQJPBEAgBCgCACEIQQEhAwNAIAQgA0ECdGoiASABKAIAIAhqIgg2AgAgA0EBaiIDIAZHDQALCyAHQQFrIgGtIQ8DQCAEIAIgD6dBAnQiA2ooAgBBAnRqIgcgBygCAEEBayIHNgIAIAUgASAHa0ECdGogACADaigCADYCACAPUCEDIA9CAX0hDyADRQ0ACyAGBEAgBEEAIAZBAnT8CwALCwQAQQAL";
var Ho = class {
};
uo(Ho, "DepthMapRange", 65536), uo(Ho, "MemoryPageSize", 65536), uo(Ho, "BytesPerFloat", 4), uo(Ho, "BytesPerInt", 4);
function _Z(n1) {
    let t, e, r, i, s, o, a, l, c, u, h, d, f, p, m, g;
    function y(P) {
        let I = new Float64Array(u, o, 16);
        for(let D = 0; D < 16; D++)I[D] = P[D];
        let _;
        if (r > 1) {
            t.exports.sortIndexes(i, s, c, o, a, l, d.DepthMapRange, r);
            let D = new Uint32Array(r);
            _ = D.buffer, D.set(new Uint32Array(u, l, r));
        } else if (r === 1) {
            let D = new Uint32Array(r);
            D[0] = new Uint32Array(u, i, e)[0], _ = D.buffer;
        } else _ = new ArrayBuffer(0);
        n1.postMessage({
            sortDone: !0,
            indexesBuffer: _
        }, [
            _
        ]);
    }
    function x(P, I, _) {
        let D = new Float32Array(u, s, e * 3);
        r = 0;
        let L = new Uint32Array(u, i, e);
        for(let j = 0; j < _.length - 1; j++){
            let V = I[j], H = P[j].elements, W = V.filter((Q)=>Q.enabled && Q.mode === "Include").map((Q)=>Q.type === "Box" ? A(Q) : M(Q)), q = V.filter((Q)=>Q.enabled && Q.mode === "Exclude").map((Q)=>Q.type === "Box" ? A(Q) : M(Q));
            for(let Q = _[j]; Q < _[j + 1]; Q++){
                let G = f[Q * 3], Z = f[Q * 3 + 1], te = f[Q * 3 + 2];
                if ((W.length === 0 || S(G, Z, te, W)) && (q.length === 0 || !S(G, Z, te, q))) {
                    let $ = 1 / (H[3] * G + H[7] * Z + H[11] * te + H[15]);
                    D[r * 3] = (H[0] * G + H[4] * Z + H[8] * te + H[12]) * $, D[r * 3 + 1] = (H[1] * G + H[5] * Z + H[9] * te + H[13]) * $, D[r * 3 + 2] = (H[2] * G + H[6] * Z + H[10] * te + H[14]) * $, L[r] = Q, r++;
                }
            }
        }
    }
    function v(P, I) {
        let _ = [], D = I.filter((V)=>V.enabled && V.mode === "Include").map((V)=>V.type === "Box" ? A(V) : M(V)), L = I.filter((V)=>V.enabled && V.mode === "Exclude").map((V)=>V.type === "Box" ? A(V) : M(V)), j = P.length;
        for(let V = 0; V < j; V += 3){
            let H = P[V], W = P[V + 1], q = P[V + 2];
            (D.length === 0 || S(H, W, q, D)) && (L.length === 0 || !S(H, W, q, L)) || _.push(V / 3);
        }
        return _;
    }
    function S(P, I, _, D, L) {
        return D[L === "Intersect" ? "every" : "some"]((j)=>{
            let V = w(P, I, _, j.invRotationMatrix, j.cropCenter);
            return Array.isArray(j) ? b(V.x, V.y, V.z, j) : C(V.x, V.y, V.z, j);
        });
    }
    function w(P, I, _, D, L) {
        let j = P - L[0], V = I - L[1], H = _ - L[2], W = 1 / (D[3] * j + D[7] * V + D[11] * H + D[15]);
        return {
            x: (D[0] * j + D[4] * V + D[8] * H + D[12]) * W + L[0],
            y: (D[1] * j + D[5] * V + D[9] * H + D[13]) * W + L[1],
            z: (D[2] * j + D[6] * V + D[10] * H + D[14]) * W + L[2]
        };
    }
    function A(P) {
        let I = P.cropSize[0] / 2, _ = P.cropSize[1] / 2, D = P.cropSize[2] / 2, L = [
            P.cropCenter[0] - I,
            P.cropCenter[1] - _,
            P.cropCenter[2] - D,
            P.cropCenter[0] + I,
            P.cropCenter[1] + _,
            P.cropCenter[2] + D
        ], j = T(P.cropRotation);
        return Object.assign(L, {
            invRotationMatrix: j,
            cropCenter: P.cropCenter
        });
    }
    function T(P) {
        let I = [], _ = P[0] * Math.PI / 180, D = P[1] * Math.PI / 180, L = P[2] * Math.PI / 180, j = Math.cos(_), V = Math.sin(_), H = Math.cos(D), W = Math.sin(D), q = Math.cos(L), Q = Math.sin(L), G = j * q, Z = j * Q, te = V * q, $ = V * Q;
        return I[0] = H * q, I[1] = -H * Q, I[2] = W, I[4] = Z + te * W, I[5] = G - $ * W, I[6] = -V * H, I[8] = $ - G * W, I[9] = te + Z * W, I[10] = j * H, I[12] = 0, I[13] = 0, I[14] = 0, I[3] = 0, I[7] = 0, I[11] = 0, I[15] = 1, I;
    }
    function b(P, I, _, D) {
        return P >= D[0] && P <= D[3] && I >= D[1] && I <= D[4] && _ >= D[2] && _ <= D[5];
    }
    function M(P) {
        let I = 2 / P.cropSize[0], _ = 2 / P.cropSize[1], D = 2 / P.cropSize[2], L = T(P.cropRotation);
        return {
            invRadiusX: I,
            invRadiusY: _,
            invRadiusZ: D,
            cropCenter: P.cropCenter,
            invRotationMatrix: L
        };
    }
    function C(P, I, _, D) {
        let L = (P - D.cropCenter[0]) * D.invRadiusX, j = (I - D.cropCenter[1]) * D.invRadiusY, V = (_ - D.cropCenter[2]) * D.invRadiusZ;
        return L * L + j * j + V * V <= 1;
    }
    n1.onmessage = (P)=>{
        if (P.data.getCroppedIndexes) {
            let I = new Uint32Array(v(new Float32Array(P.data.positions), P.data.crops)).buffer;
            n1.postMessage({
                outOfBoundsIndexes: I
            }, [
                I
            ]);
        } else if (P.data.positions) h = P.data.positions, f = new Float32Array(h), m = P.data.meshMatrixWorlds, g = P.data.cropsArray, p = P.data.meshIndexIntervals, x(m, g, p), n1.postMessage({
            sortSetupComplete: !0
        });
        else if (P.data.sort || P.data.newMatrixWorlds || P.data.newCropsArray) (P.data.newMatrixWorlds || P.data.newCropsArray) && (g = P.data.newCropsArray || g, m = P.data.newMatrixWorlds || m, x(m, g, p)), y(P.data.sort.view, P.data.sort.cameraPosition);
        else if (P.data.init) {
            d = P.data.init.Constants, e = P.data.init.splatCount;
            let I = d.BytesPerInt, _ = d.BytesPerFloat * 3, D = new Uint8Array(P.data.init.sorterWasmBytes), L = I + _, j = e * L, V = e * d.BytesPerInt * 2 + d.DepthMapRange * d.BytesPerInt * 2, H = d.MemoryPageSize * 32, W = j + V + H, q = Math.floor(W / d.MemoryPageSize) + 1, Q = {
                module: {},
                env: {
                    memory: new WebAssembly.Memory({
                        initial: q * 2,
                        maximum: q * 3,
                        shared: !0
                    })
                }
            };
            WebAssembly.compile(D).then((G)=>WebAssembly.instantiate(G, Q)).then((G)=>{
                t = G, i = 0, s = e * I, o = s + e * _, c = o + 16 * d.BytesPerFloat * 2, a = c + e * d.BytesPerInt, l = a + d.DepthMapRange * d.BytesPerInt, u = Q.env.memory.buffer, n1.postMessage({
                    sortSetupPhase1Complete: !0
                });
            });
        }
    };
}
function fB(n1) {
    let t = new Worker(URL.createObjectURL(new Blob([
        "(",
        _Z.toString(),
        ")(self)"
    ], {
        type: "application/javascript"
    }))), e = atob(dB), r = new Uint8Array(e.length);
    for(let i = 0; i < e.length; i++)r[i] = e.charCodeAt(i);
    return t.postMessage({
        init: {
            sorterWasmBytes: r.buffer,
            splatCount: n1,
            Constants: {
                BytesPerFloat: Ho.BytesPerFloat,
                BytesPerInt: Ho.BytesPerInt,
                DepthMapRange: Ho.DepthMapRange,
                MemoryPageSize: Ho.MemoryPageSize
            }
        }
    }), t;
}
var ob = function() {
    let n1 = new Float32Array(1), t = new Int32Array(n1.buffer);
    return function(e) {
        return n1[0] = e, t[0];
    };
}(), pB = function(n1, t, e, r) {
    return n1 + (t << 8) + (e << 16) + (r << 24);
};
var ab = new k;
function lb(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        if (r.visible === !1) return !0;
        r.type === "Splat" && (t = !0);
    }), t;
}
var ic = class extends zt {
    constructor(e, r, i, s, o = !1, a = 1, l, c){
        super(i, s);
        this.splatCount = r, this.meshIndexIntervals = l, this.meshMatrixWorlds = c, this.splatBuffers = e, this.geometry = i, this.material = s, this.splatDataTextures = null, this.halfPrecisionCovariancesOnGPU = o, this.devicePixelRatio = a, this.resetLocalSplatDataAndTexturesFromSplatBuffer();
    }
    static buildMesh(e, r, i = !1, s = 1, o, a) {
        let l = ic.buildGeomtery(r), c = ic.buildMaterial(o);
        return new ic(e, r, l, c, i, s, o, a);
    }
    static buildMaterial(e) {
        let r = `
            precision highp float;
            #include <common>

            attribute uint splatIndex;

            uniform highp sampler2D covariancesTexture;
            uniform highp usampler2D centersColorsTexture;
            uniform vec2 focal;
            uniform vec2 viewport;
            uniform vec2 basisViewport;
            uniform vec2 covariancesTextureSize;
            uniform vec2 centersColorsTextureSize;
						uniform highp sampler2D meshMatrixWorldsTexture;
						uniform uint meshIndexIntervals[257];
						uniform float orthoZoom;

            varying vec4 vColor;
            varying vec2 vUv;

            varying vec2 vPosition;

            const vec4 encodeNorm4 = vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0);
            const uvec4 mask4 = uvec4(uint(0x000000FF), uint(0x0000FF00), uint(0x00FF0000), uint(0xFF000000));
            const uvec4 shift4 = uvec4(0, 8, 16, 24);
            vec4 uintToRGBAVec (uint u) {
               uvec4 urgba = mask4 & u;
               urgba = urgba >> shift4;
               vec4 rgba = vec4(urgba) * encodeNorm4;
               return rgba;
            }

            vec2 getDataUV(in int stride, in int offset, in vec2 dimensions) {
                vec2 samplerUV = vec2(0.0, 0.0);
                float d = float(splatIndex * uint(stride) + uint(offset)) / dimensions.x;
                samplerUV.y = float(floor(d)) / dimensions.y;
                samplerUV.x = fract(d);
                return samplerUV;
            }

            void main () {
                uvec4 sampledCenterColor = texture(centersColorsTexture, getDataUV(1, 0, centersColorsTextureSize));
                vec3 splatCenter = uintBitsToFloat(uvec3(sampledCenterColor.gba));
                vColor = uintToRGBAVec(sampledCenterColor.r);

                vPosition = position.xy * 2.0;

								uint meshIndex;
								for (int i = 1; i < 257; i++) {
									if (splatIndex < meshIndexIntervals[i]) {
										meshIndex = uint(i - 1);
										break;
									}
								}

								float strideMulmeshIndex = float(4u*meshIndex);
								float meshMatrixWorldsTextureLength = float(256*4);

								mat4 modelMat = mat4(
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+0.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+1.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+2.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+3.0)/meshMatrixWorldsTextureLength, 0))
								);
								mat4 modelViewMat = viewMatrix * modelMat;
								vec4 viewCenter = modelViewMat * vec4(splatCenter, 1.0); 
                vec4 clipCenter = projectionMatrix * viewCenter;

                vec2 sampledCovarianceA = texture(covariancesTexture, getDataUV(3, 0, covariancesTextureSize)).rg;
                vec2 sampledCovarianceB = texture(covariancesTexture, getDataUV(3, 1, covariancesTextureSize)).rg;
                vec2 sampledCovarianceC = texture(covariancesTexture, getDataUV(3, 2, covariancesTextureSize)).rg;

                vec3 cov3D_M11_M12_M13 = vec3(sampledCovarianceA.rg, sampledCovarianceB.r);
                vec3 cov3D_M22_M23_M33 = vec3(sampledCovarianceB.g, sampledCovarianceC.rg);

                // Compute the 2D covariance matrix from the upper-right portion of the 3D covariance matrix
                mat3 Vrk = mat3(
                    cov3D_M11_M12_M13.x, cov3D_M11_M12_M13.y, cov3D_M11_M12_M13.z,
                    cov3D_M11_M12_M13.y, cov3D_M22_M23_M33.x, cov3D_M22_M23_M33.y,
                    cov3D_M11_M12_M13.z, cov3D_M22_M23_M33.y, cov3D_M22_M23_M33.z
                );
                float s = 1.0 / (viewCenter.z * viewCenter.z);

                mat3 W = transpose(mat3(modelViewMat));
                mat3 T = orthoZoom > 0.0 ? W : W * mat3(
									focal.x / viewCenter.z, 0., -(focal.x * viewCenter.x) * s,
									0., focal.y / viewCenter.z, -(focal.y * viewCenter.y) * s,
									0., 0., 0.
								);
                mat3 cov2Dm = transpose(T) * Vrk * T;
                cov2Dm[0][0] += 0.3;
                cov2Dm[1][1] += 0.3;

                // We are interested in the upper-left 2x2 portion of the projected 3D covariance matrix because
                // we only care about the X and Y values. We want the X-diagonal, cov2Dm[0][0],
                // the Y-diagonal, cov2Dm[1][1], and the correlation between the two cov2Dm[0][1]. We don't
                // need cov2Dm[1][0] because it is a symetric matrix.
                vec3 cov2Dv = vec3(cov2Dm[0][0], cov2Dm[0][1], cov2Dm[1][1]);

                vec3 ndcCenter = clipCenter.xyz / clipCenter.w;

                // We now need to solve for the eigen-values and eigen vectors of the 2D covariance matrix
                // so that we can determine the 2D basis for the splat. This is done using the method described
                // here: https://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
                //
                // This is a different approach than in the original work at INRIA. In that work they compute the
                // max extents of the 2D covariance matrix in screen space to form an axis aligned bounding rectangle
                // which forms the geometry that is actually rasterized. They then use the inverse 2D covariance
                // matrix (called 'conic') to determine fragment opacity.
                float a = cov2Dv.x;
                float d = cov2Dv.z;
                float b = cov2Dv.y;
                float D = a * d - b * b;
                float trace = a + d;
                float traceOver2 = 0.5 * trace;
                float term2 = sqrt(trace * trace / 4.0 - D);
                float eigenValue1 = traceOver2 + term2;
								float eigenValue2 = max(traceOver2 - term2, 0.00); // prevent negative eigen value

                const float maxSplatSize = 1024.0;
                vec2 eigenVector1 = normalize(vec2(b, eigenValue1 - a));
                // since the eigen vectors are orthogonal, we derive the second one from the first
                vec2 eigenVector2 = vec2(eigenVector1.y, -eigenVector1.x);
                vec2 basisVector1 = eigenVector1 * min(sqrt(2.0 * eigenValue1), maxSplatSize);
                vec2 basisVector2 = eigenVector2 * min(sqrt(2.0 * eigenValue2), maxSplatSize);

                vec2 ndcOffset = vec2(vPosition.x * basisVector1 + vPosition.y * basisVector2) * basisViewport;

								if (orthoZoom > 0.0) {
									ndcOffset *= orthoZoom;
								}

                gl_Position = vec4(ndcCenter.xy + ndcOffset, ndcCenter.z, 1.0);
            }`, i = `
            precision highp float;
            #include <common>

            uniform vec3 debugColor;

            varying vec4 vColor;
            varying vec2 vUv;

            varying vec2 vPosition;
						layout(location = 1) out vec4 gVelocity; 

            void main () {
                // compute the negative squared distance from the center of the splat to the
                // current fragment in the splat's local space.
                float A = -dot(vPosition, vPosition);
                if (A < -4.0) discard;
                vec3 color = vColor.rgb;
                A = exp(A) * vColor.a;
                gl_FragColor = vec4(color.rgb, A);
								gVelocity = vec4(0.0); // so it is ignored by TAA
            }`, s = {
            covariancesTexture: {
                type: "t",
                value: null
            },
            centersColorsTexture: {
                type: "t",
                value: null
            },
            meshIndexIntervals: {
                value: e
            },
            meshMatrixWorldsTexture: {
                type: "t",
                value: null
            },
            focal: {
                type: "v2",
                value: new k
            },
            viewport: {
                type: "v2",
                value: new k
            },
            basisViewport: {
                type: "v2",
                value: new k
            },
            debugColor: {
                type: "v3",
                value: new We
            },
            covariancesTextureSize: {
                type: "v2",
                value: new k(1024, 1024)
            },
            centersColorsTextureSize: {
                type: "v2",
                value: new k(1024, 1024)
            },
            orthoZoom: {
                type: "f",
                value: -1
            }
        };
        return new it({
            uniforms: s,
            vertexShader: r,
            fragmentShader: i,
            transparent: !0,
            alphaTest: 1,
            blending: Za,
            depthTest: !0,
            depthWrite: !1,
            side: fi
        });
    }
    static buildGeomtery(e) {
        let r = new _e;
        r.setIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        let i = new Float32Array(12), s = new Xe(i, 3);
        r.setAttribute("position", s), s.setXYZ(0, -1, -1, 0), s.setXYZ(1, -1, 1, 0), s.setXYZ(2, 1, 1, 0), s.setXYZ(3, 1, -1, 0), s.needsUpdate = !0;
        let o = new Ap().copy(r), a = new Uint32Array(e), l = new mo(a, 1, !1);
        return l.setUsage(oP), o.setAttribute("splatIndex", l), o.instanceCount = e, o;
    }
    resetLocalSplatDataAndTexturesFromSplatBuffer() {
        this.updateLocalSplatDataFromSplatBuffer(), this.allocateAndStoreLocalSplatDataInTextures();
    }
    updateLocalSplatDataFromSplatBuffer() {
        this.splatBuffers.forEach((s)=>s.buildPreComputedBuffers()), this.covariances = new Float32Array(this.splatCount * 6), this.colors = new Uint8Array(this.splatCount * 4), this.centers = new Float32Array(this.splatCount * 3);
        let e = 0, r = 0, i = 0;
        for (let s of this.splatBuffers){
            let o = s.nsplats;
            this.colors.subarray(e, e + o * 4).set(s.colorsA), e += o * 4, this.centers.subarray(r, r + o * 3).set(s.decoded.xyz.denormDequant().data), r += o * 3, this.covariances.subarray(i, i + o * 6).set(new Float32Array(s.precomputedCovarianceBufferData)), i += o * 6;
        }
    }
    allocateAndStoreLocalSplatDataInTextures() {
        let i = this.splatCount, s = new k(4096, 1024);
        for(; s.x * s.y * 2 < i * 6;)s.y *= 2;
        let o = new k(4096, 1024);
        for(; o.x * o.y * 4 < i * 4;)o.y *= 2;
        let a, l;
        if (this.halfPrecisionCovariancesOnGPU) {
            l = new Uint16Array(s.x * s.y * 2);
            for(let p = 0; p < this.covariances.length; p++)l[p] = SP.toHalfFloat(this.covariances[p]);
            a = new gi(l, s.x, s.y, eh, Wn);
        } else l = new Float32Array(s.x * s.y * 2), l.set(this.covariances), a = new gi(l, s.x, s.y, eh, br);
        a.needsUpdate = !0, this.material.uniforms.covariancesTexture.value = a, this.material.uniforms.covariancesTextureSize.value.copy(s);
        let c = new Uint32Array(o.x * o.y * 4);
        for(let p = 0; p < i; p++){
            let m = p * 4, g = p * 3, y = p * 4;
            c[y] = pB(this.colors[m], this.colors[m + 1], this.colors[m + 2], this.colors[m + 3]), c[y + 1] = ob(this.centers[g]), c[y + 2] = ob(this.centers[g + 1]), c[y + 3] = ob(this.centers[g + 2]);
        }
        let u = new gi(c, o.x, o.y, Lw, Ds);
        u.internalFormat = "RGBA32UI", u.needsUpdate = !0, this.material.uniforms.centersColorsTexture.value = u, this.material.uniforms.centersColorsTextureSize.value.copy(o);
        let h = 1024, d = new Float32Array(4096);
        for(let p = 0; p < this.meshMatrixWorlds.length; p++)d.set(this.meshMatrixWorlds[p].elements, p * 16);
        let f = new gi(d, h, 1, qr, br);
        f.needsUpdate = !0, this.material.uniforms.meshMatrixWorldsTexture.value = f, this.material.uniformsNeedUpdate = !0, this.splatDataTextures = {
            covariances: {
                data: l,
                texture: a,
                size: s
            },
            centerColors: {
                data: c,
                texture: u,
                size: o
            },
            meshMatrixWorlds: {
                data: d,
                texture: f
            }
        };
    }
    updateIndexes(e) {
        let r = this.geometry;
        r.attributes.splatIndex.set(e), r.attributes.splatIndex.needsUpdate = !0, r.instanceCount = e.length;
    }
    updateUniforms(e, r, i, s) {
        this.splatCount > 0 && (ab.set(e.x * this.devicePixelRatio, e.y * this.devicePixelRatio), this.material.uniforms.viewport.value.copy(ab), this.material.uniforms.basisViewport.value.set(2 / ab.x, 2 / ab.y), this.material.uniforms.focal.value.set(r, i), this.material.uniforms.orthoZoom.value = s, this.material.uniformsNeedUpdate = !0);
    }
    getSplatDataTextures() {
        return this.splatDataTextures;
    }
    getSplatCount() {
        return this.splatCount;
    }
    getCenters() {
        return this.centers;
    }
    getColors() {
        return this.colors;
    }
    getCovariances() {
        return this.covariances;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose(), this.splatDataTextures && (this.splatDataTextures.covariances.texture.dispose(), this.splatDataTextures.centerColors.texture.dispose(), this.splatDataTextures.meshMatrixWorlds.texture.dispose()), this.removeFromParent();
    }
};
var gB, mT = new Promise((n1)=>{
    gB = n1;
}), mB = !1;
var cb;

function gT() {
    if (mB) return;
    if (cb) return cb;
    async function n1() {
        let e = await (parcelRequire("88rJr"));
        gB(e), mB = !0;
    }
    return cb = n1(), cb;
}
var yB;
mT.then((n1)=>yB = n1);
var qm = class {
    constructor(t = {}){
        uo(this, "updateView", function() {
            let t = new ue, e = [], r = new E(0, 0, -1), i = new E(0, 0, -1), s = new E, o = new E;
            return function(a = !1, l) {
                let c = this.updateMatrixWorldsInWorkerIfNeeded(), u = this.cropsChanged();
                if (!a) {
                    i.set(0, 0, -1).applyQuaternion(l.quaternion);
                    let d = !1, f = !1;
                    if (i.dot(r) <= .95 && (d = !0), o.copy(l.position).sub(s).length() >= 1 && (f = !0), !d && !f && !c && !u && !this.needsInitialRender) return;
                }
                this.needsInitialRender = !1, s.copy(l.position), r.copy(i), t.copy(l.matrixWorld).invert(), t.premultiply(this.dummyPerspectiveMatrix), e[0] = l.position.x, e[1] = l.position.y, e[2] = l.position.z;
                let h = {
                    sort: {
                        view: t.elements,
                        cameraPosition: e,
                        splatRenderCount: this.splatRenderCount,
                        splatSortCount: this.splatRenderCount
                    },
                    ...c ? {
                        newMatrixWorlds: this.meshMatrixWorlds
                    } : {},
                    ...u ? {
                        newCropsArray: this.cropsArray
                    } : {}
                };
                this.sortRunning ? this.queuedMessage = h : (this.queuedMessage = null, this.sortRunning = !0, this.sortWorker.postMessage(h));
            };
        }());
        this.scene = t.scene, this.currentPage = null, this.devicePixelRatio = window.devicePixelRatio, this.sortWorker = null, this.splatRenderCount = 0, this.splatSortCount = 0, this.splatMesh = null, this.sortRunning = !1, this.meshMatrixWorlds = null, this.meshMatrixWorldsOld = null, this.cropsArray = null, this.splatEntries = null, this.queuedMessage = null, this.needsInitialRender = !0, this.dummyPerspectiveMatrix = new ue().makePerspective(-1, 1, -1, 1, .1, 1e3);
    }
    updateSplatMeshUniforms(t, e) {
        let r = new k;
        if (this.splatMesh === null) return;
        this.splatMesh.getSplatCount() > 0 && (t.getSize(r), this.cameraFocalLengthX = e.projectionMatrix.elements[0] * this.devicePixelRatio * r.x * .45, this.cameraFocalLengthY = e.projectionMatrix.elements[5] * this.devicePixelRatio * r.y * .45, this.splatMesh.updateUniforms(r, this.cameraFocalLengthX, this.cameraFocalLengthY, e.isPerspectiveCamera ? -1 : e.zoom * this.devicePixelRatio));
    }
    loadSplat(t = {}) {
        this.activePage = this.scene.activePage, t.position && (t.position = new E().fromArray(t.position)), t.orientation && (t.orientation = new Ke().fromArray(t.orientation)), t.halfPrecisionCovariances = !!t.halfPrecisionCovariances;
        let e = [];
        if (this.splatEntries = e, this.activePage.traverseVisibleEntity((o)=>{
            o.data.type === "Splat" && e.push(o);
        }), this.splatMesh && this.splatMesh.dispose(), e.length === 0) return this.splatMesh = null, !1;
        this.meshMatrixWorlds = e.map((o)=>o.matrixWorld), this.meshMatrixWorldsOld = e.map((o)=>o.matrixWorld.clone()), this.cropsArray = e.map((o)=>o.data.crops.map((a)=>a.data));
        let r = e.map((o)=>new yB.GSplineBuffer(new Uint8Array(o.data.buffer).buffer)), i = 0, s = [
            0
        ];
        for (let o of r)i += o.getSplatCount(), s.push(i);
        return this.setupSplatMesh(r, i, t.position, t.orientation, t.halfPrecisionCovariances, this.devicePixelRatio, s, this.meshMatrixWorlds), this.setupSortWorker(i), !0;
    }
    updateMatrixWorldsInWorkerIfNeeded() {
        let t = this.splatDataTextures.meshMatrixWorlds.data;
        for(let e = 0; e < this.meshMatrixWorlds.length; e++)t.set(this.meshMatrixWorlds[e].elements, e * 16);
        return this.splatDataTextures.meshMatrixWorlds.texture.needsUpdate = !0, this.meshMatrixWorlds.every((e, r)=>e.equals(this.meshMatrixWorldsOld[r])) ? !1 : (this.meshMatrixWorldsOld = this.meshMatrixWorlds.map((e)=>e.clone()), !0);
    }
    cropsChanged() {
        let t = !1;
        return this.splatEntries.forEach((e, r)=>{
            e.data.crops.forEach((i, s)=>{
                this.cropsArray[r][s] === void 0 ? (t = !0, this.cropsArray[r][s] = i.data) : Object.entries(i.data).forEach(([o, a])=>{
                    Array.isArray(a) && a.some((l, c)=>l !== this.cropsArray[r][s][o][c]) ? (t = !0, this.cropsArray[r][s][o] = a) : a !== this.cropsArray[r][s]?.[o] && (t = !0, this.cropsArray[r][s][o] = a);
                });
            }), e.data.crops.length !== this.cropsArray[r]?.length && (this.cropsArray[r].length = e.data.crops.length, t = !0);
        }), t;
    }
    setupSplatMesh(t, e, r = new E, i = new Ke, s = !1, o = 1, a, l) {
        this.splatMesh = ic.buildMesh(t, e, s, o, a, l), this.splatMesh.position.copy(r), this.splatMesh.quaternion.copy(i), this.splatMesh.frustumCulled = !1, this.splatMesh.renderOrder = 99999, this.splatRenderCount = e, this.splatMesh.onBeforeRender = (c, u, h)=>this.update(c, h);
    }
    setupSortWorker(t) {
        this.sortWorker = fB(t), this.sortWorker.onmessage = (e)=>{
            e.data.sortDone ? (this.sortRunning = !1, this.splatMesh?.updateIndexes(new Uint32Array(e.data.indexesBuffer)), this.lastSortTime = e.data.sortTime, this.queuedMessage && (this.sortWorker.postMessage(this.queuedMessage), this.queuedMessage = null)) : e.data.sortCanceled ? this.sortRunning = !1 : e.data.sortSetupPhase1Complete ? this.sortWorker.postMessage({
                positions: this.splatMesh.getCenters().buffer,
                meshMatrixWorlds: this.splatMesh.meshMatrixWorlds,
                meshIndexIntervals: this.splatMesh.meshIndexIntervals,
                cropsArray: this.cropsArray
            }) : e.data.sortSetupComplete && (this.splatDataTextures = this.splatMesh.getSplatDataTextures(), this.scene.activePage.add(this.splatMesh), this.needsInitialRender = !0);
        };
    }
    update(t, e) {
        this.splatMesh !== null && (this.updateSplatMeshUniforms(t, e), this.updateView(!1, e));
    }
    getSplatMesh() {
        return this.splatMesh;
    }
};
var kx = new on;
kx.wireframe = !0;
var vB = new E, Kl = class extends ei {
    constructor(e, r){
        super();
        this.data = e;
        this.sharedAssets = r;
        this.enableHelpers = !1;
        this.wireframeState = !1;
        this.needsTransmissionDirty = !0;
        this.needsNormalDirty = !0;
        this._needsTransmission = !1;
        this._needsNormal = !1;
        this.geometryCacheChanged = !1;
        this.splatViewer = null;
        this.entityByUuid = {};
        this.entityIdentityToEntity = {};
        this.toExpandCloner = new Set;
        this.toUpdateCloner = new Set;
        this.pendingCommands = [];
        this.pathConstraints = new sb;
        this.invisibleObjects = new As("jflkdsafjasdifjaslk", {
            ...$v.defaultData,
            visible: !1,
            name: "buildin invisible"
        });
        this.needsRecomputeInstances = !1;
        this.init(e, r), this.matrixAutoUpdate = !1, this.errorPage = new ur("fdasfa", {
            ...va.defaultData,
            name: ""
        }, {
            shared: r,
            scene: this
        });
    }
    markGeometryCacheDirty() {
        this.geometryCacheChanged = !0;
    }
    markNeedsUpdateRendererDirty() {
        this.needsTransmissionDirty = !0, this.needsNormalDirty = !0;
    }
    needsTransmission() {
        return this.needsTransmissionDirty && (this._needsTransmission = hB(this), this.needsTransmissionDirty = !1), this._needsTransmission;
    }
    needsNormal() {
        return this.needsNormalDirty && (this._needsNormal = uB(this), this.needsNormalDirty = !1), this._needsNormal;
    }
    registerInstanceAndSetUuid(e) {
        let r = e.identity.join("-"), i = this.entityIdentityToEntity[r];
        i && (e.uuid = i.uuid), this.entityIdentityToEntity[r] = e, this.entityByUuid[e.uuid] = e;
    }
    markPenumbraSizeDirty() {
        for (let e of this.children)e instanceof ur && (e.penumbraSizeArrayCache = null);
    }
    findInstance(e) {
        return this.entityIdentityToEntity[e.join("-")];
    }
    get bgColor() {
        return this.activePage.bgColor;
    }
    get postprocessing() {
        return this.activePage.data.postprocessing;
    }
    getWithSortKey(e) {
        let r = this.find(e);
        if (r === void 0) return;
        let i = [], s = r;
        for(; s !== this;){
            let o = s;
            s = s.parent;
            let a = s.children.indexOf(o);
            i.splice(0, 0, a);
        }
        return {
            entity: r,
            sortKey: i
        };
    }
    getAllSorted(e) {
        let r = [];
        for (let i of e){
            let s = this.getWithSortKey(i.id);
            s !== void 0 && r.push(s);
        }
        return r.sort((i, s)=>hv(i.sortKey, s.sortKey)), r.map((i)=>i.entity);
    }
    nonExistOrDescendantOf(e, r) {
        let i = this.find(e);
        if (i === void 0) return !0;
        for(; i;){
            if (i.uuid === r) return !0;
            i = i.parent;
        }
        return !1;
    }
    find(e) {
        if (this.activePage && this.activePage.personalCamera.parent) {
            if (e === "f23858d0-4a3b-4bd8-8173-66ed0af7f6fb-personalCamera") return this.activePage.personalCamera;
            if (e === hs) return this.activePage.personalCamera;
        }
        if (e === "" || e === void 0) return;
        let r = this.entityByUuid[e];
        return r === void 0 ? this.getObjectByProperty("uuid", e) : r;
    }
    find2D(e) {
        for (let r of this.children)if (r instanceof ur && r.uiScene) {
            let i = r.uiScene.find(e);
            if (i) return i;
        }
    }
    findScene2DfromObject2D(e) {
        for (let r of this.children)if (r instanceof ur && r.uiScene && r.uiScene.find(e)) return r.uiScene;
    }
    find2DInUIObjects(e) {
        let r;
        return this.traverseEntity((i)=>{
            r === void 0 && i instanceof Er && (r = i.uiCanvas.find(e));
        }), r;
    }
    traverse2D(e) {
        for (let r of this.children)r instanceof ur && r.uiScene && r.uiScene.traverse(e);
    }
    debugEnsureEntity(e) {
        let r = this.find(e);
        if (r) {
            if (Array.isArray(r.identity) && this.findInstance(r.identity) === void 0) {
                console.error("not found instance");
                debugger;
            }
        } else {
            console.error("not found");
            debugger;
        }
    }
    addPendingExpandCloner(e) {
        this.toExpandCloner.add(e);
    }
    addPendingUpdateCloner(e) {
        this.toUpdateCloner.add(e);
    }
    markToExpandCloner(e) {
        this.toExpandCloner.add(e), e.traverseEntityAncestors((r)=>{
            this.toExpandCloner.add(r);
        });
    }
    doPendingExpandCloner() {
        this.toExpandCloner.forEach((e)=>{
            e.expandCloner(this);
        }), this.toExpandCloner.clear();
    }
    doPendingUpdateCloner() {
        this.toUpdateCloner.forEach((e)=>{
            e.cloner?.update();
        }), this.toUpdateCloner.clear();
    }
    doPendingUpdates() {
        this.doPendingExpandCloner(), this.doPendingUpdateCloner(), this.applyPendingCommands();
    }
    addPendingCommand(e) {
        this.pendingCommands.push(e);
    }
    applyPendingCommands() {
        this.pendingCommands.forEach((e)=>e()), this.pendingCommands.length = 0;
    }
    updateByLibOp(e, r) {
        e.path.length === 1 && e.path[0] === "components" && e.type === 1 && this.createChildrenObjects([
            {
                ...e.data.asset,
                id: e.id
            }
        ], this.invisibleObjects, r);
    }
    updateTreeByOp(e, r) {
        if (e.path.length === 0 && e.type === 7) {
            let i = e.parent === null ? this : this.find(e.parent);
            if (i === void 0) throw new Error("unexpected");
            let s = this.createObject(e.id, e.data, e.children, i, e.localIndex, r);
            s.updateVisible(this), s.resetBBoxNeedsUpdate(), cn(s) && En(s.parent) && (s.invalidateUpstreamBooleanData(), s.parent.invalidateDownstreamBooleanData().recomputeBoolean()), this.markNeedsRecomputeInstancesForAncessors(i), this.markNeedsRecomputeInstancesForChildren(s), this.markToExpandCloner(s), this.markPenumbraSizeDirty(), s.updatePathSnapping();
        } else if (e.path.length === 0 && e.type === 8) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markToExpandCloner(i), i.resetBBoxNeedsUpdate(), this.unregisterObject(i);
            let s = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s), this.markNeedsRecomputeInstancesForChildren(i), this.markPenumbraSizeDirty(), i.parent.remove(i), En(i.parent) && (i.parent.invalidateUpstreamBooleanData(), i.parent.invalidateDownstreamBooleanData().recomputeBoolean()), cn(i) && (i.freeBooleanPointer(), s instanceof Fn && s.invalidateDownstreamBooleanData().recomputeBoolean()), i instanceof $l && i.detachShape(), this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(i), this.pathConstraints.removeDependencies(i.uuid), i.updatePathSnapping();
        } else if (e.path.length === 0 && e.type === 9) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markNeedsRecomputeInstancesForChildren(i);
            let s = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s), i.cloner?.resetOnMove(), this.markToExpandCloner(i);
            let o = e.parent === null ? this : this.find(e.parent);
            if (o === void 0) throw new Error("unexpected");
            o.add(i), this.markNeedsRecomputeInstancesForAncessors(o), this.markToExpandCloner(i), i.invalidateClonerTransform(i), i.updateVisible(this), i.resetBBoxNeedsUpdate(), this.markPenumbraSizeDirty();
            let a = e.localIndex;
            o.children.splice(a, 0, o.children.pop()), cn(i) && (i.invalidateUpstreamBooleanData(), En(i.parent) ? i.parent.invalidateDownstreamBooleanData().recomputeBoolean() : s instanceof Fn && s.invalidateDownstreamBooleanData().recomputeBoolean()), i.updatePathSnapping();
        }
        this.markNeedsUpdateRendererDirty(), this.markGeometryCacheDirty();
    }
    get playPage() {
        return this.find(this.data.publish.playPage) ?? this.errorPage;
    }
    updatePage(e) {
        this.activePage && this.activePage.onDeactive(), this.activePage = this.errorPage;
        for (let r of this.children)r instanceof ur && (r.visible = r.uuid === e, r.visible && (this.activePage = r, this.activePage.onActive(this)));
        this.activePage !== this.splatViewer?.activePage && this.reloadSplats();
    }
    updateEntityByOp(e, r, i, s) {
        if (r.type === 0) {
            if (("overrides" in r.props || "component" in r.props) && this.markNeedsRecomputeInstances(), "visible" in r.props && this.markPenumbraSizeDirty(), r.path.includes("overrides") && "states" in r.props) {
                let { rest: a } = r.props;
                r = {
                    ...r,
                    props: a
                }, this.markNeedsRecomputeInstances();
            }
            r.path[0] === "pathSnapping" && r.props.pathId !== void 0 && this.pathConstraints.setConstraint(e, r.props.pathId);
        }
        let o = this.find(e);
        if (o) try {
            aB(o, r, i, {
                scene: this,
                shared: s
            }), o instanceof cr && o.updateGeometryGroupsIfNeeded();
        } catch (a) {
            console.error(a);
        }
    }
    updateEntity2DByOp(e, r, i, s, o, a = []) {
        e.updateEntityByOp(r, i, s, o), this.traverseEntity((l)=>{
            (l instanceof Er || l instanceof ur) && (a.includes(l.frameId ?? "") || l.frameId === r) && l.updateEntity2DByOp(r, i, s, o);
        });
    }
    get activeCamera() {
        return this.activePage.activeCamera;
    }
    switchActiveCamera(e) {
        this.activePage.switchActiveCamera(e);
    }
    isInvisibleObjects(e) {
        return e === this.invisibleObjects || e.hasAnccestor(this.invisibleObjects);
    }
    init(e, r) {
        let i = Object.entries(r.data.lib.components).map((s, o)=>({
                data: s[1].asset.data,
                children: s[1].asset.children,
                id: s[0],
                fi: o
            }));
        this.invisibleObjects.updateState(this.invisibleObjects.data, {
            scene: this,
            shared: r
        }), this.add(this.invisibleObjects), this.createChildrenObjects(i, this.invisibleObjects, r), this.createChildrenObjects(e.objects, this, r), this.updatePage(e.publish.playPage), this.activePage.switchToPlayCamera(), this.expandInstances(r, !0), this.traverseEntity((s)=>{
            s instanceof wr && s.updateUp();
        }), this.doPendingExpandCloner(), this.applyPendingCommands();
    }
    markNeedsRecomputeInstances() {
        this.needsRecomputeInstances = !0;
    }
    markNeedsRecomputeInstancesForChildren(e) {
        e.traverseEntity((r)=>{
            (r.data.type === "Component" || r.data.type === "Instance") && this.markNeedsRecomputeInstances();
        });
    }
    markNeedsRecomputeInstancesForAncessors(e) {
        yt.is(e) && (e.data.type === "Component" && this.markNeedsRecomputeInstances(), e.traverseAncestors((r)=>{
            yt.is(r) && r.data.type === "Component" && this.markNeedsRecomputeInstances();
        }));
    }
    relativeizeInner(e, r, i, s, o, a, l) {
        if (e) {
            let c = s.find(e);
            c && c !== s && o.forInstancesRec((u)=>{
                u.data = vl(u.data, (h)=>{
                    let d = h.events.data(l.id), f = u.goUp(a);
                    if (f) {
                        let p = [
                            ...uv(f.identity),
                            e
                        ].join("-"), m = this.entityIdentityToEntity[p];
                        if (m) {
                            let g = m.uuid, y = Sr.zoom(d, r);
                            y[i] = g;
                        } else console.warn("cannot find instance");
                    }
                }).data;
            });
        }
    }
    rewriteActions(e, r, i, s, o, a) {
        e.forEach((l)=>{
            l.data.type === "Transition" ? this.relativeizeInner(l.data.object, [
                ...r,
                l.id
            ], "object", i, s, o, a) : l.data.type === "Animation" ? this.relativeizeInner(l.data.object, [
                ...r,
                l.id
            ], "object", i, s, o, a) : l.data.type === "Conditional" && (this.rewriteActions(l.data.ifActions, [
                ...r,
                l.id,
                "ifActions"
            ], i, s, o, a), this.rewriteActions(l.data.elseActions, [
                ...r,
                l.id,
                "elseActions"
            ], i, s, o, a));
        });
    }
    rewriteEventsBeforeGoToPlayMode() {
        this.traverseEntity((e)=>{
            if (e instanceof eo && typeof e.identity == "string" && e.data.type === "Component") return e.traverseEntity((r, i)=>{
                r.data.events.forEach((s)=>{
                    if (s.data.type === "GameControl") {
                        let o = !1;
                        if (r.forInstancesRec((a)=>{
                            a.data = vl(a.data, (l)=>{
                                a.isInstanceRoot || (l.events.delete(s.id), o = !0);
                            }).data;
                        }), o === !1) for (let a of Qh.list)this.rewriteActions(s.data.gameActions[a], [
                            "gameActions",
                            a
                        ], e, r, i, s);
                    } else s.data.type === "Conditional" ? (s.data.condition.type === "Distance" ? (this.relativeizeInner(s.data.condition.fromObject, [
                        "condition"
                    ], "fromObject", e, r, i, s), this.relativeizeInner(s.data.condition.toObject, [
                        "condition"
                    ], "toObject", e, r, i, s)) : s.data.condition.type === "State" ? this.relativeizeInner(s.data.condition.object, [
                        "condition"
                    ], "object", e, r, i, s) : s.data.condition.type === "Comparison" && (s.data.condition.lOperand.type === "Property" && this.relativeizeInner(s.data.condition.lOperand.value[0], [
                        "condition",
                        "lOperand",
                        "value"
                    ], 0, e, r, i, s), s.data.condition.rOperand.type === "Property" && this.relativeizeInner(s.data.condition.rOperand.value[0], [
                        "condition",
                        "rOperand",
                        "value"
                    ], 0, e, r, i, s)), this.rewriteActions(s.data.inActions, [
                        "inActions"
                    ], e, r, i, s), this.rewriteActions(s.data.outActions, [
                        "outActions"
                    ], e, r, i, s)) : "actions" in s.data && this.rewriteActions(s.data.actions, [
                        "actions"
                    ], e, r, i, s);
                });
            }), !0;
        });
    }
    expandInstances(e, r, i) {
        let s = new Set;
        this.traverseEntity((o)=>{
            if (o instanceof eo && o.isInstanceRoot) return o.expandInstanceChildren({
                scene: this,
                shared: e,
                pendingDeletes: s
            }), r || o.resetBBoxNeedsUpdate(), i && o.traverseEntity((a)=>{
                i.addClip(a);
            }), !0;
        });
        for (let o of s)this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(o), Zx(o);
    }
    recomputeInstances(e, r) {
        this.needsRecomputeInstances && (this.needsRecomputeInstances = !1, this.traverseEntity((i)=>{
            i instanceof eo && i.isInstanceRoot && (i.component = void 0);
        }), this.expandInstances(e, !1, r));
    }
    disposeAndUnregisterEntityRecursivelyIfNotReregistered(e) {
        e.traverseEntity((r)=>{
            let i = typeof r.identity == "string" ? r.identity : r.identity.join("-");
            this.entityIdentityToEntity[i] === r && (delete this.entityByUuid[r.uuid], delete this.entityIdentityToEntity[i]), r.dispose();
        });
    }
    clearScene() {
        for (let e of this.children)yt.is(e) && e.disposeRecursively();
        this.children.length = 0;
    }
    resetAfterClear(e, r) {
        this.init(e, r);
    }
    raycast(e) {
        return this.raycast1(e, !1);
    }
    raycast1(e, r) {
        let i = [], s = (o)=>{
            for (let a of o.children){
                let l = a.cloner;
                if (yt.is(a) && !a.raycastLock && (a.visible || l?.object.data.visible)) {
                    if (r === !0 && a.isInstanceRoot) {
                        let c = [];
                        if (e.intersectObject(a, !0, c), c.length) {
                            let u = c[0];
                            u.object = a, u.point.applyMatrix4(u.object.matrixWorld);
                            let h = a.matrixWorld.clone().invert();
                            u.point.applyMatrix4(h), i.push(u);
                        }
                    } else (cn(a) || Nm(a) && this.enableHelpers && a.objectHelper.visible) && (e.intersectObject(a, !1, i), Wm(a, e, i)), s(a);
                }
            }
        };
        return s(this.activePage), i;
    }
    raycastWithClones(e) {
        let r = [], i = (s)=>{
            for (let o of s.children){
                let a = o.cloner;
                yt.is(o) && (o.visible || a?.object.data.visible) && ((cn(o) || Nm(o) && this.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, r), Wm(o, e, r, !0)), i(o));
            }
        };
        return i(this), r;
    }
    forEachEntity(e) {
        for (let r of this.children)yt.is(r) && e(r);
    }
    traverseConcreteEntity(e) {
        for (let r of this.children)yt.is(r) && r.isConcreteEntity && r.traverseEntity(e);
    }
    traverseEntity(e) {
        for (let r of this.children)yt.is(r) && r.traverseEntity(e);
    }
    updateFont(e, r) {
        this.traverseEntity((i)=>{
            if (i instanceof cr && i.data.type === "Mesh" && (i.data.geometry.type === "TextGeometry" || i.data.geometry.type === "InputGeometry") && i.data.geometry.font === e) {
                let s = i.geometry, o = i.data.geometry;
                s.updateFont(e, r).then(()=>{
                    s.update(o);
                    let a = i.invalidateDownstreamBooleanData();
                    En(a) && a.recomputeBoolean();
                });
            }
        });
    }
    traverseObject(e) {
        for (let r of this.children)pd.is(r) && r.traverseObject(e);
    }
    traverseVisibleEntity(e) {
        for (let r of this.children)yt.is(r) && r.visible && r.traverseVisibleEntity(e);
    }
    dispose() {
        this.clearScene();
    }
    createChildrenObjects(e, r, i) {
        let s = 0;
        for (let o of e)this.createObject(o.id, o.data, o.children, r, s, i), s += 1;
    }
    registerObjectCreatedInLegacy(e) {
        this.entityByUuid[e.uuid] = e;
    }
    unregisterObject(e) {
        delete this.entityByUuid[e.uuid];
        for (let r of e.children)this.unregisterObject(r);
    }
    createObject(e, r, i, s, o, a) {
        let l = {
            scene: this,
            shared: a
        }, c = nb(e, r, l);
        return c && (this.entityByUuid[e] = c, s.add(c), s.children.splice(o, 0, s.children.pop()), i.length > 0 && (c.isInstanceRoot ? console.error("instance should not have children!") : this.createChildrenObjects(i, c, a)), c.updateState(r, l), c instanceof cr && c.updateGeometryGroupsIfNeeded(), c.updateVisible(this), c.cloner && this.toExpandCloner.add(c), r.pathSnapping?.pathId && this.pathConstraints.setConstraint(e, r.pathSnapping.pathId)), r.type === "Empty" && r.animations && c.traverseEntity((u)=>{
            let h = u.dataPatched;
            if (u instanceof cr && h.bones && h.boneInverses) {
                let d = h.bones.map((m)=>this.find(m)), f = h.boneInverses.map((m)=>new ue().fromArray(m)), p = new il(d, f);
                u.bind(p, u.bindMatrix);
            } else u.matrixAutoUpdate = !0;
        }), c;
    }
    getCenter(e) {
        let r = [];
        for(let s = 0, o = e.length; s < o; ++s){
            let { id: a, recursive: l } = e[s], c = this.find(a), u = l ? c.recursiveBBox : c.singleBBox;
            r.push(...u.vertices);
        }
        let i = new Wt;
        return i.setFromPoints(r), i.getCenter(vB), vB;
    }
    copyMatrixWorld(e, r) {
        if (e === null) {
            r.identity();
            return;
        }
        let i = this.find(e);
        i ? r.copy(i.matrixWorld) : r.identity();
    }
    copyParentMatrixWorld(e, r) {
        if (e === null) {
            r.identity();
            return;
        }
        let i = this.find(e)?.parent;
        i ? r.copy(i.matrixWorld) : r.identity();
    }
    traverseMaterial(e) {
        this.traverseEntity((r)=>{
            if (r instanceof mr) {
                if (Array.isArray(r.material)) for(let i = 0; i < r.material.length; i++)r.material[i] instanceof Nn && e(r.material[i]);
                else r.material instanceof Nn && e(r.material);
            }
        });
    }
    updateViewPlaneSize(e, r, i = !1) {
        this.traverseConcreteEntity((s)=>{
            s instanceof wr && s.setViewplaneSize(e, r, i);
        });
    }
    initializeSplatViewer() {
        this.splatViewer = new qm({
            scene: this
        }), this.reloadSplats();
    }
    reloadSplats() {
        this.splatViewer?.loadSplat();
    }
};
var Ym = (n1, t)=>{
    let e = t.x - n1.x, r = t.y - n1.y;
    return Math.sqrt(e * e + r * r);
}, xB = (n1, t)=>{
    let e = t.x - n1.x, r = t.y - n1.y;
    return IZ(Math.atan2(r, e));
}, bB = (n1, t, e)=>{
    let r = {
        x: 0,
        y: 0
    };
    return e = ub(e), r.x = n1.x - t * Math.cos(e), r.y = n1.y - t * Math.sin(e), r;
}, ub = (n1)=>n1 * (Math.PI / 180), IZ = (n1)=>n1 * (180 / Math.PI), SB = (n1)=>isNaN(n1.buttons) ? n1.pressure !== 0 : n1.buttons !== 0, yT = new Map, vT = (n1)=>{
    yT.has(n1) && clearTimeout(yT.get(n1)), yT.set(n1, setTimeout(n1, 100));
}, Df = (n1, t, e)=>{
    let r = t.split(/[ ,]+/g), i;
    for(let s = 0; s < r.length; s += 1)i = r[s], n1.addEventListener ? n1.addEventListener(i, e, !1) : n1.attachEvent && n1.attachEvent(i, e);
}, xT = (n1, t, e)=>{
    let r = t.split(/[ ,]+/g), i;
    for(let s = 0; s < r.length; s += 1)i = r[s], n1.removeEventListener ? n1.removeEventListener(i, e) : n1.detachEvent && n1.detachEvent(i, e);
};
var hb = (n1)=>(n1.preventDefault(), n1.type.match(/^touch/) ? n1.changedTouches : n1), bT = ()=>{
    if (typeof window > "u") return;
    let n1 = window.pageXOffset !== void 0 ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft, t = window.pageYOffset !== void 0 ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    return {
        x: n1,
        y: t
    };
}, db = (n1, t)=>{
    t.top || t.right || t.bottom || t.left ? (n1.style.top = t.top, n1.style.right = t.right, n1.style.bottom = t.bottom, n1.style.left = t.left) : (n1.style.left = t.x + "px", n1.style.top = t.y + "px");
}, fb = (n1, t, e)=>{
    let r = AB(n1);
    for(let i in r)if (r.hasOwnProperty(i)) {
        if (typeof t == "string") r[i] = t + " " + e;
        else {
            let s = "";
            for(let o = 0, a = t.length; o < a; o += 1)s += t[o] + " " + e + ", ";
            r[i] = s.slice(0, -2);
        }
    }
    return r;
}, wB = (n1, t)=>{
    let e = AB(n1);
    for(let r in e)e.hasOwnProperty(r) && (e[r] = t);
    return e;
}, AB = (n1)=>{
    let t = {};
    return t[n1] = "", [
        "webkit",
        "Moz",
        "o"
    ].forEach(function(r) {
        t[r + n1.charAt(0).toUpperCase() + n1.slice(1)] = "";
    }), t;
}, pb = (n1, t)=>{
    for(let e in t)t.hasOwnProperty(e) && (n1[e] = t[e]);
    return n1;
}, EB = (n1, t)=>{
    let e = {};
    for(let r in n1)n1.hasOwnProperty(r) && t.hasOwnProperty(r) ? e[r] = t[r] : n1.hasOwnProperty(r) && (e[r] = n1[r]);
    return e;
}, Xm = (n1, t)=>{
    if (n1.length) for(let e = 0, r = n1.length; e < r; e += 1)t(n1[e]);
    else t(n1);
}, TB = (n1, t, e)=>({
        x: Math.min(Math.max(n1.x, t.x - e), t.x + e),
        y: Math.min(Math.max(n1.y, t.y - e), t.y + e)
    });
typeof window < "u" && (MB = "ontouchstart" in window, CB = !!window.PointerEvent, PB = !!window.MSPointerEvent);
var MB, CB, PB, Km = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend, touchcancel"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup"
    },
    pointer: {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup, pointercancel"
    },
    MSPointer: {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    }
}, Of, Qm = {};
CB ? Of = Km.pointer : PB ? Of = Km.MSPointer : MB ? (Of = Km.touch, Qm = Km.mouse) : Of = Km.mouse;
function nu() {}
nu.prototype.on = function(n1, t) {
    var e = this, r = n1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s = 0; s < r.length; s += 1)i = r[s], e._handlers_[i] = e._handlers_[i] || [], e._handlers_[i].push(t);
    return e;
};
nu.prototype.off = function(n1, t) {
    var e = this;
    return e._handlers_ = e._handlers_ || {}, n1 === void 0 ? e._handlers_ = {} : t === void 0 ? e._handlers_[n1] = null : e._handlers_[n1] && e._handlers_[n1].indexOf(t) >= 0 && e._handlers_[n1].splice(e._handlers_[n1].indexOf(t), 1), e;
};
nu.prototype.trigger = function(n1, t) {
    var e = this, r = n1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s = 0; s < r.length; s += 1)i = r[s], e._handlers_[i] && e._handlers_[i].length && e._handlers_[i].forEach(function(o) {
        o.call(e, {
            type: i,
            target: e
        }, t);
    });
};
nu.prototype.config = function(n1) {
    var t = this;
    t.options = t.defaults || {}, n1 && (t.options = EB(t.options, n1));
};
nu.prototype.bindEvt = function(n1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, e._domHandlers_[t] = function() {
        typeof e["on" + t] == "function" ? e["on" + t].apply(e, arguments) : console.warn('[WARNING] : Missing "on' + t + '" handler.');
    }, Df(n1, Of[t], e._domHandlers_[t]), Qm[t] && Df(n1, Qm[t], e._domHandlers_[t]), e;
};
nu.prototype.unbindEvt = function(n1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, xT(n1, Of[t], e._domHandlers_[t]), Qm[t] && xT(n1, Qm[t], e._domHandlers_[t]), delete e._domHandlers_[t], this;
};
var Rf = nu;
function Ii(n1, t) {
    return this.identifier = t.identifier, this.position = t.position, this.frontPosition = t.frontPosition, this.collection = n1, this.defaults = {
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        mode: "dynamic",
        zone: document.body,
        lockX: !1,
        lockY: !1,
        shape: "circle"
    }, this.config(t), this.options.mode === "dynamic" && (this.options.restOpacity = 0), this.id = Ii.id, Ii.id += 1, this.buildEl().stylize(), this.instance = {
        el: this.ui.el,
        on: this.on.bind(this),
        off: this.off.bind(this),
        show: this.show.bind(this),
        hide: this.hide.bind(this),
        add: this.addToDom.bind(this),
        remove: this.removeFromDom.bind(this),
        destroy: this.destroy.bind(this),
        setPosition: this.setPosition.bind(this),
        resetDirection: this.resetDirection.bind(this),
        computeDirection: this.computeDirection.bind(this),
        trigger: this.trigger.bind(this),
        position: this.position,
        frontPosition: this.frontPosition,
        ui: this.ui,
        identifier: this.identifier,
        id: this.id,
        options: this.options
    }, this.instance;
}
Ii.prototype = new Rf;
Ii.constructor = Ii;
Ii.id = 0;
Ii.prototype.buildEl = function(n1) {
    return this.ui = {}, this.options.dataOnly ? this : (this.ui.el = document.createElement("div"), this.ui.back = document.createElement("div"), this.ui.front = document.createElement("div"), this.ui.el.className = "nipple collection_" + this.collection.id, this.ui.back.className = "back", this.ui.front.className = "front", this.ui.el.setAttribute("id", "nipple_" + this.collection.id + "_" + this.id), this.ui.el.appendChild(this.ui.back), this.ui.el.appendChild(this.ui.front), this);
};
Ii.prototype.stylize = function() {
    if (this.options.dataOnly) return this;
    var n1 = this.options.fadeTime + "ms", t = wB("borderRadius", "50%"), e = fb("transition", "opacity", n1), r = {};
    return r.el = {
        position: "absolute",
        opacity: this.options.restOpacity,
        display: "block",
        zIndex: 999
    }, r.back = {
        position: "absolute",
        display: "block",
        width: this.options.size + "px",
        height: this.options.size + "px",
        marginLeft: -this.options.size / 2 + "px",
        marginTop: -this.options.size / 2 + "px",
        background: "rgba(255, 255, 255, .4)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, r.front = {
        width: this.options.size / 2 + "px",
        height: this.options.size / 2 + "px",
        position: "absolute",
        display: "block",
        marginLeft: -this.options.size / 4 + "px",
        marginTop: -this.options.size / 4 + "px",
        background: "rgba(255, 255, 255, .8)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, pb(r.el, e), this.options.shape === "circle" && pb(r.back, t), pb(r.front, t), this.applyStyles(r), this;
};
Ii.prototype.applyStyles = function(n1) {
    for(var t in this.ui)if (this.ui.hasOwnProperty(t)) for(var e in n1[t])this.ui[t].style[e] = n1[t][e];
    return this;
};
Ii.prototype.addToDom = function() {
    return this.options.dataOnly || document.body.contains(this.ui.el) ? this : (this.options.zone.appendChild(this.ui.el), this);
};
Ii.prototype.removeFromDom = function() {
    return this.options.dataOnly || !document.body.contains(this.ui.el) ? this : (this.options.zone.removeChild(this.ui.el), this);
};
Ii.prototype.destroy = function() {
    clearTimeout(this.removeTimeout), clearTimeout(this.showTimeout), clearTimeout(this.restTimeout), this.trigger("destroyed", this.instance), this.removeFromDom(), this.off();
};
Ii.prototype.show = function(n1) {
    var t = this;
    return t.options.dataOnly || (clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.addToDom(), t.restCallback(), setTimeout(function() {
        t.ui.el.style.opacity = 1;
    }, 0), t.showTimeout = setTimeout(function() {
        t.trigger("shown", t.instance), typeof n1 == "function" && n1.call(this);
    }, t.options.fadeTime)), t;
};
Ii.prototype.hide = function(n1) {
    var t = this;
    if (t.options.dataOnly) return t;
    if (t.ui.el.style.opacity = t.options.restOpacity, clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.removeTimeout = setTimeout(function() {
        var e = t.options.mode === "dynamic" ? "none" : "block";
        t.ui.el.style.display = e, typeof n1 == "function" && n1.call(t), t.trigger("hidden", t.instance);
    }, t.options.fadeTime), t.options.restJoystick) {
        let e = t.options.restJoystick, r = {};
        r.x = e === !0 || e.x !== !1 ? 0 : t.instance.frontPosition.x, r.y = e === !0 || e.y !== !1 ? 0 : t.instance.frontPosition.y, t.setPosition(n1, r);
    }
    return t;
};
Ii.prototype.setPosition = function(n1, t) {
    var e = this;
    e.frontPosition = {
        x: t.x,
        y: t.y
    };
    var r = e.options.fadeTime + "ms", i = {};
    i.front = fb("transition", [
        "top",
        "left"
    ], r);
    var s = {
        front: {}
    };
    s.front = {
        left: e.frontPosition.x + "px",
        top: e.frontPosition.y + "px"
    }, e.applyStyles(i), e.applyStyles(s), e.restTimeout = setTimeout(function() {
        typeof n1 == "function" && n1.call(e), e.restCallback();
    }, e.options.fadeTime);
};
Ii.prototype.restCallback = function() {
    var n1 = this, t = {};
    t.front = fb("transition", "none", ""), n1.applyStyles(t), n1.trigger("rested", n1.instance);
};
Ii.prototype.resetDirection = function() {
    this.direction = {
        x: !1,
        y: !1,
        angle: !1
    };
};
Ii.prototype.computeDirection = function(n1) {
    var t = n1.angle.radian, e = Math.PI / 4, r = Math.PI / 2, i, s, o;
    if (t > e && t < e * 3 && !n1.lockX ? i = "up" : t > -e && t <= e && !n1.lockY ? i = "left" : t > -e * 3 && t <= -e && !n1.lockX ? i = "down" : n1.lockY || (i = "right"), n1.lockY || (t > -r && t < r ? s = "left" : s = "right"), n1.lockX || (t > 0 ? o = "up" : o = "down"), n1.force > this.options.threshold) {
        var a = {}, l;
        for(l in this.direction)this.direction.hasOwnProperty(l) && (a[l] = this.direction[l]);
        var c = {};
        this.direction = {
            x: s,
            y: o,
            angle: i
        }, n1.direction = this.direction;
        for(l in a)a[l] === this.direction[l] && (c[l] = !0);
        if (c.x && c.y && c.angle) return n1;
        (!c.x || !c.y) && this.trigger("plain", n1), c.x || this.trigger("plain:" + s, n1), c.y || this.trigger("plain:" + o, n1), c.angle || this.trigger("dir dir:" + i, n1);
    } else this.resetDirection();
    return n1;
};
var _B = Ii;
function oi(n1, t) {
    var e = this;
    e.nipples = [], e.idles = [], e.actives = [], e.ids = [], e.pressureIntervals = {}, e.manager = n1, e.id = oi.id, oi.id += 1, e.defaults = {
        zone: document.body,
        multitouch: !1,
        maxNumberOfNipples: 10,
        mode: "dynamic",
        position: {
            top: 0,
            left: 0
        },
        catchDistance: 200,
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        lockX: !1,
        lockY: !1,
        shape: "circle",
        dynamicPage: !1,
        follow: !1
    }, e.config(t), (e.options.mode === "static" || e.options.mode === "semi") && (e.options.multitouch = !1), e.options.multitouch || (e.options.maxNumberOfNipples = 1);
    let r = getComputedStyle(e.options.zone.parentElement);
    return r && r.display === "flex" && (e.parentIsFlex = !0), e.updateBox(), e.prepareNipples(), e.bindings(), e.begin(), e.nipples;
}
oi.prototype = new Rf;
oi.constructor = oi;
oi.id = 0;
oi.prototype.prepareNipples = function() {
    var n1 = this, t = n1.nipples;
    t.on = n1.on.bind(n1), t.off = n1.off.bind(n1), t.options = n1.options, t.destroy = n1.destroy.bind(n1), t.ids = n1.ids, t.id = n1.id, t.processOnMove = n1.processOnMove.bind(n1), t.processOnEnd = n1.processOnEnd.bind(n1), t.get = function(e) {
        if (e === void 0) return t[0];
        for(var r = 0, i = t.length; r < i; r += 1)if (t[r].identifier === e) return t[r];
        return !1;
    };
};
oi.prototype.bindings = function() {
    var n1 = this;
    n1.bindEvt(n1.options.zone, "start"), n1.options.zone.style.touchAction = "none", n1.options.zone.style.msTouchAction = "none";
};
oi.prototype.begin = function() {
    var n1 = this, t = n1.options;
    if (t.mode === "static") {
        var e = n1.createNipple(t.position, n1.manager.getIdentifier());
        e.add(), n1.idles.push(e);
    }
};
oi.prototype.createNipple = function(n1, t) {
    var e = this, r = e.manager.scroll, i = {}, s = e.options, o = {
        x: e.parentIsFlex ? r.x : r.x + e.box.left,
        y: e.parentIsFlex ? r.y : r.y + e.box.top
    };
    if (n1.x && n1.y) i = {
        x: n1.x - o.x,
        y: n1.y - o.y
    };
    else if (n1.top || n1.right || n1.bottom || n1.left) {
        var a = document.createElement("DIV");
        a.style.display = "hidden", a.style.top = n1.top, a.style.right = n1.right, a.style.bottom = n1.bottom, a.style.left = n1.left, a.style.position = "absolute", s.zone.appendChild(a);
        var l = a.getBoundingClientRect();
        s.zone.removeChild(a), i = n1, n1 = {
            x: l.left + r.x,
            y: l.top + r.y
        };
    }
    var c = new _B(e, {
        color: s.color,
        size: s.size,
        threshold: s.threshold,
        fadeTime: s.fadeTime,
        dataOnly: s.dataOnly,
        restJoystick: s.restJoystick,
        restOpacity: s.restOpacity,
        mode: s.mode,
        identifier: t,
        position: n1,
        zone: s.zone,
        frontPosition: {
            x: 0,
            y: 0
        },
        shape: s.shape
    });
    return s.dataOnly || (db(c.ui.el, i), db(c.ui.front, c.frontPosition)), e.nipples.push(c), e.trigger("added " + c.identifier + ":added", c), e.manager.trigger("added " + c.identifier + ":added", c), e.bindNipple(c), c;
};
oi.prototype.updateBox = function() {
    var n1 = this;
    n1.box = n1.options.zone.getBoundingClientRect();
};
oi.prototype.bindNipple = function(n1) {
    var t = this, e, r = function(i, s) {
        e = i.type + " " + s.id + ":" + i.type, t.trigger(e, s);
    };
    n1.on("destroyed", t.onDestroyed.bind(t)), n1.on("shown hidden rested dir plain", r), n1.on("dir:up dir:right dir:down dir:left", r), n1.on("plain:up plain:right plain:down plain:left", r);
};
oi.prototype.pressureFn = function(n1, t, e) {
    var r = this, i = 0;
    clearInterval(r.pressureIntervals[e]), r.pressureIntervals[e] = setInterval((function() {
        var s = n1.force || n1.pressure || n1.webkitForce || 0;
        s !== i && (t.trigger("pressure", s), r.trigger("pressure " + t.identifier + ":pressure", s), i = s);
    }).bind(r), 100);
};
oi.prototype.onstart = function(n1) {
    var t = this, e = t.options, r = n1;
    n1 = hb(n1), t.updateBox();
    var i = function(s) {
        t.actives.length < e.maxNumberOfNipples ? t.processOnStart(s) : r.type.match(/^touch/) && (Object.keys(t.manager.ids).forEach(function(o) {
            if (Object.values(r.touches).findIndex(function(l) {
                return l.identifier === o;
            }) < 0) {
                var a = [
                    n1[0]
                ];
                a.identifier = o, t.processOnEnd(a);
            }
        }), t.actives.length < e.maxNumberOfNipples && t.processOnStart(s));
    };
    return Xm(n1, i), t.manager.bindDocument(), !1;
};
oi.prototype.processOnStart = function(n1) {
    var t = this, e = t.options, r, i = t.manager.getIdentifier(n1), s = n1.force || n1.pressure || n1.webkitForce || 0, o = {
        x: n1.pageX,
        y: n1.pageY
    }, a = t.getOrCreate(i, o);
    a.identifier !== i && t.manager.removeIdentifier(a.identifier), a.identifier = i;
    var l = function(u) {
        u.trigger("start", u), t.trigger("start " + u.id + ":start", u), u.show(), s > 0 && t.pressureFn(n1, u, u.identifier), t.processOnMove(n1);
    };
    if ((r = t.idles.indexOf(a)) >= 0 && t.idles.splice(r, 1), t.actives.push(a), t.ids.push(a.identifier), e.mode !== "semi") l(a);
    else {
        var c = Ym(o, a.position);
        if (c <= e.catchDistance) l(a);
        else {
            a.destroy(), t.processOnStart(n1);
            return;
        }
    }
    return a;
};
oi.prototype.getOrCreate = function(n1, t) {
    var e = this, r = e.options, i;
    return /(semi|static)/.test(r.mode) ? (i = e.idles[0], i ? (e.idles.splice(0, 1), i) : r.mode === "semi" ? e.createNipple(t, n1) : (console.warn("Coudln't find the needed nipple."), !1)) : (i = e.createNipple(t, n1), i);
};
oi.prototype.processOnMove = function(n1) {
    var t = this, e = t.options, r = t.manager.getIdentifier(n1), i = t.nipples.get(r), s = t.manager.scroll;
    if (!SB(n1)) {
        this.processOnEnd(n1);
        return;
    }
    if (!i) {
        console.error("Found zombie joystick with ID " + r), t.manager.removeIdentifier(r);
        return;
    }
    if (e.dynamicPage) {
        var o = i.el.getBoundingClientRect();
        i.position = {
            x: s.x + o.left,
            y: s.y + o.top
        };
    }
    i.identifier = r;
    var a = i.options.size / 2, l = {
        x: n1.pageX,
        y: n1.pageY
    };
    e.lockX && (l.y = i.position.y), e.lockY && (l.x = i.position.x);
    var c = Ym(l, i.position), u = xB(l, i.position), h = ub(u), d = c / a, f = {
        distance: c,
        position: l
    }, p, m;
    if (i.options.shape === "circle" ? (p = Math.min(c, a), m = bB(i.position, p, u)) : (m = TB(l, i.position, a), p = Ym(m, i.position)), e.follow) {
        if (c > a) {
            let v = l.x - m.x, S = l.y - m.y;
            i.position.x += v, i.position.y += S, i.el.style.top = i.position.y - (t.box.top + s.y) + "px", i.el.style.left = i.position.x - (t.box.left + s.x) + "px", c = Ym(l, i.position);
        }
    } else l = m, c = p;
    var g = l.x - i.position.x, y = l.y - i.position.y;
    i.frontPosition = {
        x: g,
        y: y
    }, e.dataOnly || db(i.ui.front, i.frontPosition);
    var x = {
        identifier: i.identifier,
        position: l,
        force: d,
        pressure: n1.force || n1.pressure || n1.webkitForce || 0,
        distance: c,
        angle: {
            radian: h,
            degree: u
        },
        vector: {
            x: g / a,
            y: -y / a
        },
        raw: f,
        instance: i,
        lockX: e.lockX,
        lockY: e.lockY
    };
    x = i.computeDirection(x), x.angle = {
        radian: ub(180 - u),
        degree: 180 - u
    }, i.trigger("move", x), t.trigger("move " + i.id + ":move", x);
};
oi.prototype.processOnEnd = function(n1) {
    var t = this, e = t.options, r = t.manager.getIdentifier(n1), i = t.nipples.get(r), s = t.manager.removeIdentifier(i.identifier);
    !i || (e.dataOnly || i.hide(function() {
        e.mode === "dynamic" && (i.trigger("removed", i), t.trigger("removed " + i.id + ":removed", i), t.manager.trigger("removed " + i.id + ":removed", i), i.destroy());
    }), clearInterval(t.pressureIntervals[i.identifier]), i.resetDirection(), i.trigger("end", i), t.trigger("end " + i.id + ":end", i), t.ids.indexOf(i.identifier) >= 0 && t.ids.splice(t.ids.indexOf(i.identifier), 1), t.actives.indexOf(i) >= 0 && t.actives.splice(t.actives.indexOf(i), 1), /(semi|static)/.test(e.mode) ? t.idles.push(i) : t.nipples.indexOf(i) >= 0 && t.nipples.splice(t.nipples.indexOf(i), 1), t.manager.unbindDocument(), /(semi|static)/.test(e.mode) && (t.manager.ids[s.id] = s.identifier));
};
oi.prototype.onDestroyed = function(n1, t) {
    var e = this;
    e.nipples.indexOf(t) >= 0 && e.nipples.splice(e.nipples.indexOf(t), 1), e.actives.indexOf(t) >= 0 && e.actives.splice(e.actives.indexOf(t), 1), e.idles.indexOf(t) >= 0 && e.idles.splice(e.idles.indexOf(t), 1), e.ids.indexOf(t.identifier) >= 0 && e.ids.splice(e.ids.indexOf(t.identifier), 1), e.manager.removeIdentifier(t.identifier), e.manager.unbindDocument();
};
oi.prototype.destroy = function() {
    var n1 = this;
    n1.unbindEvt(n1.options.zone, "start"), n1.nipples.forEach(function(e) {
        e.destroy();
    });
    for(var t in n1.pressureIntervals)n1.pressureIntervals.hasOwnProperty(t) && clearInterval(n1.pressureIntervals[t]);
    n1.trigger("destroyed", n1.nipples), n1.manager.unbindDocument(), n1.off();
};
var IB = oi;
function ji(n1) {
    var t = this;
    t.ids = {}, t.index = 0, t.collections = [], t.scroll = bT(), t.config(n1), t.prepareCollections();
    var e = function() {
        var i;
        t.collections.forEach(function(s) {
            s.forEach(function(o) {
                i = o.el.getBoundingClientRect(), o.position = {
                    x: t.scroll.x + i.left,
                    y: t.scroll.y + i.top
                };
            });
        });
    };
    if (typeof window > "u") return t.collections;
    Df(window, "resize", function() {
        vT(e);
    });
    var r = function() {
        t.scroll = bT();
    };
    return Df(window, "scroll", function() {
        vT(r);
    }), t.collections;
}
ji.prototype = new Rf;
ji.constructor = ji;
ji.prototype.prepareCollections = function() {
    var n1 = this;
    n1.collections.create = n1.create.bind(n1), n1.collections.on = n1.on.bind(n1), n1.collections.off = n1.off.bind(n1), n1.collections.destroy = n1.destroy.bind(n1), n1.collections.get = function(t) {
        var e;
        return n1.collections.every(function(r) {
            return e = r.get(t), !e;
        }), e;
    };
};
ji.prototype.create = function(n1) {
    return this.createCollection(n1);
};
ji.prototype.createCollection = function(n1) {
    var t = this, e = new IB(t, n1);
    return t.bindCollection(e), t.collections.push(e), e;
};
ji.prototype.bindCollection = function(n1) {
    var t = this, e, r = function(i, s) {
        e = i.type + " " + s.id + ":" + i.type, t.trigger(e, s);
    };
    n1.on("destroyed", t.onDestroyed.bind(t)), n1.on("shown hidden rested dir plain", r), n1.on("dir:up dir:right dir:down dir:left", r), n1.on("plain:up plain:right plain:down plain:left", r);
};
ji.prototype.bindDocument = function() {
    var n1 = this;
    n1.binded || (n1.bindEvt(document, "move").bindEvt(document, "end"), n1.binded = !0);
};
ji.prototype.unbindDocument = function(n1) {
    var t = this;
    (!Object.keys(t.ids).length || n1 === !0) && (t.unbindEvt(document, "move").unbindEvt(document, "end"), t.binded = !1);
};
ji.prototype.getIdentifier = function(n1) {
    var t;
    return n1 ? (t = n1.identifier === void 0 ? n1.pointerId : n1.identifier, t === void 0 && (t = this.latest || 0)) : t = this.index, this.ids[t] === void 0 && (this.ids[t] = this.index, this.index += 1), this.latest = t, this.ids[t];
};
ji.prototype.removeIdentifier = function(n1) {
    var t = {};
    for(var e in this.ids)if (this.ids[e] === n1) {
        t.id = e, t.identifier = this.ids[e], delete this.ids[e];
        break;
    }
    return t;
};
ji.prototype.onmove = function(n1) {
    var t = this;
    return t.onAny("move", n1), !1;
};
ji.prototype.onend = function(n1) {
    var t = this;
    return t.onAny("end", n1), !1;
};
ji.prototype.oncancel = function(n1) {
    var t = this;
    return t.onAny("end", n1), !1;
};
ji.prototype.onAny = function(n1, t) {
    var e = this, r, i = "processOn" + n1.charAt(0).toUpperCase() + n1.slice(1);
    t = hb(t);
    var s = function(a, l, c) {
        c.ids.indexOf(l) >= 0 && (c[i](a), a._found_ = !0);
    }, o = function(a) {
        r = e.getIdentifier(a), Xm(e.collections, s.bind(null, a, r)), a._found_ || e.removeIdentifier(r);
    };
    return Xm(t, o), !1;
};
ji.prototype.destroy = function() {
    var n1 = this;
    n1.unbindDocument(!0), n1.ids = {}, n1.index = 0, n1.collections.forEach(function(t) {
        t.destroy();
    }), n1.off();
};
ji.prototype.onDestroyed = function(n1, t) {
    var e = this;
    if (e.collections.indexOf(t) < 0) return !1;
    e.collections.splice(e.collections.indexOf(t), 1);
};
var DB = ji;
var OB = new DB, RB = {
    create: function(n1) {
        return OB.create(n1);
    },
    factory: OB
};
var LB = new Map, Zm = new Map, Wo = class {
    constructor(t, e, r, i){
        this.data = e;
        let { audio: s, volume: o, delay: a, loop: l } = e;
        if (!s) throw new Error("Missing property");
        let c = typeof s == "string" ? i.getAudio(s).src : s.data;
        this.audioPlayer = new La({
            src: c,
            volume: o,
            delay: a,
            loop: l
        }), Zm.has(r.uuid) ? Zm.get(r.uuid).push(this) : Zm.set(r.uuid, [
            this
        ]), LB.set(t, this);
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.audioPlayer.status === "playing" ? this.audioPlayer.stop() : (this.audioPlayer.stop(), this.audioPlayer.play()) : this.data.toggle === "pause" ? this.audioPlayer.status === "playing" ? this.audioPlayer.pause() : this.audioPlayer.play() : (this.audioPlayer.stop(), this.audioPlayer.play());
    }
    dispose() {
        this.audioPlayer.stop();
    }
}, Lf = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playAudio ? this.pauseAudio(this.data.playAudio) : this.data.object ? this.pauseAllAudiosFromObject(this.data.object) : this.pauseAllAudios();
    }
    pauseAudio(t) {
        let e = LB.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.audioPlayer[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e.audioPlayer[this.data.interaction]());
    }
    pauseAllAudiosFromObject(t) {
        let e = Zm.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((r)=>r.audioPlayer[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((r)=>r.audioPlayer[this.data.interaction]()));
    }
    pauseAllAudios() {
        let t = [
            ...Zm.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((r)=>{
                    r.audioPlayer[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((r)=>{
                r.audioPlayer[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, Jm = class {
    constructor(t, e, r, i, s){
        this.data = e;
        this.shared = i;
        this.condition = s;
        if (e.interaction === "play") this.interaction = new Wo(t, e, r, i);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new Lf(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Wo ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Wo ? this.interaction.audioPlayer.play() : this.interaction.dispatch();
    }
    dispatchGameControl(t) {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Wo && (t === "start" ? this.interaction.audioPlayer.play() : this.interaction.audioPlayer.stop());
    }
    dispose() {
        this.interaction.dispose();
    }
};
var $m = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.delay = 0;
        this.emission = t.emission, t.delay !== void 0 && (this.delay = t.delay), this.particleSystem = this.page.scene.find(this.data.emitterObjectId);
    }
    toggleEmitting() {
        this.particleSystem.started && !this.particleSystem.stopped ? this.stop(this.delay) : this.start(this.delay);
    }
    toggleFroze() {
        this.particleSystem.started && !this.particleSystem.isFrozen ? this.freeze(this.delay) : this.unFreeze(this.delay);
    }
    start(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.start(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.start();
    }
    stop(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.stop(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.stop();
    }
    freeze(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.freeze(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.froze();
    }
    unFreeze(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.unFreeze(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.unFroze();
    }
    reset(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.reset(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.reset();
    }
    reverseFromCurrent() {
        switch(this.emission){
            case "emitToggle":
                this.toggleEmitting();
                break;
            case "pauseToggle":
                this.toggleFroze();
                break;
        }
    }
    dispatchBasic() {
        if (wt(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        switch(this.emission){
            case "start":
                this.start(this.delay);
                break;
            case "emitToggle":
                this.toggleEmitting();
                break;
            case "pause":
                this.freeze(this.delay);
                break;
            case "pauseToggle":
                this.toggleFroze();
                break;
            case "stop":
                this.stop(this.delay);
                break;
            case "reset":
                this.reset(this.delay);
                break;
            default:
                break;
        }
    }
    dispatchConditional() {
        if (wt(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        switch(this.emission){
            case "start":
                this.start(this.delay);
                break;
            case "stop":
                this.stop(this.delay);
                break;
            case "reset":
                this.reset(this.delay);
                break;
            default:
                break;
        }
    }
    dispatchGameControl(t) {
        if (wt(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        t === "start" ? this.start(this.delay) : this.stop(this.delay);
    }
    dispose() {
        !this.particleSystem || (this.particleSystem.reset(), this.clearDelay());
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
};
var DZ = "text/plain", OZ = "us-ascii", BB = (n1, t)=>t.some((e)=>e instanceof RegExp ? e.test(n1) : e === n1), RZ = (n1, { stripHash: t })=>{
    let e = /^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$/.exec(n1);
    if (!e) throw new Error(`Invalid URL: ${n1}`);
    let { type: r, data: i, hash: s } = e.groups, o = r.split(";");
    s = t ? "" : s;
    let a = !1;
    o[o.length - 1] === "base64" && (o.pop(), a = !0);
    let l = (o.shift() || "").toLowerCase(), u = [
        ...o.map((h)=>{
            let [d, f = ""] = h.split("=").map((p)=>p.trim());
            return d === "charset" && (f = f.toLowerCase(), f === OZ) ? "" : `${d}${f ? `=${f}` : ""}`;
        }).filter(Boolean)
    ];
    return a && u.push("base64"), (u.length > 0 || l && l !== DZ) && u.unshift(l), `data:${u.join(";")},${a ? i.trim() : i}${s ? `#${s}` : ""}`;
};
function ST(n1, t) {
    if (t = {
        defaultProtocol: "http:",
        normalizeProtocol: !0,
        forceHttp: !1,
        forceHttps: !1,
        stripAuthentication: !0,
        stripHash: !1,
        stripTextFragment: !0,
        stripWWW: !0,
        removeQueryParameters: [
            /^utm_\w+/i
        ],
        removeTrailingSlash: !0,
        removeSingleSlash: !0,
        removeDirectoryIndex: !1,
        sortQueryParameters: !0,
        ...t
    }, n1 = n1.trim(), /^data:/i.test(n1)) return RZ(n1, t);
    if (/^view-source:/i.test(n1)) throw new Error("`view-source:` is not supported as it is a non-standard protocol");
    let e = n1.startsWith("//");
    !e && /^\.*\//.test(n1) || (n1 = n1.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, t.defaultProtocol));
    let i = new URL(n1);
    if (t.forceHttp && t.forceHttps) throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
    if (t.forceHttp && i.protocol === "https:" && (i.protocol = "http:"), t.forceHttps && i.protocol === "http:" && (i.protocol = "https:"), t.stripAuthentication && (i.username = "", i.password = ""), t.stripHash ? i.hash = "" : t.stripTextFragment && (i.hash = i.hash.replace(/#?:~:text.*?$/i, "")), i.pathname) {
        let o = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g, a = 0, l = "";
        for(;;){
            let u = o.exec(i.pathname);
            if (!u) break;
            let h = u[0], d = u.index, f = i.pathname.slice(a, d);
            l += f.replace(/\/{2,}/g, "/"), l += h, a = d + h.length;
        }
        let c = i.pathname.slice(a, i.pathname.length);
        l += c.replace(/\/{2,}/g, "/"), i.pathname = l;
    }
    if (i.pathname) try {
        i.pathname = decodeURI(i.pathname);
    } catch  {}
    if (t.removeDirectoryIndex === !0 && (t.removeDirectoryIndex = [
        /^index\.[a-z]+$/
    ]), Array.isArray(t.removeDirectoryIndex) && t.removeDirectoryIndex.length > 0) {
        let o = i.pathname.split("/"), a = o[o.length - 1];
        BB(a, t.removeDirectoryIndex) && (o = o.slice(0, -1), i.pathname = o.slice(1).join("/") + "/");
    }
    if (i.hostname && (i.hostname = i.hostname.replace(/\.$/, ""), t.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(i.hostname) && (i.hostname = i.hostname.replace(/^www\./, ""))), Array.isArray(t.removeQueryParameters)) for (let o of [
        ...i.searchParams.keys()
    ])BB(o, t.removeQueryParameters) && i.searchParams.delete(o);
    if (t.removeQueryParameters === !0 && (i.search = ""), t.sortQueryParameters) {
        i.searchParams.sort();
        try {
            i.search = decodeURIComponent(i.search);
        } catch  {}
    }
    t.removeTrailingSlash && (i.pathname = i.pathname.replace(/\/$/, ""));
    let s = n1;
    return n1 = i.toString(), !t.removeSingleSlash && i.pathname === "/" && !s.endsWith("/") && i.hash === "" && (n1 = n1.replace(/\/$/, "")), (t.removeTrailingSlash || i.pathname === "/") && i.hash === "" && t.removeSingleSlash && (n1 = n1.replace(/\/$/, "")), e && !t.normalizeProtocol && (n1 = n1.replace(/^http:\/\//, "//")), t.stripProtocol && (n1 = n1.replace(/^(?:https?:)?\/\//, "")), n1;
}
var gb = class {
    constructor({ url: t, context: e }, r, i, s){
        this.controlsManager = r;
        this.shared = i;
        this.condition = s;
        if (!t) throw new Error("Missing property");
        this.url = t.startsWith("mailto:") ? t : ST(t, {
            removeTrailingSlash: !1,
            removeSingleSlash: !1,
            stripWWW: !1
        }), this.context = e ?? "tab";
    }
    dispatch() {
        if (wt(this.shared, this.condition) === !1) return !1;
        xo ? window.location.assign(this.url) : (this.context === "tab" || cA && this.context === "none" ? window.open(this.url, "_blank") : this.context === "window" ? window.open(this.url, "_blank", `width=${window.innerWidth}, height=${window.innerHeight}`) : window.open(this.url, "_parent"), this.controlsManager.orbitControls?.onPointerUp(Je[0]), iI());
    }
};
var eg = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.controlsManager = r;
        this.shared = i;
        this.condition = s;
        this.timeoutIdQueue = [];
        this.dispatchInner = ()=>{
            this.objects.forEach(this.destroyCallback);
        };
        this.destroyCallback = (t)=>{
            this.timeoutIdQueue.shift();
            let e = this.page.scene.find(t);
            if (e === void 0) return;
            let r = this.controlsManager.sharedGameControlGlobals.rapierWorld, i = r ? e.dataPatched.physics?.fusedBody : !0;
            if (e.cloner) {
                for (let s of e.cloner.children)i ? (s.playModeVisible = !1, s.rigidBody && e.dataPatched.physics?.rigidBody === "positioned" && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(s.rigidBody.collider(0).handle), r.removeRigidBody(s.rigidBody), s.rigidBody = void 0), s.bvhGeometry && (s.bvhGeometry = void 0)) : this.clone === void 0 || this.clone === s ? (s.playModeVisible = !1, s.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(s.rigidBody.collider(0).handle), r.removeRigidBody(s.rigidBody), s.rigidBody = void 0)) : s.playModeVisible === void 0 && (s.playModeVisible = !0);
                (i || this.clone === void 0 || this.clone === !1) && (e.visible = !1, e.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(e.rigidBody.collider(0).handle), r.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.bvhGeometry && (e.bvhGeometry = void 0));
            } else e.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(e.rigidBody.collider(0).handle), r.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.bvhGeometry && (e.bvhGeometry = void 0), e.visible = !1;
            r === void 0 ? this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s)=>s.bvhGeometry !== void 0) : this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s)=>s.rigidBody !== void 0), e.destroyedInAction = !0, this.controlsManager.requestRender();
        };
        this.objects = [
            ...t.objects
        ];
    }
    dispatch(t) {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.clone = t, this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
    }
    dispatchFromStart() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
    }
    dispose() {
        this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t));
    }
};
var tg = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.eventManager = i;
        this.condition = s;
        this.shared = r;
    }
    dispatch() {
        if (wt(this.shared, this.condition) === !1) return !1;
        clearTimeout(this.timeoutId), delete this.timeoutId, this.timeoutId = window.setTimeout(()=>{
            this.shared.reset(this.shared.data, !0), Bf(this.page, this.shared, !0), this.eventManager.reset(), this.eventManager.controlsManager.gameControl?.reset(!0), this.page.switchToPlayCamera(), this.eventManager.controlsManager.requestRender(), delete this.timeoutId;
        }, (this.data.delay ?? 0) * 1e3);
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
};
var zB = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    timelineChangeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0,
    rewind: !0
}, TT = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    startOnceDelay: 0,
    pingPongDelayCorrection: 0,
    pingPongEndDelayCorrection: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
}, LZ = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
], vb = {
    CSS: {},
    springs: {}
};
function to(n1, t, e) {
    return Math.min(Math.max(n1, t), e);
}
function rg(n1, t) {
    return n1.indexOf(t) > -1;
}
function wT(n1, t) {
    return n1.apply(null, t);
}
var ht = {
    arr: function(n1) {
        return Array.isArray(n1);
    },
    obj: function(n1) {
        return rg(Object.prototype.toString.call(n1), "Object");
    },
    pth: function(n1) {
        return ht.obj(n1) && n1.hasOwnProperty("totalLength");
    },
    svg: function(n1) {
        return n1 instanceof SVGElement;
    },
    inp: function(n1) {
        return n1 instanceof HTMLInputElement;
    },
    dom: function(n1) {
        return !("isNode" in n1) && (n1.nodeType || ht.svg(n1));
    },
    str: function(n1) {
        return typeof n1 == "string";
    },
    fnc: function(n1) {
        return typeof n1 == "function";
    },
    und: function(n1) {
        return typeof n1 > "u";
    },
    hex: function(n1) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n1);
    },
    rgb: function(n1) {
        return /^rgb/.test(n1);
    },
    hsl: function(n1) {
        return /^hsl/.test(n1);
    },
    col: function(n1) {
        return ht.hex(n1) || ht.rgb(n1) || ht.hsl(n1);
    },
    key: function(n1) {
        return !zB.hasOwnProperty(n1) && !TT.hasOwnProperty(n1) && n1 !== "targets" && n1 !== "keyframes";
    }
};
function GB(n1) {
    var t = /\(([^)]+)\)/.exec(n1);
    return t ? t[1].split(",").map(function(e) {
        return parseFloat(e);
    }) : [];
}
function jB(n1, t) {
    var e = GB(n1), r = to(ht.und(e[0]) ? 1 : e[0], .1, 100), i = to(ht.und(e[1]) ? 100 : e[1], .1, 100), s = to(ht.und(e[2]) ? 10 : e[2], .1, 100), o = to(ht.und(e[3]) ? 0 : e[3], .1, 100), a = Math.sqrt(i / r), l = s / (2 * Math.sqrt(i * r)), c = l < 1 ? a * Math.sqrt(1 - l * l) : 0, u = 1, h = l < 1 ? (l * a + -o) / c : -o + a;
    function d(p) {
        var m = t ? t * p / 1e3 : p;
        return l < 1 ? m = Math.exp(-m * l * a) * (u * Math.cos(c * m) + h * Math.sin(c * m)) : m = (u + h * m) * Math.exp(-m * a), p === 0 || p === 1 ? p : 1 - m;
    }
    function f() {
        var p = vb.springs[n1];
        if (p) return p;
        for(var m = 1 / 6, g = 0, y = 0;;)if (g += m, d(g) === 1) {
            if (y++, y >= 16) break;
        } else y = 0;
        var x = g * m * 1e3;
        return vb.springs[n1] = x, x;
    }
    return t ? d : f;
}
function BZ(n1) {
    return n1 === void 0 && (n1 = 10), function(t) {
        return Math.ceil(to(t, 1e-6, 1) * n1) * (1 / n1);
    };
}
var NZ = function() {
    var n1 = 11, t = 1 / (n1 - 1);
    function e(u, h) {
        return 1 - 3 * h + 3 * u;
    }
    function r(u, h) {
        return 3 * h - 6 * u;
    }
    function i(u) {
        return 3 * u;
    }
    function s(u, h, d) {
        return ((e(h, d) * u + r(h, d)) * u + i(h)) * u;
    }
    function o(u, h, d) {
        return 3 * e(h, d) * u * u + 2 * r(h, d) * u + i(h);
    }
    function a(u, h, d, f, p) {
        var m, g, y = 0;
        do g = h + (d - h) / 2, m = s(g, f, p) - u, m > 0 ? d = g : h = g;
        while (Math.abs(m) > 1e-7 && ++y < 10);
        return g;
    }
    function l(u, h, d, f) {
        for(var p = 0; p < 4; ++p){
            var m = o(h, d, f);
            if (m === 0) return h;
            var g = s(h, d, f) - u;
            h -= g / m;
        }
        return h;
    }
    function c(u, h, d, f) {
        if (!(0 <= u && u <= 1 && 0 <= d && d <= 1)) return;
        var p = new Float32Array(n1);
        if (u !== h || d !== f) for(var m = 0; m < n1; ++m)p[m] = s(m * t, u, d);
        function g(y) {
            for(var x = 0, v = 1, S = n1 - 1; v !== S && p[v] <= y; ++v)x += t;
            --v;
            var w = (y - p[v]) / (p[v + 1] - p[v]), A = x + w * t, T = o(A, u, d);
            return T >= .001 ? l(y, A, u, d) : T === 0 ? A : a(y, x, x + t, u, d);
        }
        return function(y) {
            return u === h && d === f || y === 0 || y === 1 ? y : s(g(y), h, f);
        };
    }
    return c;
}(), HB = function() {
    var n1 = {
        linear: function() {
            return function(r) {
                return r;
            };
        }
    }, t = {
        Sine: function() {
            return function(r) {
                return 1 - Math.cos(r * Math.PI / 2);
            };
        },
        Circ: function() {
            return function(r) {
                return 1 - Math.sqrt(1 - r * r);
            };
        },
        Back: function() {
            return function(r) {
                return r * r * (3 * r - 2);
            };
        },
        Bounce: function() {
            return function(r) {
                for(var i, s = 4; r < ((i = Math.pow(2, --s)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - s) - 7.5625 * Math.pow((i * 3 - 2) / 22 - r, 2);
            };
        },
        Elastic: function(r, i) {
            r === void 0 && (r = 1), i === void 0 && (i = .5);
            var s = to(r, 1, 10), o = to(i, .1, 2);
            return function(a) {
                return a === 0 || a === 1 ? a : -s * Math.pow(2, 10 * (a - 1)) * Math.sin((a - 1 - o / (Math.PI * 2) * Math.asin(1 / s)) * (Math.PI * 2) / o);
            };
        }
    }, e = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint",
        "Expo"
    ];
    return e.forEach(function(r, i) {
        t[r] = function() {
            return function(s) {
                return Math.pow(s, i + 2);
            };
        };
    }), Object.keys(t).forEach(function(r) {
        var i = t[r];
        n1["easeIn" + r] = i, n1["easeOut" + r] = function(s, o) {
            return function(a) {
                return 1 - i(s, o)(1 - a);
            };
        }, n1["easeInOut" + r] = function(s, o) {
            return function(a) {
                return a < .5 ? i(s, o)(a * 2) / 2 : 1 - i(s, o)(a * -2 + 2) / 2;
            };
        };
    }), n1;
}();
function MT(n1, t) {
    if (ht.fnc(n1)) return n1;
    var e = n1.split("(")[0], r = HB[e], i = GB(n1);
    switch(e){
        case "spring":
            return jB(n1, t);
        case "cubicBezier":
            return wT(NZ, i);
        case "steps":
            return wT(BZ, i);
        default:
            return wT(r, i);
    }
}
function WB(n1) {
    try {
        var t = document.querySelectorAll(n1);
        return t;
    } catch  {
        return;
    }
}
function xb(n1, t) {
    for(var e = n1.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], s = 0; s < e; s++)if (s in n1) {
        var o = n1[s];
        t.call(r, o, s, n1) && i.push(o);
    }
    return i;
}
function bb(n1) {
    return n1.reduce(function(t, e) {
        return t.concat(ht.arr(e) ? bb(e) : e);
    }, []);
}
function NB(n1) {
    return ht.arr(n1) ? n1 : (ht.str(n1) && (n1 = WB(n1) || n1), n1 instanceof NodeList || n1 instanceof HTMLCollection ? [].slice.call(n1) : [
        n1
    ]);
}
function CT(n1, t) {
    return n1.some(function(e) {
        return e === t;
    });
}
function PT(n1) {
    var t = {};
    for(var e in n1)t[e] = n1[e];
    return t;
}
function AT(n1, t) {
    var e = PT(n1);
    for(var r in n1)e[r] = t.hasOwnProperty(r) ? t[r] : n1[r];
    return e;
}
function Sb(n1, t) {
    var e = PT(n1);
    for(var r in t)e[r] = ht.und(n1[r]) ? t[r] : n1[r];
    return e;
}
function FZ(n1) {
    var t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n1);
    return t ? "rgba(" + t[1] + ",1)" : n1;
}
function VZ(n1) {
    var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, e = n1.replace(t, function(a, l, c, u) {
        return l + l + c + c + u + u;
    }), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), i = parseInt(r[1], 16), s = parseInt(r[2], 16), o = parseInt(r[3], 16);
    return "rgba(" + i + "," + s + "," + o + ",1)";
}
function kZ(n1) {
    var t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(n1) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(n1), e = parseInt(t[1], 10) / 360, r = parseInt(t[2], 10) / 100, i = parseInt(t[3], 10) / 100, s = t[4] || 1;
    function o(d, f, p) {
        return p < 0 && (p += 1), p > 1 && (p -= 1), p < 1 / 6 ? d + (f - d) * 6 * p : p < 0.5 ? f : p < 2 / 3 ? d + (f - d) * (2 / 3 - p) * 6 : d;
    }
    var a, l, c;
    if (r == 0) a = l = c = i;
    else {
        var u = i < .5 ? i * (1 + r) : i + r - i * r, h = 2 * i - u;
        a = o(h, u, e + 1 / 3), l = o(h, u, e), c = o(h, u, e - 1 / 3);
    }
    return "rgba(" + a * 255 + "," + l * 255 + "," + c * 255 + "," + s + ")";
}
function UZ(n1) {
    if (ht.rgb(n1)) return FZ(n1);
    if (ht.hex(n1)) return VZ(n1);
    if (ht.hsl(n1)) return kZ(n1);
}
function ka(n1) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(n1);
    if (t) return t[1];
}
function zZ(n1) {
    if (rg(n1, "translate") || n1 === "perspective") return "px";
    if (rg(n1, "rotate") || rg(n1, "skew")) return "deg";
}
function ET(n1, t) {
    return ht.fnc(n1) ? n1(t.target, t.id, t.total) : n1;
}
function qo(n1, t) {
    return n1.getAttribute(t);
}
function _T(n1, t, e) {
    var r = ka(t);
    if (CT([
        e,
        "deg",
        "rad",
        "turn"
    ], r)) return t;
    var i = vb.CSS[t + e];
    if (!ht.und(i)) return i;
    var s = 100, o = document.createElement(n1.tagName), a = n1.parentNode && n1.parentNode !== document ? n1.parentNode : document.body;
    a.appendChild(o), o.style.position = "absolute", o.style.width = s + e;
    var l = s / o.offsetWidth;
    a.removeChild(o);
    var c = l * parseFloat(t);
    return vb.CSS[t + e] = c, c;
}
function qB(n1, t, e) {
    if (t in n1.style) {
        var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = n1.style[t] || getComputedStyle(n1).getPropertyValue(r) || "0";
        return e ? _T(n1, i, e) : i;
    }
}
function IT(n1, t) {
    if (ht.dom(n1) && !ht.inp(n1) && (qo(n1, t) || ht.svg(n1) && n1[t])) return "attribute";
    if (ht.dom(n1) && CT(LZ, t)) return "transform";
    if (ht.dom(n1) && t !== "transform" && qB(n1, t)) return "css";
    if (n1[t] != null) return "object";
}
function YB(n1) {
    if (!!ht.dom(n1)) {
        for(var t = n1.style.transform || "", e = /(\w+)\(([^)]*)\)/g, r = new Map, i; i = e.exec(t);)r.set(i[1], i[2]);
        return r;
    }
}
function GZ(n1, t, e, r) {
    var i = rg(t, "scale") ? 1 : 0 + zZ(t), s = YB(n1).get(t) || i;
    return e && (e.transforms.list.set(t, s), e.transforms.last = t), r ? _T(n1, s, r) : s;
}
function DT(n1, t, e, r) {
    switch(IT(n1, t)){
        case "transform":
            return GZ(n1, t, r, e);
        case "css":
            return qB(n1, t, e);
        case "attribute":
            return qo(n1, t);
        default:
            return n1[t] || 0;
    }
}
function OT(n1, t) {
    var e = /^(\*=|\+=|-=)/.exec(n1);
    if (!e) return n1;
    var r = ka(n1) || 0, i = parseFloat(t), s = parseFloat(n1.replace(e[0], ""));
    switch(e[0][0]){
        case "+":
            return i + s + r;
        case "-":
            return i - s + r;
        case "*":
            return i * s + r;
    }
}
function XB(n1, t) {
    if (ht.col(n1)) return UZ(n1);
    if (/\s/g.test(n1)) return n1;
    var e = ka(n1), r = e ? n1.substr(0, n1.length - e.length) : n1;
    return t ? r + t : r;
}
function RT(n1, t) {
    return Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2));
}
function jZ(n1) {
    return Math.PI * 2 * qo(n1, "r");
}
function HZ(n1) {
    return qo(n1, "width") * 2 + qo(n1, "height") * 2;
}
function WZ(n1) {
    return RT({
        x: qo(n1, "x1"),
        y: qo(n1, "y1")
    }, {
        x: qo(n1, "x2"),
        y: qo(n1, "y2")
    });
}
function KB(n1) {
    for(var t = n1.points, e = 0, r, i = 0; i < t.numberOfItems; i++){
        var s = t.getItem(i);
        i > 0 && (e += RT(r, s)), r = s;
    }
    return e;
}
function qZ(n1) {
    var t = n1.points;
    return KB(n1) + RT(t.getItem(t.numberOfItems - 1), t.getItem(0));
}
function QB(n1) {
    if (n1.getTotalLength) return n1.getTotalLength();
    switch(n1.tagName.toLowerCase()){
        case "circle":
            return jZ(n1);
        case "rect":
            return HZ(n1);
        case "line":
            return WZ(n1);
        case "polyline":
            return KB(n1);
        case "polygon":
            return qZ(n1);
    }
}
function YZ(n1) {
    var t = QB(n1);
    return n1.setAttribute("stroke-dasharray", t), t;
}
function XZ(n1) {
    for(var t = n1.parentNode; ht.svg(t) && ht.svg(t.parentNode);)t = t.parentNode;
    return t;
}
function ZB(n1, t) {
    var e = t || {}, r = e.el || XZ(n1), i = r.getBoundingClientRect(), s = qo(r, "viewBox"), o = i.width, a = i.height, l = e.viewBox || (s ? s.split(" ") : [
        0,
        0,
        o,
        a
    ]);
    return {
        el: r,
        viewBox: l,
        x: l[0] / 1,
        y: l[1] / 1,
        w: o / l[2],
        h: a / l[3]
    };
}
function KZ(n1, t) {
    var e = ht.str(n1) ? WB(n1)[0] : n1, r = t || 100;
    return function(i) {
        return {
            property: i,
            el: e,
            svg: ZB(e),
            totalLength: QB(e) * (r / 100)
        };
    };
}
function QZ(n1, t) {
    function e(a) {
        a === void 0 && (a = 0);
        var l = t + a >= 1 ? t + a : 0;
        return n1.el.getPointAtLength(l);
    }
    var r = ZB(n1.el, n1.svg), i = e(), s = e(-1), o = e(1);
    switch(n1.property){
        case "x":
            return (i.x - r.x) * r.w;
        case "y":
            return (i.y - r.y) * r.h;
        case "angle":
            return Math.atan2(o.y - s.y, o.x - s.x) * 180 / Math.PI;
    }
}
function FB(n1, t) {
    var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, r = XB(ht.pth(n1) ? n1.totalLength : n1, t) + "";
    return {
        original: r,
        numbers: r.match(e) ? r.match(e).map(Number) : [
            0
        ],
        strings: ht.str(n1) || t ? r.split(e) : []
    };
}
function JB(n1) {
    var t = n1 ? bb(ht.arr(n1) ? n1.map(NB) : NB(n1)) : [];
    return xb(t, function(e, r, i) {
        return i.indexOf(e) === r;
    });
}
function $B(n1) {
    var t = JB(n1);
    return t.map(function(e, r) {
        return {
            target: e,
            id: r,
            total: t.length,
            transforms: {
                list: YB(e)
            }
        };
    });
}
function ZZ(n1, t) {
    var e = PT(t);
    if (/^spring/.test(e.easing) && (e.duration = jB(e.easing)), ht.arr(n1)) {
        var r = n1.length, i = r === 2 && !ht.obj(n1[0]);
        i ? n1 = {
            value: n1
        } : ht.fnc(t.duration) || (e.duration = t.duration / r);
    }
    var s = ht.arr(n1) ? n1 : [
        n1
    ];
    return s.map(function(o, a) {
        var l = ht.obj(o) && !ht.pth(o) ? o : {
            value: o
        };
        return ht.und(l.delay) && (l.delay = a ? 0 : t.delay), ht.und(l.endDelay) && (l.endDelay = a === s.length - 1 ? t.endDelay : 0), l;
    }).map(function(o) {
        return Sb(o, e);
    });
}
function JZ(n1) {
    for(var t = xb(bb(n1.map(function(s) {
        return Object.keys(s);
    })), function(s) {
        return ht.key(s);
    }).reduce(function(s, o) {
        return s.indexOf(o) < 0 && s.push(o), s;
    }, []), e = {}, r = function(s) {
        var o = t[s];
        e[o] = n1.map(function(a) {
            var l = {};
            for(var c in a)ht.key(c) ? c == o && (l.value = a[c]) : l[c] = a[c];
            return l;
        });
    }, i = 0; i < t.length; i++)r(i);
    return e;
}
function $Z(n1, t) {
    var e = [], r = t.keyframes;
    r && (t = Sb(JZ(r), t));
    for(var i in t)ht.key(i) && e.push({
        name: i,
        tweens: ZZ(t[i], n1)
    });
    return e;
}
function eJ(n1, t) {
    var e = {};
    for(var r in n1){
        var i = ET(n1[r], t);
        ht.arr(i) && (i = i.map(function(s) {
            return ET(s, t);
        }), i.length === 1 && (i = i[0])), e[r] = i;
    }
    return e.duration = parseFloat(e.duration), e.delay = parseFloat(e.delay), e;
}
function tJ(n1, t) {
    var e;
    return n1.tweens.map(function(r) {
        var i = eJ(r, t), s = i.value, o = ht.arr(s) ? s[1] : s, a = ka(o), l = DT(t.target, n1.name, a, t), c = e ? e.to.original : l, u = ht.arr(s) ? s[0] : c, h = ka(u) || ka(l), d = a || h;
        return ht.und(o) && (o = c), i.from = FB(u, d), i.to = FB(OT(o, u), d), i.start = e ? e.end : 0, i.end = i.start + i.delay + i.duration + i.endDelay, i.easing = MT(i.easing, i.duration), i.isPath = ht.pth(s), i.isColor = ht.col(i.from.original), i.isColor && (i.round = 1), e = i, i;
    });
}
var eN = {
    css: function(n1, t, e) {
        return n1.style[t] = e;
    },
    attribute: function(n1, t, e) {
        return n1.setAttribute(t, e);
    },
    object: function(n1, t, e) {
        return n1[t] = e;
    },
    transform: function(n1, t, e, r, i) {
        if (r.list.set(t, e), t === r.last || i) {
            var s = "";
            r.list.forEach(function(o, a) {
                s += a + "(" + o + ") ";
            }), n1.style.transform = s;
        }
    }
};
function tN(n1, t) {
    var e = $B(n1);
    e.forEach(function(r) {
        for(var i in t){
            var s = ET(t[i], r), o = r.target, a = ka(s), l = DT(o, i, a, r), c = a || ka(l), u = OT(XB(s, c), l), h = IT(o, i);
            eN[h](o, i, u, r.transforms, !0);
        }
    });
}
function rJ(n1, t) {
    var e = IT(n1.target, t.name);
    if (e) {
        var r = tJ(t, n1), i = r[r.length - 1];
        return {
            type: e,
            property: t.name,
            animatable: n1,
            tweens: r,
            duration: i.end,
            delay: r[0].delay,
            endDelay: i.endDelay
        };
    }
}
function iJ(n1, t) {
    return xb(bb(n1.map(function(e) {
        return t.map(function(r) {
            return rJ(e, r);
        });
    })), function(e) {
        return !ht.und(e);
    });
}
function rN(n1, t) {
    var e = n1.length, r = function(s) {
        return s.timelineOffset ? s.timelineOffset : 0;
    }, i = {};
    return i.duration = e ? Math.max.apply(Math, n1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0, l = s.pingPongEndDelayCorrection ?? 0;
        return r(s) + o + a + l + s.duration * (s.loop ?? 1);
    })) : t.duration, i.delay = e ? Math.min.apply(Math, n1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0;
        return r(s) + o + a + s.delay;
    })) : t.delay, i.endDelay = e ? i.duration - Math.max.apply(Math, n1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0, l = s.pingPongEndDelayCorrection ?? 0;
        return r(s) + o + a + s.duration * (s.loop ?? 1) - s.endDelay - l;
    })) : t.endDelay, i;
}
var VB = 0;
function nJ(n1) {
    var t = AT(zB, n1), e = AT(TT, n1), r = $Z(e, n1), i = $B(n1.targets), s = iJ(i, r), o = rN(s, e), a = VB;
    return VB++, Sb(t, {
        id: a,
        children: [],
        animatables: i,
        animations: s,
        duration: o.duration,
        delay: o.delay,
        endDelay: o.endDelay,
        startOnceDelay: e.startOnceDelay,
        pingPongDelayCorrection: e.pingPongDelayCorrection,
        pingPongEndDelayCorrection: e.pingPongEndDelayCorrection
    });
}
var Ts = [], kB = [], yb, sJ = function() {
    function n1() {
        yb = requestAnimationFrame(t);
    }
    function t(e) {
        var r = Ts.length;
        if (r) {
            for(var i = 0; i < r;){
                var s = Ts[i];
                s.paused ? (Ts.splice(i, 1), r -= 1) : (s.tick(e), i++);
            }
            n1();
        } else yb = cancelAnimationFrame(yb);
    }
    return n1;
}();
function oJ(n1) {
    document.hidden ? (Ts.forEach(function(t) {
        return t.pause(n1.timeStamp);
    }), kB = Ts.slice(0), ai.running = Ts = []) : kB.forEach(function(t) {
        return t.play(n1.timeStamp);
    });
}
typeof document < "u" && document.addEventListener("visibilitychange", oJ);
function ai(n1) {
    n1 === void 0 && (n1 = {});
    var t = 0, e = 0, r = 0, i, s, o = 0, a = null;
    function l(T) {
        var b = window.Promise && new Promise(function(M) {
            return a = M;
        });
        return T.finished = b, b;
    }
    var c = nJ(n1), u = l(c);
    function h() {
        var T = c.direction;
        T !== "alternate" && (c.direction = T !== "normal" ? "normal" : "reverse"), c.reversed = !c.reversed, s.forEach(function(b) {
            (b.loop === 1 || b.loop % 2 === 0) && (b.reversed = c.reversed);
        });
    }
    function d() {
        c.direction = "normal", c.reversed = !1, s.forEach(function(T) {
            return T.reversed = !1;
        });
    }
    function f(T) {
        return c.reversed ? c.duration - T : T;
    }
    function p() {
        t = 0, e = f(c.currentTime) * (1 / ai.speed);
    }
    function m(T, b, M = !1) {
        b && (c.reversed ? b.seek(b.duration * b.loop - (T - b.timelineOffset - b.pingPongDelayCorrection), M) : b.seek(T - b.timelineOffset - b.startOnceDelay - b.pingPongDelayCorrection, M));
    }
    function g(T, b = !1) {
        if (c.reversed) for(var C = o; C--;)m(T, s[C], b);
        else for(var M = 0; M < o; M++)m(T, s[M], b);
    }
    function y(T) {
        var b = 0, M = c.animations, C = M.length;
        for(c.direction !== "alternate" && c.parent?.direction === "alternate" ? c.parent?.rewind === !1 && c.reversePlayback === !0 && c.rewind === !1 && (c.parent?.reversed && c.direction === "alternate" ? T = c.duration - c.delay + c.endDelay - T : T = c.duration + c.delay - c.endDelay - T) : w(!1, c.parent?.rewind, c.rewind, c.parent?.reversePlayback, c.reversePlayback) && (c.parent?.reversed && c.direction === "alternate" ? T = c.duration - c.delay + c.endDelay - T : T = c.duration + c.delay - c.endDelay - T); b < C;){
            var P = M[b], I = P.animatable, _ = P.tweens, D = _.length - 1, L = _[D];
            D && (L = xb(_, function(J) {
                return T < J.end;
            })[0] || L);
            let re;
            c.parent?.reversed && c.direction === "alternate" ? re = to(T - L.start - L.endDelay, 0, L.duration) / L.duration : re = to(T - L.start - L.delay, 0, L.duration) / L.duration;
            for(var j = isNaN(re) ? 1 : L.easing(re), V = L.to.strings, H = L.round, W = [], q = L.to.numbers.length, Q = void 0, G = 0; G < q; G++){
                var Z = void 0;
                let J, Ee;
                c.direction !== "alternate" ? c.parent?.rewind === !1 && c.reversePlayback === !0 && c.rewind === !1 ? (J = L.to.numbers[G], Ee = L.from.numbers[G] || 0) : (Ee = L.to.numbers[G], J = L.from.numbers[G] || 0) : w(!0, c.parent?.rewind, c.rewind, c.parent?.reversePlayback, c.reversePlayback) ? (J = L.to.numbers[G], Ee = L.from.numbers[G] || 0) : (Ee = L.to.numbers[G], J = L.from.numbers[G] || 0), L.isPath ? Z = QZ(L.value, j * Ee) : Z = J + j * (Ee - J), H && (L.isColor && G > 2 || (Z = Math.round(Z * H) / H)), W.push(Z);
            }
            var te = V.length;
            if (!te) Q = W[0];
            else {
                Q = V[0];
                for(var $ = 0; $ < te; $++){
                    var Y = V[$], oe = V[$ + 1], ie = W[$];
                    isNaN(ie) || (oe ? Q += ie + oe : Q += ie + " ");
                }
            }
            eN[P.type](I.target, P.property, Q, I.transforms), P.currentValue = Q, b++;
        }
    }
    function x(T) {
        c[T] && !c.passThrough && c[T](c);
    }
    function v() {
        c.remaining && c.remaining !== !0 && c.remaining--;
    }
    let S = {
        0: !1,
        1: !0,
        2: !1,
        3: !0,
        4: !1,
        5: !1,
        6: !1,
        7: !1,
        8: !1,
        9: !0,
        10: !0,
        11: !1,
        12: !1,
        13: !1,
        14: !0,
        15: !0,
        16: !1,
        17: !0,
        18: !0,
        19: !1,
        20: !1,
        21: !1,
        22: !0,
        23: !0,
        24: !1,
        25: !0,
        26: !1,
        27: !0,
        28: !1,
        29: !1,
        30: !1,
        31: !1
    };
    function w(T, b, M, C, P) {
        return S[T << 4 | b << 3 | M << 2 | C << 1 | P];
    }
    function A(T, b = !1) {
        var M = c.duration;
        let C = c.delay, P = M - c.endDelay;
        c.parent?.reversed && c.direction === "alternate" && (C = c.endDelay, P = M - c.delay);
        var I = f(T);
        if (c.progress = to(I / M * 100, 0, 100), b || (c.reversePlayback = I < c.currentTime), o && g(I, b), !c.began && c.currentTime >= 0 && (c.began = !0, x("begin")), !c.loopBegan && c.currentTime > 0 && (c.loopBegan = !0, x("loopBegin")), (c.reversed || I >= 0) && I <= C && c.currentTime !== 0 && (y(0), x("change")), (I >= P && c.currentTime !== M + c.pingPongDelayCorrection || !M) && (y(M), x("change")), I > C && I < P ? (c.changeBegan || (c.changeBegan = !0, c.changeCompleted = !1, x("changeBegin")), y(I), x("change")) : c.changeBegan ? (c.changeCompleted = !0, c.changeBegan = !1, x("change"), o && x("timelineChangeComplete")) : c.began && I > P && x("changeComplete"), c.currentTime = to(I, 0, M + c.pingPongDelayCorrection), c.began && x("update"), T >= M) {
            if (v(), !c.remaining) c.paused = !0, c.completed || (c.completed = !0, x("loopComplete"), x("complete"), !c.passThrough && "Promise" in window && (a(), u = l(c)));
            else {
                o ? t += c.duration / ai.speed : t += c.duration;
                for (let _ of s)_.setStartTime(0), _.remaining = _.loop;
                x("loopComplete"), c.loopBegan = !1, c.direction === "alternate" ? h() : o && d();
            }
        }
    }
    return c.reset = function() {
        var T = c.direction;
        c.passThrough = !1, c.currentTime = 0, c.progress = 0, c.paused = !0, c.began = !1, c.loopBegan = !1, c.changeBegan = !1, c.completed = !1, c.changeCompleted = !1, c.reversePlayback = !1, c.reversed = T === "reverse", c.remaining = c.loop, s = c.children, o = s.length;
        for(var b = o; b--;)c.children[b].reset();
        y(c.reversed ? c.duration : 0);
    }, c.setStartTime = function(T) {
        t = T;
    }, c.set = function(T, b) {
        return tN(T, b), c;
    }, c.tick = function(T) {
        r = T, t || (t = r), A((r + (e - t)) * ai.speed);
    }, c.seek = function(T, b = !1) {
        A(T - t, b);
    }, c.pause = function(T) {
        c.paused = !0, o && (i = T ?? performance.now());
    }, c.play = function(T) {
        !c.paused || (c.completed && c.reset(), c.paused = !1, Ts.push(c), o && i !== void 0 && (t += (T ?? performance.now()) - i), yb || sJ());
    }, c.reverse = function() {
        h(), c.completed = !c.reversed, p();
    }, c.restart = function() {
        c.reset(), c.play();
    }, c.reset(), c.autoplay && c.play(), c;
}
function UB(n1, t) {
    for(var e = t.length; e--;)CT(n1, t[e].animatable.target) && t.splice(e, 1);
}
function aJ(n1) {
    for(var t = JB(n1), e = Ts.length; e--;){
        var r = Ts[e], i = r.animations, s = r.children;
        UB(t, i);
        for(var o = s.length; o--;){
            var a = s[o], l = a.animations;
            UB(t, l), !l.length && !a.children.length && s.splice(o, 1);
        }
        !i.length && !s.length && r.pause();
    }
}
function lJ(n1, t) {
    t === void 0 && (t = {});
    var e = t.direction || "normal", r = t.easing ? MT(t.easing) : null, i = t.grid, s = t.axis, o = t.from || 0, a = o === "first", l = o === "center", c = o === "last", u = ht.arr(n1), h = parseFloat(u ? n1[0] : n1), d = u ? parseFloat(n1[1]) : 0, f = ka(u ? n1[1] : n1) || 0, p = t.start || 0 + (u ? h : 0), m = [], g = 0;
    return function(y, x, v) {
        if (a && (o = 0), l && (o = (v - 1) / 2), c && (o = v - 1), !m.length) {
            for(var S = 0; S < v; S++){
                if (!i) m.push(Math.abs(o - S));
                else {
                    var w = l ? (i[0] - 1) / 2 : o % i[0], A = l ? (i[1] - 1) / 2 : Math.floor(o / i[0]), T = S % i[0], b = Math.floor(S / i[0]), M = w - T, C = A - b, P = Math.sqrt(M * M + C * C);
                    s === "x" && (P = -M), s === "y" && (P = -C), m.push(P);
                }
                g = Math.max.apply(Math, m);
            }
            r && (m = m.map(function(_) {
                return r(_ / g) * g;
            })), e === "reverse" && (m = m.map(function(_) {
                return s ? _ < 0 ? _ * -1 : -_ : Math.abs(g - _);
            }));
        }
        var I = u ? (d - h) / g : h;
        return p + I * (Math.round(m[x] * 100) / 100) + f;
    };
}
function cJ(n1) {
    n1 === void 0 && (n1 = {});
    var t = ai(n1);
    return t.duration = 0, t.add = function(e, r) {
        var i = Ts.indexOf(t), s = t.children;
        i > -1 && Ts.splice(i, 1);
        function o(d) {
            d.passThrough = !0;
        }
        for(var a = 0; a < s.length; a++)o(s[a]);
        var l = Sb(e, AT(TT, n1));
        l.targets = l.targets || n1.targets;
        var c = t.duration;
        l.autoplay = !1, l.timelineOffset = ht.und(r) ? c : OT(r, c), o(t);
        var u = ai(l);
        o(u), s.push(u), u.parent = t;
        var h = rN(s, n1);
        return t.delay = h.delay, t.endDelay = h.endDelay, t.duration = h.duration, u.loop === !0 && (t.duration = 1 / 0), t.seek(0), t.reset(), t.autoplay && t.play(), t;
    }, t;
}
ai.version = "3.2.0";
ai.speed = 1;
ai.running = Ts;
ai.remove = aJ;
ai.get = DT;
ai.set = tN;
ai.convertPx = _T;
ai.path = KZ;
ai.setDashoffset = YZ;
ai.stagger = lJ;
ai.timeline = cJ;
ai.easing = MT;
ai.penner = HB;
ai.random = function(n1, t) {
    return Math.floor(Math.random() * (t - n1 + 1)) + n1;
};
var wb = ai;
var iN = new E, nN = new E, sN = new Ke;
function aN(n1, t, e, r) {
    if (r === 0) return e.copy(n1);
    if (r === 1) return e.copy(t);
    let i = n1.w * t.w + n1.x * t.x + n1.y * t.y + n1.z * t.z;
    if (i >= 1) return e.copy(n1);
    let s = 1 - i * i;
    if (s <= Number.EPSILON) {
        let u = 1 - r;
        return e.w = u * n1.w + r * t.w, e.x = u * n1.x + r * t.x, e.y = u * n1.y + r * t.y, e.z = u * n1.z + r * t.z, e.normalize(), e;
    }
    let o = Math.sqrt(s), a = Math.atan2(o, i), l = Math.sin((1 - r) * a) / o, c = Math.sin(r * a) / o;
    return e.w = n1.w * l + t.w * c, e.x = n1.x * l + t.x * c, e.y = n1.y * l + t.y * c, e.z = n1.z * l + t.z * c, e;
}
function Zr(n1, t, e, r, i, s) {
    let o = e[n1] !== void 0 ? e[n1] : void 0, a = r[n1];
    if (a == null) return;
    let l = o != null ? typeof o == "string" ? Number(i.getVariable(o) ?? 0) : o : t[n1], c = typeof a == "string" ? Number(i.getVariable(a) ?? 0) : a;
    if (l !== c) return {
        update: (u)=>{
            let h = we.lerp(l, c, u);
            s ? t[n1] = Math.trunc(h) : t[n1] = h;
        },
        start: ()=>{
            t[n1] = l;
        },
        end: ()=>{
            t[n1] = c;
        }
    };
}
function ng(n1, t, e, r, i, s) {
    let o = e[n1] ? e[n1] : void 0, a = r[n1];
    if (!a) return;
    let l = t[n1], c = [
        ...o ?? l
    ].map((h)=>typeof h == "string" ? Number(i.getVariable(h) ?? 0) : h), u = [
        ...a
    ].map((h)=>typeof h == "string" ? Number(i.getVariable(h) ?? 0) : h);
    if (!(c.length !== u.length || Dc(c, u))) return {
        update: (h)=>{
            c.forEach((d, f)=>{
                let p = we.lerp(d, u[f], h);
                t[n1][f] = s ? Math.trunc(p) : p;
            });
        },
        start: ()=>{
            Object.assign(t[n1], c);
        },
        end: ()=>{
            Object.assign(t[n1], u);
        }
    };
}
function ig(n1, t, e) {
    return t.forEach((r, i)=>{
        n1.setComponent(i, typeof r == "string" ? Number(e.getVariable(r) ?? 0) : r);
    }), n1;
}
function LT(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = s ? ig(new E, s, i) : a.clone(), c = ig(new E, o, i);
    if (!l.equals(c)) return {
        update: (u)=>{
            a.lerpVectors(l, c, u);
        },
        start: ()=>{
            a.copy(l);
        },
        end: ()=>{
            a.copy(c);
        }
    };
}
function oN(n1, t, e) {
    return t.forEach((r, i)=>{
        n1.setComponent(i, typeof r == "string" ? Number(e.getVariable(r) ?? 0) : r);
    }), n1;
}
function Nf(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = !(a instanceof k), c = a instanceof k ? a : new k().fromArray(a), u = s ? oN(new k, s, i) : c.clone(), h = oN(new k, o, i);
    if (!u.equals(h)) return {
        update: (d)=>{
            c.lerpVectors(u, h, d), l && (t[n1] = c.toArray());
        },
        start: ()=>{
            c.copy(u), l && (t[n1] = c.toArray());
        },
        end: ()=>{
            c.copy(h), l && (t[n1] = c.toArray());
        }
    };
}
function lN(n1, t, e, r) {
    let i = e[n1] ? e[n1] : void 0, s = r[n1];
    if (!s) return;
    let o = t[n1], a = i ? new ue().fromArray(i) : o.clone(), l = new E, c = new Ke, u = new E;
    a.decompose(l, c, u);
    let h = new ue().fromArray(s), d = new E, f = new Ke, p = new E;
    if (h.decompose(d, f, p), !a.equals(h)) return {
        update: (m)=>{
            sN.slerpQuaternions(c, f, m), iN.lerpVectors(l, d, m), nN.lerpVectors(u, p, m), o.compose(iN, sN, nN);
        },
        start: ()=>{
            o.compose(l, c, u);
        },
        end: ()=>{
            o.compose(d, f, p);
        }
    };
}
function cN(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = s ? typeof s == "string" ? i.getColor(s).clone() : new We().setRGB(s.r, s.g, s.b) : a.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new We().setRGB(o.r, o.g, o.b);
    if (l.equals(c)) return;
    let u = a.clone();
    return {
        update: (h)=>{
            u.lerpColors(l, c, h), t[n1]?.copy?.(u);
        },
        start: ()=>{
            u.copy(l);
        },
        end: ()=>{
            u.copy(c);
        }
    };
}
function sg(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = new vr(a.r, a.g, a.b, a.a), c = s ? typeof s == "string" ? i.getColor(s).clone() : new vr(s.r, s.g, s.b, s.a) : l.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new vr(o.r, o.g, o.b, o.a);
    if (!c.equals(u)) return {
        update: (h)=>{
            l.lerpColors(c, u, h);
            let d = we.lerp(c.a, u.a, h);
            l.a = d, t[n1] = {
                r: l.r,
                g: l.g,
                b: l.b,
                a: l.a
            };
        },
        start: ()=>{
            l.copy(c);
        },
        end: ()=>{
            l.copy(u);
        }
    };
}
function Yo(n1, t, e, r, i) {
    if (typeof t[n1] == "number") return Zr(n1, t, e ?? {}, r, i);
    if (Array.isArray(t[n1])) return ng(n1, t, e ?? {}, r, i);
}
function uN(n1, t, e, r) {
    let i = [], s = n1.cameraType === "OrthographicCamera" ? t.orthographic?.zoom : t.perspective?.zoom, o = n1.cameraType === "OrthographicCamera" ? e.orthographic?.zoom : e.perspective?.zoom;
    if (o !== void 0) {
        let a = s ?? n1.zoom, l = o;
        a !== l && i.push({
            update: (c)=>{
                n1.zoom = we.lerp(a, l, c), n1.updateProjectionMatrix();
            },
            start: ()=>{
                n1.zoom = a, n1.updateProjectionMatrix();
            },
            end: ()=>{
                n1.zoom = l, n1.updateProjectionMatrix();
            }
        });
    }
    if (e.targetOffset !== void 0) {
        let a = Zr("targetOffset", n1, t, e, r);
        a && i.push(a);
    }
    return i;
}
function uJ(n1, t, e, r) {
    if (e.scaleBaked === void 0) return;
    let i = (t.scaleBaked ?? n1.data.geometry.scaleBaked).map((a)=>typeof a == "string" ? Number(r.getVariable(a) ?? 0) : a), s = e.scaleBaked.map((a)=>typeof a == "string" ? Number(r.getVariable(a) ?? 0) : a);
    if (Mo.isEqual(i, s)) return;
    let o = [];
    return o.push({
        update: (a)=>{
            n1.updateGeometryInteractions({
                scaleBaked: [
                    we.lerp(i[0], s[0], a),
                    we.lerp(i[1], s[1], a),
                    we.lerp(i[2], s[2], a)
                ]
            }, r), n1.invalidateDownstreamBooleanData(), n1.refreshAttachedClonersInteractions();
        },
        start: ()=>{
            n1.updateGeometryInteractions({
                scaleBaked: i
            }, r), n1.invalidateDownstreamBooleanData(), n1.refreshAttachedClonersInteractions();
        },
        end: ()=>{
            n1.updateGeometryInteractions({
                scaleBaked: s
            }, r), n1.invalidateDownstreamBooleanData(), n1.refreshAttachedClonersInteractions();
        }
    }), o;
}
function hJ(n1, t, e, r) {
    if (!e.extrusion) return;
    let i = n1.extrusion, s = t.extrusion ?? {}, o = e.extrusion, a = [];
    return zA.forEach((l)=>{
        let c = Yo(l, i, s, o, r);
        c && a.push(c);
    }), a;
}
function hN(n1, t, e, r) {
    let i = [];
    if (!("geometry" in e)) return i;
    let s = n1.geometry.userData.parameters, o = "geometry" in t ? t.geometry : {}, a = e.geometry;
    if (n1 instanceof Zs) {
        let l = uJ(n1, o, a, r);
        l && i.push(...l);
    } else {
        let l = {};
        if (Object.assign(l, Pn(s, Kv), Pn(o, Kv)), Kv.forEach((c)=>{
            let u = Yo(c, l, o, a, r);
            u && i.push(u);
        }), n1 instanceof $l) {
            Object.assign(l, {
                extrusion: {
                    ...s.extrusion
                }
            });
            let c = hJ(l, o, a, r);
            c && i.push(...c);
        }
        i.length && i.push({
            update: (c)=>{
                n1.updateGeometryInteractions(l, r), n1.updateGeometryGroupsIfNeeded(), n1.refreshAttachedClonersInteractions();
            },
            start: (c)=>{
                n1.updateGeometryInteractions(l, r), n1.updateGeometryGroupsIfNeeded(), n1.refreshAttachedClonersInteractions();
            },
            end: (c)=>{
                n1.updateGeometryInteractions(l, r), n1.updateGeometryGroupsIfNeeded(), n1.refreshAttachedClonersInteractions();
            }
        });
    }
    return i;
}
function dN(n1, t, e, r) {
    let i = [];
    if (e.intensity !== void 0) {
        let s = Zr("intensity", n1, t, e, r);
        s && i.push(s);
    }
    if (e.color !== void 0) {
        let s = cN("color", n1, t, e, r);
        s && i.push(s);
    }
    return i;
}
function pN(n1, t, e, r) {
    let i = [];
    if (Array.isArray(n1.material)) {
        if (!("materials" in e && e.materials)) return i;
        let s = "materials" in t && t.materials ? t.materials : [], o = e.materials;
        n1.material.forEach((a, l)=>{
            if (!o[l]) return;
            let c = s[l] ?? {}, u = o[l];
            typeof c == "string" || typeof u == "string" || i.push(...fN(a, c, u, r));
        });
    } else {
        if (!("material" in e && e.material)) return i;
        let s = "material" in t && t.material ? t.material : {}, o = e.material;
        if (typeof s == "string" || typeof o == "string") return i;
        i.push(...fN(n1.material, s, o, r));
    }
    return i;
}
function fN(n1, t, e, r) {
    let i = [], s = Kc(e, r) || !!t.layers && Kc(t, r);
    i.push(bJ(n1, s));
    for (let o of n1.layers){
        let a = t.layers?.data(o.uuid), l = e.layers.data(o.uuid);
        if (!l || o.type !== "light" && (!(o.visible ?? !0) || !(l.visible ?? !0))) continue;
        let c = o.getNames().filter((u)=>!Wv.some((h)=>u.includes(h)));
        for (let u of c)try {
            let h = o.getValue(u), d;
            if (u === "colors") d = vJ(o, a, l, u);
            else if (Array.isArray(h)) u === "steps" && (d = yJ(o, a, l, u));
            else if (typeof h == "number") d = dJ(o, a, l, u, r);
            else {
                if (typeof h == "boolean") continue;
                h instanceof k ? d = fJ(o, a, l, u) : h instanceof E ? d = pJ(o, a, l, u, r) : h instanceof vr ? d = gJ(o, a, l, u, r) : h instanceof We ? d = mJ(o, a, l, u, r) : "isTexture" in h && (d = xJ(o, a, l, u));
            }
            d && (Array.isArray(d) ? i.push(...d) : i.push(d));
        } catch (h) {
            console.error(`lerpMaterial: unexpected material layer for ${u}`, h);
        }
    }
    return i;
}
function dJ(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = t ? t[r] : n1.getValue(r), o = e[r], a = typeof s == "string" ? Number(i.getVariable(s) ?? 0) : s, l = typeof o == "string" ? Number(i.getVariable(o) ?? 0) : o;
    if (a !== l) return {
        update: (c)=>{
            n1.setValue(r, we.lerp(a, l, c));
        },
        start: ()=>{
            n1.setValue(r, a);
        },
        end: ()=>{
            n1.setValue(r, l);
        }
    };
}
function fJ(n1, t, e, r) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = n1.getValue(r), s = t ? new k().fromArray(t[r]) : i.clone(), o = new k().fromArray(e[r]);
    if (!s.equals(o)) return {
        update: (a)=>{
            i.lerpVectors(s, o, a);
        },
        start: ()=>{
            i.copy(s);
        },
        end: ()=>{
            i.copy(o);
        }
    };
}
function pJ(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = n1.getValue(r), o = t ? t[r] : void 0, a = e[r], l = o ? ig(new E, o, i) : s.clone(), c = ig(new E, a, i);
    if (!l.equals(c)) return {
        update: (u)=>{
            s.lerpVectors(l, c, u);
        },
        start: ()=>{
            s.copy(l);
        },
        end: ()=>{
            s.copy(c);
        }
    };
}
function mJ(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = t ? t[r] : void 0, o = e[r], a = n1.getValue(r), l = s ? typeof s == "string" ? i.getColor(s).clone() : new We().setRGB(s.r, s.g, s.b) : a.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new We().setRGB(o.r, o.g, o.b);
    if (l.equals(c)) return;
    let u = a.clone();
    return {
        update: (h)=>{
            n1.getValue(r) !== u && n1.setValue(r, u), u.lerpColors(l, c, h);
        },
        start: ()=>{
            u.copy(l);
        },
        end: ()=>{
            u.copy(c);
        }
    };
}
function gJ(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = t ? t[r] : void 0, o = e[r], a = n1.getValue(r), l = s ? typeof s == "string" ? i.getColor(s).clone() : new We().setRGB(s.r, s.g, s.b) : a.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new vr(o.r, o.g, o.b, o.a);
    if (l.equals(c)) return;
    let u = a.clone();
    return {
        update: (h)=>{
            n1.getValue(r) !== u && n1.setValue(r, u), u.lerpColors(l, c, h);
        },
        start: ()=>{
            u.copy(l);
        },
        end: ()=>{
            u.copy(c);
        }
    };
}
function yJ(n1, t, e, r = "steps") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = [], s = n1.getValue(r), o = t ? t[r] : s, a = e[r];
    return Dc(o, a) || i.push({
        update: (l)=>{
            let c = [
                ...s
            ];
            for(let u = 0; u < s.length; ++u){
                let h = o[u], d = a[u];
                c[u] = we.lerp(h, d, l);
            }
            n1.setValue(r, c);
        },
        start: ()=>{
            n1.setValue(r, o);
        },
        end: ()=>{
            n1.setValue(r, a);
        }
    }), i.length ? i : void 0;
}
function vJ(n1, t, e, r = "colors") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = [], s = n1.getValue(r), o = t ? t[r] : s.map((l)=>l.toArray()), a = e[r];
    for(let l = 0; l < s.length; ++l){
        let c = [
            ...o[l]
        ], u = [
            ...a[l]
        ];
        Wp.isEqual(c, u) || i.push({
            update: (h)=>{
                s[l].fromArray(Wp.lerp(c, u, h));
            },
            start: ()=>{
                s[l].fromArray(c);
            },
            end: ()=>{
                s[l].fromArray(u);
            }
        });
    }
    return i.length ? i : void 0;
}
function xJ(n1, t, e, r = "texture") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = n1.getNode("rotation"), s = t?.[r]?.rotation ?? 0, o = e[r]?.rotation ?? 0;
    if (i && s !== o) return {
        update: (g)=>{
            i.value = we.lerp(s, o, g) * we.DEG2RAD;
        },
        start: ()=>{
            i.value = s * we.DEG2RAD;
        },
        end: ()=>{
            i.value = o * we.DEG2RAD;
        }
    };
    let a = n1.getNode("mat");
    if (!a) return;
    let l = t ? t[r] : a, c = e[r], u = [
        ...l.repeat
    ], h = [
        ...l.offset
    ], d = [
        ...c.repeat
    ], f = [
        ...c.offset
    ], p = l.rotation ?? 0, m = c.rotation ?? 0;
    if (!Vs.isEqual(u, d) || !Vs.isEqual(h, f) || p !== m) return {
        update: (g)=>{
            a.repeat = Vs.lerp(u, d, g), a.offset = Vs.lerp(h, f, g), a.rotation = we.lerp(p, m, g), a.updateMatrix();
        },
        start: ()=>{
            a.repeat = [
                ...u
            ], a.offset = [
                ...h
            ], a.rotation = p, a.updateMatrix();
        },
        end: ()=>{
            a.repeat = [
                ...d
            ], a.offset = [
                ...f
            ], a.rotation = m, a.updateMatrix();
        }
    };
}
function bJ(n1, t) {
    return {
        update: ()=>{
            n1.transparent = t;
        }
    };
}
var BT = new E, mN = new nr;
function gN(n1, t, e, r, i) {
    let s = [], o, a, l, c, u, h, d, f;
    if (n1 instanceof rr ? (o = Nf("position", n1, t, e, i), o && s.push(o), l = Zr("rotation", n1, t, e, i), l && s.push(l), c = Nf("shear", n1, t, e, i), c && s.push(c)) : (f = {
        slide: t.pathSnapping?.slide ?? n1.updatedPathSnapping?.slide ?? n1.dataPatched.pathSnapping?.slide ?? 0,
        offset: t.pathSnapping?.offset ?? n1.updatedPathSnapping?.offset ?? n1.dataPatched.pathSnapping?.offset ?? 0
    }, h = Zr("slide", f, t.pathSnapping ?? n1.updatedPathSnapping ?? n1.dataPatched.pathSnapping, e.pathSnapping ?? n1.dataPatched.pathSnapping, i), h && s.push(h), d = Zr("offset", f, t.pathSnapping ?? n1.updatedPathSnapping ?? n1.dataPatched.pathSnapping, e.pathSnapping ?? n1.dataPatched.pathSnapping, i), d && s.push(d), !h && !d && (o = LT("position", n1, t, e, i), o && s.push(o), a = LT("scale", n1, t, e, i), a && s.push(a), l = SJ(n1, t, e, r, i), l && s.push(l), u = lN("hiddenMatrix", n1, t, e), u && s.push(u))), o || a || l || u || h || d) {
        let p = n1 instanceof rr ? ()=>{
            n1.updateWorldMatrix(!0, !1, !0), n1.resetBBoxNeedsUpdate();
        } : ()=>{
            n1.updateMatrix(), n1.hasNonUniformScale && (n1.updateMatrixWorld(), n1.updateMatrixWorldSVD()), n1.parent?.matrixWorldFusedFalse && (n1.matrixWorld.multiplyMatrices(n1.parent.matrixWorldFusedFalse, n1.matrix), n1.matrixWorldNeedsUpdate = !1), cn(n1) && En(n1.parent) && n1.invalidateDownstreamBooleanData(!0), n1.updatePathSnapping(Object.assign({}, t.pathSnapping, f));
        };
        s.push({
            update: p,
            start: p,
            end: p
        });
    }
    return s;
}
function SJ(n1, t, e, r, i) {
    let s = t?.rotation ? t.rotation.map((u)=>(typeof u == "string" ? Number(i.getVariable(u) ?? 0) : u) * we.DEG2RAD) : void 0, o = e.rotation?.map((u)=>(typeof u == "string" ? Number(i.getVariable(u) ?? 0) : u) * we.DEG2RAD);
    if (!o) return;
    let a = s ? new E().fromArray(s) : new E().setFromEuler(n1.rotation), l = new E().fromArray(o);
    if (a.equals(l)) return;
    let c = BT.subVectors(l, a);
    if (r && c.toArray().every((u)=>Math.abs(u) < 2 * Math.PI)) {
        let u = new Ke().setFromEuler(mN.setFromVector3(a)), h = new Ke().setFromEuler(mN.setFromVector3(l));
        return {
            update: (d)=>{
                aN(u, h, n1.quaternion, d);
            },
            start: ()=>{
                n1.rotation.setFromVector3(a);
            },
            end: ()=>{
                n1.rotation.setFromVector3(l);
            }
        };
    } else return {
        update: (u)=>{
            BT.lerpVectors(a, l, u), n1.rotation.setFromVector3(BT);
        },
        start: ()=>{
            n1.rotation.setFromVector3(a);
        },
        end: ()=>{
            n1.rotation.setFromVector3(l);
        }
    };
}
function yN(n1, t, e, r) {
    let i = [];
    if (!("cloner" in e) || !n1.cloner) return i;
    let s = n1.cloner, o = "cloner" in t ? t.cloner : {}, a = e.cloner;
    OA.forEach((f)=>{
        let p;
        f === "count" ? p = Zr("count", s.parameters, o, a, r, !0) : p = Yo(f, s.parameters, o ?? {}, a, r), p && i.push(p);
    });
    let l = wJ(s, o, a, r);
    l?.length && i.push(...l);
    let c = AJ(s, o, a, r);
    c?.length && i.push(...c);
    let u = EJ(s, o, a, r);
    u?.length && i.push(...u);
    let h = TJ(s, o, a, r);
    h?.length && i.push(...h);
    let d = MJ(s, o, a, r);
    return d?.length && i.push(...d), i.length && i.push({
        update: ()=>{
            s.update();
        }
    }), i;
}
function wJ(n1, t, e, r) {
    if (n1.parameters.type !== "radial") return;
    let i = t.radial, s = e.radial;
    if (!s) return;
    let o = n1.parameters.radial, a = [];
    return RA.forEach((l)=>{
        let c = Yo(l, o, i ?? {}, s, r);
        c && a.push(c);
    }), a;
}
function AJ(n1, t, e, r) {
    if (n1.parameters.type !== "linear") return;
    let i = t.linear, s = e.linear;
    if (!s) return;
    let o = [], a = n1.parameters.linear;
    return LA.forEach((l)=>{
        let c = Yo(l, a, i ?? {}, s, r);
        c && o.push(c);
    }), o;
}
function EJ(n1, t, e, r) {
    if (n1.parameters.type !== "grid") return;
    let i = t.grid, s = e.grid;
    if (!s) return;
    let o = [], a = n1.parameters.grid;
    return BA.forEach((l)=>{
        let c;
        l === "count" ? c = ng(l, a, i ?? {}, s, r, !0) : c = Yo(l, a, i ?? {}, s, r), c && o.push(c);
    }), o;
}
function TJ(n1, t, e, r) {
    if (n1.parameters.type !== "toObject") return;
    let i = t.toObject, s = e.toObject;
    if (!s) return;
    let o = [], a = n1.parameters.toObject;
    return NA.forEach((l)=>{
        let c;
        l === "count" ? c = Zr(l, a, i ?? {}, s, r, !0) : c = Yo(l, a, i ?? {}, s, r), c && o.push(c);
    }), o;
}
function MJ(n1, t, e, r) {
    if (!n1.parameters.randomness) return;
    let i = t.randomnessObject, s = e.randomnessObject;
    if (!s) return;
    let o = [], a = n1.parameters.randomnessObject;
    return FA.forEach((l)=>{
        let c = Yo(l, a, i ?? {}, s, r);
        c && o.push(c);
    }), o;
}
function CJ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.fill.enabled = t);
        }
    };
}
function PJ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.stroke.enabled = t);
        }
    };
}
function _J(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.dropShadow.enabled = t);
        }
    };
}
function IJ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.innerShadow.enabled = t);
        }
    };
}
function DJ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.backgroundBlur.enabled = t);
        }
    };
}
function OJ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.layerBlur.enabled = t);
        }
    };
}
function vN(n1, t, e, r, i) {
    let s = [], o, a, l, c, u, h, d, f, p, m, g, y, x, v, S;
    if ("width" in n1 && (o = Zr("width", n1, t, e, i), o && s.push(o)), "height" in n1 && (a = Zr("height", n1, t, e, i), a && s.push(a)), n1 instanceof Ar || n1 instanceof Ji) {
        let w = {
            ...t.fill
        }, A = {
            ...e.fill
        };
        w.enabled !== void 0 && w.enabled !== A.enabled && (s.push(CJ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), l = sg("color", n1.fill, w, A, i), l && s.push(l);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.stroke
        }, A = {
            ...e.stroke
        };
        (w.enabled || A.enabled) && (s.push(PJ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), c = sg("color", n1.stroke, w, A, i), c && s.push(c), u = Zr("thickness", n1.stroke, w, A, i), u && s.push(u);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.dropShadow
        }, A = {
            ...e.dropShadow
        };
        (w.enabled || A.enabled) && (s.push(_J(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), h = sg("color", n1.dropShadow, w, A, i), h && s.push(h), d = Zr("blurRadius", n1.dropShadow, w, A, i), d && s.push(d), p = Zr("spread", n1.dropShadow, w, A, i), p && s.push(p), f = Nf("offset", n1.dropShadow, w, A, i), f && s.push(f);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.innerShadow
        }, A = {
            ...e.innerShadow
        };
        (w.enabled || A.enabled) && (s.push(IJ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), m = sg("color", n1.innerShadow, w, A, i), m && s.push(m), g = Zr("blurRadius", n1.innerShadow, w, A, i), g && s.push(g), x = Zr("spread", n1.innerShadow, w, A, i), x && s.push(x), y = Nf("offset", n1.innerShadow, w, A, i), y && s.push(y);
    }
    if (n1 instanceof Ar || n1 instanceof Ji) {
        let w = {
            ...t.backgroundBlur
        }, A = {
            ...e.backgroundBlur
        };
        (w.enabled || A.enabled) && (s.push(DJ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            radius: 0
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            radius: 0
        })), v = Zr("radius", n1.backgroundBlur, w, A, i), v && s.push(v);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.layerBlur
        }, A = {
            ...e.layerBlur
        };
        (w.enabled || A.enabled) && (s.push(OJ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            radius: 0
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            radius: 0
        })), S = Zr("radius", n1.layerBlur, w, A, i), S && s.push(S);
    }
    if (n1 instanceof Ji || n1 instanceof Es) {
        let w = ng("cornerRadius", n1, t, e, i);
        w && s.push(w);
    }
    return s;
}
function NT(n1, t, e, r, i) {
    let s = [];
    return n1.data.visible && s.push(...gN(n1, t, e, i, r)), n1 instanceof rr ? s.push(...vN(n1, t, e, i, r)) : (n1.data.visible && s.push(...yN(n1, t, e, r)), cn(n1) ? (n1 instanceof cr && n1.data.visible && s.push(...hN(n1, t, e, r)), n1.data.visible && s.push(...pN(n1, t, e, r))) : P3(n1) ? n1.data.visible && s.push(...dN(n1, t, e, r)) : C3(n1) && s.push(...uN(n1, t, e, r))), s.length ? {
        update: (o)=>{
            s.forEach((a)=>a.update(o));
        },
        start: (o)=>{
            s.forEach((a)=>a.start?.(o));
        },
        end: (o)=>{
            s.forEach((a)=>a.end?.(o));
        }
    } : void 0;
}
var xN = new E;
function Bf(n1, t, e = !1) {
    let r = [], i = (s)=>{
        let o = s.data;
        delete s.states, s.currentState = null, s.reversibleToState = null, s.currentTransitionEvent = null;
        for (let a of o.states){
            let l = {
                ...a.data
            };
            s.states || (s.states = {}), s.states[a.id] = Ea.patch(o, l);
        }
        SN(n1.scene, s, null, t, o.events.find((a)=>a.data.type === "Follow" || a.data.type === "LookAt") !== void 0), bN(n1);
    };
    n1.scene.traverse2D(i), n1.traverseChildren((s)=>{
        if (e && (s.rigidBody?.setTranslation(s.position0, !0), s.rigidBody?.setRotation(s.rotation0, !0), s.rigidBody?.setLinvel(xN, !0), s.rigidBody?.setAngvel(xN, !0)), !yt.is(s)) return;
        let o = s.uuid, a = s.data;
        if (delete s.states, s.uuid === hs) return;
        let l = !1;
        r.some((c)=>n1.scene.find(o)?.isDescendantOf(c)) ? l = !0 : a.physics?.fusedBody === !0 && a.physics.rigidBody === "dynamic" && r.push(o), s.data = a, s.currentState = null, s.reversibleToState = null, s.currentTransitionEvent = null;
        for (let c of a.states){
            let u = {
                ...c.data
            };
            n1.data.globalPhysics.usePhysics === !0 && a.physics && (a.physics.rigidBody === "dynamic" || l) && (c.data.position !== void 0 && delete u.position, c.data.rotation !== void 0 && delete u.rotation, c.data.hiddenMatrix !== void 0 && delete u.hiddenMatrix), s.states || (s.states = {}), s.states[c.id] = xa.patch(a, u);
        }
        SN(n1.scene, s, null, t, a.events.find((c)=>c.data.type === "Follow" || c.data.type === "LookAt") !== void 0), s instanceof Er && s.frame && (s.frame.traverse((c)=>i(c)), s.uiCanvas?.applySize());
    }), bN(n1), n1.frame && (n1.frame.traverse((s)=>i(s)), n1.uiCanvas?.applySize());
}
function bN(n1) {
    n1.traverseEntity((t)=>{
        for (let e of t.data.events){
            let r = [];
            switch(e.data.type){
                case "Follow":
                case "MouseHover":
                case "Scroll":
                case "MouseDown":
                case "MouseUp":
                case "MousePress":
                case "KeyUp":
                case "KeyDown":
                case "KeyPress":
                case "Collision":
                    r.push(...e.data.actions);
                    break;
                case "GameControl":
                    for (let i of Object.values(e.data.gameActions))r.push(...i);
                    break;
                case "DragDrop":
                    r.push(...e.data.dragDropActions.drag, ...e.data.dragDropActions.drop);
                    break;
                case "Conditional":
                    r.push(...e.data.inActions, ...e.data.outActions);
                    break;
            }
            for (let i of r)if (i.data.type === "Create" && i.data.hideBase === "Yes") {
                let s = n1.scene.find(i.data.object);
                s && (s.visible = !1);
            }
        }
    });
}
function SN(n1, t, e, r, i = !1) {
    if (t instanceof cr && t.removeInteractionGeometry(r), t instanceof rr ? t.changeSelectedState(e, {
        shared: r
    }, i) : t.changeSelectedState(e, {
        scene: n1,
        shared: r
    }, i), t instanceof cr && t.updateGeometryGroupsIfNeeded(), t instanceof wr && t.updateCameraState(t.dataPatched, {
        scene: n1,
        shared: r
    }), !(t instanceof rr)) {
        if (t.cloner) for (let s of t.cloner.children)s.playModeVisible = void 0;
        t.updateVisible();
    }
}
function VT(n1) {
    let t;
    if (n1.easing === 5) {
        let { control1: e, control2: r } = n1;
        t = `cubicBezier(
			${e[0]}, ${e[1]}, ${r[0]}, ${r[1]}
		)`;
    } else if (n1.easing === 6) {
        let { mass: e, stiffness: r, damping: i, velocity: s } = n1;
        t = `spring( ${e}, ${r}, ${i}, ${s} )`;
    } else {
        let e;
        switch(n1.easing){
            case 0:
                e = ga.linear;
                break;
            case 1:
                e = ga.ease;
                break;
            case 2:
                e = ga.easeIn;
                break;
            case 3:
                e = ga.easeOut;
                break;
            case 4:
                e = ga.easeInOut;
                break;
            default:
                e = ga.linear;
        }
        let [r, i, s, o] = e;
        t = `cubicBezier( ${r}, ${i}, ${s}, ${o} )`;
    }
    return {
        duration: Math.max(n1.duration, 1e-4),
        easing: t
    };
}
function FT(n1) {
    let t = {
        delay: 0,
        loop: n1.repeat === -1 ? !0 : n1.repeat + 1
    };
    if (n1.repeat === 0) t.direction = "normal", t.rewind = !1;
    else switch(n1.direction){
        case "pingpong":
            t.direction = "alternate", t.rewind = !1;
            break;
        case "pingpong-rewind":
            t.direction = "alternate", t.rewind = !0;
            break;
        default:
            t.direction = "normal", t.rewind = !1;
            break;
    }
    switch(t.delay = 0, t.endDelay = 0, t.startOnceDelay = 0, t.pingPongDelayCorrection = 0, t.pingPongEndDelayCorrection = 0, n1.delayDirection){
        case "start-once":
            t.startOnceDelay = n1.delay;
            break;
        case "start":
            t.delay = n1.delay;
            break;
        case "end":
            t.endDelay = n1.delay;
            break;
        case "start-end":
        case void 0:
            t.delay = n1.delay, t.endDelay = n1.delay;
            break;
    }
    return t.direction === "alternate" && (t.delay /= 2, t.endDelay /= 2, n1.delayDirection === "start" ? (t.pingPongDelayCorrection = t.delay, typeof t.loop == "number" && t.loop % 2 === 0 && (t.pingPongEndDelayCorrection = t.delay)) : n1.delayDirection === "end" ? typeof t.loop == "number" && t.loop % 2 !== 0 && (t.pingPongEndDelayCorrection = t.endDelay) : n1.delayDirection === "start-end" && (t.pingPongDelayCorrection = t.delay, t.pingPongEndDelayCorrection = t.endDelay)), t;
}
var RJ = {
    type: "beginState"
}, LJ = {
    type: "completeState",
    isfromEntity: !1
}, Eb = class {
    constructor(t, e, r, i, s, o){
        this.object = t;
        this.data = i;
        this.sharedAssets = s;
        this.allowSlerp = o;
        this.targets = {
            t: 0
        };
        this.firstLoop = !0;
        this._changeBegan = !1;
        this._changeCompleted = !0;
        this.onChange = ()=>{
            this.callback && (this.callback.update(this.targets.t), this.object.requestRender()), this.targets.t === 0 || this.targets.t === 1 ? this._changeCompleted || (this._changeCompleted = !0, this._changeBegan = !1, this.onChangeComplete()) : (this._changeCompleted && (this._changeCompleted = !1), this._changeBegan || (this._changeBegan = !0, this.onChangeBegin()));
        };
        this.onChangeBegin = ()=>{
            this.object.reversibleToState = this.to.id;
            let t = this.targets.t > .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "beginState",
                state: t
            }), this.object instanceof rr || this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof wr && e.dispatchEvent(RJ);
            });
        };
        this.onChangeComplete = ()=>{
            this.firstLoop && (this.onFirstLoop(), this.firstLoop = !1), this.object.reversibleToState = this.to.id;
            let t = this.targets.t < .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "completeState",
                state: t
            }), this.object instanceof rr || this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof wr && e.dispatchEvent(LJ);
            });
        };
        this.onFirstLoop = ()=>{
            this.useCurrentState && (this.callback = NT(this.object, this.from.data, this.to.data, this.sharedAssets, this.allowSlerp));
        };
        if (e === void 0) {
            let a = Ab(this.object, this.object.currentState === r ? this.object.prevState : this.object.currentState);
            if (!a) throw new Error("Missing property");
            this.from = a;
        } else {
            let a = Ab(this.object, e);
            if (!a) throw new Error("Missing property");
            this.from = a;
        }
        if (r === void 0) throw new Error("Missing property");
        {
            let a = Ab(this.object, r);
            if (!a) throw new Error("Missing property");
            this.to = a;
        }
        this.useCurrentState = e === void 0 || r === void 0, this.params = {
            targets: this.targets,
            t: 1,
            autoplay: !1,
            ...FT(i),
            ...VT(i),
            change: this.onChange
        }, this.callback = NT(this.object, e === void 0 ? {} : this.from.data, r === void 0 ? {} : this.to.data, this.sharedAssets, this.allowSlerp);
    }
    get changeBegan() {
        return this._changeBegan;
    }
    get changeCompleted() {
        return this._changeCompleted;
    }
}, og = class extends pr {
    constructor(e, r, i, s, o){
        super();
        this.eventType = e;
        this.data = r;
        this.page = i;
        this.shared = s;
        this.condition = o;
        this.toggleIsForward = !1;
        this.timelineNeedsRebuild = !1;
        this.hasPlayedOnce = !1;
        this.onTimelineChangeComplete = ()=>{
            this.data.tweens[0].data.direction !== "normal" && (this.toggleIsForward = !this.toggleIsForward), this.timelineNeedsRebuild !== !1 && (this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward,
                needsRebuild: !1,
                isRebuild: !0
            }), this.timeline.play());
        };
        if (!r.object) throw new Error("Missing property");
        let a = this.page.scene.find(r.object) ?? this.page.uiCanvas?.find(r.object) ?? this.page.scene.find2DInUIObjects(r.object);
        if (!a) throw new Error("Missing property");
        if (!a.states) throw new Error("Missing property");
        if (this.object = a, r.tweens.length < 2) throw new Error("Missing property");
        this.tweens = Array(this.data.tweens.length - 1), this.startOnceDelay = r.tweens[0].data.delayDirection === "start-once" ? r.tweens[0].data.delay : 0, this.init();
    }
    get playing() {
        return this.timeline?.paused === !1;
    }
    get changeBegan() {
        return this.tweens.some((e)=>e.changeBegan) ?? !1;
    }
    init() {
        this.initialCurrentState = Ab(this.object, this.object.currentState).id, this.toggleIsForward = !1;
    }
    get currentState() {
        return this.data.runMode === "Toggle" && IA(this.eventType) ? this.initialCurrentState : this.object.currentState;
    }
    buildTimeline({ isForward: e = !0, needsRebuild: r = !1, isRebuild: i = !1 } = {}) {
        try {
            let s = FT(this.data.tweens[0].data);
            i && typeof s.loop == "number" && s.loop--, this.timeline?.pause(), this.timeline = wb.timeline({
                autoplay: !1,
                ...s,
                ...s.loop === !0 || s.loop > 1 ? {
                    timelineChangeComplete: this.onTimelineChangeComplete
                } : {}
            });
            let o = this.tweens.findIndex((a)=>a?.changeBegan);
            if (r === !0 && (this.timelineNeedsRebuild = !0), e) {
                let a = o === -1 ? 0 : o;
                for(let l = a; l < this.data.tweens.length - 1; l++){
                    let c = this.data.tweens[l], u = this.data.tweens[l + 1], h;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.changeBegan === !0) ? (h = void 0, this.object instanceof wr && (this.object.wasMovedByUser = !1)) : h = c.data.state === void 0 ? this.currentState : c.data.state;
                    let d = new Eb(this.object, h, u.data.state === void 0 ? this.currentState : u.data.state, u.data, this.shared, this.data.allowSlerp ?? !1);
                    o !== -1 && l === a && Object.assign(d.params, {
                        startOnceDelay: 0
                    }), this.tweens[l] = d, this.timeline.add(d.params, this.timeline.duration + (l === a ? s.delay : 0));
                }
                this.timeline.duration += s.endDelay;
            } else {
                let a = o === -1 ? this.data.tweens.length - 1 : o + 1;
                for(let l = a; l > 0; l--){
                    let c = this.data.tweens[l], u = this.data.tweens[l - 1], h;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.changeBegan === !0) ? (h = void 0, this.object instanceof wr && (this.object.wasMovedByUser = !1)) : h = c.data.state === void 0 ? this.currentState : c.data.state;
                    let d = new Eb(this.object, h, u.data.state === void 0 ? this.currentState : u.data.state, c.data, this.shared, this.data.allowSlerp ?? !1);
                    o !== -1 && l === a && Object.assign(d.params, {
                        startOnceDelay: 0
                    }), this.tweens[l - 1] = d, this.timeline.add(d.params, this.timeline.duration + (l === a ? s.endDelay : 0));
                }
                this.timeline.duration += s.delay;
            }
        } catch (s) {
            s instanceof Error && console.error(s.message);
        }
        this.object.previousAction?.playing === !0 && this.object.previousAction.pause(), this.object.previousAction = this;
    }
    play() {
        if (wt(this.shared, this.condition) === !1 || IA(this.eventType) && this.data.runMode === "Once" && this.hasPlayedOnce || (this.hasPlayedOnce = !0, this.playing)) return !1;
        clearTimeout(this.timeoutId);
        let e = FT(this.data.tweens[0].data).pingPongDelayCorrection;
        this.timeoutId = window.setTimeout(()=>{
            try {
                this.buildTimeline(), this.timeline.play();
            } catch (r) {
                r instanceof Error && console.error(r.message);
            }
        }, this.startOnceDelay + e);
    }
    pause() {
        this.timeline?.pause(), clearTimeout(this.timeoutId), this.tweens = Array(this.data.tweens.length - 1), delete this.timeoutId;
    }
    stop() {
        this.pause();
        let e = this.data.tweens[0].data.state === void 0 ? this.initialCurrentState : this.data.tweens[0].data.state;
        this.object instanceof rr ? this.object.changeSelectedState(e, {
            shared: this.shared
        }) : this.object.changeSelectedState(e, {
            scene: this.page.scene,
            shared: this.shared
        }), this.object.currentState = e;
    }
    seek(e) {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.timeline === void 0 && this.buildTimeline(), this.timeline?.seek(e * this.timeline.duration, !0);
    }
    toggle(e) {
        if (wt(this.shared, this.condition) === !1) return !1;
        clearTimeout(this.timeoutId), this.toggleIsForward = e ?? !this.toggleIsForward, this.playing ? (this.timeline?.pause(), this.buildTimeline({
            isForward: this.toggleIsForward,
            needsRebuild: !0
        }), this.timeline.play()) : this.timeoutId = window.setTimeout(()=>{
            this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward
            }), this.timeline.play();
        }, this.startOnceDelay);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause();
    }
};
function Ab(n1, t) {
    let e, r;
    if (typeof t == "string" ? (e = t, r = n1.states?.[e]) : t === null && (e = null, r = n1.data), !(e === void 0 || r === void 0)) return {
        id: e,
        data: r
    };
}
var BJ = {
    type: "beginState"
}, wN = {
    type: "completeState",
    isfromEntity: !1
}, AN = {
    type: "requestRender"
}, ag = class extends pr {
    constructor(e, r, i, s){
        super();
        this.data = e;
        this.page = r;
        this.shared = i;
        this.condition = s;
        this.toggleIsForward = !1;
        this.posStart = new E;
        this.posEnd = new E;
        this.qStart = new Ke;
        this.qEnd = new Ke;
        this.zoomStart = 1;
        this.zoomEnd = 1;
    }
    init() {}
    get playing() {
        return this.animation && this.animation.began && !this.animation.completed;
    }
    buildAnimation(e = !1) {
        if (!this.data.animate) return;
        let r = this.page.scene.find(this.data.targetCamera);
        if (!r || !r.visible) throw new ReferenceError("Target camera not founded or not visible");
        let i = {
            t: 0
        };
        this.posStart.copy(this.page.activeCamera.position), this.qStart.copy(this.page.activeCamera.quaternion), this.zoomStart = this.page.activeCamera.zoom, this.animation = wb({
            targets: i,
            t: 1,
            ...VT(this.data),
            update: ()=>{
                i.t === 0 && (this.data.runMode === "Toggle" && !this.toggleIsForward ? this.fromCamera && (this.posEnd.copy(this.fromCamera.position), this.qEnd.copy(this.fromCamera.quaternion), this.zoomEnd = this.fromCamera.zoom, this.switchCamera(this.fromCamera.uuid)) : (this.posEnd.copy(r.position), this.qEnd.copy(r.quaternion), this.zoomEnd = r.zoom, this.fromCamera = this.page.activeCamera, this.switchCamera(r.uuid)), this.page.activeCamera.dispatchEvent(BJ));
                let s = this.page.activeCamera;
                s.position.lerpVectors(this.posStart, this.posEnd, i.t), s.quaternion.slerpQuaternions(this.qStart, this.qEnd, i.t), s.zoom = this.zoomStart + (this.zoomEnd - this.zoomStart) * i.t, s.wasMovedBySwitchCameraAction = !0, s.updateMatrix(), s.updateMatrixWorld(), s.updateProjectionMatrix(), s.dispatchEvent(AN), i.t === 1 && s.dispatchEvent(wN);
            }
        });
    }
    switchCamera(e) {
        let r = this.page.activeCamera, i = this.page.scene.find(e);
        if (!i || !i.visible) throw new ReferenceError("Target camera not founded or not visible");
        this.page.switchActiveCamera(i), r.dispatchEvent({
            type: "cameraChange",
            camera: i
        });
    }
    play() {
        if (wt(this.shared, this.condition) === !1) return !1;
        if (!this.playing && this.page.activeCamera.uuid !== this.data.targetCamera) try {
            clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
                delete this.timeoutId, this.data.animate ? (this.buildAnimation(), this.animation?.play()) : this.switchCamera(this.data.targetCamera);
            }, this.data.delay * 1e3);
        } catch  {}
    }
    pause() {
        this.animation?.pause(), clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    toggle(e) {
        if (wt(this.shared, this.condition) === !1) return !1;
        if (window.clearTimeout(this.timeoutId), delete this.timeoutId, e !== this.toggleIsForward) try {
            this.playing ? (this.animation?.pause(), this.toggleIsForward = e ?? !this.toggleIsForward, this.buildAnimation(!0), this.animation?.play()) : this.timeoutId = window.setTimeout(()=>{
                this.toggleIsForward = e ?? !this.toggleIsForward, this.data.animate ? (this.animation?.pause(), this.buildAnimation(), this.animation?.play()) : (this.toggleIsForward ? (this.fromCamera = this.page.activeCamera, this.switchCamera(this.data.targetCamera)) : this.fromCamera && this.switchCamera(this.fromCamera.uuid), this.page.activeCamera.dispatchEvent(wN), this.page.activeCamera.dispatchEvent(AN));
            }, this.data.delay * 1e3);
        } catch  {}
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause(), this.toggleIsForward = !1;
    }
};
function kT(n1) {
    let t = n1?.tracks.filter((e)=>e.ValueTypeName === "vector" || e.ValueTypeName === "quaternion").map((e)=>e.times.length);
    if (t?.length) {
        let e = aA(t);
        return e && e > 2 ? e : 2;
    }
    return 2;
}
var lg = class extends pr {
    constructor(e, r, i, s, o){
        super();
        this.data = e;
        this.page = r;
        this.animationControls = i;
        this.shared = s;
        this.condition = o;
        this.startOnceDelay = 0;
        this.toggleIsForward = !1;
        let a = e.object, l = r.scene.find(e.object);
        l && Array.isArray(l.identity) && (a = l.identity[0]), this.data = {
            ...e,
            object: a
        };
        let c = this.animationControls.clipIdToAction[e.clipId + "/" + a];
        if (this.duration = c?.getClip()?.duration ?? 1, this.data.crop2) {
            let u = kT(c?.getClip());
            this.leftFrameTime = this.data.crop2[0] / (u - 1) * this.duration, this.rightFrameTime = this.data.crop2[1] / (u - 1) * this.duration;
        } else {
            let u = c?.getClip()?.tracks[0]?.times.length;
            u && u > 1 ? (this.leftFrameTime = this.data.crop[0] / u * this.duration, this.rightFrameTime = this.data.crop[1] / u * this.duration) : (this.leftFrameTime = 0, this.rightFrameTime = this.duration);
        }
        this.startOnceDelay = e.delay;
    }
    get playing() {
        return this.threeAnimAction?.isRunning() ?? !1;
    }
    play(e = !1) {
        if (wt(this.shared, this.condition) === !1) return !1;
        window.clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            if (this.threeAnimAction = this.animationControls.play(this.data), !this.threeAnimAction) return;
            this.threeAnimAction.reset(), this.threeAnimAction.time = this.leftFrameTime, this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime;
            let r = this.data.object;
            Object.entries(this.animationControls.clipIdToAction).forEach(([i, s])=>{
                let o = i.split("/")[1];
                this.threeAnimAction !== s && o === r && s.isRunning() && (e ? s.fadeOut(.2) : s.stop());
            }), e && this.threeAnimAction?.fadeIn(.2);
        }, this.startOnceDelay);
    }
    pause() {
        this.threeAnimAction && (this.threeAnimAction.paused = !0), window.clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    stop() {
        this.threeAnimAction?.fadeOut(.2);
    }
    seek(e) {
        this.threeAnimAction = this.animationControls.play(this.data), this.threeAnimAction && (this.threeAnimAction.paused = !0, this.threeAnimAction.time = we.clamp(this.threeAnimAction.time + 1 / 60 * e, this.leftFrameTime, this.rightFrameTime - 16e-5), this.animationControls.needsUpdate = !0, this.animationControls.requestRender());
    }
    toggle(e, r = !1) {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.toggleIsForward = e ?? !this.toggleIsForward, this.threeAnimAction && (this.threeAnimAction._loopCount = 0), this.playing ? this.threeAnimAction && (this.threeAnimAction.timeScale = this.toggleIsForward ? 1 : -1, this.toggleIsForward ? (this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime) : (this.threeAnimAction._clip.start = this.rightFrameTime, this.threeAnimAction._clip.duration = this.leftFrameTime)) : this.timeoutId = window.setTimeout(()=>{
            if (this.threeAnimAction = this.animationControls.play(this.data), this.threeAnimAction) {
                this.toggleIsForward ? (this.threeAnimAction.time = this.leftFrameTime, this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime) : (this.threeAnimAction.time = this.rightFrameTime, this.threeAnimAction._clip.start = this.rightFrameTime, this.threeAnimAction._clip.duration = this.leftFrameTime), this.threeAnimAction.paused = !1, this.threeAnimAction.timeScale = this.toggleIsForward ? 1 : -1;
                let i = this.data.clipId.split("/")[1];
                Object.entries(this.animationControls.clipIdToAction).forEach(([s, o])=>{
                    let a = s.split("/")[1];
                    this.threeAnimAction !== o && a === i && o.isRunning() && (r ? o.fadeOut(.2) : o.stop());
                }), r && this.threeAnimAction?.fadeIn(.2);
            }
        }, this.startOnceDelay);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        let e = this.animationControls.clipIdToAction[this.data.clipId + "/" + this.data.object]?.getClip();
        e && (e.duration = this.duration), this.pause();
    }
};
var cg = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.eventManager = r;
        this.shared = i;
        this.condition = s;
        this.timeOutId = -1;
        this.scene = e.scene;
    }
    dispatch() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.data.target !== this.page.uuid && (window.clearTimeout(this.timeOutId), this.timeOutId = window.setTimeout(()=>{
            this.play();
        }, this.data.delay * 1e3));
    }
    dispose() {
        window.clearTimeout(this.timeOutId);
    }
    play() {
        if (this.scene.children.every((r)=>r.uuid !== this.data.target || r.data.uiScene)) return;
        this.data.transition === "fade" && this.data.duration > 0 && this.eventManager.eventContext.renderer.renderFromSceneForSceneTransitionPass(this.scene, this.scene.activeCamera, this.data.duration * 1e3), this.eventManager.deactivate(), this.eventManager.controlsManager.deactivate();
        let t = this.scene.activeCamera;
        this.scene.updatePage(this.data.target), this.scene.traverseVisibleEntity((r)=>{
            r.type === "ParticleSystem" && (r.sleep(), r.wakeUp(), r.data.autoPlay ? r.start() : r.stop());
        }), this.scene.activePage.switchToPlayCamera(), this.scene.activeCamera.copyViewPlaneSize(t), Bf(this.scene.activePage, this.shared), this.eventManager.activate(), this.eventManager.controlsManager.activate(this.eventManager);
    }
};
var ug = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.evaluatedCondition = !1;
    }
    checkConditions() {
        this.evaluatedCondition = wt(this.shared, this.condition);
    }
    dispatch() {
        if (this.evaluatedCondition === !1) return !1;
        let t = this.shared.getVariable(this.data.variableId), e = F0(this.data.expression, this.shared, Br.typeOfVariable(t));
        e !== void 0 && this.shared.updateVariable(this.data.variableId, typeof e == "string" ? {
            textValue: e
        } : e);
    }
    dispose() {}
};
var hg = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.timeoutId = null;
    }
    dispatchInner() {
        if (wt(this.shared, this.condition) === !1) return !1;
        let t = this.shared.getDynamicVariablePlayState(this.data.variableId);
        if (this.data.mode === "PlayPause") this.shared.getDynamicVariableToggleIsForward(this.data.variableId) === void 0 && this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !0), this.shared.setDynamicVariablePlayState(this.data.variableId, t === "Playing" ? "Paused" : "Playing");
        else if (this.data.mode === "Play" && t !== "Playing") this.shared.getDynamicVariableToggleIsForward(this.data.variableId) === void 0 && this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !0), this.shared.setDynamicVariablePlayState(this.data.variableId, "Playing");
        else if (this.data.mode === "Stop" && t !== "Stopped") this.shared.setDynamicVariablePlayState(this.data.variableId, "Stopped");
        else if (this.data.mode === "Pause" && t !== "Paused") this.shared.setDynamicVariablePlayState(this.data.variableId, "Paused");
        else if (this.data.mode === "Restart") this.shared.setDynamicVariablePlayState(this.data.variableId, "Restarted");
        else if (this.data.mode === "Toggle") {
            let e = this.shared.getDynamicVariableToggleIsForward(this.data.variableId);
            t === "Playing" ? this.shared.setDynamicVariableToggleIsForward(this.data.variableId, e === void 0 ? !1 : !e) : (this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !e), this.shared.setDynamicVariablePlayState(this.data.variableId, "Playing"));
        }
    }
    dispatch() {
        let t = this.data.delay, e = this.shared.getDynamicVariablePlayState(this.data.variableId);
        this.data.mode === "PlayPause" && e === "Playing" && (t = this.data.pauseDelay), t !== 0 ? (this.timeoutId && window.clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            this.timeoutId = null, this.dispatchInner();
        }, t)) : this.dispatchInner();
    }
    dispose() {
        this.timeoutId && window.clearTimeout(this.timeoutId);
    }
};
var Tb = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
    }
    dispatch() {
        if (wt(this.shared, this.condition) === !1) return !1;
        (this.data.target === "single" ? this.data.variableId ? [
            this.data.variableId
        ] : [] : Object.keys(this.shared.getVariables())).forEach((e)=>{
            this.shared.getVariable(e);
            let r = this.shared.data.variables.data(e)?.value;
            r !== void 0 && this.shared.updateVariable(e, r), this.shared.enableLocalStorageForPersistentVariables && localStorage.removeItem(dx(e));
        });
    }
    dispose() {}
};
var Mb = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
    }
    dispatch() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.data.userAPIId && this.shared.getUserAPI(this.data.userAPIId)?.callUserAPI(this.shared);
    }
    dispose() {}
};
function wt(n1, t) {
    if (t === void 0) return !0;
    if (t.expression.length === 0) return !1;
    let e = F0(t.expression, n1, "boolean");
    return t.negate ? !e : !!e;
}
function Ut(n1, t, e, r, i, s) {
    let o = {
        Audio: [],
        Video: [],
        Particles: [],
        Link: [],
        Destroy: [],
        Create: [],
        Reset: [],
        Transition: [],
        SwitchCamera: [],
        Animation: [],
        SceneTransition: [],
        SetVariable: [],
        DynamicVariablePlay: [],
        ClearLocalStorage: [],
        UserAPI: []
    }, a = (l)=>({ id: c, data: u })=>{
            try {
                u.type === "Audio" ? Yi[n1.type].includes("Audio") && o.Audio.push(new Jm(c, u, s, r, l)) : u.type === "Video" && !(s instanceof rr) ? Yi[n1.type].includes("Video") && o.Video.push(new dg(c, u, s, r, l)) : u.type === "Particles" ? Yi[n1.type].includes("Particles") && o.Particles.push(new $m(u, e, r, l)) : u.type === "Link" ? Yi[n1.type].includes("Link") && o.Link.push(new gb(u, i.controlsManager, r, l)) : u.type === "Create" ? Yi[n1.type].includes("Create") && o.Create.push(new fg(u, e, i.controlsManager, r, l)) : u.type === "Destroy" ? Yi[n1.type].includes("Destroy") && o.Destroy.push(new eg(u, e, i.controlsManager, r, l)) : u.type === "Reset" ? Yi[n1.type].includes("Reset") && o.Reset.push(new tg(u, e, r, i, l)) : u.type === "Transition" ? Yi[n1.type].includes("Transition") && o.Transition.push(new og(n1.type, u, e, r, l)) : u.type === "SwitchCamera" ? Yi[n1.type].includes("SwitchCamera") && o.SwitchCamera.push(new ag(u, e, r, l)) : u.type === "SceneTransition" ? Yi[n1.type].includes("SceneTransition") && o.SceneTransition.push(new cg(u, e, i, r, l)) : u.type === "Animation" ? Yi[n1.type].includes("Animation") && o.Animation.push(new lg(u, e, i.animationControls, r, l)) : u.type === "SetVariable" ? Yi[n1.type].includes("SetVariable") && o.SetVariable.push(new ug(u, e, r, l)) : u.type === "DynamicVariablePlay" ? Yi[n1.type].includes("DynamicVariablePlay") && o.DynamicVariablePlay.push(new hg(u, e, r, l)) : u.type === "Conditional" ? Yi[n1.type].includes("Conditional") && (u.ifActions.forEach(a({
                    expression: u.condition,
                    negate: !1
                })), u.elseActions.forEach(a({
                    expression: u.condition,
                    negate: !0
                }))) : u.type === "ClearLocalStorage" ? Yi[n1.type].includes("ClearLocalStorage") && o.ClearLocalStorage.push(new Tb(u, e, r, l)) : u.type === "UserAPI" && Yi[n1.type].includes("UserAPI") && o.UserAPI.push(new Mb(u, e, r, l));
            } catch (h) {}
        };
    return t.forEach(a()), o;
}
function hr(n1) {
    Object.values(n1).forEach((t)=>{
        t.forEach((e)=>{
            (e instanceof Jm || e instanceof dg || e instanceof $m || e instanceof lg || e instanceof og || e instanceof fg || e instanceof eg || e instanceof ag || e instanceof cg || e instanceof tg || e instanceof ug || e instanceof hg) && e.dispose();
        });
    });
}
function EN(n1, t) {
    let e;
    if ("material" in n1) {
        let r = n1.material;
        Array.isArray(r) ? e = n1.material[0].layers.find((i)=>i.uuid === t) : e = n1.material.layers.find((i)=>i.uuid === t);
    }
    if (!!e) return e.color.texture.image.img instanceof HTMLVideoElement ? e.color.texture.image.img : void 0;
}
var TN = new Map, pg = new Map, Ua = class {
    constructor(t, e, r){
        this.data = e;
        this.delay = 0;
        this.status = "stopped";
        let { layerId: i, loop: s, volume: o, delay: a } = e;
        if (this.object = r, i === void 0) throw new Error("Missing property");
        let l = EN(r, i);
        l && (this.videoElement = l, this.videoElement.loop = s === 1 / 0, xo && (this.videoElement.autoplay = !0), o !== void 0 && (this.videoElement.volume = o)), a !== void 0 && (this.delay = a), pg.has(r.uuid) ? pg.get(r.uuid).push(this) : pg.set(r.uuid, [
            this
        ]), TN.set(t, this), this.pause();
    }
    mute() {
        !this.videoElement || (this.videoElement.muted = !0);
    }
    unMute() {
        !this.videoElement || (this.videoElement.muted = !1);
    }
    play(t) {
        if (!this.videoElement) return;
        let e = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        t ? (this.mute(), this.delay += 150) : e ? (this.mute(), window.setTimeout(()=>{
            this.unMute();
        }, 100)) : this.unMute(), this.delayTimerId = window.setTimeout(()=>{
            if (!this.videoElement) return;
            let r = this.videoElement.play();
            r !== void 0 && r.then((i)=>{}).catch((i)=>{
                this.play();
            }), this.clearDelay();
        }, this.delay), this.status = "playing";
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    pause() {
        !this.videoElement || (this.videoElement.pause(), this.status = "paused");
    }
    stop() {
        !this.videoElement || (this.videoElement.pause(), this.videoElement.currentTime = 0, this.status = "stopped", this.clearDelay());
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.status === "playing" ? this.stop() : (this.stop(), this.play()) : this.data.toggle === "pause" ? this.status === "playing" ? this.pause() : this.play() : (this.stop(), this.play());
    }
    dispose() {
        !this.videoElement || (this.stop(), this.videoElement.muted = !0);
    }
}, Ff = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playVideo ? this.pauseVideo(this.data.playVideo) : this.data.object ? this.pauseAllVideosFromObject(this.data.object) : this.pauseAllVideos();
    }
    pauseVideo(t) {
        let e = TN.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e[this.data.interaction]());
    }
    pauseAllVideosFromObject(t) {
        let e = pg.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((r)=>r[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((r)=>r[this.data.interaction]()));
    }
    pauseAllVideos() {
        let t = [
            ...pg.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((r)=>{
                    r[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((r)=>{
                r[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, dg = class {
    constructor(t, e, r, i, s){
        this.data = e;
        this.shared = i;
        this.condition = s;
        if (e.interaction === "play") this.interaction = new Ua(t, e, r);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new Ff(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Ua ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        if (wt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Ua ? this.interaction.play() : this.interaction.dispatch();
    }
    dispose() {
        this.interaction.dispose();
    }
};
var MN = (()=>{
    let n1, t, e, r;
    function i(a) {
        !n1 && !CN() && t?.sharedGameControlGlobals.createdObjects.length > 0 && (n1 = requestAnimationFrame(s)), a && (t = a, r = a.requestRender);
    }
    function s(a) {
        let l = e ? a - e : 0, c = t.sharedGameControlGlobals.createdObjects, u = t.sharedGameControlGlobals.nCreatedPerAction, h = c.length, d = 0;
        for(; d < h;){
            let f = c[d];
            f.userData.createdTime === void 0 && (f.userData.createdTime = a), f.userData.lifetime === void 0 && f.userData.quantity === void 0 || f.userData.lifetime && a - f.userData.createdTime < f.userData.lifetime || f.userData.quantity && u[f.userData.actionId] <= f.userData.quantity ? (f.userData.velocity && (f.position.addScaledVector(f.userData.velocity, l / 1e3), f.updateMatrix(), r()), d++) : (u[f.userData.actionId] > f.userData.quantity && u[f.userData.actionId]--, c.splice(d, 1), f.removeFromParent(), t.sharedGameControlGlobals.rapierWorld && f.rigidBody ? (t.sharedGameControlGlobals.colliderToEntity.delete(f.rigidBody.collider(0).handle), t.sharedGameControlGlobals.rapierWorld.removeRigidBody(f.rigidBody)) : (f.bvhGeometry = void 0, t.sharedGameControlGlobals.entitiesWithTransformAnim = t.sharedGameControlGlobals.entitiesWithTransformAnim.filter((p)=>p.bvhGeometry !== void 0)), h--, r());
        }
        n1 = d > 0 ? requestAnimationFrame(s) : void 0, e = d > 0 ? a : void 0;
    }
    function o() {
        CN() ? n1 && (cancelAnimationFrame(n1), n1 = void 0, e = void 0) : i();
    }
    return typeof document < "u" && document.addEventListener("visibilitychange", o), i;
})();
function CN() {
    return !!document && document.hidden;
}
var PN = new Ke, NJ = new E, FJ = new E, fg = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.controlsManager = r;
        this.shared = i;
        this.condition = s;
        this.intervalId = null;
        this.timeoutIdQueue = [];
        this.uniqueId = we.generateUUID();
        this.dispatch = ()=>{
            if (wt(this.shared, this.condition) === !1) return !1;
            this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
        };
        this.dispatchFromStart = ()=>{
            if (wt(this.shared, this.condition) === !1) return !1;
            this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
        };
        this.dispatchThrottled = lA(this.dispatch, 1e3 / this.data.creationSpeed);
        this.dispatchStart = ()=>{
            this.intervalId === null && (this.intervalId = window.setInterval(this.dispatch, 1e3 / this.data.creationSpeed));
        };
        this.dispatchStop = ()=>{
            this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null);
        };
        this.dispatchInner = ()=>{
            this.timeoutIdQueue.shift();
            let t = new Nr(this.object);
            if (t.playModeVisible = !0, t.expand(), this.data.coordinateSystem !== "world") {
                let r = this.data.coordinateSystem, i = this.page.scene.find(r);
                i && (i.updateMatrixWorldSVD(), t.hiddenMatrix.copy(i.matrixWorldRigid));
            }
            t.scale.copy(this.object.scale), t.position.fromArray(this.data.position), t.rotation.fromArray(this.data.rotation), t.updateMatrix(), this.page.add(t);
            let e = this.controlsManager.sharedGameControlGlobals;
            e.createdObjects.push(t), e.nCreatedPerAction[this.uniqueId] === void 0 ? e.nCreatedPerAction[this.uniqueId] = 1 : e.nCreatedPerAction[this.uniqueId]++, t.updateWorldMatrix(!0, !0), t.traverseObject(this.traverseObjectCB), MN(), this.controlsManager.requestRender();
        };
        this.traverseObjectCB = (t)=>{
            t.hasNonUniformScale && t.updateMatrixWorldSVD();
            let e;
            if (this.controlsManager.sharedGameControlGlobals.rapierWorld) {
                if (t instanceof Gi) {
                    if (t.objectForSample) {
                        if (t.objectForSample.dataPatched.physics.fusedBody) return;
                        e = t.object;
                    } else return t.object.dataPatched.physics.fusedBody === !0 && t.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (t instanceof Nr) e = t.object;
                else if (e = t, e.dataPatched.cloner?.hideBase) return !0;
            } else {
                if (t instanceof Gi) return;
                t instanceof Nr ? e = t.object : e = t;
            }
            this.data.destroy === "Time" ? t.userData.lifetime = this.data.lifetime * 1e3 : this.data.destroy === "Quantity" && (t.userData.quantity = this.data.destroyAfterQuantity, t.userData.actionId = this.uniqueId);
            let r = new E().fromArray(this.data.velocity), i = e.dataPatched;
            if (!(i.physics.enabled === "visibility" ? !i.visible : !i.physics.enabled) && (this.controlsManager.sharedGameControlGlobals.rapierWorld ? (this.controlsManager.addRigidBody(t, e, {
                fromCreate: !0,
                dynamic: this.data.dynamic
            }), this.data.destroy === "Collision" && (t.rigidBody?.collider(0).setActiveEvents(1), t.userData.hasCollisionDestroy = !0), t.matrixWorld.decompose(NJ, PN, FJ), r.applyQuaternion(PN), this.data.velocity.some((s)=>s !== 0) && this.data.dynamic && t.rigidBody?.setLinvel(r.divideScalar(this.controlsManager.pixelsPerMeter), !0)) : ("geometry" in t.object && this.controlsManager.addBoundsTree(t), this.data.velocity.some((s)=>s !== 0) && this.data.dynamic && (t.userData.velocity = r)), e.dataPatched.physics?.fusedBody === !0)) return !0;
        };
        let o = this.page.scene.find(this.data.object);
        if (!o) throw new Error("Missing Property");
        if (this.object = o, this.data.coordinateSystem !== "world" && !this.page.scene.find(this.data.coordinateSystem)) throw new Error("Missing Property");
        MN(r);
    }
    dispose() {
        this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null), this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t)), this.dispatchThrottled.cancel(), this.page.remove(...this.controlsManager.sharedGameControlGlobals.createdObjects), this.controlsManager.sharedGameControlGlobals.createdObjects = [];
    }
};
var jT = 200, UT = .02, zT = .3, VJ = 65, UWe = new E, _N = new E, IN = new E, kJ = new E, Tn = new E, Un = new E, nc = new E, GT = new ue, DN = new ue, UJ = new ue, zWe = new ue, ro = new Ke, za = new Ke, Xo = new nr(0, 0, 0, "YXZ"), zJ = new E(1, 0, 0), io = new E(0, 1, 0), GJ = new E(0, 0, 1), ON = new E(1, 1, 1), GWe = new Rr, jJ = 1, HJ = .025, WJ = 16e-6, RN = 12, qJ = 20, Hi = new Ti, Ms = new Wt, YJ = {
    type: "requestRender"
}, XJ = {
    type: "updateMatrix"
}, LN = Math.PI / 6, Cb = class extends pr {
    constructor(e, r, i, s, o, a, l, c, u){
        super();
        this.object = e;
        this.domElement = r;
        this.data = i;
        this.gloabalPhysics = s;
        this.controlsManager = o;
        this.cameraFollow = a;
        this.camera = l;
        this.page = c;
        this.sharedAssets = u;
        this.enableDamping = !0;
        this.hiddenMatrix0 = new ue;
        this.target0 = new E;
        this.zoom0 = 1;
        this.rotForce = 1;
        this.moveForce = 1;
        this.pixelsPerMeter = jT;
        this.euler0 = new nr(0, 0, 0, "YXZ");
        this.position0Cam = new E;
        this.quat0Cam = new Ke;
        this.scale0Cam = new E;
        this.hiddenMatrix0Cam = new ue;
        this.threshEndTranslate = .01;
        this.threshEndRotate = 1e-8;
        this.threshEndRotVel = .005;
        this.collider = {
            type: "capsule",
            radius: 40,
            segment: new Ti(new E(0, -40, 0), new E(0, 40, 0)),
            matrix: new ue,
            position: new E,
            rotation: new Ke
        };
        this.euler = new nr(0, 0, 0, "YXZ");
        this.eulerDelta = new E;
        this.lastPosition = new E;
        this.lastCameraQuaternion = new Ke;
        this.lastCameraPosition = new E;
        this.PI_2 = Math.PI / 2;
        this.prevMouse = new k;
        this.velocityTarget = new E;
        this.velocity = new E;
        this.directionXZ = new E;
        this.rotVelocityStick = new E;
        this.rotVelocityTarget = new E;
        this.rotVelocity = new E;
        this.rotDirection = new E;
        this.nonColliderRotOffset = new ue;
        this.nonColliderPosOffset = new ue;
        this.firstPointerId = -1;
        this.rot = new E;
        this.path = [];
        this.movementState = {
            moveNegZ: 0,
            movePosZ: 0,
            moveNegX: 0,
            movePosX: 0,
            moveNegY: 0,
            movePosY: 0,
            rotPosX: 0,
            rotNegX: 0,
            rotPosY: 0,
            rotNegY: 0,
            jump: 0,
            run: 0
        };
        this.vrEulerYOffset = 0;
        this.onObject = !1;
        this.actionState = {};
        this.keyAssignments = [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "ArrowUp"
            ],
            [
                "rotPosY",
                "ArrowLeft"
            ],
            [
                "rotNegX",
                "ArrowDown"
            ],
            [
                "rotNegY",
                "ArrowRight"
            ],
            [
                "jump",
                " "
            ]
        ];
        this.collisionEnabled = !0;
        this.offsetMatrix = new ue;
        this.objectToTarget = new E;
        this.objectToTarget0 = new E;
        this.objectToCamXZ = new E;
        this.objectToCamXZ0 = new E;
        this.targetToCamera = new E;
        this.targetToCamera0 = new E;
        this.cameraPolarAxis0 = new E;
        this.targetPos = new E;
        this.targetQuat = new Ke;
        this.lerpFactorPos = new E().setScalar(.3);
        this.lerpFactorPosStart = .3;
        this.lerpFactorPosEnd = .3;
        this.lerpFactorRotStart = .3;
        this.lerpFactorRotEnd = .3;
        this.lerpFactorPosCamera = .3;
        this.lerpFactorRotCamera = .3;
        this.objXZQuat = new Ke;
        this.objXZQuatInv = new Ke;
        this.objXZRotMat = new ue;
        this.isFirstPerson = !1;
        this.didHit = !1;
        this.groundVelocity = new E;
        this.pushedVelocity = new E;
        this.groundYRotation = 0;
        this.objectRealQuat = new Ke;
        this.colliderWorldQuat = new Ke;
        this.groundNormal = new E;
        this.groundTilt = new Ke;
        this.groundTiltInv = new Ke;
        this.lastHitObj = null;
        this.isFirstFrame = !0;
        this.rotationAccumWhenOrientWithCamera = 0;
        this.navMeshPathDest = null;
        this.position = new E;
        this.quaternion = new Ke;
        this.scale = new E;
        this.initialAction = !0;
        this.onPointerDown = (e)=>{
            !(e.target === this.domElement || e.target instanceof HTMLElement && e.target.tagName === "SPLINE-VIEWER" && e.target.shadowRoot?.contains(this.domElement)) || this.firstPointerId !== -1 || (this.firstPointerId = e.pointerId, this.domElement.ownerDocument.addEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.addEventListener("pointerup", this.onPointerUp), this.rotBy !== "keys" && !Ci && !uA && this.domElement.requestPointerLock(), this.prevMouse.set(e.clientX, e.clientY));
        };
        this.onPointerUp = (e)=>{
            this.firstPointerId = -1, this.domElement.ownerDocument.removeEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.removeEventListener("pointerup", this.onPointerUp), e.pointerType === "mouse" && this.domElement.ownerDocument.exitPointerLock();
        };
        this.onPointerMove = (e)=>{
            if (e.pointerId !== this.firstPointerId) return;
            let r = e.clientX - this.prevMouse.x, i = e.clientY - this.prevMouse.y;
            this.prevMouse.set(e.clientX, e.clientY), e.pointerType === "mouse" && this.rotBy !== "keys" && (uA && eI < 15.5 && !Ci ? (this.eulerDelta.y = -r * this.mouseOrbitSensitivity, this.eulerDelta.x = -i * this.mouseOrbitSensitivity) : (this.eulerDelta.y = -e.movementX * this.mouseOrbitSensitivity, this.eulerDelta.x = -e.movementY * this.mouseOrbitSensitivity)), e.pointerType !== "mouse" && this.rotByTouch === "drag" && (this.eulerDelta.y = -r * this.mouseOrbitSensitivity * 5, this.eulerDelta.x = -i * this.mouseOrbitSensitivity * 5), this.controlsManager.requestRender();
        };
        this.onPointerlockChange = (e)=>{
            this.domElement.ownerDocument.pointerLockElement === this.domElement ? Cb.isLocked = !0 : Cb.isLocked = !1;
        };
        this.onPointerlockError = ()=>{
            console.error("SPE.GameControls: Unable to use Pointer Lock API");
        };
        this.handleVisibilityChange = ()=>{
            if (document?.hidden) for(let e in this.movementState)this.movementState[e] = 0;
        };
        this.onKeyDown = (e)=>{
            !(e.target instanceof HTMLInputElement) && (e.code === "ArrowLeft" || e.code === "ArrowUp" || e.code === "ArrowRight" || e.code === "ArrowDown" || e.code === "Space") && e.preventDefault();
            for (let r of this.keyAssignments)if (e.key.toUpperCase() === r[1] || e.key === r[1]) {
                this.movementState[r[0]] = 1;
                break;
            }
            this.controlsManager.requestRender();
        };
        this.onKeyUp = (e)=>{
            for (let r of this.keyAssignments)if (e.key.toUpperCase() === r[1] || e.key === r[1] || e.code.slice(3, e.code.length).toUpperCase() === r[1]) {
                this.movementState[r[0]] = 0;
                break;
            }
        };
        this.copyVRGamePadValues = (e, r)=>{
            for(let i = 2; i < 4; i++){
                let s = e.axes[i];
                r === 0 ? i === 2 ? this.movementState.movePosX = s : this.movementState.movePosZ = s : (e.buttons[3].pressed ? this.movementState.jump = 1 : this.movementState.jump = 0, i === 2 ? (Math.abs(this.movementState.rotPosY) < .3 && Math.abs(s) >= .3 && (this.vrEulerYOffset += s < 0 ? 1 : -1), this.movementState.rotPosY = s) : this.moveMode === "fly" && (this.movementState.moveNegY = s));
            }
        };
        this.sharedGameControlGlobals = o.sharedGameControlGlobals, e === l && (this.isFirstPerson = !0), this.hiddenMatrix0.copy(this.object.hiddenMatrix), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.position, this.quaternion, this.scale), this.euler0.setFromQuaternion(this.quaternion, "YXZ");
        let h = this.euler0.clone(), d = h.y;
        if (this.objectRealQuat.copy(this.quaternion), h.y = 0, this.quaternion.setFromEuler(h), this.objXZQuat.copy(this.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.quaternion), h.set(0, d, 0), this.quaternion.setFromEuler(h), this.rot.setFromEuler(h), this.object.matrixAutoUpdate = !1, (this.isFirstPerson || this.cameraFollow === !0) && (this.target0.copy(this.camera.getTarget()), this.zoom0 = this.camera.zoom), this.cameraFollow === !0) {
            this.position0Cam.copy(this.camera.position), this.quat0Cam.copy(this.camera.quaternion), this.scale0Cam.copy(this.camera.scale), this.hiddenMatrix0Cam.copy(this.camera.hiddenMatrix), this.camera.parent ? (this.camera.hiddenMatrix.copy(this.camera?.parent.matrixWorld), this.camera.matrix.copy(this.camera.matrixWorld)) : this.camera.hiddenMatrix.identity(), this.camera.matrix.copy(this.camera.matrixWorld), this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale), this.camera.matrixAutoUpdate = !1, this.offsetMatrix.copy(this.object.matrix).invert().multiply(this.camera.matrix);
            let g = new E(0, 0, -1).applyQuaternion(this.camera.quaternion), y = new E().subVectors(this.position, this.camera.position);
            this.objectToCamXZ.copy(y), this.objectToCamXZ.y = 0, this.objectToCamXZ0.copy(this.objectToCamXZ);
            let x, v;
            Math.abs(g.y) < 1e-6 ? (y.y = 0, g.y = 0, v = y.projectOnVector(g)) : y.y / g.y > 0 ? v = g.multiplyScalar(y.y / g.y) : v = g.multiplyScalar(y.length()), this.targetToCamera0.copy(v).negate(), x = this.camera.position.clone().add(v), this.objectToTarget0.subVectors(x, this.position);
            let S = new nr().setFromQuaternion(this.camera.quaternion, "YXZ");
            this.cameraPolarOffset = -S.x, S.x = 0, S.z = 0, S.y -= Math.PI / 2, this.cameraPolarAxis0.set(0, 0, -1).applyEuler(S);
        }
        if (this.object instanceof wr && (this.object.matrixAutoUpdate = !1), this.euler.setFromQuaternion(this.quaternion, "YXZ"), this.rotByTouch = i.rotByTouch ?? "joystick", this.rotBy = i.rotBy ?? "keys", this.rotationMode = i.rotationMode ?? "normal", this.moveMode = i.moveMode ?? "walk", this.collisionEnabled = i.collisionEnabled, this.speedTranslate = (i.speedTranslate ?? 250) * jJ, this.speedOrbit = (i.speedRotate ?? 100) * HJ, this.mouseOrbitSensitivity = (i.speedRotate ?? 100) * WJ, this.keyAssignments = i.keyAssignments.map((g)=>{
            let y = [
                g[0],
                g[1]
            ];
            return y[1] === "\u25B2" ? y[1] = "ArrowUp" : y[1] === "\u25C0" ? y[1] = "ArrowLeft" : y[1] === "\u25BC" ? y[1] = "ArrowDown" : y[1] === "\u25B6" ? y[1] = "ArrowRight" : y[1] === "\u21E7" ? y[1] = "Shift" : y[1] === "\u21B5" ? y[1] = "Enter" : y[1] === "Space" ? y[1] = " " : y[1] === "\u2318" ? y[1] = "Meta" : y[1] === "Ctrl" ? y[1] = "Control" : y[1] === "Esc" && (y[1] = "Escape"), y;
        }), i.rotBy === "mouse") {
            let g;
            g = this.keyAssignments.findIndex((y)=>y[0] === "rotNegX"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotPosX"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotPosY"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotNegY"), g !== -1 && (this.keyAssignments[g][1] = "");
        }
        this.lerpFactorPosStart = 1 - .02 ** (1 / ((i.delayPos[0] ?? .3) * 60)), this.lerpFactorPosEnd = 1 - .02 ** (1 / ((i.delayPos[1] ?? .3) * 60)), this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.lerpFactorRotStart = 1 - .02 ** (1 / ((i.delayRot[0] ?? .3) * 60)), this.lerpFactorRotEnd = 1 - .02 ** (1 / ((i.delayRot[1] ?? .3) * 60)), this.lerpFactorPosCamera = 1 - .02 ** (1 / ((i.delayPosCamera ?? .3) * 60)), this.lerpFactorRotCamera = 1 - .02 ** (1 / ((i.delayRotCamera ?? .3) * 60)), this.gravity = (this.gloabalPhysics.gravity ?? Ml.defaultData.gravity) * RN, this.usePhysics = this.gloabalPhysics.usePhysics ?? Ml.defaultData.usePhysics, this.jumpPower = i.jumpPower * qJ, this.resetYPosition = this.position.y + Math.abs(i.resetYPosition) * (this.gravity > 0 ? 1 : -1), this.alignToGround = i.alignToGround ?? !1, this.orientMode = i.autoOrientMove ? i.orientMode : "none", this.orientWith = i.orientWith ?? Zh.defaultDataThirdPerson.orientWith, this.slopeThresh = VJ * Math.PI / 180, i.collider.type === "capsule" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = i.collider.height / 2 - i.collider.radius, this.collider.segment.end.y = -this.collider.segment.start.y, this.offset = i.collider.height * UT / this.pixelsPerMeter, this.stepThresh = i.collider.height * zT / this.pixelsPerMeter, this.colliderHeight = i.collider.height) : i.collider.type === "sphere" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = 0, this.collider.segment.end.y = 0, this.offset = 2 * i.collider.radius * UT / this.pixelsPerMeter, this.stepThresh = 2 * i.collider.radius * zT / this.pixelsPerMeter, this.colliderHeight = i.collider.radius * 2) : (this.offset = i.collider.height * UT / this.pixelsPerMeter, this.stepThresh = i.collider.height * zT / this.pixelsPerMeter, this.colliderHeight = i.collider.height), this.collider.type = i.collider.type;
        let f = new E().fromArray(i.collider.position), p = new Ke().setFromEuler(new nr().fromArray([
            ...i.collider.rotation,
            "XYZ"
        ]));
        this.collider.position.copy(f).multiply(this.scale), this.collider.rotation.copy(p), this.collider.matrix.compose(f, p, ON), i.cameraXAxis !== void 0 && (this.cameraXAxis = i.cameraXAxis, this.cameraYAxis = i.cameraYAxis, this.minPolarAngle = i.cameraRotXLimits[0], this.maxPolarAngle = i.cameraRotXLimits[1], this.minAzimuthAngleRel = i.cameraRotYLimits[0], this.maxAzimuthAngleRel = i.cameraRotYLimits[1]), this.forwardDir = i.forwardDirection ?? "-z", this.isFirstPerson && (this.forwardDir = "-z"), this.runMultiplier = i.runMultiplier ?? 2;
        let m = i.navmesh.destinationHelperRadius * 2;
        if (m > 0) {
            let g = new ke;
            g.push({
                fi: 0,
                data: {
                    ...Gr.defaultData("light", "phong"),
                    alpha: 0
                },
                id: "layer1"
            }), g.push({
                fi: 0,
                data: {
                    ...Gr.defaultData("color"),
                    color: i.navmesh.destinationHelperColor,
                    alpha: i.navmesh.destinationHelperColor.a
                },
                id: "layer2"
            });
            let y = new Ra({
                layers: g
            }, {
                scene: this.page.scene,
                shared: this.sharedAssets
            });
            this.navMeshPathDest = new zt(E0.create({
                parameters: {
                    width: m,
                    height: m / 10,
                    hollow: .7
                }
            }), y), this.navMeshPathDest.material.userData.opacity0 = i.navmesh.destinationHelperColor.a;
        }
        this.activate();
    }
    reset(e = !1) {
        if (this.object.hiddenMatrix.copy(this.hiddenMatrix0), e) {
            this.object.updateMatrix(), this.object.updateMatrixWorld(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.position, this.quaternion, this.scale), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity();
            let r = new nr().setFromQuaternion(this.quaternion, "YXZ"), i = r.y;
            this.objectRealQuat.copy(this.quaternion), r.y = 0, this.quaternion.setFromEuler(r), this.objXZQuat.copy(this.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.quaternion), r.set(0, i, 0), this.quaternion.setFromEuler(r), this.rot.setFromEuler(r), this.euler.setFromQuaternion(this.quaternion, "YXZ"), this.velocityTarget.set(0, 0, 0), this.velocity.set(0, 0, 0);
        } else this.object instanceof wr ? this.object.matrixAutoUpdate = !0 : this.object.updateMatrix();
        this.cameraFollow === !0 && (this.camera.quaternion.copy(this.quat0Cam), this.camera.position.copy(this.position0Cam), this.camera.scale.copy(this.scale0Cam), this.camera.hiddenMatrix.copy(this.hiddenMatrix0Cam), this.camera.matrixAutoUpdate = !0), this.controlsManager.requestRender();
    }
    activate() {
        this.instantiateActions(), this.domElement.ownerDocument.addEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.addEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.addEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.addEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.addEventListener("pointerlockerror", this.onPointerlockError), this.domElement.ownerDocument.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    deactivate() {
        this.disposeActions(), this.domElement.ownerDocument.removeEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.removeEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.removeEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.removeEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.removeEventListener("pointerlockerror", this.onPointerlockError), this.domElement.ownerDocument.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    dispose() {
        this.deactivate(), this.navMeshPathDest?.parent && this.page.remove(this.navMeshPathDest);
    }
    instantiateActions() {
        let e = this.data, r = this.sharedAssets;
        e.gameActions !== void 0 && (this.actions = {}, Qh.list.forEach((i)=>{
            this.actions[i] = Ut({
                ...e,
                disabled: !1,
                type: "GameControl"
            }, e.gameActions[i], this.page, r, this.controlsManager.eventManager, this.object);
        })), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"), this.initialAction && (this.initialAction = !1);
    }
    disposeActions() {
        this.initialAction = !1, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), hr(this.actions.idle), hr(this.actions.move), hr(this.actions.run), hr(this.actions.jump);
    }
    dispatchStartEvent(e) {
        this.actions[e] !== void 0 && (this.actionState[e] || (this.actionState[e] = !0, this.actions[e].Transition.forEach((r)=>{
            r.play();
        }), this.actions[e].Animation.forEach((r)=>{
            r.play(this.initialAction === !1);
        }), this.actions[e].Create.forEach((r)=>{
            r.dispatchStart();
        }), this.actions[e].Audio.forEach((r)=>{
            r.dispatchGameControl("start");
        }), this.actions[e].Particles.forEach((r)=>{
            r.dispatchGameControl("start");
        })));
    }
    dispatchStopEvent(e) {
        this.actions[e] !== void 0 && (!this.actionState[e] || (this.actionState[e] = !1, this.actions[e].Transition.forEach((r)=>{
            r.stop(), r.object.currentState !== null && r.object.changeSelectedState(null, {
                scene: this.page.scene,
                shared: this.sharedAssets
            });
        }), this.actions[e].Create.forEach((r)=>{
            r.dispatchStop();
        }), this.actions[e].Audio.forEach((r)=>{
            r.dispatchGameControl("stop");
        }), this.actions[e].Particles.forEach((r)=>{
            r.dispatchGameControl("stop");
        })));
    }
    get colliderWorldPosition() {
        return Tn.copy(this.collider.position).applyQuaternion(this.objectRealQuat).add(this.position);
    }
    update(e, r, i) {
        if (this.gravity < 0 ? this.position.y < this.resetYPosition : this.position.y > this.resetYPosition) return this.reset(!0), !0;
        this.sharedGameControlGlobals.gamePads.forEach(this.copyVRGamePadValues);
        let s = (this.isFirstFrame ? 16.6 : e) / 1e3;
        this.isFirstFrame && (this.isFirstFrame = !1);
        let o = s * 60, a = !1;
        if (this.usePhysics && this.collisionEnabled) {
            let c = Un.set(0, (this.velocity.y === 0 ? this.pixelsPerMeter * Math.max(Math.abs(this.gravity) / (10 * RN), 1) * (this.gravity > 0 ? 1 : -1) : this.velocity.y) * s, 0).divideScalar(this.pixelsPerMeter), u = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter), this.colliderWorldQuat, c, this.object.rigidBody?.collider(0).shape, 1, !1, 16, void 0, void 0, this.object.rigidBody);
            if (u) {
                this.onObject = !0, this.groundNormal.set(u.normal2.x, u.normal2.y, u.normal2.z).applyQuaternion(this.colliderWorldQuat).negate(), this.alignToGround && this.groundTiltAdjustment(this.groundNormal), Math.acos(this.groundNormal.y) < this.slopeThresh && (a = !0), u.collider.parent()?.bodyType() === 0 && Math.acos(this.groundNormal.y) * (180 / Math.PI) > 45 && (this.onObject = !1);
                let h = u.collider.parent();
                this.groundYRotation = 0, this.groundVelocity.set(0, 0, 0);
                for (let d of this.sharedGameControlGlobals.entitiesWithTransformAnim)if (d.rigidBody === h && d.userData.isFollowingObj !== this.object.uuid) {
                    (d.hasNonUniformScale ? d.matrixWorldRigid : d.matrixWorld).decompose(Tn, za, Un), this.groundVelocity.subVectors(Tn, d.prevT), this.object.getWorldPosition(Un).add(this.collider.position).sub(Tn), this.groundYRotation = Xo.setFromQuaternion(za).y - d.prevR.y, nc.copy(Un).applyAxisAngle(io, this.groundYRotation), this.groundVelocity.add(nc.sub(Un)).divideScalar(s);
                    break;
                }
            } else this.onObject = !1;
        }
        if (this.moveMode === "walk" && this.collisionEnabled && (this.movementState.jump === 1 && this.onObject && (this.velocityTarget.y = this.jumpPower, this.movementState.jump = 0, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("jump"), this.onObject = !1), this.onObject ? this.velocityTarget.y /= 2 : this.velocityTarget.y += this.gravity * o), this.moveMode === "fly" && (this.velocityTarget.y = (this.movementState.movePosY - this.movementState.moveNegY) * this.speedTranslate), this.directionXZ.z = this.movementState.movePosZ - this.movementState.moveNegZ, this.directionXZ.x = this.movementState.movePosX - this.movementState.moveNegX, this.forwardDir === "+z" && this.directionXZ.multiplyScalar(-1), this.directionXZ.manhattanLength() > 0 && (this.path = []), this.navMeshPathDest) {
            let c = this.navMeshPathDest.material;
            if (this.moveMode === "walk" && this.path.length > 1) {
                this.navMeshPathDest.position.copy(this.path[this.path.length - 1]), this.navMeshPathDest.parent || this.page.add(this.navMeshPathDest);
                let u = Tn.subVectors(this.path[1], this.position), h = Un.subVectors(this.path[1], this.path[0]);
                u.dot(h) < 0 ? this.path.shift() : (this.directionXZ.x = h.x, this.directionXZ.z = h.z), c.opacity = c.userData.opacity0;
            } else c.opacity -= .05 * c.userData.opacity0, this.navMeshPathDest.material.opacity <= 0 && this.navMeshPathDest.parent && this.page.remove(this.navMeshPathDest);
        }
        this.directionXZ.normalize(), this.movementState.run ? this.moveForce = this.runMultiplier : this.moveForce = 1, this.velocityTarget.z = this.directionXZ.z * this.speedTranslate * this.moveForce, this.velocityTarget.x = this.directionXZ.x * this.speedTranslate * this.moveForce, (this.moveMode === "walk" ? this.velocityTarget.x + this.velocityTarget.z === 0 : this.velocityTarget.manhattanLength() === 0) ? this.lerpFactorPos.setScalar(this.lerpFactorPosEnd) : this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.moveMode === "walk" && (this.lerpFactorPos.y = 1), this.didHit === !1 && this.pushedVelocity.manhattanLength() === 0 || this.usePhysics === !1 ? (this.velocity.x += (this.velocityTarget.x - this.velocity.x) * (1 - (1 - this.lerpFactorPos.x) ** o), this.velocity.y += (this.velocityTarget.y - this.velocity.y) * (1 - (1 - this.lerpFactorPos.y) ** o), this.velocity.z += (this.velocityTarget.z - this.velocity.z) * (1 - (1 - this.lerpFactorPos.z) ** o)) : this.velocity.copy(this.velocityTarget), (this.moveMode === "walk" ? this.velocity.x ** 2 + this.velocity.z ** 2 < this.speedTranslate : this.velocity.lengthSq() < this.speedTranslate) ? (this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.onObject && (this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"))) : (this.dispatchStopEvent("idle"), this.onObject && (this.dispatchStopEvent("jump"), this.movementState.run ? (this.dispatchStopEvent("move"), this.dispatchStartEvent("run")) : (this.dispatchStopEvent("run"), this.dispatchStartEvent("move"))));
        let l = kJ.copy(this.velocity);
        if (this.orientMode !== "none" && this.isFirstPerson === !1) {
            let c = Un.copy(l);
            c.y = 0, l.set(0, l.y, c.length() * (this.forwardDir === "+z" ? 1 : -1));
        }
        if (this.directionXZ.manhattanLength() > 0 && this.orientMode !== "none" && this.isFirstPerson === !1) {
            if (this.orientWith === "camera" && this.path.length <= 1) {
                let c = Tn;
                this.camera.getWorldDirection(c);
                let u = nc.copy(io).multiplyScalar(c.dot(io));
                c.sub(u);
                let h = Un.copy(this.directionXZ);
                h.x *= -1, this.rot.y = c.angleTo(h) * (c.cross(h).y > 0 ? -1 : 1) + this.rotationAccumWhenOrientWithCamera;
            } else this.rot.y = (this.path.length > 1 ? 0 : this.euler.y) + Math.atan2(-this.directionXZ.z, this.directionXZ.x) + Math.PI / 2 * (this.forwardDir === "+z" ? 1 : -1);
        }
        if (Xo.setFromVector3(this.rot), this.moveMode === "walk" && (Xo.x = 0), l.applyEuler(Xo), a && (za.setFromUnitVectors(io, this.groundNormal), l.applyQuaternion(za)), i) {
            let c = Xo.set(0, this.vrEulerYOffset * LN, 0);
            i.applyEuler(c), l.x += i.x, l.z += i.z, this.nonColliderPosOffset.elements[13] += i.y * s;
        }
        if (this.usePhysics === !0) {
            let c = Un;
            this.pushedVelocity.set(0, 0, 0);
            for (let u of this.sharedGameControlGlobals.entitiesWithTransformAnim){
                let h = nc.setFromMatrixPosition(u.matrixWorld).sub(u.prevT).divideScalar(s).divideScalar(this.pixelsPerMeter), d = u.rigidBody.collider(0).castCollider(h, this.object.rigidBody.collider(0), Tn.copy(l).divideScalar(this.pixelsPerMeter), s, !1);
                h.multiplyScalar(this.pixelsPerMeter);
                let f = yt.is(u) ? u : u.object;
                if (d !== null && this.lastHitObj !== f) {
                    let p;
                    u instanceof Nr && (p = u);
                    let m = this.sharedGameControlGlobals.entityToCollisionEvents[f.uuid];
                    if (m) for (let g of m)g.data.target === "character" && (g.dispatch(p), f.dispatchEvent(Pb));
                    this.lastHitObj = f;
                }
                if (d !== null) {
                    this.pushedVelocity.copy(h), c.copy(d.normal1).applyQuaternion(u.quaternion);
                    break;
                }
            }
            if (this.pushedVelocity.manhattanLength() !== 0) {
                let u = c.dot(l);
                u < 0 && l.addScaledVector(c, -u), l.add(this.pushedVelocity);
            } else l.add(this.groundVelocity);
        }
        if (this.rotDirection.y = Number(this.movementState.rotPosY) - Number(this.movementState.rotNegY), this.rotDirection.x = Number(this.movementState.rotPosX) - Number(this.movementState.rotNegX), this.rotDirection.normalize(), this.rotationMode === "normal" && (this.movementState.rotPosX || this.movementState.rotNegX) || this.rotationMode === "steer" && (this.movementState.rotPosX || this.movementState.rotNegX) && (this.movementState.movePosZ || this.movementState.moveNegZ || this.moveMode === "walk") ? this.rotVelocityStick.x = -this.rotDirection.x * this.speedOrbit * this.rotForce : this.rotVelocityStick.x = 0, this.rotationMode === "normal" && (this.movementState.rotPosY || this.movementState.rotNegY) || this.rotationMode === "steer" && (this.movementState.rotPosY || this.movementState.rotNegY) && (this.movementState.movePosZ || this.movementState.moveNegZ) ? this.rotVelocityStick.y = -this.rotDirection.y * this.speedOrbit * this.rotForce : this.rotVelocityStick.y = 0, this.rotVelocityTarget.subVectors(this.eulerDelta.divideScalar(s), this.rotVelocityStick), this.rotVelocityTarget.manhattanLength() === 0 ? this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotEnd) ** o) : this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotStart) ** o), this.euler.x += this.rotVelocity.x * s, this.euler.y += this.rotVelocity.y * s + this.groundYRotation, this.rotVelocityTarget.y === 0 && this.directionXZ.manhattanLength() === 0 ? this.rotationAccumWhenOrientWithCamera = 0 : (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.rotationAccumWhenOrientWithCamera += this.rotVelocity.y * s), this.isFirstPerson === !1 && this.orientMode !== "none" && this.directionXZ.manhattanLength() > 0) {
            if (this.orientMode === "radial") {
                this.objectToCamXZ.copy(this.objectToCamXZ0).applyAxisAngle(io, this.euler.y - this.euler0.y);
                let c = Un.copy(this.objectToCamXZ).normalize(), u = nc.copy(l).multiplyScalar(s);
                u.y = 0;
                let h = u.sub(Tn.copy(c).multiplyScalar(u.dot(c))).cross(c).y;
                this.euler.y -= Math.atan2(h, this.objectToCamXZ.length());
            }
        } else this.rot.y += this.rotVelocity.y * s + this.groundYRotation, this.rotVelocityTarget.y !== 0 && (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.euler.y = this.rot.y);
        if (this.cameraFollow === !0 && (this.moveMode === "walk" ? this.cameraXAxis === "Limit" ? this.euler.x = we.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : this.euler.x = we.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset, this.PI_2 + this.cameraPolarOffset) : this.cameraXAxis === "Limit" && (this.euler.x = we.clamp(this.euler.x, -this.PI_2, this.PI_2))), this.moveMode === "fly" ? this.rot.x = this.euler.x : this.isFirstPerson && (r ? (Xo.copy(r), Xo.y = 0) : (Xo.copy(this.euler), Xo.y = 0), this.nonColliderRotOffset.makeRotationFromEuler(Xo)), r && (this.moveMode === "walk" ? (this.rot.y = r.y, this.rot.x = 0, this.rot.z = 0) : this.rot.setFromEuler(r), this.rot.y += this.vrEulerYOffset * LN), ro.setFromAxisAngle(zJ, this.rot.x), za.setFromAxisAngle(io, this.rot.y), za.multiply(ro), ro.setFromAxisAngle(GJ, this.rot.z), za.multiply(ro), this.quaternion.copy(za), this.objectRealQuat.multiplyQuaternions(this.quaternion, this.objXZQuat), this.colliderWorldQuat.copy(this.objectRealQuat).multiply(this.collider.rotation), this.collisionEnabled) {
            if (this.usePhysics) {
                let c = Un.copy(l).multiplyScalar(s / this.pixelsPerMeter), u = null;
                this.didHit = !1;
                let h = new E;
                for(let d = 0; d < 5; d++){
                    let f = c.length(), p = nc.copy(c).normalize();
                    if (u = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(h), this.colliderWorldQuat, p, this.object.rigidBody?.collider(0).shape, f, !1, 24, void 0, void 0, this.object.rigidBody), u !== null) {
                        this.didHit = !0;
                        let m = this.sharedGameControlGlobals.colliderToEntity.get(u.collider.handle);
                        if (m !== this.lastHitObj && d === 0) {
                            this.lastHitObj = m;
                            let v = this.sharedGameControlGlobals.entityToCollisionEvents[m?.uuid];
                            if (v) {
                                for (let S of v)if (S.data.target === "character") {
                                    let w = (this.sharedGameControlGlobals.rapierWorld?.getCollider(u.collider.handle))._parent, A;
                                    if (m.cloner) {
                                        for (let T of m.cloner.children)if (T.rigidBody === w) {
                                            A = T;
                                            break;
                                        }
                                    }
                                    S.dispatch(A), m.dispatchEvent(Pb);
                                }
                            }
                        }
                        let g = _N.set(u.normal2.x, u.normal2.y, u.normal2.z).applyQuaternion(this.colliderWorldQuat), y = IN.copy(p).multiplyScalar(u.toi).dot(g), x = u.toi;
                        if (x === 0 && (this.position.y += this.offset * this.pixelsPerMeter), y > this.offset && (x = u.toi * (y - this.offset) / y, h.addScaledVector(p, x)), c.copy(p).multiplyScalar(f - x), Math.acos(-g.y) > this.slopeThresh) {
                            let v = this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(h), S = nc.copy(u.witness2).applyQuaternion(this.colliderWorldQuat);
                            S.y = 0;
                            let w = v.add(S);
                            w.y += this.stepThresh;
                            let A = this.sharedGameControlGlobals.rapierWorld.castShape(w, this.colliderWorldQuat, c, this.object.rigidBody?.collider(0).shape, 1, !1, 24, void 0, void 0, this.object.rigidBody);
                            A !== null && A.toi === 0 && (g.y = 0, g.normalize());
                        }
                        c.addScaledVector(g, -c.dot(g));
                    } else {
                        d === 0 && this.directionXZ.manhattanLength() !== 0 && (this.lastHitObj = null), h.add(c);
                        break;
                    }
                }
                this.position.addScaledVector(h, this.pixelsPerMeter), this.object.rigidBody?.setTranslation(Tn.copy(this.position).divideScalar(this.pixelsPerMeter), !0), this.object.rigidBody?.setRotation(ro.copy(this.quaternion).premultiply(this.groundTilt).multiply(this.objXZQuat), !0);
            } else {
                let c = this.onObject ? 1 : 5, u = l.multiplyScalar(s / c);
                for(let h = 0; h < c; h++)this.position.add(u), this.collisionAdjustment(s / c);
            }
        } else this.position.addScaledVector(l, s);
        if (this.moveMode === "walk" && this.onObject && (this.velocityTarget.y = 0, this.velocity.y = 0), this.quaternion.premultiply(this.groundTilt).multiply(this.objXZQuat), this.object.matrix.compose(this.position, this.quaternion, this.scale), this.object.matrixWorldNeedsUpdate = !0, this.object.matrix.multiply(this.nonColliderPosOffset).multiply(this.nonColliderRotOffset), this.quaternion.premultiply(this.groundTiltInv).multiply(this.objXZQuatInv), this.cameraFollow === !0) {
            this.updateFollowArms();
            let c = this.objectToTarget.add(this.position), u = this.targetToCamera.add(c);
            GT.lookAt(u, c, io).setPosition(u), GT.decompose(this.targetPos, this.targetQuat, Tn), this.camera.quaternion.slerp(this.targetQuat, 1 - (1 - this.lerpFactorRotCamera) ** o), this.camera.position.lerp(this.targetPos, 1 - (1 - this.lerpFactorPosCamera) ** o), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.cameraYAxis === "Limit" && this.orientMode === "cartesian" && (this.euler.y = we.clamp(this.euler.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel)), this.euler.x = we.clamp(this.euler.x, -this.PI_2 + (this.cameraPolarOffset < 0 ? this.cameraPolarOffset : 0), this.PI_2 + (this.cameraPolarOffset > 0 ? this.cameraPolarOffset : 0));
        }
        return this.eulerDelta.set(0, 0, 0), this.object.dispatchEvent(XJ), this.path.length < 2 && this.lastPosition.distanceToSquared(this.position) < this.threshEndTranslate && Math.abs(this.rotVelocity.x) < this.threshEndRotVel && Math.abs(this.rotVelocity.y) < this.threshEndRotVel && (this.camera === void 0 || this.isFirstPerson || this.lastCameraPosition.distanceToSquared(this.camera.position) < this.threshEndTranslate && 8 * (1 - this.lastCameraQuaternion.dot(this.camera.quaternion)) < this.threshEndRotate) && (this.moveMode === "fly" || this.onObject === !0 || this.collisionEnabled === !1) && (this.navMeshPathDest === null || this.navMeshPathDest.material.opacity < -0.04 * this.navMeshPathDest?.material?.userData.opacity0) ? !1 : (this.camera && (this.lastCameraPosition.copy(this.camera.position), this.lastCameraQuaternion.copy(this.camera.quaternion)), this.lastPosition.copy(this.position), this.object.dispatchEvent(YJ), !0);
    }
    updateFollowArms() {
        this.objectToTarget.copy(this.objectToTarget0), this.targetToCamera.copy(this.targetToCamera0);
        let e = ro.setFromAxisAngle(io, this.cameraYAxis === "Limit" && this.orientMode !== "radial" ? we.clamp(this.euler.y - this.euler0.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel) : this.euler.y - this.euler0.y);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && this.objectToTarget.applyQuaternion(e);
        let r;
        this.cameraXAxis === "Limit" ? r = we.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : r = we.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset + 1e-6, this.PI_2 + this.cameraPolarOffset - 1e-6);
        let i = Tn.copy(this.cameraPolarAxis0);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && i.applyQuaternion(e);
        let s = za.setFromAxisAngle(i, r);
        this.cameraYAxis !== "Locked" && this.targetToCamera.applyQuaternion(e), this.cameraXAxis !== "Locked" && this.targetToCamera.applyQuaternion(s);
    }
    groundTiltAdjustment(e) {
        io.angleTo(e) * 180 / Math.PI < 15 || io.angleTo(e) * 180 / Math.PI > 85 ? ro.identity() : ro.setFromUnitVectors(io, e), this.groundTilt.slerp(ro, .06), this.groundTiltInv.copy(this.groundTilt).invert();
    }
    collisionAdjustment(e) {
        let r = IN.set(0, 0, 0);
        this.object.matrix.compose(this.position, this.quaternion, this.scale);
        let i = GT.multiplyMatrices(this.object.matrix, this.objXZRotMat).multiply(this.collider.matrix).decompose(Tn, ro, Un).compose(Tn, ro, ON);
        this.sharedGameControlGlobals.entitiesWithTransformAnim.forEach((o)=>{
            if (o === this.object || o.isDescendantOf(this.object)) return;
            Ms.makeEmpty(), o.updateMatrixWorldSVD();
            let a = o.matrixWorldRigid, l = DN.copy(a).invert(), c = UJ.copy(DN).multiply(i);
            Hi.copy(this.collider.segment), Hi.start.applyMatrix4(c), Hi.end.applyMatrix4(c);
            let u = _N.copy(this.position).applyMatrix4(l);
            Ms.expandByPoint(Hi.start), Ms.expandByPoint(Hi.end), Ms.min.addScalar(-this.collider.radius), Ms.max.addScalar(this.collider.radius), o.bvhGeometry.boundsTree.shapecast({
                traverseBoundsOrder (h) {
                    return h.distanceToPoint(Hi.end);
                },
                intersectsBounds: (h)=>h.intersectsBox(Ms),
                intersectsTriangle: (h)=>{
                    let d = Tn, f = Un, p = h.closestPointToSegment(Hi, d, f);
                    if (p < this.collider.radius) {
                        let m = this.collider.radius - p, g = f.sub(d).normalize(), y = nc.copy(u);
                        y.addScaledVector(g, m);
                        let x = y.applyMatrix4(a).sub(this.position);
                        r.add(x), Hi.start.addScaledVector(g, m), Hi.end.addScaledVector(g, m);
                    }
                }
            });
        }), Ms.makeEmpty(), Hi.copy(this.collider.segment), Hi.start.applyMatrix4(i), Hi.end.applyMatrix4(i), Ms.expandByPoint(Hi.start), Ms.expandByPoint(Hi.end), Ms.min.addScalar(-this.collider.radius), Ms.max.addScalar(this.collider.radius), this.sharedGameControlGlobals.staticMeshBVH?.shapecast({
            traverseBoundsOrder (o) {
                return o.distanceToPoint(Hi.end);
            },
            intersectsBounds: (o)=>o.intersectsBox(Ms),
            intersectsTriangle: (o)=>{
                let a = Tn, l = Un, c = o.closestPointToSegment(Hi, a, l);
                if (c < this.collider.radius) {
                    let u = this.collider.radius - c, h = l.sub(a).normalize();
                    this.alignToGround && this.groundTiltAdjustment(h), r.addScaledVector(h, u), Hi.start.addScaledVector(h, u), Hi.end.addScaledVector(h, u);
                }
            }
        }), this.onObject = Math.abs(r.y) > Math.abs(e * this.velocity.y * .25), this.onObject && this.dispatchStopEvent("jump");
        let s = Math.max(0, r.length() - 1e-5);
        r.normalize().multiplyScalar(s), this.position.add(r);
    }
}, mg = Cb;
mg.isLocked = !1;
var BN = Wa(m1());
function no(n1, t) {
    let e = new _e;
    if (t) {
        let s = t.elements, o = s[0] ** 2 + s[1] ** 2 + s[2] ** 2, a = s[4] ** 2 + s[5] ** 2 + s[6] ** 2, l = s[8] ** 2 + s[9] ** 2 + s[10] ** 2, c = s[0] ** 2 + s[4] ** 2 + s[8] ** 2, u = s[1] ** 2 + s[5] ** 2 + s[9] ** 2, h = s[2] ** 2 + s[6] ** 2 + s[10] ** 2, d = 1e-8;
        if (o < d || a < d || l < d || c < d || u < d || h < d) return e.setAttribute("position", new Te([], 3)), e.setIndex([]), e;
    }
    if (!n1.getAttribute("position")) return e.setAttribute("position", new Te([], 3)), e.setIndex([]), e;
    let { positions: r, triIndices: i } = jc(n1.getAttribute("position"), n1.getIndex());
    return e.setAttribute("position", new Te(r, 3)), e.setIndex(i), t && e.applyMatrix4(t), e;
}
var KJ = new ue, QJ = new ue, Ko = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
function HT(n1) {
    let t = n1.elements;
    Ko[0][0] = t[0], Ko[0][1] = t[4], Ko[0][2] = t[8], Ko[1][0] = t[1], Ko[1][1] = t[5], Ko[1][2] = t[9], Ko[2][0] = t[2], Ko[2][1] = t[6], Ko[2][2] = t[10];
    let { u: e, v: r } = (0, BN.SVD)(Ko), i = KJ.set(e[0][0], e[0][1], e[0][2], 0, e[1][0], e[1][1], e[1][2], 0, e[2][0], e[2][1], e[2][2], 0, 0, 0, 0, 1), s = QJ.set(r[0][0], r[0][1], r[0][2], 0, r[1][0], r[1][1], r[1][2], 0, r[2][0], r[2][1], r[2][2], 0, 0, 0, 0, 1);
    return i.multiply(s.transpose());
}
var _b = class extends Zu {
    constructor(){
        super(), this.layers.enable(3), this.layers.enable(8);
    }
    setFromCamera(t, e) {
        e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : e.isPerspectiveCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : console.error("Raycaster: Unsupported camera type.");
    }
    intersectVisibleObjects(t, e = !0, r = []) {
        return t.forEach((i)=>{
            i.visible && this.intersectObject(i, e, r);
        }), r;
    }
    createRaycastLineHelper() {
        let t = new ss({
            color: 65280,
            linewidth: 10
        }), e = new E(this.ray.origin.x, this.ray.origin.y, this.ray.origin.z), r = new E(this.ray.direction.x, this.ray.direction.y, this.ray.direction.z), i = this.camera.far - this.camera.near, s = new E().addVectors(e, r.multiplyScalar(i)), o = new _e;
        return o.setFromPoints([
            e,
            s
        ]), new bc(o, t);
    }
};
var NN = (n1)=>n1 instanceof As || n1 instanceof eo;
function ZJ(n1, t) {
    return n1.distance - t.distance;
}
function FN(n1, t, e) {
    if (!(!Ro(t) || !t.visible)) {
        cn(t) && t.raycast(n1, e);
        for (let r of t.children)FN(n1, r, e);
    }
}
function Vf(n1, t, e, r = !1) {
    if (!r && !e.some((s)=>kf(n1, s) !== void 0)) return [];
    let i = [];
    return t.children.forEach((s)=>FN(n1, s, i)), i.sort(ZJ), i;
}
function gg(n1) {
    let t = [];
    if (n1.length) {
        let e = n1[0].object;
        Ro(e) && t.push(e);
        let r = e.parent;
        for(; r;)NN(r) && t.push(r), r = r.parent;
    }
    return t;
}
function so(n1, t, e, r) {
    let i = n1.frame;
    if (i) {
        let s = t[0] * i.width, o = (1 - t[1]) * i.height;
        for (let a of e){
            let l = a === i.uuid ? i : i.find(a);
            if (l?.intersects(s, o)) return r(l), !0;
        }
    }
    return !1;
}
function kf(n1, t) {
    if (cn(t)) {
        if (t.visible) {
            let e = [];
            return t.raycast(n1, e), e.length ? e[0] : void 0;
        }
    } else if (NN(t)) return VN(n1, t);
}
function VN(n1, t) {
    if (!(!Ro(t) || !t.visible)) {
        if (cn(t)) {
            let e = [];
            if (t.raycast(n1, e), e.length) return e[0];
        }
        for (let e of t.children){
            let r = VN(n1, e);
            if (r) return r;
        }
    }
}
function JJ(n1, t, e) {
    return {
        x: (n1 - (e.left + window.scrollX)) / e.width * 2 - 1,
        y: -((t - (e.top + window.scrollY)) / e.height) * 2 + 1
    };
}
function $J(n1, t, e) {
    return {
        x: (n1 - (e.left + window.scrollX)) / e.width,
        y: 1 - (t - (e.top + window.scrollY)) / e.height
    };
}
var Ib = class {
    constructor(t, e, r, i, s, o, a, l){
        this.renderer = t;
        this.publish = e;
        this.scene = r;
        this.getCamera = i;
        this.sharedAssets = s;
        this.requestRender = o;
        this.isExport = a;
        this.frame = l;
        this.raycaster = new _b;
        this._useWindowEvents = !1;
        this.pointerWorld = {
            x: 0,
            y: 0
        };
        this.pointerScreen = {
            x: 0,
            y: 0
        };
        this._useWindowEvents = e.mouseEventTarget === "window", this.domElement = t.domElement, this.eventElement = this._useWindowEvents ? window : t.domElement, this._domRect = this.domElement.getBoundingClientRect();
    }
    get stopRaycast() {
        return this.publish.stopRaycast;
    }
    get page() {
        return this.scene.activePage;
    }
    set useWindowEvents(t) {
        this._useWindowEvents = t, this.eventElement = t ? window : this.renderer.domElement;
    }
    get useWindowEvents() {
        return this._useWindowEvents;
    }
    set domRect(t) {
        this._domRect = t;
    }
    get domRect() {
        return this._domRect;
    }
    updateRaycaster(t) {
        let { pageX: e, pageY: r } = t.touches?.length > 0 ? t.touches[0] : t;
        this.pointerWorld = JJ(e, r, this._domRect), this.pointerScreen = $J(e, r, this._domRect), this.raycaster.setFromCamera(this.pointerWorld, this.getCamera());
    }
};
var Yt = class {
    constructor(t){
        this.eventContext = t;
        this.domEventsNeeded = new Set;
        this.hasVideoAction = !1;
    }
    connect() {}
    disconnect() {}
};
var WT = [
    [
        "start",
        "Start"
    ],
    [
        "keyDown",
        "KeyDown"
    ],
    [
        "keyUp",
        "KeyUp"
    ],
    [
        "mouseDown",
        "MouseDown"
    ],
    [
        "mouseUp",
        "MouseUp"
    ],
    [
        "mouseHover",
        "MouseHover"
    ],
    [
        "collision",
        "Collision"
    ],
    [
        "lookAt",
        "LookAt"
    ],
    [
        "follow",
        "Follow"
    ],
    [
        "scroll",
        "Scroll"
    ]
], kN = (n1)=>WT.find(([t, e])=>e === n1)?.[0], Qo = (n1)=>WT.find(([t])=>t === n1)?.[1], e$ = (n1, t)=>{
    let e = kN(n1);
    if (e) {
        let r = new CustomEvent(e, {
            bubbles: !0
        });
        return Object.defineProperty(r, "target", {
            writable: !1,
            value: t
        }), r;
    }
}, Db = class extends Yt {
    constructor(){
        super(...arguments);
        this.objectsPerEvents = new Map;
        this.splineEvents = {};
        this.onBeginEvent = (e)=>{
            if (!e.eventName || !e.target || e.eventName === "Scroll") return;
            let r = this.splineEvents[kN(e.eventName)]?.[e.target.uuid];
            if (!r) return;
            e.eventName === "Scroll" && e.deltaY !== void 0 && Object.assign(r, {
                deltaY: e.deltaY
            });
            let { domElement: i } = this.eventContext;
            i.dispatchEvent(r);
        };
    }
    connect() {
        let { page: e } = this.eventContext;
        e.traverseEntity((r)=>{
            if (!!r.data?.events.length) {
                for (let [i, s] of WT)if (r.data.events.some((o)=>o.data.type === s && !o.data.disabled)) {
                    this.objectsPerEvents.has(i) ? this.objectsPerEvents.get(i)?.push(r) : this.objectsPerEvents.set(i, [
                        r
                    ]);
                    let o = {
                        id: r.uuid,
                        name: r.name
                    }, a = e$(s, o), l = this.splineEvents[i];
                    l ? l[r.uuid] = a : this.splineEvents[i] = {
                        [r.uuid]: a
                    };
                }
            }
        }), this.objectsPerEvents.forEach((r)=>{
            r.forEach((i)=>{
                i.addEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
    disconnect() {
        this.objectsPerEvents.forEach((e)=>{
            e.forEach((r)=>{
                r.removeEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
};
var qT = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.entered = !1;
        if ((e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress") && !e.key) throw new Error("Missing property");
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    disconnect() {
        hr(this.actions);
    }
    dispatchHeld(t) {
        this.actions.Create.forEach((e)=>{
            t && e.dispatchThrottled.cancel(), e.dispatchThrottled();
        });
    }
    dispatch(t = !1) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), this.data.type === "MousePress" || this.data.type === "KeyPress" ? this.entered || (this.entered = !0, this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatchStart())) : (this.actions.Transition.some((i)=>i.playing && i.data.runMode !== "Toggle") || this.actions.Transition.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        }), this.actions.SwitchCamera.some((i)=>i.playing && i.data.runMode !== "Toggle") || this.actions.SwitchCamera.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        }), this.actions.Animation.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        })), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.SceneTransition.forEach((e)=>{
            e.dispatch();
        }), t === !1 && this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
    dispatchRelease() {
        this.entered && (this.entered = !1, this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.Particles.forEach((t)=>t.reverseFromCurrent()), this.actions.Animation.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()), this.actions.Create.forEach((t)=>t.dispatchStop()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.SceneTransition.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, Ob = class extends Yt {
    constructor(e, r, i){
        super(e);
        this.eventManager = r;
        this.useForRaycastProperty = i;
        this.objectsPerTypes = {
            MouseDown: [],
            MouseUp: [],
            MousePress: [],
            KeyDown: [],
            KeyUp: [],
            KeyPress: []
        };
        this.canvasMouseEvents = [];
        this.eventsPerObjects = {
            MouseDown: {},
            MouseUp: {},
            MousePress: {},
            KeyDown: {},
            KeyUp: {},
            KeyPress: {}
        };
        this.heldKeys = {};
        this.heldKeysPress = {};
        this._prevObjects = [];
        this.sceneInterects = null;
        this.onCanvasRaycast = (e)=>{
            if (this.useForRaycastProperty === !0 && this.sceneInterects === null) {
                this.eventContext.updateRaycaster(e);
                let { raycaster: r, page: i } = this.eventContext, s = Vf(r, i, [], !0);
                this.sceneInterects = s, s.length && (this.eventContext.sharedAssets.raycastProperty = {
                    x: s[0].point.x,
                    y: s[0].point.y,
                    z: s[0].point.z,
                    objX: s[0].object.matrixWorld.elements[12],
                    objY: s[0].object.matrixWorld.elements[13],
                    objZ: s[0].object.matrixWorld.elements[14]
                });
            }
        };
        this.onCanvasMouseDown = (e)=>{
            (e.target === this.eventContext.domElement || e.target.tagName === "SPLINE-VIEWER") && this.canvasMouseEvents.forEach((r)=>{
                (r.data.type === "MouseDown" || r.data.type === "MousePress") && (this.onCanvasRaycast(e), r.dispatch());
            });
        };
        this.onCanvasMouseUp = (e)=>{
            (e.target === this.eventContext.domElement || e.target.tagName === "SPLINE-VIEWER") && this.canvasMouseEvents.forEach((r)=>{
                r.data.type === "MouseUp" ? (this.onCanvasRaycast(e), r.dispatch()) : r.data.type === "MousePress" && r.dispatchRelease();
            });
        };
        this.onMouseDown = (e)=>{
            Je.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseDown"));
        };
        this.onMouseUp = (e)=>{
            Je.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseUp"));
        };
        this.onMousePressDown = (e)=>{
            Je.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent());
        };
        this.onMousePressRelease = (e)=>{
            Je.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent(!0));
        };
        this.onKeyDown = (e)=>{
            this.heldKeys[e.key] || (this.handleKeyEvent(e, "KeyDown"), this.handleKeyEventHeld(e, "KeyDown", !0)), this.heldKeys[e.key] = !0;
        };
        this.onKeyUp = (e)=>{
            this.handleKeyEvent(e, "KeyUp"), this.handleKeyEventHeld(e, "KeyUp", !0);
        };
        this.onKeyPressDown = (e)=>{
            this.heldKeysPress[e.key] ? this.handleKeyEventHeld(e, "KeyPress") : (this.handleKeyEvent(e, "KeyPress"), this.handleKeyEventHeld(e, "KeyPress", !0)), this.heldKeysPress[e.key] = !0;
        };
        this.onKeyPressUp = (e)=>{
            this.handleKeyEvent(e, "KeyPress", !0);
        };
        this.releaseHeldKey = (e)=>{
            delete this.heldKeys[e.key];
        };
        this.releaseHeldKeyPress = (e)=>{
            delete this.heldKeysPress[e.key];
        };
        this._onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = Qo(e);
            s && (s === "MouseDown" || s === "MouseUp" || s === "MousePress" ? (r.dispatchEvent({
                type: "beginEvent",
                eventName: s
            }), this.eventsPerObjects[s]?.[r.uuid]?.forEach((o)=>{
                o.dispatchUserEvent(i);
            })) : (s === "KeyDown" || s === "KeyUp" || s === "KeyPress") && (r.dispatchEvent({
                type: "beginEvent",
                eventName: s
            }), this.eventsPerObjects[s]?.[r.uuid]?.forEach((o)=>{
                o.dispatchUserEvent();
            })));
        };
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i } = this.eventContext, s = (o, a)=>{
            if (!o.data?.events.length) return;
            let l = [
                "MouseDown",
                "MouseUp",
                "MousePress",
                "KeyDown",
                "KeyUp",
                "KeyPress"
            ];
            for (let c of l){
                let u = this.eventsPerObjects[c];
                o.data.events.filter(({ data: h })=>h.type === c && h.disabled !== !0).forEach(({ id: h, data: d })=>{
                    try {
                        let f = new qT(h, d, o, e, r, this.eventManager);
                        f.actions.Video.length && (this.hasVideoAction = !0), (d.type === "MouseDown" || d.type === "MouseUp" || d.type === "MousePress") && (d.mode === "Canvas" || d.mode === "Window") ? this.canvasMouseEvents.push(f) : u[o.uuid] ? u[o.uuid].some((p)=>p.id === f.id) || u[o.uuid].push(f) : u[o.uuid] = [
                            f
                        ];
                    } catch (f) {}
                }), u[o.uuid]?.length && this.objectsPerTypes[c].push(o instanceof rr && (c === "MouseDown" || c === "MouseUp" || c === "MousePress") ? a : o);
            }
        };
        e.traverseEntity((o)=>{
            (o instanceof Er || o instanceof ur) && o.frame?.traverse((a)=>{
                s(a, o);
            }), s(o);
        }), this.heldKeys = {}, this.heldKeysPress = {}, this.domEventsNeeded.clear(), i.addEventListener("pointerdown", this.onCanvasMouseDown), i.addEventListener("pointerup", this.onCanvasMouseUp), (this.objectsPerTypes.MouseDown?.length || this.useForRaycastProperty) && (this.domEventsNeeded.add("pointerdown"), i.addEventListener("pointerdown", this.onMouseDown)), this.objectsPerTypes.MouseUp?.length && (this.domEventsNeeded.add("pointerup"), i.addEventListener("pointerup", this.onMouseUp)), this.objectsPerTypes.MousePress?.length && (this.domEventsNeeded.add("pointerdown"), i.addEventListener("pointerdown", this.onMousePressDown), this.domEventsNeeded.add("pointerup"), i.addEventListener("pointerup", this.onMousePressRelease)), this.objectsPerTypes.KeyDown?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.releaseHeldKey)), this.objectsPerTypes.KeyUp?.length && (this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyUp)), this.objectsPerTypes.KeyPress?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyPressDown), document.addEventListener("keyup", this.releaseHeldKeyPress), this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyPressUp)), Object.entries(this.objectsPerTypes).forEach(([o, a])=>{
            a.forEach((l)=>{
                l.addEventListener("userEvent", this._onUserEvent);
            });
        });
    }
    disconnect() {
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), this.heldKeys = {}, this.heldKeysPress = {}, e.removeEventListener("pointerdown", this.onCanvasMouseDown), e.removeEventListener("pointerup", this.onCanvasMouseUp), e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerdown", this.onMousePressDown), e.removeEventListener("pointerup", this.onMouseUp), e.removeEventListener("pointerup", this.onMousePressRelease), document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keydown", this.onKeyPressDown), document.removeEventListener("keyup", this.onKeyPressUp), document.removeEventListener("keyup", this.releaseHeldKey), Object.values(this.eventsPerObjects).forEach((r)=>{
            Object.values(r).forEach((i)=>{
                i.forEach((s)=>{
                    s.disconnect();
                });
            });
        }), this.canvasMouseEvents.forEach((r)=>{
            r.disconnect();
        }), Object.entries(this.objectsPerTypes).forEach(([r, i])=>{
            i.forEach((s)=>{
                s.removeEventListener("userEvent", this._onUserEvent);
            });
        });
    }
    handleMouseEvent(e) {
        let { stopRaycast: r, raycaster: i, page: s, pointerScreen: o } = this.eventContext, a = this.objectsPerTypes[e], l = a.filter((c)=>!(c instanceof rr));
        if (!(!a.length && !this.useForRaycastProperty) && !(s.uiCanvas && so(s, [
            o.x,
            o.y
        ], Object.keys(this.eventsPerObjects[e]), (u)=>{
            this.handleObjectMouseEventDispatch(u, e);
        }))) {
            if (r || this.useForRaycastProperty) {
                let c;
                if (this.sceneInterects === null ? c = Vf(i, s, l, this.useForRaycastProperty) : (c = this.sceneInterects, this.sceneInterects = null), this.useForRaycastProperty && c.length && (this.eventContext.sharedAssets.raycastProperty = {
                    x: c[0].point.x,
                    y: c[0].point.y,
                    z: c[0].point.z,
                    objX: c[0].object.matrixWorld.elements[12],
                    objY: c[0].object.matrixWorld.elements[13],
                    objZ: c[0].object.matrixWorld.elements[14]
                }), r) {
                    let u = [
                        c[0]?.uv?.x ?? 0,
                        c[0]?.uv?.y ?? 0
                    ];
                    gg(c).forEach((h)=>{
                        h instanceof Er && so(h, u, Object.keys(this.eventsPerObjects[e]), (d)=>{
                            this.handleObjectMouseEventDispatch(d, e);
                        }), this.eventsPerObjects[e][h.uuid] && this.handleObjectMouseEventDispatch(h, e);
                    });
                }
            }
            r || l.forEach((c)=>{
                let u = kf(i, c);
                u && (this.handleObjectMouseEventDispatch(c, e), c instanceof Er && so(c, [
                    u?.uv?.x ?? 0,
                    u?.uv?.y ?? 0
                ], Object.keys(this.eventsPerObjects[e]), (h)=>{
                    this.handleObjectMouseEventDispatch(h, e);
                }));
            });
        }
    }
    handleMousePressEvent(e = !1) {
        let r = "MousePress", i = this.objectsPerTypes[r], s = i.filter((a)=>!(a instanceof rr)), o = [];
        if (!!i.length) {
            if (!e) {
                let { stopRaycast: a, raycaster: l, page: c, pointerScreen: u } = this.eventContext, h = !1;
                if (c.uiCanvas && (h = so(c, [
                    u.x,
                    u.y
                ], Object.keys(this.eventsPerObjects[r]), (d)=>{
                    o.push(d);
                })), a && !h) {
                    let d = Vf(l, c, s);
                    o = gg(d), d.forEach((f)=>{
                        f.object instanceof Er && so(f.object, [
                            f?.uv?.x ?? 0,
                            f?.uv?.y ?? 0
                        ], Object.keys(this.eventsPerObjects[r]), (p)=>{
                            o.push(p);
                        });
                    });
                } else s.forEach((d)=>{
                    let f = kf(l, d);
                    f && (o.push(d), d instanceof Er && so(d, [
                        f?.uv?.x ?? 0,
                        f?.uv?.y ?? 0
                    ], Object.keys(this.eventsPerObjects[r]), (p)=>{
                        o.push(p);
                    }));
                });
            }
            this._prevObjects.length && this._prevObjects.forEach((a)=>{
                o.includes(a) || this.handleObjectMouseEventDispatchRelease(a, r);
            }), o.length && o.forEach((a)=>{
                this.handleObjectMouseEventDispatch(a, r);
            }), this._prevObjects = o;
        }
    }
    handleObjectMouseEventDispatch(e, r) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: r
        }), this.eventsPerObjects[r]?.[e.uuid]?.forEach((i)=>{
            i.dispatch();
        });
    }
    handleObjectMouseEventDispatchRelease(e, r) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: r
        }), this.eventsPerObjects[r]?.[e.uuid]?.forEach((i)=>{
            i.dispatchRelease();
        });
    }
    handleKeyEvent(e, r, i = !1) {
        this.objectsPerTypes[r].forEach((s)=>{
            let o = this.eventsPerObjects[r][s.uuid];
            o.some(({ data: a })=>"key" in a && a.key === e.key) && s.dispatchEvent({
                type: "beginEvent",
                eventName: r
            }), o.forEach((a)=>{
                "key" in a.data && a.data.key === e.key && (i ? a.dispatchRelease() : a.dispatch(!0));
            });
        });
    }
    handleKeyEventHeld(e, r, i = !1) {
        this.objectsPerTypes[r].forEach((s)=>{
            this.eventsPerObjects[r][s.uuid].forEach((a)=>{
                "key" in a.data && a.data.key === e.key && a.dispatchHeld(i);
            });
        });
    }
};
var t$ = new E, r$ = new E;
var Rb = class {
    constructor(t, e, r, i, s){
        this.actionsIn = Ut(t, t.inActions, r, i, s, e), this.actionsOut = Ut(t, t.outActions, r, i, s, e);
    }
    disconnect() {
        hr(this.actionsIn), hr(this.actionsOut);
    }
};
var YT = class extends Rb {
    constructor(e, r, i, s, o, a){
        super(r, i, s, o, a);
        this.id = e;
        this.data = r;
        this.object = i;
        this.stage = "out";
        this.objects = [];
        this.onUpdateMatrixWorld = ()=>{
            for (let s of this.objects)if (!s.visible) return;
            let e = t$.setFromMatrixPosition(this.objects[0].matrixWorld), r = r$.setFromMatrixPosition(this.objects[1].matrixWorld), i = e.distanceTo(r) <= this.distance ? "in" : "out";
            if (this.stage !== i) {
                this.stage = i;
                let s = i === "in" ? this.actionsIn : this.actionsOut;
                s.Audio.forEach((o)=>o.dispatchConditional()), s.Particles.forEach((o)=>o.dispatchConditional()), s.Video.forEach((o)=>o.dispatchConditional()), s.Link.forEach((o)=>o.dispatch()), s.Create.forEach((o)=>o.dispatch()), s.Destroy.forEach((o)=>o.dispatch()), s.Reset.forEach((o)=>o.dispatch()), s.Transition.forEach((o)=>{
                    o.object.currentTransitionEvent !== this && (o.object.currentTransitionEvent = this), o.init();
                }), s.Transition.forEach((o)=>o.play()), s.Animation.forEach((o)=>o.play()), s.SwitchCamera.forEach((o)=>o.play()), s.SceneTransition.forEach((o)=>o.dispatch()), s.SetVariable.forEach((o)=>o.checkConditions()), s.SetVariable.forEach((o)=>o.dispatch()), s.DynamicVariablePlay.forEach((o)=>o.dispatch()), s.ClearLocalStorage.forEach((o)=>o.dispatch()), s.UserAPI.forEach((o)=>o.dispatch());
            }
        };
        let { distance: l, fromObject: c, toObject: u } = r.condition;
        this.distance = l;
        for (let h of [
            c,
            u
        ]){
            if (!h) throw new Error("Missing property");
            let d = s.find(h);
            if (!d) throw new Error("Missing property");
            this.objects.push(d);
        }
    }
    connect() {
        window.setTimeout(()=>{
            this.objects.forEach((e)=>{
                e.addEventListener("updateMatrixWorld", this.onUpdateMatrixWorld);
            }), this.onUpdateMatrixWorld();
        }, 0);
    }
    disconnect() {
        super.disconnect(), this.stage = "out", this.objects.forEach((e)=>{
            e.removeEventListener("updateMatrixWorld", this.onUpdateMatrixWorld);
        });
    }
}, XT = class extends Rb {
    constructor(e, r, i, s, o, a){
        super(r, i, s, o, a);
        this.id = e;
        this.data = r;
        this.object = i;
        this.onBegin = ({ target: e, state: r })=>{
            this.toState !== r && (this.actionsOut.Audio.forEach((i)=>i.dispatchConditional()), this.actionsOut.Particles.forEach((i)=>i.dispatchConditional()), this.actionsOut.Video.forEach((i)=>i.dispatchConditional()), this.actionsOut.Link.forEach((i)=>i.dispatch()), this.actionsOut.Create.forEach((i)=>i.dispatch()), this.actionsOut.Destroy.forEach((i)=>i.dispatch()), this.actionsOut.Reset.forEach((i)=>i.dispatch()), this.actionsIn.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsOut.Transition.forEach((i)=>i.play()), this.actionsOut.Animation.forEach((i)=>i.play()), this.actionsIn.SwitchCamera.forEach((i)=>i.pause()), this.actionsOut.SwitchCamera.forEach((i)=>i.play()), this.actionsOut.SceneTransition.forEach((i)=>i.dispatch()), this.actionsOut.SetVariable.forEach((i)=>i.checkConditions()), this.actionsOut.SetVariable.forEach((i)=>i.dispatch()), this.actionsOut.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.actionsOut.ClearLocalStorage.forEach((i)=>i.dispatch()), this.actionsOut.UserAPI.forEach((i)=>i.dispatch()));
        };
        this.onComplete = ({ target: e, state: r })=>{
            this.toState === r && (this.actionsIn.Audio.forEach((i)=>i.dispatchConditional()), this.actionsIn.Particles.forEach((i)=>i.dispatchConditional()), this.actionsIn.Video.forEach((i)=>i.dispatchConditional()), this.actionsIn.Link.forEach((i)=>i.dispatch()), this.actionsIn.Create.forEach((i)=>i.dispatch()), this.actionsIn.Destroy.forEach((i)=>i.dispatch()), this.actionsIn.Reset.forEach((i)=>i.dispatch()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsIn.Transition.forEach((i)=>i.play()), this.actionsIn.Animation.forEach((i)=>i.play()), this.actionsOut.SwitchCamera.forEach((i)=>i.pause()), this.actionsIn.SwitchCamera.forEach((i)=>i.play()), this.actionsIn.SceneTransition.forEach((i)=>i.dispatch()), this.actionsIn.SetVariable.forEach((i)=>i.checkConditions()), this.actionsIn.SetVariable.forEach((i)=>i.dispatch()), this.actionsIn.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.actionsOut.ClearLocalStorage.forEach((i)=>i.dispatch()), this.actionsOut.UserAPI.forEach((i)=>i.dispatch()));
        };
        let { condition: l } = r;
        if (!l.object) throw new Error("Missing property");
        let c = s.find(l.object) ?? s.scene.find2D(l.object);
        if (!c) throw new Error("Missing property");
        if (this.toObject = c, l.state && !this.toObject.states?.[l.state]) throw new Error("Missing property");
        this.toState = l.state;
    }
    connect() {
        ls(this.actionsOut).forEach((e)=>{
            this.actionsOut[e]?.length && this.toObject.addEventListener("beginState", this.onBegin);
        }), ls(this.actionsIn).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.addEventListener("completeState", this.onComplete);
        });
    }
    disconnect() {
        super.disconnect(), ls(this.actionsOut).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.removeEventListener("beginState", this.onBegin);
        }), ls(this.actionsIn).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.removeEventListener("completeState", this.onComplete);
        });
    }
}, Lb = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerConditions = {
            Comparison: [],
            Distance: [],
            State: []
        };
        this.hasVideoAction = !1;
    }
    connect() {
        super.connect();
        let { page: e, sharedAssets: r } = this.eventContext;
        e.traverseEntity((i)=>{
            if (!!i.data?.events.length) {
                for (let { id: s, data: o } of i.data.events)if (!o.disabled && o.type === "Conditional") try {
                    let a;
                    o.condition.type === "Comparison" || (o.condition.type === "Distance" ? a = new YT(s, o, i, e, r, this.eventManager) : o.condition.type === "State" && (a = new XT(s, o, i, e, r, this.eventManager))), a && (this.eventsPerConditions[o.condition.type].push(a), (a.actionsIn.Video.length || a.actionsOut.Video.length) && (this.hasVideoAction = !0));
                } catch (a) {}
            }
        }), Object.values(this.eventsPerConditions).forEach((i)=>i.forEach((s)=>s.connect()));
    }
    disconnect() {
        super.disconnect(), Object.values(this.eventsPerConditions).forEach((e)=>e.forEach((r)=>r.disconnect()));
    }
};
var yg = new E, sc = new E, su = new E, UN = new kr, i$ = .01, ir = new E, Di = new E, zN = new E, ou = new Ke, KT = new nr, n$ = new ue, QT = new fr, Uf = new E, Zo = new E, zf = .2;
function ZT(n1, t) {
    !t || (t[0] < t[1] && (n1.x = Math.min(Math.max(n1.x, t[0]), t[1])), t[2] < t[3] && (n1.y = Math.min(Math.max(n1.y, t[2]), t[3])), t[4] < t[5] && (n1.z = Math.min(Math.max(n1.z, t[4]), t[5])));
}
var s$ = function() {
    let n1 = new ue;
    return (t, e, r)=>{
        let i = t.obj;
        n1.copy(i.hiddenMatrix), i.parent !== null && n1.premultiply(i.parent.matrixWorld), n1.invert(), i.position.copy(e), t.reference === "global" && ZT(i.position, t.limits), i.position.applyMatrix4(n1), t.reference === "parent" ? ZT(i.position, t.limits) : t.reference === "local" && (ou.copy(t.quat0).invert(), i.position.sub(t.position0), i.position.applyQuaternion(ou), ZT(i.position, t.limits), ou.invert(), i.position.applyQuaternion(ou), i.position.add(t.position0)), n1.multiply(r ?? i.matrixWorld).decompose(ir, i.quaternion, Di), i.updateMatrix(), i.hasNonUniformScale && (i.updateMatrixWorld(), i.updateMatrixWorldSVD()), i instanceof mr && En(i.parent) && i.invalidateDownstreamBooleanData(!0);
    };
}(), JT = class {
    constructor(t, e, r, i, s, o, a){
        this.object = t;
        this.id = e;
        this.data = r;
        this.dropDestIds = [];
        this.activeIdx = null;
        this.wasDragEventTriggered = !1;
        this.resetDampingFactor = this.data.resetSpeed === 0 ? 1 : 8 / this.data.resetSpeed + 1, this.snapDampingFactor = this.data.snapSpeed === 0 ? 1 : 8 / this.data.snapSpeed + 1, this.actionsDrag = Ut(r, r.dragDropActions.drag, i, s, o, this.object), this.actionsDrop = Ut(r, r.dragDropActions.drop, i, s, o, this.object);
        let l = [];
        this.data.objects.forEach((c)=>{
            let u = i.find(c);
            !u || u.data.visible !== !1 && (l.push(u), a[u.uuid] && a[u.uuid].forEach((h)=>{
                let d = i.find(h);
                !d || d.data.visible !== !1 && l.push(d);
            }));
        }), this.data.dropDestinations.forEach((c)=>{
            let u = i.find(c);
            !u || u.data.visible !== !1 && (this.dropDestIds.push(u.uuid), a[u.uuid] && a[u.uuid].forEach((h)=>{
                let d = i.find(h);
                !d || d.data.visible !== !1 && this.dropDestIds.push(d.uuid);
            }));
        }), this.dragItems = l.map((c)=>(this.data.planeMode === "locked" && (c.userData.lockedPlane = !0), c.userData.worldPosition0 = new E().setFromMatrixPosition(c.matrixWorld), {
                obj: c,
                fromPosition: new E().setFromMatrixPosition(c.matrixWorld),
                pointStart: new E,
                pointEnd: new E,
                paused: !0,
                currentDampingFactor: this.data.dampingFactor,
                reset: !1,
                position0: new E().copy(c.position),
                quat0: new Ke().copy(c.quaternion),
                snapped: !1,
                orientationMatrix: new ue,
                limits: this.data.limits,
                reference: this.data.referenceFrame
            }));
    }
    get activeDragItem() {
        return this.activeIdx !== null ? this.dragItems[this.activeIdx] : null;
    }
    dispose() {
        hr(this.actionsDrag), hr(this.actionsDrop), this.dragItems.forEach((t)=>{
            t.fromPosition.copy(t.obj.userData.worldPosition0), t.pointStart.copy(t.fromPosition), t.pointEnd.copy(t.pointStart), t.obj.recursiveBBoxNeedsUpdate = !0, t.obj.userData.lockedPlane = void 0, t.obj.position.copy(t.position0), t.obj.quaternion.copy(t.quat0), t.obj.updateMatrix();
        });
    }
}, Bb = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.lastDropDestination = null;
        this.dragTimeout = null;
        this.onPointerDown = (e)=>{
            if (Je.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: r, page: i } = this.eventContext, s = i.raycastWithClones(r);
            if (this.lastDropDestination = null, s.length === 0) {
                this.activeEvent = null;
                return;
            }
            for (let o of this.events){
                let a = 0;
                for (let { obj: l, pointEnd: c, pointStart: u } of o.dragItems){
                    if (l === s[0].object || l === s[0].object.object || yt.is(l) && l.isAncestorOf(s[0].object.uuid)) {
                        if (o.activeIdx = a, o.activeDragItem.reset = !1, o.activeDragItem.currentDampingFactor = o.data.dampingFactor, o.activeDragItem.snapped = !1, o.data.cursor === "hand" && this.setCursor("grabbing"), this.eventManager.controlsManager.usePhysics) {
                            o.activeDragItem.obj.rigidBody && o.activeDragItem.obj.rigidBody.setBodyType(2, !0);
                            let h = o.activeDragItem.obj;
                            l.hasNonUniformScale && l.updateMatrixWorldSVD(), (h.hasNonUniformScale ? h.matrixWorldRigid : h.matrixWorld).decompose(ir, ou, Di), KT.setFromQuaternion(ou), h.prevR === void 0 ? (h.prevR = KT.clone(), h.prevT = ir.clone()) : (h.prevR.copy(KT), h.prevT.copy(ir)), this.eventManager.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.push(o.activeDragItem.obj);
                        }
                        this.calcPlaneIntersectPos(l, u, o.data.plane, o.data.referenceFrame), c.copy(u), (this.eventManager.controlsManager.usePhysics && l.data.physics?.rigidBody === "dynamic" || o.data.drop === !1 || o.data.resetOnSnapFail === !1) && o.activeDragItem.fromPosition.setFromMatrixPosition(o.activeDragItem.obj.matrixWorld), this.activeEvent = o, this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !1);
                        return;
                    }
                    a++;
                }
            }
            this.activeEvent = null;
        };
        this.onPointerMove = (e)=>{
            if (Je.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: r, page: i } = this.eventContext, s = i.raycastWithClones(r);
            if (Je.length === 0) {
                let o = !1;
                for (let a of this.events){
                    for (let { obj: l } of a.dragItems)if (l === s[0]?.object || l === s[0]?.object?.object || yt.is(l) && l.isAncestorOf(s[0]?.object.uuid)) {
                        switch(o = !0, a.data.cursor){
                            case "hand":
                                this.setCursor("grab");
                                break;
                            case "move":
                                this.setCursor("move");
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    if (o) break;
                }
                o || this.setCursor("default");
                return;
            }
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                let o = this.activeEvent.activeDragItem;
                o.snapped = !1;
                let a;
                if (this.activeEvent.data.drop && (a = s.filter((l)=>o.obj !== l.object && !o.obj.isAncestorOf(l.object.uuid) && !(l.object instanceof As) && (this.activeEvent.data.dropOn === "all" || this.activeEvent.dropDestIds.some((c)=>c === l.object.uuid || i.scene.find(c).isAncestorOf(l.object.uuid))))[0]), a) {
                    let l = zN.copy(a.face.normal).applyMatrix3(QT.getNormalMatrix(a.object.matrixWorld));
                    if (this.activeEvent.data.snapTo === "center") o.fromPosition.setFromMatrixPosition(a.object.matrixWorld);
                    else if (this.activeEvent.data.snapTo === "surface") {
                        if (o.fromPosition.copy(a.point), this.activeEvent.data.snapSurfaceMode === "bbox") {
                            ir.copy(l).applyMatrix3(QT.setFromMatrix4(o.obj.matrixWorld).transpose());
                            let c = o.obj;
                            ir.x > zf ? Di.x = -c.recursiveBBox.min.x : ir.x < -zf && (Di.x = -c.recursiveBBox.max.x), ir.y > zf ? Di.y = -c.recursiveBBox.min.y : ir.y < -zf && (Di.y = -c.recursiveBBox.max.y), ir.z > zf ? Di.z = -c.recursiveBBox.min.z : ir.z < -zf && (Di.z = -c.recursiveBBox.max.z), Di.applyMatrix3(QT.invert());
                        } else Di.copy(l).multiplyScalar(this.activeEvent.data.snapSurfaceOffset);
                        o.fromPosition.add(Di);
                    }
                    this.activeEvent.data.autoOrient && (ir.set(0, 1, 0).cross(l), ir.length() < 1e-4 && ir.set(-1, 0, 0).cross(l), Di.crossVectors(zN, ir), o.orientationMatrix.makeBasis(ir, Di, l)), o.pointStart.copy(o.fromPosition), o.pointEnd.copy(o.pointStart), o.currentDampingFactor = this.activeEvent.snapDampingFactor, o.snapped = !0, this.lastDropDestination !== a.object && (this.lastDropDestination = a.object, this.activeEvent.actionsDrop.Transition.forEach((c)=>{
                        c.play();
                    }), this.activeEvent.actionsDrop.Animation.forEach((c)=>{
                        c.play();
                    }), this.activeEvent.actionsDrop.Audio.forEach((c)=>{
                        c.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Particles.forEach((c)=>{
                        c.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Create.forEach((c)=>{
                        c.dispatchThrottled();
                    }));
                } else o.orientationMatrix.makeRotationFromQuaternion(o.quat0), this.lastDropDestination = null, o.currentDampingFactor = this.activeEvent.data.dampingFactor, this.calcPlaneIntersectPos(o.obj, o.pointEnd, this.activeEvent.data.plane, this.activeEvent.data.referenceFrame), this.activeEvent.actionsDrop.Transition.forEach((l)=>{
                    l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                        scene: this.eventContext.page.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrop.Animation.forEach((l)=>{
                    l.stop();
                }), this.activeEvent.actionsDrop.Audio.forEach((l)=>{
                    l.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrop.Particles.forEach((l)=>{
                    l.dispatchGameControl("stop");
                });
                this.activeEvent.actionsDrag.Create.forEach((l)=>{
                    l.dispatchThrottled();
                }), this.activeEvent.actionsDrag.SetVariable.forEach((l)=>l.checkConditions()), this.activeEvent.actionsDrag.SetVariable.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.DynamicVariablePlay.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.ClearLocalStorage.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.UserAPI.forEach((l)=>l.dispatch()), this.activeEvent.wasDragEventTriggered === !1 && (this.activeEvent.wasDragEventTriggered = !0, this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Animation.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                    l.dispatchGameControl("start");
                }), this.activeEvent.actionsDrag.Particles.forEach((l)=>{
                    l.dispatchGameControl("start");
                })), this.dragTimeout && window.clearTimeout(this.dragTimeout), this.dragTimeout = window.setTimeout(()=>{
                    !this.activeEvent || (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Particles.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                        l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                            scene: this.eventContext.page.scene,
                            shared: this.eventContext.sharedAssets
                        });
                    }), this.activeEvent.actionsDrag.Animation.forEach((l)=>{
                        l.stop();
                    }));
                }, 500), this.updateDragItem(o), o.obj.dispatchEvent({
                    type: "requestRender"
                });
            }
        };
        this.onPointerUp = (e)=>{
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                this.activeEvent.data.cursor === "hand" && this.setCursor("grab");
                let r = this.activeEvent.activeDragItem.obj.data.physics?.rigidBody === "dynamic";
                this.activeEvent.activeDragItem.snapped === !1 && this.activeEvent.data.drop && this.activeEvent.data.resetOnSnapFail && (this.eventManager.controlsManager.usePhysics === !1 || !r) && (this.activeEvent.activeDragItem.reset = this.activeEvent.data.resetOnSnapFail, this.activeEvent.activeDragItem.paused = !1, this.activeEvent.activeDragItem.currentDampingFactor = this.activeEvent.resetDampingFactor), this.eventManager.controlsManager.usePhysics && r && (this.eventManager.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.pop(), this.activeEvent.activeDragItem.obj.rigidBody.setBodyType(0, !0), this.activeEvent.activeDragItem.paused = !0), this.activeEvent.wasDragEventTriggered === !0 && (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Transition.forEach((i)=>{
                    i.stop(), i.object.currentState !== null && i.object.changeSelectedState(null, {
                        scene: this.eventContext.page.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrag.Animation.forEach((i)=>{
                    i.stop();
                }), this.activeEvent.actionsDrag.Audio.forEach((i)=>{
                    i.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrag.Particles.forEach((i)=>{
                    i.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrop.SetVariable.forEach((i)=>i.checkConditions()), this.activeEvent.actionsDrop.SetVariable.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.ClearLocalStorage.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.UserAPI.forEach((i)=>i.dispatch())), this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !0);
            }
        };
    }
    connect() {
        let e = {};
        if (this.eventContext.page.traverseEntity((i)=>{
            i.component && (e[i.component.uuid] ? e[i.component.uuid].push(i.uuid) : e[i.component.uuid] = [
                i.uuid
            ]);
        }), this.eventContext.page.traverseEntity((i)=>{
            i.data?.events.filter((s)=>s.data.type === "DragDrop" && !s.data.disabled).forEach((s)=>{
                this.events.push(new JT(i, s.id, s.data, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager, e));
            });
        }), !this.events.length) return;
        this.domEventsNeeded.clear(), this.domEventsNeeded.add("pointerdown");
        let r = this.eventContext.domElement;
        r.addEventListener("pointerdown", this.onPointerDown), r.addEventListener("pointermove", this.onPointerMove), r.addEventListener("pointerup", this.onPointerUp), this.domEventsNeeded.add("pointermove");
    }
    disconnect() {
        if (!this.events.length) return;
        this.domEventsNeeded.clear();
        let e = this.eventContext.domElement;
        e.removeEventListener("pointerdown", this.onPointerDown), e.removeEventListener("pointermove", this.onPointerMove), e.removeEventListener("pointerup", this.onPointerUp), this.events.forEach((r)=>r.dispose());
    }
    setCursor(e) {
        this.eventContext.domElement.style.cursor = e;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)for (let r of e.dragItems)r.paused || this.updateDragItem(r, !0);
    }
    calcPlaneIntersectPos(e, r, i, s) {
        let { getCamera: o, raycaster: a } = this.eventContext;
        o().getWorldDirection(sc), sc.negate();
        let l = ou.identity();
        switch(s === "parent" ? n$.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix).decompose(ir, l, Di) : s === "local" && e.matrixWorld.decompose(ir, l, Di), i){
            case "x":
                ir.set(1, 0, 0).applyQuaternion(l), Uf.copy(sc).cross(ir), Zo.copy(ir).cross(Uf);
                break;
            case "y":
                ir.set(0, 1, 0).applyQuaternion(l), Uf.copy(sc).cross(ir), Zo.copy(ir).cross(Uf);
                break;
            case "z":
                ir.set(0, 0, 1).applyQuaternion(l), Uf.copy(sc).cross(ir), Zo.copy(ir).cross(Uf);
                break;
            case "xy":
                Zo.set(0, 0, 1).applyQuaternion(l);
                break;
            case "yz":
                Zo.set(1, 0, 0).applyQuaternion(l);
                break;
            case "xz":
                Zo.set(0, 1, 0).applyQuaternion(l);
                break;
            case "adaptive":
                sc.angleTo(Di.set(0, 1, 0)) > Math.PI / 6 ? (ir.crossVectors(Di.set(0, 1, 0), sc), Zo.crossVectors(ir, Di)) : Zo.set(0, 1, 0);
                break;
            default:
                Zo.copy(sc);
                break;
        }
        su.setFromMatrixPosition(e.matrixWorld);
        let c = e.userData.lockedPlane ? e.userData.worldPosition0 : su;
        if (UN.setFromNormalAndCoplanarPoint(Zo, c), !!a.ray.intersectPlane(UN, r) && (i === "x" || i === "y" || i === "z")) {
            let u = Di.subVectors(r, c).dot(ir);
            r.copy(c).addScaledVector(ir, u);
        }
    }
    updateDragItem(e, r = !1) {
        su.setFromMatrixPosition(e.obj.matrixWorld), e.reset === "current" ? yg.subVectors(e.fromPosition, su).divideScalar(e.currentDampingFactor) : e.reset === "original" ? (yg.subVectors(e.obj.userData.worldPosition0, su).divideScalar(e.currentDampingFactor), e.fromPosition.copy(e.obj.userData.worldPosition0), e.pointStart.copy(e.fromPosition), e.pointEnd.copy(e.pointStart)) : yg.subVectors(e.pointEnd, e.pointStart).add(e.fromPosition).sub(su).divideScalar(e.currentDampingFactor), e.paused = e.currentDampingFactor > 1 ? yg.length() < i$ : !0, (this.activeEvent && this.activeEvent.data.dampingFactor === 1 || r) && s$(e, yg.add(su), this.activeEvent?.data.drop && this.activeEvent?.data.autoOrient ? e.orientationMatrix : null), e.obj.dispatchEvent({
            type: "beginEvent",
            eventName: "DragDrop"
        }), this.eventManager.requestRender();
    }
};
var Gf = new E, $T = new E, Ga = new E, ja = new E, GN = new kr, o$ = .01, a$ = {
    type: "requestRender"
}, l$ = function() {
    let n1 = new E, t = new E;
    return (e, r, i)=>i > 0 ? (n1.subVectors(e, r), n1.length() <= i ? e : t.copy(r).add(n1.normalize().multiplyScalar(i))) : r;
}(), jN = function() {
    let n1 = new ue;
    return (t, e)=>{
        t.position.copy(e), t.parent !== null && (n1.copy(t.parent.matrixWorld).invert(), t.position.applyMatrix4(n1)), n1.copy(t.hiddenMatrix).invert(), t.position.applyMatrix4(n1), t.updateMatrix(), t.hasNonUniformScale && (t.updateMatrixWorld(), t.updateMatrixWorldSVD()), t instanceof mr && En(t.parent) && t.invalidateDownstreamBooleanData(!0);
    };
}(), eM = class {
    constructor(t, e, r, i, s, o){
        this.data = t;
        this.id = e;
        this.object = r;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.snapComplete = !1;
        this.isReset = !1;
        this.worldPosition0 = new E;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...Nv.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (this.target = i.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.resetDampingFactor = 80 / this.data.resetSpeed + 1, this.object.getWorldPosition(this.worldPosition0), this.actions = Ut(t, t.actions, i, s, o, r);
    }
}, Nb = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.pairOfEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(Je.length > 1)) {
                this.eventContext.updateRaycaster(e);
                for (let r of this.events)r.target === void 0 && this.updateSingleEvent(r);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.isReset = !1, r.currentDampingFactor = r.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.data.resetOnPointerLeave && (r.isReset = !0, r.currentDampingFactor = r.resetDampingFactor), this.updateSingleEvent(r));
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
    }
    connect() {
        let { page: e } = this.eventContext;
        if (e.traverseEntity((s)=>{
            let o = s.data?.events.find((a)=>a.data.type === "Follow" && !a.data.disabled);
            o && (!e.data.globalPhysics.usePhysics || s.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new eM(o.data, o.id, s, e, this.eventContext.sharedAssets, this.eventManager));
        }), !this.events.length) return;
        let { domElement: r, eventElement: i } = this.eventContext;
        this.domEventsNeeded.clear(), Ci && (this.domEventsNeeded.add("pointerdown"), r.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), i.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents || (r.addEventListener("pointerenter", this.onMouseEnter), r.addEventListener("pointerleave", this.onMouseLeave));
        for (let s of this.events)if (s.target !== void 0) {
            let o = s.target, a = this.onTargetChange(s);
            this.pairOfEventListeners.push([
                o,
                a
            ]), o.addEventListener("requestRender", a);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Ci && e.removeEventListener("pointerdown", this.onMouseMove), r.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave);
        for (let [i, s] of this.pairOfEventListeners)i.removeEventListener("requestRender", s);
        for (let i of this.events)i.paused = !0, i.isReset = !1, hr(i.actions);
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e, !0);
    }
    updateSingleEvent(e, r = !1) {
        this.events.forEach((l)=>{
            l.actions.Create.forEach((c)=>{
                c.dispatchThrottled();
            });
        });
        let { plane: i, limitDistance: s, limitDistanceEnabled: o } = e.data;
        if (e.object.getWorldPosition(Ga), e.isReset) ja.copy(e.worldPosition0);
        else if (e.target) e.target.getWorldPosition(ja);
        else {
            let { getCamera: l, raycaster: c } = this.eventContext;
            if (i === "custom" ? (l().getWorldDirection($T), $T.negate(), Gf.copy($T)) : i === "xy" ? Gf.set(0, 0, 1) : i === "xz" ? Gf.set(0, 1, 0) : i === "yz" && Gf.set(1, 0, 0), GN.setFromNormalAndCoplanarPoint(Gf, Ga), !c.ray.intersectPlane(GN, ja)) return;
        }
        if (!e.isReset) {
            if (ja.distanceTo(e.worldPosition0) > s && o && e.target) {
                if (e.snapComplete = !1, e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) ja.copy(e.worldPosition0), e.currentDampingFactor = e.resetDampingFactor;
                else return;
            } else if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
        }
        e.data.enabledTranslation[0] === !1 && (ja.x = Ga.x), e.data.enabledTranslation[1] === !1 && (ja.y = Ga.y), e.data.enabledTranslation[2] === !1 && (ja.z = Ga.z);
        let a = l$(Ga, ja, e.wasOutside ? 0 : e.data.maxDelta);
        if (e.currentDampingFactor > 1) {
            let l = Gf.subVectors(a, Ga).divideScalar(e.currentDampingFactor);
            Ga.add(l), r && jN(e.object, Ga), e.paused = l.length() < o$;
        } else jN(e.object, a), e.paused = !0;
        e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "Follow"
        }), e.object.dispatchEvent(a$);
    }
};
var vg = new E, Fb = new E, xg = new ue, jf = new Ke, oc = new Ke, bg = new E, Sg = new E, au = new E, Ha = new E, tM = new kr, c$ = 1e-6, u$ = {
    type: "requestRender"
}, h$ = {
    type: "changeRotation"
}, HN = function() {
    let n1 = new ue;
    return function(e, r) {
        e.parent !== null ? n1.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix) : n1.copy(e.hiddenMatrix), r.premultiply(HT(n1).invert()), e.rotation.setFromRotationMatrix(r), e.updateMatrix(), e instanceof mr && En(e.parent) && e.invalidateDownstreamBooleanData(!0);
    };
}(), rM = class {
    constructor(t, e, r, i){
        this.id = e;
        this.object = r;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.isReset = !1;
        this.worldQuaternion0 = new Ke;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...Fv.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (this.target = i.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.object.getWorldQuaternion(this.worldQuaternion0), this.resetDampingFactor = 80 / this.data.resetSpeed + 1;
    }
}, Vb = class extends Yt {
    constructor(){
        super(...arguments);
        this.events = [];
        this.pairOfEventListeners = [];
        this.pairOfUserEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(Je.length > 1)) {
                this._lastMouseEvent = e, this.eventContext.updateRaycaster(e);
                for (let r of this.events)r.target === void 0 && this.updateSingleEvent(r);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.isReset = !1, r.currentDampingFactor = r.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.data.resetOnPointerLeave && (r.isReset = !0, r.currentDampingFactor = r.resetDampingFactor), this.updateSingleEvent(r));
        };
        this.onScroll = (e)=>{
            if (this._lastMouseEvent) {
                let r = new PointerEvent("pointermove", {
                    clientX: this._lastMouseEvent.clientX,
                    clientY: this._lastMouseEvent.clientY,
                    bubbles: !0,
                    cancelable: !0,
                    view: window
                });
                this.eventContext.eventElement.dispatchEvent(r);
            }
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
        this.createUserEventListener = (e)=>({ eventName: r, target: i })=>{
                if (!r || !i) return;
                let s = Qo(r);
                s && s === "LookAt" && this.updateSingleEvent(e);
            };
    }
    connect() {
        let { page: e } = this.eventContext;
        if (e.traverseEntity((s)=>{
            let o = s.data?.events.find((a)=>a.data.type === "LookAt" && !a.data.disabled);
            o && (!e.data.globalPhysics.usePhysics || s.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new rM(o.data, o.id, s, e));
        }), !this.events.length) return;
        let { domElement: r, eventElement: i } = this.eventContext;
        this.domEventsNeeded.clear(), Ci && (this.domEventsNeeded.add("pointerdown"), r.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), i.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents ? i.addEventListener("scroll", this.onScroll) : (r.addEventListener("pointerenter", this.onMouseEnter), r.addEventListener("pointerleave", this.onMouseLeave));
        for (let s of this.events){
            if (s.target !== void 0) {
                let l = this.onTargetChange(s), c = s.target;
                this.pairOfEventListeners.push([
                    c,
                    l
                ]), c.addEventListener("requestRender", l);
            }
            let o = this.createUserEventListener(s), a = s.object;
            this.pairOfUserEventListeners.push([
                a,
                o
            ]), a.addEventListener("userEvent", o);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Ci && e.removeEventListener("pointerdown", this.onMouseMove), r.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave), r.removeEventListener("scroll", this.onScroll);
        for (let [i, s] of this.pairOfEventListeners)i.removeEventListener("requestRender", s);
        for (let [i, s] of this.pairOfUserEventListeners)i.removeEventListener("userEvent", s);
        for (let i of this.events)i.paused = !0, i.isReset = !1;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e);
    }
    updateSingleEvent(e) {
        let { tilt: r, axis: i, distance: s, plane: o, limitDistance: a, enabledRotation: l, limitDistanceEnabled: c } = e.data, { getCamera: u, raycaster: h } = this.eventContext, { object: d, target: f } = e;
        if (d.getWorldPosition(bg), !e.isReset) {
            if (e.target) e.target.getWorldPosition(Sg);
            else {
                if (o === "custom" ? (u().getWorldDirection(Fb), Fb.negate(), tM.setFromNormalAndCoplanarPoint(Fb, bg)) : (o === "xy" ? vg.set(0, 0, 1) : o === "xz" ? vg.set(0, 1, 0) : o === "yz" && vg.set(1, 0, 0), tM.setFromNormalAndCoplanarPoint(vg, bg)), !h.ray.intersectPlane(tM, Sg)) return;
                s > 0 && (o === "custom" || o === void 0) && Sg.addScaledVector(Fb, s);
            }
        }
        if (e.isReset || (f ? r === "target" ? au.copy(f.up).applyMatrix4(xg.extractRotation(f.matrixWorld)).normalize() : l.some((p)=>p === !1) ? (i === "x" ? (Ha.set(0, 0, 1), l[2] === !1 && Ha.set(0, 1, 0)) : i === "y" ? (Ha.set(1, 0, 0), l[0] === !1 && Ha.set(0, 0, 1)) : (Ha.set(0, 1, 0), l[1] === !1 && Ha.set(1, 0, 0)), au.copy(Ha).applyQuaternion(e.worldQuaternion0).normalize()) : au.set(0, 1, 0) : o === "custom" ? au.set(0, 1, 0) : au.copy(vg)), e.isReset) oc.copy(e.worldQuaternion0);
        else if (bg.distanceTo(Sg) > a && c && f) {
            if (e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) oc.copy(e.worldQuaternion0), e.currentDampingFactor = e.resetDampingFactor;
            else return;
        } else {
            if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
            d$(xg, Sg, bg, au, i, Ha), oc.setFromRotationMatrix(xg), jf.setFromUnitVectors(Ha.applyQuaternion(oc), au), l.some((p)=>p === !1) && r !== "target" && oc.premultiply(jf).normalize();
        }
        e.currentDampingFactor > 1 ? (d.updateWorldMatrix(!0, !1), jf.setFromRotationMatrix(HT(d.matrixWorld)), jf.slerp(oc, 1 / e.currentDampingFactor), HN(d, xg.makeRotationFromQuaternion(jf)), e.paused = 8 * (1 - jf.dot(oc)) < c$) : (HN(d, xg.makeRotationFromQuaternion(oc)), e.paused = !0), e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "LookAt"
        }), d.dispatchEvent(u$), d.dispatchEvent(h$);
    }
}, Cs = new E, Oi = new E, li = new E;
function d$(n1, t, e, r, i, s) {
    let o = n1.elements;
    li.subVectors(t, e), li.lengthSq() === 0 && (li.z = 1), li.normalize(), Oi.crossVectors(r, li), Oi.lengthSq() === 0 && (Math.abs(r.z) === 1 ? li.x += 1e-4 : li.z += 1e-4, li.normalize(), Oi.crossVectors(r, li)), Oi.normalize(), Cs.crossVectors(li, Oi), i === "x" ? s.z === 1 ? [Oi, Cs, li] = [
        li,
        Oi,
        Cs
    ] : (Oi.negate(), [Oi, li] = [
        li,
        Oi
    ]) : i === "y" ? s.x === 1 ? [Oi, Cs, li] = [
        Cs,
        li,
        Oi
    ] : (Oi.negate(), [Cs, li] = [
        li,
        Cs
    ]) : s.x === 1 && (Oi.negate(), [Oi, Cs] = [
        Cs,
        Oi
    ]), o[0] = Oi.x, o[4] = Cs.x, o[8] = li.x, o[1] = Oi.y, o[5] = Cs.y, o[9] = li.y, o[2] = Oi.z, o[6] = Cs.z, o[10] = li.z;
}
var iM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.entered = !1;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    disconnect() {
        hr(this.actions);
    }
    dispatchEnter() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered || (this.entered = !0, this.actions.Transition.forEach((t)=>t.playFromCurrent()), this.actions.Animation.forEach((t)=>t.play()), this.actions.Create.forEach((t)=>t.dispatchStart()), this.actions.Particles.forEach((t)=>t.dispatchBasic()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.SwitchCamera.forEach((t)=>t.playFromCurrent()), this.actions.SceneTransition.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch()));
    }
    dispatchLeave() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered && (this.entered = !1, this.actions.Create.forEach((t)=>t.dispatchStop()), this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.Particles.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Particles.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatch()), this.actions.Particles.forEach((e)=>e.dispatchBasic()), this.actions.Destroy.forEach((e)=>e.dispatch()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.SceneTransition.forEach((e)=>e.dispatch()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, kb = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerObjects = {};
        this.objects = [];
        this.objects2D = [];
        this._prevObjects = [];
        this.onMouseDown = (e)=>{
            Je.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onMouseUp = (e)=>{
            Je.length > 1 || this.handleMouseHoverEvent(!0);
        };
        this.onMouseMove = (e)=>{
            Je.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = Qo(e);
            s && s === "MouseHover" && (r.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[r.uuid]?.forEach((o)=>o.dispatchUserEvent(i)));
        };
    }
    connect() {
        let { page: e, sharedAssets: r } = this.eventContext, i = (o, a)=>{
            if (!(!o.visible || !o.data?.events.length)) {
                for (let { id: l, data: c } of o.data.events)if (!c.disabled && c.type === "MouseHover") try {
                    let u = new iM(l, c, o, e, r, this.eventManager);
                    this.eventsPerObjects[o.uuid] ? this.eventsPerObjects[o.uuid].push(u) : this.eventsPerObjects[o.uuid] = [
                        u
                    ];
                } catch (u) {}
                this.eventsPerObjects[o.uuid]?.length && this.objects.push(o instanceof rr ? a : o);
            }
        };
        if (e.traverseEntity((o)=>{
            (o instanceof Er || o instanceof ur) && o.frame?.traverse((a)=>{
                i(a, o);
            }), i(o);
        }), !this.objects.length) return;
        let { domElement: s } = this.eventContext;
        this.domEventsNeeded.clear(), Ci && (this.domEventsNeeded.add("pointerdown"), s.addEventListener("pointerdown", this.onMouseDown), this.domEventsNeeded.add("pointerup"), s.addEventListener("pointerup", this.onMouseUp)), this.domEventsNeeded.add("pointermove"), s.addEventListener("pointermove", this.onMouseMove), this.objects.forEach((o)=>{
            o.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if (!this.objects.length) return;
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), Ci && (e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerup", this.onMouseUp)), e.removeEventListener("pointermove", this.onMouseMove), Object.values(this.eventsPerObjects).forEach((r)=>{
            r.forEach((i)=>{
                i.disconnect();
            });
        }), this.objects.forEach((r)=>{
            r.removeEventListener("userEvent", this.onUserEvent);
        });
    }
    handleMouseHoverEvent(e = !1) {
        let r = [];
        if (!e) {
            let { stopRaycast: i, raycaster: s, page: o, pointerScreen: a } = this.eventContext, l = !1;
            if (o.uiCanvas && (l = so(o, [
                a.x,
                a.y
            ], Object.keys(this.eventsPerObjects), (c)=>{
                r.push(c);
            })), i && !l) {
                let c = Vf(s, o, this.objects);
                r = gg(c), c.forEach((u)=>{
                    u.object instanceof Er && so(u.object, [
                        u?.uv?.x ?? 0,
                        u?.uv?.y ?? 0
                    ], Object.keys(this.eventsPerObjects), (h)=>{
                        r.push(h);
                    });
                });
            } else this.objects.forEach((c)=>{
                let u = kf(s, c);
                u && (r.push(c), c instanceof Er && so(c, [
                    u?.uv?.x ?? 0,
                    u?.uv?.y ?? 0
                ], Object.keys(this.eventsPerObjects), (h)=>{
                    r.push(h);
                }));
            });
        }
        this._prevObjects.length && this._prevObjects.forEach((i)=>{
            r.includes(i) || (i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s)=>s.dispatchLeave()));
        }), r.length && r.forEach((i)=>{
            i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s)=>s.dispatchEnter());
        }), this._prevObjects = r;
    }
};
var nM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.scrollCounter = 0;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    connect() {
        this.scrollCounter = 0;
    }
    disconnect() {
        hr(this.actions);
    }
    dispatch(t) {
        this.actions.Transition.forEach((i)=>{
            i.object.currentTransitionEvent !== this && (i.object.currentTransitionEvent = this, i.init());
        });
        let e = t > 0 ? 1 : -1;
        this.scrollCounter += e, this.scrollCounter = Math.min(Math.max(this.scrollCounter, 0), this.data.steps);
        let r = this.scrollCounter / this.data.steps;
        this.actions.Transition.forEach((i)=>i.seek(r)), this.actions.Animation.forEach((i)=>i.seek(e)), this.actions.Create.forEach((i)=>i.dispatchThrottled()), this.actions.SetVariable.forEach((i)=>i.checkConditions()), this.actions.SetVariable.forEach((i)=>i.dispatch()), this.actions.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.actions.ClearLocalStorage.forEach((i)=>i.dispatch()), this.actions.UserAPI.forEach((i)=>i.dispatch());
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Animation.forEach((e)=>{
            e.playFromCurrent();
        })), this.actions.Create.forEach((e)=>e.dispatchThrottled()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, sM = class {
    constructor(t, e, r, i, s, o, a){
        this.id = t;
        this.data = e;
        this.object = r;
        this.domElement = o;
        this.eventManager = a;
        this.scrollStart = 0;
        this.scrollEnd = 0;
        this.actions = Ut(e, e.actions, i, s, a, r);
    }
    getStickyParentElement() {
        let t = this.domElement;
        for(; t;){
            if (window.getComputedStyle(t).position === "sticky") return t;
            t = t.parentElement;
        }
        return null;
    }
    computeScrollBounds() {
        let t = this.getStickyParentElement(), e = t?.parentElement, r = this.domElement.getBoundingClientRect(), i = {
            top: r.top,
            bottom: r.bottom,
            left: r.left,
            right: r.right,
            width: r.width,
            height: r.height
        };
        if (e) {
            let u = e.getBoundingClientRect(), h = window.getComputedStyle(t), d = parseFloat(h.marginTop) + parseFloat(h.marginBottom), f = parseFloat(h.top), p = parseFloat(h.bottom), m = u.height - d;
            if (!isNaN(f)) r.top === f ? (i.top += u.top - f, i.bottom += u.top - f) : r.top < 0 && (i.top -= m - r.height, i.bottom -= m - r.height);
            else if (!isNaN(p)) {
                let g = document.body.clientHeight ?? window.innerHeight, y = window.innerWidth - (document.documentElement.clientWidth ?? window.innerWidth);
                r.bottom === g - p ? (i.top += u.top - r.height + p + y, i.bottom += u.top - r.height + p + y) : r.bottom < g - p && (i.top -= m - r.height, i.bottom -= m - r.height);
            }
        }
        let s = document.body, o = document.documentElement, a = window.pageYOffset || o.scrollTop || s.scrollTop, l = o.clientTop || s.clientTop || 0, c = Math.round(i.top + a - l);
        if (this.data.startFrom === "enter") {
            let u = window.innerHeight, h = i.height, d = this.data.enterAnchor, f = d === "top" ? u : d === "bottom" ? u - h : u - h * .5;
            this.scrollStart = c - f;
        } else this.scrollStart = 0;
        this.scrollStart += this.data.startOffset ?? 0, this.scrollEnd = this.scrollStart + (this.data.endAfter ?? 400), this.box = i, this.computeScroll({
            x: window.scrollX,
            y: window.scrollY
        });
    }
    connect() {
        this.computeScrollBounds();
    }
    disconnect() {
        hr(this.actions);
    }
    handleResize() {
        this.computeScrollBounds();
    }
    get isInvalidBox() {
        return this.box === void 0 || this.box.width === 0 && this.box.height === 0 && this.box.top === 0 && this.box.bottom === 0;
    }
    computeScroll({ x: t, y: e }) {
        this.actions.Transition.forEach((s)=>{
            s.object.currentTransitionEvent !== this && (s.object.currentTransitionEvent = this, s.init());
        });
        let r = this.scrollEnd - this.scrollStart, i = Math.min(1, Math.max(0, (e - this.scrollStart) / r));
        this.actions.Transition.forEach((s)=>s.seek(i)), this.actions.Animation.forEach((s)=>s.seek(i)), this.actions.Create.forEach((s)=>s.dispatchThrottled()), this.actions.SetVariable.forEach((s)=>s.checkConditions()), this.actions.SetVariable.forEach((s)=>s.dispatch()), this.actions.DynamicVariablePlay.forEach((s)=>s.dispatch()), this.actions.ClearLocalStorage.forEach((s)=>s.dispatch()), this.actions.UserAPI.forEach((s)=>s.dispatch());
    }
    dispatch(t) {
        this.isInvalidBox && this.computeScrollBounds(), this.computeScroll(t);
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Animation.forEach((e)=>{
            e.playFromCurrent();
        })), this.actions.Create.forEach((e)=>e.dispatchThrottled()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, Ub = class extends Yt {
    constructor(e, r){
        super(e);
        this.managers = r;
        this.wheelEventsPerObject = new Map;
        this.scrollEventsPerObject = new Map;
        this.isInview = !0;
        this.handleResize = ()=>{
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([e, r])=>{
                r.forEach((i)=>i.handleResize());
            });
        };
        this.onScroll = (e)=>{
            if (!this.isInview) return;
            let r = {
                y: window.scrollY,
                x: window.scrollX
            };
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([i, s])=>{
                i.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    scroll: r
                }), s.forEach((o)=>o.dispatch(r));
            });
        };
        this.onWheel = (e)=>{
            !this.isInview || e.ctrlKey || [
                ...this.wheelEventsPerObject.entries()
            ].forEach(([r, i])=>{
                r.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    deltaY: e.deltaY
                }), i.forEach((s)=>s.dispatch(e.deltaY));
            });
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = Qo(e);
            s && s === "Scroll" && (r.dispatchEvent({
                type: "beginEvent",
                eventName: "Scroll"
            }), this.wheelEventsPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i, isExport: s } = this.eventContext, o = (a)=>{
            if (!!a.data?.events.length) {
                for (let { id: l, data: c } of a.data.events)if (!c.disabled && c.type === "Scroll") {
                    if (c.trigger === "load" || !s) {
                        let u = new nM(l, c, a, e, r, this.managers);
                        this.wheelEventsPerObject.has(a) ? this.wheelEventsPerObject.get(a)?.push(u) : this.wheelEventsPerObject.set(a, [
                            u
                        ]);
                    } else {
                        let u = new sM(l, c, a, e, r, i, this.managers);
                        this.scrollEventsPerObject.has(a) ? this.scrollEventsPerObject.get(a)?.push(u) : this.scrollEventsPerObject.set(a, [
                            u
                        ]);
                    }
                }
            }
        };
        e.traverseEntity((a)=>{
            (a instanceof Er || a instanceof ur) && a.frame?.traverse((l)=>{
                o(l);
            }), o(a);
        }), this.intersectionObserver = new IntersectionObserver((a)=>{
            let l = a[0];
            l && (this.isInview = l.isIntersecting);
        }, {
            root: null
        }), this.intersectionObserver.observe(this.eventContext.domElement), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([a, l])=>{
            l.forEach((c)=>c.connect()), a.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([a, l])=>{
            l.forEach((c)=>c.connect()), a.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.wheelEventsPerObject.values()
        ].some((a)=>a.length) && (this.domEventsNeeded.add("wheel"), window.addEventListener("wheel", this.onWheel)), [
            ...this.scrollEventsPerObject.values()
        ].some((a)=>a.length) && (this.domEventsNeeded.add("scroll"), window.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.handleResize));
    }
    disconnect() {
        window.removeEventListener("wheel", this.onWheel), window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.handleResize), this.intersectionObserver.unobserve(this.eventContext.domElement), this.domEventsNeeded.clear(), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        });
    }
};
var oM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    disconnect() {
        hr(this.actions);
    }
    dispatch() {
        this.actions.Transition.forEach((t)=>{
            t.play();
        }), this.actions.Animation.forEach((t)=>{
            t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.play();
        }), this.actions.SceneTransition.forEach((t)=>{
            t.dispatch();
        }), this.actions.Reset.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch()), this.actions.Create.forEach((t)=>{
            t.dispatchFromStart();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatchFromStart();
        });
    }
    dispatchAfter(t) {
        this.actions.Audio.forEach((e)=>{
            (e.interaction.data.triggerAfter ?? "any") === t && (e.interaction instanceof Wo ? e.interaction.audioPlayer.play() : e.interaction instanceof Lf && e.interaction.dispatch());
        }), this.actions.Video.forEach((e)=>{
            let r = e.interaction.data.triggerAfter ?? "autoplay";
            r === t && (e.interaction instanceof Ua ? e.interaction.play(r === "autoplay") : e.interaction instanceof Ff && e.interaction.dispatch());
        }), this.actions.Particles.forEach((e)=>{
            (e.data.triggerAfter ?? "any") === t && e.dispatchBasic();
        });
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.SceneTransition.forEach((e)=>e.dispatch()), this.actions.Reset.forEach((e)=>e.dispatch()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch()), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.interaction instanceof Wo ? e.interaction.audioPlayer.play() : e.interaction instanceof Lf && e.interaction.dispatch();
        }), this.actions.Video.forEach((e)=>{
            e.interaction instanceof Ua ? e.interaction.play() : e.interaction instanceof Ff && e.interaction.dispatch();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        });
    }
}, zb = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerObject = new Map;
        this.eventsAfterPerObject = new Map;
        this.onMouseDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("mouseDown");
                });
            });
        };
        this.onKeyDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("keyDown");
                });
            });
        };
        this.onAny = ()=>{
            let { domElement: e, isExport: r } = this.eventContext, i = r ? document : e;
            i.removeEventListener("pointerdown", this.onAny), i.removeEventListener("mousedown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), o.forEach((a)=>{
                    a.dispatchAfter("any");
                });
            });
        };
        this.onSceneTransitionAudioVideoPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.actions.Audio.forEach((s)=>{
                        s.interaction instanceof Wo && s.interaction.audioPlayer.play();
                    }), i.actions.Video.forEach((s)=>{
                        let o = s.interaction.data.triggerAfter ?? "autoplay";
                        s.interaction instanceof Ua && s.interaction.play(o === "autoplay");
                    }), i.actions.Particles.forEach((s)=>{
                        s.dispatchBasic();
                    });
                });
            });
        };
        this.onPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("autoplay");
                });
            });
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = Qo(e);
            s && s === "Start" && (r instanceof rr || r.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), this.eventsPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }), this.eventsAfterPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
    }
    connect() {
        let { sharedAssets: e, page: r } = this.eventContext, i = (s)=>{
            if (!!s.data?.events.length) for (let { id: o, data: a } of s.data.events){
                if (a.disabled || a.type !== "Start") continue;
                let l = new oM(o, a, s, r, e, this.eventManager);
                (l.actions.Transition.length || l.actions.Animation.length || l.actions.SwitchCamera.length || l.actions.Create.length || l.actions.Destroy.length || l.actions.SceneTransition.length || l.actions.Reset.length || l.actions.SetVariable.length || l.actions.DynamicVariablePlay.length || l.actions.ClearLocalStorage.length || l.actions.UserAPI.length) && (this.eventsPerObject.has(s) ? this.eventsPerObject.get(s)?.push(l) : this.eventsPerObject.set(s, [
                    l
                ])), l.actions.Audio.length && (this.eventsAfterPerObject.has(s) ? this.eventsAfterPerObject.get(s)?.push(l) : this.eventsAfterPerObject.set(s, [
                    l
                ])), l.actions.Video.length && (this.hasVideoAction = !0, this.eventsAfterPerObject.has(s) ? this.eventsAfterPerObject.get(s)?.push(l) : this.eventsAfterPerObject.set(s, [
                    l
                ])), l.actions.Particles.length && (this.eventsAfterPerObject.has(s) ? this.eventsAfterPerObject.get(s)?.push(l) : this.eventsAfterPerObject.set(s, [
                    l
                ]));
            }
        };
        if (r.traverseEntity((s)=>{
            (s instanceof Er || s instanceof ur) && s.frame?.traverse((o)=>{
                i(o);
            }), i(s);
        }), [
            ...this.eventsAfterPerObject.values()
        ].some((s)=>s.length)) {
            if (this.eventManager.activateCount === 0) {
                let { domElement: s, isExport: o } = this.eventContext, a = o ? document : s;
                a.addEventListener("pointerdown", this.onMouseDown, {
                    once: !0
                }), a.addEventListener("mousedown", this.onMouseDown, {
                    once: !0
                }), document.addEventListener("keydown", this.onKeyDown, {
                    once: !0
                }), a.addEventListener("pointerdown", this.onAny), a.addEventListener("mousedown", this.onAny), document.addEventListener("keydown", this.onAny), [
                    ...this.eventsAfterPerObject.entries()
                ].forEach(([l, c])=>{
                    l.addEventListener("userEvent", this.onUserEvent);
                });
            } else this.onSceneTransitionAudioVideoPlay();
            this.onPlay();
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([s, o])=>{
            s.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), o.forEach((a)=>a.dispatch()), s.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if ([
            ...this.eventsAfterPerObject.values()
        ].some((e)=>e.length)) {
            let { domElement: e, isExport: r } = this.eventContext, i = r ? document : e;
            i.removeEventListener("pointerdown", this.onMouseDown), i.removeEventListener("mousedown", this.onMouseDown), document.removeEventListener("keydown", this.onKeyDown), i.removeEventListener("pointerdown", this.onAny), i.removeEventListener("mousedown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.removeEventListener("userEvent", this.onUserEvent), o.forEach((a)=>a.disconnect());
            });
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([e, r])=>{
            e.removeEventListener("userEvent", this.onUserEvent), r.forEach((i)=>i.disconnect());
        }), this.eventsPerObject.clear(), this.eventsAfterPerObject.clear();
    }
};
var Gb = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.initialDisabled = !1;
        this.actions = Ut(e, e.actions, i, s, o, r), this.target = e.target;
    }
    disconnect() {
        hr(this.actions);
    }
    dispatch(t) {
        this.initialDisabled || (this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Collision"
        }), this.actions.Transition.forEach((e)=>{
            e.data.runMode === "Toggle" ? e.toggle() : e.play();
        }), this.actions.Animation.forEach((e)=>{
            e.data.runMode === "Toggle" ? e.toggle() : e.play();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch(t ?? !1);
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch()));
    }
};
var jb = class extends Yt {
    constructor(e, r, i, s, o){
        super(e);
        this.sharedVariables = r;
        this.eventManager = i;
        this.needsMouse = s;
        this.needsRaycast = o;
        this.dynamicVars = [];
        this.variablesToWatch = [];
        this.prevMouseProperty = null;
        this.prevRaycastProperty = null;
        this.pauseTime = 0;
        this.isOutOfFocus = !1;
        this.events = [];
        this.onFrame = (e)=>{
            let r = this.eventContext.sharedAssets;
            if (this.rafId = window.requestAnimationFrame(this.onFrame), this.isOutOfFocus) return;
            let i = new Date, s = [], o = [];
            for(let c = 0; c < this.propertiesToWatch.length; c++){
                let { objectId: u, property: h, prevValue: d } = this.propertiesToWatch[c], f = this.eventContext.scene.find(u), p = kv.propertyPaths[h];
                if (p[0] === "width" || p[0] === "height" || p[0] === "depth") f = f.geometry.userData.parameters[p[0]];
                else for(let m = 0; m < p.length; m++)f = f[p[m]];
                d === null ? this.propertiesToWatch[c].prevValue = f instanceof E ? f.clone() : f : (f instanceof E ? !f.equals(d) : d !== f) && (o.push({
                    objId: u,
                    property: h
                }), f instanceof E ? this.propertiesToWatch[c].prevValue.copy(f) : this.propertiesToWatch[c].prevValue = f);
            }
            for(let c = 0; c < this.variablesToWatch.length; c++){
                let { id: u, prevValue: h } = this.variablesToWatch[c], d = r.getVariable(u);
                d !== h && (s.push(u), this.variablesToWatch[c].prevValue = d);
            }
            for(let c = 0; c < this.dynamicVars.length; c++){
                let { id: u, expectedTime: h, last: d, data: f, timerSeconds: p, startValue: m } = this.dynamicVars[c], g = 1e3;
                if ((f.dynamicVariableType === "timer" || f.dynamicVariableType === "stopwatch") && f.format === "number3decimal" ? g = 1 : f.dynamicVariableType === "counter" ? g = f.updateInterval : f.dynamicVariableType === "random" && (g = f.isStatic ? 1 / 0 : f.updateInterval), h === -1) {
                    this.dynamicVars[c].last = e, this.dynamicVars[c].expectedTime = e + g;
                    continue;
                }
                if (!((r.getDynamicVariablePlayState(u) === "Stopped" || r.getDynamicVariablePlayState(u) === "Restarted") && (this.dynamicVars[c].last = e, this.dynamicVars[c].expectedTime = e + g, f.dynamicVariableType === "counter" && r.getVariable(u) !== m && (r.updateVariable(u, m), this.eventManager.requestRender()), (f.dynamicVariableType === "timer" || f.dynamicVariableType === "stopwatch") && this.dynamicVars[c].timerSeconds !== m && (this.dynamicVars[c].timerSeconds = m, r.updateVariable(u, vn.getFormattedTimerTime(m, f)), this.eventManager.requestRender()), r.getDynamicVariablePlayState(u) === "Restarted" && r.setDynamicVariablePlayState(u, "Playing"), r.getDynamicVariablePlayState(u) === "Stopped"))) {
                    if (r.getDynamicVariablePlayState(u) === "Paused") {
                        this.dynamicVars[c].deltaToExpectedTime === void 0 && (this.dynamicVars[c].deltaToExpectedTime = Math.max(this.dynamicVars[c].expectedTime - e, 0)), this.dynamicVars[c].last = e - (g - this.dynamicVars[c].deltaToExpectedTime), this.dynamicVars[c].expectedTime = e + this.dynamicVars[c].deltaToExpectedTime;
                        continue;
                    } else this.dynamicVars[c].deltaToExpectedTime = void 0;
                    if (e >= h) {
                        if (this.dynamicVars[c].last = e, this.dynamicVars[c].expectedTime += g, f.dynamicVariableType === "random") {
                            let y = f.min + Math.random() * (f.max - f.min), x = f.decimals;
                            y = Math.round(y * Math.pow(10, x)) / Math.pow(10, x), r.updateVariable(u, y), s.push(u), this.eventManager.requestRender();
                        } else if (f.dynamicVariableType === "counter") {
                            let y = r.getVariable(u), x = r.getDynamicVariableToggleIsForward(u) ?? !0, v = r.getVariable(u) + f.increment * (x ? 1 : -1);
                            f.hasEnd && (v = f.increment > 0 ? we.clamp(v, m, f.endValue) : we.clamp(v, f.endValue, m), v === m && r.setDynamicVariableToggleIsForward(u, void 0), f.repeat ? v === f.endValue && (v = m) : (v === m || v === f.endValue) && r.setDynamicVariablePlayState(u, "Paused")), v !== y && (s.push(u), r.updateVariable(u, v), this.eventManager.requestRender());
                        } else if (f.dynamicVariableType === "time") {
                            let y = r.getVariable(u), x = wE(i, f);
                            if (typeof y == "object" && "textValue" in y && typeof x == "object" && "textValue" in x) {
                                if (Array.isArray(y.textValue) && Array.isArray(x.textValue)) {
                                    if (y.textValue.every((v, S)=>v === x.textValue[S])) continue;
                                } else if (y.textValue === x.textValue) continue;
                            } else if (y === x) continue;
                            r.updateVariable(u, x), s.push(u), this.eventManager.requestRender();
                        } else {
                            let y = Br.isTextValue(f.endValue) ? WN(f.endValue.textValue) : f.endValue, x = r.getDynamicVariableToggleIsForward(u) ?? !0, v = p + (e - d) / 1e3 * (f.dynamicVariableType === "timer" ? -1 : 1) * (x ? 1 : -1);
                            v = Math.max(v, 0), f.hasEnd && (v = f.dynamicVariableType === "stopwatch" ? we.clamp(v, m, y) : we.clamp(v, y, m), v === m && r.setDynamicVariableToggleIsForward(u, void 0), f.repeat ? Math.abs(v - y) < (f.format === "number3decimal" ? 1e-4 : .1) && (v = m) : (Math.abs(v - m) < (f.format === "number3decimal" ? 1e-4 : .1) || Math.abs(v - y) < (f.format === "number3decimal" ? 1e-4 : .1)) && r.setDynamicVariablePlayState(u, "Paused")), v !== p && (s.push(u), this.dynamicVars[c].timerSeconds = v, r.updateVariable(u, vn.getFormattedTimerTime(v, f)), this.eventManager.requestRender());
                        }
                    }
                }
            }
            let a = !1;
            r.mouseProperty !== this.prevMouseProperty && (this.prevMouseProperty = r.mouseProperty, a = !0);
            let l = !1;
            r.raycastProperty !== this.prevRaycastProperty && (this.prevRaycastProperty = r.raycastProperty, l = !0), this.events.forEach((c)=>{
                (s.includes(c.data.variableId) || o.find((u)=>u.objId === c.data.objectId && u.property === c.data.property) || c.data.variableId === "mouseProperty" && a || c.data.variableId === "raycastProperty" && l) && (c.dispatch(), this.eventManager.requestRender());
            });
        };
        this.onBlur = ()=>{
            this.pause();
        };
        this.onFocus = ()=>{
            this.resume();
        };
    }
    pause() {
        this.isOutOfFocus || (this.isOutOfFocus = !0, this.pauseTime = Date.now());
    }
    resume() {
        if (!this.isOutOfFocus) return;
        this.isOutOfFocus = !1;
        let e = Date.now() - this.pauseTime;
        for(let r = 0; r < this.dynamicVars.length; r++)this.dynamicVars[r].last += e, this.dynamicVars[r].expectedTime += e;
    }
    connect() {
        this.eventContext.page.traverseEntity((r)=>{
            r.data?.events.filter((i)=>i.data.type === "VariableChange" && !i.data.disabled).forEach((i)=>{
                this.events.push(new aM(i.id, i.data, r, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), this.propertiesToWatch = this.events.filter((r)=>r.data.variableId === "objectProperty" && r.data.objectId !== null).map((r)=>({
                objectId: r.data.objectId,
                property: r.data.property,
                prevValue: null
            }));
        let e = this.eventContext.sharedAssets;
        this.sharedVariables.forEach(({ id: r, data: i })=>{
            if (!("dynamicVariableType" in i)) {
                this.events.find((o)=>o.data.variableId === r) && this.variablesToWatch.push({
                    id: r,
                    prevValue: e.getVariable(r)
                });
                return;
            }
            let s;
            if (i.dynamicVariableType === "timer" || i.dynamicVariableType === "stopwatch") {
                let o;
                if (Br.isTextValue(i.value) && Array.isArray(i.value.textValue)) {
                    let a = i.value.textValue;
                    a.length === 3 ? o = a[2] + a[1] * 60 + a[0] * 3600 : o = a[1] + a[0] * 60;
                } else o = i.value;
                s = o, this.dynamicVars.push({
                    id: r,
                    last: -1,
                    expectedTime: -1,
                    data: i,
                    timerSeconds: o,
                    startValue: s
                });
            } else i.dynamicVariableType === "time" && e.updateVariable(r, wE(new Date, i)), i.dynamicVariableType === "counter" && (s = Br.isTextValue(i.value) ? WN(i.value.textValue) : i.value), this.dynamicVars.push({
                id: r,
                last: -1,
                expectedTime: -1,
                data: i,
                startValue: s
            });
        }), this.rafId = window.requestAnimationFrame(this.onFrame), window.addEventListener("blur", this.onBlur), window.addEventListener("focus", this.onFocus);
    }
    disconnect() {
        window.removeEventListener("blur", this.onBlur), window.removeEventListener("focus", this.onFocus), this.rafId && (window.cancelAnimationFrame(this.rafId), this.rafId = void 0), this.events.forEach((e)=>e.dispose());
    }
}, aM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
    dispose() {
        hr(this.actions);
    }
};
function WN(n1) {
    return n1.length === 3 ? n1[2] + n1[1] * 60 + n1[0] * 3600 : n1[1] + n1[0] * 60;
}
var YN = "https://unpkg.com/@splinetool/runtime@1.9.46/build/", f$ = "https://unpkg.com/@splinetool/navmesh-wasm@1.9.46/build/", p$ = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import('${YN}' + 'navmesh.js'),
		fetch('${f$}' + 'navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, m$ = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import(self.location.origin + '/_libraries/navmesh.js'),
		fetch(self.location.origin + '/_libraries/navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, g$ = `

onmessage = function(messageEvent) {
	const meshData = messageEvent.data;
	const positions = meshData[0];
	const offset = meshData[1];
	const indices = meshData[2];
	const indicesLength = meshData[3];
	const parameters = meshData[4];

	const module = self.module;
	const rc = new module.rcConfig();
	rc.cs = parameters.cs;
	rc.ch = parameters.ch;
	rc.borderSize = parameters.borderSize ? parameters.borderSize : 0;
	rc.tileSize = parameters.tileSize ? parameters.tileSize : 0;
	rc.walkableSlopeAngle = parameters.walkableSlopeAngle;
	rc.walkableHeight = parameters.walkableHeight;
	rc.walkableClimb = parameters.walkableClimb;
	rc.walkableRadius = parameters.walkableRadius;
	rc.maxEdgeLen = parameters.maxEdgeLen;
	rc.maxSimplificationError = parameters.maxSimplificationError;
	rc.minRegionArea = parameters.minRegionArea;
	rc.mergeRegionArea = parameters.mergeRegionArea;
	rc.maxVertsPerPoly = parameters.maxVertsPerPoly;
	rc.detailSampleDist = parameters.detailSampleDist;
	rc.detailSampleMaxError = parameters.detailSampleMaxError;

	if (!self.navMesh) {
		self.navMesh = new module.NavMesh();
	}
	self.navMesh.build(positions, offset, indices, indicesLength, rc);

	const navmeshData = navMesh.getNavmeshData();
	const arrView = new Uint8Array(module.HEAPU8.buffer, navmeshData.dataPointer, navmeshData.size);
	const ret = new Uint8Array(navmeshData.size);
	ret.set(arrView);
	navMesh.freeNavmeshData(navmeshData);

	postMessage(ret);
}
`, qN = .001, y$ = {
    cs: 6,
    ch: 2,
    walkableSlopeAngle: 90,
    walkableHeight: 20,
    walkableClimb: 5,
    walkableRadius: 0,
    maxEdgeLen: 12,
    maxSimplificationError: 1.3,
    minRegionArea: 8,
    mergeRegionArea: 20,
    maxVertsPerPoly: 6,
    detailSampleDist: 6,
    detailSampleMaxError: 1
}, XN, Ot, en;
cI.then((n1)=>{
    XN = n1, Ot = new n1.Vec3, en = new n1.Vec3;
});
var v$ = new E, Hb = class {
    constructor(t = !1, e = !1){
        this.usePhysics = t;
        this.isExport = e;
        this.onPointerDown = (t)=>{
            if (Je.length !== 1) return;
            let { raycaster: e, page: r } = this.eventContext;
            this.eventContext.updateRaycaster(t);
            let i = r.raycastWithClones(e);
            if (i.length !== 0) {
                if (this.gameControl) {
                    let s = v$.copy(this.gameControl.colliderWorldPosition);
                    s.y -= this.gameControl.colliderHeight / 2, this.gameControl.path = this.computePath(s, i[0].point);
                }
                this.eventContext.requestRender();
            }
        };
        this.traverseWithPhysics = (t, e)=>(r)=>{
                let i;
                if (r instanceof Gi) {
                    if (r.objectForSample) {
                        if (r.objectForSample.dataPatched.physics.fusedBody) return;
                        i = r.object;
                    } else return r.object.dataPatched.physics.fusedBody === !0 && r.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (r instanceof Nr) i = r.object;
                else if (i = r, i.dataPatched.cloner?.disabled === !1 && i.dataPatched.cloner?.hideBase && i.dataPatched.physics?.fusedBody !== !0) return !0;
                if (e && !i.userData.navmesh) return;
                let s = i.dataPatched;
                if (!s.visible && s.physics?.enabled !== !0) return !0;
                r.updateMatrixWorldSVD();
                let o = wg(s), a = i.userData.hasDestroy, l = i.userData.hasDrag, c = !1, u = !1;
                for (let h of s.events)h.data.disabled !== !0 && (h.data.type === "GameControl" ? c = !0 : h.data.type === "Follow" && (u = !0));
                if (c || o || u || a || l) return !0;
                if (this.usePhysics && s.physics?.rigidBody === "dynamic") {
                    if (this.usePhysics && s.physics?.fusedBody) return !0;
                } else if ("geometry" in r && r.geometry && t.push(no(r.geometry, r.matrixWorld)), this.usePhysics && s.physics?.fusedBody) return r.traverseObject((h, d)=>{
                    if (d === 0) return;
                    let f;
                    if (h instanceof Gi) {
                        if (h.objectForSample) {
                            if (h.objectForSample.dataPatched.physics.fusedBody) return;
                            f = h.object;
                        } else return h.object.dataPatched.physics.fusedBody === !0 && h.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                    } else if (h instanceof Nr) f = h.object;
                    else if (f = h, h.dataPatched.cloner?.hideBase) return !0;
                    let p = f.dataPatched;
                    if (!p.visible && p.physics?.enabled !== !0) return !0;
                    "geometry" in h && h.geometry && t.push(no(h.geometry, h.matrixWorld));
                }), !0;
            };
        this.traverseNoPhysics = (t, e)=>(r)=>{
                let i;
                if (r instanceof Gi) return;
                r instanceof Nr ? i = r.object : i = r;
                let s = i.dataPatched;
                if (s.physics.enabled === "visibility" ? !s.visible : !s.physics.enabled) return !0;
                if (e && !i.userData.navmesh) return;
                let o = r.geometry, a = i.userData.hasDestroy === !0, l = i.userData.hasDrag === !0;
                if (wg(s) || a || l || i.dataPatched.events.some((c)=>c.data.disabled !== !0 && c.data.type === "GameControl")) return !0;
                o && t.push(no(o, r.matrixWorld));
            };
        this.navmeshWasm = XN, this.navMesh = new this.navmeshWasm.NavMesh, this._workerURL = URL.createObjectURL(new Blob([
            (e ? p$ : m$) + g$
        ])), this._worker = new Worker(this._workerURL);
    }
    init(t, e, r) {
        this.gameControl = e, this.eventContext = r, this.setDefaultQueryExtent(new E().setScalar(t.ch * t.walkableRadius * 1.2)), this._worker.onmessage = ()=>{
            this.createNavMesh(r.page, t, (i)=>{
                this.buildFromNavmeshData(i.data);
            });
        }, this.eventContext.renderer.domElement.addEventListener("pointerdown", this.onPointerDown);
    }
    createNavMesh(t, e, r) {
        e.objects.forEach((c)=>{
            let u = t.scene.find(c);
            u.traverseEntity((h)=>{
                h.userData.navmesh = !0;
            }), u.cloner?.traverseObject((h)=>{
                h.userData.navmesh = !0;
            });
        });
        let i = [], s = (this.usePhysics ? this.traverseWithPhysics : this.traverseNoPhysics)(i, e.zones === "custom");
        if (t.traverseChildren(s), e.objects.forEach((c)=>{
            let u = t.scene.find(c);
            u.traverseEntity((h)=>{
                h.userData.navmesh = void 0;
            }), u.cloner?.traverseObject((h)=>{
                h.userData.navmesh = void 0;
            });
        }), i.length === 0) return !1;
        let o = Gs(i), { positions: a, triIndices: l } = jc(o.getAttribute("position"), o.getIndex());
        return this._worker.postMessage([
            a,
            a.length / 3,
            l,
            l.length,
            {
                ...y$,
                ...e
            }
        ]), this._worker.onmessage = r, !0;
    }
    createDebugNavGeometry() {
        let t, e, r = this.navMesh.getDebugNavMesh(), i = r.getTriangleCount(), s = new Uint32Array(i * 3), o = new Float32Array(i * 9);
        for(t = 0; t < i * 3; t++)s[t] = t;
        for(t = 0; t < i; t++)for(e = 0; e < 3; e++){
            let l = r.getTriangle(t).getPoint(e);
            o[t * 9 + e * 3 + 0] = l.x, o[t * 9 + e * 3 + 1] = l.y, o[t * 9 + e * 3 + 2] = l.z;
        }
        let a = new _e;
        return a.setIndex(new Xe(s, 1)), a.setAttribute("position", new Xe(o, 3)), a;
    }
    getClosestPoint(t) {
        return Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, this.navMesh.getClosestPoint(Ot);
    }
    getClosestPointToRef(t, e) {
        Ot.x = t.x, Ot.y = t.y, Ot.z = t.z;
        let r = this.navMesh.getClosestPoint(Ot);
        e.set(r.x, r.y, r.z);
    }
    getRandomPointAround(t, e) {
        return Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, this.navMesh.getRandomPointAround(Ot, e);
    }
    getRandomPointAroundToRef(t, e, r) {
        Ot.x = t.x, Ot.y = t.y, Ot.z = t.z;
        let i = this.navMesh.getRandomPointAround(Ot, e);
        r.set(i.x, i.y, i.z);
    }
    moveAlong(t, e) {
        return Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, en.x = e.x, en.y = e.y, en.z = e.z, this.navMesh.moveAlong(Ot, en);
    }
    moveAlongToRef(t, e, r) {
        return Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, en.x = e.x, en.y = e.y, en.z = e.z, this.navMesh.moveAlong(Ot, en);
    }
    computePath(t, e) {
        let r = this.getClosestPoint(e);
        if (en.x = r.x, en.y = r.y, en.z = r.z, Math.sqrt(Math.pow(e.x - r.x, 2) + Math.pow(e.y - r.y, 2) + Math.pow(e.z - r.z, 2)) > this.getDefaultQueryExtent().y) return [];
        this.getClosestPoint(t);
        let s = this.navMesh.computePath(Ot, en), o = s.getPointCount(), a = [];
        for(let l = 0; l < o; l++){
            let c = s.getPoint(l);
            a.push(new E(c.x, c.y, c.z));
        }
        return a;
    }
    createCrowd(t, e) {
        return new lM(this, t, e);
    }
    setDefaultQueryExtent(t) {
        Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, this.navMesh.setDefaultQueryExtent(Ot);
    }
    getDefaultQueryExtent() {
        return this.navMesh.getDefaultQueryExtent();
    }
    buildFromNavmeshData(t) {
        let e = t.length * t.BYTES_PER_ELEMENT, r = this.navmeshWasm._malloc(e), i = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, r, e);
        i.set(t);
        let s = new this.navmeshWasm.NavmeshData;
        s.dataPointer = i.byteOffset, s.size = t.length, this.navMesh.buildFromNavmeshData(s), this.navmeshWasm._free(i.byteOffset);
    }
    getNavmeshData() {
        let t = this.navMesh.getNavmeshData(), e = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, t.dataPointer, t.size), r = new Uint8Array(t.size);
        return r.set(e), this.navMesh.freeNavmeshData(t), r;
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.navMesh.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    dispose() {
        this.navMesh.destroy(), this._worker.terminate(), URL.revokeObjectURL(this._workerURL), this.eventContext?.renderer.domElement.removeEventListener("pointerdown", this.onPointerDown);
    }
    addCylinderObstacle(t, e, r) {
        return Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, this.navMesh.addCylinderObstacle(Ot, e, r);
    }
    addBoxObstacle(t, e, r) {
        return Ot.x = t.x, Ot.y = t.y, Ot.z = t.z, en.x = e.x, en.y = e.y, en.z = e.z, this.navMesh.addBoxObstacle(Ot, en, r);
    }
    removeObstacle(t) {
        this.navMesh.removeObstacle(t);
    }
    isSupported() {
        return this.navmeshWasm !== void 0;
    }
}, lM = class {
    constructor(t, e, r){
        this.navmeshWasmWrapper = t;
        this.transforms = [];
        this.agents = new Array;
        this.reachRadii = new Array;
        this._agentDestinationArmed = new Array;
        this._agentDestination = new Array;
        this.crowd = new this.navmeshWasmWrapper.navmeshWasm.Crowd(e, r, this.navmeshWasmWrapper.navMesh.getNavMesh());
    }
    onReachTarget(t, e) {}
    addAgent(t, e, r) {
        let i = new this.navmeshWasmWrapper.navmeshWasm.dtCrowdAgentParams;
        i.radius = e.radius, i.height = e.height, i.maxAcceleration = e.maxAcceleration, i.maxSpeed = e.maxSpeed, i.collisionQueryRange = e.collisionQueryRange, i.pathOptimizationRange = e.pathOptimizationRange, i.separationWeight = e.separationWeight, i.updateFlags = 7, i.obstacleAvoidanceType = 0, i.queryFilterType = 0, i.userData = 0;
        let s = this.crowd.addAgent(new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z), i);
        return this.transforms.push(r), this.agents.push(s), this.reachRadii.push(e.reachRadius ? e.reachRadius : e.radius), this._agentDestinationArmed.push(!1), this._agentDestination.push(new E(0, 0, 0)), s;
    }
    getAgentPosition(t) {
        return this.crowd.getAgentPosition(t);
    }
    getAgentPositionToRef(t, e) {
        let r = this.crowd.getAgentPosition(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentVelocity(t) {
        return this.crowd.getAgentVelocity(t);
    }
    getAgentVelocityToRef(t, e) {
        let r = this.crowd.getAgentVelocity(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentNextTargetPath(t) {
        return this.crowd.getAgentNextTargetPath(t);
    }
    getAgentNextTargetPathToRef(t, e) {
        let r = this.crowd.getAgentNextTargetPath(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentState(t) {
        return this.crowd.getAgentState(t);
    }
    overOffmeshConnection(t) {
        return this.crowd.overOffmeshConnection(t);
    }
    agentGoto(t, e) {
        this.crowd.agentGoto(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
        let r = this.agents.indexOf(t);
        r > -1 && (this._agentDestinationArmed[r] = !0, this._agentDestination[r].set(e.x, e.y, e.z));
    }
    agentTeleport(t, e) {
        this.crowd.agentTeleport(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
    }
    updateAgentParameters(t, e) {
        let r = this.crowd.getAgentParameters(t);
        e.radius !== void 0 && (r.radius = e.radius), e.height !== void 0 && (r.height = e.height), e.maxAcceleration !== void 0 && (r.maxAcceleration = e.maxAcceleration), e.maxSpeed !== void 0 && (r.maxSpeed = e.maxSpeed), e.collisionQueryRange !== void 0 && (r.collisionQueryRange = e.collisionQueryRange), e.pathOptimizationRange !== void 0 && (r.pathOptimizationRange = e.pathOptimizationRange), e.separationWeight !== void 0 && (r.separationWeight = e.separationWeight), this.crowd.setAgentParameters(t, r);
    }
    removeAgent(t) {
        this.crowd.removeAgent(t);
        let e = this.agents.indexOf(t);
        e > -1 && (this.agents.splice(e, 1), this.transforms.splice(e, 1), this.reachRadii.splice(e, 1), this._agentDestinationArmed.splice(e, 1), this._agentDestination.splice(e, 1));
    }
    getAgents() {
        return this.agents;
    }
    update(t) {
        if (this.navmeshWasmWrapper.navMesh.update(), t <= qN) return;
        let e = 1 / 60, r = 10;
        if (e <= qN) this.crowd.update(t);
        else {
            let i = Math.floor(t / e);
            r && i > r && (i = r), i < 1 && (i = 1);
            let s = t / i;
            for(let o = 0; o < i; o++)this.crowd.update(s);
        }
        for(let i = 0; i < this.agents.length; i++){
            let s = this.agents[i], o = this.getAgentPosition(s);
            if (this.transforms[i].copy(o), this._agentDestinationArmed[i]) {
                let a = o.x - this._agentDestination[i].x, l = o.z - this._agentDestination[i].z, c = this.reachRadii[i], u = this._agentDestination[i].y - this.reachRadii[i], h = this._agentDestination[i].y + this.reachRadii[i], d = a * a + l * l;
                o.y > u && o.y < h && d < c * c && (this.onReachTarget(s, this._agentDestination[i]), this._agentDestinationArmed[i] = !1);
            }
        }
    }
    setDefaultQueryExtent(t) {
        let e = new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z);
        this.crowd.setDefaultQueryExtent(e);
    }
    getDefaultQueryExtent() {
        return this.crowd.getDefaultQueryExtent();
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.crowd.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    getCorners(t) {
        let e, r = this.crowd.getCorners(t), i = r.getPointCount(), s = [];
        for(e = 0; e < i; e++){
            let o = r.getPoint(e);
            s.push(new E(o.x, o.y, o.z));
        }
        return s;
    }
    dispose() {
        this.crowd.destroy();
    }
};
function cM(n1) {
    let t = !1;
    return n1.scene.objects.forEach((e)=>{
        e.data.type === "Page" && !t && e.data.publish.gameControlObject && Pl.traverseModuleInstances(n1, e.id, (i, s, o)=>{
            for (let a of o)a.data.type === "GameControl" && a.data.navmesh.enabled && (t = !0);
        });
    }), t;
}
var x$ = {
    type: "change"
}, KN = {
    type: "changeZoom"
}, b$ = {
    type: "changePan"
}, lu = {
    type: "start"
}, cu = {
    type: "end",
    changed: !0
}, S$ = {
    type: "end",
    changed: !1
}, uM = new Ke, QN = new k, w$ = 2 * Math.PI, A$ = 1e-8, E$ = .01, hM = new E, Wb = new k, dM = new E, qb = new Ke, ZN = new ue;
var T$ = {
    type: "requestRender"
}, Hf = class extends pr {
    constructor(e, r, i = {
        isPlayMode: !1,
        isExport: !1
    }){
        super();
        this.object = e;
        this.domElement = r;
        this.options = i;
        this.enabled = !0;
        this.useKeyEvents = !0;
        this.enableDamping = !1;
        this.enableZoom = !0;
        this.enableRotate = !0;
        this.enablePan = !0;
        this.autoRotate = !1;
        this.rotationLimitsMode = 0;
        this.panLimitsMode = 0;
        this.rotationSoftLimit = 2;
        this.panSoftLimit = 2;
        this.hoverRotatePanMode = 0;
        this.zoomLimitsEnabled = !1;
        this.mouseButtons = [
            0,
            5
        ];
        this.mouseButtonsPlay = [
            3,
            4,
            5
        ];
        this.touches = [
            null,
            Xn.DOLLY_ROTATE,
            Xn.PAN
        ];
        this.offset = new E;
        this.eye = new E;
        this.lastPosition = new E;
        this.lastQuaternion = new Ke;
        this.current = new k;
        this.overShoot = new k;
        this.overRatio = new k;
        this.spherical = new Ep;
        this.sphericalDelta = new Ep;
        this.panOffset = new E;
        this.panLeftV = new E;
        this.panUpV = new E;
        this.panV = new E;
        this.rotateStart = new k;
        this.rotateEnd = new k;
        this.rotateDelta = new k;
        this.panStart = new k;
        this.panEnd = new k;
        this.panDelta = new k;
        this.dollyStart = new k;
        this.dollyEnd = new k;
        this.dollyDelta = new k;
        this.rotationRangeFactor = new k;
        this.panRangeFactor = new k;
        this.state = -1;
        this.zoomChanged = !1;
        this.isPointerDown = !1;
        this.isThetaFlipped = !1;
        this.prevScale = 0;
        this.scale = 1;
        this.gesture = !1;
        this.timer = -1;
        this.timerHover = -1;
        this.minDistance = 0;
        this.maxDistance = 1 / 0;
        this.minZoom = 0;
        this.maxZoom = 1 / 0;
        this.minPhi = 0;
        this.maxPhi = Math.PI;
        this.minTheta = -1 / 0;
        this.maxTheta = 1 / 0;
        this.minH = 0;
        this.maxH = Math.PI;
        this.minV = -1 / 0;
        this.maxV = 1 / 0;
        this.autoRotateClockwise = !0;
        this.isPanOverShoot = !1;
        this.isRotateOverShoot = !1;
        this.resetHoverEffectOnPointerLeave = !1;
        this.hasChange = !1;
        this.useWindowEvents = !1;
        this.isTouchZoom = !0;
        this.autoRotateSpeed = 2;
        this.dampingFactor = .125;
        this.zoomSpeed = 2;
        this.rotateSpeed = 1;
        this.panSpeed = 1;
        this.hoverRotatePanStrength = .1;
        this.hoverRotateDamping = this.dampingFactor;
        this.thetaIsFree = !1;
        this.phiIsFree = !1;
        this.needsUpdate = !0;
        this.onCameraChange = (e)=>{
            this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange), this.object = e.camera, this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
        };
        this.update = ()=>{
            this.object.updateWorldMatrix(!0, !1), this.object.matrixWorld.decompose(dM, qb, hM), this.offset.copy(dM).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.autoRotate && this.state === -1 && this.rotateLeft((this.autoRotateClockwise === !0 ? 1 : -1) * this.getAutoRotationAngle()), this.rotationLimitsMode !== 0 && this.applyLimits(this.sphericalDelta, this.rotationLimitsMode, this.rotationSoftLimit, this.maxTheta, this.minTheta, this.maxPhi, this.minPhi, this.rotationRangeFactor), this.rotationLimitsMode !== 2 && (this.spherical.phi += this.sphericalDelta.phi), (this.rotationLimitsMode !== 1 || this.autoRotate === !0) && (this.spherical.theta += this.sphericalDelta.theta), this.spherical.radius *= this.scale, this.zoomLimitsEnabled && this.object.isPerspectiveCamera && (this.spherical.radius = Math.max(this.minDistance, Math.min(this.maxDistance, this.spherical.radius))), this.panLimitsMode !== 0 && (this.target.applyQuaternion(uM.copy(qb).invert()), this.panOffset.applyQuaternion(uM), this.applyLimits(this.panOffset, this.panLimitsMode, this.panSoftLimit, this.maxH, this.minH, this.maxV, this.minV, this.panRangeFactor), this.target.applyQuaternion(qb), this.panOffset.applyQuaternion(qb)), this.panLimitsMode === 2 && (this.panOffset.y = 0), this.panLimitsMode === 1 && (this.panOffset.x = 0), this.state === -1 && !this.gesture ? (this.panOffset.multiplyScalar(1 - this.dampingFactor), this.target.add(this.panOffset)) : (this.target.add(this.panOffset), this.panOffset.set(0, 0, 0)), this.offset.setFromSpherical(this.spherical), dM.copy(this.target).add(this.offset), this.object.position.copy(this.target).add(this.offset), this.object.parent && (ZN.copy(this.object.parent.matrixWorld).invert(), this.object.position.applyMatrix4(ZN));
            let e = this.spherical.phi % w$;
            if (this.eye.copy(this.offset).normalize(), this.object.up.copy(Tt.DEFAULT_UP).applyAxisAngle(this.eye, this.object.angleOffsetFromUp), e > 0 && e > Math.PI || e < 0 && e > -Math.PI ? (this.object.up.negate(), this.object.lookAt(this.target), this.object.isUpVectorFlipped = !0) : (this.object.lookAt(this.target), this.object.isUpVectorFlipped = !1), this.state === -1 || this.enableDamping === !0) {
                let r = this.hoverRotatePanMode === 1 ? this.hoverRotateDamping : this.dampingFactor;
                this.sphericalDelta.theta *= 1 - r, this.sphericalDelta.phi *= 1 - r;
            } else this.sphericalDelta.set(0, 0, 0);
            return this.scale = 1, this.zoomChanged || this.lastPosition.distanceToSquared(this.object.position) > E$ || 8 * (1 - this.lastQuaternion.dot(this.object.quaternion)) > A$ ? (this.dispatchEvent(x$), this.object.dispatchEvent(T$), this.lastPosition.copy(this.object.position), this.lastQuaternion.copy(this.object.quaternion), this.zoomChanged = !1, !0) : (this.isPanOverShoot = !1, this.isRotateOverShoot = !1, this.object.wasMovedBySwitchCameraAction = !1, this.sphericalDelta.set(0, 0, 0), this.panOffset.set(0, 0, 0), !1);
        };
        this.onPointerDown = (e)=>{
            this.enabled !== !1 && (e.pointerType === "touch" || e.pointerType === "pen" && Ci ? this.onPointerDownTouch(e) : this.onPointerDownMouse(e), this.state !== -1 && (this.isPointerDown = !0, this.dispatchEvent(lu), this.domElement.addEventListener("pointermove", this.onPointerMove), this.domElement.addEventListener("pointerup", this.onPointerUp), e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && Ci || this.domElement.setPointerCapture(e.pointerId)));
        };
        this.onPointerLeave = (e)=>{
            this.resetHoverEffectOnPointerLeave && !this.useWindowEvents ? (this.hoverRotatePanMode === 1 ? (this.sphericalDelta.theta = -this.spherical.theta, this.sphericalDelta.phi = -this.spherical.phi, hM.subVectors(this.position0, this.target0), this.spherical.setFromVector3(hM), this.sphericalDelta.theta += this.spherical.theta, this.sphericalDelta.phi += this.spherical.phi, this.sphericalDelta.theta /= 8, this.sphericalDelta.phi /= 8) : this.hoverRotatePanMode === 2 && this.panOffset.subVectors(this.target0, this.target).divideScalar(8), this.update()) : this.pointerLeaveEvent = e;
        };
        this.onPointerEnter = (e)=>{
            this.resetHoverEffectOnPointerLeave || this.pointerLeaveEvent === void 0 ? Wb.set(e.clientX - this.domElement.clientWidth / 2, e.clientY - this.domElement.clientHeight / 2) : Wb.set(e.clientX - this.pointerLeaveEvent.clientX, e.clientY - this.pointerLeaveEvent.clientY), this.hoverRotatePanMode === 1 ? (this.rotateDelta.copy(Wb).multiplyScalar(this.rotateSpeed * this.hoverRotatePanStrength).rotateAround(QN, -this.object.angleOffsetFromUp), this.rotateLeft(2 * Math.PI * this.rotateDelta.x / this.domElement.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / this.domElement.clientHeight), this.rotateStart.set(e.clientX, e.clientY)) : this.hoverRotatePanMode === 2 && (this.panDelta.copy(Wb).multiplyScalar(this.panSpeed * this.hoverRotatePanStrength), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.set(e.clientX, e.clientY)), this.update();
        };
        this.onPointerMove = (e)=>{
            this.enabled !== !1 && (this.checkRaycastLock() || (e.pointerType === "touch" || e.pointerType === "pen" && Ci ? this.onPointerMoveTouch(e) : this.onPointerMoveMouse(e), e.stopPropagation()));
        };
        this.onPointerUp = (e)=>{
            this.isPointerDown = !1, Je.length === 0 && (this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp)), Je.length > 1 && e.preventDefault(), this.hasChange ? this.dispatchEvent(cu) : this.dispatchEvent(S$), this.state = -1, e && (e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && Ci || this.domElement.releasePointerCapture(e.pointerId));
        };
        this.onPointerDownMouse = (e)=>{
            let r;
            switch(this.useKeyEvents ? r = this.mouseButtons[e.button] : r = this.mouseButtonsPlay[e.button], r){
                case 0:
                    if (e.altKey === !0 && !e.shiftKey && !Bp(e)) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else if (this.key === " ") {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleMouseDownPan(e), this.state = 2;
                    break;
                case 3:
                    if (Bp(e) || e.shiftKey) {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    } else {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    }
                    break;
                case 5:
                    if (Bp(e) || e.shiftKey) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveMouse = (e)=>{
            switch(this.state){
                case 0:
                    if (this.enableRotate === !1) return;
                    this.handleMouseMoveRotate(e);
                    break;
                case 1:
                    if (this.enableZoom === !1) return;
                    this.handleMouseMoveDolly(e);
                    break;
                case 2:
                    if (this.enablePan === !1) return;
                    this.handleMouseMovePan(e);
                    break;
            }
            this.object.wasMovedByUser = !0;
        };
        this.onPointerDownTouch = (e)=>{
            switch(Je.length > 1 && e.preventDefault(), this.touches[Je.length - 1]){
                case Xn.ROTATE:
                    if (this.enableRotate === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartRotate(), this.state = 3;
                    break;
                case Xn.PAN:
                    if (this.enablePan === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartPan(), this.state = 4;
                    break;
                case Xn.DOLLY_PAN:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchStartDollyPan(), this.state = 5;
                    break;
                case Xn.DOLLY_ROTATE:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchStartDollyRotate(), this.state = 6;
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveTouch = (e)=>{
            switch(Je.length > 1 && e.preventDefault(), this.state){
                case 3:
                    if (this.enableRotate === !1) return;
                    this.handleTouchMoveRotate(e), this.update();
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleTouchMovePan(e), this.update();
                    break;
                case 5:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchMoveDollyPan(e), this.update();
                    break;
                case 6:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchMoveDollyRotate(e), this.update();
                    break;
                default:
                    this.state = -1;
            }
            this.object.wasMovedByUser = !0;
        };
        this.dispatchEndDebounced = vo(()=>this.dispatchEvent(cu), 33);
        this.onMouseWheel = (e)=>{
            this.enabled === !1 || this.enableZoom === !1 && this.enablePan === !1 || this.checkRaycastLock() || (!this.options.isExport && this.domElement.clientHeight === document.body.clientHeight && this.domElement.clientWidth === document.body.clientWidth && e.preventDefault(), this.dispatchEvent(lu), this.handleMouseWheel(e), this.dispatchEndDebounced(), this.object.wasMovedByUser = !0);
        };
        this.onGesture = (e)=>{
            if (e.preventDefault(), this.enabled !== !1 && !this.checkRaycastLock() && !xo) {
                if (e.type === "gesturechange") {
                    if (this.enableZoom === !1 || this.isTouchZoom === !1) return;
                    this.dispatchEvent(lu), e.scale > this.prevScale ? this.dollyIn(this.getZoomScale()) : e.scale < this.prevScale && this.dollyOut(this.getZoomScale()), this.prevScale = e.scale, this.update(), this.object.wasMovedByUser = !0;
                } else this.dispatchEvent(cu);
            }
        };
        this.onContextMenu = (e)=>{
            e.preventDefault();
        };
        this.onTouchEnd = (e)=>{
            e.preventDefault();
        };
        this.onKeyDown = (e)=>{
            this.enabled !== !1 && (this.key = e.key, e.key === " " && this.dispatchEvent(lu));
        };
        this.onKeyUp = (e)=>{
            this.enabled !== !1 && (this.key = void 0, this.state !== -1 && e.key === "Alt" && this.onPointerUp(Je[0]), e.key === " " && this.dispatchEvent(cu));
        };
        this.onPointerHover = (e)=>{
            e.pointerType !== "mouse" || this.enabled === !1 || this.state !== -1 || this.hoverRotatePanMode === 2 && this.isPanOverShoot || this.hoverRotatePanMode === 1 && this.isRotateOverShoot || (this.isPointerDown = !0, this.hoverRotatePanMode === 2 ? this.handleMouseMovePan(e, this.hoverRotatePanStrength) : this.hoverRotatePanMode === 1 && this.handleMouseMoveRotate(e, this.hoverRotatePanStrength));
        };
        this.onBeginState = ()=>{
            this.enabled = !1, this.needsUpdate = !1;
        };
        this.onCompleteState = (e)=>{
            e.isfromEntity && this.options.isPlayMode || (this.enabled = !0, this.needsUpdate = !0, this.object.updateUp(), this.object.getTarget(this.target));
        };
        this.target = this.object.getTarget(), this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this.quat0 = this.object.quaternion.clone(), this.isUpVectorFlipped0 = this.object.isUpVectorFlipped, this.offset.copy(this.object.position).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.initialSphericalRadius = this.spherical.radius, this.addEventListenersToCamera();
    }
    dispatchEvent(e) {
        e.type === "start" ? this.hasChange = !1 : this.hasChange = !0, super.dispatchEvent(e);
    }
    addEventListenersToCamera() {
        this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
    }
    removeEventListenersFromCamera() {
        this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange);
    }
    updateUseWindowEvents(e) {
        if (window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("pointermove", this.onPointerHover), this.useWindowEvents = e, this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover)), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let r = this.useWindowEvents ? window : this.domElement;
            r.addEventListener("pointerleave", this.onPointerLeave), r.addEventListener("pointerenter", this.onPointerEnter);
        }
    }
    fromJSON(e, r) {
        this.setEnableDampingSpeed(e.enableDamping), this.enablePan = e.enablePan, this.enableZoom = e.enableZoom, this.enableRotate = e.enableRotate, this.rotationLimitsMode = e.rotationLimitsMode, this.thetaIsFree = e.rotationHorizontalOffset.min === e.rotationHorizontalOffset.max && e.rotationHorizontalOffset.min === Math.PI, this.phiIsFree = e.rotationVerticalOffset.min === e.rotationVerticalOffset.max && e.rotationVerticalOffset.min === Math.PI, this.panLimitsMode = e.panLimitsMode, this.panSoftLimit = e.panSoftLimit, this.rotationSoftLimit = e.rotationSoftLimit, this.hoverRotatePanMode = e.hoverRotatePanMode, this.hoverRotateDamping = e.hoverRotateDamping ?? this.dampingFactor, this.useWindowEvents = r === "window", this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover));
        let i = e.hoverRotatePanStrength / 100;
        this.hoverRotatePanStrength = i ** 2, this.zoomLimitsEnabled = e.zoomLimitsEnabled, this.minZoom = e.zoomLimits.min, this.maxZoom = Math.max(e.zoomLimits.min, e.zoomLimits.max), this.minDistance = 1e3 / e.zoomLimits.max, this.maxDistance = Math.max(this.minDistance, 1e3 / e.zoomLimits.min), this.autoRotate = e.autoRotate, this.autoRotateSpeed = e.autoRotateSpeed, this.autoRotateClockwise = e.autoRotateClockwise;
        let s = this.object.getTarget().applyQuaternion(uM.copy(this.object.quaternion).invert());
        this.minV = -e.panVerticalOffset.min + s.y, this.maxV = e.panVerticalOffset.max + s.y, this.minH = -e.panHorizontalOffset.min + s.x, this.maxH = e.panHorizontalOffset.max + s.x, this.panRangeFactor.set(this.maxH - this.minH, this.maxV - this.minV).divideScalar(2), this.rotationRangeFactor.setScalar(Math.PI).divideScalar(4), this.minPhi = Jo(this.spherical.phi - e.rotationVerticalOffset.min), this.maxPhi = Jo(this.spherical.phi + e.rotationVerticalOffset.max), this.minTheta = Jo(Jo(this.spherical.theta) - e.rotationHorizontalOffset.min), this.maxTheta = Jo(Jo(this.spherical.theta) + e.rotationHorizontalOffset.max), this.isThetaFlipped = this.minTheta > this.maxTheta, e.orbitTouches === 1 && (this.touches[0] = Xn.ROTATE), e.panTouches === 1 && (this.touches[0] = Xn.PAN), e.orbitTouches === 2 && (this.touches[1] = Xn.DOLLY_ROTATE), e.panTouches === 2 && (this.touches[1] = Xn.DOLLY_PAN), e.orbitTouches === 3 && (this.touches[2] = Xn.ROTATE), e.panTouches === 3 && (this.touches[2] = Xn.PAN), this.isTouchZoom = e.isTouchZoom, this.resetHoverEffectOnPointerLeave = e.resetHoverEffectOnPointerLeave ?? !1;
    }
    connect() {
        if (this.domElement.addEventListener("contextmenu", this.onContextMenu), this.domElement.addEventListener("pointerdown", this.onPointerDown), this.domElement.addEventListener("wheel", this.onMouseWheel), window.addEventListener("keydown", this.onKeyDown, !1), window.addEventListener("keyup", this.onKeyUp, !1), this.domElement.addEventListener("gesturestart", this.onGesture), this.domElement.addEventListener("gesturechange", this.onGesture), this.domElement.addEventListener("gestureend", this.onGesture), this.domElement.addEventListener("touchend", this.onTouchEnd), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let e = this.useWindowEvents ? window : this.domElement;
            e.addEventListener("pointerleave", this.onPointerLeave), e.addEventListener("pointerenter", this.onPointerEnter);
        }
        this.pointerLeaveEvent = void 0;
    }
    dispose() {
        this.removeEventListenersFromCamera(), this.domElement.removeEventListener("contextmenu", this.onContextMenu), this.domElement.removeEventListener("pointerdown", this.onPointerDown), this.domElement.removeEventListener("wheel", this.onMouseWheel), window.removeEventListener("keydown", this.onKeyDown, !1), window.removeEventListener("keyup", this.onKeyUp, !1), this.domElement.removeEventListener("pointermove", this.onPointerHover), window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("gesturestart", this.onGesture), this.domElement.removeEventListener("gesturechange", this.onGesture), this.domElement.removeEventListener("gestureend", this.onGesture), this.domElement.removeEventListener("touchend", this.onTouchEnd), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp);
    }
    applyLimits(e, r, i, s, o, a, l, c) {
        this.overShoot.set(0, 0);
        let u, h, d;
        e instanceof E ? (u = e.x, h = e.y, this.current.set(this.target.x, this.target.y), d = !0) : (u = e.theta, h = e.phi, this.current.set(Jo(this.spherical.theta), Jo(this.spherical.phi)), d = !1), i === 0 && (this.current.x += u, this.current.y += h), (r === 3 || r === 2) && (!d && this.isThetaFlipped ? this.current.x > s && this.current.x < 0 ? this.overShoot.x = s - this.current.x : this.current.x < o && this.current.x > 0 && (this.overShoot.x = o - this.current.x) : this.current.x > s ? this.overShoot.x = s - this.current.x : this.current.x < o && (this.overShoot.x = o - this.current.x)), (r === 3 || r === 1) && (this.current.y > a ? this.overShoot.y = a - this.current.y : this.current.y < l && (this.overShoot.y = l - this.current.y)), d || (this.overShoot.x = Jo(this.overShoot.x), this.overShoot.y = Jo(this.overShoot.y)), i !== 0 ? (this.overRatio.copy(this.overShoot).divide(c), this.overRatio.x = Math.min(Math.abs(this.overRatio.x), 1), this.overRatio.y = Math.min(Math.abs(this.overRatio.y), 1), i === 1 && (this.overRatio.x = JN(Math.abs(this.overRatio.x)), this.overRatio.y = JN(Math.abs(this.overRatio.y))), this.isPointerDown || i === 1 ? i === 2 && (this.overRatio.x > .9 && !this.thetaIsFree || this.overRatio.y > .9 && !this.phiIsFree) ? this.isPointerDown = !1 : (u * this.overShoot.x < 0 && !this.thetaIsFree && (u *= 1 - this.overRatio.x), h * this.overShoot.y < 0 && !this.phiIsFree && (h *= 1 - this.overRatio.y)) : i === 2 && (!d && (this.overRatio.x > .002 && !this.thetaIsFree || this.overRatio.y > .002 && !this.phiIsFree) || d && (Math.abs(this.overShoot.x) > 2 || Math.abs(this.overShoot.y) > 2) ? (this.thetaIsFree || (u = this.overShoot.x * .05), this.phiIsFree || (h = this.overShoot.y * .05), d ? this.isPanOverShoot = !0 : this.isRotateOverShoot = !0) : d ? this.isPanOverShoot = !1 : this.isRotateOverShoot = !1)) : (u += this.overShoot.x, h += this.overShoot.y), e instanceof E ? (e.x = u, e.y = h) : (this.thetaIsFree || (e.theta = u), this.phiIsFree || (e.phi = h));
    }
    setEnableDampingSpeed(e) {
        this.enableDamping = e, this.rotateSpeed = e === !0 ? .2 : 1;
    }
    stopDamping() {
        this.sphericalDelta.theta = 0, this.sphericalDelta.phi = 0;
    }
    getAutoRotationAngle() {
        return 2 * Math.PI / 60 / 60 * this.autoRotateSpeed;
    }
    getZoomScale() {
        return Math.pow(.95, this.zoomSpeed);
    }
    rotateLeft(e) {
        this.sphericalDelta.theta -= e;
    }
    rotateUp(e) {
        this.sphericalDelta.phi -= e;
    }
    panLeft(e, r) {
        this.panLeftV.setFromMatrixColumn(r, 0), this.panLeftV.multiplyScalar(-e), this.panOffset.add(this.panLeftV);
    }
    panUp(e, r) {
        this.panUpV.setFromMatrixColumn(r, 1), this.panUpV.multiplyScalar(e), this.panOffset.add(this.panUpV);
    }
    pan(e, r) {
        let i = this.domElement;
        if (i && this.object.isPerspectiveCamera) {
            let s = this.object.position;
            this.panV.copy(s).sub(this.target);
            let o = this.panV.length();
            o *= Math.tan(this.object.fov / 2 * Math.PI / 180), this.panLeft(2 * e * o / i.clientHeight, this.object.matrixWorld), this.panUp(2 * r * o / i.clientHeight, this.object.matrixWorld);
        } else i && this.object.isOrthographicCamera && (this.panLeft(e * (this.object.right - this.object.left) / this.object.zoom / i.clientWidth, this.object.matrixWorld), this.panUp(r * (this.object.top - this.object.bottom) / this.object.zoom / i.clientHeight, this.object.matrixWorld));
        this.dispatchEvent(b$);
    }
    dollyOut(e) {
        this.object.isPerspectiveCamera ? this.scale /= e : this.object.isOrthographicCamera && (this.object.zoom *= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(KN);
    }
    dollyIn(e) {
        this.object.isPerspectiveCamera ? this.scale *= e : this.object.isOrthographicCamera && (this.object.zoom /= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(KN);
    }
    zoomOut(e = this.getZoomScale()) {
        this.dispatchEvent(lu), this.dollyOut(e), this.dispatchEvent(cu);
    }
    zoomIn(e = this.getZoomScale()) {
        this.dispatchEvent(lu), this.dollyIn(e), this.dispatchEvent(cu);
    }
    setZoom(e) {
        if (this.dispatchEvent(lu), this.object.isPerspectiveCamera) {
            let i = this.initialSphericalRadius / e / this.spherical.radius;
            this.scale = i;
        } else this.object.isOrthographicCamera && (this.object.zoom = e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0);
        this.dispatchEvent(cu);
    }
    handleMouseDownRotate(e) {
        this.rotateStart.set(e.clientX, e.clientY);
    }
    handleMouseDownDolly(e) {
        this.dollyStart.set(e.clientX, e.clientY);
    }
    handleMouseDownPan(e) {
        this.panStart.set(e.clientX, e.clientY);
    }
    handleMouseMoveRotate(e, r = 1) {
        e.movementX !== void 0 ? this.rotateDelta.set(e.movementX, e.movementY) : (this.rotateEnd.set(e.clientX, e.clientY), this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart), this.rotateStart.copy(this.rotateEnd)), this.rotateDelta.multiplyScalar(this.rotateSpeed * r).rotateAround(QN, -this.object.angleOffsetFromUp);
        let i = this.domElement, s = this.useWindowEvents ? window.innerHeight : i.clientHeight, o = 2 * Math.PI * this.rotateDelta.x / s, a = 2 * Math.PI * this.rotateDelta.y / s;
        this.rotateLeft(o), this.rotateUp(a), this.update();
    }
    handleMouseMoveDolly(e) {
        this.dollyEnd.set(e.clientX, e.clientY), this.dollyDelta.subVectors(this.dollyEnd, this.dollyStart), this.dollyDelta.y > 0 ? this.dollyOut(this.getZoomScale()) : this.dollyDelta.y < 0 && this.dollyIn(this.getZoomScale()), this.dollyStart.copy(this.dollyEnd), this.update();
    }
    handleMouseMovePan(e, r = 1) {
        e.movementX !== void 0 ? this.panDelta.set(e.movementX, e.movementY) : (this.panEnd.set(e.clientX, e.clientY), this.panDelta.subVectors(this.panEnd, this.panStart), this.panStart.copy(this.panEnd)), this.panDelta.multiplyScalar(this.panSpeed * r), this.pan(this.panDelta.x, this.panDelta.y), this.update();
    }
    handleMouseWheel(e) {
        if ($2 === !1 && Bp(e) === !1 && tI(e) === !0) {
            if (this.enablePan === !1) return;
            this.gesture ? (this.panDelta.set(-e.deltaX, -e.deltaY).multiplyScalar(this.panSpeed), this.panDelta.x = Math.min(Math.abs(this.panDelta.x), 100) * (this.panDelta.x < 0 ? -1 : 1), this.panDelta.y = Math.min(Math.abs(this.panDelta.y), 100) * (this.panDelta.y < 0 ? -1 : 1), e.altKey ? this.pan(0, this.panDelta.y) : e.shiftKey ? this.pan(this.panDelta.x, 0) : this.pan(this.panDelta.x, this.panDelta.y), this.update()) : (this.gesture = !0, this.isPointerDown = !0), window.clearTimeout(this.timer), this.timer = window.setTimeout(()=>{
                this.gesture = !1, this.isPointerDown = !1;
            }, 30);
        } else {
            if (this.enableZoom === !1 || this.gesture) return;
            e.deltaY === 0 ? e.deltaX < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaX > 0 && this.dollyOut(this.getZoomScale()) : e.deltaY < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaY > 0 && this.dollyOut(this.getZoomScale()), this.update(), this.gesture = !1, this.isPointerDown = !1;
        }
    }
    handleTouchStartRotate() {
        if (Je.length === 2) {
            let e = .5 * (Je[0].pageX + Je[1].pageX), r = .5 * (Je[0].pageY + Je[1].pageY);
            this.rotateStart.set(e, r);
        } else this.rotateStart.set(Je[0].pageX, Je[0].pageY);
    }
    handleTouchStartPan() {
        if (Je.length === 2) {
            let e = .5 * (Je[0].pageX + Je[1].pageX), r = .5 * (Je[0].pageY + Je[1].pageY);
            this.panStart.set(e, r);
        } else this.panStart.set(Je[0].pageX, Je[0].pageY);
    }
    handleTouchStartDolly() {
        let e = Je[0].pageX - Je[1].pageX, r = Je[0].pageY - Je[1].pageY, i = Math.sqrt(e * e + r * r);
        this.dollyStart.set(0, i);
    }
    handleTouchStartDollyPan() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enablePan && this.handleTouchStartPan();
    }
    handleTouchStartDollyRotate() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enableRotate && this.handleTouchStartRotate();
    }
    handleTouchMoveRotate(e) {
        if (Je.length === 2) {
            let i = mv(e), s = .5 * (e.pageX + i.x), o = .5 * (e.pageY + i.y);
            this.rotateEnd.set(s, o);
        } else {
            if (e.pointerId !== Je[0].pointerId) return;
            this.rotateEnd.set(e.pageX, e.pageY);
        }
        this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart).multiplyScalar(this.rotateSpeed);
        let r = this.domElement;
        r && (this.rotateLeft(2 * Math.PI * this.rotateDelta.x / r.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / r.clientHeight)), this.rotateStart.copy(this.rotateEnd);
    }
    handleTouchMovePan(e) {
        if (Je.length === 2) {
            let r = mv(e), i = .5 * (e.pageX + r.x), s = .5 * (e.pageY + r.y);
            this.panEnd.set(i, s);
        } else {
            if (e.pointerId !== Je[0].pointerId) return;
            this.panEnd.set(e.pageX, e.pageY);
        }
        this.panDelta.subVectors(this.panEnd, this.panStart).multiplyScalar(this.panSpeed), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.copy(this.panEnd);
    }
    handleTouchMoveDolly(e) {
        let r = mv(e), i = e.pageX - r.x, s = e.pageY - r.y, o = Math.sqrt(i * i + s * s);
        this.dollyEnd.set(0, o), this.dollyDelta.set(0, Math.pow(this.dollyEnd.y / this.dollyStart.y, this.zoomSpeed)), this.dollyOut(this.dollyDelta.y), this.dollyStart.copy(this.dollyEnd);
    }
    handleTouchMoveDollyPan(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enablePan && this.handleTouchMovePan(e);
    }
    handleTouchMoveDollyRotate(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enableRotate && this.handleTouchMoveRotate(e);
    }
    checkRaycastLock() {
        if (this.object.data.raycastLock) {
            if (this.options.isPlayMode) return !1;
            {
                let e = this.options?.showCameraLock;
                return e && e(), !0;
            }
        } else return !1;
    }
};
function Jo(n1) {
    let t = Math.PI * 2;
    for(; n1 <= -Math.PI;)n1 += t;
    for(; n1 > Math.PI;)n1 -= t;
    return n1;
}
function JN(n1) {
    return 1 - Math.pow(1 - n1, 4);
}
var Ag = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.page = i;
        this.currentIntersectedObjects = [];
        this.actions = Ut(e, e.actions, i, s, o, r), this.target = e.target, this.triggeringObjects = [];
        for (let a of e.triggeringObjects){
            let l = i.scene.find(a);
            l && this.triggeringObjects.push(l);
        }
    }
    isValidTriggeringObject(t) {
        return this.target === "all" ? !0 : this.triggeringObjects.some((e)=>e === t || e.isAncestorOf(t.uuid) || t.isAncestorOf(e.uuid));
    }
    disconnect() {
        hr(this.actions);
    }
    dispatch() {
        this.object.destroyedInAction || (this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Trigger"
        }), this.actions.Transition.forEach((t)=>{
            t.data.runMode === "Toggle" ? t.toggle() : t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.data.runMode === "Toggle" ? t.toggle() : t.play();
        }), this.actions.Link.forEach((t)=>{
            t.dispatch();
        }), this.actions.Reset.forEach((t)=>{
            t.dispatch();
        }), this.actions.Create.forEach((t)=>{
            t.dispatch();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatch(!1);
        }), this.actions.Audio.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.Particles.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.Video.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.SceneTransition.forEach((t)=>{
            t.dispatch();
        }), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch()));
    }
};
var jt;
dI.then((n1)=>jt = n1);
var bi = new E, oo = new Ke, ac = new E, fM = new nr(0, 0, 0, "YXZ"), $N = new nr(0, 0, 0, "XYZ"), ao = new E, pM = new E, mM = new E(1, 1, 1), Wf = new Ke, Yb = new ue, eF = new ue, M$ = {
    type: "updateMatrix"
}, tF = new Ke, gM = new Rr, Pb = {
    type: "beginEvent",
    eventName: "Collision"
}, C$ = {
    type: "beginEvent",
    eventName: "Trigger"
};
function rF(n1) {
    if (Pl.physicsEnabled(n1.scene.objects)) return !0;
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        if (r.events) {
            if (Array.isArray(r.events)) {
                for (let i of r.events)if (i.data.disabled !== !0 && i.data.type === "GameControl" && i.data.collisionEnabled) {
                    t = !0;
                    break;
                }
            } else for (let i of Object.values(r.events))if (i.disabled !== !0 && i.type === "GameControl" && i.collisionEnabled) {
                t = !0;
                break;
            }
        }
    }), t;
}
var wg = (n1)=>n1.states.some((t)=>t.data.position !== void 0 || t.data.rotation !== void 0 || t.data.hiddenMatrix !== void 0 || t.data.cloner !== void 0 || t.data.pathSnapping !== void 0), Xb = class {
    constructor(t){
        this.eventContext = t;
        this.isEnabled = !1;
        this.gameControl = null;
        this.joysticks = [];
        this.joystickToGameControls = [];
        this.sharedGameControlGlobals = {
            entitiesWithTransformAnim: [],
            entityToCollisionEvents: {},
            colliderToEntity: new Map,
            triggers: [],
            gamePads: [],
            createdObjects: [],
            nCreatedPerAction: {}
        };
        this.sensorToTriggerEvent = {};
        this.eventManager = void 0;
        this.needsCollisionDetection = !1;
        this.initializationCounter = -1;
        this.rigidBodyToMesh = new Map;
        this.nActiveRigidBodies = 0;
        this.collisionEvents = [];
        this.isExport = !1;
        this.processRigidBody = (t)=>{
            if (t.bodyType() !== jt.RigidBodyType.Dynamic) return;
            t.isSleeping() || this.nActiveRigidBodies++;
            let [e, r, i] = this.rigidBodyToMesh.get(t.handle);
            if (bi.copy(t.translation()).multiplyScalar(this.pixelsPerMeter), oo.copy(t.rotation()), e.matrixWorld.compose(bi, oo, r), e.hasNonUniformScale && e.matrixWorld.multiply(e.shearScale), e.dispatchEvent(M$), i) {
                let s = e.cloner;
                if (s && s.objectForSample === void 0) {
                    s.matrixWorld.copy(e.matrixWorld);
                    for (let o of s.children)o.updateMatrixWorld(!0);
                }
                for (let o of e.children)o.updateMatrixWorld(!0);
            }
        };
        this.accumulator = 0;
        this.handleCollisionEvents = (t, e, r)=>{
            if (r === !1) return;
            let i, s;
            if (this.sensorToTriggerEvent[t] ? (i = this.sensorToTriggerEvent[t], s = this.sharedGameControlGlobals.colliderToEntity.get(e)) : this.sensorToTriggerEvent[e] && (i = this.sensorToTriggerEvent[e], s = this.sharedGameControlGlobals.colliderToEntity.get(t)), i && s && i.isValidTriggeringObject(s)) {
                i.dispatch();
                return;
            }
            for(let o = this.sharedGameControlGlobals.createdObjects.length - 1; o >= 0; o--){
                let a = this.sharedGameControlGlobals.createdObjects[o];
                if (a.userData.hasCollisionDestroy && (a.rigidBody?.collider(0).handle === t || a.rigidBody?.collider(0).handle === e)) {
                    this.sharedGameControlGlobals.createdObjects.splice(o, 1), a.removeFromParent(), requestAnimationFrame(()=>this.sharedGameControlGlobals.rapierWorld?.removeRigidBody(a.rigidBody));
                    break;
                }
            }
            if (this.gameControl?.object !== void 0 && this.gameControl.object === this.sharedGameControlGlobals.colliderToEntity.get(t)) {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(e), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a === void 0) return;
                for (let l of a)l.data.target === "character" && this.dispatchCollisionEvent(l, o, e);
            } else if (this.gameControl?.object !== void 0 && this.gameControl.object === this.sharedGameControlGlobals.colliderToEntity.get(e)) {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(t), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a === void 0) return;
                for (let l of a)l.data.target === "character" && this.dispatchCollisionEvent(l, o, t);
            } else {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(t), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a !== void 0) for (let u of a)u.data.target === "scene" && this.dispatchCollisionEvent(u, o, t);
                let l = this.sharedGameControlGlobals.colliderToEntity.get(e), c = this.sharedGameControlGlobals.entityToCollisionEvents[l?.uuid];
                if (c !== void 0) for (let u of c)u.data.target === "scene" && this.dispatchCollisionEvent(u, l, e);
            }
        };
        this.isExport = t.isExport, this.sharedAssets = t.sharedAssets, this.renderer = t.renderer, this.requestRender = t.requestRender, this.domElement = this.renderer.domElement, this.pixelsPerMeter = jT, this.gravity = this.page.data.globalPhysics.gravity;
    }
    get page() {
        return this.eventContext.page;
    }
    attachVRControllers(t) {
        t.forEach((e)=>{
            e.addEventListener("connected", (r)=>{
                "gamepad" in r.data && "axes" in r.data.gamepad && this.sharedGameControlGlobals.gamePads.push(r.data.gamepad);
            });
        });
    }
    markIsDestroyTarget() {
        this.page.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let r of e.events){
                if (r.data.disabled === !0) continue;
                let i = r.data.actions?.find((s)=>s.data.type === "Destroy")?.data;
                if (i) for (let s of i.objects){
                    let o = this.page.scene.find(s);
                    o && (o.userData.hasDestroy = !0);
                }
            }
        });
    }
    markIsDragObject() {
        this.page.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let r of e.events)if (!(r.data.disabled === !0 || r.data.type !== "DragDrop")) for (let i of r.data.objects){
                let s = this.page.scene.find(i);
                s && (s.userData.hasDrag = !0);
            }
        });
    }
    initBVH() {
        let t = [];
        if (this.page.traverseChildren((e)=>{
            let r, i = e instanceof ql, s = e instanceof rc;
            if (e instanceof Gi || i || s) return;
            e instanceof Nr ? r = e.object : r = e;
            let o = r.dataPatched;
            if (o.physics?.enabled === "visibility" ? !o.visible : !o.physics?.enabled) return !0;
            let a = e.geometry, l = r.userData.hasDestroy === !0, c = r.userData.hasDrag === !0;
            if (wg(o) || l || c || r.dataPatched.events.some((u)=>u.data.disabled !== !0 && (u.data.type === "GameControl" || u.data.type === "Follow"))) return e.updateMatrixWorldSVD(), this.addBoundsTree(e), !0;
            a && t.push(no(a, e.matrixWorld));
        }), t.length > 0) {
            let e = Gs(t, !1);
            this.sharedGameControlGlobals.staticMeshBVH = new Do(e);
        }
    }
    addRigidBody(t, e, r) {
        let i = [], s = "geometry" in t ? t.geometry : void 0, o = e.dataPatched;
        if (s?.getAttribute("position") !== void 0 && i.push(no(s, t.shearScale)), o.physics.fusedBody) {
            let a = this.gatherChildrenGeom(t, i);
            t.traverseObject(a), t.children.forEach((c)=>c.updateMatrixWorld(!0));
            let l = t.cloner;
            l && l.objectForSample === void 0 && o.physics.rigidBody === "dynamic" && (l.traverseObject(a), l.children.forEach((c)=>c.updateMatrixWorld(!0)));
        }
        if (i.length > 0) {
            let a, l = !r.fromCreate && o.physics.rigidBody === "dynamic" || r.fromCreate && r.dynamic;
            l ? (a = jt.RigidBodyDesc.dynamic(), a.setLinearDamping(o.physics.damping).setAngularDamping(o.physics.damping).setAdditionalMass(1e-9).setGravityScale(o.physics.gravityScale).enabledRotations(...o.physics.enabledRotation).enabledTranslations(...o.physics.enabledTranslation)) : (r.hasTransformAnim || r.hasFollow || r.hasDrag) && !r.fromCreate ? (a = jt.RigidBodyDesc.kinematicPositionBased(), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t)) : a = jt.RigidBodyDesc.fixed();
            let c = Gs(i);
            (t.hasNonUniformScale ? t.matrixWorldRigid : t.matrixWorld).decompose(bi, oo, ac), t.position0 = bi.clone().divideScalar(this.pixelsPerMeter), t.rotation0 = oo.clone(), bi.divideScalar(this.pixelsPerMeter), a.setTranslation(bi.x, bi.y, bi.z).setRotation(oo), s ? c?.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter) : c?.scale(ac.x / this.pixelsPerMeter, ac.y / this.pixelsPerMeter, ac.z / this.pixelsPerMeter);
            let u = this.sharedGameControlGlobals.rapierWorld.createRigidBody(a);
            l && this.rigidBodyToMesh.set(u.handle, [
                t,
                ac.clone(),
                o.physics.fusedBody
            ]);
            let h = !(o.geometry === void 0 || o.geometry.type === "SubdivGeometry" || o.geometry.type === "NonParametricGeometry" || o.geometry.type === "BooleanGeometry" || o.geometry.type === "VectorGeometry" || o.geometry.type === "StarGeometry" || o.geometry.type === "RectangleGeometry" || o.geometry.type === "EllipseGeometry" || o.geometry.type === "TriangleGeometry" || o.geometry.type === "TorusGeometry" || o.geometry.type === "HelixGeometry");
            try {
                this.addCollider(u, o.physics, c, e, h);
            } catch  {
                try {
                    this.addCollider(u, o.physics, c, e, !1);
                } catch (f) {
                    console.error(f);
                }
            }
            t.rigidBody = u;
        }
    }
    addBoundsTree(t) {
        let e = [];
        if (t.geometry?.getAttribute("position") !== void 0 && t.geometry?.getAttribute("position").count > 0 && e.push(no(t.geometry, t.shearScale)), t.traverseObject(this.gatherChildrenGeom(t, e)), t.children.forEach((r)=>r.updateMatrixWorld(!0)), e.length > 0) {
            let r = Gs(e, !1);
            t.bvhGeometry = r, r.getAttribute("position").count > 0 && (t.bvhGeometry.boundsTree = new Do(r), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t));
        }
    }
    addCollider(t, e, r, i, s = !0) {
        if (r?.getAttribute("position").count === 0 || r?.getIndex()?.count === 0) return;
        let o;
        r && (e.colliderType === "trimesh" ? o = jt.ColliderDesc.trimesh(r.getAttribute("position").array, r.getIndex().array) : o = jt.ColliderDesc.convexMesh(r.getAttribute("position").array, s ? r.getIndex().array : void 0)), o.setFrictionCombineRule(jt.CoefficientCombineRule.Average).setRestitutionCombineRule(jt.CoefficientCombineRule.Average).setDensity(e.density).setFriction(e.friction).setRestitution(e.restitution);
        let a = this.sharedGameControlGlobals.rapierWorld.createCollider(o, t);
        this.sharedGameControlGlobals.colliderToEntity.set(a.handle, i), this.sharedGameControlGlobals.entityToCollisionEvents[i.uuid]?.some((l)=>l.target === "scene") && a.setActiveEvents(jt.ActiveEvents.COLLISION_EVENTS);
    }
    gatherChildrenGeom(t, e) {
        return (r, i)=>{
            if (i === 0) return;
            let s;
            if (r instanceof Gi) {
                if (r.objectForSample) {
                    if (r.objectForSample.dataPatched.physics.fusedBody) return;
                    s = r.object;
                } else return r.object.dataPatched.physics.fusedBody === !0 && r.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (r instanceof Nr) s = r.object;
            else if (s = r, s.dataPatched.cloner?.hideBase) return !0;
            let o = s.dataPatched;
            if (o.physics.enabled === "visibility" ? !o.visible : !o.physics.enabled) return !0;
            i === 1 ? t.hasNonUniformScale ? r.matrixWorld.multiplyMatrices(t.shearScale, r.hiddenMatrix) : r.matrixWorld.copy(r.hiddenMatrix) : r.matrixWorld.multiplyMatrices(r.parent.matrixWorld, r.hiddenMatrix), r.matrixWorld.multiply(r.matrix);
            let a = r.geometry;
            a?.getAttribute("position") !== void 0 && e.push(no(a, r.matrixWorld));
        };
    }
    activate(t) {
        if (this.isEnabled) return;
        this.isEnabled = !0, this.eventManager = t, this.usePhysics = this.page.data.globalPhysics.usePhysics;
        let e = this.page.playCamera, r = !1, i = 5, s = 8, o = 9, a = "drag", l = this.page.data.publish.gameControlObject, c = l !== null ? this.page.find(l) : null, u = null;
        if (c) for (let f of c.data.events){
            if (f.data.disabled || f.data.type !== "GameControl") continue;
            let p = c;
            for(; this.usePhysics && (p = p.parent)?.parent !== null;)p.data.physics?.fusedBody;
            f.data.collisionEnabled && (this.needsCollisionDetection = !0), u === null && (u = f.data);
        }
        if (this.page.traverseEntity((f)=>{
            for (let p of f.dataPatched.events)if (p.data.disabled === !1 && p.data.type === "Trigger") return this.needsCollisionDetection = !0, !0;
        }), c && u && (c.data.visible === !0 || c.data.physics.enabled === !0)) {
            r = r || u.camera === e.uuid || c.uuid === e.uuid;
            let f = new mg(c, this.renderer.domElement, u, this.eventContext.page.data.globalPhysics, this, c.uuid !== e.uuid && u.camera === e.uuid, e, this.page, this.sharedAssets);
            this.gameControl = f, i = u.joystickPosLoc, s = u.joystickRotLoc, o = u.jumpTouchButtonLoc, a = u.rotByTouch, Ci && u.touchControl && (this.joystickToGameControls[i] = "pos", u.moveMode === "walk" && (this.joystickToGameControls[o] = "jmp"), a === "joystick" && (this.joystickToGameControls[s] = "rot"));
        }
        if (this.gameControl && this.gameControl.data.navmesh.enabled) {
            let f = this.gameControl.data;
            if (!this.navigationMeshWrapper) {
                this.navigationMeshWrapper = new Hb(this.usePhysics, this.isExport);
                let p;
                f.collider.type === "sphere" ? p = f.collider.radius * 2 : p = f.collider.height, p = Math.floor(p / f.navmesh.ch - 1), this.navigationMeshWrapper.init({
                    ...f.navmesh,
                    walkableHeight: p
                }, this.gameControl, this.eventContext);
            }
        }
        if (r === !1) {
            let { enableRotate: f, enablePan: p, enableZoom: m, autoRotate: g, hoverRotatePanMode: y } = this.eventManager.publish.orbitControls;
            (f || p || m || g || y !== 0) && (this.orbitControls = new Hf(e, this.renderer.domElement, {
                isExport: this.isExport,
                isPlayMode: !0
            }), this.orbitControls.addEventListener("change", this.requestRender), this.orbitControls.addEventListener("end", this.requestRender), this.orbitControls.addEventListener("start", this.requestRender), this.orbitControls.fromJSON(this.eventManager.publish.orbitControls, this.eventManager.publish.mouseEventTarget), this.orbitControls.useKeyEvents = !1, this.orbitControls.addEventListenersToCamera(), this.orbitControls.connect(), this.orbitControls.update());
        }
        let h = this.renderer.domElement.width / this.renderer.getPixelRatio(), d = this.renderer.domElement.height / this.renderer.getPixelRatio();
        this.joystickToGameControls.forEach((f, p)=>{
            let m = document.body.appendChild(document.createElement("div")), [g, y, x] = this.eventManager.eventContext.publish.joystickSizeAndXYOffset[p], v = (h - 5 * g) / 4 + g, S = {}, w = f === "jmp", A = w ? 0 : g;
            p < 10 ? (p < 5 ? S.top = A / 2 : S.bottom = A / 2, S.left = A / 2 + p % 5 * v) : p === 10 ? (S.left = A / 2, S.top = d / 2) : (S.right = A / 2, S.top = d / 2), S.top ? S.top -= y[1] : S.bottom += y[1], S.left ? S.left += y[0] : S.right -= y[0];
            for(let M in S)S[M] += "px";
            if (w) {
                let M = m.appendChild(document.createElement("div"));
                Object.assign(M.style, S, {
                    position: "absolute",
                    width: g + "px",
                    height: g + "px",
                    backgroundColor: `rgba(255,255,255,${x === "show" ? .4 : 0})`,
                    zIndex: "9999",
                    borderRadius: g + "px",
                    border: x === "show" ? "solid 2px rgba(0, 0, 0, .1)" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    touchAction: "none"
                });
                let C = g / 16 * 6.4;
                x === "show" && (M.innerHTML = `
						<svg width="${C}" height="${g * .4}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2 10L8 4L14 10" stroke="black" stroke-opacity="40%" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					`), M.addEventListener("pointerdown", ()=>{
                    this.gameControl.movementState.jump = 1, this.requestRender();
                }), M.addEventListener("touchend", (P)=>P.preventDefault()), this.joysticks[p] = [
                    void 0,
                    m
                ];
                return;
            }
            let T = {
                zone: m,
                mode: "static",
                position: S,
                size: g
            };
            x === "hide" && (T.restOpacity = 0);
            let b = RB.create(T);
            b.on("move", (M, C)=>{
                let P = this.gameControl;
                f === "pos" ? C.force < .2 ? P.moveForce = 0 : (P.movementState.movePosZ = Math.sin(-C.angle.radian), P.movementState.movePosX = Math.cos(-C.angle.radian), C.force > 1.2 ? P.movementState.run = 1 : P.movementState.run = 0, C.force < .3 ? P.moveForce = (C.force - .2) / .1 : P.moveForce = 1) : f === "rot" && (C.force < .2 ? P.rotForce = 0 : (P.movementState.rotPosX = C.vector.y, P.movementState.rotPosY = -C.vector.x, C.force < .3 ? P.rotForce = (C.force - .2) / .1 : P.rotForce = 1)), this.requestRender();
            }), b.on("end", (M, C)=>{
                let P = this.gameControl;
                f === "pos" ? (P.movementState.movePosZ = 0, P.movementState.movePosX = 0, P.moveForce = 1) : f === "rot" && (P.movementState.rotPosX = 0, P.movementState.rotPosY = 0, P.rotForce = 1);
            }), this.joysticks[p] = [
                b,
                m
            ];
        }), this.markIsDestroyTarget(), this.markIsDragObject(), this.rebuildBVH(), this.initializationCounter++, window.setTimeout(()=>{
            this.collisionEvents.forEach((f)=>f.initialDisabled = !1);
        }, 80);
    }
    initPhysics() {
        this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = new jt.World(new jt.Vector3(0, this.gravity, 0)), this.events = new jt.EventQueue(!0);
        let t = [], e = [];
        if (this.page.traverseChildren((a)=>{
            let l;
            if (a instanceof Gi) {
                if (a.objectForSample) {
                    if (a.objectForSample.dataPatched.physics.fusedBody) return;
                    l = a.object;
                } else return a.object.dataPatched.physics.fusedBody === !0 && a.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (a instanceof Nr) l = a.object;
            else {
                if (a instanceof rc || a instanceof ql) return;
                if (l = a, l.dataPatched.cloner?.disabled === !1 && l.dataPatched.cloner?.hideBase && l.dataPatched.physics?.fusedBody !== !0) return !0;
            }
            let c = l.dataPatched, u;
            for (let y of c.events)y.data.disabled !== !0 && y.data.type === "GameControl" && (u = y.data);
            if (!c.physics || (c.physics.enabled === "visibility" ? !c.visible : !c.physics.enabled)) return !0;
            a.updateMatrixWorldSVD();
            let h = wg(c), d = !1, f = l.userData.hasDestroy, p = l.userData.hasDrag, m = !1;
            for (let y of c.events)if (y.data.disabled !== !0) {
                if (y.data.type === "Collision") {
                    d = !0;
                    let x = new Gb(y.id, y.data, l, this.page, this.sharedAssets, this.eventManager);
                    x.initialDisabled = !0, this.collisionEvents.push(x), this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid] && this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid].every((v)=>v.id !== y.id) ? this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid].push(x) : this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid] = [
                        x
                    ];
                } else if (y.data.type === "Follow") {
                    m = !0;
                    let x = y.data.target;
                    a.traverseVisible((v)=>{
                        v.userData.isFollowingObj = x;
                    });
                }
            }
            c.physics.rigidBody === "dynamic" && c.physics.fusedBody === !1 && (a.matrixWorldFusedFalse = a.matrixWorld.clone());
            let g = a.geometry;
            if (u !== void 0) {
                let y = jt.RigidBodyDesc.kinematicPositionBased();
                (a.hasNonUniformScale ? a.matrixWorldRigid : a.matrixWorld).decompose(bi, oo, ac), a.position0 = bi.clone().divideScalar(this.pixelsPerMeter), a.rotation0 = oo.clone(), bi.divideScalar(this.pixelsPerMeter), y.setTranslation(bi.x, bi.y, bi.z).setRotation(oo);
                let x = this.sharedGameControlGlobals.rapierWorld.createRigidBody(y);
                a.rigidBody = x;
                let v;
                u.collider.type === "sphere" ? v = jt.ColliderDesc.ball(u.collider.radius / this.pixelsPerMeter) : u.collider.type === "capsule" ? v = jt.ColliderDesc.capsule((u.collider.height / 2 - u.collider.radius) / this.pixelsPerMeter, u.collider.radius / this.pixelsPerMeter) : v = jt.ColliderDesc.cuboid(u.collider.width / this.pixelsPerMeter / 2, u.collider.height / this.pixelsPerMeter / 2, u.collider.depth / this.pixelsPerMeter / 2), v.setFrictionCombineRule(jt.CoefficientCombineRule.Average).setRestitutionCombineRule(jt.CoefficientCombineRule.Average).setDensity(c.physics.density).setFriction(c.physics.friction).setRestitution(c.physics.restitution);
                let S = this.sharedGameControlGlobals.rapierWorld.createCollider(v, x);
                this.sharedGameControlGlobals.colliderToEntity.set(S.handle, l), bi.fromArray(u.collider.position).multiply(ac.setFromMatrixScale(l.matrixWorld)).divideScalar(this.pixelsPerMeter), S.setTranslationWrtParent(bi);
                let w = new Ke().setFromEuler(new nr().setFromVector3(new E().fromArray(u.collider.rotation)));
                S.setRotationWrtParent(w), S.setActiveEvents(jt.ActiveEvents.COLLISION_EVENTS), this.generateSensorColliderDescs(l, !0);
            } else c.physics.rigidBody === "dynamic" || h || m || f || p || d ? (this.addRigidBody(a, l, {
                hasFollow: m,
                hasTransformAnim: h,
                hasDrag: p
            }), this.generateSensorColliderDescs(l, c.physics.fusedBody)) : (g && t.push(no(g, a.matrixWorld)), c.physics.fusedBody && a.traverseObject((y, x)=>{
                if (x === 0) return;
                let v;
                if (y instanceof Gi) {
                    if (y.objectForSample) {
                        if (y.objectForSample.dataPatched.physics.fusedBody) return;
                        v = y.object;
                    } else return y.object.dataPatched.physics.fusedBody === !0 && y.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else {
                    if (y instanceof rc || y instanceof ql) return;
                    if (y instanceof Nr) v = y.object;
                    else if (v = y, v.dataPatched.cloner?.hideBase) return !0;
                }
                let S = v.dataPatched;
                if (S.physics.enabled === "visibility" ? !S.visible : !S.physics.enabled) return !0;
                let w = y.geometry;
                w?.getAttribute("position") !== void 0 && t.push(no(w, y.matrixWorld));
            }), this.generateSensorColliderDescs(l, c.physics.fusedBody, e));
            if (c.physics?.fusedBody === !0 || u) return !0;
        }), t.length === 0) return;
        let r = Gs(t);
        r.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter);
        let i = jt.RigidBodyDesc.fixed(), s = this.sharedGameControlGlobals.rapierWorld.createRigidBody(i), o = jt.ColliderDesc.trimesh(r.getAttribute("position").array, r.getIndex().array).setFrictionCombineRule(jt.CoefficientCombineRule.Multiply).setRestitutionCombineRule(jt.CoefficientCombineRule.Multiply).setFriction(1).setRestitution(1);
        this.sharedGameControlGlobals.rapierWorld.createCollider(o, s);
        for (let [a, l] of e){
            let c = this.sharedGameControlGlobals.rapierWorld.createCollider(a, s);
            this.sensorToTriggerEvent[c.handle] = l;
        }
    }
    updatePositions() {
        return this.nActiveRigidBodies = 0, this.sharedGameControlGlobals.rapierWorld.forEachRigidBody(this.processRigidBody), this.nActiveRigidBodies > 0;
    }
    rebuildBVH() {
        this.usePhysics ? this.initPhysics() : (this.page.traverseEntity((t)=>{
            for (let e of t.dataPatched.events)if (e.data.type === "Trigger" && e.data.disabled !== !0) {
                let r = new Ag(e.id, e.data, t, this.page, this.sharedAssets, this.eventManager), i = new ue().compose(ao.fromArray(e.data.position), Wf.setFromEuler($N.fromArray(e.data.rotation)), mM);
                if (e.data.triggerZone === "box") {
                    let s = new Wt;
                    s.min.fromArray(e.data.size).multiplyScalar(-0.5), s.max.fromArray(e.data.size).multiplyScalar(.5), this.sharedGameControlGlobals.triggers.push([
                        s,
                        i,
                        t,
                        r
                    ]);
                } else this.sharedGameControlGlobals.triggers.push([
                    e.data.radius,
                    i,
                    t,
                    r
                ]);
            }
        }), this.needsCollisionDetection && this.initBVH());
    }
    disconnectEvents() {
        this.collisionEvents.forEach((t)=>t.disconnect()), this.sharedGameControlGlobals.triggers.forEach((t)=>t[3].disconnect()), this.sharedGameControlGlobals.triggers.length = 0;
    }
    deactivate() {
        if (!!this.isEnabled) {
            this.isEnabled = !1, this.page.traverse((t)=>{
                let e = t;
                e.matrixWorldFusedFalse && (e.matrixWorldFusedFalse = void 0), e.rigidBody && (e.rigidBody = void 0), e.position0 && (e.position0 = void 0), e.rotation0 && (e.rotation0 = void 0);
            }), this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = void 0, this.sharedGameControlGlobals.staticMeshBVH = void 0, this.accumulator = 0, this.sharedGameControlGlobals.entitiesWithTransformAnim = [], this.disconnectEvents(), this.gameControl?.reset(), this.gameControl?.dispose(), this.gameControl = null, this.initializationCounter = -1, this.joysticks.forEach(([t, e])=>{
                t?.destroy(), e.remove();
            }), this.joystickToGameControls = [], this.joysticks = [], this.orbitControls && (this.orbitControls.dispose(), this.orbitControls = void 0), this.navigationMeshWrapper?.dispose(), this.navigationMeshWrapper = void 0;
            for (let t of Object.values(this.sharedGameControlGlobals.entityToCollisionEvents))t.forEach((e)=>e.disconnect());
            this.sharedGameControlGlobals.entityToCollisionEvents = {}, this.page.updateMatrixWorld(!0);
        }
    }
    update(t, e, r) {
        if (!this.isEnabled) return !0;
        let i = !0;
        if (this.orbitControls !== void 0 && this.orbitControls.needsUpdate && (i = !this.orbitControls.update()), this.initializationCounter >= 0 && this.initializationCounter < 2 ? (this.initializationCounter++, i = !1) : this.initializationCounter === 2 && this.gameControl && (i = !this.gameControl.update(t, e, r) && i), this.usePhysics === !1 && this.checkTrigger(), this.usePhysics) {
            let s = .016666666666666666;
            if (t === 0) i = this.stepPhysics() && i;
            else {
                let o = t / 1e3;
                o < s && o > s * .55 && (o = s), this.accumulator += o;
                let a = performance.now(), l = 0, c = 6;
                for(; this.accumulator >= s && l < c && (i = this.stepPhysics() && i, this.accumulator -= s, l++, !(performance.now() - a > s * 1e3)););
                this.accumulator = this.accumulator % s;
            }
        }
        return i;
    }
    stepPhysics() {
        for (let e of this.sharedGameControlGlobals.entitiesWithTransformAnim){
            (e.hasNonUniformScale ? e.matrixWorldRigid : e.matrixWorld).decompose(bi, oo, ac), fM.setFromQuaternion(oo);
            let r = e;
            r.prevR === void 0 ? (r.prevR = fM.clone(), r.prevT = bi.clone()) : (r.prevR.copy(fM), r.prevT.copy(bi)), e.rigidBody && (e.rigidBody.setNextKinematicTranslation(bi.divideScalar(this.pixelsPerMeter)), e.rigidBody.setNextKinematicRotation(oo));
        }
        return this.sharedGameControlGlobals.rapierWorld.step(this.events), this.events?.drainCollisionEvents(this.handleCollisionEvents), !this.updatePositions();
    }
    dispatchCollisionEvent(t, e, r) {
        let i = (this.sharedGameControlGlobals.rapierWorld?.getCollider(r))._parent, s;
        if (e.cloner) {
            for (let o of e.cloner.children)if (o.rigidBody === i) {
                s = o;
                break;
            }
        }
        t.dispatch(s), e.dispatchEvent(Pb);
    }
    updateUseWindowEvents(t) {
        this.orbitControls?.updateUseWindowEvents(t);
    }
    generateSensorColliderDescs(t, e, r) {
        let i = eF.copy(t.matrixWorld).invert();
        t.traverseEntity((s, o)=>{
            if (e === !1 && o === 1) return !0;
            for (let a of s.dataPatched.events)if (a.data.type === "Trigger" && a.data.disabled !== !0) {
                let l = new Ag(a.id, a.data, s, this.page, this.sharedAssets, this.eventManager), c;
                if (a.data.triggerZone === "box" ? c = jt.ColliderDesc.cuboid(...a.data.size.map((u)=>u / (2 * this.pixelsPerMeter))) : c = jt.ColliderDesc.ball(a.data.radius / this.pixelsPerMeter), c.setDensity(0).setSensor(!0).setActiveEvents(jt.ActiveEvents.COLLISION_EVENTS), ao.fromArray(a.data.position), Wf.setFromEuler($N.fromArray(a.data.rotation)), Yb.compose(ao, Wf, mM).premultiply(s.matrixWorld), r ? (Yb.decompose(ao, Wf, pM), c.setActiveCollisionTypes(jt.ActiveCollisionTypes.KINEMATIC_FIXED | jt.ActiveCollisionTypes.DYNAMIC_FIXED)) : (Yb.premultiply(i).decompose(ao, Wf, pM), t.rigidBody.bodyType() === jt.RigidBodyType.Dynamic || (t.rigidBody.bodyType() === jt.RigidBodyType.Fixed ? c.setActiveCollisionTypes(jt.ActiveCollisionTypes.KINEMATIC_FIXED | jt.ActiveCollisionTypes.DYNAMIC_FIXED) : c.setActiveCollisionTypes(jt.ActiveCollisionTypes.KINEMATIC_KINEMATIC | jt.ActiveCollisionTypes.DYNAMIC_KINEMATIC))), ao.divideScalar(this.pixelsPerMeter), c.setTranslation(ao.x, ao.y, ao.z), c.setRotation(Wf), r) r.push([
                    c,
                    l
                ]);
                else {
                    let u = this.sharedGameControlGlobals.rapierWorld.createCollider(c, t.rigidBody);
                    this.sensorToTriggerEvent[u.handle] = l;
                }
            }
        });
    }
    checkTrigger() {
        let t;
        for(let e = 0; e < this.sharedGameControlGlobals.triggers.length; e++){
            let [r, i, s, o] = this.sharedGameControlGlobals.triggers[e];
            for(let a = 0; a < this.sharedGameControlGlobals.entitiesWithTransformAnim.length; a++){
                let l = this.sharedGameControlGlobals.entitiesWithTransformAnim[a];
                if (s === l || o.isValidTriggeringObject(yt.is(l) ? l : l.object) === !1) continue;
                let c = eF.copy(s.matrixWorld).decompose(ao, tF, pM).compose(ao, tF, mM).multiply(i), u = Yb.copy(l.matrixWorld).invert().multiply(c);
                r instanceof Wt ? t = l.bvhGeometry.boundsTree.intersectsBox(r, u) : (gM.radius = r, gM.center.setFromMatrixPosition(u), t = l.bvhGeometry.boundsTree.intersectsSphere(gM)), t ? o.currentIntersectedObjects.indexOf(l) === -1 && (o.currentIntersectedObjects.push(l), o.dispatch(), s.dispatchEvent(C$)) : o.currentIntersectedObjects = o.currentIntersectedObjects.filter((h)=>h !== l);
            }
        }
    }
};
function iF(n1) {
    let t = this._clip.duration, e = this._clip.start ?? 0, r = this.loop, i = this.time + n1, s = this._loopCount, o = r === Tp;
    if (n1 === 0) return s === -1 ? i : o && (s & 1) === 1 ? t - (i - e) : i;
    if (r === Bw) {
        s === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
        e: {
            if (i >= t) i = t;
            else if (i < 0) i = 0;
            else {
                this.time = i;
                break e;
            }
            this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                type: "finished",
                action: this,
                direction: n1 < 0 ? -1 : 1
            });
        }
    } else {
        if (s === -1 && (n1 >= 0 ? (s = 0, this._setEndings(!0, this.repetitions === 0, o)) : this._setEndings(this.repetitions === 0, !0, o)), i >= t || i < e) {
            let a = Math.floor((i - e) / (t - e));
            i -= (t - e) * a, s += Math.abs(a);
            let l = this.repetitions - s;
            if (l <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, o || (i = n1 > 0 ? t : e, this.repetitions === 1 && (i = t)), this.time = i, this._mixer.dispatchEvent({
                type: "finished",
                action: this,
                direction: n1 > 0 ? 1 : -1
            });
            else {
                if (l === 1) {
                    let c = n1 < 0;
                    this._setEndings(c, !c, o);
                } else this._setEndings(!1, !1, o);
                this._loopCount = s, this.time = i, this._mixer.dispatchEvent({
                    type: "loop",
                    action: this,
                    loopDelta: a
                });
            }
        } else this.time = i;
        if (o && (s & 1) === 1) return t - (i - e);
    }
    return i;
}
var nF = !1, Kb = class {
    constructor(t, e, r, i){
        this.scene = t;
        this.requestRender = e;
        this.updateDisplayProgress = r;
        this.animationInspectorState = i;
        this.clipIdToAction = {};
        this.activeClip = null;
        this.needsUpdate = !1;
        this.addClip = (t)=>{
            t.data.type === "Empty" && t.data.animations && t.data.animations.forEach((e, r)=>{
                let i = e[0] + "/";
                if (Array.isArray(t.identity) ? i += t.identity[0] : i += t.uuid, this.clipIdToAction[i]) return;
                let s = Xu.parse(JSON.parse(e[2]));
                t.animations[r] = s;
                let o = this.mixer.clipAction(s, t);
                nF === !1 && (Object.getPrototypeOf(o)._updateTime = iF, nF = !0), o.clampWhenFinished = !0, this.clipIdToAction[i] = o;
            });
        };
        this.mixer = new Cy(t), this.scene.traverseEntity(this.addClip);
    }
    deleteClip(t, e) {
        let r = this.scene.find(e);
        if (!r) return;
        let i = r.animations.find((o)=>o.uuid === t);
        if (!i) return;
        let s = this.clipIdToAction[t];
        !s || (s.stop(), this.mixer.uncacheClip(i), delete this.clipIdToAction[t], r.animations = r.animations.filter((o)=>o.uuid !== t));
    }
    get isPlaying() {
        return Object.values(this.clipIdToAction).some((t)=>t.isRunning());
    }
    playFromInspector(t) {
        this.mixer.stopAllAction();
        let e = this.clipIdToAction[t];
        !e || (e.play(), this.activeClip = e.getClip(), this.requestRender());
    }
    onExitPlayMode() {
        Object.values(this.clipIdToAction).forEach((t)=>{
            t.repetitions = 1 / 0, t.loop = Nw;
        }), this.mixer.stopAllAction(), this.requestRender();
    }
    play(t) {
        let e = t.clipId + "/" + t.object, r = this.clipIdToAction[e];
        if (!!r) return t && (t.repeat >= 0 && (r.repetitions = t.repeat + 1), t.direction === "pingpong" && t.repeat !== 0 && (r.loop = Tp)), r.play(), r.paused = !1, this.requestRender(), r;
    }
    resumeFromInspector(t) {
        let e = this.clipIdToAction[t];
        !e || (e.play(), e.paused = !1, this.requestRender());
    }
    pauseFromInspector(t) {
        let e = this.clipIdToAction[t];
        !e || (e.paused = !0);
    }
    stop() {
        this.mixer.stopAllAction(), this.requestRender();
    }
    update(t) {
        if (this.needsUpdate) this.needsUpdate = !1;
        else if (this.isPlaying === !1 || this.animationInspectorState?.isScrubbing) return;
        this.mixer.update(t / 1e3), this.activeClip && this.updateDisplayProgress(Math.round(this.mixer.time / this.activeClip.duration * (this.maxFrames - 1) % (this.maxFrames - 1))), this.requestRender();
    }
    get maxFrames() {
        return kT(this.activeClip ?? void 0);
    }
    setProgressFromInspector(t, e) {
        if (!this.clipIdToAction[e]) return;
        this.activeClip !== this.clipIdToAction[e].getClip() && this.playFromInspector(e);
        let r = this.clipIdToAction[e].paused;
        this.clipIdToAction[e].paused = !1, this.mixer.setTime(Math.min(t / (this.maxFrames - 1), .9999) * this.activeClip.duration), this.requestRender(), r && (this.clipIdToAction[e].paused = !0);
    }
};
var yM = new WeakMap, Qb = class extends ll {
    constructor(t){
        super(t), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(t) {
        return this.decoderPath = t, this;
    }
    setDecoderConfig(t) {
        return this.decoderConfig = t, this;
    }
    setWorkerLimit(t) {
        return this.workerLimit = t, this;
    }
    load(t, e, r, i) {
        let s = new Ku(this.manager);
        s.setPath(this.path), s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, (o)=>{
            this.decodeDracoFile(o, e).catch(i);
        }, r, i);
    }
    decodeDracoFile(t, e, r, i) {
        let s = {
            attributeIDs: r || this.defaultAttributeIDs,
            attributeTypes: i || this.defaultAttributeTypes,
            useUniqueIDs: !!r
        };
        return this.decodeGeometry(t, s).then(e);
    }
    decodeGeometry(t, e) {
        let r = JSON.stringify(e);
        if (yM.has(t)) {
            let l = yM.get(t);
            if (l.key === r) return l.promise;
            if (t.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let i, s = this.workerNextTaskID++, o = t.byteLength, a = this._getWorker(s, o).then((l)=>(i = l, new Promise((c, u)=>{
                i._callbacks[s] = {
                    resolve: c,
                    reject: u
                }, i.postMessage({
                    type: "decode",
                    id: s,
                    taskConfig: e,
                    buffer: t
                }, [
                    t
                ]);
            }))).then((l)=>this._createGeometry(l.geometry));
        return a.catch(()=>!0).then(()=>{
            i && s && this._releaseTask(i, s);
        }), yM.set(t, {
            key: r,
            promise: a
        }), a;
    }
    _createGeometry(t) {
        let e = new _e;
        t.index && e.setIndex(new Xe(t.index.array, 1));
        for(let r = 0; r < t.attributes.length; r++){
            let i = t.attributes[r], s = i.name, o = i.array, a = i.itemSize;
            e.setAttribute(s, new Xe(o, a));
        }
        return e;
    }
    _loadLibrary(t, e) {
        let r = new Ku(this.manager);
        return r.setPath(this.decoderPath), r.setResponseType(e), r.setWithCredentials(this.withCredentials), new Promise((i, s)=>{
            r.load(t, i, void 0, s);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        let t = typeof WebAssembly != "object" || this.decoderConfig.type === "js", e = [];
        return t ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then((r)=>{
            let i = r[0];
            t || (this.decoderConfig.wasmBinary = r[1]);
            let s = P$.toString(), o = [
                "/* draco decoder */",
                i,
                "",
                "/* worker */",
                s.substring(s.indexOf("{") + 1, s.lastIndexOf("}"))
            ].join(`
`);
            this.workerSourceURL = URL.createObjectURL(new Blob([
                o
            ]));
        }), this.decoderPending;
    }
    _getWorker(t, e) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                let i = new Worker(this.workerSourceURL);
                i._callbacks = {}, i._taskCosts = {}, i._taskLoad = 0, i.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), i.onmessage = function(s) {
                    let o = s.data;
                    switch(o.type){
                        case "decode":
                            i._callbacks[o.id].resolve(o);
                            break;
                        case "error":
                            i._callbacks[o.id].reject(o);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + o.type + '"');
                    }
                }, this.workerPool.push(i);
            } else this.workerPool.sort(function(i, s) {
                return i._taskLoad > s._taskLoad ? -1 : 1;
            });
            let r = this.workerPool[this.workerPool.length - 1];
            return r._taskCosts[t] = e, r._taskLoad += e, r;
        });
    }
    _releaseTask(t, e) {
        t._taskLoad -= t._taskCosts[e], delete t._callbacks[e], delete t._taskCosts[e];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((t)=>t._taskLoad));
    }
    dispose() {
        for(let t = 0; t < this.workerPool.length; ++t)this.workerPool[t].terminate();
        return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
    }
};
function P$() {
    let n1, t;
    onmessage = function(o) {
        let a = o.data;
        switch(a.type){
            case "init":
                n1 = a.decoderConfig, t = new Promise(function(u) {
                    n1.onModuleLoaded = function(h) {
                        u({
                            draco: h
                        });
                    }, DracoDecoderModule(n1);
                });
                break;
            case "decode":
                let l = a.buffer, c = a.taskConfig;
                t.then((u)=>{
                    let h = u.draco, d = new h.Decoder, f = new h.DecoderBuffer;
                    f.Init(new Int8Array(l), l.byteLength);
                    try {
                        let p = e(h, d, f, c), m = p.attributes.map((g)=>g.array.buffer);
                        p.index && m.push(p.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: a.id,
                            geometry: p
                        }, m);
                    } catch (p) {
                        console.error(p), self.postMessage({
                            type: "error",
                            id: a.id,
                            error: p.message
                        });
                    } finally{
                        h.destroy(f), h.destroy(d);
                    }
                });
                break;
        }
    };
    function e(o, a, l, c) {
        let u = c.attributeIDs, h = c.attributeTypes, d, f, p = a.GetEncodedGeometryType(l);
        if (p === o.TRIANGULAR_MESH) d = new o.Mesh, f = a.DecodeBufferToMesh(l, d);
        else if (p === o.POINT_CLOUD) d = new o.PointCloud, f = a.DecodeBufferToPointCloud(l, d);
        else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!f.ok() || d.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + f.error_msg());
        let m = {
            index: null,
            attributes: []
        };
        for(let g in u){
            let y = self[h[g]], x, v;
            if (c.useUniqueIDs) v = u[g], x = a.GetAttributeByUniqueId(d, v);
            else {
                if (v = a.GetAttributeId(d, o[u[g]]), v === -1) continue;
                x = a.GetAttribute(d, v);
            }
            m.attributes.push(i(o, a, d, g, y, x));
        }
        return p === o.TRIANGULAR_MESH && (m.index = r(o, a, d)), o.destroy(d), m;
    }
    function r(o, a, l) {
        let u = l.num_faces() * 3, h = u * 4, d = o._malloc(h);
        a.GetTrianglesUInt32Array(l, h, d);
        let f = new Uint32Array(o.HEAPF32.buffer, d, u).slice();
        return o._free(d), {
            array: f,
            itemSize: 1
        };
    }
    function i(o, a, l, c, u, h) {
        let d = h.num_components(), p = l.num_points() * d, m = p * u.BYTES_PER_ELEMENT, g = s(o, u), y = o._malloc(m);
        a.GetAttributeDataArrayForAllPoints(l, h, g, m, y);
        let x = new u(o.HEAPF32.buffer, y, p).slice();
        return o._free(y), {
            name: c,
            array: x,
            itemSize: d
        };
    }
    function s(o, a) {
        switch(a){
            case Float32Array:
                return o.DT_FLOAT32;
            case Int8Array:
                return o.DT_INT8;
            case Int16Array:
                return o.DT_INT16;
            case Int32Array:
                return o.DT_INT32;
            case Uint8Array:
                return o.DT_UINT8;
            case Uint16Array:
                return o.DT_UINT16;
            case Uint32Array:
                return o.DT_UINT32;
        }
    }
}
var lc;
function sF() {
    return lc || (lc = new Qb, lc.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.2/").preload()), lc.decoderPending;
}
async function _$(n1) {
    if (lc) {
        let t = {
            attributeIDs: lc.defaultAttributeIDs,
            attributeTypes: lc.defaultAttributeTypes,
            useUniqueIDs: !1
        }, e;
        try {
            e = await lc.decodeGeometry(new Int8Array(n1).buffer, t);
        } catch (r) {
            console.error(r);
        }
        if (e) return {
            index: e.index ? {
                array: e.index.array
            } : void 0,
            attributes: Object.entries(e.attributes).map(([r, i])=>({
                    name: r,
                    itemSize: i.itemSize,
                    array: i.array
                }))
        };
    }
    return null;
}
async function oF(n1, t) {
    let [e, r] = gA(Lv.deserialize(new Uint8Array(n1)));
    return i0(e), t && t(e), r.result().data;
}
function aF(n1) {
    let t = [];
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && r.geometry.type === "NonParametricGeometry" && r.geometry.data.draco !== void 0 && t.push(r);
    }), t;
}
async function lF(n1) {
    for (let t of n1){
        let e = await _$(t.geometry.data.draco);
        if (e) {
            let r = t.geometry.data;
            e.index && (r.index = {
                array: e.index.array,
                itemSize: 1,
                normalized: !1,
                type: "Uint32Array"
            });
            let i = {};
            e.attributes.forEach(({ name: s, array: o, itemSize: a })=>{
                i[s] = {
                    array: o,
                    itemSize: a,
                    type: "Float32Array",
                    normalized: !1
                };
            }), r.attributes = i, r.draco = void 0;
        }
    }
}
var Zb = class {
    constructor(){
        this._clickCount = 0;
        this._lastTime = 0;
        this._lastPosition = [
            0,
            0
        ];
        this._delay = 500;
        this._distance = 2;
        this._onMouseDown = (t)=>{
            let e = [
                t.clientX,
                t.clientY
            ], r = new Date().getTime();
            if (this._clickCount > 0) {
                let i = e[0] - this._lastPosition[0], s = e[1] - this._lastPosition[1];
                Math.sqrt(i * i + s * s) > this._distance && (this._clickCount = 0);
            }
            this._lastPosition = e, this._clickCount = r - this._lastTime > this._delay ? 1 : this._clickCount + 1, this._lastTime = r;
        };
        this._onMouseUp = (t)=>{};
    }
    start(t, e = 500, r = 2) {
        this._target && this.stop(), this.reset(), this._delay = e, this._distance = r, this._target = t, this._target.addEventListener("pointerdown", this._onMouseDown, !1), this._target.addEventListener("pointerup", this._onMouseUp, !1);
    }
    stop() {
        this._target && (this._target.removeEventListener("pointerdown", this._onMouseDown, !1), this._target.removeEventListener("pointerup", this._onMouseUp, !1), this._target = void 0);
    }
    get clickCount() {
        return this._clickCount;
    }
    reset() {
        this._clickCount = 0, this._lastTime = 0, this._lastPosition = [
            0,
            0
        ];
    }
};
var vM = class {
    constructor(t, e, r, i, s, o, a, l){
        this.eventId = t;
        this.id = e;
        this.data = r;
        this.dataEvent = i;
        this.object = s;
        this.stage = !1;
        this.actions = Ut(i, r.actions, o, a, l, s);
    }
    disconnect() {
        hr(this.actions);
    }
    dispatchIn() {
        this.actions.Audio.forEach((t)=>t.dispatchBasic()), this.actions.Particles.forEach((t)=>t.dispatchBasic()), this.actions.Video.forEach((t)=>t.dispatchBasic()), this.actions.Create.forEach((t)=>t.dispatch()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.Reset.forEach((t)=>t.dispatch()), this.actions.Link.forEach((t)=>t.dispatch()), this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.actions.Transition.forEach((t)=>t.toggle()), this.actions.Animation.forEach((t)=>t.play()), this.actions.SwitchCamera.forEach((t)=>t.play()), this.actions.SceneTransition.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch());
    }
    dispatchOut() {
        this.actions.Transition.forEach((t)=>{
            t.toggle();
        });
    }
}, Jb = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.breakpoints = [];
        this.resize = (e, r)=>{
            this.breakpoints.forEach((i)=>{
                let s = Vv.deviceToSize(i.data.size), o = i.dataEvent.orientation === "horizontal" ? e : r, a;
                switch(i.data.operator){
                    case "<":
                        a = o < s[0];
                        break;
                    case ">":
                        a = o > s[0];
                        break;
                    case "<>":
                        a = o > s[0] && o < s[1];
                        break;
                }
                i.stage !== a && (i.stage = a, i.stage ? i.dispatchIn() : i.dispatchOut());
            });
        };
        this.onResizeObserver = new ResizeObserver((e)=>{
            for (let r of e){
                let { width: i, height: s } = r.contentRect;
                this.resize(i, s);
            }
        });
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i } = this.eventContext;
        this.onResizeObserver.observe(i);
        let s = (o)=>{
            if (!(!o.visible || !o.data?.events.length)) for (let { data: a, id: l } of o.data.events)a.disabled || a.type === "Resize" && a.breakpoints.forEach(({ data: c, id: u })=>{
                try {
                    let h = new vM(l, u, c, a, o, e, r, this.eventManager);
                    this.breakpoints.push(h);
                } catch (h) {}
            });
        };
        e.traverseEntity((o)=>{
            (o instanceof Er || o instanceof ur) && o.frame?.traverse((a)=>{
                s(a);
            }), s(o);
        });
    }
    disconnect() {
        this.onResizeObserver.disconnect(), this.breakpoints.forEach((e)=>{
            e.disconnect();
        }), this.breakpoints = [];
    }
};
var $b = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.userAPIs = {};
        this.events = [];
        this.onSuccess = ({ userAPIId: e })=>{
            this.events.forEach((r)=>{
                r.data.userAPIId === e && r.dispatchSuccess();
            });
        };
        this.onError = ({ userAPIId: e })=>{
            this.events.forEach((r)=>{
                r.data.userAPIId === e && r.dispatchError();
            });
        };
        this.userAPIs = e.sharedAssets.getUserAPIs();
    }
    connect() {
        this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "API" && !r.data.disabled).forEach((r)=>{
                this.events.push(new xM(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), Object.entries(this.userAPIs).forEach(([e, r])=>{
            r.on("success", this.onSuccess), r.on("error", this.onError), r.autostart && r.callUserAPI(this.eventContext.sharedAssets);
        });
    }
    disconnect() {
        Object.entries(this.userAPIs).forEach(([e, r])=>{
            r.off("success", this.onSuccess), r.off("error", this.onError);
        });
    }
}, xM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.successActions = Ut(e, e.successActions, i, s, o, r), this.errorActions = Ut(e, e.errorActions, i, s, o, r);
    }
    dispatchSuccess() {
        this.dispatchActions(this.successActions);
    }
    dispatchError() {
        this.dispatchActions(this.errorActions);
    }
    dispatchActions(t) {
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
};
var eS = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.userWebhooks = {};
        this.events = [];
        this.onMessage = ({ userWebhookId: e })=>{
            this.events.forEach((r)=>{
                r.data.userWebhookId === e && r.dispatch();
            });
        };
        this.userWebhooks = e.sharedAssets.getUserWebhooks();
    }
    connect() {
        this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "WEBHOOK" && !r.data.disabled).forEach((r)=>{
                this.events.push(new bM(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), Object.entries(this.userWebhooks).forEach(([e, r])=>{
            r.connect(), r.on("message", this.onMessage);
        });
    }
    disconnect() {
        Object.entries(this.userWebhooks).forEach(([e, r])=>{
            r.off("message", this.onMessage), r.disconnect();
        });
    }
}, bM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
};
function I$() {
    let n1 = document.createElement("textarea");
    return n1.style.position = "fixed", n1.style.top = "200px", n1.style.left = "400px", n1.style.zIndex = "-1", n1.style.border = "1px solid rgba(255,0,0,0.5)", n1.style.width = "10px", n1.style.height = "500px", n1.style.color = "white", n1.style.opacity = "0.5", n1.style.background = "transparent", n1.style.display = "none", n1.style.margin = "0px", n1.style.padding = "0px", n1.style.boxSizing = "content-box", n1.style.pointerEvents = "none", n1;
}
var D$ = new E(0, 0, 1), cF = new E, uF = new E, hF = new fr, tS = class {
    constructor(t, e, r, i, s){
        this.containerScene = t;
        this.raycaster = e;
        this.sharedAssets = r;
        this.requestRender = i;
        this.onExit = s;
        this.htmlInput = null;
        this.virtualInput = null;
        this.helper = new Tf;
        this.doubleClickHandler = new Zb;
        this.isDragging = !1;
        this.plane = new kr;
        this.caretInterval = 0;
        this.planeIntersection = new E;
        this.projected = new k;
        this._lastIndex = 0;
        this._isFirstDragMove = !1;
        this.selectionOnDragStart = 0;
        this.onTextMaterialChanged = ()=>{
            let t = this.virtualInput?.data;
            if (this.virtualInput !== void 0 && t) {
                let e = t.material, r = typeof e == "string" ? this.sharedAssets.data.materials[e] : e, i = pL(r, this.sharedAssets);
                this.helper.setCaretColor(i);
            }
        };
        this.stopAnimateTextCursor = ()=>{
            clearInterval(this.caretInterval), this.helper && (this.helper.caretMesh.visible = !1);
        };
        this.startAnimateTextCursor = ()=>{
            this.stopAnimateTextCursor(), this.helper && (this.helper.caretMesh.visible = !0, this.caretInterval = setInterval(()=>{
                this.helper && (this.helper.caretMesh.visible = !this.helper.caretMesh.visible), this.requestRender();
            }, 600));
        };
        this.handleCaretUpdate = (t)=>{
            if (!this.htmlInput || !this.virtualInput) return;
            let e = this.helper, r = t?.key === "ArrowLeft" || t?.key === "ArrowRight", i = t?.key === "ArrowUp" || t?.key === "ArrowDown";
            this.htmlInput.selectionStart === this.htmlInput.selectionEnd ? (e.setCaretPosition(this.htmlInput.selectionStart, {
                horizontalKeyMove: r,
                verticalKeyMove: i
            }), this.startAnimateTextCursor()) : e.setSelection(this.htmlInput.selectionStart, this.htmlInput.selectionEnd), this.requestRender();
        };
        this.containerScene.add(this.helper);
    }
    createInput() {
        return this.htmlInput = I$(), this.htmlInput;
    }
    connect() {}
    disconnect() {
        this.stopAnimateTextCursor(), this.helper.hide(), this.htmlInput?.remove(), this.doubleClickHandler.stop();
    }
    handleMouseDown() {
        if (!this.htmlInput || !this.virtualInput) return !0;
        this.getPointOnPlane();
        let t = this.doubleClickHandler.clickCount, { index: e, lineIndex: r, characterIndex: i } = this.helper.getSelectionFromPosition(this.projected.x, this.projected.y, t > 1 ? "inside" : "previous") ?? {
            index: 0,
            lineIndex: 0,
            characterIndex: 0
        };
        this.virtualInput?.wrappedText?.length && this.virtualInput.wrappedText[r][Math.max(0, i - 1)] === `
` && (e--, i--), this._lastIndex = e, this._isFirstDragMove = !0;
        let s = this.checkClickedObject();
        if (t === 1) {
            if (s === null) return this.onExit(this.virtualInput), !0;
            this.selectionOnDragStart = e, this.isDragging = !0, this.setInputSelection(e);
        } else s === this.virtualInput && (t === 2 ? this.selectClosestWord(r, i) : t > 2 && (this.setInputSelection(0, this.htmlInput.value.length), this.doubleClickHandler.reset()));
    }
    handleMouseUp() {
        this.applyRangeToTextInput(), this.isDragging = !1, this._isFirstDragMove = !1;
    }
    handleMouseMove() {
        !this.virtualInput || (this._isFirstDragMove && this.doubleClickHandler.clickCount > 1 && (this.selectionOnDragStart = this._lastIndex, this.isDragging = !0, this.setInputSelection(this._lastIndex)), this._isFirstDragMove = !1, this.getPointOnPlane(), this.applyRangeToTextInput());
    }
    focus(t) {
        if (this.virtualInput = t, this.updateTextInputStyles(), this.htmlInput) {
            if (t) {
                let e = this.data?.geometry.text;
                this.htmlInput.value = typeof e == "string" ? "" : e?.textValue.toString() ?? "";
            } else this.htmlInput.value = "";
        }
    }
    blur() {}
    get data() {
        let { virtualInput: t } = this;
        if (t) return t.dataPatched;
    }
    applyRangeToTextInput() {
        if (!this.isDragging || !this.virtualInput || !this.htmlInput) return;
        let t = this.selectionOnDragStart, { index: e, lineIndex: r, characterIndex: i } = this.helper.getSelectionFromPosition(this.projected.x, this.projected.y, this.doubleClickHandler.clickCount > 2 ? "inside" : "previous") ?? {
            index: 0
        };
        r !== void 0 && i !== void 0 && this.virtualInput?.wrappedText[r][i - 1] === `
` && e--, this.htmlInput.setSelectionRange(Math.min(t, e), Math.max(t, e));
    }
    checkClickedObject() {
        if (this.virtualInput) {
            let t = this.raycaster.intersectObject(this.virtualInput, !1);
            if (t.length > 0) {
                let e = t[0];
                if (e.object instanceof ec) return e.object;
            }
        }
        return null;
    }
    selectClosestWord(t, e) {
        if (!this.virtualInput) return;
        let r = this.virtualInput.wrappedText, i = r[t], s = e + 1, o = e;
        i[e] !== " " && (s = this.findNextCharOccurence(i, e, "forward", " "), o = this.findNextCharOccurence(i, e, "backward", " "), o > 0 && o++, s >= i.length - 1 && t === r.length - 1 && s++);
        let a = this.helper, l = a.getGlobalIndexFromLineAndCharIndexes(r, t, o), c = a.getGlobalIndexFromLineAndCharIndexes(r, t, s);
        this.setInputSelection(l, c);
    }
    findNextCharOccurence(t, e, r, i = " ") {
        let s = Math.max(0, t.length - 1), o = r === "forward" ? s : 0, a = r === "forward" ? 1 : -1, l = Math.max(Math.min(e, s), 0);
        for(; l !== o;)if (l += a, t.charAt(l) === i) return l;
        return o;
    }
    getPointOnPlane() {
        let t = this.virtualInput?.data;
        if (!(!this.virtualInput || !t) && this.raycaster.ray.intersectsPlane(this.plane)) {
            this.planeIntersection === null && (this.planeIntersection = new E);
            let e = this.raycaster.ray.intersectPlane(this.plane, this.planeIntersection);
            if (e) {
                this.planeIntersection.copy(this.virtualInput.worldToLocal(e));
                let r = typeof t.geometry.width == "number" ? t.geometry.width : 1, i = typeof t.geometry.height == "number" ? t.geometry.height : 1;
                this.projected.set(e.x + r * .5, e.y - i * .5);
            }
        }
    }
    updatePlane() {
        let t = this.virtualInput?.data;
        this.virtualInput && t && (hF.getNormalMatrix(this.virtualInput.matrixWorld), cF.copy(D$).applyMatrix3(hF).normalize(), this.virtualInput.localToWorld(uF.set(0, 0, t.geometry.depth)), this.plane.setFromNormalAndCoplanarPoint(cF, uF));
    }
    setInputSelection(t, e = t) {
        this.htmlInput?.setSelectionRange(t, e), setTimeout(()=>{
            this.htmlInput?.focus();
        });
    }
    updateTextInputStyles() {
        let t = this.virtualInput?.data;
        this.virtualInput && t && this.htmlInput && (this.htmlInput.style.fontSize = t.geometry.fontSize + "px", this.htmlInput.style.letterSpacing = t.geometry.letterSpacing * t.geometry.fontSize + "px", this.htmlInput.style.lineHeight = t.geometry.fontSize * t.geometry.lineHeight + "px", this.htmlInput.style.width = t.geometry.width + "px", this.htmlInput.style.height = t.geometry.height + "px", this.htmlInput.style.textAlign = O$(t.geometry.horizontalAlign));
    }
};
function O$(n1) {
    return n1 === 4 ? "justify" : n1 === 2 ? "right" : n1 === 3 ? "center" : "left";
}
var fF = (n1, t)=>{
    if (typeof n1 == "string") {
        let e = t.data(n1);
        if (e) return fF(e.value, t);
    }
    return Br.getDisplayedValue(n1);
};
function dF(n1, t) {
    let e = n1.text, r = "";
    if (typeof e == "string") {
        let i = t.variables.data(r);
        i && (r = fF(i.value, t.variables));
    } else r = e.textValue.toString();
    return r;
}
var rS = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this._textInputs = [];
        this.sceneHelpers = new ei;
        this.helper = new Tf;
        this._onMouseDownFocusIn = (e)=>{
            if (Je.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let r = null;
            if (this.eventContext.raycaster) {
                for (let i of this._textInputs)if (this.eventContext.raycaster.intersectObject(i, !0).length > 0) {
                    r = i;
                    break;
                }
            }
            this.focusOnTextInput(r), this._onCaretUpdate(), this._onMouseUp(), this.textInputManager.doubleClickHandler.start(this.eventContext.domElement), this.textInputManager.doubleClickHandler._onMouseDown(e), this._onMouseDown(e);
        };
        this.onExit = ()=>{
            let { virtualInput: e } = this.textInputManager;
            if (e === null) return;
            let r = this.textInputManager.htmlInput;
            this.helper.hide(), r?.setSelectionRange(r.value.length, r.value.length), this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !0);
            let { domElement: i } = this.eventContext;
            i.removeEventListener("pointerdown", this._onMouseDown, !1), i.removeEventListener("pointerup", this._onMouseUp, !1), i.removeEventListener("pointermove", this._onMouseMove, !1), window.removeEventListener("keydown", this._onKeyPress), this.textInputManager.doubleClickHandler.reset(), i.addEventListener("pointerdown", this._onMouseDownFocusIn), this.eventContext.renderer.sceneHelpersOnTop = void 0, this.eventContext.renderer.pipeline.disableHelpers();
        };
        this._onMouseDown = (e)=>{
            this.eventContext.updateRaycaster(e), this.textInputManager.handleMouseDown(), this.textInputManager.virtualInput && this.eventContext.raycaster.intersectObject(this.textInputManager.virtualInput, !0).length > 0 && this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !1);
        };
        this._onMouseUp = ()=>{
            this.textInputManager.handleMouseUp(), this.eventManager.controlsManager.orbitControls && !this.eventManager.controlsManager.orbitControls.enabled && (this.eventManager.controlsManager.orbitControls.enabled = !0);
        };
        this._onMouseMove = (e)=>{
            this.eventContext.updateRaycaster(e), this.textInputManager.handleMouseMove();
        };
        this._onTextEdit = (e)=>{
            let { htmlInput: r, virtualInput: i, helper: s } = this.textInputManager;
            if (!r || !i) return;
            let o = r.value;
            i.textGeometry.setText(o).then(()=>{
                this.eventContext.requestRender();
            });
            let a = i.data;
            s.update();
            let l = a.geometry.text;
            if (typeof l == "string") {
                let c = l;
                this.eventContext.sharedAssets.updateVariable(c, {
                    textValue: o
                });
            }
            this.textInputManager.updateTextInputStyles(), this._onCaretUpdate();
        };
        this._onCaretUpdate = (e)=>{
            this.textInputManager.handleCaretUpdate(e);
        };
        this._onKeyPress = (e)=>{
            e.key === "Escape" && this.onExit();
        };
        this.textInputManager = new tS(this.sceneHelpers, e.raycaster, e.sharedAssets, e.requestRender, this.onExit);
    }
    connect() {
        let e = [];
        if (this.eventContext.scene.traverseEntity((s)=>{
            s instanceof ec && e.push(s);
        }), this._textInputs = e, e.length === 0) return;
        let { domElement: r } = this.eventContext;
        r.addEventListener("pointerdown", this._onMouseDownFocusIn), this.textInputManager.connect();
        let i = this.textInputManager.createInput();
        document.body.appendChild(i), i.style.display = "none", i.addEventListener("keyup", this._onCaretUpdate), i.addEventListener("keydown", this._onCaretUpdate), i.addEventListener("beforeinput", this._onCaretUpdate), i.addEventListener("paste", this._onCaretUpdate), i.addEventListener("cut", this._onCaretUpdate), i.addEventListener("select", this._onCaretUpdate), i.addEventListener("selectstart", this._onCaretUpdate);
    }
    disconnect() {
        let e = this.textInputManager.htmlInput, { domElement: r } = this.eventContext;
        r.removeEventListener("pointerdown", this._onMouseDownFocusIn), e?.removeEventListener("keyup", this._onCaretUpdate), e?.removeEventListener("keydown", this._onCaretUpdate), e?.removeEventListener("beforeinput", this._onCaretUpdate), e?.removeEventListener("paste", this._onCaretUpdate), e?.removeEventListener("cut", this._onCaretUpdate), e?.removeEventListener("select", this._onCaretUpdate), e?.removeEventListener("selectstart", this._onCaretUpdate), this._textInputs.forEach((i)=>{
            let s = dF(i.data.geometry, this.eventContext.sharedAssets.data);
            i.textGeometry.setText(s);
        }), r.removeEventListener("pointerdown", this._onMouseDown, !1), r.removeEventListener("pointerup", this._onMouseUp, !1), r.removeEventListener("pointermove", this._onMouseMove, !1), window.addEventListener("keydown", this._onKeyPress), this.eventContext.renderer.sceneHelpersOnTop = void 0, this.eventContext.renderer.pipeline.disableHelpers(), this.textInputManager.disconnect();
    }
    focusOnTextInput(e) {
        this.textInputManager.focus(e), this.textInputManager.onTextMaterialChanged();
        let r = this.textInputManager.htmlInput;
        if (!r || e === null) return;
        this.textInputManager.updateTextInputStyles(), this.eventContext.renderer.sceneHelpersOnTop = this.sceneHelpers, this.eventContext.renderer.pipeline.enableHelpers(), this.textInputManager.isDragging = !1;
        let i = dF(e.textGeometry.userData.parameters, this.eventContext.sharedAssets.data);
        r.value = i, r.setSelectionRange(0, 0), this.textInputManager.helper.show(e), r.style.display = "block", r.addEventListener("input", this._onTextEdit), this.textInputManager.updatePlane();
        let { domElement: s } = this.eventContext;
        s.removeEventListener("pointerdown", this._onMouseDownFocusIn), s.addEventListener("pointerdown", this._onMouseDown, !1), s.addEventListener("pointerup", this._onMouseUp, !1), s.addEventListener("pointermove", this._onMouseMove, !1), window.addEventListener("keydown", this._onKeyPress);
    }
};
var iS = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.onVoice = ({ value: e, frequencies: r })=>{
            this.events.forEach((i)=>{
                i.dispatch();
            });
        };
    }
    connect() {
        this.openAIRealtime = this.eventContext.sharedAssets.openAIRealtime, this.openAIRealtime && (this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "AIAssistantListener" && !r.data.disabled).forEach((r)=>{
                this.events.push(new SM(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), this.openAIRealtime.on("voice", this.onVoice));
    }
    disconnect() {
        this.openAIRealtime?.off("voice", this.onVoice);
    }
}, SM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    dispatch() {
        this.dispatchActions(this.actions);
    }
    dispatchActions(t) {
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
};
var nS = class extends Yt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.onTriggerEvent = ({ description: e, direction: r })=>{
            let i = this.events.find((s)=>s.data.description === e);
            i && (r === "backward" ? i.dispatchReverse() : i.dispatch());
        };
    }
    connect() {
        this.openAIRealtime = this.eventContext.sharedAssets.openAIRealtime, this.openAIRealtime && (this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "AIAssistantTrigger" && !r.data.disabled).forEach((r)=>{
                this.events.push(new wM(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), this.openAIRealtime.on("trigger_event", this.onTriggerEvent));
    }
    disconnect() {
        this.openAIRealtime?.off("trigger_event", this.onTriggerEvent);
    }
}, wM = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Ut(e, e.actions, i, s, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
    dispatchReverse() {
        let t = this.actions;
        t.Transition.forEach((e)=>e.reverseFromCurrent()), t.Particles.forEach((e)=>e.reverseFromCurrent()), t.Animation.forEach((e)=>e.reverseFromCurrent()), t.SwitchCamera.forEach((e)=>e.reverseFromCurrent()), t.Create.forEach((e)=>e.dispatchStop());
    }
};
var sS = class {
    constructor(t, e, r, i, s){
        this.publish = t;
        this.controlsManager = e;
        this.animationControls = r;
        this.eventContext = i;
        this.sharedVariables = s;
        this.isEnabled = !1;
        this.activateCount = 0;
        this.needsMouse = !1;
        this.needsRaycast = !1;
        this.onTouchMovePreventScroll = (t)=>{
            let e = window.parent !== window, r = document.documentElement.scrollHeight > document.documentElement.clientHeight || document.documentElement.scrollWidth > document.documentElement.clientWidth;
            (t.touches.length > 1 || this.preventTouchScroll || e === !1 && r === !1) && t.preventDefault();
        };
        this.onMouseWheelPreventScroll = (t)=>{
            this.preventScroll && t.preventDefault();
        };
        this.onMouseMove = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: t.buttons > 0
            };
        };
        this.onMouseDown = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: !0
            };
        };
        this.onMouseUp = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: !1
            };
        };
        this.getMousePosition = (t)=>{
            let { domRect: e } = this.eventContext, { pageX: r, pageY: i } = t.touches?.length > 0 ? t.touches[0] : t;
            return {
                x: r - (e.left + window.scrollX),
                y: i - (e.top + window.scrollY)
            };
        };
        this.stopRaycast = t.stopRaycast, this.preventScroll = t.preventScroll, this.preventTouchScroll = t.preventTouchScroll, this.hideCursor = t.hideCursor, this.requestRender = i.requestRender;
    }
    activate(t = !1) {
        if (this.isEnabled) return;
        this.isEnabled = !0, this.initializeActionsDependentStates(), this.needsMouse && (this.eventContext.domElement.addEventListener("pointermove", this.onMouseMove), this.eventContext.domElement.addEventListener("pointerdown", this.onMouseDown)), this.handlers = {
            Spline: new Db(this.eventContext),
            ["VariableChange"]: new jb(this.eventContext, this.sharedVariables, this, this.needsMouse, this.needsRaycast),
            ["API"]: new $b(this.eventContext, this),
            ["WEBHOOK"]: new eS(this.eventContext, this),
            ["AIAssistantListener"]: new iS(this.eventContext, this),
            ["AIAssistantTrigger"]: new nS(this.eventContext, this),
            ["Conditional"]: new Lb(this.eventContext, this),
            ["Start"]: new zb(this.eventContext, this),
            Basic: new Ob(this.eventContext, this, this.needsRaycast),
            ["MouseHover"]: new kb(this.eventContext, this),
            ["Scroll"]: new Ub(this.eventContext, this),
            ["Follow"]: new Nb(this.eventContext, this),
            ["DragDrop"]: new Bb(this.eventContext, this),
            ["LookAt"]: new Vb(this.eventContext),
            ["Resize"]: new Jb(this.eventContext, this),
            Textfields: new rS(this.eventContext, this)
        };
        let { page: e, domElement: r } = this.eventContext;
        this.hideCursor && (r.style.cursor = "none"), e.traverseEntity((i)=>{
            i.addEventListener("requestRender", this.requestRender);
        }), Object.values(this.handlers).forEach((i)=>i.connect()), r.addEventListener("wheel", this.onMouseWheelPreventScroll), r.addEventListener("touchmove", this.onTouchMovePreventScroll), this.activateCount++, t || (this.eventContext.sharedAssets.openAIRealtime?.connect(), this.eventContext.sharedAssets.openAIRealtime?.start());
    }
    deactivate(t = !1) {
        if (!this.isEnabled) return;
        this.isEnabled = !1, this.eventContext.domElement.removeEventListener("pointermove", this.onMouseMove), this.eventContext.domElement.removeEventListener("pointerdown", this.onMouseDown), this.eventContext.domElement.removeEventListener("pointerup", this.onMouseUp), this.eventContext.sharedAssets.mouseProperty = null, this.eventContext.sharedAssets.raycastProperty = null;
        let { page: e, domElement: r } = this.eventContext;
        if (r.style.cursor = "", Object.values(this.handlers).forEach((i)=>i.disconnect()), this.controlsManager.gameControl?.disposeActions(), this.controlsManager.disconnectEvents(), e.traverseEntity((i)=>{
            i.removeEventListener("requestRender", this.requestRender), i.destroyedInAction = !1;
        }), r.removeEventListener("touchmove", this.onTouchMovePreventScroll), r.removeEventListener("wheel", this.onMouseWheelPreventScroll), this.animationControls.onExitPlayMode(), !t) {
            let i = this.eventContext.sharedAssets.openAIRealtime;
            i?.disconnect(), i?.stop().then(()=>{
                i?.disconnect();
            });
        }
    }
    get isPaused() {
        return this.isEnabled;
    }
    pause() {
        this.deactivate();
    }
    resume() {
        this.activate();
    }
    reset() {
        this.deactivate(!0), this.activate(!0), this.controlsManager.deactivate(), this.controlsManager.activate(this), this.controlsManager.page.updateMatrixWorld(!0), this.controlsManager.rebuildBVH();
    }
    updateUseWindowEvents(t) {
        let e = this.isEnabled;
        e && this.deactivate(), this.eventContext.useWindowEvents = t, e && this.activate();
    }
    initializeActionsDependentStates() {
        let t = this.eventContext.sharedAssets;
        t.resetDynamicVariablePlayState();
        let e = (r)=>{
            if (r.data.type === "Conditional" && (r.data.ifActions.forEach(e), r.data.elseActions.forEach(e)), r.data.type === "Conditional" || r.data.type === "SetVariable") for (let i of r.data.type === "Conditional" ? r.data.condition : r.data.expression)"id" in i && Array.isArray(i.id) && (i.id[0] === "mouse" && (this.needsMouse = !0), i.id[0] === "raycast" && (this.needsRaycast = !0));
            r.data.type === "DynamicVariablePlay" && r.data.variableId !== "" && (r.data.mode === "Play" || r.data.mode === "PlayPause" || r.data.mode === "Toggle") && t.setDynamicVariablePlayState(r.data.variableId, "Stopped");
        };
        this.eventContext.page.traverseEntity((r)=>{
            if (!!r.data?.events.length) for (let i of r.data.events)if (i.data.type === "VariableChange" && (i.data.variableId === "mouseProperty" && (this.needsMouse = !0), i.data.variableId === "raycastProperty" && (this.needsRaycast = !0)), i.data.type === "Conditional") for (let s of [
                "inActions",
                "outActions"
            ])i.data[s].forEach(e);
            else if (i.data.type === "DragDrop") for (let s of [
                "drag",
                "drop"
            ])i.data.dragDropActions[s].forEach(e);
            else if (i.data.type === "GameControl") for (let s of [
                "idle",
                "move",
                "jump",
                "run"
            ])i.data.gameActions[s].forEach(e);
            else if (i.data.type === "Resize") for (let s of i.data.breakpoints)s.data.actions.forEach(e);
            else i.data.type === "LookAt" || i.data.type === "API" || i.data.actions.forEach(e);
        });
    }
};
var oS = class {
    constructor(t, e, r, i, s){
        this._aspect = 1;
        this.enableResponsive = !1;
        this._renderer = t, this._camera = e, this._frameSize = new k().copy(r), this._editorSize = new k().copy(i), this._aspect = e.aspect, this._fov = s ?? e.fov;
    }
    set frameSize(t) {
        this._frameSize.copy(t);
    }
    updateRenderer() {
        !this._renderer || this._renderer.setSize(this._frameSize.x, this._frameSize.y);
    }
    updateViewport() {
        if (!this._renderer || !this._camera || this._camera.cameraType !== "PerspectiveCamera") return;
        let t = this._frameSize.x, e = this._frameSize.y, r = this._editorSize.y;
        this._aspect = t / e, e <= r && (this._camera.zoom *= r / e), this._renderer.setViewport(0, 0, t, e);
    }
    updateCamera(t = !0) {
        if (!!this._camera) {
            if (this._camera.cameraType === "PerspectiveCamera") {
                let e = this._frameSize.y, r = this._editorSize.y, i = this._fov;
                if (t && e > r) {
                    let s = R$(e, 1080, 2160, 1, 15) / 100;
                    i *= e / r, i *= 1 - s;
                }
                this._camera.aspect = this._aspect, this._camera.fov = i, this._camera.updateProjectionMatrix();
            } else this._camera.setViewplaneSize(this._frameSize.x, this._frameSize.y, this.enableResponsive);
        }
    }
    setCamera(t) {
        this._camera = t, this._aspect = t.aspect, this._fov = t.fov;
    }
    revert() {
        let t = window.innerWidth, e = window.innerHeight;
        this._renderer && (this._renderer.setViewport(0, 0, t, e), this._renderer.setSize(t, e)), this._camera && (this._camera.aspect = t / e, this._camera.fov = this._fov, this._camera.setViewplaneSize(t, e, this.enableResponsive), this._camera.updateProjectionMatrix());
    }
};
function R$(n1, t, e, r, i) {
    return (n1 - t) / (e - t) * (i - r) + r;
}
var aS = class {
    get sharedAssets() {
        return this.shared;
    }
    constructor(t, e = {}, r = !0){
        this.shared = new Zc(t.shared, e, !0, r), this.scene = new Kl(t.scene, this.sharedAssets), this.shared.setEntityOpContext({
            scene: this.scene,
            shared: this.shared
        });
    }
    reset(t, e) {
        this.scene.clearScene(), this.sharedAssets.reset(t.shared), this.scene.resetAfterClear(t.scene, this.sharedAssets);
    }
    resetPersonalCameraFromDocumentData() {
        for (let t of this.scene.children)t instanceof ur && !t.uiScene && t.personalCamera.updateState(t.data.camera, {
            scene: this.scene,
            shared: this.shared
        });
    }
    dispose() {
        this.scene.dispose(), this.shared.dispose();
    }
    gc() {
        this.shared.geometryCache.startGc(), this.shared.geometryCache2.startGc(), this.scene.traverseEntity((t)=>{
            t instanceof cr && t.markGeometryAsReachable(this.shared);
        }), this.shared.geometryCache.endGc(), this.shared.geometryCache2.endGc();
    }
};
var lS = class {
    constructor({ x: t = 10, y: e = 10 }){
        this._startTime = 0;
        let r = document.getElementById("spe-perfs");
        r ? this.element = r : (this.element = document.createElement("div"), document.body.appendChild(this.element), this.element.style.position = "absolute", this.element.style.zIndex = "10000", this.element.style.fontFamily = "monospace", this.element.style.background = "black", this.element.style.color = "white", this.element.style.padding = "10px", this.element.style.opacity = "0.5", this.element.style.fontSize = "11px", this.element.setAttribute("id", "spe-perfs")), this.element.style.left = `${t}px`, this.element.style.top = `${e}px`;
    }
    dispose() {
        this.element.parentElement?.removeChild(this.element);
    }
    start() {
        this._startTime = performance.now();
    }
    end() {
        let e = performance.now() - this._startTime;
        this.element.innerHTML = e.toFixed(3) + " ms";
    }
};
function L$(n1) {
    let t;
    if (!!n1.index) for(let e = 0; e < n1.index.array.length; e += 3)t = n1.index.array[e], n1.index.array[e] = n1.index.array[e + 2], n1.index.array[e + 2] = t;
}
function Eg(n1) {
    return n1 instanceof Zs ? "SubdivObject" : n1.geometry.type === "NonParametricGeometry" ? "NonParametric" : "Mesh";
}
function B$(n1, t) {
    let e = {};
    return n1.traverseEntity((r)=>{
        if (!r.visible || !(r instanceof mr) || r.type !== "Mesh" || Array.isArray(r.material) || r.states && Object.keys(r.states).length) return;
        let i = r.parent;
        for(; i;){
            if (i instanceof mr && r.states && Object.keys(r.states).length) return;
            i = i.parent;
        }
        let s = r.material.uuid, o = t.shared.materials[s];
        if (o) {
            if (!Kr.isMergable(o)) return;
        } else {
            let c = t.scene.objects.get(r.uuid)?.data;
            if (c && "material" in c && typeof c.material != "string") {
                if (!Kr.isMergable(c.material)) return;
                s = Kr.getHash(c.material);
            }
        }
        e[s] || (e[s] = {});
        let l = e[s][Eg(r)];
        if (l) {
            if (l.push(r), r.cloner) for (let c of r.cloner.children)l.push(c);
        } else if (e[s][Eg(r)] = [
            r
        ], r.cloner) for (let c of r.cloner.children)e[s][Eg(r)].push(c);
    }), e;
}
function N$(n1) {
    let t = 0;
    return Object.values(n1).forEach((e)=>{
        Object.values(e).forEach((r)=>{
            let i = r.length;
            i > t && (t = i);
        });
    }), t;
}
function pF(n1, t) {
    let e = B$(t, n1), r = N$(e), i = new Array(r), s = 0, o = new Array(r), a = 0, l = new Array(r), c = 0, u = new Array(r), h = 0;
    for (let [d, f] of Object.entries(e))for (let p of Object.values(f)){
        if (a = 0, c = 0, p.forEach((g)=>{
            g instanceof mr && (o[a++] = g.geometry.clone(), l[c++] = g);
        }), c < 2) continue;
        for(let g = 0; g < c; g++)l[g].updateWorldMatrix(!0, !1), o[g].applyMatrix4(l[g].matrixWorld), l[g].matrixWorld.determinant() < 0 && L$(o[g]);
        let m = Gs(o.slice(0, a), !1);
        if (m) {
            let g;
            switch(d){
                case "SubdivObject":
                    console.warn("Turning subdiv object into mesh"), g = new zt(m, l[0].material);
                    break;
                default:
                    g = new zt(m, l[0].material);
                    break;
            }
            g.castShadow = l[0].castShadow, g.receiveShadow = l[0].receiveShadow, t.add(g);
            let y = (x)=>{
                h = 0;
                for (let v of x)v.children && y(v.children), v instanceof mr && (Array.isArray(v.material) || e[v.material.uuid] && e[v.material.uuid][Eg(v)] && e[v.material.uuid][Eg(v)].length > 1 || (u[h++] = v));
                for(let v = 0; v < h; v++)t.attach(u[v]);
            };
            for(let x = 0; x < c; x++){
                let v = l[x];
                y(v.children), i[s++] = v;
            }
        }
    }
    for(let d = 0; d < s; d++)i[d].removeFromParent();
}
var vF = Wa(gF(), 1);
var V$ = new k;
function k$(n1) {
    let t = "The Spline Runtime only accepts .splinecode files that are generated from Spline export panel.";
    n1.endsWith(".spline") ? console.warn(t + " The .spline files are only meant to be used by the Editor.") : n1.endsWith(".splinecode") || console.warn(t);
}
var yF = class {
    constructor(t, { renderOnDemand: e, renderMode: r = "auto" } = {}){
        this._viewportMode = 1;
        this._viewportWidth = window.innerWidth;
        this._viewportHeight = window.innerHeight;
        this._proxyObjectCache = new Map;
        this._variablesCache = new Map;
        this._isPaused = !1;
        this._renderRequested = !1;
        this._skipRender = !1;
        this.time = performance.now();
        this.dt = 0;
        this.currentTAAFrame = 0;
        this.disposed = !1;
        this._requestRenderAutoMode = ()=>{
            this._skipRender = !1;
        };
        this.requestRender = ()=>{
            this._renderRequested = !0;
        };
        this.render = (t)=>{
            if (this.time = t, this._lastTime && (this.dt = this.time - this._lastTime), this._lastTime = this.time, this._perfs?.start(), !this._renderer) {
                this._perfs?.end();
                return;
            }
            if (!this._isPaused && (this.renderMode === "manual" && !this._renderRequested || this.renderMode === "auto" && this._skipRender)) {
                this._perfs?.end();
                return;
            }
            if (this._renderRequested = !1, this._skipRender = !0, this._controls && (this._skipRender = this._controls.update(this.dt)), this._eventManager && (this._eventManager.handlers?.Start.hasVideoAction || this._eventManager.handlers?.Basic.hasVideoAction || this._eventManager.handlers?.Conditional.hasVideoAction) && (this._skipRender = !1), this._animationControls?.update(this.dt), this._skipRender ? (this.currentTAAFrame++, this.currentTAAFrame < 32 ? this._skipRender = !1 : this.currentTAAFrame = 0) : this.currentTAAFrame = 0, this._scene?.traverseVisibleEntity((e)=>{
                e.type === "ParticleSystem" && (e.update(this.dt), this._skipRender = !1);
            }), this._scene && this._scene.activeCamera !== this._camera && (this._camera = this._scene.activeCamera), this._eventManager?.isEnabled && ((this._eventManager.handlers?.Follow).onAnimationFrameDamping(), (this._eventManager.handlers?.LookAt).onAnimationFrameDamping(), (this._eventManager.handlers?.DragDrop).onAnimationFrameDamping()), this._scene && this._camera) {
                if (this._scene.pathConstraints.applyConstraints(this._scene), this._renderer.sceneTransitionTimeRemaining > 0) {
                    this._renderer.sceneTransitionTimeRemaining -= this.dt;
                    let e = 1 - this._renderer.sceneTransitionTimeRemaining / this._renderer.sceneTransitionDuration;
                    this._renderer.pipeline.sceneTransitionPass.uniforms.mixRatio.value = e, this._skipRender = !1;
                } else this._renderer.pipeline.sceneTransitionFromTexture = null;
                this._renderer.renderSplineScene(this._scene, this._camera);
            }
            this.canvas.dispatchEvent(this._renderedEvent), this._perfs?.end();
        };
        this._resize = (t)=>{
            if (!!this._renderer) {
                if (this._viewportMode === 1 && this._frameView && (this._frameView.frameSize = V$.set(this._viewportWidth, this._viewportHeight)), t) {
                    let e = this._viewportWidth, r = this._viewportHeight;
                    this._renderer.setSize(e - 1, r - 1, !1), this._renderer.setSize(e, r, !1);
                } else this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1);
                if (this._camera = this._scene?.activeCamera, this._scene?.updateViewPlaneSize(this._frameView?.frameSize?.x ?? this._viewportWidth, this._frameView?.frameSize?.y ?? this._viewportHeight, this._frameView?.enableResponsive ?? !1), this._camera) {
                    let e = Object.values(this._data?.frames ?? {})[0].preset ?? "fullscreen";
                    this._frameView?.setCamera(this._camera), this._frameView?.updateCamera(e !== "fullscreen"), this._camera.cameraType === "PerspectiveCamera" && (this._camera.aspect = this._viewportWidth / this._viewportHeight), this._camera.updateProjectionMatrix();
                }
                this.eventManager && (this.eventManager.eventContext.domRect = this.canvas.getBoundingClientRect()), this._requestRenderAutoMode();
            }
        };
        this._debouncedResize = vo(this._resize, 10);
        this._onScroll = (t)=>{
            this.eventManager && (this.eventManager.eventContext.domRect = this.canvas.getBoundingClientRect());
        };
        this.canvas = t, this.renderMode = e ? "auto" : r, this._renderedEvent = new CustomEvent("rendered", {
            bubbles: !0
        }), Object.defineProperty(this._renderedEvent, "target", {
            writable: !1,
            value: this
        }), window.location.search.includes("perfs") && (this._perfs = new lS({
            x: 10,
            y: 10
        })), oI(t);
    }
    async load(t, e, r) {
        k$(t), this.disposed = !1;
        let s = await (await fetch(t, r)).arrayBuffer();
        await this.start(s, {
            variables: e
        });
    }
    async start(t, { interactive: e = !0, variables: r } = {}) {
        if (this.disposed) return;
        let i = await oF(t);
        this._data = i;
        let s = aF(i);
        i.version && (0, vF.default)(i.version, "1.9.46") > 0 && console.warn("Your .splinecode file is more recent than the library. Please upgrade @splinetool/runtime to the latest version."), await Promise.all([
            s.length && sF(),
            GE(i) && hR(),
            h3(i) && nR(),
            Pl.physicsEnabled(i.scene.objects) && fI(),
            RE(i) && JR(),
            lb(i) && gT(),
            KR(i) && YR(),
            eT(i) && PL(),
            cM(i) && uI()
        ].filter(Boolean)), s.length && await lF(s), this._eventManager?.deactivate(), this._controls?.deactivate(), this._scene?.dispose();
        let o = new aS(i);
        if (o.resetPersonalCameraFromDocumentData(), this._scene = o.scene, this._sharedAssetsManager = o.sharedAssets, this._camera = this._scene.activeCamera, window.location.search.includes("merge-geometries")) {
            let c = performance.now();
            pF(i, o.scene);
            let u = performance.now();
            console.log("Merged geometries in ", u - c, " ms");
        }
        GE(i) && this._scene.traverse((c)=>{
            En(c) && c.recomputeBoolean();
        }), this._sharedAssetsManager.setRequestRender(()=>{
            this._requestRenderAutoMode(), this._scene?.traverse((c)=>{
                c instanceof Gi && c.pendingMediaLoad && c.update();
            });
        }), this._scene?.traverse((c)=>{
            c.type === "ParticleSystem" && (c.wakeUp(), c.data.autoPlay ? c.start() : c.stop());
        });
        let a = Object.keys(i.shared.fonts).map((c)=>this._sharedAssetsManager.getFont(c).loadingPromise);
        if (Promise.all(a).then(()=>{
            o.scene.markNeedsUpdateRendererDirty(), this._requestRenderAutoMode();
        }), RE(i) && rF(i) && await Promise.all(a), eT(i)) {
            let c = [];
            this._scene.traverseEntity((u)=>{
                (u instanceof Er || u instanceof ur) && u.uiCanvas && c.push(u.uiCanvas);
            }), await Promise.all(c.map((u)=>u.promise));
        }
        if (this._scene.rewriteEventsBeforeGoToPlayMode(), Bf(this._scene.activePage, this._sharedAssetsManager), !this._renderer && (this._renderer = new Vx({
            canvas: this.canvas,
            antialias: !1,
            alpha: !0,
            stencil: !1,
            depth: !1,
            powerPreference: "high-performance"
        }), this._renderer.hdTransmission = i.scene.publish.hdTransmission === !0, this._renderer.setPixelRatio(window.devicePixelRatio), this._renderer.pipeline.enableUIOverlay(), this._renderer.pipeline.addEventListener("smaaloaded", this._requestRenderAutoMode), i.shared.images.SplineWatermark)) {
            let c = this._sharedAssetsManager.getImage("SplineWatermark");
            await c.loadPromise;
            let u = c.getTexture(1001);
            this._renderer.pipeline.setWatermark(u);
        }
        lb(i) && this._scene.initializeSplatViewer(), i.scene.blueNoiseTextureData !== void 0 && this._renderer.pipeline.updateBlueNoiseTexture(i.scene.blueNoiseTextureData);
        let l = Object.values(i.frames)[0];
        if (this._frameView ? this._frameView.setCamera(this._camera) : (l.preset === "fullscreen" ? (this._viewportMode = 1, this.canvas.style.display = "block", this.canvas.parentElement && (this._viewportWidth = this.canvas.parentElement.clientWidth || 300, this.canvas.style.width = "100%"), this.canvas.parentElement && (this._viewportHeight = this.canvas.parentElement.clientHeight || 150, this.canvas.style.height = "100%")) : (this._viewportMode = 2, this._viewportWidth = l.size[0], this._viewportHeight = l.size[1], this.canvas.style.width = `${this._viewportWidth}px`, this.canvas.style.height = `${this._viewportHeight}px`), this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1), this._frameView = new oS(this._renderer, this._camera, new k(this._viewportWidth, this._viewportHeight), new k(window.innerWidth, window.innerHeight)), this._frameView.enableResponsive = (l.allowResponsive ?? !1) && l.preset === "fullscreen"), e) {
            let c = new Ib(this._renderer, this.data.scene.publish, this._scene, ()=>this._scene.activeCamera, this._sharedAssetsManager, this._requestRenderAutoMode, !0, l);
            this._scene.updateMatrixWorld(!0), this._controls = new Xb(c), this._animationControls = new Kb(this._scene, this._requestRenderAutoMode), this._eventManager = new sS(i.scene.publish, this._controls, this._animationControls, c, i.shared.variables), this._eventManager.activate(), this._controls.activate(this._eventManager);
        }
        this._resize(), this._scene.activePage.data.postprocessing.depthOfField.enabled && Promise.all(this._sharedAssetsManager.getImageLoadPromises()).then(()=>{
            this._resize(!0);
        }), r !== void 0 && this.setVariables(r), this.dt === 0 && (this.render(performance.now()), setTimeout(()=>{
            this._renderer?.setAnimationLoop(this.render);
        }, 0)), this._resizeObserverTimeout = setTimeout(()=>{
            !this._resizeObserver && this.canvas.parentElement && (this._resizeObserver = new ResizeObserver(()=>{
                this._viewportWidth = this.canvas.clientWidth, this._viewportHeight = this.canvas.clientHeight, this._debouncedResize();
            }), this._resizeObserver.observe(this.canvas.parentElement));
        }, 300), document.addEventListener("scroll", this._onScroll);
    }
    setVariables(t) {
        if (this._data !== void 0) {
            let e = Object.entries(t);
            for (let [r, i] of e)this.setVariable(r, i);
        }
    }
    setVariable(t, e) {
        let r = this._getVariableByName(t);
        if (r && !("dynamicVariableType" in r.data)) {
            let i = e;
            typeof r.data.value == "number" ? i = typeof e == "number" ? e : typeof e == "boolean" ? e === !0 ? 1 : 0 : parseFloat(e) : typeof r.data.value == "boolean" ? i = typeof e == "number" ? !!e : typeof e == "boolean" ? e : e.toLocaleLowerCase() === "false" ? !1 : !!e : typeof r.data.value != "string" && r.data.value.textValue !== void 0 && (i = e.toString());
            let s = typeof i == "string" ? {
                textValue: i
            } : i;
            this._sharedAssetsManager?.updateVariable(r.id, s), this.requestRender(), this._requestRenderAutoMode();
        } else r === void 0 ? console.warn(`No variable named ${t} was found in your Spline file. Make sure to create it from Spline editor.`) : "dynamicVariableType" in r.data && console.warn(`Dynamic variables like ${t} cannot be updated from code.`);
    }
    getVariables() {
        let t = {};
        return this._data && this._data.shared.variables.forEach((e)=>{
            t[e.data.name] === void 0 && (t[e.data.name] = this._getVariableValue(this._sharedAssetsManager.getVariable(e.id)));
        }), t;
    }
    getVariable(t) {
        let e = this._getVariableByName(t);
        if (e) {
            let r = this._sharedAssetsManager.getVariable(e.id);
            return this._getVariableValue(r);
        }
    }
    _getVariableValue(t) {
        return typeof t != "string" && Br.isTextValue(t) ? Br.getDisplayedValue(t) : t;
    }
    _getVariableByName(t) {
        if (this._data) {
            if (this._variablesCache.has(t)) return this._variablesCache.get(t);
            let e = this._data.shared.variables.find((r)=>r.data.name === t);
            return e && this._variablesCache.set(t, e), e;
        }
    }
    findObjectById(t) {
        let e = this._scene?.getObjectByProperty("uuid", t);
        return this._createProxyObject(e);
    }
    findObjectByName(t) {
        let e = this._scene?.getObjectByName(t);
        return this._createProxyObject(e);
    }
    getAllObjects() {
        let t = [];
        return this._scene?.traverseEntity((e)=>{
            if (e.uuid !== hs && !this._scene.isInvisibleObjects(e) && !(e instanceof ur)) {
                let r = this._createProxyObject(e);
                r && t.push(r);
            }
        }), t;
    }
    getSplineEvents() {
        return (this._eventManager?.handlers?.Spline).splineEvents;
    }
    emitEvent(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEvent(t);
    }
    emitEventReverse(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEventReverse(t);
    }
    addEventListener(t, e) {
        this.canvas.addEventListener(t, e);
    }
    removeEventListener(t, e) {
        this.canvas.removeEventListener(t, e);
    }
    setZoom(t) {
        this._controls?.orbitControls instanceof Hf && this._controls?.orbitControls.setZoom(t);
    }
    get eventManager() {
        return this._eventManager;
    }
    get controls() {
        return this._controls;
    }
    setSize(t, e) {
        this._viewportWidth = t, this._viewportHeight = e, this._viewportMode = 2, this._resize();
    }
    setBackgroundColor(t) {
        let { r: e, g: r, b: i, a: s } = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, o = new vr(e, r, i, s);
        try {
            o.setStyle(t);
        } catch  {
            console.error("This is not a valid css color", t);
        }
        this._scene?.activePage.setBackgroundColor(o), this._requestRenderAutoMode();
    }
    dispose() {
        this.disposed = !0, this._eventManager?.deactivate(), this._scene?.dispose(), this._sharedAssetsManager?.dispose(), this._proxyObjectCache.forEach((t)=>{
            eA.unsubscribe(t);
        }), this._variablesCache.clear(), this._renderer?.setAnimationLoop(null), this._renderer?.dispose(), this._renderer = void 0, this._sharedAssetsManager?.dispose(), this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = void 0), this._resizeObserverTimeout !== void 0 && clearTimeout(this._resizeObserverTimeout), this.canvas.style.width = "", this.canvas.style.height = "", this.canvas.removeAttribute("width"), this.canvas.removeAttribute("height"), this._frameView && (this._frameView = void 0), this._controls?.deactivate(), this.dt = 0, aI(this.canvas), document.removeEventListener("scroll", this._onScroll);
    }
    get isStopped() {
        return this._isPaused;
    }
    stop() {
        this._isPaused || (this._renderer?.setAnimationLoop(null), this._isPaused = !0, this._eventManager?.pause(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !1));
    }
    play() {
        !this._isPaused || (this._isPaused = !1, this._eventManager?.resume(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !0), this._renderer?.setAnimationLoop(this.render));
    }
    setGlobalEvents(t) {
        this._eventManager?.updateUseWindowEvents(t);
    }
    get data() {
        return this._data;
    }
    _createProxyObject(t) {
        if (t == null) return;
        if (this._proxyObjectCache.has(t.uuid)) return this._proxyObjectCache.get(t.uuid);
        let e;
        t.traverseAncestors((s)=>{
            s instanceof ur && (e = s.name);
        });
        let r = {
            name: t.name,
            uuid: t.uuid,
            visible: t.visible,
            intensity: t.intensity,
            position: t.position,
            rotation: t.rotation,
            scale: t.scale,
            type: t.data.type,
            page: e,
            parentUuid: t.parent instanceof ur || t instanceof Kl ? void 0 : t.parent?.uuid,
            emitEvent (s) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: s
                });
            },
            emitEventReverse (s) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: s,
                    reverse: !0
                });
            }
        }, i = eA(r, (s, o)=>{
            typeof t[s] != "object" && Object.getOwnPropertyDescriptor(t, s)?.writable && (t[s] = o), this._requestRenderAutoMode(), t.updateMatrix();
        });
        return this._proxyObjectCache.set(t.uuid, i), i;
    }
    setUIWasmUrl(t) {
        X0.skiaWasmUrl = t;
    }
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8b5hF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7ld7l").then(()=>parcelRequire("gRaTy"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("lUNnT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cxrcT").then(()=>parcelRequire("lxep3"));

});

parcelRegister("9CTrk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cM1YA").then(()=>parcelRequire("1eBiX"));

});

parcelRegister("1Jpra", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9WKx7").then(()=>parcelRequire("Aa6gW"));

});

parcelRegister("fQPhc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("13cBi").then(()=>parcelRequire("8pSbm"));

});

parcelRegister("14X3t", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dtqLr").then(()=>parcelRequire("lq4np"));

});

parcelRegister("836Xp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5fiVm").then(()=>parcelRequire("jRJKa"));

});

parcelRegister("88rJr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3MkNW").then(()=>parcelRequire("5nvck"));

});


parcelRegister("FVrXi", function(module, exports) {

$parcel$export(module.exports, "Network", () => $07e064cd5d4580c1$export$95be4ae94445245a);
$parcel$export(module.exports, "VaultType", () => $07e064cd5d4580c1$export$74d89d9a07cc40e2);
$parcel$export(module.exports, "AllocatorActionType", () => $07e064cd5d4580c1$export$e6e2757d7bafe7d1);
$parcel$export(module.exports, "OsTokenPositionHealth", () => $07e064cd5d4580c1$export$8479cadfc64275dd);
$parcel$export(module.exports, "getGas", () => $07e064cd5d4580c1$export$e28db7cbe64d1041);
$parcel$export(module.exports, "configs", () => $07e064cd5d4580c1$export$c884d9dcb329c3c);
$parcel$export(module.exports, "BigDecimal", () => $07e064cd5d4580c1$export$714d099a508ef2ab);
$parcel$export(module.exports, "createProvider", () => $07e064cd5d4580c1$export$500fbc0cd14cdbaa);
$parcel$export(module.exports, "createContract", () => $07e064cd5d4580c1$export$7c4d5b09373bb58d);
$parcel$export(module.exports, "StakeWiseSDK", () => $07e064cd5d4580c1$export$14a4f206f73bf7a8);
$parcel$export(module.exports, "chains", () => $07e064cd5d4580c1$export$af1c0561ce3e4019);

var $b6VUG = parcelRequire("b6VUG");
var $1dRRv = parcelRequire("1dRRv");
var $gWuvh = parcelRequire("gWuvh");
var $3PTkx = parcelRequire("3PTkx");
var $jxZic = parcelRequire("jxZic");
var $95T0n = parcelRequire("95T0n");
var $klTOW = parcelRequire("klTOW");
var $b3To1 = parcelRequire("b3To1");
var $1H5oH = parcelRequire("1H5oH");
var $1cKTC = parcelRequire("1cKTC");
var $7RlNJ = parcelRequire("7RlNJ");
var $07e064cd5d4580c1$export$95be4ae94445245a, $07e064cd5d4580c1$export$74d89d9a07cc40e2, $07e064cd5d4580c1$export$e6e2757d7bafe7d1, $07e064cd5d4580c1$export$8479cadfc64275dd;
!function(e) {
    e[e.Mainnet = 1] = "Mainnet", e[e.Holesky = 17e3] = "Holesky", e[e.Gnosis = 100] = "Gnosis", e[e.Chiado = 10200] = "Chiado";
}($07e064cd5d4580c1$export$95be4ae94445245a || ($07e064cd5d4580c1$export$95be4ae94445245a = {})), function(e) {
    e.Default = "Default", e.Private = "Private", e.Blocklist = "Blocklist";
}($07e064cd5d4580c1$export$74d89d9a07cc40e2 || ($07e064cd5d4580c1$export$74d89d9a07cc40e2 = {})), function(e) {
    e.Redeemed = "Redeemed", e.Migrated = "Migrated", e.Deposited = "Deposited", e.TransferIn = "TransferIn", e.VaultCreated = "VaultCreated", e.OsTokenMinted = "OsTokenMinted", e.OsTokenBurned = "OsTokenBurned", e.OsTokenRedeemed = "OsTokenRedeemed", e.ExitQueueEntered = "ExitQueueEntered", e.OsTokenLiquidated = "OsTokenLiquidated", e.ExitedAssetsClaimed = "ExitedAssetsClaimed";
}($07e064cd5d4580c1$export$e6e2757d7bafe7d1 || ($07e064cd5d4580c1$export$e6e2757d7bafe7d1 = {})), function(e) {
    e[e.Unhealthy = 0] = "Unhealthy", e[e.Moderate = 1] = "Moderate", e[e.Healthy = 2] = "Healthy", e[e.Risky = 3] = "Risky";
}($07e064cd5d4580c1$export$8479cadfc64275dd || ($07e064cd5d4580c1$export$8479cadfc64275dd = {}));
var $07e064cd5d4580c1$var$v = (e)=>{
    const t = e?.substring(e.indexOf(",") + 1), a = t ? atob(t).length / 1e3 / 1e3 : 0;
    if (a > 1) {
        const e = a.toFixed(2);
        throw new Error(`The size of the image must be under 1 MB, current size is ${e} MB`);
    }
}, $07e064cd5d4580c1$var$w = (e, t = !0)=>{
    Object.keys(e).forEach((a)=>{
        if (!Array.isArray(e[a])) throw new Error(`The "${a}" argument must be an array`);
        if (t && !e[a].length) throw new Error(`The "${a}" argument is an empty array`);
    });
}, $07e064cd5d4580c1$var$b = (e)=>{
    Object.keys(e).forEach((t)=>{
        if ("bigint" != typeof e[t]) throw new Error(`The "${t}" argument must be of type bigint`);
    });
}, $07e064cd5d4580c1$var$g = (e)=>{
    Object.keys(e).forEach((t)=>{
        if ("string" != typeof e[t]) throw new Error(`The "${t}" argument must be a string`);
    });
}, $07e064cd5d4580c1$var$A = (e)=>{
    Object.keys(e).forEach((t)=>{
        if ("number" != typeof e[t]) throw new Error(`The "${t}" argument must be a number`);
    });
}, $07e064cd5d4580c1$var$T = (t)=>{
    Object.keys(t).forEach((a)=>{
        if (!(0, $klTOW.isAddress)(t[a])) throw new Error(`The "${a}" argument must be a valid address`);
    });
}, $07e064cd5d4580c1$var$k = (e)=>{
    Object.keys(e).forEach((t)=>{
        const { value: a, length: s } = e[t];
        if (a.length > s) throw new Error(`The value for "${t}" argument must be less than ${s} characters`);
    });
};
const $07e064cd5d4580c1$export$e28db7cbe64d1041 = async (e)=>{
    const { provider: t, estimatedGas: a } = e;
    $07e064cd5d4580c1$var$b({
        estimatedGas: a
    });
    const [s, r] = await Promise.all([
        t.getFeeData(),
        t.getBlock("latest")
    ]), { gasPrice: n, maxFeePerGas: i, maxPriorityFeePerGas: o } = s, u = r?.baseFeePerGas || 0n;
    return Boolean(i && o) ? a * (u + (o || 0n)) : a * n;
};
var $07e064cd5d4580c1$var$S = {
    eth: "ETH",
    swise: "SWISE",
    osETH: "osETH",
    gno: "GNO",
    xdai: "xDAI",
    osGNO: "osGNO",
    sGNO: "sGNO",
    rGNO: "rGNO",
    rETH2: "rETH2",
    sETH2: "sETH2"
};
var $07e064cd5d4580c1$var$C = {
    sessionStorageNames: {
        moduleErrorUrl: "SW_gqlModuleErrorUrl"
    },
    blockchain: {
        blocksInDay: 6646,
        secondsInBlock: 13,
        blocksInYear: 2427458,
        secondsInYear: 31536e3,
        gwei: 1000000000n,
        amount0: 0n,
        amount1: 1000000000000000000n,
        amount10: 10000000000000000000n,
        amount32: 32000000000000000000n,
        amount100: 100000000000000000000n
    },
    tokens: $07e064cd5d4580c1$var$S,
    chains: {
        mainnet: {
            id: "mainnet",
            name: "Ethereum",
            chainId: $07e064cd5d4580c1$export$95be4ae94445245a.Mainnet,
            hexadecimalChainId: "0x1",
            blockExplorerUrl: "https://etherscan.io",
            url: "https://mainnet.infura.io/v3/84842078b09946638c03157f83405213",
            nativeCurrency: {
                symbol: $07e064cd5d4580c1$var$S.eth,
                name: "Ethereum",
                decimals: 18
            },
            isTestnet: !1
        },
        holesky: {
            id: "holesky",
            name: "Holesky Testnet",
            chainId: $07e064cd5d4580c1$export$95be4ae94445245a.Holesky,
            hexadecimalChainId: "0x4268",
            url: "https://ethereum-holesky.publicnode.com/",
            blockExplorerUrl: "https://holesky.etherscan.io",
            nativeCurrency: {
                symbol: $07e064cd5d4580c1$var$S.eth,
                name: "Ethereum",
                decimals: 18
            },
            isTestnet: !0
        },
        chiado: {
            id: "chiado",
            name: "Chiado Testnet",
            chainId: $07e064cd5d4580c1$export$95be4ae94445245a.Chiado,
            hexadecimalChainId: "0x27D8",
            url: "https://rpc.chiadochain.net",
            blockExplorerUrl: "https://gnosis-chiado.blockscout.com",
            nativeCurrency: {
                symbol: $07e064cd5d4580c1$var$S.xdai,
                name: $07e064cd5d4580c1$var$S.xdai,
                decimals: 18
            },
            isTestnet: !0
        },
        gnosis: {
            id: "gnosis",
            name: "Gnosis Chain",
            chainId: $07e064cd5d4580c1$export$95be4ae94445245a.Gnosis,
            hexadecimalChainId: "0x64",
            url: "https://rpc.gnosischain.com",
            blockExplorerUrl: "https://gnosisscan.io",
            nativeCurrency: {
                symbol: $07e064cd5d4580c1$var$S.xdai,
                name: $07e064cd5d4580c1$var$S.xdai,
                decimals: 18
            },
            isTestnet: !1
        }
    }
}, $07e064cd5d4580c1$var$M = {
    network: $07e064cd5d4580c1$var$C.chains.chiado,
    api: {
        backend: "https://chiado-api.stakewise.io/graphql",
        subgraph: "https://chiado-graph.stakewise.io/subgraphs/name/stakewise/stakewise"
    },
    pages: {
        beaconchain: "https://beacon.chiadochain.net"
    },
    addresses: {
        tokens: {
            swise: "0x460d2c6c3254809949a7d0b4646ce15F77e9c545",
            mintToken: "0x0b4F6bFB694790051E0203Db83edbB5888099556",
            depositToken: "0x19C653Da7c37c66208fbfbE8908A5051B57b4C70",
            v2RewardToken: "0x14c74b1C7eCa8362D4ABcCd71051Ce174d61a3D4",
            v2StakedToken: "0xee2493a42861a0a49f88525c44aab8126d04b761"
        },
        base: {
            keeper: "0x5f31eD13eBF81B67a9f9498F3d1D2Da553058988",
            oracles: (0, $7RlNJ.ZeroAddress),
            multicall: "0xcA11bde05977b3631167028862bE2a173976CA11",
            priceOracle: "0x3CC131e6f6b975423151E5aaE8C466f4f81A8A4c",
            vaultsRegistry: "0x8750594B33516232e751C8B9C350a660cD5f1BB8",
            sharedMevEscrow: "0x453056f0bc4631abB15eEC656139f88067668E3E",
            mintTokenConfigV1: (0, $7RlNJ.ZeroAddress),
            mintTokenConfigV2: "0x6D5957e075fd93b3B9F36Da93d7462F14387706d",
            merkleDistributor: (0, $7RlNJ.ZeroAddress),
            depositDataRegistry: "0xFAce8504462AEb9BB6ae7Ecb206BD7B1EdF7956D",
            mintTokenController: "0x5518052f2d898f062ee59964004A560F24E2eE7d",
            rewardSplitterFactory: "0x6EE912596DCC3a8b7308164A65Af529a4276737C"
        },
        factories: {
            vault: "0x7fEFdC8375E84Adb0bE5e4Ba5E238c021F1858fE",
            erc20Vault: "0x7eA0D7dB6cf2402eB2B1A56bfBf6c2C88e6c8284",
            privateVault: "0xA67D62F8D26Fe034426B512A6621D4e8fc8B2aB3",
            erc20PrivateVault: "0x588102eB5E387956b8067F4948BcA34893E89597",
            blocklistVault: "0x2bC7968461c51525433b9DcE504a543b26a2f31B",
            erc20BlocklistVault: "0x35482A11E21157E0C706d1A562483902421dB341"
        },
        balancer: {
            vault: (0, $7RlNJ.ZeroAddress)
        },
        uniswap: {
            positionManager: (0, $7RlNJ.ZeroAddress)
        }
    },
    tokens: {
        mintToken: $07e064cd5d4580c1$var$C.tokens.osGNO,
        nativeToken: $07e064cd5d4580c1$var$C.tokens.xdai,
        depositToken: $07e064cd5d4580c1$var$C.tokens.gno,
        v2RewardToken: $07e064cd5d4580c1$var$C.tokens.rGNO,
        v2StakedToken: $07e064cd5d4580c1$var$C.tokens.sGNO
    }
}, $07e064cd5d4580c1$var$R = {
    network: $07e064cd5d4580c1$var$C.chains.mainnet,
    api: {
        backend: "https://mainnet-api.stakewise.io/graphql",
        subgraph: [
            "https://mainnet-graph.stakewise.io/subgraphs/name/stakewise/stakewise",
            "https://mainnet-graph-b.stakewise.io/subgraphs/name/stakewise/stakewise"
        ]
    },
    pages: {
        beaconchain: "https://beaconcha.in"
    },
    addresses: {
        tokens: {
            swise: "0x48C3399719B582dD63eB5AADf12A40B4C3f52FA2",
            mintToken: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
            depositToken: (0, $7RlNJ.ZeroAddress),
            v2RewardToken: "0x20BC832ca081b91433ff6c17f85701B6e92486c5",
            v2StakedToken: "0xFe2e637202056d30016725477c5da089Ab0A043A"
        },
        base: {
            keeper: "0x6B5815467da09DaA7DC83Db21c9239d98Bb487b5",
            oracles: "0x2f1C5E86B13a74f5A6E7B4b35DD77fe29Aa47514",
            multicall: "0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441",
            priceOracle: "0x8023518b2192FB5384DAdc596765B3dD1cdFe471",
            vaultsRegistry: "0x3a0008a588772446f6e656133C2D5029CC4FC20E",
            sharedMevEscrow: "0x48319f97E5Da1233c21c48b80097c0FB7a20Ff86",
            mintTokenConfigV1: "0xE8822246F8864DA92015813A39ae776087Fb1Cd5",
            mintTokenConfigV2: "0x287d1e2A8dE183A8bf8f2b09Fa1340fBd766eb59",
            merkleDistributor: "0xA3F21010e8b9a3930996C8849Df38f9Ca3647c20",
            depositDataRegistry: (0, $7RlNJ.ZeroAddress),
            mintTokenController: "0x2A261e60FB14586B474C208b1B7AC6D0f5000306",
            rewardSplitterFactory: "0x90a9428b8c58cA80B28aAF46B936D42e87797449"
        },
        factories: {
            vault: "0xDada5a8E3703B1e3EA2bAe5Ab704627eb2659fCC",
            erc20Vault: "0x6DDc10eEeEBbBcF00E784bA44Fe4B038af26cB53",
            privateVault: "0x170618936cd96B1eD8112eC3D3778374B38DFe5e",
            erc20PrivateVault: "0xe84183EfFbcc76D022Cccc31b95EAa332bB5Bb11",
            blocklistVault: (0, $7RlNJ.ZeroAddress),
            erc20BlocklistVault: (0, $7RlNJ.ZeroAddress)
        },
        balancer: {
            vault: "0xBA12222222228d8Ba445958a75a0704d566BF2C8"
        },
        uniswap: {
            positionManager: "0xC36442b4a4522E871399CD717aBDD847Ab11FE88"
        }
    },
    tokens: {
        mintToken: $07e064cd5d4580c1$var$C.tokens.osETH,
        nativeToken: $07e064cd5d4580c1$var$C.tokens.eth,
        depositToken: $07e064cd5d4580c1$var$C.tokens.eth,
        v2RewardToken: $07e064cd5d4580c1$var$C.tokens.rETH2,
        v2StakedToken: $07e064cd5d4580c1$var$C.tokens.sETH2
    }
}, $07e064cd5d4580c1$var$D = {
    network: $07e064cd5d4580c1$var$C.chains.holesky,
    api: {
        backend: "https://holesky-api.stakewise.io/graphql",
        subgraph: "https://holesky-graph.stakewise.io/subgraphs/name/stakewise/stakewise"
    },
    pages: {
        beaconchain: "https://holesky.beaconcha.in"
    },
    addresses: {
        tokens: {
            swise: "0x484871C6D54a3dAEBeBBDB0AB7a54c97D72986Bb",
            mintToken: "0xF603c5A3F774F05d4D848A9bB139809790890864",
            depositToken: (0, $7RlNJ.ZeroAddress),
            v2RewardToken: "0x2ee2E20702B5881a1171c5dbEd01C3d1e49Bf632",
            v2StakedToken: "0x91167861c590Fd68bEbE662951fBE30C9B23D759"
        },
        base: {
            keeper: "0xB580799Bf7d62721D1a523f0FDF2f5Ed7BA4e259",
            oracles: (0, $7RlNJ.ZeroAddress),
            multicall: "0xcA11bde05977b3631167028862bE2a173976CA11",
            priceOracle: "0xe31FAf135A6047Cbe595F91B4b6802cDB9B46E2b",
            vaultsRegistry: "0xAa773c035Af95721C518eCd8250CadAC0AAB7ed0",
            sharedMevEscrow: "0xc98F25BcAA6B812a07460f18da77AF8385be7b56",
            mintTokenConfigV1: "0x4483965Ed85cd5e67f2a7a0EB462aCcC37b23D72",
            mintTokenConfigV2: "0x124C33d07F94B31aDF87C12F7cA3a586d3510928",
            merkleDistributor: (0, $7RlNJ.ZeroAddress),
            depositDataRegistry: "0xAC0F906E433d58FA868F936E8A43230473652885",
            mintTokenController: "0x7BbC1733ee018f103A9a9052a18fA9273255Cf36",
            rewardSplitterFactory: "0x2Ed24638b3aB48cF0076f19199c78A62bfEb5889"
        },
        factories: {
            vault: "0xA1424Bd00e6940A58B1232ad4160A77dD0AC3099",
            erc20Vault: "0xc6e7d05B3F6e73E3A86C6deAE0Da1fce993cF833",
            privateVault: "0x8023518b2192FB5384DAdc596765B3dD1cdFe471",
            erc20PrivateVault: "0x481f28C0D733614aF87897E43d0D52C451799592",
            blocklistVault: "0x90a9428b8c58cA80B28aAF46B936D42e87797449",
            erc20BlocklistVault: "0x82FE8C78CaE0013471179e76224ef89941bAaa75"
        },
        balancer: {
            vault: (0, $7RlNJ.ZeroAddress)
        },
        uniswap: {
            positionManager: (0, $7RlNJ.ZeroAddress)
        }
    },
    tokens: {
        mintToken: $07e064cd5d4580c1$var$C.tokens.osETH,
        nativeToken: $07e064cd5d4580c1$var$C.tokens.eth,
        depositToken: $07e064cd5d4580c1$var$C.tokens.eth,
        v2RewardToken: $07e064cd5d4580c1$var$C.tokens.rETH2,
        v2StakedToken: $07e064cd5d4580c1$var$C.tokens.sETH2
    }
}, $07e064cd5d4580c1$var$x = {
    network: $07e064cd5d4580c1$var$C.chains.gnosis,
    api: {
        backend: "https://gnosis-api.stakewise.io/graphql",
        subgraph: "https://gnosis-graph.stakewise.io/subgraphs/name/stakewise/stakewise"
    },
    pages: {
        beaconchain: "https://gnosis.beaconcha.in"
    },
    addresses: {
        tokens: {
            swise: "0xfdA94F056346d2320d4B5E468D6Ad099b2277746",
            mintToken: "0xF490c80aAE5f2616d3e3BDa2483E30C4CB21d1A0",
            depositToken: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
            v2RewardToken: "0x6aC78efae880282396a335CA2F79863A1e6831D4",
            v2StakedToken: "0xA4eF9Da5BA71Cc0D2e5E877a910A37eC43420445"
        },
        base: {
            keeper: "0xcAC0e3E35d3BA271cd2aaBE688ac9DB1898C26aa",
            oracles: "0xa6D123620Ea004cc5158b0ec260E934bd45C78c1",
            multicall: "0xb5b692a88BDFc81ca69dcB1d924f59f0413A602a",
            priceOracle: "0x9B1b13afA6a57e54C03AD0428a4766C39707D272",
            vaultsRegistry: "0x7d014B3C6ee446563d4e0cB6fBD8C3D0419867cB",
            sharedMevEscrow: "0x30db0d10d3774e78f8cB214b9e8B72D4B402488a",
            mintTokenConfigV1: (0, $7RlNJ.ZeroAddress),
            mintTokenConfigV2: "0xd6672fbE1D28877db598DC0ac2559A15745FC3ec",
            merkleDistributor: "0x7dc30953CE236665d032329F6a922d67F0a33a2B",
            depositDataRegistry: "0x58e16621B5c0786D6667D2d54E28A20940269E16",
            mintTokenController: "0x60B2053d7f2a0bBa70fe6CDd88FB47b579B9179a",
            rewardSplitterFactory: "0x4c6306BA1821D88803e27A115433520F2d6276Fb"
        },
        factories: {
            vault: "0xC2ecc7620416bd65bfab7010B0db955a0e49579a",
            erc20Vault: "0xF6BBBc05536Ab198d4b7Ab74a93f8e2d4cAd5354",
            privateVault: "0x574952EC88b2fC271d0C0dB130794c86Ea42139A",
            erc20PrivateVault: "0x48319f97E5Da1233c21c48b80097c0FB7a20Ff86",
            blocklistVault: "0x78FbfBd1DD38892476Ac469325df36604A27F5B7",
            erc20BlocklistVault: "0x99E4300326867FE3f97864a74e500d19654c19e9"
        },
        balancer: {
            vault: "0xBA12222222228d8Ba445958a75a0704d566BF2C8"
        },
        uniswap: {
            positionManager: (0, $7RlNJ.ZeroAddress)
        }
    },
    tokens: {
        mintToken: $07e064cd5d4580c1$var$C.tokens.osGNO,
        nativeToken: $07e064cd5d4580c1$var$C.tokens.xdai,
        depositToken: $07e064cd5d4580c1$var$C.tokens.gno,
        v2RewardToken: $07e064cd5d4580c1$var$C.tokens.rGNO,
        v2StakedToken: $07e064cd5d4580c1$var$C.tokens.sGNO
    }
}, $07e064cd5d4580c1$export$c884d9dcb329c3c = {
    [$07e064cd5d4580c1$export$95be4ae94445245a.Mainnet]: $07e064cd5d4580c1$var$R,
    [$07e064cd5d4580c1$export$95be4ae94445245a.Holesky]: $07e064cd5d4580c1$var$D,
    [$07e064cd5d4580c1$export$95be4ae94445245a.Gnosis]: $07e064cd5d4580c1$var$x,
    [$07e064cd5d4580c1$export$95be4ae94445245a.Chiado]: $07e064cd5d4580c1$var$M
};
var $07e064cd5d4580c1$var$P = (e)=>e.endpoints?.web3 || $07e064cd5d4580c1$export$c884d9dcb329c3c[e.network].network.url, $07e064cd5d4580c1$var$O = (e)=>e.endpoints?.api || $07e064cd5d4580c1$export$c884d9dcb329c3c[e.network].api.backend, $07e064cd5d4580c1$var$I = (e)=>e.endpoints?.subgraph || $07e064cd5d4580c1$export$c884d9dcb329c3c[e.network].api.subgraph, $07e064cd5d4580c1$var$N = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $07e064cd5d4580c1$var$F = Math.ceil, $07e064cd5d4580c1$var$q = Math.floor, $07e064cd5d4580c1$var$_ = "[BigNumber Error] ", $07e064cd5d4580c1$var$V = $07e064cd5d4580c1$var$_ + "Number primitive has more than 15 significant digits: ", $07e064cd5d4580c1$var$$ = 1e14, $07e064cd5d4580c1$var$G = 14, $07e064cd5d4580c1$var$L = 9007199254740991, $07e064cd5d4580c1$var$j = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $07e064cd5d4580c1$var$H = 1e7, $07e064cd5d4580c1$var$Q = 1e9;
function $07e064cd5d4580c1$var$U(e) {
    var t = 0 | e;
    return e > 0 || e === t ? t : t - 1;
}
function $07e064cd5d4580c1$var$z(e) {
    for(var t, a, s = 1, r = e.length, n = e[0] + ""; s < r;){
        for(t = e[s++] + "", a = $07e064cd5d4580c1$var$G - t.length; a--; t = "0" + t);
        n += t;
    }
    for(r = n.length; 48 === n.charCodeAt(--r););
    return n.slice(0, r + 1 || 1);
}
function $07e064cd5d4580c1$var$W(e, t) {
    var a, s, r = e.c, n = t.c, i = e.s, o = t.s, u = e.e, l = t.e;
    if (!i || !o) return null;
    if (a = r && !r[0], s = n && !n[0], a || s) return a ? s ? 0 : -o : i;
    if (i != o) return i;
    if (a = i < 0, s = u == l, !r || !n) return s ? 0 : !r ^ a ? 1 : -1;
    if (!s) return u > l ^ a ? 1 : -1;
    for(o = (u = r.length) < (l = n.length) ? u : l, i = 0; i < o; i++)if (r[i] != n[i]) return r[i] > n[i] ^ a ? 1 : -1;
    return u == l ? 0 : u > l ^ a ? 1 : -1;
}
function $07e064cd5d4580c1$var$K(e, t, a, s) {
    if (e < t || e > a || e !== $07e064cd5d4580c1$var$q(e)) throw Error($07e064cd5d4580c1$var$_ + (s || "Argument") + ("number" == typeof e ? e < t || e > a ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function $07e064cd5d4580c1$var$X(e) {
    var t = e.c.length - 1;
    return $07e064cd5d4580c1$var$U(e.e / $07e064cd5d4580c1$var$G) == t && e.c[t] % 2 != 0;
}
function $07e064cd5d4580c1$var$Y(e, t) {
    return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
}
function $07e064cd5d4580c1$var$J(e, t, a) {
    var s, r;
    if (t < 0) {
        for(r = a + "."; ++t; r += a);
        e = r + e;
    } else if (++t > (s = e.length)) {
        for(r = a, t -= s; --t; r += a);
        e += r;
    } else t < s && (e = e.slice(0, t) + "." + e.slice(t));
    return e;
}
var $07e064cd5d4580c1$var$Z = function e(t) {
    var a, s, r, n, i, o, u, l, c, d, p = C.prototype = {
        constructor: C,
        toString: null,
        valueOf: null
    }, y = new C(1), m = 20, h = 4, f = -7, v = 21, w = -10000000, b = 1e7, g = !1, A = 1, T = 0, k = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, E = "0123456789abcdefghijklmnopqrstuvwxyz", S = !0;
    function C(e, t) {
        var a, n, i, o, u, l, c, d, p = this;
        if (!(p instanceof C)) return new C(e, t);
        if (null == t) {
            if (e && !0 === e._isBigNumber) return p.s = e.s, void (!e.c || e.e > b ? p.c = p.e = null : e.e < w ? p.c = [
                p.e = 0
            ] : (p.e = e.e, p.c = e.c.slice()));
            if ((l = "number" == typeof e) && 0 * e == 0) {
                if (p.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                    for(o = 0, u = e; u >= 10; u /= 10, o++);
                    return void (o > b ? p.c = p.e = null : (p.e = o, p.c = [
                        e
                    ]));
                }
                d = String(e);
            } else {
                if (!$07e064cd5d4580c1$var$N.test(d = String(e))) return r(p, d, l);
                p.s = 45 == d.charCodeAt(0) ? (d = d.slice(1), -1) : 1;
            }
            (o = d.indexOf(".")) > -1 && (d = d.replace(".", "")), (u = d.search(/e/i)) > 0 ? (o < 0 && (o = u), o += +d.slice(u + 1), d = d.substring(0, u)) : o < 0 && (o = d.length);
        } else {
            if ($07e064cd5d4580c1$var$K(t, 2, E.length, "Base"), 10 == t && S) return x(p = new C(e), m + p.e + 1, h);
            if (d = String(e), l = "number" == typeof e) {
                if (0 * e != 0) return r(p, d, l, t);
                if (p.s = 1 / e < 0 ? (d = d.slice(1), -1) : 1, C.DEBUG && d.replace(/^0\.0*|\./, "").length > 15) throw Error($07e064cd5d4580c1$var$V + e);
            } else p.s = 45 === d.charCodeAt(0) ? (d = d.slice(1), -1) : 1;
            for(a = E.slice(0, t), o = u = 0, c = d.length; u < c; u++)if (a.indexOf(n = d.charAt(u)) < 0) {
                if ("." == n) {
                    if (u > o) {
                        o = c;
                        continue;
                    }
                } else if (!i && (d == d.toUpperCase() && (d = d.toLowerCase()) || d == d.toLowerCase() && (d = d.toUpperCase()))) {
                    i = !0, u = -1, o = 0;
                    continue;
                }
                return r(p, String(e), l, t);
            }
            l = !1, (o = (d = s(d, t, 10, p.s)).indexOf(".")) > -1 ? d = d.replace(".", "") : o = d.length;
        }
        for(u = 0; 48 === d.charCodeAt(u); u++);
        for(c = d.length; 48 === d.charCodeAt(--c););
        if (d = d.slice(u, ++c)) {
            if (c -= u, l && C.DEBUG && c > 15 && (e > $07e064cd5d4580c1$var$L || e !== $07e064cd5d4580c1$var$q(e))) throw Error($07e064cd5d4580c1$var$V + p.s * e);
            if ((o = o - u - 1) > b) p.c = p.e = null;
            else if (o < w) p.c = [
                p.e = 0
            ];
            else {
                if (p.e = o, p.c = [], u = (o + 1) % $07e064cd5d4580c1$var$G, o < 0 && (u += $07e064cd5d4580c1$var$G), u < c) {
                    for(u && p.c.push(+d.slice(0, u)), c -= $07e064cd5d4580c1$var$G; u < c;)p.c.push(+d.slice(u, u += $07e064cd5d4580c1$var$G));
                    u = $07e064cd5d4580c1$var$G - (d = d.slice(u)).length;
                } else u -= c;
                for(; u--; d += "0");
                p.c.push(+d);
            }
        } else p.c = [
            p.e = 0
        ];
    }
    function M(e, t, a, s) {
        var r, n, i, o, u;
        if (null == a ? a = h : $07e064cd5d4580c1$var$K(a, 0, 8), !e.c) return e.toString();
        if (r = e.c[0], i = e.e, null == t) u = $07e064cd5d4580c1$var$z(e.c), u = 1 == s || 2 == s && (i <= f || i >= v) ? $07e064cd5d4580c1$var$Y(u, i) : $07e064cd5d4580c1$var$J(u, i, "0");
        else if (n = (e = x(new C(e), t, a)).e, o = (u = $07e064cd5d4580c1$var$z(e.c)).length, 1 == s || 2 == s && (t <= n || n <= f)) {
            for(; o < t; u += "0", o++);
            u = $07e064cd5d4580c1$var$Y(u, n);
        } else if (t -= i, u = $07e064cd5d4580c1$var$J(u, n, "0"), n + 1 > o) {
            if (--t > 0) for(u += "."; t--; u += "0");
        } else if ((t += n - o) > 0) for(n + 1 == o && (u += "."); t--; u += "0");
        return e.s < 0 && r ? "-" + u : u;
    }
    function R(e, t) {
        for(var a, s, r = 1, n = new C(e[0]); r < e.length; r++)(!(s = new C(e[r])).s || (a = $07e064cd5d4580c1$var$W(n, s)) === t || 0 === a && n.s === t) && (n = s);
        return n;
    }
    function D(e, t, a) {
        for(var s = 1, r = t.length; !t[--r]; t.pop());
        for(r = t[0]; r >= 10; r /= 10, s++);
        return (a = s + a * $07e064cd5d4580c1$var$G - 1) > b ? e.c = e.e = null : a < w ? e.c = [
            e.e = 0
        ] : (e.e = a, e.c = t), e;
    }
    function x(e, t, a, s) {
        var r, n, i, o, u, l, c, d = e.c, p = $07e064cd5d4580c1$var$j;
        if (d) {
            e: {
                for(r = 1, o = d[0]; o >= 10; o /= 10, r++);
                if ((n = t - r) < 0) n += $07e064cd5d4580c1$var$G, i = t, u = d[l = 0], c = $07e064cd5d4580c1$var$q(u / p[r - i - 1] % 10);
                else if ((l = $07e064cd5d4580c1$var$F((n + 1) / $07e064cd5d4580c1$var$G)) >= d.length) {
                    if (!s) break e;
                    for(; d.length <= l; d.push(0));
                    u = c = 0, r = 1, i = (n %= $07e064cd5d4580c1$var$G) - $07e064cd5d4580c1$var$G + 1;
                } else {
                    for(u = o = d[l], r = 1; o >= 10; o /= 10, r++);
                    c = (i = (n %= $07e064cd5d4580c1$var$G) - $07e064cd5d4580c1$var$G + r) < 0 ? 0 : $07e064cd5d4580c1$var$q(u / p[r - i - 1] % 10);
                }
                if (s = s || t < 0 || null != d[l + 1] || (i < 0 ? u : u % p[r - i - 1]), s = a < 4 ? (c || s) && (0 == a || a == (e.s < 0 ? 3 : 2)) : c > 5 || 5 == c && (4 == a || s || 6 == a && (n > 0 ? i > 0 ? u / p[r - i] : 0 : d[l - 1]) % 10 & 1 || a == (e.s < 0 ? 8 : 7)), t < 1 || !d[0]) return d.length = 0, s ? (t -= e.e + 1, d[0] = p[($07e064cd5d4580c1$var$G - t % $07e064cd5d4580c1$var$G) % $07e064cd5d4580c1$var$G], e.e = -t || 0) : d[0] = e.e = 0, e;
                if (0 == n ? (d.length = l, o = 1, l--) : (d.length = l + 1, o = p[$07e064cd5d4580c1$var$G - n], d[l] = i > 0 ? $07e064cd5d4580c1$var$q(u / p[r - i] % p[i]) * o : 0), s) for(;;){
                    if (0 == l) {
                        for(n = 1, i = d[0]; i >= 10; i /= 10, n++);
                        for(i = d[0] += o, o = 1; i >= 10; i /= 10, o++);
                        n != o && (e.e++, d[0] == $07e064cd5d4580c1$var$$ && (d[0] = 1));
                        break;
                    }
                    if (d[l] += o, d[l] != $07e064cd5d4580c1$var$$) break;
                    d[l--] = 0, o = 1;
                }
                for(n = d.length; 0 === d[--n]; d.pop());
            }
            e.e > b ? e.c = e.e = null : e.e < w && (e.c = [
                e.e = 0
            ]);
        }
        return e;
    }
    function B(e) {
        var t, a = e.e;
        return null === a ? e.toString() : (t = $07e064cd5d4580c1$var$z(e.c), t = a <= f || a >= v ? $07e064cd5d4580c1$var$Y(t, a) : $07e064cd5d4580c1$var$J(t, a, "0"), e.s < 0 ? "-" + t : t);
    }
    return C.clone = e, C.ROUND_UP = 0, C.ROUND_DOWN = 1, C.ROUND_CEIL = 2, C.ROUND_FLOOR = 3, C.ROUND_HALF_UP = 4, C.ROUND_HALF_DOWN = 5, C.ROUND_HALF_EVEN = 6, C.ROUND_HALF_CEIL = 7, C.ROUND_HALF_FLOOR = 8, C.EUCLID = 9, C.config = C.set = function(e) {
        var t, a;
        if (null != e) {
            if ("object" != typeof e) throw Error($07e064cd5d4580c1$var$_ + "Object expected: " + e);
            if (e.hasOwnProperty(t = "DECIMAL_PLACES") && ($07e064cd5d4580c1$var$K(a = e[t], 0, $07e064cd5d4580c1$var$Q, t), m = a), e.hasOwnProperty(t = "ROUNDING_MODE") && ($07e064cd5d4580c1$var$K(a = e[t], 0, 8, t), h = a), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((a = e[t]) && a.pop ? ($07e064cd5d4580c1$var$K(a[0], -$07e064cd5d4580c1$var$Q, 0, t), $07e064cd5d4580c1$var$K(a[1], 0, $07e064cd5d4580c1$var$Q, t), f = a[0], v = a[1]) : ($07e064cd5d4580c1$var$K(a, -$07e064cd5d4580c1$var$Q, $07e064cd5d4580c1$var$Q, t), f = -(v = a < 0 ? -a : a))), e.hasOwnProperty(t = "RANGE")) {
                if ((a = e[t]) && a.pop) $07e064cd5d4580c1$var$K(a[0], -$07e064cd5d4580c1$var$Q, -1, t), $07e064cd5d4580c1$var$K(a[1], 1, $07e064cd5d4580c1$var$Q, t), w = a[0], b = a[1];
                else {
                    if ($07e064cd5d4580c1$var$K(a, -$07e064cd5d4580c1$var$Q, $07e064cd5d4580c1$var$Q, t), !a) throw Error($07e064cd5d4580c1$var$_ + t + " cannot be zero: " + a);
                    w = -(b = a < 0 ? -a : a);
                }
            }
            if (e.hasOwnProperty(t = "CRYPTO")) {
                if ((a = e[t]) !== !!a) throw Error($07e064cd5d4580c1$var$_ + t + " not true or false: " + a);
                if (a) {
                    if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw g = !a, Error($07e064cd5d4580c1$var$_ + "crypto unavailable");
                    g = a;
                } else g = a;
            }
            if (e.hasOwnProperty(t = "MODULO_MODE") && ($07e064cd5d4580c1$var$K(a = e[t], 0, 9, t), A = a), e.hasOwnProperty(t = "POW_PRECISION") && ($07e064cd5d4580c1$var$K(a = e[t], 0, $07e064cd5d4580c1$var$Q, t), T = a), e.hasOwnProperty(t = "FORMAT")) {
                if ("object" != typeof (a = e[t])) throw Error($07e064cd5d4580c1$var$_ + t + " not an object: " + a);
                k = a;
            }
            if (e.hasOwnProperty(t = "ALPHABET")) {
                if ("string" != typeof (a = e[t]) || /^.?$|[+\-.\s]|(.).*\1/.test(a)) throw Error($07e064cd5d4580c1$var$_ + t + " invalid: " + a);
                S = "0123456789" == a.slice(0, 10), E = a;
            }
        }
        return {
            DECIMAL_PLACES: m,
            ROUNDING_MODE: h,
            EXPONENTIAL_AT: [
                f,
                v
            ],
            RANGE: [
                w,
                b
            ],
            CRYPTO: g,
            MODULO_MODE: A,
            POW_PRECISION: T,
            FORMAT: k,
            ALPHABET: E
        };
    }, C.isBigNumber = function(e) {
        if (!e || !0 !== e._isBigNumber) return !1;
        if (!C.DEBUG) return !0;
        var t, a, s = e.c, r = e.e, n = e.s;
        e: if ("[object Array]" == ({}).toString.call(s)) {
            if ((1 === n || -1 === n) && r >= -$07e064cd5d4580c1$var$Q && r <= $07e064cd5d4580c1$var$Q && r === $07e064cd5d4580c1$var$q(r)) {
                if (0 === s[0]) {
                    if (0 === r && 1 === s.length) return !0;
                    break e;
                }
                if ((t = (r + 1) % $07e064cd5d4580c1$var$G) < 1 && (t += $07e064cd5d4580c1$var$G), String(s[0]).length == t) {
                    for(t = 0; t < s.length; t++)if ((a = s[t]) < 0 || a >= $07e064cd5d4580c1$var$$ || a !== $07e064cd5d4580c1$var$q(a)) break e;
                    if (0 !== a) return !0;
                }
            }
        } else if (null === s && null === r && (null === n || 1 === n || -1 === n)) return !0;
        throw Error($07e064cd5d4580c1$var$_ + "Invalid BigNumber: " + e);
    }, C.maximum = C.max = function() {
        return R(arguments, -1);
    }, C.minimum = C.min = function() {
        return R(arguments, 1);
    }, C.random = (n = 9007199254740992, i = Math.random() * n & 2097151 ? function() {
        return $07e064cd5d4580c1$var$q(Math.random() * n);
    } : function() {
        return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
    }, function(e) {
        var t, a, s, r, n, o = 0, u = [], l = new C(y);
        if (null == e ? e = m : $07e064cd5d4580c1$var$K(e, 0, $07e064cd5d4580c1$var$Q), r = $07e064cd5d4580c1$var$F(e / $07e064cd5d4580c1$var$G), g) {
            if (crypto.getRandomValues) {
                for(t = crypto.getRandomValues(new Uint32Array(r *= 2)); o < r;)(n = 131072 * t[o] + (t[o + 1] >>> 11)) >= 9e15 ? (a = crypto.getRandomValues(new Uint32Array(2)), t[o] = a[0], t[o + 1] = a[1]) : (u.push(n % 1e14), o += 2);
                o = r / 2;
            } else {
                if (!crypto.randomBytes) throw g = !1, Error($07e064cd5d4580c1$var$_ + "crypto unavailable");
                for(t = crypto.randomBytes(r *= 7); o < r;)(n = 281474976710656 * (31 & t[o]) + 1099511627776 * t[o + 1] + 4294967296 * t[o + 2] + 16777216 * t[o + 3] + (t[o + 4] << 16) + (t[o + 5] << 8) + t[o + 6]) >= 9e15 ? crypto.randomBytes(7).copy(t, o) : (u.push(n % 1e14), o += 7);
                o = r / 7;
            }
        }
        if (!g) for(; o < r;)(n = i()) < 9e15 && (u[o++] = n % 1e14);
        for(r = u[--o], e %= $07e064cd5d4580c1$var$G, r && e && (n = $07e064cd5d4580c1$var$j[$07e064cd5d4580c1$var$G - e], u[o] = $07e064cd5d4580c1$var$q(r / n) * n); 0 === u[o]; u.pop(), o--);
        if (o < 0) u = [
            s = 0
        ];
        else {
            for(s = -1; 0 === u[0]; u.splice(0, 1), s -= $07e064cd5d4580c1$var$G);
            for(o = 1, n = u[0]; n >= 10; n /= 10, o++);
            o < $07e064cd5d4580c1$var$G && (s -= $07e064cd5d4580c1$var$G - o);
        }
        return l.e = s, l.c = u, l;
    }), C.sum = function() {
        for(var e = 1, t = arguments, a = new C(t[0]); e < t.length;)a = a.plus(t[e++]);
        return a;
    }, s = function() {
        var e = "0123456789";
        function t(e, t, a, s) {
            for(var r, n, i = [
                0
            ], o = 0, u = e.length; o < u;){
                for(n = i.length; n--; i[n] *= t);
                for(i[0] += s.indexOf(e.charAt(o++)), r = 0; r < i.length; r++)i[r] > a - 1 && (null == i[r + 1] && (i[r + 1] = 0), i[r + 1] += i[r] / a | 0, i[r] %= a);
            }
            return i.reverse();
        }
        return function(s, r, n, i, o) {
            var u, l, c, d, p, y, f, v, w = s.indexOf("."), b = m, g = h;
            for(w >= 0 && (d = T, T = 0, s = s.replace(".", ""), y = (v = new C(r)).pow(s.length - w), T = d, v.c = t($07e064cd5d4580c1$var$J($07e064cd5d4580c1$var$z(y.c), y.e, "0"), 10, n, e), v.e = v.c.length), c = d = (f = t(s, r, n, o ? (u = E, e) : (u = e, E))).length; 0 == f[--d]; f.pop());
            if (!f[0]) return u.charAt(0);
            if (w < 0 ? --c : (y.c = f, y.e = c, y.s = i, f = (y = a(y, v, b, g, n)).c, p = y.r, c = y.e), w = f[l = c + b + 1], d = n / 2, p = p || l < 0 || null != f[l + 1], p = g < 4 ? (null != w || p) && (0 == g || g == (y.s < 0 ? 3 : 2)) : w > d || w == d && (4 == g || p || 6 == g && 1 & f[l - 1] || g == (y.s < 0 ? 8 : 7)), l < 1 || !f[0]) s = p ? $07e064cd5d4580c1$var$J(u.charAt(1), -b, u.charAt(0)) : u.charAt(0);
            else {
                if (f.length = l, p) for(--n; ++f[--l] > n;)f[l] = 0, l || (++c, f = [
                    1
                ].concat(f));
                for(d = f.length; !f[--d];);
                for(w = 0, s = ""; w <= d; s += u.charAt(f[w++]));
                s = $07e064cd5d4580c1$var$J(s, c, u.charAt(0));
            }
            return s;
        };
    }(), a = function() {
        function e(e, t, a) {
            var s, r, n, i, o = 0, u = e.length, l = t % $07e064cd5d4580c1$var$H, c = t / $07e064cd5d4580c1$var$H | 0;
            for(e = e.slice(); u--;)o = ((r = l * (n = e[u] % $07e064cd5d4580c1$var$H) + (s = c * n + (i = e[u] / $07e064cd5d4580c1$var$H | 0) * l) % $07e064cd5d4580c1$var$H * $07e064cd5d4580c1$var$H + o) / a | 0) + (s / $07e064cd5d4580c1$var$H | 0) + c * i, e[u] = r % a;
            return o && (e = [
                o
            ].concat(e)), e;
        }
        function t(e, t, a, s) {
            var r, n;
            if (a != s) n = a > s ? 1 : -1;
            else for(r = n = 0; r < a; r++)if (e[r] != t[r]) {
                n = e[r] > t[r] ? 1 : -1;
                break;
            }
            return n;
        }
        function a(e, t, a, s) {
            for(var r = 0; a--;)e[a] -= r, r = e[a] < t[a] ? 1 : 0, e[a] = r * s + e[a] - t[a];
            for(; !e[0] && e.length > 1; e.splice(0, 1));
        }
        return function(s, r, n, i, o) {
            var u, l, c, d, p, y, m, h, f, v, w, b, g, A, T, k, E, S = s.s == r.s ? 1 : -1, M = s.c, R = r.c;
            if (!(M && M[0] && R && R[0])) return new C(s.s && r.s && (M ? !R || M[0] != R[0] : R) ? M && 0 == M[0] || !R ? 0 * S : S / 0 : NaN);
            for(f = (h = new C(S)).c = [], S = n + (l = s.e - r.e) + 1, o || (o = $07e064cd5d4580c1$var$$, l = $07e064cd5d4580c1$var$U(s.e / $07e064cd5d4580c1$var$G) - $07e064cd5d4580c1$var$U(r.e / $07e064cd5d4580c1$var$G), S = S / $07e064cd5d4580c1$var$G | 0), c = 0; R[c] == (M[c] || 0); c++);
            if (R[c] > (M[c] || 0) && l--, S < 0) f.push(1), d = !0;
            else {
                for(A = M.length, k = R.length, c = 0, S += 2, (p = $07e064cd5d4580c1$var$q(o / (R[0] + 1))) > 1 && (R = e(R, p, o), M = e(M, p, o), k = R.length, A = M.length), g = k, w = (v = M.slice(0, k)).length; w < k; v[w++] = 0);
                E = R.slice(), E = [
                    0
                ].concat(E), T = R[0], R[1] >= o / 2 && T++;
                do {
                    if (p = 0, (u = t(R, v, k, w)) < 0) {
                        if (b = v[0], k != w && (b = b * o + (v[1] || 0)), (p = $07e064cd5d4580c1$var$q(b / T)) > 1) for(p >= o && (p = o - 1), m = (y = e(R, p, o)).length, w = v.length; 1 == t(y, v, m, w);)p--, a(y, k < m ? E : R, m, o), m = y.length, u = 1;
                        else 0 == p && (u = p = 1), m = (y = R.slice()).length;
                        if (m < w && (y = [
                            0
                        ].concat(y)), a(v, y, w, o), w = v.length, -1 == u) for(; t(R, v, k, w) < 1;)p++, a(v, k < w ? E : R, w, o), w = v.length;
                    } else 0 === u && (p++, v = [
                        0
                    ]);
                    f[c++] = p, v[0] ? v[w++] = M[g] || 0 : (v = [
                        M[g]
                    ], w = 1);
                }while ((g++ < A || null != v[0]) && S--);
                d = null != v[0], f[0] || f.splice(0, 1);
            }
            if (o == $07e064cd5d4580c1$var$$) {
                for(c = 1, S = f[0]; S >= 10; S /= 10, c++);
                x(h, n + (h.e = c + l * $07e064cd5d4580c1$var$G - 1) + 1, i, d);
            } else h.e = l, h.r = +d;
            return h;
        };
    }(), o = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, l = /^\.([^.]+)$/, c = /^-?(Infinity|NaN)$/, d = /^\s*\+(?=[\w.])|^\s+|\s+$/g, r = function(e, t, a, s) {
        var r, n = a ? t : t.replace(d, "");
        if (c.test(n)) e.s = isNaN(n) ? null : n < 0 ? -1 : 1;
        else {
            if (!a && (n = n.replace(o, function(e, t, a) {
                return r = "x" == (a = a.toLowerCase()) ? 16 : "b" == a ? 2 : 8, s && s != r ? e : t;
            }), s && (r = s, n = n.replace(u, "$1").replace(l, "0.$1")), t != n)) return new C(n, r);
            if (C.DEBUG) throw Error($07e064cd5d4580c1$var$_ + "Not a" + (s ? " base " + s : "") + " number: " + t);
            e.s = null;
        }
        e.c = e.e = null;
    }, p.absoluteValue = p.abs = function() {
        var e = new C(this);
        return e.s < 0 && (e.s = 1), e;
    }, p.comparedTo = function(e, t) {
        return $07e064cd5d4580c1$var$W(this, new C(e, t));
    }, p.decimalPlaces = p.dp = function(e, t) {
        var a, s, r, n = this;
        if (null != e) return $07e064cd5d4580c1$var$K(e, 0, $07e064cd5d4580c1$var$Q), null == t ? t = h : $07e064cd5d4580c1$var$K(t, 0, 8), x(new C(n), e + n.e + 1, t);
        if (!(a = n.c)) return null;
        if (s = ((r = a.length - 1) - $07e064cd5d4580c1$var$U(this.e / $07e064cd5d4580c1$var$G)) * $07e064cd5d4580c1$var$G, r = a[r]) for(; r % 10 == 0; r /= 10, s--);
        return s < 0 && (s = 0), s;
    }, p.dividedBy = p.div = function(e, t) {
        return a(this, new C(e, t), m, h);
    }, p.dividedToIntegerBy = p.idiv = function(e, t) {
        return a(this, new C(e, t), 0, 1);
    }, p.exponentiatedBy = p.pow = function(e, t) {
        var a, s, r, n, i, o, u, l, c = this;
        if ((e = new C(e)).c && !e.isInteger()) throw Error($07e064cd5d4580c1$var$_ + "Exponent not an integer: " + B(e));
        if (null != t && (t = new C(t)), i = e.e > 14, !c.c || !c.c[0] || 1 == c.c[0] && !c.e && 1 == c.c.length || !e.c || !e.c[0]) return l = new C(Math.pow(+B(c), i ? e.s * (2 - $07e064cd5d4580c1$var$X(e)) : +B(e))), t ? l.mod(t) : l;
        if (o = e.s < 0, t) {
            if (t.c ? !t.c[0] : !t.s) return new C(NaN);
            (s = !o && c.isInteger() && t.isInteger()) && (c = c.mod(t));
        } else {
            if (e.e > 9 && (c.e > 0 || c.e < -1 || (0 == c.e ? c.c[0] > 1 || i && c.c[1] >= 24e7 : c.c[0] < 8e13 || i && c.c[0] <= 9999975e7))) return n = c.s < 0 && $07e064cd5d4580c1$var$X(e) ? -0 : 0, c.e > -1 && (n = 1 / n), new C(o ? 1 / n : n);
            T && (n = $07e064cd5d4580c1$var$F(T / $07e064cd5d4580c1$var$G + 2));
        }
        for(i ? (a = new C(.5), o && (e.s = 1), u = $07e064cd5d4580c1$var$X(e)) : u = (r = Math.abs(+B(e))) % 2, l = new C(y);;){
            if (u) {
                if (!(l = l.times(c)).c) break;
                n ? l.c.length > n && (l.c.length = n) : s && (l = l.mod(t));
            }
            if (r) {
                if (0 === (r = $07e064cd5d4580c1$var$q(r / 2))) break;
                u = r % 2;
            } else if (x(e = e.times(a), e.e + 1, 1), e.e > 14) u = $07e064cd5d4580c1$var$X(e);
            else {
                if (0 === (r = +B(e))) break;
                u = r % 2;
            }
            c = c.times(c), n ? c.c && c.c.length > n && (c.c.length = n) : s && (c = c.mod(t));
        }
        return s ? l : (o && (l = y.div(l)), t ? l.mod(t) : n ? x(l, T, h, undefined) : l);
    }, p.integerValue = function(e) {
        var t = new C(this);
        return null == e ? e = h : $07e064cd5d4580c1$var$K(e, 0, 8), x(t, t.e + 1, e);
    }, p.isEqualTo = p.eq = function(e, t) {
        return 0 === $07e064cd5d4580c1$var$W(this, new C(e, t));
    }, p.isFinite = function() {
        return !!this.c;
    }, p.isGreaterThan = p.gt = function(e, t) {
        return $07e064cd5d4580c1$var$W(this, new C(e, t)) > 0;
    }, p.isGreaterThanOrEqualTo = p.gte = function(e, t) {
        return 1 === (t = $07e064cd5d4580c1$var$W(this, new C(e, t))) || 0 === t;
    }, p.isInteger = function() {
        return !!this.c && $07e064cd5d4580c1$var$U(this.e / $07e064cd5d4580c1$var$G) > this.c.length - 2;
    }, p.isLessThan = p.lt = function(e, t) {
        return $07e064cd5d4580c1$var$W(this, new C(e, t)) < 0;
    }, p.isLessThanOrEqualTo = p.lte = function(e, t) {
        return -1 === (t = $07e064cd5d4580c1$var$W(this, new C(e, t))) || 0 === t;
    }, p.isNaN = function() {
        return !this.s;
    }, p.isNegative = function() {
        return this.s < 0;
    }, p.isPositive = function() {
        return this.s > 0;
    }, p.isZero = function() {
        return !!this.c && 0 == this.c[0];
    }, p.minus = function(e, t) {
        var a, s, r, n, i = this, o = i.s;
        if (t = (e = new C(e, t)).s, !o || !t) return new C(NaN);
        if (o != t) return e.s = -t, i.plus(e);
        var u = i.e / $07e064cd5d4580c1$var$G, l = e.e / $07e064cd5d4580c1$var$G, c = i.c, d = e.c;
        if (!u || !l) {
            if (!c || !d) return c ? (e.s = -t, e) : new C(d ? i : NaN);
            if (!c[0] || !d[0]) return d[0] ? (e.s = -t, e) : new C(c[0] ? i : 3 == h ? -0 : 0);
        }
        if (u = $07e064cd5d4580c1$var$U(u), l = $07e064cd5d4580c1$var$U(l), c = c.slice(), o = u - l) {
            for((n = o < 0) ? (o = -o, r = c) : (l = u, r = d), r.reverse(), t = o; t--; r.push(0));
            r.reverse();
        } else for(s = (n = (o = c.length) < (t = d.length)) ? o : t, o = t = 0; t < s; t++)if (c[t] != d[t]) {
            n = c[t] < d[t];
            break;
        }
        if (n && (r = c, c = d, d = r, e.s = -e.s), (t = (s = d.length) - (a = c.length)) > 0) for(; t--; c[a++] = 0);
        for(t = $07e064cd5d4580c1$var$$ - 1; s > o;){
            if (c[--s] < d[s]) {
                for(a = s; a && !c[--a]; c[a] = t);
                --c[a], c[s] += $07e064cd5d4580c1$var$$;
            }
            c[s] -= d[s];
        }
        for(; 0 == c[0]; c.splice(0, 1), --l);
        return c[0] ? D(e, c, l) : (e.s = 3 == h ? -1 : 1, e.c = [
            e.e = 0
        ], e);
    }, p.modulo = p.mod = function(e, t) {
        var s, r, n = this;
        return e = new C(e, t), !n.c || !e.s || e.c && !e.c[0] ? new C(NaN) : !e.c || n.c && !n.c[0] ? new C(n) : (9 == A ? (r = e.s, e.s = 1, s = a(n, e, 0, 3), e.s = r, s.s *= r) : s = a(n, e, 0, A), (e = n.minus(s.times(e))).c[0] || 1 != A || (e.s = n.s), e);
    }, p.multipliedBy = p.times = function(e, t) {
        var a, s, r, n, i, o, u, l, c, d, p, y, m, h, f, v = this, w = v.c, b = (e = new C(e, t)).c;
        if (!(w && b && w[0] && b[0])) return !v.s || !e.s || w && !w[0] && !b || b && !b[0] && !w ? e.c = e.e = e.s = null : (e.s *= v.s, w && b ? (e.c = [
            0
        ], e.e = 0) : e.c = e.e = null), e;
        for(s = $07e064cd5d4580c1$var$U(v.e / $07e064cd5d4580c1$var$G) + $07e064cd5d4580c1$var$U(e.e / $07e064cd5d4580c1$var$G), e.s *= v.s, (u = w.length) < (d = b.length) && (m = w, w = b, b = m, r = u, u = d, d = r), r = u + d, m = []; r--; m.push(0));
        for(h = $07e064cd5d4580c1$var$$, f = $07e064cd5d4580c1$var$H, r = d; --r >= 0;){
            for(a = 0, p = b[r] % f, y = b[r] / f | 0, n = r + (i = u); n > r;)a = ((l = p * (l = w[--i] % f) + (o = y * l + (c = w[i] / f | 0) * p) % f * f + m[n] + a) / h | 0) + (o / f | 0) + y * c, m[n--] = l % h;
            m[n] = a;
        }
        return a ? ++s : m.splice(0, 1), D(e, m, s);
    }, p.negated = function() {
        var e = new C(this);
        return e.s = -e.s || null, e;
    }, p.plus = function(e, t) {
        var a, s = this, r = s.s;
        if (t = (e = new C(e, t)).s, !r || !t) return new C(NaN);
        if (r != t) return e.s = -t, s.minus(e);
        var n = s.e / $07e064cd5d4580c1$var$G, i = e.e / $07e064cd5d4580c1$var$G, o = s.c, u = e.c;
        if (!n || !i) {
            if (!o || !u) return new C(r / 0);
            if (!o[0] || !u[0]) return u[0] ? e : new C(o[0] ? s : 0 * r);
        }
        if (n = $07e064cd5d4580c1$var$U(n), i = $07e064cd5d4580c1$var$U(i), o = o.slice(), r = n - i) {
            for(r > 0 ? (i = n, a = u) : (r = -r, a = o), a.reverse(); r--; a.push(0));
            a.reverse();
        }
        for((r = o.length) - (t = u.length) < 0 && (a = u, u = o, o = a, t = r), r = 0; t;)r = (o[--t] = o[t] + u[t] + r) / $07e064cd5d4580c1$var$$ | 0, o[t] = $07e064cd5d4580c1$var$$ === o[t] ? 0 : o[t] % $07e064cd5d4580c1$var$$;
        return r && (o = [
            r
        ].concat(o), ++i), D(e, o, i);
    }, p.precision = p.sd = function(e, t) {
        var a, s, r, n = this;
        if (null != e && e !== !!e) return $07e064cd5d4580c1$var$K(e, 1, $07e064cd5d4580c1$var$Q), null == t ? t = h : $07e064cd5d4580c1$var$K(t, 0, 8), x(new C(n), e, t);
        if (!(a = n.c)) return null;
        if (s = (r = a.length - 1) * $07e064cd5d4580c1$var$G + 1, r = a[r]) {
            for(; r % 10 == 0; r /= 10, s--);
            for(r = a[0]; r >= 10; r /= 10, s++);
        }
        return e && n.e + 1 > s && (s = n.e + 1), s;
    }, p.shiftedBy = function(e) {
        return $07e064cd5d4580c1$var$K(e, -9007199254740991, $07e064cd5d4580c1$var$L), this.times("1e" + e);
    }, p.squareRoot = p.sqrt = function() {
        var e, t, s, r, n, i = this, o = i.c, u = i.s, l = i.e, c = m + 4, d = new C("0.5");
        if (1 !== u || !o || !o[0]) return new C(!u || u < 0 && (!o || o[0]) ? NaN : o ? i : 1 / 0);
        if (0 == (u = Math.sqrt(+B(i))) || u == 1 / 0 ? (((t = $07e064cd5d4580c1$var$z(o)).length + l) % 2 == 0 && (t += "0"), u = Math.sqrt(+t), l = $07e064cd5d4580c1$var$U((l + 1) / 2) - (l < 0 || l % 2), s = new C(t = u == 1 / 0 ? "5e" + l : (t = u.toExponential()).slice(0, t.indexOf("e") + 1) + l)) : s = new C(u + ""), s.c[0]) {
            for((u = (l = s.e) + c) < 3 && (u = 0);;)if (n = s, s = d.times(n.plus(a(i, n, c, 1))), $07e064cd5d4580c1$var$z(n.c).slice(0, u) === (t = $07e064cd5d4580c1$var$z(s.c)).slice(0, u)) {
                if (s.e < l && --u, "9999" != (t = t.slice(u - 3, u + 1)) && (r || "4999" != t)) {
                    +t && (+t.slice(1) || "5" != t.charAt(0)) || (x(s, s.e + m + 2, 1), e = !s.times(s).eq(i));
                    break;
                }
                if (!r && (x(n, n.e + m + 2, 0), n.times(n).eq(i))) {
                    s = n;
                    break;
                }
                c += 4, u += 4, r = 1;
            }
        }
        return x(s, s.e + m + 1, h, e);
    }, p.toExponential = function(e, t) {
        return null != e && ($07e064cd5d4580c1$var$K(e, 0, $07e064cd5d4580c1$var$Q), e++), M(this, e, t, 1);
    }, p.toFixed = function(e, t) {
        return null != e && ($07e064cd5d4580c1$var$K(e, 0, $07e064cd5d4580c1$var$Q), e = e + this.e + 1), M(this, e, t);
    }, p.toFormat = function(e, t, a) {
        var s, r = this;
        if (null == a) null != e && t && "object" == typeof t ? (a = t, t = null) : e && "object" == typeof e ? (a = e, e = t = null) : a = k;
        else if ("object" != typeof a) throw Error($07e064cd5d4580c1$var$_ + "Argument not an object: " + a);
        if (s = r.toFixed(e, t), r.c) {
            var n, i = s.split("."), o = +a.groupSize, u = +a.secondaryGroupSize, l = a.groupSeparator || "", c = i[0], d = i[1], p = r.s < 0, y = p ? c.slice(1) : c, m = y.length;
            if (u && (n = o, o = u, u = n, m -= n), o > 0 && m > 0) {
                for(n = m % o || o, c = y.substr(0, n); n < m; n += o)c += l + y.substr(n, o);
                u > 0 && (c += l + y.slice(n)), p && (c = "-" + c);
            }
            s = d ? c + (a.decimalSeparator || "") + ((u = +a.fractionGroupSize) ? d.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (a.fractionGroupSeparator || "")) : d) : c;
        }
        return (a.prefix || "") + s + (a.suffix || "");
    }, p.toFraction = function(e) {
        var t, s, r, n, i, o, u, l, c, d, p, m, f = this, v = f.c;
        if (null != e && (!(u = new C(e)).isInteger() && (u.c || 1 !== u.s) || u.lt(y))) throw Error($07e064cd5d4580c1$var$_ + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + B(u));
        if (!v) return new C(f);
        for(t = new C(y), c = s = new C(y), r = l = new C(y), m = $07e064cd5d4580c1$var$z(v), i = t.e = m.length - f.e - 1, t.c[0] = $07e064cd5d4580c1$var$j[(o = i % $07e064cd5d4580c1$var$G) < 0 ? $07e064cd5d4580c1$var$G + o : o], e = !e || u.comparedTo(t) > 0 ? i > 0 ? t : c : u, o = b, b = 1 / 0, u = new C(m), l.c[0] = 0; d = a(u, t, 0, 1), 1 != (n = s.plus(d.times(r))).comparedTo(e);)s = r, r = n, c = l.plus(d.times(n = c)), l = n, t = u.minus(d.times(n = t)), u = n;
        return n = a(e.minus(s), r, 0, 1), l = l.plus(n.times(c)), s = s.plus(n.times(r)), l.s = c.s = f.s, p = a(c, r, i *= 2, h).minus(f).abs().comparedTo(a(l, s, i, h).minus(f).abs()) < 1 ? [
            c,
            r
        ] : [
            l,
            s
        ], b = o, p;
    }, p.toNumber = function() {
        return +B(this);
    }, p.toPrecision = function(e, t) {
        return null != e && $07e064cd5d4580c1$var$K(e, 1, $07e064cd5d4580c1$var$Q), M(this, e, t, 2);
    }, p.toString = function(e) {
        var t, a = this, r = a.s, n = a.e;
        return null === n ? r ? (t = "Infinity", r < 0 && (t = "-" + t)) : t = "NaN" : (null == e ? t = n <= f || n >= v ? $07e064cd5d4580c1$var$Y($07e064cd5d4580c1$var$z(a.c), n) : $07e064cd5d4580c1$var$J($07e064cd5d4580c1$var$z(a.c), n, "0") : 10 === e && S ? t = $07e064cd5d4580c1$var$J($07e064cd5d4580c1$var$z((a = x(new C(a), m + n + 1, h)).c), a.e, "0") : ($07e064cd5d4580c1$var$K(e, 2, E.length, "Base"), t = s($07e064cd5d4580c1$var$J($07e064cd5d4580c1$var$z(a.c), n, "0"), 10, e, r, !0)), r < 0 && a.c[0] && (t = "-" + t)), t;
    }, p.valueOf = p.toJSON = function() {
        return B(this);
    }, p._isBigNumber = !0, p[Symbol.toStringTag] = "BigNumber", p[Symbol.for("nodejs.util.inspect.custom")] = p.valueOf, null != t && C.set(t), C;
}();
class $07e064cd5d4580c1$export$714d099a508ef2ab {
    #e;
    constructor(e){
        this.#e = this.toBigDecimal(e);
    }
    toBigDecimal(e) {
        if (e instanceof $07e064cd5d4580c1$export$714d099a508ef2ab) return new $07e064cd5d4580c1$var$Z(e.toString());
        if ("string" == typeof e) return new $07e064cd5d4580c1$var$Z(e);
        if ("number" == typeof e && !isNaN(e)) return new $07e064cd5d4580c1$var$Z(String(e));
        if ("bigint" == typeof e) return new $07e064cd5d4580c1$var$Z(e.toString());
        throw new Error(`toBigDecimal did not recognize the value: ${e} ${typeof e}`);
    }
    divide(e) {
        const t = this.toBigDecimal(e);
        return this.#e = this.#e.dividedBy(t), this;
    }
    multiply(e) {
        const t = this.toBigDecimal(e);
        return this.#e = this.#e.multipliedBy(t), this;
    }
    minus(e) {
        const t = this.toBigDecimal(e);
        return this.#e = this.#e.minus(t), this;
    }
    plus(e) {
        const t = this.toBigDecimal(e);
        return this.#e = this.#e.plus(t), this;
    }
    decimals(e) {
        return this.#e = this.#e.decimalPlaces(e, 1), this;
    }
    toString() {
        return String(this.#e);
    }
}
const $07e064cd5d4580c1$var$te = (e)=>{
    const t = "string" == typeof e ? e : e.url, a = "string" == typeof e ? {} : e.headers, s = new (0, $3PTkx.FetchRequest)(t);
    return Object.keys(a).forEach((e)=>{
        s.setHeader(e, a[e]);
    }), s.setThrottleParams({
        slotInterval: 2e3,
        maxAttempts: 2
    }), s.processFunc = async (e, t)=>429 === t.statusCode ? new (0, $3PTkx.FetchResponse)(500, "", t.headers, null) : t, s.retryFunc = async (e, t)=>429 !== t.statusCode, s;
}, $07e064cd5d4580c1$export$500fbc0cd14cdbaa = (e)=>{
    const { network: t } = e, r = $07e064cd5d4580c1$var$P(e), n = "string" == typeof r ? [
        r
    ] : r;
    if (1 === n.length) {
        const e = $07e064cd5d4580c1$var$te(n[0]);
        return new (0, $b3To1.JsonRpcProvider)(e, t);
    }
    {
        const e = n.map((e, s)=>{
            const r = $07e064cd5d4580c1$var$te(e);
            return {
                provider: new (0, $b3To1.JsonRpcProvider)(r, t),
                priority: s + 1,
                weight: 1
            };
        }), r = new (0, $gWuvh.FallbackProvider)(e, t);
        return r.getSigner = ()=>{
            throw new Error("Pass your provider to the SDK class instance to get a signer");
        }, r.send = ()=>{
            throw new Error("Pass your provider to the SDK class instance to use send method");
        }, r;
    }
}, $07e064cd5d4580c1$var$se = (e)=>{
    const t = e.network;
    return {
        isEthereum: t === $07e064cd5d4580c1$export$95be4ae94445245a.Holesky || t === $07e064cd5d4580c1$export$95be4ae94445245a.Mainnet,
        isGnosis: t === $07e064cd5d4580c1$export$95be4ae94445245a.Gnosis || t === $07e064cd5d4580c1$export$95be4ae94445245a.Chiado
    };
}, $07e064cd5d4580c1$var$re = async (e)=>{
    const { ltvPercent: t, vaultAddress: a, contracts: s } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: a
    }), $07e064cd5d4580c1$var$b({
        ltvPercent: t
    });
    const r = s.helpers.createVault(a);
    return 1n === await r.version() ? t : t / 100000000000000n;
};
var $07e064cd5d4580c1$var$ne = [
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "positions",
        outputs: [
            {
                internalType: "uint96",
                name: "nonce",
                type: "uint96"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "token0",
                type: "address"
            },
            {
                internalType: "address",
                name: "token1",
                type: "address"
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24"
            },
            {
                internalType: "int24",
                name: "tickLower",
                type: "int24"
            },
            {
                internalType: "int24",
                name: "tickUpper",
                type: "int24"
            },
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "feeGrowthInside0LastX128",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "feeGrowthInside1LastX128",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "tokensOwed0",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "tokensOwed1",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "tokenId",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address"
                    },
                    {
                        internalType: "uint128",
                        name: "amount0Max",
                        type: "uint128"
                    },
                    {
                        internalType: "uint128",
                        name: "amount1Max",
                        type: "uint128"
                    }
                ],
                internalType: "struct INonfungiblePositionManager.CollectParams",
                name: "params",
                type: "tuple"
            }
        ],
        name: "collect",
        outputs: [
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    }
], $07e064cd5d4580c1$var$ie = [
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        name: "createRewardSplitter",
        outputs: [
            {
                internalType: "address",
                name: "rewardSplitter",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
], $07e064cd5d4580c1$var$oe = [
    {
        anonymous: !1,
        inputs: [
            {
                indexed: !0,
                internalType: "address",
                name: "admin",
                type: "address"
            },
            {
                indexed: !0,
                internalType: "address",
                name: "token",
                type: "address"
            },
            {
                indexed: !0,
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                indexed: !1,
                internalType: "address",
                name: "beneficiary",
                type: "address"
            },
            {
                indexed: !1,
                internalType: "address",
                name: "escrow",
                type: "address"
            },
            {
                indexed: !1,
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256"
            },
            {
                indexed: !1,
                internalType: "uint256",
                name: "startTime",
                type: "uint256"
            },
            {
                indexed: !1,
                internalType: "uint256",
                name: "endTime",
                type: "uint256"
            },
            {
                indexed: !1,
                internalType: "uint256",
                name: "cliffLength",
                type: "uint256"
            }
        ],
        name: "VestingEscrowCreated",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "total",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$ue = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "avgRewardPerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "feePercent",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$le = [
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        name: "getDepositDataManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            },
            {
                internalType: "address",
                name: "depositDataManager",
                type: "address"
            }
        ],
        name: "setDepositDataManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "depositDataRoot",
                type: "bytes32"
            }
        ],
        name: "setDepositDataRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
], $07e064cd5d4580c1$var$ce = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]"
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]"
            }
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$de = [
    {
        inputs: [],
        name: "ltvPercent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "liqThresholdPercent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$pe = [
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        name: "getConfig",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint128",
                        name: "liqBonusPercent",
                        type: "uint128"
                    },
                    {
                        internalType: "uint64",
                        name: "liqThresholdPercent",
                        type: "uint64"
                    },
                    {
                        internalType: "uint64",
                        name: "ltvPercent",
                        type: "uint64"
                    }
                ],
                internalType: "struct IOsTokenConfig.Config",
                name: "config",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$ye = [
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "osTokenPositions",
        outputs: [
            {
                internalType: "uint128",
                name: "shares",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "osTokenShares",
                type: "uint128"
            }
        ],
        name: "burnOsToken",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "osTokenShares",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "referrer",
                type: "address"
            }
        ],
        name: "mintOsToken",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            }
        ],
        name: "getExitQueueIndex",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitQueueIndex",
                type: "uint256"
            }
        ],
        name: "calculateExitedAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "leftTickets",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitedTickets",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitQueueIndex",
                type: "uint256"
            }
        ],
        name: "claimExitedAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "newPositionTicket",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "claimedShares",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "claimedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "address",
                name: "referrer",
                type: "address"
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "rewardsRoot",
                        type: "bytes32"
                    },
                    {
                        internalType: "int160",
                        name: "reward",
                        type: "int160"
                    },
                    {
                        internalType: "uint160",
                        name: "unlockedMevReward",
                        type: "uint160"
                    },
                    {
                        internalType: "bytes32[]",
                        name: "proof",
                        type: "bytes32[]"
                    }
                ],
                internalType: "struct IKeeperRewards.HarvestParams",
                name: "harvestParams",
                type: "tuple"
            }
        ],
        name: "updateStateAndDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "address",
                name: "referrer",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "enterExitQueue",
        outputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_validatorsRoot",
                type: "bytes32"
            }
        ],
        name: "setValidatorsRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]"
            }
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "rewardsRoot",
                        type: "bytes32"
                    },
                    {
                        internalType: "int160",
                        name: "reward",
                        type: "int160"
                    },
                    {
                        internalType: "uint160",
                        name: "unlockedMevReward",
                        type: "uint160"
                    },
                    {
                        internalType: "bytes32[]",
                        name: "proof",
                        type: "bytes32[]"
                    }
                ],
                internalType: "struct IKeeperRewards.HarvestParams",
                name: "harvestParams",
                type: "tuple"
            }
        ],
        name: "updateState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "metadataIpfsHash",
                type: "string"
            }
        ],
        name: "setMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_feeRecipient",
                type: "address"
            }
        ],
        name: "setFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_keysManager",
                type: "address"
            }
        ],
        name: "setKeysManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    }
], $07e064cd5d4580c1$var$me = [
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        name: "vaults",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$he = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "rewardsRoot",
                        type: "bytes32"
                    },
                    {
                        internalType: "int160",
                        name: "reward",
                        type: "int160"
                    },
                    {
                        internalType: "uint160",
                        name: "unlockedMevReward",
                        type: "uint160"
                    },
                    {
                        internalType: "bytes32[]",
                        name: "proof",
                        type: "bytes32[]"
                    }
                ],
                internalType: "struct IKeeperRewards.HarvestParams",
                name: "harvestParams",
                type: "tuple"
            }
        ],
        name: "updateVaultState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "syncRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "rewards",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "enterExitQueue",
        outputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "rewardsOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]"
            }
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128"
            }
        ],
        name: "decreaseShares",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128"
            }
        ],
        name: "increaseShares",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
], $07e064cd5d4580c1$var$fe = [
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "principal",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "reward",
                type: "uint256"
            }
        ],
        name: "migrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
], $07e064cd5d4580c1$var$ve = [
    {
        inputs: [],
        name: "eigenPod",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]"
            }
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "expiry",
                        type: "uint256"
                    }
                ],
                internalType: "struct IEigenDelegationManager.SignatureWithExpiry",
                name: "approverSignatureAndExpiry",
                type: "tuple"
            },
            {
                internalType: "bytes32",
                name: "approverSalt",
                type: "bytes32"
            }
        ],
        name: "delegateTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "undelegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
], $07e064cd5d4580c1$var$we = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "claimedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "endTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "startTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "vestedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$be = [
    {
        inputs: [
            {
                internalType: "bytes",
                name: "params",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isOwnMevEscrow",
                type: "bool"
            }
        ],
        name: "createVault",
        outputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        stateMutability: "payable",
        type: "function"
    }
], $07e064cd5d4580c1$var$ge = [
    {
        inputs: [],
        name: "latestAnswer",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$Ae = [
    {
        inputs: [],
        name: "liquidity",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "slot0",
        outputs: [
            {
                internalType: "uint160",
                name: "sqrtPriceX96",
                type: "uint160"
            },
            {
                internalType: "int24",
                name: "tick",
                type: "int24"
            },
            {
                internalType: "uint16",
                name: "observationIndex",
                type: "uint16"
            },
            {
                internalType: "uint16",
                name: "observationCardinality",
                type: "uint16"
            },
            {
                internalType: "uint16",
                name: "observationCardinalityNext",
                type: "uint16"
            },
            {
                internalType: "uint8",
                name: "feeProtocol",
                type: "uint8"
            },
            {
                internalType: "bool",
                name: "unlocked",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$Te = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate",
        outputs: [
            {
                name: "blockNumber",
                type: "uint256"
            },
            {
                name: "returnData",
                type: "bytes[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        constant: !0,
        inputs: [
            {
                name: "addr",
                type: "address"
            }
        ],
        name: "getEthBalance",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: !1,
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$ke = [
    {
        inputs: [],
        name: "latestRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "roundId",
                type: "uint80"
            },
            {
                internalType: "int256",
                name: "answer",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "startedAt",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256"
            },
            {
                internalType: "uint80",
                name: "answeredInRound",
                type: "uint80"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$Ee = [
    {
        inputs: [],
        name: "isMerkleRootVoting",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$Se = [
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        name: "isCollateralized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "vault",
                type: "address"
            }
        ],
        name: "canHarvest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
], $07e064cd5d4580c1$var$Ce = [
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        anonymous: !1,
        inputs: [
            {
                indexed: !0,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: !0,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: !1,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $07e064cd5d4580c1$var$Me = [
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "osTokenPositions",
        outputs: [
            {
                internalType: "uint128",
                name: "shares",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "osTokenShares",
                type: "uint128"
            }
        ],
        name: "burnOsToken",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "osTokenShares",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "referrer",
                type: "address"
            }
        ],
        name: "mintOsToken",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            }
        ],
        name: "getExitQueueIndex",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitQueueIndex",
                type: "uint256"
            }
        ],
        name: "calculateExitedAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "leftTickets",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitedTickets",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "exitQueueIndex",
                type: "uint256"
            }
        ],
        name: "claimExitedAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "newPositionTicket",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "claimedShares",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "claimedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "address",
                name: "referrer",
                type: "address"
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "rewardsRoot",
                        type: "bytes32"
                    },
                    {
                        internalType: "int160",
                        name: "reward",
                        type: "int160"
                    },
                    {
                        internalType: "uint160",
                        name: "unlockedMevReward",
                        type: "uint160"
                    },
                    {
                        internalType: "bytes32[]",
                        name: "proof",
                        type: "bytes32[]"
                    }
                ],
                internalType: "struct IKeeperRewards.HarvestParams",
                name: "harvestParams",
                type: "tuple"
            }
        ],
        name: "updateStateAndDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "address",
                name: "referrer",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "enterExitQueue",
        outputs: [
            {
                internalType: "uint256",
                name: "positionTicket",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_validatorsRoot",
                type: "bytes32"
            }
        ],
        name: "setValidatorsRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]"
            }
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "rewardsRoot",
                        type: "bytes32"
                    },
                    {
                        internalType: "int160",
                        name: "reward",
                        type: "int160"
                    },
                    {
                        internalType: "uint160",
                        name: "unlockedMevReward",
                        type: "uint160"
                    },
                    {
                        internalType: "bytes32[]",
                        name: "proof",
                        type: "bytes32[]"
                    }
                ],
                internalType: "struct IKeeperRewards.HarvestParams",
                name: "harvestParams",
                type: "tuple"
            }
        ],
        name: "updateState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "metadataIpfsHash",
                type: "string"
            }
        ],
        name: "setMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_feeRecipient",
                type: "address"
            }
        ],
        name: "setFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "keysManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_keysManager",
                type: "address"
            }
        ],
        name: "setKeysManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "vaultId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_validatorsManager",
                type: "address"
            }
        ],
        name: "setValidatorsManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
].concat([
    {
        inputs: [],
        name: "swapXdaiToGno",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]), $07e064cd5d4580c1$var$Re = $07e064cd5d4580c1$var$Me.concat([
    {
        inputs: [],
        name: "whitelister",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_whitelister",
                type: "address"
            }
        ],
        name: "setWhitelister",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "updateWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]), $07e064cd5d4580c1$var$De = $07e064cd5d4580c1$var$Me.concat([
    {
        inputs: [],
        name: "blocklistManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_blocklistManager",
                type: "address"
            }
        ],
        name: "setBlocklistManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "updateBlocklist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]), $07e064cd5d4580c1$var$xe = $07e064cd5d4580c1$var$Me.concat([
    {
        inputs: [
            {
                internalType: "address",
                name: "newRestakeOperatorsManager",
                type: "address"
            }
        ],
        name: "setRestakeOperatorsManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newRestakeWithdrawalsManager",
                type: "address"
            }
        ],
        name: "setRestakeWithdrawalsManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "restakeOperatorsManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "createEigenPod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]), $07e064cd5d4580c1$var$Be = (e)=>(t)=>{
        let a = 0;
        const { calls: s, items: r } = t.reduce((e, t)=>{
            if (void 0 === t.mock && t.contract) {
                const { contract: s, methodName: r, args: n } = t;
                e.calls.push({
                    target: String(s.target),
                    callData: s.interface.encodeFunctionData(r, n)
                }), e.items.push({
                    ...t,
                    realIndex: a++
                });
            } else e.items.push(t);
            return e;
        }, {
            calls: [],
            items: []
        });
        return ()=>e.aggregate(s).then((e)=>r.reduce((t, a)=>{
                    const { contract: s, methodName: r, mock: n, noContractValue: i, returnName: o, realIndex: u } = a;
                    if (t[o]) throw new Error('Need to use unique "returnName" with "multicall" handler!');
                    if (void 0 !== n) t[o] = n;
                    else if (s) {
                        const a = e.returnData[u], n = s.interface.decodeFunctionResult(r, a);
                        t[o] = 1 === n.length ? n[0] : n;
                    } else t[o] = i;
                    return t;
                }, {}));
    }, $07e064cd5d4580c1$export$7c4d5b09373bb58d = (e, t, a)=>new (0, $1dRRv.Contract)(e, t, a), $07e064cd5d4580c1$var$Oe = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.tokens.swise, $07e064cd5d4580c1$var$Ce, e), $07e064cd5d4580c1$var$Ie = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t, $07e064cd5d4580c1$var$be, e), $07e064cd5d4580c1$var$Ne = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.vaultsRegistry, $07e064cd5d4580c1$var$me, e), $07e064cd5d4580c1$var$Fe = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.rewardSplitterFactory, $07e064cd5d4580c1$var$ie, e), $07e064cd5d4580c1$var$qe = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.keeper, $07e064cd5d4580c1$var$Se, e), $07e064cd5d4580c1$var$_e = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.tokens.mintToken, $07e064cd5d4580c1$var$Ce, e), $07e064cd5d4580c1$var$Ve = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.mintTokenConfigV1, $07e064cd5d4580c1$var$de, e), $07e064cd5d4580c1$var$$e = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.mintTokenConfigV2, $07e064cd5d4580c1$var$pe, e), $07e064cd5d4580c1$var$Ge = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.mintTokenController, $07e064cd5d4580c1$var$ue, e), $07e064cd5d4580c1$var$Le = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.priceOracle, $07e064cd5d4580c1$var$ge, e), $07e064cd5d4580c1$var$je = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.tokens.v2RewardToken, $07e064cd5d4580c1$var$fe, e), $07e064cd5d4580c1$var$He = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.uniswap.positionManager, $07e064cd5d4580c1$var$ne, e), $07e064cd5d4580c1$var$Qe = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.depositDataRegistry, $07e064cd5d4580c1$var$le, e), $07e064cd5d4580c1$var$Ue = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.merkleDistributor, $07e064cd5d4580c1$var$ce, e), $07e064cd5d4580c1$var$ze = (e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.oracles, $07e064cd5d4580c1$var$Ee, e), $07e064cd5d4580c1$var$We = (e)=>{
    const { provider: t, config: a } = e, s = ((e, t)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(t.addresses.base.multicall, $07e064cd5d4580c1$var$Te, e))(t, a);
    return {
        helpers: {
            multicallContract: s,
            createMulticall: $07e064cd5d4580c1$var$Be(s),
            createVault: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$Me, t),
            createErc20: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$Ce, t),
            createUniswapPool: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$Ae, t),
            createPrivateVault: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$Re, t),
            createEigenPodOwner: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$ve, t),
            createRestakingVault: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$xe, t),
            createBlocklistedVault: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$De, t),
            createRewardSplitter: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$he, t),
            createOtherTokenVault: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$ye, t),
            createVestingEscrowDirect: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$we, t),
            createUsdRate: (e, a)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$ke, a || t),
            createVestingEscrowFactory: (e)=>$07e064cd5d4580c1$export$7c4d5b09373bb58d(e, $07e064cd5d4580c1$var$oe, t)
        },
        base: {
            keeper: $07e064cd5d4580c1$var$qe(t, a),
            oracles: $07e064cd5d4580c1$var$ze(t, a),
            priceOracle: $07e064cd5d4580c1$var$Le(t, a),
            vaultsRegistry: $07e064cd5d4580c1$var$Ne(t, a),
            mintTokenConfig: {
                v1: $07e064cd5d4580c1$var$Ve(t, a),
                v2: $07e064cd5d4580c1$var$$e(t, a)
            },
            merkleDistributor: $07e064cd5d4580c1$var$Ue(t, a),
            depositDataRegistry: $07e064cd5d4580c1$var$Qe(t, a),
            mintTokenController: $07e064cd5d4580c1$var$Ge(t, a),
            rewardSplitterFactory: $07e064cd5d4580c1$var$Fe(t, a)
        },
        tokens: {
            mintToken: $07e064cd5d4580c1$var$_e(t, a),
            swiseToken: $07e064cd5d4580c1$var$Oe(t, a),
            V2RewardToken: $07e064cd5d4580c1$var$je(t, a)
        },
        factories: {
            vault: $07e064cd5d4580c1$var$Ie(t, a.addresses.factories.vault),
            erc20Vault: $07e064cd5d4580c1$var$Ie(t, a.addresses.factories.erc20Vault),
            privateVault: $07e064cd5d4580c1$var$Ie(t, a.addresses.factories.privateVault),
            erc20PrivateVault: $07e064cd5d4580c1$var$Ie(t, a.addresses.factories.erc20PrivateVault),
            blocklistVault: $07e064cd5d4580c1$var$Ie(t, a.addresses.factories.blocklistVault),
            erc20BlocklistVault: $07e064cd5d4580c1$var$Ie(t, a.addresses.factories.erc20BlocklistVault)
        },
        uniswap: {
            positionManager: $07e064cd5d4580c1$var$He(t, a)
        }
    };
};
new Promise(()=>{});
class $07e064cd5d4580c1$var$Ke {
    isAborted;
    callback;
    onAbort;
    constructor(e, t){
        this.isAborted = !1, this.callback = e, this.onAbort = t;
    }
    then(e, t) {
        if (this.isAborted) {
            const e = new Promise(()=>{});
            return new $07e064cd5d4580c1$var$Ke(e, this.onAbort);
        }
        return new $07e064cd5d4580c1$var$Ke(this.callback.then(e, t), this.onAbort);
    }
    catch(e) {
        return new $07e064cd5d4580c1$var$Ke(this.callback.catch(e), this.onAbort);
    }
    finally(e) {
        return new $07e064cd5d4580c1$var$Ke(this.callback.finally(e), this.onAbort);
    }
    abort() {
        this.isAborted = !0, this.onAbort();
    }
}
const $07e064cd5d4580c1$var$Xe = new Promise(()=>{});
class $07e064cd5d4580c1$var$Ye {
    promise;
    isAborted;
    onAbort;
    constructor(e, t){
        this.isAborted = !1, this.onAbort = t, this.promise = new Promise(e).then((e)=>{
            try {
                return this.isAborted ? $07e064cd5d4580c1$var$Xe : e;
            } catch (e) {
                return Promise.reject(e);
            }
        });
    }
    then(e, t) {
        return new $07e064cd5d4580c1$var$Ke(this.promise.then(e, t), this.abort.bind(this));
    }
    catch(e) {
        return new $07e064cd5d4580c1$var$Ke(this.promise.catch(e), this.abort.bind(this));
    }
    finally(e) {
        return new $07e064cd5d4580c1$var$Ke(this.promise.finally(e), this.abort.bind(this));
    }
    static all(e) {
        let t = !1;
        const a = Promise.all(e).then((e)=>t ? $07e064cd5d4580c1$var$Xe : e);
        return new $07e064cd5d4580c1$var$Ke(a, ()=>{
            t = !1, e.forEach((e)=>{
                "function" == typeof e.abort && e.abort();
            });
        });
    }
    static race(e) {
        let t = !1;
        const a = Promise.race(e).then((e)=>t ? $07e064cd5d4580c1$var$Xe : e);
        return new $07e064cd5d4580c1$var$Ke(a, ()=>{
            t = !1, e.forEach((e)=>{
                "function" == typeof e.abort && e.abort();
            });
        });
    }
    abort() {
        this.isAborted = !0, "function" == typeof this.onAbort && this.onAbort();
    }
}
const $07e064cd5d4580c1$var$Je = {};
class $07e064cd5d4580c1$var$Ze {
    controller = new AbortController;
    request;
    promise;
    body;
    isAborted;
    requestId;
    constructor(e, t){
        const { onSuccess: a, onError: s, ...r } = t;
        this.body = r.body, this.isAborted = !1, this.requestId = `${e}_${this.body}`;
        const n = $07e064cd5d4580c1$var$Je[this.requestId];
        n ? (n.count += 1, this.request = n.promise) : (this.request = fetch(e, {
            ...r,
            signal: this.controller.signal
        }).then((e)=>e.ok ? e.json() : e.json().then((e)=>Promise.reject(e))).then((e)=>{
            if ($07e064cd5d4580c1$var$Je[this.requestId] = void 0, e?.errors) throw new Error(e.errors[0].message);
            if (e?.data?._meta?.hasIndexingErrors) throw new Error("Subgraph indexing error");
            return e?.data;
        }).catch((e)=>($07e064cd5d4580c1$var$Je[this.requestId] = void 0, "function" == typeof s && s(e), Promise.reject(e))), $07e064cd5d4580c1$var$Je[this.requestId] = {
            promise: this.request,
            count: 1
        }), this.promise = new $07e064cd5d4580c1$var$Ye(async (e, t)=>{
            try {
                const t = await this.request;
                return e("function" == typeof a ? a(t) : t);
            } catch (a) {
                return "function" == typeof s ? e(s(a)) : t(a);
            }
        }, this.abort.bind(this));
    }
    then(e, t) {
        return this.promise.then(e, t);
    }
    catch(e) {
        return this.promise.catch(e);
    }
    finally(e) {
        return this.promise.finally(e);
    }
    abort() {
        this.isAborted = !0;
        ($07e064cd5d4580c1$var$Je[this.requestId]?.count || 0) > 1 ? $07e064cd5d4580c1$var$Je[this.requestId].count -= 1 : ($07e064cd5d4580c1$var$Je[this.requestId] = void 0, this.controller.abort());
    }
}
class $07e064cd5d4580c1$var$et {
    storage = new Map;
    get length() {
        return this.storage.size;
    }
    key(e) {
        return Array.from(this.storage.keys())[e] || null;
    }
    getItem(e) {
        return this.storage.has(e) ? this.storage.get(e) : null;
    }
    setItem(e, t) {
        this.storage.set(e, t);
    }
    removeItem(e) {
        this.storage.delete(e);
    }
    clear() {
        this.storage.clear();
    }
}
const $07e064cd5d4580c1$var$tt = [
    "NS_ERROR_FAILURE",
    "NS_ERROR_FILE_CORRUPTED",
    "NS_ERROR_FILE_NO_DEVICE_SPACE"
];
class $07e064cd5d4580c1$var$at {
    memoryLocalStorage;
    memorySessionStorage;
    constructor(){
        $07e064cd5d4580c1$var$at.isSupported(()=>localStorage) || (this.memoryLocalStorage = new $07e064cd5d4580c1$var$et), $07e064cd5d4580c1$var$at.isSupported(()=>sessionStorage) || (this.memorySessionStorage = new $07e064cd5d4580c1$var$et);
    }
    static isSupported(e) {
        try {
            const t = "__some_random_key_you_are_not_going_to_use__";
            return e().setItem(t, t), e().removeItem(t), !0;
        } catch (e) {
            return !1;
        }
    }
    getLocalStorage() {
        return this.memoryLocalStorage || localStorage;
    }
    getSessionStorage() {
        return this.memorySessionStorage || sessionStorage;
    }
    get(e, t) {
        try {
            const a = t.getItem(e);
            return a && JSON.parse(a);
        } catch (a) {
            return $07e064cd5d4580c1$var$tt.includes(a.name) ? (this.clear(t), null) : (this.remove(e, t), null);
        }
    }
    set(e, t, a) {
        try {
            a.setItem(e, JSON.stringify(t));
        } catch (e) {
            $07e064cd5d4580c1$var$tt.includes(e.name) && this.clear(a);
        }
    }
    remove(e, t) {
        try {
            t.removeItem(e);
        } catch (t) {
            console.error(t, e);
        }
    }
    corruptedAlertWasShowed = !1;
    clear(e) {
        try {
            e.clear();
        } catch (e) {
            $07e064cd5d4580c1$var$tt.includes(e.name) && !this.corruptedAlertWasShowed && (alert("Oops, looks like your browser storage got corrupted. Follow the steps at https://support.mozilla.org/en-US/kb/storage to fix it."), this.corruptedAlertWasShowed = !0);
        }
    }
    keys(e) {
        const t = [];
        for(let a = 0; a < e.length; a++)e.key(a) && t.push();
        return t;
    }
    getItem(e) {
        return this.get(e, this.getLocalStorage());
    }
    setItem(e, t) {
        this.set(e, t, this.getLocalStorage());
    }
    removeItem(e) {
        this.remove(e, this.getLocalStorage());
    }
    getKeys() {
        return this.keys(this.getLocalStorage());
    }
    clearAll() {
        const e = this.getLocalStorage();
        this.clear(e);
    }
    getSessionItem(e) {
        return this.get(e, this.getSessionStorage());
    }
    setSessionItem(e, t) {
        this.set(e, t, this.getSessionStorage());
    }
    removeSessionItem(e) {
        this.remove(e, this.getSessionStorage());
    }
    getSessionKeys() {
        return this.keys(this.getSessionStorage());
    }
    clearAllSession() {
        const e = this.getSessionStorage();
        this.clear(e);
    }
}
var $07e064cd5d4580c1$var$st = new $07e064cd5d4580c1$var$at;
const $07e064cd5d4580c1$var$rt = $07e064cd5d4580c1$var$C.sessionStorageNames.moduleErrorUrl, $07e064cd5d4580c1$var$nt = $07e064cd5d4580c1$var$C.sessionStorageNames.moduleErrorUrl, $07e064cd5d4580c1$var$it = (e)=>{
    const { url: t, query: a, variables: s, retryCount: r = 0, modifyResult: n } = e, i = a.replace(/^(query|mutation)\s/, "").replace(/[({].*/, "").trim(), o = ((e)=>{
        if (Array.isArray(e)) {
            const t = e.length;
            if (!t) throw new Error("The array does not contain the url for the query");
            if (1 === t) return e[0];
            const [a, s] = e;
            return $07e064cd5d4580c1$var$st.getSessionItem($07e064cd5d4580c1$var$rt) === a ? s : a;
        }
        return e;
    })(t);
    return new $07e064cd5d4580c1$var$Ze(`${o}${i ? `?opName=${i}` : ""}`, {
        method: "POST",
        headers: {
            "content-type": "application/json; charset=utf-8"
        },
        body: JSON.stringify({
            query: a,
            variables: s,
            operationName: i
        }),
        onSuccess: (e)=>"function" == typeof n ? n(e) : e,
        onError: (a)=>Array.isArray(t) && t.length > 1 && r < 1 ? (((e)=>{
                $07e064cd5d4580c1$var$st.getSessionItem($07e064cd5d4580c1$var$nt) !== e && ($07e064cd5d4580c1$var$st.setSessionItem($07e064cd5d4580c1$var$nt, e), setTimeout(()=>{
                    $07e064cd5d4580c1$var$st.removeSessionItem($07e064cd5d4580c1$var$nt);
                }, 36e5));
            })(t[0]), $07e064cd5d4580c1$var$it({
                ...e,
                url: t[1],
                retryCount: r + 1
            })) : Promise.reject(a)
    });
}, $07e064cd5d4580c1$var$ot = (e)=>(t)=>new $07e064cd5d4580c1$var$Ye(async (a, s)=>{
            try {
                return a(await e(t));
            } catch (e) {
                return s(e);
            }
        });
var $07e064cd5d4580c1$var$ut = Object.freeze({
    __proto__: null,
    fetchSwiseStatsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query SwiseStats { swiseStats { price }}",
            variables: e,
            modifyResult: a
        })
});
var $07e064cd5d4580c1$var$lt = Object.freeze({
    __proto__: null,
    fetchScorePercentilesQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query ScorePercentiles { scorePercentiles { percentile25, percentile50, percentile75 }}",
            variables: e,
            modifyResult: a
        }),
    fetchSnapshotsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query Snapshots($vaultAddress: String! $dateFrom: DateAsTimestamp!) { vaultSnapshots( vaultAddress: $vaultAddress dateFrom: $dateFrom ) { date, weeklyApy totalAssets } firstSnapshots: vaultSnapshots(vaultAddress: $vaultAddress, first: 1) { date totalAssets weeklyApy }}",
            variables: e,
            modifyResult: a
        }),
    fetchUserRewardsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query UserRewards($user: String!, $vaultAddress: String!, $dateFrom: DateAsTimestamp!, $dateTo: DateAsTimestamp, $fillGaps: Boolean = true) { userRewards(user: $user, vaultAddress: $vaultAddress, dateFrom: $dateFrom, dateTo: $dateTo, fillGaps: $fillGaps) { date sumRewards dailyRewards dailyRewardsEur dailyRewardsGbp dailyRewardsUsd }}",
            variables: e,
            modifyResult: a
        }),
    fetchValidatorsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: 'query Validators( $vaultAddress: String! $skip: Int! $first: Int!) { vaultValidators( statusNotIn: [ "withdrawal_done" ], vaultAddress: $vaultAddress, skip: $skip, first: $first, ) { apy: apr earned createdAt publicKey }}',
            variables: e,
            modifyResult: a
        }),
    submitUploadMetadataMutation: ({ variables: e, url: t })=>fetch(t, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                query: "mutation UploadMetadata ( $payload: PayloadType!) { uploadMetadata( payload: $payload ) { ipfsHash }}",
                variables: e
            })
        }).then((e)=>e.json()).then(({ data: e, errors: t })=>t ? Promise.reject(t) : e)
}), $07e064cd5d4580c1$var$ct = Object.freeze({
    __proto__: null,
    swise: $07e064cd5d4580c1$var$ut,
    vault: $07e064cd5d4580c1$var$lt
});
var $07e064cd5d4580c1$var$dt = Object.freeze({
    __proto__: null,
    fetchBlocklistAccountsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query BlocklistAccounts($where: VaultBlockedAccount_filter, $limit: Int, $skip: Int, $orderDirection: OrderDirection) { vaultBlockedAccounts(where: $where, first: $limit, skip: $skip, orderDirection: $orderDirection, orderBy: createdAt) { createdAt address }}",
            variables: e,
            modifyResult: a
        }),
    fetchHarvestParamsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query HarvestParams($address: ID!) { harvestParams: vault(id: $address) { proof rewardsRoot reward: proofReward unlockedMevReward: proofUnlockedMevReward }}",
            variables: e,
            modifyResult: a
        }),
    fetchVaultQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query Vault($address: ID!) { vault(id: $address) { address: id performance: score apy admin version isErc20 imageUrl capacity mevEscrow isPrivate createdAt mevEscrow tokenName feePercent totalAssets isBlocklist displayName description whitelister tokenSymbol keysManager feeRecipient validatorsRoot blocklistCount whitelistCount blocklistManager validatorsManager depositDataManager }}",
            variables: e,
            modifyResult: a
        }),
    fetchWhitelistAccountsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query WhitelistAccounts($where: PrivateVaultAccount_filter, $limit: Int, $skip: Int, $orderDirection: OrderDirection) { privateVaultAccounts(where: $where, first: $limit, skip: $skip, orderDirection: $orderDirection, orderBy: createdAt) { createdAt address }}",
            variables: e,
            modifyResult: a
        })
});
var $07e064cd5d4580c1$var$pt = Object.freeze({
    __proto__: null,
    fetchOsTokenApyQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query osTokenApy($first: Int, $orderBy: OsTokenSnapshot_orderBy, $orderDirection: OrderDirection) { osTokens { apy }}",
            variables: e,
            modifyResult: a
        }),
    fetchOsTokenPositionsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query OsTokenPositions($address: Bytes, $vaultAddress: String) { osTokenPositions(where: { address: $address, vault: $vaultAddress }) { shares }}",
            variables: e,
            modifyResult: a
        }),
    fetchOsTokenRewardPerSecondQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query osTokenRewardPerSecond($first: Int, $orderBy: OsTokenSnapshot_orderBy, $orderDirection: OrderDirection) { osTokenSnapshots(first: $first, orderBy: $orderBy, orderDirection: $orderDirection) { avgRewardPerSecond }}",
            variables: e,
            modifyResult: a
        })
});
var $07e064cd5d4580c1$var$yt = Object.freeze({
    __proto__: null,
    fetchEigenPodsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query EigenPods( $skip: Int! $first: Int! $where: EigenPod_filter) { eigenPods( skip: $skip, first: $first, orderBy: createdAt, orderDirection: desc, where: $where, ) { id shares address operator createdAt }}",
            variables: e,
            modifyResult: a
        })
});
var $07e064cd5d4580c1$var$mt = Object.freeze({
    __proto__: null,
    fetchExitQueueQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query exitQueue($receiver: Bytes, $vault: String!) { exitRequests(where: { receiver: $receiver, vault: $vault, }) { withdrawalTimestamp positionTicket totalShares totalAssets timestamp }}",
            variables: e,
            modifyResult: a
        })
});
var $07e064cd5d4580c1$var$ht = Object.freeze({
    __proto__: null,
    fetchTransactionsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query Transactions( $where: Transaction_filter) { transactions(where: $where) { id }}",
            variables: e,
            modifyResult: a
        })
});
const $07e064cd5d4580c1$var$ft = ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
        url: t,
        query: "query RewardSplitters($where: RewardSplitter_filter) { rewardSplitters(where: $where, orderBy: id, orderDirection: desc, first: 1000) { id owner totalShares shareHolders(orderBy: shares, orderDirection: desc) { id shares address } }}",
        variables: e,
        modifyResult: a
    });
var $07e064cd5d4580c1$var$vt = Object.freeze({
    __proto__: null,
    fetchRewardSplittersQuery: $07e064cd5d4580c1$var$ft
});
var $07e064cd5d4580c1$var$wt = Object.freeze({
    __proto__: null,
    fetchAllocatorActionsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query AllocatorActions( $skip: Int! $first: Int! $where: AllocatorAction_filter) { allocatorActions( skip: $skip, first: $first, orderBy: createdAt, orderDirection: desc, where: $where, ) { id assets shares createdAt actionType }}",
            variables: e,
            modifyResult: a
        }),
    fetchMyAllocatorActionsQuery: ({ variables: e, url: t, modifyResult: a })=>$07e064cd5d4580c1$var$it({
            url: t,
            query: "query MyAllocatorActions( $where: AllocatorAction_filter) { allocatorActions( first: 1, orderBy: createdAt, orderDirection: desc, where: $where, ) { id }}",
            variables: e,
            modifyResult: a
        })
}), $07e064cd5d4580c1$var$bt = {
    backend: $07e064cd5d4580c1$var$ct,
    subgraph: Object.freeze({
        __proto__: null,
        allocatorActions: $07e064cd5d4580c1$var$wt,
        eigenPods: $07e064cd5d4580c1$var$yt,
        exitQueue: $07e064cd5d4580c1$var$mt,
        osToken: $07e064cd5d4580c1$var$pt,
        rewardSplitters: $07e064cd5d4580c1$var$vt,
        transactions: $07e064cd5d4580c1$var$ht,
        vault: $07e064cd5d4580c1$var$dt
    })
};
const $07e064cd5d4580c1$var$gt = (e)=>{
    const { options: t, vaultAddress: a } = e;
    return $07e064cd5d4580c1$var$T({
        vaultAddress: a
    }), $07e064cd5d4580c1$var$bt.subgraph.vault.fetchHarvestParamsQuery({
        url: $07e064cd5d4580c1$var$I(t),
        variables: {
            address: a.toLowerCase()
        },
        modifyResult: (e)=>e.harvestParams
    });
}, $07e064cd5d4580c1$var$At = async (e)=>{
    const { options: t, vaultAddress: a, keeperContract: s } = e, [r, n] = await Promise.all([
        $07e064cd5d4580c1$var$gt({
            options: t,
            vaultAddress: a
        }),
        s.canHarvest(a)
    ]);
    return n ? r : null;
}, $07e064cd5d4580c1$var$Tt = ({ multicallParams: e, contract: t })=>e.map(({ method: e, args: a })=>t.interface.encodeFunctionData(e, a)), $07e064cd5d4580c1$var$kt = async ({ contract: e, multicallParams: t })=>{
    const a = $07e064cd5d4580c1$var$Tt({
        multicallParams: t,
        contract: e
    });
    if (1 === a.length) {
        const { method: a, args: s } = t[0], r = 110n * await e[a].estimateGas(...s) / 100n;
        return e[a](...s, {
            gasLimit: r
        });
    }
    const s = 110n * await e.multicall.estimateGas(a) / 100n;
    return e.multicall(a, {
        gasLimit: s
    });
}, $07e064cd5d4580c1$var$Et = [
    "updateState",
    "swapXdaiToGno"
], $07e064cd5d4580c1$var$St = async ({ contract: e, multicallParams: t, userAddress: a })=>{
    const s = $07e064cd5d4580c1$var$Tt({
        multicallParams: t,
        contract: e
    }), r = await e.multicall.staticCall(s, {
        from: a
    }), n = [], i = r.map((a, s)=>{
        const { method: r } = t[s];
        return $07e064cd5d4580c1$var$Et.includes(r) && n.push(s), e.interface.decodeFunctionResult(r, a);
    });
    return i.filter((e, t)=>!n.includes(t));
}, $07e064cd5d4580c1$var$Ct = async ({ contract: e, multicallParams: t })=>{
    const a = $07e064cd5d4580c1$var$Tt({
        multicallParams: t,
        contract: e
    });
    if (1 === a.length) {
        const { method: a, args: s } = t[0];
        return e[a].estimateGas(...s);
    }
    return e.multicall.estimateGas(a);
}, $07e064cd5d4580c1$var$Mt = async (e)=>{
    const { contract: t, userAddress: a, request: s, options: r } = e, { callStatic: n, transactionData: i } = s;
    if (!n && !i) {
        let e;
        if (r.provider) e = await r.provider.getSigner(a);
        else {
            const t = $07e064cd5d4580c1$export$500fbc0cd14cdbaa(r);
            e = new (0, $1cKTC.VoidSigner)(a, t);
        }
        return t.connect(e);
    }
    return t;
}, $07e064cd5d4580c1$var$Rt = async ({ contract: e, multicallParams: t })=>{
    const a = $07e064cd5d4580c1$var$Tt({
        multicallParams: t,
        contract: e
    });
    return e.multicall.populateTransaction(a);
}, $07e064cd5d4580c1$var$Dt = [
    "deposit",
    "mintOsToken",
    "enterExitQueue",
    "setFeeRecipient",
    "convertToAssets",
    "convertToShares",
    "getExitQueueIndex",
    "claimExitedAssets",
    "calculateExitedAssets"
], $07e064cd5d4580c1$var$xt = async (e)=>{
    const { options: t, vaultAddress: a, userAddress: s, request: r, vaultContract: n, keeperContract: i } = e, { params: o, callStatic: u, estimateGas: l, transactionData: c } = r, d = await $07e064cd5d4580c1$var$Mt({
        contract: n,
        userAddress: s,
        options: t,
        request: r
    });
    let p = [
        ...o
    ];
    if (o.some(({ method: e })=>$07e064cd5d4580c1$var$Dt.includes(e))) {
        const e = await $07e064cd5d4580c1$var$At({
            options: t,
            vaultAddress: a,
            keeperContract: i
        });
        if (e) {
            const a = [
                $07e064cd5d4580c1$export$95be4ae94445245a.Chiado,
                $07e064cd5d4580c1$export$95be4ae94445245a.Gnosis
            ].includes(t.network), s = {
                method: "updateState",
                args: [
                    e
                ]
            }, r = {
                method: "swapXdaiToGno",
                args: []
            }, n = [
                s,
                ...p
            ];
            p = a ? await (async ({ contract: e, multicallParams: t, fallbackParams: a })=>{
                try {
                    return await $07e064cd5d4580c1$var$Ct({
                        contract: e,
                        multicallParams: t
                    }), t;
                } catch  {
                    return a;
                }
            })({
                contract: d,
                multicallParams: [
                    s,
                    r,
                    ...p
                ],
                fallbackParams: n
            }) : n;
        }
    }
    const m = {
        contract: d,
        multicallParams: p
    };
    return u ? $07e064cd5d4580c1$var$St({
        ...m,
        userAddress: s
    }) : l ? $07e064cd5d4580c1$var$Ct(m) : c ? $07e064cd5d4580c1$var$Rt(m) : $07e064cd5d4580c1$var$kt(m);
}, $07e064cd5d4580c1$var$Bt = async (e)=>{
    const { request: t, options: a, userAddress: s, eigenPodOwnerContract: r } = e, { params: n, callStatic: i, estimateGas: o, transactionData: u } = t, l = {
        contract: await $07e064cd5d4580c1$var$Mt({
            contract: r,
            userAddress: s,
            options: a,
            request: t
        }),
        multicallParams: [
            ...n
        ]
    };
    return i ? $07e064cd5d4580c1$var$St({
        ...l,
        userAddress: s
    }) : o ? $07e064cd5d4580c1$var$Ct(l) : u ? $07e064cd5d4580c1$var$Rt(l) : $07e064cd5d4580c1$var$kt(l);
}, $07e064cd5d4580c1$var$Pt = async (e)=>{
    const { request: t, options: a, userAddress: s, vaultAddress: r, keeperContract: n, rewardSplitterContract: i } = e, { params: o, callStatic: u, estimateGas: l, transactionData: c } = t;
    let d = [
        ...o
    ];
    const p = await $07e064cd5d4580c1$var$Mt({
        contract: i,
        userAddress: s,
        options: a,
        request: t
    }), y = await $07e064cd5d4580c1$var$At({
        options: a,
        vaultAddress: r,
        keeperContract: n
    });
    y && (d = [
        {
            method: "updateVaultState",
            args: [
                y
            ]
        },
        ...d
    ]);
    const m = {
        contract: p,
        multicallParams: d
    };
    return u ? $07e064cd5d4580c1$var$St({
        ...m,
        userAddress: s
    }) : l ? $07e064cd5d4580c1$var$Ct(m) : c ? $07e064cd5d4580c1$var$Rt(m) : $07e064cd5d4580c1$var$kt(m);
};
var $07e064cd5d4580c1$var$Ot = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, options: a, vaultAddress: s } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: s
    });
    const [r, n] = await Promise.all([
        $07e064cd5d4580c1$var$bt.subgraph.vault.fetchVaultQuery({
            url: $07e064cd5d4580c1$var$I(a),
            variables: {
                address: s.toLowerCase()
            },
            modifyResult: (e)=>((e)=>{
                    const { data: t, network: a } = e, { vault: s } = t || {};
                    if (!s) throw new Error("Vault not found");
                    const { apy: r, admin: n, address: i, version: o, mevEscrow: d, createdAt: p, feePercent: y, keysManager: m, performance: h, totalAssets: f, feeRecipient: v, blocklistCount: w, whitelistCount: b, validatorsManager: g, depositDataManager: A, ...T } = s, k = Number(o) > 1 ? A : m;
                    return {
                        ...T,
                        apy: Number(r),
                        version: Number(o),
                        isSmoothingPool: !d,
                        feePercent: y / 100,
                        vaultAdmin: (0, $95T0n.getAddress)(n),
                        performance: Number(h),
                        vaultAddress: (0, $95T0n.getAddress)(i),
                        createdAt: 1e3 * Number(p),
                        totalAssets: (0, $jxZic.formatEther)(f),
                        feeRecipient: (0, $95T0n.getAddress)(v),
                        blocklistCount: Number(w),
                        whitelistCount: Number(b),
                        keysManager: m ? (0, $95T0n.getAddress)(m) : "",
                        whitelister: s.whitelister ? (0, $95T0n.getAddress)(s.whitelister) : "",
                        whitelistManager: s.whitelister ? (0, $95T0n.getAddress)(s.whitelister) : "",
                        validatorsManager: g ? (0, $95T0n.getAddress)(g) : "",
                        depositDataManager: k ? (0, $95T0n.getAddress)(k) : "",
                        blocklistManager: s.blocklistManager ? (0, $95T0n.getAddress)(s.blocklistManager) : "",
                        mevRecipient: d ? (0, $95T0n.getAddress)(d) : $07e064cd5d4580c1$export$c884d9dcb329c3c[a].addresses.base.sharedMevEscrow,
                        capacity: s.capacity !== (0, $1H5oH.MaxUint256).toString() ? (0, $jxZic.formatEther)(s.capacity) : "\u221E"
                    };
                })({
                    data: e,
                    network: a.network
                })
        }),
        t.base.keeper.isCollateralized(s)
    ]);
    return {
        ...r,
        isCollateralized: n
    };
});
const $07e064cd5d4580c1$var$It = {
    [$07e064cd5d4580c1$export$95be4ae94445245a.Mainnet]: "https://app.eigenlayer.xyz/operator",
    [$07e064cd5d4580c1$export$95be4ae94445245a.Holesky]: "https://holesky.eigenlayer.xyz/operator"
}, $07e064cd5d4580c1$var$Nt = (e)=>{
    const t = Number(e.weeklyApy) || 0, a = e.totalAssets || "0";
    return {
        APY: t,
        TVL: Number((0, $jxZic.formatEther)(a))
    };
}, $07e064cd5d4580c1$var$Ft = (e)=>({
        days: e.vaultSnapshots.reduce((e, { date: t, ...a })=>(e[Number(t)] = $07e064cd5d4580c1$var$Nt(a), e), {}),
        first: e.firstSnapshots[0] ? $07e064cd5d4580c1$var$Nt(e.firstSnapshots[0]) : null
    }), $07e064cd5d4580c1$var$qt = ({ createdAt: e, address: t })=>({
        createdAt: 1e3 * Number(e),
        address: (0, $95T0n.getAddress)(t)
    }), $07e064cd5d4580c1$var$_t = ({ createdAt: e, address: t })=>({
        createdAt: 1e3 * Number(e),
        address: (0, $95T0n.getAddress)(t)
    }), $07e064cd5d4580c1$var$Vt = (e)=>e.userRewards.reduce((e, { date: t, ...a })=>(e[Number(t)] = ((e)=>{
            const t = String(e.sumRewards) || "0", a = String(e.dailyRewards) || "0";
            return {
                date: Number(e.date),
                sumRewards: Number((0, $jxZic.formatEther)(t)),
                dailyRewards: Number((0, $jxZic.formatEther)(a)),
                dailyRewardsEur: Number(e.dailyRewardsEur) || 0,
                dailyRewardsGbp: Number(e.dailyRewardsGbp) || 0,
                dailyRewardsUsd: Number(e.dailyRewardsUsd) || 0
            };
        })({
            date: t,
            ...a
        }), e), {}) || {}, $07e064cd5d4580c1$var$$t = (0, $jxZic.parseEther)("0.00001");
var $07e064cd5d4580c1$var$Gt = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, mintedAssets: a, stakedAssets: s, ltvPercent: r, vaultAddress: n } = e;
    if ($07e064cd5d4580c1$var$T({
        vaultAddress: n
    }), $07e064cd5d4580c1$var$b({
        mintedAssets: a,
        stakedAssets: s,
        ltvPercent: r
    }), !a) return s;
    if (r <= 0 || s < $07e064cd5d4580c1$var$$t) return 0n;
    const [i, o] = await Promise.all([
        t.base.mintTokenController.avgRewardPerSecond(),
        $07e064cd5d4580c1$var$re({
            vaultAddress: n,
            ltvPercent: r,
            contracts: t
        })
    ]), u = s - 10000n * (a + 3600n * i * a / $07e064cd5d4580c1$var$C.blockchain.amount1) / o;
    return u > $07e064cd5d4580c1$var$$t ? u : 0n;
});
var $07e064cd5d4580c1$var$Lt = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, options: a, vaultAddress: s, userAddress: r } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: s,
        userAddress: r
    });
    const n = t.helpers.createVault(s), i = await n.getShares(r), o = await $07e064cd5d4580c1$var$xt({
        options: a,
        userAddress: r,
        vaultAddress: s,
        vaultContract: n,
        keeperContract: t.base.keeper,
        request: {
            callStatic: !0,
            params: [
                {
                    method: "convertToAssets",
                    args: [
                        i
                    ]
                }
            ]
        }
    });
    return {
        shares: i || 0n,
        assets: o?.[0]?.[0] || 0n
    };
});
const $07e064cd5d4580c1$var$jt = (e, t)=>{
    const a = new $07e064cd5d4580c1$export$714d099a508ef2ab(100).divide(e).multiply(t).toString();
    return Number(a);
}, $07e064cd5d4580c1$var$Ht = (e)=>{
    const { rewardSplitters: t } = e || {};
    if (!t) return {
        rewardSplitters: []
    };
    const a = t.map(({ id: e, owner: t, totalShares: a, shareHolders: s })=>{
        const r = BigInt(a);
        return {
            owner: t,
            address: (0, $95T0n.getAddress)(e),
            totalShares: r,
            feeRecipients: s.map(({ shares: e, address: t })=>{
                const a = BigInt(e);
                return {
                    shares: a,
                    percent: $07e064cd5d4580c1$var$jt(r, a),
                    address: (0, $95T0n.getAddress)(t)
                };
            })
        };
    });
    return {
        rewardSplitters: a
    };
}, $07e064cd5d4580c1$var$Qt = async (e, t)=>{
    const a = await t.getBlock("latest"), s = a ? a.timestamp : Number(((new Date).getTime() / 1e3).toFixed(0));
    return Number(s) - Number(e) > 86400;
}, $07e064cd5d4580c1$var$Ut = async (e)=>{
    const { options: t, contracts: a, provider: s, userAddress: r, vaultAddress: n, exitRequests: i } = e;
    if (!i.length) return {
        total: 0n,
        duration: 0,
        positions: [],
        withdrawable: 0n
    };
    const o = a.base.keeper, u = a.helpers.createVault(n), l = {
        options: t,
        userAddress: r,
        vaultAddress: n,
        vaultContract: u,
        keeperContract: o
    }, c = await $07e064cd5d4580c1$var$xt({
        ...l,
        request: {
            params: i.map(({ positionTicket: e })=>({
                    method: "getExitQueueIndex",
                    args: [
                        e
                    ]
                })),
            callStatic: !0
        }
    }), d = [], p = c || [];
    let y = 0n, m = 0n;
    for(let e = 0; e < p.length; e++){
        const { positionTicket: t, timestamp: a, totalShares: r, totalAssets: n } = i[e];
        y += BigInt(r || 0), m += BigInt(n || 0);
        const o = p[e][0];
        if (o < 0n) continue;
        if (await $07e064cd5d4580c1$var$Qt(a, s)) {
            const e = {
                exitQueueIndex: o,
                positionTicket: t,
                timestamp: a,
                isV1Position: BigInt(r) > 0
            };
            d.push(e);
        }
    }
    if (!d.length) {
        const e = await $07e064cd5d4580c1$var$xt({
            ...l,
            request: {
                params: [
                    {
                        method: "convertToAssets",
                        args: [
                            y
                        ]
                    }
                ],
                callStatic: !0
            }
        });
        return {
            duration: 0,
            positions: [],
            withdrawable: 0n,
            total: (e[0]?.assets || 0n) + m
        };
    }
    const h = await $07e064cd5d4580c1$var$xt({
        ...l,
        request: {
            params: d.map(({ positionTicket: e, exitQueueIndex: t, timestamp: a })=>({
                    method: "calculateExitedAssets",
                    args: [
                        r,
                        e,
                        a,
                        t
                    ]
                })),
            callStatic: !0
        }
    }) || [];
    let f = 0n;
    if (h.forEach(({ exitedTickets: e, exitedAssets: t }, a)=>{
        const { isV1Position: s } = d[a];
        s ? y -= BigInt(e || 0) : m -= BigInt(t || 0), f += BigInt(t || 0);
    }), y > 0) {
        const e = await $07e064cd5d4580c1$var$xt({
            ...l,
            request: {
                params: [
                    {
                        method: "convertToAssets",
                        args: [
                            y
                        ]
                    }
                ],
                callStatic: !0
            }
        });
        m += e[0]?.assets || 0n;
    }
    return {
        total: f + m,
        duration: ((e)=>{
            if (!e || !e.length) return 0;
            if (e.some((e)=>null === e.withdrawalTimestamp)) return null;
            const t = e.map((e)=>Number(e.withdrawalTimestamp));
            return Math.max(...t);
        })(i),
        positions: d,
        withdrawable: f
    };
}, $07e064cd5d4580c1$var$zt = {
    total: 0n,
    duration: 0,
    positions: [],
    withdrawable: 0n
};
var $07e064cd5d4580c1$var$Wt = (e)=>{
    if (e < $07e064cd5d4580c1$var$C.blockchain.amount32) throw new Error(`The "capacity" argument must be at least ${$07e064cd5d4580c1$var$C.blockchain.amount32}`);
    if (e > (0, $1H5oH.MaxUint256)) throw new Error(`The "capacity" argument must be at most ${(0, $1H5oH.MaxUint256)}`);
}, $07e064cd5d4580c1$var$Kt = (e)=>{
    if ("boolean" != typeof e) throw new Error('The "isOwnMevEscrow" argument must be of boolean type');
}, $07e064cd5d4580c1$var$Xt = (e)=>{
    const t = Object.values($07e064cd5d4580c1$export$74d89d9a07cc40e2);
    if (!t.includes(e)) throw new Error(`The "type" argument must be one of the following: ${t.join(", ")}`);
}, $07e064cd5d4580c1$var$Yt = (e)=>{
    if ("object" != typeof e) throw new Error('The "vaultToken" argument must be an object');
    const t = Object.keys(e).filter((t)=>"string" != typeof e[t]);
    if (t.length) {
        const e = t.map((e)=>`"vaultToken.${e}"`).join(", ");
        throw new Error(`The ${e} ${1 === t.length ? "argument" : "arguments"} must be a string`);
    }
    const a = Object.keys(e).filter((t)=>!e[t]);
    if (a.length) {
        const e = a.map((e)=>`"vaultToken.${e}"`).join(", ");
        throw new Error(`The ${e} ${1 === t.length ? "argument" : "arguments"} must be not empty string`);
    }
}, $07e064cd5d4580c1$var$Jt = (e)=>{
    if (e < 0) throw new Error('The "keysManagerFee" argument must be at least 0');
    if (e > 100) throw new Error('The "keysManagerFee" argument must be at most 100');
    const t = e.toString().split(".")[1]?.length;
    if (t > 2) throw new Error('The "keysManagerFee" argument must have at most two decimal places');
};
const $07e064cd5d4580c1$var$Zt = async (e)=>{
    const { type: t = $07e064cd5d4580c1$export$74d89d9a07cc40e2.Default, vaultToken: a, capacity: s, keysManagerFee: r, isOwnMevEscrow: n = !1, metadataIpfsHash: i = "", contracts: o, userAddress: u, options: l } = e;
    $07e064cd5d4580c1$var$T({
        userAddress: u
    }), $07e064cd5d4580c1$var$Xt(t), $07e064cd5d4580c1$var$Kt(n), a && $07e064cd5d4580c1$var$Yt(a), s && ($07e064cd5d4580c1$var$b({
        capacity: s
    }), $07e064cd5d4580c1$var$Wt(s)), r && $07e064cd5d4580c1$var$Jt(r);
    const d = (a ? {
        [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Default]: o.factories.erc20Vault,
        [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Private]: o.factories.erc20PrivateVault,
        [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Blocklist]: o.factories.erc20BlocklistVault
    } : {
        [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Default]: o.factories.vault,
        [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Private]: o.factories.privateVault,
        [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Blocklist]: o.factories.blocklistVault
    })[t], h = (0, $b6VUG.AbiCoder).defaultAbiCoder(), f = {
        feePercent: 100 * (r || 0),
        capacity: s || (0, $1H5oH.MaxUint256),
        symbol: a?.symbol,
        name: a?.name
    }, v = a ? h.encode([
        "tuple(uint256 capacity, uint16 feePercent, string name, string symbol, string metadataIpfsHash)"
    ], [
        [
            f.capacity,
            f.feePercent,
            f.name,
            f.symbol,
            i
        ]
    ]) : h.encode([
        "tuple(uint256 capacity, uint16 feePercent, string metadataIpfsHash)"
    ], [
        [
            f.capacity,
            f.feePercent,
            i
        ]
    ]);
    return {
        vaultFactory: d,
        params: [
            $07e064cd5d4580c1$export$95be4ae94445245a.Mainnet,
            $07e064cd5d4580c1$export$95be4ae94445245a.Holesky
        ].includes(l.network) ? [
            v,
            n,
            {
                value: $07e064cd5d4580c1$var$C.blockchain.gwei
            }
        ] : [
            v,
            n,
            {}
        ]
    };
}, $07e064cd5d4580c1$var$ea = async ({ userAddress: e, vaultAddress: t, contracts: a })=>{
    try {
        const s = await a.helpers.createVault(t), r = await s.admin();
        if (!(r.toLowerCase() === e.toLowerCase())) return Promise.reject("User must be the vault admin to perform this action");
    } catch  {}
}, $07e064cd5d4580c1$var$ta = async ({ userAddress: e, vaultAddress: t, contracts: a })=>{
    try {
        const s = await a.helpers.createVault(t), r = 1n === await s.version() ? await s.keysManager() : await a.base.depositDataRegistry.getDepositDataManager(t);
        if (!(r.toLowerCase() === e.toLowerCase())) return Promise.reject("User must be the vault deposit data manager to perform this action");
    } catch  {}
}, $07e064cd5d4580c1$var$aa = async ({ userAddress: e, vaultAddress: t, contracts: a })=>{
    try {
        const s = a.helpers.createRestakingVault(t), r = await s.restakeOperatorsManager();
        if (!(r.toLowerCase() === e.toLowerCase())) return Promise.reject("User must be the restake operators manager to perform this action");
    } catch  {}
}, $07e064cd5d4580c1$var$sa = (e)=>{
    Object.keys(e).forEach((t)=>{
        $07e064cd5d4580c1$var$w({
            [t]: e[t]
        });
        if (!e[t].every((e)=>e && "object" == typeof e && "string" == typeof e.address && "boolean" == typeof e.isNew)) throw new Error(`The "${t}" argument must be an array of objects with "address" and "isNew" keys`);
    });
}, $07e064cd5d4580c1$var$ra = async (e)=>{
    if ([
        e.image,
        e.displayName,
        e.description
    ].every((e)=>void 0 === e)) return;
    const { image: t = "", displayName: a = "", description: s = "", options: r } = e;
    if ($07e064cd5d4580c1$var$g({
        image: t,
        displayName: a,
        description: s
    }), $07e064cd5d4580c1$var$v(t), $07e064cd5d4580c1$var$k({
        displayName: {
            value: a,
            length: 30
        },
        description: {
            value: s,
            length: 1e3
        }
    }), !t && !a && !s) return "";
    try {
        const e = await $07e064cd5d4580c1$var$bt.backend.vault.submitUploadMetadataMutation({
            url: $07e064cd5d4580c1$var$O(r),
            variables: {
                payload: {
                    image: t,
                    displayName: a,
                    description: s
                }
            }
        });
        return e?.uploadMetadata?.ipfsHash;
    } catch (e) {
        const t = Array.isArray(e) ? e[0]?.extensions?.code : null;
        return Promise.reject(t || e);
    }
}, $07e064cd5d4580c1$var$na = ({ image: e, displayName: t, description: a })=>e || t || a ? "00000000000000000000000000000000000000000000000000000000000" : "", $07e064cd5d4580c1$var$ia = async (e)=>{
    const { image: t, displayName: a, description: s, ...r } = e, { provider: n, options: i, userAddress: o } = r, u = await $07e064cd5d4580c1$var$ra({
        image: t,
        displayName: a,
        description: s,
        options: i
    }), { vaultFactory: l, params: c } = await $07e064cd5d4580c1$var$Zt({
        metadataIpfsHash: u,
        ...r
    }), d = await n.getSigner(o), p = l.connect(d);
    return (await p.createVault(...c)).hash;
};
$07e064cd5d4580c1$var$ia.encode = async (e)=>{
    const { image: t, displayName: a, description: s, ...r } = e, { options: n } = r, i = await $07e064cd5d4580c1$var$ra({
        image: t,
        displayName: a,
        description: s,
        options: n
    }), { vaultFactory: o, params: u } = await $07e064cd5d4580c1$var$Zt({
        metadataIpfsHash: i,
        ...r
    });
    return o.createVault.populateTransaction(...u);
}, $07e064cd5d4580c1$var$ia.estimateGas = async (e)=>{
    const { image: t, displayName: a, description: s, ...r } = e, { provider: n, userAddress: i } = r, o = $07e064cd5d4580c1$var$na({
        image: t,
        displayName: a,
        description: s
    }), { vaultFactory: u, params: l } = await $07e064cd5d4580c1$var$Zt({
        metadataIpfsHash: o,
        ...r
    }), c = await n.getSigner(i), d = u.connect(c), p = await d.createVault.estimateGas(...l);
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: p,
        provider: n
    });
};
const $07e064cd5d4580c1$var$oa = async (e)=>{
    const { contracts: t, vaultAddress: a, userAddress: s, assets: r } = e;
    $07e064cd5d4580c1$var$b({
        assets: r
    }), $07e064cd5d4580c1$var$T({
        vaultAddress: a,
        userAddress: s
    });
    return {
        vaultContract: t.helpers.createVault(a),
        canHarvest: await t.base.keeper.canHarvest(a),
        overrides: {
            value: r
        }
    };
}, $07e064cd5d4580c1$var$ua = (0, $7RlNJ.ZeroAddress), $07e064cd5d4580c1$var$la = async (e)=>{
    const { options: t, provider: a, vaultAddress: s, userAddress: r } = e, { vaultContract: n, canHarvest: i, overrides: o } = await $07e064cd5d4580c1$var$oa(e), u = await a.getSigner(r), l = n.connect(u);
    if (i) {
        const e = await $07e064cd5d4580c1$var$gt({
            options: t,
            vaultAddress: s
        });
        return (await l.updateStateAndDeposit(r, $07e064cd5d4580c1$var$ua, e, o)).hash;
    }
    return (await l.deposit(r, $07e064cd5d4580c1$var$ua, o)).hash;
};
$07e064cd5d4580c1$var$la.encode = async (e)=>{
    const { options: t, vaultAddress: a, userAddress: s } = e, { vaultContract: r, canHarvest: n, overrides: i } = await $07e064cd5d4580c1$var$oa(e);
    if (n) {
        const e = await $07e064cd5d4580c1$var$gt({
            options: t,
            vaultAddress: a
        });
        return {
            ...await r.updateStateAndDeposit.populateTransaction(s, $07e064cd5d4580c1$var$ua, e, i),
            value: i.value
        };
    }
    return {
        ...await r.deposit.populateTransaction(s, $07e064cd5d4580c1$var$ua, i),
        value: i.value
    };
}, $07e064cd5d4580c1$var$la.estimateGas = async (e)=>{
    const { options: t, provider: a, vaultAddress: s, userAddress: r } = e, { vaultContract: n, canHarvest: i, overrides: o } = await $07e064cd5d4580c1$var$oa(e), u = await a.getSigner(r), l = n.connect(u);
    let c = 0n;
    if (i) {
        const e = await $07e064cd5d4580c1$var$gt({
            options: t,
            vaultAddress: s
        });
        c = await l.updateStateAndDeposit.estimateGas(r, $07e064cd5d4580c1$var$ua, e, o);
    } else c = await l.deposit.estimateGas(r, $07e064cd5d4580c1$var$ua, o);
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: c,
        provider: a
    });
};
const $07e064cd5d4580c1$var$ca = (e)=>{
    const { options: a, contracts: s, vaultAddress: r, userAddress: n, assets: i } = e;
    $07e064cd5d4580c1$var$b({
        assets: i
    }), $07e064cd5d4580c1$var$T({
        vaultAddress: r,
        userAddress: n
    });
    const o = [
        {
            method: "deposit",
            args: [
                i,
                n,
                (0, $7RlNJ.ZeroAddress)
            ]
        }
    ];
    return {
        vaultContract: s.helpers.createOtherTokenVault(r),
        keeperContract: s.base.keeper,
        request: {
            params: o
        },
        vaultAddress: r,
        userAddress: n,
        options: a
    };
}, $07e064cd5d4580c1$var$da = async (e)=>{
    const { provider: t } = e, a = await $07e064cd5d4580c1$var$xt({
        ...e,
        request: {
            ...e.request,
            estimateGas: !0
        }
    });
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: a,
        provider: t
    });
}, $07e064cd5d4580c1$var$pa = async (e)=>$07e064cd5d4580c1$var$xt({
        ...e,
        request: {
            ...e.request,
            transactionData: !0
        }
    });
var $07e064cd5d4580c1$var$ya = Object.freeze({
    __proto__: null,
    getSwiseUsdPrice: (e)=>{
        const { options: t } = e;
        return $07e064cd5d4580c1$var$bt.backend.swise.fetchSwiseStatsQuery({
            url: $07e064cd5d4580c1$var$O(t),
            modifyResult: (e)=>e?.swiseStats?.price || "0"
        });
    },
    getTransactions: (e)=>{
        const { options: t, hash: a } = e;
        return $07e064cd5d4580c1$var$g({
            hash: a
        }), $07e064cd5d4580c1$var$bt.subgraph.transactions.fetchTransactionsQuery({
            url: $07e064cd5d4580c1$var$I(t),
            variables: {
                where: {
                    id: a
                }
            },
            modifyResult: (e)=>e?.transactions || []
        });
    },
    getVaultMulticallEncode: $07e064cd5d4580c1$var$pa,
    getVaultMulticallGas: $07e064cd5d4580c1$var$da
});
const $07e064cd5d4580c1$var$ma = async (e)=>{
    const t = $07e064cd5d4580c1$var$ca(e);
    return (await $07e064cd5d4580c1$var$xt(t)).hash;
};
$07e064cd5d4580c1$var$ma.encode = async (e)=>{
    const t = $07e064cd5d4580c1$var$ca(e);
    return {
        ...await $07e064cd5d4580c1$var$pa(t),
        value: e.assets
    };
}, $07e064cd5d4580c1$var$ma.estimateGas = async (e)=>{
    const { provider: t } = e, a = $07e064cd5d4580c1$var$ca(e);
    return $07e064cd5d4580c1$var$da({
        ...a,
        provider: t
    });
};
const $07e064cd5d4580c1$var$ha = async (e)=>{
    const { options: t } = e, { isEthereum: a } = $07e064cd5d4580c1$var$se(t);
    return a ? $07e064cd5d4580c1$var$la(e) : $07e064cd5d4580c1$var$ma(e);
};
$07e064cd5d4580c1$var$ha.encode = (e)=>{
    const { options: t } = e, { isEthereum: a } = $07e064cd5d4580c1$var$se(t);
    return a ? $07e064cd5d4580c1$var$la.encode(e) : $07e064cd5d4580c1$var$ma.encode(e);
}, $07e064cd5d4580c1$var$ha.estimateGas = (e)=>{
    const { options: t } = e, { isEthereum: a } = $07e064cd5d4580c1$var$se(t);
    return a ? $07e064cd5d4580c1$var$la.estimateGas(e) : $07e064cd5d4580c1$var$ma.estimateGas(e);
};
const $07e064cd5d4580c1$var$fa = async (e)=>{
    const { validatorsRoot: t, blocklistManager: a, metadataIpfsHash: s, blocklist: r, whitelist: n, depositDataManager: i, whitelistManager: o, feeRecipient: u, options: l, contracts: c, userAddress: d, vaultAddress: p, provider: y, validatorsManager: m, restakeOperatorsManager: h, restakeWithdrawalsManager: f } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: p,
        userAddress: d
    });
    let v = c.helpers.createVault(p);
    if (n?.length || o) {
        if (n && n.length > 700) throw new Error("Your transaction is likely to fail, we do not recommend passing more than 700 addresses to the whitelist at a time");
        v = c.helpers.createPrivateVault(p);
    }
    if (r?.length || a) {
        if (r && r.length > 700) throw new Error("Your transaction is likely to fail, we do not recommend passing more than 700 addresses to the block list at a time");
        v = c.helpers.createBlocklistedVault(p);
    }
    (h || f) && (v = c.helpers.createRestakingVault(p));
    if (!(1 === Number(await v.version()))) {
        if (t) throw new Error("To set validatorsRoot in version 2 of vault, use the vault.setDepositDataRoot() method");
        if (i) throw new Error("To set depositDataManager in version 2 of vault, use the vault.setDepositDataManager() method");
    }
    const w = {
        keeperContract: c.base.keeper,
        vaultContract: v,
        vaultAddress: p,
        userAddress: d,
        options: l
    }, b = {
        options: l,
        provider: y,
        contracts: c,
        userAddress: d,
        vaultAddress: p
    }, A = [];
    if (r?.length) {
        const e = ((e)=>{
            const { blocklist: t } = e;
            $07e064cd5d4580c1$var$sa({
                blocklist: t
            });
            const a = t.map(({ address: e, isNew: t })=>({
                    method: "updateBlocklist",
                    args: [
                        e,
                        t
                    ]
                }));
            return a;
        })({
            ...b,
            blocklist: r
        });
        A.push(...e);
    }
    if (n?.length) {
        const e = ((e)=>{
            const { whitelist: t } = e;
            $07e064cd5d4580c1$var$sa({
                whitelist: t
            });
            const a = t.map(({ address: e, isNew: t })=>({
                    method: "updateWhitelist",
                    args: [
                        e,
                        t
                    ]
                }));
            return a;
        })({
            ...b,
            whitelist: n
        });
        A.push(...e);
    }
    if (i) {
        const e = ((e)=>{
            const { depositDataManager: t } = e;
            return $07e064cd5d4580c1$var$T({
                depositDataManager: t
            }), [
                {
                    method: "setKeysManager",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            depositDataManager: i
        });
        A.push(...e);
    }
    if (o) {
        const e = ((e)=>{
            const { whitelistManager: t } = e;
            return $07e064cd5d4580c1$var$T({
                whitelistManager: t
            }), [
                {
                    method: "setWhitelister",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            whitelistManager: o
        });
        A.push(...e);
    }
    if (u) {
        const e = ((e)=>{
            const { feeRecipient: t } = e;
            return $07e064cd5d4580c1$var$T({
                feeRecipient: t
            }), [
                {
                    method: "setFeeRecipient",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            feeRecipient: u
        });
        A.push(...e);
    }
    if (t) {
        const e = ((e)=>{
            const { validatorsRoot: t } = e;
            return $07e064cd5d4580c1$var$g({
                validatorsRoot: t
            }), [
                {
                    method: "setValidatorsRoot",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            validatorsRoot: t
        });
        A.push(...e);
    }
    if (void 0 !== s) {
        const e = ((e)=>{
            const { metadataIpfsHash: t } = e;
            return [
                {
                    method: "setMetadata",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            metadataIpfsHash: s
        });
        A.push(...e);
    }
    if (a) {
        const e = ((e)=>{
            const { blocklistManager: t } = e;
            return $07e064cd5d4580c1$var$T({
                blocklistManager: t
            }), [
                {
                    method: "setBlocklistManager",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            blocklistManager: a
        });
        A.push(...e);
    }
    if (m) {
        const e = ((e)=>{
            const { validatorsManager: t } = e;
            return $07e064cd5d4580c1$var$T({
                validatorsManager: t
            }), [
                {
                    method: "setValidatorsManager",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            validatorsManager: m
        });
        A.push(...e);
    }
    if (h) {
        const e = ((e)=>{
            const { restakeOperatorsManager: t } = e;
            return $07e064cd5d4580c1$var$T({
                restakeOperatorsManager: t
            }), [
                {
                    method: "setRestakeOperatorsManager",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            restakeOperatorsManager: h
        });
        A.push(...e);
    }
    if (f) {
        const e = ((e)=>{
            const { restakeWithdrawalsManager: t } = e;
            return $07e064cd5d4580c1$var$T({
                restakeWithdrawalsManager: t
            }), [
                {
                    method: "setRestakeWithdrawalsManager",
                    args: [
                        t
                    ]
                }
            ];
        })({
            ...b,
            restakeWithdrawalsManager: f
        });
        A.push(...e);
    }
    return {
        ...w,
        request: {
            params: A
        }
    };
}, $07e064cd5d4580c1$var$va = (e)=>async (t)=>{
        const { blocklist: a, whitelist: s, depositDataManager: r, whitelistManager: n, feeRecipient: i, validatorsRoot: o, blocklistManager: u, metadataIpfsHash: l, validatorsManager: c, restakeOperatorsManager: d, restakeWithdrawalsManager: p } = t;
        try {
            return await e(t);
        } catch (e) {
            const y = Boolean(n || i || u || l || c || r || d || p), m = Boolean(o), h = Boolean(s), f = Boolean(a), v = [];
            return y && v.push($07e064cd5d4580c1$var$ea(t)), m && v.push($07e064cd5d4580c1$var$ta(t)), h && v.push((async ({ userAddress: e, vaultAddress: t, contracts: a })=>{
                try {
                    const s = a.helpers.createPrivateVault(t);
                    if ((await s.whitelister()).toLowerCase() !== e.toLowerCase()) return Promise.reject("User must be the vault whitelist manager to perform this action");
                } catch  {}
            })(t)), f && v.push((async ({ userAddress: e, vaultAddress: t, contracts: a })=>{
                try {
                    const s = a.helpers.createBlocklistedVault(t);
                    if ((await s.blocklistManager()).toLowerCase() !== e.toLowerCase()) return Promise.reject("User must be the vault blocklist manager to perform this action");
                } catch  {}
            })(t)), Promise.all(v).then(()=>Promise.reject(e), (e)=>Promise.reject(e));
        }
    }, $07e064cd5d4580c1$var$wa = async (e)=>{
    const { image: t, displayName: a, description: s, ...r } = e, { options: n } = r, i = await $07e064cd5d4580c1$var$ra({
        image: t,
        displayName: a,
        description: s,
        options: n
    }), o = await $07e064cd5d4580c1$var$fa({
        metadataIpfsHash: i,
        ...r
    });
    return (await $07e064cd5d4580c1$var$xt(o)).hash;
};
$07e064cd5d4580c1$var$wa.encode = $07e064cd5d4580c1$var$va(async (e)=>{
    const { image: t, displayName: a, description: s, ...r } = e, { options: n } = r, i = await $07e064cd5d4580c1$var$ra({
        image: t,
        displayName: a,
        description: s,
        options: n
    }), o = await $07e064cd5d4580c1$var$fa({
        metadataIpfsHash: i,
        ...r
    });
    return $07e064cd5d4580c1$var$pa(o);
}), $07e064cd5d4580c1$var$wa.estimateGas = $07e064cd5d4580c1$var$va(async (e)=>{
    const { image: t, displayName: a, description: s, ...r } = e, { provider: n } = r, i = $07e064cd5d4580c1$var$na({
        image: t,
        displayName: a,
        description: s
    }), o = await $07e064cd5d4580c1$var$fa({
        metadataIpfsHash: i,
        ...r
    });
    return $07e064cd5d4580c1$var$da({
        ...o,
        provider: n
    });
});
var $07e064cd5d4580c1$var$ba = $07e064cd5d4580c1$var$va($07e064cd5d4580c1$var$wa);
const $07e064cd5d4580c1$var$ga = async (e)=>{
    const { options: t, contracts: a, assets: s, vaultAddress: r, userAddress: n } = e;
    $07e064cd5d4580c1$var$b({
        assets: s
    }), $07e064cd5d4580c1$var$T({
        vaultAddress: r,
        userAddress: n
    });
    const i = [], o = a.helpers.createVault(r), u = 1 === Number(await o.version()), l = {
        keeperContract: a.base.keeper,
        vaultContract: o,
        vaultAddress: r,
        userAddress: n,
        options: t
    };
    if (await a.base.keeper.isCollateralized(r) || !u) {
        const e = (await $07e064cd5d4580c1$var$xt({
            ...l,
            request: {
                params: [
                    {
                        method: "convertToShares",
                        args: [
                            s
                        ]
                    }
                ],
                callStatic: !0
            }
        }))[0].shares;
        i.push({
            method: "enterExitQueue",
            args: [
                e,
                n
            ]
        });
    } else {
        const e = (await $07e064cd5d4580c1$var$xt({
            ...l,
            request: {
                params: [
                    {
                        method: "convertToShares",
                        args: [
                            s
                        ]
                    }
                ],
                callStatic: !0
            }
        }))[0].shares;
        i.push({
            method: "redeem",
            args: [
                e,
                n
            ]
        });
    }
    return {
        ...l,
        request: {
            params: i
        }
    };
}, $07e064cd5d4580c1$var$Aa = async (e)=>{
    const t = await $07e064cd5d4580c1$var$ga(e);
    return (await $07e064cd5d4580c1$var$xt(t)).hash;
};
$07e064cd5d4580c1$var$Aa.encode = async (e)=>{
    const t = await $07e064cd5d4580c1$var$ga(e);
    return $07e064cd5d4580c1$var$pa(t);
}, $07e064cd5d4580c1$var$Aa.estimateGas = async (e)=>{
    const { provider: t } = e, a = await $07e064cd5d4580c1$var$ga(e);
    return $07e064cd5d4580c1$var$da({
        ...a,
        provider: t
    });
};
const $07e064cd5d4580c1$var$Ta = (e)=>{
    const { options: t, contracts: a, positions: s, vaultAddress: r, userAddress: n } = e;
    ((e)=>{
        $07e064cd5d4580c1$var$w({
            positions: e
        }), e.forEach(({ positionTicket: e, exitQueueIndex: t })=>{
            $07e064cd5d4580c1$var$b({
                exitQueueIndex: t
            }), $07e064cd5d4580c1$var$g({
                positionTicket: e
            });
        });
    })(s);
    return {
        vaultContract: a.helpers.createVault(r),
        keeperContract: a.base.keeper,
        vaultAddress: r,
        userAddress: n,
        options: t,
        request: {
            params: s.map((e)=>{
                const { positionTicket: t, exitQueueIndex: a, timestamp: s } = e;
                return {
                    method: "claimExitedAssets",
                    args: [
                        t,
                        s,
                        a
                    ]
                };
            })
        }
    };
}, $07e064cd5d4580c1$var$ka = async (e)=>{
    const t = $07e064cd5d4580c1$var$Ta(e);
    return (await $07e064cd5d4580c1$var$xt(t)).hash;
};
$07e064cd5d4580c1$var$ka.encode = (e)=>{
    const t = $07e064cd5d4580c1$var$Ta(e);
    return $07e064cd5d4580c1$var$pa(t);
}, $07e064cd5d4580c1$var$ka.estimateGas = (e)=>{
    const { provider: t } = e, a = $07e064cd5d4580c1$var$Ta(e);
    return $07e064cd5d4580c1$var$da({
        ...a,
        provider: t
    });
};
const $07e064cd5d4580c1$var$Ea = async (e)=>{
    const { contracts: t, vaultAddress: a, userAddress: s } = e;
    return $07e064cd5d4580c1$var$T({
        vaultAddress: a,
        userAddress: s
    }), t.helpers.createRestakingVault(a);
}, $07e064cd5d4580c1$var$Sa = (e)=>async (t)=>{
        try {
            return await e(t);
        } catch (e) {
            return $07e064cd5d4580c1$var$aa(t).then(()=>Promise.reject(e), (e)=>Promise.reject(e));
        }
    }, $07e064cd5d4580c1$var$Ca = async (e)=>{
    const { provider: t, userAddress: a } = e, s = await $07e064cd5d4580c1$var$Ea(e), r = await t.getSigner(a), n = s.connect(r);
    return (await n.createEigenPod()).hash;
};
$07e064cd5d4580c1$var$Ca.encode = $07e064cd5d4580c1$var$Sa(async (e)=>(await $07e064cd5d4580c1$var$Ea(e)).createEigenPod.populateTransaction()), $07e064cd5d4580c1$var$Ca.estimateGas = $07e064cd5d4580c1$var$Sa(async (e)=>{
    const { provider: t, userAddress: a } = e, s = await $07e064cd5d4580c1$var$Ea(e), r = await t.getSigner(a), n = s.connect(r), i = await n.createEigenPod.estimateGas();
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: i,
        provider: t
    });
});
var $07e064cd5d4580c1$var$Ma = $07e064cd5d4580c1$var$Sa($07e064cd5d4580c1$var$Ca);
const $07e064cd5d4580c1$var$Ra = (e)=>{
    const { vaultAddress: t, validatorsRoot: a, userAddress: s } = e;
    return $07e064cd5d4580c1$var$g({
        validatorsRoot: a
    }), $07e064cd5d4580c1$var$T({
        vaultAddress: t,
        userAddress: s
    }), e.contracts.base.depositDataRegistry;
}, $07e064cd5d4580c1$var$Da = (e)=>async (t)=>{
        try {
            return await e(t);
        } catch (e) {
            return $07e064cd5d4580c1$var$ta(t).then(()=>Promise.reject(e), (e)=>Promise.reject(e));
        }
    }, $07e064cd5d4580c1$var$xa = async (e)=>{
    const { provider: t, userAddress: a, vaultAddress: s, validatorsRoot: r } = e, n = $07e064cd5d4580c1$var$Ra(e), i = await t.getSigner(a), o = n.connect(i), u = await o.setDepositDataRoot(s, r);
    return u?.hash;
};
$07e064cd5d4580c1$var$xa.encode = $07e064cd5d4580c1$var$Da(async (e)=>$07e064cd5d4580c1$var$Ra(e).setDepositDataRoot.populateTransaction(e.vaultAddress, e.validatorsRoot)), $07e064cd5d4580c1$var$xa.estimateGas = $07e064cd5d4580c1$var$Da(async (e)=>{
    const { provider: t, userAddress: a, vaultAddress: s, validatorsRoot: r } = e, n = $07e064cd5d4580c1$var$Ra(e), i = await t.getSigner(a), o = n.connect(i), u = await o.setDepositDataRoot.estimateGas(s, r);
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: u,
        provider: e.provider
    });
});
var $07e064cd5d4580c1$var$Ba = $07e064cd5d4580c1$var$Da($07e064cd5d4580c1$var$xa);
const $07e064cd5d4580c1$var$Pa = async (e)=>{
    const { contracts: t, ownerAddress: a, userAddress: s, vaultAddress: r } = e;
    $07e064cd5d4580c1$var$T({
        ownerAddress: a,
        userAddress: s,
        vaultAddress: r
    });
    return {
        eigenPodOwnerContract: t.helpers.createEigenPodOwner(a)
    };
}, $07e064cd5d4580c1$var$Oa = (e)=>async (t)=>{
        try {
            return await e(t);
        } catch (e) {
            return $07e064cd5d4580c1$var$aa(t).then(()=>Promise.reject(e), (e)=>Promise.reject(e));
        }
    }, $07e064cd5d4580c1$var$Ia = async (e)=>{
    const { provider: t, userAddress: a, operatorAddress: s } = e, { eigenPodOwnerContract: r } = await $07e064cd5d4580c1$var$Pa(e), n = await t.getSigner(a), i = r.connect(n);
    return (await i.delegateTo(s, {
        signature: "0x",
        expiry: 0
    }, "0x0000000000000000000000000000000000000000000000000000000000000000")).hash;
};
$07e064cd5d4580c1$var$Ia.encode = $07e064cd5d4580c1$var$Oa(async (e)=>{
    const { eigenPodOwnerContract: t } = await $07e064cd5d4580c1$var$Pa(e);
    return t.eigenPod.populateTransaction();
}), $07e064cd5d4580c1$var$Ia.estimateGas = $07e064cd5d4580c1$var$Oa(async (e)=>{
    const { provider: t, userAddress: a } = e, { eigenPodOwnerContract: s } = await $07e064cd5d4580c1$var$Pa(e), r = await t.getSigner(a), n = s.connect(r), i = await n.eigenPod.estimateGas();
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: i,
        provider: t
    });
});
var $07e064cd5d4580c1$var$Na = $07e064cd5d4580c1$var$Oa($07e064cd5d4580c1$var$Ia);
const $07e064cd5d4580c1$var$Fa = (e)=>{
    const { vaultAddress: t, managerAddress: a, userAddress: s } = e;
    return $07e064cd5d4580c1$var$T({
        vaultAddress: t,
        userAddress: s,
        managerAddress: a
    }), e.contracts.base.depositDataRegistry;
}, $07e064cd5d4580c1$var$qa = (e)=>async (t)=>{
        try {
            return await e(t);
        } catch (e) {
            return $07e064cd5d4580c1$var$ea(t).then(()=>Promise.reject(e), (e)=>Promise.reject(e));
        }
    }, $07e064cd5d4580c1$var$_a = async (e)=>{
    const { provider: t, userAddress: a, managerAddress: s, vaultAddress: r } = e, n = $07e064cd5d4580c1$var$Fa(e), i = await t.getSigner(a), o = n.connect(i), u = await o.setDepositDataManager(r, s);
    return u?.hash;
};
$07e064cd5d4580c1$var$_a.encode = $07e064cd5d4580c1$var$qa(async (e)=>$07e064cd5d4580c1$var$Fa(e).setDepositDataManager.populateTransaction(e.vaultAddress, e.managerAddress)), $07e064cd5d4580c1$var$_a.estimateGas = $07e064cd5d4580c1$var$qa(async (e)=>{
    const { provider: t, userAddress: a, vaultAddress: s, managerAddress: r } = e, n = $07e064cd5d4580c1$var$Fa(e), i = await t.getSigner(a), o = n.connect(i), u = await o.setDepositDataManager.estimateGas(s, r);
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: u,
        provider: e.provider
    });
});
var $07e064cd5d4580c1$var$Va = $07e064cd5d4580c1$var$qa($07e064cd5d4580c1$var$_a);
const $07e064cd5d4580c1$var$$a = async (e)=>{
    const { contracts: t, userAddress: a, vaultAddress: s, options: r, ownerAddress: n, operatorAddress: i } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: s,
        userAddress: a,
        ownerAddress: n,
        operatorAddress: i
    });
    return {
        eigenPodOwnerContract: t.helpers.createEigenPodOwner(n),
        vaultAddress: s,
        userAddress: a,
        options: r,
        request: {
            params: [
                {
                    method: "undelegate",
                    args: []
                },
                {
                    method: "delegateTo",
                    args: [
                        i,
                        {
                            signature: "0x",
                            expiry: 0
                        },
                        "0x0000000000000000000000000000000000000000000000000000000000000000"
                    ]
                }
            ]
        }
    };
}, $07e064cd5d4580c1$var$Ga = (e)=>async (t)=>{
        try {
            return await e(t);
        } catch (e) {
            return $07e064cd5d4580c1$var$aa(t).then(()=>Promise.reject(e), (e)=>Promise.reject(e));
        }
    }, $07e064cd5d4580c1$var$La = async (e)=>{
    const t = await $07e064cd5d4580c1$var$$a(e);
    return (await $07e064cd5d4580c1$var$Bt(t)).hash;
};
$07e064cd5d4580c1$var$La.encode = $07e064cd5d4580c1$var$Ga(async (e)=>{
    const t = await $07e064cd5d4580c1$var$$a(e);
    return $07e064cd5d4580c1$var$Bt({
        ...t,
        request: {
            ...t.request,
            transactionData: !0
        }
    });
}), $07e064cd5d4580c1$var$La.estimateGas = $07e064cd5d4580c1$var$Ga(async (e)=>{
    const { provider: t } = e, a = await $07e064cd5d4580c1$var$$a(e), s = await $07e064cd5d4580c1$var$Bt({
        ...a,
        request: {
            ...a.request,
            estimateGas: !0
        }
    });
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: s,
        provider: t
    });
});
var $07e064cd5d4580c1$var$ja = $07e064cd5d4580c1$var$Ga($07e064cd5d4580c1$var$La), $07e064cd5d4580c1$var$Ha = {
    requests: {
        getExitQueuePositions: async (e)=>{
            const { options: t, contracts: a, provider: s, vaultAddress: r, userAddress: n } = e;
            return $07e064cd5d4580c1$var$T({
                vaultAddress: r,
                userAddress: n
            }), ((e)=>{
                const { options: t, vaultAddress: a, userAddress: s } = e;
                return $07e064cd5d4580c1$var$bt.subgraph.exitQueue.fetchExitQueueQuery({
                    url: $07e064cd5d4580c1$var$I(t),
                    variables: {
                        vault: a.toLowerCase(),
                        receiver: s.toLowerCase()
                    },
                    modifyResult: (e)=>e?.exitRequests || []
                });
            })({
                options: t,
                vaultAddress: r,
                userAddress: n
            }).then((e)=>e ? $07e064cd5d4580c1$var$Ut({
                    options: t,
                    provider: s,
                    contracts: a,
                    userAddress: n,
                    vaultAddress: r,
                    exitRequests: e
                }) : $07e064cd5d4580c1$var$zt);
        },
        getScorePercentiles: (e)=>{
            const { options: t } = e;
            return $07e064cd5d4580c1$var$bt.backend.vault.fetchScorePercentilesQuery({
                url: $07e064cd5d4580c1$var$O(t),
                modifyResult: (e)=>((e)=>{
                        const { scorePercentiles: t } = e;
                        return {
                            percentile25: Number(t.percentile25),
                            percentile50: Number(t.percentile50),
                            percentile75: Number(t.percentile75)
                        };
                    })(e)
            });
        },
        getRewardSplitters: (e)=>{
            const { owner: t, vaultAddress: a, rewardSplitterAddress: s, options: r } = e;
            $07e064cd5d4580c1$var$T({
                owner: t,
                vaultAddress: a
            }), void 0 !== s && $07e064cd5d4580c1$var$T({
                rewardSplitterAddress: s
            });
            const n = {
                vault: a.toLowerCase(),
                owner: t.toLowerCase()
            };
            return s && (n.id = s.toLowerCase()), $07e064cd5d4580c1$var$ft({
                url: $07e064cd5d4580c1$var$I(r),
                variables: {
                    where: n
                },
                modifyResult: $07e064cd5d4580c1$var$Ht
            });
        },
        getHarvestParams: $07e064cd5d4580c1$var$gt,
        getStakerActions: (e)=>{
            const { options: t, skip: a, limit: s, types: r, vaultAddress: n, userAddress: i } = e;
            if ($07e064cd5d4580c1$var$T({
                vaultAddress: n
            }), $07e064cd5d4580c1$var$A({
                skip: a,
                limit: s
            }), i && $07e064cd5d4580c1$var$T({
                userAddress: i
            }), r) {
                if (!Array.isArray(r)) throw new Error('The "types" argument must be a array');
                r.forEach((e)=>{
                    if (!(e in $07e064cd5d4580c1$export$e6e2757d7bafe7d1)) throw new Error('The "types" argument must contain enum AllocatorActionType values');
                });
            }
            return $07e064cd5d4580c1$var$bt.subgraph.allocatorActions.fetchAllocatorActionsQuery({
                url: $07e064cd5d4580c1$var$I(t),
                variables: {
                    skip: a,
                    first: s,
                    where: {
                        actionType_in: r,
                        vault_: {
                            id: n.toLowerCase()
                        },
                        address: i ? i.toLowerCase() : void 0
                    }
                },
                modifyResult: (e)=>((e)=>{
                        const { data: t, network: a } = e;
                        return t?.allocatorActions.map((e)=>({
                                ...e,
                                shares: (0, $jxZic.formatEther)(e.shares || 0),
                                assets: (0, $jxZic.formatEther)(e.assets || 0),
                                createdAt: 1e3 * Number(e.createdAt),
                                link: `${$07e064cd5d4580c1$export$c884d9dcb329c3c[a].network.blockExplorerUrl}/tx/${e.id.replace(/-.*/, "")}`
                            })) || [];
                    })({
                        data: e,
                        network: t.network
                    })
            });
        },
        getStakeBalance: $07e064cd5d4580c1$var$Lt,
        getUserRewards: (e)=>{
            const { options: t, vaultAddress: a, userAddress: s, dateFrom: r, dateTo: n, fillGaps: i } = e;
            return $07e064cd5d4580c1$var$T({
                vaultAddress: a,
                userAddress: s
            }), $07e064cd5d4580c1$var$A({
                dateFrom: r
            }), n && $07e064cd5d4580c1$var$A({
                dateTo: n
            }), $07e064cd5d4580c1$var$bt.backend.vault.fetchUserRewardsQuery({
                url: $07e064cd5d4580c1$var$O(t),
                variables: {
                    fillGaps: i,
                    dateFrom: String(r),
                    user: s.toLowerCase(),
                    dateTo: n ? String(n) : void 0,
                    vaultAddress: a.toLowerCase()
                },
                modifyResult: $07e064cd5d4580c1$var$Vt
            });
        },
        getMaxWithdraw: $07e064cd5d4580c1$var$Gt,
        getValidators: (e)=>{
            const { options: t, skip: a, limit: s, vaultAddress: r } = e;
            return $07e064cd5d4580c1$var$T({
                vaultAddress: r
            }), $07e064cd5d4580c1$var$A({
                skip: a,
                limit: s
            }), $07e064cd5d4580c1$var$bt.backend.vault.fetchValidatorsQuery({
                url: $07e064cd5d4580c1$var$O(t),
                variables: {
                    vaultAddress: r.toLowerCase(),
                    skip: a,
                    first: s
                },
                modifyResult: (e)=>((e)=>{
                        const { data: t, network: a } = e;
                        return (t?.vaultValidators || []).map((e)=>{
                            const { apy: t, createdAt: s, earned: r, publicKey: n } = e;
                            return {
                                publicKey: n,
                                apy: Number(t).toFixed(2),
                                createdAt: new Date(s).getTime(),
                                earned: (0, $jxZic.formatEther)(String(r || 0)),
                                link: `${$07e064cd5d4580c1$export$c884d9dcb329c3c[a].pages.beaconchain}/validator/${n}`
                            };
                        });
                    })({
                        data: e,
                        network: t.network
                    })
            });
        },
        getEigenPods: (e)=>{
            const { options: t, skip: a, limit: s, vaultAddress: r } = e;
            return $07e064cd5d4580c1$var$T({
                vaultAddress: r
            }), void 0 !== a && $07e064cd5d4580c1$var$A({
                skip: a
            }), void 0 !== s && $07e064cd5d4580c1$var$A({
                limit: s
            }), $07e064cd5d4580c1$var$bt.subgraph.eigenPods.fetchEigenPodsQuery({
                url: $07e064cd5d4580c1$var$I(t),
                variables: {
                    skip: a || 0,
                    first: s || 100,
                    where: {
                        vault_: {
                            id: r.toLowerCase()
                        }
                    }
                },
                modifyResult: (e)=>((e)=>{
                        const { data: t, network: a } = e;
                        return (t?.eigenPods || []).map((e)=>{
                            const { id: t, shares: s, operator: r, createdAt: n, address: i } = e;
                            return {
                                operator: r,
                                owner: t,
                                podAddress: i,
                                link: `${$07e064cd5d4580c1$var$It[a]}/${r}`,
                                createdAt: 1e3 * Number(n),
                                restaked: (0, $jxZic.formatEther)(s || 0)
                            };
                        });
                    })({
                        data: e,
                        network: t.network
                    })
            });
        },
        getSnapshots: (e)=>{
            const { options: t, vaultAddress: a, dateFrom: s } = e;
            return $07e064cd5d4580c1$var$T({
                vaultAddress: a
            }), $07e064cd5d4580c1$var$A({
                dateFrom: s
            }), $07e064cd5d4580c1$var$bt.backend.vault.fetchSnapshotsQuery({
                url: $07e064cd5d4580c1$var$O(t),
                variables: {
                    vaultAddress: a.toLowerCase(),
                    dateFrom: String(s)
                },
                modifyResult: $07e064cd5d4580c1$var$Ft
            });
        },
        getWhitelist: (t)=>{
            const { vaultAddress: a, orderDirection: s, search: r, limit: n, skip: i, addressIn: o, options: u } = t;
            if ($07e064cd5d4580c1$var$T({
                vaultAddress: a
            }), void 0 !== i && $07e064cd5d4580c1$var$A({
                skip: i
            }), void 0 !== n && $07e064cd5d4580c1$var$A({
                limit: n
            }), void 0 !== r && $07e064cd5d4580c1$var$g({
                search: r
            }), void 0 !== s && ![
                "asc",
                "desc"
            ].includes(s)) throw new Error('The "orderDirection" argument must be "asc" or "desc"');
            void 0 !== o && ($07e064cd5d4580c1$var$w({
                addressIn: o
            }), ((t)=>{
                const a = t.every((t)=>(0, $klTOW.isAddress)(t));
                if (!a) throw new Error('The "addressIn" argument must be an array of valid addresses');
            })(o));
            const l = a.toLowerCase(), c = r ? {
                vault: l,
                address_in: o,
                address_contains: r.toLowerCase()
            } : {
                vault: l,
                address_in: o
            };
            return $07e064cd5d4580c1$var$bt.subgraph.vault.fetchWhitelistAccountsQuery({
                url: $07e064cd5d4580c1$var$I(u),
                variables: {
                    where: c,
                    skip: i || 0,
                    limit: n || 100,
                    orderDirection: s || "desc"
                },
                modifyResult: (e)=>((e)=>{
                        const { data: t } = e, { privateVaultAccounts: a } = t;
                        return {
                            whitelist: a.map($07e064cd5d4580c1$var$qt)
                        };
                    })({
                        data: e
                    })
            });
        },
        getBlocklist: (t)=>{
            const { vaultAddress: a, orderDirection: s, search: r, limit: n, skip: i, addressIn: o, options: u } = t;
            if ($07e064cd5d4580c1$var$T({
                vaultAddress: a
            }), void 0 !== i && $07e064cd5d4580c1$var$A({
                skip: i
            }), void 0 !== n && $07e064cd5d4580c1$var$A({
                limit: n
            }), void 0 !== r && $07e064cd5d4580c1$var$g({
                search: r
            }), void 0 !== s && ![
                "asc",
                "desc"
            ].includes(s)) throw new Error('The "orderDirection" argument must be "asc" or "desc"');
            void 0 !== o && ($07e064cd5d4580c1$var$w({
                addressIn: o
            }), ((t)=>{
                const a = t.every((t)=>(0, $klTOW.isAddress)(t));
                if (!a) throw new Error('The "addressIn" argument must be an array of valid addresses');
            })(o));
            const l = a.toLowerCase(), c = r ? {
                vault: l,
                address_in: o,
                address_contains: r.toLowerCase()
            } : {
                vault: l,
                address_in: o
            };
            return $07e064cd5d4580c1$var$bt.subgraph.vault.fetchBlocklistAccountsQuery({
                url: $07e064cd5d4580c1$var$I(u),
                variables: {
                    where: c,
                    skip: i || 0,
                    limit: n || 100,
                    orderDirection: s || "desc"
                },
                modifyResult: (e)=>((e)=>{
                        const { data: t } = e, { vaultBlockedAccounts: a } = t;
                        return {
                            blocklist: a.map($07e064cd5d4580c1$var$_t)
                        };
                    })({
                        data: e
                    })
            });
        },
        getVault: $07e064cd5d4580c1$var$Ot
    },
    transactions: {
        deposit: $07e064cd5d4580c1$var$ha,
        withdraw: $07e064cd5d4580c1$var$Aa,
        claimExitQueue: $07e064cd5d4580c1$var$ka,
        operate: $07e064cd5d4580c1$var$ba,
        create: $07e064cd5d4580c1$var$ia,
        setDepositDataRoot: $07e064cd5d4580c1$var$Ba,
        setDepositDataManager: $07e064cd5d4580c1$var$Va,
        createEigenPod: $07e064cd5d4580c1$var$Ma,
        setEigenPodOperator: $07e064cd5d4580c1$var$Na,
        updateEigenPodOperator: $07e064cd5d4580c1$var$ja
    }
};
var $07e064cd5d4580c1$var$Qa = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t } = e, a = await t.base.priceOracle.latestAnswer();
    return new $07e064cd5d4580c1$export$714d099a508ef2ab(a).divide($07e064cd5d4580c1$var$C.blockchain.amount1).toString();
});
var $07e064cd5d4580c1$var$Ua = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, ltvPercent: a, mintedAssets: s, stakedAssets: r, vaultAddress: n } = e;
    if ($07e064cd5d4580c1$var$T({
        vaultAddress: n
    }), $07e064cd5d4580c1$var$b({
        ltvPercent: a,
        mintedAssets: s,
        stakedAssets: r
    }), a <= 0 || r <= 0) return 0n;
    const [i, o] = await Promise.all([
        t.base.mintTokenController.avgRewardPerSecond(),
        $07e064cd5d4580c1$var$re({
            vaultAddress: n,
            ltvPercent: a,
            contracts: t
        })
    ]), u = r * o / 10000n, l = u - u * i * 3600n / $07e064cd5d4580c1$var$C.blockchain.amount1 - s;
    if (l > 0) return await t.base.mintTokenController.convertToShares(l);
    return 0n;
});
var $07e064cd5d4580c1$var$za = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { vaultAddress: t, contracts: a } = e, s = a.helpers.createVault(t);
    if (1n === await s.version()) {
        const [e, t] = await Promise.all([
            a.base.mintTokenConfig.v1.liqThresholdPercent(),
            a.base.mintTokenConfig.v1.ltvPercent()
        ]);
        return {
            ltvPercent: t,
            thresholdPercent: e
        };
    }
    {
        const [e, s, r] = await a.base.mintTokenConfig.v2.getConfig(t);
        return {
            ltvPercent: r,
            thresholdPercent: s
        };
    }
});
var $07e064cd5d4580c1$var$Wa = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, vaultAddress: a, ltvPercent: s, mintedAssets: r, stakedAssets: n, newStakedAssets: i } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: a
    }), $07e064cd5d4580c1$var$b({
        ltvPercent: s,
        mintedAssets: r,
        stakedAssets: n,
        newStakedAssets: i
    });
    if (!(r && r > 0)) return 0n;
    const o = r - (n - i) * await $07e064cd5d4580c1$var$re({
        vaultAddress: a,
        ltvPercent: s,
        contracts: t
    }) / 10000n;
    if (o > 0) {
        const e = o > r ? r : o;
        return await t.base.mintTokenController.convertToShares(e) || 0n;
    }
    return 0n;
});
const $07e064cd5d4580c1$var$Ka = (e)=>{
    const { mintedAssets: t, stakedAssets: a, thresholdPercent: s } = e;
    if ($07e064cd5d4580c1$var$b({
        mintedAssets: t,
        stakedAssets: a,
        thresholdPercent: s
    }), 0n === t || 0n === a) return {
        value: 0,
        health: $07e064cd5d4580c1$export$8479cadfc64275dd.Healthy
    };
    const r = Number(new $07e064cd5d4580c1$export$714d099a508ef2ab(a).multiply(s).divide(1e4).divide(t).decimals(4).toString()), n = {
        value: r,
        health: $07e064cd5d4580c1$export$8479cadfc64275dd.Unhealthy
    };
    return n.health = r >= 1.02 ? $07e064cd5d4580c1$export$8479cadfc64275dd.Healthy : r >= 1.01 ? $07e064cd5d4580c1$export$8479cadfc64275dd.Moderate : r >= 1 ? $07e064cd5d4580c1$export$8479cadfc64275dd.Risky : $07e064cd5d4580c1$export$8479cadfc64275dd.Unhealthy, n;
};
var $07e064cd5d4580c1$var$Xa = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, amount: a } = e;
    return await t.base.mintTokenController.convertToShares(a) || 0n;
});
var $07e064cd5d4580c1$var$Ya = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { contracts: t, amount: a } = e;
    return await t.base.mintTokenController.convertToAssets(a) || 0n;
});
const $07e064cd5d4580c1$var$Ja = (e)=>{
    const { contracts: a, options: s, vaultAddress: r, userAddress: n, shares: i } = e;
    $07e064cd5d4580c1$var$b({
        shares: i
    }), $07e064cd5d4580c1$var$T({
        vaultAddress: r,
        userAddress: n
    });
    return {
        vaultContract: a.helpers.createVault(r),
        keeperContract: a.base.keeper,
        vaultAddress: r,
        userAddress: n,
        options: s,
        request: {
            params: [
                {
                    method: "mintOsToken",
                    args: [
                        n,
                        i,
                        (0, $7RlNJ.ZeroAddress)
                    ]
                }
            ]
        }
    };
}, $07e064cd5d4580c1$var$Za = async (e)=>{
    const t = $07e064cd5d4580c1$var$Ja(e);
    return (await $07e064cd5d4580c1$var$xt(t)).hash;
};
$07e064cd5d4580c1$var$Za.encode = async (e)=>{
    const t = $07e064cd5d4580c1$var$Ja(e);
    return $07e064cd5d4580c1$var$pa(t);
}, $07e064cd5d4580c1$var$Za.estimateGas = (e)=>{
    const { provider: t } = e, a = $07e064cd5d4580c1$var$Ja(e);
    return $07e064cd5d4580c1$var$da({
        ...a,
        provider: t
    });
};
const $07e064cd5d4580c1$var$es = (e)=>{
    const { contracts: t, options: a, vaultAddress: s, userAddress: r, shares: n } = e;
    a.network === $07e064cd5d4580c1$export$95be4ae94445245a.Gnosis || (a.network, $07e064cd5d4580c1$export$95be4ae94445245a.Chiado), $07e064cd5d4580c1$var$b({
        shares: n
    }), $07e064cd5d4580c1$var$T({
        vaultAddress: s,
        userAddress: r
    });
    return t.helpers.createVault(s);
}, $07e064cd5d4580c1$var$ts = async (e)=>{
    const { shares: t, provider: a, userAddress: s } = e, r = $07e064cd5d4580c1$var$es(e), n = await a.getSigner(s), i = r.connect(n);
    return (await i.burnOsToken(t)).hash;
};
$07e064cd5d4580c1$var$ts.encode = async (e)=>{
    const { shares: t } = e;
    return $07e064cd5d4580c1$var$es(e).burnOsToken.populateTransaction(t);
}, $07e064cd5d4580c1$var$ts.estimateGas = async (e)=>{
    const { shares: t, provider: a, userAddress: s } = e, r = $07e064cd5d4580c1$var$es(e), n = await r.burnOsToken.estimateGas(t, {
        from: s
    });
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: n,
        provider: a
    });
};
var $07e064cd5d4580c1$var$as = {
    requests: {
        getAPY: (e)=>{
            const { options: t } = e;
            return $07e064cd5d4580c1$var$bt.subgraph.osToken.fetchOsTokenApyQuery({
                url: $07e064cd5d4580c1$var$I(t),
                modifyResult: (e)=>e?.osTokens?.[0]?.apy || "0"
            });
        },
        getRate: $07e064cd5d4580c1$var$Qa,
        getConfig: $07e064cd5d4580c1$var$za,
        getMaxMint: $07e064cd5d4580c1$var$Ua,
        getPosition: (e)=>{
            const { options: t, contracts: a, vaultAddress: s, userAddress: r, stakedAssets: n, thresholdPercent: i } = e;
            return $07e064cd5d4580c1$var$T({
                vaultAddress: s,
                userAddress: r
            }), $07e064cd5d4580c1$var$b({
                stakedAssets: n,
                thresholdPercent: i
            }), ((e)=>{
                const { options: t, vaultAddress: a, userAddress: s } = e;
                return $07e064cd5d4580c1$var$bt.subgraph.osToken.fetchOsTokenPositionsQuery({
                    url: $07e064cd5d4580c1$var$I(t),
                    variables: {
                        vaultAddress: a,
                        address: s
                    },
                    modifyResult: (e)=>BigInt(e?.osTokenPositions?.[0]?.shares || 0)
                });
            })({
                options: t,
                vaultAddress: s,
                userAddress: r
            }).then(async (e)=>{
                const t = a.helpers.createVault(s), o = await t.osTokenPositions(r), [u, l] = await Promise.all([
                    a.base.mintTokenController.convertToAssets(o),
                    a.base.mintTokenController.feePercent()
                ]), c = l / 100n;
                return {
                    minted: {
                        assets: u,
                        shares: o,
                        fee: o - e
                    },
                    healthFactor: $07e064cd5d4580c1$var$Ka({
                        mintedAssets: u,
                        stakedAssets: n,
                        thresholdPercent: i
                    }),
                    protocolFeePercent: c
                };
            });
        },
        getBurnAmount: $07e064cd5d4580c1$var$Wa,
        getHealthFactor: $07e064cd5d4580c1$var$Ka,
        getSharesFromAssets: $07e064cd5d4580c1$var$Xa,
        getAssetsFromShares: $07e064cd5d4580c1$var$Ya,
        getAvgRewardsPerSecond: (e)=>{
            const { options: t } = e;
            return $07e064cd5d4580c1$var$bt.subgraph.osToken.fetchOsTokenRewardPerSecondQuery({
                url: $07e064cd5d4580c1$var$I(t),
                variables: {
                    first: 14,
                    orderBy: "createdAt",
                    orderDirection: "desc"
                },
                modifyResult: (e)=>{
                    let t = 0n;
                    const a = BigInt(e.osTokenSnapshots.length || 0);
                    if (a) t = e.osTokenSnapshots.reduce((e, { avgRewardPerSecond: t })=>e + BigInt(t), 0n) / a;
                    return t;
                }
            });
        }
    },
    transactions: {
        mint: $07e064cd5d4580c1$var$Za,
        burn: $07e064cd5d4580c1$var$ts
    }
};
var $07e064cd5d4580c1$var$ss = $07e064cd5d4580c1$var$ot(async (e)=>{
    const { vaultAddress: t, userAddress: a, rewardSplitterAddress: s, options: r, contracts: n } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: t,
        userAddress: a,
        rewardSplitterAddress: s
    });
    const i = {
        vaultAddress: t,
        userAddress: a,
        rewardSplitterAddress: s,
        options: r,
        contracts: n
    }, o = await (async (e)=>{
        const { vaultAddress: t, userAddress: a, rewardSplitterAddress: s, options: r, contracts: n } = e, i = {
            params: [
                {
                    method: "syncRewards",
                    args: []
                },
                {
                    method: "rewardsOf",
                    args: [
                        a
                    ]
                }
            ],
            callStatic: !0
        }, o = await $07e064cd5d4580c1$var$Pt({
            request: i,
            options: r,
            userAddress: a,
            vaultAddress: t,
            keeperContract: n.base.keeper,
            rewardSplitterContract: n.helpers.createRewardSplitter(s)
        });
        return o?.[1]?.[0] || 0n;
    })({
        ...i,
        rewardSplitterAddress: s
    });
    return o ? (async (e)=>{
        const { shares: t, vaultAddress: a, userAddress: s, options: r, contracts: n } = e, i = {
            params: [
                {
                    method: "convertToAssets",
                    args: [
                        t
                    ]
                }
            ],
            callStatic: !0
        }, o = await $07e064cd5d4580c1$var$xt({
            request: i,
            options: r,
            userAddress: s,
            vaultAddress: a,
            keeperContract: n.base.keeper,
            vaultContract: n.helpers.createVault(a)
        });
        return 0n | o?.[0]?.assets;
    })({
        ...i,
        shares: o
    }) : 0n;
});
const $07e064cd5d4580c1$var$rs = async (e)=>{
    const { contracts: t, userAddress: a, vaultAddress: s, options: r, rewardSplitterAddress: n, assets: i } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: s,
        userAddress: a,
        rewardSplitterAddress: n
    }), $07e064cd5d4580c1$var$b({
        assets: i
    });
    const o = {
        rewardSplitterContract: t.helpers.createRewardSplitter(n),
        keeperContract: t.base.keeper,
        vaultAddress: s,
        userAddress: a,
        options: r
    }, u = await (async (e)=>{
        const { assets: t, vaultAddress: a, userAddress: s, options: r, contracts: n } = e, i = {
            params: [
                {
                    method: "convertToShares",
                    args: [
                        t
                    ]
                }
            ],
            callStatic: !0
        }, o = await $07e064cd5d4580c1$var$xt({
            request: i,
            options: r,
            userAddress: s,
            vaultAddress: a,
            keeperContract: n.base.keeper,
            vaultContract: n.helpers.createVault(a)
        });
        return 0n | o?.[0]?.shares;
    })({
        assets: i,
        vaultAddress: s,
        userAddress: a,
        options: r,
        contracts: t
    });
    return {
        ...o,
        request: {
            params: [
                {
                    method: "syncRewards",
                    args: []
                },
                {
                    method: "enterExitQueue",
                    args: [
                        u,
                        a
                    ]
                }
            ]
        }
    };
}, $07e064cd5d4580c1$var$ns = async (e)=>{
    const t = await $07e064cd5d4580c1$var$rs(e);
    return (await $07e064cd5d4580c1$var$Pt(t)).hash;
};
$07e064cd5d4580c1$var$ns.encode = async (e)=>{
    const t = await $07e064cd5d4580c1$var$rs(e);
    return $07e064cd5d4580c1$var$Pt({
        ...t,
        request: {
            ...t.request,
            transactionData: !0
        }
    });
}, $07e064cd5d4580c1$var$ns.estimateGas = async (e)=>{
    const { provider: t } = e, a = await $07e064cd5d4580c1$var$rs(e), s = await $07e064cd5d4580c1$var$Pt({
        ...a,
        request: {
            ...a.request,
            estimateGas: !0
        }
    });
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: s,
        provider: t
    });
};
const $07e064cd5d4580c1$var$is = async (e)=>{
    const { contracts: t, userAddress: a, vaultAddress: s, provider: r } = e;
    $07e064cd5d4580c1$var$T({
        vaultAddress: s,
        userAddress: a
    }), await $07e064cd5d4580c1$var$ea(e);
    const n = await r.getSigner(a);
    return t.base.rewardSplitterFactory.connect(n);
}, $07e064cd5d4580c1$var$os = async (e)=>{
    const t = await $07e064cd5d4580c1$var$is(e);
    return (await t.createRewardSplitter(e.vaultAddress)).hash;
};
$07e064cd5d4580c1$var$os.encode = async (e)=>(await $07e064cd5d4580c1$var$is(e)).createRewardSplitter.populateTransaction(e.vaultAddress), $07e064cd5d4580c1$var$os.estimateGas = async (e)=>{
    const { provider: t } = e, a = await $07e064cd5d4580c1$var$is(e), s = await a.createRewardSplitter.estimateGas(e.vaultAddress);
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: s,
        provider: t
    });
};
const $07e064cd5d4580c1$var$us = (t, a)=>{
    Object.keys(t).forEach((s)=>{
        const r = t[s];
        $07e064cd5d4580c1$var$w({
            [s]: t[s]
        }, a);
        const n = r.every(({ address: t, shares: a })=>(0, $klTOW.isAddress)(t) && "bigint" == typeof a);
        if (!n) throw new Error(`The "${s}" argument must be an array of objects with "address" and "shares" keys`);
    });
}, $07e064cd5d4580c1$var$ls = async (e)=>{
    const { contracts: t, userAddress: a, vaultAddress: s, options: r, rewardSplitterAddress: n, feeRecipients: i } = e;
    let o = e.oldFeeRecipients;
    $07e064cd5d4580c1$var$T({
        vaultAddress: s,
        userAddress: a,
        rewardSplitterAddress: n
    }), $07e064cd5d4580c1$var$us({
        feeRecipients: i
    }), o && $07e064cd5d4580c1$var$us({
        oldFeeRecipients: o
    }, !1), await $07e064cd5d4580c1$var$ea(e);
    const u = {
        rewardSplitterContract: t.helpers.createRewardSplitter(n),
        keeperContract: t.base.keeper,
        vaultAddress: s,
        userAddress: a,
        options: r
    };
    if (!o) {
        const { rewardSplitters: e } = await $07e064cd5d4580c1$var$Ha.requests.getRewardSplitters({
            owner: a,
            options: r,
            vaultAddress: s,
            rewardSplitterAddress: n
        });
        if (!e) throw new Error("Reward splitter not found");
        o = e[0]?.feeRecipients || [];
    }
    const l = {}, c = {}, d = o.map(({ address: e })=>e.toLowerCase());
    o.forEach(({ address: e, shares: t })=>{
        const a = e.toLowerCase(), s = i.find((e)=>e.address.toLowerCase() === a);
        if (s) {
            const a = s.shares - t;
            a > 0n && (l[e] = a), a < 0n && (c[e] = t - s.shares);
        } else c[e] = t;
    }), i.forEach(({ address: e, shares: t })=>{
        !d.includes(e.toLowerCase()) && (l[e] = t);
    });
    const p = [];
    return Object.keys(l).forEach((e)=>{
        p.push({
            method: "increaseShares",
            args: [
                e,
                l[e].toString()
            ]
        });
    }), Object.keys(c).forEach((e)=>{
        p.push({
            method: "decreaseShares",
            args: [
                e,
                c[e].toString()
            ]
        });
    }), {
        ...u,
        request: {
            params: p
        }
    };
}, $07e064cd5d4580c1$var$cs = async (e)=>{
    const t = await $07e064cd5d4580c1$var$ls(e);
    return (await $07e064cd5d4580c1$var$Pt(t)).hash;
};
$07e064cd5d4580c1$var$cs.encode = async (e)=>{
    const t = await $07e064cd5d4580c1$var$ls(e);
    return $07e064cd5d4580c1$var$Pt({
        ...t,
        request: {
            ...t.request,
            transactionData: !0
        }
    });
}, $07e064cd5d4580c1$var$cs.estimateGas = async (e)=>{
    const { provider: t } = e, a = await $07e064cd5d4580c1$var$ls(e), s = await $07e064cd5d4580c1$var$Pt({
        ...a,
        request: {
            ...a.request,
            estimateGas: !0
        }
    });
    return $07e064cd5d4580c1$export$e28db7cbe64d1041({
        estimatedGas: s,
        provider: t
    });
};
var $07e064cd5d4580c1$var$ds = {
    requests: {
        getClaimAmount: $07e064cd5d4580c1$var$ss
    },
    transactions: {
        create: $07e064cd5d4580c1$var$os,
        claimRewards: $07e064cd5d4580c1$var$ns,
        updateFeeRecipients: $07e064cd5d4580c1$var$cs
    }
};
const $07e064cd5d4580c1$var$ps = (e, t)=>Object.keys(e).reduce((a, s)=>{
        const r = e[s], n = (e)=>r({
                ...e || {},
                ...t
            });
        return ((e, t, a)=>{
            [
                "encode",
                "estimateGas"
            ].forEach((s)=>{
                "function" == typeof e[s] && (t[s] = (t)=>e[s]({
                        ...t || {},
                        ...a
                    }));
            });
        })(r, n, t), {
            ...a,
            [s]: n
        };
    }, {}), $07e064cd5d4580c1$var$ys = (e)=>$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$ya, e), $07e064cd5d4580c1$var$ms = (e)=>({
        ...$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$Ha.requests, e),
        ...$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$Ha.transactions, e)
    }), $07e064cd5d4580c1$var$hs = (e)=>({
        ...$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$as.requests, e),
        ...$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$as.transactions, e)
    }), $07e064cd5d4580c1$var$fs = (e)=>({
        ...$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$ds.requests, e),
        ...$07e064cd5d4580c1$var$ps($07e064cd5d4580c1$var$ds.transactions, e)
    });
class $07e064cd5d4580c1$export$14a4f206f73bf7a8 {
    utils;
    config;
    options;
    provider;
    vault;
    contracts;
    osToken;
    rewardSplitter;
    constructor(e){
        const t = $07e064cd5d4580c1$export$c884d9dcb329c3c[e.network], a = e.provider || $07e064cd5d4580c1$export$500fbc0cd14cdbaa(e), s = $07e064cd5d4580c1$var$We({
            provider: a,
            config: t
        });
        this.config = t, this.options = e, this.provider = a, this.contracts = s;
        const r = {
            options: e,
            contracts: s,
            provider: a
        };
        this.utils = $07e064cd5d4580c1$var$ys(r), this.vault = $07e064cd5d4580c1$var$ms(r), this.osToken = $07e064cd5d4580c1$var$hs(r), this.rewardSplitter = $07e064cd5d4580c1$var$fs(r);
    }
    getVaultFactory({ vaultType: e, isErc20: t }) {
        return (({ vaultType: e, contracts: t, isErc20: a })=>(a ? {
                [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Default]: t.factories.erc20Vault,
                [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Private]: t.factories.erc20PrivateVault,
                [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Blocklist]: t.factories.erc20BlocklistVault
            } : {
                [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Default]: t.factories.vault,
                [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Private]: t.factories.privateVault,
                [$07e064cd5d4580c1$export$74d89d9a07cc40e2.Blocklist]: t.factories.blocklistVault
            })[e || $07e064cd5d4580c1$export$74d89d9a07cc40e2.Default])({
            vaultType: e,
            isErc20: t,
            contracts: this.contracts
        });
    }
    vaultMulticall({ userAddress: e, vaultAddress: t, request: a }) {
        return $07e064cd5d4580c1$var$xt({
            vaultContract: this.contracts.helpers.createVault(t),
            keeperContract: this.contracts.base.keeper,
            options: this.options,
            vaultAddress: t,
            userAddress: e,
            request: a
        });
    }
    rewardSplitterMulticall(e) {
        const { userAddress: t, vaultAddress: a, rewardSplitterAddress: s, request: r } = e;
        return $07e064cd5d4580c1$var$Pt({
            rewardSplitterContract: this.contracts.helpers.createRewardSplitter(s),
            keeperContract: this.contracts.base.keeper,
            options: this.options,
            vaultAddress: a,
            userAddress: t,
            request: r
        });
    }
    getGas(e) {
        return $07e064cd5d4580c1$export$e28db7cbe64d1041({
            provider: this.provider,
            estimatedGas: e
        });
    }
    get network() {
        return this.options.network;
    }
}
const $07e064cd5d4580c1$export$af1c0561ce3e4019 = $07e064cd5d4580c1$var$C.chains;

});
parcelRegister("b6VUG", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", () => $816d2d9d4a0a65b4$export$fe041e1a83d3efc6);
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");

var $9crV3 = parcelRequire("9crV3");

var $hQ6Uj = parcelRequire("hQ6Uj");

var $k6258 = parcelRequire("k6258");

var $bZCOh = parcelRequire("bZCOh");

var $enzxJ = parcelRequire("enzxJ");

var $iTOl8 = parcelRequire("iTOl8");

var $9N0DX = parcelRequire("9N0DX");

var $17b8S = parcelRequire("17b8S");

var $fEITJ = parcelRequire("fEITJ");

var $b2u7e = parcelRequire("b2u7e");

var $9SChd = parcelRequire("9SChd");

var $95T0n = parcelRequire("95T0n");
// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $816d2d9d4a0a65b4$var$PanicReasons = new Map();
$816d2d9d4a0a65b4$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x11, "OVERFLOW");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $816d2d9d4a0a65b4$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $816d2d9d4a0a65b4$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $816d2d9d4a0a65b4$var$defaultCoder = null;
let $816d2d9d4a0a65b4$var$defaultMaxInflation = 1024;
function $816d2d9d4a0a65b4$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $lJSYP.getBytes)(data);
        data = (0, $lJSYP.hexlify)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $lJSYP.hexlify)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $lJSYP.hexlify)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$816d2d9d4a0a65b4$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $95T0n.getAddress)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $95T0n.getAddress)(tx.from);
    return (0, $8wwEQ.makeError)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $816d2d9d4a0a65b4$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $k6258.ArrayCoder)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $b2u7e.TupleCoder)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $hQ6Uj.AddressCoder)(param.name);
            case "bool":
                return new (0, $bZCOh.BooleanCoder)(param.name);
            case "string":
                return new (0, $fEITJ.StringCoder)(param.name);
            case "bytes":
                return new (0, $enzxJ.BytesCoder)(param.name);
            case "":
                return new (0, $9N0DX.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($816d2d9d4a0a65b4$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $8wwEQ.assertArgument)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $17b8S.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($816d2d9d4a0a65b4$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $8wwEQ.assertArgument)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $iTOl8.FixedBytesCoder)(size, param.name);
        }
        (0, $8wwEQ.assertArgument)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $9SChd.ParamType).from(type)));
        const coder = new (0, $b2u7e.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $8wwEQ.assertArgumentCount)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $9SChd.ParamType).from(type)));
        const coder = new (0, $b2u7e.TupleCoder)(coders, "_");
        const writer = new (0, $9crV3.Writer)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $9SChd.ParamType).from(type)));
        const coder = new (0, $b2u7e.TupleCoder)(coders, "_");
        return coder.decode(new (0, $9crV3.Reader)(data, loose, $816d2d9d4a0a65b4$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $8wwEQ.assertArgument)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $816d2d9d4a0a65b4$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($816d2d9d4a0a65b4$var$defaultCoder == null) $816d2d9d4a0a65b4$var$defaultCoder = new $816d2d9d4a0a65b4$export$fe041e1a83d3efc6();
        return $816d2d9d4a0a65b4$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $816d2d9d4a0a65b4$var$getBuiltinCallException(action, tx, data, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}

});
parcelRegister("8wwEQ", function(module, exports) {

$parcel$export(module.exports, "isError", () => $634aa51198273feb$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isCallException", () => $634aa51198273feb$export$748c4fa78f31ff35);
$parcel$export(module.exports, "makeError", () => $634aa51198273feb$export$5a4bb2b1c89bdce7);
$parcel$export(module.exports, "assert", () => $634aa51198273feb$export$a7a9523472993e97);
$parcel$export(module.exports, "assertArgument", () => $634aa51198273feb$export$c3d31707e5030f5e);
$parcel$export(module.exports, "assertArgumentCount", () => $634aa51198273feb$export$d228410a8a77e4fa);
$parcel$export(module.exports, "assertNormalize", () => $634aa51198273feb$export$d993e67fefdfecda);
$parcel$export(module.exports, "assertPrivate", () => $634aa51198273feb$export$ac1a938d48ec8c7b);
/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ 
var $dGVI0 = parcelRequire("dGVI0");

var $7N4fp = parcelRequire("7N4fp");
function $634aa51198273feb$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($634aa51198273feb$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $634aa51198273feb$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$634aa51198273feb$var$stringify(k)}: ${$634aa51198273feb$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $634aa51198273feb$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $634aa51198273feb$export$748c4fa78f31ff35(error) {
    return $634aa51198273feb$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$634aa51198273feb$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $634aa51198273feb$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $dGVI0.version)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $7N4fp.defineProperties)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $7N4fp.defineProperties)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $634aa51198273feb$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info);
}
function $634aa51198273feb$export$c3d31707e5030f5e(check, message, name, value) {
    $634aa51198273feb$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $634aa51198273feb$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $634aa51198273feb$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $634aa51198273feb$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $634aa51198273feb$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $634aa51198273feb$export$d993e67fefdfecda(form) {
    $634aa51198273feb$export$a7a9523472993e97($634aa51198273feb$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $634aa51198273feb$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $634aa51198273feb$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}

});
parcelRegister("dGVI0", function(module, exports) {

$parcel$export(module.exports, "version", () => $9f7bf65ddafc81a6$export$83d89fbfd8236492);
/* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "6.13.2";

});

parcelRegister("7N4fp", function(module, exports) {

$parcel$export(module.exports, "resolveProperties", () => $5ac0677dd70fe0c6$export$d503dd157d963b60);
$parcel$export(module.exports, "defineProperties", () => $5ac0677dd70fe0c6$export$b61bda4fbca264f2);
/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $5ac0677dd70fe0c6$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $5ac0677dd70fe0c6$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $5ac0677dd70fe0c6$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $5ac0677dd70fe0c6$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}

});


parcelRegister("lJSYP", function(module, exports) {

$parcel$export(module.exports, "getBytes", () => $fd3872da8feed9cb$export$a3521add2594f3c8);
$parcel$export(module.exports, "getBytesCopy", () => $fd3872da8feed9cb$export$37110e7fee0af4ad);
$parcel$export(module.exports, "isHexString", () => $fd3872da8feed9cb$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytesLike", () => $fd3872da8feed9cb$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "hexlify", () => $fd3872da8feed9cb$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "concat", () => $fd3872da8feed9cb$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "dataLength", () => $fd3872da8feed9cb$export$2321cd91b99770ff);
$parcel$export(module.exports, "dataSlice", () => $fd3872da8feed9cb$export$f6d845ffb449edc9);
$parcel$export(module.exports, "zeroPadValue", () => $fd3872da8feed9cb$export$4473860254365feb);
$parcel$export(module.exports, "zeroPadBytes", () => $fd3872da8feed9cb$export$1dc7fbe1b8738fe7);
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
var $8wwEQ = parcelRequire("8wwEQ");
function $fd3872da8feed9cb$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $8wwEQ.assertArgument)(false, "invalid BytesLike value", name || "value", value);
}
function $fd3872da8feed9cb$export$a3521add2594f3c8(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, false);
}
function $fd3872da8feed9cb$export$37110e7fee0af4ad(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, true);
}
function $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $fd3872da8feed9cb$export$9a14abb1a440cd5e(value) {
    return $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $fd3872da8feed9cb$var$HexCharacters = "0123456789abcdef";
function $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $fd3872da8feed9cb$var$HexCharacters[(v & 0xf0) >> 4] + $fd3872da8feed9cb$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $fd3872da8feed9cb$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$fd3872da8feed9cb$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $fd3872da8feed9cb$export$2321cd91b99770ff(data) {
    if ($fd3872da8feed9cb$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $fd3872da8feed9cb$export$a3521add2594f3c8(data).length;
}
function $fd3872da8feed9cb$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $8wwEQ.assert)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $fd3872da8feed9cb$export$9c854001a22ebaa2(data) {
    let bytes = $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $fd3872da8feed9cb$var$zeroPad(data, length, left) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    (0, $8wwEQ.assert)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(result);
}
function $fd3872da8feed9cb$export$4473860254365feb(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, true);
}
function $fd3872da8feed9cb$export$1dc7fbe1b8738fe7(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, false);
}

});

parcelRegister("9crV3", function(module, exports) {

$parcel$export(module.exports, "WordSize", () => $6b2ae433bec33333$export$b4b1d1fba463e69c);
$parcel$export(module.exports, "Result", () => $6b2ae433bec33333$export$8fdcabde73f49165);
$parcel$export(module.exports, "Coder", () => $6b2ae433bec33333$export$2c0c39526f8bad46);
$parcel$export(module.exports, "Writer", () => $6b2ae433bec33333$export$d7a960146e1a269e);
$parcel$export(module.exports, "Reader", () => $6b2ae433bec33333$export$2f7a2f0e90c07dc4);

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");
const $6b2ae433bec33333$export$b4b1d1fba463e69c = 32;
const $6b2ae433bec33333$var$Padding = new Uint8Array($6b2ae433bec33333$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $6b2ae433bec33333$var$passProperties = [
    "then"
];
const $6b2ae433bec33333$var$_guard = {};
const $6b2ae433bec33333$var$resultNames = new WeakMap();
function $6b2ae433bec33333$var$getNames(result) {
    return $6b2ae433bec33333$var$resultNames.get(result);
}
function $6b2ae433bec33333$var$setNames(result, names) {
    $6b2ae433bec33333$var$resultNames.set(result, names);
}
function $6b2ae433bec33333$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
function $6b2ae433bec33333$var$toObject(names, items, deep) {
    if (names.indexOf(null) >= 0) return items.map((item, index)=>{
        if (item instanceof $6b2ae433bec33333$export$8fdcabde73f49165) return $6b2ae433bec33333$var$toObject($6b2ae433bec33333$var$getNames(item), item, deep);
        return item;
    });
    return names.reduce((accum, name, index)=>{
        let item = items.getValue(name);
        if (!(name in accum)) {
            if (deep && item instanceof $6b2ae433bec33333$export$8fdcabde73f49165) item = $6b2ae433bec33333$var$toObject($6b2ae433bec33333$var$getNames(item), item, deep);
            accum[name] = item;
        }
        return accum;
    }, {});
}
class $6b2ae433bec33333$export$8fdcabde73f49165 extends Array {
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $6b2ae433bec33333$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        $6b2ae433bec33333$var$setNames(this, Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        })));
        // Dummy operations to prevent TypeScript from complaining
        this.#names = [];
        if (this.#names == null) this.#names;
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        const proxy = new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $9AgaV.getNumber)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($6b2ae433bec33333$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
        $6b2ae433bec33333$var$setNames(proxy, $6b2ae433bec33333$var$getNames(this));
        return proxy;
    }
    /**
     *  Returns the Result as a normal Array. If %%deep%%, any children
     *  which are Result objects are also converted to a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray(deep) {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${index}`, item);
            if (deep && item instanceof $6b2ae433bec33333$export$8fdcabde73f49165) item = item.toArray(deep);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair. If
     *  %%deep%%, any children which are Result objects are also
     *  converted to an Object.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject(deep) {
        const names = $6b2ae433bec33333$var$getNames(this);
        return names.reduce((accum, name, index)=>{
            (0, $8wwEQ.assert)(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            return $6b2ae433bec33333$var$toObject(names, this, deep);
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const _names = $6b2ae433bec33333$var$getNames(this);
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(_names[i]);
        }
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const _names = $6b2ae433bec33333$var$getNames(this);
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(_names[i]);
            }
        }
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = $6b2ae433bec33333$var$getNames(this).indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $6b2ae433bec33333$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, items, keys);
    }
}
function $6b2ae433bec33333$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $6b2ae433bec33333$var$getValue(value) {
    let bytes = (0, $9AgaV.toBeArray)(value);
    (0, $8wwEQ.assert)(bytes.length <= $6b2ae433bec33333$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $6b2ae433bec33333$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $6b2ae433bec33333$export$b4b1d1fba463e69c) bytes = (0, $lJSYP.getBytesCopy)((0, $lJSYP.concat)([
        $6b2ae433bec33333$var$Padding.slice(bytes.length % $6b2ae433bec33333$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $6b2ae433bec33333$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $7N4fp.defineProperties)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $8wwEQ.assertArgument)(false, message, this.localName, value);
    }
}
class $6b2ae433bec33333$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $lJSYP.concat)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $lJSYP.getBytesCopy)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $lJSYP.getBytesCopy)(value);
        const paddingOffset = bytes.length % $6b2ae433bec33333$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $lJSYP.getBytesCopy)((0, $lJSYP.concat)([
            bytes,
            $6b2ae433bec33333$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($6b2ae433bec33333$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($6b2ae433bec33333$var$Padding);
        this.#dataLength += $6b2ae433bec33333$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $6b2ae433bec33333$var$getValue(value);
        };
    }
}
class $6b2ae433bec33333$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $7N4fp.defineProperties)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $lJSYP.getBytesCopy)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $lJSYP.hexlify)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $8wwEQ.assert)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $lJSYP.getBytesCopy)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $6b2ae433bec33333$export$b4b1d1fba463e69c) * $6b2ae433bec33333$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $8wwEQ.assert)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $lJSYP.getBytesCopy)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $6b2ae433bec33333$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $9AgaV.toBigInt)(this.readBytes($6b2ae433bec33333$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $9AgaV.toNumber)(this.readBytes($6b2ae433bec33333$export$b4b1d1fba463e69c));
    }
}

});
parcelRegister("9AgaV", function(module, exports) {

$parcel$export(module.exports, "fromTwos", () => $6fa405e57bb6371e$export$92182edcfa20e5bc);
$parcel$export(module.exports, "getNumber", () => $6fa405e57bb6371e$export$b14f2714108df84);
$parcel$export(module.exports, "toTwos", () => $6fa405e57bb6371e$export$7101cd4e6275351c);
$parcel$export(module.exports, "getBigInt", () => $6fa405e57bb6371e$export$61fe455e2b1e28a4);
$parcel$export(module.exports, "mask", () => $6fa405e57bb6371e$export$d99f0801a68bbcf1);
$parcel$export(module.exports, "toBigInt", () => $6fa405e57bb6371e$export$c221a145703ab783);
$parcel$export(module.exports, "toNumber", () => $6fa405e57bb6371e$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "toBeHex", () => $6fa405e57bb6371e$export$c6ebe05badb16181);
$parcel$export(module.exports, "toBeArray", () => $6fa405e57bb6371e$export$b627fcfb5ea68cb0);
$parcel$export(module.exports, "toQuantity", () => $6fa405e57bb6371e$export$d9c067986dbc68dd);
/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 
var $lJSYP = parcelRequire("lJSYP");

var $8wwEQ = parcelRequire("8wwEQ");
const $6fa405e57bb6371e$var$BN_0 = BigInt(0);
const $6fa405e57bb6371e$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $6fa405e57bb6371e$var$maxValue = 0x1fffffffffffff;
function $6fa405e57bb6371e$export$92182edcfa20e5bc(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    (0, $8wwEQ.assert)(value >> width === $6fa405e57bb6371e$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $6fa405e57bb6371e$var$BN_1) {
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return -((~value & mask) + $6fa405e57bb6371e$var$BN_1);
    }
    return value;
}
function $6fa405e57bb6371e$export$7101cd4e6275351c(_value, _width) {
    let value = $6fa405e57bb6371e$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    const limit = $6fa405e57bb6371e$var$BN_1 << width - $6fa405e57bb6371e$var$BN_1;
    if (value < $6fa405e57bb6371e$var$BN_0) {
        value = -value;
        (0, $8wwEQ.assert)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return (~value & mask) + $6fa405e57bb6371e$var$BN_1;
    } else (0, $8wwEQ.assert)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $6fa405e57bb6371e$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_bits, "bits"));
    return value & ($6fa405e57bb6371e$var$BN_1 << bits) - $6fa405e57bb6371e$var$BN_1;
}
function $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $8wwEQ.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $8wwEQ.assertArgument)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $8wwEQ.assertArgument)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $8wwEQ.assertArgument)(false, "invalid BigNumberish value", name || "value", value);
}
function $6fa405e57bb6371e$export$8677d6ca9282a154(value, name) {
    const result = $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name);
    (0, $8wwEQ.assert)(result >= $6fa405e57bb6371e$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $6fa405e57bb6371e$var$Nibbles = "0123456789abcdef";
function $6fa405e57bb6371e$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $6fa405e57bb6371e$var$Nibbles[v >> 4];
            result += $6fa405e57bb6371e$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $6fa405e57bb6371e$export$61fe455e2b1e28a4(value);
}
function $6fa405e57bb6371e$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $8wwEQ.assertArgument)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $8wwEQ.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $8wwEQ.assertArgument)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $6fa405e57bb6371e$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $8wwEQ.assertArgument)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $8wwEQ.assertArgument)(false, "invalid numeric value", name || "value", value);
}
function $6fa405e57bb6371e$export$a0a81dc3380ce7d3(value) {
    return $6fa405e57bb6371e$export$b14f2714108df84($6fa405e57bb6371e$export$c221a145703ab783(value));
}
function $6fa405e57bb6371e$export$c6ebe05badb16181(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $6fa405e57bb6371e$export$b14f2714108df84(_width, "width");
        (0, $8wwEQ.assert)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $6fa405e57bb6371e$export$b627fcfb5ea68cb0(_value) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    if (value === $6fa405e57bb6371e$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $6fa405e57bb6371e$export$d9c067986dbc68dd(value) {
    let result = (0, $lJSYP.hexlify)((0, $lJSYP.isBytesLike)(value) ? value : $6fa405e57bb6371e$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}

});


parcelRegister("hQ6Uj", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", () => $cfcca69ef482e07c$export$59dbbded7775bfe7);

var $95T0n = parcelRequire("95T0n");

var $9AgaV = parcelRequire("9AgaV");

var $lj9AR = parcelRequire("lj9AR");

var $9crV3 = parcelRequire("9crV3");
class $cfcca69ef482e07c$export$59dbbded7775bfe7 extends (0, $9crV3.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $lj9AR.Typed).dereference(_value, "string");
        try {
            value = (0, $95T0n.getAddress)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $95T0n.getAddress)((0, $9AgaV.toBeHex)(reader.readValue(), 20));
    }
}

});
parcelRegister("95T0n", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $69ef3f917ff239a2$export$88411125f012957a);
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
const $69ef3f917ff239a2$var$BN_0 = BigInt(0);
const $69ef3f917ff239a2$var$BN_36 = BigInt(36);
function $69ef3f917ff239a2$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $lJSYP.getBytes)((0, $dnGYA.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $69ef3f917ff239a2$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$69ef3f917ff239a2$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$69ef3f917ff239a2$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $69ef3f917ff239a2$var$safeDigits = 15;
function $69ef3f917ff239a2$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $69ef3f917ff239a2$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $69ef3f917ff239a2$var$safeDigits){
        let block = expanded.substring(0, $69ef3f917ff239a2$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $69ef3f917ff239a2$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $69ef3f917ff239a2$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $69ef3f917ff239a2$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $69ef3f917ff239a2$var$BN_36 + $69ef3f917ff239a2$var$Base36[value[i]];
    return result;
}
function $69ef3f917ff239a2$export$88411125f012957a(address) {
    (0, $8wwEQ.assertArgument)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $69ef3f917ff239a2$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $8wwEQ.assertArgument)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $8wwEQ.assertArgument)(address.substring(2, 4) === $69ef3f917ff239a2$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $69ef3f917ff239a2$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $69ef3f917ff239a2$var$getChecksumAddress("0x" + result);
    }
    (0, $8wwEQ.assertArgument)(false, "invalid address", "address", address);
}
function $69ef3f917ff239a2$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($69ef3f917ff239a2$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $69ef3f917ff239a2$var$ibanChecksum("XE00" + base36) + base36;
}

});
parcelRegister("11WK3", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => (parcelRequire("dnGYA")).keccak256);
$parcel$export(module.exports, "sha256", () => (parcelRequire("gzqDp")).sha256);
/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ 
var $gjLY1 = parcelRequire("gjLY1");

var $dnGYA = parcelRequire("dnGYA");

var $ac3Nq = parcelRequire("ac3Nq");

var $cpy10 = parcelRequire("cpy10");

var $cqpUy = parcelRequire("cqpUy");

var $jSGE7 = parcelRequire("jSGE7");

var $gzqDp = parcelRequire("gzqDp");

var $7fKql = parcelRequire("7fKql");

var $fv2Aw = parcelRequire("fv2Aw");
/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $0c0373556082ea84$export$6a9f04c98a658ecb() {
    (0, $gjLY1.computeHmac).lock();
    (0, $dnGYA.keccak256).lock();
    (0, $cpy10.pbkdf2).lock();
    (0, $cqpUy.randomBytes).lock();
    (0, $ac3Nq.ripemd160).lock();
    (0, $jSGE7.scrypt).lock();
    (0, $jSGE7.scryptSync).lock();
    (0, $gzqDp.sha256).lock();
    (0, $gzqDp.sha512).lock();
    (0, $cqpUy.randomBytes).lock();
}

});
parcelRegister("gjLY1", function(module, exports) {

$parcel$export(module.exports, "computeHmac", () => $be13a0f2e0d9ad05$export$967075d2f3b8e7ff);
/**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ 
var $1RfGo = parcelRequire("1RfGo");

var $lJSYP = parcelRequire("lJSYP");
let $be13a0f2e0d9ad05$var$locked = false;
const $be13a0f2e0d9ad05$var$_computeHmac = function(algorithm, key, data) {
    return (0, $1RfGo.createHmac)(algorithm, key).update(data).digest();
};
let $be13a0f2e0d9ad05$var$__computeHmac = $be13a0f2e0d9ad05$var$_computeHmac;
function $be13a0f2e0d9ad05$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $lJSYP.getBytes)(_key, "key");
    const data = (0, $lJSYP.getBytes)(_data, "data");
    return (0, $lJSYP.hexlify)($be13a0f2e0d9ad05$var$__computeHmac(algorithm, key, data));
}
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff._ = $be13a0f2e0d9ad05$var$_computeHmac;
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.lock = function() {
    $be13a0f2e0d9ad05$var$locked = true;
};
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.register = function(func) {
    if ($be13a0f2e0d9ad05$var$locked) throw new Error("computeHmac is locked");
    $be13a0f2e0d9ad05$var$__computeHmac = func;
};
Object.freeze($be13a0f2e0d9ad05$export$967075d2f3b8e7ff);

});
parcelRegister("1RfGo", function(module, exports) {

$parcel$export(module.exports, "createHash", () => $15a6e7f1608663ad$export$2fb37efbf6ae0c0e);
$parcel$export(module.exports, "createHmac", () => $15a6e7f1608663ad$export$da39cf97e1eb7c91);
$parcel$export(module.exports, "pbkdf2Sync", () => $15a6e7f1608663ad$export$b80c7ba289c8fa56);
$parcel$export(module.exports, "randomBytes", () => $15a6e7f1608663ad$export$5f828d93ff035aa8);
/* Browser Crypto Shims */ 
var $70Xw9 = parcelRequire("70Xw9");

var $c2cs5 = parcelRequire("c2cs5");

var $6XnWx = parcelRequire("6XnWx");

var $3dtER = parcelRequire("3dtER");

var $8wwEQ = parcelRequire("8wwEQ");
function $15a6e7f1608663ad$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $15a6e7f1608663ad$var$anyGlobal = $15a6e7f1608663ad$var$getGlobal();
const $15a6e7f1608663ad$var$crypto = $15a6e7f1608663ad$var$anyGlobal.crypto || $15a6e7f1608663ad$var$anyGlobal.msCrypto;
function $15a6e7f1608663ad$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $6XnWx.sha256).create();
        case "sha512":
            return (0, $3dtER.sha512).create();
    }
    (0, $8wwEQ.assertArgument)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $15a6e7f1608663ad$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $6XnWx.sha256,
        sha512: $3dtER.sha512
    }[_algo];
    (0, $8wwEQ.assertArgument)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $70Xw9.hmac).create(algo, key);
}
function $15a6e7f1608663ad$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $6XnWx.sha256,
        sha512: $3dtER.sha512
    }[_algo];
    (0, $8wwEQ.assertArgument)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $c2cs5.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $15a6e7f1608663ad$export$5f828d93ff035aa8(length) {
    (0, $8wwEQ.assert)($15a6e7f1608663ad$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $8wwEQ.assertArgument)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $15a6e7f1608663ad$var$crypto.getRandomValues(result);
    return result;
}

});
parcelRegister("70Xw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// HMAC (RFC 2104)
class $51b6b372898f65c0$var$HMAC extends $3Bcdj.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $dNiq9.hash)(hash);
        const key = (0, $3Bcdj.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $dNiq9.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $51b6b372898f65c0$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $51b6b372898f65c0$var$hmac;
module.exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);

});
parcelRegister("dNiq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $a0ae23f5901291b4$var$number;
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $a0ae23f5901291b4$var$bool;
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $a0ae23f5901291b4$var$bytes;
function $a0ae23f5901291b4$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(hash.outputLen);
    $a0ae23f5901291b4$var$number(hash.blockLen);
}
module.exports.hash = $a0ae23f5901291b4$var$hash;
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $a0ae23f5901291b4$var$exists;
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $a0ae23f5901291b4$var$output;
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
module.exports.default = $a0ae23f5901291b4$var$assert;

});

parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $dUxV2 = parcelRequire("dUxV2");
const $29ee4d3171d9809b$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    if (!$29ee4d3171d9809b$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    if (!$29ee4d3171d9809b$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$29ee4d3171d9809b$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
const $29ee4d3171d9809b$var$toStr = {}.toString;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $29ee4d3171d9809b$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === "function") return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("c2cs5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");
// Common prologue and epilogue for sync/async functions
function $8c2f54a153cf1baf$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $dNiq9.hash)(hash);
    const opts = (0, $3Bcdj.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $dNiq9.number)(c);
    (0, $dNiq9.number)(dkLen);
    (0, $dNiq9.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $3Bcdj.toBytes)(_password);
    const salt = (0, $3Bcdj.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $70Xw9.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $8c2f54a153cf1baf$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $3Bcdj.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $8c2f54a153cf1baf$var$pbkdf2;
async function $8c2f54a153cf1baf$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $3Bcdj.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $3Bcdj.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2Async = $8c2f54a153cf1baf$var$pbkdf2Async;

});

parcelRegister("6XnWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $g9W9K = parcelRequire("g9W9K");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $510ad3657d73a9d2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $510ad3657d73a9d2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $510ad3657d73a9d2$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $g9W9K.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + $510ad3657d73a9d2$var$Chi(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + $510ad3657d73a9d2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
module.exports.sha224 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());

});
parcelRegister("g9W9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// Polyfill for Safari 14
function $bc3a993d7d38a7a0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $bc3a993d7d38a7a0$var$SHA2 extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $bc3a993d7d38a7a0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $bc3a993d7d38a7a0$var$SHA2;

});


parcelRegister("3dtER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $g9W9K = parcelRequire("g9W9K");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$2579977b4e52adba$var$SHA512_Kh, $2579977b4e52adba$var$SHA512_Kl] = /* @__PURE__ */ (()=>$eDgKs.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $2579977b4e52adba$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $2579977b4e52adba$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $2579977b4e52adba$var$SHA512 extends $g9W9K.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $2579977b4e52adba$var$SHA512_W_H[i] = view.getUint32(offset);
            $2579977b4e52adba$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $2579977b4e52adba$var$SHA512_W_H[i - 15] | 0;
            const W15l = $2579977b4e52adba$var$SHA512_W_L[i - 15] | 0;
            const s0h = $eDgKs.default.rotrSH(W15h, W15l, 1) ^ $eDgKs.default.rotrSH(W15h, W15l, 8) ^ $eDgKs.default.shrSH(W15h, W15l, 7);
            const s0l = $eDgKs.default.rotrSL(W15h, W15l, 1) ^ $eDgKs.default.rotrSL(W15h, W15l, 8) ^ $eDgKs.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $2579977b4e52adba$var$SHA512_W_H[i - 2] | 0;
            const W2l = $2579977b4e52adba$var$SHA512_W_L[i - 2] | 0;
            const s1h = $eDgKs.default.rotrSH(W2h, W2l, 19) ^ $eDgKs.default.rotrBH(W2h, W2l, 61) ^ $eDgKs.default.shrSH(W2h, W2l, 6);
            const s1l = $eDgKs.default.rotrSL(W2h, W2l, 19) ^ $eDgKs.default.rotrBL(W2h, W2l, 61) ^ $eDgKs.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $eDgKs.default.add4L(s0l, s1l, $2579977b4e52adba$var$SHA512_W_L[i - 7], $2579977b4e52adba$var$SHA512_W_L[i - 16]);
            const SUMh = $eDgKs.default.add4H(SUMl, s0h, s1h, $2579977b4e52adba$var$SHA512_W_H[i - 7], $2579977b4e52adba$var$SHA512_W_H[i - 16]);
            $2579977b4e52adba$var$SHA512_W_H[i] = SUMh | 0;
            $2579977b4e52adba$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $eDgKs.default.rotrSH(Eh, El, 14) ^ $eDgKs.default.rotrSH(Eh, El, 18) ^ $eDgKs.default.rotrBH(Eh, El, 41);
            const sigma1l = $eDgKs.default.rotrSL(Eh, El, 14) ^ $eDgKs.default.rotrSL(Eh, El, 18) ^ $eDgKs.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $eDgKs.default.add5L(Hl, sigma1l, CHIl, $2579977b4e52adba$var$SHA512_Kl[i], $2579977b4e52adba$var$SHA512_W_L[i]);
            const T1h = $eDgKs.default.add5H(T1ll, Hh, sigma1h, CHIh, $2579977b4e52adba$var$SHA512_Kh[i], $2579977b4e52adba$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $eDgKs.default.rotrSH(Ah, Al, 28) ^ $eDgKs.default.rotrBH(Ah, Al, 34) ^ $eDgKs.default.rotrBH(Ah, Al, 39);
            const sigma0l = $eDgKs.default.rotrSL(Ah, Al, 28) ^ $eDgKs.default.rotrBL(Ah, Al, 34) ^ $eDgKs.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $eDgKs.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $eDgKs.default.add3L(T1l, sigma0l, MAJl);
            Ah = $eDgKs.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $eDgKs.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $eDgKs.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $eDgKs.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $eDgKs.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $eDgKs.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $eDgKs.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $eDgKs.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $eDgKs.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $2579977b4e52adba$var$SHA512_W_H.fill(0);
        $2579977b4e52adba$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $2579977b4e52adba$var$SHA512;
class $2579977b4e52adba$var$SHA512_224 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $2579977b4e52adba$var$SHA512_256 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $2579977b4e52adba$var$SHA384 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512());
module.exports.sha512_224 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_224());
module.exports.sha512_256 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_256());
module.exports.sha384 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA384());

});
parcelRegister("eDgKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $aa71b30d36adb919$var$fromBig;
function $aa71b30d36adb919$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $aa71b30d36adb919$var$split;
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $aa71b30d36adb919$var$add;
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
module.exports.default = $aa71b30d36adb919$var$u64;

});




parcelRegister("dnGYA", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $9bdec2813ce7c52b$export$f8151fce47ad1c35);
/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ 
var $J0sDk = parcelRequire("J0sDk");

var $lJSYP = parcelRequire("lJSYP");
let $9bdec2813ce7c52b$var$locked = false;
const $9bdec2813ce7c52b$var$_keccak256 = function(data) {
    return (0, $J0sDk.keccak_256)(data);
};
let $9bdec2813ce7c52b$var$__keccak256 = $9bdec2813ce7c52b$var$_keccak256;
function $9bdec2813ce7c52b$export$f8151fce47ad1c35(_data) {
    const data = (0, $lJSYP.getBytes)(_data, "data");
    return (0, $lJSYP.hexlify)($9bdec2813ce7c52b$var$__keccak256(data));
}
$9bdec2813ce7c52b$export$f8151fce47ad1c35._ = $9bdec2813ce7c52b$var$_keccak256;
$9bdec2813ce7c52b$export$f8151fce47ad1c35.lock = function() {
    $9bdec2813ce7c52b$var$locked = true;
};
$9bdec2813ce7c52b$export$f8151fce47ad1c35.register = function(func) {
    if ($9bdec2813ce7c52b$var$locked) throw new TypeError("keccak256 is locked");
    $9bdec2813ce7c52b$var$__keccak256 = func;
};
Object.freeze($9bdec2813ce7c52b$export$f8151fce47ad1c35);

});
parcelRegister("J0sDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$08748f983f07956b$var$SHA3_PI, $08748f983f07956b$var$SHA3_ROTL, $08748f983f07956b$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $08748f983f07956b$var$_0n = /* @__PURE__ */ BigInt(0);
const $08748f983f07956b$var$_1n = /* @__PURE__ */ BigInt(1);
const $08748f983f07956b$var$_2n = /* @__PURE__ */ BigInt(2);
const $08748f983f07956b$var$_7n = /* @__PURE__ */ BigInt(7);
const $08748f983f07956b$var$_256n = /* @__PURE__ */ BigInt(256);
const $08748f983f07956b$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $08748f983f07956b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $08748f983f07956b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $08748f983f07956b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $08748f983f07956b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $08748f983f07956b$var$_1n ^ (R >> $08748f983f07956b$var$_7n) * $08748f983f07956b$var$_0x71n) % $08748f983f07956b$var$_256n;
        if (R & $08748f983f07956b$var$_2n) t ^= $08748f983f07956b$var$_1n << ($08748f983f07956b$var$_1n << /* @__PURE__ */ BigInt(j)) - $08748f983f07956b$var$_1n;
    }
    $08748f983f07956b$var$_SHA3_IOTA.push(t);
}
const [$08748f983f07956b$var$SHA3_IOTA_H, $08748f983f07956b$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $eDgKs.split)($08748f983f07956b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $08748f983f07956b$var$rotlH = (h, l, s)=>s > 32 ? (0, $eDgKs.rotlBH)(h, l, s) : (0, $eDgKs.rotlSH)(h, l, s);
const $08748f983f07956b$var$rotlL = (h, l, s)=>s > 32 ? (0, $eDgKs.rotlBL)(h, l, s) : (0, $eDgKs.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $08748f983f07956b$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $08748f983f07956b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $08748f983f07956b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $08748f983f07956b$var$SHA3_ROTL[t];
            const Th = $08748f983f07956b$var$rotlH(curH, curL, shift);
            const Tl = $08748f983f07956b$var$rotlL(curH, curL, shift);
            const PI = $08748f983f07956b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $08748f983f07956b$var$SHA3_IOTA_H[round];
        s[1] ^= $08748f983f07956b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $08748f983f07956b$var$keccakP;
class $08748f983f07956b$var$Keccak extends $3Bcdj.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $dNiq9.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $3Bcdj.u32)(this.state);
    }
    keccak() {
        $08748f983f07956b$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $dNiq9.exists)(this, false);
        (0, $dNiq9.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $dNiq9.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $dNiq9.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $08748f983f07956b$var$Keccak;
const $08748f983f07956b$var$gen = (suffix, blockLen, outputLen)=>(0, $3Bcdj.wrapConstructor)(()=>new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $08748f983f07956b$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $08748f983f07956b$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $08748f983f07956b$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $08748f983f07956b$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $08748f983f07956b$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $08748f983f07956b$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $08748f983f07956b$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $08748f983f07956b$var$gen(0x01, 72, 64);
const $08748f983f07956b$var$genShake = (suffix, blockLen, outputLen)=>(0, $3Bcdj.wrapXOFConstructorWithOpts)((opts = {})=>new $08748f983f07956b$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $08748f983f07956b$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $08748f983f07956b$var$genShake(0x1f, 136, 32);

});


parcelRegister("ac3Nq", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e);

var $j5xzM = parcelRequire("j5xzM");

var $lJSYP = parcelRequire("lJSYP");
let $76bdf8351c5898c8$var$locked = false;
const $76bdf8351c5898c8$var$_ripemd160 = function(data) {
    return (0, $j5xzM.ripemd160)(data);
};
let $76bdf8351c5898c8$var$__ripemd160 = $76bdf8351c5898c8$var$_ripemd160;
function $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $lJSYP.getBytes)(_data, "data");
    return (0, $lJSYP.hexlify)($76bdf8351c5898c8$var$__ripemd160(data));
}
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e._ = $76bdf8351c5898c8$var$_ripemd160;
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.lock = function() {
    $76bdf8351c5898c8$var$locked = true;
};
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($76bdf8351c5898c8$var$locked) throw new TypeError("ripemd160 is locked");
    $76bdf8351c5898c8$var$__ripemd160 = func;
};
Object.freeze($76bdf8351c5898c8$export$d1cea0ee4e3f0d3e);

});
parcelRegister("j5xzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $g9W9K = parcelRequire("g9W9K");

var $3Bcdj = parcelRequire("3Bcdj");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $de58877bbb165fd5$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $de58877bbb165fd5$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $de58877bbb165fd5$var$Pi = /* @__PURE__ */ $de58877bbb165fd5$var$Id.map((i)=>(9 * i + 5) % 16);
let $de58877bbb165fd5$var$idxL = [
    $de58877bbb165fd5$var$Id
];
let $de58877bbb165fd5$var$idxR = [
    $de58877bbb165fd5$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $de58877bbb165fd5$var$idxL,
    $de58877bbb165fd5$var$idxR
])j.push(j[i].map((k)=>$de58877bbb165fd5$var$Rho[k]));
const $de58877bbb165fd5$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $de58877bbb165fd5$var$shiftsL = /* @__PURE__ */ $de58877bbb165fd5$var$idxL.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$shiftsR = /* @__PURE__ */ $de58877bbb165fd5$var$idxR.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $de58877bbb165fd5$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $de58877bbb165fd5$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $de58877bbb165fd5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $de58877bbb165fd5$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $de58877bbb165fd5$var$RIPEMD160 extends $g9W9K.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$de58877bbb165fd5$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $de58877bbb165fd5$var$Kl[group], hbr = $de58877bbb165fd5$var$Kr[group]; // prettier-ignore
            const rl = $de58877bbb165fd5$var$idxL[group], rr = $de58877bbb165fd5$var$idxR[group]; // prettier-ignore
            const sl = $de58877bbb165fd5$var$shiftsL[group], sr = $de58877bbb165fd5$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $de58877bbb165fd5$var$rotl(al + $de58877bbb165fd5$var$f(group, bl, cl, dl) + $de58877bbb165fd5$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $de58877bbb165fd5$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $de58877bbb165fd5$var$rotl(ar + $de58877bbb165fd5$var$f(rGroup, br, cr, dr) + $de58877bbb165fd5$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $de58877bbb165fd5$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $de58877bbb165fd5$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $de58877bbb165fd5$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $3Bcdj.wrapConstructor)(()=>new $de58877bbb165fd5$var$RIPEMD160());

});


parcelRegister("cpy10", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $9092348e8cf65603$export$448fa22aedc9dbca);
/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 
var $1RfGo = parcelRequire("1RfGo");

var $lJSYP = parcelRequire("lJSYP");
let $9092348e8cf65603$var$locked = false;
const $9092348e8cf65603$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $1RfGo.pbkdf2Sync)(password, salt, iterations, keylen, algo);
};
let $9092348e8cf65603$var$__pbkdf2 = $9092348e8cf65603$var$_pbkdf2;
function $9092348e8cf65603$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $lJSYP.getBytes)(_password, "password");
    const salt = (0, $lJSYP.getBytes)(_salt, "salt");
    return (0, $lJSYP.hexlify)($9092348e8cf65603$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$9092348e8cf65603$export$448fa22aedc9dbca._ = $9092348e8cf65603$var$_pbkdf2;
$9092348e8cf65603$export$448fa22aedc9dbca.lock = function() {
    $9092348e8cf65603$var$locked = true;
};
$9092348e8cf65603$export$448fa22aedc9dbca.register = function(func) {
    if ($9092348e8cf65603$var$locked) throw new Error("pbkdf2 is locked");
    $9092348e8cf65603$var$__pbkdf2 = func;
};
Object.freeze($9092348e8cf65603$export$448fa22aedc9dbca);

});

parcelRegister("cqpUy", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $90bc03290273a6e1$export$5f828d93ff035aa8);
/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
var $1RfGo = parcelRequire("1RfGo");
let $90bc03290273a6e1$var$locked = false;
const $90bc03290273a6e1$var$_randomBytes = function(length) {
    return new Uint8Array((0, $1RfGo.randomBytes)(length));
};
let $90bc03290273a6e1$var$__randomBytes = $90bc03290273a6e1$var$_randomBytes;
function $90bc03290273a6e1$export$5f828d93ff035aa8(length) {
    return $90bc03290273a6e1$var$__randomBytes(length);
}
$90bc03290273a6e1$export$5f828d93ff035aa8._ = $90bc03290273a6e1$var$_randomBytes;
$90bc03290273a6e1$export$5f828d93ff035aa8.lock = function() {
    $90bc03290273a6e1$var$locked = true;
};
$90bc03290273a6e1$export$5f828d93ff035aa8.register = function(func) {
    if ($90bc03290273a6e1$var$locked) throw new Error("randomBytes is locked");
    $90bc03290273a6e1$var$__randomBytes = func;
};
Object.freeze($90bc03290273a6e1$export$5f828d93ff035aa8);

});

parcelRegister("jSGE7", function(module, exports) {

$parcel$export(module.exports, "scrypt", () => $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3);
$parcel$export(module.exports, "scryptSync", () => $e794241b1cb9b0d3$export$86c79e0734c26a76);

var $j1tr8 = parcelRequire("j1tr8");

var $lJSYP = parcelRequire("lJSYP");
let $e794241b1cb9b0d3$var$lockedSync = false, $e794241b1cb9b0d3$var$lockedAsync = false;
const $e794241b1cb9b0d3$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $j1tr8.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $e794241b1cb9b0d3$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $j1tr8.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $e794241b1cb9b0d3$var$__scryptAsync = $e794241b1cb9b0d3$var$_scryptAsync;
let $e794241b1cb9b0d3$var$__scryptSync = $e794241b1cb9b0d3$var$_scryptSync;
async function $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $lJSYP.getBytes)(_passwd, "passwd");
    const salt = (0, $lJSYP.getBytes)(_salt, "salt");
    return (0, $lJSYP.hexlify)(await $e794241b1cb9b0d3$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3._ = $e794241b1cb9b0d3$var$_scryptAsync;
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.lock = function() {
    $e794241b1cb9b0d3$var$lockedAsync = true;
};
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedAsync) throw new Error("scrypt is locked");
    $e794241b1cb9b0d3$var$__scryptAsync = func;
};
Object.freeze($e794241b1cb9b0d3$export$7cf7c2f1ec457bf3);
function $e794241b1cb9b0d3$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $lJSYP.getBytes)(_passwd, "passwd");
    const salt = (0, $lJSYP.getBytes)(_salt, "salt");
    return (0, $lJSYP.hexlify)($e794241b1cb9b0d3$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$e794241b1cb9b0d3$export$86c79e0734c26a76._ = $e794241b1cb9b0d3$var$_scryptSync;
$e794241b1cb9b0d3$export$86c79e0734c26a76.lock = function() {
    $e794241b1cb9b0d3$var$lockedSync = true;
};
$e794241b1cb9b0d3$export$86c79e0734c26a76.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedSync) throw new Error("scryptSync is locked");
    $e794241b1cb9b0d3$var$__scryptSync = func;
};
Object.freeze($e794241b1cb9b0d3$export$86c79e0734c26a76);

});
parcelRegister("j1tr8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scryptAsync = module.exports.scrypt = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $6XnWx = parcelRequire("6XnWx");

var $c2cs5 = parcelRequire("c2cs5");

var $3Bcdj = parcelRequire("3Bcdj");
// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $dd94f1d283dd7b2d$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $dd94f1d283dd7b2d$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $dd94f1d283dd7b2d$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $dd94f1d283dd7b2d$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $dd94f1d283dd7b2d$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $dd94f1d283dd7b2d$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $dd94f1d283dd7b2d$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $dd94f1d283dd7b2d$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $dd94f1d283dd7b2d$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $dd94f1d283dd7b2d$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $dd94f1d283dd7b2d$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $dd94f1d283dd7b2d$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $dd94f1d283dd7b2d$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $dd94f1d283dd7b2d$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $dd94f1d283dd7b2d$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $dd94f1d283dd7b2d$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $dd94f1d283dd7b2d$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $dd94f1d283dd7b2d$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $dd94f1d283dd7b2d$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $dd94f1d283dd7b2d$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $dd94f1d283dd7b2d$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $dd94f1d283dd7b2d$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $dd94f1d283dd7b2d$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $dd94f1d283dd7b2d$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $dd94f1d283dd7b2d$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $dd94f1d283dd7b2d$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $dd94f1d283dd7b2d$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $dd94f1d283dd7b2d$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $dd94f1d283dd7b2d$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $dd94f1d283dd7b2d$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $dd94f1d283dd7b2d$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $dd94f1d283dd7b2d$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $dd94f1d283dd7b2d$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $dd94f1d283dd7b2d$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $dd94f1d283dd7b2d$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $dd94f1d283dd7b2d$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $3Bcdj.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $dNiq9.number)(N);
    (0, $dNiq9.number)(r);
    (0, $dNiq9.number)(p);
    (0, $dNiq9.number)(dkLen);
    (0, $dNiq9.number)(asyncTick);
    (0, $dNiq9.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $c2cs5.pbkdf2)($6XnWx.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $3Bcdj.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $3Bcdj.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $3Bcdj.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $c2cs5.pbkdf2)($6XnWx.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function $dd94f1d283dd7b2d$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
module.exports.scrypt = $dd94f1d283dd7b2d$var$scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function $dd94f1d283dd7b2d$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $3Bcdj.asyncLoop)(N - 1, asyncTick, ()=>{
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $3Bcdj.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
module.exports.scryptAsync = $dd94f1d283dd7b2d$var$scryptAsync;

});


parcelRegister("gzqDp", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $c1049352abb4e7c6$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha512", () => $c1049352abb4e7c6$export$a888d2532e6dc7bb);

var $1RfGo = parcelRequire("1RfGo");

var $lJSYP = parcelRequire("lJSYP");
const $c1049352abb4e7c6$var$_sha256 = function(data) {
    return (0, $1RfGo.createHash)("sha256").update(data).digest();
};
const $c1049352abb4e7c6$var$_sha512 = function(data) {
    return (0, $1RfGo.createHash)("sha512").update(data).digest();
};
let $c1049352abb4e7c6$var$__sha256 = $c1049352abb4e7c6$var$_sha256;
let $c1049352abb4e7c6$var$__sha512 = $c1049352abb4e7c6$var$_sha512;
let $c1049352abb4e7c6$var$locked256 = false, $c1049352abb4e7c6$var$locked512 = false;
function $c1049352abb4e7c6$export$bced8d2aada2d1c9(_data) {
    const data = (0, $lJSYP.getBytes)(_data, "data");
    return (0, $lJSYP.hexlify)($c1049352abb4e7c6$var$__sha256(data));
}
$c1049352abb4e7c6$export$bced8d2aada2d1c9._ = $c1049352abb4e7c6$var$_sha256;
$c1049352abb4e7c6$export$bced8d2aada2d1c9.lock = function() {
    $c1049352abb4e7c6$var$locked256 = true;
};
$c1049352abb4e7c6$export$bced8d2aada2d1c9.register = function(func) {
    if ($c1049352abb4e7c6$var$locked256) throw new Error("sha256 is locked");
    $c1049352abb4e7c6$var$__sha256 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);
function $c1049352abb4e7c6$export$a888d2532e6dc7bb(_data) {
    const data = (0, $lJSYP.getBytes)(_data, "data");
    return (0, $lJSYP.hexlify)($c1049352abb4e7c6$var$__sha512(data));
}
$c1049352abb4e7c6$export$a888d2532e6dc7bb._ = $c1049352abb4e7c6$var$_sha512;
$c1049352abb4e7c6$export$a888d2532e6dc7bb.lock = function() {
    $c1049352abb4e7c6$var$locked512 = true;
};
$c1049352abb4e7c6$export$a888d2532e6dc7bb.register = function(func) {
    if ($c1049352abb4e7c6$var$locked512) throw new Error("sha512 is locked");
    $c1049352abb4e7c6$var$__sha512 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);

});

parcelRegister("7fKql", function(module, exports) {

$parcel$export(module.exports, "SigningKey", () => $015cdebda6711d1b$export$21643ca94aed3e83);
/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ 
var $5r7db = parcelRequire("5r7db");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $9AgaV = parcelRequire("9AgaV");

var $fv2Aw = parcelRequire("fv2Aw");
class $015cdebda6711d1b$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataLength)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $lJSYP.hexlify)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $5r7db.secp256k1).sign((0, $lJSYP.getBytesCopy)(digest), (0, $lJSYP.getBytesCopy)(this.#privateKey), {
            lowS: true
        });
        return (0, $fv2Aw.Signature).from({
            r: (0, $9AgaV.toBeHex)(sig.r, 32),
            s: (0, $9AgaV.toBeHex)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $lJSYP.hexlify)((0, $5r7db.secp256k1).getSharedSecret((0, $lJSYP.getBytesCopy)(this.#privateKey), (0, $lJSYP.getBytes)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $lJSYP.getBytes)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $5r7db.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, $lJSYP.hexlify)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $5r7db.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, $lJSYP.hexlify)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $fv2Aw.Signature).from(signature);
        let secpSig = (0, $5r7db.secp256k1).Signature.fromCompact((0, $lJSYP.getBytesCopy)((0, $lJSYP.concat)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $lJSYP.getBytesCopy)(digest));
        (0, $8wwEQ.assertArgument)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $5r7db.secp256k1).ProjectivePoint.fromHex($015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $5r7db.secp256k1).ProjectivePoint.fromHex($015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}

});
parcelRegister("5r7db", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $6XnWx = parcelRequire("6XnWx");

var $3Bcdj = parcelRequire("3Bcdj");

var $2D9sF = parcelRequire("2D9sF");

var $gNPqy = parcelRequire("gNPqy");

var $esaJO = parcelRequire("esaJO");

var $rkPJ6 = parcelRequire("rkPJ6");

var $7OcHe = parcelRequire("7OcHe");
const $3f551179096121b9$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $3f551179096121b9$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $3f551179096121b9$var$_1n = BigInt(1);
const $3f551179096121b9$var$_2n = BigInt(2);
const $3f551179096121b9$var$divNearest = (a, b)=>(a + b / $3f551179096121b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fp.eql($3f551179096121b9$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $3f551179096121b9$var$Fp = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1P, undefined, undefined, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
module.exports.secp256k1 = (0, $7OcHe.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $3f551179096121b9$var$Fp,
    n: $3f551179096121b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $3f551179096121b9$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$3f551179096121b9$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $3f551179096121b9$var$divNearest(b2 * k, n);
            const c2 = $3f551179096121b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $2D9sF.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $2D9sF.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $6XnWx.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $3f551179096121b9$var$_0n = BigInt(0);
const $3f551179096121b9$var$fe = (x)=>typeof x === "bigint" && $3f551179096121b9$var$_0n < x && x < $3f551179096121b9$var$secp256k1P;
const $3f551179096121b9$var$ge = (x)=>typeof x === "bigint" && $3f551179096121b9$var$_0n < x && x < $3f551179096121b9$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $6XnWx.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $esaJO.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $6XnWx.sha256)((0, $esaJO.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $3f551179096121b9$var$numTo32b = (n)=>(0, $esaJO.numberToBytesBE)(n, 32);
const $3f551179096121b9$var$modP = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1P);
const $3f551179096121b9$var$modN = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1N);
const $3f551179096121b9$var$Point = module.exports.secp256k1.ProjectivePoint;
const $3f551179096121b9$var$GmulAdd = (Q, a, b)=>$3f551179096121b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    let d_ = module.exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $3f551179096121b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $3f551179096121b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    if (!$3f551179096121b9$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $3f551179096121b9$var$modP(x * x);
    const c = $3f551179096121b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $3f551179096121b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $3f551179096121b9$var$_2n !== $3f551179096121b9$var$_0n) y = $3f551179096121b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $3f551179096121b9$var$Point(x, y, $3f551179096121b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$modN((0, $esaJO.bytesToNumberBE)($3f551179096121b9$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(privateKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, privateKey, auxRand = (0, $3Bcdj.randomBytes)(32)) {
    const m = (0, $esaJO.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $esaJO.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $3f551179096121b9$var$numTo32b(d ^ (0, $esaJO.bytesToNumberBE)($3f551179096121b9$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $3f551179096121b9$var$modN((0, $esaJO.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $3f551179096121b9$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($3f551179096121b9$var$numTo32b($3f551179096121b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $esaJO.ensureBytes)("signature", signature, 64);
    const m = (0, $esaJO.ensureBytes)("message", message);
    const pub = (0, $esaJO.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $3f551179096121b9$var$lift_x((0, $esaJO.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $esaJO.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$3f551179096121b9$var$fe(r)) return false;
        const s = (0, $esaJO.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$3f551179096121b9$var$ge(s)) return false;
        const e = $3f551179096121b9$var$challenge($3f551179096121b9$var$numTo32b(r), $3f551179096121b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $3f551179096121b9$var$GmulAdd(P, s, $3f551179096121b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
module.exports.schnorr = (()=>({
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: module.exports.secp256k1.utils.randomPrivateKey,
            lift_x: $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes,
            numberToBytesBE: $esaJO.numberToBytesBE,
            bytesToNumberBE: $esaJO.bytesToNumberBE,
            taggedHash: $3f551179096121b9$var$taggedHash,
            mod: $2D9sF.mod
        }
    }))();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $rkPJ6.isogenyMap)($3f551179096121b9$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $gNPqy.mapToCurveSimpleSWU)($3f551179096121b9$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $3f551179096121b9$var$Fp.create(BigInt("-11"))
    }))();
const $3f551179096121b9$var$htf = /* @__PURE__ */ (()=>(0, $rkPJ6.createHasher)(module.exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fp.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $3f551179096121b9$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $6XnWx.sha256
    }))();
module.exports.hashToCurve = (()=>$3f551179096121b9$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$3f551179096121b9$var$htf.encodeToCurve)();

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $esaJO = parcelRequire("esaJO");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = BigInt(2), $1ea6901afdde618b$var$_3n = BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = BigInt(4), $1ea6901afdde618b$var$_5n = BigInt(5), $1ea6901afdde618b$var$_8n = BigInt(8);
// prettier-ignore
const $1ea6901afdde618b$var$_9n = BigInt(9), $1ea6901afdde618b$var$_16n = BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
module.exports.mod = $1ea6901afdde618b$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $1ea6901afdde618b$var$pow(num, power, modulo) {
    if (modulo <= $1ea6901afdde618b$var$_0n || power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $1ea6901afdde618b$var$_1n) return $1ea6901afdde618b$var$_0n;
    let res = $1ea6901afdde618b$var$_1n;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return res;
}
module.exports.pow = $1ea6901afdde618b$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
// Inverses number over modulo
function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n || modulo <= $1ea6901afdde618b$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error("invert: does not exist");
    return $1ea6901afdde618b$var$mod(x, modulo);
}
module.exports.invert = $1ea6901afdde618b$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1ea6901afdde618b$var$_1n, S = 0; Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n; Q /= $1ea6901afdde618b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1ea6901afdde618b$var$_2n; Z < P && $1ea6901afdde618b$var$pow(Z, legendreC, P) !== P - $1ea6901afdde618b$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1ea6901afdde618b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
function $1ea6901afdde618b$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) {
        const c1 = (P - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1ea6901afdde618b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $esaJO.validateObject)(field, opts);
}
module.exports.validateField = $1ea6901afdde618b$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power > 0");
    if (power === $1ea6901afdde618b$var$_0n) return f.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $1ea6901afdde618b$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
function $1ea6901afdde618b$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1ea6901afdde618b$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $1ea6901afdde618b$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $esaJO.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $esaJO.numberToBytesLE)(num, BYTES) : (0, $esaJO.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $esaJO.bytesToNumberLE)(bytes) : (0, $esaJO.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $1ea6901afdde618b$var$Field;
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $esaJO.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(hash) : (0, $esaJO.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $esaJO.bytesToNumberBE)(key) : (0, $esaJO.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $esaJO.numberToBytesLE)(reduced, fieldLen) : (0, $esaJO.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

});
parcelRegister("esaJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a85c028f110aa8ce$var$_0n = BigInt(0);
const $a85c028f110aa8ce$var$_1n = BigInt(1);
const $a85c028f110aa8ce$var$_2n = BigInt(2);
const $a85c028f110aa8ce$var$u8a = (a)=>a instanceof Uint8Array;
const $a85c028f110aa8ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a85c028f110aa8ce$var$bytesToHex(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a85c028f110aa8ce$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a85c028f110aa8ce$var$bytesToHex;
function $a85c028f110aa8ce$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $a85c028f110aa8ce$var$numberToHexUnpadded;
function $a85c028f110aa8ce$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $a85c028f110aa8ce$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a85c028f110aa8ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a85c028f110aa8ce$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $a85c028f110aa8ce$var$bytesToNumberBE(bytes) {
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $a85c028f110aa8ce$var$bytesToNumberBE;
function $a85c028f110aa8ce$var$bytesToNumberLE(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $a85c028f110aa8ce$var$bytesToNumberLE;
function $a85c028f110aa8ce$var$numberToBytesBE(n, len) {
    return $a85c028f110aa8ce$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $a85c028f110aa8ce$var$numberToBytesBE;
function $a85c028f110aa8ce$var$numberToBytesLE(n, len) {
    return $a85c028f110aa8ce$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $a85c028f110aa8ce$var$numberToBytesLE;
// Unpadded, rarely used
function $a85c028f110aa8ce$var$numberToVarBytesBE(n) {
    return $a85c028f110aa8ce$var$hexToBytes($a85c028f110aa8ce$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $a85c028f110aa8ce$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a85c028f110aa8ce$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a85c028f110aa8ce$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a85c028f110aa8ce$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $a85c028f110aa8ce$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a85c028f110aa8ce$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a85c028f110aa8ce$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a85c028f110aa8ce$var$concatBytes;
function $a85c028f110aa8ce$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $a85c028f110aa8ce$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a85c028f110aa8ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a85c028f110aa8ce$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a85c028f110aa8ce$var$bitLen(n) {
    let len;
    for(len = 0; n > $a85c028f110aa8ce$var$_0n; n >>= $a85c028f110aa8ce$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $a85c028f110aa8ce$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a85c028f110aa8ce$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a85c028f110aa8ce$var$_1n;
}
module.exports.bitGet = $a85c028f110aa8ce$var$bitGet;
/**
 * Sets single bit at position.
 */ const $a85c028f110aa8ce$var$bitSet = (n, pos, value)=>{
    return n | (value ? $a85c028f110aa8ce$var$_1n : $a85c028f110aa8ce$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $a85c028f110aa8ce$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a85c028f110aa8ce$var$bitMask = (n)=>($a85c028f110aa8ce$var$_2n << BigInt(n - 1)) - $a85c028f110aa8ce$var$_1n;
module.exports.bitMask = $a85c028f110aa8ce$var$bitMask;
// DRBG
const $a85c028f110aa8ce$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a85c028f110aa8ce$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a85c028f110aa8ce$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a85c028f110aa8ce$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a85c028f110aa8ce$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a85c028f110aa8ce$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a85c028f110aa8ce$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a85c028f110aa8ce$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a85c028f110aa8ce$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $a85c028f110aa8ce$var$createHmacDrbg;
// Validating curves and fields
const $a85c028f110aa8ce$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a85c028f110aa8ce$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a85c028f110aa8ce$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $a85c028f110aa8ce$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("gNPqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapToCurveSimpleSWU = module.exports.SWUFpSqrtRatio = module.exports.weierstrass = module.exports.weierstrassPoints = module.exports.DER = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");

var $lkFCe = parcelRequire("lkFCe");
function $c3b91d553ab14e64$var$validatePointOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $c3b91d553ab14e64$var$b2n, hexToBytes: $c3b91d553ab14e64$var$h2b } = $esaJO;
module.exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = module.exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $c3b91d553ab14e64$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = module.exports.DER;
        const data = typeof hex === "string" ? $c3b91d553ab14e64$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = module.exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = module.exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$var$weierstrassPoints(opts) {
    const CURVE = $c3b91d553ab14e64$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $esaJO.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $c3b91d553ab14e64$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $esaJO.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $esaJO.bytesToNumberBE((0, $esaJO.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $2D9sF.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $esaJO.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $c3b91d553ab14e64$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $c3b91d553ab14e64$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $c3b91d553ab14e64$var$_0n || k2 > $c3b91d553ab14e64$var$_0n){
                if (k1 & $c3b91d553ab14e64$var$_1n) k1p = k1p.add(d);
                if (k2 & $c3b91d553ab14e64$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $c3b91d553ab14e64$var$_1n;
                k2 >>= $c3b91d553ab14e64$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $c3b91d553ab14e64$var$_0n || a === $c3b91d553ab14e64$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $esaJO.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $lkFCe.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
module.exports.weierstrassPoints = $c3b91d553ab14e64$var$weierstrassPoints;
function $c3b91d553ab14e64$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $c3b91d553ab14e64$var$weierstrass(curveDef) {
    const CURVE = $c3b91d553ab14e64$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $c3b91d553ab14e64$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $2D9sF.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $2D9sF.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $c3b91d553ab14e64$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $esaJO.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $esaJO.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $c3b91d553ab14e64$var$_1n) === $c3b91d553ab14e64$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$esaJO.bytesToHex($esaJO.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$esaJO.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $esaJO.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $esaJO.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $esaJO.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $esaJO.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $esaJO.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $2D9sF.getMinHashLength(CURVE.n);
            return $2D9sF.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $esaJO.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $esaJO.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($c3b91d553ab14e64$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $esaJO.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $esaJO.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $esaJO.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $esaJO.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $esaJO.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $esaJO.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof module.exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
module.exports.weierstrass = $c3b91d553ab14e64$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
module.exports.SWUFpSqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $c3b91d553ab14e64$var$mapToCurveSimpleSWU(Fp, opts) {
    $2D9sF.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
module.exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$var$mapToCurveSimpleSWU;

});
parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $esaJO.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});


parcelRegister("rkPJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createHasher = module.exports.isogenyMap = module.exports.hash_to_field = module.exports.expand_message_xof = module.exports.expand_message_xmd = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
function $0522aeca5769187c$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $esaJO.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $esaJO.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $0522aeca5769187c$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $esaJO.concatBytes)((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $esaJO.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $esaJO.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $esaJO.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $esaJO.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $esaJO.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
module.exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
module.exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $esaJO.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isNum(count);
    const DST = $0522aeca5769187c$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
module.exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
module.exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
function $0522aeca5769187c$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
module.exports.createHasher = $0522aeca5769187c$var$createHasher;

});

parcelRegister("7OcHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCurve = module.exports.getHash = void 0;

var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");

var $gNPqy = parcelRequire("gNPqy");
// connects noble-curves to noble-hashes
function $5af70d1c5fca3e4e$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $70Xw9.hmac)(hash, key, (0, $3Bcdj.concatBytes)(...msgs)),
        randomBytes: $3Bcdj.randomBytes
    };
}
module.exports.getHash = $5af70d1c5fca3e4e$var$getHash;
function $5af70d1c5fca3e4e$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $gNPqy.weierstrass)({
            ...curveDef,
            ...$5af70d1c5fca3e4e$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
module.exports.createCurve = $5af70d1c5fca3e4e$var$createCurve;

});


parcelRegister("fv2Aw", function(module, exports) {

$parcel$export(module.exports, "Signature", () => $b48bc2308ad845a5$export$848620f5f2f26e86);

var $iZPQy = parcelRequire("iZPQy");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $9AgaV = parcelRequire("9AgaV");
// Constants
const $b48bc2308ad845a5$var$BN_0 = BigInt(0);
const $b48bc2308ad845a5$var$BN_1 = BigInt(1);
const $b48bc2308ad845a5$var$BN_2 = BigInt(2);
const $b48bc2308ad845a5$var$BN_27 = BigInt(27);
const $b48bc2308ad845a5$var$BN_28 = BigInt(28);
const $b48bc2308ad845a5$var$BN_35 = BigInt(35);
const $b48bc2308ad845a5$var$_guard = {};
function $b48bc2308ad845a5$var$toUint256(value) {
    return (0, $lJSYP.zeroPadValue)((0, $9AgaV.toBeArray)(value), 32);
}
class $b48bc2308ad845a5$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataLength)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $lJSYP.hexlify)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataLength)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $lJSYP.hexlify)(_value);
        (0, $8wwEQ.assertArgument)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $9AgaV.getNumber)(value, "value");
        (0, $8wwEQ.assertArgument)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $b48bc2308ad845a5$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $lJSYP.getBytes)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $lJSYP.hexlify)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $lJSYP.concat)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $lJSYP.concat)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $8wwEQ.assertPrivate)(guard, $b48bc2308ad845a5$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $9AgaV.getBigInt)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $b48bc2308ad845a5$var$BN_27 || bv == $b48bc2308ad845a5$var$BN_28) return $b48bc2308ad845a5$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $8wwEQ.assertArgument)(bv >= $b48bc2308ad845a5$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $b48bc2308ad845a5$var$BN_35) / $b48bc2308ad845a5$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $9AgaV.getBigInt)(chainId) * $b48bc2308ad845a5$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $9AgaV.getBigInt)(v);
        if (bv === $b48bc2308ad845a5$var$BN_0 || bv === $b48bc2308ad845a5$var$BN_27) return 27;
        if (bv === $b48bc2308ad845a5$var$BN_1 || bv === $b48bc2308ad845a5$var$BN_28) return 28;
        (0, $8wwEQ.assertArgument)(bv >= $b48bc2308ad845a5$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $b48bc2308ad845a5$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $8wwEQ.assertArgument)(check, message, "signature", sig);
        }
        if (sig == null) return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, (0, $iZPQy.ZeroHash), (0, $iZPQy.ZeroHash), 27);
        if (typeof sig === "string") {
            const bytes = (0, $lJSYP.getBytes)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $lJSYP.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, (0, $lJSYP.hexlify)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $lJSYP.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $b48bc2308ad845a5$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, (0, $lJSYP.hexlify)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $b48bc2308ad845a5$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $b48bc2308ad845a5$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $b48bc2308ad845a5$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $lJSYP.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $lJSYP.getBytes)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $lJSYP.hexlify)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $lJSYP.getBytes)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $9AgaV.getBigInt)(_v);
                return {
                    networkV: v >= $b48bc2308ad845a5$var$BN_35 ? v : undefined,
                    v: $b48bc2308ad845a5$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $lJSYP.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $lJSYP.getBytes)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $9AgaV.getNumber)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $9AgaV.getNumber)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}

});
parcelRegister("iZPQy", function(module, exports) {

$parcel$export(module.exports, "ZeroHash", () => $dd46242704dbba3d$export$89c2533b29c23a61);
/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $dd46242704dbba3d$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});





parcelRegister("lj9AR", function(module, exports) {

$parcel$export(module.exports, "Typed", () => $f832d0621d63460e$export$af51273277efe223);
/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
const $f832d0621d63460e$var$_gaurd = {};
function $f832d0621d63460e$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $f832d0621d63460e$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $f832d0621d63460e$var$_typedSymbol = Symbol.for("_ethers_typed");
class $f832d0621d63460e$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $8wwEQ.assertPrivate)($f832d0621d63460e$var$_gaurd, gaurd, "Typed");
        (0, $7N4fp.defineProperties)(this, {
            _typedSymbol: $f832d0621d63460e$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $f832d0621d63460e$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $f832d0621d63460e$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $f832d0621d63460e$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $f832d0621d63460e$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $f832d0621d63460e$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $f832d0621d63460e$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $f832d0621d63460e$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $f832d0621d63460e$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $f832d0621d63460e$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $f832d0621d63460e$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $f832d0621d63460e$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $f832d0621d63460e$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $f832d0621d63460e$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $f832d0621d63460e$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $f832d0621d63460e$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $f832d0621d63460e$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $f832d0621d63460e$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $f832d0621d63460e$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $f832d0621d63460e$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $f832d0621d63460e$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $f832d0621d63460e$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $f832d0621d63460e$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $f832d0621d63460e$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $f832d0621d63460e$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $f832d0621d63460e$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $f832d0621d63460e$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $f832d0621d63460e$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $f832d0621d63460e$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $f832d0621d63460e$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $f832d0621d63460e$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $f832d0621d63460e$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $f832d0621d63460e$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $f832d0621d63460e$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $f832d0621d63460e$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $f832d0621d63460e$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $f832d0621d63460e$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $f832d0621d63460e$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $f832d0621d63460e$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $f832d0621d63460e$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $f832d0621d63460e$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $f832d0621d63460e$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $f832d0621d63460e$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $f832d0621d63460e$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $f832d0621d63460e$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $f832d0621d63460e$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $f832d0621d63460e$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $f832d0621d63460e$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $f832d0621d63460e$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $f832d0621d63460e$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $f832d0621d63460e$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $f832d0621d63460e$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $f832d0621d63460e$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $f832d0621d63460e$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $f832d0621d63460e$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $f832d0621d63460e$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $f832d0621d63460e$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $f832d0621d63460e$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $f832d0621d63460e$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $f832d0621d63460e$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $f832d0621d63460e$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $f832d0621d63460e$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $f832d0621d63460e$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $f832d0621d63460e$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $f832d0621d63460e$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $f832d0621d63460e$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $f832d0621d63460e$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $f832d0621d63460e$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $f832d0621d63460e$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $f832d0621d63460e$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $f832d0621d63460e$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $f832d0621d63460e$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $f832d0621d63460e$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $f832d0621d63460e$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $f832d0621d63460e$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $f832d0621d63460e$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $f832d0621d63460e$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $f832d0621d63460e$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $f832d0621d63460e$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $f832d0621d63460e$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $f832d0621d63460e$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $f832d0621d63460e$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $f832d0621d63460e$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $f832d0621d63460e$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $f832d0621d63460e$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $f832d0621d63460e$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $f832d0621d63460e$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $f832d0621d63460e$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $f832d0621d63460e$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $f832d0621d63460e$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $f832d0621d63460e$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $f832d0621d63460e$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $f832d0621d63460e$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $f832d0621d63460e$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $f832d0621d63460e$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $f832d0621d63460e$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $f832d0621d63460e$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $f832d0621d63460e$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $f832d0621d63460e$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $f832d0621d63460e$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($f832d0621d63460e$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}

});


parcelRegister("k6258", function(module, exports) {

$parcel$export(module.exports, "pack", () => $ea15fb9331abacb9$export$2a703dbb0cb35339);
$parcel$export(module.exports, "unpack", () => $ea15fb9331abacb9$export$417857010dc9287f);
$parcel$export(module.exports, "ArrayCoder", () => $ea15fb9331abacb9$export$88bc419d2df11f54);

var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");

var $lj9AR = parcelRequire("lj9AR");

var $9crV3 = parcelRequire("9crV3");

var $eTEVj = parcelRequire("eTEVj");
function $ea15fb9331abacb9$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $8wwEQ.assert)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $8wwEQ.assert)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $8wwEQ.assertArgument)(false, "invalid tuple value", "tuple", values);
    (0, $8wwEQ.assertArgument)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $9crV3.Writer)();
    let dynamicWriter = new (0, $9crV3.Writer)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $ea15fb9331abacb9$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $8wwEQ.isError)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $8wwEQ.isError)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $9crV3.Result).fromItems(values, keys);
}
class $ea15fb9331abacb9$export$88bc419d2df11f54 extends (0, $9crV3.Coder) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $7N4fp.defineProperties)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $lj9AR.Typed).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $8wwEQ.assertArgumentCount)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $ea15fb9331abacb9$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $8wwEQ.assert)(count * (0, $9crV3.WordSize) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $9crV3.WordSize),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $eTEVj.AnonymousCoder)(this.coder));
        return $ea15fb9331abacb9$export$417857010dc9287f(reader, coders);
    }
}

});
parcelRegister("eTEVj", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", () => $ad85f24c4bcad69a$export$87c41d1139a03fa2);

var $9crV3 = parcelRequire("9crV3");
class $ad85f24c4bcad69a$export$87c41d1139a03fa2 extends (0, $9crV3.Coder) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("bZCOh", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", () => $8bb37f15c6403170$export$fe9118d6c093150c);

var $lj9AR = parcelRequire("lj9AR");

var $9crV3 = parcelRequire("9crV3");
class $8bb37f15c6403170$export$fe9118d6c093150c extends (0, $9crV3.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $lj9AR.Typed).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}

});

parcelRegister("enzxJ", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", () => $a77ec8c966f279c9$export$db9eadd8df12ad2e);
$parcel$export(module.exports, "BytesCoder", () => $a77ec8c966f279c9$export$e5823e9574df18d2);

var $lJSYP = parcelRequire("lJSYP");

var $9crV3 = parcelRequire("9crV3");
class $a77ec8c966f279c9$export$db9eadd8df12ad2e extends (0, $9crV3.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $lJSYP.getBytesCopy)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $a77ec8c966f279c9$export$e5823e9574df18d2 extends $a77ec8c966f279c9$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $lJSYP.hexlify)(super.decode(reader));
    }
}

});

parcelRegister("iTOl8", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", () => $dc246983eaa4ec58$export$7dec9db68e6bcf5a);

var $7N4fp = parcelRequire("7N4fp");
var $lJSYP = parcelRequire("lJSYP");

var $lj9AR = parcelRequire("lj9AR");

var $9crV3 = parcelRequire("9crV3");
class $dc246983eaa4ec58$export$7dec9db68e6bcf5a extends (0, $9crV3.Coder) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $7N4fp.defineProperties)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $lJSYP.getBytesCopy)((0, $lj9AR.Typed).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $lJSYP.hexlify)(reader.readBytes(this.size));
    }
}

});

parcelRegister("9N0DX", function(module, exports) {

$parcel$export(module.exports, "NullCoder", () => $720930767e786ee7$export$70982cadf2d6b4ec);

var $9crV3 = parcelRequire("9crV3");
const $720930767e786ee7$var$Empty = new Uint8Array([]);
class $720930767e786ee7$export$70982cadf2d6b4ec extends (0, $9crV3.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($720930767e786ee7$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}

});

parcelRegister("17b8S", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", () => $0cff167f1e2d418f$export$b934dc8cfe13938c);

var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");

var $lj9AR = parcelRequire("lj9AR");

var $9crV3 = parcelRequire("9crV3");
const $0cff167f1e2d418f$var$BN_0 = BigInt(0);
const $0cff167f1e2d418f$var$BN_1 = BigInt(1);
const $0cff167f1e2d418f$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $0cff167f1e2d418f$export$b934dc8cfe13938c extends (0, $9crV3.Coder) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $7N4fp.defineProperties)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $9AgaV.getBigInt)((0, $lj9AR.Typed).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $9AgaV.mask)($0cff167f1e2d418f$var$BN_MAX_UINT256, (0, $9crV3.WordSize) * 8);
        if (this.signed) {
            let bounds = (0, $9AgaV.mask)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $0cff167f1e2d418f$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $9AgaV.toTwos)(value, 8 * (0, $9crV3.WordSize));
        } else if (value < $0cff167f1e2d418f$var$BN_0 || value > (0, $9AgaV.mask)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $9AgaV.mask)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $9AgaV.fromTwos)(value, this.size * 8);
        return value;
    }
}

});

parcelRegister("fEITJ", function(module, exports) {

$parcel$export(module.exports, "StringCoder", () => $b65d6b3f7161a036$export$2d1b854518731426);

var $6Vneh = parcelRequire("6Vneh");

var $lj9AR = parcelRequire("lj9AR");

var $enzxJ = parcelRequire("enzxJ");
class $b65d6b3f7161a036$export$2d1b854518731426 extends (0, $enzxJ.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $6Vneh.toUtf8Bytes)((0, $lj9AR.Typed).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $6Vneh.toUtf8String)(super.decode(reader));
    }
}

});
parcelRegister("6Vneh", function(module, exports) {

$parcel$export(module.exports, "toUtf8Bytes", () => $50aa15ceb128a952$export$8feeb310b4b4752f);
$parcel$export(module.exports, "toUtf8String", () => $50aa15ceb128a952$export$7643a1dc2c38d5eb);
/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 
var $lJSYP = parcelRequire("lJSYP");

var $8wwEQ = parcelRequire("8wwEQ");
function $50aa15ceb128a952$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $8wwEQ.assertArgument)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $50aa15ceb128a952$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $8wwEQ.assertArgument)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $50aa15ceb128a952$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $50aa15ceb128a952$var$errorFunc,
    ignore: $50aa15ceb128a952$var$ignoreFunc,
    replace: $50aa15ceb128a952$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $50aa15ceb128a952$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $50aa15ceb128a952$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $lJSYP.getBytes)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $50aa15ceb128a952$export$8feeb310b4b4752f(str, form) {
    (0, $8wwEQ.assertArgument)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $8wwEQ.assertNormalize)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $8wwEQ.assertArgument)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $50aa15ceb128a952$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $50aa15ceb128a952$export$7643a1dc2c38d5eb(bytes, onError) {
    return $50aa15ceb128a952$var$_toUtf8String($50aa15ceb128a952$var$getUtf8CodePoints(bytes, onError));
}
function $50aa15ceb128a952$export$ae470a36a31b28c2(str, form) {
    return $50aa15ceb128a952$var$getUtf8CodePoints($50aa15ceb128a952$export$8feeb310b4b4752f(str, form));
}

});


parcelRegister("b2u7e", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", () => $80973df8073baca7$export$e9fceba8f110fea6);

var $7N4fp = parcelRequire("7N4fp");

var $lj9AR = parcelRequire("lj9AR");

var $9crV3 = parcelRequire("9crV3");

var $k6258 = parcelRequire("k6258");
class $80973df8073baca7$export$e9fceba8f110fea6 extends (0, $9crV3.Coder) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $7N4fp.defineProperties)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $lj9AR.Typed).dereference(_value, "tuple");
        return (0, $k6258.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $k6258.unpack)(reader, this.coders);
    }
}

});

parcelRegister("9SChd", function(module, exports) {

$parcel$export(module.exports, "ParamType", () => $7316d9256af52303$export$426dc07f493a4c47);
$parcel$export(module.exports, "Fragment", () => $7316d9256af52303$export$ffb0004e005737fa);
$parcel$export(module.exports, "ConstructorFragment", () => $7316d9256af52303$export$3ac5c9504f801ea4);
$parcel$export(module.exports, "ErrorFragment", () => $7316d9256af52303$export$2c42c6d543aa9b59);
$parcel$export(module.exports, "EventFragment", () => $7316d9256af52303$export$958548f08bac2833);
$parcel$export(module.exports, "FunctionFragment", () => $7316d9256af52303$export$8d576c928b93668f);
/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 
var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");

var $93hEj = parcelRequire("93hEj");
// [ "a", "b" ] => { "a": 1, "b": 1 }
function $7316d9256af52303$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $7316d9256af52303$var$_kwVisibDeploy = "external public payable override";
const $7316d9256af52303$var$KwVisibDeploy = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $7316d9256af52303$var$_kwVisib = "constant external internal payable private public pure view override";
const $7316d9256af52303$var$KwVisib = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisib.split(" "));
const $7316d9256af52303$var$_kwTypes = "constructor error event fallback function receive struct";
const $7316d9256af52303$var$KwTypes = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwTypes.split(" "));
const $7316d9256af52303$var$_kwModifiers = "calldata memory storage payable indexed";
const $7316d9256af52303$var$KwModifiers = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwModifiers.split(" "));
const $7316d9256af52303$var$_kwOther = "tuple returns";
// All Keywords
const $7316d9256af52303$var$_keywords = [
    $7316d9256af52303$var$_kwTypes,
    $7316d9256af52303$var$_kwModifiers,
    $7316d9256af52303$var$_kwOther,
    $7316d9256af52303$var$_kwVisib
].join(" ");
const $7316d9256af52303$var$Keywords = $7316d9256af52303$var$setify($7316d9256af52303$var$_keywords.split(" "));
// Single character tokens
const $7316d9256af52303$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $7316d9256af52303$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $7316d9256af52303$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $7316d9256af52303$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $7316d9256af52303$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $7316d9256af52303$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $7316d9256af52303$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $7316d9256af52303$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $7316d9256af52303$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $7316d9256af52303$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($7316d9256af52303$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $7316d9256af52303$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $9AgaV.getNumber)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($7316d9256af52303$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($7316d9256af52303$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $7316d9256af52303$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $7316d9256af52303$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $7316d9256af52303$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($7316d9256af52303$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $7316d9256af52303$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $7316d9256af52303$var$consumeMutability(tokens) {
    let modifiers = $7316d9256af52303$var$consumeKeywords(tokens, $7316d9256af52303$var$KwVisib);
    // Detect conflicting modifiers
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("constant payable nonpayable".split(" ")));
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $7316d9256af52303$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $7316d9256af52303$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $9AgaV.getBigInt)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $7316d9256af52303$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $7316d9256af52303$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $7316d9256af52303$var$verifyBasicType(type) {
    const match = type.match($7316d9256af52303$var$regexType);
    (0, $8wwEQ.assertArgument)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $8wwEQ.assertArgument)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $8wwEQ.assertArgument)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $7316d9256af52303$var$_guard = {};
const $7316d9256af52303$var$internal = Symbol.for("_ethers_internal");
const $7316d9256af52303$var$ParamTypeInternal = "_ParamTypeInternal";
const $7316d9256af52303$var$ErrorFragmentInternal = "_ErrorInternal";
const $7316d9256af52303$var$EventFragmentInternal = "_EventInternal";
const $7316d9256af52303$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $7316d9256af52303$var$FallbackFragmentInternal = "_FallbackInternal";
const $7316d9256af52303$var$FunctionFragmentInternal = "_FunctionInternal";
const $7316d9256af52303$var$StructFragmentInternal = "_StructInternal";
class $7316d9256af52303$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $8wwEQ.assertPrivate)(guard, $7316d9256af52303$var$_guard, "ParamType");
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $7N4fp.defineProperties)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($7316d9256af52303$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$426dc07f493a4c47.from($7316d9256af52303$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $8wwEQ.assertArgument)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $7316d9256af52303$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $8wwEQ.assertArgument)(!name || typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $8wwEQ.assertArgument)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($7316d9256af52303$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $7316d9256af52303$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$7316d9256af52303$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $7316d9256af52303$var$verifyBasicType(obj.type);
        return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ParamTypeInternal;
    }
}
class $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $8wwEQ.assertPrivate)(guard, $7316d9256af52303$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $7N4fp.defineProperties)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $7316d9256af52303$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $7316d9256af52303$export$ffb0004e005737fa.from($7316d9256af52303$var$lex(obj));
        }
        if (obj instanceof $7316d9256af52303$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($7316d9256af52303$var$KwTypes);
            switch(type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $8wwEQ.assert)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $8wwEQ.assertArgument)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $7316d9256af52303$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $7316d9256af52303$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $7316d9256af52303$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $7316d9256af52303$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $7316d9256af52303$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $7316d9256af52303$export$85c6fc53d6299173 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $8wwEQ.assertArgument)(typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $7N4fp.defineProperties)(this, {
            name: name
        });
    }
}
function $7316d9256af52303$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $7316d9256af52303$export$2c42c6d543aa9b59 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $93hEj.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $7316d9256af52303$export$2c42c6d543aa9b59.from($7316d9256af52303$var$lex(obj));
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("error", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ErrorFragmentInternal;
    }
}
class $7316d9256af52303$export$958548f08bac2833 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$EventFragmentInternal
        });
        (0, $7N4fp.defineProperties)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $93hEj.id)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$958548f08bac2833.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $8wwEQ.assertArgument)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("event", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj, true);
            const anonymous = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "anonymous"
            ])).has("anonymous");
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, inputs, anonymous);
        }
        return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$EventFragmentInternal;
    }
}
class $7316d9256af52303$export$3ac5c9504f801ea4 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ConstructorFragmentInternal
        });
        (0, $7N4fp.defineProperties)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $8wwEQ.assert)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$7316d9256af52303$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$3ac5c9504f801ea4.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $8wwEQ.assertArgument)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "constructor"
            ]));
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const payable = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwVisibDeploy).has("payable");
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ConstructorFragmentInternal;
    }
}
class $7316d9256af52303$export$71b1ea64c89c20fc extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FallbackFragmentInternal
        });
        (0, $7N4fp.defineProperties)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$71b1ea64c89c20fc.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $8wwEQ.assertArgument)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $8wwEQ.assertArgument)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $8wwEQ.assertArgument)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                    "payable"
                ]));
                $7316d9256af52303$var$consumeEoi(obj);
                return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $7316d9256af52303$var$consumeParams(obj);
            if (inputs.length) (0, $8wwEQ.assertArgument)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            (0, $8wwEQ.assertArgument)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $8wwEQ.assertArgument)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, payable);
        }
        (0, $8wwEQ.assertArgument)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FallbackFragmentInternal;
    }
}
class $7316d9256af52303$export$8d576c928b93668f extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $7N4fp.defineProperties)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $93hEj.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($7316d9256af52303$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$8d576c928b93668f.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $8wwEQ.assertArgument)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("function", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            let outputs = [];
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) outputs = $7316d9256af52303$var$consumeParams(obj);
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FunctionFragmentInternal;
    }
}
class $7316d9256af52303$export$9f91ba10bb234ec7 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$9f91ba10bb234ec7.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $8wwEQ.assertArgument)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("struct", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$StructFragmentInternal;
    }
}

});
parcelRegister("93hEj", function(module, exports) {

$parcel$export(module.exports, "id", () => $697215a61e1ccd96$export$d560c7e4a29451c2);
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");

var $6Vneh = parcelRequire("6Vneh");
function $697215a61e1ccd96$export$d560c7e4a29451c2(value) {
    return (0, $dnGYA.keccak256)((0, $6Vneh.toUtf8Bytes)(value));
}

});



parcelRegister("1dRRv", function(module, exports) {

$parcel$export(module.exports, "Contract", () => $0e40c93799a724b3$export$8517d80acf00e19a);

var $lH7nI = parcelRequire("lH7nI");
var $lj9AR = parcelRequire("lj9AR");

var $klTOW = parcelRequire("klTOW");

var $5Hh3B = parcelRequire("5Hh3B");

var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");
var $lJSYP = parcelRequire("lJSYP");

var $UUfbN = parcelRequire("UUfbN");
const $0e40c93799a724b3$var$BN_0 = BigInt(0);
function $0e40c93799a724b3$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $0e40c93799a724b3$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $0e40c93799a724b3$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $0e40c93799a724b3$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $0e40c93799a724b3$var$getResolver(value) {
    if (value != null) {
        if ($0e40c93799a724b3$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $0e40c93799a724b3$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $7N4fp.defineProperties)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "resolveName");
        const resolver = $0e40c93799a724b3$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $klTOW.resolveAddress)(v, resolver)));
                        return (0, $klTOW.resolveAddress)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $0e40c93799a724b3$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $0e40c93799a724b3$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $0e40c93799a724b3$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $lj9AR.Typed).dereference(arg, "overrides");
    (0, $8wwEQ.assertArgument)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $5Hh3B.copyRequest)(_overrides);
    (0, $8wwEQ.assertArgument)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $8wwEQ.assertArgument)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $0e40c93799a724b3$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $0e40c93799a724b3$var$getRunner(_runner, "resolveName");
    const resolver = $0e40c93799a724b3$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $lj9AR.Typed).dereference(value, type);
            if (type === "address") return (0, $klTOW.resolveAddress)(value, resolver);
            return value;
        });
    }));
}
function $0e40c93799a724b3$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $0e40c93799a724b3$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $klTOW.resolveAddress)(tx.from, $0e40c93799a724b3$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $9AgaV.getBigInt)(tx.value || $0e40c93799a724b3$var$BN_0, "overrides.value") === $0e40c93799a724b3$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $8wwEQ.assertArgument)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $8wwEQ.assertArgument)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $8wwEQ.assertArgument)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $8wwEQ.assertArgument)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "call");
        (0, $8wwEQ.assert)($0e40c93799a724b3$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $8wwEQ.isCallException)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $8wwEQ.assert)($0e40c93799a724b3$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $UUfbN.ContractTransactionResponse)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "estimateGas");
        (0, $8wwEQ.assert)($0e40c93799a724b3$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $7N4fp.defineProperties)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $0e40c93799a724b3$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $8wwEQ.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $0e40c93799a724b3$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $klTOW.resolveAddress)(overrides.from, $0e40c93799a724b3$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $0e40c93799a724b3$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $7N4fp.resolveProperties)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $8wwEQ.assert)($0e40c93799a724b3$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $UUfbN.ContractTransactionResponse)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "estimateGas");
        (0, $8wwEQ.assert)($0e40c93799a724b3$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "call");
        (0, $8wwEQ.assert)($0e40c93799a724b3$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $8wwEQ.isCallException)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $7N4fp.defineProperties)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $8wwEQ.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $0e40c93799a724b3$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $8wwEQ.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $0e40c93799a724b3$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $7N4fp.defineProperties)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $8wwEQ.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $0e40c93799a724b3$var$internal = Symbol.for("_ethersInternal_contract");
const $0e40c93799a724b3$var$internalValues = new WeakMap();
function $0e40c93799a724b3$var$setInternal(contract, values) {
    $0e40c93799a724b3$var$internalValues.set(contract[$0e40c93799a724b3$var$internal], values);
}
function $0e40c93799a724b3$var$getInternal(contract) {
    return $0e40c93799a724b3$var$internalValues.get(contract[$0e40c93799a724b3$var$internal]);
}
function $0e40c93799a724b3$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $0e40c93799a724b3$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $lJSYP.isHexString)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $8wwEQ.assertArgument)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $lJSYP.isHexString)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $8wwEQ.assertArgument)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($0e40c93799a724b3$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $8wwEQ.assertArgument)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $0e40c93799a724b3$var$hasSub(contract, event) {
    const { subs: subs } = $0e40c93799a724b3$var$getInternal(contract);
    return subs.get((await $0e40c93799a724b3$var$getSubInfo(contract, event)).tag) || null;
}
async function $0e40c93799a724b3$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
    (0, $8wwEQ.assert)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $0e40c93799a724b3$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $0e40c93799a724b3$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $0e40c93799a724b3$var$emit(contract, event, args, (listener)=>{
                    return new (0, $UUfbN.ContractEventPayload)(contract, listener, event, _foundFragment, log);
                });
            } else $0e40c93799a724b3$var$emit(contract, event, [], (listener)=>{
                return new (0, $UUfbN.ContractUnknownEventPayload)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $0e40c93799a724b3$var$lastEmit = Promise.resolve();
async function $0e40c93799a724b3$var$_emit(contract, event, args, payloadFunc) {
    await $0e40c93799a724b3$var$lastEmit;
    const sub = await $0e40c93799a724b3$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $0e40c93799a724b3$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $0e40c93799a724b3$var$emit(contract, event, args, payloadFunc) {
    try {
        await $0e40c93799a724b3$var$lastEmit;
    } catch (error) {}
    const resultPromise = $0e40c93799a724b3$var$_emit(contract, event, args, payloadFunc);
    $0e40c93799a724b3$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $0e40c93799a724b3$var$passProperties = [
    "then"
];
class $0e40c93799a724b3$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$0e40c93799a724b3$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $8wwEQ.assertArgument)(typeof target === "string" || (0, $klTOW.isAddressable)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $lH7nI.Interface).from(abi);
        (0, $7N4fp.defineProperties)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $0e40c93799a724b3$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $0e40c93799a724b3$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $UUfbN.ContractTransactionResponse)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $lJSYP.isHexString)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $0e40c93799a724b3$var$getRunner(runner, "resolveName");
                if (!$0e40c93799a724b3$var$canResolve(resolver)) throw (0, $8wwEQ.makeError)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $8wwEQ.makeError)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $0e40c93799a724b3$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $0e40c93799a724b3$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $0e40c93799a724b3$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $8wwEQ.isError)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $7N4fp.defineProperties)(this, {
            filters: filters
        });
        (0, $7N4fp.defineProperties)(this, {
            fallback: iface.receive || iface.fallback ? $0e40c93799a724b3$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $8wwEQ.isError)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $0e40c93799a724b3$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $0e40c93799a724b3$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $0e40c93799a724b3$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $8wwEQ.assert)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $8wwEQ.assert)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $0e40c93799a724b3$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $0e40c93799a724b3$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $0e40c93799a724b3$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $0e40c93799a724b3$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $0e40c93799a724b3$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $8wwEQ.assert)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $UUfbN.EventLog)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $UUfbN.UndecodedEventLog)(log, error);
            }
            return new (0, $5Hh3B.Log)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $0e40c93799a724b3$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $0e40c93799a724b3$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $0e40c93799a724b3$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $0e40c93799a724b3$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $0e40c93799a724b3$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $0e40c93799a724b3$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $0e40c93799a724b3$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $0e40c93799a724b3$var$_ContractBase() {
    return $0e40c93799a724b3$export$304faa4fc17528db;
}
class $0e40c93799a724b3$export$8517d80acf00e19a extends $0e40c93799a724b3$var$_ContractBase() {
}

});
parcelRegister("lH7nI", function(module, exports) {

$parcel$export(module.exports, "Interface", () => $fcb356ece91f4842$export$48cefb51a4e315b2);
/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");

var $93hEj = parcelRequire("93hEj");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");

var $b6VUG = parcelRequire("b6VUG");

var $9crV3 = parcelRequire("9crV3");

var $9SChd = parcelRequire("9SChd");

var $lj9AR = parcelRequire("lj9AR");
class $fcb356ece91f4842$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $7N4fp.defineProperties)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $fcb356ece91f4842$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $7N4fp.defineProperties)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $fcb356ece91f4842$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $7N4fp.defineProperties)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $fcb356ece91f4842$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $7N4fp.defineProperties)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $fcb356ece91f4842$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $fcb356ece91f4842$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $fcb356ece91f4842$var$PanicReasons[code.toString()]) reason = $fcb356ece91f4842$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $fcb356ece91f4842$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $9SChd.Fragment).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $7N4fp.defineProperties)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $7N4fp.defineProperties)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $8wwEQ.assertArgument)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $7N4fp.defineProperties)(this, {
            deploy: (0, $9SChd.ConstructorFragment).from("constructor()")
        });
        (0, $7N4fp.defineProperties)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $b6VUG.AbiCoder).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $lJSYP.isHexString)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $lj9AR.Typed).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $lj9AR.Typed).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $8wwEQ.assertArgument)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $9SChd.FunctionFragment).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $8wwEQ.assertArgument)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $lJSYP.isHexString)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $lj9AR.Typed).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $8wwEQ.assertArgument)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $9SChd.EventFragment).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $8wwEQ.assertArgument)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $lJSYP.isHexString)(key)) {
            const selector = key.toLowerCase();
            if ($fcb356ece91f4842$var$BuiltinErrors[selector]) return (0, $9SChd.ErrorFragment).from($fcb356ece91f4842$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $9SChd.ErrorFragment).from("error Error(string)");
                if (key === "Panic") return (0, $9SChd.ErrorFragment).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $8wwEQ.assertArgument)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $9SChd.ErrorFragment).from(key).format();
        if (key === "Error(string)") return (0, $9SChd.ErrorFragment).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $9SChd.ErrorFragment).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataSlice)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $lJSYP.dataSlice)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $lJSYP.concat)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $8wwEQ.assertArgument)((0, $lJSYP.dataSlice)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $lJSYP.dataSlice)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $lJSYP.concat)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $lJSYP.getBytesCopy)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $8wwEQ.assert)(false, message, "BAD_DATA", {
            value: (0, $lJSYP.hexlify)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $lJSYP.getBytes)(_data, "data");
        const error = (0, $b6VUG.AbiCoder).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $lJSYP.hexlify)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $lJSYP.hexlify)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $8wwEQ.assert)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $93hEj.id)(value);
            else if (param.type === "bytes") return (0, $dnGYA.keccak256)((0, $lJSYP.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $9AgaV.toBeHex)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $lJSYP.zeroPadBytes)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $lJSYP.zeroPadValue)((0, $lJSYP.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $8wwEQ.assertArgument)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $8wwEQ.assertArgument)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $8wwEQ.assertArgument)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $93hEj.id)(value));
                else if (param.type === "bytes") topics.push((0, $dnGYA.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $8wwEQ.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $9SChd.ParamType).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $lJSYP.concat)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $fcb356ece91f4842$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $fcb356ece91f4842$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $9crV3.Result).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $lJSYP.getBytes)(tx.data, "tx.data");
        const value = (0, $9AgaV.getBigInt)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $lJSYP.hexlify)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $fcb356ece91f4842$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $fcb356ece91f4842$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $lJSYP.hexlify)(data);
        const fragment = this.getError((0, $lJSYP.dataSlice)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $lJSYP.dataSlice)(hexData, 4));
        return new $fcb356ece91f4842$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $fcb356ece91f4842$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $fcb356ece91f4842$export$48cefb51a4e315b2(JSON.parse(value));
        // An Interface; possibly from another v6 instance
        if (typeof value.formatJson === "function") return new $fcb356ece91f4842$export$48cefb51a4e315b2(value.formatJson());
        // A legacy Interface; from an older version
        if (typeof value.format === "function") return new $fcb356ece91f4842$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $fcb356ece91f4842$export$48cefb51a4e315b2(value);
    }
}

});

parcelRegister("klTOW", function(module, exports) {

$parcel$export(module.exports, "isAddressable", () => $ed11119eb2f9aa0c$export$6a88e03bca5eb759);
$parcel$export(module.exports, "isAddress", () => $ed11119eb2f9aa0c$export$977e255126d763d6);
$parcel$export(module.exports, "resolveAddress", () => $ed11119eb2f9aa0c$export$687eed6b344123c9);

var $8wwEQ = parcelRequire("8wwEQ");

var $95T0n = parcelRequire("95T0n");
function $ed11119eb2f9aa0c$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $ed11119eb2f9aa0c$export$977e255126d763d6(value) {
    try {
        (0, $95T0n.getAddress)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $ed11119eb2f9aa0c$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $8wwEQ.assert)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $8wwEQ.assertArgument)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $95T0n.getAddress)(result);
}
function $ed11119eb2f9aa0c$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $95T0n.getAddress)(target);
        (0, $8wwEQ.assert)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $ed11119eb2f9aa0c$var$checkAddress(target, resolver.resolveName(target));
    } else if ($ed11119eb2f9aa0c$export$6a88e03bca5eb759(target)) return $ed11119eb2f9aa0c$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $ed11119eb2f9aa0c$var$checkAddress(target, target);
    (0, $8wwEQ.assertArgument)(false, "unsupported addressable value", "target", target);
}

});

parcelRegister("5Hh3B", function(module, exports) {

$parcel$export(module.exports, "FeeData", () => $425e3311db5fb4d1$export$116c49c1e2a96a78);
$parcel$export(module.exports, "copyRequest", () => $425e3311db5fb4d1$export$607b34cdac162b7f);
$parcel$export(module.exports, "Block", () => $425e3311db5fb4d1$export$d96a8827a60d6b69);
$parcel$export(module.exports, "TransactionResponse", () => $425e3311db5fb4d1$export$70966cdb3bfc0785);
$parcel$export(module.exports, "Log", () => $425e3311db5fb4d1$export$ce30dbb46644d06c);
$parcel$export(module.exports, "TransactionReceipt", () => $425e3311db5fb4d1$export$375ffd5683aa5c1c);
//import { resolveAddress } from "@ethersproject/address";

var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");
var $lJSYP = parcelRequire("lJSYP");

var $gGqax = parcelRequire("gGqax");
const $425e3311db5fb4d1$var$BN_0 = BigInt(0);
// -----------------------
function $425e3311db5fb4d1$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $425e3311db5fb4d1$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $425e3311db5fb4d1$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $7N4fp.defineProperties)(this, {
            gasPrice: $425e3311db5fb4d1$var$getValue(gasPrice),
            maxFeePerGas: $425e3311db5fb4d1$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $425e3311db5fb4d1$var$toJson(gasPrice),
            maxFeePerGas: $425e3311db5fb4d1$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $425e3311db5fb4d1$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $lJSYP.hexlify)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $9AgaV.getBigInt)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $9AgaV.getNumber)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $gGqax.accessListify)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    if ("blobVersionedHashes" in req && req.blobVersionedHashes) result.blobVersionedHashes = req.blobVersionedHashes.slice();
    if ("kzg" in req) result.kzg = req.kzg;
    if ("blobs" in req && req.blobs) result.blobs = req.blobs.map((b)=>{
        if ((0, $lJSYP.isBytesLike)(b)) return (0, $lJSYP.hexlify)(b);
        return Object.assign({}, b);
    });
    return result;
}
class $425e3311db5fb4d1$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */ prevRandao;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $425e3311db5fb4d1$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $7N4fp.defineProperties)(this, {
            provider: provider,
            hash: $425e3311db5fb4d1$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            prevRandao: $425e3311db5fb4d1$var$getValue(block.prevRandao),
            extraData: block.extraData,
            baseFeePerGas: $425e3311db5fb4d1$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $8wwEQ.assert)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, prevRandao: prevRandao, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $425e3311db5fb4d1$var$toJson(baseFeePerGas),
            difficulty: $425e3311db5fb4d1$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $425e3311db5fb4d1$var$toJson(gasLimit),
            gasUsed: $425e3311db5fb4d1$var$toJson(gasUsed),
            blobGasUsed: $425e3311db5fb4d1$var$toJson(this.blobGasUsed),
            excessBlobGas: $425e3311db5fb4d1$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            prevRandao: prevRandao,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $8wwEQ.assertArgument)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $425e3311db5fb4d1$var$createOrphanedBlockFilter(this);
    }
}
class $425e3311db5fb4d1$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $7N4fp.defineProperties)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $8wwEQ.assert)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $8wwEQ.assert)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $8wwEQ.assert)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $425e3311db5fb4d1$var$createRemovedLogFilter(this);
    }
}
class $425e3311db5fb4d1$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $425e3311db5fb4d1$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $425e3311db5fb4d1$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $7N4fp.defineProperties)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $425e3311db5fb4d1$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $425e3311db5fb4d1$var$toJson(this.gasPrice),
            blobGasUsed: $425e3311db5fb4d1$var$toJson(this.blobGasUsed),
            blobGasPrice: $425e3311db5fb4d1$var$toJson(this.blobGasPrice),
            gasUsed: $425e3311db5fb4d1$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $425e3311db5fb4d1$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $8wwEQ.assert)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $425e3311db5fb4d1$var$createReorderedTransactionFilter(this, other);
    }
}
class $425e3311db5fb4d1$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $425e3311db5fb4d1$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $425e3311db5fb4d1$var$toJson(this.gasLimit),
            gasPrice: $425e3311db5fb4d1$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $425e3311db5fb4d1$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $425e3311db5fb4d1$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $425e3311db5fb4d1$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $7N4fp.resolveProperties)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $7N4fp.resolveProperties)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $425e3311db5fb4d1$var$BN_0) reason = "cancelled";
                        (0, $8wwEQ.assert)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $8wwEQ.assert)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $8wwEQ.makeError)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $8wwEQ.isError)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $8wwEQ.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $425e3311db5fb4d1$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $8wwEQ.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $8wwEQ.assert)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $425e3311db5fb4d1$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $8wwEQ.assertArgument)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $425e3311db5fb4d1$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $425e3311db5fb4d1$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $425e3311db5fb4d1$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $425e3311db5fb4d1$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $425e3311db5fb4d1$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}

});
parcelRegister("gGqax", function(module, exports) {

$parcel$export(module.exports, "accessListify", () => $c254de3831dd58ea$export$6c8662b1600dce2);

var $95T0n = parcelRequire("95T0n");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
function $c254de3831dd58ea$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $95T0n.getAddress)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $c254de3831dd58ea$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $8wwEQ.assertArgument)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $c254de3831dd58ea$var$accessSetify(set[0], set[1]);
        }
        (0, $8wwEQ.assertArgument)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $c254de3831dd58ea$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $8wwEQ.assertArgument)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $c254de3831dd58ea$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}

});


parcelRegister("UUfbN", function(module, exports) {

$parcel$export(module.exports, "EventLog", () => $0ab0dbf63d0f506e$export$f8203d08df5cd081);
$parcel$export(module.exports, "UndecodedEventLog", () => $0ab0dbf63d0f506e$export$53f6e6acc02bf489);
$parcel$export(module.exports, "ContractTransactionResponse", () => $0ab0dbf63d0f506e$export$853f7e2df34220ff);
$parcel$export(module.exports, "ContractUnknownEventPayload", () => $0ab0dbf63d0f506e$export$54be5ec94ad26a69);
$parcel$export(module.exports, "ContractEventPayload", () => $0ab0dbf63d0f506e$export$35f9272dc1c07dee);
// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

var $5Hh3B = parcelRequire("5Hh3B");

var $7N4fp = parcelRequire("7N4fp");
var $8u7fg = parcelRequire("8u7fg");
class $0ab0dbf63d0f506e$export$f8203d08df5cd081 extends (0, $5Hh3B.Log) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $7N4fp.defineProperties)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $0ab0dbf63d0f506e$export$53f6e6acc02bf489 extends (0, $5Hh3B.Log) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $7N4fp.defineProperties)(this, {
            error: error
        });
    }
}
class $0ab0dbf63d0f506e$export$86bdc83e93503686 extends (0, $5Hh3B.TransactionReceipt) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $0ab0dbf63d0f506e$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $0ab0dbf63d0f506e$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $0ab0dbf63d0f506e$export$853f7e2df34220ff extends (0, $5Hh3B.TransactionResponse) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $0ab0dbf63d0f506e$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $0ab0dbf63d0f506e$export$54be5ec94ad26a69 extends (0, $8u7fg.EventPayload) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $7N4fp.defineProperties)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $0ab0dbf63d0f506e$export$35f9272dc1c07dee extends $0ab0dbf63d0f506e$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $0ab0dbf63d0f506e$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $7N4fp.defineProperties)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}

});
parcelRegister("8u7fg", function(module, exports) {

$parcel$export(module.exports, "EventPayload", () => $62d6becaa0dab02c$export$9cec82196983b278);
/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
var $7N4fp = parcelRequire("7N4fp");
class $62d6becaa0dab02c$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $7N4fp.defineProperties)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}

});



parcelRegister("gWuvh", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", () => $c559b97e34d37b80$export$cb1d0beacb55feb7);
/**
 *  A **FallbackProvider** provides resilience, security and performance
 *  in a way that is customizable and configurable.
 *
 *  @_section: api/providers/fallback-provider:Fallback Provider [about-fallback-provider]
 */ 
var $8wwEQ = parcelRequire("8wwEQ");
var $9AgaV = parcelRequire("9AgaV");

var $e6sDb = parcelRequire("e6sDb");

var $6i1Zn = parcelRequire("6i1Zn");
const $c559b97e34d37b80$var$BN_1 = BigInt("1");
const $c559b97e34d37b80$var$BN_2 = BigInt("2");
function $c559b97e34d37b80$var$shuffle(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
}
function $c559b97e34d37b80$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $c559b97e34d37b80$var$getTime() {
    return new Date().getTime();
}
function $c559b97e34d37b80$var$stringify(value) {
    return JSON.stringify(value, (key, value)=>{
        if (typeof value === "bigint") return {
            type: "bigint",
            value: value.toString()
        };
        return value;
    });
}
const $c559b97e34d37b80$var$defaultConfig = {
    stallTimeout: 400,
    priority: 1,
    weight: 1
};
const $c559b97e34d37b80$var$defaultState = {
    blockNumber: -2,
    requests: 0,
    lateResponses: 0,
    errorResponses: 0,
    outOfSync: -1,
    unsupportedEvents: 0,
    rollingDuration: 0,
    score: 0,
    _network: null,
    _updateNumber: null,
    _totalTime: 0,
    _lastFatalError: null,
    _lastFatalErrorTimestamp: 0
};
async function $c559b97e34d37b80$var$waitForSync(config, blockNumber) {
    while(config.blockNumber < 0 || config.blockNumber < blockNumber){
        if (!config._updateNumber) config._updateNumber = (async ()=>{
            try {
                const blockNumber = await config.provider.getBlockNumber();
                if (blockNumber > config.blockNumber) config.blockNumber = blockNumber;
            } catch (error) {
                config.blockNumber = -2;
                config._lastFatalError = error;
                config._lastFatalErrorTimestamp = $c559b97e34d37b80$var$getTime();
            }
            config._updateNumber = null;
        })();
        await config._updateNumber;
        config.outOfSync++;
        if (config._lastFatalError) break;
    }
}
function $c559b97e34d37b80$var$_normalize(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[" + value.map($c559b97e34d37b80$var$_normalize).join(",") + "]";
    if (typeof value === "object" && typeof value.toJSON === "function") return $c559b97e34d37b80$var$_normalize(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
        case "number":
            return BigInt(value).toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{" + keys.map((k)=>`${JSON.stringify(k)}:${$c559b97e34d37b80$var$_normalize(value[k])}`).join(",") + "}";
            }
    }
    console.log("Could not serialize", value);
    throw new Error("Hmm...");
}
function $c559b97e34d37b80$var$normalizeResult(value) {
    if ("error" in value) {
        const error = value.error;
        return {
            tag: $c559b97e34d37b80$var$_normalize(error),
            value: error
        };
    }
    const result = value.result;
    return {
        tag: $c559b97e34d37b80$var$_normalize(result),
        value: result
    };
}
// This strategy picks the highest weight result, as long as the weight is
// equal to or greater than quorum
function $c559b97e34d37b80$var$checkQuorum(quorum, results) {
    const tally = new Map();
    for (const { value: value, tag: tag, weight: weight } of results){
        const t = tally.get(tag) || {
            value: value,
            weight: 0
        };
        t.weight += weight;
        tally.set(tag, t);
    }
    let best = null;
    for (const r of tally.values())if (r.weight >= quorum && (!best || r.weight > best.weight)) best = r;
    if (best) return best.value;
    return undefined;
}
function $c559b97e34d37b80$var$getMedian(quorum, results) {
    let resultWeight = 0;
    const errorMap = new Map();
    let bestError = null;
    const values = [];
    for (const { value: value, tag: tag, weight: weight } of results)if (value instanceof Error) {
        const e = errorMap.get(tag) || {
            value: value,
            weight: 0
        };
        e.weight += weight;
        errorMap.set(tag, e);
        if (bestError == null || e.weight > bestError.weight) bestError = e;
    } else {
        values.push(BigInt(value));
        resultWeight += weight;
    }
    if (resultWeight < quorum) {
        // We have quorum for an error
        if (bestError && bestError.weight >= quorum) return bestError.value;
        // We do not have quorum for a result
        return undefined;
    }
    // Get the sorted values
    values.sort((a, b)=>a < b ? -1 : b > a ? 1 : 0);
    const mid = Math.floor(values.length / 2);
    // Odd-length; take the middle value
    if (values.length % 2) return values[mid];
    // Even length; take the ceiling of the mean of the center two values
    return (values[mid - 1] + values[mid] + $c559b97e34d37b80$var$BN_1) / $c559b97e34d37b80$var$BN_2;
}
function $c559b97e34d37b80$var$getAnyResult(quorum, results) {
    // If any value or error meets quorum, that is our preferred result
    const result = $c559b97e34d37b80$var$checkQuorum(quorum, results);
    if (result !== undefined) return result;
    // Otherwise, do we have any result?
    for (const r of results){
        if (r.value) return r.value;
    }
    // Nope!
    return undefined;
}
function $c559b97e34d37b80$var$getFuzzyMode(quorum, results) {
    if (quorum === 1) return (0, $9AgaV.getNumber)($c559b97e34d37b80$var$getMedian(quorum, results), "%internal");
    const tally = new Map();
    const add = (result, weight)=>{
        const t = tally.get(result) || {
            result: result,
            weight: 0
        };
        t.weight += weight;
        tally.set(result, t);
    };
    for (const { weight: weight, value: value } of results){
        const r = (0, $9AgaV.getNumber)(value);
        add(r - 1, weight);
        add(r, weight);
        add(r + 1, weight);
    }
    let bestWeight = 0;
    let bestResult = undefined;
    for (const { weight: weight, result: result } of tally.values())// Use this result, if this result meets quorum and has either:
    // - a better weight
    // - or equal weight, but the result is larger
    if (weight >= quorum && (weight > bestWeight || bestResult != null && weight === bestWeight && result > bestResult)) {
        bestWeight = weight;
        bestResult = result;
    }
    return bestResult;
}
class $c559b97e34d37b80$export$cb1d0beacb55feb7 extends (0, $e6sDb.AbstractProvider) {
    /**
     *  The number of backends that must agree on a value before it is
     *  accpeted.
     */ quorum;
    /**
     *  @_ignore:
     */ eventQuorum;
    /**
     *  @_ignore:
     */ eventWorkers;
    #configs;
    #height;
    #initialSyncPromise;
    /**
     *  Creates a new **FallbackProvider** with %%providers%% connected to
     *  %%network%%.
     *
     *  If a [[Provider]] is included in %%providers%%, defaults are used
     *  for the configuration.
     */ constructor(providers, network, options){
        super(network, options);
        this.#configs = providers.map((p)=>{
            if (p instanceof (0, $e6sDb.AbstractProvider)) return Object.assign({
                provider: p
            }, $c559b97e34d37b80$var$defaultConfig, $c559b97e34d37b80$var$defaultState);
            else return Object.assign({}, $c559b97e34d37b80$var$defaultConfig, p, $c559b97e34d37b80$var$defaultState);
        });
        this.#height = -2;
        this.#initialSyncPromise = null;
        if (options && options.quorum != null) this.quorum = options.quorum;
        else this.quorum = Math.ceil(this.#configs.reduce((accum, config)=>{
            accum += config.weight;
            return accum;
        }, 0) / 2);
        this.eventQuorum = 1;
        this.eventWorkers = 1;
        (0, $8wwEQ.assertArgument)(this.quorum <= this.#configs.reduce((a, c)=>a + c.weight, 0), "quorum exceed provider weight", "quorum", this.quorum);
    }
    get providerConfigs() {
        return this.#configs.map((c)=>{
            const result = Object.assign({}, c);
            for(const key in result)if (key[0] === "_") delete result[key];
            return result;
        });
    }
    async _detectNetwork() {
        return (0, $6i1Zn.Network).from((0, $9AgaV.getBigInt)(await this._perform({
            method: "chainId"
        })));
    }
    // @TODO: Add support to select providers to be the event subscriber
    //_getSubscriber(sub: Subscription): Subscriber {
    //    throw new Error("@TODO");
    //}
    /**
     *  Transforms a %%req%% into the correct method call on %%provider%%.
     */ async _translatePerform(provider, req) {
        switch(req.method){
            case "broadcastTransaction":
                return await provider.broadcastTransaction(req.signedTransaction);
            case "call":
                return await provider.call(Object.assign({}, req.transaction, {
                    blockTag: req.blockTag
                }));
            case "chainId":
                return (await provider.getNetwork()).chainId;
            case "estimateGas":
                return await provider.estimateGas(req.transaction);
            case "getBalance":
                return await provider.getBalance(req.address, req.blockTag);
            case "getBlock":
                {
                    const block = "blockHash" in req ? req.blockHash : req.blockTag;
                    return await provider.getBlock(block, req.includeTransactions);
                }
            case "getBlockNumber":
                return await provider.getBlockNumber();
            case "getCode":
                return await provider.getCode(req.address, req.blockTag);
            case "getGasPrice":
                return (await provider.getFeeData()).gasPrice;
            case "getPriorityFee":
                return (await provider.getFeeData()).maxPriorityFeePerGas;
            case "getLogs":
                return await provider.getLogs(req.filter);
            case "getStorage":
                return await provider.getStorage(req.address, req.position, req.blockTag);
            case "getTransaction":
                return await provider.getTransaction(req.hash);
            case "getTransactionCount":
                return await provider.getTransactionCount(req.address, req.blockTag);
            case "getTransactionReceipt":
                return await provider.getTransactionReceipt(req.hash);
            case "getTransactionResult":
                return await provider.getTransactionResult(req.hash);
        }
    }
    // Grab the next (random) config that is not already part of
    // the running set
    #getNextConfig(running) {
        // @TODO: Maybe do a check here to favour (heavily) providers that
        //        do not require waitForSync and disfavour providers that
        //        seem down-ish or are behaving slowly
        const configs = Array.from(running).map((r)=>r.config);
        // Shuffle the states, sorted by priority
        const allConfigs = this.#configs.slice();
        $c559b97e34d37b80$var$shuffle(allConfigs);
        allConfigs.sort((a, b)=>a.priority - b.priority);
        for (const config of allConfigs){
            if (config._lastFatalError) continue;
            if (configs.indexOf(config) === -1) return config;
        }
        return null;
    }
    // Adds a new runner (if available) to running.
    #addRunner(running, req) {
        const config = this.#getNextConfig(running);
        // No runners available
        if (config == null) return null;
        // Create a new runner
        const runner = {
            config: config,
            result: null,
            didBump: false,
            perform: null,
            staller: null
        };
        const now = $c559b97e34d37b80$var$getTime();
        // Start performing this operation
        runner.perform = (async ()=>{
            try {
                config.requests++;
                const result = await this._translatePerform(config.provider, req);
                runner.result = {
                    result: result
                };
            } catch (error) {
                config.errorResponses++;
                runner.result = {
                    error: error
                };
            }
            const dt = $c559b97e34d37b80$var$getTime() - now;
            config._totalTime += dt;
            config.rollingDuration = 0.95 * config.rollingDuration + 0.05 * dt;
            runner.perform = null;
        })();
        // Start a staller; when this times out, it's time to force
        // kicking off another runner because we are taking too long
        runner.staller = (async ()=>{
            await $c559b97e34d37b80$var$stall(config.stallTimeout);
            runner.staller = null;
        })();
        running.add(runner);
        return runner;
    }
    // Initializes the blockNumber and network for each runner and
    // blocks until initialized
    async #initialSync() {
        let initialSync = this.#initialSyncPromise;
        if (!initialSync) {
            const promises = [];
            this.#configs.forEach((config)=>{
                promises.push((async ()=>{
                    await $c559b97e34d37b80$var$waitForSync(config, 0);
                    if (!config._lastFatalError) config._network = await config.provider.getNetwork();
                })());
            });
            this.#initialSyncPromise = initialSync = (async ()=>{
                // Wait for all providers to have a block number and network
                await Promise.all(promises);
                // Check all the networks match
                let chainId = null;
                for (const config of this.#configs){
                    if (config._lastFatalError) continue;
                    const network = config._network;
                    if (chainId == null) chainId = network.chainId;
                    else if (network.chainId !== chainId) (0, $8wwEQ.assert)(false, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
                        operation: "new FallbackProvider"
                    });
                }
            })();
        }
        await initialSync;
    }
    async #checkQuorum(running, req) {
        // Get all the result objects
        const results = [];
        for (const runner of running)if (runner.result != null) {
            const { tag: tag, value: value } = $c559b97e34d37b80$var$normalizeResult(runner.result);
            results.push({
                tag: tag,
                value: value,
                weight: runner.config.weight
            });
        }
        // Are there enough results to event meet quorum?
        if (results.reduce((a, r)=>a + r.weight, 0) < this.quorum) return undefined;
        switch(req.method){
            case "getBlockNumber":
                {
                    // We need to get the bootstrap block height
                    if (this.#height === -2) this.#height = Math.ceil((0, $9AgaV.getNumber)($c559b97e34d37b80$var$getMedian(this.quorum, this.#configs.filter((c)=>!c._lastFatalError).map((c)=>({
                            value: c.blockNumber,
                            tag: (0, $9AgaV.getNumber)(c.blockNumber).toString(),
                            weight: c.weight
                        })))));
                    // Find the mode across all the providers, allowing for
                    // a little drift between block heights
                    const mode = $c559b97e34d37b80$var$getFuzzyMode(this.quorum, results);
                    if (mode === undefined) return undefined;
                    if (mode > this.#height) this.#height = mode;
                    return this.#height;
                }
            case "getGasPrice":
            case "getPriorityFee":
            case "estimateGas":
                return $c559b97e34d37b80$var$getMedian(this.quorum, results);
            case "getBlock":
                // Pending blocks are in the mempool and already
                // quite untrustworthy; just grab anything
                if ("blockTag" in req && req.blockTag === "pending") return $c559b97e34d37b80$var$getAnyResult(this.quorum, results);
                return $c559b97e34d37b80$var$checkQuorum(this.quorum, results);
            case "call":
            case "chainId":
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
            case "getStorage":
            case "getTransaction":
            case "getTransactionReceipt":
            case "getLogs":
                return $c559b97e34d37b80$var$checkQuorum(this.quorum, results);
            case "broadcastTransaction":
                return $c559b97e34d37b80$var$getAnyResult(this.quorum, results);
        }
        (0, $8wwEQ.assert)(false, "unsupported method", "UNSUPPORTED_OPERATION", {
            operation: `_perform(${$c559b97e34d37b80$var$stringify(req.method)})`
        });
    }
    async #waitForQuorum(running, req) {
        if (running.size === 0) throw new Error("no runners?!");
        // Any promises that are interesting to watch for; an expired stall
        // or a successful perform
        const interesting = [];
        let newRunners = 0;
        for (const runner of running){
            // No responses, yet; keep an eye on it
            if (runner.perform) interesting.push(runner.perform);
            // Still stalling...
            if (runner.staller) {
                interesting.push(runner.staller);
                continue;
            }
            // This runner has already triggered another runner
            if (runner.didBump) continue;
            // Got a response (result or error) or stalled; kick off another runner
            runner.didBump = true;
            newRunners++;
        }
        // Check if we have reached quorum on a result (or error)
        const value = await this.#checkQuorum(running, req);
        if (value !== undefined) {
            if (value instanceof Error) throw value;
            return value;
        }
        // Add any new runners, because a staller timed out or a result
        // or error response came in.
        for(let i = 0; i < newRunners; i++)this.#addRunner(running, req);
        // All providers have returned, and we have no result
        (0, $8wwEQ.assert)(interesting.length > 0, "quorum not met", "SERVER_ERROR", {
            request: "%sub-requests",
            info: {
                request: req,
                results: Array.from(running).map((r)=>$c559b97e34d37b80$var$stringify(r.result))
            }
        });
        // Wait for someone to either complete its perform or stall out
        await Promise.race(interesting);
        // This is recursive, but at worst case the depth is 2x the
        // number of providers (each has a perform and a staller)
        return await this.#waitForQuorum(running, req);
    }
    async _perform(req) {
        // Broadcasting a transaction is rare (ish) and already incurs
        // a cost on the user, so spamming is safe-ish. Just send it to
        // every backend.
        if (req.method === "broadcastTransaction") {
            // Once any broadcast provides a positive result, use it. No
            // need to wait for anyone else
            const results = this.#configs.map((c)=>null);
            const broadcasts = this.#configs.map(async ({ provider: provider, weight: weight }, index)=>{
                try {
                    const result = await provider._perform(req);
                    results[index] = Object.assign($c559b97e34d37b80$var$normalizeResult({
                        result: result
                    }), {
                        weight: weight
                    });
                } catch (error) {
                    results[index] = Object.assign($c559b97e34d37b80$var$normalizeResult({
                        error: error
                    }), {
                        weight: weight
                    });
                }
            });
            // As each promise finishes...
            while(true){
                // Check for a valid broadcast result
                const done = results.filter((r)=>r != null);
                for (const { value: value } of done){
                    if (!(value instanceof Error)) return value;
                }
                // Check for a legit broadcast error (one which we cannot
                // recover from; some nodes may return the following red
                // herring events:
                // - alredy seend (UNKNOWN_ERROR)
                // - NONCE_EXPIRED
                // - REPLACEMENT_UNDERPRICED
                const result = $c559b97e34d37b80$var$checkQuorum(this.quorum, results.filter((r)=>r != null));
                if ((0, $8wwEQ.isError)(result, "INSUFFICIENT_FUNDS")) throw result;
                // Kick off the next provider (if any)
                const waiting = broadcasts.filter((b, i)=>results[i] == null);
                if (waiting.length === 0) break;
                await Promise.race(waiting);
            }
            // Use standard quorum results; any result was returned above,
            // so this will find any error that met quorum if any
            const result = $c559b97e34d37b80$var$getAnyResult(this.quorum, results);
            (0, $8wwEQ.assert)(result !== undefined, "problem multi-broadcasting", "SERVER_ERROR", {
                request: "%sub-requests",
                info: {
                    request: req,
                    results: results.map($c559b97e34d37b80$var$stringify)
                }
            });
            if (result instanceof Error) throw result;
            return result;
        }
        await this.#initialSync();
        // Bootstrap enough runners to meet quorum
        const running = new Set();
        let inflightQuorum = 0;
        while(true){
            const runner = this.#addRunner(running, req);
            if (runner == null) break;
            inflightQuorum += runner.config.weight;
            if (inflightQuorum >= this.quorum) break;
        }
        const result = await this.#waitForQuorum(running, req);
        // Track requests sent to a provider that are still
        // outstanding after quorum has been otherwise found
        for (const runner of running)if (runner.perform && runner.result == null) runner.config.lateResponses++;
        return result;
    }
    async destroy() {
        for (const { provider: provider } of this.#configs)provider.destroy();
        super.destroy();
    }
}

});
parcelRegister("e6sDb", function(module, exports) {

$parcel$export(module.exports, "UnmanagedSubscriber", () => $a447d5c12fd5aa4c$export$f255b979f86248fa);
$parcel$export(module.exports, "AbstractProvider", () => $a447d5c12fd5aa4c$export$ae9650e85fb229fe);
/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

var $95T0n = parcelRequire("95T0n");
var $klTOW = parcelRequire("klTOW");

var $7RlNJ = parcelRequire("7RlNJ");

var $1dRRv = parcelRequire("1dRRv");

var $7uHh6 = parcelRequire("7uHh6");

var $1PldO = parcelRequire("1PldO");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $7N4fp = parcelRequire("7N4fp");
var $8u7fg = parcelRequire("8u7fg");
var $3PTkx = parcelRequire("3PTkx");
var $9AgaV = parcelRequire("9AgaV");
var $6Vneh = parcelRequire("6Vneh");

var $3rcfR = parcelRequire("3rcfR");

var $c46JD = parcelRequire("c46JD");

var $6i1Zn = parcelRequire("6i1Zn");

var $5Hh3B = parcelRequire("5Hh3B");

var $kZz8q = parcelRequire("kZz8q");
// Constants
const $a447d5c12fd5aa4c$var$BN_2 = BigInt(2);
const $a447d5c12fd5aa4c$var$MAX_CCIP_REDIRECTS = 10;
function $a447d5c12fd5aa4c$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $a447d5c12fd5aa4c$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $a447d5c12fd5aa4c$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $7N4fp.defineProperties)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $a447d5c12fd5aa4c$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $a447d5c12fd5aa4c$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $a447d5c12fd5aa4c$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $lJSYP.isHexString)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $a447d5c12fd5aa4c$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $a447d5c12fd5aa4c$var$getTag("orphan", event),
            filter: $a447d5c12fd5aa4c$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $a447d5c12fd5aa4c$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $lJSYP.isHexString)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $klTOW.resolveAddress)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $a447d5c12fd5aa4c$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $a447d5c12fd5aa4c$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $8wwEQ.assertArgument)(false, "unknown ProviderEvent", "event", _event);
}
function $a447d5c12fd5aa4c$var$getTime() {
    return new Date().getTime();
}
const $a447d5c12fd5aa4c$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $a447d5c12fd5aa4c$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $a447d5c12fd5aa4c$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $6i1Zn.Network).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $a447d5c12fd5aa4c$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $3PTkx.FetchRequest)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $8wwEQ.assert)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $8wwEQ.assert)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $5Hh3B.Block)((0, $c46JD.formatBlock)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $5Hh3B.Log)((0, $c46JD.formatLog)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $5Hh3B.TransactionReceipt)((0, $c46JD.formatTransactionReceipt)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $5Hh3B.TransactionResponse)((0, $c46JD.formatTransactionResponse)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $8wwEQ.assert)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $8wwEQ.assert)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $9AgaV.getNumber)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $klTOW.resolveAddress)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $lJSYP.isHexString)(blockTag)) {
            if ((0, $lJSYP.isHexString)(blockTag, 32)) return blockTag;
            return (0, $9AgaV.toQuantity)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $9AgaV.getNumber)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $9AgaV.toQuantity)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $9AgaV.toQuantity)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $9AgaV.toQuantity)(b + blockTag));
        }
        (0, $8wwEQ.assertArgument)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $a447d5c12fd5aa4c$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $5Hh3B.copyRequest)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $klTOW.resolveAddress)(request[key], this);
            if ($a447d5c12fd5aa4c$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($a447d5c12fd5aa4c$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $8wwEQ.assert)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $7N4fp.resolveProperties)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $9AgaV.getBigInt)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $9AgaV.getBigInt)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $a447d5c12fd5aa4c$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $5Hh3B.FeeData)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $3PTkx.FetchRequest)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $5Hh3B.FeeData)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($a447d5c12fd5aa4c$var$isPromise(tx)) tx = await tx;
        return (0, $9AgaV.getBigInt)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $8wwEQ.assert)(attempt < $a447d5c12fd5aa4c$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $5Hh3B.copyRequest)(tx);
        try {
            return (0, $lJSYP.hexlify)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $8wwEQ.isCallException)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $lJSYP.dataSlice)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $klTOW.resolveAddress)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $a447d5c12fd5aa4c$var$parseOffchainLookup((0, $lJSYP.dataSlice)(error.data, 4));
                } catch (error) {
                    (0, $8wwEQ.assert)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $8wwEQ.assert)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $8wwEQ.assert)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $lJSYP.concat)([
                        ccipArgs.selector,
                        $a447d5c12fd5aa4c$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $7N4fp.resolveProperties)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $9AgaV.getBigInt)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $9AgaV.getNumber)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $lJSYP.hexlify)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $9AgaV.getBigInt)(_position, "position");
        return (0, $lJSYP.hexlify)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $7N4fp.resolveProperties)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $1PldO.Transaction).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $lJSYP.isHexString)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $lJSYP.hexlify)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($a447d5c12fd5aa4c$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $8wwEQ.assert)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $3rcfR.EnsResolver).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $95T0n.getAddress)(address);
        const node = (0, $7uHh6.namehash)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $3rcfR.EnsResolver).getEnsAddress(this);
            const ensContract = new (0, $1dRRv.Contract)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $7RlNJ.ZeroAddress)) return null;
            const resolverContract = new (0, $1dRRv.Contract)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $8wwEQ.isError)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $8wwEQ.isError)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $8wwEQ.makeError)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $8wwEQ.assert)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $a447d5c12fd5aa4c$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $a447d5c12fd5aa4c$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $kZz8q.PollingBlockSubscriber)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $kZz8q.PollingBlockTagSubscriber)(this, sub.type);
            case "event":
                return new (0, $kZz8q.PollingEventSubscriber)(this, sub.filter);
            case "transaction":
                return new (0, $kZz8q.PollingTransactionSubscriber)(this, sub.hash);
            case "orphan":
                return new (0, $kZz8q.PollingOrphanSubscriber)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $a447d5c12fd5aa4c$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $a447d5c12fd5aa4c$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $a447d5c12fd5aa4c$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $8u7fg.EventPayload)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $8wwEQ.assert)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $a447d5c12fd5aa4c$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $a447d5c12fd5aa4c$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $a447d5c12fd5aa4c$var$_parseString(result, start) {
    try {
        const bytes = $a447d5c12fd5aa4c$var$_parseBytes(result, start);
        if (bytes) return (0, $6Vneh.toUtf8String)(bytes);
    } catch (error) {}
    return null;
}
function $a447d5c12fd5aa4c$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $9AgaV.getNumber)((0, $lJSYP.dataSlice)(result, start, start + 32));
        const length = (0, $9AgaV.getNumber)((0, $lJSYP.dataSlice)(result, offset, offset + 32));
        return (0, $lJSYP.dataSlice)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $a447d5c12fd5aa4c$var$numPad(value) {
    const result = (0, $9AgaV.toBeArray)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $a447d5c12fd5aa4c$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $a447d5c12fd5aa4c$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $a447d5c12fd5aa4c$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($a447d5c12fd5aa4c$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $lJSYP.getBytes)(datas[i]);
        // Update the bytes offset
        result[i] = $a447d5c12fd5aa4c$var$numPad(byteCount);
        // The length and padded value of data
        result.push($a447d5c12fd5aa4c$var$numPad(data.length));
        result.push($a447d5c12fd5aa4c$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $lJSYP.concat)(result);
}
const $a447d5c12fd5aa4c$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $a447d5c12fd5aa4c$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $8wwEQ.assert)((0, $lJSYP.dataLength)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $lJSYP.dataSlice)(data, 0, 32);
    (0, $8wwEQ.assert)((0, $lJSYP.dataSlice)(sender, 0, 12) === (0, $lJSYP.dataSlice)($a447d5c12fd5aa4c$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $lJSYP.dataSlice)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $9AgaV.getNumber)((0, $lJSYP.dataSlice)(data, 32, 64));
        const urlsLength = (0, $9AgaV.getNumber)((0, $lJSYP.dataSlice)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $lJSYP.dataSlice)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $a447d5c12fd5aa4c$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $8wwEQ.assert)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $a447d5c12fd5aa4c$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $8wwEQ.assert)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $8wwEQ.assert)((0, $lJSYP.dataSlice)(data, 100, 128) === (0, $lJSYP.dataSlice)($a447d5c12fd5aa4c$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $lJSYP.dataSlice)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $a447d5c12fd5aa4c$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $8wwEQ.assert)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}

});
parcelRegister("7RlNJ", function(module, exports) {

$parcel$export(module.exports, "ZeroAddress", () => $5b8e64dd3cc782dc$export$b7cbe423ba83da17);
/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $5b8e64dd3cc782dc$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("7uHh6", function(module, exports) {

$parcel$export(module.exports, "namehash", () => $574ce7342d53bcf4$export$91d651ee363e1209);
$parcel$export(module.exports, "dnsEncode", () => $574ce7342d53bcf4$export$6c0a8cdae51cb512);
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $6Vneh = parcelRequire("6Vneh");

var $grVpz = parcelRequire("grVpz");
const $574ce7342d53bcf4$var$Zeros = new Uint8Array(32);
$574ce7342d53bcf4$var$Zeros.fill(0);
function $574ce7342d53bcf4$var$checkComponent(comp) {
    (0, $8wwEQ.assertArgument)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $574ce7342d53bcf4$var$ensNameSplit(name) {
    const bytes = (0, $6Vneh.toUtf8Bytes)($574ce7342d53bcf4$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($574ce7342d53bcf4$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $8wwEQ.assertArgument)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($574ce7342d53bcf4$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $574ce7342d53bcf4$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $grVpz.ens_normalize)(name);
    } catch (error) {
        (0, $8wwEQ.assertArgument)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $574ce7342d53bcf4$export$cce2300886e7ace6(name) {
    try {
        return $574ce7342d53bcf4$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $574ce7342d53bcf4$export$91d651ee363e1209(name) {
    (0, $8wwEQ.assertArgument)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $8wwEQ.assertArgument)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $574ce7342d53bcf4$var$Zeros;
    const comps = $574ce7342d53bcf4$var$ensNameSplit(name);
    while(comps.length)result = (0, $dnGYA.keccak256)((0, $lJSYP.concat)([
        result,
        (0, $dnGYA.keccak256)(comps.pop())
    ]));
    return (0, $lJSYP.hexlify)(result);
}
function $574ce7342d53bcf4$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $8wwEQ.assertArgument)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $lJSYP.hexlify)((0, $lJSYP.concat)($574ce7342d53bcf4$var$ensNameSplit(name).map((comp)=>{
        (0, $8wwEQ.assertArgument)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("grVpz", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", () => $e006ee16d99d0706$export$499f715881831a51);
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $e006ee16d99d0706$var$COMPRESSED$1 = "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";
const $e006ee16d99d0706$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $e006ee16d99d0706$var$NSM_MAX = 4;
function $e006ee16d99d0706$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $e006ee16d99d0706$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $e006ee16d99d0706$var$read_compressed_payload(s) {
    return $e006ee16d99d0706$var$read_payload($e006ee16d99d0706$var$decode_arithmetic($e006ee16d99d0706$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $e006ee16d99d0706$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $e006ee16d99d0706$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $e006ee16d99d0706$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $e006ee16d99d0706$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $e006ee16d99d0706$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $e006ee16d99d0706$var$read_sorted_arrays(next) {
    return $e006ee16d99d0706$var$read_array_while(()=>{
        let v = $e006ee16d99d0706$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $e006ee16d99d0706$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($e006ee16d99d0706$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($e006ee16d99d0706$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $e006ee16d99d0706$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $e006ee16d99d0706$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$e006ee16d99d0706$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $e006ee16d99d0706$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $e006ee16d99d0706$var$read_array_while(next);
    let m = $e006ee16d99d0706$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $e006ee16d99d0706$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $e006ee16d99d0706$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $e006ee16d99d0706$var$read_trie(next) {
    let ret = [];
    let sorted = $e006ee16d99d0706$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $e006ee16d99d0706$var$read_array_while(()=>{
            let cps = $e006ee16d99d0706$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $e006ee16d99d0706$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $e006ee16d99d0706$var$quote_cp(cp) {
    return `{${$e006ee16d99d0706$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $e006ee16d99d0706$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $e006ee16d99d0706$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $e006ee16d99d0706$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $e006ee16d99d0706$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $e006ee16d99d0706$var$S0 = 0xAC00;
const $e006ee16d99d0706$var$L0 = 0x1100;
const $e006ee16d99d0706$var$V0 = 0x1161;
const $e006ee16d99d0706$var$T0 = 0x11A7;
const $e006ee16d99d0706$var$L_COUNT = 19;
const $e006ee16d99d0706$var$V_COUNT = 21;
const $e006ee16d99d0706$var$T_COUNT = 28;
const $e006ee16d99d0706$var$N_COUNT = $e006ee16d99d0706$var$V_COUNT * $e006ee16d99d0706$var$T_COUNT;
const $e006ee16d99d0706$var$S_COUNT = $e006ee16d99d0706$var$L_COUNT * $e006ee16d99d0706$var$N_COUNT;
const $e006ee16d99d0706$var$S1 = $e006ee16d99d0706$var$S0 + $e006ee16d99d0706$var$S_COUNT;
const $e006ee16d99d0706$var$L1 = $e006ee16d99d0706$var$L0 + $e006ee16d99d0706$var$L_COUNT;
const $e006ee16d99d0706$var$V1 = $e006ee16d99d0706$var$V0 + $e006ee16d99d0706$var$V_COUNT;
const $e006ee16d99d0706$var$T1 = $e006ee16d99d0706$var$T0 + $e006ee16d99d0706$var$T_COUNT;
function $e006ee16d99d0706$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $e006ee16d99d0706$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $e006ee16d99d0706$var$SHIFTED_RANK, $e006ee16d99d0706$var$EXCLUSIONS, $e006ee16d99d0706$var$DECOMP, $e006ee16d99d0706$var$RECOMP;
function $e006ee16d99d0706$var$init$1() {
    //console.time('nf');
    let r = $e006ee16d99d0706$var$read_compressed_payload($e006ee16d99d0706$var$COMPRESSED);
    $e006ee16d99d0706$var$SHIFTED_RANK = new Map($e006ee16d99d0706$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $e006ee16d99d0706$var$EXCLUSIONS = new Set($e006ee16d99d0706$var$read_sorted(r));
    $e006ee16d99d0706$var$DECOMP = new Map();
    $e006ee16d99d0706$var$RECOMP = new Map();
    for (let [cp, cps] of $e006ee16d99d0706$var$read_mapped(r)){
        if (!$e006ee16d99d0706$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $e006ee16d99d0706$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $e006ee16d99d0706$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $e006ee16d99d0706$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $e006ee16d99d0706$var$is_hangul(cp) {
    return cp >= $e006ee16d99d0706$var$S0 && cp < $e006ee16d99d0706$var$S1;
}
function $e006ee16d99d0706$var$compose_pair(a, b) {
    if (a >= $e006ee16d99d0706$var$L0 && a < $e006ee16d99d0706$var$L1 && b >= $e006ee16d99d0706$var$V0 && b < $e006ee16d99d0706$var$V1) return $e006ee16d99d0706$var$S0 + (a - $e006ee16d99d0706$var$L0) * $e006ee16d99d0706$var$N_COUNT + (b - $e006ee16d99d0706$var$V0) * $e006ee16d99d0706$var$T_COUNT;
    else if ($e006ee16d99d0706$var$is_hangul(a) && b > $e006ee16d99d0706$var$T0 && b < $e006ee16d99d0706$var$T1 && (a - $e006ee16d99d0706$var$S0) % $e006ee16d99d0706$var$T_COUNT == 0) return a + (b - $e006ee16d99d0706$var$T0);
    else {
        let recomp = $e006ee16d99d0706$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $e006ee16d99d0706$var$decomposed(cps) {
    if (!$e006ee16d99d0706$var$SHIFTED_RANK) $e006ee16d99d0706$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $e006ee16d99d0706$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($e006ee16d99d0706$var$is_hangul(cp)) {
            let s_index = cp - $e006ee16d99d0706$var$S0;
            let l_index = s_index / $e006ee16d99d0706$var$N_COUNT | 0;
            let v_index = s_index % $e006ee16d99d0706$var$N_COUNT / $e006ee16d99d0706$var$T_COUNT | 0;
            let t_index = s_index % $e006ee16d99d0706$var$T_COUNT;
            add($e006ee16d99d0706$var$L0 + l_index);
            add($e006ee16d99d0706$var$V0 + v_index);
            if (t_index > 0) add($e006ee16d99d0706$var$T0 + t_index);
        } else {
            let mapped = $e006ee16d99d0706$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $e006ee16d99d0706$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $e006ee16d99d0706$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $e006ee16d99d0706$var$unpack_cc(packed);
        let cp = $e006ee16d99d0706$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $e006ee16d99d0706$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $e006ee16d99d0706$export$9d0d896b286a3dba(cps) {
    return $e006ee16d99d0706$var$decomposed(cps).map($e006ee16d99d0706$var$unpack_cp);
}
function $e006ee16d99d0706$export$f42252642e08449(cps) {
    return $e006ee16d99d0706$var$composed_from_decomposed($e006ee16d99d0706$var$decomposed(cps));
}
const $e006ee16d99d0706$var$HYPHEN = 0x2D;
const $e006ee16d99d0706$var$STOP = 0x2E;
const $e006ee16d99d0706$var$STOP_CH = ".";
const $e006ee16d99d0706$var$FE0F = 0xFE0F;
const $e006ee16d99d0706$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $e006ee16d99d0706$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $e006ee16d99d0706$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $e006ee16d99d0706$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $e006ee16d99d0706$var$MAPPED, $e006ee16d99d0706$var$IGNORED, $e006ee16d99d0706$var$CM, $e006ee16d99d0706$var$NSM, $e006ee16d99d0706$var$ESCAPE, $e006ee16d99d0706$var$NFC_CHECK, $e006ee16d99d0706$var$GROUPS, $e006ee16d99d0706$var$WHOLE_VALID, $e006ee16d99d0706$var$WHOLE_MAP, $e006ee16d99d0706$var$VALID, $e006ee16d99d0706$var$EMOJI_LIST, $e006ee16d99d0706$var$EMOJI_ROOT;
function $e006ee16d99d0706$var$init() {
    if ($e006ee16d99d0706$var$MAPPED) return;
    let r = $e006ee16d99d0706$var$read_compressed_payload($e006ee16d99d0706$var$COMPRESSED$1);
    const read_sorted_array = ()=>$e006ee16d99d0706$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $e006ee16d99d0706$var$MAPPED = new Map($e006ee16d99d0706$var$read_mapped(r));
    $e006ee16d99d0706$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $e006ee16d99d0706$var$CM = read_sorted_array();
    $e006ee16d99d0706$var$NSM = new Set(read_sorted_array().map((i)=>$e006ee16d99d0706$var$CM[i]));
    $e006ee16d99d0706$var$CM = new Set($e006ee16d99d0706$var$CM);
    $e006ee16d99d0706$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $e006ee16d99d0706$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $e006ee16d99d0706$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $e006ee16d99d0706$var$GROUPS = $e006ee16d99d0706$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $e006ee16d99d0706$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $e006ee16d99d0706$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $e006ee16d99d0706$var$WHOLE_VALID = read_sorted_set();
    $e006ee16d99d0706$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($e006ee16d99d0706$var$Array_from($e006ee16d99d0706$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$e006ee16d99d0706$var$WHOLE_VALID.has(cp)) $e006ee16d99d0706$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($e006ee16d99d0706$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $e006ee16d99d0706$var$GROUPS.filter((g)=>$e006ee16d99d0706$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$e006ee16d99d0706$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $e006ee16d99d0706$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$e006ee16d99d0706$var$VALID.has(cp) ? multi.add(cp) : $e006ee16d99d0706$var$VALID.add(cp);
    for (let g of $e006ee16d99d0706$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $e006ee16d99d0706$var$VALID)if (!$e006ee16d99d0706$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $e006ee16d99d0706$var$WHOLE_MAP.set(cp, $e006ee16d99d0706$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($e006ee16d99d0706$var$VALID, $e006ee16d99d0706$export$9d0d896b286a3dba($e006ee16d99d0706$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $e006ee16d99d0706$var$EMOJI_LIST = $e006ee16d99d0706$var$read_trie(r).map((v)=>$e006ee16d99d0706$var$Emoji.from(v)).sort($e006ee16d99d0706$var$compare_arrays);
    $e006ee16d99d0706$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $e006ee16d99d0706$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $e006ee16d99d0706$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $e006ee16d99d0706$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $e006ee16d99d0706$var$quoted_cp(cp) {
    return ($e006ee16d99d0706$export$4b1c9c18c687e5e9(cp) ? "" : `${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $e006ee16d99d0706$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $e006ee16d99d0706$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $e006ee16d99d0706$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $e006ee16d99d0706$var$HYPHEN && cps[3] == $e006ee16d99d0706$var$HYPHEN) throw new Error(`invalid label extension: "${$e006ee16d99d0706$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $e006ee16d99d0706$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $e006ee16d99d0706$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $e006ee16d99d0706$var$FENCED.get(cp);
    if (prev) throw $e006ee16d99d0706$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $e006ee16d99d0706$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $e006ee16d99d0706$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $e006ee16d99d0706$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $e006ee16d99d0706$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $e006ee16d99d0706$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($e006ee16d99d0706$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($e006ee16d99d0706$export$4b1c9c18c687e5e9(cp)) {
            buf.push($e006ee16d99d0706$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($e006ee16d99d0706$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $e006ee16d99d0706$export$e29a9e4d2573411c(cp) {
    $e006ee16d99d0706$var$init();
    return $e006ee16d99d0706$var$CM.has(cp);
}
function $e006ee16d99d0706$export$4b1c9c18c687e5e9(cp) {
    $e006ee16d99d0706$var$init();
    return $e006ee16d99d0706$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $e006ee16d99d0706$export$95d5ea4de7964366() {
    $e006ee16d99d0706$var$init();
    return $e006ee16d99d0706$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $e006ee16d99d0706$export$f4e6b2721065fb3d(frag, decompose) {
    $e006ee16d99d0706$var$init();
    let nf = decompose ? $e006ee16d99d0706$export$9d0d896b286a3dba : $e006ee16d99d0706$export$f42252642e08449;
    return frag.split($e006ee16d99d0706$var$STOP_CH).map((label)=>$e006ee16d99d0706$var$str_from_cps($e006ee16d99d0706$var$tokens_from_str($e006ee16d99d0706$var$explode_cp(label), nf, $e006ee16d99d0706$var$filter_fe0f).flat())).join($e006ee16d99d0706$var$STOP_CH);
}
function $e006ee16d99d0706$export$499f715881831a51(name) {
    return $e006ee16d99d0706$var$flatten($e006ee16d99d0706$var$split(name, $e006ee16d99d0706$export$f42252642e08449, $e006ee16d99d0706$var$filter_fe0f));
}
function $e006ee16d99d0706$export$d2ee080f6ab2341d(name) {
    let labels = $e006ee16d99d0706$var$split(name, $e006ee16d99d0706$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") $e006ee16d99d0706$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $e006ee16d99d0706$var$flatten(labels);
}
function $e006ee16d99d0706$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $e006ee16d99d0706$export$d2ba335951b08421(name, preserve_emoji) {
    return $e006ee16d99d0706$var$split(name, $e006ee16d99d0706$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $e006ee16d99d0706$var$filter_fe0f); // emoji are exposed so copy
}
function $e006ee16d99d0706$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $e006ee16d99d0706$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($e006ee16d99d0706$var$STOP_CH).map((label)=>{
        let input = $e006ee16d99d0706$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $e006ee16d99d0706$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $e006ee16d99d0706$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $e006ee16d99d0706$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($e006ee16d99d0706$var$CM.has(norm[0])) throw $e006ee16d99d0706$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $e006ee16d99d0706$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $e006ee16d99d0706$var$error_placement(`emoji + combining mark: "${$e006ee16d99d0706$var$str_from_cps(tokens[i - 1])} + ${$e006ee16d99d0706$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $e006ee16d99d0706$var$check_fenced(norm);
                    let unique = $e006ee16d99d0706$var$Array_from(new Set(chars));
                    let [g] = $e006ee16d99d0706$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $e006ee16d99d0706$var$check_group(g, chars); // need text in order
                    $e006ee16d99d0706$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $e006ee16d99d0706$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $e006ee16d99d0706$var$WHOLE_MAP.get(cp);
        if (whole === $e006ee16d99d0706$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $e006ee16d99d0706$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$e006ee16d99d0706$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $e006ee16d99d0706$var$determine_group(unique) {
    let groups = $e006ee16d99d0706$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$e006ee16d99d0706$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$e006ee16d99d0706$var$GROUPS.some((g)=>$e006ee16d99d0706$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $e006ee16d99d0706$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $e006ee16d99d0706$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $e006ee16d99d0706$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $e006ee16d99d0706$var$str_from_cps(output);
    }).join($e006ee16d99d0706$var$STOP_CH);
}
function $e006ee16d99d0706$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$e006ee16d99d0706$var$quoted_cp(cp)}`);
}
function $e006ee16d99d0706$var$error_group_member(g, cp) {
    let quoted = $e006ee16d99d0706$var$quoted_cp(cp);
    let gg = $e006ee16d99d0706$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $e006ee16d99d0706$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $e006ee16d99d0706$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$e006ee16d99d0706$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $e006ee16d99d0706$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $e006ee16d99d0706$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($e006ee16d99d0706$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $e006ee16d99d0706$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$e006ee16d99d0706$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $e006ee16d99d0706$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$e006ee16d99d0706$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $e006ee16d99d0706$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $e006ee16d99d0706$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($e006ee16d99d0706$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $e006ee16d99d0706$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$e006ee16d99d0706$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $e006ee16d99d0706$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $e006ee16d99d0706$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $e006ee16d99d0706$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $e006ee16d99d0706$var$consume_emoji_reversed(cps, eaten) {
    let node = $e006ee16d99d0706$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $e006ee16d99d0706$var$TY_VALID = "valid";
const $e006ee16d99d0706$var$TY_MAPPED = "mapped";
const $e006ee16d99d0706$var$TY_IGNORED = "ignored";
const $e006ee16d99d0706$var$TY_DISALLOWED = "disallowed";
const $e006ee16d99d0706$var$TY_EMOJI = "emoji";
const $e006ee16d99d0706$var$TY_NFC = "nfc";
const $e006ee16d99d0706$var$TY_STOP = "stop";
function $e006ee16d99d0706$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $e006ee16d99d0706$var$init();
    let input = $e006ee16d99d0706$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $e006ee16d99d0706$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $e006ee16d99d0706$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $e006ee16d99d0706$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $e006ee16d99d0706$var$STOP) tokens.push({
                type: $e006ee16d99d0706$var$TY_STOP,
                cp: cp
            });
            else if ($e006ee16d99d0706$var$VALID.has(cp)) tokens.push({
                type: $e006ee16d99d0706$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($e006ee16d99d0706$var$IGNORED.has(cp)) tokens.push({
                type: $e006ee16d99d0706$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $e006ee16d99d0706$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $e006ee16d99d0706$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $e006ee16d99d0706$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($e006ee16d99d0706$var$is_valid_or_mapped(token.type)) {
            if ($e006ee16d99d0706$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($e006ee16d99d0706$var$is_valid_or_mapped(type)) {
                        if (!$e006ee16d99d0706$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $e006ee16d99d0706$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$e006ee16d99d0706$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $e006ee16d99d0706$export$f42252642e08449(cps0);
                if ($e006ee16d99d0706$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $e006ee16d99d0706$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $e006ee16d99d0706$var$collapse_valid_tokens(slice),
                        tokens: $e006ee16d99d0706$export$bac129d8210aa825($e006ee16d99d0706$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $e006ee16d99d0706$var$TY_IGNORED) start = -1; // reset
    }
    return $e006ee16d99d0706$var$collapse_valid_tokens(tokens);
}
function $e006ee16d99d0706$var$is_valid_or_mapped(type) {
    return type == $e006ee16d99d0706$var$TY_VALID || type == $e006ee16d99d0706$var$TY_MAPPED;
}
function $e006ee16d99d0706$var$requires_check(cps) {
    return cps.some((cp)=>$e006ee16d99d0706$var$NFC_CHECK.has(cp));
}
function $e006ee16d99d0706$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $e006ee16d99d0706$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $e006ee16d99d0706$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $e006ee16d99d0706$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}

});


parcelRegister("1PldO", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $154b040c27f48330$export$febc5573c75cefb0);

var $95T0n = parcelRequire("95T0n");

var $7RlNJ = parcelRequire("7RlNJ");
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");
var $gzqDp = parcelRequire("gzqDp");
var $fv2Aw = parcelRequire("fv2Aw");
var $7fKql = parcelRequire("7fKql");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $gRqcO = parcelRequire("gRqcO");
var $hqbx3 = parcelRequire("hqbx3");
var $9AgaV = parcelRequire("9AgaV");

var $gGqax = parcelRequire("gGqax");

var $jqUca = parcelRequire("jqUca");
const $154b040c27f48330$var$BN_0 = BigInt(0);
const $154b040c27f48330$var$BN_2 = BigInt(2);
const $154b040c27f48330$var$BN_27 = BigInt(27);
const $154b040c27f48330$var$BN_28 = BigInt(28);
const $154b040c27f48330$var$BN_35 = BigInt(35);
const $154b040c27f48330$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $154b040c27f48330$var$BLOB_SIZE = 131072;
function $154b040c27f48330$var$getVersionedHash(version, hash) {
    let versioned = version.toString(16);
    while(versioned.length < 2)versioned = "0" + versioned;
    versioned += (0, $gzqDp.sha256)(hash).substring(4);
    return "0x" + versioned;
}
function $154b040c27f48330$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $95T0n.getAddress)(value);
}
function $154b040c27f48330$var$handleAccessList(value, param) {
    try {
        return (0, $gGqax.accessListify)(value);
    } catch (error) {
        (0, $8wwEQ.assertArgument)(false, error.message, param, value);
    }
}
function $154b040c27f48330$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $9AgaV.getNumber)(_value, param);
}
function $154b040c27f48330$var$handleUint(_value, param) {
    if (_value === "0x") return $154b040c27f48330$var$BN_0;
    const value = (0, $9AgaV.getBigInt)(_value, param);
    (0, $8wwEQ.assertArgument)(value <= $154b040c27f48330$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $154b040c27f48330$var$formatNumber(_value, name) {
    const value = (0, $9AgaV.getBigInt)(_value, "value");
    const result = (0, $9AgaV.toBeArray)(value);
    (0, $8wwEQ.assertArgument)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $154b040c27f48330$var$formatAccessList(value) {
    return (0, $gGqax.accessListify)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $154b040c27f48330$var$formatHashes(value, param) {
    (0, $8wwEQ.assertArgument)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $154b040c27f48330$var$_parseLegacy(data) {
    const fields = (0, $gRqcO.decodeRlp)(data);
    (0, $8wwEQ.assertArgument)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $154b040c27f48330$var$handleNumber(fields[0], "nonce"),
        gasPrice: $154b040c27f48330$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $154b040c27f48330$var$handleUint(fields[2], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[3]),
        value: $154b040c27f48330$var$handleUint(fields[4], "value"),
        data: (0, $lJSYP.hexlify)(fields[5]),
        chainId: $154b040c27f48330$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $154b040c27f48330$var$handleUint(fields[6], "v");
    const r = $154b040c27f48330$var$handleUint(fields[7], "r");
    const s = $154b040c27f48330$var$handleUint(fields[8], "s");
    if (r === $154b040c27f48330$var$BN_0 && s === $154b040c27f48330$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $154b040c27f48330$var$BN_35) / $154b040c27f48330$var$BN_2;
        if (chainId < $154b040c27f48330$var$BN_0) chainId = $154b040c27f48330$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $8wwEQ.assertArgument)(chainId !== $154b040c27f48330$var$BN_0 || v === $154b040c27f48330$var$BN_27 || v === $154b040c27f48330$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $fv2Aw.Signature).from({
            r: (0, $lJSYP.zeroPadValue)(fields[7], 32),
            s: (0, $lJSYP.zeroPadValue)(fields[8], 32),
            v: v
        });
    //tx.hash = keccak256(data);
    }
    return tx;
}
function $154b040c27f48330$var$_serializeLegacy(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $154b040c27f48330$var$BN_0;
    if (tx.chainId != $154b040c27f48330$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $9AgaV.getBigInt)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $8wwEQ.assertArgument)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $154b040c27f48330$var$BN_0) {
            fields.push((0, $9AgaV.toBeArray)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $hqbx3.encodeRlp)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $154b040c27f48330$var$BN_0) v = (0, $fv2Aw.Signature).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $8wwEQ.assertArgument)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $9AgaV.toBeArray)(v));
    fields.push((0, $9AgaV.toBeArray)(sig.r));
    fields.push((0, $9AgaV.toBeArray)(sig.s));
    return (0, $hqbx3.encodeRlp)(fields);
}
function $154b040c27f48330$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $154b040c27f48330$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $8wwEQ.assertArgument)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $lJSYP.zeroPadValue)(fields[1], 32);
    const s = (0, $lJSYP.zeroPadValue)(fields[2], 32);
    const signature = (0, $fv2Aw.Signature).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $154b040c27f48330$var$_parseEip1559(data) {
    const fields = (0, $gRqcO.decodeRlp)((0, $lJSYP.getBytes)(data).slice(1));
    (0, $8wwEQ.assertArgument)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $lJSYP.hexlify)(data));
    const tx = {
        type: 2,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $154b040c27f48330$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $154b040c27f48330$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $154b040c27f48330$var$handleUint(fields[4], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[5]),
        value: $154b040c27f48330$var$handleUint(fields[6], "value"),
        data: (0, $lJSYP.hexlify)(fields[7]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    //tx.hash = keccak256(data);
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $154b040c27f48330$var$_serializeEip1559(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data,
        $154b040c27f48330$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $9AgaV.toBeArray)(sig.r));
        fields.push((0, $9AgaV.toBeArray)(sig.s));
    }
    return (0, $lJSYP.concat)([
        "0x02",
        (0, $hqbx3.encodeRlp)(fields)
    ]);
}
function $154b040c27f48330$var$_parseEip2930(data) {
    const fields = (0, $gRqcO.decodeRlp)((0, $lJSYP.getBytes)(data).slice(1));
    (0, $8wwEQ.assertArgument)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $lJSYP.hexlify)(data));
    const tx = {
        type: 1,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        gasPrice: $154b040c27f48330$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $154b040c27f48330$var$handleUint(fields[3], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[4]),
        value: $154b040c27f48330$var$handleUint(fields[5], "value"),
        data: (0, $lJSYP.hexlify)(fields[6]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    //tx.hash = keccak256(data);
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $154b040c27f48330$var$_serializeEip2930(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data,
        $154b040c27f48330$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $9AgaV.toBeArray)(sig.r));
        fields.push((0, $9AgaV.toBeArray)(sig.s));
    }
    return (0, $lJSYP.concat)([
        "0x01",
        (0, $hqbx3.encodeRlp)(fields)
    ]);
}
function $154b040c27f48330$var$_parseEip4844(data) {
    let fields = (0, $gRqcO.decodeRlp)((0, $lJSYP.getBytes)(data).slice(1));
    let typeName = "3";
    let blobs = null;
    // Parse the network format
    if (fields.length === 4 && Array.isArray(fields[0])) {
        typeName = "3 (network format)";
        const fBlobs = fields[1], fCommits = fields[2], fProofs = fields[3];
        (0, $8wwEQ.assertArgument)(Array.isArray(fBlobs), "invalid network format: blobs not an array", "fields[1]", fBlobs);
        (0, $8wwEQ.assertArgument)(Array.isArray(fCommits), "invalid network format: commitments not an array", "fields[2]", fCommits);
        (0, $8wwEQ.assertArgument)(Array.isArray(fProofs), "invalid network format: proofs not an array", "fields[3]", fProofs);
        (0, $8wwEQ.assertArgument)(fBlobs.length === fCommits.length, "invalid network format: blobs/commitments length mismatch", "fields", fields);
        (0, $8wwEQ.assertArgument)(fBlobs.length === fProofs.length, "invalid network format: blobs/proofs length mismatch", "fields", fields);
        blobs = [];
        for(let i = 0; i < fields[1].length; i++)blobs.push({
            data: fBlobs[i],
            commitment: fCommits[i],
            proof: fProofs[i]
        });
        fields = fields[0];
    }
    (0, $8wwEQ.assertArgument)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), `invalid field count for transaction type: ${typeName}`, "data", (0, $lJSYP.hexlify)(data));
    const tx = {
        type: 3,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $154b040c27f48330$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $154b040c27f48330$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $154b040c27f48330$var$handleUint(fields[4], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[5]),
        value: $154b040c27f48330$var$handleUint(fields[6], "value"),
        data: (0, $lJSYP.hexlify)(fields[7]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $154b040c27f48330$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    if (blobs) tx.blobs = blobs;
    (0, $8wwEQ.assertArgument)(tx.to != null, `invalid address for transaction type: ${typeName}`, "data", data);
    (0, $8wwEQ.assertArgument)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    // @TODO: Do we need to do this? This is only called internally
    // and used to verify hashes; it might save time to not do this
    //tx.hash = keccak256(concat([ "0x03", encodeRlp(fields) ]));
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $154b040c27f48330$var$_serializeEip4844(tx, sig, blobs) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $7RlNJ.ZeroAddress),
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data,
        $154b040c27f48330$var$formatAccessList(tx.accessList || []),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $154b040c27f48330$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $9AgaV.toBeArray)(sig.r));
        fields.push((0, $9AgaV.toBeArray)(sig.s));
        // We have blobs; return the network wrapped format
        if (blobs) return (0, $lJSYP.concat)([
            "0x03",
            (0, $hqbx3.encodeRlp)([
                fields,
                blobs.map((b)=>b.data),
                blobs.map((b)=>b.commitment),
                blobs.map((b)=>b.proof)
            ])
        ]);
    }
    return (0, $lJSYP.concat)([
        "0x03",
        (0, $hqbx3.encodeRlp)(fields)
    ]);
}
class $154b040c27f48330$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    #kzg;
    #blobs;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, $8wwEQ.assertArgument)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $7RlNJ.ZeroAddress;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $95T0n.getAddress)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $9AgaV.getNumber)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $9AgaV.getBigInt)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $154b040c27f48330$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $9AgaV.getBigInt)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $154b040c27f48330$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $9AgaV.getBigInt)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $154b040c27f48330$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $9AgaV.getBigInt)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $lJSYP.hexlify)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $9AgaV.getBigInt)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $9AgaV.getBigInt)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $fv2Aw.Signature).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $gGqax.accessListify)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $154b040c27f48330$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $9AgaV.getBigInt)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $8wwEQ.assertArgument)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */ get blobs() {
        if (this.#blobs == null) return null;
        return this.#blobs.map((b)=>Object.assign({}, b));
    }
    set blobs(_blobs) {
        if (_blobs == null) {
            this.#blobs = null;
            return;
        }
        const blobs = [];
        const versionedHashes = [];
        for(let i = 0; i < _blobs.length; i++){
            const blob = _blobs[i];
            if ((0, $lJSYP.isBytesLike)(blob)) {
                (0, $8wwEQ.assert)(this.#kzg, "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
                    operation: "set blobs()"
                });
                let data = (0, $lJSYP.getBytes)(blob);
                (0, $8wwEQ.assertArgument)(data.length <= $154b040c27f48330$var$BLOB_SIZE, "blob is too large", `blobs[${i}]`, blob);
                // Pad blob if necessary
                if (data.length !== $154b040c27f48330$var$BLOB_SIZE) {
                    const padded = new Uint8Array($154b040c27f48330$var$BLOB_SIZE);
                    padded.set(data);
                    data = padded;
                }
                const commit = this.#kzg.blobToKzgCommitment(data);
                const proof = (0, $lJSYP.hexlify)(this.#kzg.computeBlobKzgProof(data, commit));
                blobs.push({
                    data: (0, $lJSYP.hexlify)(data),
                    commitment: (0, $lJSYP.hexlify)(commit),
                    proof: proof
                });
                versionedHashes.push($154b040c27f48330$var$getVersionedHash(1, commit));
            } else {
                const commit = (0, $lJSYP.hexlify)(blob.commitment);
                blobs.push({
                    data: (0, $lJSYP.hexlify)(blob.data),
                    commitment: commit,
                    proof: (0, $lJSYP.hexlify)(blob.proof)
                });
                versionedHashes.push($154b040c27f48330$var$getVersionedHash(1, commit));
            }
        }
        this.#blobs = blobs;
        this.#blobVersionedHashes = versionedHashes;
    }
    get kzg() {
        return this.#kzg;
    }
    set kzg(kzg) {
        this.#kzg = kzg;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $154b040c27f48330$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $154b040c27f48330$var$BN_0;
        this.#chainId = $154b040c27f48330$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
        this.#blobs = null;
        this.#kzg = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $dnGYA.keccak256)(this.#getSerialized(true, false));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $dnGYA.keccak256)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $jqUca.recoverAddress)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $7fKql.SigningKey).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    #getSerialized(signed, sidecar) {
        (0, $8wwEQ.assert)(!signed || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        const sig = signed ? this.signature : null;
        switch(this.inferType()){
            case 0:
                return $154b040c27f48330$var$_serializeLegacy(this, sig);
            case 1:
                return $154b040c27f48330$var$_serializeEip2930(this, sig);
            case 2:
                return $154b040c27f48330$var$_serializeEip1559(this, sig);
            case 3:
                return $154b040c27f48330$var$_serializeEip4844(this, sig, sidecar ? this.blobs : null);
        }
        (0, $8wwEQ.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        return this.#getSerialized(true, true);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        return this.#getSerialized(false, false);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $8wwEQ.assert)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $8wwEQ.assert)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $8wwEQ.assert)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $154b040c27f48330$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $154b040c27f48330$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $lJSYP.getBytes)(tx);
            if (payload[0] >= 0x7f) return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip2930(payload));
                case 2:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip1559(payload));
                case 3:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip4844(payload));
            }
            (0, $8wwEQ.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $154b040c27f48330$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $fv2Aw.Signature).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        // This will get overwritten by blobs, if present
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        // Make sure we assign the kzg before assigning blobs, which
        // require the library in the event raw blob data is provided.
        if (tx.kzg != null) result.kzg = tx.kzg;
        if (tx.blobs != null) result.blobs = tx.blobs;
        if (tx.hash != null) {
            (0, $8wwEQ.assertArgument)(result.isSigned(), "unsigned transaction cannot define '.hash'", "tx", tx);
            (0, $8wwEQ.assertArgument)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $8wwEQ.assertArgument)(result.isSigned(), "unsigned transaction cannot define '.from'", "tx", tx);
            (0, $8wwEQ.assertArgument)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}

});
parcelRegister("gRqcO", function(module, exports) {

$parcel$export(module.exports, "decodeRlp", () => $c465ec7edc0c99d6$export$7dc021e13b2aa20d);
//See: https://github.com/ethereum/wiki/wiki/RLP

var $lJSYP = parcelRequire("lJSYP");

var $8wwEQ = parcelRequire("8wwEQ");
function $c465ec7edc0c99d6$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $c465ec7edc0c99d6$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $c465ec7edc0c99d6$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $8wwEQ.assert)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $c465ec7edc0c99d6$var$_decode(data, offset) {
    (0, $8wwEQ.assert)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $8wwEQ.assert)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $c465ec7edc0c99d6$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $c465ec7edc0c99d6$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $lJSYP.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $lJSYP.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $c465ec7edc0c99d6$var$hexlifyByte(data[offset])
    };
}
function $c465ec7edc0c99d6$export$7dc021e13b2aa20d(_data) {
    const data = (0, $lJSYP.getBytes)(_data, "data");
    const decoded = $c465ec7edc0c99d6$var$_decode(data, 0);
    (0, $8wwEQ.assertArgument)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

});

parcelRegister("hqbx3", function(module, exports) {

$parcel$export(module.exports, "encodeRlp", () => $caedcf6749fe63e5$export$aea7770274d28b7);
//See: https://github.com/ethereum/wiki/wiki/RLP

var $lJSYP = parcelRequire("lJSYP");
function $caedcf6749fe63e5$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $caedcf6749fe63e5$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($caedcf6749fe63e5$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $caedcf6749fe63e5$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $lJSYP.getBytes)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $caedcf6749fe63e5$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $caedcf6749fe63e5$var$nibbles = "0123456789abcdef";
function $caedcf6749fe63e5$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $caedcf6749fe63e5$var$_encode(object)){
        result += $caedcf6749fe63e5$var$nibbles[v >> 4];
        result += $caedcf6749fe63e5$var$nibbles[v & 0xf];
    }
    return result;
}

});

parcelRegister("jqUca", function(module, exports) {

$parcel$export(module.exports, "recoverAddress", () => $e25c0939af0d847b$export$23cc18f96d8510e2);

var $95T0n = parcelRequire("95T0n");
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");
var $7fKql = parcelRequire("7fKql");
function $e25c0939af0d847b$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $7fKql.SigningKey).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $95T0n.getAddress)((0, $dnGYA.keccak256)("0x" + pubkey.substring(4)).substring(26));
}
function $e25c0939af0d847b$export$23cc18f96d8510e2(digest, signature) {
    return $e25c0939af0d847b$export$e67e2732ba9803f9((0, $7fKql.SigningKey).recoverPublicKey(digest, signature));
}

});


parcelRegister("3PTkx", function(module, exports) {

$parcel$export(module.exports, "FetchResponse", () => $2cb10defc4f72334$export$3ae09bba5b6b906e);
$parcel$export(module.exports, "FetchRequest", () => $2cb10defc4f72334$export$319b96fe59834522);
/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ 
var $6DHB7 = parcelRequire("6DHB7");

var $lJSYP = parcelRequire("lJSYP");

var $8wwEQ = parcelRequire("8wwEQ");

var $7N4fp = parcelRequire("7N4fp");

var $6Vneh = parcelRequire("6Vneh");

var $d4bXQ = parcelRequire("d4bXQ");
const $2cb10defc4f72334$var$MAX_ATTEMPTS = 12;
const $2cb10defc4f72334$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $2cb10defc4f72334$var$defaultGetUrlFunc = (0, $d4bXQ.createGetUrl)();
const $2cb10defc4f72334$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $2cb10defc4f72334$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $2cb10defc4f72334$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $2cb10defc4f72334$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($2cb10defc4f72334$var$reData);
        if (!match) throw new Error("invalid data");
        return new $2cb10defc4f72334$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $6DHB7.decodeBase64)(match[3]) : $2cb10defc4f72334$var$unpercent(match[3]));
    } catch (error) {
        return new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $2cb10defc4f72334$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $2cb10defc4f72334$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($2cb10defc4f72334$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $2cb10defc4f72334$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $2cb10defc4f72334$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $2cb10defc4f72334$var$Gateways = {
    "data": $2cb10defc4f72334$var$dataGatewayFunc,
    "ipfs": $2cb10defc4f72334$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $2cb10defc4f72334$var$fetchSignals = new WeakMap();
class $2cb10defc4f72334$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $2cb10defc4f72334$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $8wwEQ.assert)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $8wwEQ.assert)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $2cb10defc4f72334$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $2cb10defc4f72334$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $6Vneh.toUtf8Bytes)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $6Vneh.toUtf8Bytes)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $6DHB7.encodeBase64)((0, $6Vneh.toUtf8Bytes)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $8wwEQ.assertArgument)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $8wwEQ.assertArgument)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $2cb10defc4f72334$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $2cb10defc4f72334$var$SLOT_INTERVAL,
            maxAttempts: $2cb10defc4f72334$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $lJSYP.hexlify)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $8wwEQ.assert)($2cb10defc4f72334$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $2cb10defc4f72334$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $2cb10defc4f72334$var$Gateways) {
            const result = await $2cb10defc4f72334$var$Gateways[scheme](req.url, $2cb10defc4f72334$var$checkSignal(_request.#signal));
            if (result instanceof $2cb10defc4f72334$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $2cb10defc4f72334$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $2cb10defc4f72334$var$checkSignal(_request.#signal));
        let response = new $2cb10defc4f72334$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $2cb10defc4f72334$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $8wwEQ.assert)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $2cb10defc4f72334$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $2cb10defc4f72334$var$getTime() + this.timeout, 0, this, new $2cb10defc4f72334$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $8wwEQ.assert)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $2cb10defc4f72334$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $8wwEQ.assert)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $2cb10defc4f72334$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $2cb10defc4f72334$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#throttle = Object.assign({}, this.#throttle);
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $2cb10defc4f72334$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $2cb10defc4f72334$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($2cb10defc4f72334$var$locked) throw new Error("gateways locked");
        $2cb10defc4f72334$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($2cb10defc4f72334$var$locked) throw new Error("gateways locked");
        $2cb10defc4f72334$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $d4bXQ.createGetUrl)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $2cb10defc4f72334$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $2cb10defc4f72334$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $2cb10defc4f72334$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $lJSYP.hexlify)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $6Vneh.toUtf8String)(this.#body);
        } catch (error) {
            (0, $8wwEQ.assert)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $8wwEQ.assert)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $8wwEQ.assertArgument)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $7N4fp.defineProperties)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $6Vneh.toUtf8String)(this.#body);
        } catch (e) {}
        (0, $8wwEQ.assert)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $2cb10defc4f72334$var$getTime() {
    return new Date().getTime();
}
function $2cb10defc4f72334$var$unpercent(value) {
    return (0, $6Vneh.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $2cb10defc4f72334$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}

});
parcelRegister("6DHB7", function(module, exports) {

$parcel$export(module.exports, "decodeBase64", () => $4d58342a3bfda827$export$94fdf11bafc8de6b);
$parcel$export(module.exports, "encodeBase64", () => $4d58342a3bfda827$export$8fb536984ec8b4d7);
// utils/base64-browser

var $lJSYP = parcelRequire("lJSYP");
function $4d58342a3bfda827$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $lJSYP.getBytes)(data);
}
function $4d58342a3bfda827$export$8fb536984ec8b4d7(_data) {
    const data = (0, $lJSYP.getBytes)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});

parcelRegister("d4bXQ", function(module, exports) {

$parcel$export(module.exports, "createGetUrl", () => $9834edf3ba75eaa8$export$d3950daf7bce5bf5);

var $8wwEQ = parcelRequire("8wwEQ");
function $9834edf3ba75eaa8$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        (0, $8wwEQ.assert)(_signal == null || !_signal.cancelled, "request cancelled before sending", "CANCELLED");
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $8wwEQ.assert)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $8wwEQ.assert)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let error = null;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            error = (0, $8wwEQ.makeError)("request timeout", "TIMEOUT");
            controller.abort();
        }, req.timeout);
        if (_signal) _signal.addListener(()=>{
            error = (0, $8wwEQ.makeError)("request cancelled", "CANCELLED");
            controller.abort();
        });
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: controller.signal
        };
        let resp;
        try {
            resp = await fetch(req.url, init);
        } catch (_error) {
            clearTimeout(timer);
            if (error) throw error;
            throw _error;
        }
        clearTimeout(timer);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $9834edf3ba75eaa8$var$defaultGetUrl = $9834edf3ba75eaa8$export$d3950daf7bce5bf5({});
async function $9834edf3ba75eaa8$export$94df0e59ebebf4a7(req, _signal) {
    return $9834edf3ba75eaa8$var$defaultGetUrl(req, _signal);
}

});


parcelRegister("3rcfR", function(module, exports) {

$parcel$export(module.exports, "EnsResolver", () => $280d6641ec976e99$export$d04afd034a0a53ae);
/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 
var $95T0n = parcelRequire("95T0n");

var $7RlNJ = parcelRequire("7RlNJ");

var $1dRRv = parcelRequire("1dRRv");

var $7uHh6 = parcelRequire("7uHh6");

var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
var $f6bCR = parcelRequire("f6bCR");
var $3PTkx = parcelRequire("3PTkx");
var $lJSYP = parcelRequire("lJSYP");
var $9AgaV = parcelRequire("9AgaV");
// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $280d6641ec976e99$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $8wwEQ.assertArgument)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $280d6641ec976e99$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $7N4fp.defineProperties)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $280d6641ec976e99$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $280d6641ec976e99$export$dcf63b2028a708b5 extends $280d6641ec976e99$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($280d6641ec976e99$var$BasicMulticoinPluginId);
    }
}
const $280d6641ec976e99$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $280d6641ec976e99$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $280d6641ec976e99$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $280d6641ec976e99$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $7N4fp.defineProperties)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $1dRRv.Contract)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $8wwEQ.isError)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $7uHh6.namehash)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $8wwEQ.assert)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $7uHh6.dnsEncode)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $8wwEQ.isError)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $7RlNJ.ZeroAddress)) return null;
            return result;
        } catch (error) {
            if ((0, $8wwEQ.isError)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $lJSYP.isHexString)(data, 20)) return (0, $95T0n.getAddress)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $280d6641ec976e99$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $8wwEQ.assert)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $f6bCR.encodeBase58)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $8wwEQ.assert)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $280d6641ec976e99$var$matchers.length; i++){
                const match = avatar.match($280d6641ec976e99$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $280d6641ec976e99$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $1dRRv.Contract)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $9AgaV.toBeHex)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $280d6641ec976e99$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $3PTkx.FetchRequest)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $lJSYP.hexlify)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($280d6641ec976e99$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $280d6641ec976e99$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $8wwEQ.assert)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $280d6641ec976e99$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $1dRRv.Contract)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $7uHh6.namehash)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $7RlNJ.ZeroAddress)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $280d6641ec976e99$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $280d6641ec976e99$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}

});
parcelRegister("f6bCR", function(module, exports) {

$parcel$export(module.exports, "encodeBase58", () => $afe06f2b2ad79fd5$export$743e6bddc3282b13);
/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 
var $lJSYP = parcelRequire("lJSYP");

var $8wwEQ = parcelRequire("8wwEQ");

var $9AgaV = parcelRequire("9AgaV");
const $afe06f2b2ad79fd5$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $afe06f2b2ad79fd5$var$Lookup = null;
function $afe06f2b2ad79fd5$var$getAlpha(letter) {
    if ($afe06f2b2ad79fd5$var$Lookup == null) {
        $afe06f2b2ad79fd5$var$Lookup = {};
        for(let i = 0; i < $afe06f2b2ad79fd5$var$Alphabet.length; i++)$afe06f2b2ad79fd5$var$Lookup[$afe06f2b2ad79fd5$var$Alphabet[i]] = BigInt(i);
    }
    const result = $afe06f2b2ad79fd5$var$Lookup[letter];
    (0, $8wwEQ.assertArgument)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $afe06f2b2ad79fd5$var$BN_0 = BigInt(0);
const $afe06f2b2ad79fd5$var$BN_58 = BigInt(58);
function $afe06f2b2ad79fd5$export$743e6bddc3282b13(_value) {
    const bytes = (0, $lJSYP.getBytes)(_value);
    let value = (0, $9AgaV.toBigInt)(bytes);
    let result = "";
    while(value){
        result = $afe06f2b2ad79fd5$var$Alphabet[Number(value % $afe06f2b2ad79fd5$var$BN_58)] + result;
        value /= $afe06f2b2ad79fd5$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $afe06f2b2ad79fd5$var$Alphabet[0] + result;
    }
    return result;
}
function $afe06f2b2ad79fd5$export$63d430871b22e3d9(value) {
    let result = $afe06f2b2ad79fd5$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $afe06f2b2ad79fd5$var$BN_58;
        result += $afe06f2b2ad79fd5$var$getAlpha(value[i]);
    }
    return result;
}

});


parcelRegister("c46JD", function(module, exports) {

$parcel$export(module.exports, "formatLog", () => $8c8b15350cbd9f48$export$fccdbdc2b9d7893);
$parcel$export(module.exports, "formatBlock", () => $8c8b15350cbd9f48$export$ba1152bc4017d62a);
$parcel$export(module.exports, "formatTransactionResponse", () => $8c8b15350cbd9f48$export$fe50e42b325965d);
$parcel$export(module.exports, "formatTransactionReceipt", () => $8c8b15350cbd9f48$export$30da670e49d6fc31);
/**
 *  @_ignore
 */ 
var $95T0n = parcelRequire("95T0n");
var $lXOyU = parcelRequire("lXOyU");

var $fv2Aw = parcelRequire("fv2Aw");

var $gGqax = parcelRequire("gGqax");

var $8wwEQ = parcelRequire("8wwEQ");
var $9AgaV = parcelRequire("9AgaV");
var $lJSYP = parcelRequire("lJSYP");
const $8c8b15350cbd9f48$var$BN_0 = BigInt(0);
function $8c8b15350cbd9f48$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $8c8b15350cbd9f48$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $8c8b15350cbd9f48$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $8wwEQ.assert)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $8c8b15350cbd9f48$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $8wwEQ.assertArgument)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $8c8b15350cbd9f48$export$1f26277db27165ba(value) {
    (0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(value, true), "invalid data", "value", value);
    return value;
}
function $8c8b15350cbd9f48$export$bb5bc852e1c64b88(value) {
    (0, $8wwEQ.assertArgument)((0, $lJSYP.isHexString)(value, 32), "invalid hash", "value", value);
    return value;
}
function $8c8b15350cbd9f48$export$aff4fda55e7ac0d6(value) {
    if (!(0, $lJSYP.isHexString)(value)) throw new Error("invalid uint256");
    return (0, $lJSYP.zeroPadValue)(value, 32);
}
const $8c8b15350cbd9f48$var$_formatLog = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    address: (0, $95T0n.getAddress),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    blockNumber: (0, $9AgaV.getNumber),
    data: $8c8b15350cbd9f48$export$1f26277db27165ba,
    index: (0, $9AgaV.getNumber),
    removed: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$7a3be81718959bda, false),
    topics: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    transactionHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    transactionIndex: (0, $9AgaV.getNumber)
}, {
    index: [
        "logIndex"
    ]
});
function $8c8b15350cbd9f48$export$fccdbdc2b9d7893(value) {
    return $8c8b15350cbd9f48$var$_formatLog(value);
}
const $8c8b15350cbd9f48$var$_formatBlock = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    hash: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    parentHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    number: (0, $9AgaV.getNumber),
    timestamp: (0, $9AgaV.getNumber),
    nonce: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$1f26277db27165ba),
    difficulty: (0, $9AgaV.getBigInt),
    gasLimit: (0, $9AgaV.getBigInt),
    gasUsed: (0, $9AgaV.getBigInt),
    stateRoot: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    receiptsRoot: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    blobGasUsed: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt), null),
    excessBlobGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt), null),
    miner: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $95T0n.getAddress)),
    prevRandao: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    extraData: $8c8b15350cbd9f48$export$1f26277db27165ba,
    baseFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt))
}, {
    prevRandao: [
        "mixHash"
    ]
});
function $8c8b15350cbd9f48$export$ba1152bc4017d62a(value) {
    const result = $8c8b15350cbd9f48$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $8c8b15350cbd9f48$export$fe50e42b325965d(tx);
    });
    return result;
}
const $8c8b15350cbd9f48$var$_formatReceiptLog = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    transactionIndex: (0, $9AgaV.getNumber),
    blockNumber: (0, $9AgaV.getNumber),
    transactionHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    address: (0, $95T0n.getAddress),
    topics: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    data: $8c8b15350cbd9f48$export$1f26277db27165ba,
    index: (0, $9AgaV.getNumber),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $8c8b15350cbd9f48$export$5ec2fc59e0e92b87(value) {
    return $8c8b15350cbd9f48$var$_formatReceiptLog(value);
}
const $8c8b15350cbd9f48$var$_formatTransactionReceipt = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    to: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $95T0n.getAddress), null),
    from: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $95T0n.getAddress), null),
    contractAddress: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $95T0n.getAddress), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $9AgaV.getNumber),
    root: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $lJSYP.hexlify)),
    gasUsed: (0, $9AgaV.getBigInt),
    blobGasUsed: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt), null),
    logsBloom: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$1f26277db27165ba),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    hash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    logs: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$5ec2fc59e0e92b87),
    blockNumber: (0, $9AgaV.getNumber),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $9AgaV.getBigInt),
    effectiveGasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt)),
    blobGasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt), null),
    status: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getNumber)),
    type: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getNumber), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $8c8b15350cbd9f48$export$30da670e49d6fc31(value) {
    return $8c8b15350cbd9f48$var$_formatTransactionReceipt(value);
}
function $8c8b15350cbd9f48$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $9AgaV.getBigInt)(value.to) === $8c8b15350cbd9f48$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $8c8b15350cbd9f48$export$be5493f9613cbbe({
        hash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getNumber), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $9AgaV.getNumber)(value);
        },
        accessList: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $gGqax.accessListify), null),
        blobVersionedHashes: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88, true), null),
        blockHash: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
        blockNumber: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getNumber), null),
        transactionIndex: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getNumber), null),
        from: (0, $95T0n.getAddress),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt)),
        maxPriorityFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt)),
        maxFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt)),
        maxFeePerBlobGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt), null),
        gasLimit: (0, $9AgaV.getBigInt),
        to: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $95T0n.getAddress), null),
        value: (0, $9AgaV.getBigInt),
        nonce: (0, $9AgaV.getNumber),
        data: $8c8b15350cbd9f48$export$1f26277db27165ba,
        creates: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $95T0n.getAddress), null),
        chainId: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $9AgaV.getBigInt), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $lXOyU.getCreateAddress)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $fv2Aw.Signature).from(value.signature);
    else result.signature = (0, $fv2Aw.Signature).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $9AgaV.getBigInt)(result.blockHash) === $8c8b15350cbd9f48$var$BN_0) result.blockHash = null;
    return result;
}

});
parcelRegister("lXOyU", function(module, exports) {

$parcel$export(module.exports, "getCreateAddress", () => $ffd6543f65258923$export$769b627a7e45189e);
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $hqbx3 = parcelRequire("hqbx3");
var $9AgaV = parcelRequire("9AgaV");

var $95T0n = parcelRequire("95T0n");
function $ffd6543f65258923$export$769b627a7e45189e(tx) {
    const from = (0, $95T0n.getAddress)(tx.from);
    const nonce = (0, $9AgaV.getBigInt)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $95T0n.getAddress)((0, $lJSYP.dataSlice)((0, $dnGYA.keccak256)((0, $hqbx3.encodeRlp)([
        from,
        nonceHex
    ])), 12));
}
function $ffd6543f65258923$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $95T0n.getAddress)(_from);
    const salt = (0, $lJSYP.getBytes)(_salt, "salt");
    const initCodeHash = (0, $lJSYP.getBytes)(_initCodeHash, "initCodeHash");
    (0, $8wwEQ.assertArgument)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $8wwEQ.assertArgument)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $95T0n.getAddress)((0, $lJSYP.dataSlice)((0, $dnGYA.keccak256)((0, $lJSYP.concat)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}

});


parcelRegister("6i1Zn", function(module, exports) {

$parcel$export(module.exports, "Network", () => $4945f77db30f37e3$export$95be4ae94445245a);
/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 
var $gGqax = parcelRequire("gGqax");

var $8wwEQ = parcelRequire("8wwEQ");
var $9AgaV = parcelRequire("9AgaV");

var $byl1Q = parcelRequire("byl1Q");
/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $4945f77db30f37e3$var$Networks = new Map();
class $4945f77db30f37e3$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $9AgaV.getBigInt)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $9AgaV.getBigInt)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $9AgaV.getBigInt)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $9AgaV.getBigInt)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $9AgaV.getBigInt)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $4945f77db30f37e3$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $byl1Q.GasCostPlugin)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $gGqax.accessListify)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $4945f77db30f37e3$var$injectCommonNetworks();
        // Default network
        if (network == null) return $4945f77db30f37e3$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $4945f77db30f37e3$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $4945f77db30f37e3$export$95be4ae94445245a("unknown", network);
            (0, $8wwEQ.assertArgument)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $8wwEQ.assertArgument)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $4945f77db30f37e3$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $byl1Q.EnsPlugin)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $8wwEQ.assertArgument)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $4945f77db30f37e3$var$Networks.get(nameOrChainId);
        if (existing) (0, $8wwEQ.assertArgument)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $4945f77db30f37e3$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $4945f77db30f37e3$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $4945f77db30f37e3$var$getGasStationPlugin(url) {
    return new (0, $byl1Q.FetchUrlFeeDataNetworkPlugin)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $4945f77db30f37e3$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $4945f77db30f37e3$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $8wwEQ.assert)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $4945f77db30f37e3$var$injected = false;
function $4945f77db30f37e3$var$injectCommonNetworks() {
    if ($4945f77db30f37e3$var$injected) return;
    $4945f77db30f37e3$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $4945f77db30f37e3$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $byl1Q.EnsPlugin)(null, options.ensNetwork));
            network.attachPlugin(new (0, $byl1Q.GasCostPlugin)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $4945f77db30f37e3$export$95be4ae94445245a.register(name, func);
        $4945f77db30f37e3$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $4945f77db30f37e3$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("linea-sepolia", 59141, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $4945f77db30f37e3$var$getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-amoy", 80002, {});
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $4945f77db30f37e3$var$getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}

});
parcelRegister("byl1Q", function(module, exports) {

$parcel$export(module.exports, "GasCostPlugin", () => $86932e930ca5c8a5$export$f2b0810a2dd50377);
$parcel$export(module.exports, "EnsPlugin", () => $86932e930ca5c8a5$export$9be0b2c573890879);
$parcel$export(module.exports, "FetchUrlFeeDataNetworkPlugin", () => $86932e930ca5c8a5$export$3bee30f9880d72e8);

var $7N4fp = parcelRequire("7N4fp");

var $8wwEQ = parcelRequire("8wwEQ");
const $86932e930ca5c8a5$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $7N4fp.defineProperties)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $86932e930ca5c8a5$export$10ae60faeb7e2196(this.name);
    }
}
class $86932e930ca5c8a5$export$f2b0810a2dd50377 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $8wwEQ.assertArgument)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $7N4fp.defineProperties)(this, props);
    }
    clone() {
        return new $86932e930ca5c8a5$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $86932e930ca5c8a5$export$9be0b2c573890879 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $7N4fp.defineProperties)(this, {
            address: address || $86932e930ca5c8a5$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $86932e930ca5c8a5$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $86932e930ca5c8a5$export$dd49482b7e9ea2da extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $86932e930ca5c8a5$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $86932e930ca5c8a5$export$3bee30f9880d72e8 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 

});


parcelRegister("kZz8q", function(module, exports) {

$parcel$export(module.exports, "PollingBlockSubscriber", () => $f484c23113a92e9e$export$aaf796a16ac1a157);
$parcel$export(module.exports, "PollingTransactionSubscriber", () => $f484c23113a92e9e$export$4fe8a9740765f97e);
$parcel$export(module.exports, "PollingBlockTagSubscriber", () => $f484c23113a92e9e$export$63862f83f14090ef);
$parcel$export(module.exports, "PollingOrphanSubscriber", () => $f484c23113a92e9e$export$e4ed5c6414dc4e9e);
$parcel$export(module.exports, "PollingEventSubscriber", () => $f484c23113a92e9e$export$bdb759dc2fe68c72);

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
function $f484c23113a92e9e$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $f484c23113a92e9e$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $f484c23113a92e9e$export$aaf796a16ac1a157(provider);
    if ((0, $lJSYP.isHexString)(event, 32)) return new $f484c23113a92e9e$export$4fe8a9740765f97e(provider, event);
    (0, $8wwEQ.assert)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $f484c23113a92e9e$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $f484c23113a92e9e$export$63862f83f14090ef extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $f484c23113a92e9e$export$e4ed5c6414dc4e9e extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $f484c23113a92e9e$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $f484c23113a92e9e$export$4fe8a9740765f97e extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $f484c23113a92e9e$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $f484c23113a92e9e$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $f484c23113a92e9e$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}

});



parcelRegister("jxZic", function(module, exports) {

$parcel$export(module.exports, "formatEther", () => $e3b0a4d4db1a46c4$export$11bc63b4c03ea518);
$parcel$export(module.exports, "parseEther", () => $e3b0a4d4db1a46c4$export$642c4e67bbdc0bc7);
/**
 *  Most interactions with Ethereum requires integer values, which use
 *  the smallest magnitude unit.
 *
 *  For example, imagine dealing with dollars and cents. Since dollars
 *  are divisible, non-integer values are possible, such as ``$10.77``.
 *  By using the smallest indivisible unit (i.e. cents), the value can
 *  be kept as the integer ``1077``.
 *
 *  When receiving decimal input from the user (as a decimal string),
 *  the value should be converted to an integer and when showing a user
 *  a value, the integer value should be converted to a decimal string.
 *
 *  This creates a clear distinction, between values to be used by code
 *  (integers) and values used for display logic to users (decimals).
 *
 *  The native unit in Ethereum, //ether// is divisible to 18 decimal places,
 *  where each individual unit is called a //wei//.
 *
 *  @_subsection api/utils:Unit Conversion  [about-units]
 */ 
var $8wwEQ = parcelRequire("8wwEQ");

var $4oaI4 = parcelRequire("4oaI4");

var $9AgaV = parcelRequire("9AgaV");
const $e3b0a4d4db1a46c4$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $e3b0a4d4db1a46c4$export$bd39b96f71da1885(value, unit) {
    let decimals = 18;
    if (typeof unit === "string") {
        const index = $e3b0a4d4db1a46c4$var$names.indexOf(unit);
        (0, $8wwEQ.assertArgument)(index >= 0, "invalid unit", "unit", unit);
        decimals = 3 * index;
    } else if (unit != null) decimals = (0, $9AgaV.getNumber)(unit, "unit");
    return (0, $4oaI4.FixedNumber).fromValue(value, decimals, {
        decimals: decimals,
        width: 512
    }).toString();
}
function $e3b0a4d4db1a46c4$export$203ae30b4f6490b3(value, unit) {
    (0, $8wwEQ.assertArgument)(typeof value === "string", "value must be a string", "value", value);
    let decimals = 18;
    if (typeof unit === "string") {
        const index = $e3b0a4d4db1a46c4$var$names.indexOf(unit);
        (0, $8wwEQ.assertArgument)(index >= 0, "invalid unit", "unit", unit);
        decimals = 3 * index;
    } else if (unit != null) decimals = (0, $9AgaV.getNumber)(unit, "unit");
    return (0, $4oaI4.FixedNumber).fromString(value, {
        decimals: decimals,
        width: 512
    }).value;
}
function $e3b0a4d4db1a46c4$export$11bc63b4c03ea518(wei) {
    return $e3b0a4d4db1a46c4$export$bd39b96f71da1885(wei, 18);
}
function $e3b0a4d4db1a46c4$export$642c4e67bbdc0bc7(ether) {
    return $e3b0a4d4db1a46c4$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("4oaI4", function(module, exports) {

$parcel$export(module.exports, "FixedNumber", () => $3321b612fa8b580d$export$d4693c66c2213e45);
/**
 *  The **FixedNumber** class permits using values with decimal places,
 *  using fixed-pont math.
 *
 *  Fixed-point math is still based on integers under-the-hood, but uses an
 *  internal offset to store fractional components below, and each operation
 *  corrects for this after each operation.
 *
 *  @_section: api/utils/fixed-point-math:Fixed-Point Maths  [about-fixed-point-math]
 */ 
var $lJSYP = parcelRequire("lJSYP");

var $8wwEQ = parcelRequire("8wwEQ");

var $9AgaV = parcelRequire("9AgaV");

var $7N4fp = parcelRequire("7N4fp");
const $3321b612fa8b580d$var$BN_N1 = BigInt(-1);
const $3321b612fa8b580d$var$BN_0 = BigInt(0);
const $3321b612fa8b580d$var$BN_1 = BigInt(1);
const $3321b612fa8b580d$var$BN_5 = BigInt(5);
const $3321b612fa8b580d$var$_guard = {};
// Constant to pull zeros from for multipliers
let $3321b612fa8b580d$var$Zeros = "0000";
while($3321b612fa8b580d$var$Zeros.length < 80)$3321b612fa8b580d$var$Zeros += $3321b612fa8b580d$var$Zeros;
// Returns a string "1" followed by decimal "0"s
function $3321b612fa8b580d$var$getTens(decimals) {
    let result = $3321b612fa8b580d$var$Zeros;
    while(result.length < decimals)result += result;
    return BigInt("1" + result.substring(0, decimals));
}
function $3321b612fa8b580d$var$checkValue(val, format, safeOp) {
    const width = BigInt(format.width);
    if (format.signed) {
        const limit = $3321b612fa8b580d$var$BN_1 << width - $3321b612fa8b580d$var$BN_1;
        (0, $8wwEQ.assert)(safeOp == null || val >= -limit && val < limit, "overflow", "NUMERIC_FAULT", {
            operation: safeOp,
            fault: "overflow",
            value: val
        });
        if (val > $3321b612fa8b580d$var$BN_0) val = (0, $9AgaV.fromTwos)((0, $9AgaV.mask)(val, width), width);
        else val = -(0, $9AgaV.fromTwos)((0, $9AgaV.mask)(-val, width), width);
    } else {
        const limit = $3321b612fa8b580d$var$BN_1 << width;
        (0, $8wwEQ.assert)(safeOp == null || val >= 0 && val < limit, "overflow", "NUMERIC_FAULT", {
            operation: safeOp,
            fault: "overflow",
            value: val
        });
        val = (val % limit + limit) % limit & limit - $3321b612fa8b580d$var$BN_1;
    }
    return val;
}
function $3321b612fa8b580d$var$getFormat(value) {
    if (typeof value === "number") value = `fixed128x${value}`;
    let signed = true;
    let width = 128;
    let decimals = 18;
    if (typeof value === "string") {
        // Parse the format string
        if (value === "fixed") ;
        else if (value === "ufixed") signed = false;
        else {
            const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
            (0, $8wwEQ.assertArgument)(match, "invalid fixed format", "format", value);
            signed = match[1] !== "u";
            width = parseInt(match[2]);
            decimals = parseInt(match[3]);
        }
    } else if (value) {
        // Extract the values from the object
        const v = value;
        const check = (key, type, defaultValue)=>{
            if (v[key] == null) return defaultValue;
            (0, $8wwEQ.assertArgument)(typeof v[key] === type, "invalid fixed format (" + key + " not " + type + ")", "format." + key, v[key]);
            return v[key];
        };
        signed = check("signed", "boolean", signed);
        width = check("width", "number", width);
        decimals = check("decimals", "number", decimals);
    }
    (0, $8wwEQ.assertArgument)(width % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", width);
    (0, $8wwEQ.assertArgument)(decimals <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", decimals);
    const name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
    return {
        signed: signed,
        width: width,
        decimals: decimals,
        name: name
    };
}
function $3321b612fa8b580d$var$toString(val, decimals) {
    let negative = "";
    if (val < $3321b612fa8b580d$var$BN_0) {
        negative = "-";
        val *= $3321b612fa8b580d$var$BN_N1;
    }
    let str = val.toString();
    // No decimal point for whole values
    if (decimals === 0) return negative + str;
    // Pad out to the whole component (including a whole digit)
    while(str.length <= decimals)str = $3321b612fa8b580d$var$Zeros + str;
    // Insert the decimal point
    const index = str.length - decimals;
    str = str.substring(0, index) + "." + str.substring(index);
    // Trim the whole component (leaving at least one 0)
    while(str[0] === "0" && str[1] !== ".")str = str.substring(1);
    // Trim the decimal component (leaving at least one 0)
    while(str[str.length - 1] === "0" && str[str.length - 2] !== ".")str = str.substring(0, str.length - 1);
    return negative + str;
}
class $3321b612fa8b580d$export$d4693c66c2213e45 {
    /**
     *  The specific fixed-point arithmetic field for this value.
     */ format;
    #format;
    // The actual value (accounting for decimals)
    #val;
    // A base-10 value to multiple values by to maintain the magnitude
    #tens;
    /**
     *  This is a property so console.log shows a human-meaningful value.
     *
     *  @private
     */ _value;
    // Use this when changing this file to get some typing info,
    // but then switch to any to mask the internal type
    //constructor(guard: any, value: bigint, format: _FixedFormat) {
    /**
     *  @private
     */ constructor(guard, value, format){
        (0, $8wwEQ.assertPrivate)(guard, $3321b612fa8b580d$var$_guard, "FixedNumber");
        this.#val = value;
        this.#format = format;
        const _value = $3321b612fa8b580d$var$toString(value, format.decimals);
        (0, $7N4fp.defineProperties)(this, {
            format: format.name,
            _value: _value
        });
        this.#tens = $3321b612fa8b580d$var$getTens(format.decimals);
    }
    /**
     *  If true, negative values are permitted, otherwise only
     *  positive values and zero are allowed.
     */ get signed() {
        return this.#format.signed;
    }
    /**
     *  The number of bits available to store the value.
     */ get width() {
        return this.#format.width;
    }
    /**
     *  The number of decimal places in the fixed-point arithment field.
     */ get decimals() {
        return this.#format.decimals;
    }
    /**
     *  The value as an integer, based on the smallest unit the
     *  [[decimals]] allow.
     */ get value() {
        return this.#val;
    }
    #checkFormat(other) {
        (0, $8wwEQ.assertArgument)(this.format === other.format, "incompatible format; use fixedNumber.toFormat", "other", other);
    }
    #checkValue(val, safeOp) {
        /*
                const width = BigInt(this.width);
                if (this.signed) {
                    const limit = (BN_1 << (width - BN_1));
                    assert(safeOp == null || (val >= -limit  && val < limit), "overflow", "NUMERIC_FAULT", {
                        operation: <string>safeOp, fault: "overflow", value: val
                    });
        
                    if (val > BN_0) {
                        val = fromTwos(mask(val, width), width);
                    } else {
                        val = -fromTwos(mask(-val, width), width);
                    }
        
                } else {
                    const masked = mask(val, width);
                    assert(safeOp == null || (val >= 0 && val === masked), "overflow", "NUMERIC_FAULT", {
                        operation: <string>safeOp, fault: "overflow", value: val
                    });
                    val = masked;
                }
        */ val = $3321b612fa8b580d$var$checkValue(val, this.#format, safeOp);
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, val, this.#format);
    }
    #add(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val + o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%, ignoring overflow.
     */ addUnsafe(other) {
        return this.#add(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ add(other) {
        return this.#add(other, "add");
    }
    #sub(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val - o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%, ignoring overflow.
     */ subUnsafe(other) {
        return this.#sub(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ sub(other) {
        return this.#sub(other, "sub");
    }
    #mul(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val * o.#val / this.#tens, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%, ignoring overflow and underflow (precision loss).
     */ mulUnsafe(other) {
        return this.#mul(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ mul(other) {
        return this.#mul(other, "mul");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs or if underflow (precision loss) occurs.
     */ mulSignal(other) {
        this.#checkFormat(other);
        const value = this.#val * other.#val;
        (0, $8wwEQ.assert)(value % this.#tens === $3321b612fa8b580d$var$BN_0, "precision lost during signalling mul", "NUMERIC_FAULT", {
            operation: "mulSignal",
            fault: "underflow",
            value: this
        });
        return this.#checkValue(value / this.#tens, "mulSignal");
    }
    #div(o, safeOp) {
        (0, $8wwEQ.assert)(o.#val !== $3321b612fa8b580d$var$BN_0, "division by zero", "NUMERIC_FAULT", {
            operation: "div",
            fault: "divide-by-zero",
            value: this
        });
        this.#checkFormat(o);
        return this.#checkValue(this.#val * this.#tens / o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */ divUnsafe(other) {
        return this.#div(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */ div(other) {
        return this.#div(other, "div");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
     *  (precision loss) occurs.
     */ divSignal(other) {
        (0, $8wwEQ.assert)(other.#val !== $3321b612fa8b580d$var$BN_0, "division by zero", "NUMERIC_FAULT", {
            operation: "div",
            fault: "divide-by-zero",
            value: this
        });
        this.#checkFormat(other);
        const value = this.#val * this.#tens;
        (0, $8wwEQ.assert)(value % other.#val === $3321b612fa8b580d$var$BN_0, "precision lost during signalling div", "NUMERIC_FAULT", {
            operation: "divSignal",
            fault: "underflow",
            value: this
        });
        return this.#checkValue(value / other.#val, "divSignal");
    }
    /**
     *  Returns a comparison result between %%this%% and %%other%%.
     *
     *  This is suitable for use in sorting, where ``-1`` implies %%this%%
     *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
     *  both are equal.
     */ cmp(other) {
        let a = this.value, b = other.value;
        // Coerce a and b to the same magnitude
        const delta = this.decimals - other.decimals;
        if (delta > 0) b *= $3321b612fa8b580d$var$getTens(delta);
        else if (delta < 0) a *= $3321b612fa8b580d$var$getTens(-delta);
        // Comnpare
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }
    /**
     *  Returns true if %%other%% is equal to %%this%%.
     */ eq(other) {
        return this.cmp(other) === 0;
    }
    /**
     *  Returns true if %%other%% is less than to %%this%%.
     */ lt(other) {
        return this.cmp(other) < 0;
    }
    /**
     *  Returns true if %%other%% is less than or equal to %%this%%.
     */ lte(other) {
        return this.cmp(other) <= 0;
    }
    /**
     *  Returns true if %%other%% is greater than to %%this%%.
     */ gt(other) {
        return this.cmp(other) > 0;
    }
    /**
     *  Returns true if %%other%% is greater than or equal to %%this%%.
     */ gte(other) {
        return this.cmp(other) >= 0;
    }
    /**
     *  Returns a new [[FixedNumber]] which is the largest **integer**
     *  that is less than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */ floor() {
        let val = this.#val;
        if (this.#val < $3321b612fa8b580d$var$BN_0) val -= this.#tens - $3321b612fa8b580d$var$BN_1;
        val = this.#val / this.#tens * this.#tens;
        return this.#checkValue(val, "floor");
    }
    /**
     *  Returns a new [[FixedNumber]] which is the smallest **integer**
     *  that is greater than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */ ceiling() {
        let val = this.#val;
        if (this.#val > $3321b612fa8b580d$var$BN_0) val += this.#tens - $3321b612fa8b580d$var$BN_1;
        val = this.#val / this.#tens * this.#tens;
        return this.#checkValue(val, "ceiling");
    }
    /**
     *  Returns a new [[FixedNumber]] with the decimal component
     *  rounded up on ties at %%decimals%% places.
     */ round(decimals) {
        if (decimals == null) decimals = 0;
        // Not enough precision to not already be rounded
        if (decimals >= this.decimals) return this;
        const delta = this.decimals - decimals;
        const bump = $3321b612fa8b580d$var$BN_5 * $3321b612fa8b580d$var$getTens(delta - 1);
        let value = this.value + bump;
        const tens = $3321b612fa8b580d$var$getTens(delta);
        value = value / tens * tens;
        $3321b612fa8b580d$var$checkValue(value, this.#format, "round");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, this.#format);
    }
    /**
     *  Returns true if %%this%% is equal to ``0``.
     */ isZero() {
        return this.#val === $3321b612fa8b580d$var$BN_0;
    }
    /**
     *  Returns true if %%this%% is less than ``0``.
     */ isNegative() {
        return this.#val < $3321b612fa8b580d$var$BN_0;
    }
    /**
     *  Returns the string representation of %%this%%.
     */ toString() {
        return this._value;
    }
    /**
     *  Returns a float approximation.
     *
     *  Due to IEEE 754 precission (or lack thereof), this function
     *  can only return an approximation and most values will contain
     *  rounding errors.
     */ toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    /**
     *  Return a new [[FixedNumber]] with the same value but has had
     *  its field set to %%format%%.
     *
     *  This will throw if the value cannot fit into %%format%%.
     */ toFormat(format) {
        return $3321b612fa8b580d$export$d4693c66c2213e45.fromString(this.toString(), format);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% divided by
     *  %%decimal%% places with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
     *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
     *  or underflow (precision loss).
     */ static fromValue(_value, _decimals, _format) {
        const decimals = _decimals == null ? 0 : (0, $9AgaV.getNumber)(_decimals);
        const format = $3321b612fa8b580d$var$getFormat(_format);
        let value = (0, $9AgaV.getBigInt)(_value, "value");
        const delta = decimals - format.decimals;
        if (delta > 0) {
            const tens = $3321b612fa8b580d$var$getTens(delta);
            (0, $8wwEQ.assert)(value % tens === $3321b612fa8b580d$var$BN_0, "value loses precision for format", "NUMERIC_FAULT", {
                operation: "fromValue",
                fault: "underflow",
                value: _value
            });
            value /= tens;
        } else if (delta < 0) value *= $3321b612fa8b580d$var$getTens(-delta);
        $3321b612fa8b580d$var$checkValue(value, format, "fromValue");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, format);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%%, either due to overflow or underflow (precision loss).
     */ static fromString(_value, _format) {
        const match = _value.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
        (0, $8wwEQ.assertArgument)(match && match[2].length + match[3].length > 0, "invalid FixedNumber string value", "value", _value);
        const format = $3321b612fa8b580d$var$getFormat(_format);
        let whole = match[2] || "0", decimal = match[3] || "";
        // Pad out the decimals
        while(decimal.length < format.decimals)decimal += $3321b612fa8b580d$var$Zeros;
        // Check precision is safe
        (0, $8wwEQ.assert)(decimal.substring(format.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
            operation: "fromString",
            fault: "underflow",
            value: _value
        });
        // Remove extra padding
        decimal = decimal.substring(0, format.decimals);
        const value = BigInt(match[1] + whole + decimal);
        $3321b612fa8b580d$var$checkValue(value, format, "fromString");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, format);
    }
    /**
     *  Creates a new [[FixedNumber]] with the big-endian representation
     *  %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%% due to overflow.
     */ static fromBytes(_value, _format) {
        let value = (0, $9AgaV.toBigInt)((0, $lJSYP.getBytes)(_value, "value"));
        const format = $3321b612fa8b580d$var$getFormat(_format);
        if (format.signed) value = (0, $9AgaV.fromTwos)(value, format.width);
        $3321b612fa8b580d$var$checkValue(value, format, "fromBytes");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, format);
    }
} //const f1 = FixedNumber.fromString("12.56", "fixed16x2");
 //const f2 = FixedNumber.fromString("0.3", "fixed16x2");
 //console.log(f1.divSignal(f2));
 //const BUMP = FixedNumber.from("0.5");

});


parcelRegister("b3To1", function(module, exports) {

$parcel$export(module.exports, "JsonRpcProvider", () => $80daf019a5520af5$export$da28308012bf6748);
/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false

var $b6VUG = parcelRequire("b6VUG");

var $95T0n = parcelRequire("95T0n");
var $klTOW = parcelRequire("klTOW");

var $35ioY = parcelRequire("35ioY");

var $gGqax = parcelRequire("gGqax");

var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
var $3PTkx = parcelRequire("3PTkx");
var $9AgaV = parcelRequire("9AgaV");
var $lJSYP = parcelRequire("lJSYP");
var $6Vneh = parcelRequire("6Vneh");

var $e6sDb = parcelRequire("e6sDb");

var $1cKTC = parcelRequire("1cKTC");

var $6i1Zn = parcelRequire("6i1Zn");

var $dCiC8 = parcelRequire("dCiC8");

var $kZz8q = parcelRequire("kZz8q");
const $80daf019a5520af5$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $80daf019a5520af5$var$deepCopy(value) {
    if (value == null || $80daf019a5520af5$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($80daf019a5520af5$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $80daf019a5520af5$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $80daf019a5520af5$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $80daf019a5520af5$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $80daf019a5520af5$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $80daf019a5520af5$export$5f7b5fca3508545a extends (0, $1cKTC.AbstractSigner) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $95T0n.getAddress)(address);
        (0, $7N4fp.defineProperties)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $8wwEQ.assert)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $80daf019a5520af5$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $klTOW.resolveAddress)(_from, this.provider);
                (0, $8wwEQ.assertArgument)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $klTOW.resolveAddress)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $8wwEQ.isError)(error, "CANCELLED") || (0, $8wwEQ.isError)(error, "BAD_DATA") || (0, $8wwEQ.isError)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $8wwEQ.isError)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $8wwEQ.makeError)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $80daf019a5520af5$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $klTOW.resolveAddress)(tx.from, this.provider);
            (0, $8wwEQ.assertArgument)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $6Vneh.toUtf8Bytes)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $lJSYP.hexlify)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $80daf019a5520af5$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $35ioY.TypedDataEncoder).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $klTOW.resolveAddress)(value);
            (0, $8wwEQ.assertArgument)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $35ioY.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $6Vneh.toUtf8Bytes)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $lJSYP.hexlify)(message)
        ]);
    }
}
class $80daf019a5520af5$export$5afe35a44ca7ff9a extends (0, $e6sDb.AbstractProvider) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $8wwEQ.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $8wwEQ.makeError)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $80daf019a5520af5$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $8wwEQ.assertArgument)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $6i1Zn.Network).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $8wwEQ.assertArgument)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $8wwEQ.assert)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $9AgaV.getBigInt)(tx.type)) // If there are no EIP-1559 or newer properties, it might be pre-EIP-1559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $6i1Zn.Network).from((0, $9AgaV.getBigInt)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $6i1Zn.Network).from((0, $9AgaV.getBigInt)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $8wwEQ.makeError)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $80daf019a5520af5$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $dCiC8.FilterIdPendingSubscriber)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $kZz8q.PollingEventSubscriber)(this, sub.filter);
            return new (0, $dCiC8.FilterIdEventSubscriber)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $e6sDb.UnmanagedSubscriber)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $9AgaV.toQuantity)((0, $9AgaV.getBigInt)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $lJSYP.hexlify)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $gGqax.accessListify)(tx.accessList);
        if (tx.blobVersionedHashes) // @TODO: Remove this <any> case once EIP-4844 added to prepared tx
        result["blobVersionedHashes"] = tx.blobVersionedHashes.map((h)=>h.toLowerCase());
        // @TODO: blobs should probably also be copied over, optionally
        // accounting for the kzg property to backfill blobVersionedHashes
        // using the commitment. Or should that be left as an exercise to
        // the caller?
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($80daf019a5520af5$var$getLowerCase);
                    else req.filter.address = $80daf019a5520af5$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $8wwEQ.makeError)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $80daf019a5520af5$var$spelunkData(error);
            const e = (0, $b6VUG.AbiCoder).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($80daf019a5520af5$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $8wwEQ.makeError)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $8wwEQ.makeError)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $8wwEQ.makeError)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $8wwEQ.makeError)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $8wwEQ.makeError)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $8wwEQ.makeError)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $8wwEQ.makeError)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $8wwEQ.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $80daf019a5520af5$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $7N4fp.resolveProperties)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $95T0n.getAddress)(address);
        for (const account of accounts){
            if ((0, $95T0n.getAddress)(account) === address) return new $80daf019a5520af5$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $80daf019a5520af5$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $8wwEQ.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $80daf019a5520af5$export$e16ffa1aa36d1432 extends $80daf019a5520af5$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        let pollingInterval = this._getOption("pollingInterval");
        if (pollingInterval == null) pollingInterval = $80daf019a5520af5$var$defaultOptions.pollingInterval;
        this.#pollingInterval = pollingInterval;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($80daf019a5520af5$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($80daf019a5520af5$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $80daf019a5520af5$export$da28308012bf6748 extends $80daf019a5520af5$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $3PTkx.FetchRequest)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $80daf019a5520af5$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $lJSYP.isHexString)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $80daf019a5520af5$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $80daf019a5520af5$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $80daf019a5520af5$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$80daf019a5520af5$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $80daf019a5520af5$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $80daf019a5520af5$var$spelunkMessage(value) {
    const result = [];
    $80daf019a5520af5$var$_spelunkMessage(value, result);
    return result;
}

});
parcelRegister("35ioY", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", () => $23f01ceb797ea4ad$export$458ab927ae635c3);
//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";

var $95T0n = parcelRequire("95T0n");
parcelRequire("11WK3");
var $dnGYA = parcelRequire("dnGYA");

var $jqUca = parcelRequire("jqUca");

var $8wwEQ = parcelRequire("8wwEQ");
var $lJSYP = parcelRequire("lJSYP");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");

var $93hEj = parcelRequire("93hEj");
const $23f01ceb797ea4ad$var$padding = new Uint8Array(32);
$23f01ceb797ea4ad$var$padding.fill(0);
const $23f01ceb797ea4ad$var$BN__1 = BigInt(-1);
const $23f01ceb797ea4ad$var$BN_0 = BigInt(0);
const $23f01ceb797ea4ad$var$BN_1 = BigInt(1);
const $23f01ceb797ea4ad$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $23f01ceb797ea4ad$var$hexPadRight(value) {
    const bytes = (0, $lJSYP.getBytes)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $lJSYP.concat)([
        bytes,
        $23f01ceb797ea4ad$var$padding.slice(padOffset)
    ]);
    return (0, $lJSYP.hexlify)(bytes);
}
const $23f01ceb797ea4ad$var$hexTrue = (0, $9AgaV.toBeHex)($23f01ceb797ea4ad$var$BN_1, 32);
const $23f01ceb797ea4ad$var$hexFalse = (0, $9AgaV.toBeHex)($23f01ceb797ea4ad$var$BN_0, 32);
const $23f01ceb797ea4ad$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $23f01ceb797ea4ad$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $23f01ceb797ea4ad$var$checkString(key) {
    return function(value) {
        (0, $8wwEQ.assertArgument)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $23f01ceb797ea4ad$var$domainChecks = {
    name: $23f01ceb797ea4ad$var$checkString("name"),
    version: $23f01ceb797ea4ad$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $9AgaV.getBigInt)(_value, "domain.chainId");
        (0, $8wwEQ.assertArgument)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $9AgaV.toQuantity)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $95T0n.getAddress)(value).toLowerCase();
        } catch (error) {}
        (0, $8wwEQ.assertArgument)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $lJSYP.getBytes)(value, "domain.salt");
        (0, $8wwEQ.assertArgument)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $lJSYP.hexlify)(bytes);
    }
};
function $23f01ceb797ea4ad$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $8wwEQ.assertArgument)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $9AgaV.mask)($23f01ceb797ea4ad$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $23f01ceb797ea4ad$var$BN_1) * $23f01ceb797ea4ad$var$BN__1 : $23f01ceb797ea4ad$var$BN_0;
            return function(_value) {
                const value = (0, $9AgaV.getBigInt)(_value, "value");
                (0, $8wwEQ.assertArgument)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $9AgaV.toBeHex)(signed ? (0, $9AgaV.toTwos)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $8wwEQ.assertArgument)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $lJSYP.getBytes)(value);
                (0, $8wwEQ.assertArgument)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $23f01ceb797ea4ad$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $lJSYP.zeroPadValue)((0, $95T0n.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $23f01ceb797ea4ad$var$hexFalse : $23f01ceb797ea4ad$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $dnGYA.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $93hEj.id)(value);
            };
    }
    return null;
}
function $23f01ceb797ea4ad$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $23f01ceb797ea4ad$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $23f01ceb797ea4ad$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $23f01ceb797ea4ad$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $8wwEQ.assertArgument)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $23f01ceb797ea4ad$var$splitArray(field.type).base;
                (0, $8wwEQ.assertArgument)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $8wwEQ.assertArgument)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $8wwEQ.assertArgument)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $8wwEQ.assertArgument)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $7N4fp.defineProperties)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $8wwEQ.assertArgument)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $23f01ceb797ea4ad$var$encodeType(name, types[name]) + st.map((t)=>$23f01ceb797ea4ad$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $23f01ceb797ea4ad$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $8wwEQ.assertArgument)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $dnGYA.keccak256));
                return (0, $dnGYA.keccak256)((0, $lJSYP.concat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $93hEj.id)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $dnGYA.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $lJSYP.concat)(values);
            };
        }
        (0, $8wwEQ.assertArgument)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $8wwEQ.assertArgument)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $dnGYA.keccak256)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $23f01ceb797ea4ad$var$splitArray(type).array;
        if (array) {
            (0, $8wwEQ.assertArgument)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $8wwEQ.assertArgument)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $23f01ceb797ea4ad$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $23f01ceb797ea4ad$var$domainFieldTypes[name];
            (0, $8wwEQ.assertArgument)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $23f01ceb797ea4ad$var$domainFieldNames.indexOf(a.name) - $23f01ceb797ea4ad$var$domainFieldNames.indexOf(b.name);
        });
        return $23f01ceb797ea4ad$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $lJSYP.concat)([
            "0x1901",
            $23f01ceb797ea4ad$export$458ab927ae635c3.hashDomain(domain),
            $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $dnGYA.keccak256)($23f01ceb797ea4ad$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $lJSYP.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $23f01ceb797ea4ad$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $lJSYP.isHexString)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $23f01ceb797ea4ad$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $23f01ceb797ea4ad$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $23f01ceb797ea4ad$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $23f01ceb797ea4ad$var$domainFieldTypes[name]
            });
        });
        const encoder = $23f01ceb797ea4ad$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $8wwEQ.assertArgument)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $lJSYP.hexlify)((0, $lJSYP.getBytes)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $9AgaV.getBigInt)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $8wwEQ.assertArgument)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $8wwEQ.assertArgument)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $23f01ceb797ea4ad$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $jqUca.recoverAddress)($23f01ceb797ea4ad$export$458ab927ae635c3.hash(domain, types, value), signature);
}

});

parcelRegister("1cKTC", function(module, exports) {

$parcel$export(module.exports, "AbstractSigner", () => $0e0b4a0a5741b830$export$6c02143914c373f1);
$parcel$export(module.exports, "VoidSigner", () => $0e0b4a0a5741b830$export$7dbc56d9b9612bad);
/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 
var $klTOW = parcelRequire("klTOW");

var $1PldO = parcelRequire("1PldO");

var $8wwEQ = parcelRequire("8wwEQ");
var $7N4fp = parcelRequire("7N4fp");
var $9AgaV = parcelRequire("9AgaV");

var $5Hh3B = parcelRequire("5Hh3B");
function $0e0b4a0a5741b830$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $8wwEQ.assert)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $0e0b4a0a5741b830$var$populate(signer, tx) {
    let pop = (0, $5Hh3B.copyRequest)(tx);
    if (pop.to != null) pop.to = (0, $klTOW.resolveAddress)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $klTOW.resolveAddress)(from, signer)
        ]).then(([address, from])=>{
            (0, $8wwEQ.assertArgument)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $7N4fp.resolveProperties)(pop);
}
class $0e0b4a0a5741b830$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $7N4fp.defineProperties)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $0e0b4a0a5741b830$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "populateTransaction");
        const pop = await $0e0b4a0a5741b830$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $9AgaV.getBigInt)(pop.chainId);
            (0, $8wwEQ.assertArgument)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $8wwEQ.assertArgument)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $8wwEQ.assertArgument)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $8wwEQ.assert)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $8wwEQ.assert)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $8wwEQ.assert)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2 || pop.type === 3) {
                // Explicitly using EIP-1559 or EIP-4844
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $7N4fp.resolveProperties)(pop);
    }
    async estimateGas(tx) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $1PldO.Transaction).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $0e0b4a0a5741b830$export$7dbc56d9b9612bad extends $0e0b4a0a5741b830$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $7N4fp.defineProperties)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $0e0b4a0a5741b830$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $8wwEQ.assert)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}

});

parcelRegister("dCiC8", function(module, exports) {

$parcel$export(module.exports, "FilterIdEventSubscriber", () => $028eec70d03d6cd8$export$60f65cdabb3c5771);
$parcel$export(module.exports, "FilterIdPendingSubscriber", () => $028eec70d03d6cd8$export$285511066b2a5499);

var $8wwEQ = parcelRequire("8wwEQ");

var $kZz8q = parcelRequire("kZz8q");
function $028eec70d03d6cd8$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $028eec70d03d6cd8$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $8wwEQ.isError)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                if (this.#provider.destroyed) return;
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $028eec70d03d6cd8$export$60f65cdabb3c5771 extends $028eec70d03d6cd8$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $028eec70d03d6cd8$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $kZz8q.PollingEventSubscriber)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $028eec70d03d6cd8$export$285511066b2a5499 extends $028eec70d03d6cd8$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}

});


parcelRegister("1H5oH", function(module, exports) {

$parcel$export(module.exports, "MaxUint256", () => $13bdfe64f98fbcbf$export$1b53890de5aabdd0);
/**
 *  A constant for the order N for the secp256k1 curve.
 *
 *  (**i.e.** ``0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n``)
 */ const $13bdfe64f98fbcbf$export$a07804094c3ecf2d = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $13bdfe64f98fbcbf$export$c8db55bd7405209e = BigInt("1000000000000000000");
const $13bdfe64f98fbcbf$export$1b53890de5aabdd0 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $13bdfe64f98fbcbf$export$963c9b9317b80aaf = BigInt("0x8000000000000000000000000000000000000000000000000000000000000000") * BigInt(-1);
const $13bdfe64f98fbcbf$export$6f8dbb07ebe6d738 = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});



var $6THZ6 = parcelRequire("6THZ6");
const $a7eae01e88dd0256$var$canvas = document.getElementById("hero-image-3d");
const $a7eae01e88dd0256$var$app = new (0, $6THZ6.Application)($a7eae01e88dd0256$var$canvas);
$a7eae01e88dd0256$var$app.load("https://prod.spline.design/p8D73mm7-xKTO8qK/scene.splinecode");
document.addEventListener("click", (event)=>{
    // Check if the clicked element or its parent has `data-toggle-rotation`
    if (event.target.matches("[data-toggle-rotation]") || event.target.closest("[data-toggle-rotation]")) {
        const row = event.target.closest("[data-toggle-rotation]");
        row.classList.toggle("clicked");
    }
});
window.scrollToSection = function(section) {
    document.querySelector(`#${section}`).scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
};
window.joinDiscord = function() {
    window.open("https://discord.gg/orangefinventures", "_blank");
};
window.toggleSubmenu = function() {
    const submenu = document.getElementById("submenu");
    const navLinkMore = document.getElementById("nav-link-more");
    submenu.style.display = submenu.style.display === "flex" ? "none" : "flex";
    // Toggle the rotation class on #nav-link-more
    navLinkMore.classList.toggle("submenu-open");
};
window.toggleSubmenuMobile = function() {
    const submenu = document.getElementById("submenu-mobile");
    const navLinkMore = document.getElementById("nav-link-more-mobile");
    submenu.style.display = submenu.style.display === "flex" ? "none" : "flex";
    // Toggle the rotation class on #nav-link-more
    navLinkMore.classList.toggle("submenu-open");
};
window.prices = {};
window.fetchSolanaData = function fetchSolanaData() {
    fetch("https://api.stakewiz.com/validator/oRAnGeU5h8h2UkvbfnE5cjXnnAa4rBoaxmS4kbFymSe").then((res)=>res.json()).then((res)=>{
        const apy = document.querySelectorAll("#solana-apy");
        if (apy != null) document.querySelector("#solana-apy").textContent = res.total_apy + "%";
        const stake = document.querySelectorAll("#solana-stake");
        if (stake != null) document.querySelector("#solana-stake").textContent = formatNumber(res.activated_stake) + " SOL";
        const stake_usd = document.querySelectorAll("#solana-stake-usd");
        if (stake_usd != null) document.querySelector("#solana-stake-usd").textContent = `$${formatNumber(res.activated_stake * prices.sol)}`;
    });
};

window.fetchGnosisData = function fetchGnosisData() {
    const stakewise = (parcelRequire("FVrXi"));
    const { StakeWiseSDK: StakeWiseSDK, Network: Network } = stakewise;
    const gnosisSDK = new StakeWiseSDK({
        network: Network.Gnosis
    });
    gnosisSDK.vault.getVault({
        vaultAddress: "0xe32773a0f6fa8ebf2a32c040dacd031a1ad1e530"
    }).then((res)=>{
        const total_stake = parseFloat(res.totalAssets).toFixed(2);
        const stake = document.querySelectorAll("#gnosis-stake");
        if (stake != null) document.querySelector("#gnosis-stake").textContent = formatNumber(total_stake) + " GNO";
        const stake_usd = document.querySelectorAll("#gnosis-stake-usd");
        if (stake_usd != null) document.querySelector("#gnosis-stake-usd").textContent = `$${formatNumber(total_stake * prices.gno)}`;
        const apy_estimate = res.apy.toFixed(2);
        const apy = document.querySelectorAll("#gnosis-apy");
        if (apy != null) document.querySelector("#gnosis-apy").textContent = apy_estimate + "%";
    });
};
window.fetchSolanaAssetsUnderDelegation = function fetchSolanaAssetsUnderDelegation1() {
    return new Promise((resolve, reject)=>{
        fetch("https://validators-api.marinade.finance/validators?limit=1&query_vote_accounts=oRAnGeU5h8h2UkvbfnE5cjXnnAa4rBoaxmS4kbFymSe").then((res)=>res.json()).then((res)=>{
            resolve(parseFloat(res.validators[0].activated_stake) / 1e9);
        });
    });
};

window.fetchGnosisAssetsUnderDelegation = function fetchGnosisAssetsUnderDelegation1() {
    return new Promise((resolve, reject)=>{
        const stakewise = (parcelRequire("FVrXi"));
        const { StakeWiseSDK: StakeWiseSDK, Network: Network } = stakewise;
        const gnosisSDK = new StakeWiseSDK({
            network: Network.Gnosis
        });
        gnosisSDK.vault.getVault({
            vaultAddress: "0xe32773a0f6fa8ebf2a32c040dacd031a1ad1e530"
        }).then((res)=>{
            const total_stake = parseFloat(res.totalAssets).toFixed(2);
            resolve(parseFloat(total_stake));
        });
    });
};
window.fetchExchangeRates = function fetchExchangeRates1() {
    return new Promise((resolve, reject)=>{
        Promise.all([
            fetch("https://api.kraken.com/0/public/Ticker?pair=SOLUSD"),
            fetch("https://api.kraken.com/0/public/Ticker?pair=ETHUSD"),
            fetch("https://api.kraken.com/0/public/Ticker?pair=GNOUSD")
        ]).then((responses)=>Promise.all(responses.map((response)=>response.json()))).then((data)=>{
            const sol = parseFloat(data[0].result.SOLUSD.c[0]);
            const eth = parseFloat(data[1].result.XETHZUSD.c[0]);
            const gno = parseFloat(data[2].result.GNOUSD.c[0]);
            resolve({
                sol: sol,
                eth: eth,
                gno: gno
            });
        }).catch((error)=>reject(error));
    });
};
window.fetchAssetsUnderDelegation = function fetchAssetsUnderDelegation() {
    return new Promise((resolve, reject)=>{
        Promise.all([
            fetchExchangeRates(),
            fetchSolanaAssetsUnderDelegation(),
            fetchGnosisAssetsUnderDelegation()
        ]).then((data)=>{
            const aud = data[1] * data[0].sol + data[2] * data[0].gno;
            // This is a hack to ensure a weird bug doesn't pop up where it does not show a number
            if (aud > 40000) window.numAnim.update(aud);
            resolve(aud.toFixed(2));
        }).catch((e)=>{
            console.log(e);
            window.numAnim.update(100000000);
        });
    });
};
window.formatNumber = function formatNumber1(number) {
    if (isNaN(number)) throw new Error("Input must be a number");
    if (number < 1e3) {
        if (typeof number === "string") return number;
        return number.toFixed(2); // less than 1000
    } else if (number < 1e6) return (number / 1e3).toFixed(1) + "K"; // less than 1 million
    else if (number < 1e9) return (number / 1e6).toFixed(1) + "M"; // less than 1 billion
    else return (number / 1e9).toFixed(1) + "B"; // 1 billion or more
};
window.formatDollar = function(number) {
    return `$${formatNumber(number)}`;
};
window.animateAud = function animateAud() {
    const numAnim = new countUp.CountUp("aum", "118000000", {
        formattingFn: window.formatDollar,
        duration: 5
    });
    window.numAnim = numAnim;
    numAnim.start();
};
window.fetchExchangeRates().then((res)=>{
    prices = res;
    window.fetchAssetsUnderDelegation();
    window.fetchSolanaData();
    window.fetchGnosisData();
});
window.animateAud();


//# sourceMappingURL=index.b8cf86e0.js.map
